import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: any; output: any };
  Long: { input: any; output: any };
};

export type AbTestData = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  rollout?: Maybe<WorkflowV1WorkflowInstanceResult>;
  treatments?: Maybe<Array<AbTestDataTreatment>>;
};

export type AbTestDataInput = {
  flag?: InputMaybe<Scalars['String']['input']>;
  rollout?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<AbTestDataInputTreatmentInput>>;
};

export type AbTestDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type AbTestDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variant: FlagsAdminV1FlagVariantResult;
  weight: Scalars['Long']['output'];
};

export type ActionsV1TypesAction = {
  executeFunctionAction?: Maybe<ActionsV1TypesExecuteFunctionAction>;
  pagerdutyAction?: Maybe<ActionsV1TypesPagerDutyAction>;
  transitionAction?: Maybe<ActionsV1TypesTransitionWorkflowAction>;
};

export type ActionsV1TypesActionInput = {
  executeFunctionAction?: InputMaybe<ActionsV1TypesExecuteFunctionActionInput>;
  pagerdutyAction?: InputMaybe<ActionsV1TypesPagerDutyActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  transitionAction?: InputMaybe<ActionsV1TypesTransitionWorkflowActionInput>;
};

export type ActionsV1TypesActivityTrigger = {
  kind?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesAutomatedAction = {
  action?: Maybe<ActionsV1TypesAction>;
  trigger?: Maybe<ActionsV1TypesTrigger>;
};

export type ActionsV1TypesAutomatedActionInput = {
  action?: InputMaybe<ActionsV1TypesActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<ActionsV1TypesTriggerInput>;
};

export type ActionsV1TypesExecuteFunctionAction = {
  function?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type ActionsV1TypesExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesPagerDutyAction = {
  description?: Maybe<Scalars['String']['output']>;
  pdKey: Scalars['String']['output'];
  severity: ActionsV1TypesSeverity;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesPagerDutyActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pdKey: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity: ActionsV1TypesSeverity;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ActionsV1TypesSeverity {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export type ActionsV1TypesStateTrigger = {
  resource?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesStateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesTransitionWorkflowAction = {
  action?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type ActionsV1TypesTransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesTrigger = {
  activityTrigger?: Maybe<ActionsV1TypesActivityTrigger>;
  stateTrigger?: Maybe<ActionsV1TypesStateTrigger>;
};

export type ActionsV1TypesTriggerInput = {
  activityTrigger?: InputMaybe<ActionsV1TypesActivityTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<ActionsV1TypesStateTriggerInput>;
};

export type ActivityV1Activity = {
  activityTime: Scalars['String']['output'];
  actor: IamV1IdentityResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  body: Scalars['String']['output'];
  changeSet?: Maybe<ActivityV1ResourceChangeSet>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  data?: Maybe<Scalars['JSON']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ActivityV1ActivityLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  primaryResource: Scalars['String']['output'];
  priority: ActivityV1ActivityPriority;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  relatedResources: Array<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  title: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1ActivityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1ActivityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1ActivityObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum ActivityV1ActivityPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type ActivityV1ActivityResult = ActivityV1Activity | Error;

export type ActivityV1ActivityType = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  deletedTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  global: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  primaryResourceType: ActivityV1ResourceType;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type ActivityV1ActivityTypeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1ActivityTypeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1ActivityTypeObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeResult = ActivityV1ActivityType | Error;

export type ActivityV1EventsActivityCreated = {
  activity?: Maybe<ActivityV1Activity>;
};

export type ActivityV1Feed = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  channels: Array<ActivityV1FeedChannelConfig>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  feedEntries?: Maybe<ActivityV1ListFeedEntriesResponseResult>;
  feedSubscriptions?: Maybe<ActivityV1ListFeedSubscriptionsResponseResult>;
  labels: Array<ActivityV1FeedLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1FeedAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedFeedEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedFeedSubscriptionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedChannelConfig = {
  activityTypes: Array<ActivityV1ActivityTypeResult>;
  batchingConfig?: Maybe<ActivityV1FeedChannelConfigBatchingConfig>;
  digestConfig?: Maybe<ActivityV1FeedChannelConfigDigestConfig>;
  disabled: Scalars['Boolean']['output'];
  email?: Maybe<ActivityV1FeedChannelConfigEmail>;
  lastError?: Maybe<ActivityV1FeedChannelConfigError>;
  priority?: Maybe<ActivityV1ActivityPriority>;
  slack?: Maybe<ActivityV1FeedChannelConfigSlack>;
  webhook?: Maybe<ActivityV1FeedChannelConfigWebhook>;
};

export type ActivityV1FeedChannelConfigBatchingConfig = {
  priority?: Maybe<ActivityV1ActivityPriority>;
  window: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigBatchingConfigInput = {
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  window: Scalars['String']['input'];
};

export type ActivityV1FeedChannelConfigDigestConfig = {
  interval: ActivityV1FeedChannelConfigDigestConfigDigestInterval;
  nextDueTime?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
};

export enum ActivityV1FeedChannelConfigDigestConfigDigestInterval {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
}

export type ActivityV1FeedChannelConfigDigestConfigInput = {
  interval: ActivityV1FeedChannelConfigDigestConfigDigestInterval;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type ActivityV1FeedChannelConfigEmail = {
  address: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigEmailInput = {
  address: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigError = {
  errorTime: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigErrorInput = {
  errorTime: Scalars['String']['input'];
  message: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  batchingConfig?: InputMaybe<ActivityV1FeedChannelConfigBatchingConfigInput>;
  digestConfig?: InputMaybe<ActivityV1FeedChannelConfigDigestConfigInput>;
  disabled: Scalars['Boolean']['input'];
  email?: InputMaybe<ActivityV1FeedChannelConfigEmailInput>;
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<ActivityV1FeedChannelConfigSlackInput>;
  webhook?: InputMaybe<ActivityV1FeedChannelConfigWebhookInput>;
};

export type ActivityV1FeedChannelConfigSlack = {
  channel?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedChannelConfigSlackInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigWebhook = {
  id?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigWebhookInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type ActivityV1FeedEntry = {
  activity: ActivityV1Activity;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  channelDeliveryStatuses: Array<ActivityV1FeedEntryChannelDeliveryStatus>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entryTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ActivityV1FeedEntryLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  read: Scalars['Boolean']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1FeedEntryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedEntryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedEntryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryChannelDeliveryStatus = {
  channel: Scalars['String']['output'];
  failedAttempts: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ActivityV1FeedEntryChannelDeliveryStatusDeliveryState>;
};

export enum ActivityV1FeedEntryChannelDeliveryStatusDeliveryState {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingDigest = 'PENDING_DIGEST',
  Skipped = 'SKIPPED',
}

export type ActivityV1FeedEntryLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedEntryResult = ActivityV1FeedEntry | Error;

export type ActivityV1FeedInput = {
  channels?: InputMaybe<Array<ActivityV1FeedChannelConfigInput>>;
  labels?: InputMaybe<Array<ActivityV1FeedLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedResult = ActivityV1Feed | Error;

export type ActivityV1FeedSubscription = {
  activityTypes: Array<ActivityV1ActivityTypeResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceType?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type ActivityV1FeedSubscriptionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedSubscriptionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedSubscriptionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionResult =
  | ActivityV1FeedSubscription
  | Error;

export type ActivityV1ListActivitiesResponse = {
  activities: Array<ActivityV1Activity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  truncatedBeforeTime?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListActivitiesResponseResult =
  | ActivityV1ListActivitiesResponse
  | Error;

export type ActivityV1ListActivityTypesResponse = {
  activityTypes: Array<ActivityV1ActivityType>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListActivityTypesResponseResult =
  | ActivityV1ListActivityTypesResponse
  | Error;

export type ActivityV1ListFeedEntriesResponse = {
  feedEntries: Array<ActivityV1FeedEntry>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedEntriesResponseResult =
  | ActivityV1ListFeedEntriesResponse
  | Error;

export type ActivityV1ListFeedSubscriptionsResponse = {
  feedSubscriptions: Array<ActivityV1FeedSubscription>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedSubscriptionsResponseResult =
  | ActivityV1ListFeedSubscriptionsResponse
  | Error;

export type ActivityV1ListFeedsResponse = {
  feeds: Array<ActivityV1Feed>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedsResponseResult =
  | ActivityV1ListFeedsResponse
  | Error;

export type ActivityV1MarkFeedEntriesAsReadRequestFeedEntriesInput = {
  entryNames: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1MarkFeedEntriesAsReadRequestMarkReadTimeInput = {
  feed?: InputMaybe<Scalars['String']['input']>;
  markReadTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1QueryActivityTypesResponse = {
  activityTypes: Array<ActivityV1ActivityType>;
};

export type ActivityV1QueryActivityTypesResponseResult =
  | ActivityV1QueryActivityTypesResponse
  | Error;

export type ActivityV1QueryIsFollowingResourceResponse = {
  isFollowing?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityV1QueryIsFollowingResourceResponseResult =
  | ActivityV1QueryIsFollowingResourceResponse
  | Error;

export type ActivityV1ResourceChangeSet = {
  changes: Array<ActivityV1ResourceChangeSetFieldChange>;
};

export type ActivityV1ResourceChangeSetFieldChange = {
  changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
  description?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  fieldType?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  reorderDetails?: Maybe<ActivityV1ResourceChangeSetFieldChangeReorderDetails>;
};

export enum ActivityV1ResourceChangeSetFieldChangeChangeType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Reorder = 'REORDER',
  Update = 'UPDATE',
}

export type ActivityV1ResourceChangeSetFieldChangeReorderDetails = {
  moves: Array<ActivityV1ResourceChangeSetFieldChangeReorderDetailsReorderMove>;
};

export type ActivityV1ResourceChangeSetFieldChangeReorderDetailsReorderMove = {
  item: Scalars['String']['output'];
  itemDisplayName?: Maybe<Scalars['String']['output']>;
  newPosition: Scalars['Int']['output'];
  oldPosition: Scalars['Int']['output'];
};

export enum ActivityV1ResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  CollaborativeDocument = 'COLLABORATIVE_DOCUMENT',
  Comment = 'COMMENT',
  CommentReply = 'COMMENT_REPLY',
  DashboardAlert = 'DASHBOARD_ALERT',
  DimensionTable = 'DIMENSION_TABLE',
  EventDefinition = 'EVENT_DEFINITION',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Issue = 'ISSUE',
  Measurement = 'MEASUREMENT',
  MetaAnalysis = 'META_ANALYSIS',
  Metric = 'METRIC',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  Task = 'TASK',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type ActivityV1SlackAdminConfig = {
  state?: Maybe<ActivityV1SlackAdminConfigState>;
  teamId?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1SlackAdminConfigResult =
  | ActivityV1SlackAdminConfig
  | Error;

export enum ActivityV1SlackAdminConfigState {
  NotConfigured = 'NOT_CONFIGURED',
  Ok = 'OK',
}

export type ActivityV1TestWebhookResponse = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  responseDuration?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityV1TestWebhookResponseResult =
  | ActivityV1TestWebhookResponse
  | Error;

export type AdminLabelsV1Label = {
  allowedValues: Array<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<AdminLabelsV1LabelLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AdminLabelsV1LabelAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AdminLabelsV1LabelCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AdminLabelsV1LabelObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<AdminLabelsV1LabelLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
};

export type AdminLabelsV1LabelLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AdminLabelsV1LabelLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminLabelsV1LabelResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  DimensionTable = 'DIMENSION_TABLE',
  EventDefinition = 'EVENT_DEFINITION',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Measurement = 'MEASUREMENT',
  Metric = 'METRIC',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type AdminLabelsV1LabelResult = AdminLabelsV1Label | Error;

export type AdminLabelsV1ListLabelsResponse = {
  labels: Array<AdminLabelsV1Label>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AdminLabelsV1ListLabelsResponseResult =
  | AdminLabelsV1ListLabelsResponse
  | Error;

export enum AdminV1AccountBillingManagementMode {
  BillingManaged = 'BILLING_MANAGED',
  SalesManaged = 'SALES_MANAGED',
}

export type AdminV1AccountDomain = {
  domain: Scalars['String']['output'];
  domainId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AdminV1AccountDomainState>;
  verificationHost?: Maybe<Scalars['String']['output']>;
  verificationTxt?: Maybe<Scalars['String']['output']>;
};

export type AdminV1AccountDomainInput = {
  domain: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AdminV1AccountDomainResult = AdminV1AccountDomain | Error;

export enum AdminV1AccountDomainState {
  Pending = 'PENDING',
  Verified = 'VERIFIED',
}

export type AdminV1AccountInfo = {
  admin?: Maybe<IamV1IdentityResult>;
  allowedLoginEmailDomains: Array<Scalars['String']['output']>;
  authConnections: Array<AdminV1AccountInfoAuthConnection>;
  billingManagementMode?: Maybe<AdminV1AccountBillingManagementMode>;
  blockReason?: Maybe<Scalars['String']['output']>;
  blockTime?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createTime: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  loginId: Scalars['String']['output'];
  mode?: Maybe<AdminV1AccountMode>;
  name: Scalars['String']['output'];
  quotas?: Maybe<AdminV1Quotas>;
  region: AdminV1Region;
  serviceTier?: Maybe<AdminV1ServiceTier>;
  totalConfidenceAccountInfo?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatus>;
  updateTime: Scalars['String']['output'];
};

export type AdminV1AccountInfoAuthConnection = {
  autoJoin?: Maybe<Scalars['Boolean']['output']>;
  googleAuthConnection?: Maybe<AdminV1AccountInfoAuthConnectionGoogleAuthConnection>;
  passwordAuthConnection?: Maybe<AdminV1AccountInfoAuthConnectionPasswordAuthConnection>;
};

export type AdminV1AccountInfoAuthConnectionGoogleAuthConnection = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AdminV1AccountInfoAuthConnectionPasswordAuthConnection = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AdminV1AccountInfoResult = AdminV1AccountInfo | Error;

export type AdminV1AccountInfoTotalConfidenceAccountStatus = {
  accountInfo?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatusTotalConfidenceAccountInfo>;
  creationStartTime: Scalars['String']['output'];
  state?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatusState>;
};

export enum AdminV1AccountInfoTotalConfidenceAccountStatusState {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleted = 'DELETED',
}

export type AdminV1AccountInfoTotalConfidenceAccountStatusTotalConfidenceAccountInfo =
  {
    createDuration: Scalars['String']['output'];
    createTime: Scalars['String']['output'];
    gcpProjectId: Scalars['String']['output'];
  };

export enum AdminV1AccountMode {
  TotalConfidence = 'TOTAL_CONFIDENCE',
  WarehouseNative = 'WAREHOUSE_NATIVE',
}

export type AdminV1EntitlementValue = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  integerValue?: Maybe<Scalars['Long']['output']>;
  unlimited?: Maybe<AdminV1EntitlementValueUnlimited>;
};

export type AdminV1EntitlementValueUnlimited = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AdminV1ListAccountDomainsResponse = {
  accountDomains: Array<AdminV1AccountDomain>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AdminV1ListAccountDomainsResponseResult =
  | AdminV1ListAccountDomainsResponse
  | Error;

export type AdminV1Quotas = {
  limits: Array<AdminV1QuotasLimitsEntry>;
};

export type AdminV1QuotasLimits = {
  hardLimit?: Maybe<Scalars['Long']['output']>;
  softLimit?: Maybe<Scalars['Long']['output']>;
};

export type AdminV1QuotasLimitsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<AdminV1QuotasLimits>;
};

export enum AdminV1Region {
  RegionEu = 'REGION_EU',
  RegionUs = 'REGION_US',
}

export type AdminV1ServiceTier = {
  entitlements: Array<AdminV1ServiceTierEntitlementsEntry>;
  tier: AdminV1ServiceTierTier;
};

export type AdminV1ServiceTierEntitlementsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<AdminV1EntitlementValue>;
};

export enum AdminV1ServiceTierTier {
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Growth = 'GROWTH',
}

export type AiworkflowsV1AccountTokenUsage = {
  sessionCount?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<AiworkflowsV1TokenUsage>;
};

export type AiworkflowsV1AccountTokenUsageResult =
  | AiworkflowsV1AccountTokenUsage
  | Error;

export type AiworkflowsV1Action = {
  executeFunctionAction?: Maybe<AiworkflowsV1ExecuteFunctionAction>;
  notifyFeedAction?: Maybe<AiworkflowsV1NotifyFeedAction>;
  runPromptAction?: Maybe<AiworkflowsV1RunPromptAction>;
  transitionWorkflowAction?: Maybe<AiworkflowsV1TransitionWorkflowAction>;
};

export type AiworkflowsV1ActionInput = {
  executeFunctionAction?: InputMaybe<AiworkflowsV1ExecuteFunctionActionInput>;
  notifyFeedAction?: InputMaybe<AiworkflowsV1NotifyFeedActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runPromptAction?: InputMaybe<AiworkflowsV1RunPromptActionInput>;
  transitionWorkflowAction?: InputMaybe<AiworkflowsV1TransitionWorkflowActionInput>;
};

export type AiworkflowsV1ActivityTrigger = {
  kind: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ActivityTriggerInput = {
  kind: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export enum AiworkflowsV1ActorType {
  ClaudeAgentsActor = 'CLAUDE_AGENTS_ACTOR',
  ClaudeAgentsManagedActor = 'CLAUDE_AGENTS_MANAGED_ACTOR',
  ConfidenceActor = 'CONFIDENCE_ACTOR',
  CursorAgentActor = 'CURSOR_AGENT_ACTOR',
  CustomAgentActor = 'CUSTOM_AGENT_ACTOR',
}

export type AiworkflowsV1AiWorkflowInstance = {
  actorType: AiworkflowsV1ActorType;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<AiworkflowsV1AiWorkflowInstanceLabelsEntry>;
  mode?: Maybe<AiworkflowsV1Mode>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  outcomeType?: Maybe<AiworkflowsV1OutcomeType>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  state?: Maybe<AiworkflowsV1State>;
  taskType: AiworkflowsV1TaskType;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowInstanceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowInstanceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowInstanceObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceInput = {
  actorType: AiworkflowsV1ActorType;
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowInstanceLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<AiworkflowsV1OutcomeType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  taskType: AiworkflowsV1TaskType;
};

export type AiworkflowsV1AiWorkflowInstanceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowInstanceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceResult =
  | AiworkflowsV1AiWorkflowInstance
  | Error;

export type AiworkflowsV1AiWorkflowSchedule = {
  actorType: AiworkflowsV1ActorType;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  executedCount?: Maybe<Scalars['Int']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  intervalMinutes: Scalars['Int']['output'];
  labels: Array<AiworkflowsV1AiWorkflowScheduleLabelsEntry>;
  lastRunTime?: Maybe<Scalars['String']['output']>;
  latestInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  name: Scalars['String']['output'];
  nextRunTime?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  outcomeType?: Maybe<AiworkflowsV1OutcomeType>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleState?: Maybe<AiworkflowsV1ScheduleState>;
  taskType: AiworkflowsV1TaskType;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowScheduleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowScheduleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowScheduleObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleInput = {
  actorType: AiworkflowsV1ActorType;
  intervalMinutes: Scalars['Int']['input'];
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowScheduleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<AiworkflowsV1OutcomeType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType: AiworkflowsV1TaskType;
};

export type AiworkflowsV1AiWorkflowScheduleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowScheduleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleResult =
  | AiworkflowsV1AiWorkflowSchedule
  | Error;

export type AiworkflowsV1AiWorkflowTrigger = {
  action: AiworkflowsV1Action;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  filterName: Scalars['String']['output'];
  filterType: Scalars['String']['output'];
  labels: Array<AiworkflowsV1AiWorkflowTriggerLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  trigger: AiworkflowsV1Trigger;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowTriggerAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowTriggerCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowTriggerObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerInput = {
  action: AiworkflowsV1ActionInput;
  filterName: Scalars['String']['input'];
  filterType: Scalars['String']['input'];
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowTriggerLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger: AiworkflowsV1TriggerInput;
};

export type AiworkflowsV1AiWorkflowTriggerLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowTriggerLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerResult =
  | AiworkflowsV1AiWorkflowTrigger
  | Error;

export enum AiworkflowsV1AlertSeverity {
  AlertSeverityCritical = 'ALERT_SEVERITY_CRITICAL',
  AlertSeverityHigh = 'ALERT_SEVERITY_HIGH',
  AlertSeverityLow = 'ALERT_SEVERITY_LOW',
  AlertSeverityMedium = 'ALERT_SEVERITY_MEDIUM',
}

export enum AiworkflowsV1AlertState {
  AlertActive = 'ALERT_ACTIVE',
  AlertFiring = 'ALERT_FIRING',
  AlertPaused = 'ALERT_PAUSED',
}

export type AiworkflowsV1ArchiveManagedWorkspaceResponse = {
  archivedWorkspaceId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ArchiveManagedWorkspaceResponseResult =
  | AiworkflowsV1ArchiveManagedWorkspaceResponse
  | Error;

export type AiworkflowsV1ClaudeAgentsIntegrationConfigDisplay = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CleanupTargetInput = {
  flagName: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repositoryUri: Scalars['String']['input'];
};

export enum AiworkflowsV1Comparator {
  Above = 'ABOVE',
  Below = 'BELOW',
}

export type AiworkflowsV1CreateClaudeAgentsIntegrationDetails = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1CreateCursorIntegrationDetails = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateCursorIntegrationDetailsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1CreateIntercomIntegrationDetails = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateIntercomIntegrationDetailsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1DashboardAlertTrigger = {
  alertState?: Maybe<AiworkflowsV1AlertState>;
  condition: AiworkflowsV1ThresholdCondition;
  graphType: Scalars['String']['output'];
  labelFilters: Array<AiworkflowsV1DashboardAlertTriggerLabelFiltersEntry>;
  lastChecked?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1DashboardAlertTriggerInput = {
  condition: AiworkflowsV1ThresholdConditionInput;
  graphType: Scalars['String']['input'];
  labelFilters?: InputMaybe<
    Array<AiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1DashboardAlertTriggerLabelFiltersEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExecuteFunctionAction = {
  function: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type AiworkflowsV1ExecuteFunctionActionInput = {
  function: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegration = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  claudeAgents?: Maybe<AiworkflowsV1CreateClaudeAgentsIntegrationDetails>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  cursor?: Maybe<AiworkflowsV1CreateCursorIntegrationDetails>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  github?: Maybe<AiworkflowsV1GithubIntegrationDetails>;
  integrationType?: Maybe<Scalars['String']['output']>;
  intercom?: Maybe<AiworkflowsV1CreateIntercomIntegrationDetails>;
  labels: Array<AiworkflowsV1ExternalIntegrationLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1ExternalIntegrationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1ExternalIntegrationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1ExternalIntegrationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationInput = {
  claudeAgents?: InputMaybe<AiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput>;
  cursor?: InputMaybe<AiworkflowsV1CreateCursorIntegrationDetailsInput>;
  github?: InputMaybe<AiworkflowsV1GithubIntegrationDetailsInput>;
  intercom?: InputMaybe<AiworkflowsV1CreateIntercomIntegrationDetailsInput>;
  labels?: InputMaybe<Array<AiworkflowsV1ExternalIntegrationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ExternalIntegrationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationResult =
  | AiworkflowsV1ExternalIntegration
  | Error;

export enum AiworkflowsV1ExternalIntegrationType {
  ClaudeAgents = 'CLAUDE_AGENTS',
  Cursor = 'CURSOR',
  Github = 'GITHUB',
  Intercom = 'INTERCOM',
}

export type AiworkflowsV1GithubIntegrationDetails = {
  appId: Scalars['Long']['output'];
  installationId: Scalars['Long']['output'];
};

export type AiworkflowsV1GithubIntegrationDetailsInput = {
  appId: Scalars['Long']['input'];
  installationId: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1HasExternalIntegrationResponse = {
  claudeAgentsConfig?: Maybe<AiworkflowsV1ClaudeAgentsIntegrationConfigDisplay>;
  exists: Scalars['Boolean']['output'];
  integrationName?: Maybe<Scalars['String']['output']>;
  working?: Maybe<Scalars['Boolean']['output']>;
};

export type AiworkflowsV1HasExternalIntegrationResponseResult =
  | AiworkflowsV1HasExternalIntegrationResponse
  | Error;

export type AiworkflowsV1InstantiateGithubInstallationResponse = {
  installationUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1InstantiateGithubInstallationResponseResult =
  | AiworkflowsV1InstantiateGithubInstallationResponse
  | Error;

export type AiworkflowsV1InstantiateIntercomInstallationResponse = {
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1InstantiateIntercomInstallationResponseResult =
  | AiworkflowsV1InstantiateIntercomInstallationResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowInstancesResponse = {
  aiWorkflowInstances: Array<AiworkflowsV1AiWorkflowInstance>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowInstancesResponseResult =
  | AiworkflowsV1ListAiWorkflowInstancesResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowSchedulesResponse = {
  aiWorkflowSchedules: Array<AiworkflowsV1AiWorkflowSchedule>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowSchedulesResponseResult =
  | AiworkflowsV1ListAiWorkflowSchedulesResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowTriggersResponse = {
  aiWorkflowTriggers: Array<AiworkflowsV1AiWorkflowTrigger>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowTriggersResponseResult =
  | AiworkflowsV1ListAiWorkflowTriggersResponse
  | Error;

export type AiworkflowsV1ListExternalIntegrationsResponse = {
  externalIntegrations: Array<AiworkflowsV1ExternalIntegration>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListExternalIntegrationsResponseResult =
  | AiworkflowsV1ListExternalIntegrationsResponse
  | Error;

export type AiworkflowsV1ListManagedSessionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  sessions: Array<AiworkflowsV1ManagedCodingSession>;
};

export type AiworkflowsV1ListManagedSessionsResponseResult =
  | AiworkflowsV1ListManagedSessionsResponse
  | Error;

export type AiworkflowsV1ManagedAgentSettings = {
  available?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AiworkflowsV1ManagedAgentSettingsResult =
  | AiworkflowsV1ManagedAgentSettings
  | Error;

export type AiworkflowsV1ManagedCodingSession = {
  branch?: Maybe<Scalars['String']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  repository?: Maybe<Scalars['String']['output']>;
  runtimeMillis?: Maybe<Scalars['Long']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<AiworkflowsV1TokenUsage>;
};

export type AiworkflowsV1ManagedWorkspace = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  federationRuleId?: Maybe<Scalars['String']['output']>;
  serviceAccountId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ManagedWorkspaceResult =
  | AiworkflowsV1ManagedWorkspace
  | Error;

export enum AiworkflowsV1Mode {
  Interval = 'INTERVAL',
  Oneoff = 'ONEOFF',
}

export type AiworkflowsV1NotifyFeedAction = {
  activityType: Scalars['String']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  severity: AiworkflowsV1AlertSeverity;
};

export type AiworkflowsV1NotifyFeedActionInput = {
  activityType: Scalars['String']['input'];
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity: AiworkflowsV1AlertSeverity;
};

export enum AiworkflowsV1OutcomeType {
  GithubIssue = 'GITHUB_ISSUE',
  PullRequest = 'PULL_REQUEST',
  SlackDm = 'SLACK_DM',
}

export type AiworkflowsV1RunPromptAction = {
  actorType: AiworkflowsV1ActorType;
  prompt: Scalars['String']['output'];
  taskType?: Maybe<AiworkflowsV1TaskType>;
};

export type AiworkflowsV1RunPromptActionInput = {
  actorType: AiworkflowsV1ActorType;
  prompt: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<AiworkflowsV1TaskType>;
};

export enum AiworkflowsV1ScheduleState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Paused = 'PAUSED',
}

export enum AiworkflowsV1State {
  Created = 'CREATED',
  Done = 'DONE',
  Error = 'ERROR',
  Running = 'RUNNING',
  RunningCodemod = 'RUNNING_CODEMOD',
}

export type AiworkflowsV1StateTrigger = {
  state: Scalars['String']['output'];
};

export type AiworkflowsV1StateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export enum AiworkflowsV1TaskType {
  StaleFlags = 'STALE_FLAGS',
}

export type AiworkflowsV1ThresholdCondition = {
  comparator: AiworkflowsV1Comparator;
  thresholdValue: Scalars['Float']['output'];
};

export type AiworkflowsV1ThresholdConditionInput = {
  comparator: AiworkflowsV1Comparator;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type AiworkflowsV1TokenUsage = {
  cacheCreationInputTokens?: Maybe<Scalars['Long']['output']>;
  cacheReadInputTokens?: Maybe<Scalars['Long']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  totalInputTokens?: Maybe<Scalars['Long']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
};

export type AiworkflowsV1TransitionWorkflowAction = {
  action: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type AiworkflowsV1TransitionWorkflowActionInput = {
  action: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1Trigger = {
  activityTrigger?: Maybe<AiworkflowsV1ActivityTrigger>;
  dashboardAlertTrigger?: Maybe<AiworkflowsV1DashboardAlertTrigger>;
  stateTrigger?: Maybe<AiworkflowsV1StateTrigger>;
};

export type AiworkflowsV1TriggerInput = {
  activityTrigger?: InputMaybe<AiworkflowsV1ActivityTriggerInput>;
  dashboardAlertTrigger?: InputMaybe<AiworkflowsV1DashboardAlertTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<AiworkflowsV1StateTriggerInput>;
};

export type AnalysisData = {
  endTime?: Maybe<Scalars['String']['output']>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<AnalysisDataTreatment>>;
};

export type AnalysisDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<AnalysisDataInputTreatmentInput>>;
};

export type AnalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type AnalysisDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variantKey: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type AudiencesData = {
  audiences?: Maybe<Array<AudiencesDataAudience>>;
};

export type AudiencesDataAudience = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  segment?: Maybe<FlagsAdminV1SegmentResult>;
};

export type AudiencesDataInput = {
  audiences?: InputMaybe<Array<AudiencesDataInputAudienceInput>>;
};

export type AudiencesDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundData = {
  text?: Maybe<Scalars['String']['output']>;
};

export type BackgroundDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1AccountBilling = {
  billingHistory?: Maybe<BillingV1BillingHistory>;
  billingInfo?: Maybe<BillingV1BillingInfo>;
  managementMode?: Maybe<BillingV1AccountBillingBillingManagementMode>;
  name: Scalars['String']['output'];
};

export enum BillingV1AccountBillingBillingManagementMode {
  BillingManaged = 'BILLING_MANAGED',
  SalesManaged = 'SALES_MANAGED',
}

export type BillingV1AccountBillingResult = BillingV1AccountBilling | Error;

export type BillingV1BillingHistory = {
  trialedBillingProducts: Array<BillingV1BillingProductResult>;
};

export type BillingV1BillingInfo = {
  credits?: Maybe<BillingV1CreditBalance>;
  subscription?: Maybe<BillingV1SubscriptionInfo>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type BillingV1BillingInfoResult = BillingV1BillingInfo | Error;

export type BillingV1BillingProduct = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  creditPack?: Maybe<BillingV1BillingProductCreditPack>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  plan?: Maybe<BillingV1BillingProductPlan>;
  prices: Array<BillingV1ProductPrice>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type BillingV1BillingProductAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1BillingProductCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type BillingV1BillingProductCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1BillingProductExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type BillingV1BillingProductObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1BillingProductQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1BillingProductReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1BillingProductResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1BillingProductReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1BillingProductTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1BillingProductCreditPack = {
  credits?: Maybe<Scalars['Long']['output']>;
};

export type BillingV1BillingProductPlan = {
  entitlements: Array<BillingV1BillingProductPlanEntitlementsEntry>;
  pricingModel?: Maybe<BillingV1BillingProductPlanPricingModel>;
  tier?: Maybe<Scalars['String']['output']>;
  trialAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingV1BillingProductPlanEntitlementsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<BillingV1ProductEntitlementValue>;
};

export enum BillingV1BillingProductPlanPricingModel {
  Custom = 'CUSTOM',
  Fixed = 'FIXED',
  Free = 'FREE',
}

export type BillingV1BillingProductResult = BillingV1BillingProduct | Error;

export type BillingV1CheckoutSession = {
  checkoutUri?: Maybe<Scalars['String']['output']>;
};

export type BillingV1CheckoutSessionResult = BillingV1CheckoutSession | Error;

export type BillingV1CreditBalance = {
  consumed?: Maybe<Scalars['Long']['output']>;
  granted?: Maybe<Scalars['Long']['output']>;
  snapshotTime?: Maybe<Scalars['String']['output']>;
  sourceBreakdown?: Maybe<BillingV1CreditSourceBreakdown>;
};

export type BillingV1CreditSourceBreakdown = {
  monthlyGranted?: Maybe<Scalars['Long']['output']>;
  purchasedGranted?: Maybe<Scalars['Long']['output']>;
};

export type BillingV1CreditUsageReport = {
  endTime?: Maybe<Scalars['String']['output']>;
  lines: Array<BillingV1CreditUsageReportCreditUsageLine>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  totalCredits?: Maybe<Scalars['String']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type BillingV1CreditUsageReportCreditUsageLine = {
  attributionResource?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  usageDelta?: Maybe<Scalars['Long']['output']>;
  usageFeature?: Maybe<UsageV1EventsUsageFeature>;
};

export type BillingV1CreditUsageReportResult =
  | BillingV1CreditUsageReport
  | Error;

export type BillingV1CustomerPortalSession = {
  customerPortalUri?: Maybe<Scalars['String']['output']>;
};

export type BillingV1CustomerPortalSessionResult =
  | BillingV1CustomerPortalSession
  | Error;

export type BillingV1ListBillingProductsResponse = {
  billingProducts: Array<BillingV1BillingProduct>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type BillingV1ListBillingProductsResponseResult =
  | BillingV1ListBillingProductsResponse
  | Error;

export type BillingV1ProductEntitlementValue = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  custom?: Maybe<BillingV1ProductEntitlementValueCustom>;
  integerValue?: Maybe<Scalars['Long']['output']>;
  unlimited?: Maybe<BillingV1ProductEntitlementValueUnlimited>;
};

export type BillingV1ProductEntitlementValueCustom = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type BillingV1ProductEntitlementValueUnlimited = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type BillingV1ProductPrice = {
  amountCents?: Maybe<Scalars['Long']['output']>;
  amountType?: Maybe<BillingV1ProductPriceAmountType>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  recurringInterval?: Maybe<Scalars['String']['output']>;
  recurringIntervalCount?: Maybe<Scalars['Int']['output']>;
};

export enum BillingV1ProductPriceAmountType {
  Custom = 'CUSTOM',
  Fixed = 'FIXED',
  Free = 'FREE',
}

export type BillingV1SubscriptionInfo = {
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  currentPeriodEndTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BillingV1SubscriptionStatus>;
  tier?: Maybe<Scalars['String']['output']>;
  trialEndTime?: Maybe<Scalars['String']['output']>;
};

export enum BillingV1SubscriptionStatus {
  SubscriptionStatusActive = 'SUBSCRIPTION_STATUS_ACTIVE',
  SubscriptionStatusCanceled = 'SUBSCRIPTION_STATUS_CANCELED',
  SubscriptionStatusNone = 'SUBSCRIPTION_STATUS_NONE',
  SubscriptionStatusPastDue = 'SUBSCRIPTION_STATUS_PAST_DUE',
  SubscriptionStatusTrialing = 'SUBSCRIPTION_STATUS_TRIALING',
}

export type C4sAbTest = {
  primaryUnit?: Maybe<Scalars['String']['output']>;
  rampUpDuration?: Maybe<C4sAbTestRampUpDuration>;
  treatments?: Maybe<Array<C4sAbTestTreatment>>;
};

export type C4sAbTestInput = {
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  rampUpDuration?: InputMaybe<C4sAbTestInputRampUpDuration>;
  treatments?: InputMaybe<Array<C4sAbTestInputTreatmentInput>>;
};

export enum C4sAbTestInputRampUpDuration {
  None = 'NONE',
  OneDay = 'ONE_DAY',
  OneWeek = 'ONE_WEEK',
}

export type C4sAbTestInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyAssignments?: InputMaybe<
    Array<C4sAbTestInputTreatmentInputPropertyAssignmentInput>
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type C4sAbTestInputTreatmentInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum C4sAbTestRampUpDuration {
  None = 'NONE',
  OneDay = 'ONE_DAY',
  OneWeek = 'ONE_WEEK',
}

export type C4sAbTestTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overrideGroupId?: Maybe<Scalars['Long']['output']>;
  overrideUserIds?: Maybe<Array<Scalars['String']['output']>>;
  propertyAssignments?: Maybe<Array<C4sAbTestTreatmentPropertyAssignment>>;
  weight?: Maybe<Scalars['Long']['output']>;
};

export type C4sAbTestTreatmentPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type C4sRollout = {
  description?: Maybe<Scalars['String']['output']>;
  monitoringDisabled?: Maybe<Scalars['Boolean']['output']>;
  monitoringDisabledAt?: Maybe<Scalars['String']['output']>;
  primaryUnit?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<C4sRolloutSchedule>;
  treatmentGroupProportion?: Maybe<Array<Scalars['Long']['output']>>;
  treatments?: Maybe<Array<C4sRolloutTreatment>>;
};

export type C4sRolloutInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringDisabledAt?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<C4sRolloutInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Array<Scalars['Long']['input']>>;
  treatments?: InputMaybe<Array<C4sRolloutInputTreatmentInput>>;
};

export type C4sRolloutInputScheduleInput = {
  state?: InputMaybe<C4sRolloutInputScheduleInputState>;
  stateReason?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInput>;
  steps: Array<C4sRolloutInputScheduleInputScheduleStepsInput>;
};

export type C4sRolloutInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInputFailed>;
};

export enum C4sRolloutInputScheduleInputScheduleStateReasonInputFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type C4sRolloutInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep: Scalars['String']['input'];
  reach: Scalars['String']['input'];
  status?: InputMaybe<C4sRolloutInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export enum C4sRolloutInputScheduleInputScheduleStepsInputStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum C4sRolloutInputScheduleInputState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type C4sRolloutInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyAssignments?: InputMaybe<
    Array<C4sRolloutInputTreatmentInputPropertyAssignmentInput>
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type C4sRolloutInputTreatmentInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type C4sRolloutSchedule = {
  state?: Maybe<C4sRolloutScheduleState>;
  stateReason?: Maybe<C4sRolloutScheduleScheduleStateReason>;
  steps: Array<C4sRolloutScheduleScheduleSteps>;
};

export type C4sRolloutScheduleScheduleStateReason = {
  failed?: Maybe<C4sRolloutScheduleScheduleStateReasonFailed>;
};

export enum C4sRolloutScheduleScheduleStateReasonFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type C4sRolloutScheduleScheduleSteps = {
  durationSincePreviousStep: Scalars['String']['output'];
  reach: Scalars['String']['output'];
  status?: Maybe<C4sRolloutScheduleScheduleStepsStatus>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export enum C4sRolloutScheduleScheduleStepsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum C4sRolloutScheduleState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type C4sRolloutTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overrideGroupId?: Maybe<Scalars['Long']['output']>;
  overrideUserIds?: Maybe<Array<Scalars['String']['output']>>;
  propertyAssignments?: Maybe<Array<C4sRolloutTreatmentPropertyAssignment>>;
  weight?: Maybe<Scalars['Long']['output']>;
};

export type C4sRolloutTreatmentPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewPreview = {
  agent: IamV1AgentResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  outcome?: Maybe<CollaborationV1AgentReviewPreviewReviewOutcome>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sections: Array<CollaborationV1AgentReviewSection>;
  state: CollaborationV1AgentReviewPreviewState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewPreviewAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1AgentReviewPreviewCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1AgentReviewPreviewObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewInput = {
  agent: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1AgentReviewPreviewResult =
  | CollaborationV1AgentReviewPreview
  | Error;

export enum CollaborationV1AgentReviewPreviewReviewOutcome {
  Approve = 'APPROVE',
  Reject = 'REJECT',
}

export enum CollaborationV1AgentReviewPreviewState {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

export type CollaborationV1AgentReviewSection = {
  comment?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewSectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type CollaborationV1Anchor = {
  document?: Maybe<CollaborationV1AnchorDocumentAnchor>;
  zone?: Maybe<CollaborationV1AnchorZoneAnchor>;
};

export type CollaborationV1AnchorDocumentAnchor = {
  document: Scalars['String']['output'];
  endNode: Scalars['String']['output'];
  endOffset: Scalars['Int']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  startNode: Scalars['String']['output'];
  startOffset: Scalars['Int']['output'];
};

export type CollaborationV1AnchorDocumentAnchorInput = {
  document: Scalars['String']['input'];
  endNode: Scalars['String']['input'];
  endOffset: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  startNode: Scalars['String']['input'];
  startOffset: Scalars['Int']['input'];
};

export type CollaborationV1AnchorInput = {
  document?: InputMaybe<CollaborationV1AnchorDocumentAnchorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<CollaborationV1AnchorZoneAnchorInput>;
};

export type CollaborationV1AnchorZoneAnchor = {
  zone: Scalars['String']['output'];
};

export type CollaborationV1AnchorZoneAnchorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['String']['input'];
};

export type CollaborationV1ArchiveReviewResponse = {
  review: CollaborationV1Review;
};

export type CollaborationV1ArchiveReviewResponseResult =
  | CollaborationV1ArchiveReviewResponse
  | Error;

export type CollaborationV1Attachment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1AttachmentLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  summary?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  uri: Scalars['String']['output'];
};

export type CollaborationV1AttachmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1AttachmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1AttachmentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<CollaborationV1AttachmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type CollaborationV1AttachmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1AttachmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentResult = CollaborationV1Attachment | Error;

export type CollaborationV1BackfillPromptHooksResponse = {
  createdCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationV1BackfillPromptHooksResponseResult =
  | CollaborationV1BackfillPromptHooksResponse
  | Error;

export type CollaborationV1CollaborativeDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content?: Maybe<Scalars['JSON']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  getTiptapToken?: Maybe<CollaborationV1GetTiptapTokenResponseResult>;
  labels: Array<CollaborationV1CollaborativeDocumentLabelsEntry>;
  markdown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pendingOperation?: Maybe<CollaborationV1CollaborativeDocumentPendingOperation>;
  publishTime?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  realtimeEditing?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: CollaborationV1CollaborativeDocumentState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1CollaborativeDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CollaborativeDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CollaborativeDocumentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<CollaborationV1CollaborativeDocumentLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  realtimeEditing?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CollaborativeDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentPendingOperation = {
  type: CollaborationV1CollaborativeDocumentPendingOperationType;
};

export type CollaborationV1CollaborativeDocumentPendingOperationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type: CollaborationV1CollaborativeDocumentPendingOperationType;
};

export enum CollaborationV1CollaborativeDocumentPendingOperationType {
  AiGeneration = 'AI_GENERATION',
}

export type CollaborationV1CollaborativeDocumentResult =
  | CollaborationV1CollaborativeDocument
  | Error;

export enum CollaborationV1CollaborativeDocumentState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum CollaborationV1CollaborativeDocumentView {
  CollaborativeDocumentViewBasic = 'COLLABORATIVE_DOCUMENT_VIEW_BASIC',
  CollaborativeDocumentViewFull = 'COLLABORATIVE_DOCUMENT_VIEW_FULL',
}

export type CollaborationV1Comment = {
  anchor?: Maybe<CollaborationV1Anchor>;
  assignee?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  commentReplies?: Maybe<CollaborationV1ListCommentRepliesResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content: Scalars['String']['output'];
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1CommentLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1CommentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CommentCommentRepliesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CommentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentInput = {
  anchor?: InputMaybe<CollaborationV1AnchorInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  labels?: InputMaybe<Array<CollaborationV1CommentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1CommentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CommentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReply = {
  action?: Maybe<CollaborationV1CommentReplyAction>;
  assignee?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1CommentReplyLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1CommentReplyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentReplyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CommentReplyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentReplyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CommentReplyObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentReplyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CollaborationV1CommentReplyAction {
  Assign = 'ASSIGN',
  Reopen = 'REOPEN',
  Resolve = 'RESOLVE',
}

export type CollaborationV1CommentReplyInput = {
  action?: InputMaybe<CollaborationV1CommentReplyAction>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<CollaborationV1CommentReplyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CommentReplyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyResult =
  | CollaborationV1CommentReply
  | Error;

export type CollaborationV1CommentResult = CollaborationV1Comment | Error;

export type CollaborationV1EventsAgentReviewPreviewCreated = {
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreview>;
};

export type CollaborationV1EventsAgentReviewPreviewUpdated = {
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreview>;
};

export type CollaborationV1EventsAttachmentCreated = {
  attachment?: Maybe<CollaborationV1Attachment>;
};

export type CollaborationV1EventsAttachmentDeleted = {
  attachment?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsAttachmentUpdated = {
  attachment?: Maybe<CollaborationV1Attachment>;
};

export type CollaborationV1EventsCollaborativeDocumentUpdated = {
  collaborativeDocument?: Maybe<CollaborationV1CollaborativeDocument>;
};

export type CollaborationV1EventsCommentCreated = {
  comment?: Maybe<CollaborationV1Comment>;
};

export type CollaborationV1EventsCommentDeleted = {
  comment?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsCommentReplyCreated = {
  reply?: Maybe<CollaborationV1CommentReply>;
};

export type CollaborationV1EventsCommentReplyDeleted = {
  reply?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsCommentReplyUpdated = {
  reply?: Maybe<CollaborationV1CommentReply>;
};

export type CollaborationV1EventsCommentUpdated = {
  comment?: Maybe<CollaborationV1Comment>;
};

export type CollaborationV1EventsPresenceCreated = {
  presence?: Maybe<CollaborationV1Presence>;
};

export type CollaborationV1EventsPresenceDeleted = {
  presence?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsPresenceUpdated = {
  presence?: Maybe<CollaborationV1Presence>;
};

export type CollaborationV1EventsProjectCreated = {
  project?: Maybe<CollaborationV1Project>;
};

export type CollaborationV1EventsProjectDeleted = {
  project?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsProjectUpdated = {
  project?: Maybe<CollaborationV1Project>;
};

export type CollaborationV1EventsReactionCreated = {
  reaction?: Maybe<CollaborationV1Reaction>;
};

export type CollaborationV1EventsReactionDeleted = {
  reaction?: Maybe<CollaborationV1Reaction>;
};

export type CollaborationV1EventsReactionSummaryCreated = {
  reactionSummary?: Maybe<CollaborationV1ReactionSummary>;
};

export type CollaborationV1EventsReactionSummaryUpdated = {
  reactionSummary?: Maybe<CollaborationV1ReactionSummary>;
};

export type CollaborationV1EventsReviewCreated = {
  review?: Maybe<CollaborationV1Review>;
};

export type CollaborationV1EventsReviewDeleted = {
  review?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseCreated = {
  response?: Maybe<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewResponseDeleted = {
  response?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseRequested = {
  requester?: Maybe<Scalars['String']['output']>;
  responses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewResponseSubmitted = {
  response?: Maybe<CollaborationV1ReviewResponse>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseUpdated = {
  response?: Maybe<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewUpdated = {
  review?: Maybe<CollaborationV1Review>;
};

export type CollaborationV1ExternalDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ExternalDocumentLabelsEntry>;
  markdown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  refreshTime?: Maybe<Scalars['String']['output']>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source: CollaborationV1ExternalDocumentSource;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1ExternalDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ExternalDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ExternalDocumentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentInput = {
  labels?: InputMaybe<Array<CollaborationV1ExternalDocumentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  source: CollaborationV1ExternalDocumentSourceInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ExternalDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentResult =
  | CollaborationV1ExternalDocument
  | Error;

export type CollaborationV1ExternalDocumentSource = {
  sourceId: Scalars['String']['output'];
  type: CollaborationV1ExternalDocumentSourceType;
  uri?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ExternalDocumentSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  type: CollaborationV1ExternalDocumentSourceType;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum CollaborationV1ExternalDocumentSourceType {
  GoogleDocs = 'GOOGLE_DOCS',
  GoogleSlides = 'GOOGLE_SLIDES',
  Notion = 'NOTION',
}

export enum CollaborationV1ExternalDocumentView {
  ExternalDocumentViewBasic = 'EXTERNAL_DOCUMENT_VIEW_BASIC',
  ExternalDocumentViewFull = 'EXTERNAL_DOCUMENT_VIEW_FULL',
}

export type CollaborationV1GetTiptapTokenResponse = {
  appId: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  readWrite?: Maybe<Scalars['Boolean']['output']>;
  tiptapDocumentName?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type CollaborationV1GetTiptapTokenResponseResult =
  | CollaborationV1GetTiptapTokenResponse
  | Error;

export type CollaborationV1KnowledgeFragmentInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceUri: Scalars['String']['input'];
};

export type CollaborationV1ListAttachmentsResponse = {
  attachments: Array<CollaborationV1Attachment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListAttachmentsResponseResult =
  | CollaborationV1ListAttachmentsResponse
  | Error;

export type CollaborationV1ListCollaborativeDocumentsResponse = {
  collaborativeDocuments: Array<CollaborationV1CollaborativeDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCollaborativeDocumentsResponseResult =
  | CollaborationV1ListCollaborativeDocumentsResponse
  | Error;

export type CollaborationV1ListCommentRepliesResponse = {
  commentReplies: Array<CollaborationV1CommentReply>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCommentRepliesResponseResult =
  | CollaborationV1ListCommentRepliesResponse
  | Error;

export type CollaborationV1ListCommentsResponse = {
  comments: Array<CollaborationV1Comment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCommentsResponseResult =
  | CollaborationV1ListCommentsResponse
  | Error;

export type CollaborationV1ListExternalDocumentsResponse = {
  externalDocuments: Array<CollaborationV1ExternalDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListExternalDocumentsResponseResult =
  | CollaborationV1ListExternalDocumentsResponse
  | Error;

export type CollaborationV1ListPresencesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  presences: Array<CollaborationV1Presence>;
};

export type CollaborationV1ListPresencesResponseResult =
  | CollaborationV1ListPresencesResponse
  | Error;

export type CollaborationV1ListProjectsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  projects: Array<CollaborationV1Project>;
};

export type CollaborationV1ListProjectsResponseResult =
  | CollaborationV1ListProjectsResponse
  | Error;

export type CollaborationV1ListReactionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reactions: Array<CollaborationV1Reaction>;
};

export type CollaborationV1ListReactionsResponseResult =
  | CollaborationV1ListReactionsResponse
  | Error;

export type CollaborationV1ListReviewResponsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1ListReviewResponsesResponseResult =
  | CollaborationV1ListReviewResponsesResponse
  | Error;

export type CollaborationV1ListReviewsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviews: Array<CollaborationV1Review>;
};

export type CollaborationV1ListReviewsResponseResult =
  | CollaborationV1ListReviewsResponse
  | Error;

export type CollaborationV1ListUserRequestedReviewResponsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1ListUserRequestedReviewResponsesResponseResult =
  | CollaborationV1ListUserRequestedReviewResponsesResponse
  | Error;

export type CollaborationV1Presence = {
  actor: IamV1IdentityResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1PresenceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1PresenceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1PresenceObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceResult = CollaborationV1Presence | Error;

export type CollaborationV1PreviewAgentReviewResponse = {
  comment?: Maybe<Scalars['String']['output']>;
  outcome: CollaborationV1PreviewAgentReviewResponseReviewOutcome;
  sections: Array<CollaborationV1AgentReviewSection>;
};

export type CollaborationV1PreviewAgentReviewResponseResult =
  | CollaborationV1PreviewAgentReviewResponse
  | Error;

export enum CollaborationV1PreviewAgentReviewResponseReviewOutcome {
  Approve = 'APPROVE',
  Reject = 'REJECT',
}

export type CollaborationV1Project = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  labels: Array<CollaborationV1ProjectLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  summary?: Maybe<CollaborationV1ProjectSummary>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1ProjectAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ProjectCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ProjectObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<CollaborationV1ProjectLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<CollaborationV1ProjectSummaryInput>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollaborationV1ProjectLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ProjectLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectResult = CollaborationV1Project | Error;

export type CollaborationV1ProjectSummary = {
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ProjectSummaryInput = {
  body: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CollaborationV1ProviderDocumentPage = {
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastEditedTime?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1QueryReactionSummaryResponse = {
  summary: CollaborationV1ReactionSummary;
};

export type CollaborationV1QueryReactionSummaryResponseResult =
  | CollaborationV1QueryReactionSummaryResponse
  | Error;

export type CollaborationV1Reaction = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReactionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReactionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReactionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionInput = {
  emoji: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1ReactionResult = CollaborationV1Reaction | Error;

export type CollaborationV1ReactionSummary = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  commentCount: Scalars['Int']['output'];
  commentators: Array<IamV1IdentityResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  emojiReactions: Array<CollaborationV1ReactionSummaryEmojiReactionsEntry>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReactionSummaryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReactionSummaryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReactionSummaryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryEmojiReactionSummary = {
  emoji?: Maybe<Scalars['String']['output']>;
  identities: Array<IamV1IdentityResult>;
  reactionCount?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationV1ReactionSummaryEmojiReactionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<CollaborationV1ReactionSummaryEmojiReactionSummary>;
};

export type CollaborationV1RequestReviewResponsesResponse = {
  review: CollaborationV1Review;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1RequestReviewResponsesResponseResult =
  | CollaborationV1RequestReviewResponsesResponse
  | Error;

export type CollaborationV1Review = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  assignedReviewers: Array<CollaborationV1ReviewReviewers>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ReviewLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewResponses?: Maybe<CollaborationV1ListReviewResponsesResponseResult>;
  /** @deprecated No longer supported */
  reviewers: Array<CollaborationV1ReviewReviewer>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: CollaborationV1ReviewState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReviewAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReviewCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReviewObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewInput = {
  assignedReviewers?: InputMaybe<Array<CollaborationV1ReviewReviewersInput>>;
  labels?: InputMaybe<Array<CollaborationV1ReviewLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  reviewers?: InputMaybe<Array<CollaborationV1ReviewReviewerInput>>;
};

export type CollaborationV1ReviewLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ReviewLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponse = {
  action?: Maybe<CollaborationV1ReviewResponseAction>;
  archiveTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comment?: Maybe<CollaborationV1CommentResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ReviewResponseLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewers: Array<IamV1IdentityResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  stale?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReviewResponseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewResponseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReviewResponseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewResponseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReviewResponseObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewResponseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CollaborationV1ReviewResponseAction {
  Approve = 'APPROVE',
  Reject = 'REJECT',
  Requested = 'REQUESTED',
}

export type CollaborationV1ReviewResponseLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ReviewResponseResult =
  | CollaborationV1ReviewResponse
  | Error;

export type CollaborationV1ReviewResult = CollaborationV1Review | Error;

export type CollaborationV1ReviewReviewer = {
  identity: IamV1IdentityResult;
  role: CollaborationV1ReviewReviewerReviewRole;
};

export type CollaborationV1ReviewReviewerInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: CollaborationV1ReviewReviewerReviewRole;
};

export enum CollaborationV1ReviewReviewerReviewRole {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export type CollaborationV1ReviewReviewers = {
  identity: Array<IamV1IdentityResult>;
  role: CollaborationV1ReviewReviewersReviewRole;
};

export type CollaborationV1ReviewReviewersInput = {
  identity: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: CollaborationV1ReviewReviewersReviewRole;
};

export enum CollaborationV1ReviewReviewersReviewRole {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export enum CollaborationV1ReviewState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum CollaborationV1SearchProvider {
  GoogleDrive = 'GOOGLE_DRIVE',
  Notion = 'NOTION',
}

export type CollaborationV1SearchProviderDocumentsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pages: Array<CollaborationV1ProviderDocumentPage>;
};

export type CollaborationV1SearchProviderDocumentsResponseResult =
  | CollaborationV1SearchProviderDocumentsResponse
  | Error;

export type CollaborationV1StaleReviewResponse = {
  review: CollaborationV1Review;
};

export type CollaborationV1StaleReviewResponseResult =
  | CollaborationV1StaleReviewResponse
  | Error;

export type CollaborationV1SubmitReviewResponseResponse = {
  review: CollaborationV1Review;
  reviewResponse: CollaborationV1ReviewResponse;
};

export type CollaborationV1SubmitReviewResponseResponseResult =
  | CollaborationV1SubmitReviewResponseResponse
  | Error;

export type CollaborationV1UndoReactionResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1UndoReactionResponseResult =
  | CollaborationV1UndoReactionResponse
  | Error;

export type CollectionsV1Collection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  collectionEntries?: Maybe<CollectionsV1ListCollectionEntriesResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<CollectionsV1CollectionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceTypes: Array<CollectionsV1ResourceType>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollectionsV1CollectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollectionsV1CollectionCollectionEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollectionsV1CollectionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntry = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<IamV1IdentityResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<CollectionsV1CollectionEntryResourceUnion>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type CollectionsV1CollectionEntryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollectionsV1CollectionEntryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollectionsV1CollectionEntryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollectionsV1CollectionEntryResourceUnion =
  | CollaborationV1ExternalDocument
  | CollaborationV1Project
  | Error
  | FlagsAdminV1Flag
  | FlagsAdminV1Segment
  | MetricsV1AssignmentTable
  | MetricsV1DimensionTable
  | MetricsV1FactTable
  | MetricsV1Metric
  | WorkflowV1Initiative
  | WorkflowV1Surface
  | WorkflowV1WorkflowInstance;

export type CollectionsV1CollectionEntryResult =
  | CollectionsV1CollectionEntry
  | Error;

export type CollectionsV1CollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<CollectionsV1CollectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<CollectionsV1ResourceType>>;
};

export type CollectionsV1CollectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1CollectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionResult = CollectionsV1Collection | Error;

export type CollectionsV1EventsCollectionCreated = {
  collection: CollectionsV1Collection;
};

export type CollectionsV1EventsCollectionDeleted = {
  collection: Scalars['String']['output'];
};

export type CollectionsV1EventsCollectionEntryCreated = {
  collectionEntry: CollectionsV1CollectionEntry;
};

export type CollectionsV1EventsCollectionEntryDeleted = {
  collectionEntry: Scalars['String']['output'];
};

export type CollectionsV1EventsCollectionUpdated = {
  collection: CollectionsV1Collection;
};

export type CollectionsV1ListCollectionEntriesResponse = {
  collectionEntries: Array<CollectionsV1CollectionEntry>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1ListCollectionEntriesResponseResult =
  | CollectionsV1ListCollectionEntriesResponse
  | Error;

export type CollectionsV1ListCollectionsResponse = {
  collections: Array<CollectionsV1Collection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1ListCollectionsResponseResult =
  | CollectionsV1ListCollectionsResponse
  | Error;

export enum CollectionsV1ResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  DimensionTable = 'DIMENSION_TABLE',
  ExternalDocument = 'EXTERNAL_DOCUMENT',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Metric = 'METRIC',
  Project = 'PROJECT',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type ConclusionOneOfInput = {
  conclusion?: InputMaybe<ExploreDataInputAnalysisInputConclusionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1AwsCredentialsAuthenticationSettings = {
  accessKeyId: Scalars['String']['output'];
};

export type ConnectorsV1AwsCredentialsAuthenticationSettingsInput = {
  accessKeyId: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey: Scalars['String']['input'];
};

export enum ConnectorsV1AwsRegion {
  AfSouth_1 = 'AF_SOUTH_1',
  ApEast_1 = 'AP_EAST_1',
  ApNortheast_1 = 'AP_NORTHEAST_1',
  ApNortheast_2 = 'AP_NORTHEAST_2',
  ApNortheast_3 = 'AP_NORTHEAST_3',
  ApSoutheast_1 = 'AP_SOUTHEAST_1',
  ApSoutheast_2 = 'AP_SOUTHEAST_2',
  ApSoutheast_3 = 'AP_SOUTHEAST_3',
  ApSoutheast_4 = 'AP_SOUTHEAST_4',
  ApSouth_1 = 'AP_SOUTH_1',
  ApSouth_2 = 'AP_SOUTH_2',
  CaCentral_1 = 'CA_CENTRAL_1',
  CnNorthwest_1 = 'CN_NORTHWEST_1',
  CnNorth_1 = 'CN_NORTH_1',
  EuCentral_1 = 'EU_CENTRAL_1',
  EuCentral_2 = 'EU_CENTRAL_2',
  EuNorth_1 = 'EU_NORTH_1',
  EuSouth_1 = 'EU_SOUTH_1',
  EuSouth_2 = 'EU_SOUTH_2',
  EuWest_1 = 'EU_WEST_1',
  EuWest_2 = 'EU_WEST_2',
  EuWest_3 = 'EU_WEST_3',
  IlCentral_1 = 'IL_CENTRAL_1',
  MeCentral_1 = 'ME_CENTRAL_1',
  MeSouth_1 = 'ME_SOUTH_1',
  SaEast_1 = 'SA_EAST_1',
  UsEast_1 = 'US_EAST_1',
  UsEast_2 = 'US_EAST_2',
  UsGovEast_1 = 'US_GOV_EAST_1',
  UsGovWest_1 = 'US_GOV_WEST_1',
  UsIsoEast_1 = 'US_ISO_EAST_1',
  UsIsoWest_1 = 'US_ISO_WEST_1',
  UsWest_1 = 'US_WEST_1',
  UsWest_2 = 'US_WEST_2',
}

export type ConnectorsV1AwsWebIdentityAuthenticationSettings = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1AwsWebIdentityAuthenticationSettingsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1BatchFileConfig = {
  maxEventsPerFile: Scalars['Long']['output'];
  maxFileAge: Scalars['String']['output'];
  maxFileSize: Scalars['Long']['output'];
};

export type ConnectorsV1BatchFileConfigInput = {
  maxEventsPerFile: Scalars['Long']['input'];
  maxFileAge: Scalars['String']['input'];
  maxFileSize: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1BigQueryConfig = {
  dataset: Scalars['String']['output'];
  project: Scalars['String']['output'];
  serviceAccount: Scalars['String']['output'];
};

export type ConnectorsV1BigQueryConfigInput = {
  dataset: Scalars['String']['input'];
  project: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount: Scalars['String']['input'];
};

export type ConnectorsV1DatabricksConfig = {
  batchFileConfig: ConnectorsV1BatchFileConfig;
  connectionConfig: ConnectorsV1DatabricksConnectionConfig;
  s3BucketConfig?: Maybe<ConnectorsV1S3BucketConfig>;
  schema: Scalars['String']['output'];
};

export type ConnectorsV1DatabricksConfigInput = {
  batchFileConfig: ConnectorsV1BatchFileConfigInput;
  connectionConfig: ConnectorsV1DatabricksConnectionConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  s3BucketConfig?: InputMaybe<ConnectorsV1S3BucketConfigInput>;
  schema: Scalars['String']['input'];
};

export type ConnectorsV1DatabricksConnectionConfig = {
  clientId: Scalars['String']['output'];
  host: Scalars['String']['output'];
  warehouseId: Scalars['String']['output'];
};

export type ConnectorsV1DatabricksConnectionConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['String']['input'];
};

export type ConnectorsV1Event = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  cloudEvent?: Maybe<IoCloudeventsV1CloudEvent>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  eventType?: Maybe<ConnectorsV1EventTypeResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pubsubMetadata?: Maybe<ConnectorsV1EventPubsubMetadata>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resources: Array<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type ConnectorsV1EventAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bigQuery?: Maybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfig>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  databricks?: Maybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfig>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  includedDefinitions: Array<EventsAdminV1EventDefinitionResult>;
  labels: Array<ConnectorsV1EventConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  redshift?: Maybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snowflake?: Maybe<ConnectorsV1EventConnectionSnowflakeEventConnectionConfig>;
  state?: Maybe<ConnectorsV1State>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1EventConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventConnectionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionBigQueryEventConnectionConfig = {
  bigQueryConfig: ConnectorsV1BigQueryConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput = {
  bigQueryConfig: ConnectorsV1BigQueryConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionDatabricksEventConnectionConfig = {
  databricksConfig: ConnectorsV1DatabricksConfig;
};

export type ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput = {
  databricksConfig: ConnectorsV1DatabricksConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionInput = {
  bigQuery?: InputMaybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  databricks?: InputMaybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput>;
  includedDefinitions?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<ConnectorsV1EventConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshift?: InputMaybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1EventConnectionSnowflakeEventConnectionConfigInput>;
};

export type ConnectorsV1EventConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionRedshiftEventConnectionConfig = {
  batchFileConfig: ConnectorsV1BatchFileConfig;
  redshiftConfig: ConnectorsV1RedshiftConfig;
  s3Config: ConnectorsV1S3BucketConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput = {
  batchFileConfig: ConnectorsV1BatchFileConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig: ConnectorsV1RedshiftConfigInput;
  s3Config: ConnectorsV1S3BucketConfigInput;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionResult =
  | ConnectorsV1EventConnection
  | Error;

export type ConnectorsV1EventConnectionSnowflakeEventConnectionConfig = {
  snowflakeConfig: ConnectorsV1SnowflakeConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionSnowflakeEventConnectionConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snowflakeConfig: ConnectorsV1SnowflakeConfigInput;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventPubsubMetadata = {
  consumeTime?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  publishTime?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventResult = ConnectorsV1Event | Error;

export type ConnectorsV1EventType = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  persist?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type ConnectorsV1EventTypeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventTypeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventTypeObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeResult = ConnectorsV1EventType | Error;

export type ConnectorsV1FlagAppliedConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bigQuery?: Maybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfig>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  databricks?: Maybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfig>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kinesis?: Maybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfig>;
  labels: Array<ConnectorsV1FlagAppliedConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pubsub?: Maybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfig>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  redshift?: Maybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snowflake?: Maybe<ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfig>;
  state?: Maybe<ConnectorsV1State>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1FlagAppliedConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1FlagAppliedConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1FlagAppliedConnectionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfig =
  {
    bigQueryConfig: ConnectorsV1BigQueryConfig;
    evaluationContextTable?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode>;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput =
  {
    bigQueryConfig: ConnectorsV1BigQueryConfigInput;
    evaluationContextTable?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfig =
  {
    databricksConfig: ConnectorsV1DatabricksConfig;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode>;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput =
  {
    databricksConfig: ConnectorsV1DatabricksConfigInput;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionInput = {
  bigQuery?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  databricks?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput>;
  kinesis?: InputMaybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput>;
  labels?: InputMaybe<Array<ConnectorsV1FlagAppliedConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  pubsub?: InputMaybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfigInput>;
};

export type ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfig =
  {
    kinesisConfig: ConnectorsV1KinesisConfig;
  };

export type ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput =
  {
    kinesisConfig: ConnectorsV1KinesisConfigInput;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type ConnectorsV1FlagAppliedConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1FlagAppliedConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfig =
  {
    pubsubConfig: ConnectorsV1PubsubConfig;
  };

export type ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    pubsubConfig: ConnectorsV1PubsubConfigInput;
  };

export type ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfig =
  {
    batchFileConfig: ConnectorsV1BatchFileConfig;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode>;
    redshiftConfig: ConnectorsV1RedshiftConfig;
    s3Config: ConnectorsV1S3BucketConfig;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput =
  {
    batchFileConfig: ConnectorsV1BatchFileConfigInput;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    redshiftConfig: ConnectorsV1RedshiftConfigInput;
    s3Config: ConnectorsV1S3BucketConfigInput;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionResult =
  | ConnectorsV1FlagAppliedConnection
  | Error;

export type ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfig =
  {
    snowflakeConfig: ConnectorsV1SnowflakeConfig;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    snowflakeConfig: ConnectorsV1SnowflakeConfigInput;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1Format {
  Json = 'JSON',
  Proto = 'PROTO',
}

export type ConnectorsV1KinesisConfig = {
  outputFormat: ConnectorsV1Format;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  stream: Scalars['String']['output'];
};

export type ConnectorsV1KinesisConfigInput = {
  outputFormat: ConnectorsV1Format;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  stream: Scalars['String']['input'];
};

export type ConnectorsV1ListEventConnectionsResponse = {
  eventConnections: Array<ConnectorsV1EventConnection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventConnectionsResponseResult =
  | ConnectorsV1ListEventConnectionsResponse
  | Error;

export type ConnectorsV1ListEventTypesResponse = {
  eventTypes: Array<ConnectorsV1EventType>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventTypesResponseResult =
  | ConnectorsV1ListEventTypesResponse
  | Error;

export type ConnectorsV1ListEventsResponse = {
  events: Array<ConnectorsV1Event>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventsResponseResult =
  | ConnectorsV1ListEventsResponse
  | Error;

export type ConnectorsV1ListFlagAppliedConnectionsResponse = {
  flagAppliedConnections: Array<ConnectorsV1FlagAppliedConnection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListFlagAppliedConnectionsResponseResult =
  | ConnectorsV1ListFlagAppliedConnectionsResponse
  | Error;

export type ConnectorsV1ListPlatformConnectionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  platformConnections: Array<ConnectorsV1PlatformConnection>;
};

export type ConnectorsV1ListPlatformConnectionsResponseResult =
  | ConnectorsV1ListPlatformConnectionsResponse
  | Error;

export type ConnectorsV1PartialSnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  database?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type ConnectorsV1PlatformConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  eventType: ConnectorsV1EventTypeResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kinesis?: Maybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfig>;
  labels: Array<ConnectorsV1PlatformConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pubsub?: Maybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfig>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<ConnectorsV1State>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1PlatformConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1PlatformConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1PlatformConnectionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionInput = {
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  eventType: Scalars['String']['input'];
  kinesis?: InputMaybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput>;
  labels?: InputMaybe<Array<ConnectorsV1PlatformConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  pubsub?: InputMaybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput>;
};

export type ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfig = {
  kinesisConfig: ConnectorsV1KinesisConfig;
};

export type ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput =
  {
    kinesisConfig: ConnectorsV1KinesisConfigInput;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type ConnectorsV1PlatformConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1PlatformConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfig = {
  pubsubConfig: ConnectorsV1PubsubConfig;
};

export type ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    pubsubConfig: ConnectorsV1PubsubConfigInput;
  };

export type ConnectorsV1PlatformConnectionResult =
  | ConnectorsV1PlatformConnection
  | Error;

export type ConnectorsV1PubsubConfig = {
  outputFormat: ConnectorsV1Format;
  project: Scalars['String']['output'];
  serviceAccount: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export type ConnectorsV1PubsubConfigInput = {
  outputFormat: ConnectorsV1Format;
  project: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type ConnectorsV1RedshiftConfig = {
  cluster: Scalars['String']['output'];
  credentialsSettings?: Maybe<ConnectorsV1AwsCredentialsAuthenticationSettings>;
  database: Scalars['String']['output'];
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  webIdentitySettings?: Maybe<ConnectorsV1AwsWebIdentityAuthenticationSettings>;
};

export type ConnectorsV1RedshiftConfigInput = {
  cluster: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<ConnectorsV1AwsCredentialsAuthenticationSettingsInput>;
  database: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  schema: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<ConnectorsV1AwsWebIdentityAuthenticationSettingsInput>;
};

export type ConnectorsV1S3BucketConfig = {
  bucket: Scalars['String']['output'];
  credentialsSettings?: Maybe<ConnectorsV1AwsCredentialsAuthenticationSettings>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  webIdentitySettings?: Maybe<ConnectorsV1AwsWebIdentityAuthenticationSettings>;
};

export type ConnectorsV1S3BucketConfigInput = {
  bucket: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<ConnectorsV1AwsCredentialsAuthenticationSettingsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<ConnectorsV1AwsWebIdentityAuthenticationSettingsInput>;
};

export type ConnectorsV1SnowflakeConfig = {
  account: Scalars['String']['output'];
  authenticationKey: IamV1CryptoKeyResult;
  database: Scalars['String']['output'];
  role: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ConnectorsV1SnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  database: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  schema: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type ConnectorsV1SnowflakeConfigValidation = {
  databases: Array<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  schemas: Array<Scalars['String']['output']>;
};

export enum ConnectorsV1State {
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type ConnectorsV1UsageMetadata = {
  errorRate?: Maybe<ConnectorsV1UsageMetadataRates>;
  lag?: Maybe<ConnectorsV1UsageMetadataHistogram>;
  successRate?: Maybe<ConnectorsV1UsageMetadataRates>;
  successRatio?: Maybe<ConnectorsV1UsageMetadataRates>;
};

export type ConnectorsV1UsageMetadataHistogram = {
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  p75?: Maybe<Scalars['Float']['output']>;
  p95?: Maybe<Scalars['Float']['output']>;
  p99?: Maybe<Scalars['Float']['output']>;
};

export type ConnectorsV1UsageMetadataHistogramInput = {
  average?: InputMaybe<Scalars['Float']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  median?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  p75?: InputMaybe<Scalars['Float']['input']>;
  p95?: InputMaybe<Scalars['Float']['input']>;
  p99?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1UsageMetadataInput = {
  errorRate?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
  lag?: InputMaybe<ConnectorsV1UsageMetadataHistogramInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successRate?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
  successRatio?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
};

export type ConnectorsV1UsageMetadataRates = {
  rate1m?: Maybe<Scalars['Float']['output']>;
  rate5m?: Maybe<Scalars['Float']['output']>;
  rate15m?: Maybe<Scalars['Float']['output']>;
};

export type ConnectorsV1UsageMetadataRatesInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rate1m?: InputMaybe<Scalars['Float']['input']>;
  rate5m?: InputMaybe<Scalars['Float']['input']>;
  rate15m?: InputMaybe<Scalars['Float']['input']>;
};

export type ConnectorsV1ValidateEventConnectionConfigResponse = {
  bigQueryConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseBigQueryConfigValidation>;
  databricksConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseDatabricksConfigValidation>;
  redshiftConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<ConnectorsV1SnowflakeConfigValidation>;
};

export type ConnectorsV1ValidateEventConnectionConfigResponseBigQueryConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseDatabricksConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseRedshiftConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseResult =
  | ConnectorsV1ValidateEventConnectionConfigResponse
  | Error;

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponse = {
  bigQueryConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseBigQueryConfigValidation>;
  databricksConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseDatabricksConfigValidation>;
  kinesisConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseKinesisConfigValidation>;
  pubsubConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponsePubsubConfigValidation>;
  redshiftConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<ConnectorsV1SnowflakeConfigValidation>;
};

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseBigQueryConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseDatabricksConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseKinesisConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponsePubsubConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseRedshiftConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseResult =
  | ConnectorsV1ValidateFlagAppliedConnectionConfigResponse
  | Error;

export type ConnectorsV1ValidatePlatformConnectionConfigResponse = {
  kinesisConfigValidation?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponseKinesisConfigValidation>;
  pubsubConfigValidation?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponsePubsubConfigValidation>;
};

export type ConnectorsV1ValidatePlatformConnectionConfigResponseKinesisConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidatePlatformConnectionConfigResponsePubsubConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidatePlatformConnectionConfigResponseResult =
  | ConnectorsV1ValidatePlatformConnectionConfigResponse
  | Error;

export type ConversationsV1ApprovedToolCall = {
  tool: Scalars['String']['output'];
};

export type ConversationsV1ApprovedToolCallInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV1Conversation = {
  account?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['String']['output']>;
  approvedToolCalls: Array<ConversationsV1ApprovedToolCall>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  exportConversation?: Maybe<ConversationsV1ExportConversationResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  firstUserMessage?: Maybe<Scalars['String']['output']>;
  lifecycle?: Maybe<ConversationsV1ConversationLifecycle>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages: Array<ConversationsV1ConversationMessage>;
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sessionId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ConversationsV1ConversationSource>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV1ConversationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationExportConversationArgs = {
  format?: InputMaybe<ConversationsV1ExportFormat>;
};

export type ConversationsV1ConversationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV1ConversationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationEvent = {
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationEventInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  approvedToolCalls?: InputMaybe<Array<ConversationsV1ApprovedToolCallInput>>;
  lifecycle?: InputMaybe<ConversationsV1ConversationLifecycle>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV1ConversationSource>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationsV1ConversationLifecycle {
  ConversationLifecycleActive = 'CONVERSATION_LIFECYCLE_ACTIVE',
  ConversationLifecycleArchived = 'CONVERSATION_LIFECYCLE_ARCHIVED',
}

export type ConversationsV1ConversationMessage = {
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  events: Array<ConversationsV1ConversationEvent>;
  generatedKind?: Maybe<ConversationsV1GeneratedKind>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  pendingApproval?: Maybe<ConversationsV1PendingApproval>;
  role: ConversationsV1MessageRole;
  toolCalls?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  generatedKind?: InputMaybe<ConversationsV1GeneratedKind>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<ConversationsV1PendingApprovalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: ConversationsV1MessageRole;
  toolCalls?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationMessageResult =
  | ConversationsV1ConversationMessage
  | Error;

export type ConversationsV1ConversationResult =
  | ConversationsV1Conversation
  | Error;

export enum ConversationsV1ConversationSource {
  ConversationSourceApi = 'CONVERSATION_SOURCE_API',
  ConversationSourceCli = 'CONVERSATION_SOURCE_CLI',
  ConversationSourceSlack = 'CONVERSATION_SOURCE_SLACK',
  ConversationSourceWeb = 'CONVERSATION_SOURCE_WEB',
}

export enum ConversationsV1ConversationView {
  ConversationViewBasic = 'CONVERSATION_VIEW_BASIC',
  ConversationViewFull = 'CONVERSATION_VIEW_FULL',
}

export type ConversationsV1ExportConversationResponse = {
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type ConversationsV1ExportConversationResponseResult =
  | ConversationsV1ExportConversationResponse
  | Error;

export enum ConversationsV1ExportFormat {
  ExportFormatMarkdown = 'EXPORT_FORMAT_MARKDOWN',
}

export enum ConversationsV1GeneratedKind {
  GeneratedKindToolApproved = 'GENERATED_KIND_TOOL_APPROVED',
  GeneratedKindToolRejected = 'GENERATED_KIND_TOOL_REJECTED',
}

export type ConversationsV1ListConversationsResponse = {
  conversations: Array<ConversationsV1Conversation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ListConversationsResponseResult =
  | ConversationsV1ListConversationsResponse
  | Error;

export enum ConversationsV1MessageRole {
  MessageRoleAssistant = 'MESSAGE_ROLE_ASSISTANT',
  MessageRoleUser = 'MESSAGE_ROLE_USER',
}

export type ConversationsV1PendingApproval = {
  requestId: Scalars['String']['output'];
  tool: Scalars['String']['output'];
};

export type ConversationsV1PendingApprovalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  tool: Scalars['String']['input'];
};

export type ConversationsV2AssistantMessage = {
  content: Scalars['String']['output'];
  phase?: Maybe<ConversationsV2AssistantMessagePhase>;
};

export type ConversationsV2AssistantMessageInput = {
  content: Scalars['String']['input'];
  phase?: InputMaybe<ConversationsV2AssistantMessagePhase>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationsV2AssistantMessagePhase {
  Commentary = 'COMMENTARY',
  FinalAnswer = 'FINAL_ANSWER',
}

export type ConversationsV2Chat = {
  /** @deprecated No longer supported */
  alwaysApprovedTools: Array<ConversationsV2ChatAlwaysApprovedTool>;
  assistantOutcome?: Maybe<ConversationsV2ChatAssistantOutcome>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  chatEvents?: Maybe<ConversationsV2ListChatEventsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  executionPolicy?: Maybe<ConversationsV2ExecutionPolicy>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  intelligenceLevel?: Maybe<ConversationsV2ChatIntelligenceLevel>;
  labels: Array<ConversationsV2ChatLabelsEntry>;
  lastEvent?: Maybe<ConversationsV2ChatEventResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  parentChatEvent?: Maybe<ConversationsV2ChatEventResult>;
  pendingEvents: Array<ConversationsV2ChatEventResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<ConversationsV2ChatSource>;
  state?: Maybe<ConversationsV2ChatState>;
  summary?: Maybe<ConversationsV2ChatSummary>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ConversationsV2ChatAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatChatEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2ChatCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2ChatObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatAlwaysApprovedTool = {
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ChatAlwaysApprovedToolInput = {
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ChatAssistantOutcome = {
  askQuestion?: Maybe<ConversationsV2ChatAssistantOutcomeAskQuestion>;
  error?: Maybe<ConversationsV2ChatAssistantOutcomeError>;
  interrupted?: Maybe<ConversationsV2ChatAssistantOutcomeInterrupted>;
  outcome?: Maybe<ConversationsV2ChatAssistantOutcomeCompleted>;
  toolConfirmation?: Maybe<ConversationsV2ChatAssistantOutcomeToolConfirmation>;
};

export type ConversationsV2ChatAssistantOutcomeAskQuestion = {
  alternatives: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeAskQuestionInput = {
  alternatives?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type ConversationsV2ChatAssistantOutcomeCompleted = {
  response?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatAssistantOutcomeCompletedInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeError = {
  details: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeErrorInput = {
  details: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeInput = {
  askQuestion?: InputMaybe<ConversationsV2ChatAssistantOutcomeAskQuestionInput>;
  error?: InputMaybe<ConversationsV2ChatAssistantOutcomeErrorInput>;
  interrupted?: InputMaybe<ConversationsV2ChatAssistantOutcomeInterruptedInput>;
  outcome?: InputMaybe<ConversationsV2ChatAssistantOutcomeCompletedInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolConfirmation?: InputMaybe<ConversationsV2ChatAssistantOutcomeToolConfirmationInput>;
};

export type ConversationsV2ChatAssistantOutcomeInterrupted = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatAssistantOutcomeInterruptedInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeToolConfirmation = {
  input?: Maybe<Scalars['JSON']['output']>;
  requestEvent?: Maybe<ConversationsV2ChatEventResult>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeToolConfirmationInput = {
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ChatEvent = {
  assistantMessage?: Maybe<ConversationsV2AssistantMessage>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clear?: Maybe<ConversationsV2Clear>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  compactionResult?: Maybe<ConversationsV2CompactionResult>;
  compactionStart?: Maybe<ConversationsV2CompactionStart>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  error?: Maybe<ConversationsV2Error>;
  eventIndex?: Maybe<Scalars['Int']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ConversationsV2ChatEventLabelsEntry>;
  name: Scalars['String']['output'];
  notification?: Maybe<ConversationsV2Notification>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  thinking?: Maybe<ConversationsV2Thinking>;
  toolCall?: Maybe<ConversationsV2ToolCall>;
  toolConfirmationRequest?: Maybe<ConversationsV2ToolConfirmationRequest>;
  toolConfirmationResponse?: Maybe<ConversationsV2ToolConfirmationResponse>;
  toolResult?: Maybe<ConversationsV2ToolResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  userInterrupt?: Maybe<ConversationsV2UserInterrupt>;
  userMessage?: Maybe<ConversationsV2UserMessage>;
};

export type ConversationsV2ChatEventAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2ChatEventCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2ChatEventObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventInput = {
  assistantMessage?: InputMaybe<ConversationsV2AssistantMessageInput>;
  clear?: InputMaybe<ConversationsV2ClearInput>;
  compactionResult?: InputMaybe<ConversationsV2CompactionResultInput>;
  compactionStart?: InputMaybe<ConversationsV2CompactionStartInput>;
  error?: InputMaybe<ConversationsV2ErrorInput>;
  labels?: InputMaybe<Array<ConversationsV2ChatEventLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<ConversationsV2NotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thinking?: InputMaybe<ConversationsV2ThinkingInput>;
  toolCall?: InputMaybe<ConversationsV2ToolCallInput>;
  toolConfirmationRequest?: InputMaybe<ConversationsV2ToolConfirmationRequestInput>;
  toolConfirmationResponse?: InputMaybe<ConversationsV2ToolConfirmationResponseInput>;
  toolResult?: InputMaybe<ConversationsV2ToolResultInput>;
  userInterrupt?: InputMaybe<ConversationsV2UserInterruptInput>;
  userMessage?: InputMaybe<ConversationsV2UserMessageInput>;
};

export type ConversationsV2ChatEventLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatEventLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventResult = ConversationsV2ChatEvent | Error;

export type ConversationsV2ChatInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  executionPolicy?: InputMaybe<ConversationsV2ExecutionPolicyInput>;
  intelligenceLevel?: InputMaybe<ConversationsV2ChatIntelligenceLevel>;
  labels?: InputMaybe<Array<ConversationsV2ChatLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV2ChatSource>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConversationsV2ChatIntelligenceLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type ConversationsV2ChatLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatResult = ConversationsV2Chat | Error;

export enum ConversationsV2ChatSource {
  Mcp = 'MCP',
  PromptHook = 'PROMPT_HOOK',
  Slack = 'SLACK',
  Web = 'WEB',
}

export enum ConversationsV2ChatState {
  Idle = 'IDLE',
  Running = 'RUNNING',
}

export type ConversationsV2ChatSummary = {
  body?: Maybe<Scalars['String']['output']>;
  lastSummarizedEvent?: Maybe<ConversationsV2ChatEventResult>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatSummaryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChildChatStopped = {
  childChat: ConversationsV2ChatResult;
  success: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChildChatStoppedInput = {
  childChat: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Clear = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ClearInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2CompactionResult = {
  summary: Scalars['String']['output'];
};

export type ConversationsV2CompactionResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

export type ConversationsV2CompactionStart = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2CompactionStartInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ConfirmToolResponse = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2ConfirmToolResponseResult =
  | ConversationsV2ConfirmToolResponse
  | Error;

export type ConversationsV2DomainEventNotification = {
  chatSubscription: Scalars['String']['output'];
  cloudEventId?: Maybe<Scalars['String']['output']>;
  cloudEventSource?: Maybe<Scalars['String']['output']>;
  eventData?: Maybe<Scalars['JSON']['output']>;
  eventType: Scalars['String']['output'];
};

export type ConversationsV2DomainEventNotificationInput = {
  chatSubscription: Scalars['String']['input'];
  cloudEventId?: InputMaybe<Scalars['String']['input']>;
  cloudEventSource?: InputMaybe<Scalars['String']['input']>;
  eventData?: InputMaybe<Scalars['JSON']['input']>;
  eventType: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Error = {
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ConversationsV2ErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2EventTrigger = {
  eventType: Scalars['String']['output'];
  filter?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2EventTriggerInput = {
  eventType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2EventsChatCreated = {
  chat?: Maybe<ConversationsV2Chat>;
};

export type ConversationsV2EventsChatEventCreated = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2EventsChatEventUpdated = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2EventsChatUpdated = {
  chat?: Maybe<ConversationsV2Chat>;
};

export type ConversationsV2ExecutionPolicy = {
  alwaysApprovedTools: Array<ConversationsV2ChatAlwaysApprovedTool>;
  permissionMode?: Maybe<ConversationsV2ExecutionPolicyPermissionMode>;
  principal?: Maybe<IamV1IdentityResult>;
};

export type ConversationsV2ExecutionPolicyInput = {
  permissionMode?: InputMaybe<ConversationsV2ExecutionPolicyPermissionMode>;
  principal?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationsV2ExecutionPolicyPermissionMode {
  PermissionModeDontAsk = 'PERMISSION_MODE_DONT_ASK',
}

export type ConversationsV2ListChatEventsResponse = {
  chatEvents: Array<ConversationsV2ChatEvent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ListChatEventsResponseResult =
  | ConversationsV2ListChatEventsResponse
  | Error;

export type ConversationsV2ListChatsResponse = {
  chats: Array<ConversationsV2Chat>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ListChatsResponseResult =
  | ConversationsV2ListChatsResponse
  | Error;

export type ConversationsV2ListPromptHooksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  promptHooks: Array<ConversationsV2PromptHook>;
};

export type ConversationsV2ListPromptHooksResponseResult =
  | ConversationsV2ListPromptHooksResponse
  | Error;

export type ConversationsV2MessagePart = {
  imageUri?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2MessagePartInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Notification = {
  childChatStopped?: Maybe<ConversationsV2ChildChatStopped>;
  domainEvent?: Maybe<ConversationsV2DomainEventNotification>;
};

export type ConversationsV2NotificationInput = {
  childChatStopped?: InputMaybe<ConversationsV2ChildChatStoppedInput>;
  domainEvent?: InputMaybe<ConversationsV2DomainEventNotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHook = {
  agent?: Maybe<Scalars['String']['output']>;
  approvedTools: Array<ConversationsV2PromptHookApprovedTool>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  intelligenceLevel?: Maybe<ConversationsV2ChatIntelligenceLevel>;
  labels: Array<ConversationsV2PromptHookLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  promptTemplate: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  skipScratchpad?: Maybe<Scalars['Boolean']['output']>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  trigger: ConversationsV2PromptHookTrigger;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ConversationsV2PromptHookAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2PromptHookCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2PromptHookObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookApprovedTool = {
  tool: Scalars['String']['output'];
};

export type ConversationsV2PromptHookApprovedToolInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2PromptHookInput = {
  agent?: InputMaybe<Scalars['String']['input']>;
  approvedTools?: InputMaybe<Array<ConversationsV2PromptHookApprovedToolInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  intelligenceLevel?: InputMaybe<ConversationsV2ChatIntelligenceLevel>;
  labels?: InputMaybe<Array<ConversationsV2PromptHookLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  promptTemplate: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipScratchpad?: InputMaybe<Scalars['Boolean']['input']>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  trigger: ConversationsV2PromptHookTriggerInput;
};

export type ConversationsV2PromptHookLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2PromptHookLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookResult = ConversationsV2PromptHook | Error;

export type ConversationsV2PromptHookTrigger = {
  eventTrigger?: Maybe<ConversationsV2EventTrigger>;
  scheduleTrigger?: Maybe<ConversationsV2ScheduleTrigger>;
};

export type ConversationsV2PromptHookTriggerInput = {
  eventTrigger?: InputMaybe<ConversationsV2EventTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleTrigger?: InputMaybe<ConversationsV2ScheduleTriggerInput>;
};

export type ConversationsV2ScheduleTrigger = {
  cron: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ScheduleTriggerInput = {
  cron: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Thinking = {
  content: Scalars['String']['output'];
};

export type ConversationsV2ThinkingInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ToolCall = {
  displayName?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ToolCallInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ToolConfirmationRequest = {
  displayName?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ToolConfirmationRequestInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ToolConfirmationResponse = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  toolRequestEvent: ConversationsV2ChatEventResult;
};

export enum ConversationsV2ToolConfirmationResponseDecision {
  Allow = 'ALLOW',
  AllowAll = 'ALLOW_ALL',
  Deny = 'DENY',
}

export type ConversationsV2ToolConfirmationResponseInput = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolRequestEvent: Scalars['String']['input'];
};

export type ConversationsV2ToolResult = {
  content: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  toolCallEvent?: Maybe<ConversationsV2ChatEventResult>;
};

export type ConversationsV2ToolResultInput = {
  content: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  toolCallEvent?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2UserInterrupt = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2UserInterruptInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2UserMessage = {
  /** @deprecated No longer supported */
  content?: Maybe<Scalars['String']['output']>;
  parts: Array<ConversationsV2MessagePart>;
};

export type ConversationsV2UserMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<ConversationsV2MessagePartInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionRecordData = {
  conclusion?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<DecisionRecordDataOutcome>;
  treatment?: Maybe<Scalars['String']['output']>;
};

export type DecisionRecordDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<DecisionRecordDataInputOutcome>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export enum DecisionRecordDataInputOutcome {
  Abandoned = 'abandoned',
  Aborted = 'aborted',
  Restarted = 'restarted',
  Shipped = 'shipped',
}

export enum DecisionRecordDataOutcome {
  Abandoned = 'abandoned',
  Aborted = 'aborted',
  Restarted = 'restarted',
  Shipped = 'shipped',
}

export type DimensionsOneOfInput = {
  metricCalculationDimensionTableDimension?: InputMaybe<ExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput>;
  metricCalculationFactTableDimension?: InputMaybe<ExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EpTest = {
  myConfigField: Scalars['String']['output'];
};

export type EpTestInput = {
  myConfigField: Scalars['String']['input'];
};

export type Error = {
  code: ErrorCode;
  domain?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum ErrorCode {
  Aborted = 'ABORTED',
  AlreadyExists = 'ALREADY_EXISTS',
  Cancelled = 'CANCELLED',
  DataLoss = 'DATA_LOSS',
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  FailedPrecondition = 'FAILED_PRECONDITION',
  Internal = 'INTERNAL',
  InvalidArgument = 'INVALID_ARGUMENT',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  OutOfRange = 'OUT_OF_RANGE',
  PermissionDenied = 'PERMISSION_DENIED',
  ResourceExhausted = 'RESOURCE_EXHAUSTED',
  Unauthenticated = 'UNAUTHENTICATED',
  Unavailable = 'UNAVAILABLE',
  Unimplemented = 'UNIMPLEMENTED',
  Unknown = 'UNKNOWN',
}

export type EventsAdminV1DraftEvent = {
  client: IamV1ClientResult;
  draftEventDefinition?: Maybe<Scalars['String']['output']>;
  eventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  eventTime: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  reason: EventsAdminV1DraftEventValidationErrorReason;
  schema: EventsAdminV1EventSchema;
};

export enum EventsAdminV1DraftEventValidationErrorReason {
  EventDefinitionMissing = 'EVENT_DEFINITION_MISSING',
  EventDefinitionUnknownFields = 'EVENT_DEFINITION_UNKNOWN_FIELDS',
}

export type EventsAdminV1EventDefinition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<EventsAdminV1EventDefinitionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schema: Array<EventsAdminV1EventDefinitionSchemaEntry>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata: EventsAdminV1EventDefinitionUsageMetadata;
};

export type EventsAdminV1EventDefinitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type EventsAdminV1EventDefinitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type EventsAdminV1EventDefinitionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionInput = {
  labels?: InputMaybe<Array<EventsAdminV1EventDefinitionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Array<EventsAdminV1EventDefinitionSchemaEntryInput>>;
};

export type EventsAdminV1EventDefinitionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1EventDefinitionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionResult =
  | Error
  | EventsAdminV1EventDefinition;

export type EventsAdminV1EventDefinitionSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventDefinitionSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<EventsAdminV1EventSchemaInput>;
};

export type EventsAdminV1EventDefinitionUsageMetadata = {
  lastPublishTime?: Maybe<Scalars['String']['output']>;
  lastValidationFailedTime?: Maybe<Scalars['String']['output']>;
  publishCount: Scalars['Long']['output'];
  validationFailedCount: Scalars['Long']['output'];
};

export type EventsAdminV1EventDefinitionUsageMetadataInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventSchema = {
  boolSchema?: Maybe<EventsAdminV1EventSchemaBoolSchema>;
  dateSchema?: Maybe<EventsAdminV1EventSchemaDateSchema>;
  doubleSchema?: Maybe<EventsAdminV1EventSchemaDoubleSchema>;
  intSchema?: Maybe<EventsAdminV1EventSchemaIntSchema>;
  listSchema?: Maybe<EventsAdminV1EventSchemaListSchema>;
  stringSchema?: Maybe<EventsAdminV1EventSchemaStringSchema>;
  structSchema?: Maybe<EventsAdminV1EventSchemaStructSchema>;
  timestampSchema?: Maybe<EventsAdminV1EventSchemaTimestampSchema>;
};

export type EventsAdminV1EventSchemaBoolSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaBoolSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaDateSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaDateSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaDoubleSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaDoubleSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaInput = {
  boolSchema?: InputMaybe<EventsAdminV1EventSchemaBoolSchemaInput>;
  dateSchema?: InputMaybe<EventsAdminV1EventSchemaDateSchemaInput>;
  doubleSchema?: InputMaybe<EventsAdminV1EventSchemaDoubleSchemaInput>;
  intSchema?: InputMaybe<EventsAdminV1EventSchemaIntSchemaInput>;
  listSchema?: InputMaybe<EventsAdminV1EventSchemaListSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<EventsAdminV1EventSchemaStringSchemaInput>;
  structSchema?: InputMaybe<EventsAdminV1EventSchemaStructSchemaInput>;
  timestampSchema?: InputMaybe<EventsAdminV1EventSchemaTimestampSchemaInput>;
};

export type EventsAdminV1EventSchemaIntSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaIntSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaListSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  elementSchema?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventSchemaListSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  elementSchema?: InputMaybe<EventsAdminV1EventSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventSchemaStringSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaStringSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaStructSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  schema: Array<EventsAdminV1EventSchemaStructSchemaSchemaEntry>;
};

export type EventsAdminV1EventSchemaStructSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<EventsAdminV1EventSchemaStructSchemaSchemaEntryInput>
  >;
};

export type EventsAdminV1EventSchemaStructSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventSchemaStructSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<EventsAdminV1EventSchemaInput>;
};

export type EventsAdminV1EventSchemaTimestampSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaTimestampSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventUsageEntry = {
  hourTime: Scalars['String']['output'];
  publishCount: Scalars['Long']['output'];
  validationFailedCount: Scalars['Long']['output'];
};

export type EventsAdminV1EventsEventDefinitionCreated = {
  eventDefinition?: Maybe<EventsAdminV1EventDefinition>;
};

export type EventsAdminV1EventsEventDefinitionDeleted = {
  eventDefinition?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1EventsEventDefinitionUpdated = {
  eventDefinition?: Maybe<EventsAdminV1EventDefinition>;
  oldEventDefinition?: Maybe<EventsAdminV1EventDefinition>;
};

export type EventsAdminV1FieldSemanticType = {
  country?: Maybe<EventsAdminV1FieldSemanticTypeCountrySemanticType>;
  entityReference?: Maybe<EventsAdminV1FieldSemanticTypeEntitySemanticType>;
  enumType?: Maybe<EventsAdminV1FieldSemanticTypeEnumSemanticType>;
};

export type EventsAdminV1FieldSemanticTypeCountrySemanticType = {
  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
};

export enum EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat {
  TwoLetterIsoCode = 'TWO_LETTER_ISO_CODE',
}

export type EventsAdminV1FieldSemanticTypeCountrySemanticTypeInput = {
  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEntitySemanticType = {
  entity: MetricsV1EntityResult;
};

export type EventsAdminV1FieldSemanticTypeEntitySemanticTypeInput = {
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticType = {
  values: Array<EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValue>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValue = {
  value?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput>;
};

export type EventsAdminV1FieldSemanticTypeInput = {
  country?: InputMaybe<EventsAdminV1FieldSemanticTypeCountrySemanticTypeInput>;
  entityReference?: InputMaybe<EventsAdminV1FieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<EventsAdminV1FieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1ListEventDefinitionsResponse = {
  eventDefinitions: Array<EventsAdminV1EventDefinition>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1ListEventDefinitionsResponseResult =
  | Error
  | EventsAdminV1ListEventDefinitionsResponse;

export type EventsAdminV1QueryDraftEventsResponse = {
  draftEvents: Array<EventsAdminV1DraftEvent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1QueryDraftEventsResponseResult =
  | Error
  | EventsAdminV1QueryDraftEventsResponse;

export type EventsAdminV1QueryEventsUsageResponse = {
  usage: Array<EventsAdminV1EventUsageEntry>;
};

export type EventsAdminV1QueryEventsUsageResponseResult =
  | Error
  | EventsAdminV1QueryEventsUsageResponse;

export type ExploreData = {
  exploratoryAnalyses: Array<ExploreDataAnalysis>;
};

export type ExploreDataAnalysis = {
  analysisResults?: Maybe<Array<ExploreDataAnalysisAnalysisResult>>;
  conclusion?: Maybe<ExploreDataAnalysisConclusionUnion>;
  createTime: Scalars['String']['output'];
  createdBy?: Maybe<IamV1UserResult>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  labels?: Maybe<Array<ExploreDataAnalysisLabel>>;
  messages: Array<Scalars['String']['output']>;
  metrics: Array<ExploreDataAnalysisMetric>;
  name: Scalars['String']['output'];
  splitByExposureFilters?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state: ExploreDataAnalysisState;
  updateTime: Scalars['String']['output'];
  useCustomDateRange?: Maybe<Scalars['Boolean']['output']>;
  useScheduledCalculation?: Maybe<Scalars['Boolean']['output']>;
};

export type ExploreDataAnalysisAnalysisResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilterName?: Maybe<Scalars['String']['output']>;
};

export type ExploreDataAnalysisConclusion = {
  text: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
};

export type ExploreDataAnalysisConclusionUnion = ExploreDataAnalysisConclusion;

export type ExploreDataAnalysisLabel = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExploreDataAnalysisMetric = {
  calculation?: Maybe<MetricsV1MetricCalculationResult>;
  calculationError?: Maybe<Scalars['String']['output']>;
  dimensions: Array<ExploreDataAnalysisMetricDimensionsUnion>;
  metricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  name: MetricsV1MetricResult;
  scheduledCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
};

export type ExploreDataAnalysisMetricDimensionsUnion =
  | ExploreDataAnalysisMetricMetricCalculationDimensionTableDimension
  | ExploreDataAnalysisMetricMetricCalculationFactTableDimension;

export type ExploreDataAnalysisMetricMetricCalculationDimensionTableDimension =
  {
    column: Scalars['String']['output'];
    dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  };

export type ExploreDataAnalysisMetricMetricCalculationFactTableDimension = {
  column: Scalars['String']['output'];
  factTable: MetricsV1FactTableResult;
};

export enum ExploreDataAnalysisState {
  Calculating = 'CALCULATING',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type ExploreDataInput = {
  exploratoryAnalyses: Array<ExploreDataInputAnalysisInput>;
};

export type ExploreDataInputAnalysisInput = {
  analysisResults?: InputMaybe<
    Array<ExploreDataInputAnalysisInputAnalysisResultInput>
  >;
  conclusion?: InputMaybe<ConclusionOneOfInput>;
  createTime: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  labels?: InputMaybe<Array<ExploreDataInputAnalysisInputLabelInput>>;
  messages: Array<Scalars['String']['input']>;
  metrics: Array<ExploreDataInputAnalysisInputMetricInput>;
  name: Scalars['String']['input'];
  splitByExposureFilters?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state: ExploreDataInputAnalysisInputState;
  updateTime: Scalars['String']['input'];
  useCustomDateRange?: InputMaybe<Scalars['Boolean']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExploreDataInputAnalysisInputAnalysisResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type ExploreDataInputAnalysisInputConclusionInput = {
  text: Scalars['String']['input'];
  updateTime: Scalars['String']['input'];
};

export type ExploreDataInputAnalysisInputLabelInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ExploreDataInputAnalysisInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  calculationError?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<DimensionsOneOfInput>;
  metricCalculation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scheduledCalculation?: InputMaybe<Scalars['String']['input']>;
};

export type ExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput =
  {
    column: Scalars['String']['input'];
    dimensionTable?: InputMaybe<Scalars['String']['input']>;
  };

export type ExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput =
  {
    column: Scalars['String']['input'];
    factTable: Scalars['String']['input'];
  };

export enum ExploreDataInputAnalysisInputState {
  Calculating = 'CALCULATING',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type ExposureData = {
  exposure: Array<ExposureDataExposureEntry>;
};

export type ExposureDataExposureEntry = {
  exposureFilter?: Maybe<Scalars['String']['output']>;
  totalExposureCount: Scalars['Long']['output'];
  treatment: Scalars['String']['output'];
};

export type ExposureDataInput = {
  exposure: Array<ExposureDataInputExposureEntryInput>;
};

export type ExposureDataInputExposureEntryInput = {
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  totalExposureCount: Scalars['Long']['input'];
  treatment: Scalars['String']['input'];
};

export type ExposureOneOfInput = {
  exposureCalculation?: InputMaybe<SampleSizeDataInputExposureCalculationInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledExposureCalculation?: InputMaybe<SampleSizeDataInputScheduledExposureCalculationInput>;
};

export type ExposureSourceOneOfInput = {
  assignmentTable?: InputMaybe<SampleSizeDataInputAssignmentTableInput>;
  existingInstance?: InputMaybe<SampleSizeDataInputExistingInstanceInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLog = {
  accountStateVersionTime: Scalars['String']['output'];
  allAllowed: Scalars['Boolean']['output'];
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contextualTuples: Array<FgaV1TupleKey>;
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  results: Array<FgaV1CheckResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  ttlTime: Scalars['String']['output'];
};

export type FgaV1AuthCheckLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FgaV1AuthCheckLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FgaV1AuthCheckLogObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1CheckResult = {
  allowed?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<FgaV1ResourceRelation>;
};

export type FgaV1EventsAuthCheckLogCreated = {
  authCheckLog?: Maybe<FgaV1AuthCheckLog>;
};

export type FgaV1ExecuteCheckResponse = {
  allAllowed?: Maybe<Scalars['Boolean']['output']>;
  results: Array<FgaV1CheckResult>;
};

export type FgaV1ExecuteCheckResponseResult = Error | FgaV1ExecuteCheckResponse;

export type FgaV1ListResourcePermissionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  resourcePermissions: Array<FgaV1ResourcePermission>;
};

export type FgaV1ListResourcePermissionsResponseResult =
  | Error
  | FgaV1ListResourcePermissionsResponse;

export type FgaV1ListResourceRelationsResponse = {
  resourceRelations: Array<FgaV1ResourceRelation>;
};

export type FgaV1ListResourceRelationsResponseResult =
  | Error
  | FgaV1ListResourceRelationsResponse;

export enum FgaV1Permission {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

export type FgaV1ResourcePermission = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<FgaV1ResourcePermissionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermission: FgaV1Permission;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FgaV1ResourcePermissionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FgaV1ResourcePermissionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FgaV1ResourcePermissionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionInput = {
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<FgaV1ResourcePermissionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  resourcePermission: FgaV1Permission;
};

export type FgaV1ResourcePermissionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FgaV1ResourcePermissionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionResult = Error | FgaV1ResourcePermission;

export type FgaV1ResourceRelation = {
  relation: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type FgaV1ResourceRelationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  relation: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type FgaV1TupleKey = {
  object: Scalars['String']['output'];
  relation: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type FgaV1WriteResourcePermissionsResponse = {
  addedPermissions: Array<FgaV1ResourcePermission>;
  removedPermissions: Array<FgaV1ResourcePermission>;
};

export type FgaV1WriteResourcePermissionsResponseResult =
  | Error
  | FgaV1WriteResourcePermissionsResponse;

export type FlagsAdminV1ClientEvaluationContextSchema = {
  client: IamV1ClientResult;
  schema?: Maybe<FlagsAdminV1EvaluationContextSchema>;
};

export type FlagsAdminV1ComputeSegmentSpaceCalendarResponse = {
  dailyAvailability: Array<FlagsAdminV1DailySpaceAvailability>;
};

export type FlagsAdminV1ComputeSegmentSpaceCalendarResponseResult =
  | Error
  | FlagsAdminV1ComputeSegmentSpaceCalendarResponse;

export type FlagsAdminV1ContextFieldSeenValuesInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type FlagsAdminV1ContextFieldSemanticType = {
  country?: Maybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticType>;
  date?: Maybe<FlagsAdminV1ContextFieldSemanticTypeDateSemanticType>;
  entityReference?: Maybe<FlagsAdminV1ContextFieldSemanticTypeEntitySemanticType>;
  enumType?: Maybe<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticType>;
  timestamp?: Maybe<FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticType>;
  version?: Maybe<FlagsAdminV1ContextFieldSemanticTypeVersionSemanticType>;
};

export type FlagsAdminV1ContextFieldSemanticTypeCountrySemanticType = {
  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
};

export enum FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat {
  TwoLetterIsoCode = 'TWO_LETTER_ISO_CODE',
}

export type FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput = {
  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeDateSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEntitySemanticType = {
  entity: MetricsV1EntityResult;
};

export type FlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput = {
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticType = {
  values: Array<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValue>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValue = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput>;
};

export type FlagsAdminV1ContextFieldSemanticTypeInput = {
  country?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput>;
  date?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput>;
  entityReference?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput>;
  version?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput>;
};

export type FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeVersionSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DailySpaceAvailability = {
  availableSpace?: Maybe<GoogleTypeDecimal>;
  date: GoogleTypeDate;
  reclaimableSpace: Array<FlagsAdminV1DailySpaceAvailabilityReclaimableSpaceEntry>;
};

export type FlagsAdminV1DailySpaceAvailabilityReclaimableSpaceEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1DeriveClientEvaluationContextSchemaResponse = {
  capped?: Maybe<Scalars['Boolean']['output']>;
  clientSchema: Array<FlagsAdminV1ClientEvaluationContextSchema>;
  mergedSchema?: Maybe<FlagsAdminV1EvaluationContextSchema>;
};

export type FlagsAdminV1DeriveClientEvaluationContextSchemaResponseResult =
  | Error
  | FlagsAdminV1DeriveClientEvaluationContextSchemaResponse;

export type FlagsAdminV1DistinctCount = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  count: Scalars['Long']['output'];
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1DistinctCountLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type FlagsAdminV1DistinctCountAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1DistinctCountCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1DistinctCountCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1DistinctCountExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1DistinctCountObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1DistinctCountQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FlagsAdminV1DistinctCountKind {
  Applies = 'APPLIES',
  Assigns = 'ASSIGNS',
}

export type FlagsAdminV1DistinctCountLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1DistinctCountResult = Error | FlagsAdminV1DistinctCount;

export type FlagsAdminV1Environment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  color?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1EnvironmentLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1EnvironmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1EnvironmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1EnvironmentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1EnvironmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EnvironmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentResult = Error | FlagsAdminV1Environment;

export type FlagsAdminV1EvaluationContextFieldOverride = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  field: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
  labels: Array<FlagsAdminV1EvaluationContextFieldOverrideLabelsEntry>;
  log?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nonPii?: Maybe<Scalars['Boolean']['output']>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  semanticType?: Maybe<FlagsAdminV1ContextFieldSemanticType>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1EvaluationContextFieldOverrideAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideInput = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
  labels?: InputMaybe<
    Array<FlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput>
  >;
  log?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonPii?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideResult =
  | Error
  | FlagsAdminV1EvaluationContextFieldOverride;

export type FlagsAdminV1EvaluationContextSchema = {
  schema: Array<FlagsAdminV1EvaluationContextSchemaSchemaEntry>;
};

export type FlagsAdminV1EvaluationContextSchemaField = {
  displayName?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  seenValues: Array<Scalars['JSON']['output']>;
  semanticType?: Maybe<FlagsAdminV1ContextFieldSemanticType>;
  types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
};

export type FlagsAdminV1EvaluationContextSchemaFieldInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  seenValues?: InputMaybe<Array<Scalars['JSON']['input']>>;
  semanticType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
  types?: InputMaybe<Array<FlagsAdminV1EvaluationContextSchemaFieldKind>>;
};

export enum FlagsAdminV1EvaluationContextSchemaFieldKind {
  BoolKind = 'BOOL_KIND',
  NullKind = 'NULL_KIND',
  NumberKind = 'NUMBER_KIND',
  StringKind = 'STRING_KIND',
}

export type FlagsAdminV1EvaluationContextSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsAdminV1EvaluationContextSchemaSchemaEntryInput>
  >;
};

export type FlagsAdminV1EvaluationContextSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsAdminV1EvaluationContextSchemaField>;
};

export type FlagsAdminV1EvaluationContextSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldInput>;
};

export type FlagsAdminV1EventsEnvironmentCreated = {
  environment?: Maybe<FlagsAdminV1Environment>;
};

export type FlagsAdminV1EventsEnvironmentDeleted = {
  environment?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsEnvironmentUpdated = {
  environment?: Maybe<FlagsAdminV1Environment>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideCreated = {
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverride>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideDeleted = {
  evaluationContextFieldOverride?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideUpdated = {
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverride>;
};

export type FlagsAdminV1EventsFlagArchived = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagCreated = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagUnarchived = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagUpdated = {
  flag?: Maybe<FlagsAdminV1Flag>;
  oldFlag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsMaterializedSegmentCreated = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegment>;
};

export type FlagsAdminV1EventsMaterializedSegmentDeleted = {
  materializedSegment?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsMaterializedSegmentUpdated = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegment>;
};

export type FlagsAdminV1EventsSegmentAllocated = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentArchived = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentCreated = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentUpdated = {
  oldSegment?: Maybe<FlagsAdminV1Segment>;
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1Flag = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<IamV1ClientResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1FlagLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  rules: Array<FlagsAdminV1FlagRule>;
  schema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
  state: FlagsAdminV1FlagState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<FlagsAdminV1FlagUsageMetadata>;
  variants: Array<FlagsAdminV1FlagVariant>;
};

export type FlagsAdminV1FlagAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagInput = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<FlagsAdminV1FlagRuleInput>>;
  schema?: InputMaybe<FlagsTypesV1FlagSchemaStructFlagSchemaInput>;
  usageMetadata?: InputMaybe<FlagsAdminV1FlagUsageMetadataInput>;
  variants?: InputMaybe<Array<FlagsAdminV1FlagVariantInput>>;
};

export type FlagsAdminV1FlagLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagResult = Error | FlagsAdminV1Flag;

export type FlagsAdminV1FlagRule = {
  assignmentSpec: FlagsAdminV1FlagRuleAssignmentSpec;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  environments: Array<FlagsAdminV1EnvironmentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1FlagRuleLabelsEntry>;
  materializationSpec?: Maybe<FlagsAdminV1FlagRuleMaterializationSpec>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment: FlagsAdminV1SegmentResult;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata: FlagsAdminV1FlagRuleUsageMetadata;
};

export type FlagsAdminV1FlagRuleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagRuleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagRuleObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleAssignment = {
  assignmentId?: Maybe<Scalars['String']['output']>;
  bucketRanges: Array<FlagsAdminV1FlagRuleBucketRange>;
  clientDefault?: Maybe<FlagsAdminV1FlagRuleAssignmentClientDefaultAssignment>;
  fallthrough?: Maybe<FlagsAdminV1FlagRuleAssignmentFallthroughAssignment>;
  variant?: Maybe<FlagsAdminV1FlagRuleAssignmentVariantAssignment>;
};

export type FlagsAdminV1FlagRuleAssignmentClientDefaultAssignment = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentFallthroughAssignment = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  bucketRanges?: InputMaybe<Array<FlagsAdminV1FlagRuleBucketRangeInput>>;
  clientDefault?: InputMaybe<FlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput>;
  fallthrough?: InputMaybe<FlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<FlagsAdminV1FlagRuleAssignmentVariantAssignmentInput>;
};

export type FlagsAdminV1FlagRuleAssignmentSpec = {
  assignments: Array<FlagsAdminV1FlagRuleAssignment>;
  bucketCount?: Maybe<Scalars['Int']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentSpecInput = {
  assignments?: InputMaybe<Array<FlagsAdminV1FlagRuleAssignmentInput>>;
  bucketCount?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentUsageMetadata = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  assignmentId?: Maybe<Scalars['String']['output']>;
  emptyTargetingKeyCount?: Maybe<Scalars['Long']['output']>;
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentUsageMetadataInput = {
  applyCount?: InputMaybe<Scalars['Long']['input']>;
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  emptyTargetingKeyCount?: InputMaybe<Scalars['Long']['input']>;
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentVariantAssignment = {
  variant: FlagsAdminV1FlagVariantResult;
};

export type FlagsAdminV1FlagRuleAssignmentVariantAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant: Scalars['String']['input'];
};

export type FlagsAdminV1FlagRuleBucketRange = {
  lower: Scalars['Int']['output'];
  upper: Scalars['Int']['output'];
};

export type FlagsAdminV1FlagRuleBucketRangeInput = {
  lower: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper: Scalars['Int']['input'];
};

export type FlagsAdminV1FlagRuleInput = {
  assignmentSpec: FlagsAdminV1FlagRuleAssignmentSpecInput;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagRuleLabelsEntryInput>>;
  materializationSpec?: InputMaybe<FlagsAdminV1FlagRuleMaterializationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment: Scalars['String']['input'];
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpec = {
  mode?: Maybe<FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadMode>;
  readMaterialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  writeMaterialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecInput = {
  mode?: InputMaybe<FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  readMaterialization?: InputMaybe<Scalars['String']['input']>;
  writeMaterialization?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadMode = {
  materializationMustMatch?: Maybe<Scalars['Boolean']['output']>;
  segmentTargetingCanBeIgnored?: Maybe<Scalars['Boolean']['output']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput =
  {
    materializationMustMatch?: InputMaybe<Scalars['Boolean']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    segmentTargetingCanBeIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type FlagsAdminV1FlagRuleResult = Error | FlagsAdminV1FlagRule;

export type FlagsAdminV1FlagRuleUsageMetadata = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  assignmentUsageMetadata: Array<FlagsAdminV1FlagRuleAssignmentUsageMetadata>;
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  lastResolveTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagRuleUsageMetadataInput = {
  applyCount?: InputMaybe<Scalars['Long']['input']>;
  assignmentUsageMetadata?: InputMaybe<
    Array<FlagsAdminV1FlagRuleAssignmentUsageMetadataInput>
  >;
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export enum FlagsAdminV1FlagState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type FlagsAdminV1FlagUsageEntry = {
  hourTime: Scalars['String']['output'];
  variants: Array<FlagsAdminV1FlagUsageEntryVariantsEntry>;
};

export type FlagsAdminV1FlagUsageEntryVariantUsage = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagUsageEntryVariantsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsAdminV1FlagUsageEntryVariantUsage>;
};

export type FlagsAdminV1FlagUsageMetadata = {
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  lastResolveTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagUsageMetadataInput = {
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type FlagsAdminV1FlagVariant = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  imageUri?: Maybe<Scalars['String']['output']>;
  labels: Array<FlagsAdminV1FlagVariantLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  value: Scalars['JSON']['output'];
};

export type FlagsAdminV1FlagVariantAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagVariantCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagVariantObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagVariantLabelsEntryInput>>;
  name: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type FlagsAdminV1FlagVariantLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagVariantLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantResult = Error | FlagsAdminV1FlagVariant;

export type FlagsAdminV1ListEnvironmentsResponse = {
  environments: Array<FlagsAdminV1Environment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListEnvironmentsResponseResult =
  | Error
  | FlagsAdminV1ListEnvironmentsResponse;

export type FlagsAdminV1ListEvaluationContextFieldOverridesResponse = {
  evaluationContextFieldOverrides: Array<FlagsAdminV1EvaluationContextFieldOverride>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListEvaluationContextFieldOverridesResponseResult =
  | Error
  | FlagsAdminV1ListEvaluationContextFieldOverridesResponse;

export type FlagsAdminV1ListFlagsResponse = {
  flags: Array<FlagsAdminV1Flag>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListFlagsResponseResult =
  | Error
  | FlagsAdminV1ListFlagsResponse;

export type FlagsAdminV1ListMaterializedSegmentsResponse = {
  materializedSegments: Array<FlagsAdminV1MaterializedSegment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListMaterializedSegmentsResponseResult =
  | Error
  | FlagsAdminV1ListMaterializedSegmentsResponse;

export type FlagsAdminV1ListRulesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  rules: Array<FlagsAdminV1FlagRule>;
};

export type FlagsAdminV1ListRulesResponseResult =
  | Error
  | FlagsAdminV1ListRulesResponse;

export type FlagsAdminV1ListSegmentsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  segments: Array<FlagsAdminV1Segment>;
};

export type FlagsAdminV1ListSegmentsResponseResult =
  | Error
  | FlagsAdminV1ListSegmentsResponse;

export type FlagsAdminV1ListVariantsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  variants: Array<FlagsAdminV1FlagVariant>;
};

export type FlagsAdminV1ListVariantsResponseResult =
  | Error
  | FlagsAdminV1ListVariantsResponse;

export type FlagsAdminV1MaterializedSegment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1MaterializedSegmentLabelsEntry>;
  materializedSegmentLoadJobs?: Maybe<MaterializerV1ListMaterializedSegmentLoadJobsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduledMaterializedSegmentLoadJobs?: Maybe<MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1MaterializedSegmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1MaterializedSegmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1MaterializedSegmentMaterializedSegmentLoadJobsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentScheduledMaterializedSegmentLoadJobsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1MaterializedSegmentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<FlagsAdminV1MaterializedSegmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1MaterializedSegmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentResult =
  | Error
  | FlagsAdminV1MaterializedSegment;

export type FlagsAdminV1QueryAccountDistinctCountResponse = {
  distinctCount?: Maybe<FlagsAdminV1DistinctCount>;
};

export type FlagsAdminV1QueryAccountDistinctCountResponseResult =
  | Error
  | FlagsAdminV1QueryAccountDistinctCountResponse;

export type FlagsAdminV1QueryAssignmentDistinctCountResponse = {
  distinctCount?: Maybe<FlagsAdminV1DistinctCount>;
};

export type FlagsAdminV1QueryAssignmentDistinctCountResponseResult =
  | Error
  | FlagsAdminV1QueryAssignmentDistinctCountResponse;

export type FlagsAdminV1QueryFlagUsageResponse = {
  usage: Array<FlagsAdminV1FlagUsageEntry>;
};

export type FlagsAdminV1QueryFlagUsageResponseResult =
  | Error
  | FlagsAdminV1QueryFlagUsageResponse;

export type FlagsAdminV1QueryRuleWorkflowInstanceResponse = {
  rule: FlagsAdminV1FlagRuleResult;
  segment: FlagsAdminV1SegmentResult;
  workflowInstanceInfo?: Maybe<FlagsAdminV1WorkflowInstanceInfo>;
};

export type FlagsAdminV1QueryRuleWorkflowInstanceResponseResult =
  | Error
  | FlagsAdminV1QueryRuleWorkflowInstanceResponse;

export type FlagsAdminV1QuerySegmentReferencesResponse = {
  segmentReferences: Array<FlagsAdminV1QuerySegmentReferencesResponseSegmentReference>;
};

export type FlagsAdminV1QuerySegmentReferencesResponseResult =
  | Error
  | FlagsAdminV1QuerySegmentReferencesResponse;

export type FlagsAdminV1QuerySegmentReferencesResponseSegmentReference = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  segment: FlagsAdminV1SegmentResult;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
};

export type FlagsAdminV1Segment = {
  allocation?: Maybe<FlagsAdminV1SegmentAllocation>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bitsetAllocation?: Maybe<FlagsAdminV1SegmentBitsetAllocation>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  labels: Array<FlagsAdminV1SegmentLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  querySegmentReferences?: Maybe<FlagsAdminV1QuerySegmentReferencesResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<FlagsAdminV1SegmentState>;
  targeting?: Maybe<FlagsTypesV1Targeting>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
};

export type FlagsAdminV1SegmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1SegmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1SegmentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentAllocation = {
  exclusiveTo: Array<Scalars['String']['output']>;
  exclusivityTags: Array<Scalars['String']['output']>;
  proportion?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1SegmentAllocationInput = {
  exclusiveTo?: InputMaybe<Array<Scalars['String']['input']>>;
  exclusivityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  proportion?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput = {
  exclusiveTo?: InputMaybe<Array<Scalars['String']['input']>>;
  exclusivityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<FlagsTypesV1TargetingInput>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponse = {
  availableSpace?: Maybe<GoogleTypeDecimal>;
  reclaimableSpace: Array<FlagsAdminV1SegmentAvailableSpaceResponseReclaimableSpaceEntry>;
  relatedSegments: Array<FlagsAdminV1SegmentResult>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponseReclaimableSpaceEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponseResult =
  | Error
  | FlagsAdminV1SegmentAvailableSpaceResponse;

export type FlagsAdminV1SegmentBitsetAllocation = {
  bitset?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1SegmentBitsetAllocationInput = {
  bitset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentInput = {
  allocation?: InputMaybe<FlagsAdminV1SegmentAllocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1SegmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<FlagsTypesV1TargetingInput>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1SegmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentResult = Error | FlagsAdminV1Segment;

export type FlagsAdminV1SegmentScheduleInput = {
  endDate: GoogleTypeDateInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment: Scalars['String']['input'];
  startDate: GoogleTypeDateInput;
};

export enum FlagsAdminV1SegmentState {
  Allocated = 'ALLOCATED',
  Archived = 'ARCHIVED',
  Ok = 'OK',
  Unallocated = 'UNALLOCATED',
}

export enum FlagsAdminV1SegmentView {
  Basic = 'BASIC',
  Full = 'FULL',
}

export type FlagsAdminV1WorkflowInstanceInfo = {
  workflowInstance: WorkflowV1WorkflowInstanceResult;
  workflowInstanceType: FlagsAdminV1WorkflowInstanceType;
};

export enum FlagsAdminV1WorkflowInstanceType {
  AbTest = 'AB_TEST',
  Analysis = 'ANALYSIS',
  Reanalysis = 'REANALYSIS',
  Rollout = 'ROLLOUT',
}

export type FlagsAdminV1WriteFlagAssignedResponse = {
  assignedFlags?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1WriteFlagAssignedResponseResult =
  | Error
  | FlagsAdminV1WriteFlagAssignedResponse;

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    schema?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSchemaEntryInput>
    >;
    seenValues?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSeenValuesEntryInput>
    >;
    semanticTypes?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSemanticTypesEntryInput>
    >;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSchemaEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldKind>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSeenValuesEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1ContextFieldSeenValuesInput>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSemanticTypesEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoInput = {
  client: Scalars['String']['input'];
  clientCredential: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceInput>
  >;
};

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoAssignmentResolveInfoInput =
  {
    assignmentId?: InputMaybe<Scalars['String']['input']>;
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoInput = {
  flag: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ruleResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoRuleResolveInfoInput>
  >;
  variantResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoVariantResolveInfoInput>
  >;
};

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoRuleResolveInfoInput =
  {
    assignmentResolveInfo?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoAssignmentResolveInfoInput>
    >;
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    rule: Scalars['String']['input'];
  };

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoVariantResolveInfoInput =
  {
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1WriteResolveInfoResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1WriteResolveInfoResponseResult =
  | Error
  | FlagsAdminV1WriteResolveInfoResponse;

export type FlagsData = {
  audiences?: Maybe<Array<FlagsDataAudience>>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  ignoreTargetingForSticky?: Maybe<Scalars['Boolean']['output']>;
  intakePaused?: Maybe<Scalars['Boolean']['output']>;
  materialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  stickyAssignments?: Maybe<Scalars['Boolean']['output']>;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
};

export type FlagsDataAudience = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intakePaused?: Maybe<Scalars['Boolean']['output']>;
  launchTime?: Maybe<Scalars['String']['output']>;
  materialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  stopTime?: Maybe<Scalars['String']['output']>;
};

export type FlagsDataInput = {
  audiences?: InputMaybe<Array<FlagsDataInputAudienceInput>>;
  flag?: InputMaybe<Scalars['String']['input']>;
  ignoreTargetingForSticky?: InputMaybe<Scalars['Boolean']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stickyAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  launchTime?: InputMaybe<Scalars['String']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stopTime?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverAdminV1ResolveFlagsVerboseResponse = {
  resolvedFlags: Array<FlagsResolverAdminV1ResolvedFlag>;
};

export type FlagsResolverAdminV1ResolveFlagsVerboseResponseResult =
  | Error
  | FlagsResolverAdminV1ResolveFlagsVerboseResponse;

export type FlagsResolverAdminV1ResolvedFlag = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  flagSchema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
  reason?: Maybe<FlagsResolverV1ResolveReason>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  ruleDetails: Array<FlagsResolverAdminV1ResolvedFlagRuleDetails>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  value?: Maybe<Scalars['JSON']['output']>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
};

export type FlagsResolverAdminV1ResolvedFlagRuleDetails = {
  evalContextMissingValues: Array<Scalars['String']['output']>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  ruleEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  segmentEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason;
};

export enum FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason {
  MaterializationAndSegmentNotMatched = 'MATERIALIZATION_AND_SEGMENT_NOT_MATCHED',
  MaterializationNotMatched = 'MATERIALIZATION_NOT_MATCHED',
  RuleEvaluatedNoVariantMatch = 'RULE_EVALUATED_NO_VARIANT_MATCH',
  RuleMatched = 'RULE_MATCHED',
  RuleMatchedFallthrough = 'RULE_MATCHED_FALLTHROUGH',
  RuleNotEnabled = 'RULE_NOT_ENABLED',
  RuleNotEnabledForEnvironment = 'RULE_NOT_ENABLED_FOR_ENVIRONMENT',
  RuleNotEvaluated = 'RULE_NOT_EVALUATED',
  SegmentNotFoundOrNotActive = 'SEGMENT_NOT_FOUND_OR_NOT_ACTIVE',
  SegmentNotMatched = 'SEGMENT_NOT_MATCHED',
}

export enum FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason {
  BitsetNotMatched = 'BITSET_NOT_MATCHED',
  SegmentMatched = 'SEGMENT_MATCHED',
  SegmentNotEvaluated = 'SEGMENT_NOT_EVALUATED',
  TargetingKeyMissing = 'TARGETING_KEY_MISSING',
  TargetingNotMatched = 'TARGETING_NOT_MATCHED',
}

export type FlagsResolverV1EventsClientInfoInput = {
  client?: InputMaybe<Scalars['String']['input']>;
  clientCredential?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdk?: InputMaybe<FlagsResolverV1SdkInput>;
};

export type FlagsResolverV1EventsFallthroughAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  targetingKey?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverV1EventsFlagAssignedAppliedFlagInput = {
  applyTime?: InputMaybe<Scalars['String']['input']>;
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  assignmentInfo?: InputMaybe<FlagsResolverV1EventsFlagAssignedAssignmentInfoInput>;
  defaultAssignment?: InputMaybe<FlagsResolverV1EventsFlagAssignedDefaultAssignmentInput>;
  fallthroughAssignments?: InputMaybe<
    Array<FlagsResolverV1EventsFallthroughAssignmentInput>
  >;
  flag?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  targetingKey?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverV1EventsFlagAssignedAssignmentInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagsResolverV1EventsFlagAssignedDefaultAssignmentDefaultAssignmentReason {
  FlagArchived = 'FLAG_ARCHIVED',
  NoSegmentMatch = 'NO_SEGMENT_MATCH',
  NoTreatmentMatch = 'NO_TREATMENT_MATCH',
}

export type FlagsResolverV1EventsFlagAssignedDefaultAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<FlagsResolverV1EventsFlagAssignedDefaultAssignmentDefaultAssignmentReason>;
};

export type FlagsResolverV1EventsFlagAssignedInput = {
  clientInfo?: InputMaybe<FlagsResolverV1EventsClientInfoInput>;
  flags?: InputMaybe<Array<FlagsResolverV1EventsFlagAssignedAppliedFlagInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveId?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagsResolverV1ResolveReason {
  ResolveReasonBundle = 'RESOLVE_REASON_BUNDLE',
  ResolveReasonError = 'RESOLVE_REASON_ERROR',
  ResolveReasonFlagArchived = 'RESOLVE_REASON_FLAG_ARCHIVED',
  ResolveReasonFlagNotFound = 'RESOLVE_REASON_FLAG_NOT_FOUND',
  ResolveReasonMatch = 'RESOLVE_REASON_MATCH',
  ResolveReasonMaterializationNotSupported = 'RESOLVE_REASON_MATERIALIZATION_NOT_SUPPORTED',
  ResolveReasonNoSegmentMatch = 'RESOLVE_REASON_NO_SEGMENT_MATCH',
  ResolveReasonNoTreatmentMatch = 'RESOLVE_REASON_NO_TREATMENT_MATCH',
  ResolveReasonTargetingKeyError = 'RESOLVE_REASON_TARGETING_KEY_ERROR',
  ResolveReasonTypeMismatch = 'RESOLVE_REASON_TYPE_MISMATCH',
  ResolveReasonUnrecognizedTargetingRule = 'RESOLVE_REASON_UNRECOGNIZED_TARGETING_RULE',
}

export enum FlagsResolverV1SdkId {
  SdkIdCloudflareResolver = 'SDK_ID_CLOUDFLARE_RESOLVER',
  SdkIdDotnetConfidence = 'SDK_ID_DOTNET_CONFIDENCE',
  SdkIdFlutterAndroidConfidence = 'SDK_ID_FLUTTER_ANDROID_CONFIDENCE',
  SdkIdFlutterIosConfidence = 'SDK_ID_FLUTTER_IOS_CONFIDENCE',
  SdkIdGoConfidence = 'SDK_ID_GO_CONFIDENCE',
  SdkIdGoLocalProvider = 'SDK_ID_GO_LOCAL_PROVIDER',
  SdkIdGoProvider = 'SDK_ID_GO_PROVIDER',
  SdkIdJavaConfidence = 'SDK_ID_JAVA_CONFIDENCE',
  SdkIdJavaLocalProvider = 'SDK_ID_JAVA_LOCAL_PROVIDER',
  SdkIdJavaProvider = 'SDK_ID_JAVA_PROVIDER',
  SdkIdJsConfidence = 'SDK_ID_JS_CONFIDENCE',
  SdkIdJsLocalServerProvider = 'SDK_ID_JS_LOCAL_SERVER_PROVIDER',
  SdkIdJsServerProvider = 'SDK_ID_JS_SERVER_PROVIDER',
  SdkIdJsWebProvider = 'SDK_ID_JS_WEB_PROVIDER',
  SdkIdKotlinConfidence = 'SDK_ID_KOTLIN_CONFIDENCE',
  SdkIdKotlinProvider = 'SDK_ID_KOTLIN_PROVIDER',
  SdkIdPhpProvider = 'SDK_ID_PHP_PROVIDER',
  SdkIdPythonConfidence = 'SDK_ID_PYTHON_CONFIDENCE',
  SdkIdPythonLocalProvider = 'SDK_ID_PYTHON_LOCAL_PROVIDER',
  SdkIdPythonProvider = 'SDK_ID_PYTHON_PROVIDER',
  SdkIdRubyProvider = 'SDK_ID_RUBY_PROVIDER',
  SdkIdRustConfidence = 'SDK_ID_RUST_CONFIDENCE',
  SdkIdRustLocalProvider = 'SDK_ID_RUST_LOCAL_PROVIDER',
  SdkIdRustProvider = 'SDK_ID_RUST_PROVIDER',
  SdkIdSwiftConfidence = 'SDK_ID_SWIFT_CONFIDENCE',
  SdkIdSwiftProvider = 'SDK_ID_SWIFT_PROVIDER',
}

export type FlagsResolverV1SdkInput = {
  customId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<FlagsResolverV1SdkId>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1Expression = {
  and?: Maybe<FlagsTypesV1ExpressionOperands>;
  not?: Maybe<FlagsTypesV1Expression>;
  or?: Maybe<FlagsTypesV1ExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1ExpressionInput = {
  and?: InputMaybe<FlagsTypesV1ExpressionOperandsInput>;
  not?: InputMaybe<FlagsTypesV1ExpressionInput>;
  or?: InputMaybe<FlagsTypesV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1ExpressionOperands = {
  operands: Array<FlagsTypesV1Expression>;
};

export type FlagsTypesV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<FlagsTypesV1ExpressionInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchema = {
  boolSchema?: Maybe<FlagsTypesV1FlagSchemaBoolFlagSchema>;
  doubleSchema?: Maybe<FlagsTypesV1FlagSchemaDoubleFlagSchema>;
  intSchema?: Maybe<FlagsTypesV1FlagSchemaIntFlagSchema>;
  listSchema?: Maybe<FlagsTypesV1FlagSchemaListFlagSchema>;
  stringSchema?: Maybe<FlagsTypesV1FlagSchemaStringFlagSchema>;
  structSchema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
};

export type FlagsTypesV1FlagSchemaBoolFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaBoolFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaDoubleFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaDoubleFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaInput = {
  boolSchema?: InputMaybe<FlagsTypesV1FlagSchemaBoolFlagSchemaInput>;
  doubleSchema?: InputMaybe<FlagsTypesV1FlagSchemaDoubleFlagSchemaInput>;
  intSchema?: InputMaybe<FlagsTypesV1FlagSchemaIntFlagSchemaInput>;
  listSchema?: InputMaybe<FlagsTypesV1FlagSchemaListFlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<FlagsTypesV1FlagSchemaStringFlagSchemaInput>;
  structSchema?: InputMaybe<FlagsTypesV1FlagSchemaStructFlagSchemaInput>;
};

export type FlagsTypesV1FlagSchemaIntFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaIntFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaListFlagSchema = {
  elementSchema?: Maybe<FlagsTypesV1FlagSchema>;
};

export type FlagsTypesV1FlagSchemaListFlagSchemaInput = {
  elementSchema?: InputMaybe<FlagsTypesV1FlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaStringFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaStringFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchema = {
  schema: Array<FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntry>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput>
  >;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsTypesV1FlagSchema>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1FlagSchemaInput>;
};

export type FlagsTypesV1Targeting = {
  criteria: Array<FlagsTypesV1TargetingCriteriaEntry>;
  expression?: Maybe<FlagsTypesV1Expression>;
};

export type FlagsTypesV1TargetingAllRule = {
  rule?: Maybe<FlagsTypesV1TargetingInnerRule>;
};

export type FlagsTypesV1TargetingAllRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<FlagsTypesV1TargetingInnerRuleInput>;
};

export type FlagsTypesV1TargetingAnyRule = {
  rule?: Maybe<FlagsTypesV1TargetingInnerRule>;
};

export type FlagsTypesV1TargetingAnyRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<FlagsTypesV1TargetingInnerRuleInput>;
};

export type FlagsTypesV1TargetingContainsRule = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingContainsRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsTypesV1TargetingCriterion>;
};

export type FlagsTypesV1TargetingCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1TargetingCriterionInput>;
};

export type FlagsTypesV1TargetingCriterion = {
  attribute?: Maybe<FlagsTypesV1TargetingCriterionAttributeCriterion>;
  materializedSegment?: Maybe<FlagsTypesV1TargetingCriterionMaterializedSegmentCriterion>;
  segment?: Maybe<FlagsTypesV1TargetingCriterionSegmentCriterion>;
};

export type FlagsTypesV1TargetingCriterionAttributeCriterion = {
  allRule?: Maybe<FlagsTypesV1TargetingAllRule>;
  anyRule?: Maybe<FlagsTypesV1TargetingAnyRule>;
  attributeName?: Maybe<Scalars['String']['output']>;
  containsRule?: Maybe<FlagsTypesV1TargetingContainsRule>;
  endsWithRule?: Maybe<FlagsTypesV1TargetingEndsWithRule>;
  eqRule?: Maybe<FlagsTypesV1TargetingEqRule>;
  rangeRule?: Maybe<FlagsTypesV1TargetingRangeRule>;
  setRule?: Maybe<FlagsTypesV1TargetingSetRule>;
  startsWithRule?: Maybe<FlagsTypesV1TargetingStartsWithRule>;
};

export type FlagsTypesV1TargetingCriterionAttributeCriterionInput = {
  allRule?: InputMaybe<FlagsTypesV1TargetingAllRuleInput>;
  anyRule?: InputMaybe<FlagsTypesV1TargetingAnyRuleInput>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  containsRule?: InputMaybe<FlagsTypesV1TargetingContainsRuleInput>;
  endsWithRule?: InputMaybe<FlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<FlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<FlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<FlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<FlagsTypesV1TargetingStartsWithRuleInput>;
};

export type FlagsTypesV1TargetingCriterionInput = {
  attribute?: InputMaybe<FlagsTypesV1TargetingCriterionAttributeCriterionInput>;
  materializedSegment?: InputMaybe<FlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<FlagsTypesV1TargetingCriterionSegmentCriterionInput>;
};

export type FlagsTypesV1TargetingCriterionMaterializedSegmentCriterion = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
};

export type FlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput = {
  materializedSegment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingCriterionSegmentCriterion = {
  segment?: Maybe<FlagsAdminV1SegmentResult>;
};

export type FlagsTypesV1TargetingCriterionSegmentCriterionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingEndsWithRule = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingEndsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingEqRule = {
  value?: Maybe<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1TargetingValueInput>;
};

export type FlagsTypesV1TargetingInnerRule = {
  containsRule?: Maybe<FlagsTypesV1TargetingContainsRule>;
  endsWithRule?: Maybe<FlagsTypesV1TargetingEndsWithRule>;
  eqRule?: Maybe<FlagsTypesV1TargetingEqRule>;
  rangeRule?: Maybe<FlagsTypesV1TargetingRangeRule>;
  setRule?: Maybe<FlagsTypesV1TargetingSetRule>;
  startsWithRule?: Maybe<FlagsTypesV1TargetingStartsWithRule>;
};

export type FlagsTypesV1TargetingInnerRuleInput = {
  containsRule?: InputMaybe<FlagsTypesV1TargetingContainsRuleInput>;
  endsWithRule?: InputMaybe<FlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<FlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<FlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<FlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<FlagsTypesV1TargetingStartsWithRuleInput>;
};

export type FlagsTypesV1TargetingInput = {
  criteria?: InputMaybe<Array<FlagsTypesV1TargetingCriteriaEntryInput>>;
  expression?: InputMaybe<FlagsTypesV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingListValue = {
  values: Array<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingListValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<FlagsTypesV1TargetingValueInput>>;
};

export type FlagsTypesV1TargetingRangeRule = {
  endExclusive?: Maybe<FlagsTypesV1TargetingValue>;
  endInclusive?: Maybe<FlagsTypesV1TargetingValue>;
  startExclusive?: Maybe<FlagsTypesV1TargetingValue>;
  startInclusive?: Maybe<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingRangeRuleInput = {
  endExclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  endInclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  startInclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
};

export type FlagsTypesV1TargetingSemanticVersion = {
  version?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingSemanticVersionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingSetRule = {
  values: Array<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<FlagsTypesV1TargetingValueInput>>;
};

export type FlagsTypesV1TargetingStartsWithRule = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingStartsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingValue = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  listValue?: Maybe<FlagsTypesV1TargetingListValue>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
  versionValue?: Maybe<FlagsTypesV1TargetingSemanticVersion>;
};

export type FlagsTypesV1TargetingValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<FlagsTypesV1TargetingListValueInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
  versionValue?: InputMaybe<FlagsTypesV1TargetingSemanticVersionInput>;
};

export type GoogleApiHttpBody = {
  contentType?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  extensions: Array<Scalars['JSON']['output']>;
};

export type GoogleApiHttpBodyResult = Error | GoogleApiHttpBody;

export type GoogleProtobufEmpty = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type GoogleProtobufEmptyResult = Error | GoogleProtobufEmpty;

export type GoogleTypeDate = {
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type GoogleTypeDateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleTypeDecimal = {
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleTypeDecimalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HypothesisData = {
  text?: Maybe<Scalars['String']['output']>;
};

export type HypothesisDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AddGroupMembersResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1AddGroupMembersResponseResult =
  | Error
  | IamV1AddGroupMembersResponse;

export type IamV1Agent = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  instructions?: Maybe<Scalars['String']['output']>;
  labels: Array<IamV1AgentLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewerSkill?: Maybe<IamV1AgentReviewerSkill>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1AgentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1AgentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1AgentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1AgentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewerSkill?: InputMaybe<IamV1AgentReviewerSkillInput>;
};

export type IamV1AgentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1AgentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentResult = Error | IamV1Agent;

export type IamV1AgentReviewerSkill = {
  enabled: Scalars['Boolean']['output'];
  instructions: Scalars['String']['output'];
};

export type IamV1AgentReviewerSkillInput = {
  enabled: Scalars['Boolean']['input'];
  instructions: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClient = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientId: Scalars['String']['output'];
  /** @deprecated No longer supported */
  clientSecret?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<IamV1ApiClientLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ApiClientAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ApiClientCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ApiClientObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1ApiClientLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ApiClientLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientResult = Error | IamV1ApiClient;

export type IamV1ApiClientSecret = {
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type IamV1ApiClientSecretResult = Error | IamV1ApiClientSecret;

export type IamV1Client = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientCredentials?: Maybe<IamV1ListClientCredentialsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1ClientLabelsEntry>;
  lastSeenTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ClientAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientClientCredentialsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ClientCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ClientObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredential = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientSecret?: Maybe<IamV1ClientCredentialClientSecret>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  environments: Array<FlagsAdminV1EnvironmentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  hasEncryptionKey?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<IamV1ClientCredentialLabelsEntry>;
  lastSeenTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sdkType?: Maybe<IamV1ClientCredentialSdkType>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ClientCredentialAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ClientCredentialCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ClientCredentialObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialClientSecret = {
  secret?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialClientSecretInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialEncryptionKey = {
  encryptionKey?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialEncryptionKeyResult =
  | Error
  | IamV1ClientCredentialEncryptionKey;

export type IamV1ClientCredentialInput = {
  clientSecret?: InputMaybe<IamV1ClientCredentialClientSecretInput>;
  displayName: Scalars['String']['input'];
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<IamV1ClientCredentialLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdkType?: InputMaybe<IamV1ClientCredentialSdkType>;
};

export type IamV1ClientCredentialLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialResult = Error | IamV1ClientCredential;

export enum IamV1ClientCredentialSdkType {
  Backend = 'BACKEND',
  Frontend = 'FRONTEND',
}

export type IamV1ClientInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1ClientLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientResult = Error | IamV1Client;

export type IamV1CryptoKey = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kind: IamV1CryptoKeyKind;
  labels: Array<IamV1CryptoKeyLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  publicKey?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: IamV1CryptoKeyState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1CryptoKeyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1CryptoKeyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1CryptoKeyObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyInput = {
  kind: IamV1CryptoKeyKind;
  labels?: InputMaybe<Array<IamV1CryptoKeyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum IamV1CryptoKeyKind {
  Snowflake = 'SNOWFLAKE',
}

export type IamV1CryptoKeyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1CryptoKeyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyResult = Error | IamV1CryptoKey;

export enum IamV1CryptoKeyState {
  Created = 'CREATED',
  Creating = 'CREATING',
  Deleted = 'DELETED',
}

export type IamV1CurrentUser = {
  account: Scalars['String']['output'];
  accountMemberships: Array<IamV1CurrentUserAccountMembership>;
  identity: IamV1Identity;
  serviceAccountOauth2ClientId: Scalars['String']['output'];
  user?: Maybe<IamV1User>;
};

export type IamV1CurrentUserAccountMembership = {
  account: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  loginId: Scalars['String']['output'];
  portalInstanceUri?: Maybe<Scalars['String']['output']>;
  region: IamV1CurrentUserAccountMembershipRegion;
};

export enum IamV1CurrentUserAccountMembershipRegion {
  RegionEu = 'REGION_EU',
  RegionUs = 'REGION_US',
}

export type IamV1CurrentUserResult = Error | IamV1CurrentUser;

export type IamV1EventsApiClientCreated = {
  apiClient?: Maybe<IamV1ApiClient>;
};

export type IamV1EventsApiClientDeleted = {
  apiClient?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsApiClientUpdated = {
  apiClient?: Maybe<IamV1ApiClient>;
};

export type IamV1EventsClientCreated = {
  client?: Maybe<IamV1Client>;
};

export type IamV1EventsClientCredentialCreated = {
  clientCredential?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientCredentialDeleted = {
  clientCredential?: Maybe<IamV1ClientCredentialResult>;
  resource?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientCredentialUpdated = {
  clientCredential?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientDeleted = {
  client?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsClientUpdated = {
  client?: Maybe<IamV1Client>;
};

export type IamV1EventsGroupCreated = {
  group?: Maybe<IamV1Group>;
};

export type IamV1EventsGroupDeleted = {
  group?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsGroupUpdated = {
  group?: Maybe<IamV1Group>;
  oldGroup?: Maybe<IamV1Group>;
};

export type IamV1EventsIdentityCreated = {
  identity?: Maybe<IamV1Identity>;
};

export type IamV1EventsIdentityDeleted = {
  identity?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsIdentityUpdated = {
  identity?: Maybe<IamV1Identity>;
  oldIdentity?: Maybe<IamV1Identity>;
};

export type IamV1EventsPolicyCreated = {
  policy?: Maybe<IamV1Policy>;
};

export type IamV1EventsPolicyDeleted = {
  policy?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsPolicyUpdated = {
  policy?: Maybe<IamV1Policy>;
};

export type IamV1EventsUserCreated = {
  user?: Maybe<IamV1User>;
};

export type IamV1EventsUserUpdated = {
  user?: Maybe<IamV1User>;
};

export type IamV1GenerateClientCredentialEncryptionKeyResponse = {
  encryptionKey?: Maybe<Scalars['String']['output']>;
};

export type IamV1GenerateClientCredentialEncryptionKeyResponseResult =
  | Error
  | IamV1GenerateClientCredentialEncryptionKeyResponse;

export type IamV1Group = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  groupMembers?: Maybe<IamV1ListGroupMembersResponseResult>;
  groupType: IamV1GroupGroupType;
  identity: IamV1IdentityResult;
  labels: Array<IamV1GroupLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  slackChannel?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1GroupAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1GroupCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1GroupCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1GroupExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1GroupGroupMembersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1GroupQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IamV1GroupGroupType {
  SystemCreated = 'SYSTEM_CREATED',
  UserCreated = 'USER_CREATED',
}

export type IamV1GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1GroupLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slackChannel?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1GroupLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupResult = Error | IamV1Group;

export type IamV1Identity = {
  agent?: Maybe<IamV1AgentResult>;
  apiClient?: Maybe<IamV1ApiClientResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  everyone?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  group?: Maybe<IamV1GroupResult>;
  labels: Array<IamV1IdentityLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  service?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  user?: Maybe<IamV1UserResult>;
};

export type IamV1IdentityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1IdentityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1IdentityObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1IdentityResult = Error | IamV1Identity;

export type IamV1ListAgentsResponse = {
  agents: Array<IamV1Agent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListAgentsResponseResult = Error | IamV1ListAgentsResponse;

export type IamV1ListApiClientsResponse = {
  apiClients: Array<IamV1ApiClient>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListApiClientsResponseResult =
  | Error
  | IamV1ListApiClientsResponse;

export type IamV1ListClientCredentialsResponse = {
  clientCredentials: Array<IamV1ClientCredential>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListClientCredentialsResponseResult =
  | Error
  | IamV1ListClientCredentialsResponse;

export type IamV1ListClientsResponse = {
  clients: Array<IamV1Client>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListClientsResponseResult = Error | IamV1ListClientsResponse;

export type IamV1ListCryptoKeysResponse = {
  cryptoKeys: Array<IamV1CryptoKey>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListCryptoKeysResponseResult =
  | Error
  | IamV1ListCryptoKeysResponse;

export type IamV1ListGroupMembersResponse = {
  groupMembers: Array<IamV1Identity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListGroupMembersResponseResult =
  | Error
  | IamV1ListGroupMembersResponse;

export type IamV1ListGroupsResponse = {
  groups: Array<IamV1Group>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListGroupsResponseResult = Error | IamV1ListGroupsResponse;

export type IamV1ListIdentitiesResponse = {
  identities: Array<IamV1Identity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListIdentitiesResponseResult =
  | Error
  | IamV1ListIdentitiesResponse;

export type IamV1ListOAuthAppsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  oauthApps: Array<IamV1OAuthApp>;
};

export type IamV1ListOAuthAppsResponseResult =
  | Error
  | IamV1ListOAuthAppsResponse;

export type IamV1ListPermissionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  permissions: Array<IamV1Permission>;
};

export type IamV1ListPermissionsResponseResult =
  | Error
  | IamV1ListPermissionsResponse;

export type IamV1ListPoliciesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  policies: Array<IamV1Policy>;
};

export type IamV1ListPoliciesResponseResult = Error | IamV1ListPoliciesResponse;

export type IamV1ListRolesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  roles: Array<IamV1Role>;
};

export type IamV1ListRolesResponseResult = Error | IamV1ListRolesResponse;

export type IamV1ListUserGroupsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  userGroups: Array<IamV1UserGroup>;
};

export type IamV1ListUserGroupsResponseResult =
  | Error
  | IamV1ListUserGroupsResponse;

export type IamV1ListUserInvitationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  userInvitations: Array<IamV1UserInvitation>;
};

export type IamV1ListUserInvitationsResponseResult =
  | Error
  | IamV1ListUserInvitationsResponse;

export type IamV1ListUsersResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  users: Array<IamV1User>;
};

export type IamV1ListUsersResponseResult = Error | IamV1ListUsersResponse;

export type IamV1OAuthApp = {
  allowedCallbackUrls: Array<Scalars['String']['output']>;
  allowedLogoutUrls: Array<Scalars['String']['output']>;
  allowedWebOrigins: Array<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1OAuthAppLabelsEntry>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1OAuthAppAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1OAuthAppCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1OAuthAppObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppInput = {
  allowedCallbackUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLogoutUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedWebOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1OAuthAppLabelsEntryInput>>;
  logoUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1OAuthAppLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppResult = Error | IamV1OAuthApp;

export type IamV1Permission = {
  category: IamV1PermissionCategory;
  description?: Maybe<Scalars['String']['output']>;
  type: IamV1PermissionType;
};

export enum IamV1PermissionCategory {
  Agent = 'AGENT',
  ApiClient = 'API_CLIENT',
  AssignmentTable = 'ASSIGNMENT_TABLE',
  Billing = 'BILLING',
  Chat = 'CHAT',
  Client = 'CLIENT',
  Collection = 'COLLECTION',
  DataWarehouse = 'DATA_WAREHOUSE',
  DimensionTable = 'DIMENSION_TABLE',
  Entity = 'ENTITY',
  EntityRelationTable = 'ENTITY_RELATION_TABLE',
  EvaluationContextSchema = 'EVALUATION_CONTEXT_SCHEMA',
  Event = 'EVENT',
  EventConnection = 'EVENT_CONNECTION',
  EventDefinition = 'EVENT_DEFINITION',
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ExposureTable = 'EXPOSURE_TABLE',
  ExternalDocument = 'EXTERNAL_DOCUMENT',
  ExternalIntegration = 'EXTERNAL_INTEGRATION',
  FactTable = 'FACT_TABLE',
  Feed = 'FEED',
  Flag = 'FLAG',
  FlagAppliedConnection = 'FLAG_APPLIED_CONNECTION',
  FlagAssigned = 'FLAG_ASSIGNED',
  Group = 'GROUP',
  IamPolicy = 'IAM_POLICY',
  Label = 'LABEL',
  MaterializedSegment = 'MATERIALIZED_SEGMENT',
  MaterializedSegmentLoadJob = 'MATERIALIZED_SEGMENT_LOAD_JOB',
  Metric = 'METRIC',
  MetricCalculation = 'METRIC_CALCULATION',
  OauthApp = 'OAUTH_APP',
  PlatformConnection = 'PLATFORM_CONNECTION',
  Project = 'PROJECT',
  Pulse = 'PULSE',
  RecordingPolicy = 'RECORDING_POLICY',
  ResolveInfo = 'RESOLVE_INFO',
  Role = 'ROLE',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
  ScheduledMetricCalculation = 'SCHEDULED_METRIC_CALCULATION',
  Segment = 'SEGMENT',
  SqlJob = 'SQL_JOB',
  StatsApi = 'STATS_API',
  Surface = 'SURFACE',
  User = 'USER',
  UserInvitation = 'USER_INVITATION',
  Workflow = 'WORKFLOW',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
  WorkflowLog = 'WORKFLOW_LOG',
  WorkflowSecret = 'WORKFLOW_SECRET',
}

export type IamV1PermissionInput = {
  category: IamV1PermissionCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type: IamV1PermissionType;
};

export enum IamV1PermissionType {
  Admin = 'ADMIN',
  Creator = 'CREATOR',
  Editor = 'EDITOR',
  Reader = 'READER',
}

export type IamV1Policy = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identities: Array<IamV1IdentityResult>;
  labels: Array<IamV1PolicyLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  roles: Array<IamV1RoleResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1PolicyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1PolicyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1PolicyObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyInput = {
  identities: Array<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1PolicyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type IamV1PolicyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1PolicyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyResult = Error | IamV1Policy;

export type IamV1RemoveGroupMembersResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1RemoveGroupMembersResponseResult =
  | Error
  | IamV1RemoveGroupMembersResponse;

export type IamV1Role = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1RoleLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  permissions: Array<IamV1Permission>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1RoleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1RoleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1RoleObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1RoleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<IamV1PermissionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1RoleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleResult = Error | IamV1Role;

export type IamV1SlackUserInfo = {
  picture?: Maybe<Scalars['String']['output']>;
  team: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type IamV1SlackUserInfoInput = {
  picture?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type IamV1StoreSlackUserInfoResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1StoreSlackUserInfoResponseResult =
  | Error
  | IamV1StoreSlackUserInfoResponse;

export type IamV1User = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  externalId?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  identity: IamV1IdentityResult;
  labels: Array<IamV1UserLabelsEntry>;
  lastLoginTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scimExternalId?: Maybe<Scalars['String']['output']>;
  slackUserInfo?: Maybe<IamV1SlackUserInfo>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  userGroups?: Maybe<IamV1ListUserGroupsResponseResult>;
  username?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1UserCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1UserObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserUserGroupsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserGroup = {
  group?: Maybe<IamV1Group>;
};

export type IamV1UserInput = {
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1UserLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  expirationTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  invitationToken: Scalars['String']['output'];
  invitationUri: Scalars['String']['output'];
  invitedEmail: Scalars['String']['output'];
  inviter?: Maybe<Scalars['String']['output']>;
  labels: Array<IamV1UserInvitationLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  ttl?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1UserInvitationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1UserInvitationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1UserInvitationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationInput = {
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  invitedEmail: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1UserInvitationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ttl?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserInvitationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationResult = Error | IamV1UserInvitation;

export type IamV1UserLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserResult = Error | IamV1User;

export type InsightsV1ActiveSdk = {
  resolveMode?: Maybe<InsightsV1SdkResolveMode>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
  sdkId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ArithmeticExpression = {
  aggregate?: Maybe<InsightsV1ArithmeticExpressionAggregate>;
  divide?: Maybe<InsightsV1ArithmeticExpressionDivide>;
  field?: Maybe<Scalars['String']['output']>;
  multiply?: Maybe<InsightsV1ArithmeticExpressionOperands>;
  negate?: Maybe<InsightsV1ArithmeticExpression>;
  plus?: Maybe<InsightsV1ArithmeticExpressionOperands>;
  subtract?: Maybe<InsightsV1ArithmeticExpressionSubtract>;
  value?: Maybe<InsightsV1Value>;
};

export type InsightsV1ArithmeticExpressionAggregate = {
  average?: Maybe<InsightsV1ArithmeticExpression>;
  count?: Maybe<InsightsV1ArithmeticExpressionCount>;
  max?: Maybe<InsightsV1ArithmeticExpression>;
  min?: Maybe<InsightsV1ArithmeticExpression>;
  sum?: Maybe<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionAggregateInput = {
  average?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  count?: InputMaybe<InsightsV1ArithmeticExpressionCountInput>;
  max?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  min?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sum?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
};

export type InsightsV1ArithmeticExpressionCount = {
  distinct?: Maybe<Scalars['Boolean']['output']>;
  expression?: Maybe<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionCountInput = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionDivide = {
  denominator: InsightsV1ArithmeticExpression;
  numerator: InsightsV1ArithmeticExpression;
};

export type InsightsV1ArithmeticExpressionDivideInput = {
  denominator: InsightsV1ArithmeticExpressionInput;
  numerator: InsightsV1ArithmeticExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionInput = {
  aggregate?: InputMaybe<InsightsV1ArithmeticExpressionAggregateInput>;
  divide?: InputMaybe<InsightsV1ArithmeticExpressionDivideInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  multiply?: InputMaybe<InsightsV1ArithmeticExpressionOperandsInput>;
  negate?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  plus?: InputMaybe<InsightsV1ArithmeticExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  subtract?: InputMaybe<InsightsV1ArithmeticExpressionSubtractInput>;
  value?: InputMaybe<InsightsV1ValueInput>;
};

export type InsightsV1ArithmeticExpressionOperands = {
  operands: Array<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionOperandsInput = {
  operands: Array<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionSubtract = {
  left: InsightsV1ArithmeticExpression;
  right: InsightsV1ArithmeticExpression;
};

export type InsightsV1ArithmeticExpressionSubtractInput = {
  left: InsightsV1ArithmeticExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  right: InsightsV1ArithmeticExpressionInput;
};

export type InsightsV1CheckSdkCompatibilityResponse = {
  activeSdks: Array<InsightsV1ActiveSdk>;
  featureCompatibilities: Array<InsightsV1FeatureCompatibility>;
};

export type InsightsV1CheckSdkCompatibilityResponseResult =
  | Error
  | InsightsV1CheckSdkCompatibilityResponse;

export type InsightsV1ColumnInfo = {
  column: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum InsightsV1CompatibilityStatus {
  CompatibilityStatusCompatible = 'COMPATIBILITY_STATUS_COMPATIBLE',
  CompatibilityStatusIncompatible = 'COMPATIBILITY_STATUS_INCOMPATIBLE',
  CompatibilityStatusUnknown = 'COMPATIBILITY_STATUS_UNKNOWN',
}

export type InsightsV1Dashboard = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<InsightsV1DashboardLabelsEntry>;
  metrics: Array<InsightsV1InsightsMetricResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1DashboardAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1DashboardCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1DashboardObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<InsightsV1DashboardLabelsEntryInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1DashboardLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardResult = Error | InsightsV1Dashboard;

export type InsightsV1EntityMapping = {
  column: Scalars['String']['output'];
  entity: Scalars['String']['output'];
};

export type InsightsV1ExampleQuery = {
  question: Scalars['String']['output'];
  sql: Scalars['String']['output'];
};

export type InsightsV1ExampleQueryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sql: Scalars['String']['input'];
};

export type InsightsV1ExecuteSqlResponse = {
  columns: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  rows: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type InsightsV1ExecuteSqlResponseResult =
  | Error
  | InsightsV1ExecuteSqlResponse;

export type InsightsV1FactTableContext = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  ddl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<InsightsV1ColumnInfo>;
  displayName: Scalars['String']['output'];
  entities: Array<InsightsV1EntityMapping>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  measures: Array<InsightsV1ColumnInfo>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sql?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timestampColumn?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1FactTableContextAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1FactTableContextCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1FactTableContextObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextResult =
  | Error
  | InsightsV1FactTableContext;

export type InsightsV1FactTableSummary = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  columnSummary?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type InsightsV1FactTableSummaryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1FactTableSummaryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1FactTableSummaryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryResult =
  | Error
  | InsightsV1FactTableSummary;

export type InsightsV1FeatureCompatibility = {
  displayName?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  incompatibleSdks: Array<InsightsV1IncompatibleSdk>;
  status?: Maybe<InsightsV1CompatibilityStatus>;
};

export type InsightsV1Filter = {
  criteria: Array<InsightsV1FilterCriteriaEntry>;
  expression: InsightsV1FilterBooleanExpression;
};

export type InsightsV1FilterAnyRule = {
  eqRule?: Maybe<InsightsV1FilterEqRule>;
  itemAttribute: Scalars['String']['output'];
  rangeRule?: Maybe<InsightsV1FilterRangeRule>;
  setRule?: Maybe<InsightsV1FilterSetRule>;
};

export type InsightsV1FilterAnyRuleInput = {
  eqRule?: InputMaybe<InsightsV1FilterEqRuleInput>;
  itemAttribute: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<InsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<InsightsV1FilterSetRuleInput>;
};

export type InsightsV1FilterBooleanExpression = {
  and?: Maybe<InsightsV1FilterBooleanExpressionOperands>;
  not?: Maybe<InsightsV1FilterBooleanExpression>;
  or?: Maybe<InsightsV1FilterBooleanExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1FilterBooleanExpressionInput = {
  and?: InputMaybe<InsightsV1FilterBooleanExpressionOperandsInput>;
  not?: InputMaybe<InsightsV1FilterBooleanExpressionInput>;
  or?: InputMaybe<InsightsV1FilterBooleanExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterBooleanExpressionOperands = {
  operands: Array<InsightsV1FilterBooleanExpression>;
};

export type InsightsV1FilterBooleanExpressionOperandsInput = {
  operands: Array<InsightsV1FilterBooleanExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<InsightsV1FilterCriterion>;
};

export type InsightsV1FilterCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<InsightsV1FilterCriterionInput>;
};

export type InsightsV1FilterCriterion = {
  attribute?: Maybe<InsightsV1FilterCriterionAttributeCriterion>;
};

export type InsightsV1FilterCriterionAttributeCriterion = {
  anyRule?: Maybe<InsightsV1FilterAnyRule>;
  attribute: Scalars['String']['output'];
  eqRule?: Maybe<InsightsV1FilterEqRule>;
  rangeRule?: Maybe<InsightsV1FilterRangeRule>;
  setRule?: Maybe<InsightsV1FilterSetRule>;
};

export type InsightsV1FilterCriterionAttributeCriterionInput = {
  anyRule?: InputMaybe<InsightsV1FilterAnyRuleInput>;
  attribute: Scalars['String']['input'];
  eqRule?: InputMaybe<InsightsV1FilterEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<InsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<InsightsV1FilterSetRuleInput>;
};

export type InsightsV1FilterCriterionInput = {
  attribute?: InputMaybe<InsightsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterEqRule = {
  value: InsightsV1Value;
};

export type InsightsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: InsightsV1ValueInput;
};

export type InsightsV1FilterInput = {
  criteria: Array<InsightsV1FilterCriteriaEntryInput>;
  expression: InsightsV1FilterBooleanExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterRangeRule = {
  endExclusive?: Maybe<InsightsV1Value>;
  endInclusive?: Maybe<InsightsV1Value>;
  startExclusive?: Maybe<InsightsV1Value>;
  startInclusive?: Maybe<InsightsV1Value>;
};

export type InsightsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<InsightsV1ValueInput>;
  endInclusive?: InputMaybe<InsightsV1ValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<InsightsV1ValueInput>;
  startInclusive?: InputMaybe<InsightsV1ValueInput>;
};

export type InsightsV1FilterSetRule = {
  values: Array<InsightsV1Value>;
};

export type InsightsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<InsightsV1ValueInput>;
};

export type InsightsV1GetLatestSdkVersionsResponse = {
  features: Array<InsightsV1SdkFeatureDefinition>;
  sdkLatestVersions: Array<InsightsV1SdkLatestVersion>;
};

export type InsightsV1GetLatestSdkVersionsResponseResult =
  | Error
  | InsightsV1GetLatestSdkVersionsResponse;

export enum InsightsV1GraphType {
  GraphTypeApolloResolvedFlagsByClient = 'GRAPH_TYPE_APOLLO_RESOLVED_FLAGS_BY_CLIENT',
  GraphTypeAverageResolveLatency = 'GRAPH_TYPE_AVERAGE_RESOLVE_LATENCY',
  GraphTypeCombinedErrorRate = 'GRAPH_TYPE_COMBINED_ERROR_RATE',
  GraphTypeCombinedErrorRatio = 'GRAPH_TYPE_COMBINED_ERROR_RATIO',
  GraphTypeCombinedResolveRate = 'GRAPH_TYPE_COMBINED_RESOLVE_RATE',
  GraphTypeEvaluationErrorsByStatus = 'GRAPH_TYPE_EVALUATION_ERRORS_BY_STATUS',
  GraphTypeEvaluationErrorRatio = 'GRAPH_TYPE_EVALUATION_ERROR_RATIO',
  GraphTypeEventsPublishRate = 'GRAPH_TYPE_EVENTS_PUBLISH_RATE',
  GraphTypeEventsPublishRateByEventDefinition = 'GRAPH_TYPE_EVENTS_PUBLISH_RATE_BY_EVENT_DEFINITION',
  GraphTypeEventsPublishRateBySdk = 'GRAPH_TYPE_EVENTS_PUBLISH_RATE_BY_SDK',
  GraphTypeMobileResolveRate = 'GRAPH_TYPE_MOBILE_RESOLVE_RATE',
  GraphTypeRemoteSdkResolveRate = 'GRAPH_TYPE_REMOTE_SDK_RESOLVE_RATE',
  GraphTypeResolveCountByPlatform = 'GRAPH_TYPE_RESOLVE_COUNT_BY_PLATFORM',
  GraphTypeResolveCountOverTime = 'GRAPH_TYPE_RESOLVE_COUNT_OVER_TIME',
  GraphTypeResolveErrorsByReason = 'GRAPH_TYPE_RESOLVE_ERRORS_BY_REASON',
  GraphTypeResolveErrorRatio = 'GRAPH_TYPE_RESOLVE_ERROR_RATIO',
  GraphTypeTotalEvaluationRate = 'GRAPH_TYPE_TOTAL_EVALUATION_RATE',
  GraphTypeTotalResolveRate = 'GRAPH_TYPE_TOTAL_RESOLVE_RATE',
}

export type InsightsV1IncompatibleSdk = {
  currentVersion?: Maybe<Scalars['String']['output']>;
  requiredVersion?: Maybe<Scalars['String']['output']>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum InsightsV1InsightsContextSource {
  LlmGenerated = 'LLM_GENERATED',
  Synced = 'SYNCED',
  User = 'USER',
}

export type InsightsV1InsightsDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  labels: Array<InsightsV1InsightsDocumentLabelsEntry>;
  lifecycle?: Maybe<InsightsV1InsightsDocumentLifecycle>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  uri?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsDocumentObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InsightsV1InsightsDocumentLabelsEntryInput>>;
  lifecycle?: InputMaybe<InsightsV1InsightsDocumentLifecycle>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum InsightsV1InsightsDocumentLifecycle {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type InsightsV1InsightsDocumentResult =
  | Error
  | InsightsV1InsightsDocument;

export type InsightsV1InsightsMetric = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataSource: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  expression: InsightsV1ArithmeticExpression;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  filter?: Maybe<InsightsV1Filter>;
  groupBy: Array<Scalars['String']['output']>;
  labels: Array<InsightsV1InsightsMetricLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryInsightsMetric?: Maybe<InsightsV1QueryInsightsMetricResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timeConfig?: Maybe<InsightsV1TimeConfig>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1InsightsMetricAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsMetricCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsMetricObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricQueryInsightsMetricArgs = {
  filter?: InputMaybe<InsightsV1FilterInput>;
};

export type InsightsV1InsightsMetricQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricInput = {
  dataSource: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  expression: InsightsV1ArithmeticExpressionInput;
  filter?: InputMaybe<InsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<InsightsV1InsightsMetricLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<InsightsV1TimeConfigInput>;
};

export type InsightsV1InsightsMetricLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsMetricLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricResult = Error | InsightsV1InsightsMetric;

export type InsightsV1InsightsTableContext = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  capabilitySummary?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contextMarkdown?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  ddl?: Maybe<Scalars['String']['output']>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  exampleQueries: Array<InsightsV1ExampleQuery>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  labels: Array<InsightsV1InsightsTableContextLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<InsightsV1InsightsContextSource>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1InsightsTableContextAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsTableContextCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsTableContextObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextInput = {
  capabilitySummary?: InputMaybe<Scalars['String']['input']>;
  contextMarkdown?: InputMaybe<Scalars['String']['input']>;
  ddl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exampleQueries?: InputMaybe<Array<InsightsV1ExampleQueryInput>>;
  factTable: Scalars['String']['input'];
  labels?: InputMaybe<Array<InsightsV1InsightsTableContextLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsightsV1InsightsContextSource>;
};

export type InsightsV1InsightsTableContextLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsTableContextLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextResult =
  | Error
  | InsightsV1InsightsTableContext;

export type InsightsV1ListDashboardsResponse = {
  dashboards: Array<InsightsV1Dashboard>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListDashboardsResponseResult =
  | Error
  | InsightsV1ListDashboardsResponse;

export type InsightsV1ListFactTableContextsResponse = {
  factTableContexts: Array<InsightsV1FactTableContext>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListFactTableContextsResponseResult =
  | Error
  | InsightsV1ListFactTableContextsResponse;

export type InsightsV1ListFactTableSummariesResponse = {
  factTableSummaries: Array<InsightsV1FactTableSummary>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListFactTableSummariesResponseResult =
  | Error
  | InsightsV1ListFactTableSummariesResponse;

export type InsightsV1ListInsightsDocumentsResponse = {
  insightsDocuments: Array<InsightsV1InsightsDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListInsightsDocumentsResponseResult =
  | Error
  | InsightsV1ListInsightsDocumentsResponse;

export type InsightsV1ListInsightsTableContextsResponse = {
  insightsTableContexts: Array<InsightsV1InsightsTableContext>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListInsightsTableContextsResponseResult =
  | Error
  | InsightsV1ListInsightsTableContextsResponse;

export type InsightsV1ListSuggestedQuestionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  suggestedQuestions: Array<InsightsV1SuggestedQuestion>;
};

export type InsightsV1ListSuggestedQuestionsResponseResult =
  | Error
  | InsightsV1ListSuggestedQuestionsResponse;

export type InsightsV1MetricValue = {
  dimensions: Array<InsightsV1MetricValueDimensionsEntry>;
  endTime?: Maybe<Scalars['String']['output']>;
  metricValue?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1MetricValueDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum InsightsV1NullValue {
  NullValue = 'NULL_VALUE',
}

export enum InsightsV1Platform {
  PlatformFlutterAndroid = 'PLATFORM_FLUTTER_ANDROID',
  PlatformFlutterIos = 'PLATFORM_FLUTTER_IOS',
  PlatformGo = 'PLATFORM_GO',
  PlatformJava = 'PLATFORM_JAVA',
  PlatformJsServer = 'PLATFORM_JS_SERVER',
  PlatformJsWeb = 'PLATFORM_JS_WEB',
  PlatformKotlin = 'PLATFORM_KOTLIN',
  PlatformPython = 'PLATFORM_PYTHON',
  PlatformRuby = 'PLATFORM_RUBY',
  PlatformRust = 'PLATFORM_RUST',
  PlatformSwift = 'PLATFORM_SWIFT',
}

export type InsightsV1PreviewInsightsMetricResponse = {
  values: Array<InsightsV1MetricValue>;
};

export type InsightsV1PreviewInsightsMetricResponseResult =
  | Error
  | InsightsV1PreviewInsightsMetricResponse;

export type InsightsV1QueryData = {
  result: Array<InsightsV1QueryResult>;
  resultType?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1QueryInsightsMetricResponse = {
  values: Array<InsightsV1MetricValue>;
};

export type InsightsV1QueryInsightsMetricResponseResult =
  | Error
  | InsightsV1QueryInsightsMetricResponse;

export type InsightsV1QueryResponse = {
  data?: Maybe<InsightsV1QueryData>;
  error?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type InsightsV1QueryResponseResult = Error | InsightsV1QueryResponse;

export type InsightsV1QueryResult = {
  metric: Array<InsightsV1QueryResultMetricEntry>;
  sdkResolveMode?: Maybe<InsightsV1SdkResolveMode>;
  values: Array<InsightsV1Sample>;
};

export type InsightsV1QueryResultMetricEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1RangeQueryRequestLabelFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1Sample = {
  timestamp?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1SdkFeatureDefinition = {
  displayName?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  minVersions: Array<InsightsV1SdkMinVersion>;
};

export enum InsightsV1SdkId {
  SdkIdCloudflareResolver = 'SDK_ID_CLOUDFLARE_RESOLVER',
  SdkIdDotnetConfidence = 'SDK_ID_DOTNET_CONFIDENCE',
  SdkIdFlutterAndroidConfidence = 'SDK_ID_FLUTTER_ANDROID_CONFIDENCE',
  SdkIdFlutterIosConfidence = 'SDK_ID_FLUTTER_IOS_CONFIDENCE',
  SdkIdGoConfidence = 'SDK_ID_GO_CONFIDENCE',
  SdkIdGoLocalProvider = 'SDK_ID_GO_LOCAL_PROVIDER',
  SdkIdGoProvider = 'SDK_ID_GO_PROVIDER',
  SdkIdJavaConfidence = 'SDK_ID_JAVA_CONFIDENCE',
  SdkIdJavaLocalProvider = 'SDK_ID_JAVA_LOCAL_PROVIDER',
  SdkIdJavaProvider = 'SDK_ID_JAVA_PROVIDER',
  SdkIdJsConfidence = 'SDK_ID_JS_CONFIDENCE',
  SdkIdJsLocalServerProvider = 'SDK_ID_JS_LOCAL_SERVER_PROVIDER',
  SdkIdJsServerProvider = 'SDK_ID_JS_SERVER_PROVIDER',
  SdkIdJsWebProvider = 'SDK_ID_JS_WEB_PROVIDER',
  SdkIdKotlinConfidence = 'SDK_ID_KOTLIN_CONFIDENCE',
  SdkIdKotlinProvider = 'SDK_ID_KOTLIN_PROVIDER',
  SdkIdPythonConfidence = 'SDK_ID_PYTHON_CONFIDENCE',
  SdkIdPythonLocalProvider = 'SDK_ID_PYTHON_LOCAL_PROVIDER',
  SdkIdPythonProvider = 'SDK_ID_PYTHON_PROVIDER',
  SdkIdRubyProvider = 'SDK_ID_RUBY_PROVIDER',
  SdkIdRustConfidence = 'SDK_ID_RUST_CONFIDENCE',
  SdkIdRustLocalProvider = 'SDK_ID_RUST_LOCAL_PROVIDER',
  SdkIdRustProvider = 'SDK_ID_RUST_PROVIDER',
  SdkIdSwiftConfidence = 'SDK_ID_SWIFT_CONFIDENCE',
  SdkIdSwiftProvider = 'SDK_ID_SWIFT_PROVIDER',
}

export type InsightsV1SdkLatestVersion = {
  latestVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<InsightsV1Platform>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
  sdkId?: Maybe<InsightsV1SdkId>;
};

export type InsightsV1SdkMinVersion = {
  minVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<InsightsV1Platform>;
  sdkId?: Maybe<InsightsV1SdkId>;
};

export enum InsightsV1SdkResolveMode {
  SdkResolveModeCached = 'SDK_RESOLVE_MODE_CACHED',
  SdkResolveModeLocal = 'SDK_RESOLVE_MODE_LOCAL',
  SdkResolveModeRemote = 'SDK_RESOLVE_MODE_REMOTE',
}

export type InsightsV1SearchFactTableSummariesResponse = {
  factTableSummaries: Array<InsightsV1FactTableSummary>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1SearchFactTableSummariesResponseResult =
  | Error
  | InsightsV1SearchFactTableSummariesResponse;

export enum InsightsV1Statistic {
  StatisticAbTestsWithHypotheses = 'STATISTIC_AB_TESTS_WITH_HYPOTHESES',
  StatisticActiveUsers = 'STATISTIC_ACTIVE_USERS',
  StatisticApprovedReviews = 'STATISTIC_APPROVED_REVIEWS',
  StatisticApprovedReviewsPerUser = 'STATISTIC_APPROVED_REVIEWS_PER_USER',
  StatisticApprovedReviewsPerUserPosition = 'STATISTIC_APPROVED_REVIEWS_PER_USER_POSITION',
  StatisticAutomaticRolloutsUsed = 'STATISTIC_AUTOMATIC_ROLLOUTS_USED',
  StatisticCreatedExploratoryAnalyses = 'STATISTIC_CREATED_EXPLORATORY_ANALYSES',
  StatisticCreatedFlags = 'STATISTIC_CREATED_FLAGS',
  StatisticCreatedMetrics = 'STATISTIC_CREATED_METRICS',
  StatisticFlagsCreatedPerUser = 'STATISTIC_FLAGS_CREATED_PER_USER',
  StatisticFlagsCreatedPerUserPosition = 'STATISTIC_FLAGS_CREATED_PER_USER_POSITION',
  StatisticLaunchedAbTests = 'STATISTIC_LAUNCHED_AB_TESTS',
  StatisticLaunchedAbTestsPerUser = 'STATISTIC_LAUNCHED_AB_TESTS_PER_USER',
  StatisticLaunchedAbTestsPerUserPosition = 'STATISTIC_LAUNCHED_AB_TESTS_PER_USER_POSITION',
  StatisticLaunchedRollouts = 'STATISTIC_LAUNCHED_ROLLOUTS',
  StatisticReviewsCreated = 'STATISTIC_REVIEWS_CREATED',
  StatisticRolledBack = 'STATISTIC_ROLLED_BACK',
  StatisticRolledBackPerUser = 'STATISTIC_ROLLED_BACK_PER_USER',
  StatisticRolledBackPerUserPosition = 'STATISTIC_ROLLED_BACK_PER_USER_POSITION',
  StatisticRolledForward = 'STATISTIC_ROLLED_FORWARD',
  StatisticRolledForwardPerUser = 'STATISTIC_ROLLED_FORWARD_PER_USER',
  StatisticRolledForwardPerUserPosition = 'STATISTIC_ROLLED_FORWARD_PER_USER_POSITION',
  StatisticSampleSizeCalculationsUsed = 'STATISTIC_SAMPLE_SIZE_CALCULATIONS_USED',
  StatisticSurfacesUsed = 'STATISTIC_SURFACES_USED',
}

export type InsightsV1SuggestedQuestion = {
  factTable: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type InsightsV1SyncInsightsTableContextsResponse = {
  created?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  totalFactTables?: Maybe<Scalars['Int']['output']>;
};

export type InsightsV1SyncInsightsTableContextsResponseResult =
  | Error
  | InsightsV1SyncInsightsTableContextsResponse;

export type InsightsV1TimeAggregationConfig = {
  allCombinations?: Maybe<Scalars['Boolean']['output']>;
  maxLength?: Maybe<Scalars['String']['output']>;
  truncation: InsightsV1Truncation;
  until?: Maybe<InsightsV1TimeSeriesEnd>;
  window?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1TimeAggregationConfigInput = {
  allCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  truncation: InsightsV1Truncation;
  until?: InputMaybe<InsightsV1TimeSeriesEnd>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1TimeConfig = {
  disableDeleteTimeFilter?: Maybe<Scalars['Boolean']['output']>;
  endTimeColumn?: Maybe<Scalars['String']['output']>;
  timeAggregation?: Maybe<InsightsV1TimeAggregationConfig>;
  timeColumn: Scalars['String']['output'];
};

export type InsightsV1TimeConfigInput = {
  disableDeleteTimeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeColumn?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeAggregation?: InputMaybe<InsightsV1TimeAggregationConfigInput>;
  timeColumn: Scalars['String']['input'];
};

export enum InsightsV1TimeSeriesEnd {
  CurrentDate = 'CURRENT_DATE',
  LastDate = 'LAST_DATE',
}

export enum InsightsV1Truncation {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
}

export type InsightsV1Value = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  dateValue?: Maybe<Scalars['String']['output']>;
  decimalValue?: Maybe<GoogleTypeDecimal>;
  intValue?: Maybe<Scalars['Long']['output']>;
  nullValue?: Maybe<InsightsV1NullValue>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  decimalValue?: InputMaybe<GoogleTypeDecimalInput>;
  intValue?: InputMaybe<Scalars['Long']['input']>;
  nullValue?: InputMaybe<InsightsV1NullValue>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1Wrapped = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  stats: Array<InsightsV1WrappedStatistic>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type InsightsV1WrappedAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1WrappedCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1WrappedObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedResult = Error | InsightsV1Wrapped;

export type InsightsV1WrappedStatistic = {
  statistic?: Maybe<InsightsV1Statistic>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IoCloudeventsV1CloudEvent = {
  attributes: Array<IoCloudeventsV1CloudEventAttributesEntry>;
  binaryData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  protoData?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  specVersion?: Maybe<Scalars['String']['output']>;
  textData?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IoCloudeventsV1CloudEventAttributesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<IoCloudeventsV1CloudEventCloudEventAttributeValue>;
};

export type IoCloudeventsV1CloudEventCloudEventAttributeValue = {
  ceBoolean?: Maybe<Scalars['Boolean']['output']>;
  ceBytes?: Maybe<Scalars['String']['output']>;
  ceInteger?: Maybe<Scalars['Int']['output']>;
  ceString?: Maybe<Scalars['String']['output']>;
  ceTimestamp?: Maybe<Scalars['String']['output']>;
  ceUri?: Maybe<Scalars['String']['output']>;
  ceUriRef?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1BloomFilterDetails = {
  falsePositiveRate: Scalars['Float']['output'];
  keyCount: Scalars['Long']['output'];
  sizeBytes: Scalars['Long']['output'];
};

export type MaterializerV1BloomFilterDetailsInput = {
  falsePositiveRate: Scalars['Float']['input'];
  keyCount: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sizeBytes: Scalars['Long']['input'];
};

export type MaterializerV1BloomFilterStatus = {
  bloomFilterEndTime?: Maybe<Scalars['String']['output']>;
  bloomFilterStartTime?: Maybe<Scalars['String']['output']>;
  details?: Maybe<MaterializerV1BloomFilterDetails>;
  ingestionRate?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<MaterializerV1GcsFile>;
  progress: Scalars['Float']['output'];
  state: MaterializerV1BloomFilterStatusState;
};

export type MaterializerV1BloomFilterStatusInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum MaterializerV1BloomFilterStatusState {
  Building = 'BUILDING',
  Cancelled = 'CANCELLED',
  Done = 'DONE',
}

export enum MaterializerV1ColumnType {
  ColumnTypeInt32 = 'COLUMN_TYPE_INT32',
  ColumnTypeInt64 = 'COLUMN_TYPE_INT64',
  ColumnTypeString = 'COLUMN_TYPE_STRING',
}

export type MaterializerV1EventsMaterializedSegmentLoadJobCancelled = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobCompleted = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobCreated = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobFailed = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobUpdated = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsScheduledMaterializedSegmentLoadJobCreated = {
  schedule?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsScheduledMaterializedSegmentLoadJobUpdated = {
  schedule?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJob>;
};

export type MaterializerV1GcsFile = {
  bucket: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type MaterializerV1GcsFileInput = {
  bucket: Scalars['String']['input'];
  path: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1IngestionStatus = {
  ingestionEndTime?: Maybe<Scalars['String']['output']>;
  ingestionRate?: Maybe<Scalars['Float']['output']>;
  ingestionStartTime: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  state?: Maybe<MaterializerV1IngestionStatusState>;
};

export type MaterializerV1IngestionStatusInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum MaterializerV1IngestionStatusState {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Ingesting = 'INGESTING',
}

export type MaterializerV1ListMaterializedSegmentLoadJobsResponse = {
  materializedSegmentLoadJobs: Array<MaterializerV1MaterializedSegmentLoadJob>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1ListMaterializedSegmentLoadJobsResponseResult =
  | Error
  | MaterializerV1ListMaterializedSegmentLoadJobsResponse;

export type MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledMaterializedSegmentLoadJobs: Array<MaterializerV1ScheduledMaterializedSegmentLoadJob>;
};

export type MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponseResult =
  Error | MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse;

export type MaterializerV1MaterializedSegmentLoadJob = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bloomFilterStatus?: Maybe<MaterializerV1BloomFilterStatus>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entityIdColumn: Scalars['String']['output'];
  entityIdColumnType?: Maybe<MaterializerV1ColumnType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportEndTime?: Maybe<Scalars['String']['output']>;
  exportStartTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  ingestionStatus?: Maybe<MaterializerV1IngestionStatus>;
  labels: Array<MaterializerV1MaterializedSegmentLoadJobLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  parent: FlagsAdminV1MaterializedSegmentResult;
  progress: Scalars['Float']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  rowCount?: Maybe<Scalars['Long']['output']>;
  schedule?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  scheduleIteration?: Maybe<Scalars['Int']['output']>;
  sql: Scalars['String']['output'];
  state?: Maybe<MaterializerV1MaterializedSegmentLoadJobJobState>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MaterializerV1MaterializedSegmentLoadJobAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MaterializerV1MaterializedSegmentLoadJobCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MaterializerV1MaterializedSegmentLoadJobObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MaterializerV1MaterializedSegmentLoadJobReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobInput = {
  entityIdColumn: Scalars['String']['input'];
  entityIdColumnType?: InputMaybe<MaterializerV1ColumnType>;
  labels?: InputMaybe<
    Array<MaterializerV1MaterializedSegmentLoadJobLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
};

export enum MaterializerV1MaterializedSegmentLoadJobJobState {
  JobStateCancelled = 'JOB_STATE_CANCELLED',
  JobStateCompleted = 'JOB_STATE_COMPLETED',
  JobStateFailed = 'JOB_STATE_FAILED',
  JobStatePending = 'JOB_STATE_PENDING',
  JobStateRunning = 'JOB_STATE_RUNNING',
}

export type MaterializerV1MaterializedSegmentLoadJobLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1MaterializedSegmentLoadJobLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobResult =
  | Error
  | MaterializerV1MaterializedSegmentLoadJob;

export type MaterializerV1ScheduledMaterializedSegmentLoadJob = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  attempt?: Maybe<Scalars['Int']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entityIdColumn: Scalars['String']['output'];
  entityIdColumnType?: Maybe<MaterializerV1ColumnType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executedLoadJobsCount?: Maybe<Scalars['Int']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntry>;
  latestLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  name: Scalars['String']['output'];
  nextScheduledRunTime?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  parent: FlagsAdminV1MaterializedSegmentResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  sql: Scalars['String']['output'];
  state?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobState>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobExternalDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1ExternalDocumentView>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobObservationsArgs =
  {
    filter?: InputMaybe<Scalars['String']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobInput = {
  entityIdColumn: Scalars['String']['input'];
  entityIdColumnType?: InputMaybe<MaterializerV1ColumnType>;
  labels?: InputMaybe<
    Array<MaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals: Array<Scalars['String']['input']>;
  scheduleStartTime: Scalars['String']['input'];
  sql: Scalars['String']['input'];
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type MaterializerV1ScheduledMaterializedSegmentLoadJobResult =
  | Error
  | MaterializerV1ScheduledMaterializedSegmentLoadJob;

export enum MaterializerV1ScheduledMaterializedSegmentLoadJobState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paused = 'PAUSED',
}

export type MetaAnalysisData = {
  error?: Maybe<Scalars['String']['output']>;
  experiments?: Maybe<Array<MetaAnalysisDataExperimentEntry>>;
  metrics?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MetaAnalysisDataExperimentEntry = {
  analysisResult?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exposureTable?: Maybe<Scalars['String']['output']>;
  instanceName: Scalars['String']['output'];
  metricCalculations?: Maybe<
    Array<MetaAnalysisDataExperimentEntryMetricCalculationEntry>
  >;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<MetaAnalysisDataExperimentEntryTreatmentEntry>>;
};

export type MetaAnalysisDataExperimentEntryMetricCalculationEntry = {
  calculation?: Maybe<Scalars['String']['output']>;
  metricName: Scalars['String']['output'];
  state?: Maybe<MetaAnalysisDataExperimentEntryMetricCalculationEntryState>;
};

export enum MetaAnalysisDataExperimentEntryMetricCalculationEntryState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type MetaAnalysisDataExperimentEntryTreatmentEntry = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type MetaAnalysisDataInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  experiments?: InputMaybe<Array<MetaAnalysisDataInputExperimentEntryInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAnalysisDataInputExperimentEntryInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  instanceName: Scalars['String']['input'];
  metricCalculations?: InputMaybe<
    Array<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<MetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput>
  >;
};

export type MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput =
  {
    calculation?: InputMaybe<Scalars['String']['input']>;
    metricName: Scalars['String']['input'];
    state?: InputMaybe<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState>;
  };

export enum MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type MetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type MetricRoleOneOfInput = {
  guardrailMetric?: InputMaybe<MetricsDataInputMetricInputGuardrailMetricInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  successMetric?: InputMaybe<MetricsDataInputMetricInputSuccessMetricInput>;
};

export type MetricsData = {
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  assignmentTableSource?: Maybe<MetricsDataAssignmentTableSource>;
  bucket?: Maybe<MetricsDataBucket>;
  entity?: Maybe<MetricsV1EntityResult>;
  entityFilters?: Maybe<Array<MetricsDataEntityFilter>>;
  entitySource?: Maybe<MetricsDataEntitySource>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureFilter?: Maybe<MetricsDataExposureFilter>;
  exposureMetric?: Maybe<MetricsV1MetricResult>;
  exposureMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  exposureMetricSchedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  exposureTableSchedule?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  filters?: Maybe<Array<MetricsDataExposureFilter>>;
  metrics: Array<MetricsDataMetric>;
};

export enum MetricsDataAssignmentTableSource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export enum MetricsDataBucket {
  BucketingTemporalUnitUnspecified = 'BUCKETING_TEMPORAL_UNIT_UNSPECIFIED',
  Days = 'DAYS',
  Hours = 'HOURS',
}

export type MetricsDataEntityFilter = {
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  filter?: Maybe<MetricsDataEntityFilterFilter>;
};

export type MetricsDataEntityFilterFilter = {
  criteria: Scalars['JSON']['output'];
  expression: Scalars['JSON']['output'];
};

export enum MetricsDataEntitySource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export type MetricsDataExposureFilter = {
  displayName?: Maybe<Scalars['String']['output']>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  filter?: Maybe<MetricsDataExposureFilterFilter>;
};

export type MetricsDataExposureFilterFilter = {
  criteria: Scalars['JSON']['output'];
  expression: Scalars['JSON']['output'];
};

export type MetricsDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  assignmentTableSource?: InputMaybe<MetricsDataInputAssignmentTableSource>;
  bucket?: InputMaybe<MetricsDataInputBucket>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityFilters?: InputMaybe<Array<MetricsDataInputEntityFilterInput>>;
  entitySource?: InputMaybe<MetricsDataInputEntitySource>;
  exposureCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<MetricsDataInputExposureFilterInput>;
  exposureMetric?: InputMaybe<Scalars['String']['input']>;
  exposureMetricCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureMetricSchedule?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<MetricsDataInputExposureFilterInput>>;
  metrics: Array<MetricsDataInputMetricInput>;
};

export enum MetricsDataInputAssignmentTableSource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export enum MetricsDataInputBucket {
  BucketingTemporalUnitUnspecified = 'BUCKETING_TEMPORAL_UNIT_UNSPECIFIED',
  Days = 'DAYS',
  Hours = 'HOURS',
}

export type MetricsDataInputEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsDataInputEntityFilterInputFilterInput>;
};

export type MetricsDataInputEntityFilterInputFilterInput = {
  criteria: Scalars['JSON']['input'];
  expression: Scalars['JSON']['input'];
};

export enum MetricsDataInputEntitySource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export type MetricsDataInputExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsDataInputExposureFilterInputFilterInput>;
};

export type MetricsDataInputExposureFilterInputFilterInput = {
  criteria: Scalars['JSON']['input'];
  expression: Scalars['JSON']['input'];
};

export type MetricsDataInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  metricRole: MetricRoleOneOfInput;
  preferredDirection?: InputMaybe<MetricsDataInputMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsDataInputMetricInputGuardrailMetricInput = {
  metricKind: MetricsDataInputMetricInputGuardrailMetricInputMetricKind;
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export enum MetricsDataInputMetricInputGuardrailMetricInputMetricKind {
  Guardrail = 'GUARDRAIL',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export enum MetricsDataInputMetricInputPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsDataInputMetricInputSuccessMetricInput = {
  metricKind: MetricsDataInputMetricInputSuccessMetricInputMetricKind;
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export enum MetricsDataInputMetricInputSuccessMetricInputMetricKind {
  Guardrail = 'GUARDRAIL',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsDataMetric = {
  calculation?: Maybe<MetricsV1MetricCalculationResult>;
  metric: MetricsV1MetricResult;
  metricRole: MetricsDataMetricMetricRoleUnion;
  preferredDirection?: Maybe<MetricsDataMetricPreferredDirection>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
  surfaceOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsDataMetricGuardrailMetric = {
  metricKind: MetricsDataMetricGuardrailMetricMetricKind;
  nonInferiorityMargin?: Maybe<Scalars['Float']['output']>;
};

export enum MetricsDataMetricGuardrailMetricMetricKind {
  Guardrail = 'GUARDRAIL',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsDataMetricMetricRoleUnion =
  | MetricsDataMetricGuardrailMetric
  | MetricsDataMetricSuccessMetric;

export enum MetricsDataMetricPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsDataMetricSuccessMetric = {
  metricKind: MetricsDataMetricSuccessMetricMetricKind;
  minimumDetectableEffect?: Maybe<Scalars['Float']['output']>;
};

export enum MetricsDataMetricSuccessMetricMetricKind {
  Guardrail = 'GUARDRAIL',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsV1Aggregation = {
  cap?: Maybe<MetricsV1ValueCap>;
  threshold?: Maybe<MetricsV1AggregationThreshold>;
  type: MetricsV1AggregationType;
};

export type MetricsV1AggregationInput = {
  cap?: InputMaybe<MetricsV1ValueCapInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<MetricsV1AggregationThresholdInput>;
  type: MetricsV1AggregationType;
};

export type MetricsV1AggregationThreshold = {
  direction: MetricsV1AggregationThresholdDirection;
  threshold: GoogleTypeDecimal;
};

export enum MetricsV1AggregationThresholdDirection {
  AggregationThresholdDirectionEq = 'AGGREGATION_THRESHOLD_DIRECTION_EQ',
  AggregationThresholdDirectionGt = 'AGGREGATION_THRESHOLD_DIRECTION_GT',
  AggregationThresholdDirectionGte = 'AGGREGATION_THRESHOLD_DIRECTION_GTE',
  AggregationThresholdDirectionLt = 'AGGREGATION_THRESHOLD_DIRECTION_LT',
  AggregationThresholdDirectionLte = 'AGGREGATION_THRESHOLD_DIRECTION_LTE',
}

export type MetricsV1AggregationThresholdInput = {
  direction: MetricsV1AggregationThresholdDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold: GoogleTypeDecimalInput;
};

export enum MetricsV1AggregationType {
  AggregationTypeApproxCountDistinct = 'AGGREGATION_TYPE_APPROX_COUNT_DISTINCT',
  AggregationTypeAvg = 'AGGREGATION_TYPE_AVG',
  AggregationTypeCount = 'AGGREGATION_TYPE_COUNT',
  AggregationTypeCountDistinct = 'AGGREGATION_TYPE_COUNT_DISTINCT',
  AggregationTypeMax = 'AGGREGATION_TYPE_MAX',
  AggregationTypeMin = 'AGGREGATION_TYPE_MIN',
  AggregationTypeSum = 'AGGREGATION_TYPE_SUM',
}

export type MetricsV1ApplyMetricsSyncRequestSyncResourceInput = {
  factTable?: InputMaybe<MetricsV1FactTableInput>;
  measurement?: InputMaybe<MetricsV1MeasurementInput>;
  metric?: InputMaybe<MetricsV1MetricInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ApplyMetricsSyncResponse = {
  archived: Array<MetricsV1ApplyMetricsSyncResponseResourceOutcome>;
  outcomes: Array<MetricsV1ApplyMetricsSyncResponseResourceOutcome>;
};

export type MetricsV1ApplyMetricsSyncResponseResourceOutcome = {
  action?: Maybe<MetricsV1ApplyMetricsSyncResponseResourceOutcomeAction>;
  changedFields: Array<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previousReference?: Maybe<Scalars['String']['output']>;
};

export enum MetricsV1ApplyMetricsSyncResponseResourceOutcomeAction {
  Adopt = 'ADOPT',
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Error = 'ERROR',
  Unchanged = 'UNCHANGED',
  Update = 'UPDATE',
}

export type MetricsV1ApplyMetricsSyncResponseResult =
  | Error
  | MetricsV1ApplyMetricsSyncResponse;

export type MetricsV1AssignmentData = {
  endTime: Scalars['String']['output'];
  exposureKey: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  variants: Array<Scalars['String']['output']>;
};

export type MetricsV1AssignmentTable = {
  assignmentDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entityColumn: MetricsV1Column;
  error?: Maybe<MetricsV1OperationError>;
  exposureKeyColumn: MetricsV1Column;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1AssignmentTableLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timestampColumn: MetricsV1Column;
  timestampTruncation?: Maybe<MetricsV1TimeTruncation>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  variantKeyColumn: MetricsV1Column;
};

export type MetricsV1AssignmentTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1AssignmentTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1AssignmentTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableInput = {
  assignmentDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entityColumn: MetricsV1ColumnInput;
  exposureKeyColumn: MetricsV1ColumnInput;
  labels?: InputMaybe<Array<MetricsV1AssignmentTableLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  timestampColumn: MetricsV1ColumnInput;
  timestampTruncation?: InputMaybe<MetricsV1TimeTruncationInput>;
  variantKeyColumn: MetricsV1ColumnInput;
};

export type MetricsV1AssignmentTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1AssignmentTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableResult = Error | MetricsV1AssignmentTable;

export enum MetricsV1AwsRegion {
  AfSouth_1 = 'AF_SOUTH_1',
  ApEast_1 = 'AP_EAST_1',
  ApNortheast_1 = 'AP_NORTHEAST_1',
  ApNortheast_2 = 'AP_NORTHEAST_2',
  ApNortheast_3 = 'AP_NORTHEAST_3',
  ApSoutheast_1 = 'AP_SOUTHEAST_1',
  ApSoutheast_2 = 'AP_SOUTHEAST_2',
  ApSoutheast_3 = 'AP_SOUTHEAST_3',
  ApSoutheast_4 = 'AP_SOUTHEAST_4',
  ApSouth_1 = 'AP_SOUTH_1',
  ApSouth_2 = 'AP_SOUTH_2',
  CaCentral_1 = 'CA_CENTRAL_1',
  CnNorthwest_1 = 'CN_NORTHWEST_1',
  CnNorth_1 = 'CN_NORTH_1',
  EuCentral_1 = 'EU_CENTRAL_1',
  EuCentral_2 = 'EU_CENTRAL_2',
  EuNorth_1 = 'EU_NORTH_1',
  EuSouth_1 = 'EU_SOUTH_1',
  EuSouth_2 = 'EU_SOUTH_2',
  EuWest_1 = 'EU_WEST_1',
  EuWest_2 = 'EU_WEST_2',
  EuWest_3 = 'EU_WEST_3',
  IlCentral_1 = 'IL_CENTRAL_1',
  MeCentral_1 = 'ME_CENTRAL_1',
  MeSouth_1 = 'ME_SOUTH_1',
  SaEast_1 = 'SA_EAST_1',
  UsEast_1 = 'US_EAST_1',
  UsEast_2 = 'US_EAST_2',
  UsGovEast_1 = 'US_GOV_EAST_1',
  UsGovWest_1 = 'US_GOV_WEST_1',
  UsIsoEast_1 = 'US_ISO_EAST_1',
  UsIsoWest_1 = 'US_ISO_WEST_1',
  UsWest_1 = 'US_WEST_1',
  UsWest_2 = 'US_WEST_2',
}

export type MetricsV1BigQueryConfig = {
  bigQueryLocation?: Maybe<Scalars['String']['output']>;
  dataset?: Maybe<Scalars['String']['output']>;
  exportJobsServiceAccount?: Maybe<Scalars['String']['output']>;
  gcpProjectId?: Maybe<Scalars['String']['output']>;
  interactiveProjectId?: Maybe<Scalars['String']['output']>;
  processingProjectId?: Maybe<Scalars['String']['output']>;
  serviceAccount?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1BigQueryConfigInput = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  exportJobsServiceAccount?: InputMaybe<Scalars['String']['input']>;
  gcpProjectId?: InputMaybe<Scalars['String']['input']>;
  interactiveProjectId?: InputMaybe<Scalars['String']['input']>;
  processingProjectId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1BigQueryJobStats = {
  billingTier?: Maybe<Scalars['Int']['output']>;
  cacheHit: Scalars['Boolean']['output'];
  createTime: Scalars['String']['output'];
  dmlAffectedRowsCount?: Maybe<Scalars['Long']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  estimatedBytesProcessed?: Maybe<Scalars['Long']['output']>;
  referencedTables: Array<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  statementType: Scalars['String']['output'];
  totalBytesBilled?: Maybe<Scalars['Long']['output']>;
  totalBytesProcessed?: Maybe<Scalars['Long']['output']>;
  totalPartitionsProcessed?: Maybe<Scalars['Long']['output']>;
  totalSlotMs?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1Column = {
  name: Scalars['String']['output'];
  repeated?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<MetricsV1ColumnType>;
};

export type MetricsV1ColumnInput = {
  name: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repeated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ColumnIssue = {
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum MetricsV1ColumnType {
  ColumnTypeBoolean = 'COLUMN_TYPE_BOOLEAN',
  ColumnTypeBytes = 'COLUMN_TYPE_BYTES',
  ColumnTypeDate = 'COLUMN_TYPE_DATE',
  ColumnTypeDecimal = 'COLUMN_TYPE_DECIMAL',
  ColumnTypeDouble = 'COLUMN_TYPE_DOUBLE',
  ColumnTypeHllSketch = 'COLUMN_TYPE_HLL_SKETCH',
  ColumnTypeInt32 = 'COLUMN_TYPE_INT32',
  ColumnTypeInt64 = 'COLUMN_TYPE_INT64',
  ColumnTypeString = 'COLUMN_TYPE_STRING',
  ColumnTypeTimestamp = 'COLUMN_TYPE_TIMESTAMP',
  ColumnTypeTimestampWithoutTimezone = 'COLUMN_TYPE_TIMESTAMP_WITHOUT_TIMEZONE',
}

export type MetricsV1ContiguousPartition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  endTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  startTime: Scalars['String']['output'];
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type MetricsV1ContiguousPartitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ContiguousPartitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ContiguousPartitionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionResult =
  | Error
  | MetricsV1ContiguousPartition;

export type MetricsV1DataDeliveredUntilUpdateStrategyConfig = {
  automaticUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig>;
  dailyUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig>;
  disableEmptyPartitions?: Maybe<Scalars['Boolean']['output']>;
  hourlyUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig>;
  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
};

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig =
  {
    changeThreshold?: Maybe<GoogleTypeDecimal>;
    commitDelay: Scalars['String']['output'];
    /** @deprecated No longer supported */
    incrementDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput =
  {
    changeThreshold?: InputMaybe<GoogleTypeDecimalInput>;
    commitDelay: Scalars['String']['input'];
    incrementDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig =
  {
    maxZeroDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig =
  {
    maxZeroDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigInput = {
  automaticUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput>;
  dailyUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput>;
  disableEmptyPartitions?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
};

export enum MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

export type MetricsV1DataWarehouse = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  config: MetricsV1DataWarehouseConfig;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<MetricsV1DataWarehouseLabelsEntry>;
  limits?: Maybe<MetricsV1DataWarehouseDataWarehouseLimits>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1DataWarehouseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DataWarehouseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DataWarehouseObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseConfig = {
  bigQueryConfig?: Maybe<MetricsV1BigQueryConfig>;
  dataBricksConfig?: Maybe<MetricsV1DatabricksConfig>;
  redshiftConfig?: Maybe<MetricsV1RedshiftConfig>;
  snowflakeConfig?: Maybe<MetricsV1SnowflakeConfig>;
};

export type MetricsV1DataWarehouseConfigInput = {
  bigQueryConfig?: InputMaybe<MetricsV1BigQueryConfigInput>;
  dataBricksConfig?: InputMaybe<MetricsV1DatabricksConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<MetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<MetricsV1SnowflakeConfigInput>;
};

export type MetricsV1DataWarehouseDataWarehouseLimits = {
  maxConcurrentInteractiveQueries?: Maybe<Scalars['Long']['output']>;
  maxConcurrentQueries?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1DataWarehouseDataWarehouseLimitsInput = {
  maxConcurrentInteractiveQueries?: InputMaybe<Scalars['Long']['input']>;
  maxConcurrentQueries?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseInput = {
  config: MetricsV1DataWarehouseConfigInput;
  labels?: InputMaybe<Array<MetricsV1DataWarehouseLabelsEntryInput>>;
  limits?: InputMaybe<MetricsV1DataWarehouseDataWarehouseLimitsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DataWarehouseLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseResult = Error | MetricsV1DataWarehouse;

export type MetricsV1DataWarehouseStatsEntry = {
  bqStats?: Maybe<MetricsV1DataWarehouseStatsEntryBqStats>;
  entryTime: Scalars['String']['output'];
  failedQueryCount: Scalars['Long']['output'];
  totalQueryCount: Scalars['Long']['output'];
};

export type MetricsV1DataWarehouseStatsEntryBqStats = {
  totalBytesBilled: Scalars['Long']['output'];
  totalBytesProcessed: Scalars['Long']['output'];
  totalSlotMs: Scalars['Long']['output'];
};

export type MetricsV1DatabricksConfig = {
  clientId?: Maybe<Scalars['String']['output']>;
  exposureSchema?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  resultsSchema?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DatabricksConfigInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultsSchema?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1Dependency = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  dataStatus: Array<MetricsV1DependencyDataStatus>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  parent?: Maybe<MetricsV1DependencyResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  table: MetricsV1DependencyTableScheduleReference;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type MetricsV1DependencyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DependencyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DependencyObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyAssignmentReference = {
  assignmentTable: MetricsV1AssignmentTableResult;
};

export type MetricsV1DependencyDataStatus = {
  endTime: Scalars['String']['output'];
  fulfilled?: Maybe<Scalars['Boolean']['output']>;
  startTime: Scalars['String']['output'];
};

export type MetricsV1DependencyDimensionReference = {
  dimensionTable: MetricsV1DimensionTableResult;
};

export type MetricsV1DependencyEntityRelationReference = {
  entityRelationTable: MetricsV1EntityRelationTableResult;
};

export type MetricsV1DependencyExposureReference = {
  exposureTable: MetricsV1ExposureTableResult;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
};

export type MetricsV1DependencyFactReference = {
  factTable: MetricsV1FactTableResult;
};

export type MetricsV1DependencyMeasurementReference = {
  measurementTable: MetricsV1MeasurementTableResult;
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculationResult;
};

export type MetricsV1DependencyResult = Error | MetricsV1Dependency;

export type MetricsV1DependencyTableScheduleReference = {
  assignments?: Maybe<MetricsV1DependencyAssignmentReference>;
  dimensions?: Maybe<MetricsV1DependencyDimensionReference>;
  entityRelation?: Maybe<MetricsV1DependencyEntityRelationReference>;
  exposures?: Maybe<MetricsV1DependencyExposureReference>;
  facts?: Maybe<MetricsV1DependencyFactReference>;
  measurements?: Maybe<MetricsV1DependencyMeasurementReference>;
};

export type MetricsV1DescribeAssignmentTableResponse = {
  assignmentsData: Array<MetricsV1AssignmentData>;
  name: MetricsV1AssignmentTableResult;
};

export type MetricsV1DescribeAssignmentTableResponseResult =
  | Error
  | MetricsV1DescribeAssignmentTableResponse;

export type MetricsV1DimensionFilterInput = {
  allowedValues: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entityColumnMapping: MetricsV1EntityColumnMapping;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1DimensionTableLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timeConfig?: Maybe<MetricsV1DimensionTableTimeConfig>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  valueMappings: Array<MetricsV1DimensionTableDimensionValueMapping>;
};

export type MetricsV1DimensionTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DimensionTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DimensionTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableDimensionValueMapping = {
  column: Scalars['String']['output'];
  mappings: Array<MetricsV1DimensionTableValueMapping>;
};

export type MetricsV1DimensionTableDimensionValueMappingInput = {
  column: Scalars['String']['input'];
  mappings: Array<MetricsV1DimensionTableValueMappingInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<MetricsV1ColumnInput>;
  displayName: Scalars['String']['input'];
  entityColumnMapping: MetricsV1EntityColumnMappingInput;
  labels?: InputMaybe<Array<MetricsV1DimensionTableLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  timeConfig?: InputMaybe<MetricsV1DimensionTableTimeConfigInput>;
  valueMappings?: InputMaybe<
    Array<MetricsV1DimensionTableDimensionValueMappingInput>
  >;
};

export type MetricsV1DimensionTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableResult = Error | MetricsV1DimensionTable;

export type MetricsV1DimensionTableTimeConfig = {
  timestampColumn: MetricsV1Column;
  window: Scalars['String']['output'];
};

export type MetricsV1DimensionTableTimeConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestampColumn: MetricsV1ColumnInput;
  window: Scalars['String']['input'];
};

export type MetricsV1DimensionTableValueMapping = {
  inputDimensionValue?: Maybe<Scalars['String']['output']>;
  outputDimensionValue?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionTableValueMappingInput = {
  inputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  outputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionValue = {
  dimension?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1Entity = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  defaultAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  displayName: Scalars['String']['output'];
  entityIdentityBindings?: Maybe<MetricsV1ListEntityIdentityBindingsResponseResult>;
  entityRelationTables?: Maybe<MetricsV1ListEntityRelationTablesResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1EntityLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  primaryKeyType: MetricsV1ColumnType;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1EntityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityEntityIdentityBindingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityEntityRelationTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityColumn = {
  column: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
};

export type MetricsV1EntityColumnMapping = {
  column: MetricsV1Column;
  entity: MetricsV1EntityResult;
};

export type MetricsV1EntityColumnMappingInput = {
  column: MetricsV1ColumnInput;
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBinding = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entity?: Maybe<MetricsV1EntityResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<MetricsV1EntityIdentityBindingLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  value: Scalars['String']['output'];
};

export type MetricsV1EntityIdentityBindingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityIdentityBindingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityIdentityBindingObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingInput = {
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<MetricsV1EntityIdentityBindingLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type MetricsV1EntityIdentityBindingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityIdentityBindingLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingResult =
  | Error
  | MetricsV1EntityIdentityBinding;

export type MetricsV1EntityInput = {
  defaultAssignmentTable?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<MetricsV1EntityLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryKeyType: MetricsV1ColumnType;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1EntityRelationTableLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  parentEntityIdColumn: MetricsV1Column;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  targetEntity: MetricsV1EntityResult;
  targetEntityIdColumn: MetricsV1Column;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1EntityRelationTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityRelationTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityRelationTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1EntityRelationTableLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  parentEntityIdColumn: MetricsV1ColumnInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  targetEntity: Scalars['String']['input'];
  targetEntityIdColumn: MetricsV1ColumnInput;
};

export type MetricsV1EntityRelationTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityRelationTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableResult =
  | Error
  | MetricsV1EntityRelationTable;

export type MetricsV1EntityResult = Error | MetricsV1Entity;

export type MetricsV1EntitySamplingConfig = {
  hashSeed?: Maybe<Scalars['String']['output']>;
  sampleRate: Scalars['Float']['output'];
};

export type MetricsV1EntitySamplingConfigInput = {
  hashSeed?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleRate: Scalars['Float']['input'];
};

export type MetricsV1EventsAssignmentTableCreated = {
  assignmentTable: MetricsV1AssignmentTable;
};

export type MetricsV1EventsAssignmentTableUpdated = {
  assignmentTable: MetricsV1AssignmentTable;
};

export type MetricsV1EventsDataWarehouseCreated = {
  dataWarehouse: MetricsV1DataWarehouse;
};

export type MetricsV1EventsDataWarehouseUpdated = {
  dataWarehouse: MetricsV1DataWarehouse;
};

export type MetricsV1EventsDimensionTableCreated = {
  dimensionTable: MetricsV1DimensionTable;
};

export type MetricsV1EventsDimensionTableUpdated = {
  dimensionTable: MetricsV1DimensionTable;
};

export type MetricsV1EventsEntityCreated = {
  entity: MetricsV1Entity;
};

export type MetricsV1EventsEntityDeleted = {
  entity: Scalars['String']['output'];
};

export type MetricsV1EventsEntityIdentityBindingCreated = {
  entityIdentityBinding: MetricsV1EntityIdentityBinding;
};

export type MetricsV1EventsEntityIdentityBindingDeleted = {
  entityIdentityBinding: Scalars['String']['output'];
};

export type MetricsV1EventsEntityIdentityBindingUpdated = {
  entityIdentityBinding: MetricsV1EntityIdentityBinding;
};

export type MetricsV1EventsEntityRelationTableCreated = {
  entityRelationTable: MetricsV1EntityRelationTable;
};

export type MetricsV1EventsEntityRelationTableDeleted = {
  entityRelationTable: Scalars['String']['output'];
};

export type MetricsV1EventsEntityRelationTableUpdated = {
  entityRelationTable: MetricsV1EntityRelationTable;
};

export type MetricsV1EventsEntityUpdated = {
  entity: MetricsV1Entity;
};

export type MetricsV1EventsExposureCalculationCompleted = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationCreated = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationUpdated = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureTableCreated = {
  exposureTable: MetricsV1ExposureTable;
};

export type MetricsV1EventsExposureTableUpdated = {
  exposureTable: MetricsV1ExposureTable;
};

export type MetricsV1EventsFactTableCreated = {
  factTable: MetricsV1FactTable;
};

export type MetricsV1EventsFactTableUpdated = {
  factTable: MetricsV1FactTable;
};

export type MetricsV1EventsMeasurementCalculationCompleted = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationCreated = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationUpdated = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCreated = {
  measurement: MetricsV1Measurement;
};

export type MetricsV1EventsMeasurementTableCreated = {
  measurementTable: MetricsV1MeasurementTable;
};

export type MetricsV1EventsMeasurementTableUpdated = {
  measurementTable: MetricsV1MeasurementTable;
};

export type MetricsV1EventsMeasurementUpdated = {
  measurement: MetricsV1Measurement;
  oldMeasurement?: Maybe<MetricsV1Measurement>;
};

export type MetricsV1EventsMetricCalculationCompleted = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationCreated = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationUpdated = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCreated = {
  metric: MetricsV1Metric;
};

export type MetricsV1EventsMetricUpdated = {
  metric: MetricsV1Metric;
  oldMetric?: Maybe<MetricsV1Metric>;
};

export type MetricsV1EventsPartitionCreated = {
  partition: MetricsV1Partition;
};

export type MetricsV1EventsPartitionDeleted = {
  partition: MetricsV1Partition;
};

export type MetricsV1EventsProcessRoundLogVerificationFailed = {
  actualCount?: Maybe<Scalars['Long']['output']>;
  expectedCount?: Maybe<Scalars['Long']['output']>;
  processRoundLog: MetricsV1ProcessRoundLog;
  queryEndTime?: Maybe<Scalars['String']['output']>;
  queryStartTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EventsRetriggerCreated = {
  retrigger: MetricsV1Retrigger;
};

export type MetricsV1EventsRetriggerScheduledExposureCalculationCompleted = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsRetriggerScheduledMeasurementCalculationCompleted = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsRetriggerScheduledMetricCalculationCompleted = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsRetriggerUpdated = {
  retrigger: MetricsV1Retrigger;
};

export type MetricsV1EventsScheduledExposureCalculationCreated = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsScheduledExposureCalculationDeleted = {
  scheduledExposureCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledExposureCalculationUpdated = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsScheduledMeasurementCalculationCreated = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsScheduledMeasurementCalculationDeleted = {
  scheduledMeasurementCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledMeasurementCalculationUpdated = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsScheduledMetricCalculationCreated = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsScheduledMetricCalculationDeleted = {
  scheduledMetricCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledMetricCalculationUpdated = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsSqlJobCreated = {
  sqlJob: MetricsV1SqlJob;
};

export type MetricsV1EventsSqlJobUpdated = {
  sqlJob: MetricsV1SqlJob;
};

export type MetricsV1ExistsDataWarehousesResponse = {
  demoData?: Maybe<Scalars['Boolean']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  hasCustomerWarehouse?: Maybe<Scalars['Boolean']['output']>;
  hasManagedWarehouse?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ExistsDataWarehousesResponseResult =
  | Error
  | MetricsV1ExistsDataWarehousesResponse;

export type MetricsV1ExposureCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  error?: Maybe<Scalars['String']['output']>;
  exposureCalculationSpec: MetricsV1ExposureCalculationSpec;
  exposureTable: MetricsV1ExposureTableResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1ExposureCalculationLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  outdatedSourceDataInfo?: Maybe<MetricsV1OutdatedSourceDataInfo>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql: Scalars['String']['output'];
  sqlJob: MetricsV1SqlJobResult;
  startTime: Scalars['String']['output'];
  state: MetricsV1ExposureCalculationState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ExposureCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ExposureCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ExposureCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationGroup = {
  group: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
};

export type MetricsV1ExposureCalculationGroupInput = {
  group: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
};

export type MetricsV1ExposureCalculationInput = {
  endTime: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  exposureCalculationSpec: MetricsV1ExposureCalculationSpecInput;
  labels?: InputMaybe<Array<MetricsV1ExposureCalculationLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1ExposureCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExposureCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationResult =
  | Error
  | MetricsV1ExposureCalculation;

export type MetricsV1ExposureCalculationSpec = {
  assignmentFilter?: Maybe<MetricsV1Filter>;
  assignmentTable: MetricsV1AssignmentTableResult;
  /** @deprecated No longer supported */
  entityFilter?: Maybe<MetricsV1ExposureCalculationSpecEntityFilter>;
  entityFilters: Array<MetricsV1ExposureCalculationSpecEntityFilter>;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  /** @deprecated No longer supported */
  exposureFilter?: Maybe<MetricsV1ExposureCalculationSpecExposureFilter>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  filters: Array<MetricsV1ExposureCalculationSpecExposureFilter>;
  groups: Array<MetricsV1ExposureCalculationGroup>;
  splitDimensions: Array<Scalars['String']['output']>;
};

export type MetricsV1ExposureCalculationSpecEntityFilter = {
  dimensionTable: MetricsV1DimensionTableResult;
  filter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1ExposureCalculationSpecEntityFilterInput = {
  dimensionTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationSpecExposureFilter = {
  displayName?: Maybe<Scalars['String']['output']>;
  factTable: MetricsV1FactTableResult;
  filter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1ExposureCalculationSpecExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationSpecInput = {
  assignmentFilter?: InputMaybe<MetricsV1FilterInput>;
  assignmentTable: Scalars['String']['input'];
  entityFilter?: InputMaybe<MetricsV1ExposureCalculationSpecEntityFilterInput>;
  entityFilters?: InputMaybe<
    Array<MetricsV1ExposureCalculationSpecEntityFilterInput>
  >;
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureFilter?: InputMaybe<MetricsV1ExposureCalculationSpecExposureFilterInput>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<MetricsV1ExposureCalculationSpecExposureFilterInput>
  >;
  groups?: InputMaybe<Array<MetricsV1ExposureCalculationGroupInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  splitDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MetricsV1ExposureCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1ExposureTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  entityIdColumn: MetricsV1Column;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  error?: Maybe<MetricsV1OperationError>;
  exposedEntitiesMetric?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  exposureFilterColumn?: Maybe<MetricsV1Column>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  firstExposureTimeColumn: MetricsV1Column;
  firstExposureTruncation?: Maybe<MetricsV1TimeTruncation>;
  groupNameColumn: MetricsV1Column;
  labels: Array<MetricsV1ExposureTableLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ExposureTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ExposureTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ExposureTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  entityIdColumn: MetricsV1ColumnInput;
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  exposureFilterColumn?: InputMaybe<MetricsV1ColumnInput>;
  firstExposureTimeColumn: MetricsV1ColumnInput;
  firstExposureTruncation?: InputMaybe<MetricsV1TimeTruncationInput>;
  groupNameColumn: MetricsV1ColumnInput;
  labels?: InputMaybe<Array<MetricsV1ExposureTableLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
};

export type MetricsV1ExposureTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExposureTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableResult = Error | MetricsV1ExposureTable;

export type MetricsV1Expression = {
  and?: Maybe<MetricsV1ExpressionOperands>;
  not?: Maybe<MetricsV1Expression>;
  or?: Maybe<MetricsV1ExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExpressionInput = {
  and?: InputMaybe<MetricsV1ExpressionOperandsInput>;
  not?: InputMaybe<MetricsV1ExpressionInput>;
  or?: InputMaybe<MetricsV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExpressionOperands = {
  operands: Array<MetricsV1Expression>;
};

export type MetricsV1ExpressionOperandsInput = {
  operands: Array<MetricsV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entities: Array<MetricsV1EntityColumnMapping>;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1FactTableLabelsEntry>;
  measures: Array<MetricsV1Measure>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  source?: Maybe<MetricsV1MetricMetricSource>;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timestampColumn: MetricsV1Column;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1FactTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1FactTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1FactTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableColumnsSuggestion = {
  dimensions: Array<Scalars['String']['output']>;
  entities: Array<MetricsV1EntityColumn>;
  measures: Array<Scalars['String']['output']>;
  timestampColumn: Scalars['String']['output'];
};

export type MetricsV1FactTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entities: Array<MetricsV1EntityColumnMappingInput>;
  factDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1FactTableLabelsEntryInput>>;
  measures?: InputMaybe<Array<MetricsV1MeasureInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipSqlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  sql: Scalars['String']['input'];
  timestampColumn: MetricsV1ColumnInput;
};

export type MetricsV1FactTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FactTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableResult = Error | MetricsV1FactTable;

export type MetricsV1FailedQueryResult = {
  error?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1Filter = {
  criteria: Array<MetricsV1FilterCriteriaEntry>;
  expression: MetricsV1Expression;
};

export type MetricsV1FilterCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<MetricsV1FilterCriterion>;
};

export type MetricsV1FilterCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<MetricsV1FilterCriterionInput>;
};

export type MetricsV1FilterCriterion = {
  attribute?: Maybe<MetricsV1FilterCriterionAttributeCriterion>;
};

export type MetricsV1FilterCriterionAttributeCriterion = {
  attribute: Scalars['String']['output'];
  eqRule?: Maybe<MetricsV1FilterEqRule>;
  likeRule?: Maybe<MetricsV1FilterLikeRule>;
  rangeRule?: Maybe<MetricsV1FilterRangeRule>;
  setRule?: Maybe<MetricsV1FilterSetRule>;
};

export type MetricsV1FilterCriterionAttributeCriterionInput = {
  attribute: Scalars['String']['input'];
  eqRule?: InputMaybe<MetricsV1FilterEqRuleInput>;
  likeRule?: InputMaybe<MetricsV1FilterLikeRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<MetricsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<MetricsV1FilterSetRuleInput>;
};

export type MetricsV1FilterCriterionInput = {
  attribute?: InputMaybe<MetricsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterEqRule = {
  value: MetricsV1FilterValue;
};

export type MetricsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: MetricsV1FilterValueInput;
};

export type MetricsV1FilterInput = {
  criteria: Array<MetricsV1FilterCriteriaEntryInput>;
  expression: MetricsV1ExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterLikeRule = {
  pattern: Scalars['String']['output'];
};

export type MetricsV1FilterLikeRuleInput = {
  pattern: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterRangeRule = {
  endExclusive?: Maybe<MetricsV1FilterValue>;
  endInclusive?: Maybe<MetricsV1FilterValue>;
  startExclusive?: Maybe<MetricsV1FilterValue>;
  startInclusive?: Maybe<MetricsV1FilterValue>;
};

export type MetricsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<MetricsV1FilterValueInput>;
  endInclusive?: InputMaybe<MetricsV1FilterValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<MetricsV1FilterValueInput>;
  startInclusive?: InputMaybe<MetricsV1FilterValueInput>;
};

export type MetricsV1FilterSetRule = {
  values: Array<MetricsV1FilterValue>;
};

export type MetricsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<MetricsV1FilterValueInput>;
};

export type MetricsV1FilterValue = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  nullValue?: Maybe<MetricsV1FilterValueNull>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FilterValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  nullValue?: InputMaybe<MetricsV1FilterValueNullInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterValueNull = {
  dummyField?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FilterValueNullInput = {
  dummyField?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1JobStats = {
  bigQueryJobStats?: Maybe<MetricsV1BigQueryJobStats>;
  redshiftJobStats?: Maybe<MetricsV1RedshiftJobStats>;
};

export type MetricsV1ListAssignmentTablesResponse = {
  assignmentTables: Array<MetricsV1AssignmentTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListAssignmentTablesResponseResult =
  | Error
  | MetricsV1ListAssignmentTablesResponse;

export type MetricsV1ListContiguousPartitionsResponse = {
  contiguousPartitions: Array<MetricsV1ContiguousPartition>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListContiguousPartitionsResponseResult =
  | Error
  | MetricsV1ListContiguousPartitionsResponse;

export type MetricsV1ListDataWarehousesResponse = {
  dataWarehouses: Array<MetricsV1DataWarehouse>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListDataWarehousesResponseResult =
  | Error
  | MetricsV1ListDataWarehousesResponse;

export type MetricsV1ListDependenciesResponse = {
  dependencies: Array<MetricsV1Dependency>;
};

export type MetricsV1ListDependenciesResponseResult =
  | Error
  | MetricsV1ListDependenciesResponse;

export type MetricsV1ListDimensionTablesResponse = {
  dimensionTables: Array<MetricsV1DimensionTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListDimensionTablesResponseResult =
  | Error
  | MetricsV1ListDimensionTablesResponse;

export type MetricsV1ListEntitiesResponse = {
  entities: Array<MetricsV1Entity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntitiesResponseResult =
  | Error
  | MetricsV1ListEntitiesResponse;

export type MetricsV1ListEntityIdentityBindingsResponse = {
  entityIdentityBindings: Array<MetricsV1EntityIdentityBinding>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntityIdentityBindingsResponseResult =
  | Error
  | MetricsV1ListEntityIdentityBindingsResponse;

export type MetricsV1ListEntityRelationTablesResponse = {
  entityRelationTables: Array<MetricsV1EntityRelationTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntityRelationTablesResponseResult =
  | Error
  | MetricsV1ListEntityRelationTablesResponse;

export type MetricsV1ListExposureCalculationsResponse = {
  exposureCalculations: Array<MetricsV1ExposureCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListExposureCalculationsResponseResult =
  | Error
  | MetricsV1ListExposureCalculationsResponse;

export type MetricsV1ListExposureTablesResponse = {
  exposureTables: Array<MetricsV1ExposureTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListExposureTablesResponseResult =
  | Error
  | MetricsV1ListExposureTablesResponse;

export type MetricsV1ListFactTablesResponse = {
  factTables: Array<MetricsV1FactTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListFactTablesResponseResult =
  | Error
  | MetricsV1ListFactTablesResponse;

export type MetricsV1ListMeasurementCalculationsResponse = {
  measurementCalculations: Array<MetricsV1MeasurementCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMeasurementCalculationsResponseResult =
  | Error
  | MetricsV1ListMeasurementCalculationsResponse;

export type MetricsV1ListMeasurementTablesResponse = {
  measurementTables: Array<MetricsV1MeasurementTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMeasurementTablesResponseResult =
  | Error
  | MetricsV1ListMeasurementTablesResponse;

export type MetricsV1ListMeasurementsResponse = {
  measurements: Array<MetricsV1Measurement>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type MetricsV1ListMeasurementsResponseResult =
  | Error
  | MetricsV1ListMeasurementsResponse;

export type MetricsV1ListMetricCalculationsResponse = {
  metricCalculations: Array<MetricsV1MetricCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMetricCalculationsResponseResult =
  | Error
  | MetricsV1ListMetricCalculationsResponse;

export type MetricsV1ListMetricsResponse = {
  metrics: Array<MetricsV1Metric>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMetricsResponseResult =
  | Error
  | MetricsV1ListMetricsResponse;

export type MetricsV1ListPartitionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  partitions: Array<MetricsV1Partition>;
};

export type MetricsV1ListPartitionsResponseResult =
  | Error
  | MetricsV1ListPartitionsResponse;

export type MetricsV1ListProcessRoundLogsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  processRoundLogs: Array<MetricsV1ProcessRoundLog>;
};

export type MetricsV1ListProcessRoundLogsResponseResult =
  | Error
  | MetricsV1ListProcessRoundLogsResponse;

export type MetricsV1ListRetriggersResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  retriggers: Array<MetricsV1Retrigger>;
};

export type MetricsV1ListRetriggersResponseResult =
  | Error
  | MetricsV1ListRetriggersResponse;

export type MetricsV1ListScheduledExposureCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledExposureCalculations: Array<MetricsV1ScheduledExposureCalculation>;
};

export type MetricsV1ListScheduledExposureCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledExposureCalculationsResponse;

export type MetricsV1ListScheduledMeasurementCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledMeasurementCalculations: Array<MetricsV1ScheduledMeasurementCalculation>;
};

export type MetricsV1ListScheduledMeasurementCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledMeasurementCalculationsResponse;

export type MetricsV1ListScheduledMetricCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledMetricCalculations: Array<MetricsV1ScheduledMetricCalculation>;
};

export type MetricsV1ListScheduledMetricCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledMetricCalculationsResponse;

export type MetricsV1Measure = {
  column: MetricsV1Column;
  declaredType?: Maybe<MetricsV1ColumnType>;
  displayName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<MetricsV1Unit>;
};

export type MetricsV1MeasureInput = {
  column: MetricsV1ColumnInput;
  declaredType?: InputMaybe<MetricsV1ColumnType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<MetricsV1UnitInput>;
};

export type MetricsV1Measurement = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  filter?: Maybe<MetricsV1Filter>;
  filterString?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1MeasurementLabelsEntry>;
  name: Scalars['String']['output'];
  nullHandling?: Maybe<MetricsV1MetricNullHandlingConfig>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<MetricsV1MetricMetricSource>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  typeSpec: MetricsV1MetricMetricTypeSpec;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1MeasurementCalculationLabelsEntry>;
  measurementCalculationSpec: MetricsV1MeasurementCalculationSpec;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql?: Maybe<Scalars['String']['output']>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  startTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1MeasurementCalculationState>;
  supersededBy?: Maybe<MetricsV1MeasurementCalculationResult>;
  superseeds?: Maybe<MetricsV1MetricCalculationResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  times: MetricsV1MeasurementCalculationTimes;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementCalculationResult =
  | Error
  | MetricsV1MeasurementCalculation;

export type MetricsV1MeasurementCalculationSpec = {
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  exposureTable: MetricsV1ExposureTableResult;
  metric: MetricsV1MetricResult;
  splitDimensions: Array<MetricsV1MetricCalculationDimension>;
};

export enum MetricsV1MeasurementCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1MeasurementCalculationTimes = {
  exposureEndTime: Scalars['String']['output'];
  exposureStartTime: Scalars['String']['output'];
  factEndTime?: Maybe<Scalars['String']['output']>;
  factStartTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
  factTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MeasurementLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<MetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec: MetricsV1MetricMetricTypeSpecInput;
};

export type MetricsV1MeasurementLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementResult = Error | MetricsV1Measurement;

export type MetricsV1MeasurementTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  entity: MetricsV1EntityResult;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  error?: Maybe<MetricsV1OperationError>;
  exposureTable: MetricsV1ExposureTableResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  labels: Array<MetricsV1MeasurementTableLabelsEntry>;
  measurementDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  metric: MetricsV1MetricResult;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementTableObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementTableResult = Error | MetricsV1MeasurementTable;

export type MetricsV1Metric = {
  /** @deprecated No longer supported */
  aggregationWindow?: Maybe<Scalars['String']['output']>;
  archiveInfo?: Maybe<MetricsV1MetricArchiveInfo>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  defaultEffectSize?: Maybe<GoogleTypeDecimal>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  derivedUnit?: Maybe<MetricsV1MetricCompositeUnit>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  entity?: Maybe<MetricsV1EntityResult>;
  etag?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  exposureOffset?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  filter?: Maybe<MetricsV1Filter>;
  filterString?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1MetricLabelsEntry>;
  measurement?: Maybe<MetricsV1MeasurementResult>;
  measurementConfig?: Maybe<MetricsV1MetricMeasurementConfig>;
  name: Scalars['String']['output'];
  nullHandling?: Maybe<MetricsV1MetricNullHandlingConfig>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  preferredDirection?: Maybe<MetricsV1MetricPreferredDirection>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<MetricsV1MetricMetricSource>;
  state?: Maybe<MetricsV1MetricState>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  typeSpec?: Maybe<MetricsV1MetricMetricTypeSpec>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  varianceReductionConfig?: Maybe<MetricsV1MetricVarianceReductionConfig>;
  verification?: Maybe<MetricsV1MetricMetricVerification>;
};

export type MetricsV1MetricAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MetricCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MetricObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricArchiveInfo = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricArchiveInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricAverageMetricSpec = {
  aggregation: MetricsV1Aggregation;
  measurement?: Maybe<MetricsV1Column>;
};

export type MetricsV1MetricAverageMetricSpecInput = {
  aggregation: MetricsV1AggregationInput;
  measurement?: InputMaybe<MetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricBucketStats = {
  dimensions: Array<MetricsV1DimensionValue>;
  summaryStats: MetricsV1SummaryStats;
  variant: Scalars['String']['output'];
};

export type MetricsV1MetricBucketStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  effectiveEntitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1MetricCalculationLabelsEntry>;
  metricCalculationSpec: MetricsV1MetricCalculationSpec;
  metricResults?: Maybe<MetricsV1MetricResults>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  outdatedSourceDataInfo?: Maybe<MetricsV1OutdatedSourceDataInfo>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryMetricCalculation?: Maybe<MetricsV1QueryMetricCalculationResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql?: Maybe<Scalars['String']['output']>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  startTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1MetricCalculationState>;
  supersededBy?: Maybe<MetricsV1MetricCalculationResult>;
  superseeds?: Maybe<MetricsV1MetricCalculationResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  times: MetricsV1MetricCalculationTimes;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MetricCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MetricCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MetricCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationQueryMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationAvailableData = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricCalculationAvailableDataInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationDimension = {
  column: Scalars['String']['output'];
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
};

export type MetricsV1MetricCalculationDimensionInput = {
  column: Scalars['String']['input'];
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationEndTimeConfig = {
  availableData?: Maybe<MetricsV1MetricCalculationAvailableData>;
  exposureEndTime?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
};

export type MetricsV1MetricCalculationEndTimeConfigInput = {
  availableData?: InputMaybe<MetricsV1MetricCalculationAvailableDataInput>;
  exposureEndTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  endTimeConfig?: InputMaybe<MetricsV1MetricCalculationEndTimeConfigInput>;
  exposureEndTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MetricCalculationLabelsEntryInput>>;
  metricCalculationSpec: MetricsV1MetricCalculationSpecInput;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1MetricCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationResult =
  | Error
  | MetricsV1MetricCalculation;

export type MetricsV1MetricCalculationSpec = {
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  exposureGroups: Array<Scalars['String']['output']>;
  exposureTable: MetricsV1ExposureTableResult;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  metric: MetricsV1MetricResult;
  scaleUpResults?: Maybe<Scalars['Boolean']['output']>;
  splitDimensions: Array<MetricsV1MetricCalculationDimension>;
};

export type MetricsV1MetricCalculationSpecInput = {
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  exposureTable: Scalars['String']['input'];
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scaleUpResults?: InputMaybe<Scalars['Boolean']['input']>;
  splitDimensions?: InputMaybe<Array<MetricsV1MetricCalculationDimensionInput>>;
};

export enum MetricsV1MetricCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1MetricCalculationTimes = {
  exposureEndTime: Scalars['String']['output'];
  exposureStartTime: Scalars['String']['output'];
  factEndTime: Scalars['String']['output'];
  factStartTime: Scalars['String']['output'];
};

export type MetricsV1MetricCalculationTimesInput = {
  exposureEndTime: Scalars['String']['input'];
  exposureStartTime: Scalars['String']['input'];
  factEndTime: Scalars['String']['input'];
  factStartTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCompositeUnit = {
  denominator?: Maybe<MetricsV1Unit>;
  numerator: MetricsV1Unit;
};

export type MetricsV1MetricCompositeUnitInput = {
  denominator?: InputMaybe<MetricsV1UnitInput>;
  numerator: MetricsV1UnitInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  defaultEffectSize?: InputMaybe<GoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MetricLabelsEntryInput>>;
  measurement?: InputMaybe<Scalars['String']['input']>;
  measurementConfig?: InputMaybe<MetricsV1MetricMeasurementConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<MetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MetricsV1MetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<MetricsV1MetricMetricTypeSpecInput>;
  varianceReductionConfig?: InputMaybe<MetricsV1MetricVarianceReductionConfigInput>;
};

export type MetricsV1MetricLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfig = {
  closedWindow?: Maybe<MetricsV1MetricMeasurementConfigClosedWindowConfig>;
  openWindow?: Maybe<MetricsV1MetricMeasurementConfigOpenWindowConfig>;
  semiOpenWindow?: Maybe<MetricsV1MetricMeasurementConfigSemiOpenWindowConfig>;
};

export type MetricsV1MetricMeasurementConfigClosedWindowConfig = {
  aggregationWindow: Scalars['String']['output'];
  exposureOffset: Scalars['String']['output'];
};

export type MetricsV1MetricMeasurementConfigClosedWindowConfigInput = {
  aggregationWindow: Scalars['String']['input'];
  exposureOffset: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfigInput = {
  closedWindow?: InputMaybe<MetricsV1MetricMeasurementConfigClosedWindowConfigInput>;
  openWindow?: InputMaybe<MetricsV1MetricMeasurementConfigOpenWindowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semiOpenWindow?: InputMaybe<MetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput>;
};

export type MetricsV1MetricMeasurementConfigOpenWindowConfig = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMeasurementConfigOpenWindowConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfigSemiOpenWindowConfig = {
  aggregationWindow: Scalars['String']['output'];
  exposureOffset?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput = {
  aggregationWindow: Scalars['String']['input'];
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMetricSource = {
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetricsV1MetricMetricSourceType>;
};

export type MetricsV1MetricMetricSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetricsV1MetricMetricSourceType>;
};

export enum MetricsV1MetricMetricSourceType {
  Api = 'API',
  Repository = 'REPOSITORY',
}

export type MetricsV1MetricMetricTypeSpec = {
  averageMetricSpec?: Maybe<MetricsV1MetricAverageMetricSpec>;
  quantileMetricSpec?: Maybe<MetricsV1MetricQuantileMetricSpec>;
  ratioMetricSpec?: Maybe<MetricsV1MetricRatioMetricSpec>;
};

export type MetricsV1MetricMetricTypeSpecInput = {
  averageMetricSpec?: InputMaybe<MetricsV1MetricAverageMetricSpecInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileMetricSpec?: InputMaybe<MetricsV1MetricQuantileMetricSpecInput>;
  ratioMetricSpec?: InputMaybe<MetricsV1MetricRatioMetricSpecInput>;
};

export type MetricsV1MetricMetricVerification = {
  state?: Maybe<MetricsV1MetricMetricVerificationVerificationState>;
  verifier?: Maybe<IamV1IdentityResult>;
  verifyTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMetricVerificationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  verifier?: InputMaybe<Scalars['String']['input']>;
  verifyTime?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricsV1MetricMetricVerificationVerificationState {
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
}

export type MetricsV1MetricNullHandlingConfig = {
  replaceEntityNullWithZero?: Maybe<Scalars['Boolean']['output']>;
  replaceMeasureNullWithZero?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1MetricNullHandlingConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  replaceEntityNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
  replaceMeasureNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MetricsV1MetricPreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsV1MetricQuantileMetricSpec = {
  aggregation: MetricsV1Aggregation;
  measurement?: Maybe<MetricsV1Column>;
  quantileLevel: Scalars['Float']['output'];
};

export type MetricsV1MetricQuantileMetricSpecInput = {
  aggregation: MetricsV1AggregationInput;
  measurement?: InputMaybe<MetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileLevel: Scalars['Float']['input'];
};

export type MetricsV1MetricRatioMetricSpec = {
  denominator?: Maybe<MetricsV1Column>;
  denominatorAggregation: MetricsV1Aggregation;
  denominatorFilter?: Maybe<MetricsV1Filter>;
  numerator?: Maybe<MetricsV1Column>;
  numeratorAggregation: MetricsV1Aggregation;
  numeratorFilter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1MetricRatioMetricSpecInput = {
  denominator?: InputMaybe<MetricsV1ColumnInput>;
  denominatorAggregation: MetricsV1AggregationInput;
  denominatorFilter?: InputMaybe<MetricsV1FilterInput>;
  numerator?: InputMaybe<MetricsV1ColumnInput>;
  numeratorAggregation: MetricsV1AggregationInput;
  numeratorFilter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricResult = Error | MetricsV1Metric;

export type MetricsV1MetricResults = {
  metricBucketStats: Array<MetricsV1MetricBucketStats>;
};

export type MetricsV1MetricResultsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricRow = {
  aggCount?: Maybe<Scalars['Int']['output']>;
  dimensions: Array<MetricsV1MetricRowDimensionsEntry>;
  value?: Maybe<MetricsV1SummaryStats>;
};

export type MetricsV1MetricRowDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum MetricsV1MetricState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
}

export type MetricsV1MetricVarianceReductionConfig = {
  aggregationWindowOverride?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1MetricVarianceReductionConfigInput = {
  aggregationWindowOverride?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1OperationError = {
  details: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1OperationErrorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1OutdatedSourceDataInfo = {
  actualCount: Scalars['Long']['output'];
  expectedCount: Scalars['Long']['output'];
  queryEndTime: Scalars['String']['output'];
  queryStartTime: Scalars['String']['output'];
  table: Scalars['String']['output'];
};

export type MetricsV1OutdatedSourceDataInfoInput = {
  actualCount: Scalars['Long']['input'];
  expectedCount: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryEndTime: Scalars['String']['input'];
  queryStartTime: Scalars['String']['input'];
  table: Scalars['String']['input'];
};

export type MetricsV1Partition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  info?: Maybe<MetricsV1PartitionPartitionInfo>;
  labels: Array<MetricsV1PartitionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  startTime: Scalars['String']['output'];
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1PartitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1PartitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1PartitionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionInput = {
  endTime: Scalars['String']['input'];
  info?: InputMaybe<MetricsV1PartitionPartitionInfoInput>;
  labels?: InputMaybe<Array<MetricsV1PartitionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1PartitionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionPartitionInfo = {
  maxTime: Scalars['String']['output'];
  minTime: Scalars['String']['output'];
  rowCount: Scalars['Long']['output'];
};

export type MetricsV1PartitionPartitionInfoInput = {
  maxTime: Scalars['String']['input'];
  minTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rowCount: Scalars['Long']['input'];
};

export type MetricsV1PartitionResult = Error | MetricsV1Partition;

export type MetricsV1PartitionedTimestampUpdateProcessRoundResult = {
  state?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  updatedDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionedUpdateStrategyState = {
  count?: Maybe<Scalars['Long']['output']>;
  currentPartitionLastCheckTime?: Maybe<Scalars['String']['output']>;
  existsCheckDuration?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MetricsV1PartitionedUpdateStrategyStateState>;
  usualLateness?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionedUpdateStrategyStateInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  currentPartitionLastCheckTime?: InputMaybe<Scalars['String']['input']>;
  existsCheckDuration?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  usualLateness?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricsV1PartitionedUpdateStrategyStateState {
  NextPartitionIsInTheFuture = 'NEXT_PARTITION_IS_IN_THE_FUTURE',
  PartitionsUsuallyArriveLater = 'PARTITIONS_USUALLY_ARRIVE_LATER',
  PartitionDoesNotExist = 'PARTITION_DOES_NOT_EXIST',
}

export type MetricsV1PendingQueryResult = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PreviewSqlQueryResponse = {
  job?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PreviewSqlQueryResponseResult =
  | Error
  | MetricsV1PreviewSqlQueryResponse;

export type MetricsV1ProcessRoundLog = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  partition?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  /** @deprecated No longer supported */
  result?: Maybe<MetricsV1PartitionedTimestampUpdateProcessRoundResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  table: Scalars['String']['output'];
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  timestamp?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResult>;
  verificationState: MetricsV1ProcessRoundLogVerificationState;
  /** @deprecated No longer supported */
  watermarkState?: Maybe<MetricsV1WatermarkState>;
};

export type MetricsV1ProcessRoundLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ProcessRoundLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ProcessRoundLogObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResult = {
  partitionArrivesLater?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionArrivesLater>;
  partitionCommitted?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionCommitted>;
  partitionError?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionError>;
  partitionNotCommitted?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionNotCommitted>;
  partitionTime?: Maybe<Scalars['String']['output']>;
};

export enum MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason {
  NoCommitReasonEmptyNotAllowed = 'NO_COMMIT_REASON_EMPTY_NOT_ALLOWED',
  NoCommitReasonEmptyWithinMaxWaitTime = 'NO_COMMIT_REASON_EMPTY_WITHIN_MAX_WAIT_TIME',
}

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionArrivesLater =
  {
    expectedArrivalTime?: Maybe<Scalars['String']['output']>;
    usualLateness?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionCommitted = {
  count?: Maybe<Scalars['Long']['output']>;
  maxWaitTimeReached?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionNotCommitted =
  {
    noCommitReason?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason>;
  };

export type MetricsV1ProcessRoundLogResult = Error | MetricsV1ProcessRoundLog;

export type MetricsV1ProcessRoundLogTimestampCheckResult = {
  currentDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dataCommitted?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataCommitted>;
  dataError?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataError>;
  dataPendingCommit?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataPendingCommit>;
  newDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataCommitted = {
  count?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataPendingCommit = {
  currentCount?: Maybe<Scalars['Long']['output']>;
  newDataDeliveredUntil?: Maybe<Scalars['Boolean']['output']>;
  noCommitReason?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason>;
  previousCount?: Maybe<Scalars['Long']['output']>;
};

export enum MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason {
  NoCommitReasonCommitTimeNotReached = 'NO_COMMIT_REASON_COMMIT_TIME_NOT_REACHED',
  NoCommitReasonOutsideCommitThreshold = 'NO_COMMIT_REASON_OUTSIDE_COMMIT_THRESHOLD',
}

export enum MetricsV1ProcessRoundLogVerificationState {
  Error = 'ERROR',
  Failed = 'FAILED',
  Passed = 'PASSED',
  VerificationNotNeeded = 'VERIFICATION_NOT_NEEDED',
  VerificationPending = 'VERIFICATION_PENDING',
}

export type MetricsV1QueryAvailableTimeRangeResponse = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type MetricsV1QueryAvailableTimeRangeResponseResult =
  | Error
  | MetricsV1QueryAvailableTimeRangeResponse;

export enum MetricsV1QueryDataWarehouseStatsRequestStatsInterval {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
}

export type MetricsV1QueryDataWarehouseStatsResponse = {
  stats: Array<MetricsV1DataWarehouseStatsEntry>;
};

export type MetricsV1QueryDataWarehouseStatsResponseResult =
  | Error
  | MetricsV1QueryDataWarehouseStatsResponse;

export type MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<MetricsV1DimensionFilterInput>;
};

export type MetricsV1QueryMetricCalculationResponse = {
  dimensions: Array<Scalars['String']['output']>;
  rows: Array<MetricsV1MetricRow>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1QueryMetricCalculationResponseResult =
  | Error
  | MetricsV1QueryMetricCalculationResponse;

export type MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<MetricsV1DimensionFilterInput>;
  };

export type MetricsV1QueryScheduledMetricCalculationResponse = {
  dimensions: Array<Scalars['String']['output']>;
  maxStartTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
  rows: Array<MetricsV1MetricRow>;
};

export type MetricsV1QueryScheduledMetricCalculationResponseResult =
  | Error
  | MetricsV1QueryScheduledMetricCalculationResponse;

export type MetricsV1RedshiftConfig = {
  cluster: Scalars['String']['output'];
  credentialsSettings?: Maybe<MetricsV1RedshiftConfigCredentialsAuthenticationSettings>;
  dataApiEndpoint?: Maybe<Scalars['String']['output']>;
  database: Scalars['String']['output'];
  exposureSchema?: Maybe<Scalars['String']['output']>;
  region: MetricsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  webIdentitySettings?: Maybe<MetricsV1RedshiftConfigWebIdentityAuthenticationSettings>;
};

export type MetricsV1RedshiftConfigCredentialsAuthenticationSettings = {
  accessKeyId: Scalars['String']['output'];
};

export type MetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput = {
  accessKeyId: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RedshiftConfigInput = {
  cluster: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<MetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput>;
  dataApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  database: Scalars['String']['input'];
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: MetricsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<MetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput>;
};

export type MetricsV1RedshiftConfigWebIdentityAuthenticationSettings = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RedshiftJobStats = {
  duration?: Maybe<Scalars['String']['output']>;
  resultSizeBytes?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1Retrigger = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  completeTime?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1RetriggerLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  targetTime: Scalars['String']['output'];
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1RetriggerAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1RetriggerCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1RetriggerObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerAllScheduledMetricCalculationsResponse = {
  retriggerInfo?: Maybe<MetricsV1ScheduledMetricCalculationRetriggerInfo>;
};

export type MetricsV1RetriggerAllScheduledMetricCalculationsResponseResult =
  | Error
  | MetricsV1RetriggerAllScheduledMetricCalculationsResponse;

export type MetricsV1RetriggerLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1RetriggerResult = Error | MetricsV1Retrigger;

export type MetricsV1SampleRow = {
  values: Array<MetricsV1SampleRowValuesEntry>;
};

export type MetricsV1SampleRowValuesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1SampleRows = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  failedQueryResult?: Maybe<MetricsV1FailedQueryResult>;
  name: MetricsV1SqlJobResult;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pendingQueryResult?: Maybe<MetricsV1PendingQueryResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sampleRows: Array<MetricsV1SampleRow>;
  successfulQueryResult?: Maybe<MetricsV1SuccessfulQueryResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type MetricsV1SampleRowsAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1SampleRowsCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1SampleRowsObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsResult = Error | MetricsV1SampleRows;

export type MetricsV1ScheduledExposureCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entity: MetricsV1EntityResult;
  executedCalculationsCount: Scalars['Int']['output'];
  exposedEntitiesMetric?: Maybe<MetricsV1MetricResult>;
  exposedEntitiesMetricSchedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  exposureCalculationSpec: MetricsV1ExposureCalculationSpec;
  exposureCalculations?: Maybe<MetricsV1ListExposureCalculationsResponseResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledExposureCalculationLabelsEntry>;
  name: Scalars['String']['output'];
  nextAssignmentEndTime: Scalars['String']['output'];
  nextAssignmentStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledExposureCalculationState>;
  status: MetricsV1ScheduledExposureCalculationStatus;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledExposureCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ScheduledExposureCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledExposureCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledExposureCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  exposureCalculationSpec: MetricsV1ExposureCalculationSpecInput;
  labels?: InputMaybe<
    Array<MetricsV1ScheduledExposureCalculationLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals: Array<Scalars['String']['input']>;
  scheduleStartTime: Scalars['String']['input'];
};

export type MetricsV1ScheduledExposureCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledExposureCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationResult =
  | Error
  | MetricsV1ScheduledExposureCalculation;

export enum MetricsV1ScheduledExposureCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledExposureCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledExposureCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledExposureCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledExposureCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledExposureCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledExposureCalculationStatusWaiting>;
};

export type MetricsV1ScheduledExposureCalculationStatusCalculating = {
  exposureCalculation: MetricsV1ExposureCalculationResult;
};

export type MetricsV1ScheduledExposureCalculationStatusCalculatingInput = {
  exposureCalculation: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusCancelledInput = {
  cancelledTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusErrorInput = {
  errorMessage: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusInput = {
  calculating?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusCalculatingInput>;
  cancelled?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusCancelledInput>;
  error?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusErrorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusScheduledInput>;
  waiting?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusWaitingInput>;
};

export type MetricsV1ScheduledExposureCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusScheduledInput = {
  nextScheduleTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusWaiting = {
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusWaitingInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  needDataUntilTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  executedCalculationsCount: Scalars['Int']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledMeasurementCalculationLabelsEntry>;
  measurementCalculationSpec: MetricsV1MeasurementCalculationSpec;
  measurementCalculations?: Maybe<MetricsV1ListMeasurementCalculationsResponseResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  name: Scalars['String']['output'];
  nextExposureEndTime: Scalars['String']['output'];
  nextExposureStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledMeasurementCalculationState>;
  status: MetricsV1ScheduledMeasurementCalculationStatus;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledMeasurementCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MetricsV1ScheduledMeasurementCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledMeasurementCalculationMeasurementCalculationsArgs =
  {
    filter?: InputMaybe<Scalars['String']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMeasurementCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMeasurementCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledMeasurementCalculationResult =
  | Error
  | MetricsV1ScheduledMeasurementCalculation;

export enum MetricsV1ScheduledMeasurementCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledMeasurementCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusWaiting>;
};

export type MetricsV1ScheduledMeasurementCalculationStatusCalculating = {
  measurementCalculation: MetricsV1MeasurementCalculationResult;
};

export type MetricsV1ScheduledMeasurementCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusWaiting = {
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  executedCalculationsCount: Scalars['Int']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledMetricCalculationLabelsEntry>;
  latestCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  metricCalculationSpec: MetricsV1MetricCalculationSpec;
  metricCalculations?: Maybe<MetricsV1ListMetricCalculationsResponseResult>;
  name: Scalars['String']['output'];
  nextExposureEndTime: Scalars['String']['output'];
  nextExposureStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryScheduledMetricCalculation?: Maybe<MetricsV1QueryScheduledMetricCalculationResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledMetricCalculationState>;
  status: MetricsV1ScheduledMetricCalculationStatus;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledMetricCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ScheduledMetricCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledMetricCalculationMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationQueryScheduledMetricCalculationArgs =
  {
    accumulateDimension?: InputMaybe<Scalars['String']['input']>;
    dimensionFilters?: InputMaybe<
      Array<MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput>
    >;
    endTime?: InputMaybe<Scalars['String']['input']>;
    groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
    includeAllCombinations?: InputMaybe<Scalars['Boolean']['input']>;
    startTime?: InputMaybe<Scalars['String']['input']>;
    timeZone?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationInput = {
  labels?: InputMaybe<
    Array<MetricsV1ScheduledMetricCalculationLabelsEntryInput>
  >;
  metricCalculationSpec: MetricsV1MetricCalculationSpecInput;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals: Array<Scalars['String']['input']>;
  scheduleStartTime: Scalars['String']['input'];
};

export type MetricsV1ScheduledMetricCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledMetricCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationResult =
  | Error
  | MetricsV1ScheduledMetricCalculation;

export type MetricsV1ScheduledMetricCalculationRetriggerInfo = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggerInfoItems: Array<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoExternalDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1ExternalDocumentView>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MetricsV1ScheduledMetricCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledMetricCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledMetricCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledMetricCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledMetricCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledMetricCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledMetricCalculationStatusWaiting>;
};

export type MetricsV1ScheduledMetricCalculationStatusCalculating = {
  metricCalculation: MetricsV1MetricCalculationResult;
};

export type MetricsV1ScheduledMetricCalculationStatusCalculatingInput = {
  metricCalculation: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusCancelledInput = {
  cancelledTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusErrorInput = {
  errorMessage: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusInput = {
  calculating?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusCalculatingInput>;
  cancelled?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusCancelledInput>;
  error?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusErrorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusScheduledInput>;
  waiting?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusWaitingInput>;
};

export type MetricsV1ScheduledMetricCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusScheduledInput = {
  nextScheduleTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusWaiting = {
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusWaitingInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SnowflakeConfig = {
  account: Scalars['String']['output'];
  authenticationKey: IamV1CryptoKeyResult;
  exposureDatabase: Scalars['String']['output'];
  exposureSchema: Scalars['String']['output'];
  role: Scalars['String']['output'];
  user: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type MetricsV1SnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  exposureDatabase: Scalars['String']['input'];
  exposureSchema: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  user: Scalars['String']['input'];
  warehouse: Scalars['String']['input'];
};

export type MetricsV1SqlJob = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  failedQueryResult?: Maybe<MetricsV1FailedQueryResult>;
  labels: Array<MetricsV1SqlJobLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pendingQueryResult?: Maybe<MetricsV1PendingQueryResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<MetricsV1SqlJobState>;
  successfulQueryResult?: Maybe<MetricsV1SuccessfulQueryResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  triggeringResource?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetricsV1SqlJobType>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1SqlJobAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1SqlJobCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1SqlJobObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1SqlJobResult = Error | MetricsV1SqlJob;

export enum MetricsV1SqlJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingRetry = 'PENDING_RETRY',
  Running = 'RUNNING',
  Throttled = 'THROTTLED',
}

export enum MetricsV1SqlJobType {
  Count = 'COUNT',
  CreateTable = 'CREATE_TABLE',
  DescribeAssignmentsTable = 'DESCRIBE_ASSIGNMENTS_TABLE',
  Execute = 'EXECUTE',
  Exists = 'EXISTS',
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  MeasurementCalculation = 'MEASUREMENT_CALCULATION',
  MetricCalculation = 'METRIC_CALCULATION',
  Preview = 'PREVIEW',
  Truncate = 'TRUNCATE',
}

export type MetricsV1SuccessfulQueryResult = {
  issues: Array<MetricsV1ColumnIssue>;
  jobStats?: Maybe<MetricsV1JobStats>;
  schema: Array<MetricsV1Column>;
  tableIssues: Array<MetricsV1TableIssue>;
};

export type MetricsV1SuggestFactTableColumnsResponse = {
  error?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<MetricsV1FactTableColumnsSuggestion>;
};

export type MetricsV1SuggestFactTableColumnsResponseResult =
  | Error
  | MetricsV1SuggestFactTableColumnsResponse;

export type MetricsV1SuggestMetricResponse = {
  error?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<MetricsV1Metric>;
};

export type MetricsV1SuggestMetricResponseResult =
  | Error
  | MetricsV1SuggestMetricResponse;

export type MetricsV1SummaryStats = {
  averageSummaryStats?: Maybe<MetricsV1SummaryStatsAverageSummaryStats>;
  quantileSummaryStats?: Maybe<MetricsV1SummaryStatsQuantileSummaryStats>;
  ratioSummaryStats?: Maybe<MetricsV1SummaryStatsRatioSummaryStats>;
};

export type MetricsV1SummaryStatsAverageSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  sumOfSquares?: Maybe<Scalars['Float']['output']>;
  summaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  variance?: Maybe<Scalars['Float']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStats>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  covariance?: Maybe<Scalars['Float']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  postCount?: Maybe<Scalars['Long']['output']>;
  postSum?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
  sumOfSquares?: Maybe<Scalars['Float']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsInput = {
  averageSummaryStats?: InputMaybe<MetricsV1SummaryStatsAverageSummaryStatsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileSummaryStats?: InputMaybe<MetricsV1SummaryStatsQuantileSummaryStatsInput>;
  ratioSummaryStats?: InputMaybe<MetricsV1SummaryStatsRatioSummaryStatsInput>;
};

export type MetricsV1SummaryStatsQuantileSummaryStats = {
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  indicatorObservationSumOfProducts?: Maybe<Scalars['Long']['output']>;
  indicatorSum?: Maybe<Scalars['Long']['output']>;
  indicatorSumOfSquares?: Maybe<Scalars['Long']['output']>;
  observationCount?: Maybe<Scalars['Long']['output']>;
  observationCountSumOfSquares?: Maybe<Scalars['Long']['output']>;
  quantileLevel?: Maybe<Scalars['Float']['output']>;
  sumLogValue?: Maybe<Scalars['Float']['output']>;
  sumLogValueSquared?: Maybe<Scalars['Float']['output']>;
  userCount?: Maybe<Scalars['Long']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStats>;
};

export type MetricsV1SummaryStatsQuantileSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStats =
  {
    covariateSum?: Maybe<Scalars['Float']['output']>;
    covariateSumOfSquares?: Maybe<Scalars['Float']['output']>;
    indicatorCovariateSumOfProducts?: Maybe<Scalars['Float']['output']>;
    observationCovariateSumOfProducts?: Maybe<Scalars['Float']['output']>;
  };

export type MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsRatioSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  denominatorMean?: Maybe<Scalars['Float']['output']>;
  denominatorSum?: Maybe<Scalars['Float']['output']>;
  denominatorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  denominatorSummaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  denominatorVariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  numeratorMean?: Maybe<Scalars['Float']['output']>;
  numeratorSum?: Maybe<Scalars['Float']['output']>;
  numeratorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  numeratorSummaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  numeratorVariance?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStats>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  denominatorDenominatorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  denominatorMean?: Maybe<Scalars['Float']['output']>;
  denominatorNumeratorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  denominatorSum?: Maybe<Scalars['Float']['output']>;
  denominatorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  denominatorVariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  numeratorMean?: Maybe<Scalars['Float']['output']>;
  numeratorNumeratorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  numeratorSum?: Maybe<Scalars['Float']['output']>;
  numeratorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  numeratorVariance?: Maybe<Scalars['Float']['output']>;
  postDenominatorSum?: Maybe<Scalars['Float']['output']>;
  postNumeratorSum?: Maybe<Scalars['Float']['output']>;
  preDenominatorPostDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  preDenominatorPostNumeratorCovariance?: Maybe<Scalars['Float']['output']>;
  preNumeratorPostDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  preNumeratorPostNumeratorCovariance?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsSummaryStatsInfo = {
  countZeroes?: Maybe<Scalars['Long']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsSummaryStatsInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1TableIssue = {
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<MetricsV1TableIssueTableIssueSeverity>;
};

export enum MetricsV1TableIssueTableIssueSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

export enum MetricsV1TableState {
  TableStateActive = 'TABLE_STATE_ACTIVE',
  TableStateCreating = 'TABLE_STATE_CREATING',
  TableStateDeleted = 'TABLE_STATE_DELETED',
  TableStateFailed = 'TABLE_STATE_FAILED',
  TableStateUpdating = 'TABLE_STATE_UPDATING',
}

export type MetricsV1TimeTruncation = {
  behaviour: MetricsV1TruncationBehavior;
  timeZone: MetricsV1TruncationTimeZone;
  window: MetricsV1TruncationWindow;
};

export type MetricsV1TimeTruncationInput = {
  behaviour: MetricsV1TruncationBehavior;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone: MetricsV1TruncationTimeZone;
  window: MetricsV1TruncationWindow;
};

export enum MetricsV1TruncationBehavior {
  TruncationBehaviorStart = 'TRUNCATION_BEHAVIOR_START',
}

export enum MetricsV1TruncationTimeZone {
  TruncationTimezoneUtc = 'TRUNCATION_TIMEZONE_UTC',
}

export enum MetricsV1TruncationWindow {
  TruncationWindowDay = 'TRUNCATION_WINDOW_DAY',
  TruncationWindowHour = 'TRUNCATION_WINDOW_HOUR',
}

export type MetricsV1Unit = {
  baseUnit?: Maybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customUnit?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<MetricsV1EntityResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
};

export enum MetricsV1UnitBaseUnit {
  Bit = 'BIT',
  Byte = 'BYTE',
  None = 'NONE',
  Percent = 'PERCENT',
  Second = 'SECOND',
}

export type MetricsV1UnitInput = {
  baseUnit?: InputMaybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ValidateDataWarehouseConfigResponse = {
  bigQueryConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseBigQueryConfigValidation>;
  redshiftConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseSnowflakeConfigValidation>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  validation: Array<MetricsV1ValidateDataWarehouseConfigResponseValidation>;
};

export type MetricsV1ValidateDataWarehouseConfigResponseBigQueryConfigValidation =
  {
    location?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseRedshiftConfigValidation =
  {
    availableSchemas: Array<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseResult =
  | Error
  | MetricsV1ValidateDataWarehouseConfigResponse;

export type MetricsV1ValidateDataWarehouseConfigResponseSnowflakeConfigValidation =
  {
    databases: Array<Scalars['String']['output']>;
    roles: Array<Scalars['String']['output']>;
    schemas: Array<Scalars['String']['output']>;
    warehouses: Array<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseValidation = {
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ValidateMetricResponse = {
  errors: Array<MetricsV1ValidateMetricResponseError>;
};

export type MetricsV1ValidateMetricResponseError = {
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ValidateMetricResponseResult =
  | Error
  | MetricsV1ValidateMetricResponse;

export type MetricsV1ValidateSnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  exposureDatabase?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ValueCap = {
  max?: Maybe<GoogleTypeDecimal>;
  min?: Maybe<GoogleTypeDecimal>;
};

export type MetricsV1ValueCapInput = {
  max?: InputMaybe<GoogleTypeDecimalInput>;
  min?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1WatermarkState = {
  automaticUpdateState?: Maybe<MetricsV1WatermarkStateAutomaticUpdateStrategyState>;
  config?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig>;
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1WatermarkStateAutomaticUpdateStrategyState = {
  count?: Maybe<Scalars['Long']['output']>;
  countTime?: Maybe<Scalars['String']['output']>;
  incrementCommitTime?: Maybe<Scalars['String']['output']>;
  updatedDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type ModuleData = {
  abtest?: Maybe<AbTestData>;
  analysis?: Maybe<AnalysisData>;
  audiences?: Maybe<AudiencesData>;
  background?: Maybe<BackgroundData>;
  c4sabtest?: Maybe<C4sAbTest>;
  c4srollout?: Maybe<C4sRollout>;
  decision?: Maybe<DecisionRecordData>;
  eptest?: Maybe<EpTest>;
  explore?: Maybe<ExploreData>;
  exposure?: Maybe<ExposureData>;
  flags?: Maybe<FlagsData>;
  hypothesis?: Maybe<HypothesisData>;
  metaanalysis?: Maybe<MetaAnalysisData>;
  metrics?: Maybe<MetricsData>;
  monitoring?: Maybe<MonitoringMetricsData>;
  observational?: Maybe<ObservationalMetricsData>;
  planning?: Maybe<PlanningData>;
  reanalysis?: Maybe<ReanalysisData>;
  remoteconfig?: Maybe<RemoteConfigData>;
  report?: Maybe<ReportData>;
  reviews?: Maybe<ReviewsData>;
  rollout?: Maybe<RolloutData>;
  samplesize?: Maybe<SampleSizeData>;
  spotifyanalysis?: Maybe<SpotifyAnalysis>;
  staticconfig?: Maybe<StaticConfig>;
  stats?: Maybe<StatsData>;
};

export type ModuleDataInput = {
  abtest?: InputMaybe<AbTestDataInput>;
  analysis?: InputMaybe<AnalysisDataInput>;
  audiences?: InputMaybe<AudiencesDataInput>;
  background?: InputMaybe<BackgroundDataInput>;
  c4sabtest?: InputMaybe<C4sAbTestInput>;
  c4srollout?: InputMaybe<C4sRolloutInput>;
  decision?: InputMaybe<DecisionRecordDataInput>;
  eptest?: InputMaybe<EpTestInput>;
  explore?: InputMaybe<ExploreDataInput>;
  exposure?: InputMaybe<ExposureDataInput>;
  flags?: InputMaybe<FlagsDataInput>;
  hypothesis?: InputMaybe<HypothesisDataInput>;
  metaanalysis?: InputMaybe<MetaAnalysisDataInput>;
  metrics?: InputMaybe<MetricsDataInput>;
  monitoring?: InputMaybe<MonitoringMetricsDataInput>;
  observational?: InputMaybe<ObservationalMetricsDataInput>;
  planning?: InputMaybe<PlanningDataInput>;
  reanalysis?: InputMaybe<ReanalysisDataInput>;
  remoteconfig?: InputMaybe<RemoteConfigDataInput>;
  report?: InputMaybe<ReportDataInput>;
  reviews?: InputMaybe<ReviewsDataInput>;
  rollout?: InputMaybe<RolloutDataInput>;
  samplesize?: InputMaybe<SampleSizeDataInput>;
  spotifyanalysis?: InputMaybe<SpotifyAnalysisInput>;
  staticconfig?: InputMaybe<StaticConfigInput>;
  stats?: InputMaybe<StatsDataInput>;
};

export type MonitoringMetricsData = {
  metrics: Array<MonitoringMetricsDataMonitoringMetric>;
  results?: Maybe<Array<MonitoringMetricsDataMonitoringMetricResult>>;
};

export type MonitoringMetricsDataInput = {
  metrics: Array<MonitoringMetricsDataInputMonitoringMetricInput>;
  results?: InputMaybe<
    Array<MonitoringMetricsDataInputMonitoringMetricResultInput>
  >;
};

export type MonitoringMetricsDataInputMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric: Scalars['String']['input'];
  preferredDirection: MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export enum MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MonitoringMetricsDataInputMonitoringMetricResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  groups: Array<MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput>;
  metric: Scalars['String']['input'];
};

export type MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput =
  {
    group: Scalars['String']['input'];
    state: MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState;
  };

export enum MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState {
  Normal = 'NORMAL',
  SignificantDecrease = 'SIGNIFICANT_DECREASE',
  SignificantIncrease = 'SIGNIFICANT_INCREASE',
}

export type MonitoringMetricsDataMonitoringMetric = {
  alpha?: Maybe<Scalars['Float']['output']>;
  metric: MetricsV1MetricResult;
  preferredDirection: MonitoringMetricsDataMonitoringMetricPreferredDirection;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export enum MonitoringMetricsDataMonitoringMetricPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MonitoringMetricsDataMonitoringMetricResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilter?: Maybe<Scalars['String']['output']>;
  groups: Array<MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResult>;
  metric: MetricsV1MetricResult;
};

export type MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResult = {
  group: Scalars['String']['output'];
  state: MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResultState;
};

export enum MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResultState {
  Normal = 'NORMAL',
  SignificantDecrease = 'SIGNIFICANT_DECREASE',
  SignificantIncrease = 'SIGNIFICANT_INCREASE',
}

export type Mutation = {
  addFlagClient?: Maybe<FlagsAdminV1FlagResult>;
  addGroupMembers?: Maybe<IamV1AddGroupMembersResponseResult>;
  addMessage?: Maybe<ConversationsV1ConversationMessageResult>;
  addSurfaceIdentityBinding?: Maybe<WorkflowV1SurfaceIdentityBindingResult>;
  allocateSegment?: Maybe<FlagsAdminV1SegmentResult>;
  answerQuestions?: Maybe<OnboardingV1LearningProgressResult>;
  applyMetricsSync?: Maybe<MetricsV1ApplyMetricsSyncResponseResult>;
  archiveFlag?: Maybe<FlagsAdminV1FlagResult>;
  archiveManagedWorkspace?: Maybe<AiworkflowsV1ArchiveManagedWorkspaceResponseResult>;
  archiveMetric?: Maybe<MetricsV1MetricResult>;
  archiveReview?: Maybe<CollaborationV1ArchiveReviewResponseResult>;
  archiveSegment?: Maybe<FlagsAdminV1SegmentResult>;
  backfillPromptHooks?: Maybe<CollaborationV1BackfillPromptHooksResponseResult>;
  batchDownloadRecording?: Maybe<RecordingV1BatchDownloadRecordingResponseResult>;
  cancelAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  cancelIssueReview?: Maybe<ObservationsV1IssueResult>;
  cancelMaterializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  cancelMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  cancelScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  cancelScheduledMaterializedSegmentLoadJob?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  cancelScheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  cancelScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  cancelSqlJob?: Maybe<MetricsV1SqlJobResult>;
  capturePulseBlock?: Maybe<PulseV1CapturePulseBlockResponseResult>;
  checkPermissions?: Maybe<WorkflowV1CheckPermissionsResponseResult>;
  checkSdkCompatibility?: Maybe<InsightsV1CheckSdkCompatibilityResponseResult>;
  clearChat?: Maybe<ConversationsV2ChatResult>;
  cloneWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  closeIssue?: Maybe<ObservationsV1IssueResult>;
  completeTask?: Maybe<ObservationsV1TaskResult>;
  computeSegmentSpaceCalendar?: Maybe<FlagsAdminV1ComputeSegmentSpaceCalendarResponseResult>;
  configurePulseRefreshSchedule?: Maybe<PulseV1ConfigurePulseRefreshScheduleResponseResult>;
  configurePulseSubscription?: Maybe<PulseV1ConfigurePulseSubscriptionResponseResult>;
  configureSlack?: Maybe<ActivityV1SlackAdminConfigResult>;
  confirmTool?: Maybe<ConversationsV2ConfirmToolResponseResult>;
  createAgent?: Maybe<IamV1AgentResult>;
  createAgentReviewPreview?: Maybe<CollaborationV1AgentReviewPreviewResult>;
  createAiWorkflowInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  createAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  createAiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  createAnalysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  createApiClient?: Maybe<IamV1ApiClientResult>;
  createAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  createAttachment?: Maybe<CollaborationV1AttachmentResult>;
  createChat?: Maybe<ConversationsV2ChatResult>;
  createCleanupTasks?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  createClient?: Maybe<IamV1ClientResult>;
  createClientCredential?: Maybe<IamV1ClientCredentialResult>;
  createCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  createCollection?: Maybe<CollectionsV1CollectionResult>;
  createCollectionEntry?: Maybe<CollectionsV1CollectionEntryResult>;
  createComment?: Maybe<CollaborationV1CommentResult>;
  createCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  createConversation?: Maybe<ConversationsV1ConversationResult>;
  createCryptoKey?: Maybe<IamV1CryptoKeyResult>;
  createDashboard?: Maybe<InsightsV1DashboardResult>;
  createDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  createDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  createEntity?: Maybe<MetricsV1EntityResult>;
  createEntityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  createEntityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  createEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  createEvaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  createEventConnection?: Maybe<ConnectorsV1EventConnectionResult>;
  createEventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  createExclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  createExposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  createExposureTable?: Maybe<MetricsV1ExposureTableResult>;
  createExternalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  createExternalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  createFactTable?: Maybe<MetricsV1FactTableResult>;
  createFeed?: Maybe<ActivityV1FeedResult>;
  createFlag?: Maybe<FlagsAdminV1FlagResult>;
  createFlagAppliedConnection?: Maybe<ConnectorsV1FlagAppliedConnectionResult>;
  createGroup?: Maybe<IamV1GroupResult>;
  createHoldback?: Maybe<WorkflowV1HoldbackResult>;
  createInitiative?: Maybe<WorkflowV1InitiativeResult>;
  createInsightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  createInsightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  createIssue?: Maybe<ObservationsV1IssueResult>;
  createLabel?: Maybe<AdminLabelsV1LabelResult>;
  createManagedDataWarehouse?: Maybe<OnboardingV1ManagedDataWarehouseProvisioningResult>;
  createMaterializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  createMaterializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  createMeasurement?: Maybe<MetricsV1MeasurementResult>;
  createMetric?: Maybe<MetricsV1MetricResult>;
  createMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  createOAuthApp?: Maybe<IamV1OAuthAppResult>;
  createObservation?: Maybe<ObservationsV1ObservationResult>;
  createPartition?: Maybe<MetricsV1PartitionResult>;
  createPlatformConnection?: Maybe<ConnectorsV1PlatformConnectionResult>;
  createPolicy?: Maybe<IamV1PolicyResult>;
  createPresence?: Maybe<CollaborationV1PresenceResult>;
  createProject?: Maybe<CollaborationV1ProjectResult>;
  createPromptHook?: Maybe<ConversationsV2PromptHookResult>;
  createPulse?: Maybe<PulseV1PulseResult>;
  createPulseBlock?: Maybe<PulseV1PulseBlockResult>;
  createReaction?: Maybe<CollaborationV1ReactionResult>;
  createRecordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  createRecordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  createResourcePermission?: Maybe<FgaV1ResourcePermissionResult>;
  createReview?: Maybe<CollaborationV1ReviewResult>;
  createRole?: Maybe<IamV1RoleResult>;
  createRule?: Maybe<FlagsAdminV1FlagRuleResult>;
  createScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  createScheduledMaterializedSegmentLoadJob?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  createScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  createSegment?: Maybe<FlagsAdminV1SegmentResult>;
  createSurface?: Maybe<WorkflowV1SurfaceResult>;
  createTask?: Maybe<ObservationsV1TaskResult>;
  createTheme?: Maybe<ObservationsV1ThemeResult>;
  createUserInvitation?: Maybe<IamV1UserInvitationResult>;
  createVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  createWorkflow?: Maybe<WorkflowV1WorkflowResult>;
  createWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  createWorkflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  createWorkflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  createWorkflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  deleteAgent?: Maybe<GoogleProtobufEmptyResult>;
  deleteAiWorkflowTrigger?: Maybe<GoogleProtobufEmptyResult>;
  deleteAnalysisResult?: Maybe<GoogleProtobufEmptyResult>;
  deleteApiClient?: Maybe<GoogleProtobufEmptyResult>;
  deleteAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  deleteAttachment?: Maybe<CollaborationV1AttachmentResult>;
  deleteChat?: Maybe<GoogleProtobufEmptyResult>;
  deleteCheck?: Maybe<GoogleProtobufEmptyResult>;
  deleteClient?: Maybe<GoogleProtobufEmptyResult>;
  deleteClientCredential?: Maybe<GoogleProtobufEmptyResult>;
  deleteCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  deleteCollection?: Maybe<GoogleProtobufEmptyResult>;
  deleteCollectionEntry?: Maybe<GoogleProtobufEmptyResult>;
  deleteComment?: Maybe<CollaborationV1CommentResult>;
  deleteCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  deleteConversation?: Maybe<GoogleProtobufEmptyResult>;
  deleteCryptoKey?: Maybe<IamV1CryptoKeyResult>;
  deleteDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  deleteEntity?: Maybe<GoogleProtobufEmptyResult>;
  deleteEntityIdentityBinding?: Maybe<GoogleProtobufEmptyResult>;
  deleteEntityRelationTable?: Maybe<GoogleProtobufEmptyResult>;
  deleteEnvironment?: Maybe<GoogleProtobufEmptyResult>;
  deleteEvaluationContextFieldOverride?: Maybe<GoogleProtobufEmptyResult>;
  deleteEventConnection?: Maybe<GoogleProtobufEmptyResult>;
  deleteEventDefinition?: Maybe<GoogleProtobufEmptyResult>;
  deleteExclusivityGroup?: Maybe<GoogleProtobufEmptyResult>;
  deleteExposureTable?: Maybe<GoogleProtobufEmptyResult>;
  deleteExternalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  deleteExternalIntegration?: Maybe<GoogleProtobufEmptyResult>;
  deleteFactTable?: Maybe<MetricsV1FactTableResult>;
  deleteFeed?: Maybe<GoogleProtobufEmptyResult>;
  deleteFlagAppliedConnection?: Maybe<GoogleProtobufEmptyResult>;
  deleteGroup?: Maybe<GoogleProtobufEmptyResult>;
  deleteHoldback?: Maybe<GoogleProtobufEmptyResult>;
  deleteInitiative?: Maybe<GoogleProtobufEmptyResult>;
  deleteInsightsDocument?: Maybe<GoogleProtobufEmptyResult>;
  deleteIssue?: Maybe<GoogleProtobufEmptyResult>;
  deleteLabel?: Maybe<GoogleProtobufEmptyResult>;
  deleteMaterializedSegment?: Maybe<GoogleProtobufEmptyResult>;
  deleteMeasurement?: Maybe<MetricsV1MeasurementResult>;
  deleteMetric?: Maybe<MetricsV1MetricResult>;
  deleteOAuthApp?: Maybe<GoogleProtobufEmptyResult>;
  deleteObservation?: Maybe<GoogleProtobufEmptyResult>;
  deletePartition?: Maybe<GoogleProtobufEmptyResult>;
  deletePlatformConnection?: Maybe<GoogleProtobufEmptyResult>;
  deletePolicy?: Maybe<GoogleProtobufEmptyResult>;
  deletePresence?: Maybe<GoogleProtobufEmptyResult>;
  deleteProject?: Maybe<GoogleProtobufEmptyResult>;
  deletePromptHook?: Maybe<GoogleProtobufEmptyResult>;
  deletePulse?: Maybe<GoogleProtobufEmptyResult>;
  deletePulseBlock?: Maybe<GoogleProtobufEmptyResult>;
  deleteReaction?: Maybe<GoogleProtobufEmptyResult>;
  deleteRecordingPolicy?: Maybe<GoogleProtobufEmptyResult>;
  deleteRecordingRule?: Maybe<GoogleProtobufEmptyResult>;
  deleteResourcePermission?: Maybe<GoogleProtobufEmptyResult>;
  deleteReview?: Maybe<GoogleProtobufEmptyResult>;
  deleteReviewResponse?: Maybe<CollaborationV1ReviewResponseResult>;
  deleteRole?: Maybe<GoogleProtobufEmptyResult>;
  deleteRule?: Maybe<GoogleProtobufEmptyResult>;
  deleteScheduledMetricCalculation?: Maybe<GoogleProtobufEmptyResult>;
  deleteSurface?: Maybe<GoogleProtobufEmptyResult>;
  deleteTask?: Maybe<GoogleProtobufEmptyResult>;
  deleteTheme?: Maybe<GoogleProtobufEmptyResult>;
  deleteUser?: Maybe<GoogleProtobufEmptyResult>;
  deleteUserInvitation?: Maybe<GoogleProtobufEmptyResult>;
  deleteVariant?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowInstance?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowSecret?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowTemplate?: Maybe<GoogleProtobufEmptyResult>;
  deriveClientEvaluationContextSchema?: Maybe<FlagsAdminV1DeriveClientEvaluationContextSchemaResponseResult>;
  describeAssignmentTable?: Maybe<MetricsV1DescribeAssignmentTableResponseResult>;
  disableSlack?: Maybe<GoogleProtobufEmptyResult>;
  discardDraftEvent?: Maybe<GoogleProtobufEmptyResult>;
  evictPulseBlockCache?: Maybe<GoogleProtobufEmptyResult>;
  executeCheck?: Maybe<FgaV1ExecuteCheckResponseResult>;
  executeFunction?: Maybe<WorkflowV1ExecuteFunctionResponseResult>;
  executeSql?: Maybe<InsightsV1ExecuteSqlResponseResult>;
  extractKnowledge?: Maybe<GoogleProtobufEmptyResult>;
  extractObservations?: Maybe<ObservationsV1ExtractObservationsResponseResult>;
  followResources?: Maybe<GoogleProtobufEmptyResult>;
  generateClientCredentialEncryptionKey?: Maybe<IamV1GenerateClientCredentialEncryptionKeyResponseResult>;
  generateCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  initiateImageUpload?: Maybe<WorkflowV1InitiateImageUploadResponseResult>;
  initiateTarUpload?: Maybe<WorkflowV1InitiateTarUploadResponseResult>;
  instantiateGithubInstallation?: Maybe<AiworkflowsV1InstantiateGithubInstallationResponseResult>;
  instantiateIntercomInstallation?: Maybe<AiworkflowsV1InstantiateIntercomInstallationResponseResult>;
  interruptChat?: Maybe<ConversationsV2ChatEventResult>;
  markFeedEntriesAsRead?: Maybe<GoogleProtobufEmptyResult>;
  pauseAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  previewAgentReview?: Maybe<CollaborationV1PreviewAgentReviewResponseResult>;
  previewInsightsMetric?: Maybe<InsightsV1PreviewInsightsMetricResponseResult>;
  previewPulseBlock?: Maybe<PulseV1PulseBlockResult>;
  previewSqlQuery?: Maybe<MetricsV1PreviewSqlQueryResponseResult>;
  promotePrimaryDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  provideTaskInput?: Maybe<ObservationsV1TaskResult>;
  publishCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  publishMetric?: Maybe<MetricsV1MetricResult>;
  rangeQuery?: Maybe<InsightsV1QueryResponseResult>;
  refreshPulse?: Maybe<PulseV1RefreshPulseResponseResult>;
  refreshPulseBlock?: Maybe<PulseV1RefreshPulseBlockResponseResult>;
  registerAccountDomain?: Maybe<AdminV1AccountDomainResult>;
  registerManagedWorkspace?: Maybe<AiworkflowsV1ManagedWorkspaceResult>;
  removeClientCredentialEncryptionKey?: Maybe<IamV1ClientCredentialResult>;
  removeDemoData?: Maybe<GoogleProtobufEmptyResult>;
  removeFlagClient?: Maybe<FlagsAdminV1FlagResult>;
  removeGroupMembers?: Maybe<IamV1RemoveGroupMembersResponseResult>;
  removeSurfaceIdentityBinding?: Maybe<GoogleProtobufEmptyResult>;
  reopenIssue?: Maybe<ObservationsV1IssueResult>;
  reorderRecordingRules?: Maybe<GoogleProtobufEmptyResult>;
  requestIssueReview?: Maybe<ObservationsV1IssueResult>;
  requestReviewResponses?: Maybe<CollaborationV1RequestReviewResponsesResponseResult>;
  requestTaskInput?: Maybe<ObservationsV1TaskResult>;
  resolveFlagsVerbose?: Maybe<FlagsResolverAdminV1ResolveFlagsVerboseResponseResult>;
  resumeAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  resumeScheduledMaterializedSegmentLoadJob?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  resumeScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  retriggerAllScheduledMetricCalculations?: Maybe<MetricsV1RetriggerAllScheduledMetricCalculationsResponseResult>;
  retriggerMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  retriggerScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  retriggerScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  reviewIssue?: Maybe<ObservationsV1IssueResult>;
  segmentAvailableSpace?: Maybe<FlagsAdminV1SegmentAvailableSpaceResponseResult>;
  sendUserMessage?: Maybe<ConversationsV2ChatEventResult>;
  staleReview?: Maybe<CollaborationV1StaleReviewResponseResult>;
  startCheckoutSession?: Maybe<BillingV1CheckoutSessionResult>;
  startCustomerPortalSession?: Maybe<BillingV1CustomerPortalSessionResult>;
  startInvestigation?: Maybe<ObservationsV1ThemeResult>;
  startIssue?: Maybe<ObservationsV1IssueResult>;
  startTask?: Maybe<ObservationsV1TaskResult>;
  storeSlackUserInfo?: Maybe<IamV1StoreSlackUserInfoResponseResult>;
  submitRecordingFeedback?: Maybe<GoogleProtobufEmptyResult>;
  submitReviewResponse?: Maybe<CollaborationV1SubmitReviewResponseResponseResult>;
  suggestFactTableColumns?: Maybe<MetricsV1SuggestFactTableColumnsResponseResult>;
  suggestMetric?: Maybe<MetricsV1SuggestMetricResponseResult>;
  syncInsightsTableContexts?: Maybe<InsightsV1SyncInsightsTableContextsResponseResult>;
  takeSuggestedAction?: Maybe<ObservationsV1IssueResult>;
  testWebhook?: Maybe<ActivityV1TestWebhookResponseResult>;
  transitionWorkflowInstance?: Maybe<WorkflowV1TransitionWorkflowInstanceResponseResult>;
  unarchiveFlag?: Maybe<FlagsAdminV1FlagResult>;
  unarchiveMetric?: Maybe<MetricsV1MetricResult>;
  undeleteEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  undeleteFactTable?: Maybe<MetricsV1FactTableResult>;
  undoReaction?: Maybe<CollaborationV1UndoReactionResponseResult>;
  unfollowResources?: Maybe<GoogleProtobufEmptyResult>;
  unpublishCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  unregisterAccountDomain?: Maybe<GoogleProtobufEmptyResult>;
  updateAgent?: Maybe<IamV1AgentResult>;
  updateAiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  updateAnalysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  updateApiClient?: Maybe<IamV1ApiClientResult>;
  updateAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  updateAttachment?: Maybe<CollaborationV1AttachmentResult>;
  updateChat?: Maybe<ConversationsV2ChatResult>;
  updateChatEvent?: Maybe<ConversationsV2ChatEventResult>;
  updateCheck?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  updateClient?: Maybe<IamV1ClientResult>;
  updateClientCredential?: Maybe<IamV1ClientCredentialResult>;
  updateCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  updateCollection?: Maybe<CollectionsV1CollectionResult>;
  updateComment?: Maybe<CollaborationV1CommentResult>;
  updateCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  updateConversation?: Maybe<ConversationsV1ConversationResult>;
  updateConversationMessage?: Maybe<ConversationsV1ConversationMessageResult>;
  updateDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  updateDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  updateEntity?: Maybe<MetricsV1EntityResult>;
  updateEntityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  updateEntityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  updateEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  updateEvaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  updateEventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  updateExclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  updateExposureTable?: Maybe<MetricsV1ExposureTableResult>;
  updateExternalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  updateExternalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  updateFactTable?: Maybe<MetricsV1FactTableResult>;
  updateFeed?: Maybe<ActivityV1FeedResult>;
  updateFlag?: Maybe<FlagsAdminV1FlagResult>;
  updateGroup?: Maybe<IamV1GroupResult>;
  updateHoldback?: Maybe<WorkflowV1HoldbackResult>;
  updateInitiative?: Maybe<WorkflowV1InitiativeResult>;
  updateInsightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  updateInsightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  updateInsightsTableContext?: Maybe<InsightsV1InsightsTableContextResult>;
  updateIssue?: Maybe<ObservationsV1IssueResult>;
  updateIssuesConfig?: Maybe<ObservationsV1IssuesConfigResult>;
  updateLabel?: Maybe<AdminLabelsV1LabelResult>;
  updateLearningProgress?: Maybe<OnboardingV1LearningProgressResult>;
  updateMaterializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  updateMeasurement?: Maybe<MetricsV1MeasurementResult>;
  updateMetric?: Maybe<MetricsV1MetricResult>;
  updateOAuthApp?: Maybe<IamV1OAuthAppResult>;
  updateObservation?: Maybe<ObservationsV1ObservationResult>;
  updateOnboardingSetup?: Maybe<OnboardingV1OnboardingSetupResult>;
  updatePolicy?: Maybe<IamV1PolicyResult>;
  updatePresence?: Maybe<CollaborationV1PresenceResult>;
  updateProject?: Maybe<CollaborationV1ProjectResult>;
  updatePromptHook?: Maybe<ConversationsV2PromptHookResult>;
  updatePulse?: Maybe<PulseV1PulseResult>;
  updatePulseBlock?: Maybe<PulseV1PulseBlockResult>;
  updateRecordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  updateRecordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  updateReview?: Maybe<CollaborationV1ReviewResult>;
  updateRole?: Maybe<IamV1RoleResult>;
  updateRule?: Maybe<FlagsAdminV1FlagRuleResult>;
  updateScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  updateScheduledMaterializedSegmentLoadJob?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  updateScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  updateSegment?: Maybe<FlagsAdminV1SegmentResult>;
  updateSurface?: Maybe<WorkflowV1SurfaceResult>;
  updateTask?: Maybe<ObservationsV1TaskResult>;
  updateTheme?: Maybe<ObservationsV1ThemeResult>;
  updateTourPreferences?: Maybe<OnboardingV1TourPreferencesResult>;
  updateUser?: Maybe<IamV1UserResult>;
  updateVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  updateWorkflow?: Maybe<WorkflowV1WorkflowResult>;
  updateWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  updateWorkflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  updateWorkflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  upgradeWorkflowInstances?: Maybe<WorkflowV1UpgradeWorkflowInstancesResponseResult>;
  validateDataWarehouseConfig?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseResult>;
  validateEventConnectionConfig?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseResult>;
  validateFlagAppliedConnectionConfig?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseResult>;
  validateMetric?: Maybe<MetricsV1ValidateMetricResponseResult>;
  validatePlatformConnectionConfig?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponseResult>;
  verifyAccountDomain?: Maybe<AdminV1AccountDomainResult>;
  verifyMetric?: Maybe<MetricsV1MetricResult>;
  writeDemoData?: Maybe<GoogleProtobufEmptyResult>;
  writeFlagAssigned?: Maybe<FlagsAdminV1WriteFlagAssignedResponseResult>;
  writeResolveInfo?: Maybe<FlagsAdminV1WriteResolveInfoResponseResult>;
  writeResourcePermissions?: Maybe<FgaV1WriteResourcePermissionsResponseResult>;
};

export type MutationAddFlagClientArgs = {
  client: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

export type MutationAddGroupMembersArgs = {
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']>;
};

export type MutationAddMessageArgs = {
  message: ConversationsV1ConversationMessageInput;
  parent: Scalars['String']['input'];
};

export type MutationAddSurfaceIdentityBindingArgs = {
  parent: Scalars['String']['input'];
  surfaceIdentityBinding: WorkflowV1SurfaceIdentityBindingInput;
};

export type MutationAllocateSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationAnswerQuestionsArgs = {
  course: Scalars['String']['input'];
  questionUpdates: Array<OnboardingV1AnswerQuestionsRequestQuestionUpdateInput>;
};

export type MutationApplyMetricsSyncArgs = {
  adoptFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
  resources?: InputMaybe<
    Array<MetricsV1ApplyMetricsSyncRequestSyncResourceInput>
  >;
};

export type MutationArchiveFlagArgs = {
  name: Scalars['String']['input'];
};

export type MutationArchiveManagedWorkspaceArgs = {
  account: Scalars['String']['input'];
};

export type MutationArchiveMetricArgs = {
  archiveInfo?: InputMaybe<MetricsV1MetricArchiveInfoInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationArchiveReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationArchiveSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationBatchDownloadRecordingArgs = {
  names: Array<Scalars['String']['input']>;
};

export type MutationCancelAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelIssueReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelSqlJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationCapturePulseBlockArgs = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  selectedContent?: InputMaybe<Scalars['String']['input']>;
  sourceChat?: InputMaybe<Scalars['String']['input']>;
  sourceEvent?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationCheckPermissionsArgs = {
  workflowInstance: Scalars['String']['input'];
};

export type MutationCheckSdkCompatibilityArgs = {
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationClearChatArgs = {
  name: Scalars['String']['input'];
};

export type MutationCloneWorkflowInstanceArgs = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationCloseIssueArgs = {
  closeReason: ObservationsV1IssueCloseReason;
  name: Scalars['String']['input'];
};

export type MutationCompleteTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationComputeSegmentSpaceCalendarArgs = {
  endDate: GoogleTypeDateInput;
  segments?: InputMaybe<Array<FlagsAdminV1SegmentScheduleInput>>;
  startDate: GoogleTypeDateInput;
};

export type MutationConfigurePulseRefreshScheduleArgs = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  hour?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  pulse: Scalars['String']['input'];
  schedule: PulseV1PulseRefreshSchedule;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationConfigurePulseSubscriptionArgs = {
  pulse: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
  subscription: PulseV1PulseSubscriptionInput;
};

export type MutationConfigureSlackArgs = {
  code: Scalars['String']['input'];
  stateToken: Scalars['String']['input'];
};

export type MutationConfirmToolArgs = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  name: Scalars['String']['input'];
};

export type MutationCreateAgentArgs = {
  agent: IamV1AgentInput;
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAgentReviewPreviewArgs = {
  agentReviewPreview: CollaborationV1AgentReviewPreviewInput;
  agentReviewPreviewId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowInstanceArgs = {
  aiWorkflowInstance: AiworkflowsV1AiWorkflowInstanceInput;
  aiWorkflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowScheduleArgs = {
  aiWorkflowSchedule: AiworkflowsV1AiWorkflowScheduleInput;
  aiWorkflowScheduleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowTriggerArgs = {
  aiWorkflowTrigger: AiworkflowsV1AiWorkflowTriggerInput;
  aiWorkflowTriggerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAnalysisResultArgs = {
  analysisResult: StatsV2AnalysisAnalysisResultInput;
  analysisResultId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateApiClientArgs = {
  apiClient: IamV1ApiClientInput;
  apiClientId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAssignmentTableArgs = {
  assignmentTable: MetricsV1AssignmentTableInput;
  assignmentTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAttachmentArgs = {
  attachment: CollaborationV1AttachmentInput;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateChatArgs = {
  chat: ConversationsV2ChatInput;
  chatId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCleanupTasksArgs = {
  name: Scalars['String']['input'];
  targets: Array<AiworkflowsV1CleanupTargetInput>;
};

export type MutationCreateClientArgs = {
  client: IamV1ClientInput;
};

export type MutationCreateClientCredentialArgs = {
  clientCredential: IamV1ClientCredentialInput;
  parent: Scalars['String']['input'];
};

export type MutationCreateCollaborativeDocumentArgs = {
  collaborativeDocument: CollaborationV1CollaborativeDocumentInput;
  collaborativeDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCollectionArgs = {
  collection: CollectionsV1CollectionInput;
  collectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCollectionEntryArgs = {
  collectionEntry: CollectionsV1CollectionEntryInput;
  parent: Scalars['String']['input'];
};

export type MutationCreateCommentArgs = {
  comment: CollaborationV1CommentInput;
  commentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCommentReplyArgs = {
  commentReply: CollaborationV1CommentReplyInput;
  commentReplyId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateConversationArgs = {
  conversation: ConversationsV1ConversationInput;
};

export type MutationCreateCryptoKeyArgs = {
  cryptoKey: IamV1CryptoKeyInput;
  cryptoKeyId: Scalars['String']['input'];
};

export type MutationCreateDashboardArgs = {
  dashboard: InsightsV1DashboardInput;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDataWarehouseArgs = {
  dataWarehouse: MetricsV1DataWarehouseInput;
  dataWarehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDimensionTableArgs = {
  dimensionTable: MetricsV1DimensionTableInput;
  dimensionTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEntityArgs = {
  entity: MetricsV1EntityInput;
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEntityIdentityBindingArgs = {
  entityIdentityBinding: MetricsV1EntityIdentityBindingInput;
  entityIdentityBindingId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateEntityRelationTableArgs = {
  entityRelationTable: MetricsV1EntityRelationTableInput;
  entityRelationTableId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateEnvironmentArgs = {
  environment: FlagsAdminV1EnvironmentInput;
  environmentId: Scalars['String']['input'];
};

export type MutationCreateEvaluationContextFieldOverrideArgs = {
  evaluationContextFieldOverride: FlagsAdminV1EvaluationContextFieldOverrideInput;
  evaluationContextFieldOverrideId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEventConnectionArgs = {
  eventConnection: ConnectorsV1EventConnectionInput;
  eventConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEventDefinitionArgs = {
  eventDefinition: EventsAdminV1EventDefinitionInput;
  eventDefinitionId: Scalars['String']['input'];
};

export type MutationCreateExclusivityGroupArgs = {
  exclusivityGroup: WorkflowV1ExclusivityGroupInput;
  exclusivityGroupId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
};

export type MutationCreateExposureCalculationArgs = {
  exposureCalculation: MetricsV1ExposureCalculationInput;
  exposureCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExposureTableArgs = {
  exposureTable: MetricsV1ExposureTableInput;
  exposureTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExternalDocumentArgs = {
  externalDocument: CollaborationV1ExternalDocumentInput;
  externalDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExternalIntegrationArgs = {
  externalIntegration: AiworkflowsV1ExternalIntegrationInput;
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFactTableArgs = {
  factTable: MetricsV1FactTableInput;
  factTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFeedArgs = {
  feed: ActivityV1FeedInput;
  feedId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFlagArgs = {
  flag: FlagsAdminV1FlagInput;
  flagId: Scalars['String']['input'];
};

export type MutationCreateFlagAppliedConnectionArgs = {
  flagAppliedConnection: ConnectorsV1FlagAppliedConnectionInput;
  flagAppliedConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateGroupArgs = {
  group: IamV1GroupInput;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateHoldbackArgs = {
  holdback: WorkflowV1HoldbackInput;
  holdbackId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
};

export type MutationCreateInitiativeArgs = {
  initiative: WorkflowV1InitiativeInput;
  initiativeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateInsightsDocumentArgs = {
  insightsDocument: InsightsV1InsightsDocumentInput;
  insightsDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateInsightsMetricArgs = {
  insightsMetric: InsightsV1InsightsMetricInput;
  insightsMetricId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateIssueArgs = {
  issue: ObservationsV1IssueInput;
  issueId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateLabelArgs = {
  label: AdminLabelsV1LabelInput;
  labelId: Scalars['String']['input'];
};

export type MutationCreateMaterializedSegmentArgs = {
  materializedSegment: FlagsAdminV1MaterializedSegmentInput;
  materializedSegmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMaterializedSegmentLoadJobArgs = {
  materializedSegmentLoadJob: MaterializerV1MaterializedSegmentLoadJobInput;
  materializedSegmentLoadJobId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateMeasurementArgs = {
  measurement: MetricsV1MeasurementInput;
  measurementId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMetricArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  metric: MetricsV1MetricInput;
  metricId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMetricCalculationArgs = {
  metricCalculation: MetricsV1MetricCalculationInput;
  metricCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOAuthAppArgs = {
  oAuthAppId?: InputMaybe<Scalars['String']['input']>;
  oauthApp: IamV1OAuthAppInput;
};

export type MutationCreateObservationArgs = {
  observation: ObservationsV1ObservationInput;
  observationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePartitionArgs = {
  parent: Scalars['String']['input'];
  partition: MetricsV1PartitionInput;
};

export type MutationCreatePlatformConnectionArgs = {
  platformConnection: ConnectorsV1PlatformConnectionInput;
  platformConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePolicyArgs = {
  policy: IamV1PolicyInput;
  policyId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePresenceArgs = {
  presence: CollaborationV1PresenceInput;
  presenceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateProjectArgs = {
  project: CollaborationV1ProjectInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePromptHookArgs = {
  promptHook: ConversationsV2PromptHookInput;
  promptHookId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePulseArgs = {
  pulse: PulseV1PulseInput;
  pulseId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePulseBlockArgs = {
  parent: Scalars['String']['input'];
  pulseBlock: PulseV1PulseBlockInput;
  pulseBlockId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateReactionArgs = {
  reaction: CollaborationV1ReactionInput;
  reactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRecordingPolicyArgs = {
  recordingPolicy: RecordingV1RecordingPolicyInput;
  recordingPolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRecordingRuleArgs = {
  parent: Scalars['String']['input'];
  recordingRule: RecordingV1RecordingRuleInput;
  recordingRuleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateResourcePermissionArgs = {
  resourcePermission: FgaV1ResourcePermissionInput;
};

export type MutationCreateReviewArgs = {
  review: CollaborationV1ReviewInput;
  reviewId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRoleArgs = {
  role: IamV1RoleInput;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRuleArgs = {
  parent: Scalars['String']['input'];
  rule: FlagsAdminV1FlagRuleInput;
  ruleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScheduledExposureCalculationArgs = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculationInput;
  scheduledExposureCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScheduledMaterializedSegmentLoadJobArgs = {
  parent: Scalars['String']['input'];
  scheduledMaterializedSegmentLoadJob: MaterializerV1ScheduledMaterializedSegmentLoadJobInput;
  scheduledMaterializedSegmentLoadJobId?: InputMaybe<
    Scalars['String']['input']
  >;
};

export type MutationCreateScheduledMetricCalculationArgs = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculationInput;
  scheduledMetricCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSegmentArgs = {
  segment: FlagsAdminV1SegmentInput;
  segmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSurfaceArgs = {
  surface: WorkflowV1SurfaceInput;
  surfaceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTaskArgs = {
  task: ObservationsV1TaskInput;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateThemeArgs = {
  theme: ObservationsV1ThemeInput;
  themeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateUserInvitationArgs = {
  userInvitation: IamV1UserInvitationInput;
};

export type MutationCreateVariantArgs = {
  parent: Scalars['String']['input'];
  variant: FlagsAdminV1FlagVariantInput;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowArgs = {
  workflow: WorkflowV1WorkflowInput;
  workflowId: Scalars['String']['input'];
};

export type MutationCreateWorkflowInstanceArgs = {
  parent: Scalars['String']['input'];
  workflowInstance: WorkflowV1WorkflowInstanceInput;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowSecretArgs = {
  workflowSecret: WorkflowV1WorkflowSecretInput;
  workflowSecretId: Scalars['String']['input'];
};

export type MutationCreateWorkflowTemplateArgs = {
  workflowTemplate: WorkflowV1WorkflowTemplateInput;
  workflowTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowVersionArgs = {
  parent: Scalars['String']['input'];
  workflowVersion: WorkflowV1WorkflowVersionInput;
};

export type MutationDeleteAgentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAiWorkflowTriggerArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAnalysisResultArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteApiClientArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAssignmentTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAttachmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteChatArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCheckArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteClientArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteClientCredentialArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCollaborativeDocumentArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCollectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCollectionEntryArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCommentArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCommentReplyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteConversationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCryptoKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteDimensionTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityRelationTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEvaluationContextFieldOverrideArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEventConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEventDefinitionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExclusivityGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExposureTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExternalDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExternalIntegrationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteFactTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteFeedArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteFlagAppliedConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteHoldbackArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteInitiativeArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteInsightsDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteIssueArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteLabelArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteMaterializedSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteMeasurementArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteOAuthAppArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteObservationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePartitionArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeletePlatformConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePolicyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePresenceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteProjectArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePromptHookArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePulseArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeletePulseBlockArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteReactionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRecordingPolicyArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteRecordingRuleArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteResourcePermissionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteReviewArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteReviewResponseArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRuleArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteScheduledMetricCalculationArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteSurfaceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteThemeArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteUserArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteUserInvitationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteVariantArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowSecretArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowTemplateArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeriveClientEvaluationContextSchemaArgs = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  mustMatchSchema?: InputMaybe<FlagsAdminV1EvaluationContextSchemaInput>;
};

export type MutationDescribeAssignmentTableArgs = {
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type MutationDiscardDraftEventArgs = {
  name: Scalars['String']['input'];
};

export type MutationEvictPulseBlockCacheArgs = {
  name: Scalars['String']['input'];
};

export type MutationExecuteCheckArgs = {
  resourceRelations: Array<FgaV1ResourceRelationInput>;
};

export type MutationExecuteFunctionArgs = {
  functionName: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type MutationExecuteSqlArgs = {
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type MutationExtractKnowledgeArgs = {
  fragments: Array<CollaborationV1KnowledgeFragmentInput>;
  parent: Scalars['String']['input'];
};

export type MutationExtractObservationsArgs = {
  content: Scalars['String']['input'];
  eventTime?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source: ObservationsV1SourceInput;
};

export type MutationFollowResourcesArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']>;
};

export type MutationGenerateClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationGenerateCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationInitiateTarUploadArgs = {
  extension?: InputMaybe<Scalars['String']['input']>;
  fileSizeBytes: Scalars['Int']['input'];
};

export type MutationInterruptChatArgs = {
  name: Scalars['String']['input'];
};

export type MutationMarkFeedEntriesAsReadArgs = {
  entries?: InputMaybe<ActivityV1MarkFeedEntriesAsReadRequestFeedEntriesInput>;
  markRead?: InputMaybe<ActivityV1MarkFeedEntriesAsReadRequestMarkReadTimeInput>;
};

export type MutationPauseAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationPreviewAgentReviewArgs = {
  agent: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type MutationPreviewInsightsMetricArgs = {
  dataSource: Scalars['String']['input'];
  expression: InsightsV1ArithmeticExpressionInput;
  filter?: InputMaybe<InsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  timeConfig?: InputMaybe<InsightsV1TimeConfigInput>;
};

export type MutationPreviewPulseBlockArgs = {
  pulseBlock: PulseV1PulseBlockInput;
};

export type MutationPreviewSqlQueryArgs = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type MutationPromotePrimaryDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type MutationProvideTaskInputArgs = {
  inputResponse: ObservationsV1InputResponseInput;
  name: Scalars['String']['input'];
};

export type MutationPublishCollaborativeDocumentArgs = {
  activityMessage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publisher?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationRangeQueryArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  graph: InsightsV1GraphType;
  labelFilters?: InputMaybe<
    Array<InsightsV1RangeQueryRequestLabelFiltersEntryInput>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefreshPulseArgs = {
  pulse: Scalars['String']['input'];
};

export type MutationRefreshPulseBlockArgs = {
  pulseBlock: Scalars['String']['input'];
};

export type MutationRegisterAccountDomainArgs = {
  accountDomain: AdminV1AccountDomainInput;
};

export type MutationRegisterManagedWorkspaceArgs = {
  account: Scalars['String']['input'];
};

export type MutationRemoveClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationRemoveFlagClientArgs = {
  client: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

export type MutationRemoveGroupMembersArgs = {
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']>;
};

export type MutationRemoveSurfaceIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type MutationReopenIssueArgs = {
  name: Scalars['String']['input'];
};

export type MutationReorderRecordingRulesArgs = {
  parent: Scalars['String']['input'];
  rules: Array<Scalars['String']['input']>;
};

export type MutationRequestIssueReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationRequestReviewResponsesArgs = {
  name: Scalars['String']['input'];
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationRequestTaskInputArgs = {
  inputRequest: ObservationsV1InputRequestInput;
  name: Scalars['String']['input'];
};

export type MutationResolveFlagsVerboseArgs = {
  clientSecret: Scalars['String']['input'];
  evaluationContext?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationResumeAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationResumeScheduledMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationResumeScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationRetriggerAllScheduledMetricCalculationsArgs = {
  factTable?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRetriggerMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationRetriggerScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
  retriggerDependentMetricSchedules?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRetriggerScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationReviewIssueArgs = {
  autonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
  feedback?: InputMaybe<Array<ObservationsV1IssueFeedbackInput>>;
  name: Scalars['String']['input'];
};

export type MutationSegmentAvailableSpaceArgs = {
  queryParams?: InputMaybe<FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendUserMessageArgs = {
  chatEventId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userMessage: ConversationsV2UserMessageInput;
};

export type MutationStaleReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationStartCheckoutSessionArgs = {
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  returnUri?: InputMaybe<Scalars['String']['input']>;
  successUri?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartInvestigationArgs = {
  name: Scalars['String']['input'];
};

export type MutationStartIssueArgs = {
  name: Scalars['String']['input'];
};

export type MutationStartTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationStoreSlackUserInfoArgs = {
  code: Scalars['String']['input'];
};

export type MutationSubmitRecordingFeedbackArgs = {
  name: Scalars['String']['input'];
  rating: RecordingV1RecordingFeedbackRating;
};

export type MutationSubmitReviewResponseArgs = {
  action?: InputMaybe<CollaborationV1ReviewResponseAction>;
  comment?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationSuggestFactTableColumnsArgs = {
  schema: Array<MetricsV1ColumnInput>;
};

export type MutationSuggestMetricArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSyncInsightsTableContextsArgs = {
  includeEnrichment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationTakeSuggestedActionArgs = {
  name: Scalars['String']['input'];
  suggestedActionId: Scalars['String']['input'];
};

export type MutationTestWebhookArgs = {
  account: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type MutationTransitionWorkflowInstanceArgs = {
  action: Scalars['String']['input'];
  actualTransitionTime?: InputMaybe<Scalars['String']['input']>;
  asyncTransition?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationUnarchiveFlagArgs = {
  name: Scalars['String']['input'];
};

export type MutationUnarchiveMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationUndeleteEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationUndeleteFactTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationUndoReactionArgs = {
  emoji: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type MutationUnfollowResourcesArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']>;
};

export type MutationUnpublishCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationUnregisterAccountDomainArgs = {
  domainId: Scalars['String']['input'];
};

export type MutationUpdateAgentArgs = {
  agent: PartialIamV1AgentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAiWorkflowTriggerArgs = {
  aiWorkflowTrigger: PartialAiworkflowsV1AiWorkflowTriggerInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAnalysisResultArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  analysisResult: PartialStatsV2AnalysisAnalysisResultInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateApiClientArgs = {
  apiClient: PartialIamV1ApiClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAssignmentTableArgs = {
  assignmentTable: PartialMetricsV1AssignmentTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAttachmentArgs = {
  attachment: PartialCollaborationV1AttachmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateChatArgs = {
  chat: PartialConversationsV2ChatInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateChatEventArgs = {
  chatEvent: PartialConversationsV2ChatEventInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCheckArgs = {
  check: WorkflowV1WorkflowInstanceCheckInput;
};

export type MutationUpdateClientArgs = {
  client: PartialIamV1ClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateClientCredentialArgs = {
  clientCredential: PartialIamV1ClientCredentialInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCollaborativeDocumentArgs = {
  collaborativeDocument: PartialCollaborationV1CollaborativeDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCollectionArgs = {
  collection: PartialCollectionsV1CollectionInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCommentArgs = {
  comment: PartialCollaborationV1CommentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCommentReplyArgs = {
  commentReply: PartialCollaborationV1CommentReplyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateConversationArgs = {
  conversation: PartialConversationsV1ConversationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateConversationMessageArgs = {
  conversationMessage: PartialConversationsV1ConversationMessageInput;
  parent: Scalars['String']['input'];
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDataWarehouseArgs = {
  dataWarehouse: PartialMetricsV1DataWarehouseInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDimensionTableArgs = {
  dimensionTable: PartialMetricsV1DimensionTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityArgs = {
  entity: PartialMetricsV1EntityInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityIdentityBindingArgs = {
  entityIdentityBinding: PartialMetricsV1EntityIdentityBindingInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityRelationTableArgs = {
  entityRelationTable: PartialMetricsV1EntityRelationTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEnvironmentArgs = {
  environment: PartialFlagsAdminV1EnvironmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEvaluationContextFieldOverrideArgs = {
  evaluationContextFieldOverride: PartialFlagsAdminV1EvaluationContextFieldOverrideInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEventDefinitionArgs = {
  eventDefinition: PartialEventsAdminV1EventDefinitionInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExclusivityGroupArgs = {
  exclusivityGroup: PartialWorkflowV1ExclusivityGroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExposureTableArgs = {
  exposureTable: PartialMetricsV1ExposureTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExternalDocumentArgs = {
  externalDocument: PartialCollaborationV1ExternalDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExternalIntegrationArgs = {
  externalIntegration: PartialAiworkflowsV1ExternalIntegrationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFactTableArgs = {
  factTable: PartialMetricsV1FactTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFeedArgs = {
  feed: PartialActivityV1FeedInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFlagArgs = {
  flag: PartialFlagsAdminV1FlagInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateGroupArgs = {
  group: PartialIamV1GroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateHoldbackArgs = {
  holdback: PartialWorkflowV1HoldbackInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInitiativeArgs = {
  initiative: PartialWorkflowV1InitiativeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsDocumentArgs = {
  insightsDocument: PartialInsightsV1InsightsDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsMetricArgs = {
  insightsMetric: PartialInsightsV1InsightsMetricInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsTableContextArgs = {
  insightsTableContext: PartialInsightsV1InsightsTableContextInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateIssueArgs = {
  issue: PartialObservationsV1IssueInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateIssuesConfigArgs = {
  issuesConfig: PartialObservationsV1IssuesConfigInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLabelArgs = {
  label: PartialAdminLabelsV1LabelInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLearningProgressArgs = {
  learningProgress: PartialOnboardingV1LearningProgressInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMaterializedSegmentArgs = {
  materializedSegment: PartialFlagsAdminV1MaterializedSegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMeasurementArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  measurement: PartialMetricsV1MeasurementInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMetricArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  metric: PartialMetricsV1MetricInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateOAuthAppArgs = {
  oauthApp: PartialIamV1OAuthAppInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateObservationArgs = {
  observation: PartialObservationsV1ObservationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateOnboardingSetupArgs = {
  onboardingSetup: PartialOnboardingV1OnboardingSetupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePolicyArgs = {
  policy: PartialIamV1PolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePresenceArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  presence: PartialCollaborationV1PresenceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateProjectArgs = {
  project: PartialCollaborationV1ProjectInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePromptHookArgs = {
  promptHook: PartialConversationsV2PromptHookInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePulseArgs = {
  pulse: PartialPulseV1PulseInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePulseBlockArgs = {
  pulseBlock: PartialPulseV1PulseBlockInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRecordingPolicyArgs = {
  recordingPolicy: PartialRecordingV1RecordingPolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRecordingRuleArgs = {
  recordingRule: PartialRecordingV1RecordingRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateReviewArgs = {
  review: PartialCollaborationV1ReviewInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRoleArgs = {
  role: PartialIamV1RoleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRuleArgs = {
  rule: PartialFlagsAdminV1FlagRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduledExposureCalculationArgs = {
  scheduledExposureCalculation: PartialMetricsV1ScheduledExposureCalculationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduledMaterializedSegmentLoadJobArgs = {
  scheduledMaterializedSegmentLoadJob: PartialMaterializerV1ScheduledMaterializedSegmentLoadJobInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduledMetricCalculationArgs = {
  scheduledMetricCalculation: PartialMetricsV1ScheduledMetricCalculationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSegmentArgs = {
  segment: PartialFlagsAdminV1SegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSurfaceArgs = {
  surface: PartialWorkflowV1SurfaceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTaskArgs = {
  task: PartialObservationsV1TaskInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateThemeArgs = {
  theme: PartialObservationsV1ThemeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTourPreferencesArgs = {
  tourPreferences: PartialOnboardingV1TourPreferencesInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateUserArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  user: PartialIamV1UserInput;
};

export type MutationUpdateVariantArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  variant: PartialFlagsAdminV1FlagVariantInput;
};

export type MutationUpdateWorkflowArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflow: PartialWorkflowV1WorkflowInput;
};

export type MutationUpdateWorkflowInstanceArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
};

export type MutationUpdateWorkflowSecretArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowSecret: PartialWorkflowV1WorkflowSecretInput;
};

export type MutationUpdateWorkflowTemplateArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowTemplate: PartialWorkflowV1WorkflowTemplateInput;
};

export type MutationUpgradeWorkflowInstancesArgs = {
  lowestVersion: Scalars['String']['input'];
  name: Scalars['String']['input'];
  setCurrentVersion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationValidateDataWarehouseConfigArgs = {
  bigQueryConfig?: InputMaybe<MetricsV1BigQueryConfigInput>;
  existingWarehouse?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<MetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<MetricsV1ValidateSnowflakeConfigInput>;
};

export type MutationValidateEventConnectionConfigArgs = {
  bigQuery?: InputMaybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput>;
  databricks?: InputMaybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
};

export type MutationValidateFlagAppliedConnectionConfigArgs = {
  bigQuery?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput>;
  databricks?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput>;
  kinesis?: InputMaybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput>;
  pubsub?: InputMaybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
};

export type MutationValidateMetricArgs = {
  metric: MetricsV1MetricInput;
};

export type MutationValidatePlatformConnectionConfigArgs = {
  kinesis?: InputMaybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput>;
  pubsub?: InputMaybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput>;
};

export type MutationVerifyAccountDomainArgs = {
  domainId: Scalars['String']['input'];
};

export type MutationVerifyMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  verification: MetricsV1MetricMetricVerificationVerificationState;
};

export type MutationWriteFlagAssignedArgs = {
  flagAssigned?: InputMaybe<Array<FlagsResolverV1EventsFlagAssignedInput>>;
};

export type MutationWriteResolveInfoArgs = {
  clientResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoInput>
  >;
  flagResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoInput>
  >;
};

export type MutationWriteResourcePermissionsArgs = {
  addPermissions?: InputMaybe<Array<FgaV1ResourcePermissionInput>>;
  removePermissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ObservationalMetricsData = {
  dismissed?: Maybe<Array<MetricsV1MetricResult>>;
  metrics: Array<ObservationalMetricsDataObservationalMetric>;
  results?: Maybe<Array<ObservationalMetricsDataObservationalResult>>;
};

export type ObservationalMetricsDataInput = {
  dismissed?: InputMaybe<Array<Scalars['String']['input']>>;
  metrics: Array<ObservationalMetricsDataInputObservationalMetricInput>;
  results?: InputMaybe<
    Array<ObservationalMetricsDataInputObservationalResultInput>
  >;
};

export type ObservationalMetricsDataInputObservationalMetricInput = {
  directEnforcement?: InputMaybe<ObservationalMetricsDataInputObservationalMetricInputDirectEnforcement>;
  enforcement: ObservationalMetricsDataInputObservationalMetricInputEnforcement;
  metric: Scalars['String']['input'];
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ObservationalMetricsDataInputObservationalMetricInputDirectEnforcement {
  Associated = 'ASSOCIATED',
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export enum ObservationalMetricsDataInputObservationalMetricInputEnforcement {
  Associated = 'ASSOCIATED',
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type ObservationalMetricsDataInputObservationalResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationalMetricsDataObservationalMetric = {
  directEnforcement?: Maybe<ObservationalMetricsDataObservationalMetricDirectEnforcement>;
  enforcement: ObservationalMetricsDataObservationalMetricEnforcement;
  metric: MetricsV1MetricResult;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
  surfaceOnly?: Maybe<Scalars['Boolean']['output']>;
};

export enum ObservationalMetricsDataObservationalMetricDirectEnforcement {
  Associated = 'ASSOCIATED',
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export enum ObservationalMetricsDataObservationalMetricEnforcement {
  Associated = 'ASSOCIATED',
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type ObservationalMetricsDataObservationalResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1EventsIssueCreated = {
  issue?: Maybe<ObservationsV1Issue>;
};

export type ObservationsV1EventsIssueDeleted = {
  deletedIssue?: Maybe<ObservationsV1Issue>;
  issue?: Maybe<ObservationsV1IssueResult>;
};

export type ObservationsV1EventsIssueUpdated = {
  feedback: Array<ObservationsV1IssueFeedback>;
  issue?: Maybe<ObservationsV1Issue>;
  oldIssue?: Maybe<ObservationsV1Issue>;
  reviewCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type ObservationsV1EventsObservationCreated = {
  observation?: Maybe<ObservationsV1Observation>;
};

export type ObservationsV1EventsObservationDeleted = {
  deletedObservation?: Maybe<ObservationsV1Observation>;
  observation?: Maybe<ObservationsV1ObservationResult>;
};

export type ObservationsV1EventsObservationUpdated = {
  observation?: Maybe<ObservationsV1Observation>;
  oldObservation?: Maybe<ObservationsV1Observation>;
};

export type ObservationsV1EventsTaskCreated = {
  task?: Maybe<ObservationsV1Task>;
};

export type ObservationsV1EventsTaskDeleted = {
  deletedTask?: Maybe<ObservationsV1Task>;
  task?: Maybe<ObservationsV1TaskResult>;
};

export type ObservationsV1EventsTaskUpdated = {
  oldTask?: Maybe<ObservationsV1Task>;
  task?: Maybe<ObservationsV1Task>;
};

export type ObservationsV1EventsThemeCreated = {
  theme?: Maybe<ObservationsV1Theme>;
};

export type ObservationsV1EventsThemeDeleted = {
  deletedTheme?: Maybe<ObservationsV1Theme>;
  theme?: Maybe<ObservationsV1ThemeResult>;
};

export type ObservationsV1EventsThemeUpdated = {
  oldTheme?: Maybe<ObservationsV1Theme>;
  theme?: Maybe<ObservationsV1Theme>;
};

export type ObservationsV1ExtractObservationsResponse = {
  deletedObservations: Array<ObservationsV1ObservationResult>;
  observations: Array<ObservationsV1Observation>;
};

export type ObservationsV1ExtractObservationsResponseResult =
  | Error
  | ObservationsV1ExtractObservationsResponse;

export type ObservationsV1InputRequest = {
  approval?: Maybe<ObservationsV1InputRequestApproval>;
  codeReview?: Maybe<ObservationsV1InputRequestCodeReview>;
  direction?: Maybe<ObservationsV1InputRequestDirection>;
};

export type ObservationsV1InputRequestApproval = {
  prompt: Scalars['String']['output'];
};

export type ObservationsV1InputRequestApprovalInput = {
  prompt: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputRequestCodeReview = {
  prompt?: Maybe<Scalars['String']['output']>;
  pullRequestNumber: Scalars['Int']['output'];
  repository: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type ObservationsV1InputRequestCodeReviewInput = {
  prompt?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  pullRequestNumber: Scalars['Int']['input'];
  repository: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type ObservationsV1InputRequestDirection = {
  options: Array<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1InputRequestDirectionInput = {
  options: Array<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputRequestInput = {
  approval?: InputMaybe<ObservationsV1InputRequestApprovalInput>;
  codeReview?: InputMaybe<ObservationsV1InputRequestCodeReviewInput>;
  direction?: InputMaybe<ObservationsV1InputRequestDirectionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputResponse = {
  approval?: Maybe<ObservationsV1InputResponseApprovalResponse>;
  codeReview?: Maybe<ObservationsV1InputResponseCodeReviewResponse>;
  direction?: Maybe<ObservationsV1InputResponseDirectionResponse>;
};

export type ObservationsV1InputResponseApprovalResponse = {
  approved: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1InputResponseApprovalResponseInput = {
  approved: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputResponseCodeReviewResponse = {
  approved: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1InputResponseCodeReviewResponseInput = {
  approved: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputResponseDirectionResponse = {
  choice: Scalars['String']['output'];
};

export type ObservationsV1InputResponseDirectionResponseInput = {
  choice: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1InputResponseInput = {
  approval?: InputMaybe<ObservationsV1InputResponseApprovalResponseInput>;
  codeReview?: InputMaybe<ObservationsV1InputResponseCodeReviewResponseInput>;
  direction?: InputMaybe<ObservationsV1InputResponseDirectionResponseInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1Issue = {
  assessment?: Maybe<ObservationsV1IssueAssessment>;
  assignee?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  autonomyLevel?: Maybe<ObservationsV1IssueAutonomyLevel>;
  closeReason?: Maybe<ObservationsV1IssueCloseReason>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  driver?: Maybe<ConversationsV2ChatResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kind?: Maybe<ObservationsV1IssueKind>;
  labels: Array<ObservationsV1IssueLabelsEntry>;
  name: Scalars['String']['output'];
  observationActivity: Array<ObservationsV1IssueActivityBucket>;
  observationCount?: Maybe<Scalars['Int']['output']>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  priority?: Maybe<ObservationsV1IssuePriority>;
  problemStatement?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  progressSummary?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewRequestedTime?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snoozedUntilTime?: Maybe<Scalars['String']['output']>;
  state: ObservationsV1IssueState;
  status?: Maybe<ObservationsV1IssueStatus>;
  suggestedActions: Array<ObservationsV1IssueSuggestedAction>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  taskStats?: Maybe<ObservationsV1IssueTaskStats>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  theme?: Maybe<ObservationsV1ThemeResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1IssueAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1IssueCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1IssueObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueActivityBucket = {
  count?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1IssueActivityBucketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueAssessment = {
  evidence?: Maybe<Scalars['Float']['output']>;
  impact?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

export type ObservationsV1IssueAssessmentInput = {
  evidence?: InputMaybe<Scalars['Float']['input']>;
  impact?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Float']['input']>;
};

export enum ObservationsV1IssueAutonomyLevel {
  Build = 'BUILD',
  Collect = 'COLLECT',
  Full = 'FULL',
  Investigate = 'INVESTIGATE',
}

export enum ObservationsV1IssueCloseReason {
  Fixed = 'FIXED',
  NonIssue = 'NON_ISSUE',
  WontFix = 'WONT_FIX',
}

export type ObservationsV1IssueFeedback = {
  comment: Scalars['String']['output'];
  quote: Scalars['String']['output'];
};

export type ObservationsV1IssueFeedbackInput = {
  comment: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quote: Scalars['String']['input'];
};

export type ObservationsV1IssueInput = {
  assessment?: InputMaybe<ObservationsV1IssueAssessmentInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  autonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  displayName: Scalars['String']['input'];
  kind?: InputMaybe<ObservationsV1IssueKind>;
  labels?: InputMaybe<Array<ObservationsV1IssueLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ObservationsV1IssuePriorityInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snoozedUntilTime?: InputMaybe<Scalars['String']['input']>;
  suggestedActions?: InputMaybe<Array<ObservationsV1IssueSuggestedActionInput>>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1IssueKind {
  Bug = 'BUG',
  DataQuality = 'DATA_QUALITY',
  Documentation = 'DOCUMENTATION',
  FeatureRequest = 'FEATURE_REQUEST',
  Performance = 'PERFORMANCE',
  Reliability = 'RELIABILITY',
  Risk = 'RISK',
  Security = 'SECURITY',
  Usability = 'USABILITY',
}

export type ObservationsV1IssueLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1IssueLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuePriority = {
  humanEdited?: Maybe<Scalars['Boolean']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  level?: Maybe<ObservationsV1IssuePriorityLevel>;
};

export type ObservationsV1IssuePriorityInput = {
  humanEdited?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<ObservationsV1IssuePriorityLevel>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1IssuePriorityLevel {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type ObservationsV1IssueResult = Error | ObservationsV1Issue;

export enum ObservationsV1IssueState {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export enum ObservationsV1IssueStatus {
  Idle = 'IDLE',
  Running = 'RUNNING',
  WaitingForInput = 'WAITING_FOR_INPUT',
  WaitingForReview = 'WAITING_FOR_REVIEW',
}

export type ObservationsV1IssueSuggestedAction = {
  chat?: Maybe<ConversationsV2ChatResult>;
  displayName: Scalars['String']['output'];
  document?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ObservationsV1IssueSuggestedActionState>;
};

export type ObservationsV1IssueSuggestedActionInput = {
  displayName: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1IssueSuggestedActionState {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Suggested = 'SUGGESTED',
}

export type ObservationsV1IssueTaskStats = {
  completed?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Int']['output']>;
  waitingForInput?: Maybe<Scalars['Int']['output']>;
};

export type ObservationsV1IssueTaskStatsInput = {
  completed?: InputMaybe<Scalars['Int']['input']>;
  failed?: InputMaybe<Scalars['Int']['input']>;
  inProgress?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  waitingForInput?: InputMaybe<Scalars['Int']['input']>;
};

export type ObservationsV1IssuesConfig = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  defaultAutonomyLevel?: Maybe<ObservationsV1IssueAutonomyLevel>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1IssuesConfigAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssuesConfigCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1IssuesConfigCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssuesConfigExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1IssuesConfigObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssuesConfigQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuesConfigReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuesConfigResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuesConfigReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuesConfigTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssuesConfigInput = {
  defaultAutonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssuesConfigResult =
  | Error
  | ObservationsV1IssuesConfig;

export type ObservationsV1ListIssuesResponse = {
  issues: Array<ObservationsV1Issue>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ListIssuesResponseResult =
  | Error
  | ObservationsV1ListIssuesResponse;

export type ObservationsV1ListObservationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  observations: Array<ObservationsV1Observation>;
};

export type ObservationsV1ListObservationsResponseResult =
  | Error
  | ObservationsV1ListObservationsResponse;

export type ObservationsV1ListTasksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  tasks: Array<ObservationsV1Task>;
};

export type ObservationsV1ListTasksResponseResult =
  | Error
  | ObservationsV1ListTasksResponse;

export type ObservationsV1ListThemesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  themes: Array<ObservationsV1Theme>;
};

export type ObservationsV1ListThemesResponseResult =
  | Error
  | ObservationsV1ListThemesResponse;

export type ObservationsV1Observation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['String']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  issue?: Maybe<ObservationsV1IssueResult>;
  kind: Scalars['String']['output'];
  labels: Array<ObservationsV1ObservationLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source: ObservationsV1Source;
  summary: Scalars['String']['output'];
  surfaces: Array<WorkflowV1SurfaceResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1ObservationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1ObservationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1ObservationObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationInput = {
  eventTime: Scalars['String']['input'];
  excerpt?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1ObservationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source: ObservationsV1SourceInput;
  summary: Scalars['String']['input'];
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ObservationsV1ObservationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ObservationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationResult = Error | ObservationsV1Observation;

export type ObservationsV1SearchIssuesHit = {
  issue: ObservationsV1Issue;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ObservationsV1SearchIssuesResponse = {
  hits: Array<ObservationsV1SearchIssuesHit>;
};

export type ObservationsV1SearchIssuesResponseResult =
  | Error
  | ObservationsV1SearchIssuesResponse;

export type ObservationsV1SearchObservationsHit = {
  observation: ObservationsV1Observation;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ObservationsV1SearchObservationsResponse = {
  hits: Array<ObservationsV1SearchObservationsHit>;
};

export type ObservationsV1SearchObservationsResponseResult =
  | Error
  | ObservationsV1SearchObservationsResponse;

export type ObservationsV1SearchThemesHit = {
  score?: Maybe<Scalars['Float']['output']>;
  theme: ObservationsV1Theme;
};

export type ObservationsV1SearchThemesResponse = {
  hits: Array<ObservationsV1SearchThemesHit>;
};

export type ObservationsV1SearchThemesResponseResult =
  | Error
  | ObservationsV1SearchThemesResponse;

export type ObservationsV1Source = {
  externalId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  origin: ObservationsV1SourceOrigin;
  system: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1SourceInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  origin: ObservationsV1SourceOrigin;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  system: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1SourceOrigin {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  System = 'SYSTEM',
}

export type ObservationsV1Task = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  dependencies: Array<ObservationsV1TaskResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  inputRequest?: Maybe<ObservationsV1InputRequest>;
  inputResponse?: Maybe<ObservationsV1InputResponse>;
  labels: Array<ObservationsV1TaskLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  plan?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: ObservationsV1TaskState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1TaskAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1TaskCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1TaskObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskInput = {
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1TaskLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1TaskLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskResult = Error | ObservationsV1Task;

export enum ObservationsV1TaskState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  WaitingForInput = 'WAITING_FOR_INPUT',
}

export type ObservationsV1Theme = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  chat?: Maybe<ConversationsV2ChatResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  issueCount?: Maybe<Scalars['Int']['output']>;
  labels: Array<ObservationsV1ThemeLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: ObservationsV1ThemeState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1ThemeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1ThemeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1ThemeObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1ThemeLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ThemeLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeResult = Error | ObservationsV1Theme;

export enum ObservationsV1ThemeState {
  Idle = 'IDLE',
  Investigating = 'INVESTIGATING',
}

export type OnboardingV1AnswerQuestionsRequestQuestionUpdateInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  lessonIndex: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
};

export type OnboardingV1LearningProgress = {
  completedCourses?: Maybe<Scalars['Int']['output']>;
  courseProgresses: Array<OnboardingV1LearningProgressCourseProgress>;
};

export type OnboardingV1LearningProgressCourseProgress = {
  completedLessons?: Maybe<Scalars['Int']['output']>;
  course: Scalars['String']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lessonProgresses: Array<OnboardingV1LearningProgressLessonProgress>;
};

export type OnboardingV1LearningProgressCourseProgressInput = {
  course: Scalars['String']['input'];
  lessonProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressLessonProgressInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1LearningProgressInput = {
  courseProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressCourseProgressInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1LearningProgressLessonProgress = {
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lessonIndex: Scalars['Int']['output'];
  questionProgresses: Array<OnboardingV1LearningProgressQuestionProgress>;
};

export type OnboardingV1LearningProgressLessonProgressInput = {
  lessonIndex: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressQuestionProgressInput>
  >;
};

export type OnboardingV1LearningProgressQuestionProgress = {
  correctAnswerIndex: Scalars['Int']['output'];
  currentAnswerIndex?: Maybe<Scalars['Int']['output']>;
  questionIndex: Scalars['Int']['output'];
};

export type OnboardingV1LearningProgressQuestionProgressInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
};

export type OnboardingV1LearningProgressResult =
  | Error
  | OnboardingV1LearningProgress;

export type OnboardingV1ManagedDataWarehouseProvisioning = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: OnboardingV1ManagedDataWarehouseProvisioningState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type OnboardingV1ManagedDataWarehouseProvisioningAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningExternalDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1ExternalDocumentView>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningResult =
  | Error
  | OnboardingV1ManagedDataWarehouseProvisioning;

export enum OnboardingV1ManagedDataWarehouseProvisioningState {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Failed = 'FAILED',
}

export enum OnboardingV1OnboardingPath {
  OnboardingPathExploreDemo = 'ONBOARDING_PATH_EXPLORE_DEMO',
  OnboardingPathGuidedSetup = 'ONBOARDING_PATH_GUIDED_SETUP',
}

export type OnboardingV1OnboardingSetup = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  path?: Maybe<OnboardingV1OnboardingPath>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type OnboardingV1OnboardingSetupAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1OnboardingSetupCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type OnboardingV1OnboardingSetupCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1OnboardingSetupExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type OnboardingV1OnboardingSetupObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1OnboardingSetupQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1OnboardingSetupReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1OnboardingSetupResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1OnboardingSetupReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1OnboardingSetupTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1OnboardingSetupInput = {
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<OnboardingV1OnboardingPath>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1OnboardingSetupResult =
  | Error
  | OnboardingV1OnboardingSetup;

export type OnboardingV1TourPreferences = {
  abTestsStatus?: Maybe<OnboardingV1TourStepStatus>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  featureFlagsStatus?: Maybe<OnboardingV1TourStepStatus>;
  rolloutsStatus?: Maybe<OnboardingV1TourStepStatus>;
};

export type OnboardingV1TourPreferencesInput = {
  abTestsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rolloutsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
};

export type OnboardingV1TourPreferencesResult =
  | Error
  | OnboardingV1TourPreferences;

export enum OnboardingV1TourStepStatus {
  TourStepStatusCompleted = 'TOUR_STEP_STATUS_COMPLETED',
  TourStepStatusInProgress = 'TOUR_STEP_STATUS_IN_PROGRESS',
  TourStepStatusNotStarted = 'TOUR_STEP_STATUS_NOT_STARTED',
}

export type PartialAbTestDataInput = {
  flag?: InputMaybe<Scalars['String']['input']>;
  rollout?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialAbTestDataInputTreatmentInput>>
  >;
};

export type PartialAbTestDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialActionsV1TypesActionInput = {
  executeFunctionAction?: InputMaybe<PartialActionsV1TypesExecuteFunctionActionInput>;
  pagerdutyAction?: InputMaybe<PartialActionsV1TypesPagerDutyActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  transitionAction?: InputMaybe<PartialActionsV1TypesTransitionWorkflowActionInput>;
};

export type PartialActionsV1TypesActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesAutomatedActionInput = {
  action?: InputMaybe<PartialActionsV1TypesActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<PartialActionsV1TypesTriggerInput>;
};

export type PartialActionsV1TypesExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesPagerDutyActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pdKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<ActionsV1TypesSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesStateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesTransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesTriggerInput = {
  activityTrigger?: InputMaybe<PartialActionsV1TypesActivityTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<PartialActionsV1TypesStateTriggerInput>;
};

export type PartialActivityV1FeedChannelConfigBatchingConfigInput = {
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigDigestConfigInput = {
  interval?: InputMaybe<ActivityV1FeedChannelConfigDigestConfigDigestInterval>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigEmailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigInput = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  batchingConfig?: InputMaybe<PartialActivityV1FeedChannelConfigBatchingConfigInput>;
  digestConfig?: InputMaybe<PartialActivityV1FeedChannelConfigDigestConfigInput>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<PartialActivityV1FeedChannelConfigEmailInput>;
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PartialActivityV1FeedChannelConfigSlackInput>;
  webhook?: InputMaybe<PartialActivityV1FeedChannelConfigWebhookInput>;
};

export type PartialActivityV1FeedChannelConfigSlackInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigWebhookInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedInput = {
  channels?: InputMaybe<
    Array<InputMaybe<PartialActivityV1FeedChannelConfigInput>>
  >;
  labels?: InputMaybe<Array<InputMaybe<PartialActivityV1FeedLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAdminLabelsV1LabelInput = {
  allowedValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAdminLabelsV1LabelLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<InputMaybe<AdminLabelsV1LabelResourceType>>>;
};

export type PartialAdminLabelsV1LabelLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ActionInput = {
  executeFunctionAction?: InputMaybe<PartialAiworkflowsV1ExecuteFunctionActionInput>;
  notifyFeedAction?: InputMaybe<PartialAiworkflowsV1NotifyFeedActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runPromptAction?: InputMaybe<PartialAiworkflowsV1RunPromptActionInput>;
  transitionWorkflowAction?: InputMaybe<PartialAiworkflowsV1TransitionWorkflowActionInput>;
};

export type PartialAiworkflowsV1ActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1AiWorkflowTriggerInput = {
  action?: InputMaybe<PartialAiworkflowsV1ActionInput>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAiworkflowsV1AiWorkflowTriggerLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<PartialAiworkflowsV1TriggerInput>;
};

export type PartialAiworkflowsV1AiWorkflowTriggerLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateCursorIntegrationDetailsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateIntercomIntegrationDetailsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1DashboardAlertTriggerInput = {
  condition?: InputMaybe<PartialAiworkflowsV1ThresholdConditionInput>;
  graphType?: InputMaybe<Scalars['String']['input']>;
  labelFilters?: InputMaybe<
    Array<
      InputMaybe<PartialAiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput>
    >
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExternalIntegrationInput = {
  claudeAgents?: InputMaybe<PartialAiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput>;
  cursor?: InputMaybe<PartialAiworkflowsV1CreateCursorIntegrationDetailsInput>;
  github?: InputMaybe<PartialAiworkflowsV1GithubIntegrationDetailsInput>;
  intercom?: InputMaybe<PartialAiworkflowsV1CreateIntercomIntegrationDetailsInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAiworkflowsV1ExternalIntegrationLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExternalIntegrationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1GithubIntegrationDetailsInput = {
  appId?: InputMaybe<Scalars['Long']['input']>;
  installationId?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1NotifyFeedActionInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AiworkflowsV1AlertSeverity>;
};

export type PartialAiworkflowsV1RunPromptActionInput = {
  actorType?: InputMaybe<AiworkflowsV1ActorType>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<AiworkflowsV1TaskType>;
};

export type PartialAiworkflowsV1StateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ThresholdConditionInput = {
  comparator?: InputMaybe<AiworkflowsV1Comparator>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thresholdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialAiworkflowsV1TransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1TriggerInput = {
  activityTrigger?: InputMaybe<PartialAiworkflowsV1ActivityTriggerInput>;
  dashboardAlertTrigger?: InputMaybe<PartialAiworkflowsV1DashboardAlertTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<PartialAiworkflowsV1StateTriggerInput>;
};

export type PartialAnalysisDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialAnalysisDataInputTreatmentInput>>
  >;
};

export type PartialAnalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialAudiencesDataInput = {
  audiences?: InputMaybe<
    Array<InputMaybe<PartialAudiencesDataInputAudienceInput>>
  >;
};

export type PartialAudiencesDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialBackgroundDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sAbTestInput = {
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  rampUpDuration?: InputMaybe<C4sAbTestInputRampUpDuration>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialC4sAbTestInputTreatmentInput>>
  >;
};

export type PartialC4sAbTestInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyAssignments?: InputMaybe<
    Array<
      InputMaybe<PartialC4sAbTestInputTreatmentInputPropertyAssignmentInput>
    >
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialC4sAbTestInputTreatmentInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sRolloutInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringDisabledAt?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<PartialC4sRolloutInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<
    Array<InputMaybe<Scalars['Long']['input']>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialC4sRolloutInputTreatmentInput>>
  >;
};

export type PartialC4sRolloutInputScheduleInput = {
  state?: InputMaybe<C4sRolloutInputScheduleInputState>;
  stateReason?: InputMaybe<PartialC4sRolloutInputScheduleInputScheduleStateReasonInput>;
  steps?: InputMaybe<
    Array<InputMaybe<PartialC4sRolloutInputScheduleInputScheduleStepsInput>>
  >;
};

export type PartialC4sRolloutInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInputFailed>;
};

export type PartialC4sRolloutInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<C4sRolloutInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sRolloutInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyAssignments?: InputMaybe<
    Array<
      InputMaybe<PartialC4sRolloutInputTreatmentInputPropertyAssignmentInput>
    >
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialC4sRolloutInputTreatmentInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AnchorDocumentAnchorInput = {
  document?: InputMaybe<Scalars['String']['input']>;
  endNode?: InputMaybe<Scalars['String']['input']>;
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  startNode?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialCollaborationV1AnchorInput = {
  document?: InputMaybe<PartialCollaborationV1AnchorDocumentAnchorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<PartialCollaborationV1AnchorZoneAnchorInput>;
};

export type PartialCollaborationV1AnchorZoneAnchorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AttachmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1AttachmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AttachmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CollaborativeDocumentInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialCollaborationV1CollaborativeDocumentLabelsEntryInput>
    >
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  realtimeEditing?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CollaborativeDocumentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentInput = {
  anchor?: InputMaybe<PartialCollaborationV1AnchorInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1CommentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentReplyInput = {
  action?: InputMaybe<CollaborationV1CommentReplyAction>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1CommentReplyLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentReplyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ExternalDocumentInput = {
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ExternalDocumentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialCollaborationV1ExternalDocumentSourceInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ExternalDocumentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ExternalDocumentSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CollaborationV1ExternalDocumentSourceType>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1PresenceInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ProjectLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<PartialCollaborationV1ProjectSummaryInput>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialCollaborationV1ProjectLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ProjectSummaryInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ReviewInput = {
  assignedReviewers?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewReviewersInput>>
  >;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewReviewerInput>>
  >;
};

export type PartialCollaborationV1ReviewLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ReviewReviewerInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CollaborationV1ReviewReviewerReviewRole>;
};

export type PartialCollaborationV1ReviewReviewersInput = {
  identity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CollaborationV1ReviewReviewersReviewRole>;
};

export type PartialCollectionsV1CollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollectionsV1CollectionLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<InputMaybe<CollectionsV1ResourceType>>>;
};

export type PartialCollectionsV1CollectionLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConclusionOneOfInput = {
  conclusion?: InputMaybe<PartialExploreDataInputAnalysisInputConclusionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialConversationsV1ApprovedToolCallInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1ConversationInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  approvedToolCalls?: InputMaybe<
    Array<InputMaybe<PartialConversationsV1ApprovedToolCallInput>>
  >;
  lifecycle?: InputMaybe<ConversationsV1ConversationLifecycle>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV1ConversationSource>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1ConversationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  generatedKind?: InputMaybe<ConversationsV1GeneratedKind>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<PartialConversationsV1PendingApprovalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ConversationsV1MessageRole>;
  toolCalls?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1PendingApprovalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2AssistantMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<ConversationsV2AssistantMessagePhase>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChatEventInput = {
  assistantMessage?: InputMaybe<PartialConversationsV2AssistantMessageInput>;
  clear?: InputMaybe<PartialConversationsV2ClearInput>;
  compactionResult?: InputMaybe<PartialConversationsV2CompactionResultInput>;
  compactionStart?: InputMaybe<PartialConversationsV2CompactionStartInput>;
  error?: InputMaybe<PartialConversationsV2ErrorInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2ChatEventLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<PartialConversationsV2NotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thinking?: InputMaybe<PartialConversationsV2ThinkingInput>;
  toolCall?: InputMaybe<PartialConversationsV2ToolCallInput>;
  toolConfirmationRequest?: InputMaybe<PartialConversationsV2ToolConfirmationRequestInput>;
  toolConfirmationResponse?: InputMaybe<PartialConversationsV2ToolConfirmationResponseInput>;
  toolResult?: InputMaybe<PartialConversationsV2ToolResultInput>;
  userInterrupt?: InputMaybe<PartialConversationsV2UserInterruptInput>;
  userMessage?: InputMaybe<PartialConversationsV2UserMessageInput>;
};

export type PartialConversationsV2ChatEventLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChatInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  executionPolicy?: InputMaybe<PartialConversationsV2ExecutionPolicyInput>;
  intelligenceLevel?: InputMaybe<ConversationsV2ChatIntelligenceLevel>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2ChatLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV2ChatSource>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialConversationsV2ChatLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChildChatStoppedInput = {
  childChat?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ClearInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2CompactionResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2CompactionStartInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2DomainEventNotificationInput = {
  chatSubscription?: InputMaybe<Scalars['String']['input']>;
  cloudEventId?: InputMaybe<Scalars['String']['input']>;
  cloudEventSource?: InputMaybe<Scalars['String']['input']>;
  eventData?: InputMaybe<Scalars['JSON']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2EventTriggerInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ExecutionPolicyInput = {
  permissionMode?: InputMaybe<ConversationsV2ExecutionPolicyPermissionMode>;
  principal?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2MessagePartInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2NotificationInput = {
  childChatStopped?: InputMaybe<PartialConversationsV2ChildChatStoppedInput>;
  domainEvent?: InputMaybe<PartialConversationsV2DomainEventNotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookApprovedToolInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookInput = {
  agent?: InputMaybe<Scalars['String']['input']>;
  approvedTools?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2PromptHookApprovedToolInput>>
  >;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  intelligenceLevel?: InputMaybe<ConversationsV2ChatIntelligenceLevel>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2PromptHookLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  promptTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipScratchpad?: InputMaybe<Scalars['Boolean']['input']>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<PartialConversationsV2PromptHookTriggerInput>;
};

export type PartialConversationsV2PromptHookLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookTriggerInput = {
  eventTrigger?: InputMaybe<PartialConversationsV2EventTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleTrigger?: InputMaybe<PartialConversationsV2ScheduleTriggerInput>;
};

export type PartialConversationsV2ScheduleTriggerInput = {
  cron?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ThinkingInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolCallInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolConfirmationRequestInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolConfirmationResponseInput = {
  decision?: InputMaybe<ConversationsV2ToolConfirmationResponseDecision>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolRequestEvent?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolResultInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  toolCallEvent?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2UserInterruptInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2UserMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<PartialConversationsV2MessagePartInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDecisionRecordDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<DecisionRecordDataInputOutcome>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDimensionsOneOfInput = {
  metricCalculationDimensionTableDimension?: InputMaybe<PartialExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput>;
  metricCalculationFactTableDimension?: InputMaybe<PartialExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialEpTestInput = {
  myConfigField?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventDefinitionInput = {
  labels?: InputMaybe<
    Array<InputMaybe<PartialEventsAdminV1EventDefinitionLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<InputMaybe<PartialEventsAdminV1EventDefinitionSchemaEntryInput>>
  >;
};

export type PartialEventsAdminV1EventDefinitionLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventDefinitionSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaBoolSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaDateSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaDoubleSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaInput = {
  boolSchema?: InputMaybe<PartialEventsAdminV1EventSchemaBoolSchemaInput>;
  dateSchema?: InputMaybe<PartialEventsAdminV1EventSchemaDateSchemaInput>;
  doubleSchema?: InputMaybe<PartialEventsAdminV1EventSchemaDoubleSchemaInput>;
  intSchema?: InputMaybe<PartialEventsAdminV1EventSchemaIntSchemaInput>;
  listSchema?: InputMaybe<PartialEventsAdminV1EventSchemaListSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<PartialEventsAdminV1EventSchemaStringSchemaInput>;
  structSchema?: InputMaybe<PartialEventsAdminV1EventSchemaStructSchemaInput>;
  timestampSchema?: InputMaybe<PartialEventsAdminV1EventSchemaTimestampSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaIntSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaListSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  elementSchema?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventSchemaStringSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaStructSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<
      InputMaybe<PartialEventsAdminV1EventSchemaStructSchemaSchemaEntryInput>
    >
  >;
};

export type PartialEventsAdminV1EventSchemaStructSchemaSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaTimestampSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1FieldSemanticTypeCountrySemanticTypeInput = {
  format?: InputMaybe<EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1FieldSemanticTypeEntitySemanticTypeInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<
      InputMaybe<PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput>
    >
  >;
};

export type PartialEventsAdminV1FieldSemanticTypeInput = {
  country?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeCountrySemanticTypeInput>;
  entityReference?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInput = {
  exploratoryAnalyses?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInput>>
  >;
};

export type PartialExploreDataInputAnalysisInput = {
  analysisResults?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputAnalysisResultInput>>
  >;
  conclusion?: InputMaybe<PartialConclusionOneOfInput>;
  createTime?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputLabelInput>>
  >;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputMetricInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  splitByExposureFilters?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ExploreDataInputAnalysisInputState>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  useCustomDateRange?: InputMaybe<Scalars['Boolean']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialExploreDataInputAnalysisInputAnalysisResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputConclusionInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputLabelInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  calculationError?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialDimensionsOneOfInput>>>;
  metricCalculation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledCalculation?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput =
  {
    column?: InputMaybe<Scalars['String']['input']>;
    dimensionTable?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput =
  {
    column?: InputMaybe<Scalars['String']['input']>;
    factTable?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialExposureDataInput = {
  exposure?: InputMaybe<
    Array<InputMaybe<PartialExposureDataInputExposureEntryInput>>
  >;
};

export type PartialExposureDataInputExposureEntryInput = {
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  totalExposureCount?: InputMaybe<Scalars['Long']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExposureOneOfInput = {
  exposureCalculation?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledExposureCalculation?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationInput>;
};

export type PartialExposureSourceOneOfInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputAssignmentTableInput>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputExistingInstanceInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput =
  {
    format?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput =
  {
    entity?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput>
    >
  >;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeInput = {
  country?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput>;
  date?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput>;
  entityReference?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput>;
  version?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1EnvironmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1EnvironmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1EnvironmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1EvaluationContextFieldOverrideInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldKind>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput>
    >
  >;
  log?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonPii?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeInput>;
};

export type PartialFlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput =
  {
    key?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1FlagInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<PartialFlagsAdminV1FlagRuleInput>>>;
  schema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput>;
  usageMetadata?: InputMaybe<PartialFlagsAdminV1FlagUsageMetadataInput>;
  variants?: InputMaybe<Array<InputMaybe<PartialFlagsAdminV1FlagVariantInput>>>;
};

export type PartialFlagsAdminV1FlagLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  bucketRanges?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleBucketRangeInput>>
  >;
  clientDefault?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput>;
  fallthrough?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentVariantAssignmentInput>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentSpecInput = {
  assignments?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentInput>>
  >;
  bucketCount?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentVariantAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleBucketRangeInput = {
  lower?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialFlagsAdminV1FlagRuleInput = {
  assignmentSpec?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentSpecInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleLabelsEntryInput>>
  >;
  materializationSpec?: InputMaybe<PartialFlagsAdminV1FlagRuleMaterializationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleMaterializationSpecInput = {
  mode?: InputMaybe<PartialFlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  readMaterialization?: InputMaybe<Scalars['String']['input']>;
  writeMaterialization?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput =
  {
    materializationMustMatch?: InputMaybe<Scalars['Boolean']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    segmentTargetingCanBeIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type PartialFlagsAdminV1FlagUsageMetadataInput = {
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialFlagsAdminV1FlagVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagVariantLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialFlagsAdminV1FlagVariantLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1MaterializedSegmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1MaterializedSegmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1MaterializedSegmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentAllocationInput = {
  exclusiveTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusivityTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proportion?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentInput = {
  allocation?: InputMaybe<PartialFlagsAdminV1SegmentAllocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1SegmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<PartialFlagsTypesV1TargetingInput>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<PartialFlagsDataInputAudienceInput>>>;
  flag?: InputMaybe<Scalars['String']['input']>;
  ignoreTargetingForSticky?: InputMaybe<Scalars['Boolean']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stickyAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  launchTime?: InputMaybe<Scalars['String']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stopTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1ExpressionInput = {
  and?: InputMaybe<PartialFlagsTypesV1ExpressionOperandsInput>;
  not?: InputMaybe<PartialFlagsTypesV1ExpressionInput>;
  or?: InputMaybe<PartialFlagsTypesV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<InputMaybe<PartialFlagsTypesV1ExpressionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaBoolFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaDoubleFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaInput = {
  boolSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaBoolFlagSchemaInput>;
  doubleSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaDoubleFlagSchemaInput>;
  intSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaIntFlagSchemaInput>;
  listSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaListFlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStringFlagSchemaInput>;
  structSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput>;
};

export type PartialFlagsTypesV1FlagSchemaIntFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaListFlagSchemaInput = {
  elementSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaStringFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput>
    >
  >;
};

export type PartialFlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1FlagSchemaInput>;
};

export type PartialFlagsTypesV1TargetingAllRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<PartialFlagsTypesV1TargetingInnerRuleInput>;
};

export type PartialFlagsTypesV1TargetingAnyRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<PartialFlagsTypesV1TargetingInnerRuleInput>;
};

export type PartialFlagsTypesV1TargetingContainsRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1TargetingCriterionInput>;
};

export type PartialFlagsTypesV1TargetingCriterionAttributeCriterionInput = {
  allRule?: InputMaybe<PartialFlagsTypesV1TargetingAllRuleInput>;
  anyRule?: InputMaybe<PartialFlagsTypesV1TargetingAnyRuleInput>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  containsRule?: InputMaybe<PartialFlagsTypesV1TargetingContainsRuleInput>;
  endsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<PartialFlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialFlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<PartialFlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingStartsWithRuleInput>;
};

export type PartialFlagsTypesV1TargetingCriterionInput = {
  attribute?: InputMaybe<PartialFlagsTypesV1TargetingCriterionAttributeCriterionInput>;
  materializedSegment?: InputMaybe<PartialFlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<PartialFlagsTypesV1TargetingCriterionSegmentCriterionInput>;
};

export type PartialFlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput =
  {
    materializedSegment?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsTypesV1TargetingCriterionSegmentCriterionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingEndsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
};

export type PartialFlagsTypesV1TargetingInnerRuleInput = {
  containsRule?: InputMaybe<PartialFlagsTypesV1TargetingContainsRuleInput>;
  endsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<PartialFlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialFlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<PartialFlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingStartsWithRuleInput>;
};

export type PartialFlagsTypesV1TargetingInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialFlagsTypesV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingListValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingValueInput>>
  >;
};

export type PartialFlagsTypesV1TargetingRangeRuleInput = {
  endExclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  endInclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  startInclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
};

export type PartialFlagsTypesV1TargetingSemanticVersionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingValueInput>>
  >;
};

export type PartialFlagsTypesV1TargetingStartsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<PartialFlagsTypesV1TargetingListValueInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
  versionValue?: InputMaybe<PartialFlagsTypesV1TargetingSemanticVersionInput>;
};

export type PartialGoogleTypeDecimalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialHypothesisDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1AgentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1AgentLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewerSkill?: InputMaybe<PartialIamV1AgentReviewerSkillInput>;
};

export type PartialIamV1AgentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1AgentReviewerSkillInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ApiClientInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1ApiClientLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ApiClientLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientCredentialClientSecretInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientCredentialInput = {
  clientSecret?: InputMaybe<PartialIamV1ClientCredentialClientSecretInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialIamV1ClientCredentialLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdkType?: InputMaybe<IamV1ClientCredentialSdkType>;
};

export type PartialIamV1ClientCredentialLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1ClientLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1GroupLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slackChannel?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1GroupLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1OAuthAppInput = {
  allowedCallbackUrls?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  allowedLogoutUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedWebOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1OAuthAppLabelsEntryInput>>>;
  logoUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1OAuthAppLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1PermissionInput = {
  category?: InputMaybe<IamV1PermissionCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IamV1PermissionType>;
};

export type PartialIamV1PolicyInput = {
  identities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1PolicyLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialIamV1PolicyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1RoleInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1RoleLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<PartialIamV1PermissionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1RoleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1UserLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1UserLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionAggregateInput = {
  average?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  count?: InputMaybe<PartialInsightsV1ArithmeticExpressionCountInput>;
  max?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  min?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sum?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
};

export type PartialInsightsV1ArithmeticExpressionCountInput = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionDivideInput = {
  denominator?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  numerator?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionInput = {
  aggregate?: InputMaybe<PartialInsightsV1ArithmeticExpressionAggregateInput>;
  divide?: InputMaybe<PartialInsightsV1ArithmeticExpressionDivideInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  multiply?: InputMaybe<PartialInsightsV1ArithmeticExpressionOperandsInput>;
  negate?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  plus?: InputMaybe<PartialInsightsV1ArithmeticExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  subtract?: InputMaybe<PartialInsightsV1ArithmeticExpressionSubtractInput>;
  value?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1ArithmeticExpressionOperandsInput = {
  operands?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1ArithmeticExpressionInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionSubtractInput = {
  left?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
};

export type PartialInsightsV1ExampleQueryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterAnyRuleInput = {
  eqRule?: InputMaybe<PartialInsightsV1FilterEqRuleInput>;
  itemAttribute?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialInsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialInsightsV1FilterSetRuleInput>;
};

export type PartialInsightsV1FilterBooleanExpressionInput = {
  and?: InputMaybe<PartialInsightsV1FilterBooleanExpressionOperandsInput>;
  not?: InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>;
  or?: InputMaybe<PartialInsightsV1FilterBooleanExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterBooleanExpressionOperandsInput = {
  operands?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialInsightsV1FilterCriterionInput>;
};

export type PartialInsightsV1FilterCriterionAttributeCriterionInput = {
  anyRule?: InputMaybe<PartialInsightsV1FilterAnyRuleInput>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  eqRule?: InputMaybe<PartialInsightsV1FilterEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialInsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialInsightsV1FilterSetRuleInput>;
};

export type PartialInsightsV1FilterCriterionInput = {
  attribute?: InputMaybe<PartialInsightsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1FilterInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1FilterCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  endInclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  startInclusive?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<PartialInsightsV1ValueInput>>>;
};

export type PartialInsightsV1InsightsDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsDocumentLabelsEntryInput>>
  >;
  lifecycle?: InputMaybe<InsightsV1InsightsDocumentLifecycle>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsDocumentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsMetricInput = {
  dataSource?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  filter?: InputMaybe<PartialInsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsMetricLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<PartialInsightsV1TimeConfigInput>;
};

export type PartialInsightsV1InsightsMetricLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsTableContextInput = {
  capabilitySummary?: InputMaybe<Scalars['String']['input']>;
  contextMarkdown?: InputMaybe<Scalars['String']['input']>;
  ddl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exampleQueries?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1ExampleQueryInput>>
  >;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsTableContextLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsightsV1InsightsContextSource>;
};

export type PartialInsightsV1InsightsTableContextLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1TimeAggregationConfigInput = {
  allCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  truncation?: InputMaybe<InsightsV1Truncation>;
  until?: InputMaybe<InsightsV1TimeSeriesEnd>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1TimeConfigInput = {
  disableDeleteTimeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeColumn?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeAggregation?: InputMaybe<PartialInsightsV1TimeAggregationConfigInput>;
  timeColumn?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  decimalValue?: InputMaybe<PartialGoogleTypeDecimalInput>;
  intValue?: InputMaybe<Scalars['Long']['input']>;
  nullValue?: InputMaybe<InsightsV1NullValue>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMaterializerV1ScheduledMaterializedSegmentLoadJobInput = {
  entityIdColumn?: InputMaybe<Scalars['String']['input']>;
  entityIdColumnType?: InputMaybe<MaterializerV1ColumnType>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialMaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntryInput>
    >
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMaterializerV1ScheduledMaterializedSegmentLoadJobLabelsEntryInput =
  {
    key?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetaAnalysisDataInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  experiments?: InputMaybe<
    Array<InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetaAnalysisDataInputExperimentEntryInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  instanceName?: InputMaybe<Scalars['String']['input']>;
  metricCalculations?: InputMaybe<
    Array<
      InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput>
    >
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<
      InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput>
    >
  >;
};

export type PartialMetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput =
  {
    calculation?: InputMaybe<Scalars['String']['input']>;
    metricName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState>;
  };

export type PartialMetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    weight?: InputMaybe<Scalars['Long']['input']>;
  };

export type PartialMetricRoleOneOfInput = {
  guardrailMetric?: InputMaybe<PartialMetricsDataInputMetricInputGuardrailMetricInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  successMetric?: InputMaybe<PartialMetricsDataInputMetricInputSuccessMetricInput>;
};

export type PartialMetricsDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  assignmentTableSource?: InputMaybe<MetricsDataInputAssignmentTableSource>;
  bucket?: InputMaybe<MetricsDataInputBucket>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityFilters?: InputMaybe<
    Array<InputMaybe<PartialMetricsDataInputEntityFilterInput>>
  >;
  entitySource?: InputMaybe<MetricsDataInputEntitySource>;
  exposureCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<PartialMetricsDataInputExposureFilterInput>;
  exposureMetric?: InputMaybe<Scalars['String']['input']>;
  exposureMetricCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureMetricSchedule?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<InputMaybe<PartialMetricsDataInputExposureFilterInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialMetricsDataInputMetricInput>>>;
};

export type PartialMetricsDataInputEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsDataInputEntityFilterInputFilterInput>;
};

export type PartialMetricsDataInputEntityFilterInputFilterInput = {
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  expression?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialMetricsDataInputExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsDataInputExposureFilterInputFilterInput>;
};

export type PartialMetricsDataInputExposureFilterInputFilterInput = {
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  expression?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialMetricsDataInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricRole?: InputMaybe<PartialMetricRoleOneOfInput>;
  preferredDirection?: InputMaybe<MetricsDataInputMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsDataInputMetricInputGuardrailMetricInput = {
  metricKind?: InputMaybe<MetricsDataInputMetricInputGuardrailMetricInputMetricKind>;
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsDataInputMetricInputSuccessMetricInput = {
  metricKind?: InputMaybe<MetricsDataInputMetricInputSuccessMetricInputMetricKind>;
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1AggregationInput = {
  cap?: InputMaybe<PartialMetricsV1ValueCapInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<PartialMetricsV1AggregationThresholdInput>;
  type?: InputMaybe<MetricsV1AggregationType>;
};

export type PartialMetricsV1AggregationThresholdInput = {
  direction?: InputMaybe<MetricsV1AggregationThresholdDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<PartialGoogleTypeDecimalInput>;
};

export type PartialMetricsV1AssignmentTableInput = {
  assignmentDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  exposureKeyColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1AssignmentTableLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  timestampTruncation?: InputMaybe<PartialMetricsV1TimeTruncationInput>;
  variantKeyColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1AssignmentTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1BigQueryConfigInput = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  exportJobsServiceAccount?: InputMaybe<Scalars['String']['input']>;
  gcpProjectId?: InputMaybe<Scalars['String']['input']>;
  interactiveProjectId?: InputMaybe<Scalars['String']['input']>;
  processingProjectId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ColumnInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repeated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput =
  {
    changeThreshold?: InputMaybe<PartialGoogleTypeDecimalInput>;
    commitDelay?: InputMaybe<Scalars['String']['input']>;
    incrementDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput = {
  automaticUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput>;
  dailyUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput>;
  disableEmptyPartitions?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy>;
};

export type PartialMetricsV1DataWarehouseConfigInput = {
  bigQueryConfig?: InputMaybe<PartialMetricsV1BigQueryConfigInput>;
  dataBricksConfig?: InputMaybe<PartialMetricsV1DatabricksConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<PartialMetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<PartialMetricsV1SnowflakeConfigInput>;
};

export type PartialMetricsV1DataWarehouseDataWarehouseLimitsInput = {
  maxConcurrentInteractiveQueries?: InputMaybe<Scalars['Long']['input']>;
  maxConcurrentQueries?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DataWarehouseInput = {
  config?: InputMaybe<PartialMetricsV1DataWarehouseConfigInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DataWarehouseLabelsEntryInput>>
  >;
  limits?: InputMaybe<PartialMetricsV1DataWarehouseDataWarehouseLimitsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DataWarehouseLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DatabricksConfigInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultsSchema?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableDimensionValueMappingInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  mappings?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableValueMappingInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityColumnMapping?: InputMaybe<PartialMetricsV1EntityColumnMappingInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<PartialMetricsV1DimensionTableTimeConfigInput>;
  valueMappings?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableDimensionValueMappingInput>>
  >;
};

export type PartialMetricsV1DimensionTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableTimeConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableValueMappingInput = {
  inputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  outputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityColumnMappingInput = {
  column?: InputMaybe<PartialMetricsV1ColumnInput>;
  entity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityIdentityBindingInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityIdentityBindingLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityIdentityBindingLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityInput = {
  defaultAssignmentTable?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryKeyType?: InputMaybe<MetricsV1ColumnType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityRelationTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityRelationTableLabelsEntryInput>>
  >;
  owner?: InputMaybe<Scalars['String']['input']>;
  parentEntityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  targetEntityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1EntityRelationTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntitySamplingConfigInput = {
  hashSeed?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1ExposureCalculationGroupInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecInput = {
  assignmentFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  entityFilter?: InputMaybe<PartialMetricsV1ExposureCalculationSpecEntityFilterInput>;
  entityFilters?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureCalculationSpecEntityFilterInput>>
  >;
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureFilter?: InputMaybe<PartialMetricsV1ExposureCalculationSpecExposureFilterInput>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ExposureCalculationSpecExposureFilterInput>
    >
  >;
  groups?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureCalculationGroupInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  splitDimensions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialMetricsV1ExposureTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  exposureFilterColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  firstExposureTimeColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  firstExposureTruncation?: InputMaybe<PartialMetricsV1TimeTruncationInput>;
  groupNameColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureTableLabelsEntryInput>>
  >;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExpressionInput = {
  and?: InputMaybe<PartialMetricsV1ExpressionOperandsInput>;
  not?: InputMaybe<PartialMetricsV1ExpressionInput>;
  or?: InputMaybe<PartialMetricsV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<InputMaybe<PartialMetricsV1ExpressionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FactTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityColumnMappingInput>>
  >;
  factDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1FactTableLabelsEntryInput>>
  >;
  measures?: InputMaybe<Array<InputMaybe<PartialMetricsV1MeasureInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipSqlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1FactTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialMetricsV1FilterCriterionInput>;
};

export type PartialMetricsV1FilterCriterionAttributeCriterionInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  eqRule?: InputMaybe<PartialMetricsV1FilterEqRuleInput>;
  likeRule?: InputMaybe<PartialMetricsV1FilterLikeRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialMetricsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialMetricsV1FilterSetRuleInput>;
};

export type PartialMetricsV1FilterCriterionInput = {
  attribute?: InputMaybe<PartialMetricsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialMetricsV1FilterValueInput>;
};

export type PartialMetricsV1FilterInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1FilterCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialMetricsV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterLikeRuleInput = {
  pattern?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  endInclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  startInclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
};

export type PartialMetricsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<PartialMetricsV1FilterValueInput>>>;
};

export type PartialMetricsV1FilterValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  nullValue?: InputMaybe<PartialMetricsV1FilterValueNullInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterValueNullInput = {
  dummyField?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MeasureInput = {
  column?: InputMaybe<PartialMetricsV1ColumnInput>;
  declaredType?: InputMaybe<MetricsV1ColumnType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<PartialMetricsV1UnitInput>;
};

export type PartialMetricsV1MeasurementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MeasurementLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<PartialMetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<PartialMetricsV1MetricMetricTypeSpecInput>;
};

export type PartialMetricsV1MeasurementLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricAverageMetricSpecInput = {
  aggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  measurement?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricCalculationDimensionInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricCalculationSpecInput = {
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scaleUpResults?: InputMaybe<Scalars['Boolean']['input']>;
  splitDimensions?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MetricCalculationDimensionInput>>
  >;
};

export type PartialMetricsV1MetricInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  defaultEffectSize?: InputMaybe<PartialGoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MetricLabelsEntryInput>>
  >;
  measurement?: InputMaybe<Scalars['String']['input']>;
  measurementConfig?: InputMaybe<PartialMetricsV1MetricMeasurementConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<PartialMetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MetricsV1MetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<PartialMetricsV1MetricMetricTypeSpecInput>;
  varianceReductionConfig?: InputMaybe<PartialMetricsV1MetricVarianceReductionConfigInput>;
};

export type PartialMetricsV1MetricLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigClosedWindowConfigInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigInput = {
  closedWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigClosedWindowConfigInput>;
  openWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigOpenWindowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semiOpenWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput>;
};

export type PartialMetricsV1MetricMeasurementConfigOpenWindowConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMetricSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetricsV1MetricMetricSourceType>;
};

export type PartialMetricsV1MetricMetricTypeSpecInput = {
  averageMetricSpec?: InputMaybe<PartialMetricsV1MetricAverageMetricSpecInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileMetricSpec?: InputMaybe<PartialMetricsV1MetricQuantileMetricSpecInput>;
  ratioMetricSpec?: InputMaybe<PartialMetricsV1MetricRatioMetricSpecInput>;
};

export type PartialMetricsV1MetricNullHandlingConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  replaceEntityNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
  replaceMeasureNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsV1MetricQuantileMetricSpecInput = {
  aggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  measurement?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1MetricRatioMetricSpecInput = {
  denominator?: InputMaybe<PartialMetricsV1ColumnInput>;
  denominatorAggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  denominatorFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  numerator?: InputMaybe<PartialMetricsV1ColumnInput>;
  numeratorAggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  numeratorFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricVarianceReductionConfigInput = {
  aggregationWindowOverride?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput =
  {
    accessKeyId?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    secretAccessKey?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1RedshiftConfigInput = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  credentialsSettings?: InputMaybe<PartialMetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput>;
  dataApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<MetricsV1AwsRegion>;
  roleArn?: InputMaybe<Scalars['String']['input']>;
  webIdentitySettings?: InputMaybe<PartialMetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput>;
};

export type PartialMetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1ScheduledExposureCalculationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  exposureCalculationSpec?: InputMaybe<PartialMetricsV1ExposureCalculationSpecInput>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ScheduledExposureCalculationLabelsEntryInput>
    >
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledExposureCalculationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledMetricCalculationInput = {
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ScheduledMetricCalculationLabelsEntryInput>
    >
  >;
  metricCalculationSpec?: InputMaybe<PartialMetricsV1MetricCalculationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledMetricCalculationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1SnowflakeConfigInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  authenticationKey?: InputMaybe<Scalars['String']['input']>;
  exposureDatabase?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1TimeTruncationInput = {
  behaviour?: InputMaybe<MetricsV1TruncationBehavior>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<MetricsV1TruncationTimeZone>;
  window?: InputMaybe<MetricsV1TruncationWindow>;
};

export type PartialMetricsV1UnitInput = {
  baseUnit?: InputMaybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ValueCapInput = {
  max?: InputMaybe<PartialGoogleTypeDecimalInput>;
  min?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialModuleDataInput = {
  abtest?: InputMaybe<PartialAbTestDataInput>;
  analysis?: InputMaybe<PartialAnalysisDataInput>;
  audiences?: InputMaybe<PartialAudiencesDataInput>;
  background?: InputMaybe<PartialBackgroundDataInput>;
  c4sabtest?: InputMaybe<PartialC4sAbTestInput>;
  c4srollout?: InputMaybe<PartialC4sRolloutInput>;
  decision?: InputMaybe<PartialDecisionRecordDataInput>;
  eptest?: InputMaybe<PartialEpTestInput>;
  explore?: InputMaybe<PartialExploreDataInput>;
  exposure?: InputMaybe<PartialExposureDataInput>;
  flags?: InputMaybe<PartialFlagsDataInput>;
  hypothesis?: InputMaybe<PartialHypothesisDataInput>;
  metaanalysis?: InputMaybe<PartialMetaAnalysisDataInput>;
  metrics?: InputMaybe<PartialMetricsDataInput>;
  monitoring?: InputMaybe<PartialMonitoringMetricsDataInput>;
  observational?: InputMaybe<PartialObservationalMetricsDataInput>;
  planning?: InputMaybe<PartialPlanningDataInput>;
  reanalysis?: InputMaybe<PartialReanalysisDataInput>;
  remoteconfig?: InputMaybe<PartialRemoteConfigDataInput>;
  report?: InputMaybe<PartialReportDataInput>;
  reviews?: InputMaybe<PartialReviewsDataInput>;
  rollout?: InputMaybe<PartialRolloutDataInput>;
  samplesize?: InputMaybe<PartialSampleSizeDataInput>;
  spotifyanalysis?: InputMaybe<PartialSpotifyAnalysisInput>;
  staticconfig?: InputMaybe<PartialStaticConfigInput>;
  stats?: InputMaybe<PartialStatsDataInput>;
};

export type PartialMonitoringMetricsDataInput = {
  metrics?: InputMaybe<
    Array<InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricInput>>
  >;
  results?: InputMaybe<
    Array<
      InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricResultInput>
    >
  >;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<
    Array<
      InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput>
    >
  >;
  metric?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput =
  {
    group?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState>;
  };

export type PartialObservationalMetricsDataInput = {
  dismissed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metrics?: InputMaybe<
    Array<
      InputMaybe<PartialObservationalMetricsDataInputObservationalMetricInput>
    >
  >;
  results?: InputMaybe<
    Array<
      InputMaybe<PartialObservationalMetricsDataInputObservationalResultInput>
    >
  >;
};

export type PartialObservationalMetricsDataInputObservationalMetricInput = {
  directEnforcement?: InputMaybe<ObservationalMetricsDataInputObservationalMetricInputDirectEnforcement>;
  enforcement?: InputMaybe<ObservationalMetricsDataInputObservationalMetricInputEnforcement>;
  metric?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialObservationalMetricsDataInputObservationalResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssueAssessmentInput = {
  evidence?: InputMaybe<Scalars['Float']['input']>;
  impact?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialObservationsV1IssueInput = {
  assessment?: InputMaybe<PartialObservationsV1IssueAssessmentInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  autonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ObservationsV1IssueKind>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1IssueLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PartialObservationsV1IssuePriorityInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snoozedUntilTime?: InputMaybe<Scalars['String']['input']>;
  suggestedActions?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1IssueSuggestedActionInput>>
  >;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssueLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssuePriorityInput = {
  humanEdited?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<ObservationsV1IssuePriorityLevel>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssueSuggestedActionInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssuesConfigInput = {
  defaultAutonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ObservationInput = {
  eventTime?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1ObservationLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialObservationsV1SourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialObservationsV1ObservationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1SourceInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  origin?: InputMaybe<ObservationsV1SourceOrigin>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1TaskInput = {
  dependencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1TaskLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1TaskLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ThemeInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1ThemeLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ThemeLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressCourseProgressInput = {
  course?: InputMaybe<Scalars['String']['input']>;
  lessonProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressLessonProgressInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressInput = {
  courseProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressCourseProgressInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressLessonProgressInput = {
  lessonIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressQuestionProgressInput>>
  >;
};

export type PartialOnboardingV1LearningProgressQuestionProgressInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialOnboardingV1OnboardingSetupInput = {
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<OnboardingV1OnboardingPath>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1TourPreferencesInput = {
  abTestsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rolloutsStatus?: InputMaybe<OnboardingV1TourStepStatus>;
};

export type PartialPlanningDataInput = {
  actual?: InputMaybe<PartialPlanningDataInputPeriodInput>;
  planned?: InputMaybe<PartialPlanningDataInputPeriodInput>;
};

export type PartialPlanningDataInputPeriodInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1AgentOutputInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1AgentSourceInput = {
  instructions?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialPulseV1PulseBlockInput = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  currentResult?: InputMaybe<PartialPulseV1PulseBlockOutputInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PartialPulseV1PulseBlockOriginInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultData?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialPulseV1PulseBlockSourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1PulseBlockOriginInput = {
  conversation?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1PulseBlockOutputInput = {
  agentOutput?: InputMaybe<PartialPulseV1AgentOutputInput>;
  captureTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryResult?: InputMaybe<PartialPulseV1QueryResultInput>;
};

export type PartialPulseV1PulseBlockPlacementInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialPulseV1PulseBlockSourceInput = {
  agent?: InputMaybe<PartialPulseV1AgentSourceInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<PartialPulseV1SqlSourceInput>;
  staticResult?: InputMaybe<PartialPulseV1StaticResultSourceInput>;
};

export type PartialPulseV1PulseInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<PartialPulseV1PulseLayoutInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reportingConfig?: InputMaybe<PartialPulseV1ReportingConfigInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  userSummary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1PulseLayoutInput = {
  placements?: InputMaybe<
    Array<InputMaybe<PartialPulseV1PulseBlockPlacementInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1QueryResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialPulseV1ReportingConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PartialPulseV1SlackDestinationInput>;
};

export type PartialPulseV1SlackDestinationInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1SqlSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1StaticResultSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReanalysisDataInput = {
  configChanged?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  exposureMetricState?: InputMaybe<ReanalysisDataInputExposureMetricState>;
  exposureState?: InputMaybe<ReanalysisDataInputExposureState>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialReanalysisDataInputMetricDataInput>>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialReanalysisDataInputTreatmentInput>>
  >;
};

export type PartialReanalysisDataInputMetricDataInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ReanalysisDataInputMetricDataInputState>;
};

export type PartialReanalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialRecordingV1RecordingPolicyInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialRecordingV1RecordingPolicyLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingPolicyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingRuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialRecordingV1RecordingRuleLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sessionSampleRate?: InputMaybe<Scalars['Float']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingRuleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRemoteConfigDataInput = {
  epExperimentOverride?: InputMaybe<PartialRemoteConfigDataInputEpExperimentOverrideInput>;
  overridePolicyMap?: InputMaybe<Scalars['JSON']['input']>;
  policyId?: InputMaybe<Scalars['String']['input']>;
  policyName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<
    Array<InputMaybe<PartialRemoteConfigDataInputPropertyInput>>
  >;
};

export type PartialRemoteConfigDataInputEpExperimentOverrideInput = {
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRemoteConfigDataInputPropertyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<PartialSectionsOneOfInput>>>;
};

export type PartialReportDataInputHypothesisSectionInput = {
  hypothesisData?: InputMaybe<PartialReportDataInputHypothesisSectionInputHypothesisDataInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputHypothesisSectionInputHypothesisDataInput = {
  hypothesis?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputImagesSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  imagesData?: InputMaybe<PartialReportDataInputImagesSectionInputImagesDataInput>;
};

export type PartialReportDataInputImagesSectionInputImagesDataInput = {
  images?: InputMaybe<
    Array<
      InputMaybe<PartialReportDataInputImagesSectionInputImagesDataInputImageDataInput>
    >
  >;
};

export type PartialReportDataInputImagesSectionInputImagesDataInputImageDataInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    imageUri?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputMetricsSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  metricsData?: InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInput>;
};

export type PartialReportDataInputMetricsSectionInputMetricsDataInput = {
  metrics?: InputMaybe<
    Array<
      InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInput>
    >
  >;
};

export type PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    metric?: InputMaybe<Scalars['String']['input']>;
    metricName?: InputMaybe<Scalars['String']['input']>;
    treatments?: InputMaybe<
      Array<
        InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput>
      >
    >;
  };

export type PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    treatment?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputNextSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  nextData?: InputMaybe<PartialReportDataInputNextSectionInputNextDataInput>;
};

export type PartialReportDataInputNextSectionInputNextDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputOutcomeSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  outcomeData?: InputMaybe<PartialReportDataInputOutcomeSectionInputOutcomeDataInput>;
};

export type PartialReportDataInputOutcomeSectionInputOutcomeDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputRecommendationSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  recommendationsData?: InputMaybe<PartialReportDataInputRecommendationSectionInputRecommendationsDataInput>;
};

export type PartialReportDataInputRecommendationSectionInputRecommendationsDataInput =
  {
    content?: InputMaybe<
      Array<
        InputMaybe<PartialReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput>
      >
    >;
  };

export type PartialReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    shippingRecommendation?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputResultsSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  resultsData?: InputMaybe<PartialReportDataInputResultsSectionInputResultsDataInput>;
};

export type PartialReportDataInputResultsSectionInputResultsDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputSummarySectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  summaryData?: InputMaybe<PartialReportDataInputSummarySectionInputSummaryDataInput>;
};

export type PartialReportDataInputSummarySectionInputSummaryDataInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReviewsDataInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  optionalReviews?: InputMaybe<
    Array<InputMaybe<PartialReviewsDataInputSurfaceReviewDataInput>>
  >;
  requiredReviews?: InputMaybe<
    Array<InputMaybe<PartialReviewsDataInputSurfaceReviewDataInput>>
  >;
  reviewId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewsDataInputStatus>;
};

export type PartialReviewsDataInputSurfaceReviewDataInput = {
  responses?: InputMaybe<
    Array<
      InputMaybe<PartialReviewsDataInputSurfaceReviewDataInputResponseInput>
    >
  >;
  state?: InputMaybe<ReviewsDataInputSurfaceReviewDataInputState>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReviewsDataInputSurfaceReviewDataInputResponseInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  reviewer?: InputMaybe<Scalars['String']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ReviewsDataInputSurfaceReviewDataInputResponseInputState>;
};

export type PartialRolloutDataInput = {
  abtest?: InputMaybe<Scalars['String']['input']>;
  controlAssignmentId?: InputMaybe<Scalars['String']['input']>;
  controlVariant?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  initialReach?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  reusableBucketRanges?: InputMaybe<
    Array<InputMaybe<PartialRolloutDataInputBucketRangeInput>>
  >;
  schedule?: InputMaybe<PartialRolloutDataInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variantAssignmentId?: InputMaybe<Scalars['String']['input']>;
  variantImageUri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRolloutDataInputBucketRangeInput = {
  lower?: InputMaybe<Scalars['Long']['input']>;
  upper?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialRolloutDataInputScheduleInput = {
  state?: InputMaybe<RolloutDataInputScheduleInputState>;
  stateReason?: InputMaybe<PartialRolloutDataInputScheduleInputScheduleStateReasonInput>;
  steps?: InputMaybe<
    Array<InputMaybe<PartialRolloutDataInputScheduleInputScheduleStepsInput>>
  >;
};

export type PartialRolloutDataInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInputFailed>;
};

export type PartialRolloutDataInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RolloutDataInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInput = {
  assignmentTableData?: InputMaybe<PartialSampleSizeDataInputAssignmentTableDataInput>;
  error?: InputMaybe<Scalars['String']['input']>;
  existingInstanceData?: InputMaybe<PartialSampleSizeDataInputExistingInstanceDataInput>;
  exposure?: InputMaybe<PartialExposureOneOfInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationData?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInput>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  exposureKind?: InputMaybe<SampleSizeDataInputExposureKind>;
  exposureSource?: InputMaybe<PartialExposureSourceOneOfInput>;
  exposureSourceKind?: InputMaybe<SampleSizeDataInputExposureSourceKind>;
  hasCustomizedExposureSource?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInput>>
  >;
  powerAnalysis?: InputMaybe<Scalars['JSON']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledExposureCalculationData?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationDataInput>;
  state?: InputMaybe<SampleSizeDataInputState>;
  statsParameters?: InputMaybe<PartialSampleSizeDataInputStatsParametersInput>;
  statsTestConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialSampleSizeDataInputAssignmentTableDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PartialSampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput>;
};

export type PartialSampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PartialSampleSizeDataInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSampleSizeDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputExistingInstanceDataInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExistingInstanceInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationDataInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInput>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput>;
  };

export type PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputExposureCalculationInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInput>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  scheduledExposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    customEndTime?: InputMaybe<Scalars['String']['input']>;
    customStartTime?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput>;
    runtime?: InputMaybe<Scalars['String']['input']>;
    samplingFactor?: InputMaybe<Scalars['Float']['input']>;
  };

export type PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  forecastedData?: InputMaybe<
    Array<
      InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput>
    >
  >;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  metricCalculationName?: InputMaybe<Scalars['String']['input']>;
  observedData?: InputMaybe<
    Array<
      InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputObservedDataPointInput>
    >
  >;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledMetricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputState>;
  summaryStats?: InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputSummaryStatsInput>;
  type?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputType>;
};

export type PartialSampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput =
  {
    dayIndex?: InputMaybe<Scalars['Long']['input']>;
    expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
    requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInputObservedDataPointInput =
  {
    dayIndex?: InputMaybe<Scalars['Long']['input']>;
    expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
    mean?: InputMaybe<Scalars['Float']['input']>;
    requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
    variance?: InputMaybe<Scalars['Float']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInputSummaryStatsInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputScheduledExposureCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputStatsParametersInput = {
  allocationProportion?: InputMaybe<Scalars['String']['input']>;
  alpha?: InputMaybe<Scalars['Float']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<SampleSizeDataInputStatsParametersInputTestHorizonStrategy>;
};

export type PartialSectionsOneOfInput = {
  hypothesisSection?: InputMaybe<PartialReportDataInputHypothesisSectionInput>;
  imagesSection?: InputMaybe<PartialReportDataInputImagesSectionInput>;
  metricsSection?: InputMaybe<PartialReportDataInputMetricsSectionInput>;
  nextSection?: InputMaybe<PartialReportDataInputNextSectionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeSection?: InputMaybe<PartialReportDataInputOutcomeSectionInput>;
  recommendationSection?: InputMaybe<PartialReportDataInputRecommendationSectionInput>;
  resultsSection?: InputMaybe<PartialReportDataInputResultsSectionInput>;
  summarySection?: InputMaybe<PartialReportDataInputSummarySectionInput>;
};

export type PartialSpotifyAnalysisInput = {
  experimentId?: InputMaybe<Scalars['Long']['input']>;
  mhMetrics?: InputMaybe<
    Array<InputMaybe<PartialSpotifyAnalysisInputMhMetricInput>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialSpotifyAnalysisInputTreatmentInput>>
  >;
};

export type PartialSpotifyAnalysisInputMhMetricInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  guardrail?: InputMaybe<PartialSpotifyAnalysisInputMhMetricInputGuardrailInput>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['JSON']['input']>;
  success?: InputMaybe<PartialSpotifyAnalysisInputMhMetricInputSuccessInput>;
  userCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialSpotifyAnalysisInputMhMetricInputGuardrailInput = {
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSpotifyAnalysisInputMhMetricInputSuccessInput = {
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSpotifyAnalysisInputTreatmentInput = {
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStaticConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  propertyAssignments?: InputMaybe<
    Array<InputMaybe<PartialStaticConfigInputPropertyAssignmentInput>>
  >;
  treatmentId?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStaticConfigInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  analysisResults?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputAnalysisResultInput>>
  >;
  fallbackSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricInformation?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputMetricInformationInput>>
  >;
  metricMethods?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputMethodInput>>
  >;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<StatsDataInputTestHorizonStrategy>;
};

export type PartialStatsDataInputAnalysisResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInputMethodInput = {
  method?: InputMaybe<StatsDataInputMethodInputMethod>;
  metricName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInputMetricInformationInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisAnalysisResultInput = {
  annotations?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationInput>>
  >;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisAnalysisResultLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsHypothesisResultInput>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisTreatmentInfoInput>>
  >;
};

export type PartialStatsV2AnalysisAnalysisResultLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisEstimateInput = {
  estimate?: InputMaybe<Scalars['Float']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lower?: InputMaybe<Scalars['Float']['input']>;
  powered?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialStatsV2AnalysisMetricDetailsInput = {
  direction?: InputMaybe<StatsV2AnalysisMetricDirection>;
  hasRun?: InputMaybe<Scalars['Boolean']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisMetricStatusInput = {
  decisionIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  decisionPowered?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialStatsV2AnalysisRecommendationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<StatsV2AnalysisShippingRecommendation>;
  status?: InputMaybe<PartialStatsV2AnalysisRecommendationStatusInput>;
};

export type PartialStatsV2AnalysisRecommendationStatusInput = {
  guardrail?: InputMaybe<StatsV2AnalysisGuardrailStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<StatsV2AnalysisQualityStatus>;
  success?: InputMaybe<StatsV2AnalysisSuccessStatus>;
  tanking?: InputMaybe<StatsV2AnalysisTankingStatus>;
};

export type PartialStatsV2AnalysisSampleSizeEstimateInput = {
  current?: InputMaybe<Scalars['Long']['input']>;
  poweredEffectAbs?: InputMaybe<Scalars['Float']['input']>;
  poweredEffectRel?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStatsV2AnalysisSrmGroupResultInput = {
  expected?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  observed?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisSrmResultDimensionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisSrmResultInput = {
  dimensions?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmResultDimensionsEntryInput>>
  >;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmGroupResultInput>>
  >;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PartialStatsV2AnalysisMetricStatusInput>;
};

export type PartialStatsV2AnalysisStatsAnnotationContextItemInput = {
  key?: InputMaybe<StatsV2AnalysisStatsAnnotationContext>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsAnnotationErrorInput = {
  category?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsAnnotationInput = {
  context?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationContextItemInput>>
  >;
  error?: InputMaybe<PartialStatsV2AnalysisStatsAnnotationErrorInput>;
  info?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonPairInput = {
  baseline?: InputMaybe<Scalars['String']['input']>;
  compared?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonResultDimensionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonResultInput = {
  comparisonId?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<
    Array<
      InputMaybe<PartialStatsV2AnalysisStatsComparisonResultDimensionsEntryInput>
    >
  >;
  groupStats?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsGroupStatsInput>>
  >;
  groups?: InputMaybe<PartialStatsV2AnalysisStatsComparisonPairInput>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lastDeteriorationResult?: InputMaybe<PartialStatsV2AnalysisStatsResultInput>;
  lastResult?: InputMaybe<PartialStatsV2AnalysisStatsResultInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsResultInput>>
  >;
  sampleSize?: InputMaybe<PartialStatsV2AnalysisSampleSizeEstimateInput>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PartialStatsV2AnalysisMetricStatusInput>;
  usedDataType?: InputMaybe<StatsV2AnalysisStatsDataType>;
};

export type PartialStatsV2AnalysisStatsGroupStatsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStatsV2AnalysisStatsHypothesisResultInput = {
  annotations?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationInput>>
  >;
  id?: InputMaybe<Scalars['String']['input']>;
  metricDetails?: InputMaybe<PartialStatsV2AnalysisMetricDetailsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsComparisonResultInput>>
  >;
  srmResult?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmResultInput>>
  >;
  statsSettings?: InputMaybe<PartialStatsV2AnalysisStatsSettingsInput>;
};

export type PartialStatsV2AnalysisStatsResultInput = {
  baselineEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  baselineEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  baselineSampleSize?: InputMaybe<Scalars['Long']['input']>;
  comparedEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  comparedEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  comparedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  differenceEstimateAbs?: InputMaybe<PartialStatsV2AnalysisEstimateInput>;
  differenceEstimateRel?: InputMaybe<PartialStatsV2AnalysisEstimateInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultTime?: InputMaybe<Scalars['String']['input']>;
  unadjustedEstimateBaseline?: InputMaybe<Scalars['Float']['input']>;
  unadjustedEstimateCompared?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialStatsV2AnalysisStatsSettingsInput = {
  adjustedAlpha?: InputMaybe<Scalars['Float']['input']>;
  adjustedBeta?: InputMaybe<Scalars['Float']['input']>;
  hasVarianceReduction?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<StatsV2AnalysisMethod>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisTreatmentInfoInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<PartialStatsV2AnalysisRecommendationInput>;
};

export type PartialWorkflowV1ExclusivityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1ExclusivityGroupLabelsEntryInput>>
  >;
  mode?: InputMaybe<WorkflowV1ExclusivityGroupMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1ExclusivityGroupLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1HoldbackInput = {
  allocation?: InputMaybe<PartialGoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1HoldbackLabelsEntryInput>>
  >;
  mode?: InputMaybe<WorkflowV1HoldbackMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1HoldbackLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1InitiativeGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1InitiativeSuccessMetricInput>;
};

export type PartialWorkflowV1InitiativeGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeInput = {
  automatedActions?: InputMaybe<
    Array<InputMaybe<PartialActionsV1TypesAutomatedActionInput>>
  >;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeLabelsEntryInput>>
  >;
  metricConfig?: InputMaybe<PartialWorkflowV1InitiativeMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<PartialWorkflowV1InitiativeReviewsInput>;
  stakeholders?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeStakeholderInput>>
  >;
};

export type PartialWorkflowV1InitiativeLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeAssociatedMetricInput>>
  >;
  mandatoryMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeMetricInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialWorkflowV1LinkedMetricInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1InitiativeGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1InitiativeSuccessMetricInput>;
};

export type PartialWorkflowV1InitiativeReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialWorkflowV1InitiativeStakeholderInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1LinkedMetricGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1LinkedMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: InputMaybe<PartialWorkflowV1LinkedMetricGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1LinkedMetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1LinkedMetricSuccessMetricInput>;
};

export type PartialWorkflowV1LinkedMetricSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1SurfaceGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1SurfaceSuccessMetricInput>;
};

export type PartialWorkflowV1SurfaceGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceInput = {
  automatedActions?: InputMaybe<
    Array<InputMaybe<PartialActionsV1TypesAutomatedActionInput>>
  >;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceLabelsEntryInput>>
  >;
  metricConfig?: InputMaybe<PartialWorkflowV1SurfaceMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<PartialWorkflowV1SurfaceReviewsInput>;
  stakeholders?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceStakeholderInput>>
  >;
};

export type PartialWorkflowV1SurfaceLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceAssociatedMetricInput>>
  >;
  mandatoryMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceMetricInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialWorkflowV1LinkedMetricInput>>>;
  monitoringMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceMonitoringMetricInput>>
  >;
  observationalMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceObservationalMetricInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1SurfaceGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1SurfaceSuccessMetricInput>;
};

export type PartialWorkflowV1SurfaceMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1SurfaceMonitoringMetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceObservationalMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  metric?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialWorkflowV1SurfaceStakeholderInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInput = {
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobQueue?: InputMaybe<PartialWorkflowV1WorkflowInstanceWorkflowJobQueueInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceLabelsEntryInput>>
  >;
  moduleData?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceModuleDataEntryInput>>
  >;
  moduleData2?: InputMaybe<PartialModuleDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template?: InputMaybe<Scalars['String']['input']>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceModuleDataEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceWorkflowJobInput = {
  func?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceWorkflowJobQueueInput = {
  items?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceWorkflowJobInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowSecretInput = {
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowSecretLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowSecretLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowTemplateLabelsEntryInput>>
  >;
  moduleData?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowTemplateModuleDataEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceInstance?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateModuleDataEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PlanningData = {
  actual?: Maybe<PlanningDataPeriod>;
  planned?: Maybe<PlanningDataPeriod>;
};

export type PlanningDataInput = {
  actual?: InputMaybe<PlanningDataInputPeriodInput>;
  planned?: InputMaybe<PlanningDataInputPeriodInput>;
};

export type PlanningDataInputPeriodInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningDataPeriod = {
  endTime?: Maybe<Scalars['String']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type PulseV1AgentOutput = {
  content: Scalars['String']['output'];
};

export type PulseV1AgentOutputInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1AgentSource = {
  instructions: Scalars['String']['output'];
  tools: Array<Scalars['String']['output']>;
};

export type PulseV1AgentSourceInput = {
  instructions: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PulseV1CapturePulseBlockResponse = {
  block?: Maybe<PulseV1PulseBlock>;
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1CapturePulseBlockResponseResult =
  | Error
  | PulseV1CapturePulseBlockResponse;

export type PulseV1ConfigurePulseRefreshScheduleResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type PulseV1ConfigurePulseRefreshScheduleResponseResult =
  | Error
  | PulseV1ConfigurePulseRefreshScheduleResponse;

export type PulseV1ConfigurePulseSubscriptionResponse = {
  subscriptions: Array<PulseV1PulseSubscription>;
};

export type PulseV1ConfigurePulseSubscriptionResponseResult =
  | Error
  | PulseV1ConfigurePulseSubscriptionResponse;

export type PulseV1EventsPulseBlockCreated = {
  pulseBlock?: Maybe<PulseV1PulseBlock>;
};

export type PulseV1EventsPulseBlockUpdated = {
  pulseBlock?: Maybe<PulseV1PulseBlock>;
};

export type PulseV1EventsPulseCreated = {
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1EventsPulseUpdated = {
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1ListPulseBlocksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pulseBlocks: Array<PulseV1PulseBlock>;
};

export type PulseV1ListPulseBlocksResponseResult =
  | Error
  | PulseV1ListPulseBlocksResponse;

export type PulseV1ListPulseChangesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pulseChanges: Array<PulseV1PulseChange>;
};

export type PulseV1ListPulseChangesResponseResult =
  | Error
  | PulseV1ListPulseChangesResponse;

export type PulseV1ListPulsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pulses: Array<PulseV1Pulse>;
};

export type PulseV1ListPulsesResponseResult = Error | PulseV1ListPulsesResponse;

export type PulseV1Pulse = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocks: Array<PulseV1PulseBlock>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  layout?: Maybe<PulseV1PulseLayout>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  projects: Array<CollaborationV1ProjectResult>;
  pulseBlocks?: Maybe<PulseV1ListPulseBlocksResponseResult>;
  pulseChanges?: Maybe<PulseV1ListPulseChangesResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  reportingConfig?: Maybe<PulseV1ReportingConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  subscriptions: Array<PulseV1PulseSubscription>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryStale?: Maybe<Scalars['Boolean']['output']>;
  summaryUpdateTime?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  userSummary?: Maybe<Scalars['String']['output']>;
  userSummaryUpdateTime?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type PulseV1PulseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type PulseV1PulseObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulsePulseBlocksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulsePulseChangesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlock = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blockType?: Maybe<PulseV1PulseBlockType>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentResult?: Maybe<PulseV1PulseBlockOutput>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PulseV1PulseBlockError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  origin?: Maybe<PulseV1PulseBlockOrigin>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  refreshTime?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<PulseV1PulseBlockSource>;
  state?: Maybe<PulseV1PulseBlockState>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryUpdateTime?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type PulseV1PulseBlockAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type PulseV1PulseBlockCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type PulseV1PulseBlockObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseBlockErrorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockInput = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  currentResult?: InputMaybe<PulseV1PulseBlockOutputInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PulseV1PulseBlockOriginInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultData?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PulseV1PulseBlockSourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockOrigin = {
  conversation?: Maybe<Scalars['String']['output']>;
  event?: Maybe<ConversationsV2ChatEventResult>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseBlockOriginInput = {
  conversation?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockOutput = {
  agentOutput?: Maybe<PulseV1AgentOutput>;
  captureTime?: Maybe<Scalars['String']['output']>;
  queryResult?: Maybe<PulseV1QueryResult>;
};

export type PulseV1PulseBlockOutputInput = {
  agentOutput?: InputMaybe<PulseV1AgentOutputInput>;
  captureTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryResult?: InputMaybe<PulseV1QueryResultInput>;
};

export type PulseV1PulseBlockPlacement = {
  block: PulseV1PulseBlockResult;
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type PulseV1PulseBlockPlacementInput = {
  block: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type PulseV1PulseBlockResult = Error | PulseV1PulseBlock;

export type PulseV1PulseBlockSource = {
  agent?: Maybe<PulseV1AgentSource>;
  sql?: Maybe<PulseV1SqlSource>;
  staticResult?: Maybe<PulseV1StaticResultSource>;
};

export type PulseV1PulseBlockSourceInput = {
  agent?: InputMaybe<PulseV1AgentSourceInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<PulseV1SqlSourceInput>;
  staticResult?: InputMaybe<PulseV1StaticResultSourceInput>;
};

export enum PulseV1PulseBlockState {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Pending = 'PENDING',
}

export enum PulseV1PulseBlockType {
  PulseBlockTypeBigNumber = 'PULSE_BLOCK_TYPE_BIG_NUMBER',
  PulseBlockTypeChart = 'PULSE_BLOCK_TYPE_CHART',
  PulseBlockTypeTable = 'PULSE_BLOCK_TYPE_TABLE',
  PulseBlockTypeText = 'PULSE_BLOCK_TYPE_TEXT',
}

export type PulseV1PulseChange = {
  action?: Maybe<Scalars['String']['output']>;
  actionTime?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemInitiated?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type PulseV1PulseChangeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseChangeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type PulseV1PulseChangeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseChangeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type PulseV1PulseChangeObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseChangeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseChangeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseChangeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseChangeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseChangeTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<PulseV1PulseLayoutInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reportingConfig?: InputMaybe<PulseV1ReportingConfigInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  userSummary?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseLayout = {
  placements: Array<PulseV1PulseBlockPlacement>;
};

export type PulseV1PulseLayoutInput = {
  placements: Array<PulseV1PulseBlockPlacementInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum PulseV1PulseRefreshSchedule {
  PulseRefreshScheduleDaily = 'PULSE_REFRESH_SCHEDULE_DAILY',
  PulseRefreshScheduleHourly = 'PULSE_REFRESH_SCHEDULE_HOURLY',
  PulseRefreshScheduleOff = 'PULSE_REFRESH_SCHEDULE_OFF',
  PulseRefreshScheduleWeekly = 'PULSE_REFRESH_SCHEDULE_WEEKLY',
}

export type PulseV1PulseResult = Error | PulseV1Pulse;

export type PulseV1PulseSubscription = {
  slackChannel?: Maybe<PulseV1SlackChannelSubscription>;
  slackDirectMessage?: Maybe<PulseV1SlackDirectMessageSubscription>;
};

export type PulseV1PulseSubscriptionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slackChannel?: InputMaybe<PulseV1SlackChannelSubscriptionInput>;
  slackDirectMessage?: InputMaybe<PulseV1SlackDirectMessageSubscriptionInput>;
};

export enum PulseV1PulseView {
  PulseViewBasic = 'PULSE_VIEW_BASIC',
  PulseViewFull = 'PULSE_VIEW_FULL',
}

export type PulseV1QueryResult = {
  resultData?: Maybe<Scalars['String']['output']>;
  resultRef?: Maybe<Scalars['String']['output']>;
  visualizationSpec?: Maybe<Scalars['JSON']['output']>;
};

export type PulseV1QueryResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type PulseV1RefreshPulseBlockResponse = {
  pulseBlock?: Maybe<PulseV1PulseBlock>;
};

export type PulseV1RefreshPulseBlockResponseResult =
  | Error
  | PulseV1RefreshPulseBlockResponse;

export type PulseV1RefreshPulseResponse = {
  pulse?: Maybe<PulseV1Pulse>;
  refreshedBlocks: Array<PulseV1PulseBlock>;
};

export type PulseV1RefreshPulseResponseResult =
  | Error
  | PulseV1RefreshPulseResponse;

export type PulseV1ReportingConfig = {
  enabled?: Maybe<Scalars['Boolean']['output']>;
  slack?: Maybe<PulseV1SlackDestination>;
};

export type PulseV1ReportingConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PulseV1SlackDestinationInput>;
};

export type PulseV1ResolvePulseRefreshScheduleResponse = {
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<PulseV1PulseRefreshSchedule>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type PulseV1ResolvePulseRefreshScheduleResponseResult =
  | Error
  | PulseV1ResolvePulseRefreshScheduleResponse;

export type PulseV1SlackChannelSubscription = {
  channel: Scalars['String']['output'];
};

export type PulseV1SlackChannelSubscriptionInput = {
  channel: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1SlackDestination = {
  channel: Scalars['String']['output'];
};

export type PulseV1SlackDestinationInput = {
  channel: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1SlackDirectMessageSubscription = {
  identity?: Maybe<IamV1IdentityResult>;
};

export type PulseV1SlackDirectMessageSubscriptionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1SqlSource = {
  query: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type PulseV1SqlSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1StaticResultSource = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type PulseV1StaticResultSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  accountBilling?: Maybe<BillingV1AccountBillingResult>;
  accountDomains?: Maybe<AdminV1ListAccountDomainsResponseResult>;
  accountTokenUsage?: Maybe<AiworkflowsV1AccountTokenUsageResult>;
  activities?: Maybe<ActivityV1ListActivitiesResponseResult>;
  activity?: Maybe<ActivityV1ActivityResult>;
  activityType?: Maybe<ActivityV1ActivityTypeResult>;
  activityTypes?: Maybe<ActivityV1ListActivityTypesResponseResult>;
  agent?: Maybe<IamV1AgentResult>;
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreviewResult>;
  agents?: Maybe<IamV1ListAgentsResponseResult>;
  aggregateRecordingFilterValues?: Maybe<RecordingV1AggregateRecordingFilterValuesResponseResult>;
  aiWorkflowInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  aiWorkflowInstances?: Maybe<AiworkflowsV1ListAiWorkflowInstancesResponseResult>;
  aiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  aiWorkflowSchedules?: Maybe<AiworkflowsV1ListAiWorkflowSchedulesResponseResult>;
  aiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  aiWorkflowTriggers?: Maybe<AiworkflowsV1ListAiWorkflowTriggersResponseResult>;
  analysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  analysisResults?: Maybe<StatsV2AnalysisListAnalysisResultsResponseResult>;
  apiClient?: Maybe<IamV1ApiClientResult>;
  apiClientSecret?: Maybe<IamV1ApiClientSecretResult>;
  apiClients?: Maybe<IamV1ListApiClientsResponseResult>;
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  assignmentTables?: Maybe<MetricsV1ListAssignmentTablesResponseResult>;
  attachment?: Maybe<CollaborationV1AttachmentResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  billingInfo?: Maybe<BillingV1BillingInfoResult>;
  billingProduct?: Maybe<BillingV1BillingProductResult>;
  billingProducts?: Maybe<BillingV1ListBillingProductsResponseResult>;
  chat?: Maybe<ConversationsV2ChatResult>;
  chatEvent?: Maybe<ConversationsV2ChatEventResult>;
  chatEvents?: Maybe<ConversationsV2ListChatEventsResponseResult>;
  chats?: Maybe<ConversationsV2ListChatsResponseResult>;
  check?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  checks?: Maybe<WorkflowV1ListChecksResponseResult>;
  client?: Maybe<IamV1ClientResult>;
  clientCredential?: Maybe<IamV1ClientCredentialResult>;
  clientCredentialEncryptionKey?: Maybe<IamV1ClientCredentialEncryptionKeyResult>;
  clientCredentials?: Maybe<IamV1ListClientCredentialsResponseResult>;
  clients?: Maybe<IamV1ListClientsResponseResult>;
  collaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  collection?: Maybe<CollectionsV1CollectionResult>;
  collectionEntries?: Maybe<CollectionsV1ListCollectionEntriesResponseResult>;
  collectionEntry?: Maybe<CollectionsV1CollectionEntryResult>;
  collections?: Maybe<CollectionsV1ListCollectionsResponseResult>;
  comment?: Maybe<CollaborationV1CommentResult>;
  commentReplies?: Maybe<CollaborationV1ListCommentRepliesResponseResult>;
  commentReply?: Maybe<CollaborationV1CommentReplyResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contiguousPartition?: Maybe<MetricsV1ContiguousPartitionResult>;
  contiguousPartitions?: Maybe<MetricsV1ListContiguousPartitionsResponseResult>;
  conversation?: Maybe<ConversationsV1ConversationResult>;
  conversations?: Maybe<ConversationsV1ListConversationsResponseResult>;
  cryptoKey?: Maybe<IamV1CryptoKeyResult>;
  cryptoKeys?: Maybe<IamV1ListCryptoKeysResponseResult>;
  currentAccount?: Maybe<AdminV1AccountInfoResult>;
  currentUser?: Maybe<IamV1CurrentUserResult>;
  dashboard?: Maybe<InsightsV1DashboardResult>;
  dashboards?: Maybe<InsightsV1ListDashboardsResponseResult>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  dataWarehouses?: Maybe<MetricsV1ListDataWarehousesResponseResult>;
  dependencies?: Maybe<MetricsV1ListDependenciesResponseResult>;
  dependency?: Maybe<MetricsV1DependencyResult>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  dimensionTables?: Maybe<MetricsV1ListDimensionTablesResponseResult>;
  distinctCount?: Maybe<FlagsAdminV1DistinctCountResult>;
  downloadRecording?: Maybe<RecordingV1DownloadRecordingResponseResult>;
  downloadRecordingTranscript?: Maybe<RecordingV1DownloadRecordingTranscriptResponseResult>;
  entities?: Maybe<MetricsV1ListEntitiesResponseResult>;
  entity?: Maybe<MetricsV1EntityResult>;
  entityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  entityIdentityBindings?: Maybe<MetricsV1ListEntityIdentityBindingsResponseResult>;
  entityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  entityRelationTables?: Maybe<MetricsV1ListEntityRelationTablesResponseResult>;
  environment?: Maybe<FlagsAdminV1EnvironmentResult>;
  environments?: Maybe<FlagsAdminV1ListEnvironmentsResponseResult>;
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  evaluationContextFieldOverrides?: Maybe<FlagsAdminV1ListEvaluationContextFieldOverridesResponseResult>;
  event?: Maybe<ConnectorsV1EventResult>;
  eventConnection?: Maybe<ConnectorsV1EventConnectionResult>;
  eventConnections?: Maybe<ConnectorsV1ListEventConnectionsResponseResult>;
  eventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  eventDefinitions?: Maybe<EventsAdminV1ListEventDefinitionsResponseResult>;
  eventType?: Maybe<ConnectorsV1EventTypeResult>;
  eventTypes?: Maybe<ConnectorsV1ListEventTypesResponseResult>;
  events?: Maybe<ConnectorsV1ListEventsResponseResult>;
  exclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  exclusivityGroups?: Maybe<WorkflowV1ListExclusivityGroupsResponseResult>;
  existsDataWarehouses?: Maybe<MetricsV1ExistsDataWarehousesResponseResult>;
  existsSlack?: Maybe<ActivityV1SlackAdminConfigResult>;
  exportConversation?: Maybe<ConversationsV1ExportConversationResponseResult>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureCalculations?: Maybe<MetricsV1ListExposureCalculationsResponseResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  exposureTables?: Maybe<MetricsV1ListExposureTablesResponseResult>;
  externalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  externalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  externalIntegrations?: Maybe<AiworkflowsV1ListExternalIntegrationsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  factTableContext?: Maybe<InsightsV1FactTableContextResult>;
  factTableContexts?: Maybe<InsightsV1ListFactTableContextsResponseResult>;
  factTableSummaries?: Maybe<InsightsV1ListFactTableSummariesResponseResult>;
  factTableSummary?: Maybe<InsightsV1FactTableSummaryResult>;
  factTables?: Maybe<MetricsV1ListFactTablesResponseResult>;
  feed?: Maybe<ActivityV1FeedResult>;
  feedEntries?: Maybe<ActivityV1ListFeedEntriesResponseResult>;
  feedEntry?: Maybe<ActivityV1FeedEntryResult>;
  feedSubscription?: Maybe<ActivityV1FeedSubscriptionResult>;
  feedSubscriptions?: Maybe<ActivityV1ListFeedSubscriptionsResponseResult>;
  feeds?: Maybe<ActivityV1ListFeedsResponseResult>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  flagAppliedConnection?: Maybe<ConnectorsV1FlagAppliedConnectionResult>;
  flagAppliedConnections?: Maybe<ConnectorsV1ListFlagAppliedConnectionsResponseResult>;
  flags?: Maybe<FlagsAdminV1ListFlagsResponseResult>;
  getFastlyLoggingChallenge?: Maybe<GoogleApiHttpBodyResult>;
  getLatestSdkVersions?: Maybe<InsightsV1GetLatestSdkVersionsResponseResult>;
  getTiptapToken?: Maybe<CollaborationV1GetTiptapTokenResponseResult>;
  group?: Maybe<IamV1GroupResult>;
  groupMembers?: Maybe<IamV1ListGroupMembersResponseResult>;
  groups?: Maybe<IamV1ListGroupsResponseResult>;
  hasExternalIntegration?: Maybe<AiworkflowsV1HasExternalIntegrationResponseResult>;
  holdback?: Maybe<WorkflowV1HoldbackResult>;
  holdbacks?: Maybe<WorkflowV1ListHoldbacksResponseResult>;
  identities?: Maybe<IamV1ListIdentitiesResponseResult>;
  identity?: Maybe<IamV1IdentityResult>;
  initiative?: Maybe<WorkflowV1InitiativeResult>;
  initiatives?: Maybe<WorkflowV1ListInitiativesResponseResult>;
  insightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  insightsDocuments?: Maybe<InsightsV1ListInsightsDocumentsResponseResult>;
  insightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  insightsTableContext?: Maybe<InsightsV1InsightsTableContextResult>;
  insightsTableContexts?: Maybe<InsightsV1ListInsightsTableContextsResponseResult>;
  issue?: Maybe<ObservationsV1IssueResult>;
  issues?: Maybe<ObservationsV1ListIssuesResponseResult>;
  issuesConfig?: Maybe<ObservationsV1IssuesConfigResult>;
  label?: Maybe<AdminLabelsV1LabelResult>;
  labels?: Maybe<AdminLabelsV1ListLabelsResponseResult>;
  learningProgress?: Maybe<OnboardingV1LearningProgressResult>;
  managedAgentSettings?: Maybe<AiworkflowsV1ManagedAgentSettingsResult>;
  managedDataWarehouseProvisioning?: Maybe<OnboardingV1ManagedDataWarehouseProvisioningResult>;
  managedSessions?: Maybe<AiworkflowsV1ListManagedSessionsResponseResult>;
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  materializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  materializedSegmentLoadJobs?: Maybe<MaterializerV1ListMaterializedSegmentLoadJobsResponseResult>;
  materializedSegments?: Maybe<FlagsAdminV1ListMaterializedSegmentsResponseResult>;
  measurement?: Maybe<MetricsV1MeasurementResult>;
  measurementCalculation?: Maybe<MetricsV1MeasurementCalculationResult>;
  measurementCalculations?: Maybe<MetricsV1ListMeasurementCalculationsResponseResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  measurementTables?: Maybe<MetricsV1ListMeasurementTablesResponseResult>;
  measurements?: Maybe<MetricsV1ListMeasurementsResponseResult>;
  metric?: Maybe<MetricsV1MetricResult>;
  metricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  metricCalculations?: Maybe<MetricsV1ListMetricCalculationsResponseResult>;
  metrics?: Maybe<MetricsV1ListMetricsResponseResult>;
  oAuthApp?: Maybe<IamV1OAuthAppResult>;
  oAuthApps?: Maybe<IamV1ListOAuthAppsResponseResult>;
  observation?: Maybe<ObservationsV1ObservationResult>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  onboardingSetup?: Maybe<OnboardingV1OnboardingSetupResult>;
  partition?: Maybe<MetricsV1PartitionResult>;
  partitions?: Maybe<MetricsV1ListPartitionsResponseResult>;
  permissions?: Maybe<IamV1ListPermissionsResponseResult>;
  platformConnection?: Maybe<ConnectorsV1PlatformConnectionResult>;
  platformConnections?: Maybe<ConnectorsV1ListPlatformConnectionsResponseResult>;
  policies?: Maybe<IamV1ListPoliciesResponseResult>;
  policy?: Maybe<IamV1PolicyResult>;
  presence?: Maybe<CollaborationV1PresenceResult>;
  presences?: Maybe<CollaborationV1ListPresencesResponseResult>;
  processRoundLog?: Maybe<MetricsV1ProcessRoundLogResult>;
  processRoundLogs?: Maybe<MetricsV1ListProcessRoundLogsResponseResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  projects?: Maybe<CollaborationV1ListProjectsResponseResult>;
  promptHook?: Maybe<ConversationsV2PromptHookResult>;
  promptHooks?: Maybe<ConversationsV2ListPromptHooksResponseResult>;
  pullRequest?: Maybe<RepositoriesV1PullRequestResult>;
  pulse?: Maybe<PulseV1PulseResult>;
  pulseBlock?: Maybe<PulseV1PulseBlockResult>;
  pulseBlocks?: Maybe<PulseV1ListPulseBlocksResponseResult>;
  pulseChanges?: Maybe<PulseV1ListPulseChangesResponseResult>;
  pulses?: Maybe<PulseV1ListPulsesResponseResult>;
  queryAccountDistinctCount?: Maybe<FlagsAdminV1QueryAccountDistinctCountResponseResult>;
  queryActivityTypes?: Maybe<ActivityV1QueryActivityTypesResponseResult>;
  queryAssignmentDistinctCount?: Maybe<FlagsAdminV1QueryAssignmentDistinctCountResponseResult>;
  queryAvailableTimeRange?: Maybe<MetricsV1QueryAvailableTimeRangeResponseResult>;
  queryCreditUsage?: Maybe<BillingV1CreditUsageReportResult>;
  queryDataWarehouseStats?: Maybe<MetricsV1QueryDataWarehouseStatsResponseResult>;
  queryDraftEvents?: Maybe<EventsAdminV1QueryDraftEventsResponseResult>;
  queryEventsUsage?: Maybe<EventsAdminV1QueryEventsUsageResponseResult>;
  queryFlagUsage?: Maybe<FlagsAdminV1QueryFlagUsageResponseResult>;
  queryInsightsMetric?: Maybe<InsightsV1QueryInsightsMetricResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryMetricCalculation?: Maybe<MetricsV1QueryMetricCalculationResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryRecordingInsightsOverview?: Maybe<RecordingV1QueryRecordingInsightsOverviewResponseResult>;
  queryRecordingRouteInsights?: Maybe<RecordingV1QueryRecordingRouteInsightsResponseResult>;
  queryRuleWorkflowInstance?: Maybe<FlagsAdminV1QueryRuleWorkflowInstanceResponseResult>;
  queryScheduledMetricCalculation?: Maybe<MetricsV1QueryScheduledMetricCalculationResponseResult>;
  querySegmentReferences?: Maybe<FlagsAdminV1QuerySegmentReferencesResponseResult>;
  queryWorkflowInstancePermissions?: Maybe<WorkflowV1QueryWorkflowInstancePermissionsResponseResult>;
  reaction?: Maybe<CollaborationV1ReactionResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  recording?: Maybe<RecordingV1RecordingResult>;
  recordingPolicies?: Maybe<RecordingV1ListRecordingPoliciesResponseResult>;
  recordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  recordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  recordingRules?: Maybe<RecordingV1ListRecordingRulesResponseResult>;
  recordings?: Maybe<RecordingV1ListRecordingsResponseResult>;
  repositories?: Maybe<RepositoriesV1ListRepositoriesResponseResult>;
  repository?: Maybe<RepositoriesV1RepositoryResult>;
  resolvePulseRefreshSchedule?: Maybe<PulseV1ResolvePulseRefreshScheduleResponseResult>;
  resourcePermission?: Maybe<FgaV1ResourcePermissionResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retrigger?: Maybe<MetricsV1RetriggerResult>;
  retriggers?: Maybe<MetricsV1ListRetriggersResponseResult>;
  review?: Maybe<CollaborationV1ReviewResult>;
  reviewResponse?: Maybe<CollaborationV1ReviewResponseResult>;
  reviewResponses?: Maybe<CollaborationV1ListReviewResponsesResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  role?: Maybe<IamV1RoleResult>;
  roles?: Maybe<IamV1ListRolesResponseResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  rules?: Maybe<FlagsAdminV1ListRulesResponseResult>;
  sampleRows?: Maybe<MetricsV1SampleRowsResult>;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  scheduledExposureCalculations?: Maybe<MetricsV1ListScheduledExposureCalculationsResponseResult>;
  scheduledMaterializedSegmentLoadJob?: Maybe<MaterializerV1ScheduledMaterializedSegmentLoadJobResult>;
  scheduledMaterializedSegmentLoadJobs?: Maybe<MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponseResult>;
  scheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  scheduledMeasurementCalculations?: Maybe<MetricsV1ListScheduledMeasurementCalculationsResponseResult>;
  scheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  scheduledMetricCalculations?: Maybe<MetricsV1ListScheduledMetricCalculationsResponseResult>;
  search?: Maybe<SearchV1ExternalSearchResponseResult>;
  searchFactTableSummaries?: Maybe<InsightsV1SearchFactTableSummariesResponseResult>;
  searchIssues?: Maybe<ObservationsV1SearchIssuesResponseResult>;
  searchObservations?: Maybe<ObservationsV1SearchObservationsResponseResult>;
  searchProviderDocuments?: Maybe<CollaborationV1SearchProviderDocumentsResponseResult>;
  searchRecordings?: Maybe<RecordingV1SearchRecordingsResponseResult>;
  searchThemes?: Maybe<ObservationsV1SearchThemesResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  segments?: Maybe<FlagsAdminV1ListSegmentsResponseResult>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  suggestedQuestions?: Maybe<InsightsV1ListSuggestedQuestionsResponseResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
  surfaceIdentityBinding?: Maybe<WorkflowV1SurfaceIdentityBindingResult>;
  surfaceIdentityBindings?: Maybe<WorkflowV1ListSurfaceIdentityBindingsResponseResult>;
  surfaces?: Maybe<WorkflowV1ListSurfacesResponseResult>;
  task?: Maybe<ObservationsV1TaskResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  theme?: Maybe<ObservationsV1ThemeResult>;
  themes?: Maybe<ObservationsV1ListThemesResponseResult>;
  tourPreferences?: Maybe<OnboardingV1TourPreferencesResult>;
  user?: Maybe<IamV1UserResult>;
  userGroups?: Maybe<IamV1ListUserGroupsResponseResult>;
  userInvitation?: Maybe<IamV1UserInvitationResult>;
  userInvitations?: Maybe<IamV1ListUserInvitationsResponseResult>;
  userRequestedReviewResponses?: Maybe<CollaborationV1ListUserRequestedReviewResponsesResponseResult>;
  users?: Maybe<IamV1ListUsersResponseResult>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
  variants?: Maybe<FlagsAdminV1ListVariantsResponseResult>;
  workflow?: Maybe<WorkflowV1WorkflowResult>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  workflowInstances?: Maybe<WorkflowV1ListWorkflowInstancesResponseResult>;
  workflowLog?: Maybe<WorkflowV1WorkflowLogResult>;
  workflowLogs?: Maybe<WorkflowV1ListWorkflowLogsResponseResult>;
  workflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  workflowSecrets?: Maybe<WorkflowV1ListWorkflowSecretsResponseResult>;
  workflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  workflowTemplates?: Maybe<WorkflowV1ListWorkflowTemplatesResponseResult>;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  workflowVersions?: Maybe<WorkflowV1ListWorkflowVersionsResponseResult>;
  workflows?: Maybe<WorkflowV1ListWorkflowsResponseResult>;
  wrapped?: Maybe<InsightsV1WrappedResult>;
};

export type QueryAccountDomainsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryActivitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryActivityArgs = {
  name: Scalars['String']['input'];
};

export type QueryActivityTypeArgs = {
  name: Scalars['String']['input'];
};

export type QueryActivityTypesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAgentArgs = {
  name: Scalars['String']['input'];
};

export type QueryAgentReviewPreviewArgs = {
  name: Scalars['String']['input'];
};

export type QueryAgentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAggregateRecordingFilterValuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowSchedulesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowTriggerArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowTriggersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAnalysisResultArgs = {
  name: Scalars['String']['input'];
};

export type QueryAnalysisResultsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryApiClientArgs = {
  name: Scalars['String']['input'];
};

export type QueryApiClientSecretArgs = {
  name: Scalars['String']['input'];
};

export type QueryApiClientsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAssignmentTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryAssignmentTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAttachmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBillingProductArgs = {
  name: Scalars['String']['input'];
};

export type QueryBillingProductsArgs = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChatArgs = {
  name: Scalars['String']['input'];
};

export type QueryChatEventArgs = {
  name: Scalars['String']['input'];
};

export type QueryChatEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryChatsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCheckArgs = {
  name: Scalars['String']['input'];
};

export type QueryChecksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryClientArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryClientsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type QueryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type QueryCollectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryCollectionEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryCollectionEntryArgs = {
  name: Scalars['String']['input'];
};

export type QueryCollectionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCommentArgs = {
  name: Scalars['String']['input'];
};

export type QueryCommentRepliesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCommentReplyArgs = {
  name: Scalars['String']['input'];
};

export type QueryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryContiguousPartitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryContiguousPartitionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryConversationArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<ConversationsV1ConversationView>;
};

export type QueryConversationsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<ConversationsV1ConversationView>;
};

export type QueryCryptoKeyArgs = {
  name: Scalars['String']['input'];
};

export type QueryCryptoKeysArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDashboardArgs = {
  name: Scalars['String']['input'];
};

export type QueryDashboardsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type QueryDataWarehousesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDependenciesArgs = {
  parent: Scalars['String']['input'];
};

export type QueryDependencyArgs = {
  name: Scalars['String']['input'];
};

export type QueryDimensionTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryDimensionTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDistinctCountArgs = {
  name: Scalars['String']['input'];
};

export type QueryDownloadRecordingArgs = {
  name: Scalars['String']['input'];
};

export type QueryDownloadRecordingTranscriptArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEntityArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityIdentityBindingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEntityRelationTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityRelationTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryEnvironmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEvaluationContextFieldOverrideArgs = {
  name: Scalars['String']['input'];
};

export type QueryEvaluationContextFieldOverridesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventDefinitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventDefinitionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventTypeArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventTypesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExclusivityGroupArgs = {
  name: Scalars['String']['input'];
};

export type QueryExclusivityGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryExportConversationArgs = {
  format?: InputMaybe<ConversationsV1ExportFormat>;
  name: Scalars['String']['input'];
};

export type QueryExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryExposureTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryExposureTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExternalDocumentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type QueryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type QueryExternalIntegrationArgs = {
  name: Scalars['String']['input'];
};

export type QueryExternalIntegrationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTableContextArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTableContextsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableSummariesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableSummaryArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFeedArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeedEntryArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedSubscriptionArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedSubscriptionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeedsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFlagArgs = {
  name: Scalars['String']['input'];
};

export type QueryFlagAppliedConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryFlagAppliedConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFlagsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTiptapTokenArgs = {
  name: Scalars['String']['input'];
};

export type QueryGroupArgs = {
  name: Scalars['String']['input'];
};

export type QueryGroupMembersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHasExternalIntegrationArgs = {
  integrationType: AiworkflowsV1ExternalIntegrationType;
  verify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHoldbackArgs = {
  name: Scalars['String']['input'];
};

export type QueryHoldbacksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryIdentitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIdentityArgs = {
  name: Scalars['String']['input'];
};

export type QueryInitiativeArgs = {
  name: Scalars['String']['input'];
};

export type QueryInitiativesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInsightsDocumentArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInsightsMetricArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsTableContextArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsTableContextsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIssueArgs = {
  name: Scalars['String']['input'];
};

export type QueryIssuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIssuesConfigArgs = {
  name: Scalars['String']['input'];
};

export type QueryLabelArgs = {
  name: Scalars['String']['input'];
};

export type QueryLabelsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryManagedDataWarehouseProvisioningArgs = {
  name: Scalars['String']['input'];
};

export type QueryManagedSessionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMaterializedSegmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type QueryMaterializedSegmentLoadJobsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMaterializedSegmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMeasurementArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMeasurementTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMeasurementsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMetricArgs = {
  name: Scalars['String']['input'];
};

export type QueryMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMetricsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOAuthAppArgs = {
  name: Scalars['String']['input'];
};

export type QueryOAuthAppsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryObservationArgs = {
  name: Scalars['String']['input'];
};

export type QueryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOnboardingSetupArgs = {
  name: Scalars['String']['input'];
};

export type QueryPartitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryPartitionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryPermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlatformConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryPlatformConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPoliciesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPolicyArgs = {
  name: Scalars['String']['input'];
};

export type QueryPresenceArgs = {
  name: Scalars['String']['input'];
};

export type QueryPresencesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProcessRoundLogArgs = {
  name: Scalars['String']['input'];
};

export type QueryProcessRoundLogsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryProjectArgs = {
  name: Scalars['String']['input'];
};

export type QueryProjectsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPromptHookArgs = {
  name: Scalars['String']['input'];
};

export type QueryPromptHooksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPullRequestArgs = {
  number: Scalars['Int']['input'];
  repository: Scalars['String']['input'];
};

export type QueryPulseArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<PulseV1PulseView>;
};

export type QueryPulseBlockArgs = {
  name: Scalars['String']['input'];
};

export type QueryPulseBlocksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryPulseChangesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryPulsesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryAccountDistinctCountArgs = {
  kind: FlagsAdminV1DistinctCountKind;
};

export type QueryQueryActivityTypesArgs = {
  resource: Scalars['String']['input'];
};

export type QueryQueryAssignmentDistinctCountArgs = {
  assignmentId: Scalars['String']['input'];
  kind: FlagsAdminV1DistinctCountKind;
  rule: Scalars['String']['input'];
};

export type QueryQueryAvailableTimeRangeArgs = {
  exposureCalculationSpec?: InputMaybe<MetricsV1ExposureCalculationSpecInput>;
  metricCalculationSpec?: InputMaybe<MetricsV1MetricCalculationSpecInput>;
};

export type QueryQueryCreditUsageArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  usageFeature?: InputMaybe<UsageV1EventsUsageFeature>;
};

export type QueryQueryDataWarehouseStatsArgs = {
  endTime: Scalars['String']['input'];
  interval?: InputMaybe<MetricsV1QueryDataWarehouseStatsRequestStatsInterval>;
  startTime: Scalars['String']['input'];
};

export type QueryQueryDraftEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryEventsUsageArgs = {
  endTime: Scalars['String']['input'];
  eventDefinition: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type QueryQueryFlagUsageArgs = {
  endTime: Scalars['String']['input'];
  flag: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type QueryQueryInsightsMetricArgs = {
  filter?: InputMaybe<InsightsV1FilterInput>;
  name: Scalars['String']['input'];
};

export type QueryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryQueryMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryReactionSummaryArgs = {
  name: Scalars['String']['input'];
};

export type QueryQueryRecordingInsightsOverviewArgs = {
  client?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  granularity: Scalars['String']['input'];
  maxDuration?: InputMaybe<Scalars['String']['input']>;
  metrics: Array<Scalars['String']['input']>;
  minDuration?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type QueryQueryRecordingRouteInsightsArgs = {
  client?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  granularity: Scalars['String']['input'];
  maxDuration?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  minDuration?: InputMaybe<Scalars['String']['input']>;
  minRouteRecordings?: InputMaybe<Scalars['Int']['input']>;
  routeLimit?: InputMaybe<Scalars['Int']['input']>;
  routeOrder?: InputMaybe<RecordingV1RecordingRouteInsightsOrder>;
  startTime: Scalars['String']['input'];
};

export type QueryQueryRuleWorkflowInstanceArgs = {
  rule: Scalars['String']['input'];
};

export type QueryQueryScheduledMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  endTime?: InputMaybe<Scalars['String']['input']>;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAllCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQuerySegmentReferencesArgs = {
  name: Scalars['String']['input'];
};

export type QueryQueryWorkflowInstancePermissionsArgs = {
  name: Scalars['String']['input'];
};

export type QueryReactionArgs = {
  name: Scalars['String']['input'];
};

export type QueryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryRecordingArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingPoliciesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRecordingPolicyArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingRuleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryRecordingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRepositoryArgs = {
  name: Scalars['String']['input'];
};

export type QueryResolvePulseRefreshScheduleArgs = {
  pulse: Scalars['String']['input'];
};

export type QueryResourcePermissionArgs = {
  name: Scalars['String']['input'];
};

export type QueryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryResourceRelationsArgs = {
  parent: Scalars['String']['input'];
};

export type QueryRetriggerArgs = {
  name: Scalars['String']['input'];
};

export type QueryRetriggersArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryReviewArgs = {
  name: Scalars['String']['input'];
};

export type QueryReviewResponseArgs = {
  name: Scalars['String']['input'];
};

export type QueryReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRoleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRolesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRuleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QuerySampleRowsArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryScheduledMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledMaterializedSegmentLoadJobsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryScheduledMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledMeasurementCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchArgs = {
  enableSemanticSearch?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  resourceSpecificFilters?: InputMaybe<SearchV1ExternalSearchRequestFiltersInput>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<SearchV1ExternalResourceType>;
};

export type QuerySearchFactTableSummariesArgs = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type QuerySearchIssuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchProviderDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  provider: CollaborationV1SearchProvider;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchRecordingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  semanticQuery: Scalars['String']['input'];
};

export type QuerySearchThemesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySegmentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<FlagsAdminV1SegmentView>;
};

export type QuerySegmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<FlagsAdminV1SegmentView>;
};

export type QuerySqlJobArgs = {
  name: Scalars['String']['input'];
};

export type QuerySuggestedQuestionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySurfaceArgs = {
  name: Scalars['String']['input'];
};

export type QuerySurfaceIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type QuerySurfaceIdentityBindingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QuerySurfacesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaskArgs = {
  name: Scalars['String']['input'];
};

export type QueryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryThemeArgs = {
  name: Scalars['String']['input'];
};

export type QueryThemesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryUserArgs = {
  name: Scalars['String']['input'];
};

export type QueryUserGroupsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryUserInvitationArgs = {
  name: Scalars['String']['input'];
};

export type QueryUserInvitationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserRequestedReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVariantArgs = {
  name: Scalars['String']['input'];
};

export type QueryVariantsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryWorkflowArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowLogArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowLogsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryWorkflowSecretArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowSecretsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWorkflowTemplateArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowTemplatesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowVersionArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowVersionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWrappedArgs = {
  name: Scalars['String']['input'];
};

export type ReanalysisData = {
  configChanged?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  exposureMetricState?: Maybe<ReanalysisDataExposureMetricState>;
  exposureState?: Maybe<ReanalysisDataExposureState>;
  metrics?: Maybe<Array<ReanalysisDataMetricData>>;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<ReanalysisDataTreatment>>;
};

export enum ReanalysisDataExposureMetricState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export enum ReanalysisDataExposureState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInput = {
  configChanged?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  exposureMetricState?: InputMaybe<ReanalysisDataInputExposureMetricState>;
  exposureState?: InputMaybe<ReanalysisDataInputExposureState>;
  metrics?: InputMaybe<Array<ReanalysisDataInputMetricDataInput>>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<ReanalysisDataInputTreatmentInput>>;
};

export enum ReanalysisDataInputExposureMetricState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export enum ReanalysisDataInputExposureState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInputMetricDataInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ReanalysisDataInputMetricDataInputState>;
};

export enum ReanalysisDataInputMetricDataInputState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type ReanalysisDataMetricData = {
  calculation?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ReanalysisDataMetricDataState>;
};

export enum ReanalysisDataMetricDataState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variantKey: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type RecordingV1AggregateRecordingFilterValuesResponse = {
  labels: Array<RecordingV1FieldValues>;
  tags: Array<RecordingV1FieldValues>;
};

export type RecordingV1AggregateRecordingFilterValuesResponseResult =
  | Error
  | RecordingV1AggregateRecordingFilterValuesResponse;

export type RecordingV1BatchDownloadRecordingResponse = {
  recordingsDownload: Array<RecordingV1RecordingDownload>;
};

export type RecordingV1BatchDownloadRecordingResponseResult =
  | Error
  | RecordingV1BatchDownloadRecordingResponse;

export type RecordingV1DownloadRecordingResponse = {
  downloadUri: Scalars['String']['output'];
};

export type RecordingV1DownloadRecordingResponseResult =
  | Error
  | RecordingV1DownloadRecordingResponse;

export type RecordingV1DownloadRecordingTranscriptResponse = {
  transcript: Scalars['String']['output'];
};

export type RecordingV1DownloadRecordingTranscriptResponseResult =
  | Error
  | RecordingV1DownloadRecordingTranscriptResponse;

export type RecordingV1EventsRecordingCreated = {
  recording: RecordingV1Recording;
};

export type RecordingV1EventsRecordingDeleted = {
  recording: RecordingV1Recording;
};

export type RecordingV1EventsRecordingUpdated = {
  recording: RecordingV1Recording;
};

export type RecordingV1FieldValues = {
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type RecordingV1ListRecordingPoliciesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordingPolicies: Array<RecordingV1RecordingPolicy>;
};

export type RecordingV1ListRecordingPoliciesResponseResult =
  | Error
  | RecordingV1ListRecordingPoliciesResponse;

export type RecordingV1ListRecordingRulesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordingRules: Array<RecordingV1RecordingRule>;
};

export type RecordingV1ListRecordingRulesResponseResult =
  | Error
  | RecordingV1ListRecordingRulesResponse;

export type RecordingV1ListRecordingsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordings: Array<RecordingV1Recording>;
};

export type RecordingV1ListRecordingsResponseResult =
  | Error
  | RecordingV1ListRecordingsResponse;

export type RecordingV1QueryRecordingInsightsOverviewResponse = {
  signals: Array<RecordingV1RecordingSignalInsightsSummary>;
};

export type RecordingV1QueryRecordingInsightsOverviewResponseResult =
  | Error
  | RecordingV1QueryRecordingInsightsOverviewResponse;

export type RecordingV1QueryRecordingRouteInsightsResponse = {
  routes: Array<RecordingV1RecordingRouteInsight>;
  summaryBuckets: Array<RecordingV1RecordingRouteInsightsSummaryBucket>;
};

export type RecordingV1QueryRecordingRouteInsightsResponseResult =
  | Error
  | RecordingV1QueryRecordingRouteInsightsResponse;

export type RecordingV1Recording = {
  activeDuration?: Maybe<Scalars['String']['output']>;
  analysis?: Maybe<RecordingV1RecordingAnalysis>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  client?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  downloadRecording?: Maybe<RecordingV1DownloadRecordingResponseResult>;
  downloadRecordingTranscript?: Maybe<RecordingV1DownloadRecordingTranscriptResponseResult>;
  duration?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  environmentInfo?: Maybe<RecordingV1RecordingEnvironmentInfo>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  flagEvaluations: Array<RecordingV1RecordingFlagEvaluation>;
  gcsUri?: Maybe<Scalars['String']['output']>;
  labels: Array<RecordingV1RecordingLabelsEntry>;
  metrics: Array<RecordingV1RecordingMetricsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  pageDetails: Array<RecordingV1RecordingPageDetails>;
  pageMetrics: Array<RecordingV1RecordingPageMetric>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  routing?: Maybe<RecordingV1RecordingRouting>;
  sdkInfo?: Maybe<RecordingV1RecordingSdkInfo>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<RecordingV1RecordingState>;
  tags: Array<RecordingV1RecordingTagsEntry>;
  targetingKey?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  transcript?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInstances: Array<RecordingV1RecordingWorkflowInstanceInfo>;
};

export type RecordingV1RecordingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingAnalysis = {
  findings: Array<RecordingV1RecordingAnalysisFinding>;
  intent?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  missedOpportunities: Array<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingAnalysisFinding = {
  evidence?: Maybe<Scalars['String']['output']>;
  evidenceSource?: Maybe<RecordingV1RecordingAnalysisFindingEvidenceSource>;
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: RecordingV1RecordingAnalysisFindingFindingKind;
  pageUri?: Maybe<Scalars['String']['output']>;
  recordingOffset?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<RecordingV1RecordingAnalysisFindingSeverity>;
  summary: Scalars['String']['output'];
};

export enum RecordingV1RecordingAnalysisFindingEvidenceSource {
  Transcript = 'TRANSCRIPT',
  TranscriptAndVisual = 'TRANSCRIPT_AND_VISUAL',
  Visual = 'VISUAL',
}

export enum RecordingV1RecordingAnalysisFindingFindingKind {
  Accessibility = 'ACCESSIBILITY',
  Bug = 'BUG',
  MissedOpportunity = 'MISSED_OPPORTUNITY',
  PainPoint = 'PAIN_POINT',
  Performance = 'PERFORMANCE',
}

export enum RecordingV1RecordingAnalysisFindingSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type RecordingV1RecordingDownload = {
  downloadUri?: Maybe<Scalars['String']['output']>;
  recording?: Maybe<RecordingV1RecordingResult>;
};

export type RecordingV1RecordingEnvironmentInfo = {
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  devicePixelRatio?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  screenHeight?: Maybe<Scalars['Int']['output']>;
  screenWidth?: Maybe<Scalars['Int']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  viewportHeight?: Maybe<Scalars['Int']['output']>;
  viewportWidth?: Maybe<Scalars['Int']['output']>;
};

export enum RecordingV1RecordingFeedbackRating {
  RecordingFeedbackRatingDown = 'RECORDING_FEEDBACK_RATING_DOWN',
  RecordingFeedbackRatingUp = 'RECORDING_FEEDBACK_RATING_UP',
}

export type RecordingV1RecordingFlagEvaluation = {
  flag: Scalars['String']['output'];
  variants: Array<RecordingV1RecordingFlagVariant>;
};

export type RecordingV1RecordingFlagVariant = {
  assignmentOrigin?: Maybe<Scalars['String']['output']>;
  variant: Scalars['String']['output'];
};

export type RecordingV1RecordingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingMetric = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type RecordingV1RecordingMetricsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<RecordingV1RecordingMetric>;
};

export type RecordingV1RecordingPageDetails = {
  metadata?: Maybe<Scalars['JSON']['output']>;
  pageUri: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingPageMetric = {
  metric: Scalars['String']['output'];
  metricValue: Scalars['Float']['output'];
  pageUri: Scalars['String']['output'];
};

export type RecordingV1RecordingPolicy = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<IamV1ClientResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<RecordingV1RecordingPolicyLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  recordingRules?: Maybe<RecordingV1ListRecordingRulesResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type RecordingV1RecordingPolicyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingPolicyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingPolicyObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyRecordingRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyInput = {
  clients: Array<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<RecordingV1RecordingPolicyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingPolicyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyResult =
  | Error
  | RecordingV1RecordingPolicy;

export type RecordingV1RecordingResult = Error | RecordingV1Recording;

export type RecordingV1RecordingRouteInsight = {
  buckets: Array<RecordingV1RecordingRouteInsightBucket>;
  route: Scalars['String']['output'];
};

export type RecordingV1RecordingRouteInsightBucket = {
  affectedPercentage: Scalars['Float']['output'];
  affectedRecordings: Scalars['Long']['output'];
  signalCount: Scalars['Float']['output'];
  signalsPerAffectedRecording: Scalars['Float']['output'];
  signalsPerRecording: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  totalRecordings: Scalars['Long']['output'];
};

export enum RecordingV1RecordingRouteInsightsOrder {
  RecordingRouteInsightsOrderAffectedPercentage = 'RECORDING_ROUTE_INSIGHTS_ORDER_AFFECTED_PERCENTAGE',
  RecordingRouteInsightsOrderAffectedPercentageChange = 'RECORDING_ROUTE_INSIGHTS_ORDER_AFFECTED_PERCENTAGE_CHANGE',
  RecordingRouteInsightsOrderAffectedRecordings = 'RECORDING_ROUTE_INSIGHTS_ORDER_AFFECTED_RECORDINGS',
  RecordingRouteInsightsOrderSignalsPerAffectedRecording = 'RECORDING_ROUTE_INSIGHTS_ORDER_SIGNALS_PER_AFFECTED_RECORDING',
}

export type RecordingV1RecordingRouteInsightsSummaryBucket = {
  affectedPercentage: Scalars['Float']['output'];
  affectedRecordings: Scalars['Long']['output'];
  affectedRoutes: Scalars['Long']['output'];
  signalCount: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  totalRecordings: Scalars['Long']['output'];
  totalRoutes: Scalars['Long']['output'];
};

export type RecordingV1RecordingRouting = {
  entryPage?: Maybe<Scalars['String']['output']>;
  exitPage?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  routes: Array<RecordingV1RecordingPageDetails>;
};

export type RecordingV1RecordingRule = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<FlagsAdminV1EnvironmentResult>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<RecordingV1RecordingRuleLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  order: Scalars['Int']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  sessionSampleRate?: Maybe<Scalars['Float']['output']>;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type RecordingV1RecordingRuleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingRuleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingRuleObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<RecordingV1RecordingRuleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sessionSampleRate?: InputMaybe<Scalars['Float']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingRuleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleResult = Error | RecordingV1RecordingRule;

export type RecordingV1RecordingSdkInfo = {
  analyzerVersion?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  sdkVersion?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingSignalInsightsSummary = {
  buckets: Array<RecordingV1RecordingRouteInsightsSummaryBucket>;
  metric: Scalars['String']['output'];
};

export enum RecordingV1RecordingState {
  Analyzed = 'ANALYZED',
  Discarded = 'DISCARDED',
  PendingAnalysis = 'PENDING_ANALYSIS',
  PendingUpload = 'PENDING_UPLOAD',
}

export type RecordingV1RecordingTagValues = {
  values: Array<Scalars['String']['output']>;
};

export type RecordingV1RecordingTagsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<RecordingV1RecordingTagValues>;
};

export type RecordingV1RecordingWorkflowInstanceInfo = {
  displayName?: Maybe<Scalars['String']['output']>;
  workflow: Scalars['String']['output'];
  workflowType: RecordingV1RecordingWorkflowType;
};

export enum RecordingV1RecordingWorkflowType {
  AbTest = 'AB_TEST',
  Analysis = 'ANALYSIS',
  Rollout = 'ROLLOUT',
}

export type RecordingV1SearchRecordingsHit = {
  recording?: Maybe<RecordingV1Recording>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type RecordingV1SearchRecordingsResponse = {
  hits: Array<RecordingV1SearchRecordingsHit>;
};

export type RecordingV1SearchRecordingsResponseResult =
  | Error
  | RecordingV1SearchRecordingsResponse;

export type RemoteConfigData = {
  epExperimentOverride?: Maybe<RemoteConfigDataEpExperimentOverride>;
  overridePolicyMap?: Maybe<Scalars['JSON']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyName?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<RemoteConfigDataProperty>>;
};

export type RemoteConfigDataEpExperimentOverride = {
  startTime: Scalars['String']['output'];
};

export type RemoteConfigDataInput = {
  epExperimentOverride?: InputMaybe<RemoteConfigDataInputEpExperimentOverrideInput>;
  overridePolicyMap?: InputMaybe<Scalars['JSON']['input']>;
  policyId?: InputMaybe<Scalars['String']['input']>;
  policyName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<RemoteConfigDataInputPropertyInput>>;
};

export type RemoteConfigDataInputEpExperimentOverrideInput = {
  startTime: Scalars['String']['input'];
};

export type RemoteConfigDataInputPropertyInput = {
  name: Scalars['String']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  scope: Scalars['String']['input'];
};

export type RemoteConfigDataProperty = {
  name: Scalars['String']['output'];
  offline?: Maybe<Scalars['Boolean']['output']>;
  scope: Scalars['String']['output'];
};

export type ReportData = {
  name?: Maybe<Scalars['String']['output']>;
  sections: Array<ReportDataSectionsUnion>;
};

export type ReportDataHypothesisSection = {
  hypothesisData: ReportDataHypothesisSectionHypothesisData;
  id: Scalars['String']['output'];
};

export type ReportDataHypothesisSectionHypothesisData = {
  hypothesis?: Maybe<Scalars['String']['output']>;
};

export type ReportDataImagesSection = {
  id: Scalars['String']['output'];
  imagesData: ReportDataImagesSectionImagesData;
};

export type ReportDataImagesSectionImagesData = {
  images?: Maybe<Array<ReportDataImagesSectionImagesDataImageData>>;
};

export type ReportDataImagesSectionImagesDataImageData = {
  id: Scalars['String']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ReportDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sections: Array<SectionsOneOfInput>;
};

export type ReportDataInputHypothesisSectionInput = {
  hypothesisData: ReportDataInputHypothesisSectionInputHypothesisDataInput;
  id: Scalars['String']['input'];
};

export type ReportDataInputHypothesisSectionInputHypothesisDataInput = {
  hypothesis?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputImagesSectionInput = {
  id: Scalars['String']['input'];
  imagesData: ReportDataInputImagesSectionInputImagesDataInput;
};

export type ReportDataInputImagesSectionInputImagesDataInput = {
  images?: InputMaybe<
    Array<ReportDataInputImagesSectionInputImagesDataInputImageDataInput>
  >;
};

export type ReportDataInputImagesSectionInputImagesDataInputImageDataInput = {
  id: Scalars['String']['input'];
  imageUri?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputMetricsSectionInput = {
  id: Scalars['String']['input'];
  metricsData: ReportDataInputMetricsSectionInputMetricsDataInput;
};

export type ReportDataInputMetricsSectionInputMetricsDataInput = {
  metrics?: InputMaybe<
    Array<ReportDataInputMetricsSectionInputMetricsDataInputMetricInput>
  >;
};

export type ReportDataInputMetricsSectionInputMetricsDataInputMetricInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<ReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput>
  >;
};

export type ReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    treatment: Scalars['String']['input'];
  };

export type ReportDataInputNextSectionInput = {
  id: Scalars['String']['input'];
  nextData: ReportDataInputNextSectionInputNextDataInput;
};

export type ReportDataInputNextSectionInputNextDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputOutcomeSectionInput = {
  id: Scalars['String']['input'];
  outcomeData: ReportDataInputOutcomeSectionInputOutcomeDataInput;
};

export type ReportDataInputOutcomeSectionInputOutcomeDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputRecommendationSectionInput = {
  id: Scalars['String']['input'];
  recommendationsData: ReportDataInputRecommendationSectionInputRecommendationsDataInput;
};

export type ReportDataInputRecommendationSectionInputRecommendationsDataInput =
  {
    content?: InputMaybe<
      Array<ReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput>
    >;
  };

export type ReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput =
  {
    id: Scalars['String']['input'];
    shippingRecommendation?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type ReportDataInputResultsSectionInput = {
  id: Scalars['String']['input'];
  resultsData: ReportDataInputResultsSectionInputResultsDataInput;
};

export type ReportDataInputResultsSectionInputResultsDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputSummarySectionInput = {
  id: Scalars['String']['input'];
  summaryData: ReportDataInputSummarySectionInputSummaryDataInput;
};

export type ReportDataInputSummarySectionInputSummaryDataInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataMetricsSection = {
  id: Scalars['String']['output'];
  metricsData: ReportDataMetricsSectionMetricsData;
};

export type ReportDataMetricsSectionMetricsData = {
  metrics?: Maybe<Array<ReportDataMetricsSectionMetricsDataMetric>>;
};

export type ReportDataMetricsSectionMetricsDataMetric = {
  hidden?: Maybe<Scalars['Boolean']['output']>;
  metric?: Maybe<MetricsV1MetricResult>;
  metricName?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<
    Array<ReportDataMetricsSectionMetricsDataMetricMetricTreatmentConfig>
  >;
};

export type ReportDataMetricsSectionMetricsDataMetricMetricTreatmentConfig = {
  hidden?: Maybe<Scalars['Boolean']['output']>;
  treatment: Scalars['String']['output'];
};

export type ReportDataNextSection = {
  id: Scalars['String']['output'];
  nextData: ReportDataNextSectionNextData;
};

export type ReportDataNextSectionNextData = {
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportDataOutcomeSection = {
  id: Scalars['String']['output'];
  outcomeData: ReportDataOutcomeSectionOutcomeData;
};

export type ReportDataOutcomeSectionOutcomeData = {
  conclusion?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
};

export type ReportDataRecommendationSection = {
  id: Scalars['String']['output'];
  recommendationsData: ReportDataRecommendationSectionRecommendationsData;
};

export type ReportDataRecommendationSectionRecommendationsData = {
  content?: Maybe<
    Array<ReportDataRecommendationSectionRecommendationsDataRecommendationsContent>
  >;
};

export type ReportDataRecommendationSectionRecommendationsDataRecommendationsContent =
  {
    id: Scalars['String']['output'];
    shippingRecommendation?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    variant?: Maybe<Scalars['String']['output']>;
  };

export type ReportDataResultsSection = {
  id: Scalars['String']['output'];
  resultsData: ReportDataResultsSectionResultsData;
};

export type ReportDataResultsSectionResultsData = {
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportDataSectionsUnion =
  | ReportDataHypothesisSection
  | ReportDataImagesSection
  | ReportDataMetricsSection
  | ReportDataNextSection
  | ReportDataOutcomeSection
  | ReportDataRecommendationSection
  | ReportDataResultsSection
  | ReportDataSummarySection;

export type ReportDataSummarySection = {
  id: Scalars['String']['output'];
  summaryData: ReportDataSummarySectionSummaryData;
};

export type ReportDataSummarySectionSummaryData = {
  imageUri?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1EventsPullRequestClosed = {
  closedAt: Scalars['String']['output'];
  pullRequestNumber: Scalars['Int']['output'];
  repository: RepositoriesV1RepositoryResult;
  url?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1EventsPullRequestMerged = {
  mergedAt: Scalars['String']['output'];
  pullRequestNumber: Scalars['Int']['output'];
  repository: RepositoriesV1RepositoryResult;
  url?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1ListRepositoriesResponse = {
  repositories: Array<RepositoriesV1Repository>;
};

export type RepositoriesV1ListRepositoriesResponseResult =
  | Error
  | RepositoriesV1ListRepositoriesResponse;

export type RepositoriesV1PullRequest = {
  additions?: Maybe<Scalars['Int']['output']>;
  assignees: Array<Scalars['String']['output']>;
  base?: Maybe<RepositoriesV1PullRequestRef>;
  body?: Maybe<Scalars['String']['output']>;
  bodyTruncated?: Maybe<Scalars['Boolean']['output']>;
  changedFiles?: Maybe<Scalars['Int']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  commits?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletions?: Maybe<Scalars['Int']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  head?: Maybe<RepositoriesV1PullRequestRef>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  labels: Array<Scalars['String']['output']>;
  mergeable?: Maybe<Scalars['Boolean']['output']>;
  mergeableState?: Maybe<Scalars['String']['output']>;
  merged?: Maybe<Scalars['Boolean']['output']>;
  mergedAt?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  repository?: Maybe<RepositoriesV1RepositoryResult>;
  requestedReviewers: Array<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userLogin?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1PullRequestRef = {
  ref?: Maybe<Scalars['String']['output']>;
  sha?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1PullRequestResult = Error | RepositoriesV1PullRequest;

export type RepositoriesV1Repository = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  defaultBranch?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  fullName?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  private?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
};

export type RepositoriesV1RepositoryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RepositoriesV1RepositoryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RepositoriesV1RepositoryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryResult = Error | RepositoriesV1Repository;

export type ReviewsData = {
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  optionalReviews?: Maybe<Array<ReviewsDataSurfaceReviewData>>;
  requiredReviews?: Maybe<Array<ReviewsDataSurfaceReviewData>>;
  reviewId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReviewsDataStatus>;
};

export type ReviewsDataInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  optionalReviews?: InputMaybe<Array<ReviewsDataInputSurfaceReviewDataInput>>;
  requiredReviews?: InputMaybe<Array<ReviewsDataInputSurfaceReviewDataInput>>;
  reviewId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewsDataInputStatus>;
};

export enum ReviewsDataInputStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type ReviewsDataInputSurfaceReviewDataInput = {
  responses?: InputMaybe<
    Array<ReviewsDataInputSurfaceReviewDataInputResponseInput>
  >;
  state: ReviewsDataInputSurfaceReviewDataInputState;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewsDataInputSurfaceReviewDataInputResponseInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  reviewer: Scalars['String']['input'];
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  state: ReviewsDataInputSurfaceReviewDataInputResponseInputState;
};

export enum ReviewsDataInputSurfaceReviewDataInputResponseInputState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataInputSurfaceReviewDataInputState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type ReviewsDataSurfaceReviewData = {
  responses?: Maybe<Array<ReviewsDataSurfaceReviewDataResponse>>;
  state: ReviewsDataSurfaceReviewDataState;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export type ReviewsDataSurfaceReviewDataResponse = {
  commentId?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<IamV1IdentityResult>>;
  id?: Maybe<Scalars['String']['output']>;
  reviewer: IamV1IdentityResult;
  stale?: Maybe<Scalars['Boolean']['output']>;
  state: ReviewsDataSurfaceReviewDataResponseState;
};

export enum ReviewsDataSurfaceReviewDataResponseState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataSurfaceReviewDataState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type RolloutData = {
  abtest?: Maybe<WorkflowV1WorkflowInstanceResult>;
  controlAssignmentId?: Maybe<Scalars['String']['output']>;
  controlVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  description?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  initialReach?: Maybe<Scalars['String']['output']>;
  monitoringDisabled: Scalars['Boolean']['output'];
  reach?: Maybe<Scalars['String']['output']>;
  reusableBucketRanges?: Maybe<Array<RolloutDataBucketRange>>;
  schedule?: Maybe<RolloutDataSchedule>;
  treatmentGroupProportion?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
  variantAssignmentId?: Maybe<Scalars['String']['output']>;
  variantImageUri?: Maybe<Scalars['String']['output']>;
};

export type RolloutDataBucketRange = {
  lower: Scalars['Long']['output'];
  upper: Scalars['Long']['output'];
};

export type RolloutDataInput = {
  abtest?: InputMaybe<Scalars['String']['input']>;
  controlAssignmentId?: InputMaybe<Scalars['String']['input']>;
  controlVariant?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  initialReach?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled: Scalars['Boolean']['input'];
  reach?: InputMaybe<Scalars['String']['input']>;
  reusableBucketRanges?: InputMaybe<Array<RolloutDataInputBucketRangeInput>>;
  schedule?: InputMaybe<RolloutDataInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variantAssignmentId?: InputMaybe<Scalars['String']['input']>;
  variantImageUri?: InputMaybe<Scalars['String']['input']>;
};

export type RolloutDataInputBucketRangeInput = {
  lower: Scalars['Long']['input'];
  upper: Scalars['Long']['input'];
};

export type RolloutDataInputScheduleInput = {
  state?: InputMaybe<RolloutDataInputScheduleInputState>;
  stateReason?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInput>;
  steps: Array<RolloutDataInputScheduleInputScheduleStepsInput>;
};

export type RolloutDataInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInputFailed>;
};

export enum RolloutDataInputScheduleInputScheduleStateReasonInputFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type RolloutDataInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep: Scalars['String']['input'];
  reach: Scalars['String']['input'];
  status?: InputMaybe<RolloutDataInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export enum RolloutDataInputScheduleInputScheduleStepsInputStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum RolloutDataInputScheduleInputState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type RolloutDataSchedule = {
  state?: Maybe<RolloutDataScheduleState>;
  stateReason?: Maybe<RolloutDataScheduleScheduleStateReason>;
  steps: Array<RolloutDataScheduleScheduleSteps>;
};

export type RolloutDataScheduleScheduleStateReason = {
  failed?: Maybe<RolloutDataScheduleScheduleStateReasonFailed>;
};

export enum RolloutDataScheduleScheduleStateReasonFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type RolloutDataScheduleScheduleSteps = {
  durationSincePreviousStep: Scalars['String']['output'];
  reach: Scalars['String']['output'];
  status?: Maybe<RolloutDataScheduleScheduleStepsStatus>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export enum RolloutDataScheduleScheduleStepsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum RolloutDataScheduleState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type SampleSizeData = {
  assignmentTableData?: Maybe<SampleSizeDataAssignmentTableData>;
  error?: Maybe<Scalars['String']['output']>;
  existingInstanceData?: Maybe<SampleSizeDataExistingInstanceData>;
  exposure?: Maybe<SampleSizeDataExposureUnion>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  exposureCalculationData?: Maybe<SampleSizeDataExposureCalculationData>;
  exposureCalculationName?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureKind?: Maybe<SampleSizeDataExposureKind>;
  exposureSource?: Maybe<SampleSizeDataExposureSourceUnion>;
  exposureSourceKind?: Maybe<SampleSizeDataExposureSourceKind>;
  hasCustomizedExposureSource?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<Array<SampleSizeDataSampleSizeMetric>>;
  powerAnalysis?: Maybe<Scalars['JSON']['output']>;
  request?: Maybe<Scalars['JSON']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  scheduledExposureCalculationData?: Maybe<SampleSizeDataScheduledExposureCalculationData>;
  state?: Maybe<SampleSizeDataState>;
  statsParameters?: Maybe<SampleSizeDataStatsParameters>;
  statsTestConfiguration?: Maybe<Scalars['JSON']['output']>;
  useScheduledCalculation?: Maybe<Scalars['Boolean']['output']>;
};

export type SampleSizeDataAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  customEndTime?: Maybe<Scalars['String']['output']>;
  customStartTime?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataAssignmentTableSampleSizeFilter>;
  runtime?: Maybe<Scalars['String']['output']>;
  samplingFactor?: Maybe<Scalars['Float']['output']>;
};

export type SampleSizeDataAssignmentTableData = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataAssignmentTableDataSampleSizeFilter>;
};

export type SampleSizeDataAssignmentTableDataSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataAssignmentTableSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataExistingInstanceData = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataExposureCalculation = {
  assignmentTable: SampleSizeDataExposureCalculationAssignmentTable;
  endTime?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  exposureCalculationName?: Maybe<MetricsV1ExposureCalculationResult>;
  scheduledExposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  customEndTime?: Maybe<Scalars['String']['output']>;
  customStartTime?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataExposureCalculationAssignmentTableSampleSizeFilter>;
  runtime?: Maybe<Scalars['String']['output']>;
  samplingFactor?: Maybe<Scalars['Float']['output']>;
};

export type SampleSizeDataExposureCalculationAssignmentTableSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationData = {
  assignmentTable: SampleSizeDataExposureCalculationDataAssignmentTable;
  endTime?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationDataAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataExposureCalculationDataAssignmentTableSampleSizeFilter>;
};

export type SampleSizeDataExposureCalculationDataAssignmentTableSampleSizeFilter =
  {
    assignmentFilter?: Maybe<Scalars['JSON']['output']>;
    entityFilter?: Maybe<Scalars['JSON']['output']>;
    exposureFilter?: Maybe<Scalars['String']['output']>;
  };

export enum SampleSizeDataExposureKind {
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
}

export enum SampleSizeDataExposureSourceKind {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  ExistingInstance = 'EXISTING_INSTANCE',
}

export type SampleSizeDataExposureSourceUnion =
  | SampleSizeDataAssignmentTable
  | SampleSizeDataExistingInstance;

export type SampleSizeDataExposureUnion =
  | SampleSizeDataExposureCalculation
  | SampleSizeDataScheduledExposureCalculation;

export type SampleSizeDataInput = {
  assignmentTableData?: InputMaybe<SampleSizeDataInputAssignmentTableDataInput>;
  error?: InputMaybe<Scalars['String']['input']>;
  existingInstanceData?: InputMaybe<SampleSizeDataInputExistingInstanceDataInput>;
  exposure?: InputMaybe<ExposureOneOfInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationData?: InputMaybe<SampleSizeDataInputExposureCalculationDataInput>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  exposureKind?: InputMaybe<SampleSizeDataInputExposureKind>;
  exposureSource?: InputMaybe<ExposureSourceOneOfInput>;
  exposureSourceKind?: InputMaybe<SampleSizeDataInputExposureSourceKind>;
  hasCustomizedExposureSource?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<Array<SampleSizeDataInputSampleSizeMetricInput>>;
  powerAnalysis?: InputMaybe<Scalars['JSON']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledExposureCalculationData?: InputMaybe<SampleSizeDataInputScheduledExposureCalculationDataInput>;
  state?: InputMaybe<SampleSizeDataInputState>;
  statsParameters?: InputMaybe<SampleSizeDataInputStatsParametersInput>;
  statsTestConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleSizeDataInputAssignmentTableDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput>;
};

export type SampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput = {
  assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
  entityFilter?: InputMaybe<Scalars['JSON']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type SampleSizeDataInputAssignmentTableInputSampleSizeFilterInput = {
  assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
  entityFilter?: InputMaybe<Scalars['JSON']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExistingInstanceDataInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type SampleSizeDataInputExistingInstanceInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type SampleSizeDataInputExposureCalculationDataInput = {
  assignmentTable: SampleSizeDataInputExposureCalculationDataInputAssignmentTableInput;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExposureCalculationDataInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<SampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput>;
  };

export type SampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type SampleSizeDataInputExposureCalculationInput = {
  assignmentTable: SampleSizeDataInputExposureCalculationInputAssignmentTableInput;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  scheduledExposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExposureCalculationInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type SampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export enum SampleSizeDataInputExposureKind {
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
}

export enum SampleSizeDataInputExposureSourceKind {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  ExistingInstance = 'EXISTING_INSTANCE',
}

export type SampleSizeDataInputSampleSizeMetricInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  forecastedData?: InputMaybe<
    Array<SampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput>
  >;
  metric: Scalars['String']['input'];
  metricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  metricCalculationName?: InputMaybe<Scalars['String']['input']>;
  observedData?: InputMaybe<
    Array<SampleSizeDataInputSampleSizeMetricInputObservedDataPointInput>
  >;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledMetricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputState>;
  summaryStats?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputSummaryStatsInput>;
  type?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputType>;
};

export type SampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput = {
  dayIndex: Scalars['Long']['input'];
  expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type SampleSizeDataInputSampleSizeMetricInputObservedDataPointInput = {
  dayIndex: Scalars['Long']['input'];
  expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
};

export enum SampleSizeDataInputSampleSizeMetricInputState {
  Error = 'ERROR',
  NoPlannedEffectSize = 'NO_PLANNED_EFFECT_SIZE',
  Ok = 'OK',
}

export type SampleSizeDataInputSampleSizeMetricInputSummaryStatsInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export enum SampleSizeDataInputSampleSizeMetricInputType {
  Deterioration = 'DETERIORATION',
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Observational = 'OBSERVATIONAL',
  Quality = 'QUALITY',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type SampleSizeDataInputScheduledExposureCalculationDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance: SampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance: Scalars['String']['input'];
  };

export type SampleSizeDataInputScheduledExposureCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance: SampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance: Scalars['String']['input'];
  };

export enum SampleSizeDataInputState {
  CalculatingExposure = 'CALCULATING_EXPOSURE',
  CalculatingMetrics = 'CALCULATING_METRICS',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type SampleSizeDataInputStatsParametersInput = {
  allocationProportion?: InputMaybe<Scalars['String']['input']>;
  alpha: Scalars['Float']['input'];
  power: Scalars['Float']['input'];
  testHorizonStrategy: SampleSizeDataInputStatsParametersInputTestHorizonStrategy;
};

export enum SampleSizeDataInputStatsParametersInputTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type SampleSizeDataSampleSizeMetric = {
  error?: Maybe<Scalars['String']['output']>;
  forecastedData?: Maybe<
    Array<SampleSizeDataSampleSizeMetricForecastedDataPoint>
  >;
  metric: Scalars['String']['output'];
  metricCalculation?: Maybe<Scalars['JSON']['output']>;
  metricCalculationName?: Maybe<MetricsV1MetricCalculationResult>;
  observedData?: Maybe<Array<SampleSizeDataSampleSizeMetricObservedDataPoint>>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  scheduledMetricCalculation?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<SampleSizeDataSampleSizeMetricState>;
  summaryStats?: Maybe<SampleSizeDataSampleSizeMetricSummaryStats>;
  type?: Maybe<SampleSizeDataSampleSizeMetricType>;
};

export type SampleSizeDataSampleSizeMetricForecastedDataPoint = {
  dayIndex: Scalars['Long']['output'];
  expectedSampleSize?: Maybe<Scalars['Long']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
};

export type SampleSizeDataSampleSizeMetricObservedDataPoint = {
  dayIndex: Scalars['Long']['output'];
  expectedSampleSize?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export enum SampleSizeDataSampleSizeMetricState {
  Error = 'ERROR',
  NoPlannedEffectSize = 'NO_PLANNED_EFFECT_SIZE',
  Ok = 'OK',
}

export type SampleSizeDataSampleSizeMetricSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
  varianceReductionRate?: Maybe<Scalars['Float']['output']>;
};

export enum SampleSizeDataSampleSizeMetricType {
  Deterioration = 'DETERIORATION',
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Observational = 'OBSERVATIONAL',
  Quality = 'QUALITY',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type SampleSizeDataScheduledExposureCalculation = {
  endTime?: Maybe<Scalars['String']['output']>;
  existingInstance: SampleSizeDataScheduledExposureCalculationExistingInstance;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataScheduledExposureCalculationData = {
  endTime?: Maybe<Scalars['String']['output']>;
  existingInstance: SampleSizeDataScheduledExposureCalculationDataExistingInstance;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataScheduledExposureCalculationDataExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataScheduledExposureCalculationExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export enum SampleSizeDataState {
  CalculatingExposure = 'CALCULATING_EXPOSURE',
  CalculatingMetrics = 'CALCULATING_METRICS',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type SampleSizeDataStatsParameters = {
  allocationProportion?: Maybe<Scalars['String']['output']>;
  alpha: Scalars['Float']['output'];
  power: Scalars['Float']['output'];
  testHorizonStrategy: SampleSizeDataStatsParametersTestHorizonStrategy;
};

export enum SampleSizeDataStatsParametersTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type SearchV1ExternalHit = {
  resource?: Maybe<SearchV1ExternalHitResourceUnion>;
  resourceType?: Maybe<SearchV1ExternalResourceType>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type SearchV1ExternalHitResourceUnion =
  | FlagsAdminV1Flag
  | IamV1Client
  | IamV1Identity
  | MetricsV1Entity
  | MetricsV1FactTable
  | MetricsV1Metric
  | RecordingV1Recording
  | WorkflowV1Surface
  | WorkflowV1WorkflowInstance;

export enum SearchV1ExternalResourceType {
  Client = 'CLIENT',
  Entity = 'ENTITY',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Identity = 'IDENTITY',
  Metric = 'METRIC',
  Recording = 'RECORDING',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type SearchV1ExternalSearchRequestFiltersIdentityFilterInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<
    Array<SearchV1ExternalSearchRequestFiltersIdentityFilterKind>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchV1ExternalSearchRequestFiltersIdentityFilterKind {
  Agent = 'AGENT',
  ApiClient = 'API_CLIENT',
  Everyone = 'EVERYONE',
  Group = 'GROUP',
  Service = 'SERVICE',
  User = 'USER',
}

export type SearchV1ExternalSearchRequestFiltersInput = {
  identity?: InputMaybe<SearchV1ExternalSearchRequestFiltersIdentityFilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type SearchV1ExternalSearchResponse = {
  hits: Array<SearchV1ExternalHit>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type SearchV1ExternalSearchResponseResult =
  | Error
  | SearchV1ExternalSearchResponse;

export type SectionsOneOfInput = {
  hypothesisSection?: InputMaybe<ReportDataInputHypothesisSectionInput>;
  imagesSection?: InputMaybe<ReportDataInputImagesSectionInput>;
  metricsSection?: InputMaybe<ReportDataInputMetricsSectionInput>;
  nextSection?: InputMaybe<ReportDataInputNextSectionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeSection?: InputMaybe<ReportDataInputOutcomeSectionInput>;
  recommendationSection?: InputMaybe<ReportDataInputRecommendationSectionInput>;
  resultsSection?: InputMaybe<ReportDataInputResultsSectionInput>;
  summarySection?: InputMaybe<ReportDataInputSummarySectionInput>;
};

export type SpotifyAnalysis = {
  experimentId?: Maybe<Scalars['Long']['output']>;
  mhMetrics: Array<SpotifyAnalysisMhMetric>;
  treatments: Array<SpotifyAnalysisTreatment>;
};

export type SpotifyAnalysisInput = {
  experimentId?: InputMaybe<Scalars['Long']['input']>;
  mhMetrics: Array<SpotifyAnalysisInputMhMetricInput>;
  treatments: Array<SpotifyAnalysisInputTreatmentInput>;
};

export type SpotifyAnalysisInputMhMetricInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  guardrail?: InputMaybe<SpotifyAnalysisInputMhMetricInputGuardrailInput>;
  metricName: Scalars['String']['input'];
  preferredDirection: Scalars['String']['input'];
  secondary?: InputMaybe<Scalars['JSON']['input']>;
  success?: InputMaybe<SpotifyAnalysisInputMhMetricInputSuccessInput>;
  userCreated: Scalars['Boolean']['input'];
};

export type SpotifyAnalysisInputMhMetricInputGuardrailInput = {
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type SpotifyAnalysisInputMhMetricInputSuccessInput = {
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type SpotifyAnalysisInputTreatmentInput = {
  id: Scalars['Long']['input'];
  name: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type SpotifyAnalysisMhMetric = {
  expectedSampleSize?: Maybe<Scalars['String']['output']>;
  guardrail?: Maybe<SpotifyAnalysisMhMetricGuardrail>;
  metricName: Scalars['String']['output'];
  preferredDirection: Scalars['String']['output'];
  secondary?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<SpotifyAnalysisMhMetricSuccess>;
  userCreated: Scalars['Boolean']['output'];
};

export type SpotifyAnalysisMhMetricGuardrail = {
  nonInferiorityMargin?: Maybe<Scalars['Float']['output']>;
};

export type SpotifyAnalysisMhMetricSuccess = {
  minimumDetectableEffect?: Maybe<Scalars['Float']['output']>;
};

export type SpotifyAnalysisTreatment = {
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type StaticConfig = {
  description?: Maybe<Scalars['String']['output']>;
  primaryUnit?: Maybe<Scalars['String']['output']>;
  propertyAssignments?: Maybe<Array<StaticConfigPropertyAssignment>>;
  treatmentId?: Maybe<Scalars['Long']['output']>;
};

export type StaticConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  propertyAssignments?: InputMaybe<
    Array<StaticConfigInputPropertyAssignmentInput>
  >;
  treatmentId?: InputMaybe<Scalars['Long']['input']>;
};

export type StaticConfigInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StaticConfigPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StatsData = {
  alpha?: Maybe<Scalars['Float']['output']>;
  analysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  analysisResults?: Maybe<Array<StatsDataAnalysisResult>>;
  fallbackSampleSize?: Maybe<Scalars['String']['output']>;
  metricInformation?: Maybe<Array<StatsDataMetricInformation>>;
  metricMethods?: Maybe<Array<StatsDataMethod>>;
  power?: Maybe<Scalars['Float']['output']>;
  testHorizonStrategy?: Maybe<StatsDataTestHorizonStrategy>;
};

export type StatsDataAnalysisResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilterName?: Maybe<Scalars['String']['output']>;
};

export type StatsDataInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  analysisResults?: InputMaybe<Array<StatsDataInputAnalysisResultInput>>;
  fallbackSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricInformation?: InputMaybe<Array<StatsDataInputMetricInformationInput>>;
  metricMethods?: InputMaybe<Array<StatsDataInputMethodInput>>;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<StatsDataInputTestHorizonStrategy>;
};

export type StatsDataInputAnalysisResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type StatsDataInputMethodInput = {
  method: StatsDataInputMethodInputMethod;
  metricName: Scalars['String']['input'];
};

export enum StatsDataInputMethodInputMethod {
  AsympCs = 'ASYMP_CS',
  AsympCsQuantile = 'ASYMP_CS_QUANTILE',
  AsympCsRatio = 'ASYMP_CS_RATIO',
  Chi2 = 'CHI2',
  GstQuantile = 'GST_QUANTILE',
  GstRatio = 'GST_RATIO',
  GstZTest = 'GST_Z_TEST',
  Quantile = 'QUANTILE',
  Ratio = 'RATIO',
  Unknown = 'UNKNOWN',
  ZTest = 'Z_TEST',
}

export type StatsDataInputMetricInformationInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export enum StatsDataInputTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type StatsDataMethod = {
  method: StatsDataMethodMethod;
  metricName: Scalars['String']['output'];
};

export enum StatsDataMethodMethod {
  AsympCs = 'ASYMP_CS',
  AsympCsQuantile = 'ASYMP_CS_QUANTILE',
  AsympCsRatio = 'ASYMP_CS_RATIO',
  Chi2 = 'CHI2',
  GstQuantile = 'GST_QUANTILE',
  GstRatio = 'GST_RATIO',
  GstZTest = 'GST_Z_TEST',
  Quantile = 'QUANTILE',
  Ratio = 'RATIO',
  Unknown = 'UNKNOWN',
  ZTest = 'Z_TEST',
}

export type StatsDataMetricInformation = {
  expectedSampleSize?: Maybe<Scalars['String']['output']>;
  metricName: Scalars['String']['output'];
};

export enum StatsDataTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type StatsV2AnalysisAnalysisResult = {
  annotations: Array<StatsV2AnalysisStatsAnnotation>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  exposureFilter?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<StatsV2AnalysisAnalysisResultLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  results: Array<StatsV2AnalysisStatsHypothesisResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  treatments: Array<StatsV2AnalysisTreatmentInfo>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type StatsV2AnalysisAnalysisResultAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type StatsV2AnalysisAnalysisResultCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type StatsV2AnalysisAnalysisResultObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultInput = {
  annotations?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationInput>>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<StatsV2AnalysisAnalysisResultLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<StatsV2AnalysisStatsHypothesisResultInput>>;
  treatments?: InputMaybe<Array<StatsV2AnalysisTreatmentInfoInput>>;
};

export type StatsV2AnalysisAnalysisResultLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisAnalysisResultLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultResult =
  | Error
  | StatsV2AnalysisAnalysisResult;

export type StatsV2AnalysisEstimate = {
  estimate?: Maybe<Scalars['Float']['output']>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  lower?: Maybe<Scalars['Float']['output']>;
  powered?: Maybe<Scalars['Float']['output']>;
  upper?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisEstimateInput = {
  estimate?: InputMaybe<Scalars['Float']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lower?: InputMaybe<Scalars['Float']['input']>;
  powered?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type StatsV2AnalysisEventsAnalysisResultCreated = {
  analysisResult: StatsV2AnalysisAnalysisResult;
};

export type StatsV2AnalysisEventsAnalysisResultDeleted = {
  analysisResult: Scalars['String']['output'];
};

export type StatsV2AnalysisEventsAnalysisResultUpdated = {
  analysisResult: StatsV2AnalysisAnalysisResult;
};

export enum StatsV2AnalysisGuardrailStatus {
  GuardrailStatusAllPoweredAllSignificant = 'GUARDRAIL_STATUS_ALL_POWERED_ALL_SIGNIFICANT',
  GuardrailStatusAllPoweredNoneSignificant = 'GUARDRAIL_STATUS_ALL_POWERED_NONE_SIGNIFICANT',
  GuardrailStatusAllPoweredUnknownSignificance = 'GUARDRAIL_STATUS_ALL_POWERED_UNKNOWN_SIGNIFICANCE',
  GuardrailStatusNoGuardrails = 'GUARDRAIL_STATUS_NO_GUARDRAILS',
  GuardrailStatusSomeMissing = 'GUARDRAIL_STATUS_SOME_MISSING',
  GuardrailStatusSomeNotSignificant = 'GUARDRAIL_STATUS_SOME_NOT_SIGNIFICANT',
  GuardrailStatusSomePoweredNotSignificant = 'GUARDRAIL_STATUS_SOME_POWERED_NOT_SIGNIFICANT',
  GuardrailStatusSomeUnpoweredAllSignificant = 'GUARDRAIL_STATUS_SOME_UNPOWERED_ALL_SIGNIFICANT',
  GuardrailStatusSomeUnpoweredUnknownSignificance = 'GUARDRAIL_STATUS_SOME_UNPOWERED_UNKNOWN_SIGNIFICANCE',
  GuardrailStatusWaitForEnd = 'GUARDRAIL_STATUS_WAIT_FOR_END',
  GuardrailStatusWithoutNimNoneDeteriorated = 'GUARDRAIL_STATUS_WITHOUT_NIM_NONE_DETERIORATED',
  GuardrailStatusWithoutNimSomeDeteriorated = 'GUARDRAIL_STATUS_WITHOUT_NIM_SOME_DETERIORATED',
}

export type StatsV2AnalysisListAnalysisResultsResponse = {
  analysisResults: Array<StatsV2AnalysisAnalysisResult>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisListAnalysisResultsResponseResult =
  | Error
  | StatsV2AnalysisListAnalysisResultsResponse;

export enum StatsV2AnalysisMethod {
  MethodAsympCs = 'METHOD_ASYMP_CS',
  MethodAsympCsQuantile = 'METHOD_ASYMP_CS_QUANTILE',
  MethodAsympCsRatio = 'METHOD_ASYMP_CS_RATIO',
  MethodChi2 = 'METHOD_CHI2',
  MethodGstQuantile = 'METHOD_GST_QUANTILE',
  MethodGstRatio = 'METHOD_GST_RATIO',
  MethodGstZTest = 'METHOD_GST_Z_TEST',
  MethodQuantile = 'METHOD_QUANTILE',
  MethodRatio = 'METHOD_RATIO',
  MethodZTest = 'METHOD_Z_TEST',
}

export type StatsV2AnalysisMetricDetails = {
  direction?: Maybe<StatsV2AnalysisMetricDirection>;
  hasRun?: Maybe<Scalars['Boolean']['output']>;
  metricType?: Maybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: Maybe<GoogleTypeDecimal>;
};

export type StatsV2AnalysisMetricDetailsInput = {
  direction?: InputMaybe<StatsV2AnalysisMetricDirection>;
  hasRun?: InputMaybe<Scalars['Boolean']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum StatsV2AnalysisMetricDirection {
  MetricDirectionAny = 'METRIC_DIRECTION_ANY',
  MetricDirectionDecrease = 'METRIC_DIRECTION_DECREASE',
  MetricDirectionIncrease = 'METRIC_DIRECTION_INCREASE',
}

export enum StatsV2AnalysisMetricResultStatus {
  MetricResultStatusDesiredAndUndesiredSignificant = 'METRIC_RESULT_STATUS_DESIRED_AND_UNDESIRED_SIGNIFICANT',
  MetricResultStatusDesiredSignificant = 'METRIC_RESULT_STATUS_DESIRED_SIGNIFICANT',
  MetricResultStatusNotSignificant = 'METRIC_RESULT_STATUS_NOT_SIGNIFICANT',
  MetricResultStatusUndesiredSignificant = 'METRIC_RESULT_STATUS_UNDESIRED_SIGNIFICANT',
  MetricResultStatusWaitForData = 'METRIC_RESULT_STATUS_WAIT_FOR_DATA',
  MetricResultStatusWaitForEnd = 'METRIC_RESULT_STATUS_WAIT_FOR_END',
}

export type StatsV2AnalysisMetricStatus = {
  decisionIsSignificant?: Maybe<Scalars['Boolean']['output']>;
  decisionPowered?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<StatsV2AnalysisMetricType>;
  status?: Maybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: Maybe<Scalars['Boolean']['output']>;
};

export type StatsV2AnalysisMetricStatusInput = {
  decisionIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  decisionPowered?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StatsV2AnalysisMetricType {
  MetricTypeDeterioration = 'METRIC_TYPE_DETERIORATION',
  MetricTypeGuardrail = 'METRIC_TYPE_GUARDRAIL',
  MetricTypeMonitoring = 'METRIC_TYPE_MONITORING',
  MetricTypeObservational = 'METRIC_TYPE_OBSERVATIONAL',
  MetricTypeQuality = 'METRIC_TYPE_QUALITY',
  MetricTypeSecondary = 'METRIC_TYPE_SECONDARY',
  MetricTypeSuccess = 'METRIC_TYPE_SUCCESS',
}

export enum StatsV2AnalysisQualityStatus {
  QualityStatusAllSucceeded = 'QUALITY_STATUS_ALL_SUCCEEDED',
  QualityStatusSomeFailed = 'QUALITY_STATUS_SOME_FAILED',
  QualityStatusSomePending = 'QUALITY_STATUS_SOME_PENDING',
}

export type StatsV2AnalysisRecommendation = {
  shipping?: Maybe<StatsV2AnalysisShippingRecommendation>;
  status?: Maybe<StatsV2AnalysisRecommendationStatus>;
};

export type StatsV2AnalysisRecommendationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<StatsV2AnalysisShippingRecommendation>;
  status?: InputMaybe<StatsV2AnalysisRecommendationStatusInput>;
};

export type StatsV2AnalysisRecommendationStatus = {
  guardrail?: Maybe<StatsV2AnalysisGuardrailStatus>;
  quality?: Maybe<StatsV2AnalysisQualityStatus>;
  success?: Maybe<StatsV2AnalysisSuccessStatus>;
  tanking?: Maybe<StatsV2AnalysisTankingStatus>;
};

export type StatsV2AnalysisRecommendationStatusInput = {
  guardrail?: InputMaybe<StatsV2AnalysisGuardrailStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<StatsV2AnalysisQualityStatus>;
  success?: InputMaybe<StatsV2AnalysisSuccessStatus>;
  tanking?: InputMaybe<StatsV2AnalysisTankingStatus>;
};

export type StatsV2AnalysisSampleSizeEstimate = {
  current?: Maybe<Scalars['Long']['output']>;
  poweredEffectAbs?: Maybe<Scalars['Float']['output']>;
  poweredEffectRel?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Long']['output']>;
};

export type StatsV2AnalysisSampleSizeEstimateInput = {
  current?: InputMaybe<Scalars['Long']['input']>;
  poweredEffectAbs?: InputMaybe<Scalars['Float']['input']>;
  poweredEffectRel?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Long']['input']>;
};

export enum StatsV2AnalysisShippingRecommendation {
  ShippingRecommendationAbort = 'SHIPPING_RECOMMENDATION_ABORT',
  ShippingRecommendationContinue = 'SHIPPING_RECOMMENDATION_CONTINUE',
  ShippingRecommendationDontShip = 'SHIPPING_RECOMMENDATION_DONT_SHIP',
  ShippingRecommendationEnd = 'SHIPPING_RECOMMENDATION_END',
  ShippingRecommendationEnoughDataCollected = 'SHIPPING_RECOMMENDATION_ENOUGH_DATA_COLLECTED',
  ShippingRecommendationShip = 'SHIPPING_RECOMMENDATION_SHIP',
  ShippingRecommendationShipWithCaution = 'SHIPPING_RECOMMENDATION_SHIP_WITH_CAUTION',
  ShippingRecommendationWaitForData = 'SHIPPING_RECOMMENDATION_WAIT_FOR_DATA',
}

export type StatsV2AnalysisSrmGroupResult = {
  expected?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  observed?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisSrmGroupResultInput = {
  expected?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  observed?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisSrmResult = {
  dimensions: Array<StatsV2AnalysisSrmResultDimensionsEntry>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  result: Array<StatsV2AnalysisSrmGroupResult>;
  segmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatsV2AnalysisMetricStatus>;
};

export type StatsV2AnalysisSrmResultDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisSrmResultDimensionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisSrmResultInput = {
  dimensions?: InputMaybe<Array<StatsV2AnalysisSrmResultDimensionsEntryInput>>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisSrmGroupResultInput>>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricStatusInput>;
};

export type StatsV2AnalysisStatsAnnotation = {
  context: Array<StatsV2AnalysisStatsAnnotationContextItem>;
  error?: Maybe<StatsV2AnalysisStatsAnnotationError>;
  info?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export enum StatsV2AnalysisStatsAnnotationContext {
  StatsAnnotationContextComparison = 'STATS_ANNOTATION_CONTEXT_COMPARISON',
  StatsAnnotationContextGroup = 'STATS_ANNOTATION_CONTEXT_GROUP',
  StatsAnnotationContextHypothesis = 'STATS_ANNOTATION_CONTEXT_HYPOTHESIS',
  StatsAnnotationContextSegment = 'STATS_ANNOTATION_CONTEXT_SEGMENT',
  StatsAnnotationContextUnknown = 'STATS_ANNOTATION_CONTEXT_UNKNOWN',
}

export type StatsV2AnalysisStatsAnnotationContextItem = {
  key?: Maybe<StatsV2AnalysisStatsAnnotationContext>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsAnnotationContextItemInput = {
  key?: InputMaybe<StatsV2AnalysisStatsAnnotationContext>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsAnnotationError = {
  category?: Maybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: Maybe<Scalars['String']['output']>;
};

export enum StatsV2AnalysisStatsAnnotationErrorCategory {
  StatsAnnotationErrorCategoryAnalysisError = 'STATS_ANNOTATION_ERROR_CATEGORY_ANALYSIS_ERROR',
  StatsAnnotationErrorCategoryDataValidationError = 'STATS_ANNOTATION_ERROR_CATEGORY_DATA_VALIDATION_ERROR',
  StatsAnnotationErrorCategoryGeneral = 'STATS_ANNOTATION_ERROR_CATEGORY_GENERAL',
  StatsAnnotationErrorCategoryNoData = 'STATS_ANNOTATION_ERROR_CATEGORY_NO_DATA',
}

export type StatsV2AnalysisStatsAnnotationErrorInput = {
  category?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsAnnotationInput = {
  context?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationContextItemInput>>;
  error?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorInput>;
  info?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonPair = {
  baseline?: Maybe<Scalars['String']['output']>;
  compared?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsComparisonPairInput = {
  baseline?: InputMaybe<Scalars['String']['input']>;
  compared?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonResult = {
  comparisonId?: Maybe<Scalars['String']['output']>;
  dimensions: Array<StatsV2AnalysisStatsComparisonResultDimensionsEntry>;
  groupStats: Array<StatsV2AnalysisStatsGroupStats>;
  groups?: Maybe<StatsV2AnalysisStatsComparisonPair>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  lastDeteriorationResult?: Maybe<StatsV2AnalysisStatsResult>;
  lastResult?: Maybe<StatsV2AnalysisStatsResult>;
  result: Array<StatsV2AnalysisStatsResult>;
  sampleSize?: Maybe<StatsV2AnalysisSampleSizeEstimate>;
  segmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatsV2AnalysisMetricStatus>;
  usedDataType?: Maybe<StatsV2AnalysisStatsDataType>;
};

export type StatsV2AnalysisStatsComparisonResultDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsComparisonResultDimensionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonResultInput = {
  comparisonId?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<
    Array<StatsV2AnalysisStatsComparisonResultDimensionsEntryInput>
  >;
  groupStats?: InputMaybe<Array<StatsV2AnalysisStatsGroupStatsInput>>;
  groups?: InputMaybe<StatsV2AnalysisStatsComparisonPairInput>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lastDeteriorationResult?: InputMaybe<StatsV2AnalysisStatsResultInput>;
  lastResult?: InputMaybe<StatsV2AnalysisStatsResultInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisStatsResultInput>>;
  sampleSize?: InputMaybe<StatsV2AnalysisSampleSizeEstimateInput>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricStatusInput>;
  usedDataType?: InputMaybe<StatsV2AnalysisStatsDataType>;
};

export enum StatsV2AnalysisStatsDataType {
  StatsDataTypeBinary = 'STATS_DATA_TYPE_BINARY',
  StatsDataTypeContinuous = 'STATS_DATA_TYPE_CONTINUOUS',
  StatsDataTypeCount = 'STATS_DATA_TYPE_COUNT',
}

export type StatsV2AnalysisStatsGroupStats = {
  id?: Maybe<Scalars['String']['output']>;
  sampleSize?: Maybe<Scalars['Long']['output']>;
};

export type StatsV2AnalysisStatsGroupStatsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type StatsV2AnalysisStatsHypothesisResult = {
  annotations: Array<StatsV2AnalysisStatsAnnotation>;
  id?: Maybe<Scalars['String']['output']>;
  metricDetails?: Maybe<StatsV2AnalysisMetricDetails>;
  result: Array<StatsV2AnalysisStatsComparisonResult>;
  srmResult: Array<StatsV2AnalysisSrmResult>;
  statsSettings?: Maybe<StatsV2AnalysisStatsSettings>;
};

export type StatsV2AnalysisStatsHypothesisResultInput = {
  annotations?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  metricDetails?: InputMaybe<StatsV2AnalysisMetricDetailsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisStatsComparisonResultInput>>;
  srmResult?: InputMaybe<Array<StatsV2AnalysisSrmResultInput>>;
  statsSettings?: InputMaybe<StatsV2AnalysisStatsSettingsInput>;
};

export type StatsV2AnalysisStatsResult = {
  baselineEstimateAbs?: Maybe<Scalars['Float']['output']>;
  baselineEstimateRel?: Maybe<Scalars['Float']['output']>;
  baselineSampleSize?: Maybe<Scalars['Long']['output']>;
  comparedEstimateAbs?: Maybe<Scalars['Float']['output']>;
  comparedEstimateRel?: Maybe<Scalars['Float']['output']>;
  comparedSampleSize?: Maybe<Scalars['Long']['output']>;
  differenceEstimateAbs?: Maybe<StatsV2AnalysisEstimate>;
  differenceEstimateRel?: Maybe<StatsV2AnalysisEstimate>;
  resultTime?: Maybe<Scalars['String']['output']>;
  unadjustedEstimateBaseline?: Maybe<Scalars['Float']['output']>;
  unadjustedEstimateCompared?: Maybe<Scalars['Float']['output']>;
  varianceReductionRate?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisStatsResultInput = {
  baselineEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  baselineEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  baselineSampleSize?: InputMaybe<Scalars['Long']['input']>;
  comparedEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  comparedEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  comparedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  differenceEstimateAbs?: InputMaybe<StatsV2AnalysisEstimateInput>;
  differenceEstimateRel?: InputMaybe<StatsV2AnalysisEstimateInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultTime?: InputMaybe<Scalars['String']['input']>;
  unadjustedEstimateBaseline?: InputMaybe<Scalars['Float']['input']>;
  unadjustedEstimateCompared?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type StatsV2AnalysisStatsSettings = {
  adjustedAlpha?: Maybe<Scalars['Float']['output']>;
  adjustedBeta?: Maybe<Scalars['Float']['output']>;
  hasVarianceReduction?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<StatsV2AnalysisMethod>;
};

export type StatsV2AnalysisStatsSettingsInput = {
  adjustedAlpha?: InputMaybe<Scalars['Float']['input']>;
  adjustedBeta?: InputMaybe<Scalars['Float']['input']>;
  hasVarianceReduction?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<StatsV2AnalysisMethod>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum StatsV2AnalysisSuccessStatus {
  SuccessStatusAllPoweredNoneSignificant = 'SUCCESS_STATUS_ALL_POWERED_NONE_SIGNIFICANT',
  SuccessStatusAllPoweredUnknownSignificance = 'SUCCESS_STATUS_ALL_POWERED_UNKNOWN_SIGNIFICANCE',
  SuccessStatusNoneSignificant = 'SUCCESS_STATUS_NONE_SIGNIFICANT',
  SuccessStatusNoSuccessMetric = 'SUCCESS_STATUS_NO_SUCCESS_METRIC',
  SuccessStatusSomeMissing = 'SUCCESS_STATUS_SOME_MISSING',
  SuccessStatusSomePoweredSignificant = 'SUCCESS_STATUS_SOME_POWERED_SIGNIFICANT',
  SuccessStatusSomeUnpoweredSignificant = 'SUCCESS_STATUS_SOME_UNPOWERED_SIGNIFICANT',
  SuccessStatusSomeUnpoweredUnknownSignificance = 'SUCCESS_STATUS_SOME_UNPOWERED_UNKNOWN_SIGNIFICANCE',
  SuccessStatusWaitForEnd = 'SUCCESS_STATUS_WAIT_FOR_END',
}

export enum StatsV2AnalysisTankingStatus {
  TankingStatusAllSucceeded = 'TANKING_STATUS_ALL_SUCCEEDED',
  TankingStatusNoMetrics = 'TANKING_STATUS_NO_METRICS',
  TankingStatusSomeFailed = 'TANKING_STATUS_SOME_FAILED',
  TankingStatusSomePending = 'TANKING_STATUS_SOME_PENDING',
}

export type StatsV2AnalysisTreatmentInfo = {
  id?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<StatsV2AnalysisRecommendation>;
};

export type StatsV2AnalysisTreatmentInfoInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<StatsV2AnalysisRecommendationInput>;
};

export type Subscription = {
  activityCreated?: Maybe<ActivityV1EventsActivityCreated>;
  agentReviewPreviewCreated?: Maybe<CollaborationV1EventsAgentReviewPreviewCreated>;
  agentReviewPreviewUpdated?: Maybe<CollaborationV1EventsAgentReviewPreviewUpdated>;
  analysisResultCreated?: Maybe<StatsV2AnalysisEventsAnalysisResultCreated>;
  analysisResultDeleted?: Maybe<StatsV2AnalysisEventsAnalysisResultDeleted>;
  analysisResultUpdated?: Maybe<StatsV2AnalysisEventsAnalysisResultUpdated>;
  apiClientCreated?: Maybe<IamV1EventsApiClientCreated>;
  apiClientDeleted?: Maybe<IamV1EventsApiClientDeleted>;
  apiClientUpdated?: Maybe<IamV1EventsApiClientUpdated>;
  assignmentTableCreated?: Maybe<MetricsV1EventsAssignmentTableCreated>;
  assignmentTableUpdated?: Maybe<MetricsV1EventsAssignmentTableUpdated>;
  attachmentCreated?: Maybe<CollaborationV1EventsAttachmentCreated>;
  attachmentDeleted?: Maybe<CollaborationV1EventsAttachmentDeleted>;
  attachmentUpdated?: Maybe<CollaborationV1EventsAttachmentUpdated>;
  authCheckLogCreated?: Maybe<FgaV1EventsAuthCheckLogCreated>;
  chatCreated?: Maybe<ConversationsV2EventsChatCreated>;
  chatEventCreated?: Maybe<ConversationsV2EventsChatEventCreated>;
  chatEventUpdated?: Maybe<ConversationsV2EventsChatEventUpdated>;
  chatUpdated?: Maybe<ConversationsV2EventsChatUpdated>;
  checkCreated?: Maybe<WorkflowV1EventsCheckCreated>;
  checkRemoved?: Maybe<WorkflowV1EventsCheckRemoved>;
  checkUpdated?: Maybe<WorkflowV1EventsCheckUpdated>;
  clientCreated?: Maybe<IamV1EventsClientCreated>;
  clientCredentialCreated?: Maybe<IamV1EventsClientCredentialCreated>;
  clientCredentialDeleted?: Maybe<IamV1EventsClientCredentialDeleted>;
  clientCredentialUpdated?: Maybe<IamV1EventsClientCredentialUpdated>;
  clientDeleted?: Maybe<IamV1EventsClientDeleted>;
  clientUpdated?: Maybe<IamV1EventsClientUpdated>;
  collaborativeDocumentUpdated?: Maybe<CollaborationV1EventsCollaborativeDocumentUpdated>;
  collectionCreated?: Maybe<CollectionsV1EventsCollectionCreated>;
  collectionDeleted?: Maybe<CollectionsV1EventsCollectionDeleted>;
  collectionEntryCreated?: Maybe<CollectionsV1EventsCollectionEntryCreated>;
  collectionEntryDeleted?: Maybe<CollectionsV1EventsCollectionEntryDeleted>;
  collectionUpdated?: Maybe<CollectionsV1EventsCollectionUpdated>;
  commentCreated?: Maybe<CollaborationV1EventsCommentCreated>;
  commentDeleted?: Maybe<CollaborationV1EventsCommentDeleted>;
  commentReplyCreated?: Maybe<CollaborationV1EventsCommentReplyCreated>;
  commentReplyDeleted?: Maybe<CollaborationV1EventsCommentReplyDeleted>;
  commentReplyUpdated?: Maybe<CollaborationV1EventsCommentReplyUpdated>;
  commentUpdated?: Maybe<CollaborationV1EventsCommentUpdated>;
  dataWarehouseCreated?: Maybe<MetricsV1EventsDataWarehouseCreated>;
  dataWarehouseUpdated?: Maybe<MetricsV1EventsDataWarehouseUpdated>;
  dimensionTableCreated?: Maybe<MetricsV1EventsDimensionTableCreated>;
  dimensionTableUpdated?: Maybe<MetricsV1EventsDimensionTableUpdated>;
  entityCreated?: Maybe<MetricsV1EventsEntityCreated>;
  entityDeleted?: Maybe<MetricsV1EventsEntityDeleted>;
  entityIdentityBindingCreated?: Maybe<MetricsV1EventsEntityIdentityBindingCreated>;
  entityIdentityBindingDeleted?: Maybe<MetricsV1EventsEntityIdentityBindingDeleted>;
  entityIdentityBindingUpdated?: Maybe<MetricsV1EventsEntityIdentityBindingUpdated>;
  entityRelationTableCreated?: Maybe<MetricsV1EventsEntityRelationTableCreated>;
  entityRelationTableDeleted?: Maybe<MetricsV1EventsEntityRelationTableDeleted>;
  entityRelationTableUpdated?: Maybe<MetricsV1EventsEntityRelationTableUpdated>;
  entityUpdated?: Maybe<MetricsV1EventsEntityUpdated>;
  environmentCreated?: Maybe<FlagsAdminV1EventsEnvironmentCreated>;
  environmentDeleted?: Maybe<FlagsAdminV1EventsEnvironmentDeleted>;
  environmentUpdated?: Maybe<FlagsAdminV1EventsEnvironmentUpdated>;
  evaluationContextFieldOverrideCreated?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideCreated>;
  evaluationContextFieldOverrideDeleted?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideDeleted>;
  evaluationContextFieldOverrideUpdated?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideUpdated>;
  eventDefinitionCreated?: Maybe<EventsAdminV1EventsEventDefinitionCreated>;
  eventDefinitionDeleted?: Maybe<EventsAdminV1EventsEventDefinitionDeleted>;
  eventDefinitionUpdated?: Maybe<EventsAdminV1EventsEventDefinitionUpdated>;
  exposureCalculationCompleted?: Maybe<MetricsV1EventsExposureCalculationCompleted>;
  exposureCalculationCreated?: Maybe<MetricsV1EventsExposureCalculationCreated>;
  exposureCalculationFailed?: Maybe<MetricsV1EventsExposureCalculationFailed>;
  exposureCalculationUpdated?: Maybe<MetricsV1EventsExposureCalculationUpdated>;
  exposureTableCreated?: Maybe<MetricsV1EventsExposureTableCreated>;
  exposureTableUpdated?: Maybe<MetricsV1EventsExposureTableUpdated>;
  factTableCreated?: Maybe<MetricsV1EventsFactTableCreated>;
  factTableUpdated?: Maybe<MetricsV1EventsFactTableUpdated>;
  flagArchived?: Maybe<FlagsAdminV1EventsFlagArchived>;
  flagCreated?: Maybe<FlagsAdminV1EventsFlagCreated>;
  flagUnarchived?: Maybe<FlagsAdminV1EventsFlagUnarchived>;
  flagUpdated?: Maybe<FlagsAdminV1EventsFlagUpdated>;
  groupCreated?: Maybe<IamV1EventsGroupCreated>;
  groupDeleted?: Maybe<IamV1EventsGroupDeleted>;
  groupUpdated?: Maybe<IamV1EventsGroupUpdated>;
  identityCreated?: Maybe<IamV1EventsIdentityCreated>;
  identityDeleted?: Maybe<IamV1EventsIdentityDeleted>;
  identityUpdated?: Maybe<IamV1EventsIdentityUpdated>;
  initiativeCreated?: Maybe<WorkflowV1EventsInitiativeCreated>;
  initiativeDeleted?: Maybe<WorkflowV1EventsInitiativeDeleted>;
  initiativeUpdated?: Maybe<WorkflowV1EventsInitiativeUpdated>;
  issueCreated?: Maybe<ObservationsV1EventsIssueCreated>;
  issueDeleted?: Maybe<ObservationsV1EventsIssueDeleted>;
  issueUpdated?: Maybe<ObservationsV1EventsIssueUpdated>;
  materializedSegmentCreated?: Maybe<FlagsAdminV1EventsMaterializedSegmentCreated>;
  materializedSegmentDeleted?: Maybe<FlagsAdminV1EventsMaterializedSegmentDeleted>;
  materializedSegmentLoadJobCancelled?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCancelled>;
  materializedSegmentLoadJobCompleted?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCompleted>;
  materializedSegmentLoadJobCreated?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCreated>;
  materializedSegmentLoadJobFailed?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobFailed>;
  materializedSegmentLoadJobUpdated?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobUpdated>;
  materializedSegmentUpdated?: Maybe<FlagsAdminV1EventsMaterializedSegmentUpdated>;
  measurementCalculationCompleted?: Maybe<MetricsV1EventsMeasurementCalculationCompleted>;
  measurementCalculationCreated?: Maybe<MetricsV1EventsMeasurementCalculationCreated>;
  measurementCalculationFailed?: Maybe<MetricsV1EventsMeasurementCalculationFailed>;
  measurementCalculationUpdated?: Maybe<MetricsV1EventsMeasurementCalculationUpdated>;
  measurementCreated?: Maybe<MetricsV1EventsMeasurementCreated>;
  measurementTableCreated?: Maybe<MetricsV1EventsMeasurementTableCreated>;
  measurementTableUpdated?: Maybe<MetricsV1EventsMeasurementTableUpdated>;
  measurementUpdated?: Maybe<MetricsV1EventsMeasurementUpdated>;
  metricCalculationCompleted?: Maybe<MetricsV1EventsMetricCalculationCompleted>;
  metricCalculationCreated?: Maybe<MetricsV1EventsMetricCalculationCreated>;
  metricCalculationFailed?: Maybe<MetricsV1EventsMetricCalculationFailed>;
  metricCalculationUpdated?: Maybe<MetricsV1EventsMetricCalculationUpdated>;
  metricCreated?: Maybe<MetricsV1EventsMetricCreated>;
  metricUpdated?: Maybe<MetricsV1EventsMetricUpdated>;
  observationCreated?: Maybe<ObservationsV1EventsObservationCreated>;
  observationDeleted?: Maybe<ObservationsV1EventsObservationDeleted>;
  observationUpdated?: Maybe<ObservationsV1EventsObservationUpdated>;
  partitionCreated?: Maybe<MetricsV1EventsPartitionCreated>;
  partitionDeleted?: Maybe<MetricsV1EventsPartitionDeleted>;
  policyCreated?: Maybe<IamV1EventsPolicyCreated>;
  policyDeleted?: Maybe<IamV1EventsPolicyDeleted>;
  policyUpdated?: Maybe<IamV1EventsPolicyUpdated>;
  presenceCreated?: Maybe<CollaborationV1EventsPresenceCreated>;
  presenceDeleted?: Maybe<CollaborationV1EventsPresenceDeleted>;
  presenceUpdated?: Maybe<CollaborationV1EventsPresenceUpdated>;
  processRoundLogVerificationFailed?: Maybe<MetricsV1EventsProcessRoundLogVerificationFailed>;
  projectCreated?: Maybe<CollaborationV1EventsProjectCreated>;
  projectDeleted?: Maybe<CollaborationV1EventsProjectDeleted>;
  projectUpdated?: Maybe<CollaborationV1EventsProjectUpdated>;
  pullRequestClosed?: Maybe<RepositoriesV1EventsPullRequestClosed>;
  pullRequestMerged?: Maybe<RepositoriesV1EventsPullRequestMerged>;
  pulseBlockCreated?: Maybe<PulseV1EventsPulseBlockCreated>;
  pulseBlockUpdated?: Maybe<PulseV1EventsPulseBlockUpdated>;
  pulseCreated?: Maybe<PulseV1EventsPulseCreated>;
  pulseUpdated?: Maybe<PulseV1EventsPulseUpdated>;
  reactionCreated?: Maybe<CollaborationV1EventsReactionCreated>;
  reactionDeleted?: Maybe<CollaborationV1EventsReactionDeleted>;
  reactionSummaryCreated?: Maybe<CollaborationV1EventsReactionSummaryCreated>;
  reactionSummaryUpdated?: Maybe<CollaborationV1EventsReactionSummaryUpdated>;
  recordingCreated?: Maybe<RecordingV1EventsRecordingCreated>;
  recordingDeleted?: Maybe<RecordingV1EventsRecordingDeleted>;
  recordingUpdated?: Maybe<RecordingV1EventsRecordingUpdated>;
  retriggerCreated?: Maybe<MetricsV1EventsRetriggerCreated>;
  retriggerScheduledExposureCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledExposureCalculationCompleted>;
  retriggerScheduledMeasurementCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledMeasurementCalculationCompleted>;
  retriggerScheduledMetricCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledMetricCalculationCompleted>;
  retriggerUpdated?: Maybe<MetricsV1EventsRetriggerUpdated>;
  reviewCreated?: Maybe<CollaborationV1EventsReviewCreated>;
  reviewDeleted?: Maybe<CollaborationV1EventsReviewDeleted>;
  reviewResponseCreated?: Maybe<CollaborationV1EventsReviewResponseCreated>;
  reviewResponseDeleted?: Maybe<CollaborationV1EventsReviewResponseDeleted>;
  reviewResponseRequested?: Maybe<CollaborationV1EventsReviewResponseRequested>;
  reviewResponseSubmitted?: Maybe<CollaborationV1EventsReviewResponseSubmitted>;
  reviewResponseUpdated?: Maybe<CollaborationV1EventsReviewResponseUpdated>;
  reviewUpdated?: Maybe<CollaborationV1EventsReviewUpdated>;
  scheduledExposureCalculationCreated?: Maybe<MetricsV1EventsScheduledExposureCalculationCreated>;
  scheduledExposureCalculationDeleted?: Maybe<MetricsV1EventsScheduledExposureCalculationDeleted>;
  scheduledExposureCalculationUpdated?: Maybe<MetricsV1EventsScheduledExposureCalculationUpdated>;
  scheduledMaterializedSegmentLoadJobCreated?: Maybe<MaterializerV1EventsScheduledMaterializedSegmentLoadJobCreated>;
  scheduledMaterializedSegmentLoadJobUpdated?: Maybe<MaterializerV1EventsScheduledMaterializedSegmentLoadJobUpdated>;
  scheduledMeasurementCalculationCreated?: Maybe<MetricsV1EventsScheduledMeasurementCalculationCreated>;
  scheduledMeasurementCalculationDeleted?: Maybe<MetricsV1EventsScheduledMeasurementCalculationDeleted>;
  scheduledMeasurementCalculationUpdated?: Maybe<MetricsV1EventsScheduledMeasurementCalculationUpdated>;
  scheduledMetricCalculationCreated?: Maybe<MetricsV1EventsScheduledMetricCalculationCreated>;
  scheduledMetricCalculationDeleted?: Maybe<MetricsV1EventsScheduledMetricCalculationDeleted>;
  scheduledMetricCalculationUpdated?: Maybe<MetricsV1EventsScheduledMetricCalculationUpdated>;
  segmentAllocated?: Maybe<FlagsAdminV1EventsSegmentAllocated>;
  segmentArchived?: Maybe<FlagsAdminV1EventsSegmentArchived>;
  segmentCreated?: Maybe<FlagsAdminV1EventsSegmentCreated>;
  segmentUpdated?: Maybe<FlagsAdminV1EventsSegmentUpdated>;
  sqlJobCreated?: Maybe<MetricsV1EventsSqlJobCreated>;
  sqlJobUpdated?: Maybe<MetricsV1EventsSqlJobUpdated>;
  surfaceCreated?: Maybe<WorkflowV1EventsSurfaceCreated>;
  surfaceDeleted?: Maybe<WorkflowV1EventsSurfaceDeleted>;
  surfaceUpdated?: Maybe<WorkflowV1EventsSurfaceUpdated>;
  taskCreated?: Maybe<ObservationsV1EventsTaskCreated>;
  taskDeleted?: Maybe<ObservationsV1EventsTaskDeleted>;
  taskUpdated?: Maybe<ObservationsV1EventsTaskUpdated>;
  themeCreated?: Maybe<ObservationsV1EventsThemeCreated>;
  themeDeleted?: Maybe<ObservationsV1EventsThemeDeleted>;
  themeUpdated?: Maybe<ObservationsV1EventsThemeUpdated>;
  userCreated?: Maybe<IamV1EventsUserCreated>;
  userUpdated?: Maybe<IamV1EventsUserUpdated>;
  workflowCreated?: Maybe<WorkflowV1EventsWorkflowCreated>;
  workflowInstanceCreated?: Maybe<WorkflowV1EventsWorkflowInstanceCreated>;
  workflowInstanceInitiativesUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceInitiativesUpdated>;
  workflowInstanceSurfacesUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceSurfacesUpdated>;
  workflowInstanceTransitionCompleted?: Maybe<WorkflowV1EventsWorkflowInstanceTransitionCompleted>;
  workflowInstanceUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceUpdated>;
  workflowUpdated?: Maybe<WorkflowV1EventsWorkflowUpdated>;
};

export type SubscriptionActivityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAgentReviewPreviewCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAgentReviewPreviewUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAssignmentTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAssignmentTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAuthCheckLogCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatEventCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatEventUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckRemovedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollaborativeDocumentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionEntryCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionEntryDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDataWarehouseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDataWarehouseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDimensionTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDimensionTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFactTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFactTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagArchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagUnarchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCancelledArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPartitionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPartitionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProcessRoundLogVerificationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPullRequestClosedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPullRequestMergedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseBlockCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseBlockUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionSummaryCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionSummaryUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerScheduledExposureCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerScheduledMeasurementCalculationCompletedArgs =
  {
    filter?: InputMaybe<Scalars['String']['input']>;
  };

export type SubscriptionRetriggerScheduledMetricCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseRequestedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseSubmittedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMaterializedSegmentLoadJobCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMaterializedSegmentLoadJobUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentAllocatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentArchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSqlJobCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSqlJobUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionUserCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionUserUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceInitiativesUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceSurfacesUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceTransitionCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export enum UsageV1EventsUsageFeature {
  UsageFeatureExposedEntities = 'USAGE_FEATURE_EXPOSED_ENTITIES',
  UsageFeatureManagedCodingAgentTokens = 'USAGE_FEATURE_MANAGED_CODING_AGENT_TOKENS',
  UsageFeaturePublishedEvents = 'USAGE_FEATURE_PUBLISHED_EVENTS',
  UsageFeatureSessionRecordingAnalysisMinutes = 'USAGE_FEATURE_SESSION_RECORDING_ANALYSIS_MINUTES',
}

export type WorkflowV1CheckPermissionsResponse = {
  actionPermissionCheckResults: Array<WorkflowV1CheckPermissionsResponseActionPermissionCheckResult>;
  functionPermissionCheckResults: Array<WorkflowV1CheckPermissionsResponseFunctionPermissionCheckResult>;
  isAllAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1CheckPermissionsResponseActionPermissionCheckResult = {
  action?: Maybe<Scalars['String']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  permissionChecks: Array<WorkflowV1CheckPermissionsResponsePermissionCheck>;
};

export type WorkflowV1CheckPermissionsResponseFunctionPermissionCheckResult = {
  function?: Maybe<Scalars['String']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  permissionChecks: Array<WorkflowV1CheckPermissionsResponsePermissionCheck>;
};

export type WorkflowV1CheckPermissionsResponsePermissionCheck = {
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1CheckPermissionsResponseResult =
  | Error
  | WorkflowV1CheckPermissionsResponse;

export enum WorkflowV1EnforcementLevel {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1EventsCheckCreated = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsCheckRemoved = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsCheckUpdated = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsInitiativeCreated = {
  initiative?: Maybe<WorkflowV1Initiative>;
};

export type WorkflowV1EventsInitiativeDeleted = {
  initiative: Scalars['String']['output'];
};

export type WorkflowV1EventsInitiativeUpdated = {
  initiative?: Maybe<WorkflowV1Initiative>;
};

export type WorkflowV1EventsSurfaceCreated = {
  surface?: Maybe<WorkflowV1Surface>;
};

export type WorkflowV1EventsSurfaceDeleted = {
  surface: Scalars['String']['output'];
};

export type WorkflowV1EventsSurfaceUpdated = {
  surface?: Maybe<WorkflowV1Surface>;
};

export type WorkflowV1EventsWorkflowCreated = {
  workflow?: Maybe<WorkflowV1Workflow>;
};

export type WorkflowV1EventsWorkflowInstanceCreated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceInitiativesUpdated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceSurfacesUpdated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceTransitionCompleted = {
  action: Scalars['String']['output'];
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type WorkflowV1EventsWorkflowInstanceUpdated = {
  oldWorkflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowUpdated = {
  workflow?: Maybe<WorkflowV1Workflow>;
};

export type WorkflowV1ExclusivityGroup = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1ExclusivityGroupLabelsEntry>;
  mode?: Maybe<WorkflowV1ExclusivityGroupMode>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1ExclusivityGroupAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1ExclusivityGroupCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1ExclusivityGroupObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1ExclusivityGroupLabelsEntryInput>>;
  mode?: InputMaybe<WorkflowV1ExclusivityGroupMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ExclusivityGroupLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1ExclusivityGroupMode {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1ExclusivityGroupResult =
  | Error
  | WorkflowV1ExclusivityGroup;

export type WorkflowV1ExecuteFunctionResponse = {
  instance: WorkflowV1WorkflowInstance;
  response?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1ExecuteFunctionResponseResult =
  | Error
  | WorkflowV1ExecuteFunctionResponse;

export type WorkflowV1Holdback = {
  allocation: GoogleTypeDecimal;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1HoldbackLabelsEntry>;
  mode?: Maybe<WorkflowV1HoldbackMode>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1HoldbackAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1HoldbackCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1HoldbackObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackInput = {
  allocation: GoogleTypeDecimalInput;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1HoldbackLabelsEntryInput>>;
  mode?: InputMaybe<WorkflowV1HoldbackMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1HoldbackLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1HoldbackMode {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1HoldbackResult = Error | WorkflowV1Holdback;

export type WorkflowV1InitiateImageUploadResponse = {
  imageUri?: Maybe<Scalars['String']['output']>;
  signedUri?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiateImageUploadResponseResult =
  | Error
  | WorkflowV1InitiateImageUploadResponse;

export type WorkflowV1InitiateTarUploadResponse = {
  path?: Maybe<Scalars['String']['output']>;
  signedUri?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiateTarUploadResponseResult =
  | Error
  | WorkflowV1InitiateTarUploadResponse;

export type WorkflowV1Initiative = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  automatedActions: Array<ActionsV1TypesAutomatedAction>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1InitiativeLabelsEntry>;
  metricConfig?: Maybe<WorkflowV1InitiativeMetricConfig>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<WorkflowV1InitiativeReviews>;
  stakeholders: Array<WorkflowV1InitiativeStakeholder>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1InitiativeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1InitiativeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1InitiativeObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeAssociatedMetric = {
  guardrailMetric?: Maybe<WorkflowV1InitiativeGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1InitiativePreferredDirection>;
  successMetric?: Maybe<WorkflowV1InitiativeSuccessMetric>;
};

export type WorkflowV1InitiativeAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1InitiativeGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1InitiativeSuccessMetricInput>;
};

export type WorkflowV1InitiativeGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1InitiativeGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeInput = {
  automatedActions?: InputMaybe<Array<ActionsV1TypesAutomatedActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1InitiativeLabelsEntryInput>>;
  metricConfig?: InputMaybe<WorkflowV1InitiativeMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<WorkflowV1InitiativeReviewsInput>;
  stakeholders?: InputMaybe<Array<WorkflowV1InitiativeStakeholderInput>>;
};

export type WorkflowV1InitiativeLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiativeLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeMetric = {
  guardrailMetric?: Maybe<WorkflowV1InitiativeGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection: WorkflowV1InitiativePreferredDirection;
  successMetric?: Maybe<WorkflowV1InitiativeSuccessMetric>;
};

export type WorkflowV1InitiativeMetricConfig = {
  /** @deprecated No longer supported */
  associatedMetrics: Array<WorkflowV1InitiativeAssociatedMetric>;
  /** @deprecated No longer supported */
  mandatoryMetrics: Array<WorkflowV1InitiativeMetric>;
  metrics: Array<WorkflowV1LinkedMetric>;
};

export type WorkflowV1InitiativeMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<WorkflowV1InitiativeAssociatedMetricInput>
  >;
  mandatoryMetrics?: InputMaybe<Array<WorkflowV1InitiativeMetricInput>>;
  metrics?: InputMaybe<Array<WorkflowV1LinkedMetricInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1InitiativeGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection: WorkflowV1InitiativePreferredDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1InitiativeSuccessMetricInput>;
};

export enum WorkflowV1InitiativePreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1InitiativeResult = Error | WorkflowV1Initiative;

export type WorkflowV1InitiativeReviews = {
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  reviewers: Array<IamV1IdentityResult>;
};

export type WorkflowV1InitiativeReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1InitiativeStakeholder = {
  identity: IamV1IdentityResult;
  role: Scalars['String']['output'];
};

export type WorkflowV1InitiativeStakeholderInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type WorkflowV1InitiativeSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1InitiativeSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1LinkedMetric = {
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: Maybe<WorkflowV1LinkedMetricGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1LinkedMetricPreferredDirection>;
  successMetric?: Maybe<WorkflowV1LinkedMetricSuccessMetric>;
};

export type WorkflowV1LinkedMetricGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1LinkedMetricGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1LinkedMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: InputMaybe<WorkflowV1LinkedMetricGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1LinkedMetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1LinkedMetricSuccessMetricInput>;
};

export enum WorkflowV1LinkedMetricPreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1LinkedMetricSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1LinkedMetricSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ListChecksResponse = {
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListChecksResponseResult =
  | Error
  | WorkflowV1ListChecksResponse;

export type WorkflowV1ListExclusivityGroupsResponse = {
  exclusivityGroups: Array<WorkflowV1ExclusivityGroup>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListExclusivityGroupsResponseResult =
  | Error
  | WorkflowV1ListExclusivityGroupsResponse;

export type WorkflowV1ListHoldbacksResponse = {
  holdbacks: Array<WorkflowV1Holdback>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListHoldbacksResponseResult =
  | Error
  | WorkflowV1ListHoldbacksResponse;

export type WorkflowV1ListInitiativesResponse = {
  initiatives: Array<WorkflowV1Initiative>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListInitiativesResponseResult =
  | Error
  | WorkflowV1ListInitiativesResponse;

export type WorkflowV1ListSurfaceIdentityBindingsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  surfaceIdentityBindings: Array<WorkflowV1SurfaceIdentityBinding>;
};

export type WorkflowV1ListSurfaceIdentityBindingsResponseResult =
  | Error
  | WorkflowV1ListSurfaceIdentityBindingsResponse;

export type WorkflowV1ListSurfacesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  surfaces: Array<WorkflowV1Surface>;
};

export type WorkflowV1ListSurfacesResponseResult =
  | Error
  | WorkflowV1ListSurfacesResponse;

export type WorkflowV1ListWorkflowInstancesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowInstances: Array<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1ListWorkflowInstancesResponseResult =
  | Error
  | WorkflowV1ListWorkflowInstancesResponse;

export type WorkflowV1ListWorkflowLogsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowLogs: Array<WorkflowV1WorkflowLog>;
};

export type WorkflowV1ListWorkflowLogsResponseResult =
  | Error
  | WorkflowV1ListWorkflowLogsResponse;

export type WorkflowV1ListWorkflowSecretsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowSecrets: Array<WorkflowV1WorkflowSecret>;
};

export type WorkflowV1ListWorkflowSecretsResponseResult =
  | Error
  | WorkflowV1ListWorkflowSecretsResponse;

export type WorkflowV1ListWorkflowTemplatesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowTemplates: Array<WorkflowV1WorkflowTemplate>;
};

export type WorkflowV1ListWorkflowTemplatesResponseResult =
  | Error
  | WorkflowV1ListWorkflowTemplatesResponse;

export type WorkflowV1ListWorkflowVersionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowVersions: Array<WorkflowV1WorkflowVersion>;
};

export type WorkflowV1ListWorkflowVersionsResponseResult =
  | Error
  | WorkflowV1ListWorkflowVersionsResponse;

export type WorkflowV1ListWorkflowsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflows: Array<WorkflowV1Workflow>;
};

export type WorkflowV1ListWorkflowsResponseResult =
  | Error
  | WorkflowV1ListWorkflowsResponse;

export type WorkflowV1QueryWorkflowInstancePermissionsResponse = {
  actionPermissionCheckResults: Array<WorkflowV1QueryWorkflowInstancePermissionsResponseActionPermissionCheckResult>;
  functionPermissionCheckResults: Array<WorkflowV1QueryWorkflowInstancePermissionsResponseFunctionPermissionCheckResult>;
  isAllAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1QueryWorkflowInstancePermissionsResponseActionPermissionCheckResult =
  {
    action?: Maybe<Scalars['String']['output']>;
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    permissionChecks: Array<WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponseFunctionPermissionCheckResult =
  {
    function?: Maybe<Scalars['String']['output']>;
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    permissionChecks: Array<WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck =
  {
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    relation?: Maybe<Scalars['String']['output']>;
    resource?: Maybe<Scalars['String']['output']>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponseResult =
  | Error
  | WorkflowV1QueryWorkflowInstancePermissionsResponse;

export type WorkflowV1Surface = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  automatedActions: Array<ActionsV1TypesAutomatedAction>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  exclusivityGroups?: Maybe<WorkflowV1ListExclusivityGroupsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  holdbacks?: Maybe<WorkflowV1ListHoldbacksResponseResult>;
  labels: Array<WorkflowV1SurfaceLabelsEntry>;
  metricConfig?: Maybe<WorkflowV1SurfaceMetricConfig>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<WorkflowV1SurfaceReviews>;
  stakeholders: Array<WorkflowV1SurfaceStakeholder>;
  surfaceIdentityBindings?: Maybe<WorkflowV1ListSurfaceIdentityBindingsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1SurfaceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1SurfaceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceExclusivityGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1SurfaceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1SurfaceHoldbacksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1SurfaceObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceSurfaceIdentityBindingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceAssociatedMetric = {
  guardrailMetric?: Maybe<WorkflowV1SurfaceGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1SurfacePreferredDirection>;
  successMetric?: Maybe<WorkflowV1SurfaceSuccessMetric>;
};

export type WorkflowV1SurfaceAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1SurfaceGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1SurfaceSuccessMetricInput>;
};

export type WorkflowV1SurfaceGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1SurfaceGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBinding = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<WorkflowV1SurfaceIdentityBindingLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1SurfaceIdentityBindingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1SurfaceIdentityBindingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1SurfaceIdentityBindingObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1SurfaceIdentityBindingLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1SurfaceIdentityBindingLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingResult =
  | Error
  | WorkflowV1SurfaceIdentityBinding;

export type WorkflowV1SurfaceInput = {
  automatedActions?: InputMaybe<Array<ActionsV1TypesAutomatedActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1SurfaceLabelsEntryInput>>;
  metricConfig?: InputMaybe<WorkflowV1SurfaceMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<WorkflowV1SurfaceReviewsInput>;
  stakeholders?: InputMaybe<Array<WorkflowV1SurfaceStakeholderInput>>;
};

export type WorkflowV1SurfaceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1SurfaceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceMetric = {
  guardrailMetric?: Maybe<WorkflowV1SurfaceGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection: WorkflowV1SurfacePreferredDirection;
  successMetric?: Maybe<WorkflowV1SurfaceSuccessMetric>;
};

export type WorkflowV1SurfaceMetricConfig = {
  /** @deprecated No longer supported */
  associatedMetrics: Array<WorkflowV1SurfaceAssociatedMetric>;
  /** @deprecated No longer supported */
  mandatoryMetrics: Array<WorkflowV1SurfaceMetric>;
  metrics: Array<WorkflowV1LinkedMetric>;
  /** @deprecated No longer supported */
  monitoringMetrics: Array<WorkflowV1SurfaceMonitoringMetric>;
  observationalMetrics: Array<WorkflowV1SurfaceObservationalMetric>;
};

export type WorkflowV1SurfaceMetricConfigInput = {
  associatedMetrics?: InputMaybe<Array<WorkflowV1SurfaceAssociatedMetricInput>>;
  mandatoryMetrics?: InputMaybe<Array<WorkflowV1SurfaceMetricInput>>;
  metrics?: InputMaybe<Array<WorkflowV1LinkedMetricInput>>;
  monitoringMetrics?: InputMaybe<Array<WorkflowV1SurfaceMonitoringMetricInput>>;
  observationalMetrics?: InputMaybe<
    Array<WorkflowV1SurfaceObservationalMetricInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1SurfaceGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection: WorkflowV1SurfacePreferredDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1SurfaceSuccessMetricInput>;
};

export type WorkflowV1SurfaceMonitoringMetric = {
  alpha?: Maybe<Scalars['Float']['output']>;
  metric: MetricsV1MetricResult;
  preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
};

export type WorkflowV1SurfaceMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric: Scalars['String']['input'];
  preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1SurfaceMonitoringMetricPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1SurfaceObservationalMetric = {
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  metric: MetricsV1MetricResult;
};

export type WorkflowV1SurfaceObservationalMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  metric: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1SurfacePreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1SurfaceRequirement = {
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  reason?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export type WorkflowV1SurfaceRequirementInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceResult = Error | WorkflowV1Surface;

export type WorkflowV1SurfaceReviews = {
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  reviewers: Array<IamV1IdentityResult>;
};

export type WorkflowV1SurfaceReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1SurfaceStakeholder = {
  identity: IamV1IdentityResult;
  role: Scalars['String']['output'];
};

export type WorkflowV1SurfaceStakeholderInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type WorkflowV1SurfaceSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1SurfaceSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1TransitionWorkflowInstanceResponse = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1TransitionWorkflowInstanceResponseResult =
  | Error
  | WorkflowV1TransitionWorkflowInstanceResponse;

export type WorkflowV1UpgradeWorkflowInstancesResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1UpgradeWorkflowInstancesResponseResult =
  | Error
  | WorkflowV1UpgradeWorkflowInstancesResponse;

export type WorkflowV1Workflow = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowLabelsEntry>;
  lowestVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInfo: WorkflowV1WorkflowWorkflowInfo;
  workflowInstances?: Maybe<WorkflowV1ListWorkflowInstancesResponseResult>;
  workflowLogs?: Maybe<WorkflowV1ListWorkflowLogsResponseResult>;
  workflowVersions?: Maybe<WorkflowV1ListWorkflowVersionsResponseResult>;
};

export type WorkflowV1WorkflowAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1WorkflowWorkflowLogsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowVersionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1WorkflowInput = {
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1WorkflowLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstance = {
  analysisResults?: Maybe<StatsV2AnalysisListAnalysisResultsResponseResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  cloneSource?: Maybe<WorkflowV1WorkflowInstanceResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  jobQueue?: Maybe<WorkflowV1WorkflowInstanceWorkflowJobQueue>;
  labels: Array<WorkflowV1WorkflowInstanceLabelsEntry>;
  lockedDataKeys: Array<Scalars['String']['output']>;
  moduleData: Array<WorkflowV1WorkflowInstanceModuleDataEntry>;
  moduleData2: ModuleData;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  pendingTransition?: Maybe<WorkflowV1WorkflowInstancePendingTransition>;
  possibleTransitions: Array<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryWorkflowInstancePermissions?: Maybe<WorkflowV1QueryWorkflowInstancePermissionsResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: Scalars['String']['output'];
  stateHistory: Array<WorkflowV1WorkflowInstanceStateHistory>;
  surfaceRequirements: Array<WorkflowV1SurfaceRequirement>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  template?: Maybe<WorkflowV1WorkflowTemplateResult>;
  transitionStatus?: Maybe<WorkflowV1WorkflowInstanceTransitionStatus>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
};

export type WorkflowV1WorkflowInstanceAnalysisResultsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowInstanceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowInstanceObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheck = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  data?: Maybe<Scalars['JSON']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowInstanceCheckLabelsEntry>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  parent?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  persist: Scalars['Boolean']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: WorkflowV1WorkflowInstanceCheckState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1WorkflowInstanceCheckAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowInstanceCheckCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowInstanceCheckObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowInstanceCheckLabelsEntryInput>>;
  message: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  persist: Scalars['Boolean']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state: WorkflowV1WorkflowInstanceCheckState;
};

export type WorkflowV1WorkflowInstanceCheckLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceCheckLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckResult =
  | Error
  | WorkflowV1WorkflowInstanceCheck;

export enum WorkflowV1WorkflowInstanceCheckState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export type WorkflowV1WorkflowInstanceInput = {
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  jobQueue?: InputMaybe<WorkflowV1WorkflowInstanceWorkflowJobQueueInput>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowInstanceLabelsEntryInput>>;
  moduleData?: InputMaybe<
    Array<WorkflowV1WorkflowInstanceModuleDataEntryInput>
  >;
  moduleData2?: InputMaybe<ModuleDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceModuleDataEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1WorkflowInstanceModuleDataEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransition = {
  /** @deprecated No longer supported */
  failedActions: Array<WorkflowV1WorkflowInstancePendingTransitionFailedAction>;
  failedSteps: Array<WorkflowV1WorkflowInstancePendingTransitionFailedActionStep>;
  /** @deprecated No longer supported */
  succeededActions: Array<Scalars['String']['output']>;
  succeededSteps: Array<Scalars['String']['output']>;
  targetState: Scalars['String']['output'];
  transitionAction: Scalars['String']['output'];
  /** @deprecated No longer supported */
  unprocessedActions: Array<Scalars['String']['output']>;
  unprocessedSteps: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedAction = {
  action: Scalars['String']['output'];
  failuresMessages: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionInput = {
  action: Scalars['String']['input'];
  failuresMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionStep = {
  actionStep: Scalars['String']['output'];
  failuresMessages: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionStepInput = {
  actionStep: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionInput = {
  failedActions?: InputMaybe<
    Array<WorkflowV1WorkflowInstancePendingTransitionFailedActionInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  succeededActions?: InputMaybe<Array<Scalars['String']['input']>>;
  targetState: Scalars['String']['input'];
  transitionAction: Scalars['String']['input'];
  unprocessedActions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1WorkflowInstanceResult =
  | Error
  | WorkflowV1WorkflowInstance;

export type WorkflowV1WorkflowInstanceStateHistory = {
  actualEnteredTime?: Maybe<Scalars['String']['output']>;
  actualExitedTime?: Maybe<Scalars['String']['output']>;
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  enteredTime?: Maybe<Scalars['String']['output']>;
  exitedTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceStateHistoryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceTransitionStatus = {
  action: Scalars['String']['output'];
  completed?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusCompleted>;
  failed?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusFailed>;
  initiator: IamV1IdentityResult;
  running?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusRunning>;
};

export type WorkflowV1WorkflowInstanceTransitionStatusCompleted = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusCompletedInput = {
  endTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusFailed = {
  endTime: Scalars['String']['output'];
  error: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusFailedInput = {
  endTime: Scalars['String']['input'];
  error: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusInput = {
  action: Scalars['String']['input'];
  completed?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusCompletedInput>;
  failed?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusFailedInput>;
  initiator: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  running?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusRunningInput>;
};

export type WorkflowV1WorkflowInstanceTransitionStatusRunning = {
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusRunningInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceWorkflowJob = {
  func: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  runTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceWorkflowJobInput = {
  func: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceWorkflowJobQueue = {
  isEnabled: Scalars['Boolean']['output'];
  items: Array<WorkflowV1WorkflowInstanceWorkflowJob>;
};

export type WorkflowV1WorkflowInstanceWorkflowJobQueueInput = {
  items?: InputMaybe<Array<WorkflowV1WorkflowInstanceWorkflowJobInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLog = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  level: WorkflowV1WorkflowLogLogLevel;
  logTime: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  workflowVersion: WorkflowV1WorkflowVersionResult;
};

export type WorkflowV1WorkflowLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowLogObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WorkflowV1WorkflowLogLogLevel {
  LogLevelError = 'LOG_LEVEL_ERROR',
  LogLevelInfo = 'LOG_LEVEL_INFO',
  LogLevelWarn = 'LOG_LEVEL_WARN',
}

export type WorkflowV1WorkflowLogResult = Error | WorkflowV1WorkflowLog;

export type WorkflowV1WorkflowResult = Error | WorkflowV1Workflow;

export type WorkflowV1WorkflowSecret = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowSecretLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1WorkflowSecretAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowSecretCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowSecretObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretInput = {
  labels?: InputMaybe<Array<WorkflowV1WorkflowSecretLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};

export type WorkflowV1WorkflowSecretLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowSecretLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretResult = Error | WorkflowV1WorkflowSecret;

export type WorkflowV1WorkflowTemplate = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  labels: Array<WorkflowV1WorkflowTemplateLabelsEntry>;
  moduleData: Array<WorkflowV1WorkflowTemplateModuleDataEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sourceInstance: WorkflowV1WorkflowInstanceResult;
  state?: Maybe<Scalars['String']['output']>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
};

export type WorkflowV1WorkflowTemplateAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowTemplateCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowTemplateObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowTemplateLabelsEntryInput>>;
  moduleData?: InputMaybe<
    Array<WorkflowV1WorkflowTemplateModuleDataEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceInstance: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowTemplateLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateModuleDataEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1WorkflowTemplateModuleDataEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkflowV1WorkflowTemplateResult =
  | Error
  | WorkflowV1WorkflowTemplate;

export type WorkflowV1WorkflowVersion = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowVersionLabelsEntry>;
  name: Scalars['String']['output'];
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: WorkflowV1WorkflowVersionState;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowConfig: WorkflowV1WorkflowVersionWorkflowConfig;
  workflowInfo?: Maybe<WorkflowV1WorkflowWorkflowInfo>;
};

export type WorkflowV1WorkflowVersionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowVersionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowVersionObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionInput = {
  labels?: InputMaybe<Array<WorkflowV1WorkflowVersionLabelsEntryInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  workflowConfig: WorkflowV1WorkflowVersionWorkflowConfigInput;
};

export type WorkflowV1WorkflowVersionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowVersionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionResult = Error | WorkflowV1WorkflowVersion;

export enum WorkflowV1WorkflowVersionState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Creating = 'CREATING',
  Failed = 'FAILED',
}

export type WorkflowV1WorkflowVersionWorkflowConfig = {
  jsConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfig>;
  localDevConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfig>;
  remoteHttpConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfig>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigInput = {
  jsConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfigInput>;
  localDevConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  remoteHttpConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigInput>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfig = {
  jsPackagePath: Scalars['String']['output'];
};

export type WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfigInput = {
  jsPackagePath: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfig = {
  describeResponse?: Maybe<Scalars['JSON']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  tunnelInfo?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfo>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigInput =
  {
    describeResponse?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    tunnelInfo?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfoInput>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfo =
  {
    url: Scalars['String']['output'];
  };

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfoInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    url: Scalars['String']['input'];
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfig = {
  baseUrls: Array<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntry>;
  entryPoint: Scalars['String']['output'];
  jsPackagePath?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntry =
  {
    key: Scalars['String']['output'];
    value?: Maybe<Scalars['String']['output']>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigInput =
  {
    baseUrls?: InputMaybe<
      Array<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntryInput>
    >;
    entryPoint: Scalars['String']['input'];
    jsPackagePath?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type WorkflowV1WorkflowWorkflowInfo = {
  eventHandlers: Array<WorkflowV1WorkflowWorkflowInfoEventHandlersEntry>;
  functions: Array<WorkflowV1WorkflowWorkflowInfoFunctionsEntry>;
  initialState?: Maybe<Scalars['String']['output']>;
  migrations: Array<WorkflowV1WorkflowWorkflowInfoMigrationsEntry>;
  modules: Array<WorkflowV1WorkflowWorkflowInfoModulesEntry>;
  protocolVersion?: Maybe<Scalars['Int']['output']>;
  states: Array<WorkflowV1WorkflowWorkflowInfoStatesEntry>;
  validations: Array<WorkflowV1WorkflowWorkflowInfoValidationsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoAction = {
  actionSteps: Array<Scalars['String']['output']>;
  labels: Array<WorkflowV1WorkflowWorkflowInfoActionLabelsEntry>;
  nextState?: Maybe<Scalars['String']['output']>;
  requiredPermissions: Array<WorkflowV1WorkflowWorkflowInfoPermissionSpec>;
  softChecks?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionInput = {
  actionSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoActionLabelsEntryInput>
  >;
  nextState?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requiredPermissions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoPermissionSpecInput>
  >;
  softChecks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandler = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlersEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoEventHandler>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoEventHandlerInput>;
};

export type WorkflowV1WorkflowWorkflowInfoFunction = {
  description?: Maybe<Scalars['String']['output']>;
  requestSchema?: Maybe<Scalars['JSON']['output']>;
  requiredPermissions: Array<WorkflowV1WorkflowWorkflowInfoPermissionSpec>;
  responseSchema?: Maybe<Scalars['JSON']['output']>;
  visibility?: Maybe<WorkflowV1WorkflowWorkflowInfoFunctionVisibility>;
};

export type WorkflowV1WorkflowWorkflowInfoFunctionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestSchema?: InputMaybe<Scalars['JSON']['input']>;
  requiredPermissions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoPermissionSpecInput>
  >;
  responseSchema?: InputMaybe<Scalars['JSON']['input']>;
  visibility?: InputMaybe<WorkflowV1WorkflowWorkflowInfoFunctionVisibility>;
};

export enum WorkflowV1WorkflowWorkflowInfoFunctionVisibility {
  Internal = 'INTERNAL',
}

export type WorkflowV1WorkflowWorkflowInfoFunctionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoFunction>;
};

export type WorkflowV1WorkflowWorkflowInfoFunctionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoFunctionInput>;
};

export type WorkflowV1WorkflowWorkflowInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigration = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoMigration>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoMigrationInput>;
};

export type WorkflowV1WorkflowWorkflowInfoModule = {
  payloadSchema?: Maybe<Scalars['JSON']['output']>;
  payloadType?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoModuleInput = {
  payloadSchema?: InputMaybe<Scalars['JSON']['input']>;
  payloadType?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoModulesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoModule>;
};

export type WorkflowV1WorkflowWorkflowInfoModulesEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoModuleInput>;
};

export type WorkflowV1WorkflowWorkflowInfoPermissionSpec = {
  ref?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoPermissionSpecInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoState = {
  actions: Array<WorkflowV1WorkflowWorkflowInfoStateActionsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoStateActionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoAction>;
};

export type WorkflowV1WorkflowWorkflowInfoStateActionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoActionInput>;
};

export type WorkflowV1WorkflowWorkflowInfoStateInput = {
  actions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoStateActionsEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoStatesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoState>;
};

export type WorkflowV1WorkflowWorkflowInfoStatesEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoStateInput>;
};

export type WorkflowV1WorkflowWorkflowInfoValidation = {
  appliedStates: Array<Scalars['String']['output']>;
  labels: Array<WorkflowV1WorkflowWorkflowInfoValidationLabelsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationInput = {
  appliedStates?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoValidationLabelsEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoValidation>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoValidationInput>;
};

export type GetAccountStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountStateQuery = {
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
        demoData?: boolean | null;
      }
    | null;
  currentAccount?:
    | {
        __typename: 'AdminV1AccountInfo';
        mode?: AdminV1AccountMode | null;
        totalConfidenceAccountInfo?: {
          state?: AdminV1AccountInfoTotalConfidenceAccountStatusState | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{
          name: string;
          labels: Array<{ value?: string | null; key: string }>;
        }>;
      }
    | null;
  eventDefinitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1ListEventDefinitionsResponse';
        eventDefinitions: Array<{
          name: string;
          usageMetadata: { lastPublishTime?: string | null };
        }>;
      }
    | null;
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1CurrentUser'; identity: { name: string } }
    | null;
};

export type GetEventPublishedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetEventPublishedQuery = {
  eventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        usageMetadata: { lastPublishTime?: string | null };
      }
    | null;
};

export type GetFlagResolvedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetFlagResolvedQuery = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type GetOwnedInstancesQueryVariables = Exact<{
  tutorialFilter?: InputMaybe<Scalars['String']['input']>;
  instancesFilter?: InputMaybe<Scalars['String']['input']>;
  accountFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOwnedInstancesQuery = {
  tutorialInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
  accountWorkflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
};

export type StoreSlackUserInfoMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type StoreSlackUserInfoMutation = {
  storeSlackUserInfo?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1StoreSlackUserInfoResponse' }
    | null;
};

export type WriteDemoDataMutationVariables = Exact<{ [key: string]: never }>;

export type WriteDemoDataMutation = {
  writeDemoData?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type AnalysisResultQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AnalysisResultQuery = {
  analysisResult?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        name: string;
        exposureFilter?: string | null;
        updateTime: string;
        annotations: Array<{
          context: Array<{
            key?: StatsV2AnalysisStatsAnnotationContext | null;
            value?: string | null;
          }>;
        }>;
        results: Array<{
          id?: string | null;
          annotations: Array<{
            info?: string | null;
            warning?: string | null;
            context: Array<{
              key?: StatsV2AnalysisStatsAnnotationContext | null;
              value?: string | null;
            }>;
            error?: {
              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
              details?: string | null;
            } | null;
          }>;
          metricDetails?: {
            direction?: StatsV2AnalysisMetricDirection | null;
            hasRun?: boolean | null;
            metricType?: StatsV2AnalysisMetricType | null;
            plannedEffectSize?: { value?: string | null } | null;
          } | null;
          result: Array<{
            comparisonId?: string | null;
            isSignificant?: boolean | null;
            usedDataType?: StatsV2AnalysisStatsDataType | null;
            segmentId?: string | null;
            dimensions: Array<{ value?: string | null; key: string }>;
            groupStats: Array<{ sampleSize?: any | null; id?: string | null }>;
            groups?: {
              baseline?: string | null;
              compared?: string | null;
            } | null;
            lastDeteriorationResult?: {
              baselineEstimateAbs?: number | null;
              baselineEstimateRel?: number | null;
              baselineSampleSize?: any | null;
              comparedEstimateAbs?: number | null;
              comparedEstimateRel?: number | null;
              comparedSampleSize?: any | null;
              differenceEstimateAbs?: {
                estimate?: number | null;
                isSignificant?: boolean | null;
                lower?: number | null;
                powered?: number | null;
                upper?: number | null;
              } | null;
            } | null;
            lastResult?: {
              baselineEstimateAbs?: number | null;
              baselineEstimateRel?: number | null;
              baselineSampleSize?: any | null;
              comparedEstimateAbs?: number | null;
              differenceEstimateAbs?: {
                estimate?: number | null;
                lower?: number | null;
                upper?: number | null;
                isSignificant?: boolean | null;
              } | null;
              differenceEstimateRel?: {
                estimate?: number | null;
                lower?: number | null;
                upper?: number | null;
                isSignificant?: boolean | null;
              } | null;
            } | null;
            status?: {
              status?: StatsV2AnalysisMetricResultStatus | null;
              message?: string | null;
              metricType?: StatsV2AnalysisMetricType | null;
              decisionPowered?: boolean | null;
              decisionIsSignificant?: boolean | null;
              validationIsSignificant?: boolean | null;
            } | null;
            result: Array<{
              resultTime?: string | null;
              baselineEstimateAbs?: number | null;
              comparedEstimateAbs?: number | null;
              baselineEstimateRel?: number | null;
              comparedEstimateRel?: number | null;
              varianceReductionRate?: number | null;
              unadjustedEstimateBaseline?: number | null;
              unadjustedEstimateCompared?: number | null;
              baselineSampleSize?: any | null;
              comparedSampleSize?: any | null;
              differenceEstimateAbs?: {
                estimate?: number | null;
                lower?: number | null;
                upper?: number | null;
                isSignificant?: boolean | null;
              } | null;
              differenceEstimateRel?: {
                estimate?: number | null;
                lower?: number | null;
                upper?: number | null;
                isSignificant?: boolean | null;
              } | null;
            }>;
            sampleSize?: {
              current?: any | null;
              required?: any | null;
              poweredEffectRel?: number | null;
              poweredEffectAbs?: number | null;
            } | null;
          }>;
          srmResult: Array<{
            isSignificant?: boolean | null;
            segmentId?: string | null;
            status?: {
              status?: StatsV2AnalysisMetricResultStatus | null;
              message?: string | null;
              metricType?: StatsV2AnalysisMetricType | null;
              decisionPowered?: boolean | null;
              decisionIsSignificant?: boolean | null;
              validationIsSignificant?: boolean | null;
            } | null;
            dimensions: Array<{ key: string; value?: string | null }>;
            result: Array<{
              group?: string | null;
              observed?: number | null;
              expected?: number | null;
              isSignificant?: boolean | null;
            }>;
          }>;
          statsSettings?: {
            method?: StatsV2AnalysisMethod | null;
            adjustedAlpha?: number | null;
            adjustedBeta?: number | null;
            hasVarianceReduction?: boolean | null;
          } | null;
        }>;
        treatments: Array<{
          id?: string | null;
          recommendation?: {
            shipping?: StatsV2AnalysisShippingRecommendation | null;
            status?: {
              quality?: StatsV2AnalysisQualityStatus | null;
              tanking?: StatsV2AnalysisTankingStatus | null;
              guardrail?: StatsV2AnalysisGuardrailStatus | null;
              success?: StatsV2AnalysisSuccessStatus | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type SpotifyAnalysisFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  moduleData2: {
    spotifyanalysis?: {
      experimentId?: any | null;
      mhMetrics: Array<{
        secondary?: any | null;
        metricName: string;
        preferredDirection: string;
        userCreated: boolean;
        success?: { minimumDetectableEffect?: number | null } | null;
        guardrail?: { nonInferiorityMargin?: number | null } | null;
      }>;
      treatments: Array<{ name: string; weight: any; id: any }>;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        nextPageToken?: string | null;
        comments: Array<{
          __typename: 'CollaborationV1Comment';
          name: string;
          resource: string;
          createTime: string;
          updateTime: string;
          content: string;
          resolved?: boolean | null;
          author:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          assignee?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          anchor?: { zone?: { zone: string } | null } | null;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type SpotifyAnalysisQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type SpotifyAnalysisQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        moduleData2: {
          spotifyanalysis?: {
            experimentId?: any | null;
            mhMetrics: Array<{
              secondary?: any | null;
              metricName: string;
              preferredDirection: string;
              userCreated: boolean;
              success?: { minimumDetectableEffect?: number | null } | null;
              guardrail?: { nonInferiorityMargin?: number | null } | null;
            }>;
            treatments: Array<{ name: string; weight: any; id: any }>;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        comments?:
          | {
              __typename: 'CollaborationV1ListCommentsResponse';
              nextPageToken?: string | null;
              comments: Array<{
                __typename: 'CollaborationV1Comment';
                name: string;
                resource: string;
                createTime: string;
                updateTime: string;
                content: string;
                resolved?: boolean | null;
                author:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>;
                assignee?:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                anchor?: { zone?: { zone: string } | null } | null;
                queryReactionSummary?:
                  | {
                      __typename: 'CollaborationV1QueryReactionSummaryResponse';
                      summary: {
                        name: string;
                        commentCount: number;
                        emojiReactions: Array<{
                          key: string;
                          value?: {
                            emoji?: string | null;
                            reactionCount?: number | null;
                            identities: Array<
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                            >;
                          } | null;
                        }>;
                      };
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type SpotifyAnalysisDataFragment = {
  experimentId?: any | null;
  mhMetrics: Array<{
    secondary?: any | null;
    metricName: string;
    preferredDirection: string;
    userCreated: boolean;
    success?: { minimumDetectableEffect?: number | null } | null;
    guardrail?: { nonInferiorityMargin?: number | null } | null;
  }>;
  treatments: Array<{ name: string; weight: any; id: any }>;
};

export type C4sAbTestFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  moduleData2: {
    c4sabtest?: {
      __typename: 'C4sAbTest';
      primaryUnit?: string | null;
      rampUpDuration?: C4sAbTestRampUpDuration | null;
      treatments?: Array<{
        id?: any | null;
        name: string;
        displayName: string;
        description?: string | null;
        weight?: any | null;
        imageUri?: string | null;
        overrideUserIds?: Array<string> | null;
        propertyAssignments?: Array<{
          name: string;
          scope: string;
          value: string;
        }> | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    audiences?: {
      __typename: 'AudiencesData';
      audiences?: Array<{
        __typename: 'AudiencesDataAudience';
        id: string;
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }> | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    hypothesis?: { text?: string | null } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type C4sAbTestQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type C4sAbTestQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          c4sabtest?: {
            __typename: 'C4sAbTest';
            primaryUnit?: string | null;
            rampUpDuration?: C4sAbTestRampUpDuration | null;
            treatments?: Array<{
              id?: any | null;
              name: string;
              displayName: string;
              description?: string | null;
              weight?: any | null;
              imageUri?: string | null;
              overrideUserIds?: Array<string> | null;
              propertyAssignments?: Array<{
                name: string;
                scope: string;
                value: string;
              }> | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          hypothesis?: { text?: string | null } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type C4sAbTestDataFragment = {
  __typename: 'C4sAbTest';
  primaryUnit?: string | null;
  rampUpDuration?: C4sAbTestRampUpDuration | null;
  treatments?: Array<{
    id?: any | null;
    name: string;
    displayName: string;
    description?: string | null;
    weight?: any | null;
    imageUri?: string | null;
    overrideUserIds?: Array<string> | null;
    propertyAssignments?: Array<{
      name: string;
      scope: string;
      value: string;
    }> | null;
  }> | null;
};

export type OnC4sAbTestCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnC4sAbTestCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        c4sabtest?: {
          __typename: 'C4sAbTest';
          primaryUnit?: string | null;
          rampUpDuration?: C4sAbTestRampUpDuration | null;
          treatments?: Array<{
            id?: any | null;
            name: string;
            displayName: string;
            description?: string | null;
            weight?: any | null;
            imageUri?: string | null;
            overrideUserIds?: Array<string> | null;
            propertyAssignments?: Array<{
              name: string;
              scope: string;
              value: string;
            }> | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        hypothesis?: { text?: string | null } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnC4sAbTestUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnC4sAbTestUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        c4sabtest?: {
          __typename: 'C4sAbTest';
          primaryUnit?: string | null;
          rampUpDuration?: C4sAbTestRampUpDuration | null;
          treatments?: Array<{
            id?: any | null;
            name: string;
            displayName: string;
            description?: string | null;
            weight?: any | null;
            imageUri?: string | null;
            overrideUserIds?: Array<string> | null;
            propertyAssignments?: Array<{
              name: string;
              scope: string;
              value: string;
            }> | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        hypothesis?: { text?: string | null } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateC4sAbTestDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateC4sAbTestDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        deleteTime?: string | null;
        updateTime: string;
        moduleData2: {
          c4sabtest?: {
            __typename: 'C4sAbTest';
            primaryUnit?: string | null;
            rampUpDuration?: C4sAbTestRampUpDuration | null;
            treatments?: Array<{
              id?: any | null;
              name: string;
              displayName: string;
              description?: string | null;
              weight?: any | null;
              imageUri?: string | null;
              overrideUserIds?: Array<string> | null;
              propertyAssignments?: Array<{
                name: string;
                scope: string;
                value: string;
              }> | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          hypothesis?: { text?: string | null } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type C4sRolloutFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  moduleData2: {
    c4srollout?: {
      __typename: 'C4sRollout';
      description?: string | null;
      primaryUnit?: string | null;
      monitoringDisabled?: boolean | null;
      reach?: string | null;
      schedule?: {
        state?: C4sRolloutScheduleState | null;
        stateReason?: {
          failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: C4sRolloutScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      treatments?: Array<{
        id?: any | null;
        name: string;
        displayName: string;
        description?: string | null;
        weight?: any | null;
        imageUri?: string | null;
        overrideUserIds?: Array<string> | null;
        propertyAssignments?: Array<{
          name: string;
          scope: string;
          value: string;
        }> | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    audiences?: {
      __typename: 'AudiencesData';
      audiences?: Array<{
        __typename: 'AudiencesDataAudience';
        id: string;
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }> | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type C4sRolloutQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type C4sRolloutQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          c4srollout?: {
            __typename: 'C4sRollout';
            description?: string | null;
            primaryUnit?: string | null;
            monitoringDisabled?: boolean | null;
            reach?: string | null;
            schedule?: {
              state?: C4sRolloutScheduleState | null;
              stateReason?: {
                failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: C4sRolloutScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            treatments?: Array<{
              id?: any | null;
              name: string;
              displayName: string;
              description?: string | null;
              weight?: any | null;
              imageUri?: string | null;
              overrideUserIds?: Array<string> | null;
              propertyAssignments?: Array<{
                name: string;
                scope: string;
                value: string;
              }> | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type C4sRolloutDataFragment = {
  __typename: 'C4sRollout';
  description?: string | null;
  primaryUnit?: string | null;
  monitoringDisabled?: boolean | null;
  reach?: string | null;
  schedule?: {
    state?: C4sRolloutScheduleState | null;
    stateReason?: {
      failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
    } | null;
    steps: Array<{
      durationSincePreviousStep: string;
      reach: string;
      status?: C4sRolloutScheduleScheduleStepsStatus | null;
      updateTime?: string | null;
    }>;
  } | null;
  treatments?: Array<{
    id?: any | null;
    name: string;
    displayName: string;
    description?: string | null;
    weight?: any | null;
    imageUri?: string | null;
    overrideUserIds?: Array<string> | null;
    propertyAssignments?: Array<{
      name: string;
      scope: string;
      value: string;
    }> | null;
  }> | null;
};

export type OnC4sRolloutCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnC4sRolloutCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        c4srollout?: {
          __typename: 'C4sRollout';
          description?: string | null;
          primaryUnit?: string | null;
          monitoringDisabled?: boolean | null;
          reach?: string | null;
          schedule?: {
            state?: C4sRolloutScheduleState | null;
            stateReason?: {
              failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: C4sRolloutScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          treatments?: Array<{
            id?: any | null;
            name: string;
            displayName: string;
            description?: string | null;
            weight?: any | null;
            imageUri?: string | null;
            overrideUserIds?: Array<string> | null;
            propertyAssignments?: Array<{
              name: string;
              scope: string;
              value: string;
            }> | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnC4sRolloutUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnC4sRolloutUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        c4srollout?: {
          __typename: 'C4sRollout';
          description?: string | null;
          primaryUnit?: string | null;
          monitoringDisabled?: boolean | null;
          reach?: string | null;
          schedule?: {
            state?: C4sRolloutScheduleState | null;
            stateReason?: {
              failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: C4sRolloutScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          treatments?: Array<{
            id?: any | null;
            name: string;
            displayName: string;
            description?: string | null;
            weight?: any | null;
            imageUri?: string | null;
            overrideUserIds?: Array<string> | null;
            propertyAssignments?: Array<{
              name: string;
              scope: string;
              value: string;
            }> | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateC4sRolloutDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateC4sRolloutDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        deleteTime?: string | null;
        updateTime: string;
        moduleData2: {
          c4srollout?: {
            __typename: 'C4sRollout';
            description?: string | null;
            primaryUnit?: string | null;
            monitoringDisabled?: boolean | null;
            reach?: string | null;
            schedule?: {
              state?: C4sRolloutScheduleState | null;
              stateReason?: {
                failed?: C4sRolloutScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: C4sRolloutScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            treatments?: Array<{
              id?: any | null;
              name: string;
              displayName: string;
              description?: string | null;
              weight?: any | null;
              imageUri?: string | null;
              overrideUserIds?: Array<string> | null;
              propertyAssignments?: Array<{
                name: string;
                scope: string;
                value: string;
              }> | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type OnStaticConfigCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnStaticConfigCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      moduleData2: {
        staticconfig?: {
          primaryUnit?: string | null;
          description?: string | null;
          propertyAssignments?: Array<{
            scope: string;
            name: string;
            value: string;
          }> | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      comments?:
        | {
            __typename: 'CollaborationV1ListCommentsResponse';
            nextPageToken?: string | null;
            comments: Array<{
              __typename: 'CollaborationV1Comment';
              name: string;
              resource: string;
              createTime: string;
              updateTime: string;
              content: string;
              resolved?: boolean | null;
              author:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>;
              assignee?:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>
                | null;
              anchor?: { zone?: { zone: string } | null } | null;
              queryReactionSummary?:
                | {
                    __typename: 'CollaborationV1QueryReactionSummaryResponse';
                    summary: {
                      name: string;
                      commentCount: number;
                      emojiReactions: Array<{
                        key: string;
                        value?: {
                          emoji?: string | null;
                          reactionCount?: number | null;
                          identities: Array<
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                          >;
                        } | null;
                      }>;
                    };
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnStaticConfigUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnStaticConfigUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      moduleData2: {
        staticconfig?: {
          primaryUnit?: string | null;
          description?: string | null;
          propertyAssignments?: Array<{
            scope: string;
            name: string;
            value: string;
          }> | null;
        } | null;
        audiences?: {
          __typename: 'AudiencesData';
          audiences?: Array<{
            __typename: 'AudiencesDataAudience';
            id: string;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
          }> | null;
        } | null;
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      comments?:
        | {
            __typename: 'CollaborationV1ListCommentsResponse';
            nextPageToken?: string | null;
            comments: Array<{
              __typename: 'CollaborationV1Comment';
              name: string;
              resource: string;
              createTime: string;
              updateTime: string;
              content: string;
              resolved?: boolean | null;
              author:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>;
              assignee?:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>
                | null;
              anchor?: { zone?: { zone: string } | null } | null;
              queryReactionSummary?:
                | {
                    __typename: 'CollaborationV1QueryReactionSummaryResponse';
                    summary: {
                      name: string;
                      commentCount: number;
                      emojiReactions: Array<{
                        key: string;
                        value?: {
                          emoji?: string | null;
                          reactionCount?: number | null;
                          identities: Array<
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                          >;
                        } | null;
                      }>;
                    };
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type StaticConfigFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  moduleData2: {
    staticconfig?: {
      primaryUnit?: string | null;
      description?: string | null;
      propertyAssignments?: Array<{
        scope: string;
        name: string;
        value: string;
      }> | null;
    } | null;
    audiences?: {
      __typename: 'AudiencesData';
      audiences?: Array<{
        __typename: 'AudiencesDataAudience';
        id: string;
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }> | null;
    } | null;
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        nextPageToken?: string | null;
        comments: Array<{
          __typename: 'CollaborationV1Comment';
          name: string;
          resource: string;
          createTime: string;
          updateTime: string;
          content: string;
          resolved?: boolean | null;
          author:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          assignee?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          anchor?: { zone?: { zone: string } | null } | null;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type StaticConfigQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type StaticConfigQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        moduleData2: {
          staticconfig?: {
            primaryUnit?: string | null;
            description?: string | null;
            propertyAssignments?: Array<{
              scope: string;
              name: string;
              value: string;
            }> | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        comments?:
          | {
              __typename: 'CollaborationV1ListCommentsResponse';
              nextPageToken?: string | null;
              comments: Array<{
                __typename: 'CollaborationV1Comment';
                name: string;
                resource: string;
                createTime: string;
                updateTime: string;
                content: string;
                resolved?: boolean | null;
                author:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>;
                assignee?:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                anchor?: { zone?: { zone: string } | null } | null;
                queryReactionSummary?:
                  | {
                      __typename: 'CollaborationV1QueryReactionSummaryResponse';
                      summary: {
                        name: string;
                        commentCount: number;
                        emojiReactions: Array<{
                          key: string;
                          value?: {
                            emoji?: string | null;
                            reactionCount?: number | null;
                            identities: Array<
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                            >;
                          } | null;
                        }>;
                      };
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type StaticConfigDataFragment = {
  primaryUnit?: string | null;
  description?: string | null;
  propertyAssignments?: Array<{
    scope: string;
    name: string;
    value: string;
  }> | null;
};

export type UpdateStaticConfigDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateStaticConfigDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        deleteTime?: string | null;
        updateTime: string;
        moduleData2: {
          staticconfig?: {
            primaryUnit?: string | null;
            description?: string | null;
            propertyAssignments?: Array<{
              scope: string;
              name: string;
              value: string;
            }> | null;
          } | null;
          audiences?: {
            __typename: 'AudiencesData';
            audiences?: Array<{
              __typename: 'AudiencesDataAudience';
              id: string;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
            }> | null;
          } | null;
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        comments?:
          | {
              __typename: 'CollaborationV1ListCommentsResponse';
              nextPageToken?: string | null;
              comments: Array<{
                __typename: 'CollaborationV1Comment';
                name: string;
                resource: string;
                createTime: string;
                updateTime: string;
                content: string;
                resolved?: boolean | null;
                author:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>;
                assignee?:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                anchor?: { zone?: { zone: string } | null } | null;
                queryReactionSummary?:
                  | {
                      __typename: 'CollaborationV1QueryReactionSummaryResponse';
                      summary: {
                        name: string;
                        commentCount: number;
                        emojiReactions: Array<{
                          key: string;
                          value?: {
                            emoji?: string | null;
                            reactionCount?: number | null;
                            identities: Array<
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                            >;
                          } | null;
                        }>;
                      };
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type AudienceFragment = {
  __typename: 'AudiencesDataAudience';
  id: string;
  segment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type AudiencesDataFragment = {
  __typename: 'AudiencesData';
  audiences?: Array<{
    __typename: 'AudiencesDataAudience';
    id: string;
    segment?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FlagsAdminV1Segment';
          name: string;
          displayName?: string | null;
          description?: string | null;
          state?: FlagsAdminV1SegmentState | null;
          createTime: string;
          updateTime: string;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                displayName: string;
              }
            | null;
          workflowInstance?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          allocation?: {
            exclusiveTo: Array<string>;
            exclusivityTags: Array<string>;
            proportion?: { value?: string | null } | null;
          } | null;
          targeting?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attributeName?: string | null;
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                  anyRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                  allRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                } | null;
                segment?: {
                  segment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Segment';
                        name: string;
                        displayName?: string | null;
                        labels: Array<{ key: string; value?: string | null }>;
                      }
                    | null;
                } | null;
                materializedSegment?: {
                  materializedSegment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1MaterializedSegment';
                        name: string;
                        displayName: string;
                      }
                    | null;
                } | null;
              } | null;
            }>;
            expression?: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }
      | null;
  }> | null;
};

export type SampleSizeConfigMutationVariables = Exact<{
  workflowInstance: Scalars['String']['input'];
}>;

export type SampleSizeConfigMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1ExecuteFunctionResponse'; response?: any | null }
    | null;
};

export type ActivitiesQueryVariables = Exact<{
  resource: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ActivitiesQuery = {
  activities?:
    | {
        __typename: 'ActivityV1ListActivitiesResponse';
        nextPageToken?: string | null;
        truncatedBeforeTime?: string | null;
        activities: Array<{
          __typename: 'ActivityV1Activity';
          name: string;
          title: string;
          body: string;
          data?: any | null;
          primaryResource: string;
          relatedResources: Array<string>;
          priority: ActivityV1ActivityPriority;
          activityTime: string;
          createTime: string;
          updateTime: string;
          actor:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          creator:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          updater:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          labels: Array<{ key: string; value?: string | null }>;
          changeSet?: {
            __typename: 'ActivityV1ResourceChangeSet';
            changes: Array<{
              description?: string | null;
              fieldPath: string;
              fieldType?: string | null;
              newValue?: any | null;
              oldValue?: any | null;
              changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
              reorderDetails?: {
                moves: Array<{
                  item: string;
                  newPosition: number;
                  oldPosition: number;
                }>;
              } | null;
            }>;
          } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ActivityFragment = {
  __typename: 'ActivityV1Activity';
  name: string;
  title: string;
  body: string;
  data?: any | null;
  primaryResource: string;
  relatedResources: Array<string>;
  priority: ActivityV1ActivityPriority;
  activityTime: string;
  createTime: string;
  updateTime: string;
  actor:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  creator:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  updater:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  labels: Array<{ key: string; value?: string | null }>;
  changeSet?: {
    __typename: 'ActivityV1ResourceChangeSet';
    changes: Array<{
      description?: string | null;
      fieldPath: string;
      fieldType?: string | null;
      newValue?: any | null;
      oldValue?: any | null;
      changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
      reorderDetails?: {
        moves: Array<{
          item: string;
          newPosition: number;
          oldPosition: number;
        }>;
      } | null;
    }>;
  } | null;
};

export type ActivityTypeRefFragment = {
  __typename: 'ActivityV1ActivityType';
  name: string;
  displayName: string;
};

export type ActivityTypesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ActivityTypesQuery = {
  activityTypes?:
    | {
        __typename: 'ActivityV1ListActivityTypesResponse';
        nextPageToken?: string | null;
        activityTypes: Array<{
          __typename: 'ActivityV1ActivityType';
          name: string;
          displayName: string;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ChangeSetFragment = {
  __typename: 'ActivityV1ResourceChangeSet';
  changes: Array<{
    description?: string | null;
    fieldPath: string;
    fieldType?: string | null;
    newValue?: any | null;
    oldValue?: any | null;
    changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
    reorderDetails?: {
      moves: Array<{ item: string; newPosition: number; oldPosition: number }>;
    } | null;
  }>;
};

export type ChannelDeliveryStatusFragment = {
  channel: string;
  state?: ActivityV1FeedEntryChannelDeliveryStatusDeliveryState | null;
  failedAttempts: number;
  lastError?: string | null;
};

export type FeedActivityFragment = {
  __typename: 'ActivityV1Activity';
  name: string;
  title: string;
  body: string;
  data?: any | null;
  primaryResource: string;
  relatedResources: Array<string>;
  priority: ActivityV1ActivityPriority;
  activityTime: string;
  createTime: string;
  updateTime: string;
  actor:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  creator:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  updater:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  labels: Array<{ key: string; value?: string | null }>;
  queryReactionSummary?:
    | {
        __typename: 'CollaborationV1QueryReactionSummaryResponse';
        summary: {
          name: string;
          commentCount: number;
          emojiReactions: Array<{
            key: string;
            value?: {
              emoji?: string | null;
              reactionCount?: number | null;
              identities: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
              >;
            } | null;
          }>;
        };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FeedEntriesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FeedEntriesQuery = {
  feedEntries?:
    | {
        __typename: 'ActivityV1ListFeedEntriesResponse';
        nextPageToken?: string | null;
        feedEntries: Array<{
          __typename: 'ActivityV1FeedEntry';
          name: string;
          entryTime: string;
          read: boolean;
          createTime: string;
          updateTime: string;
          creator:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          activity: {
            __typename: 'ActivityV1Activity';
            name: string;
            title: string;
            body: string;
            data?: any | null;
            primaryResource: string;
            relatedResources: Array<string>;
            priority: ActivityV1ActivityPriority;
            activityTime: string;
            createTime: string;
            updateTime: string;
            actor:
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | Record<PropertyKey, never>;
            creator:
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | Record<PropertyKey, never>;
            updater:
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | Record<PropertyKey, never>;
            labels: Array<{ key: string; value?: string | null }>;
            queryReactionSummary?:
              | {
                  __typename: 'CollaborationV1QueryReactionSummaryResponse';
                  summary: {
                    name: string;
                    commentCount: number;
                    emojiReactions: Array<{
                      key: string;
                      value?: {
                        emoji?: string | null;
                        reactionCount?: number | null;
                        identities: Array<
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                            }
                        >;
                      } | null;
                    }>;
                  };
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
          };
          channelDeliveryStatuses: Array<{
            channel: string;
            state?: ActivityV1FeedEntryChannelDeliveryStatusDeliveryState | null;
            failedAttempts: number;
            lastError?: string | null;
          }>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FeedEntryFragment = {
  __typename: 'ActivityV1FeedEntry';
  name: string;
  entryTime: string;
  read: boolean;
  createTime: string;
  updateTime: string;
  creator:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  activity: {
    __typename: 'ActivityV1Activity';
    name: string;
    title: string;
    body: string;
    data?: any | null;
    primaryResource: string;
    relatedResources: Array<string>;
    priority: ActivityV1ActivityPriority;
    activityTime: string;
    createTime: string;
    updateTime: string;
    actor:
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
      | Record<PropertyKey, never>;
    creator:
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
      | Record<PropertyKey, never>;
    updater:
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
      | Record<PropertyKey, never>;
    labels: Array<{ key: string; value?: string | null }>;
    queryReactionSummary?:
      | {
          __typename: 'CollaborationV1QueryReactionSummaryResponse';
          summary: {
            name: string;
            commentCount: number;
            emojiReactions: Array<{
              key: string;
              value?: {
                emoji?: string | null;
                reactionCount?: number | null;
                identities: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                >;
              } | null;
            }>;
          };
        }
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | null;
  };
  channelDeliveryStatuses: Array<{
    channel: string;
    state?: ActivityV1FeedEntryChannelDeliveryStatusDeliveryState | null;
    failedAttempts: number;
    lastError?: string | null;
  }>;
};

export type FollowResourcesMutationVariables = Exact<{
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']> | Scalars['String']['input'];
  activityTypes?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type FollowResourcesMutation = {
  followResources?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type OnActivityCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnActivityCreatedSubscription = {
  activityCreated?: {
    activity?: {
      __typename: 'ActivityV1Activity';
      name: string;
      title: string;
      body: string;
      data?: any | null;
      primaryResource: string;
      relatedResources: Array<string>;
      priority: ActivityV1ActivityPriority;
      activityTime: string;
      createTime: string;
      updateTime: string;
      actor:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>;
      creator:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>;
      updater:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>;
      labels: Array<{ key: string; value?: string | null }>;
      changeSet?: {
        __typename: 'ActivityV1ResourceChangeSet';
        changes: Array<{
          description?: string | null;
          fieldPath: string;
          fieldType?: string | null;
          newValue?: any | null;
          oldValue?: any | null;
          changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
          reorderDetails?: {
            moves: Array<{
              item: string;
              newPosition: number;
              oldPosition: number;
            }>;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type QueryIsFollowingResourceQueryVariables = Exact<{
  feed?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
}>;

export type QueryIsFollowingResourceQuery = {
  queryIsFollowingResource?:
    | {
        __typename: 'ActivityV1QueryIsFollowingResourceResponse';
        isFollowing?: boolean | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UnfollowResourcesMutationVariables = Exact<{
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UnfollowResourcesMutation = {
  unfollowResources?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type ConversationFragment = {
  __typename: 'ConversationsV1Conversation';
  name: string;
  sessionId?: string | null;
  title?: string | null;
  firstUserMessage?: string | null;
  messageCount?: number | null;
  createTime: string;
  updateTime: string;
  messages: Array<{
    id?: string | null;
    role: ConversationsV1MessageRole;
    content?: string | null;
    createTime: string;
    events: Array<{
      eventType: string;
      content?: string | null;
      metadata?: string | null;
      createTime: string;
    }>;
  }>;
};

export type ConversationQueryVariables = Exact<{
  name: Scalars['String']['input'];
  view?: InputMaybe<ConversationsV1ConversationView>;
}>;

export type ConversationQuery = {
  conversation?:
    | {
        __typename: 'ConversationsV1Conversation';
        name: string;
        sessionId?: string | null;
        title?: string | null;
        firstUserMessage?: string | null;
        messageCount?: number | null;
        createTime: string;
        updateTime: string;
        messages: Array<{
          id?: string | null;
          role: ConversationsV1MessageRole;
          content?: string | null;
          createTime: string;
          events: Array<{
            eventType: string;
            content?: string | null;
            metadata?: string | null;
            createTime: string;
          }>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ConversationRefFragment = {
  __typename: 'ConversationsV1Conversation';
  name: string;
  sessionId?: string | null;
  title?: string | null;
  firstUserMessage?: string | null;
  messageCount?: number | null;
  createTime: string;
  updateTime: string;
};

export type ConversationsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConversationsQuery = {
  conversations?:
    | {
        __typename: 'ConversationsV1ListConversationsResponse';
        nextPageToken?: string | null;
        conversations: Array<{
          __typename: 'ConversationsV1Conversation';
          name: string;
          sessionId?: string | null;
          title?: string | null;
          firstUserMessage?: string | null;
          messageCount?: number | null;
          createTime: string;
          updateTime: string;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type GlobalContextExternalDocumentsQueryVariables = Exact<{
  resource: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GlobalContextExternalDocumentsQuery = {
  externalDocuments?:
    | {
        __typename: 'CollaborationV1ListExternalDocumentsResponse';
        nextPageToken?: string | null;
        externalDocuments: Array<{
          __typename: 'CollaborationV1ExternalDocument';
          name: string;
          resource: string;
          title?: string | null;
          markdown?: string | null;
          createTime: string;
          updateTime: string;
          source: {
            type: CollaborationV1ExternalDocumentSourceType;
            sourceId: string;
            uri?: string | null;
          };
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateInsightsDocumentMutationVariables = Exact<{
  insightsDocument: InsightsV1InsightsDocumentInput;
}>;

export type CreateInsightsDocumentMutation = {
  createInsightsDocument?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1InsightsDocument';
        name: string;
        title: string;
        text?: string | null;
        lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
        description?: string | null;
      }
    | null;
};

export type DeleteInsightsDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteInsightsDocumentMutation = {
  deleteInsightsDocument?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type InsightsDocumentFragment = {
  __typename: 'InsightsV1InsightsDocument';
  name: string;
  title: string;
  text?: string | null;
  lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
  description?: string | null;
};

export type InsightsDocumentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type InsightsDocumentQuery = {
  insightsDocument?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1InsightsDocument';
        name: string;
        title: string;
        text?: string | null;
        lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
        description?: string | null;
      }
    | null;
};

export type InsightsDocumentRefFragment = {
  __typename: 'InsightsV1InsightsDocument';
  name: string;
  title: string;
  lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
  description?: string | null;
};

export type InsightsDocumentsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type InsightsDocumentsQuery = {
  insightsDocuments?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1ListInsightsDocumentsResponse';
        nextPageToken?: string | null;
        insightsDocuments: Array<{
          __typename: 'InsightsV1InsightsDocument';
          name: string;
          title: string;
          lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
          description?: string | null;
        }>;
      }
    | null;
};

export type InsightsTableContextRefFragment = {
  __typename: 'InsightsV1InsightsTableContext';
  name: string;
  displayName?: string | null;
  enabled?: boolean | null;
  source?: InsightsV1InsightsContextSource | null;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  factTable:
    | { __typename: 'Error'; message?: string | null }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        state: MetricsV1TableState;
      };
};

export type InsightsTableContextsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type InsightsTableContextsQuery = {
  insightsTableContexts?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1ListInsightsTableContextsResponse';
        nextPageToken?: string | null;
        insightsTableContexts: Array<{
          __typename: 'InsightsV1InsightsTableContext';
          name: string;
          displayName?: string | null;
          enabled?: boolean | null;
          source?: InsightsV1InsightsContextSource | null;
          createTime: string;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          factTable:
            | { __typename: 'Error'; message?: string | null }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                description?: string | null;
                state: MetricsV1TableState;
              };
        }>;
      }
    | null;
};

export type SyncInsightsTableContextsMutationVariables = Exact<{
  includeEnrichment?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SyncInsightsTableContextsMutation = {
  syncInsightsTableContexts?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1SyncInsightsTableContextsResponse';
        totalFactTables?: number | null;
        created?: number | null;
        skipped?: number | null;
        failed?: number | null;
      }
    | null;
};

export type UpdateInsightsDocumentMutationVariables = Exact<{
  input: PartialInsightsV1InsightsDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateInsightsDocumentMutation = {
  updateInsightsDocument?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1InsightsDocument';
        name: string;
        title: string;
        text?: string | null;
        lifecycle?: InsightsV1InsightsDocumentLifecycle | null;
        description?: string | null;
      }
    | null;
};

export type UpdateInsightsTableContextMutationVariables = Exact<{
  input: PartialInsightsV1InsightsTableContextInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateInsightsTableContextMutation = {
  updateInsightsTableContext?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1InsightsTableContext';
        name: string;
        displayName?: string | null;
        enabled?: boolean | null;
        source?: InsightsV1InsightsContextSource | null;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        factTable:
          | { __typename: 'Error'; message?: string | null }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              description?: string | null;
              state: MetricsV1TableState;
            };
      }
    | null;
};

export type AccountDomainFragment = {
  __typename: 'AdminV1AccountDomain';
  domainId?: string | null;
  domain: string;
  state?: AdminV1AccountDomainState | null;
  verificationTxt?: string | null;
  verificationHost?: string | null;
};

export type AccountDomainsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type AccountDomainsQuery = {
  accountDomains?:
    | {
        __typename: 'AdminV1ListAccountDomainsResponse';
        nextPageToken?: string | null;
        accountDomains: Array<{
          __typename: 'AdminV1AccountDomain';
          domainId?: string | null;
          domain: string;
          state?: AdminV1AccountDomainState | null;
          verificationTxt?: string | null;
          verificationHost?: string | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type RegisterAccountDomainMutationVariables = Exact<{
  accountDomain: AdminV1AccountDomainInput;
}>;

export type RegisterAccountDomainMutation = {
  registerAccountDomain?:
    | {
        __typename: 'AdminV1AccountDomain';
        domainId?: string | null;
        domain: string;
        state?: AdminV1AccountDomainState | null;
        verificationTxt?: string | null;
        verificationHost?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UnregisterAccountDomainMutationVariables = Exact<{
  domainId: Scalars['String']['input'];
}>;

export type UnregisterAccountDomainMutation = {
  unregisterAccountDomain?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type VerifyAccountDomainMutationVariables = Exact<{
  domainId: Scalars['String']['input'];
}>;

export type VerifyAccountDomainMutation = {
  verifyAccountDomain?:
    | {
        __typename: 'AdminV1AccountDomain';
        domainId?: string | null;
        domain: string;
        state?: AdminV1AccountDomainState | null;
        verificationTxt?: string | null;
        verificationHost?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AddGroupMembersMutationVariables = Exact<{
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AddGroupMembersMutation = {
  addGroupMembers?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1AddGroupMembersResponse'; dummy?: string | null }
    | null;
};

export type AgentReviewPreviewFragment = {
  __typename: 'CollaborationV1AgentReviewPreview';
  name: string;
  resource: string;
  state: CollaborationV1AgentReviewPreviewState;
  outcome?: CollaborationV1AgentReviewPreviewReviewOutcome | null;
  comment?: string | null;
  errorMessage?: string | null;
  createTime: string;
  updateTime: string;
  agent:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Agent'; name: string; displayName: string };
  sections: Array<{ zone: string; title: string; comment?: string | null }>;
};

export type AgentReviewPreviewUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type AgentReviewPreviewUpdatedSubscription = {
  agentReviewPreviewUpdated?: {
    agentReviewPreview?: {
      __typename: 'CollaborationV1AgentReviewPreview';
      name: string;
      resource: string;
      state: CollaborationV1AgentReviewPreviewState;
      outcome?: CollaborationV1AgentReviewPreviewReviewOutcome | null;
      comment?: string | null;
      errorMessage?: string | null;
      createTime: string;
      updateTime: string;
      agent:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'IamV1Agent'; name: string; displayName: string };
      sections: Array<{ zone: string; title: string; comment?: string | null }>;
    } | null;
  } | null;
};

export type ApiClientDetailsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ApiClientDetailsQuery = {
  apiClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ApiClient';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type ApiClientSecretQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ApiClientSecretQuery = {
  apiClientSecret?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1ApiClientSecret'; clientSecret?: string | null }
    | null;
};

export type AuthAppFragment = { name: string; displayName: string };

export type BigQueryConfigFragment = {
  gcpProjectId?: string | null;
  dataset?: string | null;
  serviceAccount?: string | null;
  processingProjectId?: string | null;
  interactiveProjectId?: string | null;
};

export type ClientCredentialFragment = {
  __typename: 'IamV1ClientCredential';
  name: string;
  displayName: string;
  sdkType?: IamV1ClientCredentialSdkType | null;
  lastSeenTime?: string | null;
  createTime: string;
  hasEncryptionKey?: boolean | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string; displayName: string };
  clientSecret?: { secret?: string | null } | null;
  environments: Array<
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
        description?: string | null;
        deleteTime?: string | null;
      }
    | Record<PropertyKey, never>
  >;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type ClientCredentialQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ClientCredentialQuery = {
  clientCredential?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ClientCredential';
        name: string;
        displayName: string;
        sdkType?: IamV1ClientCredentialSdkType | null;
        lastSeenTime?: string | null;
        createTime: string;
        hasEncryptionKey?: boolean | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
        clientSecret?: { secret?: string | null } | null;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type ClientCredentialEncryptionKeyQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ClientCredentialEncryptionKeyQuery = {
  clientCredentialEncryptionKey?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ClientCredentialEncryptionKey';
        encryptionKey?: string | null;
      }
    | null;
};

export type ClientCredentialsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ClientCredentialsQuery = {
  clientCredentials?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientCredentialsResponse';
        nextPageToken?: string | null;
        clientCredentials: Array<{
          __typename: 'IamV1ClientCredential';
          name: string;
          displayName: string;
          sdkType?: IamV1ClientCredentialSdkType | null;
          lastSeenTime?: string | null;
          createTime: string;
          hasEncryptionKey?: boolean | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
              };
          clientSecret?: { secret?: string | null } | null;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type ConfigureSlackMutationVariables = Exact<{
  code: Scalars['String']['input'];
  stateToken: Scalars['String']['input'];
}>;

export type ConfigureSlackMutation = {
  configureSlack?:
    | {
        __typename: 'ActivityV1SlackAdminConfig';
        state?: ActivityV1SlackAdminConfigState | null;
        teamId?: string | null;
      }
    | { code: ErrorCode }
    | null;
};

export type ConnectorBigQueryConfigFragment = {
  dataset: string;
  project: string;
  serviceAccount: string;
};

export type ConnectorDatabricksConfigFragment = {
  schema: string;
  s3BucketConfig?: {
    roleArn: string;
    bucket: string;
    region: ConnectorsV1AwsRegion;
    webIdentitySettings?: {
      __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
    } | null;
    credentialsSettings?: { accessKeyId: string } | null;
  } | null;
  connectionConfig: { host: string; warehouseId: string; clientId: string };
  batchFileConfig: {
    maxEventsPerFile: any;
    maxFileAge: string;
    maxFileSize: any;
  };
};

export type ConnectorRedshiftConfigFragment = {
  database: string;
  cluster: string;
  region: ConnectorsV1AwsRegion;
  roleArn: string;
  schema: string;
  webIdentitySettings?: {
    __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
  } | null;
  credentialsSettings?: { accessKeyId: string } | null;
};

export type ConnectorS3BucketConfigFragment = {
  roleArn: string;
  bucket: string;
  region: ConnectorsV1AwsRegion;
  webIdentitySettings?: {
    __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
  } | null;
  credentialsSettings?: { accessKeyId: string } | null;
};

export type ConnectorDatabricksConnectionConfigFragment = {
  host: string;
  warehouseId: string;
  clientId: string;
};

export type ConnectorBatchFileConfigFragment = {
  maxEventsPerFile: any;
  maxFileAge: string;
  maxFileSize: any;
};

export type ConnectorKinesisConfigFragment = {
  region: ConnectorsV1AwsRegion;
  roleArn: string;
  stream: string;
  outputFormat: ConnectorsV1Format;
};

export type ConnectorPubsubConfigFragment = {
  serviceAccount: string;
  project: string;
  topic: string;
  outputFormat: ConnectorsV1Format;
};

export type ConnectorSnowflakeConfigFragment = {
  user: string;
  account: string;
  database: string;
  role: string;
  schema: string;
};

export type ContextSchemaFragment = {
  schema: Array<{
    key: string;
    value?: {
      displayName?: string | null;
      hidden?: boolean | null;
      types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
      semanticType?: {
        enumType?: { values: Array<{ value?: string | null }> } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        country?: {
          format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        timestamp?: { dummy?: string | null } | null;
        date?: { dummy?: string | null } | null;
        version?: { dummy?: string | null } | null;
      } | null;
    } | null;
  }>;
};

export type ContextSchemaEntryFragment = {
  key: string;
  value?: {
    displayName?: string | null;
    hidden?: boolean | null;
    types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
    semanticType?: {
      enumType?: { values: Array<{ value?: string | null }> } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      country?: {
        format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      timestamp?: { dummy?: string | null } | null;
      date?: { dummy?: string | null } | null;
      version?: { dummy?: string | null } | null;
    } | null;
  } | null;
};

export type CreateActivityFeedMutationVariables = Exact<{
  feed: ActivityV1FeedInput;
  feedId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateActivityFeedMutation = {
  createFeed?:
    | {
        __typename: 'ActivityV1Feed';
        name: string;
        channels: Array<{
          priority?: ActivityV1ActivityPriority | null;
          email?: { address: string } | null;
          slack?: { channel?: string | null } | null;
          webhook?: { uri: string; id?: string | null } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateAgentReviewPreviewMutationVariables = Exact<{
  input: CollaborationV1AgentReviewPreviewInput;
}>;

export type CreateAgentReviewPreviewMutation = {
  createAgentReviewPreview?:
    | {
        __typename: 'CollaborationV1AgentReviewPreview';
        name: string;
        resource: string;
        state: CollaborationV1AgentReviewPreviewState;
        outcome?: CollaborationV1AgentReviewPreviewReviewOutcome | null;
        comment?: string | null;
        errorMessage?: string | null;
        createTime: string;
        updateTime: string;
        agent:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Agent'; name: string; displayName: string };
        sections: Array<{
          zone: string;
          title: string;
          comment?: string | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateApiClientMutationVariables = Exact<{
  apiClient: IamV1ApiClientInput;
}>;

export type CreateApiClientMutation = {
  createApiClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ApiClient';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type CreateClaudeAgentsIntegrationMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
}>;

export type CreateClaudeAgentsIntegrationMutation = {
  createExternalIntegration?:
    | {
        __typename: 'AiworkflowsV1ExternalIntegration';
        name: string;
        integrationType?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateClientCredentialMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  clientCredential: IamV1ClientCredentialInput;
}>;

export type CreateClientCredentialMutation = {
  createClientCredential?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ClientCredential';
        name: string;
        displayName: string;
        sdkType?: IamV1ClientCredentialSdkType | null;
        lastSeenTime?: string | null;
        createTime: string;
        hasEncryptionKey?: boolean | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
        clientSecret?: { secret?: string | null } | null;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateCryptoKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  kind: IamV1CryptoKeyKind;
}>;

export type CreateCryptoKeyMutation = {
  createCryptoKey?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CryptoKey';
        name: string;
        state: IamV1CryptoKeyState;
        kind: IamV1CryptoKeyKind;
        publicKey?: string | null;
      }
    | null;
};

export type CreateCursorIntegrationMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
}>;

export type CreateCursorIntegrationMutation = {
  createExternalIntegration?:
    | {
        __typename: 'AiworkflowsV1ExternalIntegration';
        name: string;
        integrationType?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateDataWarehouseMutationVariables = Exact<{
  dataWarehouse: MetricsV1DataWarehouseInput;
}>;

export type CreateDataWarehouseMutation = {
  createDataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
        deleteTime?: string | null;
        config: {
          bigQueryConfig?: {
            gcpProjectId?: string | null;
            dataset?: string | null;
            serviceAccount?: string | null;
            processingProjectId?: string | null;
            interactiveProjectId?: string | null;
          } | null;
          dataBricksConfig?: {
            host?: string | null;
            warehouseId?: string | null;
            clientId?: string | null;
            exposureSchema?: string | null;
            resultsSchema?: string | null;
          } | null;
          redshiftConfig?: {
            cluster: string;
            database: string;
            exposureSchema?: string | null;
            region: MetricsV1AwsRegion;
            roleArn: string;
            webIdentitySettings?: {
              __typename: 'MetricsV1RedshiftConfigWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          } | null;
          snowflakeConfig?: {
            account: string;
            user: string;
            role: string;
            warehouse: string;
            exposureDatabase: string;
            exposureSchema: string;
            authenticationKey:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'IamV1CryptoKey'; name: string };
          } | null;
        };
        limits?: {
          maxConcurrentInteractiveQueries?: any | null;
          maxConcurrentQueries?: any | null;
        } | null;
      }
    | null;
};

export type CreateEntityRelationTableMutationVariables = Exact<{
  entityRelationTable: MetricsV1EntityRelationTableInput;
  parent: Scalars['String']['input'];
}>;

export type CreateEntityRelationTableMutation = {
  createEntityRelationTable?:
    | { name: string }
    | Record<PropertyKey, never>
    | null;
};

export type CreateEvaluationContextFieldOverrideMutationVariables = Exact<{
  evaluationContextFieldOverride: FlagsAdminV1EvaluationContextFieldOverrideInput;
}>;

export type CreateEvaluationContextFieldOverrideMutation = {
  createEvaluationContextFieldOverride?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1EvaluationContextFieldOverride';
        name: string;
        displayName?: string | null;
        field: string;
        hidden?: boolean | null;
        kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
        nonPii?: boolean | null;
        semanticType?: {
          enumType?: { values: Array<{ value?: string | null }> } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          country?: {
            format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          timestamp?: { dummy?: string | null } | null;
          date?: { dummy?: string | null } | null;
          version?: { dummy?: string | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type CreateEventConnectionMutationVariables = Exact<{
  eventConnection: ConnectorsV1EventConnectionInput;
}>;

export type CreateEventConnectionMutation = {
  createEventConnection?:
    | {
        __typename: 'ConnectorsV1EventConnection';
        name: string;
        state?: ConnectorsV1State | null;
        createTime: string;
        bigQuery?: {
          tablePrefix?: string | null;
          bigQueryConfig: {
            dataset: string;
            project: string;
            serviceAccount: string;
          };
        } | null;
        databricks?: {
          databricksConfig: {
            schema: string;
            s3BucketConfig?: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            } | null;
            connectionConfig: {
              host: string;
              warehouseId: string;
              clientId: string;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
          };
        } | null;
        redshift?: {
          tablePrefix?: string | null;
          redshiftConfig: {
            database: string;
            cluster: string;
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            schema: string;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
          batchFileConfig: {
            maxEventsPerFile: any;
            maxFileAge: string;
            maxFileSize: any;
          };
          s3Config: {
            roleArn: string;
            bucket: string;
            region: ConnectorsV1AwsRegion;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
        } | null;
        snowflake?: {
          tablePrefix?: string | null;
          snowflakeConfig: {
            user: string;
            account: string;
            database: string;
            role: string;
            schema: string;
          };
        } | null;
        usageMetadata?: {
          errorRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRatio?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          lag?: { p95?: number | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateFlagAppliedConnectionMutationVariables = Exact<{
  flagAppliedConnection: ConnectorsV1FlagAppliedConnectionInput;
}>;

export type CreateFlagAppliedConnectionMutation = {
  createFlagAppliedConnection?:
    | {
        __typename: 'ConnectorsV1FlagAppliedConnection';
        name: string;
        state?: ConnectorsV1State | null;
        createTime: string;
        bigQuery?: {
          table: string;
          bigQueryConfig: {
            dataset: string;
            project: string;
            serviceAccount: string;
          };
        } | null;
        databricks?: {
          table: string;
          databricksConfig: {
            schema: string;
            s3BucketConfig?: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            } | null;
            connectionConfig: {
              host: string;
              warehouseId: string;
              clientId: string;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
          };
        } | null;
        pubsub?: {
          pubsubConfig: {
            serviceAccount: string;
            project: string;
            topic: string;
            outputFormat: ConnectorsV1Format;
          };
        } | null;
        kinesis?: {
          kinesisConfig: {
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            stream: string;
            outputFormat: ConnectorsV1Format;
          };
        } | null;
        redshift?: {
          table: string;
          redshiftConfig: {
            database: string;
            cluster: string;
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            schema: string;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
          batchFileConfig: {
            maxEventsPerFile: any;
            maxFileAge: string;
            maxFileSize: any;
          };
          s3Config: {
            roleArn: string;
            bucket: string;
            region: ConnectorsV1AwsRegion;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
        } | null;
        snowflake?: {
          table: string;
          snowflakeConfig: {
            user: string;
            account: string;
            database: string;
            role: string;
            schema: string;
          };
        } | null;
        usageMetadata?: {
          errorRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRatio?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          lag?: { p95?: number | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateManagedDataWarehouseMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateManagedDataWarehouseMutation = {
  createManagedDataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1ManagedDataWarehouseProvisioning';
        name: string;
        state: OnboardingV1ManagedDataWarehouseProvisioningState;
        error?: string | null;
      }
    | null;
};

export type CreateOAuthAppMutationVariables = Exact<{
  oauthApp: IamV1OAuthAppInput;
}>;

export type CreateOAuthAppMutation = {
  createOAuthApp?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1OAuthApp';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret: string;
        allowedCallbackUrls: Array<string>;
        allowedWebOrigins: Array<string>;
        allowedLogoutUrls: Array<string>;
        logoUri?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreatePolicyMutationVariables = Exact<{
  policy: IamV1PolicyInput;
}>;

export type CreatePolicyMutation = {
  createPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Policy';
        name: string;
        createTime: string;
        updateTime: string;
        roles: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Role';
              name: string;
              displayName: string;
              builtin?: boolean | null;
              permissions: Array<{
                category: IamV1PermissionCategory;
                description?: string | null;
                type: IamV1PermissionType;
              }>;
            }
        >;
        identities: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateUserInvitationMutationVariables = Exact<{
  userInvitation: IamV1UserInvitationInput;
}>;

export type CreateUserInvitationMutation = {
  createUserInvitation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1UserInvitation';
        name: string;
        invitedEmail: string;
        inviter?: string | null;
        expirationTime: string;
        createTime: string;
        ttl?: string | null;
      }
    | null;
};

export type CreateWorkflowSecretMutationVariables = Exact<{
  workflowSecret: WorkflowV1WorkflowSecretInput;
  workflowSecretId: Scalars['String']['input'];
}>;

export type CreateWorkflowSecretMutation = {
  createWorkflowSecret?:
    | { name: string; updateTime: string }
    | Record<PropertyKey, never>
    | null;
};

export type CryptoKeyQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CryptoKeyQuery = {
  cryptoKey?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CryptoKey';
        name: string;
        state: IamV1CryptoKeyState;
        kind: IamV1CryptoKeyKind;
        publicKey?: string | null;
      }
    | null;
};

export type CryptoKeysQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CryptoKeysQuery = {
  cryptoKeys?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListCryptoKeysResponse';
        nextPageToken?: string | null;
        cryptoKeys: Array<{
          name: string;
          state: IamV1CryptoKeyState;
          kind: IamV1CryptoKeyKind;
          publicKey?: string | null;
        }>;
      }
    | null;
};

export type DataBricksConfigFragment = {
  host?: string | null;
  warehouseId?: string | null;
  clientId?: string | null;
  exposureSchema?: string | null;
  resultsSchema?: string | null;
};

export type DataWarehouseFragment = {
  __typename: 'MetricsV1DataWarehouse';
  name: string;
  isPrimary?: boolean | null;
  deleteTime?: string | null;
  config: {
    bigQueryConfig?: {
      gcpProjectId?: string | null;
      dataset?: string | null;
      serviceAccount?: string | null;
      processingProjectId?: string | null;
      interactiveProjectId?: string | null;
    } | null;
    dataBricksConfig?: {
      host?: string | null;
      warehouseId?: string | null;
      clientId?: string | null;
      exposureSchema?: string | null;
      resultsSchema?: string | null;
    } | null;
    redshiftConfig?: {
      cluster: string;
      database: string;
      exposureSchema?: string | null;
      region: MetricsV1AwsRegion;
      roleArn: string;
      webIdentitySettings?: {
        __typename: 'MetricsV1RedshiftConfigWebIdentityAuthenticationSettings';
      } | null;
      credentialsSettings?: { accessKeyId: string } | null;
    } | null;
    snowflakeConfig?: {
      account: string;
      user: string;
      role: string;
      warehouse: string;
      exposureDatabase: string;
      exposureSchema: string;
      authenticationKey:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'IamV1CryptoKey'; name: string };
    } | null;
  };
  limits?: {
    maxConcurrentInteractiveQueries?: any | null;
    maxConcurrentQueries?: any | null;
  } | null;
};

export type DeleteAgentIntegrationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteAgentIntegrationMutation = {
  deleteExternalIntegration?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type DeleteApiClientMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteApiClientMutation = {
  deleteApiClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DeleteClientCredentialMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteClientCredentialMutation = {
  deleteClientCredential?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteDataWarehouseMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteDataWarehouseMutation = {
  deleteDataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1DataWarehouse'; name: string }
    | null;
};

export type DeleteEntityRelationTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEntityRelationTableMutation = {
  deleteEntityRelationTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type DeleteEvaluationContextFieldOverrideMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEvaluationContextFieldOverrideMutation = {
  deleteEvaluationContextFieldOverride?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteEventConnectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEventConnectionMutation = {
  deleteEventConnection?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteFeedMutationVariables = Exact<{
  name: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteFeedMutation = {
  deleteFeed?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeleteFlagAppliedConnectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteFlagAppliedConnectionMutation = {
  deleteFlagAppliedConnection?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteGithubIntegrationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteGithubIntegrationMutation = {
  deleteExternalIntegration?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type DeleteOAuthAppMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteOAuthAppMutation = {
  deleteOAuthApp?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeletePolicyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeletePolicyMutation = {
  deletePolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteUserMutation = {
  deleteUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeleteUserInvitationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteUserInvitationMutation = {
  deleteUserInvitation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DeleteWorkflowSecretMutationVariables = Exact<{
  deleteWorkflowSecretName: Scalars['String']['input'];
}>;

export type DeleteWorkflowSecretMutation = {
  deleteWorkflowSecret?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DimensionTablesPageQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type DimensionTablesPageQuery = {
  dimensionTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDimensionTablesResponse';
        nextPageToken?: string | null;
        dimensionTables: Array<{
          name: string;
          displayName: string;
          state: MetricsV1TableState;
          entityColumnMapping: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  displayName: string;
                  name: string;
                };
          };
          error?: { message?: string | null; details: Array<string> } | null;
          dimensions: Array<{ name: string }>;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
        }>;
      }
    | null;
};

export type DisableSlackMutationVariables = Exact<{ [key: string]: never }>;

export type DisableSlackMutation = {
  disableSlack?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type EntityRelationTableEntityFragment = {
  name: string;
  displayName: string;
  primaryKeyType: MetricsV1ColumnType;
};

export type EntityRelationTableRowFragment = {
  name: string;
  state: MetricsV1TableState;
  targetEntity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
  targetEntityIdColumn: { name: string; type?: MetricsV1ColumnType | null };
  parentEntityIdColumn: { name: string; type?: MetricsV1ColumnType | null };
  error?: { details: Array<string>; message?: string | null } | null;
};

export type EvaluationContextFieldOverrideFragment = {
  __typename: 'FlagsAdminV1EvaluationContextFieldOverride';
  name: string;
  displayName?: string | null;
  field: string;
  hidden?: boolean | null;
  kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
  nonPii?: boolean | null;
  semanticType?: {
    enumType?: { values: Array<{ value?: string | null }> } | null;
    entityReference?: {
      entity:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
    } | null;
    country?: {
      format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
    } | null;
    timestamp?: { dummy?: string | null } | null;
    date?: { dummy?: string | null } | null;
    version?: { dummy?: string | null } | null;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type EvaluationContextFieldOverridesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type EvaluationContextFieldOverridesQuery = {
  evaluationContextFieldOverrides?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListEvaluationContextFieldOverridesResponse';
        nextPageToken?: string | null;
        evaluationContextFieldOverrides: Array<{
          __typename: 'FlagsAdminV1EvaluationContextFieldOverride';
          name: string;
          displayName?: string | null;
          field: string;
          hidden?: boolean | null;
          kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
          nonPii?: boolean | null;
          semanticType?: {
            enumType?: { values: Array<{ value?: string | null }> } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            country?: {
              format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            timestamp?: { dummy?: string | null } | null;
            date?: { dummy?: string | null } | null;
            version?: { dummy?: string | null } | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | null;
};

export type EventFragment = {
  __typename: 'ConnectorsV1Event';
  name: string;
  resources: Array<string>;
  eventType?:
    | {
        __typename: 'ConnectorsV1EventType';
        name: string;
        description?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  pubsubMetadata?: {
    messageId?: string | null;
    publishTime?: string | null;
    consumeTime?: string | null;
  } | null;
  cloudEvent?: {
    id?: string | null;
    type?: string | null;
    source?: string | null;
    protoData?: any | null;
  } | null;
};

export type EventConnectionFragment = {
  __typename: 'ConnectorsV1EventConnection';
  name: string;
  state?: ConnectorsV1State | null;
  createTime: string;
  bigQuery?: {
    tablePrefix?: string | null;
    bigQueryConfig: {
      dataset: string;
      project: string;
      serviceAccount: string;
    };
  } | null;
  databricks?: {
    databricksConfig: {
      schema: string;
      s3BucketConfig?: {
        roleArn: string;
        bucket: string;
        region: ConnectorsV1AwsRegion;
        webIdentitySettings?: {
          __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
        } | null;
        credentialsSettings?: { accessKeyId: string } | null;
      } | null;
      connectionConfig: { host: string; warehouseId: string; clientId: string };
      batchFileConfig: {
        maxEventsPerFile: any;
        maxFileAge: string;
        maxFileSize: any;
      };
    };
  } | null;
  redshift?: {
    tablePrefix?: string | null;
    redshiftConfig: {
      database: string;
      cluster: string;
      region: ConnectorsV1AwsRegion;
      roleArn: string;
      schema: string;
      webIdentitySettings?: {
        __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
      } | null;
      credentialsSettings?: { accessKeyId: string } | null;
    };
    batchFileConfig: {
      maxEventsPerFile: any;
      maxFileAge: string;
      maxFileSize: any;
    };
    s3Config: {
      roleArn: string;
      bucket: string;
      region: ConnectorsV1AwsRegion;
      webIdentitySettings?: {
        __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
      } | null;
      credentialsSettings?: { accessKeyId: string } | null;
    };
  } | null;
  snowflake?: {
    tablePrefix?: string | null;
    snowflakeConfig: {
      user: string;
      account: string;
      database: string;
      role: string;
      schema: string;
    };
  } | null;
  usageMetadata?: {
    errorRate?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    successRate?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    successRatio?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    lag?: { p95?: number | null } | null;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type EventConnectionQueryVariables = Exact<{
  eventConnectionName: Scalars['String']['input'];
}>;

export type EventConnectionQuery = {
  eventConnection?:
    | {
        __typename: 'ConnectorsV1EventConnection';
        name: string;
        state?: ConnectorsV1State | null;
        createTime: string;
        bigQuery?: {
          tablePrefix?: string | null;
          bigQueryConfig: {
            dataset: string;
            project: string;
            serviceAccount: string;
          };
        } | null;
        databricks?: {
          databricksConfig: {
            schema: string;
            s3BucketConfig?: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            } | null;
            connectionConfig: {
              host: string;
              warehouseId: string;
              clientId: string;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
          };
        } | null;
        redshift?: {
          tablePrefix?: string | null;
          redshiftConfig: {
            database: string;
            cluster: string;
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            schema: string;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
          batchFileConfig: {
            maxEventsPerFile: any;
            maxFileAge: string;
            maxFileSize: any;
          };
          s3Config: {
            roleArn: string;
            bucket: string;
            region: ConnectorsV1AwsRegion;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
        } | null;
        snowflake?: {
          tablePrefix?: string | null;
          snowflakeConfig: {
            user: string;
            account: string;
            database: string;
            role: string;
            schema: string;
          };
        } | null;
        usageMetadata?: {
          errorRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRatio?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          lag?: { p95?: number | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type EventConnectionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type EventConnectionsQuery = {
  eventConnections?:
    | {
        __typename: 'ConnectorsV1ListEventConnectionsResponse';
        nextPageToken?: string | null;
        eventConnections: Array<{
          __typename: 'ConnectorsV1EventConnection';
          name: string;
          state?: ConnectorsV1State | null;
          createTime: string;
          bigQuery?: {
            tablePrefix?: string | null;
            bigQueryConfig: {
              dataset: string;
              project: string;
              serviceAccount: string;
            };
          } | null;
          databricks?: {
            databricksConfig: {
              schema: string;
              s3BucketConfig?: {
                roleArn: string;
                bucket: string;
                region: ConnectorsV1AwsRegion;
                webIdentitySettings?: {
                  __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
                } | null;
                credentialsSettings?: { accessKeyId: string } | null;
              } | null;
              connectionConfig: {
                host: string;
                warehouseId: string;
                clientId: string;
              };
              batchFileConfig: {
                maxEventsPerFile: any;
                maxFileAge: string;
                maxFileSize: any;
              };
            };
          } | null;
          redshift?: {
            tablePrefix?: string | null;
            redshiftConfig: {
              database: string;
              cluster: string;
              region: ConnectorsV1AwsRegion;
              roleArn: string;
              schema: string;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
            s3Config: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            };
          } | null;
          snowflake?: {
            tablePrefix?: string | null;
            snowflakeConfig: {
              user: string;
              account: string;
              database: string;
              role: string;
              schema: string;
            };
          } | null;
          usageMetadata?: {
            errorRate?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            successRate?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            successRatio?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            lag?: { p95?: number | null } | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type EventTypeFragment = {
  __typename: 'ConnectorsV1EventType';
  name: string;
  description?: string | null;
};

export type ExistsDataWarehousesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ExistsDataWarehousesQuery = {
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
        demoData?: boolean | null;
      }
    | null;
};

export type ExistsSlackQueryVariables = Exact<{ [key: string]: never }>;

export type ExistsSlackQuery = {
  existsSlack?:
    | {
        __typename: 'ActivityV1SlackAdminConfig';
        state?: ActivityV1SlackAdminConfigState | null;
        teamId?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FactTablePageListQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FactTablePageListQuery = {
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        nextPageToken?: string | null;
        factTables: Array<{
          displayName: string;
          name: string;
          state: MetricsV1TableState;
          measures: Array<{ column: { name: string } }>;
          entities: Array<{
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          }>;
          error?: { details: Array<string>; message?: string | null } | null;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
        }>;
      }
    | null;
};

export type FeedFragment = {
  __typename: 'ActivityV1Feed';
  name: string;
  channels: Array<{
    disabled: boolean;
    priority?: ActivityV1ActivityPriority | null;
    email?: { address: string } | null;
    lastError?: { message: string; errorTime: string } | null;
    slack?: { channel?: string | null } | null;
    activityTypes: Array<
      { name: string; displayName: string } | Record<PropertyKey, never>
    >;
    webhook?: { uri: string; id?: string | null } | null;
  }>;
  feedSubscriptions?:
    | {
        __typename: 'ActivityV1ListFeedSubscriptionsResponse';
        feedSubscriptions: Array<{ resourceType?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FeedsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FeedsQuery = {
  feeds?:
    | {
        __typename: 'ActivityV1ListFeedsResponse';
        nextPageToken?: string | null;
        feeds: Array<{
          __typename: 'ActivityV1Feed';
          name: string;
          channels: Array<{
            disabled: boolean;
            priority?: ActivityV1ActivityPriority | null;
            email?: { address: string } | null;
            lastError?: { message: string; errorTime: string } | null;
            slack?: { channel?: string | null } | null;
            activityTypes: Array<
              { name: string; displayName: string } | Record<PropertyKey, never>
            >;
            webhook?: { uri: string; id?: string | null } | null;
          }>;
          feedSubscriptions?:
            | {
                __typename: 'ActivityV1ListFeedSubscriptionsResponse';
                feedSubscriptions: Array<{ resourceType?: string | null }>;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FlagAppliedConnectionFragment = {
  __typename: 'ConnectorsV1FlagAppliedConnection';
  name: string;
  state?: ConnectorsV1State | null;
  createTime: string;
  bigQuery?: {
    table: string;
    bigQueryConfig: {
      dataset: string;
      project: string;
      serviceAccount: string;
    };
  } | null;
  databricks?: {
    table: string;
    databricksConfig: {
      schema: string;
      s3BucketConfig?: {
        roleArn: string;
        bucket: string;
        region: ConnectorsV1AwsRegion;
        webIdentitySettings?: {
          __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
        } | null;
        credentialsSettings?: { accessKeyId: string } | null;
      } | null;
      connectionConfig: { host: string; warehouseId: string; clientId: string };
      batchFileConfig: {
        maxEventsPerFile: any;
        maxFileAge: string;
        maxFileSize: any;
      };
    };
  } | null;
  pubsub?: {
    pubsubConfig: {
      serviceAccount: string;
      project: string;
      topic: string;
      outputFormat: ConnectorsV1Format;
    };
  } | null;
  kinesis?: {
    kinesisConfig: {
      region: ConnectorsV1AwsRegion;
      roleArn: string;
      stream: string;
      outputFormat: ConnectorsV1Format;
    };
  } | null;
  redshift?: {
    table: string;
    redshiftConfig: {
      database: string;
      cluster: string;
      region: ConnectorsV1AwsRegion;
      roleArn: string;
      schema: string;
      webIdentitySettings?: {
        __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
      } | null;
      credentialsSettings?: { accessKeyId: string } | null;
    };
    batchFileConfig: {
      maxEventsPerFile: any;
      maxFileAge: string;
      maxFileSize: any;
    };
    s3Config: {
      roleArn: string;
      bucket: string;
      region: ConnectorsV1AwsRegion;
      webIdentitySettings?: {
        __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
      } | null;
      credentialsSettings?: { accessKeyId: string } | null;
    };
  } | null;
  snowflake?: {
    table: string;
    snowflakeConfig: {
      user: string;
      account: string;
      database: string;
      role: string;
      schema: string;
    };
  } | null;
  usageMetadata?: {
    errorRate?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    successRate?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    successRatio?: {
      rate1m?: number | null;
      rate5m?: number | null;
      rate15m?: number | null;
    } | null;
    lag?: { p95?: number | null } | null;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type FlagAppliedConnectionQueryVariables = Exact<{
  flagAppliedConnectionName: Scalars['String']['input'];
}>;

export type FlagAppliedConnectionQuery = {
  flagAppliedConnection?:
    | {
        __typename: 'ConnectorsV1FlagAppliedConnection';
        name: string;
        state?: ConnectorsV1State | null;
        createTime: string;
        bigQuery?: {
          table: string;
          bigQueryConfig: {
            dataset: string;
            project: string;
            serviceAccount: string;
          };
        } | null;
        databricks?: {
          table: string;
          databricksConfig: {
            schema: string;
            s3BucketConfig?: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            } | null;
            connectionConfig: {
              host: string;
              warehouseId: string;
              clientId: string;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
          };
        } | null;
        pubsub?: {
          pubsubConfig: {
            serviceAccount: string;
            project: string;
            topic: string;
            outputFormat: ConnectorsV1Format;
          };
        } | null;
        kinesis?: {
          kinesisConfig: {
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            stream: string;
            outputFormat: ConnectorsV1Format;
          };
        } | null;
        redshift?: {
          table: string;
          redshiftConfig: {
            database: string;
            cluster: string;
            region: ConnectorsV1AwsRegion;
            roleArn: string;
            schema: string;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
          batchFileConfig: {
            maxEventsPerFile: any;
            maxFileAge: string;
            maxFileSize: any;
          };
          s3Config: {
            roleArn: string;
            bucket: string;
            region: ConnectorsV1AwsRegion;
            webIdentitySettings?: {
              __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          };
        } | null;
        snowflake?: {
          table: string;
          snowflakeConfig: {
            user: string;
            account: string;
            database: string;
            role: string;
            schema: string;
          };
        } | null;
        usageMetadata?: {
          errorRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRate?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          successRatio?: {
            rate1m?: number | null;
            rate5m?: number | null;
            rate15m?: number | null;
          } | null;
          lag?: { p95?: number | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type FlagAppliedConnectionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FlagAppliedConnectionsQuery = {
  flagAppliedConnections?:
    | {
        __typename: 'ConnectorsV1ListFlagAppliedConnectionsResponse';
        nextPageToken?: string | null;
        flagAppliedConnections: Array<{
          __typename: 'ConnectorsV1FlagAppliedConnection';
          name: string;
          state?: ConnectorsV1State | null;
          createTime: string;
          bigQuery?: {
            table: string;
            bigQueryConfig: {
              dataset: string;
              project: string;
              serviceAccount: string;
            };
          } | null;
          databricks?: {
            table: string;
            databricksConfig: {
              schema: string;
              s3BucketConfig?: {
                roleArn: string;
                bucket: string;
                region: ConnectorsV1AwsRegion;
                webIdentitySettings?: {
                  __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
                } | null;
                credentialsSettings?: { accessKeyId: string } | null;
              } | null;
              connectionConfig: {
                host: string;
                warehouseId: string;
                clientId: string;
              };
              batchFileConfig: {
                maxEventsPerFile: any;
                maxFileAge: string;
                maxFileSize: any;
              };
            };
          } | null;
          pubsub?: {
            pubsubConfig: {
              serviceAccount: string;
              project: string;
              topic: string;
              outputFormat: ConnectorsV1Format;
            };
          } | null;
          kinesis?: {
            kinesisConfig: {
              region: ConnectorsV1AwsRegion;
              roleArn: string;
              stream: string;
              outputFormat: ConnectorsV1Format;
            };
          } | null;
          redshift?: {
            table: string;
            redshiftConfig: {
              database: string;
              cluster: string;
              region: ConnectorsV1AwsRegion;
              roleArn: string;
              schema: string;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            };
            batchFileConfig: {
              maxEventsPerFile: any;
              maxFileAge: string;
              maxFileSize: any;
            };
            s3Config: {
              roleArn: string;
              bucket: string;
              region: ConnectorsV1AwsRegion;
              webIdentitySettings?: {
                __typename: 'ConnectorsV1AwsWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            };
          } | null;
          snowflake?: {
            table: string;
            snowflakeConfig: {
              user: string;
              account: string;
              database: string;
              role: string;
              schema: string;
            };
          } | null;
          usageMetadata?: {
            errorRate?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            successRate?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            successRatio?: {
              rate1m?: number | null;
              rate5m?: number | null;
              rate15m?: number | null;
            } | null;
            lag?: { p95?: number | null } | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type GetClientSchemaMutationVariables = Exact<{
  clients: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetClientSchemaMutation = {
  deriveClientEvaluationContextSchema?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1DeriveClientEvaluationContextSchemaResponse';
        capped?: boolean | null;
        mergedSchema?: {
          schema: Array<{
            key: string;
            value?: {
              displayName?: string | null;
              hidden?: boolean | null;
              types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
              semanticType?: {
                enumType?: { values: Array<{ value?: string | null }> } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                country?: {
                  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                timestamp?: { dummy?: string | null } | null;
                date?: { dummy?: string | null } | null;
                version?: { dummy?: string | null } | null;
              } | null;
            } | null;
          }>;
        } | null;
      }
    | null;
};

export type GetCurrentAccountAutojoinQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentAccountAutojoinQuery = {
  currentAccount?:
    | {
        __typename: 'AdminV1AccountInfo';
        allowedLoginEmailDomains: Array<string>;
        authConnections: Array<{ autoJoin?: boolean | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type GetCurrentUserServiceAccountIdQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentUserServiceAccountIdQuery = {
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CurrentUser';
        serviceAccountOauth2ClientId: string;
        user?: { name: string } | null;
      }
    | null;
};

export type GetEntityRelationTableQueryVariables = Exact<{
  name: Scalars['String']['input'];
  parentEntityName: Scalars['String']['input'];
}>;

export type GetEntityRelationTableQuery = {
  entityRelationTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1EntityRelationTable';
        name: string;
        state: MetricsV1TableState;
        sql: string;
        parentEntityIdColumn: {
          name: string;
          type?: MetricsV1ColumnType | null;
        };
        targetEntityIdColumn: {
          name: string;
          type?: MetricsV1ColumnType | null;
        };
        targetEntity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
    | null;
};

export type GetFactTableQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetFactTableQuery = {
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        sql: string;
        state: MetricsV1TableState;
        factDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        entities: Array<{
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          column: { name: string };
        }>;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string };
          unit?: {
            baseUnitMultiplier?: number | null;
            baseUnit?: MetricsV1UnitBaseUnit | null;
            currencyCode?: string | null;
            customUnit?: string | null;
          } | null;
        }>;
        dimensions: Array<{ name: string }>;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                }>;
              } | null;
            };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type GetManagedWarehouseProvisioningQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetManagedWarehouseProvisioningQuery = {
  managedDataWarehouseProvisioning?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1ManagedDataWarehouseProvisioning';
        name: string;
        state: OnboardingV1ManagedDataWarehouseProvisioningState;
        error?: string | null;
      }
    | null;
};

export type GetPreviewSqlJobQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetPreviewSqlJobQuery = {
  sqlJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        name: string;
        successfulQueryResult?: {
          schema: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
        } | null;
        failedQueryResult?: { error?: string | null } | null;
        pendingQueryResult?: {
          __typename: 'MetricsV1PendingQueryResult';
        } | null;
      }
    | null;
};

export type GetWorkflowDetailsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetWorkflowDetailsQuery = {
  workflow?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Workflow';
        name: string;
        displayName: string;
        createTime: string;
        builtin?: boolean | null;
        currentVersion?:
          | {
              name: string;
              updater: { name: string } | Record<PropertyKey, never>;
            }
          | Record<PropertyKey, never>
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
      }
    | null;
};

export type GetWorkflowDevVersionsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetWorkflowDevVersionsQuery = {
  workflowVersions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowVersionsResponse';
        nextPageToken?: string | null;
        workflowVersions: Array<{
          name: string;
          updateTime: string;
          workflowConfig: {
            localDevConfig?: {
              displayName?: string | null;
              tunnelInfo?: { url: string } | null;
            } | null;
          };
        }>;
      }
    | null;
};

export type GetWorkflowInstancesQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetWorkflowInstancesQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          name: string;
          displayName: string;
          updateTime: string;
          createTime: string;
          state: string;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
            | null;
          workflowVersion?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowVersion'; name: string }
            | null;
        }>;
      }
    | null;
};

export type GetWorkflowVersionsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetWorkflowVersionsQuery = {
  workflow?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Workflow';
        name: string;
        createTime: string;
        builtin?: boolean | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
        currentVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowVersion'; name: string }
          | null;
      }
    | null;
  workflowVersions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowVersionsResponse';
        nextPageToken?: string | null;
        workflowVersions: Array<{
          name: string;
          createTime: string;
          workflowConfig: {
            localDevConfig?: {
              displayName?: string | null;
              tunnelInfo?: { url: string } | null;
            } | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type GroupMembersQueryVariables = Exact<{
  name: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GroupMembersQuery = {
  groupMembers?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListGroupMembersResponse';
        nextPageToken?: string | null;
        groupMembers: Array<{
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        }>;
      }
    | null;
};

export type HasAgentIntegrationQueryVariables = Exact<{
  integrationType: AiworkflowsV1ExternalIntegrationType;
  verify?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type HasAgentIntegrationQuery = {
  hasExternalIntegration?:
    | {
        __typename: 'AiworkflowsV1HasExternalIntegrationResponse';
        exists: boolean;
        integrationName?: string | null;
        working?: boolean | null;
        claudeAgentsConfig?: {
          agentId?: string | null;
          environmentId?: string | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type HasGithubIntegrationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type HasGithubIntegrationQuery = {
  hasExternalIntegration?:
    | {
        __typename: 'AiworkflowsV1HasExternalIntegrationResponse';
        exists: boolean;
        integrationName?: string | null;
        working?: boolean | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type InstantiateGithubInstallationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type InstantiateGithubInstallationMutation = {
  instantiateGithubInstallation?:
    | {
        __typename: 'AiworkflowsV1InstantiateGithubInstallationResponse';
        installationUrl?: string | null;
        state?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type InstantiateIntercomInstallationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type InstantiateIntercomInstallationMutation = {
  instantiateIntercomInstallation?:
    | {
        __typename: 'AiworkflowsV1InstantiateIntercomInstallationResponse';
        authorizationUrl?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ListDataWarehousesQueryVariables = Exact<{ [key: string]: never }>;

export type ListDataWarehousesQuery = {
  dataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDataWarehousesResponse';
        dataWarehouses: Array<{
          __typename: 'MetricsV1DataWarehouse';
          name: string;
          isPrimary?: boolean | null;
          deleteTime?: string | null;
          config: {
            bigQueryConfig?: {
              gcpProjectId?: string | null;
              dataset?: string | null;
              serviceAccount?: string | null;
              processingProjectId?: string | null;
              interactiveProjectId?: string | null;
            } | null;
            dataBricksConfig?: {
              host?: string | null;
              warehouseId?: string | null;
              clientId?: string | null;
              exposureSchema?: string | null;
              resultsSchema?: string | null;
            } | null;
            redshiftConfig?: {
              cluster: string;
              database: string;
              exposureSchema?: string | null;
              region: MetricsV1AwsRegion;
              roleArn: string;
              webIdentitySettings?: {
                __typename: 'MetricsV1RedshiftConfigWebIdentityAuthenticationSettings';
              } | null;
              credentialsSettings?: { accessKeyId: string } | null;
            } | null;
            snowflakeConfig?: {
              account: string;
              user: string;
              role: string;
              warehouse: string;
              exposureDatabase: string;
              exposureSchema: string;
              authenticationKey:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'IamV1CryptoKey'; name: string };
            } | null;
          };
          limits?: {
            maxConcurrentInteractiveQueries?: any | null;
            maxConcurrentQueries?: any | null;
          } | null;
        }>;
      }
    | null;
};

export type ListEntityRelationTablesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEntityRelationTablesQuery = {
  entityRelationTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntityRelationTablesResponse';
        nextPageToken?: string | null;
        entityRelationTables: Array<{
          name: string;
          state: MetricsV1TableState;
          targetEntity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          targetEntityIdColumn: {
            name: string;
            type?: MetricsV1ColumnType | null;
          };
          parentEntityIdColumn: {
            name: string;
            type?: MetricsV1ColumnType | null;
          };
          error?: { details: Array<string>; message?: string | null } | null;
        }>;
      }
    | null;
};

export type ListEventsQueryVariables = Exact<{
  resource?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEventsQuery = {
  events?:
    | {
        __typename: 'ConnectorsV1ListEventsResponse';
        nextPageToken?: string | null;
        events: Array<{
          __typename: 'ConnectorsV1Event';
          name: string;
          resources: Array<string>;
          eventType?:
            | {
                __typename: 'ConnectorsV1EventType';
                name: string;
                description?: string | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
          pubsubMetadata?: {
            messageId?: string | null;
            publishTime?: string | null;
            consumeTime?: string | null;
          } | null;
          cloudEvent?: {
            id?: string | null;
            type?: string | null;
            source?: string | null;
            protoData?: any | null;
          } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ListRepositoriesQueryVariables = Exact<{ [key: string]: never }>;

export type ListRepositoriesQuery = {
  repositories?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RepositoriesV1ListRepositoriesResponse';
        repositories: Array<{
          name: string;
          host?: string | null;
          htmlUrl?: string | null;
        }>;
      }
    | null;
};

export type ListUsersQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListUsersQuery = {
  users?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListUsersResponse';
        nextPageToken?: string | null;
        users: Array<{
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          lastLoginTime?: string | null;
        }>;
      }
    | null;
};

export type ListWorkflowsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListWorkflowsQuery = {
  workflows?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowsResponse';
        nextPageToken?: string | null;
        workflows: Array<{
          displayName: string;
          name: string;
          updateTime: string;
          currentVersion?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowVersion';
                name: string;
                updateTime: string;
              }
            | null;
        }>;
      }
    | null;
};

export type MetricsUsingFactTableQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricsUsingFactTableQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          name: string;
          displayName: string;
          createTime: string;
          entity?:
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | Record<PropertyKey, never>
            | null;
          owner?:
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | Record<PropertyKey, never>
            | null;
          typeSpec?: {
            averageMetricSpec?: {
              aggregation: { type: MetricsV1AggregationType };
            } | null;
            ratioMetricSpec?: {
              numeratorAggregation: { type: MetricsV1AggregationType };
            } | null;
            quantileMetricSpec?: {
              quantileLevel: number;
              aggregation: { type: MetricsV1AggregationType };
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
};

export type OAuthAppFragment = {
  __typename: 'IamV1OAuthApp';
  name: string;
  displayName: string;
  description?: string | null;
  clientId: string;
  clientSecret: string;
  allowedCallbackUrls: Array<string>;
  allowedWebOrigins: Array<string>;
  allowedLogoutUrls: Array<string>;
  logoUri?: string | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type OAuthAppQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type OAuthAppQuery = {
  oAuthApp?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1OAuthApp';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret: string;
        allowedCallbackUrls: Array<string>;
        allowedWebOrigins: Array<string>;
        allowedLogoutUrls: Array<string>;
        logoUri?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type OAuthAppsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type OAuthAppsQuery = {
  oAuthApps?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListOAuthAppsResponse';
        nextPageToken?: string | null;
        oauthApps: Array<{ name: string; displayName: string }>;
      }
    | null;
};

export type PermissionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PermissionsQuery = {
  permissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListPermissionsResponse';
        nextPageToken?: string | null;
        permissions: Array<{
          category: IamV1PermissionCategory;
          description?: string | null;
          type: IamV1PermissionType;
        }>;
      }
    | null;
};

export type PlatformConnectionFragment = {
  name: string;
  state?: ConnectorsV1State | null;
  createTime: string;
  eventType:
    | { name: string; description?: string | null }
    | Record<PropertyKey, never>;
  pubsub?: {
    pubsubConfig: {
      serviceAccount: string;
      project: string;
      topic: string;
      outputFormat: ConnectorsV1Format;
    };
  } | null;
  kinesis?: {
    kinesisConfig: {
      region: ConnectorsV1AwsRegion;
      roleArn: string;
      stream: string;
      outputFormat: ConnectorsV1Format;
    };
  } | null;
};

export type PoliciesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PoliciesQuery = {
  policies?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListPoliciesResponse';
        nextPageToken?: string | null;
        policies: Array<{
          __typename: 'IamV1Policy';
          name: string;
          createTime: string;
          updateTime: string;
          roles: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Role';
                name: string;
                displayName: string;
                builtin?: boolean | null;
                permissions: Array<{
                  category: IamV1PermissionCategory;
                  description?: string | null;
                  type: IamV1PermissionType;
                }>;
              }
          >;
          identities: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type PolicyFragment = {
  __typename: 'IamV1Policy';
  name: string;
  createTime: string;
  updateTime: string;
  roles: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Role';
        name: string;
        displayName: string;
        builtin?: boolean | null;
        permissions: Array<{
          category: IamV1PermissionCategory;
          description?: string | null;
          type: IamV1PermissionType;
        }>;
      }
  >;
  identities: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
  >;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type PromotePrimaryDataWarehouseMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type PromotePrimaryDataWarehouseMutation = {
  promotePrimaryDataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
      }
    | null;
};

export type RedshiftConfigFragment = {
  cluster: string;
  database: string;
  exposureSchema?: string | null;
  region: MetricsV1AwsRegion;
  roleArn: string;
  webIdentitySettings?: {
    __typename: 'MetricsV1RedshiftConfigWebIdentityAuthenticationSettings';
  } | null;
  credentialsSettings?: { accessKeyId: string } | null;
};

export type RemoveDemoDataMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveDemoDataMutation = {
  removeDemoData?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type RemoveGroupMembersMutationVariables = Exact<{
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type RemoveGroupMembersMutation = {
  removeGroupMembers?:
    | { dummy?: string | null }
    | Record<PropertyKey, never>
    | null;
};

export type RoleIndexPageRoleFragment = {
  __typename: 'IamV1Role';
  builtin?: boolean | null;
  name: string;
  displayName: string;
  permissions: Array<{
    category: IamV1PermissionCategory;
    description?: string | null;
    type: IamV1PermissionType;
  }>;
};

export type SemanticTypeFragment = {
  enumType?: { values: Array<{ value?: string | null }> } | null;
  entityReference?: {
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
  } | null;
  country?: {
    format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
  } | null;
  timestamp?: { dummy?: string | null } | null;
  date?: { dummy?: string | null } | null;
  version?: { dummy?: string | null } | null;
};

export type SnowflakeConfigFragment = {
  account: string;
  user: string;
  role: string;
  warehouse: string;
  exposureDatabase: string;
  exposureSchema: string;
  authenticationKey:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1CryptoKey'; name: string };
};

export type SqlJobFragment = {
  __typename: 'MetricsV1SqlJob';
  name: string;
  successfulQueryResult?: {
    schema: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
  } | null;
  failedQueryResult?: { error?: string | null } | null;
  pendingQueryResult?: { __typename: 'MetricsV1PendingQueryResult' } | null;
};

export type SuggestFactTableColumnsMutationVariables = Exact<{
  schema: Array<MetricsV1ColumnInput> | MetricsV1ColumnInput;
}>;

export type SuggestFactTableColumnsMutation = {
  suggestFactTableColumns?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SuggestFactTableColumnsResponse';
        error?: string | null;
        suggestion?: {
          dimensions: Array<string>;
          measures: Array<string>;
          timestampColumn: string;
          entities: Array<{
            column: string;
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          }>;
        } | null;
      }
    | null;
};

export type TestWebhookMutationVariables = Exact<{
  account: Scalars['String']['input'];
  uri: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;

export type TestWebhookMutation = {
  testWebhook?:
    | {
        __typename: 'ActivityV1TestWebhookResponse';
        success?: boolean | null;
        statusCode?: number | null;
        responseDuration?: string | null;
        errorMessage?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateActivityFeedMutationVariables = Exact<{
  feed: PartialActivityV1FeedInput;
}>;

export type UpdateActivityFeedMutation = {
  updateFeed?:
    | {
        __typename: 'ActivityV1Feed';
        name: string;
        channels: Array<{
          disabled: boolean;
          priority?: ActivityV1ActivityPriority | null;
          email?: { address: string } | null;
          lastError?: { message: string; errorTime: string } | null;
          slack?: { channel?: string | null } | null;
          activityTypes: Array<
            { name: string; displayName: string } | Record<PropertyKey, never>
          >;
          webhook?: { uri: string; id?: string | null } | null;
        }>;
        feedSubscriptions?:
          | {
              __typename: 'ActivityV1ListFeedSubscriptionsResponse';
              feedSubscriptions: Array<{ resourceType?: string | null }>;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateApiClientMutationVariables = Exact<{
  apiClient: PartialIamV1ApiClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateApiClientMutation = {
  updateApiClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ApiClient';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateClientCredentialMutationVariables = Exact<{
  input: PartialIamV1ClientCredentialInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateClientCredentialMutation = {
  updateClientCredential?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ClientCredential';
        name: string;
        displayName: string;
        sdkType?: IamV1ClientCredentialSdkType | null;
        lastSeenTime?: string | null;
        createTime: string;
        hasEncryptionKey?: boolean | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
        clientSecret?: { secret?: string | null } | null;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateDataWarehouseMutationVariables = Exact<{
  dataWarehouse: PartialMetricsV1DataWarehouseInput;
}>;

export type UpdateDataWarehouseMutation = {
  updateDataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
        deleteTime?: string | null;
        config: {
          bigQueryConfig?: {
            gcpProjectId?: string | null;
            dataset?: string | null;
            serviceAccount?: string | null;
            processingProjectId?: string | null;
            interactiveProjectId?: string | null;
          } | null;
          dataBricksConfig?: {
            host?: string | null;
            warehouseId?: string | null;
            clientId?: string | null;
            exposureSchema?: string | null;
            resultsSchema?: string | null;
          } | null;
          redshiftConfig?: {
            cluster: string;
            database: string;
            exposureSchema?: string | null;
            region: MetricsV1AwsRegion;
            roleArn: string;
            webIdentitySettings?: {
              __typename: 'MetricsV1RedshiftConfigWebIdentityAuthenticationSettings';
            } | null;
            credentialsSettings?: { accessKeyId: string } | null;
          } | null;
          snowflakeConfig?: {
            account: string;
            user: string;
            role: string;
            warehouse: string;
            exposureDatabase: string;
            exposureSchema: string;
            authenticationKey:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'IamV1CryptoKey'; name: string };
          } | null;
        };
        limits?: {
          maxConcurrentInteractiveQueries?: any | null;
          maxConcurrentQueries?: any | null;
        } | null;
      }
    | null;
};

export type UpdateEvaluationContextFieldOverrideMutationVariables = Exact<{
  evaluationContextFieldOverride: PartialFlagsAdminV1EvaluationContextFieldOverrideInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateEvaluationContextFieldOverrideMutation = {
  updateEvaluationContextFieldOverride?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1EvaluationContextFieldOverride';
        name: string;
        displayName?: string | null;
        field: string;
        hidden?: boolean | null;
        kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
        nonPii?: boolean | null;
        semanticType?: {
          enumType?: { values: Array<{ value?: string | null }> } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          country?: {
            format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          timestamp?: { dummy?: string | null } | null;
          date?: { dummy?: string | null } | null;
          version?: { dummy?: string | null } | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateOAuthAppMutationVariables = Exact<{
  oauthApp: PartialIamV1OAuthAppInput;
}>;

export type UpdateOAuthAppMutation = {
  updateOAuthApp?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1OAuthApp';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret: string;
        allowedCallbackUrls: Array<string>;
        allowedWebOrigins: Array<string>;
        allowedLogoutUrls: Array<string>;
        logoUri?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdatePolicyMutationVariables = Exact<{
  policy: PartialIamV1PolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePolicyMutation = {
  updatePolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Policy';
        name: string;
        createTime: string;
        updateTime: string;
        roles: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Role';
              name: string;
              displayName: string;
              builtin?: boolean | null;
              permissions: Array<{
                category: IamV1PermissionCategory;
                description?: string | null;
                type: IamV1PermissionType;
              }>;
            }
        >;
        identities: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateWorkflowSecretMutationVariables = Exact<{
  workflowSecret: PartialWorkflowV1WorkflowSecretInput;
}>;

export type UpdateWorkflowSecretMutation = {
  updateWorkflowSecret?:
    | { name: string; updateTime: string }
    | Record<PropertyKey, never>
    | null;
};

export type UpdateWorkflowVersionMutationVariables = Exact<{
  version: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;

export type UpdateWorkflowVersionMutation = {
  updateWorkflow?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1Workflow'; name: string }
    | null;
};

export type UsageMetadataFragment = {
  errorRate?: {
    rate1m?: number | null;
    rate5m?: number | null;
    rate15m?: number | null;
  } | null;
  successRate?: {
    rate1m?: number | null;
    rate5m?: number | null;
    rate15m?: number | null;
  } | null;
  successRatio?: {
    rate1m?: number | null;
    rate5m?: number | null;
    rate15m?: number | null;
  } | null;
  lag?: { p95?: number | null } | null;
};

export type UserDetailsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UserDetailsQuery = {
  user?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        email: string;
        fullName: string;
        name: string;
        pictureUri?: string | null;
        lastLoginTime?: string | null;
      }
    | null;
};

export type UserInvitationFragment = {
  __typename: 'IamV1UserInvitation';
  name: string;
  invitedEmail: string;
  inviter?: string | null;
  expirationTime: string;
  createTime: string;
  ttl?: string | null;
};

export type UserInvitationsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type UserInvitationsQuery = {
  userInvitations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListUserInvitationsResponse';
        nextPageToken?: string | null;
        userInvitations: Array<{
          __typename: 'IamV1UserInvitation';
          name: string;
          invitedEmail: string;
          inviter?: string | null;
          expirationTime: string;
          createTime: string;
          ttl?: string | null;
        }>;
      }
    | null;
};

export type ValidateBigQueryDataWarehouseConfigMutationVariables = Exact<{
  bigQueryConfig?: InputMaybe<MetricsV1BigQueryConfigInput>;
}>;

export type ValidateBigQueryDataWarehouseConfigMutation = {
  validateDataWarehouseConfig?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ValidateDataWarehouseConfigResponse';
        successful?: boolean | null;
        validation: Array<{
          description?: string | null;
          error?: string | null;
          key?: string | null;
          success?: boolean | null;
        }>;
      }
    | null;
};

export type ValidateBigQueryEventConnectionConfigMutationVariables = Exact<{
  bigQuery?: InputMaybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput>;
}>;

export type ValidateBigQueryEventConnectionConfigMutation = {
  validateEventConnectionConfig?:
    | { bigQueryConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateBigQueryFlagAppliedConnectionConfigMutationVariables =
  Exact<{
    bigQuery?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput>;
  }>;

export type ValidateBigQueryFlagAppliedConnectionConfigMutation = {
  validateFlagAppliedConnectionConfig?:
    | { bigQueryConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateDataWarehouseConfigMutationVariables = Exact<{
  existingWarehouse?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<MetricsV1RedshiftConfigInput>;
}>;

export type ValidateDataWarehouseConfigMutation = {
  validateDataWarehouseConfig?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ValidateDataWarehouseConfigResponse';
        redshiftConfigValidation?: { availableSchemas: Array<string> } | null;
      }
    | null;
};

export type ValidateDatabricksEventConnectionConfigMutationVariables = Exact<{
  databricks?: InputMaybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput>;
}>;

export type ValidateDatabricksEventConnectionConfigMutation = {
  validateEventConnectionConfig?:
    | { databricksConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateDatabricksFlagAppliedConnectionConfigMutationVariables =
  Exact<{
    databricks?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput>;
  }>;

export type ValidateDatabricksFlagAppliedConnectionConfigMutation = {
  validateFlagAppliedConnectionConfig?:
    | { databricksConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidatePubsubFlagAppliedConnectionConfigMutationVariables = Exact<{
  pubsub?: InputMaybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput>;
}>;

export type ValidatePubsubFlagAppliedConnectionConfigMutation = {
  validateFlagAppliedConnectionConfig?:
    | { pubsubConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateRedshiftEventConnectionConfigMutationVariables = Exact<{
  redshift?: InputMaybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput>;
}>;

export type ValidateRedshiftEventConnectionConfigMutation = {
  validateEventConnectionConfig?:
    | { redshiftConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateRedshiftFlagAppliedConnectionConfigMutationVariables =
  Exact<{
    redshift?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput>;
  }>;

export type ValidateRedshiftFlagAppliedConnectionConfigMutation = {
  validateFlagAppliedConnectionConfig?:
    | { redshiftConfigValidation?: { dummy?: string | null } | null }
    | Record<PropertyKey, never>
    | null;
};

export type ValidateSnowflakeDataWarehouseConfigMutationVariables = Exact<{
  snowflakeConfig?: InputMaybe<MetricsV1ValidateSnowflakeConfigInput>;
}>;

export type ValidateSnowflakeDataWarehouseConfigMutation = {
  validateDataWarehouseConfig?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ValidateDataWarehouseConfigResponse';
        snowflakeConfigValidation?: {
          databases: Array<string>;
          roles: Array<string>;
          warehouses: Array<string>;
          schemas: Array<string>;
        } | null;
      }
    | null;
};

export type ValidateSnowflakeEventConnectionConfigMutationVariables = Exact<{
  snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
}>;

export type ValidateSnowflakeEventConnectionConfigMutation = {
  validateEventConnectionConfig?:
    | {
        __typename: 'ConnectorsV1ValidateEventConnectionConfigResponse';
        snowflakeConfigValidation?: {
          databases: Array<string>;
          roles: Array<string>;
          schemas: Array<string>;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ValidateSnowflakeFlagAppliedConnectionConfigMutationVariables =
  Exact<{
    snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
  }>;

export type ValidateSnowflakeFlagAppliedConnectionConfigMutation = {
  validateFlagAppliedConnectionConfig?:
    | {
        __typename: 'ConnectorsV1ValidateFlagAppliedConnectionConfigResponse';
        snowflakeConfigValidation?: {
          databases: Array<string>;
          roles: Array<string>;
          schemas: Array<string>;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type WarehouseLimitsFragment = {
  maxConcurrentInteractiveQueries?: any | null;
  maxConcurrentQueries?: any | null;
};

export type WarehouseStatsQueryVariables = Exact<{
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;

export type WarehouseStatsQuery = {
  queryDataWarehouseStats?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1QueryDataWarehouseStatsResponse';
        stats: Array<{
          entryTime: string;
          failedQueryCount: any;
          totalQueryCount: any;
          bqStats?: {
            totalSlotMs: any;
            totalBytesBilled: any;
            totalBytesProcessed: any;
          } | null;
        }>;
      }
    | null;
};

export type WorkflowInstanceQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type WorkflowInstanceQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        displayName: string;
        state: string;
        createTime: string;
        updateTime: string;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowVersion'; name: string }
          | null;
      }
    | null;
};

export type WorkflowLogsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type WorkflowLogsQuery = {
  workflowLogs?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowLogsResponse';
        nextPageToken?: string | null;
        workflowLogs: Array<{
          logTime: string;
          level: WorkflowV1WorkflowLogLogLevel;
          message: string;
          name: string;
        }>;
      }
    | null;
};

export type WorkflowSecretsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type WorkflowSecretsQuery = {
  workflowSecrets?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowSecretsResponse';
        nextPageToken?: string | null;
        workflowSecrets: Array<{ name: string; updateTime: string }>;
      }
    | null;
};

export type CreateLabelMutationVariables = Exact<{
  input: AdminLabelsV1LabelInput;
  labelId: Scalars['String']['input'];
}>;

export type CreateLabelMutation = {
  createLabel?:
    | {
        __typename: 'AdminLabelsV1Label';
        name: string;
        displayName?: string | null;
        description?: string | null;
        resourceTypes: Array<AdminLabelsV1LabelResourceType>;
        allowedValues: Array<string>;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteLabelMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteLabelMutation = {
  deleteLabel?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type UpdateLabelMutationVariables = Exact<{
  label: PartialAdminLabelsV1LabelInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateLabelMutation = {
  updateLabel?:
    | {
        __typename: 'AdminLabelsV1Label';
        name: string;
        displayName?: string | null;
        description?: string | null;
        resourceTypes: Array<AdminLabelsV1LabelResourceType>;
        allowedValues: Array<string>;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AccountTokenUsageQueryVariables = Exact<{ [key: string]: never }>;

export type AccountTokenUsageQuery = {
  accountTokenUsage?:
    | {
        __typename: 'AiworkflowsV1AccountTokenUsage';
        sessionCount?: number | null;
        usage?: {
          inputTokens?: any | null;
          outputTokens?: any | null;
          cacheCreationInputTokens?: any | null;
          cacheReadInputTokens?: any | null;
          totalInputTokens?: any | null;
          totalTokens?: any | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ArchiveManagedWorkspaceMutationVariables = Exact<{
  account: Scalars['String']['input'];
}>;

export type ArchiveManagedWorkspaceMutation = {
  archiveManagedWorkspace?:
    | {
        __typename: 'AiworkflowsV1ArchiveManagedWorkspaceResponse';
        archivedWorkspaceId?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ManagedAgentSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedAgentSettingsQuery = {
  managedAgentSettings?:
    | {
        __typename: 'AiworkflowsV1ManagedAgentSettings';
        enabled?: boolean | null;
        available?: boolean | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ManagedCodingSessionFragment = {
  chatName?: string | null;
  sessionId?: string | null;
  repository?: string | null;
  branch?: string | null;
  provider?: string | null;
  status?: string | null;
  prompt?: string | null;
  prUrl?: string | null;
  startedAt?: string | null;
  updatedAt?: string | null;
  usage?: {
    inputTokens?: any | null;
    outputTokens?: any | null;
    cacheCreationInputTokens?: any | null;
    cacheReadInputTokens?: any | null;
    totalInputTokens?: any | null;
    totalTokens?: any | null;
  } | null;
};

export type ManagedSessionsQueryVariables = Exact<{ [key: string]: never }>;

export type ManagedSessionsQuery = {
  managedSessions?:
    | {
        __typename: 'AiworkflowsV1ListManagedSessionsResponse';
        sessions: Array<{
          chatName?: string | null;
          sessionId?: string | null;
          repository?: string | null;
          branch?: string | null;
          provider?: string | null;
          status?: string | null;
          prompt?: string | null;
          prUrl?: string | null;
          startedAt?: string | null;
          updatedAt?: string | null;
          usage?: {
            inputTokens?: any | null;
            outputTokens?: any | null;
            cacheCreationInputTokens?: any | null;
            cacheReadInputTokens?: any | null;
            totalInputTokens?: any | null;
            totalTokens?: any | null;
          } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ManagedTokenUsageFragment = {
  inputTokens?: any | null;
  outputTokens?: any | null;
  cacheCreationInputTokens?: any | null;
  cacheReadInputTokens?: any | null;
  totalInputTokens?: any | null;
  totalTokens?: any | null;
};

export type RegisterManagedWorkspaceMutationVariables = Exact<{
  account: Scalars['String']['input'];
}>;

export type RegisterManagedWorkspaceMutation = {
  registerManagedWorkspace?:
    | {
        __typename: 'AiworkflowsV1ManagedWorkspace';
        workspaceId?: string | null;
        serviceAccountId?: string | null;
        federationRuleId?: string | null;
        agentId?: string | null;
        environmentId?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AttachmentFragment = {
  __typename: 'CollaborationV1Attachment';
  name: string;
  displayName?: string | null;
  uri: string;
  resource: string;
  createTime: string;
  labels: Array<{ key: string; value?: string | null }>;
};

export type AttachmentCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type AttachmentCreatedSubscription = {
  attachmentCreated?: {
    attachment?: {
      __typename: 'CollaborationV1Attachment';
      name: string;
      displayName?: string | null;
      uri: string;
      resource: string;
      createTime: string;
      labels: Array<{ key: string; value?: string | null }>;
    } | null;
  } | null;
};

export type AttachmentsFragment = {
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
};

export type AttachmentsQueryVariables = Exact<{
  resource: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type AttachmentsQuery = {
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateAttachmentMutationVariables = Exact<{
  attachment: CollaborationV1AttachmentInput;
}>;

export type CreateAttachmentMutation = {
  createAttachment?:
    | {
        __typename: 'CollaborationV1Attachment';
        name: string;
        displayName?: string | null;
        uri: string;
        resource: string;
        createTime: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteAttachmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteAttachmentMutation = {
  deleteAttachment?:
    | {
        __typename: 'CollaborationV1Attachment';
        name: string;
        displayName?: string | null;
        uri: string;
        resource: string;
        createTime: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateAttachmentMutationVariables = Exact<{
  input: PartialCollaborationV1AttachmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAttachmentMutation = {
  updateAttachment?:
    | {
        __typename: 'CollaborationV1Attachment';
        name: string;
        displayName?: string | null;
        uri: string;
        resource: string;
        createTime: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AssistantOutcomeFragment = {
  outcome?: {
    __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
    response?: string | null;
  } | null;
  toolConfirmation?: {
    __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
    tool: string;
    input?: any | null;
  } | null;
  askQuestion?: {
    __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
    question: string;
    alternatives: Array<string>;
  } | null;
  error?: {
    __typename: 'ConversationsV2ChatAssistantOutcomeError';
    details: string;
  } | null;
};

export type ChatFragment = {
  __typename: 'ConversationsV2Chat';
  name: string;
  displayName?: string | null;
  state?: ConversationsV2ChatState | null;
  createTime: string;
  updateTime: string;
  source?: ConversationsV2ChatSource | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  project?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  assistantOutcome?: {
    outcome?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
      response?: string | null;
    } | null;
    toolConfirmation?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
      tool: string;
      input?: any | null;
    } | null;
    askQuestion?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
      question: string;
      alternatives: Array<string>;
    } | null;
    error?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeError';
      details: string;
    } | null;
  } | null;
  summary?: { title?: string | null } | null;
};

export type ChatQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ChatQuery = {
  chat?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        displayName?: string | null;
        state?: ConversationsV2ChatState | null;
        createTime: string;
        updateTime: string;
        source?: ConversationsV2ChatSource | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        assistantOutcome?: {
          outcome?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
            response?: string | null;
          } | null;
          toolConfirmation?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
            tool: string;
            input?: any | null;
          } | null;
          askQuestion?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
            question: string;
            alternatives: Array<string>;
          } | null;
          error?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeError';
            details: string;
          } | null;
        } | null;
        summary?: { title?: string | null } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ChatEventFragment = {
  __typename: 'ConversationsV2ChatEvent';
  name: string;
  createTime: string;
  updateTime: string;
  userMessage?: {
    __typename: 'ConversationsV2UserMessage';
    content?: string | null;
    parts: Array<{
      text?: string | null;
      resource?: string | null;
      imageUri?: string | null;
    }>;
  } | null;
  assistantMessage?: {
    __typename: 'ConversationsV2AssistantMessage';
    content: string;
    phase?: ConversationsV2AssistantMessagePhase | null;
  } | null;
  thinking?: { __typename: 'ConversationsV2Thinking'; content: string } | null;
  toolCall?: {
    __typename: 'ConversationsV2ToolCall';
    tool: string;
    input?: any | null;
    displayName?: string | null;
  } | null;
  toolResult?: {
    __typename: 'ConversationsV2ToolResult';
    content: string;
    success: boolean;
    toolCallEvent?:
      | { __typename: 'ConversationsV2ChatEvent'; name: string }
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | null;
  } | null;
  toolConfirmationRequest?: {
    __typename: 'ConversationsV2ToolConfirmationRequest';
    tool: string;
    input?: any | null;
    displayName?: string | null;
  } | null;
  toolConfirmationResponse?: {
    __typename: 'ConversationsV2ToolConfirmationResponse';
    decision: ConversationsV2ToolConfirmationResponseDecision;
    toolRequestEvent:
      | {
          __typename: 'ConversationsV2ChatEvent';
          name: string;
          toolConfirmationRequest?: {
            __typename: 'ConversationsV2ToolConfirmationRequest';
            tool: string;
            input?: any | null;
            displayName?: string | null;
          } | null;
        }
      | { __typename: 'Error'; message?: string | null; code: ErrorCode };
  } | null;
  userInterrupt?: { __typename: 'ConversationsV2UserInterrupt' } | null;
  notification?: {
    __typename: 'ConversationsV2Notification';
    childChatStopped?: {
      __typename: 'ConversationsV2ChildChatStopped';
      success: boolean;
      summary?: string | null;
      childChat:
        | {
            __typename: 'ConversationsV2Chat';
            name: string;
            displayName?: string | null;
            state?: ConversationsV2ChatState | null;
            createTime: string;
            updateTime: string;
            source?: ConversationsV2ChatSource | null;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
            project?:
              | {
                  __typename: 'CollaborationV1Project';
                  name: string;
                  displayName: string;
                  updateTime: string;
                  deleteTime?: string | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
            assistantOutcome?: {
              outcome?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                response?: string | null;
              } | null;
              toolConfirmation?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                tool: string;
                input?: any | null;
              } | null;
              askQuestion?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                question: string;
                alternatives: Array<string>;
              } | null;
              error?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeError';
                details: string;
              } | null;
            } | null;
            summary?: { title?: string | null } | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode };
    } | null;
  } | null;
  error?: {
    __typename: 'ConversationsV2Error';
    message: string;
    code?: string | null;
  } | null;
};

export type ChatEventAssistantMessageFragment = {
  __typename: 'ConversationsV2AssistantMessage';
  content: string;
  phase?: ConversationsV2AssistantMessagePhase | null;
};

export type ChatEventCreatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChatEventCreatedSubscription = {
  chatEventCreated?: {
    chatEvent?: {
      __typename: 'ConversationsV2ChatEvent';
      name: string;
      createTime: string;
      updateTime: string;
      userMessage?: {
        __typename: 'ConversationsV2UserMessage';
        content?: string | null;
        parts: Array<{
          text?: string | null;
          resource?: string | null;
          imageUri?: string | null;
        }>;
      } | null;
      assistantMessage?: {
        __typename: 'ConversationsV2AssistantMessage';
        content: string;
        phase?: ConversationsV2AssistantMessagePhase | null;
      } | null;
      thinking?: {
        __typename: 'ConversationsV2Thinking';
        content: string;
      } | null;
      toolCall?: {
        __typename: 'ConversationsV2ToolCall';
        tool: string;
        input?: any | null;
        displayName?: string | null;
      } | null;
      toolResult?: {
        __typename: 'ConversationsV2ToolResult';
        content: string;
        success: boolean;
        toolCallEvent?:
          | { __typename: 'ConversationsV2ChatEvent'; name: string }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      } | null;
      toolConfirmationRequest?: {
        __typename: 'ConversationsV2ToolConfirmationRequest';
        tool: string;
        input?: any | null;
        displayName?: string | null;
      } | null;
      toolConfirmationResponse?: {
        __typename: 'ConversationsV2ToolConfirmationResponse';
        decision: ConversationsV2ToolConfirmationResponseDecision;
        toolRequestEvent:
          | {
              __typename: 'ConversationsV2ChatEvent';
              name: string;
              toolConfirmationRequest?: {
                __typename: 'ConversationsV2ToolConfirmationRequest';
                tool: string;
                input?: any | null;
                displayName?: string | null;
              } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode };
      } | null;
      userInterrupt?: { __typename: 'ConversationsV2UserInterrupt' } | null;
      notification?: {
        __typename: 'ConversationsV2Notification';
        childChatStopped?: {
          __typename: 'ConversationsV2ChildChatStopped';
          success: boolean;
          summary?: string | null;
          childChat:
            | {
                __typename: 'ConversationsV2Chat';
                name: string;
                displayName?: string | null;
                state?: ConversationsV2ChatState | null;
                createTime: string;
                updateTime: string;
                source?: ConversationsV2ChatSource | null;
                creator:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    };
                project?:
                  | {
                      __typename: 'CollaborationV1Project';
                      name: string;
                      displayName: string;
                      updateTime: string;
                      deleteTime?: string | null;
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
                assistantOutcome?: {
                  outcome?: {
                    __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                    response?: string | null;
                  } | null;
                  toolConfirmation?: {
                    __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                    tool: string;
                    input?: any | null;
                  } | null;
                  askQuestion?: {
                    __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                    question: string;
                    alternatives: Array<string>;
                  } | null;
                  error?: {
                    __typename: 'ConversationsV2ChatAssistantOutcomeError';
                    details: string;
                  } | null;
                } | null;
                summary?: { title?: string | null } | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode };
        } | null;
      } | null;
      error?: {
        __typename: 'ConversationsV2Error';
        message: string;
        code?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ChatEventErrorFragment = {
  __typename: 'ConversationsV2Error';
  message: string;
  code?: string | null;
};

export type ChatEventNotificationFragment = {
  __typename: 'ConversationsV2Notification';
  childChatStopped?: {
    __typename: 'ConversationsV2ChildChatStopped';
    success: boolean;
    summary?: string | null;
    childChat:
      | {
          __typename: 'ConversationsV2Chat';
          name: string;
          displayName?: string | null;
          state?: ConversationsV2ChatState | null;
          createTime: string;
          updateTime: string;
          source?: ConversationsV2ChatSource | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          project?:
            | {
                __typename: 'CollaborationV1Project';
                name: string;
                displayName: string;
                updateTime: string;
                deleteTime?: string | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
          assistantOutcome?: {
            outcome?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
              response?: string | null;
            } | null;
            toolConfirmation?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
              tool: string;
              input?: any | null;
            } | null;
            askQuestion?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
              question: string;
              alternatives: Array<string>;
            } | null;
            error?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeError';
              details: string;
            } | null;
          } | null;
          summary?: { title?: string | null } | null;
        }
      | { __typename: 'Error'; message?: string | null; code: ErrorCode };
  } | null;
};

export type ChatEventRefFragment = {
  __typename: 'ConversationsV2ChatEvent';
  name: string;
};

export type ChatEventThinkingFragment = {
  __typename: 'ConversationsV2Thinking';
  content: string;
};

export type ChatEventToolCallFragment = {
  __typename: 'ConversationsV2ToolCall';
  tool: string;
  input?: any | null;
  displayName?: string | null;
};

export type ChatEventToolConfirmationRequestFragment = {
  __typename: 'ConversationsV2ToolConfirmationRequest';
  tool: string;
  input?: any | null;
  displayName?: string | null;
};

export type ChatEventToolConfirmationResponseFragment = {
  __typename: 'ConversationsV2ToolConfirmationResponse';
  decision: ConversationsV2ToolConfirmationResponseDecision;
  toolRequestEvent:
    | {
        __typename: 'ConversationsV2ChatEvent';
        name: string;
        toolConfirmationRequest?: {
          __typename: 'ConversationsV2ToolConfirmationRequest';
          tool: string;
          input?: any | null;
          displayName?: string | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode };
};

export type ChatEventToolResultFragment = {
  __typename: 'ConversationsV2ToolResult';
  content: string;
  success: boolean;
  toolCallEvent?:
    | { __typename: 'ConversationsV2ChatEvent'; name: string }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ChatEventUserInterruptFragment = {
  __typename: 'ConversationsV2UserInterrupt';
};

export type ChatEventUserMessageFragment = {
  __typename: 'ConversationsV2UserMessage';
  content?: string | null;
  parts: Array<{
    text?: string | null;
    resource?: string | null;
    imageUri?: string | null;
  }>;
};

export type ChatEventsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChatEventsQuery = {
  chatEvents?:
    | {
        __typename: 'ConversationsV2ListChatEventsResponse';
        nextPageToken?: string | null;
        chatEvents: Array<{
          __typename: 'ConversationsV2ChatEvent';
          name: string;
          createTime: string;
          updateTime: string;
          userMessage?: {
            __typename: 'ConversationsV2UserMessage';
            content?: string | null;
            parts: Array<{
              text?: string | null;
              resource?: string | null;
              imageUri?: string | null;
            }>;
          } | null;
          assistantMessage?: {
            __typename: 'ConversationsV2AssistantMessage';
            content: string;
            phase?: ConversationsV2AssistantMessagePhase | null;
          } | null;
          thinking?: {
            __typename: 'ConversationsV2Thinking';
            content: string;
          } | null;
          toolCall?: {
            __typename: 'ConversationsV2ToolCall';
            tool: string;
            input?: any | null;
            displayName?: string | null;
          } | null;
          toolResult?: {
            __typename: 'ConversationsV2ToolResult';
            content: string;
            success: boolean;
            toolCallEvent?:
              | { __typename: 'ConversationsV2ChatEvent'; name: string }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
          } | null;
          toolConfirmationRequest?: {
            __typename: 'ConversationsV2ToolConfirmationRequest';
            tool: string;
            input?: any | null;
            displayName?: string | null;
          } | null;
          toolConfirmationResponse?: {
            __typename: 'ConversationsV2ToolConfirmationResponse';
            decision: ConversationsV2ToolConfirmationResponseDecision;
            toolRequestEvent:
              | {
                  __typename: 'ConversationsV2ChatEvent';
                  name: string;
                  toolConfirmationRequest?: {
                    __typename: 'ConversationsV2ToolConfirmationRequest';
                    tool: string;
                    input?: any | null;
                    displayName?: string | null;
                  } | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                };
          } | null;
          userInterrupt?: { __typename: 'ConversationsV2UserInterrupt' } | null;
          notification?: {
            __typename: 'ConversationsV2Notification';
            childChatStopped?: {
              __typename: 'ConversationsV2ChildChatStopped';
              success: boolean;
              summary?: string | null;
              childChat:
                | {
                    __typename: 'ConversationsV2Chat';
                    name: string;
                    displayName?: string | null;
                    state?: ConversationsV2ChatState | null;
                    createTime: string;
                    updateTime: string;
                    source?: ConversationsV2ChatSource | null;
                    creator:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        };
                    project?:
                      | {
                          __typename: 'CollaborationV1Project';
                          name: string;
                          displayName: string;
                          updateTime: string;
                          deleteTime?: string | null;
                        }
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | null;
                    assistantOutcome?: {
                      outcome?: {
                        __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                        response?: string | null;
                      } | null;
                      toolConfirmation?: {
                        __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                        tool: string;
                        input?: any | null;
                      } | null;
                      askQuestion?: {
                        __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                        question: string;
                        alternatives: Array<string>;
                      } | null;
                      error?: {
                        __typename: 'ConversationsV2ChatAssistantOutcomeError';
                        details: string;
                      } | null;
                    } | null;
                    summary?: { title?: string | null } | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  };
            } | null;
          } | null;
          error?: {
            __typename: 'ConversationsV2Error';
            message: string;
            code?: string | null;
          } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ChatRefFragment = {
  __typename: 'ConversationsV2Chat';
  name: string;
  displayName?: string | null;
  state?: ConversationsV2ChatState | null;
  createTime: string;
  updateTime: string;
  source?: ConversationsV2ChatSource | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  project?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  assistantOutcome?: {
    outcome?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
      response?: string | null;
    } | null;
    toolConfirmation?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
      tool: string;
      input?: any | null;
    } | null;
    askQuestion?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
      question: string;
      alternatives: Array<string>;
    } | null;
    error?: {
      __typename: 'ConversationsV2ChatAssistantOutcomeError';
      details: string;
    } | null;
  } | null;
  summary?: { title?: string | null } | null;
};

export type ChatUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChatUpdatedSubscription = {
  chatUpdated?: {
    chat?: {
      __typename: 'ConversationsV2Chat';
      name: string;
      displayName?: string | null;
      state?: ConversationsV2ChatState | null;
      createTime: string;
      updateTime: string;
      source?: ConversationsV2ChatSource | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      project?:
        | {
            __typename: 'CollaborationV1Project';
            name: string;
            displayName: string;
            updateTime: string;
            deleteTime?: string | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      assistantOutcome?: {
        outcome?: {
          __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
          response?: string | null;
        } | null;
        toolConfirmation?: {
          __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
          tool: string;
          input?: any | null;
        } | null;
        askQuestion?: {
          __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
          question: string;
          alternatives: Array<string>;
        } | null;
        error?: {
          __typename: 'ConversationsV2ChatAssistantOutcomeError';
          details: string;
        } | null;
      } | null;
      summary?: { title?: string | null } | null;
    } | null;
  } | null;
};

export type ChatsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChatsQuery = {
  chats?:
    | {
        __typename: 'ConversationsV2ListChatsResponse';
        nextPageToken?: string | null;
        chats: Array<{
          __typename: 'ConversationsV2Chat';
          name: string;
          displayName?: string | null;
          state?: ConversationsV2ChatState | null;
          createTime: string;
          updateTime: string;
          source?: ConversationsV2ChatSource | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          project?:
            | {
                __typename: 'CollaborationV1Project';
                name: string;
                displayName: string;
                updateTime: string;
                deleteTime?: string | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
          assistantOutcome?: {
            outcome?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
              response?: string | null;
            } | null;
            toolConfirmation?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
              tool: string;
              input?: any | null;
            } | null;
            askQuestion?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
              question: string;
              alternatives: Array<string>;
            } | null;
            error?: {
              __typename: 'ConversationsV2ChatAssistantOutcomeError';
              details: string;
            } | null;
          } | null;
          summary?: { title?: string | null } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ConfirmToolMutationVariables = Exact<{
  name: Scalars['String']['input'];
  decision: ConversationsV2ToolConfirmationResponseDecision;
}>;

export type ConfirmToolMutation = {
  confirmTool?:
    | { __typename: 'ConversationsV2ConfirmToolResponse' }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateChatMutationVariables = Exact<{
  chat: ConversationsV2ChatInput;
  chatId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateChatMutation = {
  createChat?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        displayName?: string | null;
        state?: ConversationsV2ChatState | null;
        createTime: string;
        updateTime: string;
        source?: ConversationsV2ChatSource | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        assistantOutcome?: {
          outcome?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
            response?: string | null;
          } | null;
          toolConfirmation?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
            tool: string;
            input?: any | null;
          } | null;
          askQuestion?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
            question: string;
            alternatives: Array<string>;
          } | null;
          error?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeError';
            details: string;
          } | null;
        } | null;
        summary?: { title?: string | null } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteChatMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteChatMutation = {
  deleteChat?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type InterruptChatMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type InterruptChatMutation = {
  interruptChat?:
    | {
        __typename: 'ConversationsV2ChatEvent';
        name: string;
        createTime: string;
        updateTime: string;
        userMessage?: {
          __typename: 'ConversationsV2UserMessage';
          content?: string | null;
          parts: Array<{
            text?: string | null;
            resource?: string | null;
            imageUri?: string | null;
          }>;
        } | null;
        assistantMessage?: {
          __typename: 'ConversationsV2AssistantMessage';
          content: string;
          phase?: ConversationsV2AssistantMessagePhase | null;
        } | null;
        thinking?: {
          __typename: 'ConversationsV2Thinking';
          content: string;
        } | null;
        toolCall?: {
          __typename: 'ConversationsV2ToolCall';
          tool: string;
          input?: any | null;
          displayName?: string | null;
        } | null;
        toolResult?: {
          __typename: 'ConversationsV2ToolResult';
          content: string;
          success: boolean;
          toolCallEvent?:
            | { __typename: 'ConversationsV2ChatEvent'; name: string }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        } | null;
        toolConfirmationRequest?: {
          __typename: 'ConversationsV2ToolConfirmationRequest';
          tool: string;
          input?: any | null;
          displayName?: string | null;
        } | null;
        toolConfirmationResponse?: {
          __typename: 'ConversationsV2ToolConfirmationResponse';
          decision: ConversationsV2ToolConfirmationResponseDecision;
          toolRequestEvent:
            | {
                __typename: 'ConversationsV2ChatEvent';
                name: string;
                toolConfirmationRequest?: {
                  __typename: 'ConversationsV2ToolConfirmationRequest';
                  tool: string;
                  input?: any | null;
                  displayName?: string | null;
                } | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode };
        } | null;
        userInterrupt?: { __typename: 'ConversationsV2UserInterrupt' } | null;
        notification?: {
          __typename: 'ConversationsV2Notification';
          childChatStopped?: {
            __typename: 'ConversationsV2ChildChatStopped';
            success: boolean;
            summary?: string | null;
            childChat:
              | {
                  __typename: 'ConversationsV2Chat';
                  name: string;
                  displayName?: string | null;
                  state?: ConversationsV2ChatState | null;
                  createTime: string;
                  updateTime: string;
                  source?: ConversationsV2ChatSource | null;
                  creator:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      };
                  project?:
                    | {
                        __typename: 'CollaborationV1Project';
                        name: string;
                        displayName: string;
                        updateTime: string;
                        deleteTime?: string | null;
                      }
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | null;
                  assistantOutcome?: {
                    outcome?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                      response?: string | null;
                    } | null;
                    toolConfirmation?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                      tool: string;
                      input?: any | null;
                    } | null;
                    askQuestion?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                      question: string;
                      alternatives: Array<string>;
                    } | null;
                    error?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeError';
                      details: string;
                    } | null;
                  } | null;
                  summary?: { title?: string | null } | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                };
          } | null;
        } | null;
        error?: {
          __typename: 'ConversationsV2Error';
          message: string;
          code?: string | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ResourceDisplayNamesQueryVariables = Exact<{
  assignmentTablesFilter: Scalars['String']['input'];
  entitiesFilter: Scalars['String']['input'];
  factTablesFilter: Scalars['String']['input'];
  flagsFilter: Scalars['String']['input'];
  metricsFilter: Scalars['String']['input'];
  surfacesFilter: Scalars['String']['input'];
  fetchAssignmentTables: Scalars['Boolean']['input'];
  fetchEntities: Scalars['Boolean']['input'];
  fetchFactTables: Scalars['Boolean']['input'];
  fetchFlags: Scalars['Boolean']['input'];
  fetchMetrics: Scalars['Boolean']['input'];
  fetchSurfaces: Scalars['Boolean']['input'];
}>;

export type ResourceDisplayNamesQuery = {
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{ name: string; displayName: string }>;
      }
    | null;
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        entities: Array<{ name: string; displayName: string }>;
      }
    | null;
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        factTables: Array<{ name: string; displayName: string }>;
      }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{ name: string; displayName: string }>;
      }
    | null;
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        metrics: Array<{ name: string; displayName: string }>;
      }
    | null;
  surfaces?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListSurfacesResponse';
        surfaces: Array<{ name: string; displayName: string }>;
      }
    | null;
};

export type SendUserMessageMutationVariables = Exact<{
  name: Scalars['String']['input'];
  userMessage: ConversationsV2UserMessageInput;
}>;

export type SendUserMessageMutation = {
  sendUserMessage?:
    | {
        __typename: 'ConversationsV2ChatEvent';
        name: string;
        createTime: string;
        updateTime: string;
        userMessage?: {
          __typename: 'ConversationsV2UserMessage';
          content?: string | null;
          parts: Array<{
            text?: string | null;
            resource?: string | null;
            imageUri?: string | null;
          }>;
        } | null;
        assistantMessage?: {
          __typename: 'ConversationsV2AssistantMessage';
          content: string;
          phase?: ConversationsV2AssistantMessagePhase | null;
        } | null;
        thinking?: {
          __typename: 'ConversationsV2Thinking';
          content: string;
        } | null;
        toolCall?: {
          __typename: 'ConversationsV2ToolCall';
          tool: string;
          input?: any | null;
          displayName?: string | null;
        } | null;
        toolResult?: {
          __typename: 'ConversationsV2ToolResult';
          content: string;
          success: boolean;
          toolCallEvent?:
            | { __typename: 'ConversationsV2ChatEvent'; name: string }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        } | null;
        toolConfirmationRequest?: {
          __typename: 'ConversationsV2ToolConfirmationRequest';
          tool: string;
          input?: any | null;
          displayName?: string | null;
        } | null;
        toolConfirmationResponse?: {
          __typename: 'ConversationsV2ToolConfirmationResponse';
          decision: ConversationsV2ToolConfirmationResponseDecision;
          toolRequestEvent:
            | {
                __typename: 'ConversationsV2ChatEvent';
                name: string;
                toolConfirmationRequest?: {
                  __typename: 'ConversationsV2ToolConfirmationRequest';
                  tool: string;
                  input?: any | null;
                  displayName?: string | null;
                } | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode };
        } | null;
        userInterrupt?: { __typename: 'ConversationsV2UserInterrupt' } | null;
        notification?: {
          __typename: 'ConversationsV2Notification';
          childChatStopped?: {
            __typename: 'ConversationsV2ChildChatStopped';
            success: boolean;
            summary?: string | null;
            childChat:
              | {
                  __typename: 'ConversationsV2Chat';
                  name: string;
                  displayName?: string | null;
                  state?: ConversationsV2ChatState | null;
                  createTime: string;
                  updateTime: string;
                  source?: ConversationsV2ChatSource | null;
                  creator:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      };
                  project?:
                    | {
                        __typename: 'CollaborationV1Project';
                        name: string;
                        displayName: string;
                        updateTime: string;
                        deleteTime?: string | null;
                      }
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | null;
                  assistantOutcome?: {
                    outcome?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                      response?: string | null;
                    } | null;
                    toolConfirmation?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                      tool: string;
                      input?: any | null;
                    } | null;
                    askQuestion?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                      question: string;
                      alternatives: Array<string>;
                    } | null;
                    error?: {
                      __typename: 'ConversationsV2ChatAssistantOutcomeError';
                      details: string;
                    } | null;
                  } | null;
                  summary?: { title?: string | null } | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                };
          } | null;
        } | null;
        error?: {
          __typename: 'ConversationsV2Error';
          message: string;
          code?: string | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateChatMutationVariables = Exact<{
  input: PartialConversationsV2ChatInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateChatMutation = {
  updateChat?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        displayName?: string | null;
        state?: ConversationsV2ChatState | null;
        createTime: string;
        updateTime: string;
        source?: ConversationsV2ChatSource | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        assistantOutcome?: {
          outcome?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
            response?: string | null;
          } | null;
          toolConfirmation?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
            tool: string;
            input?: any | null;
          } | null;
          askQuestion?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
            question: string;
            alternatives: Array<string>;
          } | null;
          error?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeError';
            details: string;
          } | null;
        } | null;
        summary?: { title?: string | null } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreatePresenceMutationVariables = Exact<{
  presence: CollaborationV1PresenceInput;
  presenceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreatePresenceMutation = {
  createPresence?:
    | {
        __typename: 'CollaborationV1Presence';
        name: string;
        createTime: string;
        updateTime: string;
        data?: any | null;
        actor:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeletePresenceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeletePresenceMutation = {
  deletePresence?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type PresenceFragment = {
  name: string;
  createTime: string;
  updateTime: string;
  data?: any | null;
  actor:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type PresenceCreatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type PresenceCreatedSubscription = {
  presenceCreated?: {
    presence?: {
      name: string;
      createTime: string;
      updateTime: string;
      data?: any | null;
      actor:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
    } | null;
  } | null;
};

export type PresenceDeletedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type PresenceDeletedSubscription = {
  presenceDeleted?: { presence?: string | null } | null;
};

export type PresenceUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type PresenceUpdatedSubscription = {
  presenceUpdated?: {
    presence?: {
      name: string;
      createTime: string;
      updateTime: string;
      data?: any | null;
      actor:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
    } | null;
  } | null;
};

export type PresencesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PresencesQuery = {
  presences?:
    | {
        __typename: 'CollaborationV1ListPresencesResponse';
        nextPageToken?: string | null;
        presences: Array<{
          name: string;
          createTime: string;
          updateTime: string;
          data?: any | null;
          actor:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdatePresenceMutationVariables = Exact<{
  presence: PartialCollaborationV1PresenceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdatePresenceMutation = {
  updatePresence?:
    | {
        __typename: 'CollaborationV1Presence';
        name: string;
        createTime: string;
        updateTime: string;
        data?: any | null;
        actor:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CollectionFragment = {
  __typename: 'CollectionsV1Collection';
  name: string;
  displayName: string;
  description?: string | null;
  isPrivate?: boolean | null;
  updateTime: string;
  createTime: string;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type CollectionQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CollectionQuery = {
  collection?:
    | {
        __typename: 'CollectionsV1Collection';
        name: string;
        displayName: string;
        description?: string | null;
        isPrivate?: boolean | null;
        updateTime: string;
        createTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CollectionEntriesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectionEntriesQuery = {
  collectionEntries?:
    | {
        __typename: 'CollectionsV1ListCollectionEntriesResponse';
        nextPageToken?: string | null;
        collectionEntries: Array<{
          __typename: 'CollectionsV1CollectionEntry';
          name: string;
          createTime?: string | null;
          resource?:
            | { __typename: 'CollaborationV1ExternalDocument' }
            | {
                __typename: 'CollaborationV1Project';
                name: string;
                displayName: string;
                updateTime: string;
                deleteTime?: string | null;
              }
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                displayName: string;
              }
            | { __typename: 'FlagsAdminV1Segment' }
            | { __typename: 'MetricsV1AssignmentTable' }
            | { __typename: 'MetricsV1DimensionTable' }
            | { __typename: 'MetricsV1FactTable' }
            | {
                __typename: 'MetricsV1Metric';
                name: string;
                displayName: string;
              }
            | { __typename: 'WorkflowV1Initiative' }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
                deleteTime?: string | null;
              }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CollectionEntryFragment = {
  __typename: 'CollectionsV1CollectionEntry';
  name: string;
  createTime?: string | null;
  resource?:
    | { __typename: 'CollaborationV1ExternalDocument' }
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error' }
    | { __typename: 'FlagsAdminV1Flag'; name: string; displayName: string }
    | { __typename: 'FlagsAdminV1Segment' }
    | { __typename: 'MetricsV1AssignmentTable' }
    | { __typename: 'MetricsV1DimensionTable' }
    | { __typename: 'MetricsV1FactTable' }
    | { __typename: 'MetricsV1Metric'; name: string; displayName: string }
    | { __typename: 'WorkflowV1Initiative' }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
      }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        displayName: string;
      }
    | null;
};

export type CollectionIndexPageCollectionFragment = {
  __typename: 'CollectionsV1Collection';
  updateTime: string;
  name: string;
  displayName: string;
  description?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type CollectionRefFragment = {
  __typename: 'CollectionsV1Collection';
  name: string;
  displayName: string;
  description?: string | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type CollectionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type CollectionsQuery = {
  collections?:
    | {
        __typename: 'CollectionsV1ListCollectionsResponse';
        nextPageToken?: string | null;
        collections: Array<{
          __typename: 'CollectionsV1Collection';
          name: string;
          displayName: string;
          description?: string | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCollectionMutationVariables = Exact<{
  input: CollectionsV1CollectionInput;
}>;

export type CreateCollectionMutation = {
  createCollection?:
    | {
        __typename: 'CollectionsV1Collection';
        name: string;
        displayName: string;
        description?: string | null;
        isPrivate?: boolean | null;
        updateTime: string;
        createTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCollectionEntryMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  collectionEntry: CollectionsV1CollectionEntryInput;
}>;

export type CreateCollectionEntryMutation = {
  createCollectionEntry?:
    | {
        __typename: 'CollectionsV1CollectionEntry';
        name: string;
        createTime?: string | null;
        resource?:
          | { __typename: 'CollaborationV1ExternalDocument' }
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error' }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | { __typename: 'FlagsAdminV1Segment' }
          | { __typename: 'MetricsV1AssignmentTable' }
          | { __typename: 'MetricsV1DimensionTable' }
          | { __typename: 'MetricsV1FactTable' }
          | { __typename: 'MetricsV1Metric'; name: string; displayName: string }
          | { __typename: 'WorkflowV1Initiative' }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCollectionWithIdMutationVariables = Exact<{
  input: CollectionsV1CollectionInput;
  collectionId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCollectionWithIdMutation = {
  createCollection?:
    | {
        __typename: 'CollectionsV1Collection';
        name: string;
        displayName: string;
        description?: string | null;
        isPrivate?: boolean | null;
        updateTime: string;
        createTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteCollectionMutation = {
  deleteCollection?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeleteCollectionEntryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteCollectionEntryMutation = {
  deleteCollectionEntry?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type UpdateCollectionMutationVariables = Exact<{
  input: PartialCollectionsV1CollectionInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCollectionMutation = {
  updateCollection?:
    | {
        __typename: 'CollectionsV1Collection';
        name: string;
        displayName: string;
        description?: string | null;
        isPrivate?: boolean | null;
        updateTime: string;
        createTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CommentFragment = {
  name: string;
  resource: string;
  createTime: string;
  updateTime: string;
  content: string;
  resolved?: boolean | null;
  author:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  assignee?:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>
    | null;
  anchor?: { zone?: { zone: string } | null } | null;
  queryReactionSummary?:
    | {
        __typename: 'CollaborationV1QueryReactionSummaryResponse';
        summary: {
          name: string;
          commentCount: number;
          emojiReactions: Array<{
            key: string;
            value?: {
              emoji?: string | null;
              reactionCount?: number | null;
              identities: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
              >;
            } | null;
          }>;
        };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CommentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CommentQuery = {
  comment?:
    | {
        __typename: 'CollaborationV1Comment';
        name: string;
        resource: string;
        createTime: string;
        updateTime: string;
        content: string;
        resolved?: boolean | null;
        author:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        assignee?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        anchor?: { zone?: { zone: string } | null } | null;
        queryReactionSummary?:
          | {
              __typename: 'CollaborationV1QueryReactionSummaryResponse';
              summary: {
                name: string;
                commentCount: number;
                emojiReactions: Array<{
                  key: string;
                  value?: {
                    emoji?: string | null;
                    reactionCount?: number | null;
                    identities: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                    >;
                  } | null;
                }>;
              };
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CommentCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type CommentCreatedSubscription = {
  commentCreated?: {
    comment?: {
      name: string;
      resource: string;
      createTime: string;
      updateTime: string;
      content: string;
      resolved?: boolean | null;
      author:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>;
      assignee?:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>
        | null;
      anchor?: { zone?: { zone: string } | null } | null;
      queryReactionSummary?:
        | {
            __typename: 'CollaborationV1QueryReactionSummaryResponse';
            summary: {
              name: string;
              commentCount: number;
              emojiReactions: Array<{
                key: string;
                value?: {
                  emoji?: string | null;
                  reactionCount?: number | null;
                  identities: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                  >;
                } | null;
              }>;
            };
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
    } | null;
  } | null;
};

export type CommentRepliesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CommentRepliesQuery = {
  commentReplies?:
    | {
        __typename: 'CollaborationV1ListCommentRepliesResponse';
        nextPageToken?: string | null;
        commentReplies: Array<{
          name: string;
          content?: string | null;
          action?: CollaborationV1CommentReplyAction | null;
          createTime: string;
          updateTime: string;
          assignee?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          author:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CommentReplyFragment = {
  name: string;
  content?: string | null;
  action?: CollaborationV1CommentReplyAction | null;
  createTime: string;
  updateTime: string;
  assignee?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  author:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  queryReactionSummary?:
    | {
        __typename: 'CollaborationV1QueryReactionSummaryResponse';
        summary: {
          name: string;
          commentCount: number;
          emojiReactions: Array<{
            key: string;
            value?: {
              emoji?: string | null;
              reactionCount?: number | null;
              identities: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
              >;
            } | null;
          }>;
        };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CommentReplyCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type CommentReplyCreatedSubscription = {
  commentReplyCreated?: {
    reply?: {
      name: string;
      content?: string | null;
      action?: CollaborationV1CommentReplyAction | null;
      createTime: string;
      updateTime: string;
      assignee?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      author:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      queryReactionSummary?:
        | {
            __typename: 'CollaborationV1QueryReactionSummaryResponse';
            summary: {
              name: string;
              commentCount: number;
              emojiReactions: Array<{
                key: string;
                value?: {
                  emoji?: string | null;
                  reactionCount?: number | null;
                  identities: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                  >;
                } | null;
              }>;
            };
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
    } | null;
  } | null;
};

export type CommentUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type CommentUpdatedSubscription = {
  commentUpdated?: {
    comment?: {
      name: string;
      resource: string;
      createTime: string;
      updateTime: string;
      content: string;
      resolved?: boolean | null;
      author:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>;
      assignee?:
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | Record<PropertyKey, never>
        | null;
      anchor?: { zone?: { zone: string } | null } | null;
      queryReactionSummary?:
        | {
            __typename: 'CollaborationV1QueryReactionSummaryResponse';
            summary: {
              name: string;
              commentCount: number;
              emojiReactions: Array<{
                key: string;
                value?: {
                  emoji?: string | null;
                  reactionCount?: number | null;
                  identities: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                  >;
                } | null;
              }>;
            };
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
    } | null;
  } | null;
};

export type CommentsQueryVariables = Exact<{
  resource?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CommentsQuery = {
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        nextPageToken?: string | null;
        comments: Array<{
          name: string;
          resource: string;
          createTime: string;
          updateTime: string;
          content: string;
          resolved?: boolean | null;
          author:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          assignee?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          anchor?: { zone?: { zone: string } | null } | null;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCommentMutationVariables = Exact<{
  comment: CollaborationV1CommentInput;
  commentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCommentMutation = {
  createComment?:
    | {
        __typename: 'CollaborationV1Comment';
        name: string;
        resource: string;
        createTime: string;
        updateTime: string;
        content: string;
        resolved?: boolean | null;
        author:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        assignee?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        anchor?: { zone?: { zone: string } | null } | null;
        queryReactionSummary?:
          | {
              __typename: 'CollaborationV1QueryReactionSummaryResponse';
              summary: {
                name: string;
                commentCount: number;
                emojiReactions: Array<{
                  key: string;
                  value?: {
                    emoji?: string | null;
                    reactionCount?: number | null;
                    identities: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                    >;
                  } | null;
                }>;
              };
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCommentReplyMutationVariables = Exact<{
  reply: CollaborationV1CommentReplyInput;
  commentName: Scalars['String']['input'];
  commentReplyId: Scalars['String']['input'];
}>;

export type CreateCommentReplyMutation = {
  createCommentReply?:
    | {
        __typename: 'CollaborationV1CommentReply';
        name: string;
        content?: string | null;
        action?: CollaborationV1CommentReplyAction | null;
        createTime: string;
        updateTime: string;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        author:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        queryReactionSummary?:
          | {
              __typename: 'CollaborationV1QueryReactionSummaryResponse';
              summary: {
                name: string;
                commentCount: number;
                emojiReactions: Array<{
                  key: string;
                  value?: {
                    emoji?: string | null;
                    reactionCount?: number | null;
                    identities: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                    >;
                  } | null;
                }>;
              };
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateReactionMutationVariables = Exact<{
  input: CollaborationV1ReactionInput;
  reactionId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateReactionMutation = {
  createReaction?:
    | {
        __typename: 'CollaborationV1Reaction';
        name: string;
        emoji: string;
        resource: string;
        createTime: string;
        updateTime: string;
        author:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteCommentMutationVariables = Exact<{
  commentName: Scalars['String']['input'];
}>;

export type DeleteCommentMutation = {
  deleteComment?:
    | { __typename: 'CollaborationV1Comment' }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ReactionFragment = {
  __typename: 'CollaborationV1Reaction';
  name: string;
  emoji: string;
  resource: string;
  createTime: string;
  updateTime: string;
  author:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type ReactionSummaryFragment = {
  name: string;
  commentCount: number;
  emojiReactions: Array<{
    key: string;
    value?: {
      emoji?: string | null;
      reactionCount?: number | null;
      identities: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
      >;
    } | null;
  }>;
};

export type UndoReactionMutationVariables = Exact<{
  resource: Scalars['String']['input'];
  emoji: Scalars['String']['input'];
}>;

export type UndoReactionMutation = {
  undoReaction?:
    | {
        __typename: 'CollaborationV1UndoReactionResponse';
        dummy?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type LabelFragment = {
  __typename: 'AdminLabelsV1Label';
  name: string;
  displayName?: string | null;
  description?: string | null;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
  allowedValues: Array<string>;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  creator:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  updater:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
};

export type LabelQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type LabelQuery = {
  label?:
    | {
        __typename: 'AdminLabelsV1Label';
        name: string;
        displayName?: string | null;
        description?: string | null;
        resourceTypes: Array<AdminLabelsV1LabelResourceType>;
        allowedValues: Array<string>;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type LabelRefFragment = {
  __typename: 'AdminLabelsV1Label';
  name: string;
  displayName?: string | null;
  description?: string | null;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
  allowedValues: Array<string>;
};

export type LabelsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type LabelsQuery = {
  labels?:
    | {
        __typename: 'AdminLabelsV1ListLabelsResponse';
        nextPageToken?: string | null;
        labels: Array<{
          __typename: 'AdminLabelsV1Label';
          name: string;
          displayName?: string | null;
          description?: string | null;
          resourceTypes: Array<AdminLabelsV1LabelResourceType>;
          allowedValues: Array<string>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type InitiateImageUploadMutationVariables = Exact<{
  [key: string]: never;
}>;

export type InitiateImageUploadMutation = {
  initiateImageUpload?:
    | { signedUri?: string | null; imageUri?: string | null }
    | Record<PropertyKey, never>
    | null;
};

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  types: Array<SearchV1ExternalResourceType> | SearchV1ExternalResourceType;
  resourceSpecificFilters?: InputMaybe<SearchV1ExternalSearchRequestFiltersInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchQuery = {
  search?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'SearchV1ExternalSearchResponse';
        nextPageToken?: string | null;
        totalSize?: number | null;
        hits: Array<{
          resource?:
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                description?: string | null;
              }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                email?: string | null;
                pictureUri?: string | null;
              }
            | {
                __typename: 'MetricsV1Metric';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
};

export type SearchIdentityFragment = {
  __typename: 'IamV1Identity';
  name: string;
  displayName: string;
  email?: string | null;
  pictureUri?: string | null;
};

export type DevBarFlagsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type DevBarFlagsQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{
          name: string;
          variants: Array<{ name: string; value: any }>;
        }>;
      }
    | null;
};

export type CollaborativeDocumentFragment = {
  __typename: 'CollaborationV1CollaborativeDocument';
  name: string;
  resource?: string | null;
  title?: string | null;
  state: CollaborationV1CollaborativeDocumentState;
  content?: any | null;
  markdown?: string | null;
  etag?: string | null;
  realtimeEditing?: boolean | null;
  createTime: string;
  updateTime: string;
  publishTime?: string | null;
  pendingOperation?: {
    type: CollaborationV1CollaborativeDocumentPendingOperationType;
  } | null;
  creator:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  updater:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>;
  publisher?:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type CollaborativeDocumentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CollaborativeDocumentQuery = {
  collaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        resource?: string | null;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
        content?: any | null;
        markdown?: string | null;
        etag?: string | null;
        realtimeEditing?: boolean | null;
        createTime: string;
        updateTime: string;
        publishTime?: string | null;
        pendingOperation?: {
          type: CollaborationV1CollaborativeDocumentPendingOperationType;
        } | null;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        publisher?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CollaborativeDocumentRefFragment = {
  __typename: 'CollaborationV1CollaborativeDocument';
  name: string;
  title?: string | null;
  state: CollaborationV1CollaborativeDocumentState;
};

export type CollaborativeDocumentRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CollaborativeDocumentRefQuery = {
  collaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type GenerateCollaborativeDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GenerateCollaborativeDocumentMutation = {
  generateCollaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        resource?: string | null;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
        content?: any | null;
        markdown?: string | null;
        etag?: string | null;
        realtimeEditing?: boolean | null;
        createTime: string;
        updateTime: string;
        publishTime?: string | null;
        pendingOperation?: {
          type: CollaborationV1CollaborativeDocumentPendingOperationType;
        } | null;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        publisher?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type GetTiptapTokenQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetTiptapTokenQuery = {
  getTiptapToken?:
    | {
        __typename: 'CollaborationV1GetTiptapTokenResponse';
        appId: string;
        tiptapDocumentName?: string | null;
        token: string;
        expiresAt: string;
        readWrite?: boolean | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type PublishCollaborativeDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  activityMessage?: InputMaybe<Scalars['String']['input']>;
}>;

export type PublishCollaborativeDocumentMutation = {
  publishCollaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        resource?: string | null;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
        content?: any | null;
        markdown?: string | null;
        etag?: string | null;
        realtimeEditing?: boolean | null;
        createTime: string;
        updateTime: string;
        publishTime?: string | null;
        pendingOperation?: {
          type: CollaborationV1CollaborativeDocumentPendingOperationType;
        } | null;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        publisher?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type TiptapTokenFragment = {
  __typename: 'CollaborationV1GetTiptapTokenResponse';
  appId: string;
  tiptapDocumentName?: string | null;
  token: string;
  expiresAt: string;
  readWrite?: boolean | null;
};

export type UnpublishCollaborativeDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UnpublishCollaborativeDocumentMutation = {
  unpublishCollaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        resource?: string | null;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
        content?: any | null;
        markdown?: string | null;
        etag?: string | null;
        realtimeEditing?: boolean | null;
        createTime: string;
        updateTime: string;
        publishTime?: string | null;
        pendingOperation?: {
          type: CollaborationV1CollaborativeDocumentPendingOperationType;
        } | null;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        publisher?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateCollaborativeDocumentMutationVariables = Exact<{
  input: PartialCollaborationV1CollaborativeDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCollaborativeDocumentMutation = {
  updateCollaborativeDocument?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        resource?: string | null;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
        content?: any | null;
        markdown?: string | null;
        etag?: string | null;
        realtimeEditing?: boolean | null;
        createTime: string;
        updateTime: string;
        publishTime?: string | null;
        pendingOperation?: {
          type: CollaborationV1CollaborativeDocumentPendingOperationType;
        } | null;
        creator:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        updater:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>;
        publisher?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateEntityIdentityBindingMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  entityIdentityBinding: MetricsV1EntityIdentityBindingInput;
}>;

export type CreateEntityIdentityBindingMutation = {
  createEntityIdentityBinding?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1EntityIdentityBinding';
        name: string;
        value: string;
        createTime: string;
        updateTime: string;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
              primaryKeyType: MetricsV1ColumnType;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type DeleteEntityIdentityBindingMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEntityIdentityBindingMutation = {
  deleteEntityIdentityBinding?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type EntityIdentityBindingFragment = {
  __typename: 'MetricsV1EntityIdentityBinding';
  name: string;
  value: string;
  createTime: string;
  updateTime: string;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
  identity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type EntityIdentityBindingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
}>;

export type EntityIdentityBindingsQuery = {
  entityIdentityBindings?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntityIdentityBindingsResponse';
        nextPageToken?: string | null;
        entityIdentityBindings: Array<{
          __typename: 'MetricsV1EntityIdentityBinding';
          name: string;
          value: string;
          createTime: string;
          updateTime: string;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
              }
            | null;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type UpdateEntityIdentityBindingMutationVariables = Exact<{
  input: PartialMetricsV1EntityIdentityBindingInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateEntityIdentityBindingMutation = {
  updateEntityIdentityBinding?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1EntityIdentityBinding';
        name: string;
        value: string;
        createTime: string;
        updateTime: string;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
              primaryKeyType: MetricsV1ColumnType;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type CreateEnvironmentMutationVariables = Exact<{
  environment: FlagsAdminV1EnvironmentInput;
  environmentId: Scalars['String']['input'];
}>;

export type CreateEnvironmentMutation = {
  createEnvironment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
        description?: string | null;
        deleteTime?: string | null;
      }
    | null;
};

export type DeleteEnvironmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEnvironmentMutation = {
  deleteEnvironment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type EnvironmentFragment = {
  __typename: 'FlagsAdminV1Environment';
  name: string;
  color?: string | null;
  description?: string | null;
  deleteTime?: string | null;
};

export type EnvironmentsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type EnvironmentsQuery = {
  environments?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListEnvironmentsResponse';
        nextPageToken?: string | null;
        environments: Array<{
          __typename: 'FlagsAdminV1Environment';
          name: string;
          color?: string | null;
          description?: string | null;
          deleteTime?: string | null;
        }>;
      }
    | null;
};

export type ListEnvironmentsQueryVariables = Exact<{ [key: string]: never }>;

export type ListEnvironmentsQuery = {
  environments?:
    | {
        environments: Array<{
          __typename: 'FlagsAdminV1Environment';
          name: string;
          color?: string | null;
          description?: string | null;
          deleteTime?: string | null;
        }>;
      }
    | Record<PropertyKey, never>
    | null;
};

export type UndeleteEnvironmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UndeleteEnvironmentMutation = {
  undeleteEnvironment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
        description?: string | null;
        deleteTime?: string | null;
      }
    | null;
};

export type UpdateEnvironmentMutationVariables = Exact<{
  input: PartialFlagsAdminV1EnvironmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateEnvironmentMutation = {
  updateEnvironment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
        description?: string | null;
        deleteTime?: string | null;
      }
    | null;
};

export type CreateEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  event: EventsAdminV1EventDefinitionInput;
}>;

export type CreateEventMutation = {
  createEventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{ key: string }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        usageMetadata: {
          publishCount: any;
          validationFailedCount: any;
          lastPublishTime?: string | null;
          lastValidationFailedTime?: string | null;
        };
      }
    | null;
};

export type DeleteEventDefinitionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEventDefinitionMutation = {
  deleteEventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DraftEventFragment = {
  reason: EventsAdminV1DraftEventValidationErrorReason;
  eventTime: string;
  draftEventDefinition?: string | null;
  payload: any;
  schema: {
    __typename: 'EventsAdminV1EventSchema';
    structSchema?: {
      displayName?: string | null;
      description?: string | null;
      schema: Array<{
        key: string;
        value?: {
          structSchema?: {
            displayName?: string | null;
            description?: string | null;
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{ key: string }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  elementSchema?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{ key: string }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            }>;
          } | null;
          listSchema?: {
            displayName?: string | null;
            description?: string | null;
            elementSchema?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{ key: string }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
          intSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          doubleSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          stringSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          boolSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          dateSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          timestampSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  };
  eventDefinition?:
    | { __typename: 'Error' }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{ key: string }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        usageMetadata: {
          publishCount: any;
          validationFailedCount: any;
          lastPublishTime?: string | null;
          lastValidationFailedTime?: string | null;
        };
      }
    | null;
  client:
    | { __typename: 'Error' }
    | {
        __typename: 'IamV1Client';
        name: string;
        displayName: string;
        lastSeenTime?: string | null;
        createTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      };
};

export type DraftFieldsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type DraftFieldsQuery = {
  queryDraftEvents?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1QueryDraftEventsResponse';
        nextPageToken?: string | null;
        draftEvents: Array<{
          reason: EventsAdminV1DraftEventValidationErrorReason;
          eventTime: string;
          draftEventDefinition?: string | null;
          payload: any;
          schema: {
            __typename: 'EventsAdminV1EventSchema';
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
          };
          eventDefinition?:
            | { __typename: 'Error' }
            | {
                __typename: 'EventsAdminV1EventDefinition';
                name: string;
                updateTime: string;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      displayName: string;
                      name: string;
                      everyone?: boolean | null;
                      user?:
                        | { pictureUri?: string | null; name: string }
                        | Record<PropertyKey, never>
                        | null;
                      group?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      apiClient?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        listSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          elementSchema?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  listSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    elementSchema?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                      value?: {
                                                                                        structSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          schema: Array<{
                                                                                            key: string;
                                                                                          }>;
                                                                                        } | null;
                                                                                        intSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        doubleSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        stringSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        boolSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        dateSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        timestampSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                      } | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            listSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              elementSchema?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      listSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        elementSchema?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
                usageMetadata: {
                  publishCount: any;
                  validationFailedCount: any;
                  lastPublishTime?: string | null;
                  lastValidationFailedTime?: string | null;
                };
              }
            | null;
          client:
            | { __typename: 'Error' }
            | {
                __typename: 'IamV1Client';
                name: string;
                displayName: string;
                lastSeenTime?: string | null;
                createTime: string;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
        }>;
      }
    | null;
};

export type EventQueryVariables = Exact<{
  name: Scalars['String']['input'];
  draftFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type EventQuery = {
  eventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{ key: string }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        usageMetadata: {
          publishCount: any;
          validationFailedCount: any;
          lastPublishTime?: string | null;
          lastValidationFailedTime?: string | null;
        };
      }
    | null;
  queryDraftEvents?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1QueryDraftEventsResponse';
        draftEvents: Array<{
          reason: EventsAdminV1DraftEventValidationErrorReason;
          eventTime: string;
          draftEventDefinition?: string | null;
          payload: any;
          schema: {
            __typename: 'EventsAdminV1EventSchema';
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
          };
          eventDefinition?:
            | { __typename: 'Error' }
            | {
                __typename: 'EventsAdminV1EventDefinition';
                name: string;
                updateTime: string;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      displayName: string;
                      name: string;
                      everyone?: boolean | null;
                      user?:
                        | { pictureUri?: string | null; name: string }
                        | Record<PropertyKey, never>
                        | null;
                      group?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      apiClient?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        listSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          elementSchema?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  listSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    elementSchema?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                      value?: {
                                                                                        structSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          schema: Array<{
                                                                                            key: string;
                                                                                          }>;
                                                                                        } | null;
                                                                                        intSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        doubleSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        stringSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        boolSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        dateSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        timestampSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                      } | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            listSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              elementSchema?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      listSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        elementSchema?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
                usageMetadata: {
                  publishCount: any;
                  validationFailedCount: any;
                  lastPublishTime?: string | null;
                  lastValidationFailedTime?: string | null;
                };
              }
            | null;
          client:
            | { __typename: 'Error' }
            | {
                __typename: 'IamV1Client';
                name: string;
                displayName: string;
                lastSeenTime?: string | null;
                createTime: string;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
        }>;
      }
    | null;
};

export type EventDefinitionFragment = {
  __typename: 'EventsAdminV1EventDefinition';
  name: string;
  updateTime: string;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        displayName: string;
        name: string;
        everyone?: boolean | null;
        user?:
          | { pictureUri?: string | null; name: string }
          | Record<PropertyKey, never>
          | null;
        group?: { name: string } | Record<PropertyKey, never> | null;
        apiClient?: { name: string } | Record<PropertyKey, never> | null;
      }
    | null;
  schema: Array<{
    key: string;
    value?: {
      structSchema?: {
        displayName?: string | null;
        description?: string | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{ key: string }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
      listSchema?: {
        displayName?: string | null;
        description?: string | null;
        elementSchema?: {
          structSchema?: {
            displayName?: string | null;
            description?: string | null;
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{ key: string }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  elementSchema?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{ key: string }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            }>;
          } | null;
          intSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          doubleSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          stringSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          boolSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          dateSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          timestampSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      intSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      doubleSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      stringSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      boolSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      dateSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      timestampSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
    } | null;
  }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  usageMetadata: {
    publishCount: any;
    validationFailedCount: any;
    lastPublishTime?: string | null;
    lastValidationFailedTime?: string | null;
  };
};

export type EventDefinitionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type EventDefinitionsQuery = {
  eventDefinitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1ListEventDefinitionsResponse';
        nextPageToken?: string | null;
        eventDefinitions: Array<{
          __typename: 'EventsAdminV1EventDefinition';
          name: string;
          updateTime: string;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                displayName: string;
                name: string;
                everyone?: boolean | null;
                user?:
                  | { pictureUri?: string | null; name: string }
                  | Record<PropertyKey, never>
                  | null;
                group?: { name: string } | Record<PropertyKey, never> | null;
                apiClient?:
                  | { name: string }
                  | Record<PropertyKey, never>
                  | null;
              }
            | null;
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            listSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              elementSchema?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      listSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        elementSchema?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                displayName?: string | null;
                description?: string | null;
                elementSchema?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{ key: string }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
          usageMetadata: {
            publishCount: any;
            validationFailedCount: any;
            lastPublishTime?: string | null;
            lastValidationFailedTime?: string | null;
          };
        }>;
      }
    | null;
};

export type EventExistQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type EventExistQuery = {
  eventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'EventsAdminV1EventDefinition'; name: string }
    | null;
};

export type EventSchemaEntryFragment = {
  key: string;
  value?: {
    structSchema?: {
      displayName?: string | null;
      description?: string | null;
      schema: Array<{
        key: string;
        value?: {
          structSchema?: {
            displayName?: string | null;
            description?: string | null;
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{ key: string }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  elementSchema?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{ key: string }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            }>;
          } | null;
          listSchema?: {
            displayName?: string | null;
            description?: string | null;
            elementSchema?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{ key: string }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
          intSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          doubleSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          stringSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          boolSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          dateSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          timestampSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
    listSchema?: {
      displayName?: string | null;
      description?: string | null;
      elementSchema?: {
        structSchema?: {
          displayName?: string | null;
          description?: string | null;
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{ key: string }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                displayName?: string | null;
                description?: string | null;
                elementSchema?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        intSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        doubleSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        stringSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        boolSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        dateSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        timestampSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    intSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
    doubleSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
    stringSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
    boolSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
    dateSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
    timestampSchema?: {
      displayName?: string | null;
      description?: string | null;
      semanticType?: {
        country?: {
          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
        } | null;
        entityReference?: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        } | null;
        enumType?: { values: Array<{ value?: string | null }> } | null;
      } | null;
    } | null;
  } | null;
};

export type FieldSemanticTypeFragment = {
  country?: {
    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
  } | null;
  entityReference?: {
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
  } | null;
  enumType?: { values: Array<{ value?: string | null }> } | null;
};

export type EventSchemaBoolSchemaFragment = {
  boolSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaIntSchemaFragment = {
  intSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaDoubleSchemaFragment = {
  doubleSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaStringSchemaFragment = {
  stringSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaDateSchemaFragment = {
  dateSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaTimestampSchemaFragment = {
  timestampSchema?: {
    displayName?: string | null;
    description?: string | null;
    semanticType?: {
      country?: {
        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      enumType?: { values: Array<{ value?: string | null }> } | null;
    } | null;
  } | null;
};

export type EventSchemaListSchemaFragment = {
  listSchema?: {
    displayName?: string | null;
    description?: string | null;
    elementSchema?: {
      structSchema?: {
        displayName?: string | null;
        description?: string | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{ key: string }>;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
      intSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      doubleSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      stringSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      boolSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      dateSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
      timestampSchema?: {
        displayName?: string | null;
        description?: string | null;
        semanticType?: {
          country?: {
            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
          } | null;
          entityReference?: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
          } | null;
          enumType?: { values: Array<{ value?: string | null }> } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type EventSchemaStructSchemaFragment = {
  structSchema?: {
    displayName?: string | null;
    description?: string | null;
    schema: Array<{
      key: string;
      value?: {
        structSchema?: {
          displayName?: string | null;
          description?: string | null;
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                displayName?: string | null;
                description?: string | null;
                elementSchema?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{ key: string }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        listSchema?: {
          displayName?: string | null;
          description?: string | null;
          elementSchema?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{ key: string }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        } | null;
        intSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        doubleSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        stringSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        boolSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        dateSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
        timestampSchema?: {
          displayName?: string | null;
          description?: string | null;
          semanticType?: {
            country?: {
              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
            } | null;
            entityReference?: {
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
            } | null;
            enumType?: { values: Array<{ value?: string | null }> } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type EventUsageQueryVariables = Exact<{
  event: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;

export type EventUsageQuery = {
  queryEventsUsage?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1QueryEventsUsageResponse';
        usage: Array<{
          hourTime: string;
          publishCount: any;
          validationFailedCount: any;
        }>;
      }
    | null;
};

export type OnEventDefinitionCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnEventDefinitionCreatedSubscription = {
  eventDefinitionCreated?: {
    eventDefinition?: {
      __typename: 'EventsAdminV1EventDefinition';
      name: string;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      schema: Array<{
        key: string;
        value?: {
          structSchema?: {
            displayName?: string | null;
            description?: string | null;
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        listSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          elementSchema?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                            value?: {
                                                                              structSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                schema: Array<{
                                                                                  key: string;
                                                                                }>;
                                                                              } | null;
                                                                              intSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              doubleSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              stringSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              boolSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              dateSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              timestampSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{ key: string }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  elementSchema?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{ key: string }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            }>;
          } | null;
          listSchema?: {
            displayName?: string | null;
            description?: string | null;
            elementSchema?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{ key: string }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
          intSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          doubleSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          stringSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          boolSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          dateSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          timestampSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
        } | null;
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      usageMetadata: {
        publishCount: any;
        validationFailedCount: any;
        lastPublishTime?: string | null;
        lastValidationFailedTime?: string | null;
      };
    } | null;
  } | null;
};

export type OnEventDefinitionDeletedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnEventDefinitionDeletedSubscription = {
  eventDefinitionDeleted?: { eventDefinition?: string | null } | null;
};

export type OnEventDefinitionUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnEventDefinitionUpdatedSubscription = {
  eventDefinitionUpdated?: {
    eventDefinition?: {
      __typename: 'EventsAdminV1EventDefinition';
      name: string;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      schema: Array<{
        key: string;
        value?: {
          structSchema?: {
            displayName?: string | null;
            description?: string | null;
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        listSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          elementSchema?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                            value?: {
                                                                              structSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                schema: Array<{
                                                                                  key: string;
                                                                                }>;
                                                                              } | null;
                                                                              intSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              doubleSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              stringSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              boolSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              dateSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                              timestampSchema?: {
                                                                                displayName?:
                                                                                  | string
                                                                                  | null;
                                                                                description?:
                                                                                  | string
                                                                                  | null;
                                                                                semanticType?: {
                                                                                  country?: {
                                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                  } | null;
                                                                                  entityReference?: {
                                                                                    entity:
                                                                                      | {
                                                                                          __typename: 'Error';
                                                                                          message?:
                                                                                            | string
                                                                                            | null;
                                                                                          code: ErrorCode;
                                                                                        }
                                                                                      | {
                                                                                          __typename: 'MetricsV1Entity';
                                                                                          name: string;
                                                                                          displayName: string;
                                                                                        };
                                                                                  } | null;
                                                                                  enumType?: {
                                                                                    values: Array<{
                                                                                      value?:
                                                                                        | string
                                                                                        | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{ key: string }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  elementSchema?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{ key: string }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            }>;
          } | null;
          listSchema?: {
            displayName?: string | null;
            description?: string | null;
            elementSchema?: {
              structSchema?: {
                displayName?: string | null;
                description?: string | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{ key: string }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              intSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              doubleSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              stringSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              boolSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              dateSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
              timestampSchema?: {
                displayName?: string | null;
                description?: string | null;
                semanticType?: {
                  country?: {
                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                  } | null;
                  entityReference?: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                  } | null;
                  enumType?: {
                    values: Array<{ value?: string | null }>;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
          intSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          doubleSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          stringSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          boolSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          dateSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
          timestampSchema?: {
            displayName?: string | null;
            description?: string | null;
            semanticType?: {
              country?: {
                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
              } | null;
              entityReference?: {
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
              } | null;
              enumType?: { values: Array<{ value?: string | null }> } | null;
            } | null;
          } | null;
        } | null;
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      usageMetadata: {
        publishCount: any;
        validationFailedCount: any;
        lastPublishTime?: string | null;
        lastValidationFailedTime?: string | null;
      };
    } | null;
  } | null;
};

export type QueryDraftEventsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type QueryDraftEventsQuery = {
  queryDraftEvents?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1QueryDraftEventsResponse';
        nextPageToken?: string | null;
        draftEvents: Array<{
          reason: EventsAdminV1DraftEventValidationErrorReason;
          eventTime: string;
          draftEventDefinition?: string | null;
          payload: any;
          schema: {
            __typename: 'EventsAdminV1EventSchema';
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
          };
          eventDefinition?:
            | { __typename: 'Error' }
            | {
                __typename: 'EventsAdminV1EventDefinition';
                name: string;
                updateTime: string;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      displayName: string;
                      name: string;
                      everyone?: boolean | null;
                      user?:
                        | { pictureUri?: string | null; name: string }
                        | Record<PropertyKey, never>
                        | null;
                      group?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      apiClient?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | null;
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        listSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          elementSchema?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                      value?: {
                                                                        structSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          schema: Array<{
                                                                            key: string;
                                                                          }>;
                                                                        } | null;
                                                                        intSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        doubleSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        stringSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        boolSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        dateSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                        timestampSchema?: {
                                                                          displayName?:
                                                                            | string
                                                                            | null;
                                                                          description?:
                                                                            | string
                                                                            | null;
                                                                          semanticType?: {
                                                                            country?: {
                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                            } | null;
                                                                            entityReference?: {
                                                                              entity:
                                                                                | {
                                                                                    __typename: 'Error';
                                                                                    message?:
                                                                                      | string
                                                                                      | null;
                                                                                    code: ErrorCode;
                                                                                  }
                                                                                | {
                                                                                    __typename: 'MetricsV1Entity';
                                                                                    name: string;
                                                                                    displayName: string;
                                                                                  };
                                                                            } | null;
                                                                            enumType?: {
                                                                              values: Array<{
                                                                                value?:
                                                                                  | string
                                                                                  | null;
                                                                              }>;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    }>;
                                                                  } | null;
                                                                  listSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    elementSchema?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                      value?: {
                                                                                        structSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          schema: Array<{
                                                                                            key: string;
                                                                                          }>;
                                                                                        } | null;
                                                                                        intSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        doubleSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        stringSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        boolSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        dateSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                        timestampSchema?: {
                                                                                          displayName?:
                                                                                            | string
                                                                                            | null;
                                                                                          description?:
                                                                                            | string
                                                                                            | null;
                                                                                          semanticType?: {
                                                                                            country?: {
                                                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                            } | null;
                                                                                            entityReference?: {
                                                                                              entity:
                                                                                                | {
                                                                                                    __typename: 'Error';
                                                                                                    message?:
                                                                                                      | string
                                                                                                      | null;
                                                                                                    code: ErrorCode;
                                                                                                  }
                                                                                                | {
                                                                                                    __typename: 'MetricsV1Entity';
                                                                                                    name: string;
                                                                                                    displayName: string;
                                                                                                  };
                                                                                            } | null;
                                                                                            enumType?: {
                                                                                              values: Array<{
                                                                                                value?:
                                                                                                  | string
                                                                                                  | null;
                                                                                              }>;
                                                                                            } | null;
                                                                                          } | null;
                                                                                        } | null;
                                                                                      } | null;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  listSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    elementSchema?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                                value?: {
                                                                  structSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    schema: Array<{
                                                                      key: string;
                                                                    }>;
                                                                  } | null;
                                                                  intSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  doubleSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  stringSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  boolSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  dateSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                  timestampSchema?: {
                                                                    displayName?:
                                                                      | string
                                                                      | null;
                                                                    description?:
                                                                      | string
                                                                      | null;
                                                                    semanticType?: {
                                                                      country?: {
                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                      } | null;
                                                                      entityReference?: {
                                                                        entity:
                                                                          | {
                                                                              __typename: 'Error';
                                                                              message?:
                                                                                | string
                                                                                | null;
                                                                              code: ErrorCode;
                                                                            }
                                                                          | {
                                                                              __typename: 'MetricsV1Entity';
                                                                              name: string;
                                                                              displayName: string;
                                                                            };
                                                                      } | null;
                                                                      enumType?: {
                                                                        values: Array<{
                                                                          value?:
                                                                            | string
                                                                            | null;
                                                                        }>;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              }>;
                                                            } | null;
                                                            listSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              elementSchema?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                                value?: {
                                                                                  structSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    schema: Array<{
                                                                                      key: string;
                                                                                    }>;
                                                                                  } | null;
                                                                                  intSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  doubleSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  stringSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  boolSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  dateSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                  timestampSchema?: {
                                                                                    displayName?:
                                                                                      | string
                                                                                      | null;
                                                                                    description?:
                                                                                      | string
                                                                                      | null;
                                                                                    semanticType?: {
                                                                                      country?: {
                                                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                      } | null;
                                                                                      entityReference?: {
                                                                                        entity:
                                                                                          | {
                                                                                              __typename: 'Error';
                                                                                              message?:
                                                                                                | string
                                                                                                | null;
                                                                                              code: ErrorCode;
                                                                                            }
                                                                                          | {
                                                                                              __typename: 'MetricsV1Entity';
                                                                                              name: string;
                                                                                              displayName: string;
                                                                                            };
                                                                                      } | null;
                                                                                      enumType?: {
                                                                                        values: Array<{
                                                                                          value?:
                                                                                            | string
                                                                                            | null;
                                                                                        }>;
                                                                                      } | null;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            listSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              elementSchema?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                          value?: {
                                                            structSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              schema: Array<{
                                                                key: string;
                                                              }>;
                                                            } | null;
                                                            intSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            doubleSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            stringSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            boolSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            dateSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                            timestampSchema?: {
                                                              displayName?:
                                                                | string
                                                                | null;
                                                              description?:
                                                                | string
                                                                | null;
                                                              semanticType?: {
                                                                country?: {
                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                } | null;
                                                                entityReference?: {
                                                                  entity:
                                                                    | {
                                                                        __typename: 'Error';
                                                                        message?:
                                                                          | string
                                                                          | null;
                                                                        code: ErrorCode;
                                                                      }
                                                                    | {
                                                                        __typename: 'MetricsV1Entity';
                                                                        name: string;
                                                                        displayName: string;
                                                                      };
                                                                } | null;
                                                                enumType?: {
                                                                  values: Array<{
                                                                    value?:
                                                                      | string
                                                                      | null;
                                                                  }>;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        }>;
                                                      } | null;
                                                      listSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        elementSchema?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                          value?: {
                                                                            structSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              schema: Array<{
                                                                                key: string;
                                                                              }>;
                                                                            } | null;
                                                                            intSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            doubleSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            stringSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            boolSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            dateSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                            timestampSchema?: {
                                                                              displayName?:
                                                                                | string
                                                                                | null;
                                                                              description?:
                                                                                | string
                                                                                | null;
                                                                              semanticType?: {
                                                                                country?: {
                                                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                } | null;
                                                                                entityReference?: {
                                                                                  entity:
                                                                                    | {
                                                                                        __typename: 'Error';
                                                                                        message?:
                                                                                          | string
                                                                                          | null;
                                                                                        code: ErrorCode;
                                                                                      }
                                                                                    | {
                                                                                        __typename: 'MetricsV1Entity';
                                                                                        name: string;
                                                                                        displayName: string;
                                                                                      };
                                                                                } | null;
                                                                                enumType?: {
                                                                                  values: Array<{
                                                                                    value?:
                                                                                      | string
                                                                                      | null;
                                                                                  }>;
                                                                                } | null;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      listSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        elementSchema?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                    value?: {
                                                      structSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        schema: Array<{
                                                          key: string;
                                                        }>;
                                                      } | null;
                                                      intSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      doubleSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      stringSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      boolSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      dateSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                      timestampSchema?: {
                                                        displayName?:
                                                          | string
                                                          | null;
                                                        description?:
                                                          | string
                                                          | null;
                                                        semanticType?: {
                                                          country?: {
                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                          } | null;
                                                          entityReference?: {
                                                            entity:
                                                              | {
                                                                  __typename: 'Error';
                                                                  message?:
                                                                    | string
                                                                    | null;
                                                                  code: ErrorCode;
                                                                }
                                                              | {
                                                                  __typename: 'MetricsV1Entity';
                                                                  name: string;
                                                                  displayName: string;
                                                                };
                                                          } | null;
                                                          enumType?: {
                                                            values: Array<{
                                                              value?:
                                                                | string
                                                                | null;
                                                            }>;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  }>;
                                                } | null;
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                    value?: {
                                                                      structSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        schema: Array<{
                                                                          key: string;
                                                                        }>;
                                                                      } | null;
                                                                      intSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      doubleSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      stringSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      boolSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      dateSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                      timestampSchema?: {
                                                                        displayName?:
                                                                          | string
                                                                          | null;
                                                                        description?:
                                                                          | string
                                                                          | null;
                                                                        semanticType?: {
                                                                          country?: {
                                                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                          } | null;
                                                                          entityReference?: {
                                                                            entity:
                                                                              | {
                                                                                  __typename: 'Error';
                                                                                  message?:
                                                                                    | string
                                                                                    | null;
                                                                                  code: ErrorCode;
                                                                                }
                                                                              | {
                                                                                  __typename: 'MetricsV1Entity';
                                                                                  name: string;
                                                                                  displayName: string;
                                                                                };
                                                                          } | null;
                                                                          enumType?: {
                                                                            values: Array<{
                                                                              value?:
                                                                                | string
                                                                                | null;
                                                                            }>;
                                                                          } | null;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                listSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  elementSchema?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                structSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  schema: Array<{
                                                    key: string;
                                                  }>;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            elementSchema?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{ key: string }>;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      elementSchema?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{ key: string }>;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                    intSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    doubleSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    stringSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    boolSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    dateSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                    timestampSchema?: {
                      displayName?: string | null;
                      description?: string | null;
                      semanticType?: {
                        country?: {
                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                        } | null;
                        entityReference?: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                        } | null;
                        enumType?: {
                          values: Array<{ value?: string | null }>;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
                usageMetadata: {
                  publishCount: any;
                  validationFailedCount: any;
                  lastPublishTime?: string | null;
                  lastValidationFailedTime?: string | null;
                };
              }
            | null;
          client:
            | { __typename: 'Error' }
            | {
                __typename: 'IamV1Client';
                name: string;
                displayName: string;
                lastSeenTime?: string | null;
                createTime: string;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
        }>;
      }
    | null;
};

export type UpdateEventDefinitionMutationVariables = Exact<{
  event: PartialEventsAdminV1EventDefinitionInput;
  updateMask: Scalars['String']['input'];
}>;

export type UpdateEventDefinitionMutation = {
  updateEventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              displayName?: string | null;
              description?: string | null;
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                schema: Array<{
                                  key: string;
                                  value?: {
                                    structSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      schema: Array<{
                                        key: string;
                                        value?: {
                                          structSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            schema: Array<{
                                              key: string;
                                              value?: {
                                                listSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  elementSchema?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                              value?: {
                                                                structSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  schema: Array<{
                                                                    key: string;
                                                                  }>;
                                                                } | null;
                                                                intSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                doubleSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                stringSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                boolSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                dateSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                                timestampSchema?: {
                                                                  displayName?:
                                                                    | string
                                                                    | null;
                                                                  description?:
                                                                    | string
                                                                    | null;
                                                                  semanticType?: {
                                                                    country?: {
                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                    } | null;
                                                                    entityReference?: {
                                                                      entity:
                                                                        | {
                                                                            __typename: 'Error';
                                                                            message?:
                                                                              | string
                                                                              | null;
                                                                            code: ErrorCode;
                                                                          }
                                                                        | {
                                                                            __typename: 'MetricsV1Entity';
                                                                            name: string;
                                                                            displayName: string;
                                                                          };
                                                                    } | null;
                                                                    enumType?: {
                                                                      values: Array<{
                                                                        value?:
                                                                          | string
                                                                          | null;
                                                                      }>;
                                                                    } | null;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            }>;
                                                          } | null;
                                                          listSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            elementSchema?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                              value?: {
                                                                                structSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  schema: Array<{
                                                                                    key: string;
                                                                                  }>;
                                                                                } | null;
                                                                                intSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                doubleSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                stringSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                boolSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                dateSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                                timestampSchema?: {
                                                                                  displayName?:
                                                                                    | string
                                                                                    | null;
                                                                                  description?:
                                                                                    | string
                                                                                    | null;
                                                                                  semanticType?: {
                                                                                    country?: {
                                                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                                    } | null;
                                                                                    entityReference?: {
                                                                                      entity:
                                                                                        | {
                                                                                            __typename: 'Error';
                                                                                            message?:
                                                                                              | string
                                                                                              | null;
                                                                                            code: ErrorCode;
                                                                                          }
                                                                                        | {
                                                                                            __typename: 'MetricsV1Entity';
                                                                                            name: string;
                                                                                            displayName: string;
                                                                                          };
                                                                                    } | null;
                                                                                    enumType?: {
                                                                                      values: Array<{
                                                                                        value?:
                                                                                          | string
                                                                                          | null;
                                                                                      }>;
                                                                                    } | null;
                                                                                  } | null;
                                                                                } | null;
                                                                              } | null;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                intSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                doubleSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                stringSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                boolSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                dateSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                                timestampSchema?: {
                                                  displayName?: string | null;
                                                  description?: string | null;
                                                  semanticType?: {
                                                    country?: {
                                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                    } | null;
                                                    entityReference?: {
                                                      entity:
                                                        | {
                                                            __typename: 'Error';
                                                            message?:
                                                              | string
                                                              | null;
                                                            code: ErrorCode;
                                                          }
                                                        | {
                                                            __typename: 'MetricsV1Entity';
                                                            name: string;
                                                            displayName: string;
                                                          };
                                                    } | null;
                                                    enumType?: {
                                                      values: Array<{
                                                        value?: string | null;
                                                      }>;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            }>;
                                          } | null;
                                          listSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            elementSchema?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                        value?: {
                                                          structSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            schema: Array<{
                                                              key: string;
                                                            }>;
                                                          } | null;
                                                          intSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          doubleSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          stringSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          boolSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          dateSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                          timestampSchema?: {
                                                            displayName?:
                                                              | string
                                                              | null;
                                                            description?:
                                                              | string
                                                              | null;
                                                            semanticType?: {
                                                              country?: {
                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                              } | null;
                                                              entityReference?: {
                                                                entity:
                                                                  | {
                                                                      __typename: 'Error';
                                                                      message?:
                                                                        | string
                                                                        | null;
                                                                      code: ErrorCode;
                                                                    }
                                                                  | {
                                                                      __typename: 'MetricsV1Entity';
                                                                      name: string;
                                                                      displayName: string;
                                                                    };
                                                              } | null;
                                                              enumType?: {
                                                                values: Array<{
                                                                  value?:
                                                                    | string
                                                                    | null;
                                                                }>;
                                                              } | null;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      }>;
                                                    } | null;
                                                    listSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      elementSchema?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                        value?: {
                                                                          structSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            schema: Array<{
                                                                              key: string;
                                                                            }>;
                                                                          } | null;
                                                                          intSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          doubleSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          stringSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          boolSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          dateSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                          timestampSchema?: {
                                                                            displayName?:
                                                                              | string
                                                                              | null;
                                                                            description?:
                                                                              | string
                                                                              | null;
                                                                            semanticType?: {
                                                                              country?: {
                                                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                              } | null;
                                                                              entityReference?: {
                                                                                entity:
                                                                                  | {
                                                                                      __typename: 'Error';
                                                                                      message?:
                                                                                        | string
                                                                                        | null;
                                                                                      code: ErrorCode;
                                                                                    }
                                                                                  | {
                                                                                      __typename: 'MetricsV1Entity';
                                                                                      name: string;
                                                                                      displayName: string;
                                                                                    };
                                                                              } | null;
                                                                              enumType?: {
                                                                                values: Array<{
                                                                                  value?:
                                                                                    | string
                                                                                    | null;
                                                                                }>;
                                                                              } | null;
                                                                            } | null;
                                                                          } | null;
                                                                        } | null;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                          intSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          doubleSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          stringSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          boolSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          dateSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                          timestampSchema?: {
                                            displayName?: string | null;
                                            description?: string | null;
                                            semanticType?: {
                                              country?: {
                                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                              } | null;
                                              entityReference?: {
                                                entity:
                                                  | {
                                                      __typename: 'Error';
                                                      message?: string | null;
                                                      code: ErrorCode;
                                                    }
                                                  | {
                                                      __typename: 'MetricsV1Entity';
                                                      name: string;
                                                      displayName: string;
                                                    };
                                              } | null;
                                              enumType?: {
                                                values: Array<{
                                                  value?: string | null;
                                                }>;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    listSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      elementSchema?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{
                                                  key: string;
                                                  value?: {
                                                    structSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      schema: Array<{
                                                        key: string;
                                                      }>;
                                                    } | null;
                                                    intSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    doubleSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    stringSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    boolSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    dateSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                    timestampSchema?: {
                                                      displayName?:
                                                        | string
                                                        | null;
                                                      description?:
                                                        | string
                                                        | null;
                                                      semanticType?: {
                                                        country?: {
                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                        } | null;
                                                        entityReference?: {
                                                          entity:
                                                            | {
                                                                __typename: 'Error';
                                                                message?:
                                                                  | string
                                                                  | null;
                                                                code: ErrorCode;
                                                              }
                                                            | {
                                                                __typename: 'MetricsV1Entity';
                                                                name: string;
                                                                displayName: string;
                                                              };
                                                        } | null;
                                                        enumType?: {
                                                          values: Array<{
                                                            value?:
                                                              | string
                                                              | null;
                                                          }>;
                                                        } | null;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                }>;
                                              } | null;
                                              listSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                elementSchema?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                  value?: {
                                                                    structSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      schema: Array<{
                                                                        key: string;
                                                                      }>;
                                                                    } | null;
                                                                    intSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    doubleSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    stringSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    boolSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    dateSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                    timestampSchema?: {
                                                                      displayName?:
                                                                        | string
                                                                        | null;
                                                                      description?:
                                                                        | string
                                                                        | null;
                                                                      semanticType?: {
                                                                        country?: {
                                                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                        } | null;
                                                                        entityReference?: {
                                                                          entity:
                                                                            | {
                                                                                __typename: 'Error';
                                                                                message?:
                                                                                  | string
                                                                                  | null;
                                                                                code: ErrorCode;
                                                                              }
                                                                            | {
                                                                                __typename: 'MetricsV1Entity';
                                                                                name: string;
                                                                                displayName: string;
                                                                              };
                                                                        } | null;
                                                                        enumType?: {
                                                                          values: Array<{
                                                                            value?:
                                                                              | string
                                                                              | null;
                                                                          }>;
                                                                        } | null;
                                                                      } | null;
                                                                    } | null;
                                                                  } | null;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    intSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    doubleSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    stringSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    boolSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    dateSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                    timestampSchema?: {
                                      displayName?: string | null;
                                      description?: string | null;
                                      semanticType?: {
                                        country?: {
                                          format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                        } | null;
                                        entityReference?: {
                                          entity:
                                            | {
                                                __typename: 'Error';
                                                message?: string | null;
                                                code: ErrorCode;
                                              }
                                            | {
                                                __typename: 'MetricsV1Entity';
                                                name: string;
                                                displayName: string;
                                              };
                                        } | null;
                                        enumType?: {
                                          values: Array<{
                                            value?: string | null;
                                          }>;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                }>;
                              } | null;
                              listSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                elementSchema?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{
                                            key: string;
                                            value?: {
                                              structSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                schema: Array<{ key: string }>;
                                              } | null;
                                              intSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              doubleSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              stringSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              boolSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              dateSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                              timestampSchema?: {
                                                displayName?: string | null;
                                                description?: string | null;
                                                semanticType?: {
                                                  country?: {
                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                  } | null;
                                                  entityReference?: {
                                                    entity:
                                                      | {
                                                          __typename: 'Error';
                                                          message?:
                                                            | string
                                                            | null;
                                                          code: ErrorCode;
                                                        }
                                                      | {
                                                          __typename: 'MetricsV1Entity';
                                                          name: string;
                                                          displayName: string;
                                                        };
                                                  } | null;
                                                  enumType?: {
                                                    values: Array<{
                                                      value?: string | null;
                                                    }>;
                                                  } | null;
                                                } | null;
                                              } | null;
                                            } | null;
                                          }>;
                                        } | null;
                                        listSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          elementSchema?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                            value?: {
                                                              structSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                schema: Array<{
                                                                  key: string;
                                                                }>;
                                                              } | null;
                                                              intSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              doubleSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              stringSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              boolSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              dateSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                              timestampSchema?: {
                                                                displayName?:
                                                                  | string
                                                                  | null;
                                                                description?:
                                                                  | string
                                                                  | null;
                                                                semanticType?: {
                                                                  country?: {
                                                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                                  } | null;
                                                                  entityReference?: {
                                                                    entity:
                                                                      | {
                                                                          __typename: 'Error';
                                                                          message?:
                                                                            | string
                                                                            | null;
                                                                          code: ErrorCode;
                                                                        }
                                                                      | {
                                                                          __typename: 'MetricsV1Entity';
                                                                          name: string;
                                                                          displayName: string;
                                                                        };
                                                                  } | null;
                                                                  enumType?: {
                                                                    values: Array<{
                                                                      value?:
                                                                        | string
                                                                        | null;
                                                                    }>;
                                                                  } | null;
                                                                } | null;
                                                              } | null;
                                                            } | null;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              intSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              doubleSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              stringSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              boolSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              dateSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                              timestampSchema?: {
                                displayName?: string | null;
                                description?: string | null;
                                semanticType?: {
                                  country?: {
                                    format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                  } | null;
                                  entityReference?: {
                                    entity:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1Entity';
                                          name: string;
                                          displayName: string;
                                        };
                                  } | null;
                                  enumType?: {
                                    values: Array<{ value?: string | null }>;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          elementSchema?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{
                                      key: string;
                                      value?: {
                                        structSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          schema: Array<{ key: string }>;
                                        } | null;
                                        intSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        doubleSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        stringSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        boolSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        dateSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                        timestampSchema?: {
                                          displayName?: string | null;
                                          description?: string | null;
                                          semanticType?: {
                                            country?: {
                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                            } | null;
                                            entityReference?: {
                                              entity:
                                                | {
                                                    __typename: 'Error';
                                                    message?: string | null;
                                                    code: ErrorCode;
                                                  }
                                                | {
                                                    __typename: 'MetricsV1Entity';
                                                    name: string;
                                                    displayName: string;
                                                  };
                                            } | null;
                                            enumType?: {
                                              values: Array<{
                                                value?: string | null;
                                              }>;
                                            } | null;
                                          } | null;
                                        } | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  listSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    elementSchema?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                      value?: {
                                                        structSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          schema: Array<{
                                                            key: string;
                                                          }>;
                                                        } | null;
                                                        intSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        doubleSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        stringSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        boolSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        dateSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                        timestampSchema?: {
                                                          displayName?:
                                                            | string
                                                            | null;
                                                          description?:
                                                            | string
                                                            | null;
                                                          semanticType?: {
                                                            country?: {
                                                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                            } | null;
                                                            entityReference?: {
                                                              entity:
                                                                | {
                                                                    __typename: 'Error';
                                                                    message?:
                                                                      | string
                                                                      | null;
                                                                    code: ErrorCode;
                                                                  }
                                                                | {
                                                                    __typename: 'MetricsV1Entity';
                                                                    name: string;
                                                                    displayName: string;
                                                                  };
                                                            } | null;
                                                            enumType?: {
                                                              values: Array<{
                                                                value?:
                                                                  | string
                                                                  | null;
                                                              }>;
                                                            } | null;
                                                          } | null;
                                                        } | null;
                                                      } | null;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                        intSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        doubleSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        stringSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        boolSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        dateSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                        timestampSchema?: {
                          displayName?: string | null;
                          description?: string | null;
                          semanticType?: {
                            country?: {
                              format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                            } | null;
                            entityReference?: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                            } | null;
                            enumType?: {
                              values: Array<{ value?: string | null }>;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    elementSchema?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{
                                key: string;
                                value?: {
                                  structSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    schema: Array<{ key: string }>;
                                  } | null;
                                  intSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  doubleSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  stringSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  boolSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  dateSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                  timestampSchema?: {
                                    displayName?: string | null;
                                    description?: string | null;
                                    semanticType?: {
                                      country?: {
                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                      } | null;
                                      entityReference?: {
                                        entity:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1Entity';
                                              name: string;
                                              displayName: string;
                                            };
                                      } | null;
                                      enumType?: {
                                        values: Array<{
                                          value?: string | null;
                                        }>;
                                      } | null;
                                    } | null;
                                  } | null;
                                } | null;
                              }>;
                            } | null;
                            listSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              elementSchema?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{
                                                key: string;
                                                value?: {
                                                  structSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    schema: Array<{
                                                      key: string;
                                                    }>;
                                                  } | null;
                                                  intSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  doubleSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  stringSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  boolSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  dateSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                  timestampSchema?: {
                                                    displayName?: string | null;
                                                    description?: string | null;
                                                    semanticType?: {
                                                      country?: {
                                                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                      } | null;
                                                      entityReference?: {
                                                        entity:
                                                          | {
                                                              __typename: 'Error';
                                                              message?:
                                                                | string
                                                                | null;
                                                              code: ErrorCode;
                                                            }
                                                          | {
                                                              __typename: 'MetricsV1Entity';
                                                              name: string;
                                                              displayName: string;
                                                            };
                                                      } | null;
                                                      enumType?: {
                                                        values: Array<{
                                                          value?: string | null;
                                                        }>;
                                                      } | null;
                                                    } | null;
                                                  } | null;
                                                } | null;
                                              }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  } | null;
                  intSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  doubleSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  stringSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  boolSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  dateSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                  timestampSchema?: {
                    displayName?: string | null;
                    description?: string | null;
                    semanticType?: {
                      country?: {
                        format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                      } | null;
                      entityReference?: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                      } | null;
                      enumType?: {
                        values: Array<{ value?: string | null }>;
                      } | null;
                    } | null;
                  } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              displayName?: string | null;
              description?: string | null;
              elementSchema?: {
                structSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        schema: Array<{
                          key: string;
                          value?: {
                            structSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              schema: Array<{ key: string }>;
                            } | null;
                            intSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            doubleSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            stringSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            boolSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            dateSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                            timestampSchema?: {
                              displayName?: string | null;
                              description?: string | null;
                              semanticType?: {
                                country?: {
                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                } | null;
                                entityReference?: {
                                  entity:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1Entity';
                                        name: string;
                                        displayName: string;
                                      };
                                } | null;
                                enumType?: {
                                  values: Array<{ value?: string | null }>;
                                } | null;
                              } | null;
                            } | null;
                          } | null;
                        }>;
                      } | null;
                      listSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        elementSchema?: {
                          structSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  schema: Array<{
                                    key: string;
                                    value?: {
                                      structSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        schema: Array<{
                                          key: string;
                                          value?: {
                                            structSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              schema: Array<{ key: string }>;
                                            } | null;
                                            intSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            doubleSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            stringSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            boolSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            dateSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                            timestampSchema?: {
                                              displayName?: string | null;
                                              description?: string | null;
                                              semanticType?: {
                                                country?: {
                                                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                                } | null;
                                                entityReference?: {
                                                  entity:
                                                    | {
                                                        __typename: 'Error';
                                                        message?: string | null;
                                                        code: ErrorCode;
                                                      }
                                                    | {
                                                        __typename: 'MetricsV1Entity';
                                                        name: string;
                                                        displayName: string;
                                                      };
                                                } | null;
                                                enumType?: {
                                                  values: Array<{
                                                    value?: string | null;
                                                  }>;
                                                } | null;
                                              } | null;
                                            } | null;
                                          } | null;
                                        }>;
                                      } | null;
                                      intSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      doubleSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      stringSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      boolSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      dateSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                      timestampSchema?: {
                                        displayName?: string | null;
                                        description?: string | null;
                                        semanticType?: {
                                          country?: {
                                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                          } | null;
                                          entityReference?: {
                                            entity:
                                              | {
                                                  __typename: 'Error';
                                                  message?: string | null;
                                                  code: ErrorCode;
                                                }
                                              | {
                                                  __typename: 'MetricsV1Entity';
                                                  name: string;
                                                  displayName: string;
                                                };
                                          } | null;
                                          enumType?: {
                                            values: Array<{
                                              value?: string | null;
                                            }>;
                                          } | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                  }>;
                                } | null;
                                intSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                doubleSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                stringSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                boolSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                dateSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                                timestampSchema?: {
                                  displayName?: string | null;
                                  description?: string | null;
                                  semanticType?: {
                                    country?: {
                                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                                    } | null;
                                    entityReference?: {
                                      entity:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1Entity';
                                            name: string;
                                            displayName: string;
                                          };
                                    } | null;
                                    enumType?: {
                                      values: Array<{ value?: string | null }>;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                            }>;
                          } | null;
                          intSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          doubleSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          stringSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          boolSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          dateSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                          timestampSchema?: {
                            displayName?: string | null;
                            description?: string | null;
                            semanticType?: {
                              country?: {
                                format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                              } | null;
                              entityReference?: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                              } | null;
                              enumType?: {
                                values: Array<{ value?: string | null }>;
                              } | null;
                            } | null;
                          } | null;
                        } | null;
                      } | null;
                      intSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      doubleSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      stringSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      boolSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      dateSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                      timestampSchema?: {
                        displayName?: string | null;
                        description?: string | null;
                        semanticType?: {
                          country?: {
                            format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                          } | null;
                          entityReference?: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                          } | null;
                          enumType?: {
                            values: Array<{ value?: string | null }>;
                          } | null;
                        } | null;
                      } | null;
                    } | null;
                  }>;
                } | null;
                intSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                doubleSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                stringSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                boolSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                dateSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
                timestampSchema?: {
                  displayName?: string | null;
                  description?: string | null;
                  semanticType?: {
                    country?: {
                      format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                    } | null;
                    entityReference?: {
                      entity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          };
                    } | null;
                    enumType?: {
                      values: Array<{ value?: string | null }>;
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            intSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            doubleSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            stringSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            boolSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            dateSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
            timestampSchema?: {
              displayName?: string | null;
              description?: string | null;
              semanticType?: {
                country?: {
                  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                enumType?: { values: Array<{ value?: string | null }> } | null;
              } | null;
            } | null;
          } | null;
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        usageMetadata: {
          publishCount: any;
          validationFailedCount: any;
          lastPublishTime?: string | null;
          lastValidationFailedTime?: string | null;
        };
      }
    | null;
};

export type CreateExternalDocumentMutationVariables = Exact<{
  externalDocument: CollaborationV1ExternalDocumentInput;
  externalDocumentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateExternalDocumentMutation = {
  createExternalDocument?:
    | {
        __typename: 'CollaborationV1ExternalDocument';
        name: string;
        resource: string;
        title?: string | null;
        markdown?: string | null;
        createTime: string;
        updateTime: string;
        source: {
          type: CollaborationV1ExternalDocumentSourceType;
          sourceId: string;
          uri?: string | null;
        };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteExternalDocumentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteExternalDocumentMutation = {
  deleteExternalDocument?:
    | { __typename: 'CollaborationV1ExternalDocument'; name: string }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ExternalDocumentRefFragment = {
  __typename: 'CollaborationV1ExternalDocument';
  name: string;
  resource: string;
  title?: string | null;
  markdown?: string | null;
  createTime: string;
  updateTime: string;
  source: {
    type: CollaborationV1ExternalDocumentSourceType;
    sourceId: string;
    uri?: string | null;
  };
};

export type ExternalDocumentRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ExternalDocumentRefQuery = {
  externalDocument?:
    | {
        __typename: 'CollaborationV1ExternalDocument';
        name: string;
        resource: string;
        title?: string | null;
        markdown?: string | null;
        createTime: string;
        updateTime: string;
        source: {
          type: CollaborationV1ExternalDocumentSourceType;
          sourceId: string;
          uri?: string | null;
        };
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type SearchProviderDocumentsQueryVariables = Exact<{
  provider: CollaborationV1SearchProvider;
  query?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchProviderDocumentsQuery = {
  searchProviderDocuments?:
    | {
        nextPageToken?: string | null;
        pages: Array<{
          id?: string | null;
          title?: string | null;
          icon?: string | null;
          mimeType?: string | null;
          lastEditedTime?: string | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CancelScheduledMaterializedSegmentLoadJobMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CancelScheduledMaterializedSegmentLoadJobMutation = {
  cancelScheduledMaterializedSegmentLoadJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
        name: string;
        sql: string;
        entityIdColumn: string;
        state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
        createTime: string;
        updateTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        scheduleIntervals: Array<string>;
        nextScheduledRunTime?: string | null;
        executedLoadJobsCount?: number | null;
        attempt?: number | null;
        errorMessage?: string | null;
      }
    | null;
};

export type CreateMaterializedSegmentLoadJobMutationVariables = Exact<{
  materializedSegmentLoadJob: MaterializerV1MaterializedSegmentLoadJobInput;
  materializedSegmentLoadJobId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
}>;

export type CreateMaterializedSegmentLoadJobMutation = {
  createMaterializedSegmentLoadJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1MaterializedSegmentLoadJob';
        name: string;
        sql: string;
        entityIdColumn: string;
        state?: MaterializerV1MaterializedSegmentLoadJobJobState | null;
        createTime: string;
        updateTime: string;
        progress: number;
        rowCount?: any | null;
        errorMessage?: string | null;
        exportStartTime?: string | null;
        exportEndTime?: string | null;
        schedule?:
          | { __typename: 'Error' }
          | {
              __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
              name: string;
            }
          | null;
        ingestionStatus?: {
          ingestionStartTime: string;
          ingestionEndTime?: string | null;
          ingestionRate?: number | null;
          progress: number;
          state?: MaterializerV1IngestionStatusState | null;
        } | null;
        bloomFilterStatus?: {
          state: MaterializerV1BloomFilterStatusState;
          progress: number;
          bloomFilterStartTime?: string | null;
          bloomFilterEndTime?: string | null;
          details?: {
            keyCount: any;
            sizeBytes: any;
            falsePositiveRate: number;
          } | null;
        } | null;
      }
    | null;
};

export type CreateScheduledMaterializedSegmentLoadJobMutationVariables = Exact<{
  scheduledMaterializedSegmentLoadJob: MaterializerV1ScheduledMaterializedSegmentLoadJobInput;
  scheduledMaterializedSegmentLoadJobId?: InputMaybe<
    Scalars['String']['input']
  >;
  parent: Scalars['String']['input'];
}>;

export type CreateScheduledMaterializedSegmentLoadJobMutation = {
  createScheduledMaterializedSegmentLoadJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
        name: string;
        sql: string;
        entityIdColumn: string;
        state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
        createTime: string;
        updateTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        scheduleIntervals: Array<string>;
        nextScheduledRunTime?: string | null;
        executedLoadJobsCount?: number | null;
        attempt?: number | null;
        errorMessage?: string | null;
      }
    | null;
};

export type MaterializedSegmentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type MaterializedSegmentQuery = {
  materializedSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1MaterializedSegment';
        name: string;
        displayName: string;
        createTime: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
      }
    | null;
};

export type MaterializedSegmentLoadJobFragment = {
  __typename: 'MaterializerV1MaterializedSegmentLoadJob';
  name: string;
  sql: string;
  entityIdColumn: string;
  state?: MaterializerV1MaterializedSegmentLoadJobJobState | null;
  createTime: string;
  updateTime: string;
  progress: number;
  rowCount?: any | null;
  errorMessage?: string | null;
  exportStartTime?: string | null;
  exportEndTime?: string | null;
  schedule?:
    | { __typename: 'Error' }
    | {
        __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
        name: string;
      }
    | null;
  ingestionStatus?: {
    ingestionStartTime: string;
    ingestionEndTime?: string | null;
    ingestionRate?: number | null;
    progress: number;
    state?: MaterializerV1IngestionStatusState | null;
  } | null;
  bloomFilterStatus?: {
    state: MaterializerV1BloomFilterStatusState;
    progress: number;
    bloomFilterStartTime?: string | null;
    bloomFilterEndTime?: string | null;
    details?: {
      keyCount: any;
      sizeBytes: any;
      falsePositiveRate: number;
    } | null;
  } | null;
};

export type MaterializedSegmentLoadJobsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MaterializedSegmentLoadJobsQuery = {
  materializedSegmentLoadJobs?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1ListMaterializedSegmentLoadJobsResponse';
        nextPageToken?: string | null;
        materializedSegmentLoadJobs: Array<{
          __typename: 'MaterializerV1MaterializedSegmentLoadJob';
          name: string;
          sql: string;
          entityIdColumn: string;
          state?: MaterializerV1MaterializedSegmentLoadJobJobState | null;
          createTime: string;
          updateTime: string;
          progress: number;
          rowCount?: any | null;
          errorMessage?: string | null;
          exportStartTime?: string | null;
          exportEndTime?: string | null;
          schedule?:
            | { __typename: 'Error' }
            | {
                __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
                name: string;
              }
            | null;
          ingestionStatus?: {
            ingestionStartTime: string;
            ingestionEndTime?: string | null;
            ingestionRate?: number | null;
            progress: number;
            state?: MaterializerV1IngestionStatusState | null;
          } | null;
          bloomFilterStatus?: {
            state: MaterializerV1BloomFilterStatusState;
            progress: number;
            bloomFilterStartTime?: string | null;
            bloomFilterEndTime?: string | null;
            details?: {
              keyCount: any;
              sizeBytes: any;
              falsePositiveRate: number;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type MaterializedSegmentWithSchedulesFragment = {
  __typename: 'FlagsAdminV1MaterializedSegment';
  name: string;
  displayName: string;
  createTime: string;
  updateTime: string;
  scheduledMaterializedSegmentLoadJobs?:
    | { __typename: 'Error' }
    | {
        __typename: 'MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse';
        scheduledMaterializedSegmentLoadJobs: Array<{
          __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
          name: string;
          state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
        }>;
      }
    | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type MaterializedSegmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MaterializedSegmentsQuery = {
  materializedSegments?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListMaterializedSegmentsResponse';
        nextPageToken?: string | null;
        materializedSegments: Array<{
          __typename: 'FlagsAdminV1MaterializedSegment';
          name: string;
          displayName: string;
          createTime: string;
          updateTime: string;
          scheduledMaterializedSegmentLoadJobs?:
            | { __typename: 'Error' }
            | {
                __typename: 'MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse';
                scheduledMaterializedSegmentLoadJobs: Array<{
                  __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
                  name: string;
                  state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
                }>;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        }>;
      }
    | null;
};

export type OnMaterializedSegmentLoadJobUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnMaterializedSegmentLoadJobUpdatedSubscription = {
  materializedSegmentLoadJobUpdated?: {
    loadJob?: {
      __typename: 'MaterializerV1MaterializedSegmentLoadJob';
      name: string;
      sql: string;
      entityIdColumn: string;
      state?: MaterializerV1MaterializedSegmentLoadJobJobState | null;
      createTime: string;
      updateTime: string;
      progress: number;
      rowCount?: any | null;
      errorMessage?: string | null;
      exportStartTime?: string | null;
      exportEndTime?: string | null;
      schedule?:
        | { __typename: 'Error' }
        | {
            __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
            name: string;
          }
        | null;
      ingestionStatus?: {
        ingestionStartTime: string;
        ingestionEndTime?: string | null;
        ingestionRate?: number | null;
        progress: number;
        state?: MaterializerV1IngestionStatusState | null;
      } | null;
      bloomFilterStatus?: {
        state: MaterializerV1BloomFilterStatusState;
        progress: number;
        bloomFilterStartTime?: string | null;
        bloomFilterEndTime?: string | null;
        details?: {
          keyCount: any;
          sizeBytes: any;
          falsePositiveRate: number;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ResumeScheduledMaterializedSegmentLoadJobMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ResumeScheduledMaterializedSegmentLoadJobMutation = {
  resumeScheduledMaterializedSegmentLoadJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
        name: string;
        sql: string;
        entityIdColumn: string;
        state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
        createTime: string;
        updateTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        scheduleIntervals: Array<string>;
        nextScheduledRunTime?: string | null;
        executedLoadJobsCount?: number | null;
        attempt?: number | null;
        errorMessage?: string | null;
      }
    | null;
};

export type ScheduledMaterializedSegmentLoadJobFragment = {
  __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
  name: string;
  sql: string;
  entityIdColumn: string;
  state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
  createTime: string;
  updateTime: string;
  scheduleStartTime: string;
  scheduleEndTime?: string | null;
  scheduleIntervals: Array<string>;
  nextScheduledRunTime?: string | null;
  executedLoadJobsCount?: number | null;
  attempt?: number | null;
  errorMessage?: string | null;
};

export type ScheduledMaterializedSegmentLoadJobsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ScheduledMaterializedSegmentLoadJobsQuery = {
  scheduledMaterializedSegmentLoadJobs?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse';
        nextPageToken?: string | null;
        scheduledMaterializedSegmentLoadJobs: Array<{
          __typename: 'MaterializerV1ScheduledMaterializedSegmentLoadJob';
          name: string;
          sql: string;
          entityIdColumn: string;
          state?: MaterializerV1ScheduledMaterializedSegmentLoadJobState | null;
          createTime: string;
          updateTime: string;
          scheduleStartTime: string;
          scheduleEndTime?: string | null;
          scheduleIntervals: Array<string>;
          nextScheduledRunTime?: string | null;
          executedLoadJobsCount?: number | null;
          attempt?: number | null;
          errorMessage?: string | null;
        }>;
      }
    | null;
};

export type UpdateMaterializedSegmentMutationVariables = Exact<{
  input: PartialFlagsAdminV1MaterializedSegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateMaterializedSegmentMutation = {
  updateMaterializedSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1MaterializedSegment';
        name: string;
        displayName: string;
        createTime: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
      }
    | null;
};

export type AiWorkflowInstanceFragment = {
  __typename: 'AiworkflowsV1AiWorkflowInstance';
  name: string;
  mode?: AiworkflowsV1Mode | null;
  taskType: AiworkflowsV1TaskType;
  actorType: AiworkflowsV1ActorType;
  state?: AiworkflowsV1State | null;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  schedule?:
    | { __typename: 'AiworkflowsV1AiWorkflowSchedule'; name: string }
    | Record<PropertyKey, never>
    | null;
};

export type AiWorkflowInstancesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AiWorkflowInstancesQuery = {
  aiWorkflowInstances?:
    | {
        __typename: 'AiworkflowsV1ListAiWorkflowInstancesResponse';
        aiWorkflowInstances: Array<{
          __typename: 'AiworkflowsV1AiWorkflowInstance';
          name: string;
          mode?: AiworkflowsV1Mode | null;
          taskType: AiworkflowsV1TaskType;
          actorType: AiworkflowsV1ActorType;
          state?: AiworkflowsV1State | null;
          createTime: string;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          schedule?:
            | { __typename: 'AiworkflowsV1AiWorkflowSchedule'; name: string }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AiWorkflowScheduleFragment = {
  __typename: 'AiworkflowsV1AiWorkflowSchedule';
  name: string;
  actorType: AiworkflowsV1ActorType;
  taskType: AiworkflowsV1TaskType;
  intervalMinutes: number;
  scheduleState?: AiworkflowsV1ScheduleState | null;
  lastRunTime?: string | null;
  nextRunTime?: string | null;
  executedCount?: number | null;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
};

export type AiWorkflowSchedulesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AiWorkflowSchedulesQuery = {
  aiWorkflowSchedules?:
    | {
        __typename: 'AiworkflowsV1ListAiWorkflowSchedulesResponse';
        aiWorkflowSchedules: Array<{
          __typename: 'AiworkflowsV1AiWorkflowSchedule';
          name: string;
          actorType: AiworkflowsV1ActorType;
          taskType: AiworkflowsV1TaskType;
          intervalMinutes: number;
          scheduleState?: AiworkflowsV1ScheduleState | null;
          lastRunTime?: string | null;
          nextRunTime?: string | null;
          executedCount?: number | null;
          createTime: string;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ArchiveFlagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ArchiveFlagMutation = {
  archiveFlag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        archiveTime?: string | null;
        state: FlagsAdminV1FlagState;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        schema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  schema: Array<{ key: string }>;
                                } | null;
                                listSchema?: {
                                  elementSchema?: {
                                    intSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    doubleSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    stringSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    boolSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: { dummy?: string | null } | null;
                                doubleSchema?: { dummy?: string | null } | null;
                                stringSchema?: { dummy?: string | null } | null;
                                boolSchema?: { dummy?: string | null } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        variants: Array<{
          __typename: 'FlagsAdminV1FlagVariant';
          name: string;
          description?: string | null;
          value: any;
          imageUri?: string | null;
          createTime: string;
          updateTime: string;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
        rules: Array<{
          __typename: 'FlagsAdminV1FlagRule';
          name: string;
          enabled: boolean;
          updateTime: string;
          targetingKeySelector?: string | null;
          description?: string | null;
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
          assignmentSpec: {
            bucketCount?: number | null;
            assignments: Array<{
              assignmentId?: string | null;
              variant?: {
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              } | null;
              fallthrough?: { dummy?: string | null } | null;
              clientDefault?: { dummy?: string | null } | null;
              bucketRanges: Array<{ lower: number; upper: number }>;
            }>;
          };
          materializationSpec?: {
            mode?: {
              materializationMustMatch?: boolean | null;
              segmentTargetingCanBeIgnored?: boolean | null;
            } | null;
            readMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
            writeMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
        }>;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type CancelAiWorkflowScheduleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CancelAiWorkflowScheduleMutation = {
  cancelAiWorkflowSchedule?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowSchedule';
        name: string;
        actorType: AiworkflowsV1ActorType;
        taskType: AiworkflowsV1TaskType;
        intervalMinutes: number;
        scheduleState?: AiworkflowsV1ScheduleState | null;
        lastRunTime?: string | null;
        nextRunTime?: string | null;
        executedCount?: number | null;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CheckSdkCompatibilityMutationVariables = Exact<{
  featureIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type CheckSdkCompatibilityMutation = {
  checkSdkCompatibility?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1CheckSdkCompatibilityResponse';
        featureCompatibilities: Array<{
          featureId?: string | null;
          displayName?: string | null;
          status?: InsightsV1CompatibilityStatus | null;
          incompatibleSdks: Array<{
            sdkDisplayName?: string | null;
            currentVersion?: string | null;
            requiredVersion?: string | null;
          }>;
        }>;
        activeSdks: Array<{
          sdkDisplayName?: string | null;
          sdkId?: string | null;
          version?: string | null;
          resolveMode?: InsightsV1SdkResolveMode | null;
        }>;
      }
    | null;
};

export type CreateAiWorkflowInstanceMutationVariables = Exact<{
  input: AiworkflowsV1AiWorkflowInstanceInput;
}>;

export type CreateAiWorkflowInstanceMutation = {
  createAiWorkflowInstance?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowInstance';
        name: string;
        mode?: AiworkflowsV1Mode | null;
        taskType: AiworkflowsV1TaskType;
        actorType: AiworkflowsV1ActorType;
        state?: AiworkflowsV1State | null;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        schedule?:
          | { __typename: 'AiworkflowsV1AiWorkflowSchedule'; name: string }
          | Record<PropertyKey, never>
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateAiWorkflowScheduleMutationVariables = Exact<{
  input: AiworkflowsV1AiWorkflowScheduleInput;
}>;

export type CreateAiWorkflowScheduleMutation = {
  createAiWorkflowSchedule?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowSchedule';
        name: string;
        actorType: AiworkflowsV1ActorType;
        taskType: AiworkflowsV1TaskType;
        intervalMinutes: number;
        scheduleState?: AiworkflowsV1ScheduleState | null;
        lastRunTime?: string | null;
        nextRunTime?: string | null;
        executedCount?: number | null;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateCleanupTasksMutationVariables = Exact<{
  name: Scalars['String']['input'];
  targets:
    | Array<AiworkflowsV1CleanupTargetInput>
    | AiworkflowsV1CleanupTargetInput;
}>;

export type CreateCleanupTasksMutation = {
  createCleanupTasks?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowInstance';
        name: string;
        mode?: AiworkflowsV1Mode | null;
        taskType: AiworkflowsV1TaskType;
        actorType: AiworkflowsV1ActorType;
        state?: AiworkflowsV1State | null;
        createTime: string;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        schedule?:
          | { __typename: 'AiworkflowsV1AiWorkflowSchedule'; name: string }
          | Record<PropertyKey, never>
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateFlagMutationVariables = Exact<{
  flagId: Scalars['String']['input'];
  flag: FlagsAdminV1FlagInput;
}>;

export type CreateFlagMutation = {
  createFlag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        archiveTime?: string | null;
        state: FlagsAdminV1FlagState;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        schema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  schema: Array<{ key: string }>;
                                } | null;
                                listSchema?: {
                                  elementSchema?: {
                                    intSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    doubleSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    stringSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    boolSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: { dummy?: string | null } | null;
                                doubleSchema?: { dummy?: string | null } | null;
                                stringSchema?: { dummy?: string | null } | null;
                                boolSchema?: { dummy?: string | null } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        variants: Array<{
          __typename: 'FlagsAdminV1FlagVariant';
          name: string;
          description?: string | null;
          value: any;
          imageUri?: string | null;
          createTime: string;
          updateTime: string;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
        rules: Array<{
          __typename: 'FlagsAdminV1FlagRule';
          name: string;
          enabled: boolean;
          updateTime: string;
          targetingKeySelector?: string | null;
          description?: string | null;
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
          assignmentSpec: {
            bucketCount?: number | null;
            assignments: Array<{
              assignmentId?: string | null;
              variant?: {
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              } | null;
              fallthrough?: { dummy?: string | null } | null;
              clientDefault?: { dummy?: string | null } | null;
              bucketRanges: Array<{ lower: number; upper: number }>;
            }>;
          };
          materializationSpec?: {
            mode?: {
              materializationMustMatch?: boolean | null;
              segmentTargetingCanBeIgnored?: boolean | null;
            } | null;
            readMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
            writeMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
        }>;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type CreateMaterializedSegmentMutationVariables = Exact<{
  materializationId?: InputMaybe<Scalars['String']['input']>;
  materializedSegment: FlagsAdminV1MaterializedSegmentInput;
}>;

export type CreateMaterializedSegmentMutation = {
  createMaterializedSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1MaterializedSegment';
        name: string;
        displayName: string;
        createTime: string;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
      }
    | null;
};

export type CreateRuleMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  rule: FlagsAdminV1FlagRuleInput;
}>;

export type CreateRuleMutation = {
  createRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        enabled: boolean;
        updateTime: string;
        targetingKeySelector?: string | null;
        description?: string | null;
        segment:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            };
        assignmentSpec: {
          bucketCount?: number | null;
          assignments: Array<{
            assignmentId?: string | null;
            variant?: {
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            } | null;
            fallthrough?: { dummy?: string | null } | null;
            clientDefault?: { dummy?: string | null } | null;
            bucketRanges: Array<{ lower: number; upper: number }>;
          }>;
        };
        materializationSpec?: {
          mode?: {
            materializationMustMatch?: boolean | null;
            segmentTargetingCanBeIgnored?: boolean | null;
          } | null;
          readMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
          writeMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
      }
    | null;
};

export type DeleteRuleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteRuleMutation = {
  deleteRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type FlagFragment = {
  __typename: 'FlagsAdminV1Flag';
  name: string;
  description?: string | null;
  createTime: string;
  updateTime: string;
  archiveTime?: string | null;
  state: FlagsAdminV1FlagState;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  updater:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  labels: Array<{ key: string; value?: string | null }>;
  schema?: {
    schema: Array<{
      key: string;
      value?: {
        structSchema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{ key: string }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        listSchema?: {
          elementSchema?: {
            intSchema?: { dummy?: string | null } | null;
            doubleSchema?: { dummy?: string | null } | null;
            stringSchema?: { dummy?: string | null } | null;
            boolSchema?: { dummy?: string | null } | null;
          } | null;
        } | null;
        intSchema?: { dummy?: string | null } | null;
        doubleSchema?: { dummy?: string | null } | null;
        stringSchema?: { dummy?: string | null } | null;
        boolSchema?: { dummy?: string | null } | null;
      } | null;
    }>;
  } | null;
  variants: Array<{
    __typename: 'FlagsAdminV1FlagVariant';
    name: string;
    description?: string | null;
    value: any;
    imageUri?: string | null;
    createTime: string;
    updateTime: string;
    resourceRelations?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FgaV1ListResourceRelationsResponse';
          resourceRelations: Array<{ relation: string }>;
        }
      | null;
  }>;
  rules: Array<{
    __typename: 'FlagsAdminV1FlagRule';
    name: string;
    enabled: boolean;
    updateTime: string;
    targetingKeySelector?: string | null;
    description?: string | null;
    segment:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FlagsAdminV1Segment';
          name: string;
          displayName?: string | null;
          description?: string | null;
          state?: FlagsAdminV1SegmentState | null;
          createTime: string;
          updateTime: string;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                displayName: string;
              }
            | null;
          workflowInstance?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          allocation?: {
            exclusiveTo: Array<string>;
            exclusivityTags: Array<string>;
            proportion?: { value?: string | null } | null;
          } | null;
          targeting?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attributeName?: string | null;
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                  anyRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                  allRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                } | null;
                segment?: {
                  segment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Segment';
                        name: string;
                        displayName?: string | null;
                        labels: Array<{ key: string; value?: string | null }>;
                      }
                    | null;
                } | null;
                materializedSegment?: {
                  materializedSegment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1MaterializedSegment';
                        name: string;
                        displayName: string;
                      }
                    | null;
                } | null;
              } | null;
            }>;
            expression?: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        };
    assignmentSpec: {
      bucketCount?: number | null;
      assignments: Array<{
        assignmentId?: string | null;
        variant?: {
          variant:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
        } | null;
        fallthrough?: { dummy?: string | null } | null;
        clientDefault?: { dummy?: string | null } | null;
        bucketRanges: Array<{ lower: number; upper: number }>;
      }>;
    };
    materializationSpec?: {
      mode?: {
        materializationMustMatch?: boolean | null;
        segmentTargetingCanBeIgnored?: boolean | null;
      } | null;
      readMaterialization?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
        | null;
      writeMaterialization?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
        | null;
    } | null;
    resourceRelations?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FgaV1ListResourceRelationsResponse';
          resourceRelations: Array<{ relation: string }>;
        }
      | null;
    labels: Array<{ key: string; value?: string | null }>;
    environments: Array<
      | {
          __typename: 'FlagsAdminV1Environment';
          name: string;
          color?: string | null;
          description?: string | null;
          deleteTime?: string | null;
        }
      | Record<PropertyKey, never>
    >;
  }>;
  clients: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Client';
        name: string;
        displayName: string;
        createTime: string;
        deleteTime?: string | null;
      }
  >;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  usageMetadata?: {
    lastApplyTime?: string | null;
    lastResolveTime?: string | null;
  } | null;
};

export type FlagQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type FlagQuery = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        archiveTime?: string | null;
        state: FlagsAdminV1FlagState;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        schema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  schema: Array<{ key: string }>;
                                } | null;
                                listSchema?: {
                                  elementSchema?: {
                                    intSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    doubleSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    stringSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    boolSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: { dummy?: string | null } | null;
                                doubleSchema?: { dummy?: string | null } | null;
                                stringSchema?: { dummy?: string | null } | null;
                                boolSchema?: { dummy?: string | null } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        variants: Array<{
          __typename: 'FlagsAdminV1FlagVariant';
          name: string;
          description?: string | null;
          value: any;
          imageUri?: string | null;
          createTime: string;
          updateTime: string;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
        rules: Array<{
          __typename: 'FlagsAdminV1FlagRule';
          name: string;
          enabled: boolean;
          updateTime: string;
          targetingKeySelector?: string | null;
          description?: string | null;
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
          assignmentSpec: {
            bucketCount?: number | null;
            assignments: Array<{
              assignmentId?: string | null;
              variant?: {
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              } | null;
              fallthrough?: { dummy?: string | null } | null;
              clientDefault?: { dummy?: string | null } | null;
              bucketRanges: Array<{ lower: number; upper: number }>;
            }>;
          };
          materializationSpec?: {
            mode?: {
              materializationMustMatch?: boolean | null;
              segmentTargetingCanBeIgnored?: boolean | null;
            } | null;
            readMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
            writeMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
        }>;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type FlagClientFragment = {
  __typename: 'IamV1Client';
  name: string;
  displayName: string;
  createTime: string;
  deleteTime?: string | null;
};

export type FlagRefFragment = { __typename: 'FlagsAdminV1Flag'; name: string };

export type FlagsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type FlagsQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{ __typename: 'FlagsAdminV1Flag'; name: string }>;
      }
    | null;
};

export type MaterializedSegmentFragment = {
  __typename: 'FlagsAdminV1MaterializedSegment';
  name: string;
  displayName: string;
  createTime: string;
  updateTime: string;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type OnFlagCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnFlagCreatedSubscription = {
  flagCreated?: {
    flag?: {
      __typename: 'FlagsAdminV1Flag';
      name: string;
      description?: string | null;
      createTime: string;
      updateTime: string;
      archiveTime?: string | null;
      state: FlagsAdminV1FlagState;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      updater:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      labels: Array<{ key: string; value?: string | null }>;
      schema?: {
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                schema: Array<{ key: string }>;
                              } | null;
                              listSchema?: {
                                elementSchema?: {
                                  intSchema?: { dummy?: string | null } | null;
                                  doubleSchema?: {
                                    dummy?: string | null;
                                  } | null;
                                  stringSchema?: {
                                    dummy?: string | null;
                                  } | null;
                                  boolSchema?: { dummy?: string | null } | null;
                                } | null;
                              } | null;
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          elementSchema?: {
                            intSchema?: { dummy?: string | null } | null;
                            doubleSchema?: { dummy?: string | null } | null;
                            stringSchema?: { dummy?: string | null } | null;
                            boolSchema?: { dummy?: string | null } | null;
                          } | null;
                        } | null;
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    elementSchema?: {
                      intSchema?: { dummy?: string | null } | null;
                      doubleSchema?: { dummy?: string | null } | null;
                      stringSchema?: { dummy?: string | null } | null;
                      boolSchema?: { dummy?: string | null } | null;
                    } | null;
                  } | null;
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              elementSchema?: {
                intSchema?: { dummy?: string | null } | null;
                doubleSchema?: { dummy?: string | null } | null;
                stringSchema?: { dummy?: string | null } | null;
                boolSchema?: { dummy?: string | null } | null;
              } | null;
            } | null;
            intSchema?: { dummy?: string | null } | null;
            doubleSchema?: { dummy?: string | null } | null;
            stringSchema?: { dummy?: string | null } | null;
            boolSchema?: { dummy?: string | null } | null;
          } | null;
        }>;
      } | null;
      variants: Array<{
        __typename: 'FlagsAdminV1FlagVariant';
        name: string;
        description?: string | null;
        value: any;
        imageUri?: string | null;
        createTime: string;
        updateTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }>;
      rules: Array<{
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        enabled: boolean;
        updateTime: string;
        targetingKeySelector?: string | null;
        description?: string | null;
        segment:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            };
        assignmentSpec: {
          bucketCount?: number | null;
          assignments: Array<{
            assignmentId?: string | null;
            variant?: {
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            } | null;
            fallthrough?: { dummy?: string | null } | null;
            clientDefault?: { dummy?: string | null } | null;
            bucketRanges: Array<{ lower: number; upper: number }>;
          }>;
        };
        materializationSpec?: {
          mode?: {
            materializationMustMatch?: boolean | null;
            segmentTargetingCanBeIgnored?: boolean | null;
          } | null;
          readMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
          writeMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
      }>;
      clients: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Client';
            name: string;
            displayName: string;
            createTime: string;
            deleteTime?: string | null;
          }
      >;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      usageMetadata?: {
        lastApplyTime?: string | null;
        lastResolveTime?: string | null;
      } | null;
    } | null;
  } | null;
};

export type OnFlagUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnFlagUpdatedSubscription = {
  flagUpdated?: {
    flag?: {
      __typename: 'FlagsAdminV1Flag';
      name: string;
      description?: string | null;
      createTime: string;
      updateTime: string;
      archiveTime?: string | null;
      state: FlagsAdminV1FlagState;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      updater:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      labels: Array<{ key: string; value?: string | null }>;
      schema?: {
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          schema: Array<{
                            key: string;
                            value?: {
                              structSchema?: {
                                schema: Array<{ key: string }>;
                              } | null;
                              listSchema?: {
                                elementSchema?: {
                                  intSchema?: { dummy?: string | null } | null;
                                  doubleSchema?: {
                                    dummy?: string | null;
                                  } | null;
                                  stringSchema?: {
                                    dummy?: string | null;
                                  } | null;
                                  boolSchema?: { dummy?: string | null } | null;
                                } | null;
                              } | null;
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          }>;
                        } | null;
                        listSchema?: {
                          elementSchema?: {
                            intSchema?: { dummy?: string | null } | null;
                            doubleSchema?: { dummy?: string | null } | null;
                            stringSchema?: { dummy?: string | null } | null;
                            boolSchema?: { dummy?: string | null } | null;
                          } | null;
                        } | null;
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    elementSchema?: {
                      intSchema?: { dummy?: string | null } | null;
                      doubleSchema?: { dummy?: string | null } | null;
                      stringSchema?: { dummy?: string | null } | null;
                      boolSchema?: { dummy?: string | null } | null;
                    } | null;
                  } | null;
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              elementSchema?: {
                intSchema?: { dummy?: string | null } | null;
                doubleSchema?: { dummy?: string | null } | null;
                stringSchema?: { dummy?: string | null } | null;
                boolSchema?: { dummy?: string | null } | null;
              } | null;
            } | null;
            intSchema?: { dummy?: string | null } | null;
            doubleSchema?: { dummy?: string | null } | null;
            stringSchema?: { dummy?: string | null } | null;
            boolSchema?: { dummy?: string | null } | null;
          } | null;
        }>;
      } | null;
      variants: Array<{
        __typename: 'FlagsAdminV1FlagVariant';
        name: string;
        description?: string | null;
        value: any;
        imageUri?: string | null;
        createTime: string;
        updateTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }>;
      rules: Array<{
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        enabled: boolean;
        updateTime: string;
        targetingKeySelector?: string | null;
        description?: string | null;
        segment:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            };
        assignmentSpec: {
          bucketCount?: number | null;
          assignments: Array<{
            assignmentId?: string | null;
            variant?: {
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            } | null;
            fallthrough?: { dummy?: string | null } | null;
            clientDefault?: { dummy?: string | null } | null;
            bucketRanges: Array<{ lower: number; upper: number }>;
          }>;
        };
        materializationSpec?: {
          mode?: {
            materializationMustMatch?: boolean | null;
            segmentTargetingCanBeIgnored?: boolean | null;
          } | null;
          readMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
          writeMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
      }>;
      clients: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Client';
            name: string;
            displayName: string;
            createTime: string;
            deleteTime?: string | null;
          }
      >;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      usageMetadata?: {
        lastApplyTime?: string | null;
        lastResolveTime?: string | null;
      } | null;
    } | null;
  } | null;
};

export type RuleFragment = {
  __typename: 'FlagsAdminV1FlagRule';
  name: string;
  enabled: boolean;
  updateTime: string;
  targetingKeySelector?: string | null;
  description?: string | null;
  segment:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      };
  assignmentSpec: {
    bucketCount?: number | null;
    assignments: Array<{
      assignmentId?: string | null;
      variant?: {
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      } | null;
      fallthrough?: { dummy?: string | null } | null;
      clientDefault?: { dummy?: string | null } | null;
      bucketRanges: Array<{ lower: number; upper: number }>;
    }>;
  };
  materializationSpec?: {
    mode?: {
      materializationMustMatch?: boolean | null;
      segmentTargetingCanBeIgnored?: boolean | null;
    } | null;
    readMaterialization?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
      | null;
    writeMaterialization?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
      | null;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  environments: Array<
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
        description?: string | null;
        deleteTime?: string | null;
      }
    | Record<PropertyKey, never>
  >;
};

export type EntryFragment = {
  key: string;
  value?: {
    structSchema?: {
      schema: Array<{
        key: string;
        value?: {
          structSchema?: {
            schema: Array<{
              key: string;
              value?: {
                structSchema?: {
                  schema: Array<{
                    key: string;
                    value?: {
                      structSchema?: { schema: Array<{ key: string }> } | null;
                      listSchema?: {
                        elementSchema?: {
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      } | null;
                      intSchema?: { dummy?: string | null } | null;
                      doubleSchema?: { dummy?: string | null } | null;
                      stringSchema?: { dummy?: string | null } | null;
                      boolSchema?: { dummy?: string | null } | null;
                    } | null;
                  }>;
                } | null;
                listSchema?: {
                  elementSchema?: {
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                } | null;
                intSchema?: { dummy?: string | null } | null;
                doubleSchema?: { dummy?: string | null } | null;
                stringSchema?: { dummy?: string | null } | null;
                boolSchema?: { dummy?: string | null } | null;
              } | null;
            }>;
          } | null;
          listSchema?: {
            elementSchema?: {
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          } | null;
          intSchema?: { dummy?: string | null } | null;
          doubleSchema?: { dummy?: string | null } | null;
          stringSchema?: { dummy?: string | null } | null;
          boolSchema?: { dummy?: string | null } | null;
        } | null;
      }>;
    } | null;
    listSchema?: {
      elementSchema?: {
        intSchema?: { dummy?: string | null } | null;
        doubleSchema?: { dummy?: string | null } | null;
        stringSchema?: { dummy?: string | null } | null;
        boolSchema?: { dummy?: string | null } | null;
      } | null;
    } | null;
    intSchema?: { dummy?: string | null } | null;
    doubleSchema?: { dummy?: string | null } | null;
    stringSchema?: { dummy?: string | null } | null;
    boolSchema?: { dummy?: string | null } | null;
  } | null;
};

export type BoolSchemaFragment = {
  boolSchema?: { dummy?: string | null } | null;
};

export type IntSchemaFragment = {
  intSchema?: { dummy?: string | null } | null;
};

export type DoubleSchemaFragment = {
  doubleSchema?: { dummy?: string | null } | null;
};

export type StringSchemaFragment = {
  stringSchema?: { dummy?: string | null } | null;
};

export type ListSchemaFragment = {
  listSchema?: {
    elementSchema?: {
      intSchema?: { dummy?: string | null } | null;
      doubleSchema?: { dummy?: string | null } | null;
      stringSchema?: { dummy?: string | null } | null;
      boolSchema?: { dummy?: string | null } | null;
    } | null;
  } | null;
};

export type StructSchemaFragment = {
  structSchema?: {
    schema: Array<{
      key: string;
      value?: {
        structSchema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: { schema: Array<{ key: string }> } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        listSchema?: {
          elementSchema?: {
            intSchema?: { dummy?: string | null } | null;
            doubleSchema?: { dummy?: string | null } | null;
            stringSchema?: { dummy?: string | null } | null;
            boolSchema?: { dummy?: string | null } | null;
          } | null;
        } | null;
        intSchema?: { dummy?: string | null } | null;
        doubleSchema?: { dummy?: string | null } | null;
        stringSchema?: { dummy?: string | null } | null;
        boolSchema?: { dummy?: string | null } | null;
      } | null;
    }>;
  } | null;
};

export type SchemaFragment = {
  schema: Array<{
    key: string;
    value?: {
      structSchema?: {
        schema: Array<{
          key: string;
          value?: {
            structSchema?: {
              schema: Array<{
                key: string;
                value?: {
                  structSchema?: {
                    schema: Array<{
                      key: string;
                      value?: {
                        structSchema?: {
                          schema: Array<{ key: string }>;
                        } | null;
                        listSchema?: {
                          elementSchema?: {
                            intSchema?: { dummy?: string | null } | null;
                            doubleSchema?: { dummy?: string | null } | null;
                            stringSchema?: { dummy?: string | null } | null;
                            boolSchema?: { dummy?: string | null } | null;
                          } | null;
                        } | null;
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    }>;
                  } | null;
                  listSchema?: {
                    elementSchema?: {
                      intSchema?: { dummy?: string | null } | null;
                      doubleSchema?: { dummy?: string | null } | null;
                      stringSchema?: { dummy?: string | null } | null;
                      boolSchema?: { dummy?: string | null } | null;
                    } | null;
                  } | null;
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              }>;
            } | null;
            listSchema?: {
              elementSchema?: {
                intSchema?: { dummy?: string | null } | null;
                doubleSchema?: { dummy?: string | null } | null;
                stringSchema?: { dummy?: string | null } | null;
                boolSchema?: { dummy?: string | null } | null;
              } | null;
            } | null;
            intSchema?: { dummy?: string | null } | null;
            doubleSchema?: { dummy?: string | null } | null;
            stringSchema?: { dummy?: string | null } | null;
            boolSchema?: { dummy?: string | null } | null;
          } | null;
        }>;
      } | null;
      listSchema?: {
        elementSchema?: {
          intSchema?: { dummy?: string | null } | null;
          doubleSchema?: { dummy?: string | null } | null;
          stringSchema?: { dummy?: string | null } | null;
          boolSchema?: { dummy?: string | null } | null;
        } | null;
      } | null;
      intSchema?: { dummy?: string | null } | null;
      doubleSchema?: { dummy?: string | null } | null;
      stringSchema?: { dummy?: string | null } | null;
      boolSchema?: { dummy?: string | null } | null;
    } | null;
  }>;
};

export type UnarchiveFlagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UnarchiveFlagMutation = {
  unarchiveFlag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        archiveTime?: string | null;
        state: FlagsAdminV1FlagState;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        schema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  schema: Array<{ key: string }>;
                                } | null;
                                listSchema?: {
                                  elementSchema?: {
                                    intSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    doubleSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    stringSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    boolSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: { dummy?: string | null } | null;
                                doubleSchema?: { dummy?: string | null } | null;
                                stringSchema?: { dummy?: string | null } | null;
                                boolSchema?: { dummy?: string | null } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        variants: Array<{
          __typename: 'FlagsAdminV1FlagVariant';
          name: string;
          description?: string | null;
          value: any;
          imageUri?: string | null;
          createTime: string;
          updateTime: string;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
        rules: Array<{
          __typename: 'FlagsAdminV1FlagRule';
          name: string;
          enabled: boolean;
          updateTime: string;
          targetingKeySelector?: string | null;
          description?: string | null;
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
          assignmentSpec: {
            bucketCount?: number | null;
            assignments: Array<{
              assignmentId?: string | null;
              variant?: {
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              } | null;
              fallthrough?: { dummy?: string | null } | null;
              clientDefault?: { dummy?: string | null } | null;
              bucketRanges: Array<{ lower: number; upper: number }>;
            }>;
          };
          materializationSpec?: {
            mode?: {
              materializationMustMatch?: boolean | null;
              segmentTargetingCanBeIgnored?: boolean | null;
            } | null;
            readMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
            writeMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
        }>;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type UpdateFlagMutationVariables = Exact<{
  input: PartialFlagsAdminV1FlagInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateFlagMutation = {
  updateFlag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        archiveTime?: string | null;
        state: FlagsAdminV1FlagState;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        schema?: {
          schema: Array<{
            key: string;
            value?: {
              structSchema?: {
                schema: Array<{
                  key: string;
                  value?: {
                    structSchema?: {
                      schema: Array<{
                        key: string;
                        value?: {
                          structSchema?: {
                            schema: Array<{
                              key: string;
                              value?: {
                                structSchema?: {
                                  schema: Array<{ key: string }>;
                                } | null;
                                listSchema?: {
                                  elementSchema?: {
                                    intSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    doubleSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    stringSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                    boolSchema?: {
                                      dummy?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                intSchema?: { dummy?: string | null } | null;
                                doubleSchema?: { dummy?: string | null } | null;
                                stringSchema?: { dummy?: string | null } | null;
                                boolSchema?: { dummy?: string | null } | null;
                              } | null;
                            }>;
                          } | null;
                          listSchema?: {
                            elementSchema?: {
                              intSchema?: { dummy?: string | null } | null;
                              doubleSchema?: { dummy?: string | null } | null;
                              stringSchema?: { dummy?: string | null } | null;
                              boolSchema?: { dummy?: string | null } | null;
                            } | null;
                          } | null;
                          intSchema?: { dummy?: string | null } | null;
                          doubleSchema?: { dummy?: string | null } | null;
                          stringSchema?: { dummy?: string | null } | null;
                          boolSchema?: { dummy?: string | null } | null;
                        } | null;
                      }>;
                    } | null;
                    listSchema?: {
                      elementSchema?: {
                        intSchema?: { dummy?: string | null } | null;
                        doubleSchema?: { dummy?: string | null } | null;
                        stringSchema?: { dummy?: string | null } | null;
                        boolSchema?: { dummy?: string | null } | null;
                      } | null;
                    } | null;
                    intSchema?: { dummy?: string | null } | null;
                    doubleSchema?: { dummy?: string | null } | null;
                    stringSchema?: { dummy?: string | null } | null;
                    boolSchema?: { dummy?: string | null } | null;
                  } | null;
                }>;
              } | null;
              listSchema?: {
                elementSchema?: {
                  intSchema?: { dummy?: string | null } | null;
                  doubleSchema?: { dummy?: string | null } | null;
                  stringSchema?: { dummy?: string | null } | null;
                  boolSchema?: { dummy?: string | null } | null;
                } | null;
              } | null;
              intSchema?: { dummy?: string | null } | null;
              doubleSchema?: { dummy?: string | null } | null;
              stringSchema?: { dummy?: string | null } | null;
              boolSchema?: { dummy?: string | null } | null;
            } | null;
          }>;
        } | null;
        variants: Array<{
          __typename: 'FlagsAdminV1FlagVariant';
          name: string;
          description?: string | null;
          value: any;
          imageUri?: string | null;
          createTime: string;
          updateTime: string;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
        rules: Array<{
          __typename: 'FlagsAdminV1FlagRule';
          name: string;
          enabled: boolean;
          updateTime: string;
          targetingKeySelector?: string | null;
          description?: string | null;
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              };
          assignmentSpec: {
            bucketCount?: number | null;
            assignments: Array<{
              assignmentId?: string | null;
              variant?: {
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              } | null;
              fallthrough?: { dummy?: string | null } | null;
              clientDefault?: { dummy?: string | null } | null;
              bucketRanges: Array<{ lower: number; upper: number }>;
            }>;
          };
          materializationSpec?: {
            mode?: {
              materializationMustMatch?: boolean | null;
              segmentTargetingCanBeIgnored?: boolean | null;
            } | null;
            readMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
            writeMaterialization?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          environments: Array<
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
                description?: string | null;
                deleteTime?: string | null;
              }
            | Record<PropertyKey, never>
          >;
        }>;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type UpdateRuleMutationVariables = Exact<{
  input: PartialFlagsAdminV1FlagRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateRuleMutation = {
  updateRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        enabled: boolean;
        updateTime: string;
        targetingKeySelector?: string | null;
        description?: string | null;
        segment:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            };
        assignmentSpec: {
          bucketCount?: number | null;
          assignments: Array<{
            assignmentId?: string | null;
            variant?: {
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            } | null;
            fallthrough?: { dummy?: string | null } | null;
            clientDefault?: { dummy?: string | null } | null;
            bucketRanges: Array<{ lower: number; upper: number }>;
          }>;
        };
        materializationSpec?: {
          mode?: {
            materializationMustMatch?: boolean | null;
            segmentTargetingCanBeIgnored?: boolean | null;
          } | null;
          readMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
          writeMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
      }
    | null;
};

export type VariantFragment = {
  __typename: 'FlagsAdminV1FlagVariant';
  name: string;
  description?: string | null;
  value: any;
  imageUri?: string | null;
  createTime: string;
  updateTime: string;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type VariantQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type VariantQuery = {
  variant?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagVariant';
        name: string;
        description?: string | null;
        value: any;
        imageUri?: string | null;
        createTime: string;
        updateTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type FlagIndexPageQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type FlagIndexPageQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{
          __typename: 'FlagsAdminV1Flag';
          name: string;
          createTime: string;
          archiveTime?: string | null;
          state: FlagsAdminV1FlagState;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | null;
          variants: Array<{
            __typename: 'FlagsAdminV1FlagVariant';
            name: string;
          }>;
          rules: Array<{ __typename: 'FlagsAdminV1FlagRule'; name: string }>;
          usageMetadata?: {
            lastApplyTime?: string | null;
            lastResolveTime?: string | null;
          } | null;
        }>;
      }
    | null;
};

export type FlagListItemFragment = {
  __typename: 'FlagsAdminV1Flag';
  name: string;
  createTime: string;
  archiveTime?: string | null;
  state: FlagsAdminV1FlagState;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | null;
  variants: Array<{ __typename: 'FlagsAdminV1FlagVariant'; name: string }>;
  rules: Array<{ __typename: 'FlagsAdminV1FlagRule'; name: string }>;
  usageMetadata?: {
    lastApplyTime?: string | null;
    lastResolveTime?: string | null;
  } | null;
};

export type ArchiveUserCreatedSegmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ArchiveUserCreatedSegmentMutation = {
  archiveSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        state?: FlagsAdminV1SegmentState | null;
      }
    | null;
};

export type AvailableClientsQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableClientsQuery = {
  clients?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientsResponse';
        nextPageToken?: string | null;
        clients: Array<{
          displayName: string;
          name: string;
          clientCredentials?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ListClientCredentialsResponse';
                clientCredentials: Array<{
                  name: string;
                  displayName: string;
                  sdkType?: IamV1ClientCredentialSdkType | null;
                  createTime: string;
                  creator:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                      };
                  environments: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'FlagsAdminV1Environment'; name: string }
                  >;
                  clientSecret?: { secret?: string | null } | null;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type CreateVariantMutationVariables = Exact<{
  variant: FlagsAdminV1FlagVariantInput;
  parent: Scalars['String']['input'];
}>;

export type CreateVariantMutation = {
  createVariant?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagVariant';
        name: string;
        description?: string | null;
        value: any;
        imageUri?: string | null;
        createTime: string;
        updateTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type DeleteVariantMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteVariantMutation = {
  deleteVariant?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeriveClientEvaluationContextSchemaMutationVariables = Exact<{
  schema:
    | Array<FlagsAdminV1EvaluationContextSchemaSchemaEntryInput>
    | FlagsAdminV1EvaluationContextSchemaSchemaEntryInput;
  clients: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DeriveClientEvaluationContextSchemaMutation = {
  deriveClientEvaluationContextSchema?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1DeriveClientEvaluationContextSchemaResponse';
        capped?: boolean | null;
        mergedSchema?: {
          schema: Array<{
            key: string;
            value?: {
              types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
              displayName?: string | null;
              hidden?: boolean | null;
              seenValues: Array<any>;
              semanticType?: {
                enumType?: { values: Array<{ value?: string | null }> } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                country?: {
                  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                timestamp?: { dummy?: string | null } | null;
                date?: { dummy?: string | null } | null;
                version?: { dummy?: string | null } | null;
              } | null;
            } | null;
          }>;
        } | null;
      }
    | null;
};

export type FlagOptionFragment = {
  name: string;
  variants: Array<{ name: string }>;
};

export type FlagsFilterQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FlagsFilterQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{ name: string }>;
      }
    | null;
};

export type FlagsOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FlagsOptionsQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{ name: string; variants: Array<{ name: string }> }>;
      }
    | null;
};

export type GetMergedClientSchemaMutationVariables = Exact<{
  clients: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetMergedClientSchemaMutation = {
  deriveClientEvaluationContextSchema?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1DeriveClientEvaluationContextSchemaResponse';
        capped?: boolean | null;
        mergedSchema?: {
          schema: Array<{
            key: string;
            value?: {
              types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
              displayName?: string | null;
              hidden?: boolean | null;
              seenValues: Array<any>;
              semanticType?: {
                enumType?: { values: Array<{ value?: string | null }> } | null;
                entityReference?: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                } | null;
                country?: {
                  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
                } | null;
                timestamp?: { dummy?: string | null } | null;
                date?: { dummy?: string | null } | null;
                version?: { dummy?: string | null } | null;
              } | null;
            } | null;
          }>;
        } | null;
      }
    | null;
};

export type GetWorkflowInstanceDisplayNamesQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetWorkflowInstanceDisplayNamesQuery = {
  workflowInstances?:
    | {
        nextPageToken?: string | null;
        workflowInstances: Array<{ name: string; displayName: string }>;
      }
    | Record<PropertyKey, never>
    | null;
};

export type ListSnippetSecretsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSnippetSecretsQuery = {
  clientCredentials?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientCredentialsResponse';
        nextPageToken?: string | null;
        clientCredentials: Array<{
          displayName: string;
          name: string;
          clientSecret?: { secret?: string | null } | null;
        }>;
      }
    | null;
};

export type ResolveFlagsVerboseMutationVariables = Exact<{
  clientSecret: Scalars['String']['input'];
  flags?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  evaluationContext?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type ResolveFlagsVerboseMutation = {
  resolveFlagsVerbose?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsResolverAdminV1ResolveFlagsVerboseResponse';
        resolvedFlags: Array<{
          reason?: FlagsResolverV1ResolveReason | null;
          value?: any | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1Flag'; name: string }
            | null;
          ruleDetails: Array<{
            ruleEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason;
            segmentEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1FlagRule';
                  name: string;
                  enabled: boolean;
                  updateTime: string;
                  targetingKeySelector?: string | null;
                  description?: string | null;
                  segment:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Segment';
                        name: string;
                        displayName?: string | null;
                        description?: string | null;
                        state?: FlagsAdminV1SegmentState | null;
                        createTime: string;
                        updateTime: string;
                        flag?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Flag';
                              name: string;
                              displayName: string;
                            }
                          | null;
                        workflowInstance?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'WorkflowV1WorkflowInstance';
                              name: string;
                              displayName: string;
                            }
                          | null;
                        owner?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                            }
                          | null;
                        allocation?: {
                          exclusiveTo: Array<string>;
                          exclusivityTags: Array<string>;
                          proportion?: { value?: string | null } | null;
                        } | null;
                        targeting?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attributeName?: string | null;
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                                anyRule?: {
                                  rule?: {
                                    eqRule?: {
                                      value?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    startsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                    containsRule?: {
                                      value?: string | null;
                                    } | null;
                                    endsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                allRule?: {
                                  rule?: {
                                    eqRule?: {
                                      value?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    startsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                    containsRule?: {
                                      value?: string | null;
                                    } | null;
                                    endsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              segment?: {
                                segment?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'FlagsAdminV1Segment';
                                      name: string;
                                      displayName?: string | null;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                    }
                                  | null;
                              } | null;
                              materializedSegment?: {
                                materializedSegment?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'FlagsAdminV1MaterializedSegment';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                            } | null;
                          }>;
                          expression?: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          } | null;
                        } | null;
                        labels: Array<{ key: string; value?: string | null }>;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{
                                relation: string;
                                resource: string;
                              }>;
                            }
                          | null;
                      };
                  assignmentSpec: {
                    bucketCount?: number | null;
                    assignments: Array<{
                      assignmentId?: string | null;
                      variant?: {
                        variant:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1FlagVariant';
                              name: string;
                            };
                      } | null;
                      fallthrough?: { dummy?: string | null } | null;
                      clientDefault?: { dummy?: string | null } | null;
                      bucketRanges: Array<{ lower: number; upper: number }>;
                    }>;
                  };
                  materializationSpec?: {
                    mode?: {
                      materializationMustMatch?: boolean | null;
                      segmentTargetingCanBeIgnored?: boolean | null;
                    } | null;
                    readMaterialization?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                        }
                      | null;
                    writeMaterialization?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  environments: Array<
                    | {
                        __typename: 'FlagsAdminV1Environment';
                        name: string;
                        color?: string | null;
                        description?: string | null;
                        deleteTime?: string | null;
                      }
                    | Record<PropertyKey, never>
                  >;
                }
              | null;
          }>;
          variant?: { name: string } | Record<PropertyKey, never> | null;
        }>;
      }
    | null;
};

export type ResolvedClientFragment = {
  displayName: string;
  name: string;
  clientCredentials?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientCredentialsResponse';
        clientCredentials: Array<{
          name: string;
          displayName: string;
          sdkType?: IamV1ClientCredentialSdkType | null;
          createTime: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
              };
          environments: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1Environment'; name: string }
          >;
          clientSecret?: { secret?: string | null } | null;
        }>;
      }
    | null;
};

export type ResolvedClientCredentialFragment = {
  name: string;
  displayName: string;
  sdkType?: IamV1ClientCredentialSdkType | null;
  createTime: string;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string; displayName: string };
  environments: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'FlagsAdminV1Environment'; name: string }
  >;
  clientSecret?: { secret?: string | null } | null;
};

export type RuleDetailsFragment = {
  ruleEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason;
  segmentEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason;
  rule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        enabled: boolean;
        updateTime: string;
        targetingKeySelector?: string | null;
        description?: string | null;
        segment:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            };
        assignmentSpec: {
          bucketCount?: number | null;
          assignments: Array<{
            assignmentId?: string | null;
            variant?: {
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            } | null;
            fallthrough?: { dummy?: string | null } | null;
            clientDefault?: { dummy?: string | null } | null;
            bucketRanges: Array<{ lower: number; upper: number }>;
          }>;
        };
        materializationSpec?: {
          mode?: {
            materializationMustMatch?: boolean | null;
            segmentTargetingCanBeIgnored?: boolean | null;
          } | null;
          readMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
          writeMaterialization?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1MaterializedSegment'; name: string }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        environments: Array<
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
              description?: string | null;
              deleteTime?: string | null;
            }
          | Record<PropertyKey, never>
        >;
      }
    | null;
};

export type RuleResolvedCounterQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RuleResolvedCounterQuery = {
  rule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagRule';
        usageMetadata: {
          __typename: 'FlagsAdminV1FlagRuleUsageMetadata';
          resolveCount?: any | null;
          lastResolveTime?: string | null;
        };
      }
    | null;
};

export type SchemaEntryFragment = {
  key: string;
  value?: {
    types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
    displayName?: string | null;
    hidden?: boolean | null;
    seenValues: Array<any>;
    semanticType?: {
      enumType?: { values: Array<{ value?: string | null }> } | null;
      entityReference?: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
      } | null;
      country?: {
        format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
      } | null;
      timestamp?: { dummy?: string | null } | null;
      date?: { dummy?: string | null } | null;
      version?: { dummy?: string | null } | null;
    } | null;
  } | null;
};

export type SegmentReferencesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type SegmentReferencesQuery = {
  querySegmentReferences?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1QuerySegmentReferencesResponse';
        segmentReferences: Array<{
          segment:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                state?: FlagsAdminV1SegmentState | null;
              };
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                displayName: string;
                state: FlagsAdminV1FlagState;
                rules: Array<{
                  name: string;
                  segment:
                    | { __typename: 'FlagsAdminV1Segment'; name: string }
                    | Record<PropertyKey, never>;
                }>;
              }
            | null;
          workflowInstance?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
                state: string;
              }
            | null;
        }>;
      }
    | null;
};

export type SnippetClientFragment = { displayName: string; name: string };

export type SnippetSecretFragment = {
  displayName: string;
  name: string;
  clientSecret?: { secret?: string | null } | null;
};

export type UpdateVariantMutationVariables = Exact<{
  variant: PartialFlagsAdminV1FlagVariantInput;
}>;

export type UpdateVariantMutation = {
  updateVariant?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1FlagVariant';
        name: string;
        description?: string | null;
        value: any;
        imageUri?: string | null;
        createTime: string;
        updateTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UsageChartQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;

export type UsageChartQuery = {
  queryFlagUsage?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1QueryFlagUsageResponse';
        usage: Array<{
          hourTime: string;
          variants: Array<{
            key: string;
            value?: { resolveCount?: any | null } | null;
          }>;
        }>;
      }
    | null;
};

export type AccountBillingQueryVariables = Exact<{ [key: string]: never }>;

export type AccountBillingQuery = {
  accountBilling?:
    | {
        __typename: 'BillingV1AccountBilling';
        name: string;
        managementMode?: BillingV1AccountBillingBillingManagementMode | null;
        billingInfo?: {
          subscription?: {
            status?: BillingV1SubscriptionStatus | null;
            trialEndTime?: string | null;
            cancelAtPeriodEnd?: boolean | null;
            currentPeriodEndTime?: string | null;
          } | null;
          credits?: { granted?: any | null; consumed?: any | null } | null;
        } | null;
        billingHistory?: {
          trialedBillingProducts: Array<
            | { __typename: 'BillingV1BillingProduct'; name: string }
            | { __typename: 'Error' }
          >;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AccountSetupQueryVariables = Exact<{ [key: string]: never }>;

export type AccountSetupQuery = {
  currentAccount?:
    | {
        __typename: 'AdminV1AccountInfo';
        mode?: AdminV1AccountMode | null;
        billingManagementMode?: AdminV1AccountBillingManagementMode | null;
        createTime: string;
        blocked?: boolean | null;
        serviceTier?: {
          __typename: 'AdminV1ServiceTier';
          tier: AdminV1ServiceTierTier;
          entitlements: Array<{
            __typename: 'AdminV1ServiceTierEntitlementsEntry';
            key: string;
            value?: {
              booleanValue?: boolean | null;
              integerValue?: any | null;
              unlimited?: {
                __typename: 'AdminV1EntitlementValueUnlimited';
              } | null;
            } | null;
          }>;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CurrentUser';
        account: string;
        identity: {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        };
        user?: {
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          lastLoginTime?: string | null;
        } | null;
        accountMemberships: Array<{
          __typename: 'IamV1CurrentUserAccountMembership';
          account: string;
          displayName: string;
          externalId: string;
          loginId: string;
        }>;
      }
    | null;
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
        demoData?: boolean | null;
        hasManagedWarehouse?: boolean | null;
        hasCustomerWarehouse?: boolean | null;
      }
    | null;
  dataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDataWarehousesResponse';
        dataWarehouses: Array<{
          __typename: 'MetricsV1DataWarehouse';
          name: string;
        }>;
      }
    | null;
};

export type BillingProductFragment = {
  __typename: 'BillingV1BillingProduct';
  name: string;
  displayName?: string | null;
  description?: string | null;
  prices: Array<{
    amountCents?: any | null;
    currencyCode?: string | null;
    recurringInterval?: string | null;
    recurringIntervalCount?: number | null;
    amountType?: BillingV1ProductPriceAmountType | null;
  }>;
  plan?: {
    tier?: string | null;
    pricingModel?: BillingV1BillingProductPlanPricingModel | null;
    trialAvailable?: boolean | null;
    entitlements: Array<{
      key: string;
      value?: {
        booleanValue?: boolean | null;
        integerValue?: any | null;
        unlimited?: { dummy?: string | null } | null;
        custom?: { dummy?: string | null } | null;
      } | null;
    }>;
  } | null;
  creditPack?: { credits?: any | null } | null;
};

export type BillingProductsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type BillingProductsQuery = {
  billingProducts?:
    | {
        __typename: 'BillingV1ListBillingProductsResponse';
        nextPageToken?: string | null;
        billingProducts: Array<{
          __typename: 'BillingV1BillingProduct';
          name: string;
          displayName?: string | null;
          description?: string | null;
          prices: Array<{
            amountCents?: any | null;
            currencyCode?: string | null;
            recurringInterval?: string | null;
            recurringIntervalCount?: number | null;
            amountType?: BillingV1ProductPriceAmountType | null;
          }>;
          plan?: {
            tier?: string | null;
            pricingModel?: BillingV1BillingProductPlanPricingModel | null;
            trialAvailable?: boolean | null;
            entitlements: Array<{
              key: string;
              value?: {
                booleanValue?: boolean | null;
                integerValue?: any | null;
                unlimited?: { dummy?: string | null } | null;
                custom?: { dummy?: string | null } | null;
              } | null;
            }>;
          } | null;
          creditPack?: { credits?: any | null } | null;
        }>;
      }
    | { __typename: 'Error'; code: ErrorCode; message?: string | null }
    | null;
};

export type CreditUsageQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  usageFeature?: InputMaybe<UsageV1EventsUsageFeature>;
}>;

export type CreditUsageQuery = {
  queryCreditUsage?:
    | {
        __typename: 'BillingV1CreditUsageReport';
        startTime?: string | null;
        endTime?: string | null;
        totalCredits?: string | null;
        nextPageToken?: string | null;
        totalSize?: number | null;
        lines: Array<{
          attributionResource?: string | null;
          usageFeature?: UsageV1EventsUsageFeature | null;
          usageDelta?: any | null;
          credits?: string | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreditUsageChatsQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreditUsageChatsQuery = {
  chats?:
    | {
        __typename: 'ConversationsV2ListChatsResponse';
        nextPageToken?: string | null;
        chats: Array<{ name: string; displayName?: string | null }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreditUsageInstancesQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreditUsageInstancesQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          name: string;
          displayName: string;
          state: string;
        }>;
      }
    | null;
};

export type DefaultErrorFragment = {
  __typename: 'Error';
  message?: string | null;
  code: ErrorCode;
};

export type StartCheckoutSessionMutationVariables = Exact<{
  products?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  returnUri?: InputMaybe<Scalars['String']['input']>;
  successUri?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartCheckoutSessionMutation = {
  startCheckoutSession?:
    | { __typename: 'BillingV1CheckoutSession'; checkoutUri?: string | null }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type StartCustomerPortalSessionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type StartCustomerPortalSessionMutation = {
  startCustomerPortalSession?:
    | {
        __typename: 'BillingV1CustomerPortalSession';
        customerPortalUri?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type InactiveFlagFragment = {
  __typename: 'FlagsAdminV1Flag';
  name: string;
  usageMetadata?: { lastApplyTime?: string | null } | null;
};

export type AppWorkflowInstanceFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  displayName: string;
  state: string;
  name: string;
  updateTime: string;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
    completed?: { startTime: string; endTime: string } | null;
  } | null;
  checks: Array<{
    name: string;
    state: WorkflowV1WorkflowInstanceCheckState;
    displayName?: string | null;
    message: string;
    updateTime: string;
    labels: Array<{ key: string; value?: string | null }>;
  }>;
  moduleData2: {
    planning?: {
      planned?: { startTime?: string | null; endTime?: string | null } | null;
      actual?: { endTime?: string | null } | null;
    } | null;
  };
};

export type AppWorkflowInstanceCheckFragment = {
  name: string;
  state: WorkflowV1WorkflowInstanceCheckState;
  displayName?: string | null;
  message: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
};

export type TodoQueryVariables = Exact<{
  troubledFilter?: InputMaybe<Scalars['String']['input']>;
  overdueFilter?: InputMaybe<Scalars['String']['input']>;
  endingFilter?: InputMaybe<Scalars['String']['input']>;
  runningFilter?: InputMaybe<Scalars['String']['input']>;
  delayedFilter?: InputMaybe<Scalars['String']['input']>;
  readyFilter?: InputMaybe<Scalars['String']['input']>;
  reviewRequestedFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TodoQuery = {
  troubled?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  overdue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  ending?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  running?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  delayed?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  ready?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
        }>;
      }
    | null;
  reviewRequested?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          displayName: string;
          state: string;
          name: string;
          updateTime: string;
          moduleData2: {
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
              } | null;
              actual?: { endTime?: string | null } | null;
            } | null;
          };
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
            completed?: { startTime: string; endTime: string } | null;
          } | null;
          checks: Array<{
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            displayName?: string | null;
            message: string;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
        }>;
      }
    | null;
};

export type AgentFragment = {
  __typename: 'IamV1Agent';
  name: string;
  displayName: string;
  description?: string | null;
  pictureUri?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  identity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string };
  reviewerSkill?: { enabled: boolean; instructions: string } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type AgentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AgentQuery = {
  agent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Agent';
        name: string;
        displayName: string;
        description?: string | null;
        pictureUri?: string | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string };
        reviewerSkill?: { enabled: boolean; instructions: string } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type AgentsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AgentsQuery = {
  agents?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListAgentsResponse';
        nextPageToken?: string | null;
        agents: Array<{
          __typename: 'IamV1Agent';
          name: string;
          displayName: string;
          description?: string | null;
          pictureUri?: string | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'IamV1Identity'; name: string };
          reviewerSkill?: { enabled: boolean; instructions: string } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type ApiClientFragment = {
  __typename: 'IamV1ApiClient';
  name: string;
  displayName: string;
  description?: string | null;
  clientId: string;
  clientSecret?: string | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type ApiClientRefFragment = {
  __typename: 'IamV1ApiClient';
  name: string;
  displayName: string;
  description?: string | null;
};

export type ApiClientsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ApiClientsQuery = {
  apiClients?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListApiClientsResponse';
        nextPageToken?: string | null;
        apiClients: Array<{
          __typename: 'IamV1ApiClient';
          name: string;
          displayName: string;
          description?: string | null;
        }>;
      }
    | null;
};

export type ClientFragment = {
  __typename: 'IamV1Client';
  name: string;
  displayName: string;
  lastSeenTime?: string | null;
  createTime: string;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type ClientQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ClientQuery = {
  client?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Client';
        name: string;
        displayName: string;
        lastSeenTime?: string | null;
        createTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type ClientRefFragment = {
  __typename: 'IamV1Client';
  name: string;
  displayName: string;
  lastSeenTime?: string | null;
  createTime: string;
};

export type ClientsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ClientsQuery = {
  clients?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientsResponse';
        nextPageToken?: string | null;
        clients: Array<{
          __typename: 'IamV1Client';
          name: string;
          displayName: string;
          lastSeenTime?: string | null;
          createTime: string;
        }>;
      }
    | null;
};

export type CreateAgentMutationVariables = Exact<{
  agent: IamV1AgentInput;
  agentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateAgentMutation = {
  createAgent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Agent';
        name: string;
        displayName: string;
        description?: string | null;
        pictureUri?: string | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string };
        reviewerSkill?: { enabled: boolean; instructions: string } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateClientMutationVariables = Exact<{
  client: IamV1ClientInput;
}>;

export type CreateClientMutation = {
  createClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Client';
        name: string;
        displayName: string;
        lastSeenTime?: string | null;
        createTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateGroupMutationVariables = Exact<{
  input: IamV1GroupInput;
}>;

export type CreateGroupMutation = {
  createGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Group';
        name: string;
        displayName: string;
        description?: string | null;
        groupType: IamV1GroupGroupType;
        slackChannel?: string | null;
        createTime: string;
        updateTime: string;
        identity: { name: string } | Record<PropertyKey, never>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateRoleMutationVariables = Exact<{
  input: IamV1RoleInput;
}>;

export type CreateRoleMutation = {
  createRole?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Role';
        name: string;
        displayName: string;
        builtin?: boolean | null;
        permissions: Array<{
          category: IamV1PermissionCategory;
          description?: string | null;
          type: IamV1PermissionType;
        }>;
      }
    | null;
};

export type CurrentUserFragment = {
  __typename: 'IamV1CurrentUser';
  account: string;
  user?: {
    __typename: 'IamV1User';
    name: string;
    fullName: string;
    email: string;
    pictureUri?: string | null;
    lastLoginTime?: string | null;
    slackUserInfo?: { user: string; team: string } | null;
  } | null;
  identity: {
    __typename: 'IamV1Identity';
    name: string;
    displayName: string;
    pictureUri?: string | null;
    service?: string | null;
    everyone?: boolean | null;
    user?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          scimExternalId?: string | null;
          lastLoginTime?: string | null;
        }
      | null;
    apiClient?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1ApiClient';
          name: string;
          displayName: string;
          description?: string | null;
          clientId: string;
          clientSecret?: string | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }
      | null;
    group?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Group';
          name: string;
          displayName: string;
          description?: string | null;
          groupType: IamV1GroupGroupType;
          slackChannel?: string | null;
          createTime: string;
          updateTime: string;
          identity: { name: string } | Record<PropertyKey, never>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }
      | null;
    agent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Agent';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          reviewerSkill?: { enabled: boolean } | null;
        }
      | null;
  };
  accountMemberships: Array<{
    account: string;
    displayName: string;
    externalId: string;
    loginId: string;
    portalInstanceUri?: string | null;
  }>;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CurrentUser';
        account: string;
        user?: {
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          lastLoginTime?: string | null;
          slackUserInfo?: { user: string; team: string } | null;
        } | null;
        identity: {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        };
        accountMemberships: Array<{
          account: string;
          displayName: string;
          externalId: string;
          loginId: string;
          portalInstanceUri?: string | null;
        }>;
      }
    | null;
};

export type CurrentUserGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserGroupsQuery = {
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1CurrentUser';
        user?: {
          name: string;
          userGroups?:
            | {
                __typename: 'IamV1ListUserGroupsResponse';
                userGroups: Array<{
                  __typename: 'IamV1UserGroup';
                  group?: {
                    __typename: 'IamV1Group';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    groupType: IamV1GroupGroupType;
                    slackChannel?: string | null;
                    createTime: string;
                    updateTime: string;
                    identity: { name: string } | Record<PropertyKey, never>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  } | null;
                }>;
              }
            | Record<PropertyKey, never>
            | null;
        } | null;
      }
    | null;
};

export type DeleteAgentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteAgentMutation = {
  deleteAgent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeleteClientMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteClientMutation = {
  deleteClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DeleteGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteGroupMutation = {
  deleteGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { dummy?: string | null }
    | null;
};

export type DeleteRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteRoleMutation = {
  deleteRole?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type GroupFragment = {
  __typename: 'IamV1Group';
  name: string;
  displayName: string;
  description?: string | null;
  groupType: IamV1GroupGroupType;
  slackChannel?: string | null;
  createTime: string;
  updateTime: string;
  identity: { name: string } | Record<PropertyKey, never>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type GroupQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GroupQuery = {
  group?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Group';
        name: string;
        displayName: string;
        description?: string | null;
        groupType: IamV1GroupGroupType;
        slackChannel?: string | null;
        createTime: string;
        updateTime: string;
        identity: { name: string } | Record<PropertyKey, never>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type GroupsQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GroupsQuery = {
  groups?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListGroupsResponse';
        nextPageToken?: string | null;
        groups: Array<{
          __typename: 'IamV1Group';
          name: string;
          displayName: string;
          description?: string | null;
          groupType: IamV1GroupGroupType;
          slackChannel?: string | null;
          createTime: string;
          updateTime: string;
          identity: { name: string } | Record<PropertyKey, never>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type IdentitiesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type IdentitiesQuery = {
  identities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListIdentitiesResponse';
        nextPageToken?: string | null;
        identities: Array<{
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        }>;
      }
    | null;
};

export type IdentityFragment = {
  __typename: 'IamV1Identity';
  name: string;
  displayName: string;
  pictureUri?: string | null;
  service?: string | null;
  everyone?: boolean | null;
  user?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        name: string;
        fullName: string;
        email: string;
        pictureUri?: string | null;
        scimExternalId?: string | null;
        lastLoginTime?: string | null;
      }
    | null;
  apiClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ApiClient';
        name: string;
        displayName: string;
        description?: string | null;
        clientId: string;
        clientSecret?: string | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
  group?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Group';
        name: string;
        displayName: string;
        description?: string | null;
        groupType: IamV1GroupGroupType;
        slackChannel?: string | null;
        createTime: string;
        updateTime: string;
        identity: { name: string } | Record<PropertyKey, never>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
  agent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Agent';
        name: string;
        displayName: string;
        pictureUri?: string | null;
        reviewerSkill?: { enabled: boolean } | null;
      }
    | null;
};

export type IdentityQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type IdentityQuery = {
  identity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
        service?: string | null;
        everyone?: boolean | null;
        user?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              scimExternalId?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
        apiClient?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1ApiClient';
              name: string;
              displayName: string;
              description?: string | null;
              clientId: string;
              clientSecret?: string | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            }
          | null;
        group?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Group';
              name: string;
              displayName: string;
              description?: string | null;
              groupType: IamV1GroupGroupType;
              slackChannel?: string | null;
              createTime: string;
              updateTime: string;
              identity: { name: string } | Record<PropertyKey, never>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
        agent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Agent';
              name: string;
              displayName: string;
              pictureUri?: string | null;
              reviewerSkill?: { enabled: boolean } | null;
            }
          | null;
      }
    | null;
};

export type IdentityRefFragment = {
  __typename: 'IamV1Identity';
  name: string;
  displayName: string;
  pictureUri?: string | null;
};

export type IdentityRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type IdentityRefQuery = {
  identity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type LatestSdkVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type LatestSdkVersionsQuery = {
  getLatestSdkVersions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1GetLatestSdkVersionsResponse';
        sdkLatestVersions: Array<{
          sdkId?: InsightsV1SdkId | null;
          platform?: InsightsV1Platform | null;
          sdkDisplayName?: string | null;
          latestVersion?: string | null;
        }>;
        features: Array<{
          featureId?: string | null;
          displayName?: string | null;
          minVersions: Array<{
            sdkId?: InsightsV1SdkId | null;
            platform?: InsightsV1Platform | null;
            minVersion?: string | null;
          }>;
        }>;
      }
    | null;
};

export type OnGroupCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnGroupCreatedSubscription = {
  groupCreated?: {
    group?: {
      __typename: 'IamV1Group';
      name: string;
      displayName: string;
      description?: string | null;
      groupType: IamV1GroupGroupType;
      slackChannel?: string | null;
      createTime: string;
      updateTime: string;
      identity: { name: string } | Record<PropertyKey, never>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type OnGroupDeletedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnGroupDeletedSubscription = {
  groupDeleted?: { group?: string | null } | null;
};

export type OnGroupUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnGroupUpdatedSubscription = {
  groupUpdated?: {
    group?: {
      __typename: 'IamV1Group';
      name: string;
      displayName: string;
      description?: string | null;
      groupType: IamV1GroupGroupType;
      slackChannel?: string | null;
      createTime: string;
      updateTime: string;
      identity: { name: string } | Record<PropertyKey, never>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type RangeQueryMutationVariables = Exact<{
  graph: InsightsV1GraphType;
  startTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  labelFilters?: InputMaybe<
    | Array<InsightsV1RangeQueryRequestLabelFiltersEntryInput>
    | InsightsV1RangeQueryRequestLabelFiltersEntryInput
  >;
}>;

export type RangeQueryMutation = {
  rangeQuery?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryResponse';
        status?: string | null;
        data?: {
          resultType?: string | null;
          result: Array<{
            sdkResolveMode?: InsightsV1SdkResolveMode | null;
            metric: Array<{ key: string; value?: string | null }>;
            values: Array<{ timestamp?: number | null; value?: string | null }>;
          }>;
        } | null;
      }
    | null;
};

export type RoleFragment = {
  __typename: 'IamV1Role';
  name: string;
  displayName: string;
  builtin?: boolean | null;
  permissions: Array<{
    category: IamV1PermissionCategory;
    description?: string | null;
    type: IamV1PermissionType;
  }>;
};

export type RoleRefFragment = {
  __typename: 'IamV1Role';
  name: string;
  displayName: string;
};

export type RolesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type RolesQuery = {
  roles?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListRolesResponse';
        nextPageToken?: string | null;
        roles: Array<{
          __typename: 'IamV1Role';
          name: string;
          displayName: string;
        }>;
      }
    | null;
};

export type UpdateAgentMutationVariables = Exact<{
  input: PartialIamV1AgentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAgentMutation = {
  updateAgent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Agent';
        name: string;
        displayName: string;
        description?: string | null;
        pictureUri?: string | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string };
        reviewerSkill?: { enabled: boolean; instructions: string } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateClientMutationVariables = Exact<{
  input: PartialIamV1ClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateClientMutation = {
  updateClient?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Client';
        name: string;
        displayName: string;
        lastSeenTime?: string | null;
        createTime: string;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateGroupMutationVariables = Exact<{
  input: PartialIamV1GroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateGroupMutation = {
  updateGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Group';
        name: string;
        displayName: string;
        description?: string | null;
        groupType: IamV1GroupGroupType;
        slackChannel?: string | null;
        createTime: string;
        updateTime: string;
        identity: { name: string } | Record<PropertyKey, never>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateRoleMutationVariables = Exact<{
  input: PartialIamV1RoleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateRoleMutation = {
  updateRole?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Role';
        name: string;
        displayName: string;
        builtin?: boolean | null;
        permissions: Array<{
          category: IamV1PermissionCategory;
          description?: string | null;
          type: IamV1PermissionType;
        }>;
      }
    | null;
};

export type UserFragment = {
  __typename: 'IamV1User';
  name: string;
  fullName: string;
  email: string;
  pictureUri?: string | null;
  lastLoginTime?: string | null;
};

export type UserQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UserQuery = {
  user?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        name: string;
        fullName: string;
        email: string;
        pictureUri?: string | null;
        lastLoginTime?: string | null;
      }
    | null;
};

export type UserRefFragment = {
  __typename: 'IamV1User';
  name: string;
  fullName: string;
  email: string;
  pictureUri?: string | null;
  lastLoginTime?: string | null;
};

export type UsersQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type UsersQuery = {
  users?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListUsersResponse';
        nextPageToken?: string | null;
        users: Array<{
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          lastLoginTime?: string | null;
        }>;
      }
    | null;
};

export type CreateInitiativeMutationVariables = Exact<{
  input: WorkflowV1InitiativeInput;
}>;

export type CreateInitiativeMutation = {
  createInitiative?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type DeleteInitiativeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteInitiativeMutation = {
  deleteInitiative?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type InitiativeFragment = {
  __typename: 'WorkflowV1Initiative';
  name: string;
  displayName: string;
  description?: string | null;
  updateTime: string;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  reviews?: {
    mandatory?: boolean | null;
    reviewers: Array<
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
    >;
  } | null;
  stakeholders: Array<{
    role: string;
    identity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        };
  }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  automatedActions: Array<{
    action?: {
      executeFunctionAction?: {
        __typename: 'ActionsV1TypesExecuteFunctionAction';
        function?: string | null;
        parameters?: any | null;
      } | null;
      transitionAction?: {
        __typename: 'ActionsV1TypesTransitionWorkflowAction';
        action?: string | null;
        parameters?: any | null;
      } | null;
      pagerdutyAction?: {
        pdKey: string;
        severity: ActionsV1TypesSeverity;
        title?: string | null;
        description?: string | null;
      } | null;
    } | null;
    trigger?: {
      stateTrigger?: {
        __typename: 'ActionsV1TypesStateTrigger';
        resource?: string | null;
        state?: string | null;
      } | null;
      activityTrigger?: {
        kind?: string | null;
        resource?: string | null;
      } | null;
    } | null;
  }>;
};

export type InitiativeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type InitiativeQuery = {
  initiative?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type InitiativeRefFragment = {
  __typename: 'WorkflowV1Initiative';
  name: string;
  displayName: string;
  description?: string | null;
};

export type InitiativesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type InitiativesQuery = {
  initiatives?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListInitiativesResponse';
        nextPageToken?: string | null;
        initiatives: Array<{
          __typename: 'WorkflowV1Initiative';
          name: string;
          displayName: string;
          description?: string | null;
        }>;
      }
    | null;
};

export type OnInitiativeCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnInitiativeCreatedSubscription = {
  initiativeCreated?: {
    initiative?: {
      __typename: 'WorkflowV1Initiative';
      name: string;
      displayName: string;
      description?: string | null;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      reviews?: {
        mandatory?: boolean | null;
        reviewers: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
      } | null;
      stakeholders: Array<{
        role: string;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      automatedActions: Array<{
        action?: {
          executeFunctionAction?: {
            __typename: 'ActionsV1TypesExecuteFunctionAction';
            function?: string | null;
            parameters?: any | null;
          } | null;
          transitionAction?: {
            __typename: 'ActionsV1TypesTransitionWorkflowAction';
            action?: string | null;
            parameters?: any | null;
          } | null;
          pagerdutyAction?: {
            pdKey: string;
            severity: ActionsV1TypesSeverity;
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
        trigger?: {
          stateTrigger?: {
            __typename: 'ActionsV1TypesStateTrigger';
            resource?: string | null;
            state?: string | null;
          } | null;
          activityTrigger?: {
            kind?: string | null;
            resource?: string | null;
          } | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type OnInitiativeDeletedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnInitiativeDeletedSubscription = {
  initiativeDeleted?: { initiative: string } | null;
};

export type OnInitiativeUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnInitiativeUpdatedSubscription = {
  initiativeUpdated?: {
    initiative?: {
      __typename: 'WorkflowV1Initiative';
      name: string;
      displayName: string;
      description?: string | null;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      reviews?: {
        mandatory?: boolean | null;
        reviewers: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
      } | null;
      stakeholders: Array<{
        role: string;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      automatedActions: Array<{
        action?: {
          executeFunctionAction?: {
            __typename: 'ActionsV1TypesExecuteFunctionAction';
            function?: string | null;
            parameters?: any | null;
          } | null;
          transitionAction?: {
            __typename: 'ActionsV1TypesTransitionWorkflowAction';
            action?: string | null;
            parameters?: any | null;
          } | null;
          pagerdutyAction?: {
            pdKey: string;
            severity: ActionsV1TypesSeverity;
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
        trigger?: {
          stateTrigger?: {
            __typename: 'ActionsV1TypesStateTrigger';
            resource?: string | null;
            state?: string | null;
          } | null;
          activityTrigger?: {
            kind?: string | null;
            resource?: string | null;
          } | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type UpdateInitiativeMutationVariables = Exact<{
  input: PartialWorkflowV1InitiativeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateInitiativeMutation = {
  updateInitiative?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type InitiativeIndexPageInitiativeFragment = {
  __typename: 'WorkflowV1Initiative';
  updateTime: string;
  name: string;
  displayName: string;
  description?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type InitiativePageActivitiesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type InitiativePageActivitiesQuery = {
  activities?:
    | {
        nextPageToken?: string | null;
        activities: Array<{
          __typename: 'ActivityV1Activity';
          name: string;
          title: string;
          body: string;
          data?: any | null;
          primaryResource: string;
          relatedResources: Array<string>;
          priority: ActivityV1ActivityPriority;
          activityTime: string;
          createTime: string;
          updateTime: string;
          actor:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          creator:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          updater:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          labels: Array<{ key: string; value?: string | null }>;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type InsightsMetricActiveUsersFragment = {
  __typename: 'InsightsV1QueryInsightsMetricResponse';
  values: Array<{
    __typename: 'InsightsV1MetricValue';
    metricValue?: number | null;
    startTime?: string | null;
    endTime?: string | null;
  }>;
};

export type InsightsMetricFlagFragment = {
  __typename: 'InsightsV1QueryInsightsMetricResponse';
  values: Array<{
    __typename: 'InsightsV1MetricValue';
    metricValue?: number | null;
    startTime?: string | null;
  }>;
};

export type InsightsMetricLearningsFragment = {
  __typename: 'InsightsV1QueryInsightsMetricResponse';
  values: Array<{
    __typename: 'InsightsV1MetricValue';
    metricValue?: number | null;
    dimensions: Array<{
      __typename: 'InsightsV1MetricValueDimensionsEntry';
      value?: string | null;
      key: string;
    }>;
  }>;
};

export type InsightsMetricLineChartDataFragment = {
  __typename: 'InsightsV1QueryInsightsMetricResponse';
  values: Array<{
    __typename: 'InsightsV1MetricValue';
    metricValue?: number | null;
    startTime?: string | null;
    endTime?: string | null;
    dimensions: Array<{
      __typename: 'InsightsV1MetricValueDimensionsEntry';
      key: string;
      value?: string | null;
    }>;
  }>;
};

export type InsightsMetricOnboardedUsersFragment = {
  __typename: 'InsightsV1QueryInsightsMetricResponse';
  values: Array<{
    __typename: 'InsightsV1MetricValue';
    metricValue?: number | null;
    startTime?: string | null;
  }>;
};

export type InsightsMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type InsightsMetricsQuery = {
  wau?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
          endTime?: string | null;
        }>;
      }
    | null;
  mau?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
          endTime?: string | null;
        }>;
      }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
        }>;
      }
    | null;
  live?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
          endTime?: string | null;
          dimensions: Array<{
            __typename: 'InsightsV1MetricValueDimensionsEntry';
            key: string;
            value?: string | null;
          }>;
        }>;
      }
    | null;
  onboarded?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
        }>;
      }
    | null;
  surface90days?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          startTime?: string | null;
          endTime?: string | null;
          dimensions: Array<{
            __typename: 'InsightsV1MetricValueDimensionsEntry';
            key: string;
            value?: string | null;
          }>;
        }>;
      }
    | null;
  learnings?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'InsightsV1QueryInsightsMetricResponse';
        values: Array<{
          __typename: 'InsightsV1MetricValue';
          metricValue?: number | null;
          dimensions: Array<{
            __typename: 'InsightsV1MetricValueDimensionsEntry';
            value?: string | null;
            key: string;
          }>;
        }>;
      }
    | null;
};

export type CloseIssueMutationVariables = Exact<{
  name: Scalars['String']['input'];
  closeReason: ObservationsV1IssueCloseReason;
}>;

export type CloseIssueMutation = {
  closeIssue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type CreateThemeMutationVariables = Exact<{
  theme: ObservationsV1ThemeInput;
  themeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateThemeMutation = {
  createTheme?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Theme';
        state: ObservationsV1ThemeState;
        createTime: string;
        updateTime: string;
        issueCount?: number | null;
        name: string;
        displayName: string;
        chat?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        description?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | null;
};

export type IssueFragment = {
  __typename: 'ObservationsV1Issue';
  state: ObservationsV1IssueState;
  kind?: ObservationsV1IssueKind | null;
  status?: ObservationsV1IssueStatus | null;
  closeReason?: ObservationsV1IssueCloseReason | null;
  autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
  snoozedUntilTime?: string | null;
  confidenceScore?: number | null;
  observationCount?: number | null;
  createTime: string;
  updateTime: string;
  name: string;
  displayName: string;
  taskStats?: {
    completed?: number | null;
    failed?: number | null;
    inProgress?: number | null;
    open?: number | null;
    waitingForInput?: number | null;
  } | null;
  assignee?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
      }
  >;
  theme?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'ObservationsV1Theme'; name: string; displayName: string }
    | null;
  driver?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        displayName?: string | null;
        state?: ConversationsV2ChatState | null;
        createTime: string;
        updateTime: string;
        source?: ConversationsV2ChatSource | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        assistantOutcome?: {
          outcome?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
            response?: string | null;
          } | null;
          toolConfirmation?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
            tool: string;
            input?: any | null;
          } | null;
          askQuestion?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
            question: string;
            alternatives: Array<string>;
          } | null;
          error?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeError';
            details: string;
          } | null;
        } | null;
        summary?: { title?: string | null } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  problemStatement?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type IssueQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type IssueQuery = {
  issue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type IssueRefFragment = {
  __typename: 'ObservationsV1Issue';
  name: string;
  displayName: string;
};

export type IssueSourceFragment = {
  origin: ObservationsV1SourceOrigin;
  system: string;
  externalId?: string | null;
  uri?: string | null;
  metadata?: any | null;
};

export type IssuesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type IssuesQuery = {
  issues?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1ListIssuesResponse';
        nextPageToken?: string | null;
        issues: Array<{
          __typename: 'ObservationsV1Issue';
          name: string;
          displayName: string;
        }>;
      }
    | null;
};

export type ObservationRefFragment = {
  __typename: 'ObservationsV1Observation';
  name: string;
  kind: string;
  summary: string;
  excerpt?: string | null;
  eventTime: string;
  createTime: string;
  source: {
    origin: ObservationsV1SourceOrigin;
    system: string;
    externalId?: string | null;
    uri?: string | null;
    metadata?: any | null;
  };
  issue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { name: string }
    | null;
};

export type ObservationsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ObservationsQuery = {
  observations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1ListObservationsResponse';
        nextPageToken?: string | null;
        observations: Array<{
          __typename: 'ObservationsV1Observation';
          name: string;
          kind: string;
          summary: string;
          excerpt?: string | null;
          eventTime: string;
          createTime: string;
          source: {
            origin: ObservationsV1SourceOrigin;
            system: string;
            externalId?: string | null;
            uri?: string | null;
            metadata?: any | null;
          };
          issue?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { name: string }
            | null;
        }>;
      }
    | null;
};

export type OnIssueCreatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnIssueCreatedSubscription = {
  issueCreated?: {
    issue?: {
      __typename: 'ObservationsV1Issue';
      state: ObservationsV1IssueState;
      kind?: ObservationsV1IssueKind | null;
      status?: ObservationsV1IssueStatus | null;
      closeReason?: ObservationsV1IssueCloseReason | null;
      autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
      snoozedUntilTime?: string | null;
      confidenceScore?: number | null;
      observationCount?: number | null;
      createTime: string;
      updateTime: string;
      name: string;
      displayName: string;
      taskStats?: {
        completed?: number | null;
        failed?: number | null;
        inProgress?: number | null;
        open?: number | null;
        waitingForInput?: number | null;
      } | null;
      assignee?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            deleteTime?: string | null;
          }
      >;
      theme?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'ObservationsV1Theme';
            name: string;
            displayName: string;
          }
        | null;
      driver?:
        | {
            __typename: 'ConversationsV2Chat';
            name: string;
            displayName?: string | null;
            state?: ConversationsV2ChatState | null;
            createTime: string;
            updateTime: string;
            source?: ConversationsV2ChatSource | null;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
            project?:
              | {
                  __typename: 'CollaborationV1Project';
                  name: string;
                  displayName: string;
                  updateTime: string;
                  deleteTime?: string | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
            assistantOutcome?: {
              outcome?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                response?: string | null;
              } | null;
              toolConfirmation?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                tool: string;
                input?: any | null;
              } | null;
              askQuestion?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                question: string;
                alternatives: Array<string>;
              } | null;
              error?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeError';
                details: string;
              } | null;
            } | null;
            summary?: { title?: string | null } | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      problemStatement?:
        | {
            __typename: 'CollaborationV1CollaborativeDocument';
            name: string;
            title?: string | null;
            state: CollaborationV1CollaborativeDocumentState;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type OnIssueUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnIssueUpdatedSubscription = {
  issueUpdated?: {
    issue?: {
      __typename: 'ObservationsV1Issue';
      state: ObservationsV1IssueState;
      kind?: ObservationsV1IssueKind | null;
      status?: ObservationsV1IssueStatus | null;
      closeReason?: ObservationsV1IssueCloseReason | null;
      autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
      snoozedUntilTime?: string | null;
      confidenceScore?: number | null;
      observationCount?: number | null;
      createTime: string;
      updateTime: string;
      name: string;
      displayName: string;
      taskStats?: {
        completed?: number | null;
        failed?: number | null;
        inProgress?: number | null;
        open?: number | null;
        waitingForInput?: number | null;
      } | null;
      assignee?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            deleteTime?: string | null;
          }
      >;
      theme?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'ObservationsV1Theme';
            name: string;
            displayName: string;
          }
        | null;
      driver?:
        | {
            __typename: 'ConversationsV2Chat';
            name: string;
            displayName?: string | null;
            state?: ConversationsV2ChatState | null;
            createTime: string;
            updateTime: string;
            source?: ConversationsV2ChatSource | null;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
            project?:
              | {
                  __typename: 'CollaborationV1Project';
                  name: string;
                  displayName: string;
                  updateTime: string;
                  deleteTime?: string | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
            assistantOutcome?: {
              outcome?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                response?: string | null;
              } | null;
              toolConfirmation?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                tool: string;
                input?: any | null;
              } | null;
              askQuestion?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                question: string;
                alternatives: Array<string>;
              } | null;
              error?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeError';
                details: string;
              } | null;
            } | null;
            summary?: { title?: string | null } | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      problemStatement?:
        | {
            __typename: 'CollaborationV1CollaborativeDocument';
            name: string;
            title?: string | null;
            state: CollaborationV1CollaborativeDocumentState;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type OnTaskCreatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnTaskCreatedSubscription = {
  taskCreated?: {
    task?: {
      __typename: 'ObservationsV1Task';
      resource?: string | null;
      updateTime: string;
      name: string;
      displayName: string;
      state: ObservationsV1TaskState;
      blocked?: boolean | null;
      createTime: string;
      plan?:
        | {
            __typename: 'CollaborationV1CollaborativeDocument';
            name: string;
            markdown?: string | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      inputRequest?: {
        __typename: 'ObservationsV1InputRequest';
        approval?: {
          __typename: 'ObservationsV1InputRequestApproval';
          prompt: string;
        } | null;
        codeReview?: {
          __typename: 'ObservationsV1InputRequestCodeReview';
          prompt?: string | null;
          pullRequestNumber: number;
          repository: string;
          uri: string;
        } | null;
        direction?: {
          __typename: 'ObservationsV1InputRequestDirection';
          prompt?: string | null;
          options: Array<string>;
        } | null;
      } | null;
      inputResponse?: {
        __typename: 'ObservationsV1InputResponse';
        approval?: {
          __typename: 'ObservationsV1InputResponseApprovalResponse';
          approved: boolean;
          comment?: string | null;
        } | null;
        codeReview?: {
          __typename: 'ObservationsV1InputResponseCodeReviewResponse';
          approved: boolean;
          comment?: string | null;
        } | null;
        direction?: {
          __typename: 'ObservationsV1InputResponseDirectionResponse';
          choice: string;
        } | null;
      } | null;
      dependencies: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'ObservationsV1Task';
            name: string;
            displayName: string;
            state: ObservationsV1TaskState;
            blocked?: boolean | null;
            createTime: string;
          }
      >;
    } | null;
  } | null;
};

export type OnTaskUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnTaskUpdatedSubscription = {
  taskUpdated?: {
    task?: {
      __typename: 'ObservationsV1Task';
      resource?: string | null;
      updateTime: string;
      name: string;
      displayName: string;
      state: ObservationsV1TaskState;
      blocked?: boolean | null;
      createTime: string;
      plan?:
        | {
            __typename: 'CollaborationV1CollaborativeDocument';
            name: string;
            markdown?: string | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      inputRequest?: {
        __typename: 'ObservationsV1InputRequest';
        approval?: {
          __typename: 'ObservationsV1InputRequestApproval';
          prompt: string;
        } | null;
        codeReview?: {
          __typename: 'ObservationsV1InputRequestCodeReview';
          prompt?: string | null;
          pullRequestNumber: number;
          repository: string;
          uri: string;
        } | null;
        direction?: {
          __typename: 'ObservationsV1InputRequestDirection';
          prompt?: string | null;
          options: Array<string>;
        } | null;
      } | null;
      inputResponse?: {
        __typename: 'ObservationsV1InputResponse';
        approval?: {
          __typename: 'ObservationsV1InputResponseApprovalResponse';
          approved: boolean;
          comment?: string | null;
        } | null;
        codeReview?: {
          __typename: 'ObservationsV1InputResponseCodeReviewResponse';
          approved: boolean;
          comment?: string | null;
        } | null;
        direction?: {
          __typename: 'ObservationsV1InputResponseDirectionResponse';
          choice: string;
        } | null;
      } | null;
      dependencies: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'ObservationsV1Task';
            name: string;
            displayName: string;
            state: ObservationsV1TaskState;
            blocked?: boolean | null;
            createTime: string;
          }
      >;
    } | null;
  } | null;
};

export type OnThemeUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnThemeUpdatedSubscription = {
  themeUpdated?: {
    theme?: {
      __typename: 'ObservationsV1Theme';
      state: ObservationsV1ThemeState;
      createTime: string;
      updateTime: string;
      issueCount?: number | null;
      name: string;
      displayName: string;
      chat?:
        | {
            __typename: 'ConversationsV2Chat';
            name: string;
            displayName?: string | null;
            state?: ConversationsV2ChatState | null;
            createTime: string;
            updateTime: string;
            source?: ConversationsV2ChatSource | null;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
            project?:
              | {
                  __typename: 'CollaborationV1Project';
                  name: string;
                  displayName: string;
                  updateTime: string;
                  deleteTime?: string | null;
                }
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | null;
            assistantOutcome?: {
              outcome?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                response?: string | null;
              } | null;
              toolConfirmation?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                tool: string;
                input?: any | null;
              } | null;
              askQuestion?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                question: string;
                alternatives: Array<string>;
              } | null;
              error?: {
                __typename: 'ConversationsV2ChatAssistantOutcomeError';
                details: string;
              } | null;
            } | null;
            summary?: { title?: string | null } | null;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      description?:
        | {
            __typename: 'CollaborationV1CollaborativeDocument';
            name: string;
            title?: string | null;
            state: CollaborationV1CollaborativeDocumentState;
          }
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | null;
    } | null;
  } | null;
};

export type ProvideTaskInputMutationVariables = Exact<{
  name: Scalars['String']['input'];
  inputResponse: ObservationsV1InputResponseInput;
}>;

export type ProvideTaskInputMutation = {
  provideTaskInput?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Task';
        resource?: string | null;
        updateTime: string;
        name: string;
        displayName: string;
        state: ObservationsV1TaskState;
        blocked?: boolean | null;
        createTime: string;
        plan?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              markdown?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        inputRequest?: {
          __typename: 'ObservationsV1InputRequest';
          approval?: {
            __typename: 'ObservationsV1InputRequestApproval';
            prompt: string;
          } | null;
          codeReview?: {
            __typename: 'ObservationsV1InputRequestCodeReview';
            prompt?: string | null;
            pullRequestNumber: number;
            repository: string;
            uri: string;
          } | null;
          direction?: {
            __typename: 'ObservationsV1InputRequestDirection';
            prompt?: string | null;
            options: Array<string>;
          } | null;
        } | null;
        inputResponse?: {
          __typename: 'ObservationsV1InputResponse';
          approval?: {
            __typename: 'ObservationsV1InputResponseApprovalResponse';
            approved: boolean;
            comment?: string | null;
          } | null;
          codeReview?: {
            __typename: 'ObservationsV1InputResponseCodeReviewResponse';
            approved: boolean;
            comment?: string | null;
          } | null;
          direction?: {
            __typename: 'ObservationsV1InputResponseDirectionResponse';
            choice: string;
          } | null;
        } | null;
        dependencies: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Task';
              name: string;
              displayName: string;
              state: ObservationsV1TaskState;
              blocked?: boolean | null;
              createTime: string;
            }
        >;
      }
    | null;
};

export type PullRequestQueryVariables = Exact<{
  repository: Scalars['String']['input'];
  number: Scalars['Int']['input'];
}>;

export type PullRequestQuery = {
  pullRequest?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RepositoriesV1PullRequest';
        additions?: number | null;
        createdAt?: string | null;
        deletions?: number | null;
        draft?: boolean | null;
        htmlUrl?: string | null;
        labels: Array<string>;
        merged?: boolean | null;
        mergeable?: boolean | null;
        number?: number | null;
        requestedReviewers: Array<string>;
        state?: string | null;
        title?: string | null;
        userLogin?: string | null;
        head?: { ref?: string | null } | null;
      }
    | null;
};

export type ReopenIssueMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ReopenIssueMutation = {
  reopenIssue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type ReviewIssueMutationVariables = Exact<{
  name: Scalars['String']['input'];
  feedback?: InputMaybe<
    Array<ObservationsV1IssueFeedbackInput> | ObservationsV1IssueFeedbackInput
  >;
  autonomyLevel?: InputMaybe<ObservationsV1IssueAutonomyLevel>;
}>;

export type ReviewIssueMutation = {
  reviewIssue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type StartInvestigationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type StartInvestigationMutation = {
  startInvestigation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Theme';
        state: ObservationsV1ThemeState;
        createTime: string;
        updateTime: string;
        issueCount?: number | null;
        name: string;
        displayName: string;
        chat?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        description?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | null;
};

export type StartIssueMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type StartIssueMutation = {
  startIssue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type TaskFragment = {
  __typename: 'ObservationsV1Task';
  resource?: string | null;
  updateTime: string;
  name: string;
  displayName: string;
  state: ObservationsV1TaskState;
  blocked?: boolean | null;
  createTime: string;
  plan?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        markdown?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  inputRequest?: {
    __typename: 'ObservationsV1InputRequest';
    approval?: {
      __typename: 'ObservationsV1InputRequestApproval';
      prompt: string;
    } | null;
    codeReview?: {
      __typename: 'ObservationsV1InputRequestCodeReview';
      prompt?: string | null;
      pullRequestNumber: number;
      repository: string;
      uri: string;
    } | null;
    direction?: {
      __typename: 'ObservationsV1InputRequestDirection';
      prompt?: string | null;
      options: Array<string>;
    } | null;
  } | null;
  inputResponse?: {
    __typename: 'ObservationsV1InputResponse';
    approval?: {
      __typename: 'ObservationsV1InputResponseApprovalResponse';
      approved: boolean;
      comment?: string | null;
    } | null;
    codeReview?: {
      __typename: 'ObservationsV1InputResponseCodeReviewResponse';
      approved: boolean;
      comment?: string | null;
    } | null;
    direction?: {
      __typename: 'ObservationsV1InputResponseDirectionResponse';
      choice: string;
    } | null;
  } | null;
  dependencies: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Task';
        name: string;
        displayName: string;
        state: ObservationsV1TaskState;
        blocked?: boolean | null;
        createTime: string;
      }
  >;
};

export type TaskQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type TaskQuery = {
  task?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Task';
        resource?: string | null;
        updateTime: string;
        name: string;
        displayName: string;
        state: ObservationsV1TaskState;
        blocked?: boolean | null;
        createTime: string;
        plan?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              markdown?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        inputRequest?: {
          __typename: 'ObservationsV1InputRequest';
          approval?: {
            __typename: 'ObservationsV1InputRequestApproval';
            prompt: string;
          } | null;
          codeReview?: {
            __typename: 'ObservationsV1InputRequestCodeReview';
            prompt?: string | null;
            pullRequestNumber: number;
            repository: string;
            uri: string;
          } | null;
          direction?: {
            __typename: 'ObservationsV1InputRequestDirection';
            prompt?: string | null;
            options: Array<string>;
          } | null;
        } | null;
        inputResponse?: {
          __typename: 'ObservationsV1InputResponse';
          approval?: {
            __typename: 'ObservationsV1InputResponseApprovalResponse';
            approved: boolean;
            comment?: string | null;
          } | null;
          codeReview?: {
            __typename: 'ObservationsV1InputResponseCodeReviewResponse';
            approved: boolean;
            comment?: string | null;
          } | null;
          direction?: {
            __typename: 'ObservationsV1InputResponseDirectionResponse';
            choice: string;
          } | null;
        } | null;
        dependencies: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Task';
              name: string;
              displayName: string;
              state: ObservationsV1TaskState;
              blocked?: boolean | null;
              createTime: string;
            }
        >;
      }
    | null;
};

export type TaskInputRequestFragment = {
  __typename: 'ObservationsV1InputRequest';
  approval?: {
    __typename: 'ObservationsV1InputRequestApproval';
    prompt: string;
  } | null;
  codeReview?: {
    __typename: 'ObservationsV1InputRequestCodeReview';
    prompt?: string | null;
    pullRequestNumber: number;
    repository: string;
    uri: string;
  } | null;
  direction?: {
    __typename: 'ObservationsV1InputRequestDirection';
    prompt?: string | null;
    options: Array<string>;
  } | null;
};

export type TaskInputResponseFragment = {
  __typename: 'ObservationsV1InputResponse';
  approval?: {
    __typename: 'ObservationsV1InputResponseApprovalResponse';
    approved: boolean;
    comment?: string | null;
  } | null;
  codeReview?: {
    __typename: 'ObservationsV1InputResponseCodeReviewResponse';
    approved: boolean;
    comment?: string | null;
  } | null;
  direction?: {
    __typename: 'ObservationsV1InputResponseDirectionResponse';
    choice: string;
  } | null;
};

export type TaskRefFragment = {
  __typename: 'ObservationsV1Task';
  name: string;
  displayName: string;
  state: ObservationsV1TaskState;
  blocked?: boolean | null;
  createTime: string;
};

export type TasksQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type TasksQuery = {
  tasks?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1ListTasksResponse';
        nextPageToken?: string | null;
        tasks: Array<{
          __typename: 'ObservationsV1Task';
          name: string;
          displayName: string;
          state: ObservationsV1TaskState;
          blocked?: boolean | null;
          createTime: string;
        }>;
      }
    | null;
};

export type ThemeFragment = {
  __typename: 'ObservationsV1Theme';
  state: ObservationsV1ThemeState;
  createTime: string;
  updateTime: string;
  issueCount?: number | null;
  name: string;
  displayName: string;
  chat?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        displayName?: string | null;
        state?: ConversationsV2ChatState | null;
        createTime: string;
        updateTime: string;
        source?: ConversationsV2ChatSource | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        assistantOutcome?: {
          outcome?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
            response?: string | null;
          } | null;
          toolConfirmation?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
            tool: string;
            input?: any | null;
          } | null;
          askQuestion?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
            question: string;
            alternatives: Array<string>;
          } | null;
          error?: {
            __typename: 'ConversationsV2ChatAssistantOutcomeError';
            details: string;
          } | null;
        } | null;
        summary?: { title?: string | null } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  description?:
    | {
        __typename: 'CollaborationV1CollaborativeDocument';
        name: string;
        title?: string | null;
        state: CollaborationV1CollaborativeDocumentState;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ThemeQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ThemeQuery = {
  theme?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Theme';
        state: ObservationsV1ThemeState;
        createTime: string;
        updateTime: string;
        issueCount?: number | null;
        name: string;
        displayName: string;
        chat?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        description?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | null;
};

export type ThemeRefFragment = {
  __typename: 'ObservationsV1Theme';
  name: string;
  displayName: string;
};

export type ThemesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ThemesQuery = {
  themes?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1ListThemesResponse';
        nextPageToken?: string | null;
        themes: Array<{
          __typename: 'ObservationsV1Theme';
          name: string;
          displayName: string;
        }>;
      }
    | null;
};

export type UpdateIssueMutationVariables = Exact<{
  input: PartialObservationsV1IssueInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateIssueMutation = {
  updateIssue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Issue';
        state: ObservationsV1IssueState;
        kind?: ObservationsV1IssueKind | null;
        status?: ObservationsV1IssueStatus | null;
        closeReason?: ObservationsV1IssueCloseReason | null;
        autonomyLevel?: ObservationsV1IssueAutonomyLevel | null;
        snoozedUntilTime?: string | null;
        confidenceScore?: number | null;
        observationCount?: number | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName: string;
        taskStats?: {
          completed?: number | null;
          failed?: number | null;
          inProgress?: number | null;
          open?: number | null;
          waitingForInput?: number | null;
        } | null;
        assignee?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        theme?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1Theme';
              name: string;
              displayName: string;
            }
          | null;
        driver?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        problemStatement?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateThemeMutationVariables = Exact<{
  input: PartialObservationsV1ThemeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateThemeMutation = {
  updateTheme?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1Theme';
        state: ObservationsV1ThemeState;
        createTime: string;
        updateTime: string;
        issueCount?: number | null;
        name: string;
        displayName: string;
        chat?:
          | {
              __typename: 'ConversationsV2Chat';
              name: string;
              displayName?: string | null;
              state?: ConversationsV2ChatState | null;
              createTime: string;
              updateTime: string;
              source?: ConversationsV2ChatSource | null;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
              project?:
                | {
                    __typename: 'CollaborationV1Project';
                    name: string;
                    displayName: string;
                    updateTime: string;
                    deleteTime?: string | null;
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
              assistantOutcome?: {
                outcome?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeCompleted';
                  response?: string | null;
                } | null;
                toolConfirmation?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeToolConfirmation';
                  tool: string;
                  input?: any | null;
                } | null;
                askQuestion?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeAskQuestion';
                  question: string;
                  alternatives: Array<string>;
                } | null;
                error?: {
                  __typename: 'ConversationsV2ChatAssistantOutcomeError';
                  details: string;
                } | null;
              } | null;
              summary?: { title?: string | null } | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        description?:
          | {
              __typename: 'CollaborationV1CollaborativeDocument';
              name: string;
              title?: string | null;
              state: CollaborationV1CollaborativeDocumentState;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
      }
    | null;
};

export type IssueIndexPageIssueFragment = {
  __typename: 'ObservationsV1Issue';
  state: ObservationsV1IssueState;
  kind?: ObservationsV1IssueKind | null;
  status?: ObservationsV1IssueStatus | null;
  closeReason?: ObservationsV1IssueCloseReason | null;
  snoozedUntilTime?: string | null;
  confidenceScore?: number | null;
  createTime: string;
  updateTime: string;
  name: string;
  displayName: string;
  assignee?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
      }
  >;
  driver?:
    | {
        __typename: 'ConversationsV2Chat';
        name: string;
        state?: ConversationsV2ChatState | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  tasks?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'ObservationsV1ListTasksResponse';
        tasks: Array<{
          __typename: 'ObservationsV1Task';
          name: string;
          displayName: string;
          state: ObservationsV1TaskState;
          blocked?: boolean | null;
          createTime: string;
          inputRequest?: {
            approval?: {
              __typename: 'ObservationsV1InputRequestApproval';
            } | null;
            codeReview?: {
              __typename: 'ObservationsV1InputRequestCodeReview';
            } | null;
            direction?: {
              __typename: 'ObservationsV1InputRequestDirection';
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type DeleteMaterializedSegmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteMaterializedSegmentMutation = {
  deleteMaterializedSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type AssignmentTableFragment = {
  __typename: 'MetricsV1AssignmentTable';
  name: string;
  displayName: string;
  description?: string | null;
  deleteTime?: string | null;
  state: MetricsV1TableState;
  sql: string;
  assignmentDataDeliveredUntilTime?: string | null;
  timestampColumn: { name: string };
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entityColumn: { name: string };
  exposureKeyColumn: { name: string };
  variantKeyColumn: { name: string };
  schemaValidationJob:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1SqlJob'; name: string };
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  error?: { details: Array<string>; message?: string | null } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  dimensions: Array<{ name: string }>;
};

export type AssignmentTableQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AssignmentTableQuery = {
  assignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1AssignmentTable';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
        state: MetricsV1TableState;
        sql: string;
        assignmentDataDeliveredUntilTime?: string | null;
        dataWarehouse?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1DataWarehouse';
              name: string;
              isPrimary?: boolean | null;
              deleteTime?: string | null;
              config: {
                bigQueryConfig?: { gcpProjectId?: string | null } | null;
                dataBricksConfig?: { host?: string | null } | null;
                snowflakeConfig?: { account: string } | null;
                redshiftConfig?: { cluster: string } | null;
              };
            }
          | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumn: { name: string };
        exposureKeyColumn: { name: string };
        variantKeyColumn: { name: string };
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1SqlJob'; name: string };
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        dimensions: Array<{ name: string }>;
      }
    | null;
};

export type AssignmentTableRefFragment = {
  __typename: 'MetricsV1AssignmentTable';
  displayName: string;
  name: string;
  state: MetricsV1TableState;
  deleteTime?: string | null;
  error?: { message?: string | null; details: Array<string> } | null;
};

export type AssignmentTableWithWarehouseFragment = {
  __typename: 'MetricsV1AssignmentTable';
  name: string;
  displayName: string;
  description?: string | null;
  deleteTime?: string | null;
  state: MetricsV1TableState;
  sql: string;
  assignmentDataDeliveredUntilTime?: string | null;
  dataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
        deleteTime?: string | null;
        config: {
          bigQueryConfig?: { gcpProjectId?: string | null } | null;
          dataBricksConfig?: { host?: string | null } | null;
          snowflakeConfig?: { account: string } | null;
          redshiftConfig?: { cluster: string } | null;
        };
      }
    | null;
  timestampColumn: { name: string };
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entityColumn: { name: string };
  exposureKeyColumn: { name: string };
  variantKeyColumn: { name: string };
  schemaValidationJob:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1SqlJob'; name: string };
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  error?: { details: Array<string>; message?: string | null } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  dimensions: Array<{ name: string }>;
};

export type AssignmentTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type AssignmentTablesQuery = {
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        nextPageToken?: string | null;
        assignmentTables: Array<{
          __typename: 'MetricsV1AssignmentTable';
          name: string;
          displayName: string;
          description?: string | null;
          deleteTime?: string | null;
          state: MetricsV1TableState;
          sql: string;
          assignmentDataDeliveredUntilTime?: string | null;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
          timestampColumn: { name: string };
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entityColumn: { name: string };
          exposureKeyColumn: { name: string };
          variantKeyColumn: { name: string };
          schemaValidationJob:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'MetricsV1SqlJob'; name: string };
          dataDeliveredUntilUpdateStrategyConfig?: {
            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
            disableEmptyPartitions?: boolean | null;
            automaticUpdateConfig?: {
              commitDelay: string;
              changeThreshold?: { value?: string | null } | null;
            } | null;
            dailyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
            hourlyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
          } | null;
          error?: { details: Array<string>; message?: string | null } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          dimensions: Array<{ name: string }>;
        }>;
      }
    | null;
};

export type CreateAssignmentTableMutationVariables = Exact<{
  assignmentTable: MetricsV1AssignmentTableInput;
}>;

export type CreateAssignmentTableMutation = {
  createAssignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1AssignmentTable';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
        state: MetricsV1TableState;
        sql: string;
        assignmentDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumn: { name: string };
        exposureKeyColumn: { name: string };
        variantKeyColumn: { name: string };
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1SqlJob'; name: string };
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        dimensions: Array<{ name: string }>;
      }
    | null;
};

export type CreateDimensionTableMutationVariables = Exact<{
  input: MetricsV1DimensionTableInput;
}>;

export type CreateDimensionTableMutation = {
  createDimensionTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DimensionTable';
        name: string;
        displayName: string;
        description?: string | null;
        state: MetricsV1TableState;
        dimensionDataDeliveredUntilTime?: string | null;
        sql: string;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumnMapping: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                createTime: string;
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                defaultAssignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | null;
              };
          column: { name: string };
        };
        dimensions: Array<{ name: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        timeConfig?: {
          window: string;
          timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
        } | null;
        valueMappings: Array<{
          column: string;
          mappings: Array<{
            inputDimensionValue?: string | null;
            outputDimensionValue?: string | null;
          }>;
        }>;
      }
    | null;
};

export type CreateEntityMutationVariables = Exact<{
  input: MetricsV1EntityInput;
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateEntityMutation = {
  createEntity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        createTime: string;
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        defaultAssignmentTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { name: string; displayName: string; state: MetricsV1TableState }
          | null;
      }
    | null;
};

export type CreateFactTableMutationVariables = Exact<{
  factTable: MetricsV1FactTableInput;
}>;

export type CreateFactTableMutation = {
  createFactTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        sql: string;
        state: MetricsV1TableState;
        factDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        entities: Array<{
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          column: { name: string };
        }>;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string };
          unit?: {
            baseUnitMultiplier?: number | null;
            baseUnit?: MetricsV1UnitBaseUnit | null;
            currencyCode?: string | null;
            customUnit?: string | null;
          } | null;
        }>;
        dimensions: Array<{ name: string }>;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                }>;
              } | null;
            };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type CreateMeasurementMutationVariables = Exact<{
  measurement: MetricsV1MeasurementInput;
  measurementId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateMeasurementMutation = {
  createMeasurement?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Measurement'; name: string; displayName: string }
    | null;
};

export type CreateQueryPreviewMutationVariables = Exact<{
  query: Scalars['String']['input'];
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateQueryPreviewMutation = {
  previewSqlQuery?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1PreviewSqlQueryResponse'; job?: string | null }
    | null;
};

export type DataDeliveredUntilUpdateStrategyConfigFragment = {
  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
  disableEmptyPartitions?: boolean | null;
  automaticUpdateConfig?: {
    commitDelay: string;
    changeThreshold?: { value?: string | null } | null;
  } | null;
  dailyUpdateConfig?: {
    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
    maxZeroDuration?: string | null;
  } | null;
  hourlyUpdateConfig?: {
    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
    maxZeroDuration?: string | null;
  } | null;
};

export type DataWarehouseExistsQueryVariables = Exact<{ [key: string]: never }>;

export type DataWarehouseExistsQuery = {
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
      }
    | null;
  currentAccount?:
    | {
        __typename: 'AdminV1AccountInfo';
        mode?: AdminV1AccountMode | null;
        totalConfidenceAccountInfo?: {
          state?: AdminV1AccountInfoTotalConfidenceAccountStatusState | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DataWarehouseRefFragment = {
  __typename: 'MetricsV1DataWarehouse';
  name: string;
  isPrimary?: boolean | null;
  deleteTime?: string | null;
  config: {
    bigQueryConfig?: { gcpProjectId?: string | null } | null;
    dataBricksConfig?: { host?: string | null } | null;
    snowflakeConfig?: { account: string } | null;
    redshiftConfig?: { cluster: string } | null;
  };
};

export type DataWarehousesQueryVariables = Exact<{ [key: string]: never }>;

export type DataWarehousesQuery = {
  dataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDataWarehousesResponse';
        dataWarehouses: Array<{
          __typename: 'MetricsV1DataWarehouse';
          name: string;
          isPrimary?: boolean | null;
          deleteTime?: string | null;
          config: {
            bigQueryConfig?: { gcpProjectId?: string | null } | null;
            dataBricksConfig?: { host?: string | null } | null;
            snowflakeConfig?: { account: string } | null;
            redshiftConfig?: { cluster: string } | null;
          };
        }>;
      }
    | null;
};

export type DeleteAssignmentTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteAssignmentTableMutation = {
  deleteAssignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1AssignmentTable';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
        state: MetricsV1TableState;
        sql: string;
        assignmentDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumn: { name: string };
        exposureKeyColumn: { name: string };
        variantKeyColumn: { name: string };
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1SqlJob'; name: string };
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        dimensions: Array<{ name: string }>;
      }
    | null;
};

export type DeleteDimensionTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteDimensionTableMutation = {
  deleteDimensionTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DimensionTable';
        name: string;
        displayName: string;
        description?: string | null;
        state: MetricsV1TableState;
        dimensionDataDeliveredUntilTime?: string | null;
        sql: string;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumnMapping: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                createTime: string;
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                defaultAssignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | null;
              };
          column: { name: string };
        };
        dimensions: Array<{ name: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        timeConfig?: {
          window: string;
          timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
        } | null;
        valueMappings: Array<{
          column: string;
          mappings: Array<{
            inputDimensionValue?: string | null;
            outputDimensionValue?: string | null;
          }>;
        }>;
      }
    | null;
};

export type DeleteEntityMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteEntityMutation = {
  deleteEntity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export type DeleteFactTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteFactTableMutation = {
  deleteFactTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        sql: string;
        state: MetricsV1TableState;
        factDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        entities: Array<{
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          column: { name: string };
        }>;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string };
          unit?: {
            baseUnitMultiplier?: number | null;
            baseUnit?: MetricsV1UnitBaseUnit | null;
            currencyCode?: string | null;
            customUnit?: string | null;
          } | null;
        }>;
        dimensions: Array<{ name: string }>;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                }>;
              } | null;
            };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type DimensionTableFragment = {
  __typename: 'MetricsV1DimensionTable';
  name: string;
  displayName: string;
  description?: string | null;
  state: MetricsV1TableState;
  dimensionDataDeliveredUntilTime?: string | null;
  sql: string;
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entityColumnMapping: {
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Entity';
          createTime: string;
          name: string;
          displayName: string;
          primaryKeyType: MetricsV1ColumnType;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          defaultAssignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { name: string; displayName: string; state: MetricsV1TableState }
            | null;
        };
    column: { name: string };
  };
  dimensions: Array<{ name: string }>;
  labels: Array<{ key: string; value?: string | null }>;
  error?: { details: Array<string>; message?: string | null } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  timeConfig?: {
    window: string;
    timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
  } | null;
  valueMappings: Array<{
    column: string;
    mappings: Array<{
      inputDimensionValue?: string | null;
      outputDimensionValue?: string | null;
    }>;
  }>;
};

export type DimensionTableQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DimensionTableQuery = {
  dimensionTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DimensionTable';
        name: string;
        displayName: string;
        description?: string | null;
        state: MetricsV1TableState;
        dimensionDataDeliveredUntilTime?: string | null;
        sql: string;
        dataWarehouse?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1DataWarehouse';
              name: string;
              isPrimary?: boolean | null;
              deleteTime?: string | null;
              config: {
                bigQueryConfig?: { gcpProjectId?: string | null } | null;
                dataBricksConfig?: { host?: string | null } | null;
                snowflakeConfig?: { account: string } | null;
                redshiftConfig?: { cluster: string } | null;
              };
            }
          | null;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumnMapping: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                createTime: string;
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                defaultAssignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | null;
              };
          column: { name: string };
        };
        dimensions: Array<{ name: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        timeConfig?: {
          window: string;
          timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
        } | null;
        valueMappings: Array<{
          column: string;
          mappings: Array<{
            inputDimensionValue?: string | null;
            outputDimensionValue?: string | null;
          }>;
        }>;
      }
    | null;
};

export type DimensionTableWithWarehouseFragment = {
  __typename: 'MetricsV1DimensionTable';
  name: string;
  displayName: string;
  description?: string | null;
  state: MetricsV1TableState;
  dimensionDataDeliveredUntilTime?: string | null;
  sql: string;
  dataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
        deleteTime?: string | null;
        config: {
          bigQueryConfig?: { gcpProjectId?: string | null } | null;
          dataBricksConfig?: { host?: string | null } | null;
          snowflakeConfig?: { account: string } | null;
          redshiftConfig?: { cluster: string } | null;
        };
      }
    | null;
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entityColumnMapping: {
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Entity';
          createTime: string;
          name: string;
          displayName: string;
          primaryKeyType: MetricsV1ColumnType;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          defaultAssignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { name: string; displayName: string; state: MetricsV1TableState }
            | null;
        };
    column: { name: string };
  };
  dimensions: Array<{ name: string }>;
  labels: Array<{ key: string; value?: string | null }>;
  error?: { details: Array<string>; message?: string | null } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  timeConfig?: {
    window: string;
    timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
  } | null;
  valueMappings: Array<{
    column: string;
    mappings: Array<{
      inputDimensionValue?: string | null;
      outputDimensionValue?: string | null;
    }>;
  }>;
};

export type DimensionTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type DimensionTablesQuery = {
  dimensionTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDimensionTablesResponse';
        nextPageToken?: string | null;
        dimensionTables: Array<{
          __typename: 'MetricsV1DimensionTable';
          name: string;
          displayName: string;
          description?: string | null;
          state: MetricsV1TableState;
          dimensionDataDeliveredUntilTime?: string | null;
          sql: string;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
          dataDeliveredUntilUpdateStrategyConfig?: {
            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
            disableEmptyPartitions?: boolean | null;
            automaticUpdateConfig?: {
              commitDelay: string;
              changeThreshold?: { value?: string | null } | null;
            } | null;
            dailyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
            hourlyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
          } | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entityColumnMapping: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  createTime: string;
                  name: string;
                  displayName: string;
                  primaryKeyType: MetricsV1ColumnType;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                  defaultAssignmentTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                };
            column: { name: string };
          };
          dimensions: Array<{ name: string }>;
          labels: Array<{ key: string; value?: string | null }>;
          error?: { details: Array<string>; message?: string | null } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          timeConfig?: {
            window: string;
            timestampColumn: {
              name: string;
              type?: MetricsV1ColumnType | null;
            };
          } | null;
          valueMappings: Array<{
            column: string;
            mappings: Array<{
              inputDimensionValue?: string | null;
              outputDimensionValue?: string | null;
            }>;
          }>;
        }>;
      }
    | null;
};

export type EntitiesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type EntitiesQuery = {
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        nextPageToken?: string | null;
        entities: Array<{
          __typename: 'MetricsV1Entity';
          createTime: string;
          name: string;
          displayName: string;
          primaryKeyType: MetricsV1ColumnType;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          defaultAssignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { name: string; displayName: string; state: MetricsV1TableState }
            | null;
        }>;
      }
    | null;
};

export type EntityFragment = {
  __typename: 'MetricsV1Entity';
  createTime: string;
  name: string;
  displayName: string;
  primaryKeyType: MetricsV1ColumnType;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  defaultAssignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { name: string; displayName: string; state: MetricsV1TableState }
    | null;
};

export type EntityQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type EntityQuery = {
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        createTime: string;
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        defaultAssignmentTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { name: string; displayName: string; state: MetricsV1TableState }
          | null;
      }
    | null;
};

export type EntityRefFragment = {
  __typename: 'MetricsV1Entity';
  name: string;
  displayName: string;
  primaryKeyType: MetricsV1ColumnType;
};

export type EntityRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type EntityRefQuery = {
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
      }
    | null;
};

export type FactTableFragment = {
  __typename: 'MetricsV1FactTable';
  name: string;
  displayName: string;
  description?: string | null;
  sql: string;
  state: MetricsV1TableState;
  factDataDeliveredUntilTime?: string | null;
  timestampColumn: { name: string };
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        displayName: string;
        name: string;
        everyone?: boolean | null;
        user?:
          | { pictureUri?: string | null; name: string }
          | Record<PropertyKey, never>
          | null;
        group?: { name: string } | Record<PropertyKey, never> | null;
        apiClient?: { name: string } | Record<PropertyKey, never> | null;
      }
    | null;
  entities: Array<{
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
    column: { name: string };
  }>;
  measures: Array<{
    declaredType?: MetricsV1ColumnType | null;
    column: { name: string };
    unit?: {
      baseUnitMultiplier?: number | null;
      baseUnit?: MetricsV1UnitBaseUnit | null;
      currencyCode?: string | null;
      customUnit?: string | null;
    } | null;
  }>;
  dimensions: Array<{ name: string }>;
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  error?: { details: Array<string>; message?: string | null } | null;
  schemaValidationJob:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        name: string;
        successfulQueryResult?: {
          schema: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
        } | null;
      };
  source?: {
    type?: MetricsV1MetricMetricSourceType | null;
    reference?: string | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type FactTableQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type FactTableQuery = {
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        sql: string;
        state: MetricsV1TableState;
        factDataDeliveredUntilTime?: string | null;
        dataWarehouse?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1DataWarehouse';
              name: string;
              isPrimary?: boolean | null;
              deleteTime?: string | null;
              config: {
                bigQueryConfig?: { gcpProjectId?: string | null } | null;
                dataBricksConfig?: { host?: string | null } | null;
                snowflakeConfig?: { account: string } | null;
                redshiftConfig?: { cluster: string } | null;
              };
            }
          | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        entities: Array<{
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          column: { name: string };
        }>;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string };
          unit?: {
            baseUnitMultiplier?: number | null;
            baseUnit?: MetricsV1UnitBaseUnit | null;
            currencyCode?: string | null;
            customUnit?: string | null;
          } | null;
        }>;
        dimensions: Array<{ name: string }>;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                }>;
              } | null;
            };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type FactTableOptionFragment = {
  displayName: string;
  name: string;
  state: MetricsV1TableState;
  entities: Array<{
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1Entity'; displayName: string; name: string };
  }>;
  measures: Array<{
    column: { name: string; type?: MetricsV1ColumnType | null };
  }>;
  error?: { message?: string | null; details: Array<string> } | null;
};

export type FactTableRefFragment = {
  __typename: 'MetricsV1FactTable';
  name: string;
  displayName: string;
  state: MetricsV1TableState;
};

export type FactTableWithWarehouseFragment = {
  __typename: 'MetricsV1FactTable';
  name: string;
  displayName: string;
  description?: string | null;
  sql: string;
  state: MetricsV1TableState;
  factDataDeliveredUntilTime?: string | null;
  dataWarehouse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DataWarehouse';
        name: string;
        isPrimary?: boolean | null;
        deleteTime?: string | null;
        config: {
          bigQueryConfig?: { gcpProjectId?: string | null } | null;
          dataBricksConfig?: { host?: string | null } | null;
          snowflakeConfig?: { account: string } | null;
          redshiftConfig?: { cluster: string } | null;
        };
      }
    | null;
  timestampColumn: { name: string };
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        displayName: string;
        name: string;
        everyone?: boolean | null;
        user?:
          | { pictureUri?: string | null; name: string }
          | Record<PropertyKey, never>
          | null;
        group?: { name: string } | Record<PropertyKey, never> | null;
        apiClient?: { name: string } | Record<PropertyKey, never> | null;
      }
    | null;
  entities: Array<{
    entity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
    column: { name: string };
  }>;
  measures: Array<{
    declaredType?: MetricsV1ColumnType | null;
    column: { name: string };
    unit?: {
      baseUnitMultiplier?: number | null;
      baseUnit?: MetricsV1UnitBaseUnit | null;
      currencyCode?: string | null;
      customUnit?: string | null;
    } | null;
  }>;
  dimensions: Array<{ name: string }>;
  dataDeliveredUntilUpdateStrategyConfig?: {
    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
    disableEmptyPartitions?: boolean | null;
    automaticUpdateConfig?: {
      commitDelay: string;
      changeThreshold?: { value?: string | null } | null;
    } | null;
    dailyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
    hourlyUpdateConfig?: {
      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
      maxZeroDuration?: string | null;
    } | null;
  } | null;
  error?: { details: Array<string>; message?: string | null } | null;
  schemaValidationJob:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        name: string;
        successfulQueryResult?: {
          schema: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
        } | null;
      };
  source?: {
    type?: MetricsV1MetricMetricSourceType | null;
    reference?: string | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type FactTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FactTablesQuery = {
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        nextPageToken?: string | null;
        factTables: Array<{
          __typename: 'MetricsV1FactTable';
          name: string;
          displayName: string;
          description?: string | null;
          sql: string;
          state: MetricsV1TableState;
          factDataDeliveredUntilTime?: string | null;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
          timestampColumn: { name: string };
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                displayName: string;
                name: string;
                everyone?: boolean | null;
                user?:
                  | { pictureUri?: string | null; name: string }
                  | Record<PropertyKey, never>
                  | null;
                group?: { name: string } | Record<PropertyKey, never> | null;
                apiClient?:
                  | { name: string }
                  | Record<PropertyKey, never>
                  | null;
              }
            | null;
          entities: Array<{
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
            column: { name: string };
          }>;
          measures: Array<{
            declaredType?: MetricsV1ColumnType | null;
            column: { name: string };
            unit?: {
              baseUnitMultiplier?: number | null;
              baseUnit?: MetricsV1UnitBaseUnit | null;
              currencyCode?: string | null;
              customUnit?: string | null;
            } | null;
          }>;
          dimensions: Array<{ name: string }>;
          dataDeliveredUntilUpdateStrategyConfig?: {
            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
            disableEmptyPartitions?: boolean | null;
            automaticUpdateConfig?: {
              commitDelay: string;
              changeThreshold?: { value?: string | null } | null;
            } | null;
            dailyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
            hourlyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
          } | null;
          error?: { details: Array<string>; message?: string | null } | null;
          schemaValidationJob:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1SqlJob';
                name: string;
                successfulQueryResult?: {
                  schema: Array<{
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  }>;
                } | null;
              };
          source?: {
            type?: MetricsV1MetricMetricSourceType | null;
            reference?: string | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | null;
};

export type GetFactTableColumnsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetFactTableColumnsQuery = {
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        measures: Array<{
          displayName?: string | null;
          column: { name: string; type?: MetricsV1ColumnType | null };
        }>;
        dimensions: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
      }
    | null;
};

export type GetQueryPreviewQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;

export type GetQueryPreviewQuery = {
  sampleRows?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SampleRows';
        successfulQueryResult?: {
          schema: Array<{ name: string; type?: MetricsV1ColumnType | null }>;
          tableIssues: Array<{
            message?: string | null;
            severity?: MetricsV1TableIssueTableIssueSeverity | null;
          }>;
        } | null;
        failedQueryResult?: { error?: string | null } | null;
        sampleRows: Array<{
          values: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
};

export type GetSqlJobQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetSqlJobQuery = {
  sqlJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        state?: MetricsV1SqlJobState | null;
        failedQueryResult?: { error?: string | null } | null;
      }
    | null;
};

export type ListFactTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListFactTablesQuery = {
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        nextPageToken?: string | null;
        factTables: Array<{
          displayName: string;
          name: string;
          state: MetricsV1TableState;
          entities: Array<{
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  displayName: string;
                  name: string;
                };
          }>;
          measures: Array<{
            column: { name: string; type?: MetricsV1ColumnType | null };
          }>;
          error?: { message?: string | null; details: Array<string> } | null;
        }>;
      }
    | null;
};

export type MeasurementRefFragment = {
  __typename: 'MetricsV1Measurement';
  name: string;
  displayName: string;
};

export type MeasurementRefsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeasurementRefsQuery = {
  measurements?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMeasurementsResponse';
        nextPageToken?: string | null;
        measurements: Array<{
          __typename: 'MetricsV1Measurement';
          name: string;
          displayName: string;
        }>;
      }
    | null;
};

export type MetricPickerFragment = {
  name: string;
  displayName: string;
  description?: string | null;
  state?: MetricsV1MetricState | null;
  preferredDirection?: MetricsV1MetricPreferredDirection | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; displayName: string; name: string }
    | null;
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        state: MetricsV1TableState;
      }
    | null;
  measurementConfig?: {
    closedWindow?: { aggregationWindow: string; exposureOffset: string } | null;
    openWindow?: { dummy?: string | null } | null;
    semiOpenWindow?: {
      aggregationWindow: string;
      exposureOffset?: string | null;
    } | null;
  } | null;
  typeSpec?: {
    averageMetricSpec?: {
      __typename: 'MetricsV1MetricAverageMetricSpec';
    } | null;
    ratioMetricSpec?: { __typename: 'MetricsV1MetricRatioMetricSpec' } | null;
    quantileMetricSpec?: { quantileLevel: number } | null;
  } | null;
  labels: Array<{ value?: string | null; key: string }>;
  defaultEffectSize?: { value?: string | null } | null;
  varianceReductionConfig?: { disabled?: boolean | null } | null;
  nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
  source?: { type?: MetricsV1MetricMetricSourceType | null } | null;
  verification?: {
    state?: MetricsV1MetricMetricVerificationVerificationState | null;
  } | null;
};

export type MetricsTableErrorFragment = {
  details: Array<string>;
  message?: string | null;
};

export type MultipleMetricsPickerQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type MultipleMetricsPickerQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          name: string;
          displayName: string;
          description?: string | null;
          state?: MetricsV1MetricState | null;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                displayName: string;
                name: string;
              }
            | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | null;
          measurementConfig?: {
            closedWindow?: {
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            openWindow?: { dummy?: string | null } | null;
            semiOpenWindow?: {
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
          } | null;
          typeSpec?: {
            averageMetricSpec?: {
              __typename: 'MetricsV1MetricAverageMetricSpec';
            } | null;
            ratioMetricSpec?: {
              __typename: 'MetricsV1MetricRatioMetricSpec';
            } | null;
            quantileMetricSpec?: { quantileLevel: number } | null;
          } | null;
          labels: Array<{ value?: string | null; key: string }>;
          defaultEffectSize?: { value?: string | null } | null;
          varianceReductionConfig?: { disabled?: boolean | null } | null;
          nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
          source?: { type?: MetricsV1MetricMetricSourceType | null } | null;
          verification?: {
            state?: MetricsV1MetricMetricVerificationVerificationState | null;
          } | null;
        }>;
      }
    | null;
};

export type OnAssignmentTableCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAssignmentTableCreatedSubscription = {
  assignmentTableCreated?: {
    assignmentTable: {
      __typename: 'MetricsV1AssignmentTable';
      name: string;
      displayName: string;
      description?: string | null;
      deleteTime?: string | null;
      state: MetricsV1TableState;
      sql: string;
      assignmentDataDeliveredUntilTime?: string | null;
      timestampColumn: { name: string };
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      entityColumn: { name: string };
      exposureKeyColumn: { name: string };
      variantKeyColumn: { name: string };
      schemaValidationJob:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1SqlJob'; name: string };
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      error?: { details: Array<string>; message?: string | null } | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      dimensions: Array<{ name: string }>;
    };
  } | null;
};

export type OnAssignmentTableUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAssignmentTableUpdatedSubscription = {
  assignmentTableUpdated?: {
    assignmentTable: {
      __typename: 'MetricsV1AssignmentTable';
      name: string;
      displayName: string;
      description?: string | null;
      deleteTime?: string | null;
      state: MetricsV1TableState;
      sql: string;
      assignmentDataDeliveredUntilTime?: string | null;
      timestampColumn: { name: string };
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      entityColumn: { name: string };
      exposureKeyColumn: { name: string };
      variantKeyColumn: { name: string };
      schemaValidationJob:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1SqlJob'; name: string };
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      error?: { details: Array<string>; message?: string | null } | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      dimensions: Array<{ name: string }>;
    };
  } | null;
};

export type OnDimensionTableCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnDimensionTableCreatedSubscription = {
  dimensionTableCreated?: {
    dimensionTable: {
      __typename: 'MetricsV1DimensionTable';
      name: string;
      displayName: string;
      description?: string | null;
      state: MetricsV1TableState;
      dimensionDataDeliveredUntilTime?: string | null;
      sql: string;
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      entityColumnMapping: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              createTime: string;
              name: string;
              displayName: string;
              primaryKeyType: MetricsV1ColumnType;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
              defaultAssignmentTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
            };
        column: { name: string };
      };
      dimensions: Array<{ name: string }>;
      labels: Array<{ key: string; value?: string | null }>;
      error?: { details: Array<string>; message?: string | null } | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      timeConfig?: {
        window: string;
        timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
      } | null;
      valueMappings: Array<{
        column: string;
        mappings: Array<{
          inputDimensionValue?: string | null;
          outputDimensionValue?: string | null;
        }>;
      }>;
    };
  } | null;
};

export type OnDimensionTableUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnDimensionTableUpdatedSubscription = {
  dimensionTableUpdated?: {
    dimensionTable: {
      __typename: 'MetricsV1DimensionTable';
      name: string;
      displayName: string;
      description?: string | null;
      state: MetricsV1TableState;
      dimensionDataDeliveredUntilTime?: string | null;
      sql: string;
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      entityColumnMapping: {
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              createTime: string;
              name: string;
              displayName: string;
              primaryKeyType: MetricsV1ColumnType;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
              defaultAssignmentTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
            };
        column: { name: string };
      };
      dimensions: Array<{ name: string }>;
      labels: Array<{ key: string; value?: string | null }>;
      error?: { details: Array<string>; message?: string | null } | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      timeConfig?: {
        window: string;
        timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
      } | null;
      valueMappings: Array<{
        column: string;
        mappings: Array<{
          inputDimensionValue?: string | null;
          outputDimensionValue?: string | null;
        }>;
      }>;
    };
  } | null;
};

export type OnEntityCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnEntityCreatedSubscription = {
  entityCreated?: {
    entity: {
      __typename: 'MetricsV1Entity';
      createTime: string;
      name: string;
      displayName: string;
      primaryKeyType: MetricsV1ColumnType;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      defaultAssignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { name: string; displayName: string; state: MetricsV1TableState }
        | null;
    };
  } | null;
};

export type OnEntityUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnEntityUpdatedSubscription = {
  entityUpdated?: {
    entity: {
      __typename: 'MetricsV1Entity';
      createTime: string;
      name: string;
      displayName: string;
      primaryKeyType: MetricsV1ColumnType;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      defaultAssignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { name: string; displayName: string; state: MetricsV1TableState }
        | null;
    };
  } | null;
};

export type OnFactTableCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnFactTableCreatedSubscription = {
  factTableCreated?: {
    factTable: {
      __typename: 'MetricsV1FactTable';
      name: string;
      displayName: string;
      description?: string | null;
      sql: string;
      state: MetricsV1TableState;
      factDataDeliveredUntilTime?: string | null;
      timestampColumn: { name: string };
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      entities: Array<{
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        column: { name: string };
      }>;
      measures: Array<{
        declaredType?: MetricsV1ColumnType | null;
        column: { name: string };
        unit?: {
          baseUnitMultiplier?: number | null;
          baseUnit?: MetricsV1UnitBaseUnit | null;
          currencyCode?: string | null;
          customUnit?: string | null;
        } | null;
      }>;
      dimensions: Array<{ name: string }>;
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      error?: { details: Array<string>; message?: string | null } | null;
      schemaValidationJob:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1SqlJob';
            name: string;
            successfulQueryResult?: {
              schema: Array<{
                name: string;
                type?: MetricsV1ColumnType | null;
              }>;
            } | null;
          };
      source?: {
        type?: MetricsV1MetricMetricSourceType | null;
        reference?: string | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    };
  } | null;
};

export type OnFactTableUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnFactTableUpdatedSubscription = {
  factTableUpdated?: {
    factTable: {
      __typename: 'MetricsV1FactTable';
      name: string;
      displayName: string;
      description?: string | null;
      sql: string;
      state: MetricsV1TableState;
      factDataDeliveredUntilTime?: string | null;
      timestampColumn: { name: string };
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      entities: Array<{
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        column: { name: string };
      }>;
      measures: Array<{
        declaredType?: MetricsV1ColumnType | null;
        column: { name: string };
        unit?: {
          baseUnitMultiplier?: number | null;
          baseUnit?: MetricsV1UnitBaseUnit | null;
          currencyCode?: string | null;
          customUnit?: string | null;
        } | null;
      }>;
      dimensions: Array<{ name: string }>;
      dataDeliveredUntilUpdateStrategyConfig?: {
        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
        disableEmptyPartitions?: boolean | null;
        automaticUpdateConfig?: {
          commitDelay: string;
          changeThreshold?: { value?: string | null } | null;
        } | null;
        dailyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
        hourlyUpdateConfig?: {
          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
          maxZeroDuration?: string | null;
        } | null;
      } | null;
      error?: { details: Array<string>; message?: string | null } | null;
      schemaValidationJob:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1SqlJob';
            name: string;
            successfulQueryResult?: {
              schema: Array<{
                name: string;
                type?: MetricsV1ColumnType | null;
              }>;
            } | null;
          };
      source?: {
        type?: MetricsV1MetricMetricSourceType | null;
        reference?: string | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    };
  } | null;
};

export type PartitionFragment = {
  __typename: 'MetricsV1Partition';
  name: string;
  startTime: string;
  endTime: string;
  createTime: string;
};

export type PartitionsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartitionsQuery = {
  partitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListPartitionsResponse';
        nextPageToken?: string | null;
        partitions: Array<{
          __typename: 'MetricsV1Partition';
          name: string;
          startTime: string;
          endTime: string;
          createTime: string;
        }>;
      }
    | null;
};

export type UpdateAssignmentTableMutationVariables = Exact<{
  input: PartialMetricsV1AssignmentTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAssignmentTableMutation = {
  updateAssignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1AssignmentTable';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
        state: MetricsV1TableState;
        sql: string;
        assignmentDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumn: { name: string };
        exposureKeyColumn: { name: string };
        variantKeyColumn: { name: string };
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1SqlJob'; name: string };
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        dimensions: Array<{ name: string }>;
      }
    | null;
};

export type UpdateDimensionTableMutationVariables = Exact<{
  input: PartialMetricsV1DimensionTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateDimensionTableMutation = {
  updateDimensionTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DimensionTable';
        name: string;
        displayName: string;
        description?: string | null;
        state: MetricsV1TableState;
        dimensionDataDeliveredUntilTime?: string | null;
        sql: string;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entityColumnMapping: {
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                createTime: string;
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                defaultAssignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | null;
              };
          column: { name: string };
        };
        dimensions: Array<{ name: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        error?: { details: Array<string>; message?: string | null } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        timeConfig?: {
          window: string;
          timestampColumn: { name: string; type?: MetricsV1ColumnType | null };
        } | null;
        valueMappings: Array<{
          column: string;
          mappings: Array<{
            inputDimensionValue?: string | null;
            outputDimensionValue?: string | null;
          }>;
        }>;
      }
    | null;
};

export type UpdateEntityMutationVariables = Exact<{
  input: PartialMetricsV1EntityInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateEntityMutation = {
  updateEntity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        createTime: string;
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        defaultAssignmentTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { name: string; displayName: string; state: MetricsV1TableState }
          | null;
      }
    | null;
};

export type UpdateFactTableMutationVariables = Exact<{
  input: PartialMetricsV1FactTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateFactTableMutation = {
  updateFactTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        description?: string | null;
        sql: string;
        state: MetricsV1TableState;
        factDataDeliveredUntilTime?: string | null;
        timestampColumn: { name: string };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        entities: Array<{
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
          column: { name: string };
        }>;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string };
          unit?: {
            baseUnitMultiplier?: number | null;
            baseUnit?: MetricsV1UnitBaseUnit | null;
            currencyCode?: string | null;
            customUnit?: string | null;
          } | null;
        }>;
        dimensions: Array<{ name: string }>;
        dataDeliveredUntilUpdateStrategyConfig?: {
          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
          disableEmptyPartitions?: boolean | null;
          automaticUpdateConfig?: {
            commitDelay: string;
            changeThreshold?: { value?: string | null } | null;
          } | null;
          dailyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
          hourlyUpdateConfig?: {
            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
            maxZeroDuration?: string | null;
          } | null;
        } | null;
        error?: { details: Array<string>; message?: string | null } | null;
        schemaValidationJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                }>;
              } | null;
            };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type ArchiveMetricMutationVariables = Exact<{
  name: Scalars['String']['input'];
  archiveInfo?: InputMaybe<MetricsV1MetricArchiveInfoInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
}>;

export type ArchiveMetricMutation = {
  archiveMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type CancelMetricCalculationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CancelMetricCalculationMutation = {
  cancelMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { name: string; state?: MetricsV1MetricCalculationState | null }
    | null;
};

export type CreateMetricMutationVariables = Exact<{
  metric: MetricsV1MetricInput;
  metricId?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateMetricMutation = {
  createMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Metric'; name: string }
    | null;
};

export type CreateMetricCalculationMutationVariables = Exact<{
  metricCalculation: MetricsV1MetricCalculationInput;
  metricCalculationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateMetricCalculationMutation = {
  createMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1MetricCalculation'; name: string }
    | null;
};

export type DeleteMeasurementMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteMeasurementMutation = {
  deleteMeasurement?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Measurement'; name: string }
    | null;
};

export type DeleteMetricMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteMetricMutation = {
  deleteMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Metric'; name: string }
    | null;
};

export type DependenciesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
}>;

export type DependenciesQuery = {
  dependencies?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDependenciesResponse';
        dependencies: Array<{
          name: string;
          parent?:
            | { __typename: 'MetricsV1Dependency'; name: string }
            | Record<PropertyKey, never>
            | null;
          table: {
            assignments?: {
              assignmentTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1AssignmentTable';
                    name: string;
                    displayName: string;
                    dataDeliveredUntilUpdateStrategyConfig?: {
                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                      disableEmptyPartitions?: boolean | null;
                      automaticUpdateConfig?: {
                        commitDelay: string;
                        changeThreshold?: { value?: string | null } | null;
                      } | null;
                      dailyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                      hourlyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                    } | null;
                    partitionedUpdateStrategyState?: {
                      currentPartitionLastCheckTime?: string | null;
                      existsCheckDuration?: string | null;
                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                      usualLateness?: string | null;
                    } | null;
                  };
            } | null;
            dimensions?: {
              dimensionTable:
                | {
                    __typename: 'MetricsV1DimensionTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                    dataDeliveredUntilUpdateStrategyConfig?: {
                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                      disableEmptyPartitions?: boolean | null;
                      automaticUpdateConfig?: {
                        commitDelay: string;
                        changeThreshold?: { value?: string | null } | null;
                      } | null;
                      dailyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                      hourlyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                    } | null;
                    partitionedUpdateStrategyState?: {
                      currentPartitionLastCheckTime?: string | null;
                      existsCheckDuration?: string | null;
                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                      usualLateness?: string | null;
                    } | null;
                  }
                | Record<PropertyKey, never>;
            } | null;
            entityRelation?: {
              entityRelationTable:
                | {
                    __typename: 'MetricsV1EntityRelationTable';
                    name: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>;
            } | null;
            exposures?: {
              exposureTable:
                | {
                    __typename: 'MetricsV1ExposureTable';
                    name: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>;
              scheduledExposureCalculation?:
                | {
                    __typename: 'MetricsV1ScheduledExposureCalculation';
                    name: string;
                    state?: MetricsV1ScheduledExposureCalculationState | null;
                    status: {
                      calculating?: {
                        exposureCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      cancelled?: { cancelledTime: string } | null;
                      error?: { errorMessage: string } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        assignmentTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                      scheduled?: { nextScheduleTime: string } | null;
                    };
                  }
                | Record<PropertyKey, never>
                | null;
            } | null;
            facts?: {
              factTable:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    dataDeliveredUntilUpdateStrategyConfig?: {
                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                      disableEmptyPartitions?: boolean | null;
                      automaticUpdateConfig?: {
                        commitDelay: string;
                        changeThreshold?: { value?: string | null } | null;
                      } | null;
                      dailyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                      hourlyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                    } | null;
                    partitionedUpdateStrategyState?: {
                      currentPartitionLastCheckTime?: string | null;
                      existsCheckDuration?: string | null;
                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                      usualLateness?: string | null;
                    } | null;
                  }
                | Record<PropertyKey, never>;
            } | null;
            measurements?: {
              measurementTable:
                | {
                    __typename: 'MetricsV1MeasurementTable';
                    name: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>;
              scheduledMeasurementCalculation:
                | {
                    __typename: 'MetricsV1ScheduledMeasurementCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMeasurementCalculationState | null;
                    status: {
                      calculating?: {
                        __typename: 'MetricsV1ScheduledMeasurementCalculationStatusCalculating';
                      } | null;
                      cancelled?: { cancelledTime: string } | null;
                      error?: { errorMessage: string } | null;
                      waiting?: {
                        __typename: 'MetricsV1ScheduledMeasurementCalculationStatusWaiting';
                        needDataUntilTime: string;
                      } | null;
                      scheduled?: { nextScheduleTime: string } | null;
                    };
                  }
                | Record<PropertyKey, never>;
            } | null;
          };
          dataStatus: Array<{
            startTime: string;
            endTime: string;
            fulfilled?: boolean | null;
          }>;
        }>;
      }
    | null;
};

export type DependencyFragment = {
  name: string;
  parent?:
    | { __typename: 'MetricsV1Dependency'; name: string }
    | Record<PropertyKey, never>
    | null;
  table: {
    assignments?: {
      assignmentTable:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dataDeliveredUntilUpdateStrategyConfig?: {
              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
              disableEmptyPartitions?: boolean | null;
              automaticUpdateConfig?: {
                commitDelay: string;
                changeThreshold?: { value?: string | null } | null;
              } | null;
              dailyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
              hourlyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
            } | null;
            partitionedUpdateStrategyState?: {
              currentPartitionLastCheckTime?: string | null;
              existsCheckDuration?: string | null;
              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
              usualLateness?: string | null;
            } | null;
          };
    } | null;
    dimensions?: {
      dimensionTable:
        | {
            __typename: 'MetricsV1DimensionTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
            dataDeliveredUntilUpdateStrategyConfig?: {
              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
              disableEmptyPartitions?: boolean | null;
              automaticUpdateConfig?: {
                commitDelay: string;
                changeThreshold?: { value?: string | null } | null;
              } | null;
              dailyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
              hourlyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
            } | null;
            partitionedUpdateStrategyState?: {
              currentPartitionLastCheckTime?: string | null;
              existsCheckDuration?: string | null;
              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
              usualLateness?: string | null;
            } | null;
          }
        | Record<PropertyKey, never>;
    } | null;
    entityRelation?: {
      entityRelationTable:
        | {
            __typename: 'MetricsV1EntityRelationTable';
            name: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>;
    } | null;
    exposures?: {
      exposureTable:
        | {
            __typename: 'MetricsV1ExposureTable';
            name: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>;
      scheduledExposureCalculation?:
        | {
            __typename: 'MetricsV1ScheduledExposureCalculation';
            name: string;
            state?: MetricsV1ScheduledExposureCalculationState | null;
            status: {
              calculating?: {
                exposureCalculation:
                  | { name: string }
                  | Record<PropertyKey, never>;
              } | null;
              cancelled?: { cancelledTime: string } | null;
              error?: { errorMessage: string } | null;
              waiting?: {
                dataDeliveredUntilTime?: string | null;
                needDataUntilTime: string;
                assignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1AssignmentTable';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
              scheduled?: { nextScheduleTime: string } | null;
            };
          }
        | Record<PropertyKey, never>
        | null;
    } | null;
    facts?: {
      factTable:
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            dataDeliveredUntilUpdateStrategyConfig?: {
              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
              disableEmptyPartitions?: boolean | null;
              automaticUpdateConfig?: {
                commitDelay: string;
                changeThreshold?: { value?: string | null } | null;
              } | null;
              dailyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
              hourlyUpdateConfig?: {
                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                maxZeroDuration?: string | null;
              } | null;
            } | null;
            partitionedUpdateStrategyState?: {
              currentPartitionLastCheckTime?: string | null;
              existsCheckDuration?: string | null;
              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
              usualLateness?: string | null;
            } | null;
          }
        | Record<PropertyKey, never>;
    } | null;
    measurements?: {
      measurementTable:
        | {
            __typename: 'MetricsV1MeasurementTable';
            name: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>;
      scheduledMeasurementCalculation:
        | {
            __typename: 'MetricsV1ScheduledMeasurementCalculation';
            name: string;
            state?: MetricsV1ScheduledMeasurementCalculationState | null;
            status: {
              calculating?: {
                __typename: 'MetricsV1ScheduledMeasurementCalculationStatusCalculating';
              } | null;
              cancelled?: { cancelledTime: string } | null;
              error?: { errorMessage: string } | null;
              waiting?: {
                __typename: 'MetricsV1ScheduledMeasurementCalculationStatusWaiting';
                needDataUntilTime: string;
              } | null;
              scheduled?: { nextScheduleTime: string } | null;
            };
          }
        | Record<PropertyKey, never>;
    } | null;
  };
  dataStatus: Array<{
    startTime: string;
    endTime: string;
    fulfilled?: boolean | null;
  }>;
};

export type PartitionedUpdateStrategyStateFragment = {
  currentPartitionLastCheckTime?: string | null;
  existsCheckDuration?: string | null;
  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
  usualLateness?: string | null;
};

export type EntityRelationTablesQueryVariables = Exact<{
  entity: Scalars['String']['input'];
}>;

export type EntityRelationTablesQuery = {
  entityRelationTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntityRelationTablesResponse';
        entityRelationTables: Array<{
          name: string;
          targetEntity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              };
        }>;
      }
    | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
    | null;
};

export type ExposureCalculationFragment = {
  name: string;
  scheduleIteration: number;
  startTime: string;
  endTime: string;
  state: MetricsV1ExposureCalculationState;
  sql: string;
  createTime: string;
  updateTime: string;
  sqlJob:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        createTime: string;
        updateTime: string;
        name: string;
        state?: MetricsV1SqlJobState | null;
        labels: Array<{ key: string; value?: string | null }>;
        failedQueryResult?: { error?: string | null } | null;
      };
};

export type ExposureCalculationsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExposureCalculationsQuery = {
  exposureCalculations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListExposureCalculationsResponse';
        nextPageToken?: string | null;
        exposureCalculations: Array<{
          name: string;
          scheduleIteration: number;
          startTime: string;
          endTime: string;
          state: MetricsV1ExposureCalculationState;
          sql: string;
          createTime: string;
          updateTime: string;
          sqlJob:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1SqlJob';
                createTime: string;
                updateTime: string;
                name: string;
                state?: MetricsV1SqlJobState | null;
                labels: Array<{ key: string; value?: string | null }>;
                failedQueryResult?: { error?: string | null } | null;
              };
        }>;
      }
    | null;
};

export type ExposureTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExposureTablesQuery = {
  exposureTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListExposureTablesResponse';
        nextPageToken?: string | null;
        exposureTables: Array<{
          name: string;
          displayName: string;
          state: MetricsV1TableState;
          createTime: string;
          entity:
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | Record<PropertyKey, never>;
        }>;
      }
    | null;
};

export type ExposureTrendDataQueryVariables = Exact<{
  name: Scalars['String']['input'];
  groupByDimensions:
    | Array<Scalars['String']['input']>
    | Scalars['String']['input'];
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExposureTrendDataQuery = {
  queryScheduledMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1QueryScheduledMetricCalculationResponse';
        dimensions: Array<string>;
        minStartTime?: string | null;
        maxStartTime?: string | null;
        rows: Array<{
          aggCount?: number | null;
          dimensions: Array<{ key: string; value?: string | null }>;
          value?: {
            averageSummaryStats?: {
              count?: any | null;
              mean?: number | null;
              variance?: number | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type FactTableMeasuresQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type FactTableMeasuresQuery = {
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        measures: Array<{
          declaredType?: MetricsV1ColumnType | null;
          column: { name: string; type?: MetricsV1ColumnType | null };
        }>;
      }
    | null;
};

export type GetMandatoryMetricsMutationVariables = Exact<{
  instance: Scalars['String']['input'];
}>;

export type GetMandatoryMetricsMutation = {
  executeFunction?:
    | { __typename: 'WorkflowV1ExecuteFunctionResponse'; response?: any | null }
    | Record<PropertyKey, never>
    | null;
};

export type GetMetricDetailsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetMetricDetailsQuery = {
  metric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type GetMetricSchedulesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMetricSchedulesQuery = {
  scheduledMetricCalculations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListScheduledMetricCalculationsResponse';
        scheduledMetricCalculations: Array<{
          __typename: 'MetricsV1ScheduledMetricCalculation';
          name: string;
          state?: MetricsV1ScheduledMetricCalculationState | null;
          nextScheduledRunTime: string;
          nextExposureStartTime: string;
          nextExposureEndTime: string;
          iteration: number;
          executedCalculationsCount: number;
          status: {
            scheduled?: { nextScheduleTime: string } | null;
            cancelled?: { cancelledTime: string } | null;
            calculating?: {
              metricCalculation: { name: string } | Record<PropertyKey, never>;
            } | null;
            waiting?: {
              dataDeliveredUntilTime?: string | null;
              needDataUntilTime: string;
              exposureTable?:
                | { name: string }
                | Record<PropertyKey, never>
                | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>
                | null;
            } | null;
            error?: { errorMessage: string } | null;
          };
          metricCalculationSpec: {
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  name: string;
                  displayName: string;
                  nullHandling?: {
                    __typename: 'MetricsV1MetricNullHandlingConfig';
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  measurementConfig?: {
                    closedWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                    } | null;
                  } | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                        partitionedUpdateStrategyState?: {
                          currentPartitionLastCheckTime?: string | null;
                          existsCheckDuration?: string | null;
                          state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                          usualLateness?: string | null;
                        } | null;
                      }
                    | null;
                };
            exposureTable:
              | {
                  __typename: 'MetricsV1ExposureTable';
                  scheduledExposureCalculation?:
                    | {
                        __typename: 'MetricsV1ScheduledExposureCalculation';
                        name: string;
                        exposureCalculationSpec: {
                          __typename: 'MetricsV1ExposureCalculationSpec';
                          assignmentTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1AssignmentTable';
                                name: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                              };
                        };
                        status: {
                          calculating?: {
                            exposureCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          cancelled?: { cancelledTime: string } | null;
                          error?: { errorMessage: string } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            assignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1AssignmentTable';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                          scheduled?: { nextScheduleTime: string } | null;
                        };
                      }
                    | Record<PropertyKey, never>
                    | null;
                }
              | Record<PropertyKey, never>;
            measurementTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1MeasurementTable'; name: string }
              | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
};

export type ListMetricsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListMetricsQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          name: string;
          displayName: string;
          description?: string | null;
          state?: MetricsV1MetricState | null;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                displayName: string;
                name: string;
              }
            | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
          varianceReductionConfig?: { disabled?: boolean | null } | null;
          nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
          defaultEffectSize?: { value?: string | null } | null;
          typeSpec?: {
            averageMetricSpec?: {
              __typename: 'MetricsV1MetricAverageMetricSpec';
            } | null;
            ratioMetricSpec?: {
              __typename: 'MetricsV1MetricRatioMetricSpec';
            } | null;
            quantileMetricSpec?: { quantileLevel: number } | null;
          } | null;
          source?: { type?: MetricsV1MetricMetricSourceType | null } | null;
          verification?: {
            state?: MetricsV1MetricMetricVerificationVerificationState | null;
          } | null;
          measurementConfig?: {
            closedWindow?: {
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: { dummy?: string | null } | null;
          } | null;
          measurement?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Measurement';
                name: string;
                displayName: string;
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      displayName: string;
                      name: string;
                    };
                factTable:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                    };
                labels: Array<{ key: string; value?: string | null }>;
                typeSpec: {
                  averageMetricSpec?: {
                    __typename: 'MetricsV1MetricAverageMetricSpec';
                  } | null;
                  ratioMetricSpec?: {
                    __typename: 'MetricsV1MetricRatioMetricSpec';
                  } | null;
                  quantileMetricSpec?: { quantileLevel: number } | null;
                };
              }
            | null;
          dataWarehouse?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1DataWarehouse';
                name: string;
                isPrimary?: boolean | null;
                deleteTime?: string | null;
                config: {
                  bigQueryConfig?: { gcpProjectId?: string | null } | null;
                  dataBricksConfig?: { host?: string | null } | null;
                  snowflakeConfig?: { account: string } | null;
                  redshiftConfig?: { cluster: string } | null;
                };
              }
            | null;
        }>;
      }
    | null;
};

export type MeasurementQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type MeasurementQuery = {
  measurement?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Measurement';
        displayName: string;
        name: string;
        description?: string | null;
        deleteTime?: string | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            };
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type MeasurementCalculationFragment = {
  name: string;
  startTime: string;
  endTime: string;
  state?: MetricsV1MeasurementCalculationState | null;
  sql?: string | null;
  scheduleIteration: number;
  createTime: string;
  updateTime: string;
  sqlJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        name: string;
        createTime: string;
        updateTime: string;
        state?: MetricsV1SqlJobState | null;
        labels: Array<{ key: string; value?: string | null }>;
        failedQueryResult?: { error?: string | null } | null;
      }
    | null;
  supersededBy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1MeasurementCalculation'; name: string }
    | null;
  times: {
    exposureEndTime: string;
    exposureStartTime: string;
    factEndTime?: string | null;
    factStartTime?: string | null;
  };
};

export type MeasurementCalculationsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeasurementCalculationsQuery = {
  measurementCalculations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMeasurementCalculationsResponse';
        nextPageToken?: string | null;
        measurementCalculations: Array<{
          name: string;
          startTime: string;
          endTime: string;
          state?: MetricsV1MeasurementCalculationState | null;
          sql?: string | null;
          scheduleIteration: number;
          createTime: string;
          updateTime: string;
          sqlJob?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1SqlJob';
                name: string;
                createTime: string;
                updateTime: string;
                state?: MetricsV1SqlJobState | null;
                labels: Array<{ key: string; value?: string | null }>;
                failedQueryResult?: { error?: string | null } | null;
              }
            | null;
          supersededBy?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'MetricsV1MeasurementCalculation'; name: string }
            | null;
          times: {
            exposureEndTime: string;
            exposureStartTime: string;
            factEndTime?: string | null;
            factStartTime?: string | null;
          };
        }>;
      }
    | null;
};

export type MeasurementConfigFieldsFragment = {
  closedWindow?: { aggregationWindow: string; exposureOffset: string } | null;
  semiOpenWindow?: {
    aggregationWindow: string;
    exposureOffset?: string | null;
  } | null;
  openWindow?: { dummy?: string | null } | null;
};

export type MeasurementDetailsFragment = {
  __typename: 'MetricsV1Measurement';
  displayName: string;
  name: string;
  description?: string | null;
  deleteTime?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        displayName: string;
        name: string;
        everyone?: boolean | null;
        user?:
          | { pictureUri?: string | null; name: string }
          | Record<PropertyKey, never>
          | null;
        group?: { name: string } | Record<PropertyKey, never> | null;
        apiClient?: { name: string } | Record<PropertyKey, never> | null;
      }
    | null;
  factTable:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        state: MetricsV1TableState;
      };
  filter?: {
    criteria: Array<{
      key: string;
      value?: {
        attribute?: {
          attribute: string;
          eqRule?: {
            value: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            };
          } | null;
          setRule?: {
            values: Array<{
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            }>;
          } | null;
          rangeRule?: {
            startInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            startExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            endInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            endExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
          } | null;
          likeRule?: { pattern: string } | null;
        } | null;
      } | null;
    }>;
    expression: {
      ref?: string | null;
      not?: { ref?: string | null } | null;
      and?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
        }>;
      } | null;
      or?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
        }>;
      } | null;
    };
  } | null;
  entity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
  nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
  typeSpec: {
    ratioMetricSpec?: {
      numerator?: { name: string } | null;
      numeratorAggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
      numeratorFilter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
      denominator?: { name: string } | null;
      denominatorAggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
      denominatorFilter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
    } | null;
    averageMetricSpec?: {
      measurement?: { name: string; type?: MetricsV1ColumnType | null } | null;
      aggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
    } | null;
    quantileMetricSpec?: {
      quantileLevel: number;
      measurement?: { name: string; type?: MetricsV1ColumnType | null } | null;
      aggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
    } | null;
  };
  source?: {
    type?: MetricsV1MetricMetricSourceType | null;
    reference?: string | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type MeasurementListItemFragment = {
  name: string;
  displayName: string;
  description?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; displayName: string; name: string };
  factTable:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        state: MetricsV1TableState;
      };
  labels: Array<{ key: string; value?: string | null }>;
  typeSpec: {
    averageMetricSpec?: {
      aggregation: { type: MetricsV1AggregationType };
    } | null;
    ratioMetricSpec?: {
      numeratorAggregation: { type: MetricsV1AggregationType };
    } | null;
    quantileMetricSpec?: {
      quantileLevel: number;
      aggregation: { type: MetricsV1AggregationType };
    } | null;
  };
};

export type MeasurementMetricsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeasurementMetricsQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          __typename: 'MetricsV1Metric';
          name: string;
          displayName: string;
          deleteTime?: string | null;
          state?: MetricsV1MetricState | null;
          labels: Array<{ key: string; value?: string | null }>;
          measurementConfig?: {
            closedWindow?: {
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: { dummy?: string | null } | null;
          } | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        }>;
      }
    | null;
};

export type MeasurementPageMetricFragment = {
  __typename: 'MetricsV1Metric';
  name: string;
  displayName: string;
  deleteTime?: string | null;
  state?: MetricsV1MetricState | null;
  labels: Array<{ key: string; value?: string | null }>;
  measurementConfig?: {
    closedWindow?: { aggregationWindow: string; exposureOffset: string } | null;
    semiOpenWindow?: {
      aggregationWindow: string;
      exposureOffset?: string | null;
    } | null;
    openWindow?: { dummy?: string | null } | null;
  } | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type MeasurementScheduleStatusFragment = {
  scheduled?: { nextScheduleTime: string } | null;
  cancelled?: { cancelledTime: string } | null;
  calculating?: {
    measurementCalculation: { name: string } | Record<PropertyKey, never>;
  } | null;
  waiting?: {
    dataDeliveredUntilTime?: string | null;
    needDataUntilTime: string;
    exposureTable?: { name: string } | Record<PropertyKey, never> | null;
    factTable?:
      | {
          __typename: 'MetricsV1FactTable';
          name: string;
          displayName: string;
          state: MetricsV1TableState;
        }
      | Record<PropertyKey, never>
      | null;
  } | null;
  error?: { errorMessage: string } | null;
};

export type MeasurementsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeasurementsQuery = {
  measurements?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMeasurementsResponse';
        nextPageToken?: string | null;
        measurements: Array<{
          name: string;
          displayName: string;
          description?: string | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                displayName: string;
                name: string;
              };
          factTable:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              };
          labels: Array<{ key: string; value?: string | null }>;
          typeSpec: {
            averageMetricSpec?: {
              aggregation: { type: MetricsV1AggregationType };
            } | null;
            ratioMetricSpec?: {
              numeratorAggregation: { type: MetricsV1AggregationType };
            } | null;
            quantileMetricSpec?: {
              quantileLevel: number;
              aggregation: { type: MetricsV1AggregationType };
            } | null;
          };
        }>;
      }
    | null;
};

export type MetricFragment = {
  name: string;
  displayName: string;
  description?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; displayName: string; name: string }
    | null;
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        state: MetricsV1TableState;
      }
    | null;
};

export type MetricQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type MetricQuery = {
  metric?:
    | { __typename: 'Error' }
    | {
        __typename: 'MetricsV1Metric';
        name: string;
        displayName: string;
        description?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; displayName: string; name: string }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          openWindow?: { dummy?: string | null } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
        } | null;
        typeSpec?: {
          averageMetricSpec?: {
            __typename: 'MetricsV1MetricAverageMetricSpec';
          } | null;
          ratioMetricSpec?: {
            __typename: 'MetricsV1MetricRatioMetricSpec';
          } | null;
          quantileMetricSpec?: { quantileLevel: number } | null;
        } | null;
        labels: Array<{ value?: string | null; key: string }>;
        defaultEffectSize?: { value?: string | null } | null;
        varianceReductionConfig?: { disabled?: boolean | null } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        source?: { type?: MetricsV1MetricMetricSourceType | null } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
        } | null;
      }
    | null;
};

export type MetricAggregationFragment = {
  type: MetricsV1AggregationType;
  threshold?: {
    direction: MetricsV1AggregationThresholdDirection;
    threshold: { value?: string | null };
  } | null;
  cap?: {
    min?: { value?: string | null } | null;
    max?: { value?: string | null } | null;
  } | null;
};

export type MetricAssignmentTableFragment = {
  displayName: string;
  name: string;
  state: MetricsV1TableState;
  error?: { message?: string | null; details: Array<string> } | null;
};

export type MetricCalculationFragment = {
  name: string;
  startTime: string;
  endTime?: string | null;
  state?: MetricsV1MetricCalculationState | null;
  sql?: string | null;
  scheduleIteration: number;
  createTime: string;
  updateTime: string;
  sqlJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        name: string;
        createTime: string;
        updateTime: string;
        state?: MetricsV1SqlJobState | null;
        labels: Array<{ key: string; value?: string | null }>;
        failedQueryResult?: { error?: string | null } | null;
      }
    | null;
  metricResults?: {
    metricBucketStats: Array<{
      variant: string;
      summaryStats: {
        ratioSummaryStats?: {
          count?: any | null;
          numeratorMean?: number | null;
          numeratorVariance?: number | null;
          denominatorMean?: number | null;
          denominatorVariance?: number | null;
          countMissing?: any | null;
        } | null;
        averageSummaryStats?: {
          count?: any | null;
          mean?: number | null;
          variance?: number | null;
          countMissing?: any | null;
        } | null;
      };
      dimensions: Array<{ value?: string | null; dimension?: string | null }>;
    }>;
  } | null;
  supersededBy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1MetricCalculation'; name: string }
    | null;
  times: {
    exposureEndTime: string;
    exposureStartTime: string;
    factEndTime: string;
    factStartTime: string;
  };
  outdatedSourceDataInfo?: {
    actualCount: any;
    expectedCount: any;
    queryEndTime: string;
    queryStartTime: string;
    table: string;
  } | null;
};

export type MetricCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type MetricCalculationQuery = {
  metricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1MetricCalculation';
        name: string;
        createTime: string;
        error?: string | null;
        sql?: string | null;
        state?: MetricsV1MetricCalculationState | null;
        endTime?: string | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        labels: Array<{ key: string; value?: string | null }>;
        metricResults?: {
          metricBucketStats: Array<{
            variant: string;
            dimensions: Array<{
              value?: string | null;
              dimension?: string | null;
            }>;
            summaryStats: {
              averageSummaryStats?: {
                mean?: number | null;
                variance?: number | null;
                count?: any | null;
                countMissing?: any | null;
              } | null;
              ratioSummaryStats?: {
                count?: any | null;
                numeratorMean?: number | null;
                numeratorVariance?: number | null;
                denominatorMean?: number | null;
                denominatorVariance?: number | null;
                countMissing?: any | null;
              } | null;
            };
          }>;
        } | null;
        sqlJob?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              state?: MetricsV1SqlJobState | null;
              failedQueryResult?: { error?: string | null } | null;
              pendingQueryResult?: { dummy?: string | null } | null;
              successfulQueryResult?: {
                schema: Array<{
                  name: string;
                  type?: MetricsV1ColumnType | null;
                  repeated?: boolean | null;
                }>;
                issues: Array<{ message?: string | null; name: string }>;
              } | null;
            }
          | null;
      }
    | null;
};

export type MetricCalculationSpecFragment = {
  metric:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        name: string;
        displayName: string;
        nullHandling?: {
          __typename: 'MetricsV1MetricNullHandlingConfig';
          replaceEntityNullWithZero?: boolean | null;
        } | null;
        measurementConfig?: {
          closedWindow?: {
            __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: {
            __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
          } | null;
        } | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              dataDeliveredUntilUpdateStrategyConfig?: {
                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                disableEmptyPartitions?: boolean | null;
                automaticUpdateConfig?: {
                  commitDelay: string;
                  changeThreshold?: { value?: string | null } | null;
                } | null;
                dailyUpdateConfig?: {
                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                  maxZeroDuration?: string | null;
                } | null;
                hourlyUpdateConfig?: {
                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                  maxZeroDuration?: string | null;
                } | null;
              } | null;
              partitionedUpdateStrategyState?: {
                currentPartitionLastCheckTime?: string | null;
                existsCheckDuration?: string | null;
                state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                usualLateness?: string | null;
              } | null;
            }
          | null;
      };
  exposureTable:
    | {
        __typename: 'MetricsV1ExposureTable';
        scheduledExposureCalculation?:
          | {
              __typename: 'MetricsV1ScheduledExposureCalculation';
              name: string;
              exposureCalculationSpec: {
                __typename: 'MetricsV1ExposureCalculationSpec';
                assignmentTable:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1AssignmentTable';
                      name: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                    };
              };
              status: {
                calculating?: {
                  exposureCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                cancelled?: { cancelledTime: string } | null;
                error?: { errorMessage: string } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  assignmentTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1AssignmentTable';
                        name: string;
                        displayName: string;
                      }
                    | null;
                } | null;
                scheduled?: { nextScheduleTime: string } | null;
              };
            }
          | Record<PropertyKey, never>
          | null;
      }
    | Record<PropertyKey, never>;
  measurementTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1MeasurementTable'; name: string }
    | null;
};

export type MetricCalculationsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricCalculationsQuery = {
  metricCalculations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricCalculationsResponse';
        nextPageToken?: string | null;
        metricCalculations: Array<{
          name: string;
          startTime: string;
          endTime?: string | null;
          state?: MetricsV1MetricCalculationState | null;
          sql?: string | null;
          scheduleIteration: number;
          createTime: string;
          updateTime: string;
          sqlJob?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1SqlJob';
                name: string;
                createTime: string;
                updateTime: string;
                state?: MetricsV1SqlJobState | null;
                labels: Array<{ key: string; value?: string | null }>;
                failedQueryResult?: { error?: string | null } | null;
              }
            | null;
          metricResults?: {
            metricBucketStats: Array<{
              variant: string;
              summaryStats: {
                ratioSummaryStats?: {
                  count?: any | null;
                  numeratorMean?: number | null;
                  numeratorVariance?: number | null;
                  denominatorMean?: number | null;
                  denominatorVariance?: number | null;
                  countMissing?: any | null;
                } | null;
                averageSummaryStats?: {
                  count?: any | null;
                  mean?: number | null;
                  variance?: number | null;
                  countMissing?: any | null;
                } | null;
              };
              dimensions: Array<{
                value?: string | null;
                dimension?: string | null;
              }>;
            }>;
          } | null;
          supersededBy?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'MetricsV1MetricCalculation'; name: string }
            | null;
          times: {
            exposureEndTime: string;
            exposureStartTime: string;
            factEndTime: string;
            factStartTime: string;
          };
          outdatedSourceDataInfo?: {
            actualCount: any;
            expectedCount: any;
            queryEndTime: string;
            queryStartTime: string;
            table: string;
          } | null;
        }>;
      }
    | null;
};

export type MetricConfigAssignmentTablesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricConfigAssignmentTablesQuery = {
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        nextPageToken?: string | null;
        assignmentTables: Array<{
          displayName: string;
          name: string;
          state: MetricsV1TableState;
          error?: { message?: string | null; details: Array<string> } | null;
        }>;
      }
    | null;
};

export type MetricConfigEntitiesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricConfigEntitiesQuery = {
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        nextPageToken?: string | null;
        entities: Array<{
          primaryKeyType: MetricsV1ColumnType;
          displayName: string;
          name: string;
        }>;
      }
    | null;
};

export type MetricDetailsFragment = {
  __typename: 'MetricsV1Metric';
  displayName: string;
  name: string;
  description?: string | null;
  createTime: string;
  updateTime: string;
  deleteTime?: string | null;
  state?: MetricsV1MetricState | null;
  preferredDirection?: MetricsV1MetricPreferredDirection | null;
  measurement?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Measurement';
        name: string;
        displayName: string;
        typeSpec: {
          averageMetricSpec?: {
            measurement?: { name: string } | null;
            aggregation: { type: MetricsV1AggregationType };
          } | null;
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: { type: MetricsV1AggregationType };
            denominator?: { name: string } | null;
            denominatorAggregation: { type: MetricsV1AggregationType };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            aggregation: { type: MetricsV1AggregationType };
          } | null;
        };
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        factTable:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            };
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
      }
    | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        displayName: string;
        name: string;
        everyone?: boolean | null;
        user?:
          | { pictureUri?: string | null; name: string }
          | Record<PropertyKey, never>
          | null;
        group?: { name: string } | Record<PropertyKey, never> | null;
        apiClient?: { name: string } | Record<PropertyKey, never> | null;
      }
    | null;
  factTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1FactTable';
        name: string;
        displayName: string;
        state: MetricsV1TableState;
      }
    | null;
  filter?: {
    criteria: Array<{
      key: string;
      value?: {
        attribute?: {
          attribute: string;
          eqRule?: {
            value: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            };
          } | null;
          setRule?: {
            values: Array<{
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            }>;
          } | null;
          rangeRule?: {
            startInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            startExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            endInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
            endExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              nullValue?: { dummyField?: string | null } | null;
            } | null;
          } | null;
          likeRule?: { pattern: string } | null;
        } | null;
      } | null;
    }>;
    expression: {
      ref?: string | null;
      not?: { ref?: string | null } | null;
      and?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
        }>;
      } | null;
      or?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
            }>;
          } | null;
        }>;
      } | null;
    };
  } | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
    | null;
  measurementConfig?: {
    closedWindow?: { aggregationWindow: string; exposureOffset: string } | null;
    semiOpenWindow?: {
      aggregationWindow: string;
      exposureOffset?: string | null;
    } | null;
    openWindow?: { dummy?: string | null } | null;
  } | null;
  varianceReductionConfig?: {
    aggregationWindowOverride?: string | null;
    disabled?: boolean | null;
  } | null;
  nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
  typeSpec?: {
    ratioMetricSpec?: {
      numerator?: { name: string } | null;
      numeratorAggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
      numeratorFilter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
      denominator?: { name: string } | null;
      denominatorAggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
      denominatorFilter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
    } | null;
    averageMetricSpec?: {
      measurement?: { name: string; type?: MetricsV1ColumnType | null } | null;
      aggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
    } | null;
    quantileMetricSpec?: {
      quantileLevel: number;
      measurement?: { name: string; type?: MetricsV1ColumnType | null } | null;
      aggregation: {
        type: MetricsV1AggregationType;
        threshold?: {
          direction: MetricsV1AggregationThresholdDirection;
          threshold: { value?: string | null };
        } | null;
        cap?: {
          min?: { value?: string | null } | null;
          max?: { value?: string | null } | null;
        } | null;
      };
    } | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  archiveInfo?: { reason?: string | null; archiveTime?: string | null } | null;
  defaultEffectSize?: { value?: string | null } | null;
  source?: {
    type?: MetricsV1MetricMetricSourceType | null;
    reference?: string | null;
  } | null;
  verification?: {
    state?: MetricsV1MetricMetricVerificationVerificationState | null;
    verifyTime?: string | null;
    verifier?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
      | null;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type MetricDialogEntityRelationTableFragmentFragment = {
  name: string;
  targetEntity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
};

export type MetricEntityFragment = {
  primaryKeyType: MetricsV1ColumnType;
  displayName: string;
  name: string;
};

export type MetricFilterSetRuleFragment = {
  values: Array<{
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  }>;
};

export type MetricsFilterRangeRuleFragment = {
  startInclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  } | null;
  startExclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  } | null;
  endInclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  } | null;
  endExclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  } | null;
};

export type MetricFilterEqRuleFragment = {
  value: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    nullValue?: { dummyField?: string | null } | null;
  };
};

export type MetricFilterLikeRuleFragment = { pattern: string };

export type MetricsFilterValueFragment = {
  boolValue?: boolean | null;
  numberValue?: number | null;
  stringValue?: string | null;
  timestampValue?: string | null;
  nullValue?: { dummyField?: string | null } | null;
};

export type MetricFilterValuesFragment = {
  eqRule?: {
    value: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    };
  } | null;
  setRule?: {
    values: Array<{
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    }>;
  } | null;
  rangeRule?: {
    startInclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    } | null;
    startExclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    } | null;
    endInclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    } | null;
    endExclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      nullValue?: { dummyField?: string | null } | null;
    } | null;
  } | null;
  likeRule?: { pattern: string } | null;
};

export type MetricFilterCriterionFragment = {
  attribute?: {
    attribute: string;
    eqRule?: {
      value: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      };
    } | null;
    setRule?: {
      values: Array<{
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      }>;
    } | null;
    rangeRule?: {
      startInclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      } | null;
      startExclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      } | null;
      endInclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      } | null;
      endExclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        nullValue?: { dummyField?: string | null } | null;
      } | null;
    } | null;
    likeRule?: { pattern: string } | null;
  } | null;
};

export type MetricFilterExpressionFragment = {
  ref?: string | null;
  not?: { ref?: string | null } | null;
  and?: {
    operands: Array<{
      ref?: string | null;
      not?: { ref?: string | null } | null;
      and?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
        }>;
      } | null;
      or?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
        }>;
      } | null;
    }>;
  } | null;
  or?: {
    operands: Array<{
      ref?: string | null;
      not?: { ref?: string | null } | null;
      and?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
        }>;
      } | null;
      or?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type MetricFilterFragment = {
  criteria: Array<{
    key: string;
    value?: {
      attribute?: {
        attribute: string;
        eqRule?: {
          value: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          };
        } | null;
        setRule?: {
          values: Array<{
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          }>;
        } | null;
        rangeRule?: {
          startInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          } | null;
          startExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          } | null;
          endInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          } | null;
          endExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            nullValue?: { dummyField?: string | null } | null;
          } | null;
        } | null;
        likeRule?: { pattern: string } | null;
      } | null;
    } | null;
  }>;
  expression: {
    ref?: string | null;
    not?: { ref?: string | null } | null;
    and?: {
      operands: Array<{
        ref?: string | null;
        not?: { ref?: string | null } | null;
        and?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
          }>;
        } | null;
        or?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
          }>;
        } | null;
      }>;
    } | null;
    or?: {
      operands: Array<{
        ref?: string | null;
        not?: { ref?: string | null } | null;
        and?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
          }>;
        } | null;
        or?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
          }>;
        } | null;
      }>;
    } | null;
  };
};

export type MetricPreviewCalculationFragment = {
  __typename: 'MetricsV1MetricCalculation';
  name: string;
  createTime: string;
  error?: string | null;
  sql?: string | null;
  state?: MetricsV1MetricCalculationState | null;
  endTime?: string | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  labels: Array<{ key: string; value?: string | null }>;
  metricResults?: {
    metricBucketStats: Array<{
      variant: string;
      dimensions: Array<{ value?: string | null; dimension?: string | null }>;
      summaryStats: {
        averageSummaryStats?: {
          mean?: number | null;
          variance?: number | null;
          count?: any | null;
          countMissing?: any | null;
        } | null;
        ratioSummaryStats?: {
          count?: any | null;
          numeratorMean?: number | null;
          numeratorVariance?: number | null;
          denominatorMean?: number | null;
          denominatorVariance?: number | null;
          countMissing?: any | null;
        } | null;
      };
    }>;
  } | null;
  sqlJob?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1SqlJob';
        state?: MetricsV1SqlJobState | null;
        failedQueryResult?: { error?: string | null } | null;
        pendingQueryResult?: { dummy?: string | null } | null;
        successfulQueryResult?: {
          schema: Array<{
            name: string;
            type?: MetricsV1ColumnType | null;
            repeated?: boolean | null;
          }>;
          issues: Array<{ message?: string | null; name: string }>;
        } | null;
      }
    | null;
};

export type MetricPreviewCalculationsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MetricPreviewCalculationsQuery = {
  metricCalculations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricCalculationsResponse';
        metricCalculations: Array<{
          __typename: 'MetricsV1MetricCalculation';
          name: string;
          createTime: string;
          error?: string | null;
          sql?: string | null;
          state?: MetricsV1MetricCalculationState | null;
          endTime?: string | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          labels: Array<{ key: string; value?: string | null }>;
          metricResults?: {
            metricBucketStats: Array<{
              variant: string;
              dimensions: Array<{
                value?: string | null;
                dimension?: string | null;
              }>;
              summaryStats: {
                averageSummaryStats?: {
                  mean?: number | null;
                  variance?: number | null;
                  count?: any | null;
                  countMissing?: any | null;
                } | null;
                ratioSummaryStats?: {
                  count?: any | null;
                  numeratorMean?: number | null;
                  numeratorVariance?: number | null;
                  denominatorMean?: number | null;
                  denominatorVariance?: number | null;
                  countMissing?: any | null;
                } | null;
              };
            }>;
          } | null;
          sqlJob?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1SqlJob';
                state?: MetricsV1SqlJobState | null;
                failedQueryResult?: { error?: string | null } | null;
                pendingQueryResult?: { dummy?: string | null } | null;
                successfulQueryResult?: {
                  schema: Array<{
                    name: string;
                    type?: MetricsV1ColumnType | null;
                    repeated?: boolean | null;
                  }>;
                  issues: Array<{ message?: string | null; name: string }>;
                } | null;
              }
            | null;
        }>;
      }
    | null;
};

export type MetricRowFragment = {
  aggCount?: number | null;
  dimensions: Array<{ key: string; value?: string | null }>;
  value?: {
    averageSummaryStats?: {
      mean?: number | null;
      variance?: number | null;
      count?: any | null;
      countMissing?: any | null;
      summaryStatsInfo?: {
        min?: number | null;
        max?: number | null;
        countZeroes?: any | null;
      } | null;
    } | null;
    ratioSummaryStats?: {
      numeratorMean?: number | null;
      numeratorVariance?: number | null;
      denominatorMean?: number | null;
      denominatorVariance?: number | null;
      numeratorDenominatorCovariance?: number | null;
      count?: any | null;
      countMissing?: any | null;
      numeratorSummaryStatsInfo?: {
        min?: number | null;
        max?: number | null;
        countZeroes?: any | null;
      } | null;
      denominatorSummaryStatsInfo?: {
        min?: number | null;
        max?: number | null;
        countZeroes?: any | null;
      } | null;
    } | null;
  } | null;
};

export type MetricScheduleFragment = {
  __typename: 'MetricsV1ScheduledMetricCalculation';
  name: string;
  state?: MetricsV1ScheduledMetricCalculationState | null;
  nextScheduledRunTime: string;
  nextExposureStartTime: string;
  nextExposureEndTime: string;
  iteration: number;
  executedCalculationsCount: number;
  status: {
    scheduled?: { nextScheduleTime: string } | null;
    cancelled?: { cancelledTime: string } | null;
    calculating?: {
      metricCalculation: { name: string } | Record<PropertyKey, never>;
    } | null;
    waiting?: {
      dataDeliveredUntilTime?: string | null;
      needDataUntilTime: string;
      exposureTable?: { name: string } | Record<PropertyKey, never> | null;
      factTable?:
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>
        | null;
    } | null;
    error?: { errorMessage: string } | null;
  };
  metricCalculationSpec: {
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Metric';
          name: string;
          displayName: string;
          nullHandling?: {
            __typename: 'MetricsV1MetricNullHandlingConfig';
            replaceEntityNullWithZero?: boolean | null;
          } | null;
          measurementConfig?: {
            closedWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
            } | null;
          } | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                partitionedUpdateStrategyState?: {
                  currentPartitionLastCheckTime?: string | null;
                  existsCheckDuration?: string | null;
                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                  usualLateness?: string | null;
                } | null;
              }
            | null;
        };
    exposureTable:
      | {
          __typename: 'MetricsV1ExposureTable';
          scheduledExposureCalculation?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
                exposureCalculationSpec: {
                  __typename: 'MetricsV1ExposureCalculationSpec';
                  assignmentTable:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1AssignmentTable';
                        name: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                      };
                };
                status: {
                  calculating?: {
                    exposureCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  cancelled?: { cancelledTime: string } | null;
                  error?: { errorMessage: string } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    assignmentTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1AssignmentTable';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                  scheduled?: { nextScheduleTime: string } | null;
                };
              }
            | Record<PropertyKey, never>
            | null;
        }
      | Record<PropertyKey, never>;
    measurementTable?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1MeasurementTable'; name: string }
      | null;
  };
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
};

export type MetricUsageQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricUsageQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          state: string;
          displayName: string;
          name: string;
          checks: Array<{
            message: string;
            name: string;
            state: WorkflowV1WorkflowInstanceCheckState;
            updateTime: string;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            metrics?: {
              metrics: Array<{
                __typename: 'MetricsDataMetric';
                preferredDirection?: MetricsDataMetricPreferredDirection | null;
              }>;
            } | null;
          };
        }>;
      }
    | null;
};

export type MetricUsageWorkflowInstanceFragment = {
  state: string;
  displayName: string;
  name: string;
  checks: Array<{
    message: string;
    name: string;
    state: WorkflowV1WorkflowInstanceCheckState;
    updateTime: string;
    labels: Array<{ key: string; value?: string | null }>;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  moduleData2: {
    metrics?: {
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
      }>;
    } | null;
  };
};

export type MetricsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricsQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          name: string;
          displayName: string;
          description?: string | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                displayName: string;
                name: string;
              }
            | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | null;
        }>;
      }
    | null;
};

export type MetricsListMeasurementFragment = {
  name: string;
  displayName: string;
  entity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; displayName: string; name: string };
  factTable:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1FactTable'; name: string; displayName: string };
  labels: Array<{ key: string; value?: string | null }>;
  typeSpec: {
    averageMetricSpec?: {
      __typename: 'MetricsV1MetricAverageMetricSpec';
    } | null;
    ratioMetricSpec?: { __typename: 'MetricsV1MetricRatioMetricSpec' } | null;
    quantileMetricSpec?: { quantileLevel: number } | null;
  };
};

export type MetricsPickerQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type MetricsPickerQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        nextPageToken?: string | null;
        metrics: Array<{
          name: string;
          displayName: string;
          description?: string | null;
          state?: MetricsV1MetricState | null;
        }>;
      }
    | null;
};

export type OnMeasurementUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnMeasurementUpdatedSubscription = {
  measurementUpdated?: {
    measurement: {
      __typename: 'MetricsV1Measurement';
      displayName: string;
      name: string;
      description?: string | null;
      deleteTime?: string | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      factTable:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
          };
      filter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
      entity:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string };
      nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
      typeSpec: {
        ratioMetricSpec?: {
          numerator?: { name: string } | null;
          numeratorAggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
          numeratorFilter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
          denominator?: { name: string } | null;
          denominatorAggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
          denominatorFilter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
        } | null;
        averageMetricSpec?: {
          measurement?: {
            name: string;
            type?: MetricsV1ColumnType | null;
          } | null;
          aggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
        } | null;
        quantileMetricSpec?: {
          quantileLevel: number;
          measurement?: {
            name: string;
            type?: MetricsV1ColumnType | null;
          } | null;
          aggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
        } | null;
      };
      source?: {
        type?: MetricsV1MetricMetricSourceType | null;
        reference?: string | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    };
  } | null;
};

export type OnMetricCalculationUpdatedSubscriptionVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnMetricCalculationUpdatedSubscription = {
  metricCalculationUpdated?: {
    metricCalculation: {
      __typename: 'MetricsV1MetricCalculation';
      name: string;
      createTime: string;
      error?: string | null;
      sql?: string | null;
      state?: MetricsV1MetricCalculationState | null;
      endTime?: string | null;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      labels: Array<{ key: string; value?: string | null }>;
      metricResults?: {
        metricBucketStats: Array<{
          variant: string;
          dimensions: Array<{
            value?: string | null;
            dimension?: string | null;
          }>;
          summaryStats: {
            averageSummaryStats?: {
              mean?: number | null;
              variance?: number | null;
              count?: any | null;
              countMissing?: any | null;
            } | null;
            ratioSummaryStats?: {
              count?: any | null;
              numeratorMean?: number | null;
              numeratorVariance?: number | null;
              denominatorMean?: number | null;
              denominatorVariance?: number | null;
              countMissing?: any | null;
            } | null;
          };
        }>;
      } | null;
      sqlJob?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1SqlJob';
            state?: MetricsV1SqlJobState | null;
            failedQueryResult?: { error?: string | null } | null;
            pendingQueryResult?: { dummy?: string | null } | null;
            successfulQueryResult?: {
              schema: Array<{
                name: string;
                type?: MetricsV1ColumnType | null;
                repeated?: boolean | null;
              }>;
              issues: Array<{ message?: string | null; name: string }>;
            } | null;
          }
        | null;
    };
  } | null;
};

export type OnMetricUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnMetricUpdatedSubscription = {
  metricUpdated?: {
    metric: {
      __typename: 'MetricsV1Metric';
      displayName: string;
      name: string;
      description?: string | null;
      createTime: string;
      updateTime: string;
      deleteTime?: string | null;
      state?: MetricsV1MetricState | null;
      preferredDirection?: MetricsV1MetricPreferredDirection | null;
      measurement?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1Measurement';
            name: string;
            displayName: string;
            typeSpec: {
              averageMetricSpec?: {
                measurement?: { name: string } | null;
                aggregation: { type: MetricsV1AggregationType };
              } | null;
              ratioMetricSpec?: {
                numerator?: { name: string } | null;
                numeratorAggregation: { type: MetricsV1AggregationType };
                denominator?: { name: string } | null;
                denominatorAggregation: { type: MetricsV1AggregationType };
              } | null;
              quantileMetricSpec?: {
                quantileLevel: number;
                aggregation: { type: MetricsV1AggregationType };
              } | null;
            };
            filter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                };
            factTable:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  state: MetricsV1TableState;
                };
            nullHandling?: {
              replaceEntityNullWithZero?: boolean | null;
            } | null;
          }
        | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            displayName: string;
            name: string;
            everyone?: boolean | null;
            user?:
              | { pictureUri?: string | null; name: string }
              | Record<PropertyKey, never>
              | null;
            group?: { name: string } | Record<PropertyKey, never> | null;
            apiClient?: { name: string } | Record<PropertyKey, never> | null;
          }
        | null;
      factTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
          }
        | null;
      filter?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attribute: string;
              eqRule?: {
                value: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                };
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  nullValue?: { dummyField?: string | null } | null;
                } | null;
              } | null;
              likeRule?: { pattern: string } | null;
            } | null;
          } | null;
        }>;
        expression: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        };
      } | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
      measurementConfig?: {
        closedWindow?: {
          aggregationWindow: string;
          exposureOffset: string;
        } | null;
        semiOpenWindow?: {
          aggregationWindow: string;
          exposureOffset?: string | null;
        } | null;
        openWindow?: { dummy?: string | null } | null;
      } | null;
      varianceReductionConfig?: {
        aggregationWindowOverride?: string | null;
        disabled?: boolean | null;
      } | null;
      nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
      typeSpec?: {
        ratioMetricSpec?: {
          numerator?: { name: string } | null;
          numeratorAggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
          numeratorFilter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
          denominator?: { name: string } | null;
          denominatorAggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
          denominatorFilter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
        } | null;
        averageMetricSpec?: {
          measurement?: {
            name: string;
            type?: MetricsV1ColumnType | null;
          } | null;
          aggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
        } | null;
        quantileMetricSpec?: {
          quantileLevel: number;
          measurement?: {
            name: string;
            type?: MetricsV1ColumnType | null;
          } | null;
          aggregation: {
            type: MetricsV1AggregationType;
            threshold?: {
              direction: MetricsV1AggregationThresholdDirection;
              threshold: { value?: string | null };
            } | null;
            cap?: {
              min?: { value?: string | null } | null;
              max?: { value?: string | null } | null;
            } | null;
          };
        } | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      archiveInfo?: {
        reason?: string | null;
        archiveTime?: string | null;
      } | null;
      defaultEffectSize?: { value?: string | null } | null;
      source?: {
        type?: MetricsV1MetricMetricSourceType | null;
        reference?: string | null;
      } | null;
      verification?: {
        state?: MetricsV1MetricMetricVerificationVerificationState | null;
        verifyTime?: string | null;
        verifier?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
      } | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    };
  } | null;
};

export type OnRetriggerCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnRetriggerCreatedSubscription = {
  retriggerCreated?: {
    retrigger: {
      __typename: 'MetricsV1Retrigger';
      name: string;
      createTime: string;
      completeTime?: string | null;
      currentTime: string;
      targetTime: string;
      updateTime: string;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
    };
  } | null;
};

export type OnRetriggerUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnRetriggerUpdatedSubscription = {
  retriggerUpdated?: {
    retrigger: {
      __typename: 'MetricsV1Retrigger';
      name: string;
      createTime: string;
      completeTime?: string | null;
      currentTime: string;
      targetTime: string;
      updateTime: string;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
    };
  } | null;
};

export type OnScheduledExposureCalculationUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnScheduledExposureCalculationUpdatedSubscription = {
  scheduledExposureCalculationUpdated?: {
    scheduledExposureCalculation: {
      __typename: 'MetricsV1ScheduledExposureCalculation';
      iteration: number;
      name: string;
      scheduleIntervals: Array<string>;
      scheduleStartTime: string;
      scheduleEndTime?: string | null;
      nextAssignmentStartTime: string;
      nextAssignmentEndTime: string;
      nextScheduledRunTime: string;
      executedCalculationsCount: number;
      status: {
        calculating?: {
          exposureCalculation: { name: string } | Record<PropertyKey, never>;
        } | null;
        cancelled?: { cancelledTime: string } | null;
        error?: { errorMessage: string } | null;
        waiting?: {
          dataDeliveredUntilTime?: string | null;
          needDataUntilTime: string;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        scheduled?: { nextScheduleTime: string } | null;
      };
      exposureCalculationSpec: {
        assignmentTable:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1AssignmentTable';
              name: string;
              displayName: string;
              dataDeliveredUntilUpdateStrategyConfig?: {
                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                disableEmptyPartitions?: boolean | null;
                automaticUpdateConfig?: {
                  commitDelay: string;
                  changeThreshold?: { value?: string | null } | null;
                } | null;
                dailyUpdateConfig?: {
                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                  maxZeroDuration?: string | null;
                } | null;
                hourlyUpdateConfig?: {
                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                  maxZeroDuration?: string | null;
                } | null;
              } | null;
            };
      };
      exposedEntitiesMetricSchedule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1ScheduledMetricCalculation'; name: string }
        | null;
      activeRetrigger?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1Retrigger';
            name: string;
            createTime: string;
            completeTime?: string | null;
            currentTime: string;
            targetTime: string;
            updateTime: string;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
          }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
    };
  } | null;
};

export type OnScheduledMeasurementCalculationUpdatedSubscriptionVariables =
  Exact<{ [key: string]: never }>;

export type OnScheduledMeasurementCalculationUpdatedSubscription = {
  scheduledMeasurementCalculationUpdated?: {
    scheduledMeasurementCalculation: {
      __typename: 'MetricsV1ScheduledMeasurementCalculation';
      name: string;
      state?: MetricsV1ScheduledMeasurementCalculationState | null;
      nextScheduledRunTime: string;
      nextExposureStartTime: string;
      nextExposureEndTime: string;
      scheduleStartTime: string;
      scheduleEndTime?: string | null;
      iteration: number;
      scheduleIntervals: Array<string>;
      executedCalculationsCount: number;
      status: {
        scheduled?: { nextScheduleTime: string } | null;
        cancelled?: { cancelledTime: string } | null;
        calculating?: {
          measurementCalculation: { name: string } | Record<PropertyKey, never>;
        } | null;
        waiting?: {
          dataDeliveredUntilTime?: string | null;
          needDataUntilTime: string;
          exposureTable?: { name: string } | Record<PropertyKey, never> | null;
          factTable?:
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | Record<PropertyKey, never>
            | null;
        } | null;
        error?: { errorMessage: string } | null;
      };
      measurementCalculationSpec: {
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              name: string;
              displayName: string;
              nullHandling?: {
                __typename: 'MetricsV1MetricNullHandlingConfig';
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              measurementConfig?: {
                closedWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                } | null;
              } | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    dataDeliveredUntilUpdateStrategyConfig?: {
                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                      disableEmptyPartitions?: boolean | null;
                      automaticUpdateConfig?: {
                        commitDelay: string;
                        changeThreshold?: { value?: string | null } | null;
                      } | null;
                      dailyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                      hourlyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                    } | null;
                    partitionedUpdateStrategyState?: {
                      currentPartitionLastCheckTime?: string | null;
                      existsCheckDuration?: string | null;
                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                      usualLateness?: string | null;
                    } | null;
                  }
                | null;
            };
        exposureTable:
          | {
              __typename: 'MetricsV1ExposureTable';
              scheduledExposureCalculation?:
                | {
                    __typename: 'MetricsV1ScheduledExposureCalculation';
                    name: string;
                    exposureCalculationSpec: {
                      __typename: 'MetricsV1ExposureCalculationSpec';
                      assignmentTable:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1AssignmentTable';
                            name: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                          };
                    };
                    status: {
                      calculating?: {
                        exposureCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      cancelled?: { cancelledTime: string } | null;
                      error?: { errorMessage: string } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        assignmentTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                      scheduled?: { nextScheduleTime: string } | null;
                    };
                  }
                | Record<PropertyKey, never>
                | null;
            }
          | Record<PropertyKey, never>;
      };
      activeRetrigger?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1Retrigger';
            name: string;
            createTime: string;
            completeTime?: string | null;
            currentTime: string;
            targetTime: string;
            updateTime: string;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
          }
        | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
    };
  } | null;
};

export type OnScheduledMetricCalculationUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnScheduledMetricCalculationUpdatedSubscription = {
  scheduledMetricCalculationUpdated?: {
    scheduledMetricCalculation: {
      __typename: 'MetricsV1ScheduledMetricCalculation';
      name: string;
      state?: MetricsV1ScheduledMetricCalculationState | null;
      nextScheduledRunTime: string;
      nextExposureStartTime: string;
      nextExposureEndTime: string;
      scheduleStartTime: string;
      scheduleEndTime?: string | null;
      iteration: number;
      scheduleIntervals: Array<string>;
      executedCalculationsCount: number;
      status: {
        scheduled?: { nextScheduleTime: string } | null;
        cancelled?: { cancelledTime: string } | null;
        calculating?: {
          metricCalculation: { name: string } | Record<PropertyKey, never>;
        } | null;
        waiting?: {
          dataDeliveredUntilTime?: string | null;
          needDataUntilTime: string;
          exposureTable?: { name: string } | Record<PropertyKey, never> | null;
          factTable?:
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | Record<PropertyKey, never>
            | null;
        } | null;
        error?: { errorMessage: string } | null;
      };
      metricCalculationSpec: {
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              name: string;
              displayName: string;
              nullHandling?: {
                __typename: 'MetricsV1MetricNullHandlingConfig';
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              measurementConfig?: {
                closedWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: {
                  __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                } | null;
              } | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    dataDeliveredUntilUpdateStrategyConfig?: {
                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                      disableEmptyPartitions?: boolean | null;
                      automaticUpdateConfig?: {
                        commitDelay: string;
                        changeThreshold?: { value?: string | null } | null;
                      } | null;
                      dailyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                      hourlyUpdateConfig?: {
                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                        maxZeroDuration?: string | null;
                      } | null;
                    } | null;
                    partitionedUpdateStrategyState?: {
                      currentPartitionLastCheckTime?: string | null;
                      existsCheckDuration?: string | null;
                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                      usualLateness?: string | null;
                    } | null;
                  }
                | null;
            };
        exposureTable:
          | {
              __typename: 'MetricsV1ExposureTable';
              scheduledExposureCalculation?:
                | {
                    __typename: 'MetricsV1ScheduledExposureCalculation';
                    name: string;
                    exposureCalculationSpec: {
                      __typename: 'MetricsV1ExposureCalculationSpec';
                      assignmentTable:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1AssignmentTable';
                            name: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                          };
                    };
                    status: {
                      calculating?: {
                        exposureCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      cancelled?: { cancelledTime: string } | null;
                      error?: { errorMessage: string } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        assignmentTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                      scheduled?: { nextScheduleTime: string } | null;
                    };
                  }
                | Record<PropertyKey, never>
                | null;
            }
          | Record<PropertyKey, never>;
        measurementTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1MeasurementTable'; name: string }
          | null;
      };
      activeRetrigger?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1Retrigger';
            name: string;
            createTime: string;
            completeTime?: string | null;
            currentTime: string;
            targetTime: string;
            updateTime: string;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
          }
        | null;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      labels: Array<{ key: string; value?: string | null }>;
    };
  } | null;
};

export type ProcessRoundLogFragment = {
  __typename: 'MetricsV1ProcessRoundLog';
  name: string;
  createTime: string;
  verificationState: MetricsV1ProcessRoundLogVerificationState;
  error?: string | null;
  partition?: {
    partitionTime?: string | null;
    partitionArrivesLater?: { expectedArrivalTime?: string | null } | null;
    partitionNotCommitted?: {
      noCommitReason?: MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason | null;
    } | null;
    partitionCommitted?: {
      count?: any | null;
      maxWaitTimeReached?: boolean | null;
    } | null;
    partitionError?: { message?: string | null } | null;
  } | null;
  timestamp?: {
    currentDataDeliveredUntilTime?: string | null;
    newDataDeliveredUntilTime?: string | null;
    dataCommitted?: { count?: any | null } | null;
    dataPendingCommit?: {
      previousCount?: any | null;
      currentCount?: any | null;
      noCommitReason?: MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason | null;
      newDataDeliveredUntil?: boolean | null;
    } | null;
    dataError?: { message?: string | null } | null;
  } | null;
};

export type ProcessRoundLogsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProcessRoundLogsQuery = {
  processRoundLogs?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListProcessRoundLogsResponse';
        nextPageToken?: string | null;
        processRoundLogs: Array<{
          __typename: 'MetricsV1ProcessRoundLog';
          name: string;
          createTime: string;
          verificationState: MetricsV1ProcessRoundLogVerificationState;
          error?: string | null;
          partition?: {
            partitionTime?: string | null;
            partitionArrivesLater?: {
              expectedArrivalTime?: string | null;
            } | null;
            partitionNotCommitted?: {
              noCommitReason?: MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason | null;
            } | null;
            partitionCommitted?: {
              count?: any | null;
              maxWaitTimeReached?: boolean | null;
            } | null;
            partitionError?: { message?: string | null } | null;
          } | null;
          timestamp?: {
            currentDataDeliveredUntilTime?: string | null;
            newDataDeliveredUntilTime?: string | null;
            dataCommitted?: { count?: any | null } | null;
            dataPendingCommit?: {
              previousCount?: any | null;
              currentCount?: any | null;
              noCommitReason?: MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason | null;
              newDataDeliveredUntil?: boolean | null;
            } | null;
            dataError?: { message?: string | null } | null;
          } | null;
        }>;
      }
    | null;
};

export type PublishMetricMutationVariables = Exact<{
  name: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
}>;

export type PublishMetricMutation = {
  publishMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type QueryAvailableTimeRangeQueryVariables = Exact<{
  metricCalculationSpec?: InputMaybe<MetricsV1MetricCalculationSpecInput>;
}>;

export type QueryAvailableTimeRangeQuery = {
  queryAvailableTimeRange?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1QueryAvailableTimeRangeResponse';
        startTime: string;
        endTime: string;
      }
    | null;
};

export type QueryMetricCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
  groupByDimensions:
    | Array<Scalars['String']['input']>
    | Scalars['String']['input'];
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;

export type QueryMetricCalculationQuery = {
  queryMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1QueryMetricCalculationResponse';
        dimensions: Array<string>;
        rows: Array<{
          aggCount?: number | null;
          dimensions: Array<{ key: string; value?: string | null }>;
          value?: {
            averageSummaryStats?: {
              mean?: number | null;
              variance?: number | null;
              count?: any | null;
              countMissing?: any | null;
              summaryStatsInfo?: {
                min?: number | null;
                max?: number | null;
                countZeroes?: any | null;
              } | null;
            } | null;
            ratioSummaryStats?: {
              numeratorMean?: number | null;
              numeratorVariance?: number | null;
              denominatorMean?: number | null;
              denominatorVariance?: number | null;
              numeratorDenominatorCovariance?: number | null;
              count?: any | null;
              countMissing?: any | null;
              numeratorSummaryStatsInfo?: {
                min?: number | null;
                max?: number | null;
                countZeroes?: any | null;
              } | null;
              denominatorSummaryStatsInfo?: {
                min?: number | null;
                max?: number | null;
                countZeroes?: any | null;
              } | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type QueryScheduledMetricCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
  groupByDimensions:
    | Array<Scalars['String']['input']>
    | Scalars['String']['input'];
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type QueryScheduledMetricCalculationQuery = {
  queryScheduledMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1QueryScheduledMetricCalculationResponse';
        dimensions: Array<string>;
        minStartTime?: string | null;
        maxStartTime?: string | null;
        rows: Array<{
          aggCount?: number | null;
          dimensions: Array<{ key: string; value?: string | null }>;
          value?: {
            averageSummaryStats?: {
              mean?: number | null;
              variance?: number | null;
              count?: any | null;
              countMissing?: any | null;
            } | null;
            ratioSummaryStats?: {
              numeratorMean?: number | null;
              numeratorVariance?: number | null;
              denominatorMean?: number | null;
              denominatorVariance?: number | null;
              count?: any | null;
              countMissing?: any | null;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type RetriggerFragment = {
  __typename: 'MetricsV1Retrigger';
  name: string;
  createTime: string;
  completeTime?: string | null;
  currentTime: string;
  targetTime: string;
  updateTime: string;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type RetriggerScheduledExposureCalculationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  retriggerDependentMetricSchedules: Scalars['Boolean']['input'];
}>;

export type RetriggerScheduledExposureCalculationMutation = {
  retriggerScheduledExposureCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ScheduledExposureCalculation';
        iteration: number;
        name: string;
        scheduleIntervals: Array<string>;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        nextAssignmentStartTime: string;
        nextAssignmentEndTime: string;
        nextScheduledRunTime: string;
        executedCalculationsCount: number;
        status: {
          calculating?: {
            exposureCalculation: { name: string } | Record<PropertyKey, never>;
          } | null;
          cancelled?: { cancelledTime: string } | null;
          error?: { errorMessage: string } | null;
          waiting?: {
            dataDeliveredUntilTime?: string | null;
            needDataUntilTime: string;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          scheduled?: { nextScheduleTime: string } | null;
        };
        exposureCalculationSpec: {
          assignmentTable:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
              };
        };
        exposedEntitiesMetricSchedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1ScheduledMetricCalculation'; name: string }
          | null;
        activeRetrigger?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Retrigger';
              name: string;
              createTime: string;
              completeTime?: string | null;
              currentTime: string;
              targetTime: string;
              updateTime: string;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type RetriggerScheduledMetricCalculationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RetriggerScheduledMetricCalculationMutation = {
  retriggerScheduledMetricCalculation?:
    | {
        __typename: 'MetricsV1ScheduledMetricCalculation';
        name: string;
        state?: MetricsV1ScheduledMetricCalculationState | null;
        nextScheduledRunTime: string;
        nextExposureStartTime: string;
        nextExposureEndTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        iteration: number;
        scheduleIntervals: Array<string>;
        executedCalculationsCount: number;
        status: {
          scheduled?: { nextScheduleTime: string } | null;
          cancelled?: { cancelledTime: string } | null;
          calculating?: {
            metricCalculation: { name: string } | Record<PropertyKey, never>;
          } | null;
          waiting?: {
            dataDeliveredUntilTime?: string | null;
            needDataUntilTime: string;
            exposureTable?:
              | { name: string }
              | Record<PropertyKey, never>
              | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  state: MetricsV1TableState;
                }
              | Record<PropertyKey, never>
              | null;
          } | null;
          error?: { errorMessage: string } | null;
        };
        metricCalculationSpec: {
          metric:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Metric';
                name: string;
                displayName: string;
                nullHandling?: {
                  __typename: 'MetricsV1MetricNullHandlingConfig';
                  replaceEntityNullWithZero?: boolean | null;
                } | null;
                measurementConfig?: {
                  closedWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                    aggregationWindow: string;
                    exposureOffset: string;
                  } | null;
                  semiOpenWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                    aggregationWindow: string;
                    exposureOffset?: string | null;
                  } | null;
                  openWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                  } | null;
                } | null;
                factTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      partitionedUpdateStrategyState?: {
                        currentPartitionLastCheckTime?: string | null;
                        existsCheckDuration?: string | null;
                        state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                        usualLateness?: string | null;
                      } | null;
                    }
                  | null;
              };
          exposureTable:
            | {
                __typename: 'MetricsV1ExposureTable';
                scheduledExposureCalculation?:
                  | {
                      __typename: 'MetricsV1ScheduledExposureCalculation';
                      name: string;
                      exposureCalculationSpec: {
                        __typename: 'MetricsV1ExposureCalculationSpec';
                        assignmentTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                            };
                      };
                      status: {
                        calculating?: {
                          exposureCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        cancelled?: { cancelledTime: string } | null;
                        error?: { errorMessage: string } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          assignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1AssignmentTable';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                        scheduled?: { nextScheduleTime: string } | null;
                      };
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          measurementTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'MetricsV1MeasurementTable'; name: string }
            | null;
        };
        activeRetrigger?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Retrigger';
              name: string;
              createTime: string;
              completeTime?: string | null;
              currentTime: string;
              targetTime: string;
              updateTime: string;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
            }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | Record<PropertyKey, never>
    | null;
};

export type RetriggersQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RetriggersQuery = {
  retriggers?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListRetriggersResponse';
        nextPageToken?: string | null;
        retriggers: Array<{
          __typename: 'MetricsV1Retrigger';
          name: string;
          createTime: string;
          completeTime?: string | null;
          currentTime: string;
          targetTime: string;
          updateTime: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type ScheduledExposureCalculationFragment = {
  __typename: 'MetricsV1ScheduledExposureCalculation';
  iteration: number;
  name: string;
  scheduleIntervals: Array<string>;
  scheduleStartTime: string;
  scheduleEndTime?: string | null;
  nextAssignmentStartTime: string;
  nextAssignmentEndTime: string;
  nextScheduledRunTime: string;
  executedCalculationsCount: number;
  status: {
    calculating?: {
      exposureCalculation: { name: string } | Record<PropertyKey, never>;
    } | null;
    cancelled?: { cancelledTime: string } | null;
    error?: { errorMessage: string } | null;
    waiting?: {
      dataDeliveredUntilTime?: string | null;
      needDataUntilTime: string;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
          }
        | null;
    } | null;
    scheduled?: { nextScheduleTime: string } | null;
  };
  exposureCalculationSpec: {
    assignmentTable:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1AssignmentTable';
          name: string;
          displayName: string;
          dataDeliveredUntilUpdateStrategyConfig?: {
            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
            disableEmptyPartitions?: boolean | null;
            automaticUpdateConfig?: {
              commitDelay: string;
              changeThreshold?: { value?: string | null } | null;
            } | null;
            dailyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
            hourlyUpdateConfig?: {
              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
              maxZeroDuration?: string | null;
            } | null;
          } | null;
        };
  };
  exposedEntitiesMetricSchedule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1ScheduledMetricCalculation'; name: string }
    | null;
  activeRetrigger?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Retrigger';
        name: string;
        createTime: string;
        completeTime?: string | null;
        currentTime: string;
        targetTime: string;
        updateTime: string;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type ScheduledExposureCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ScheduledExposureCalculationQuery = {
  scheduledExposureCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ScheduledExposureCalculation';
        iteration: number;
        name: string;
        scheduleIntervals: Array<string>;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        nextAssignmentStartTime: string;
        nextAssignmentEndTime: string;
        nextScheduledRunTime: string;
        executedCalculationsCount: number;
        status: {
          calculating?: {
            exposureCalculation: { name: string } | Record<PropertyKey, never>;
          } | null;
          cancelled?: { cancelledTime: string } | null;
          error?: { errorMessage: string } | null;
          waiting?: {
            dataDeliveredUntilTime?: string | null;
            needDataUntilTime: string;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          scheduled?: { nextScheduleTime: string } | null;
        };
        exposureCalculationSpec: {
          assignmentTable:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
              };
        };
        exposedEntitiesMetricSchedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1ScheduledMetricCalculation'; name: string }
          | null;
        activeRetrigger?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Retrigger';
              name: string;
              createTime: string;
              completeTime?: string | null;
              currentTime: string;
              targetTime: string;
              updateTime: string;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type ScheduledExposureCalculationStatusFragment = {
  calculating?: {
    exposureCalculation: { name: string } | Record<PropertyKey, never>;
  } | null;
  cancelled?: { cancelledTime: string } | null;
  error?: { errorMessage: string } | null;
  waiting?: {
    dataDeliveredUntilTime?: string | null;
    needDataUntilTime: string;
    assignmentTable?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1AssignmentTable';
          name: string;
          displayName: string;
        }
      | null;
  } | null;
  scheduled?: { nextScheduleTime: string } | null;
};

export type ScheduledMeasurementCalculationFragment = {
  __typename: 'MetricsV1ScheduledMeasurementCalculation';
  name: string;
  state?: MetricsV1ScheduledMeasurementCalculationState | null;
  nextScheduledRunTime: string;
  nextExposureStartTime: string;
  nextExposureEndTime: string;
  scheduleStartTime: string;
  scheduleEndTime?: string | null;
  iteration: number;
  scheduleIntervals: Array<string>;
  executedCalculationsCount: number;
  status: {
    scheduled?: { nextScheduleTime: string } | null;
    cancelled?: { cancelledTime: string } | null;
    calculating?: {
      measurementCalculation: { name: string } | Record<PropertyKey, never>;
    } | null;
    waiting?: {
      dataDeliveredUntilTime?: string | null;
      needDataUntilTime: string;
      exposureTable?: { name: string } | Record<PropertyKey, never> | null;
      factTable?:
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>
        | null;
    } | null;
    error?: { errorMessage: string } | null;
  };
  measurementCalculationSpec: {
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Metric';
          name: string;
          displayName: string;
          nullHandling?: {
            __typename: 'MetricsV1MetricNullHandlingConfig';
            replaceEntityNullWithZero?: boolean | null;
          } | null;
          measurementConfig?: {
            closedWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
            } | null;
          } | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                partitionedUpdateStrategyState?: {
                  currentPartitionLastCheckTime?: string | null;
                  existsCheckDuration?: string | null;
                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                  usualLateness?: string | null;
                } | null;
              }
            | null;
        };
    exposureTable:
      | {
          __typename: 'MetricsV1ExposureTable';
          scheduledExposureCalculation?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
                exposureCalculationSpec: {
                  __typename: 'MetricsV1ExposureCalculationSpec';
                  assignmentTable:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1AssignmentTable';
                        name: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                      };
                };
                status: {
                  calculating?: {
                    exposureCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  cancelled?: { cancelledTime: string } | null;
                  error?: { errorMessage: string } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    assignmentTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1AssignmentTable';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                  scheduled?: { nextScheduleTime: string } | null;
                };
              }
            | Record<PropertyKey, never>
            | null;
        }
      | Record<PropertyKey, never>;
  };
  activeRetrigger?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Retrigger';
        name: string;
        createTime: string;
        completeTime?: string | null;
        currentTime: string;
        targetTime: string;
        updateTime: string;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
};

export type ScheduledMeasurementCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ScheduledMeasurementCalculationQuery = {
  scheduledMeasurementCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ScheduledMeasurementCalculation';
        name: string;
        state?: MetricsV1ScheduledMeasurementCalculationState | null;
        nextScheduledRunTime: string;
        nextExposureStartTime: string;
        nextExposureEndTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        iteration: number;
        scheduleIntervals: Array<string>;
        executedCalculationsCount: number;
        status: {
          scheduled?: { nextScheduleTime: string } | null;
          cancelled?: { cancelledTime: string } | null;
          calculating?: {
            measurementCalculation:
              | { name: string }
              | Record<PropertyKey, never>;
          } | null;
          waiting?: {
            dataDeliveredUntilTime?: string | null;
            needDataUntilTime: string;
            exposureTable?:
              | { name: string }
              | Record<PropertyKey, never>
              | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  state: MetricsV1TableState;
                }
              | Record<PropertyKey, never>
              | null;
          } | null;
          error?: { errorMessage: string } | null;
        };
        measurementCalculationSpec: {
          metric:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Metric';
                name: string;
                displayName: string;
                nullHandling?: {
                  __typename: 'MetricsV1MetricNullHandlingConfig';
                  replaceEntityNullWithZero?: boolean | null;
                } | null;
                measurementConfig?: {
                  closedWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                    aggregationWindow: string;
                    exposureOffset: string;
                  } | null;
                  semiOpenWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                    aggregationWindow: string;
                    exposureOffset?: string | null;
                  } | null;
                  openWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                  } | null;
                } | null;
                factTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      partitionedUpdateStrategyState?: {
                        currentPartitionLastCheckTime?: string | null;
                        existsCheckDuration?: string | null;
                        state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                        usualLateness?: string | null;
                      } | null;
                    }
                  | null;
              };
          exposureTable:
            | {
                __typename: 'MetricsV1ExposureTable';
                scheduledExposureCalculation?:
                  | {
                      __typename: 'MetricsV1ScheduledExposureCalculation';
                      name: string;
                      exposureCalculationSpec: {
                        __typename: 'MetricsV1ExposureCalculationSpec';
                        assignmentTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                            };
                      };
                      status: {
                        calculating?: {
                          exposureCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        cancelled?: { cancelledTime: string } | null;
                        error?: { errorMessage: string } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          assignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1AssignmentTable';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                        scheduled?: { nextScheduleTime: string } | null;
                      };
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
        };
        activeRetrigger?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Retrigger';
              name: string;
              createTime: string;
              completeTime?: string | null;
              currentTime: string;
              targetTime: string;
              updateTime: string;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
            }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type ScheduledMetricCalculationFragment = {
  __typename: 'MetricsV1ScheduledMetricCalculation';
  name: string;
  state?: MetricsV1ScheduledMetricCalculationState | null;
  nextScheduledRunTime: string;
  nextExposureStartTime: string;
  nextExposureEndTime: string;
  scheduleStartTime: string;
  scheduleEndTime?: string | null;
  iteration: number;
  scheduleIntervals: Array<string>;
  executedCalculationsCount: number;
  status: {
    scheduled?: { nextScheduleTime: string } | null;
    cancelled?: { cancelledTime: string } | null;
    calculating?: {
      metricCalculation: { name: string } | Record<PropertyKey, never>;
    } | null;
    waiting?: {
      dataDeliveredUntilTime?: string | null;
      needDataUntilTime: string;
      exposureTable?: { name: string } | Record<PropertyKey, never> | null;
      factTable?:
        | {
            __typename: 'MetricsV1FactTable';
            name: string;
            displayName: string;
            state: MetricsV1TableState;
          }
        | Record<PropertyKey, never>
        | null;
    } | null;
    error?: { errorMessage: string } | null;
  };
  metricCalculationSpec: {
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Metric';
          name: string;
          displayName: string;
          nullHandling?: {
            __typename: 'MetricsV1MetricNullHandlingConfig';
            replaceEntityNullWithZero?: boolean | null;
          } | null;
          measurementConfig?: {
            closedWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: {
              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
            } | null;
          } | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                partitionedUpdateStrategyState?: {
                  currentPartitionLastCheckTime?: string | null;
                  existsCheckDuration?: string | null;
                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                  usualLateness?: string | null;
                } | null;
              }
            | null;
        };
    exposureTable:
      | {
          __typename: 'MetricsV1ExposureTable';
          scheduledExposureCalculation?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
                exposureCalculationSpec: {
                  __typename: 'MetricsV1ExposureCalculationSpec';
                  assignmentTable:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1AssignmentTable';
                        name: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                      };
                };
                status: {
                  calculating?: {
                    exposureCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  cancelled?: { cancelledTime: string } | null;
                  error?: { errorMessage: string } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    assignmentTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1AssignmentTable';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                  scheduled?: { nextScheduleTime: string } | null;
                };
              }
            | Record<PropertyKey, never>
            | null;
        }
      | Record<PropertyKey, never>;
    measurementTable?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'MetricsV1MeasurementTable'; name: string }
      | null;
  };
  activeRetrigger?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Retrigger';
        name: string;
        createTime: string;
        completeTime?: string | null;
        currentTime: string;
        targetTime: string;
        updateTime: string;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
};

export type ScheduledMetricCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ScheduledMetricCalculationQuery = {
  scheduledMetricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ScheduledMetricCalculation';
        name: string;
        state?: MetricsV1ScheduledMetricCalculationState | null;
        nextScheduledRunTime: string;
        nextExposureStartTime: string;
        nextExposureEndTime: string;
        scheduleStartTime: string;
        scheduleEndTime?: string | null;
        iteration: number;
        scheduleIntervals: Array<string>;
        executedCalculationsCount: number;
        status: {
          scheduled?: { nextScheduleTime: string } | null;
          cancelled?: { cancelledTime: string } | null;
          calculating?: {
            metricCalculation: { name: string } | Record<PropertyKey, never>;
          } | null;
          waiting?: {
            dataDeliveredUntilTime?: string | null;
            needDataUntilTime: string;
            exposureTable?:
              | { name: string }
              | Record<PropertyKey, never>
              | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  state: MetricsV1TableState;
                }
              | Record<PropertyKey, never>
              | null;
          } | null;
          error?: { errorMessage: string } | null;
        };
        metricCalculationSpec: {
          metric:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Metric';
                name: string;
                displayName: string;
                nullHandling?: {
                  __typename: 'MetricsV1MetricNullHandlingConfig';
                  replaceEntityNullWithZero?: boolean | null;
                } | null;
                measurementConfig?: {
                  closedWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                    aggregationWindow: string;
                    exposureOffset: string;
                  } | null;
                  semiOpenWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                    aggregationWindow: string;
                    exposureOffset?: string | null;
                  } | null;
                  openWindow?: {
                    __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                  } | null;
                } | null;
                factTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      partitionedUpdateStrategyState?: {
                        currentPartitionLastCheckTime?: string | null;
                        existsCheckDuration?: string | null;
                        state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                        usualLateness?: string | null;
                      } | null;
                    }
                  | null;
              };
          exposureTable:
            | {
                __typename: 'MetricsV1ExposureTable';
                scheduledExposureCalculation?:
                  | {
                      __typename: 'MetricsV1ScheduledExposureCalculation';
                      name: string;
                      exposureCalculationSpec: {
                        __typename: 'MetricsV1ExposureCalculationSpec';
                        assignmentTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1AssignmentTable';
                              name: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                            };
                      };
                      status: {
                        calculating?: {
                          exposureCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        cancelled?: { cancelledTime: string } | null;
                        error?: { errorMessage: string } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          assignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1AssignmentTable';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                        scheduled?: { nextScheduleTime: string } | null;
                      };
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          measurementTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'MetricsV1MeasurementTable'; name: string }
            | null;
        };
        activeRetrigger?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Retrigger';
              name: string;
              createTime: string;
              completeTime?: string | null;
              currentTime: string;
              targetTime: string;
              updateTime: string;
              creator:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  };
            }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type ScheduledMetricCalculationStatusFragment = {
  scheduled?: { nextScheduleTime: string } | null;
  cancelled?: { cancelledTime: string } | null;
  calculating?: {
    metricCalculation: { name: string } | Record<PropertyKey, never>;
  } | null;
  waiting?: {
    dataDeliveredUntilTime?: string | null;
    needDataUntilTime: string;
    exposureTable?: { name: string } | Record<PropertyKey, never> | null;
    factTable?:
      | {
          __typename: 'MetricsV1FactTable';
          name: string;
          displayName: string;
          state: MetricsV1TableState;
        }
      | Record<PropertyKey, never>
      | null;
  } | null;
  error?: { errorMessage: string } | null;
};

export type SelectableMetricFragment = {
  name: string;
  displayName: string;
  preferredDirection?: MetricsV1MetricPreferredDirection | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
    | null;
  defaultEffectSize?: { value?: string | null } | null;
};

export type SuggestMetricMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type SuggestMetricMutation = {
  suggestMetric?:
    | { __typename: 'Error'; code: ErrorCode; message?: string | null }
    | {
        __typename: 'MetricsV1SuggestMetricResponse';
        error?: string | null;
        metric?: {
          __typename: 'MetricsV1Metric';
          displayName: string;
          name: string;
          description?: string | null;
          createTime: string;
          updateTime: string;
          deleteTime?: string | null;
          state?: MetricsV1MetricState | null;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          measurement?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Measurement';
                name: string;
                displayName: string;
                typeSpec: {
                  averageMetricSpec?: {
                    measurement?: { name: string } | null;
                    aggregation: { type: MetricsV1AggregationType };
                  } | null;
                  ratioMetricSpec?: {
                    numerator?: { name: string } | null;
                    numeratorAggregation: { type: MetricsV1AggregationType };
                    denominator?: { name: string } | null;
                    denominatorAggregation: { type: MetricsV1AggregationType };
                  } | null;
                  quantileMetricSpec?: {
                    quantileLevel: number;
                    aggregation: { type: MetricsV1AggregationType };
                  } | null;
                };
                filter?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attribute: string;
                        eqRule?: {
                          value: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          };
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                        } | null;
                        likeRule?: { pattern: string } | null;
                      } | null;
                    } | null;
                  }>;
                  expression: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  };
                } | null;
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
                factTable:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    };
                nullHandling?: {
                  replaceEntityNullWithZero?: boolean | null;
                } | null;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                displayName: string;
                name: string;
                everyone?: boolean | null;
                user?:
                  | { pictureUri?: string | null; name: string }
                  | Record<PropertyKey, never>
                  | null;
                group?: { name: string } | Record<PropertyKey, never> | null;
                apiClient?:
                  | { name: string }
                  | Record<PropertyKey, never>
                  | null;
              }
            | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | null;
          filter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
          measurementConfig?: {
            closedWindow?: {
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: { dummy?: string | null } | null;
          } | null;
          varianceReductionConfig?: {
            aggregationWindowOverride?: string | null;
            disabled?: boolean | null;
          } | null;
          nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
          typeSpec?: {
            ratioMetricSpec?: {
              numerator?: { name: string } | null;
              numeratorAggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
              numeratorFilter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              denominator?: { name: string } | null;
              denominatorAggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
              denominatorFilter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
            } | null;
            averageMetricSpec?: {
              measurement?: {
                name: string;
                type?: MetricsV1ColumnType | null;
              } | null;
              aggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
            } | null;
            quantileMetricSpec?: {
              quantileLevel: number;
              measurement?: {
                name: string;
                type?: MetricsV1ColumnType | null;
              } | null;
              aggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          archiveInfo?: {
            reason?: string | null;
            archiveTime?: string | null;
          } | null;
          defaultEffectSize?: { value?: string | null } | null;
          source?: {
            type?: MetricsV1MetricMetricSourceType | null;
            reference?: string | null;
          } | null;
          verification?: {
            state?: MetricsV1MetricMetricVerificationVerificationState | null;
            verifyTime?: string | null;
            verifier?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        } | null;
      }
    | null;
};

export type UnarchiveMetricMutationVariables = Exact<{
  name: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
}>;

export type UnarchiveMetricMutation = {
  unarchiveMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateMeasurementMutationVariables = Exact<{
  input: PartialMetricsV1MeasurementInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateMeasurementMutation = {
  updateMeasurement?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Measurement';
        displayName: string;
        name: string;
        description?: string | null;
        deleteTime?: string | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            };
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Entity';
              name: string;
              displayName: string;
            };
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        };
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type UpdateMetricMutationVariables = Exact<{
  input: PartialMetricsV1MetricInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateMetricMutation = {
  updateMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type VerifyMetricMutationVariables = Exact<{
  name: Scalars['String']['input'];
  verification: MetricsV1MetricMetricVerificationVerificationState;
}>;

export type VerifyMetricMutation = {
  verifyMetric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        displayName: string;
        name: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        state?: MetricsV1MetricState | null;
        preferredDirection?: MetricsV1MetricPreferredDirection | null;
        measurement?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Measurement';
              name: string;
              displayName: string;
              typeSpec: {
                averageMetricSpec?: {
                  measurement?: { name: string } | null;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: { type: MetricsV1AggregationType };
                  denominator?: { name: string } | null;
                  denominatorAggregation: { type: MetricsV1AggregationType };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  aggregation: { type: MetricsV1AggregationType };
                } | null;
              };
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  };
              factTable:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  };
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              displayName: string;
              name: string;
              everyone?: boolean | null;
              user?:
                | { pictureUri?: string | null; name: string }
                | Record<PropertyKey, never>
                | null;
              group?: { name: string } | Record<PropertyKey, never> | null;
              apiClient?: { name: string } | Record<PropertyKey, never> | null;
            }
          | null;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        filter?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attribute: string;
                eqRule?: {
                  value: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  };
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    nullValue?: { dummyField?: string | null } | null;
                  } | null;
                } | null;
                likeRule?: { pattern: string } | null;
              } | null;
            } | null;
          }>;
          expression: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                  }>;
                } | null;
              }>;
            } | null;
          };
        } | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
          | null;
        measurementConfig?: {
          closedWindow?: {
            aggregationWindow: string;
            exposureOffset: string;
          } | null;
          semiOpenWindow?: {
            aggregationWindow: string;
            exposureOffset?: string | null;
          } | null;
          openWindow?: { dummy?: string | null } | null;
        } | null;
        varianceReductionConfig?: {
          aggregationWindowOverride?: string | null;
          disabled?: boolean | null;
        } | null;
        nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
        typeSpec?: {
          ratioMetricSpec?: {
            numerator?: { name: string } | null;
            numeratorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            numeratorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
            denominator?: { name: string } | null;
            denominatorAggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
            denominatorFilter?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attribute: string;
                    eqRule?: {
                      value: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      };
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        nullValue?: { dummyField?: string | null } | null;
                      } | null;
                    } | null;
                    likeRule?: { pattern: string } | null;
                  } | null;
                } | null;
              }>;
              expression: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              };
            } | null;
          } | null;
          averageMetricSpec?: {
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
          quantileMetricSpec?: {
            quantileLevel: number;
            measurement?: {
              name: string;
              type?: MetricsV1ColumnType | null;
            } | null;
            aggregation: {
              type: MetricsV1AggregationType;
              threshold?: {
                direction: MetricsV1AggregationThresholdDirection;
                threshold: { value?: string | null };
              } | null;
              cap?: {
                min?: { value?: string | null } | null;
                max?: { value?: string | null } | null;
              } | null;
            };
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        archiveInfo?: {
          reason?: string | null;
          archiveTime?: string | null;
        } | null;
        defaultEffectSize?: { value?: string | null } | null;
        source?: {
          type?: MetricsV1MetricMetricSourceType | null;
          reference?: string | null;
        } | null;
        verification?: {
          state?: MetricsV1MetricMetricVerificationVerificationState | null;
          verifyTime?: string | null;
          verifier?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type WorkflowDisplayNamesQueryVariables = Exact<{
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type WorkflowDisplayNamesQuery = {
  workflows?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowsResponse';
        nextPageToken?: string | null;
        workflows: Array<{ displayName: string; name: string }>;
      }
    | null;
};

export type WorkflowInstanceExposureDetailsFragment = {
  name: string;
  state: string;
  moduleData: Array<{ key: string; value?: any | null }>;
  stateHistory: Array<{
    enteredTime?: string | null;
    exitedTime?: string | null;
    state?: string | null;
  }>;
};

export type OnboardingDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingDetailsQuery = {
  clients?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1ListClientsResponse';
        clients: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          variants: Array<{
            name: string;
            creator:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                };
          }>;
          rules: Array<{
            __typename: 'FlagsAdminV1FlagRule';
            name: string;
            enabled: boolean;
            labels: Array<{ key: string; value?: string | null }>;
          }>;
          usageMetadata?: { lastResolveTime?: string | null } | null;
        }>;
      }
    | null;
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
      }
    | null;
  dataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDataWarehousesResponse';
        dataWarehouses: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
  flagAppliedConnections?:
    | {
        __typename: 'ConnectorsV1ListFlagAppliedConnectionsResponse';
        flagAppliedConnections: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        factTables: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        metrics: Array<{
          name: string;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type OnboardingSetupQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingSetupQuery = {
  onboardingSetup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1OnboardingSetup';
        path?: OnboardingV1OnboardingPath | null;
        dismissed?: boolean | null;
      }
    | null;
};

export type TourPreferencesFragment = {
  __typename: 'OnboardingV1TourPreferences';
  featureFlagsStatus?: OnboardingV1TourStepStatus | null;
  rolloutsStatus?: OnboardingV1TourStepStatus | null;
  abTestsStatus?: OnboardingV1TourStepStatus | null;
  dismissed?: boolean | null;
};

export type TourPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type TourPreferencesQuery = {
  tourPreferences?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1TourPreferences';
        featureFlagsStatus?: OnboardingV1TourStepStatus | null;
        rolloutsStatus?: OnboardingV1TourStepStatus | null;
        abTestsStatus?: OnboardingV1TourStepStatus | null;
        dismissed?: boolean | null;
      }
    | null;
};

export type UpdateOnboardingSetupMutationVariables = Exact<{
  input: PartialOnboardingV1OnboardingSetupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateOnboardingSetupMutation = {
  updateOnboardingSetup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1OnboardingSetup';
        path?: OnboardingV1OnboardingPath | null;
        dismissed?: boolean | null;
      }
    | null;
};

export type UpdateTourPreferencesMutationVariables = Exact<{
  input: PartialOnboardingV1TourPreferencesInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateTourPreferencesMutation = {
  updateTourPreferences?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'OnboardingV1TourPreferences';
        featureFlagsStatus?: OnboardingV1TourStepStatus | null;
        rolloutsStatus?: OnboardingV1TourStepStatus | null;
        abTestsStatus?: OnboardingV1TourStepStatus | null;
        dismissed?: boolean | null;
      }
    | null;
};

export type ExecuteCheckMutationVariables = Exact<{
  resourceRelations:
    | Array<FgaV1ResourceRelationInput>
    | FgaV1ResourceRelationInput;
}>;

export type ExecuteCheckMutation = {
  executeCheck?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ExecuteCheckResponse';
        allAllowed?: boolean | null;
        results: Array<{
          allowed?: boolean | null;
          relation?: { resource: string; relation: string } | null;
        }>;
      }
    | null;
};

export type ResourcePermissionFragment = {
  name: string;
  resource: string;
  resourcePermission: FgaV1Permission;
  identity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type ResourcePermissionsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ResourcePermissionsQuery = {
  resourcePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourcePermissionsResponse';
        resourcePermissions: Array<{
          name: string;
          resource: string;
          resourcePermission: FgaV1Permission;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type WriteResourcePermissionsMutationVariables = Exact<{
  removePermissions?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  addPermissions?: InputMaybe<
    Array<FgaV1ResourcePermissionInput> | FgaV1ResourcePermissionInput
  >;
}>;

export type WriteResourcePermissionsMutation = {
  writeResourcePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1WriteResourcePermissionsResponse';
        addedPermissions: Array<{
          name: string;
          resource: string;
          resourcePermission: FgaV1Permission;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        removedPermissions: Array<{ name: string }>;
      }
    | null;
};

export type TransferWorkflowOwnershipMutationVariables = Exact<{
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
}>;

export type TransferWorkflowOwnershipMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        owner?:
          | { __typename: 'Error' }
          | { __typename: 'IamV1Identity'; name: string }
          | null;
      }
    | null;
};

export type CreateProjectMutationVariables = Exact<{
  project: CollaborationV1ProjectInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateProjectMutation = {
  createProject?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        summary?: { body: string; updateTime?: string | null } | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreatePromptHookMutationVariables = Exact<{
  promptHook: ConversationsV2PromptHookInput;
  promptHookId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreatePromptHookMutation = {
  createPromptHook?:
    | {
        __typename: 'ConversationsV2PromptHook';
        name: string;
        displayName?: string | null;
        enabled?: boolean | null;
        promptTemplate: string;
        systemCreated?: boolean | null;
        createTime: string;
        updateTime: string;
        trigger: {
          scheduleTrigger?: { cron: string; timeZone?: string | null } | null;
          eventTrigger?: { eventType: string; filter?: string | null } | null;
        };
        approvedTools: Array<{ tool: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type DeleteProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteProjectMutation = {
  deleteProject?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeletePromptHookMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeletePromptHookMutation = {
  deletePromptHook?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type OnProjectCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnProjectCreatedSubscription = {
  projectCreated?: {
    project?: {
      __typename: 'CollaborationV1Project';
      name: string;
      displayName: string;
      description?: string | null;
      createTime: string;
      updateTime: string;
      deleteTime?: string | null;
      summary?: { body: string; updateTime?: string | null } | null;
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      updater:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            deleteTime?: string | null;
          }
      >;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type OnProjectUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnProjectUpdatedSubscription = {
  projectUpdated?: {
    project?: {
      __typename: 'CollaborationV1Project';
      name: string;
      displayName: string;
      description?: string | null;
      createTime: string;
      updateTime: string;
      deleteTime?: string | null;
      summary?: { body: string; updateTime?: string | null } | null;
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      creator:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      updater:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          };
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            deleteTime?: string | null;
          }
      >;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type ProjectFragment = {
  __typename: 'CollaborationV1Project';
  name: string;
  displayName: string;
  description?: string | null;
  createTime: string;
  updateTime: string;
  deleteTime?: string | null;
  summary?: { body: string; updateTime?: string | null } | null;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  updater:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
      }
  >;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type ProjectQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ProjectQuery = {
  project?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        summary?: { body: string; updateTime?: string | null } | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ProjectRefFragment = {
  __typename: 'CollaborationV1Project';
  name: string;
  displayName: string;
  updateTime: string;
  deleteTime?: string | null;
};

export type ProjectRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ProjectRefQuery = {
  project?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ProjectsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProjectsQuery = {
  projects?:
    | {
        __typename: 'CollaborationV1ListProjectsResponse';
        nextPageToken?: string | null;
        projects: Array<{
          __typename: 'CollaborationV1Project';
          name: string;
          displayName: string;
          updateTime: string;
          deleteTime?: string | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type PromptHookFragment = {
  __typename: 'ConversationsV2PromptHook';
  name: string;
  displayName?: string | null;
  enabled?: boolean | null;
  promptTemplate: string;
  systemCreated?: boolean | null;
  createTime: string;
  updateTime: string;
  trigger: {
    scheduleTrigger?: { cron: string; timeZone?: string | null } | null;
    eventTrigger?: { eventType: string; filter?: string | null } | null;
  };
  approvedTools: Array<{ tool: string }>;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  project?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type PromptHookQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type PromptHookQuery = {
  promptHook?:
    | {
        __typename: 'ConversationsV2PromptHook';
        name: string;
        displayName?: string | null;
        enabled?: boolean | null;
        promptTemplate: string;
        systemCreated?: boolean | null;
        createTime: string;
        updateTime: string;
        collaborativeDocuments?:
          | {
              __typename: 'CollaborationV1ListCollaborativeDocumentsResponse';
              collaborativeDocuments: Array<{
                __typename: 'CollaborationV1CollaborativeDocument';
                name: string;
                title?: string | null;
                state: CollaborationV1CollaborativeDocumentState;
              }>;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        trigger: {
          scheduleTrigger?: { cron: string; timeZone?: string | null } | null;
          eventTrigger?: { eventType: string; filter?: string | null } | null;
        };
        approvedTools: Array<{ tool: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type PromptHooksQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PromptHooksQuery = {
  promptHooks?:
    | {
        __typename: 'ConversationsV2ListPromptHooksResponse';
        nextPageToken?: string | null;
        promptHooks: Array<{
          __typename: 'ConversationsV2PromptHook';
          name: string;
          displayName?: string | null;
          enabled?: boolean | null;
          promptTemplate: string;
          systemCreated?: boolean | null;
          createTime: string;
          updateTime: string;
          trigger: {
            scheduleTrigger?: { cron: string; timeZone?: string | null } | null;
            eventTrigger?: { eventType: string; filter?: string | null } | null;
          };
          approvedTools: Array<{ tool: string }>;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          project?:
            | {
                __typename: 'CollaborationV1Project';
                name: string;
                displayName: string;
                updateTime: string;
                deleteTime?: string | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateProjectMutationVariables = Exact<{
  input: PartialCollaborationV1ProjectInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateProjectMutation = {
  updateProject?:
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        deleteTime?: string | null;
        summary?: { body: string; updateTime?: string | null } | null;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdatePromptHookMutationVariables = Exact<{
  input: PartialConversationsV2PromptHookInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePromptHookMutation = {
  updatePromptHook?:
    | {
        __typename: 'ConversationsV2PromptHook';
        name: string;
        displayName?: string | null;
        enabled?: boolean | null;
        promptTemplate: string;
        systemCreated?: boolean | null;
        createTime: string;
        updateTime: string;
        trigger: {
          scheduleTrigger?: { cron: string; timeZone?: string | null } | null;
          eventTrigger?: { eventType: string; filter?: string | null } | null;
        };
        approvedTools: Array<{ tool: string }>;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        project?:
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ProjectIndexPageQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProjectIndexPageQuery = {
  projects?:
    | {
        __typename: 'CollaborationV1ListProjectsResponse';
        nextPageToken?: string | null;
        projects: Array<{
          __typename: 'CollaborationV1Project';
          name: string;
          displayName: string;
          description?: string | null;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ProjectIndexPageProjectFragment = {
  __typename: 'CollaborationV1Project';
  name: string;
  displayName: string;
  description?: string | null;
  createTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | null;
};

export type CapturePulseBlockMutationVariables = Exact<{
  sourceChat: Scalars['String']['input'];
  sourceEvent?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
  selectedContent?: InputMaybe<Scalars['String']['input']>;
}>;

export type CapturePulseBlockMutation = {
  capturePulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1CapturePulseBlockResponse';
        pulse?: {
          __typename: 'PulseV1Pulse';
          name: string;
          displayName?: string | null;
        } | null;
        block?: {
          __typename: 'PulseV1PulseBlock';
          name: string;
          displayName?: string | null;
          blockType?: PulseV1PulseBlockType | null;
          state?: PulseV1PulseBlockState | null;
          summary?: string | null;
          summaryUpdateTime?: string | null;
          refreshTime?: string | null;
          createTime: string;
          updateTime: string;
          error?: { message?: string | null } | null;
          source?: {
            sql?: { query: string; question?: string | null } | null;
            staticResult?: { dummy?: string | null } | null;
            agent?: { instructions: string; tools: Array<string> } | null;
          } | null;
          currentResult?: {
            captureTime?: string | null;
            queryResult?: {
              visualizationSpec?: any | null;
              resultRef?: string | null;
              resultData?: string | null;
            } | null;
            agentOutput?: { content: string } | null;
          } | null;
          origin?: {
            conversation?: string | null;
            message?: string | null;
          } | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          updater:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        } | null;
      }
    | null;
};

export type ConfigurePulseRefreshScheduleMutationVariables = Exact<{
  pulse: Scalars['String']['input'];
  schedule: PulseV1PulseRefreshSchedule;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ConfigurePulseRefreshScheduleMutation = {
  configurePulseRefreshSchedule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'PulseV1ConfigurePulseRefreshScheduleResponse' }
    | null;
};

export type CreatePulseMutationVariables = Exact<{
  pulse: PulseV1PulseInput;
  pulseId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreatePulseMutation = {
  createPulse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'PulseV1Pulse'; name: string; displayName?: string | null }
    | null;
};

export type CreatePulseBlockMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  pulseBlock: PulseV1PulseBlockInput;
}>;

export type CreatePulseBlockMutation = {
  createPulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1PulseBlock';
        name: string;
        displayName?: string | null;
        blockType?: PulseV1PulseBlockType | null;
        state?: PulseV1PulseBlockState | null;
        summary?: string | null;
        summaryUpdateTime?: string | null;
        refreshTime?: string | null;
        createTime: string;
        updateTime: string;
        error?: { message?: string | null } | null;
        source?: {
          sql?: { query: string; question?: string | null } | null;
          staticResult?: { dummy?: string | null } | null;
          agent?: { instructions: string; tools: Array<string> } | null;
        } | null;
        currentResult?: {
          captureTime?: string | null;
          queryResult?: {
            visualizationSpec?: any | null;
            resultRef?: string | null;
            resultData?: string | null;
          } | null;
          agentOutput?: { content: string } | null;
        } | null;
        origin?: {
          conversation?: string | null;
          message?: string | null;
        } | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type DeletePulseMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeletePulseMutation = {
  deletePulse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeletePulseBlockMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeletePulseBlockMutation = {
  deletePulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type PreviewPulseBlockMutationVariables = Exact<{
  input: PulseV1PulseBlockInput;
}>;

export type PreviewPulseBlockMutation = {
  previewPulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1PulseBlock';
        name: string;
        displayName?: string | null;
        blockType?: PulseV1PulseBlockType | null;
        state?: PulseV1PulseBlockState | null;
        summary?: string | null;
        summaryUpdateTime?: string | null;
        refreshTime?: string | null;
        createTime: string;
        updateTime: string;
        error?: { message?: string | null } | null;
        source?: {
          sql?: { query: string; question?: string | null } | null;
          staticResult?: { dummy?: string | null } | null;
          agent?: { instructions: string; tools: Array<string> } | null;
        } | null;
        currentResult?: {
          captureTime?: string | null;
          queryResult?: {
            visualizationSpec?: any | null;
            resultRef?: string | null;
            resultData?: string | null;
          } | null;
          agentOutput?: { content: string } | null;
        } | null;
        origin?: {
          conversation?: string | null;
          message?: string | null;
        } | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type PulseFragment = {
  __typename: 'PulseV1Pulse';
  summary?: string | null;
  summaryStale?: boolean | null;
  summaryUpdateTime?: string | null;
  createTime: string;
  updateTime: string;
  name: string;
  displayName?: string | null;
  projects: Array<
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
  >;
  reportingConfig?: {
    enabled?: boolean | null;
    slack?: { channel: string } | null;
  } | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  updater:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  blocks: Array<{
    __typename: 'PulseV1PulseBlock';
    name: string;
    displayName?: string | null;
    blockType?: PulseV1PulseBlockType | null;
    state?: PulseV1PulseBlockState | null;
    summary?: string | null;
    summaryUpdateTime?: string | null;
    refreshTime?: string | null;
    createTime: string;
    updateTime: string;
    error?: { message?: string | null } | null;
    source?: {
      sql?: { query: string; question?: string | null } | null;
      staticResult?: { dummy?: string | null } | null;
      agent?: { instructions: string; tools: Array<string> } | null;
    } | null;
    origin?: { conversation?: string | null; message?: string | null } | null;
    creator:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        };
    updater:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        };
  }>;
  layout?: {
    placements: Array<{
      x: number;
      y: number;
      width: number;
      height: number;
      block:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'PulseV1PulseBlock'; name: string };
    }>;
  } | null;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type PulseQueryVariables = Exact<{
  name: Scalars['String']['input'];
  view?: InputMaybe<PulseV1PulseView>;
}>;

export type PulseQuery = {
  pulse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1Pulse';
        summary?: string | null;
        summaryStale?: boolean | null;
        summaryUpdateTime?: string | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName?: string | null;
        projects: Array<
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        >;
        reportingConfig?: {
          enabled?: boolean | null;
          slack?: { channel: string } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        blocks: Array<{
          __typename: 'PulseV1PulseBlock';
          name: string;
          displayName?: string | null;
          blockType?: PulseV1PulseBlockType | null;
          state?: PulseV1PulseBlockState | null;
          summary?: string | null;
          summaryUpdateTime?: string | null;
          refreshTime?: string | null;
          createTime: string;
          updateTime: string;
          error?: { message?: string | null } | null;
          source?: {
            sql?: { query: string; question?: string | null } | null;
            staticResult?: { dummy?: string | null } | null;
            agent?: { instructions: string; tools: Array<string> } | null;
          } | null;
          origin?: {
            conversation?: string | null;
            message?: string | null;
          } | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          updater:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        layout?: {
          placements: Array<{
            x: number;
            y: number;
            width: number;
            height: number;
            block:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'PulseV1PulseBlock'; name: string };
          }>;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | null;
};

export type PulseBlockFragment = {
  __typename: 'PulseV1PulseBlock';
  name: string;
  displayName?: string | null;
  blockType?: PulseV1PulseBlockType | null;
  state?: PulseV1PulseBlockState | null;
  summary?: string | null;
  summaryUpdateTime?: string | null;
  refreshTime?: string | null;
  createTime: string;
  updateTime: string;
  error?: { message?: string | null } | null;
  source?: {
    sql?: { query: string; question?: string | null } | null;
    staticResult?: { dummy?: string | null } | null;
    agent?: { instructions: string; tools: Array<string> } | null;
  } | null;
  currentResult?: {
    captureTime?: string | null;
    queryResult?: {
      visualizationSpec?: any | null;
      resultRef?: string | null;
      resultData?: string | null;
    } | null;
    agentOutput?: { content: string } | null;
  } | null;
  origin?: { conversation?: string | null; message?: string | null } | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  updater:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type PulseBlockQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type PulseBlockQuery = {
  pulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1PulseBlock';
        name: string;
        displayName?: string | null;
        blockType?: PulseV1PulseBlockType | null;
        state?: PulseV1PulseBlockState | null;
        summary?: string | null;
        summaryUpdateTime?: string | null;
        refreshTime?: string | null;
        createTime: string;
        updateTime: string;
        error?: { message?: string | null } | null;
        source?: {
          sql?: { query: string; question?: string | null } | null;
          staticResult?: { dummy?: string | null } | null;
          agent?: { instructions: string; tools: Array<string> } | null;
        } | null;
        currentResult?: {
          captureTime?: string | null;
          queryResult?: {
            visualizationSpec?: any | null;
            resultRef?: string | null;
            resultData?: string | null;
          } | null;
          agentOutput?: { content: string } | null;
        } | null;
        origin?: {
          conversation?: string | null;
          message?: string | null;
        } | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type PulseBlockShellFragment = {
  __typename: 'PulseV1PulseBlock';
  name: string;
  displayName?: string | null;
  blockType?: PulseV1PulseBlockType | null;
  state?: PulseV1PulseBlockState | null;
  summary?: string | null;
  summaryUpdateTime?: string | null;
  refreshTime?: string | null;
  createTime: string;
  updateTime: string;
  error?: { message?: string | null } | null;
  source?: {
    sql?: { query: string; question?: string | null } | null;
    staticResult?: { dummy?: string | null } | null;
    agent?: { instructions: string; tools: Array<string> } | null;
  } | null;
  origin?: { conversation?: string | null; message?: string | null } | null;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  updater:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type PulseChangeFragment = {
  name: string;
  action?: string | null;
  actionTime?: string | null;
  target?: string | null;
  description?: string | null;
  systemInitiated?: boolean | null;
  actor?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type PulseChangesQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type PulseChangesQuery = {
  pulseChanges?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1ListPulseChangesResponse';
        nextPageToken?: string | null;
        pulseChanges: Array<{
          name: string;
          action?: string | null;
          actionTime?: string | null;
          target?: string | null;
          description?: string | null;
          systemInitiated?: boolean | null;
          actor?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        }>;
      }
    | null;
};

export type PulseIndexPagePulseFragment = {
  __typename: 'PulseV1Pulse';
  updateTime: string;
  name: string;
  displayName?: string | null;
  projects: Array<
    | {
        __typename: 'CollaborationV1Project';
        name: string;
        displayName: string;
        updateTime: string;
        deleteTime?: string | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
  >;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type PulseRefFragment = {
  __typename: 'PulseV1Pulse';
  name: string;
  displayName?: string | null;
};

export type PulsesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type PulsesQuery = {
  pulses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1ListPulsesResponse';
        nextPageToken?: string | null;
        pulses: Array<{
          __typename: 'PulseV1Pulse';
          updateTime: string;
          name: string;
          displayName?: string | null;
          projects: Array<
            | {
                __typename: 'CollaborationV1Project';
                name: string;
                displayName: string;
                updateTime: string;
                deleteTime?: string | null;
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          >;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
        }>;
      }
    | null;
};

export type RefreshPulseMutationVariables = Exact<{
  pulse: Scalars['String']['input'];
}>;

export type RefreshPulseMutation = {
  refreshPulse?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1RefreshPulseResponse';
        pulse?: {
          __typename: 'PulseV1Pulse';
          name: string;
          displayName?: string | null;
        } | null;
        refreshedBlocks: Array<{
          __typename: 'PulseV1PulseBlock';
          name: string;
          displayName?: string | null;
          blockType?: PulseV1PulseBlockType | null;
          state?: PulseV1PulseBlockState | null;
          summary?: string | null;
          summaryUpdateTime?: string | null;
          refreshTime?: string | null;
          createTime: string;
          updateTime: string;
          error?: { message?: string | null } | null;
          source?: {
            sql?: { query: string; question?: string | null } | null;
            staticResult?: { dummy?: string | null } | null;
            agent?: { instructions: string; tools: Array<string> } | null;
          } | null;
          currentResult?: {
            captureTime?: string | null;
            queryResult?: {
              visualizationSpec?: any | null;
              resultRef?: string | null;
              resultData?: string | null;
            } | null;
            agentOutput?: { content: string } | null;
          } | null;
          origin?: {
            conversation?: string | null;
            message?: string | null;
          } | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          updater:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type RefreshPulseBlockMutationVariables = Exact<{
  pulseBlock: Scalars['String']['input'];
}>;

export type RefreshPulseBlockMutation = {
  refreshPulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1RefreshPulseBlockResponse';
        pulseBlock?: {
          __typename: 'PulseV1PulseBlock';
          name: string;
          displayName?: string | null;
          blockType?: PulseV1PulseBlockType | null;
          state?: PulseV1PulseBlockState | null;
          summary?: string | null;
          summaryUpdateTime?: string | null;
          refreshTime?: string | null;
          createTime: string;
          updateTime: string;
          error?: { message?: string | null } | null;
          source?: {
            sql?: { query: string; question?: string | null } | null;
            staticResult?: { dummy?: string | null } | null;
            agent?: { instructions: string; tools: Array<string> } | null;
          } | null;
          currentResult?: {
            captureTime?: string | null;
            queryResult?: {
              visualizationSpec?: any | null;
              resultRef?: string | null;
              resultData?: string | null;
            } | null;
            agentOutput?: { content: string } | null;
          } | null;
          origin?: {
            conversation?: string | null;
            message?: string | null;
          } | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          updater:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        } | null;
      }
    | null;
};

export type ResolvePulseRefreshScheduleQueryVariables = Exact<{
  pulse: Scalars['String']['input'];
}>;

export type ResolvePulseRefreshScheduleQuery = {
  resolvePulseRefreshSchedule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1ResolvePulseRefreshScheduleResponse';
        schedule?: PulseV1PulseRefreshSchedule | null;
        timeZone?: string | null;
        interval?: number | null;
        hour?: number | null;
        minute?: number | null;
        dayOfWeek?: number | null;
      }
    | null;
};

export type UpdatePulseMutationVariables = Exact<{
  input: PartialPulseV1PulseInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePulseMutation = {
  updatePulse?:
    | {
        __typename: 'PulseV1Pulse';
        summary?: string | null;
        summaryStale?: boolean | null;
        summaryUpdateTime?: string | null;
        createTime: string;
        updateTime: string;
        name: string;
        displayName?: string | null;
        projects: Array<
          | {
              __typename: 'CollaborationV1Project';
              name: string;
              displayName: string;
              updateTime: string;
              deleteTime?: string | null;
            }
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        >;
        reportingConfig?: {
          enabled?: boolean | null;
          slack?: { channel: string } | null;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        blocks: Array<{
          __typename: 'PulseV1PulseBlock';
          name: string;
          displayName?: string | null;
          blockType?: PulseV1PulseBlockType | null;
          state?: PulseV1PulseBlockState | null;
          summary?: string | null;
          summaryUpdateTime?: string | null;
          refreshTime?: string | null;
          createTime: string;
          updateTime: string;
          error?: { message?: string | null } | null;
          source?: {
            sql?: { query: string; question?: string | null } | null;
            staticResult?: { dummy?: string | null } | null;
            agent?: { instructions: string; tools: Array<string> } | null;
          } | null;
          origin?: {
            conversation?: string | null;
            message?: string | null;
          } | null;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
          updater:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        layout?: {
          placements: Array<{
            x: number;
            y: number;
            width: number;
            height: number;
            block:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'PulseV1PulseBlock'; name: string };
          }>;
        } | null;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | Record<PropertyKey, never>
    | null;
};

export type UpdatePulseBlockMutationVariables = Exact<{
  input: PartialPulseV1PulseBlockInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePulseBlockMutation = {
  updatePulseBlock?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'PulseV1PulseBlock';
        name: string;
        displayName?: string | null;
        blockType?: PulseV1PulseBlockType | null;
        state?: PulseV1PulseBlockState | null;
        summary?: string | null;
        summaryUpdateTime?: string | null;
        refreshTime?: string | null;
        createTime: string;
        updateTime: string;
        error?: { message?: string | null } | null;
        source?: {
          sql?: { query: string; question?: string | null } | null;
          staticResult?: { dummy?: string | null } | null;
          agent?: { instructions: string; tools: Array<string> } | null;
        } | null;
        currentResult?: {
          captureTime?: string | null;
          queryResult?: {
            visualizationSpec?: any | null;
            resultRef?: string | null;
            resultData?: string | null;
          } | null;
          agentOutput?: { content: string } | null;
        } | null;
        origin?: {
          conversation?: string | null;
          message?: string | null;
        } | null;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        updater:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type AggregateRecordingFilterValuesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AggregateRecordingFilterValuesQuery = {
  aggregateRecordingFilterValues?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1AggregateRecordingFilterValuesResponse';
        labels: Array<{ key: string; values: Array<string> }>;
        tags: Array<{ key: string; values: Array<string> }>;
      }
    | null;
};

export type CreateRecordingPolicyMutationVariables = Exact<{
  recordingPolicy: RecordingV1RecordingPolicyInput;
  recordingPolicyId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateRecordingPolicyMutation = {
  createRecordingPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingPolicy';
        name: string;
        displayName?: string | null;
        createTime: string;
        updateTime: string;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Client'; name: string; displayName: string }
        >;
        recordingRules?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'RecordingV1ListRecordingRulesResponse';
              recordingRules: Array<{
                __typename: 'RecordingV1RecordingRule';
                name: string;
                enabled?: boolean | null;
                order: number;
                sessionSampleRate?: number | null;
                targetingKeySelector?: string | null;
                createTime: string;
                updateTime: string;
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      state?: FlagsAdminV1SegmentState | null;
                      allocation?: {
                        exclusiveTo: Array<string>;
                        exclusivityTags: Array<string>;
                        proportion?: { value?: string | null } | null;
                      } | null;
                      targeting?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attributeName?: string | null;
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                              anyRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              allRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            segment?: {
                              segment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1Segment';
                                    name: string;
                                    displayName?: string | null;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                  }
                                | null;
                            } | null;
                            materializedSegment?: {
                              materializedSegment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1MaterializedSegment';
                                    name: string;
                                    displayName: string;
                                  }
                                | null;
                            } | null;
                          } | null;
                        }>;
                        expression?: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        } | null;
                      } | null;
                      workflowInstance?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    }
                  | null;
                environments: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Environment';
                      name: string;
                      color?: string | null;
                    }
                >;
                labels: Array<{ key: string; value?: string | null }>;
                creator:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    };
              }>;
            }
          | null;
      }
    | null;
};

export type CreateRecordingRuleMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  recordingRule: RecordingV1RecordingRuleInput;
  recordingRuleId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateRecordingRuleMutation = {
  createRecordingRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingRule';
        name: string;
        enabled?: boolean | null;
        order: number;
        sessionSampleRate?: number | null;
        targetingKeySelector?: string | null;
        createTime: string;
        updateTime: string;
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
            }
          | null;
        environments: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
            }
        >;
        labels: Array<{ key: string; value?: string | null }>;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type DeleteRecordingPolicyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteRecordingPolicyMutation = {
  deleteRecordingPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type DeleteRecordingRuleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteRecordingRuleMutation = {
  deleteRecordingRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type FindingIssueObservationFragment = {
  name: string;
  source: { externalId?: string | null };
  issue?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'ObservationsV1Issue'; name: string }
    | null;
};

export type FlagVariantsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type FlagVariantsQuery = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        variants: Array<{ name: string }>;
      }
    | null;
};

export type RecordingFragment = {
  __typename: 'RecordingV1Recording';
  name: string;
  client?: string | null;
  createTime: string;
  updateTime: string;
  state?: RecordingV1RecordingState | null;
  targetingKey?: string | null;
  duration?: string | null;
  displayName?: string | null;
  analysis?: {
    intent?: string | null;
    summary?: string | null;
    findings: Array<{
      id: string;
      kind: RecordingV1RecordingAnalysisFindingFindingKind;
      recordingOffset?: string | null;
      summary: string;
    }>;
  } | null;
  downloadRecording?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1DownloadRecordingResponse';
        downloadUri: string;
      }
    | null;
  labels: Array<{ key: string; value?: string | null }>;
  tags: Array<{ key: string; value?: { values: Array<string> } | null }>;
  flagEvaluations: Array<{
    flag: string;
    variants: Array<{ variant: string }>;
  }>;
  metrics: Array<{ key: string; value?: { value?: number | null } | null }>;
  environmentInfo?: {
    browser?: string | null;
    browserVersion?: string | null;
    city?: string | null;
    devicePixelRatio?: number | null;
    mobile?: boolean | null;
    os?: string | null;
    osVersion?: string | null;
    regionCode?: string | null;
    screenHeight?: number | null;
    screenWidth?: number | null;
    userAgent?: string | null;
  } | null;
  routing?: {
    entryPage?: string | null;
    exitPage?: string | null;
    hostname?: string | null;
    routes: Array<{ pageUri: string; title?: string | null }>;
  } | null;
  sdkInfo?: {
    sdkVersion?: string | null;
    analyzerVersion?: string | null;
    appVersion?: string | null;
  } | null;
};

export type RecordingQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RecordingQuery = {
  recording?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1Recording';
        name: string;
        client?: string | null;
        createTime: string;
        updateTime: string;
        state?: RecordingV1RecordingState | null;
        targetingKey?: string | null;
        duration?: string | null;
        displayName?: string | null;
        analysis?: {
          intent?: string | null;
          summary?: string | null;
          findings: Array<{
            id: string;
            kind: RecordingV1RecordingAnalysisFindingFindingKind;
            recordingOffset?: string | null;
            summary: string;
          }>;
        } | null;
        downloadRecording?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'RecordingV1DownloadRecordingResponse';
              downloadUri: string;
            }
          | null;
        labels: Array<{ key: string; value?: string | null }>;
        tags: Array<{ key: string; value?: { values: Array<string> } | null }>;
        flagEvaluations: Array<{
          flag: string;
          variants: Array<{ variant: string }>;
        }>;
        metrics: Array<{
          key: string;
          value?: { value?: number | null } | null;
        }>;
        environmentInfo?: {
          browser?: string | null;
          browserVersion?: string | null;
          city?: string | null;
          devicePixelRatio?: number | null;
          mobile?: boolean | null;
          os?: string | null;
          osVersion?: string | null;
          regionCode?: string | null;
          screenHeight?: number | null;
          screenWidth?: number | null;
          userAgent?: string | null;
        } | null;
        routing?: {
          entryPage?: string | null;
          exitPage?: string | null;
          hostname?: string | null;
          routes: Array<{ pageUri: string; title?: string | null }>;
        } | null;
        sdkInfo?: {
          sdkVersion?: string | null;
          analyzerVersion?: string | null;
          appVersion?: string | null;
        } | null;
      }
    | null;
};

export type RecordingObservationIssuesPageQueryVariables = Exact<{
  name: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type RecordingObservationIssuesPageQuery = {
  recording?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1Recording';
        name: string;
        observations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'ObservationsV1ListObservationsResponse';
              nextPageToken?: string | null;
              observations: Array<{
                name: string;
                source: { externalId?: string | null };
                issue?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'ObservationsV1Issue'; name: string }
                  | null;
              }>;
            }
          | null;
      }
    | null;
};

export type RecordingPoliciesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type RecordingPoliciesQuery = {
  recordingPolicies?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1ListRecordingPoliciesResponse';
        nextPageToken?: string | null;
        recordingPolicies: Array<{
          __typename: 'RecordingV1RecordingPolicy';
          name: string;
          displayName?: string | null;
          createTime: string;
          updateTime: string;
          clients: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'IamV1Client'; name: string; displayName: string }
          >;
          recordingRules?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'RecordingV1ListRecordingRulesResponse';
                recordingRules: Array<{
                  __typename: 'RecordingV1RecordingRule';
                  name: string;
                  enabled?: boolean | null;
                  order: number;
                  sessionSampleRate?: number | null;
                  targetingKeySelector?: string | null;
                  createTime: string;
                  updateTime: string;
                  segment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Segment';
                        name: string;
                        displayName?: string | null;
                        state?: FlagsAdminV1SegmentState | null;
                        allocation?: {
                          exclusiveTo: Array<string>;
                          exclusivityTags: Array<string>;
                          proportion?: { value?: string | null } | null;
                        } | null;
                        targeting?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attributeName?: string | null;
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                                anyRule?: {
                                  rule?: {
                                    eqRule?: {
                                      value?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    startsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                    containsRule?: {
                                      value?: string | null;
                                    } | null;
                                    endsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                allRule?: {
                                  rule?: {
                                    eqRule?: {
                                      value?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        versionValue?: {
                                          version?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    startsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                    containsRule?: {
                                      value?: string | null;
                                    } | null;
                                    endsWithRule?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                              } | null;
                              segment?: {
                                segment?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'FlagsAdminV1Segment';
                                      name: string;
                                      displayName?: string | null;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                    }
                                  | null;
                              } | null;
                              materializedSegment?: {
                                materializedSegment?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'FlagsAdminV1MaterializedSegment';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                            } | null;
                          }>;
                          expression?: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          } | null;
                        } | null;
                        workflowInstance?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'WorkflowV1WorkflowInstance';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      }
                    | null;
                  environments: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Environment';
                        name: string;
                        color?: string | null;
                      }
                  >;
                  labels: Array<{ key: string; value?: string | null }>;
                  creator:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      };
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type RecordingPolicyFragment = {
  __typename: 'RecordingV1RecordingPolicy';
  name: string;
  displayName?: string | null;
  createTime: string;
  updateTime: string;
  clients: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Client'; name: string; displayName: string }
  >;
  recordingRules?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1ListRecordingRulesResponse';
        recordingRules: Array<{
          __typename: 'RecordingV1RecordingRule';
          name: string;
          enabled?: boolean | null;
          order: number;
          sessionSampleRate?: number | null;
          targetingKeySelector?: string | null;
          createTime: string;
          updateTime: string;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
              }
            | null;
          environments: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Environment';
                name: string;
                color?: string | null;
              }
          >;
          labels: Array<{ key: string; value?: string | null }>;
          creator:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type RecordingPolicyQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RecordingPolicyQuery = {
  recordingPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingPolicy';
        name: string;
        displayName?: string | null;
        createTime: string;
        updateTime: string;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Client'; name: string; displayName: string }
        >;
        recordingRules?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'RecordingV1ListRecordingRulesResponse';
              recordingRules: Array<{
                __typename: 'RecordingV1RecordingRule';
                name: string;
                enabled?: boolean | null;
                order: number;
                sessionSampleRate?: number | null;
                targetingKeySelector?: string | null;
                createTime: string;
                updateTime: string;
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      state?: FlagsAdminV1SegmentState | null;
                      allocation?: {
                        exclusiveTo: Array<string>;
                        exclusivityTags: Array<string>;
                        proportion?: { value?: string | null } | null;
                      } | null;
                      targeting?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attributeName?: string | null;
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                              anyRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              allRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            segment?: {
                              segment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1Segment';
                                    name: string;
                                    displayName?: string | null;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                  }
                                | null;
                            } | null;
                            materializedSegment?: {
                              materializedSegment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1MaterializedSegment';
                                    name: string;
                                    displayName: string;
                                  }
                                | null;
                            } | null;
                          } | null;
                        }>;
                        expression?: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        } | null;
                      } | null;
                      workflowInstance?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    }
                  | null;
                environments: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Environment';
                      name: string;
                      color?: string | null;
                    }
                >;
                labels: Array<{ key: string; value?: string | null }>;
                creator:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    };
              }>;
            }
          | null;
      }
    | null;
};

export type RecordingRefFragment = {
  __typename: 'RecordingV1Recording';
  name: string;
  client?: string | null;
  createTime: string;
  updateTime: string;
  state?: RecordingV1RecordingState | null;
  targetingKey?: string | null;
  duration?: string | null;
  displayName?: string | null;
  labels: Array<{ key: string; value?: string | null }>;
  tags: Array<{ key: string; value?: { values: Array<string> } | null }>;
  flagEvaluations: Array<{
    flag: string;
    variants: Array<{ variant: string }>;
  }>;
  metrics: Array<{ key: string; value?: { value?: number | null } | null }>;
  environmentInfo?: {
    browser?: string | null;
    browserVersion?: string | null;
    city?: string | null;
    devicePixelRatio?: number | null;
    mobile?: boolean | null;
    os?: string | null;
    osVersion?: string | null;
    regionCode?: string | null;
    screenHeight?: number | null;
    screenWidth?: number | null;
    userAgent?: string | null;
  } | null;
  routing?: {
    entryPage?: string | null;
    exitPage?: string | null;
    hostname?: string | null;
    routes: Array<{ pageUri: string; title?: string | null }>;
  } | null;
  sdkInfo?: {
    sdkVersion?: string | null;
    analyzerVersion?: string | null;
    appVersion?: string | null;
  } | null;
};

export type RecordingRuleFragment = {
  __typename: 'RecordingV1RecordingRule';
  name: string;
  enabled?: boolean | null;
  order: number;
  sessionSampleRate?: number | null;
  targetingKeySelector?: string | null;
  createTime: string;
  updateTime: string;
  segment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
      }
    | null;
  environments: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Environment';
        name: string;
        color?: string | null;
      }
  >;
  labels: Array<{ key: string; value?: string | null }>;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type RecordingRulesForPolicyQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RecordingRulesForPolicyQuery = {
  recordingPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingPolicy';
        name: string;
        recordingRules?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'RecordingV1ListRecordingRulesResponse';
              recordingRules: Array<{
                name: string;
                enabled?: boolean | null;
                sessionSampleRate?: number | null;
                targetingKeySelector?: string | null;
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      allocation?: {
                        proportion?: { value?: string | null } | null;
                      } | null;
                      workflowInstance?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                          }
                        | null;
                    }
                  | null;
              }>;
            }
          | null;
      }
    | null;
};

export type RecordingsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type RecordingsQuery = {
  recordings?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1ListRecordingsResponse';
        nextPageToken?: string | null;
        recordings: Array<{
          __typename: 'RecordingV1Recording';
          name: string;
          client?: string | null;
          createTime: string;
          updateTime: string;
          state?: RecordingV1RecordingState | null;
          targetingKey?: string | null;
          duration?: string | null;
          displayName?: string | null;
          labels: Array<{ key: string; value?: string | null }>;
          tags: Array<{
            key: string;
            value?: { values: Array<string> } | null;
          }>;
          flagEvaluations: Array<{
            flag: string;
            variants: Array<{ variant: string }>;
          }>;
          metrics: Array<{
            key: string;
            value?: { value?: number | null } | null;
          }>;
          environmentInfo?: {
            browser?: string | null;
            browserVersion?: string | null;
            city?: string | null;
            devicePixelRatio?: number | null;
            mobile?: boolean | null;
            os?: string | null;
            osVersion?: string | null;
            regionCode?: string | null;
            screenHeight?: number | null;
            screenWidth?: number | null;
            userAgent?: string | null;
          } | null;
          routing?: {
            entryPage?: string | null;
            exitPage?: string | null;
            hostname?: string | null;
            routes: Array<{ pageUri: string; title?: string | null }>;
          } | null;
          sdkInfo?: {
            sdkVersion?: string | null;
            analyzerVersion?: string | null;
            appVersion?: string | null;
          } | null;
        }>;
      }
    | null;
};

export type ReorderRecordingRulesMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  rules: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ReorderRecordingRulesMutation = {
  reorderRecordingRules?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type SubmitRecordingFeedbackMutationVariables = Exact<{
  name: Scalars['String']['input'];
  rating: RecordingV1RecordingFeedbackRating;
}>;

export type SubmitRecordingFeedbackMutation = {
  submitRecordingFeedback?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type UpdateRecordingPolicyMutationVariables = Exact<{
  input: PartialRecordingV1RecordingPolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateRecordingPolicyMutation = {
  updateRecordingPolicy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingPolicy';
        name: string;
        displayName?: string | null;
        createTime: string;
        updateTime: string;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Client'; name: string; displayName: string }
        >;
        recordingRules?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'RecordingV1ListRecordingRulesResponse';
              recordingRules: Array<{
                __typename: 'RecordingV1RecordingRule';
                name: string;
                enabled?: boolean | null;
                order: number;
                sessionSampleRate?: number | null;
                targetingKeySelector?: string | null;
                createTime: string;
                updateTime: string;
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      state?: FlagsAdminV1SegmentState | null;
                      allocation?: {
                        exclusiveTo: Array<string>;
                        exclusivityTags: Array<string>;
                        proportion?: { value?: string | null } | null;
                      } | null;
                      targeting?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attributeName?: string | null;
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                              anyRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              allRule?: {
                                rule?: {
                                  eqRule?: {
                                    value?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      versionValue?: {
                                        version?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  startsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                  containsRule?: {
                                    value?: string | null;
                                  } | null;
                                  endsWithRule?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                            } | null;
                            segment?: {
                              segment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1Segment';
                                    name: string;
                                    displayName?: string | null;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                  }
                                | null;
                            } | null;
                            materializedSegment?: {
                              materializedSegment?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FlagsAdminV1MaterializedSegment';
                                    name: string;
                                    displayName: string;
                                  }
                                | null;
                            } | null;
                          } | null;
                        }>;
                        expression?: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        } | null;
                      } | null;
                      workflowInstance?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    }
                  | null;
                environments: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Environment';
                      name: string;
                      color?: string | null;
                    }
                >;
                labels: Array<{ key: string; value?: string | null }>;
                creator:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    };
              }>;
            }
          | null;
      }
    | null;
};

export type UpdateRecordingRuleMutationVariables = Exact<{
  input: PartialRecordingV1RecordingRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateRecordingRuleMutation = {
  updateRecordingRule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1RecordingRule';
        name: string;
        enabled?: boolean | null;
        order: number;
        sessionSampleRate?: number | null;
        targetingKeySelector?: string | null;
        createTime: string;
        updateTime: string;
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
            }
          | null;
        environments: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Environment';
              name: string;
              color?: string | null;
            }
        >;
        labels: Array<{ key: string; value?: string | null }>;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type RecordingInsightsOverviewQueryVariables = Exact<{
  client?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  granularity: Scalars['String']['input'];
  maxDuration?: InputMaybe<Scalars['String']['input']>;
  metrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  minDuration?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
}>;

export type RecordingInsightsOverviewQuery = {
  recordingInsightsOverview?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1QueryRecordingInsightsOverviewResponse';
        signals: Array<{
          metric: string;
          buckets: Array<{
            startTime: string;
            totalRecordings: any;
            affectedRecordings: any;
            affectedPercentage: number;
            signalCount: number;
            totalRoutes: any;
            affectedRoutes: any;
          }>;
        }>;
      }
    | null;
};

export type RecordingRouteInsightsQueryVariables = Exact<{
  client?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  granularity: Scalars['String']['input'];
  maxDuration?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  minDuration?: InputMaybe<Scalars['String']['input']>;
  routeOrder?: InputMaybe<RecordingV1RecordingRouteInsightsOrder>;
  routeLimit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
}>;

export type RecordingRouteInsightsQuery = {
  recordingRouteInsights?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'RecordingV1QueryRecordingRouteInsightsResponse';
        summaryBuckets: Array<{
          startTime: string;
          totalRecordings: any;
          affectedRecordings: any;
          affectedPercentage: number;
          signalCount: number;
          totalRoutes: any;
          affectedRoutes: any;
        }>;
        routes: Array<{
          route: string;
          buckets: Array<{
            totalRecordings: any;
            affectedRecordings: any;
            affectedPercentage: number;
            signalCount: number;
            signalsPerAffectedRecording: number;
          }>;
        }>;
      }
    | null;
};

export type CollaborationReviewResponseFragment = {
  __typename: 'CollaborationV1ListReviewResponsesResponse';
  reviewResponses: Array<{
    name: string;
    comment?:
      | {
          __typename: 'CollaborationV1Comment';
          name: string;
          resource: string;
          createTime: string;
          updateTime: string;
          content: string;
          resolved?: boolean | null;
          author:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          assignee?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          anchor?: { zone?: { zone: string } | null } | null;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | null;
  }>;
};

export type ReviewQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ReviewQuery = {
  review?:
    | {
        __typename: 'CollaborationV1Review';
        name: string;
        resource: string;
        state: CollaborationV1ReviewState;
        reviewResponses?:
          | {
              __typename: 'CollaborationV1ListReviewResponsesResponse';
              reviewResponses: Array<{
                name: string;
                comment?:
                  | {
                      __typename: 'CollaborationV1Comment';
                      name: string;
                      resource: string;
                      createTime: string;
                      updateTime: string;
                      content: string;
                      resolved?: boolean | null;
                      author:
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | Record<PropertyKey, never>;
                      assignee?:
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      anchor?: { zone?: { zone: string } | null } | null;
                      queryReactionSummary?:
                        | {
                            __typename: 'CollaborationV1QueryReactionSummaryResponse';
                            summary: {
                              name: string;
                              commentCount: number;
                              emojiReactions: Array<{
                                key: string;
                                value?: {
                                  emoji?: string | null;
                                  reactionCount?: number | null;
                                  identities: Array<
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'IamV1Identity';
                                        name: string;
                                        displayName: string;
                                        pictureUri?: string | null;
                                      }
                                  >;
                                } | null;
                              }>;
                            };
                          }
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | null;
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | Record<PropertyKey, never>
          | null;
      }
    | Record<PropertyKey, never>
    | null;
};

export type AppGroupFragment = {
  __typename: 'IamV1Group';
  name: string;
  displayName: string;
  description?: string | null;
  groupType: IamV1GroupGroupType;
  createTime: string;
  updateTime: string;
};

export type AppIdentityFragment = {
  __typename: 'IamV1Identity';
  name: string;
  displayName: string;
  everyone?: boolean | null;
  user?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        name: string;
        fullName: string;
        email: string;
        pictureUri?: string | null;
        lastLoginTime?: string | null;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'IamV1Identity'; name: string; displayName: string };
      }
    | null;
  group?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Group';
        name: string;
        displayName: string;
        description?: string | null;
        groupType: IamV1GroupGroupType;
        createTime: string;
        updateTime: string;
      }
    | null;
};

export type AppUserFragment = {
  __typename: 'IamV1User';
  name: string;
  fullName: string;
  email: string;
  pictureUri?: string | null;
  lastLoginTime?: string | null;
  identity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1Identity'; name: string; displayName: string };
};

export type ConfidenceResourceSearchQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  includeWorkflows: Scalars['Boolean']['input'];
  workflowFilter?: InputMaybe<Scalars['String']['input']>;
  includeMetrics: Scalars['Boolean']['input'];
  includeFactTables: Scalars['Boolean']['input'];
  includeAssignmentTables: Scalars['Boolean']['input'];
  includeFlags: Scalars['Boolean']['input'];
  includeEvents: Scalars['Boolean']['input'];
  includeEntities: Scalars['Boolean']['input'];
  includeInitiatives: Scalars['Boolean']['input'];
  includeProjects: Scalars['Boolean']['input'];
  includeSurfaces: Scalars['Boolean']['input'];
}>;

export type ConfidenceResourceSearchQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        metrics: Array<{ displayName: string; name: string }>;
      }
    | null;
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        factTables: Array<{ displayName: string; name: string }>;
      }
    | null;
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{ displayName: string; name: string }>;
      }
    | null;
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{ displayName: string; name: string }>;
      }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{ name: string }>;
      }
    | null;
  eventDefinitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1ListEventDefinitionsResponse';
        eventDefinitions: Array<{ name: string }>;
      }
    | null;
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        entities: Array<{ displayName: string; name: string }>;
      }
    | null;
  initiatives?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListInitiativesResponse';
        initiatives: Array<{ displayName: string; name: string }>;
      }
    | null;
  projects?:
    | {
        __typename: 'CollaborationV1ListProjectsResponse';
        projects: Array<{ displayName: string; name: string }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  surfaces?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListSurfacesResponse';
        surfaces: Array<{ displayName: string; name: string }>;
      }
    | null;
};

export type ConfidenceSearchQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  flagsFilter?: InputMaybe<Scalars['String']['input']>;
  eventsFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConfidenceSearchQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        metrics: Array<{
          displayName: string;
          name: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        factTables: Array<{
          displayName: string;
          name: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          displayName: string;
          name: string;
          state: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{
          displayName: string;
          name: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{
          name: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
  eventDefinitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1ListEventDefinitionsResponse';
        eventDefinitions: Array<{
          name: string;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                      identity:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                          };
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      createTime: string;
                      updateTime: string;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
};

export type ActivityFeedFragment = {
  __typename: 'ActivityV1Feed';
  name: string;
  channels: Array<{
    priority?: ActivityV1ActivityPriority | null;
    disabled: boolean;
    email?: { address: string } | null;
    slack?: {
      channel?: string | null;
      user?: string | null;
      team?: string | null;
    } | null;
    activityTypes: Array<
      { name: string; displayName: string } | Record<PropertyKey, never>
    >;
  }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
};

export type ActivityFeedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ActivityFeedQuery = {
  feed?:
    | {
        __typename: 'ActivityV1Feed';
        name: string;
        channels: Array<{
          priority?: ActivityV1ActivityPriority | null;
          disabled: boolean;
          email?: { address: string } | null;
          slack?: {
            channel?: string | null;
            user?: string | null;
            team?: string | null;
          } | null;
          activityTypes: Array<
            { name: string; displayName: string } | Record<PropertyKey, never>
          >;
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AddSurfaceIdentityBindingMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  surfaceIdentityBinding: WorkflowV1SurfaceIdentityBindingInput;
}>;

export type AddSurfaceIdentityBindingMutation = {
  addSurfaceIdentityBinding?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1SurfaceIdentityBinding';
        name: string;
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        createTime: string;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }
    | null;
};

export type AiWorkflowTriggerFragment = {
  __typename: 'AiworkflowsV1AiWorkflowTrigger';
  name: string;
  filterType: string;
  filterName: string;
  createTime: string;
  updateTime: string;
  action: {
    executeFunctionAction?: {
      function: string;
      parameters?: any | null;
    } | null;
    transitionWorkflowAction?: {
      action: string;
      parameters?: any | null;
    } | null;
  };
  trigger: {
    stateTrigger?: { state: string } | null;
    activityTrigger?: { kind: string; resource?: string | null } | null;
    dashboardAlertTrigger?: {
      alertState?: AiworkflowsV1AlertState | null;
      graphType: string;
      lastChecked?: string | null;
      condition: {
        comparator: AiworkflowsV1Comparator;
        thresholdValue: number;
      };
      labelFilters: Array<{ key: string; value?: string | null }>;
    } | null;
  };
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type AiWorkflowTriggersQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AiWorkflowTriggersQuery = {
  aiWorkflowTriggers?:
    | {
        __typename: 'AiworkflowsV1ListAiWorkflowTriggersResponse';
        nextPageToken?: string | null;
        aiWorkflowTriggers: Array<{
          __typename: 'AiworkflowsV1AiWorkflowTrigger';
          name: string;
          filterType: string;
          filterName: string;
          createTime: string;
          updateTime: string;
          action: {
            executeFunctionAction?: {
              function: string;
              parameters?: any | null;
            } | null;
            transitionWorkflowAction?: {
              action: string;
              parameters?: any | null;
            } | null;
          };
          trigger: {
            stateTrigger?: { state: string } | null;
            activityTrigger?: { kind: string; resource?: string | null } | null;
            dashboardAlertTrigger?: {
              alertState?: AiworkflowsV1AlertState | null;
              graphType: string;
              lastChecked?: string | null;
              condition: {
                comparator: AiworkflowsV1Comparator;
                thresholdValue: number;
              };
              labelFilters: Array<{ key: string; value?: string | null }>;
            } | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type AutomatedActionFragment = {
  action?: {
    executeFunctionAction?: {
      __typename: 'ActionsV1TypesExecuteFunctionAction';
      function?: string | null;
      parameters?: any | null;
    } | null;
    transitionAction?: {
      __typename: 'ActionsV1TypesTransitionWorkflowAction';
      action?: string | null;
      parameters?: any | null;
    } | null;
    pagerdutyAction?: {
      pdKey: string;
      severity: ActionsV1TypesSeverity;
      title?: string | null;
      description?: string | null;
    } | null;
  } | null;
  trigger?: {
    stateTrigger?: {
      __typename: 'ActionsV1TypesStateTrigger';
      resource?: string | null;
      state?: string | null;
    } | null;
    activityTrigger?: { kind?: string | null; resource?: string | null } | null;
  } | null;
};

export type ComputeSegmentSpaceCalendarMutationVariables = Exact<{
  startDate: GoogleTypeDateInput;
  endDate: GoogleTypeDateInput;
  segments?: InputMaybe<
    Array<FlagsAdminV1SegmentScheduleInput> | FlagsAdminV1SegmentScheduleInput
  >;
}>;

export type ComputeSegmentSpaceCalendarMutation = {
  computeSegmentSpaceCalendar?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ComputeSegmentSpaceCalendarResponse';
        dailyAvailability: Array<{
          date: {
            year?: number | null;
            month?: number | null;
            day?: number | null;
          };
          availableSpace?: { value?: string | null } | null;
          reclaimableSpace: Array<{
            key: string;
            value?: { value?: string | null } | null;
          }>;
        }>;
      }
    | null;
};

export type CreateAiWorkflowTriggerMutationVariables = Exact<{
  aiWorkflowTrigger: AiworkflowsV1AiWorkflowTriggerInput;
}>;

export type CreateAiWorkflowTriggerMutation = {
  createAiWorkflowTrigger?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowTrigger';
        name: string;
        filterType: string;
        filterName: string;
        createTime: string;
        updateTime: string;
        action: {
          executeFunctionAction?: {
            function: string;
            parameters?: any | null;
          } | null;
          transitionWorkflowAction?: {
            action: string;
            parameters?: any | null;
          } | null;
        };
        trigger: {
          stateTrigger?: { state: string } | null;
          activityTrigger?: { kind: string; resource?: string | null } | null;
          dashboardAlertTrigger?: {
            alertState?: AiworkflowsV1AlertState | null;
            graphType: string;
            lastChecked?: string | null;
            condition: {
              comparator: AiworkflowsV1Comparator;
              thresholdValue: number;
            };
            labelFilters: Array<{ key: string; value?: string | null }>;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateFeedMutationVariables = Exact<{
  feed: ActivityV1FeedInput;
  feedId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateFeedMutation = {
  createFeed?:
    | {
        __typename: 'ActivityV1Feed';
        name: string;
        channels: Array<{
          priority?: ActivityV1ActivityPriority | null;
          email?: { address: string } | null;
          slack?: { channel?: string | null } | null;
          activityTypes: Array<{ name: string } | Record<PropertyKey, never>>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type CreateHoldbackMutationVariables = Exact<{
  holdback: WorkflowV1HoldbackInput;
  holdbackId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
}>;

export type CreateHoldbackMutation = {
  createHoldback?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Holdback';
        name: string;
        displayName?: string | null;
        description?: string | null;
        mode?: WorkflowV1HoldbackMode | null;
        owner?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        allocation: { value?: string | null };
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }
    | null;
};

export type CreateSurfaceMutationVariables = Exact<{
  input: WorkflowV1SurfaceInput;
}>;

export type CreateSurfaceMutation = {
  createSurface?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type DeleteAiWorkflowTriggerMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteAiWorkflowTriggerMutation = {
  deleteAiWorkflowTrigger?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type DeleteHoldbackMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteHoldbackMutation = {
  deleteHoldback?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type DeleteSurfaceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteSurfaceMutation = {
  deleteSurface?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | Record<PropertyKey, never>
    | null;
};

export type HoldbackFragment = {
  __typename: 'WorkflowV1Holdback';
  name: string;
  displayName?: string | null;
  description?: string | null;
  mode?: WorkflowV1HoldbackMode | null;
  owner?:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>
    | null;
  allocation: { value?: string | null };
  segment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type HoldbackQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type HoldbackQuery = {
  holdback?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Holdback';
        name: string;
        displayName?: string | null;
        description?: string | null;
        mode?: WorkflowV1HoldbackMode | null;
        owner?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        allocation: { value?: string | null };
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }
    | null;
};

export type HoldbacksQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type HoldbacksQuery = {
  holdbacks?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListHoldbacksResponse';
        nextPageToken?: string | null;
        holdbacks: Array<{
          __typename: 'WorkflowV1Holdback';
          name: string;
          displayName?: string | null;
          description?: string | null;
          mode?: WorkflowV1HoldbackMode | null;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          allocation: { value?: string | null };
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
        }>;
      }
    | null;
};

export type OnSurfaceCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnSurfaceCreatedSubscription = {
  surfaceCreated?: {
    surface?: {
      __typename: 'WorkflowV1Surface';
      name: string;
      displayName: string;
      description?: string | null;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      reviews?: {
        mandatory?: boolean | null;
        reviewers: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
      } | null;
      stakeholders: Array<{
        role: string;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      automatedActions: Array<{
        action?: {
          executeFunctionAction?: {
            __typename: 'ActionsV1TypesExecuteFunctionAction';
            function?: string | null;
            parameters?: any | null;
          } | null;
          transitionAction?: {
            __typename: 'ActionsV1TypesTransitionWorkflowAction';
            action?: string | null;
            parameters?: any | null;
          } | null;
          pagerdutyAction?: {
            pdKey: string;
            severity: ActionsV1TypesSeverity;
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
        trigger?: {
          stateTrigger?: {
            __typename: 'ActionsV1TypesStateTrigger';
            resource?: string | null;
            state?: string | null;
          } | null;
          activityTrigger?: {
            kind?: string | null;
            resource?: string | null;
          } | null;
        } | null;
      }>;
      labels: Array<{ key: string; value?: string | null }>;
    } | null;
  } | null;
};

export type OnSurfaceDeletedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnSurfaceDeletedSubscription = {
  surfaceDeleted?: { surface: string } | null;
};

export type OnSurfaceUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnSurfaceUpdatedSubscription = {
  surfaceUpdated?: {
    surface?: {
      __typename: 'WorkflowV1Surface';
      name: string;
      displayName: string;
      description?: string | null;
      updateTime: string;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      reviews?: {
        mandatory?: boolean | null;
        reviewers: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
        >;
      } | null;
      stakeholders: Array<{
        role: string;
        identity:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
      }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
      automatedActions: Array<{
        action?: {
          executeFunctionAction?: {
            __typename: 'ActionsV1TypesExecuteFunctionAction';
            function?: string | null;
            parameters?: any | null;
          } | null;
          transitionAction?: {
            __typename: 'ActionsV1TypesTransitionWorkflowAction';
            action?: string | null;
            parameters?: any | null;
          } | null;
          pagerdutyAction?: {
            pdKey: string;
            severity: ActionsV1TypesSeverity;
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
        trigger?: {
          stateTrigger?: {
            __typename: 'ActionsV1TypesStateTrigger';
            resource?: string | null;
            state?: string | null;
          } | null;
          activityTrigger?: {
            kind?: string | null;
            resource?: string | null;
          } | null;
        } | null;
      }>;
      labels: Array<{ key: string; value?: string | null }>;
    } | null;
  } | null;
};

export type RemoveSurfaceIdentityBindingMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RemoveSurfaceIdentityBindingMutation = {
  removeSurfaceIdentityBinding?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type SpaceAvailabilitySegmentFragment = {
  __typename: 'FlagsAdminV1Segment';
  state?: FlagsAdminV1SegmentState | null;
  name: string;
  displayName?: string | null;
  allocation?: {
    exclusiveTo: Array<string>;
    exclusivityTags: Array<string>;
    proportion?: { value?: string | null } | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  workflowInstance?:
    | {
        name: string;
        displayName: string;
        moduleData2: {
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
            } | null;
          } | null;
        };
      }
    | Record<PropertyKey, never>
    | null;
};

export type SpaceAvailabilitySegmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type SpaceAvailabilitySegmentsQuery = {
  segments?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListSegmentsResponse';
        nextPageToken?: string | null;
        segments: Array<{
          __typename: 'FlagsAdminV1Segment';
          state?: FlagsAdminV1SegmentState | null;
          name: string;
          displayName?: string | null;
          allocation?: {
            exclusiveTo: Array<string>;
            exclusivityTags: Array<string>;
            proportion?: { value?: string | null } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          workflowInstance?:
            | {
                name: string;
                displayName: string;
                moduleData2: {
                  planning?: {
                    planned?: {
                      startTime?: string | null;
                      endTime?: string | null;
                    } | null;
                    actual?: {
                      startTime?: string | null;
                      endTime?: string | null;
                    } | null;
                  } | null;
                };
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
};

export type SurfaceFragment = {
  __typename: 'WorkflowV1Surface';
  name: string;
  displayName: string;
  description?: string | null;
  updateTime: string;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  reviews?: {
    mandatory?: boolean | null;
    reviewers: Array<
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
    >;
  } | null;
  stakeholders: Array<{
    role: string;
    identity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        };
  }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  automatedActions: Array<{
    action?: {
      executeFunctionAction?: {
        __typename: 'ActionsV1TypesExecuteFunctionAction';
        function?: string | null;
        parameters?: any | null;
      } | null;
      transitionAction?: {
        __typename: 'ActionsV1TypesTransitionWorkflowAction';
        action?: string | null;
        parameters?: any | null;
      } | null;
      pagerdutyAction?: {
        pdKey: string;
        severity: ActionsV1TypesSeverity;
        title?: string | null;
        description?: string | null;
      } | null;
    } | null;
    trigger?: {
      stateTrigger?: {
        __typename: 'ActionsV1TypesStateTrigger';
        resource?: string | null;
        state?: string | null;
      } | null;
      activityTrigger?: {
        kind?: string | null;
        resource?: string | null;
      } | null;
    } | null;
  }>;
  labels: Array<{ key: string; value?: string | null }>;
};

export type SurfaceQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type SurfaceQuery = {
  surface?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            preferredDirection?: WorkflowV1LinkedMetricPreferredDirection | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  name: string;
                  displayName: string;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                      }
                    | null;
                };
            guardrailMetric?: {
              nonInferiorityMargin?: { value?: string | null } | null;
            } | null;
            successMetric?: {
              minimumDetectableEffect?: { value?: string | null } | null;
            } | null;
          }>;
          monitoringMetrics: Array<{
            preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  name: string;
                  displayName: string;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                      }
                    | null;
                };
          }>;
        } | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type SurfaceCoordinationQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  showDeletedHoldbacks?: InputMaybe<Scalars['Boolean']['input']>;
  showDeletedExclusivityGroups?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SurfaceCoordinationQuery = {
  surfaces?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListSurfacesResponse';
        surfaces: Array<{
          name: string;
          description?: string | null;
          displayName: string;
          holdbacks?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1ListHoldbacksResponse';
                holdbacks: Array<{
                  name: string;
                  description?: string | null;
                  mode?: WorkflowV1HoldbackMode | null;
                  displayName?: string | null;
                }>;
              }
            | null;
          exclusivityGroups?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1ListExclusivityGroupsResponse';
                exclusivityGroups: Array<{
                  name: string;
                  mode?: WorkflowV1ExclusivityGroupMode | null;
                  description?: string | null;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type SurfaceIdentityBindingFragment = {
  __typename: 'WorkflowV1SurfaceIdentityBinding';
  name: string;
  enforcementLevel?: WorkflowV1EnforcementLevel | null;
  createTime: string;
  identity:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
};

export type SurfaceIdentityBindingsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type SurfaceIdentityBindingsQuery = {
  surfaceIdentityBindings?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListSurfaceIdentityBindingsResponse';
        nextPageToken?: string | null;
        surfaceIdentityBindings: Array<{
          __typename: 'WorkflowV1SurfaceIdentityBinding';
          name: string;
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          createTime: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
      }
    | null;
};

export type SurfaceMetricDetailsFragment = {
  name: string;
  displayName: string;
  preferredDirection?: MetricsV1MetricPreferredDirection | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Entity';
        name: string;
        displayName: string;
        primaryKeyType: MetricsV1ColumnType;
      }
    | null;
};

export type SurfaceMetricsFragment = {
  metrics: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    preferredDirection?: WorkflowV1LinkedMetricPreferredDirection | null;
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          name: string;
          displayName: string;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
              }
            | null;
        };
    guardrailMetric?: {
      nonInferiorityMargin?: { value?: string | null } | null;
    } | null;
    successMetric?: {
      minimumDetectableEffect?: { value?: string | null } | null;
    } | null;
  }>;
  monitoringMetrics: Array<{
    preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          name: string;
          displayName: string;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
              }
            | null;
        };
  }>;
};

export type SurfaceRefFragment = {
  __typename: 'WorkflowV1Surface';
  name: string;
  displayName: string;
  description?: string | null;
  deleteTime?: string | null;
};

export type SurfaceWithMetricsFragment = {
  __typename: 'WorkflowV1Surface';
  name: string;
  displayName: string;
  description?: string | null;
  updateTime: string;
  metricConfig?: {
    metrics: Array<{
      enforcementLevel?: WorkflowV1EnforcementLevel | null;
      preferredDirection?: WorkflowV1LinkedMetricPreferredDirection | null;
      metric:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            name: string;
            displayName: string;
            preferredDirection?: MetricsV1MetricPreferredDirection | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                  primaryKeyType: MetricsV1ColumnType;
                }
              | null;
          };
      guardrailMetric?: {
        nonInferiorityMargin?: { value?: string | null } | null;
      } | null;
      successMetric?: {
        minimumDetectableEffect?: { value?: string | null } | null;
      } | null;
    }>;
    monitoringMetrics: Array<{
      preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
      metric:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            name: string;
            displayName: string;
            preferredDirection?: MetricsV1MetricPreferredDirection | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                  primaryKeyType: MetricsV1ColumnType;
                }
              | null;
          };
    }>;
  } | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  reviews?: {
    mandatory?: boolean | null;
    reviewers: Array<
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        }
    >;
  } | null;
  stakeholders: Array<{
    role: string;
    identity:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
        };
  }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
  automatedActions: Array<{
    action?: {
      executeFunctionAction?: {
        __typename: 'ActionsV1TypesExecuteFunctionAction';
        function?: string | null;
        parameters?: any | null;
      } | null;
      transitionAction?: {
        __typename: 'ActionsV1TypesTransitionWorkflowAction';
        action?: string | null;
        parameters?: any | null;
      } | null;
      pagerdutyAction?: {
        pdKey: string;
        severity: ActionsV1TypesSeverity;
        title?: string | null;
        description?: string | null;
      } | null;
    } | null;
    trigger?: {
      stateTrigger?: {
        __typename: 'ActionsV1TypesStateTrigger';
        resource?: string | null;
        state?: string | null;
      } | null;
      activityTrigger?: {
        kind?: string | null;
        resource?: string | null;
      } | null;
    } | null;
  }>;
  labels: Array<{ key: string; value?: string | null }>;
};

export type SurfacesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type SurfacesQuery = {
  surfaces?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListSurfacesResponse';
        nextPageToken?: string | null;
        surfaces: Array<{
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
          deleteTime?: string | null;
        }>;
      }
    | null;
};

export type UpdateAiWorkflowTriggerMutationVariables = Exact<{
  aiWorkflowTrigger: PartialAiworkflowsV1AiWorkflowTriggerInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAiWorkflowTriggerMutation = {
  updateAiWorkflowTrigger?:
    | {
        __typename: 'AiworkflowsV1AiWorkflowTrigger';
        name: string;
        filterType: string;
        filterName: string;
        createTime: string;
        updateTime: string;
        action: {
          executeFunctionAction?: {
            function: string;
            parameters?: any | null;
          } | null;
          transitionWorkflowAction?: {
            action: string;
            parameters?: any | null;
          } | null;
        };
        trigger: {
          stateTrigger?: { state: string } | null;
          activityTrigger?: { kind: string; resource?: string | null } | null;
          dashboardAlertTrigger?: {
            alertState?: AiworkflowsV1AlertState | null;
            graphType: string;
            lastChecked?: string | null;
            condition: {
              comparator: AiworkflowsV1Comparator;
              thresholdValue: number;
            };
            labelFilters: Array<{ key: string; value?: string | null }>;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateFeedMutationVariables = Exact<{
  feed: PartialActivityV1FeedInput;
}>;

export type UpdateFeedMutation = {
  updateFeed?:
    | {
        __typename: 'ActivityV1Feed';
        name: string;
        channels: Array<{
          priority?: ActivityV1ActivityPriority | null;
          disabled: boolean;
          email?: { address: string } | null;
          slack?: { channel?: string | null } | null;
          activityTypes: Array<{ name: string } | Record<PropertyKey, never>>;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateHoldbackMutationVariables = Exact<{
  input: PartialWorkflowV1HoldbackInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateHoldbackMutation = {
  updateHoldback?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Holdback';
        name: string;
        displayName?: string | null;
        description?: string | null;
        mode?: WorkflowV1HoldbackMode | null;
        owner?:
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | Record<PropertyKey, never>
          | null;
        allocation: { value?: string | null };
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              description?: string | null;
              state?: FlagsAdminV1SegmentState | null;
              createTime: string;
              updateTime: string;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    displayName: string;
                  }
                | null;
              workflowInstance?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              allocation?: {
                exclusiveTo: Array<string>;
                exclusivityTags: Array<string>;
                proportion?: { value?: string | null } | null;
              } | null;
              targeting?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attributeName?: string | null;
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                      anyRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                      allRule?: {
                        rule?: {
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                        } | null;
                      } | null;
                    } | null;
                    segment?: {
                      segment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1Segment';
                            name: string;
                            displayName?: string | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                          }
                        | null;
                    } | null;
                    materializedSegment?: {
                      materializedSegment?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FlagsAdminV1MaterializedSegment';
                            name: string;
                            displayName: string;
                          }
                        | null;
                    } | null;
                  } | null;
                }>;
                expression?: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
      }
    | null;
};

export type UpdateSurfaceMutationVariables = Exact<{
  input: PartialWorkflowV1SurfaceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSurfaceMutation = {
  updateSurface?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        updateTime: string;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        reviews?: {
          mandatory?: boolean | null;
          reviewers: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
          >;
        } | null;
        stakeholders: Array<{
          role: string;
          identity:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              };
        }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
        automatedActions: Array<{
          action?: {
            executeFunctionAction?: {
              __typename: 'ActionsV1TypesExecuteFunctionAction';
              function?: string | null;
              parameters?: any | null;
            } | null;
            transitionAction?: {
              __typename: 'ActionsV1TypesTransitionWorkflowAction';
              action?: string | null;
              parameters?: any | null;
            } | null;
            pagerdutyAction?: {
              pdKey: string;
              severity: ActionsV1TypesSeverity;
              title?: string | null;
              description?: string | null;
            } | null;
          } | null;
          trigger?: {
            stateTrigger?: {
              __typename: 'ActionsV1TypesStateTrigger';
              resource?: string | null;
              state?: string | null;
            } | null;
            activityTrigger?: {
              kind?: string | null;
              resource?: string | null;
            } | null;
          } | null;
        }>;
        labels: Array<{ key: string; value?: string | null }>;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            preferredDirection?: WorkflowV1LinkedMetricPreferredDirection | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  name: string;
                  displayName: string;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                      }
                    | null;
                };
            guardrailMetric?: {
              nonInferiorityMargin?: { value?: string | null } | null;
            } | null;
            successMetric?: {
              minimumDetectableEffect?: { value?: string | null } | null;
            } | null;
          }>;
          monitoringMetrics: Array<{
            preferredDirection: WorkflowV1SurfaceMonitoringMetricPreferredDirection;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  name: string;
                  displayName: string;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                      }
                    | null;
                };
          }>;
        } | null;
      }
    | null;
};

export type CreateExclusivityGroupMutationVariables = Exact<{
  exclusivityGroup: WorkflowV1ExclusivityGroupInput;
  exclusivityGroupId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
}>;

export type CreateExclusivityGroupMutation = {
  createExclusivityGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExclusivityGroup';
        description?: string | null;
        mode?: WorkflowV1ExclusivityGroupMode | null;
        name: string;
      }
    | null;
};

export type DeleteExclusivityGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteExclusivityGroupMutation = {
  deleteExclusivityGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type ExclusivityGroupFragment = {
  __typename: 'WorkflowV1ExclusivityGroup';
  description?: string | null;
  mode?: WorkflowV1ExclusivityGroupMode | null;
  name: string;
};

export type ExclusivityGroupQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ExclusivityGroupQuery = {
  exclusivityGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExclusivityGroup';
        description?: string | null;
        mode?: WorkflowV1ExclusivityGroupMode | null;
        name: string;
      }
    | null;
};

export type ExclusivityGroupsQueryVariables = Exact<{
  parent: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExclusivityGroupsQuery = {
  exclusivityGroups?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListExclusivityGroupsResponse';
        nextPageToken?: string | null;
        exclusivityGroups: Array<{
          __typename: 'WorkflowV1ExclusivityGroup';
          description?: string | null;
          mode?: WorkflowV1ExclusivityGroupMode | null;
          name: string;
        }>;
      }
    | null;
};

export type SurfaceIndexPageSurfaceFragment = {
  __typename: 'WorkflowV1Surface';
  updateTime: string;
  name: string;
  displayName: string;
  description?: string | null;
  deleteTime?: string | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type SurfacePageActivitiesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type SurfacePageActivitiesQuery = {
  activities?:
    | {
        nextPageToken?: string | null;
        activities: Array<{
          __typename: 'ActivityV1Activity';
          name: string;
          title: string;
          body: string;
          data?: any | null;
          primaryResource: string;
          relatedResources: Array<string>;
          priority: ActivityV1ActivityPriority;
          activityTime: string;
          createTime: string;
          updateTime: string;
          actor:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          creator:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          updater:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          labels: Array<{ key: string; value?: string | null }>;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type UpdateExclusivityGroupMutationVariables = Exact<{
  exclusivityGroup: PartialWorkflowV1ExclusivityGroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateExclusivityGroupMutation = {
  updateExclusivityGroup?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExclusivityGroup';
        description?: string | null;
        mode?: WorkflowV1ExclusivityGroupMode | null;
        name: string;
      }
    | null;
};

export type AllocateSegmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AllocateSegmentMutation = {
  allocateSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type AllocationFragment = {
  exclusiveTo: Array<string>;
  exclusivityTags: Array<string>;
  proportion?: { value?: string | null } | null;
};

export type ArchiveSegmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ArchiveSegmentMutation = {
  archiveSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type CreateSegmentMutationVariables = Exact<{
  segment: FlagsAdminV1SegmentInput;
}>;

export type CreateSegmentMutation = {
  createSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type OnSegmentCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnSegmentCreatedSubscription = {
  segmentCreated?: {
    segment?: {
      __typename: 'FlagsAdminV1Segment';
      name: string;
      displayName?: string | null;
      description?: string | null;
      state?: FlagsAdminV1SegmentState | null;
      createTime: string;
      updateTime: string;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1Flag'; name: string; displayName: string }
        | null;
      workflowInstance?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowInstance';
            name: string;
            displayName: string;
          }
        | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      allocation?: {
        exclusiveTo: Array<string>;
        exclusivityTags: Array<string>;
        proportion?: { value?: string | null } | null;
      } | null;
      targeting?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attributeName?: string | null;
              eqRule?: {
                value?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              startsWithRule?: { value?: string | null } | null;
              containsRule?: { value?: string | null } | null;
              endsWithRule?: { value?: string | null } | null;
              anyRule?: {
                rule?: {
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                } | null;
              } | null;
              allRule?: {
                rule?: {
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                } | null;
              } | null;
            } | null;
            segment?: {
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
            } | null;
            materializedSegment?: {
              materializedSegment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1MaterializedSegment';
                    name: string;
                    displayName: string;
                  }
                | null;
            } | null;
          } | null;
        }>;
        expression?: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            }>;
          } | null;
        } | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type OnSegmentUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnSegmentUpdatedSubscription = {
  segmentUpdated?: {
    segment?: {
      __typename: 'FlagsAdminV1Segment';
      name: string;
      displayName?: string | null;
      description?: string | null;
      state?: FlagsAdminV1SegmentState | null;
      createTime: string;
      updateTime: string;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1Flag'; name: string; displayName: string }
        | null;
      workflowInstance?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowInstance';
            name: string;
            displayName: string;
          }
        | null;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      allocation?: {
        exclusiveTo: Array<string>;
        exclusivityTags: Array<string>;
        proportion?: { value?: string | null } | null;
      } | null;
      targeting?: {
        criteria: Array<{
          key: string;
          value?: {
            attribute?: {
              attributeName?: string | null;
              eqRule?: {
                value?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              startsWithRule?: { value?: string | null } | null;
              containsRule?: { value?: string | null } | null;
              endsWithRule?: { value?: string | null } | null;
              anyRule?: {
                rule?: {
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                } | null;
              } | null;
              allRule?: {
                rule?: {
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                } | null;
              } | null;
            } | null;
            segment?: {
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
            } | null;
            materializedSegment?: {
              materializedSegment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1MaterializedSegment';
                    name: string;
                    displayName: string;
                  }
                | null;
            } | null;
          } | null;
        }>;
        expression?: {
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            }>;
          } | null;
        } | null;
      } | null;
      labels: Array<{ key: string; value?: string | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string; resource: string }>;
          }
        | null;
    } | null;
  } | null;
};

export type SegmentFragment = {
  __typename: 'FlagsAdminV1Segment';
  name: string;
  displayName?: string | null;
  description?: string | null;
  state?: FlagsAdminV1SegmentState | null;
  createTime: string;
  updateTime: string;
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'FlagsAdminV1Flag'; name: string; displayName: string }
    | null;
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        displayName: string;
      }
    | null;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  allocation?: {
    exclusiveTo: Array<string>;
    exclusivityTags: Array<string>;
    proportion?: { value?: string | null } | null;
  } | null;
  targeting?: {
    criteria: Array<{
      key: string;
      value?: {
        attribute?: {
          attributeName?: string | null;
          eqRule?: {
            value?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            } | null;
          } | null;
          setRule?: {
            values: Array<{
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            }>;
          } | null;
          rangeRule?: {
            startInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            } | null;
            startExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            } | null;
            endInclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            } | null;
            endExclusive?: {
              boolValue?: boolean | null;
              numberValue?: number | null;
              stringValue?: string | null;
              timestampValue?: string | null;
              versionValue?: { version?: string | null } | null;
            } | null;
          } | null;
          startsWithRule?: { value?: string | null } | null;
          containsRule?: { value?: string | null } | null;
          endsWithRule?: { value?: string | null } | null;
          anyRule?: {
            rule?: {
              eqRule?: {
                value?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              startsWithRule?: { value?: string | null } | null;
              containsRule?: { value?: string | null } | null;
              endsWithRule?: { value?: string | null } | null;
            } | null;
          } | null;
          allRule?: {
            rule?: {
              eqRule?: {
                value?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              setRule?: {
                values: Array<{
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                }>;
              } | null;
              rangeRule?: {
                startInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                startExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endInclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
                endExclusive?: {
                  boolValue?: boolean | null;
                  numberValue?: number | null;
                  stringValue?: string | null;
                  timestampValue?: string | null;
                  versionValue?: { version?: string | null } | null;
                } | null;
              } | null;
              startsWithRule?: { value?: string | null } | null;
              containsRule?: { value?: string | null } | null;
              endsWithRule?: { value?: string | null } | null;
            } | null;
          } | null;
        } | null;
        segment?: {
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                labels: Array<{ key: string; value?: string | null }>;
              }
            | null;
        } | null;
        materializedSegment?: {
          materializedSegment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1MaterializedSegment';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
      } | null;
    }>;
    expression?: {
      ref?: string | null;
      not?: { ref?: string | null } | null;
      and?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        }>;
      } | null;
      or?: {
        operands: Array<{
          ref?: string | null;
          not?: { ref?: string | null } | null;
          and?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
          or?: {
            operands: Array<{
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                }>;
              } | null;
            }>;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
  labels: Array<{ key: string; value?: string | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string; resource: string }>;
      }
    | null;
};

export type SegmentQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type SegmentQuery = {
  segment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type SegmentAvailableSpaceMutationVariables = Exact<{
  segment?: InputMaybe<Scalars['String']['input']>;
  queryParams?: InputMaybe<FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput>;
}>;

export type SegmentAvailableSpaceMutation = {
  segmentAvailableSpace?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1SegmentAvailableSpaceResponse';
        availableSpace?: { value?: string | null } | null;
        relatedSegments: Array<
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              workflowInstance?:
                | {
                    name: string;
                    displayName: string;
                    moduleData2: {
                      planning?: {
                        planned?: {
                          startTime?: string | null;
                          endTime?: string | null;
                        } | null;
                        actual?: {
                          startTime?: string | null;
                          endTime?: string | null;
                        } | null;
                      } | null;
                    };
                  }
                | Record<PropertyKey, never>
                | null;
            }
          | Record<PropertyKey, never>
        >;
      }
    | null;
};

export type SegmentRefFragment = {
  __typename: 'FlagsAdminV1Segment';
  name: string;
  displayName?: string | null;
};

export type SegmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type SegmentsQuery = {
  segments?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListSegmentsResponse';
        nextPageToken?: string | null;
        segments: Array<{
          __typename: 'FlagsAdminV1Segment';
          name: string;
          displayName?: string | null;
          description?: string | null;
          state?: FlagsAdminV1SegmentState | null;
          createTime: string;
          updateTime: string;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                displayName: string;
              }
            | null;
          workflowInstance?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          allocation?: {
            exclusiveTo: Array<string>;
            exclusivityTags: Array<string>;
            proportion?: { value?: string | null } | null;
          } | null;
          targeting?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attributeName?: string | null;
                  eqRule?: {
                    value?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      versionValue?: { version?: string | null } | null;
                    } | null;
                  } | null;
                  startsWithRule?: { value?: string | null } | null;
                  containsRule?: { value?: string | null } | null;
                  endsWithRule?: { value?: string | null } | null;
                  anyRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                  allRule?: {
                    rule?: {
                      eqRule?: {
                        value?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          versionValue?: { version?: string | null } | null;
                        } | null;
                      } | null;
                      startsWithRule?: { value?: string | null } | null;
                      containsRule?: { value?: string | null } | null;
                      endsWithRule?: { value?: string | null } | null;
                    } | null;
                  } | null;
                } | null;
                segment?: {
                  segment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Segment';
                        name: string;
                        displayName?: string | null;
                        labels: Array<{ key: string; value?: string | null }>;
                      }
                    | null;
                } | null;
                materializedSegment?: {
                  materializedSegment?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1MaterializedSegment';
                        name: string;
                        displayName: string;
                      }
                    | null;
                } | null;
              } | null;
            }>;
            expression?: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
        }>;
      }
    | null;
};

export type TargetingCriterionFragment = {
  attribute?: {
    attributeName?: string | null;
    eqRule?: {
      value?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      } | null;
    } | null;
    setRule?: {
      values: Array<{
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      }>;
    } | null;
    rangeRule?: {
      startInclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      } | null;
      startExclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      } | null;
      endInclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      } | null;
      endExclusive?: {
        boolValue?: boolean | null;
        numberValue?: number | null;
        stringValue?: string | null;
        timestampValue?: string | null;
        versionValue?: { version?: string | null } | null;
      } | null;
    } | null;
    startsWithRule?: { value?: string | null } | null;
    containsRule?: { value?: string | null } | null;
    endsWithRule?: { value?: string | null } | null;
    anyRule?: {
      rule?: {
        eqRule?: {
          value?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        setRule?: {
          values: Array<{
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          }>;
        } | null;
        rangeRule?: {
          startInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          startExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        startsWithRule?: { value?: string | null } | null;
        containsRule?: { value?: string | null } | null;
        endsWithRule?: { value?: string | null } | null;
      } | null;
    } | null;
    allRule?: {
      rule?: {
        eqRule?: {
          value?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        setRule?: {
          values: Array<{
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          }>;
        } | null;
        rangeRule?: {
          startInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          startExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        startsWithRule?: { value?: string | null } | null;
        containsRule?: { value?: string | null } | null;
        endsWithRule?: { value?: string | null } | null;
      } | null;
    } | null;
  } | null;
  segment?: {
    segment?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FlagsAdminV1Segment';
          name: string;
          displayName?: string | null;
          labels: Array<{ key: string; value?: string | null }>;
        }
      | null;
  } | null;
  materializedSegment?: {
    materializedSegment?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'FlagsAdminV1MaterializedSegment';
          name: string;
          displayName: string;
        }
      | null;
  } | null;
};

export type TargetingFragment = {
  criteria: Array<{
    key: string;
    value?: {
      attribute?: {
        attributeName?: string | null;
        eqRule?: {
          value?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        setRule?: {
          values: Array<{
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          }>;
        } | null;
        rangeRule?: {
          startInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          startExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endInclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
          endExclusive?: {
            boolValue?: boolean | null;
            numberValue?: number | null;
            stringValue?: string | null;
            timestampValue?: string | null;
            versionValue?: { version?: string | null } | null;
          } | null;
        } | null;
        startsWithRule?: { value?: string | null } | null;
        containsRule?: { value?: string | null } | null;
        endsWithRule?: { value?: string | null } | null;
        anyRule?: {
          rule?: {
            eqRule?: {
              value?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
            } | null;
            setRule?: {
              values: Array<{
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              }>;
            } | null;
            rangeRule?: {
              startInclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              startExclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              endInclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              endExclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
            } | null;
            startsWithRule?: { value?: string | null } | null;
            containsRule?: { value?: string | null } | null;
            endsWithRule?: { value?: string | null } | null;
          } | null;
        } | null;
        allRule?: {
          rule?: {
            eqRule?: {
              value?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
            } | null;
            setRule?: {
              values: Array<{
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              }>;
            } | null;
            rangeRule?: {
              startInclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              startExclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              endInclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
              endExclusive?: {
                boolValue?: boolean | null;
                numberValue?: number | null;
                stringValue?: string | null;
                timestampValue?: string | null;
                versionValue?: { version?: string | null } | null;
              } | null;
            } | null;
            startsWithRule?: { value?: string | null } | null;
            containsRule?: { value?: string | null } | null;
            endsWithRule?: { value?: string | null } | null;
          } | null;
        } | null;
      } | null;
      segment?: {
        segment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Segment';
              name: string;
              displayName?: string | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
      } | null;
      materializedSegment?: {
        materializedSegment?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1MaterializedSegment';
              name: string;
              displayName: string;
            }
          | null;
      } | null;
    } | null;
  }>;
  expression?: {
    ref?: string | null;
    not?: { ref?: string | null } | null;
    and?: {
      operands: Array<{
        ref?: string | null;
        not?: { ref?: string | null } | null;
        and?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
          }>;
        } | null;
        or?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
    or?: {
      operands: Array<{
        ref?: string | null;
        not?: { ref?: string | null } | null;
        and?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
          }>;
        } | null;
        or?: {
          operands: Array<{
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
  } | null;
};

export type ValueFragment = {
  boolValue?: boolean | null;
  numberValue?: number | null;
  stringValue?: string | null;
  timestampValue?: string | null;
  versionValue?: { version?: string | null } | null;
};

export type SetRuleFragment = {
  values: Array<{
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  }>;
};

export type RangeRuleFragment = {
  startInclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  } | null;
  startExclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  } | null;
  endInclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  } | null;
  endExclusive?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  } | null;
};

export type EqRuleFragment = {
  value?: {
    boolValue?: boolean | null;
    numberValue?: number | null;
    stringValue?: string | null;
    timestampValue?: string | null;
    versionValue?: { version?: string | null } | null;
  } | null;
};

export type InnerRuleInputFragment = {
  eqRule?: {
    value?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    } | null;
  } | null;
  setRule?: {
    values: Array<{
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    }>;
  } | null;
  rangeRule?: {
    startInclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    } | null;
    startExclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    } | null;
    endInclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    } | null;
    endExclusive?: {
      boolValue?: boolean | null;
      numberValue?: number | null;
      stringValue?: string | null;
      timestampValue?: string | null;
      versionValue?: { version?: string | null } | null;
    } | null;
  } | null;
  startsWithRule?: { value?: string | null } | null;
  containsRule?: { value?: string | null } | null;
  endsWithRule?: { value?: string | null } | null;
};

export type StartsWithRuleFragment = { value?: string | null };

export type ContainsRuleFragment = { value?: string | null };

export type EndsWithRuleFragment = { value?: string | null };

export type UpdateSegmentMutationVariables = Exact<{
  input: PartialFlagsAdminV1SegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSegmentMutation = {
  updateSegment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
};

export type AaTestOnboardingFragment = {
  displayName: string;
  state: string;
  name: string;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | Record<PropertyKey, never>
    | null;
  moduleData2: {
    abtest?: { treatments?: Array<{ name?: string | null }> | null } | null;
    flags?: {
      targetingKeySelector?: string | null;
      segment?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1Segment'; name: string }
        | null;
    } | null;
    metrics?: {
      metrics: Array<{ __typename: 'MetricsDataMetric' }>;
      entity?:
        | { __typename: 'Error' }
        | { __typename: 'MetricsV1Entity'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
  };
};

export type AaTestOnboardingQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type AaTestOnboardingQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          displayName: string;
          state: string;
          name: string;
          createTime: string;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          moduleData2: {
            abtest?: {
              treatments?: Array<{ name?: string | null }> | null;
            } | null;
            flags?: {
              targetingKeySelector?: string | null;
              segment?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1Segment'; name: string }
                | null;
            } | null;
            metrics?: {
              metrics: Array<{ __typename: 'MetricsDataMetric' }>;
              entity?:
                | { __typename: 'Error' }
                | { __typename: 'MetricsV1Entity'; name: string }
                | null;
            } | null;
            hypothesis?: { text?: string | null } | null;
          };
        }>;
      }
    | null;
};

export type AbTestFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        nextPageToken?: string | null;
        comments: Array<{
          __typename: 'CollaborationV1Comment';
          name: string;
          resource: string;
          createTime: string;
          updateTime: string;
          content: string;
          resolved?: boolean | null;
          author:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>;
          assignee?:
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | Record<PropertyKey, never>
            | null;
          anchor?: { zone?: { zone: string } | null } | null;
          queryReactionSummary?:
            | {
                __typename: 'CollaborationV1QueryReactionSummaryResponse';
                summary: {
                  name: string;
                  commentCount: number;
                  emojiReactions: Array<{
                    key: string;
                    value?: {
                      emoji?: string | null;
                      reactionCount?: number | null;
                      identities: Array<
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                      >;
                    } | null;
                  }>;
                };
              }
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  moduleData2: {
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type AbTestQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AbTestQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        comments?:
          | {
              __typename: 'CollaborationV1ListCommentsResponse';
              nextPageToken?: string | null;
              comments: Array<{
                __typename: 'CollaborationV1Comment';
                name: string;
                resource: string;
                createTime: string;
                updateTime: string;
                content: string;
                resolved?: boolean | null;
                author:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>;
                assignee?:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                anchor?: { zone?: { zone: string } | null } | null;
                queryReactionSummary?:
                  | {
                      __typename: 'CollaborationV1QueryReactionSummaryResponse';
                      summary: {
                        name: string;
                        commentCount: number;
                        emojiReactions: Array<{
                          key: string;
                          value?: {
                            emoji?: string | null;
                            reactionCount?: number | null;
                            identities: Array<
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                            >;
                          } | null;
                        }>;
                      };
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type AbTestDataFragment = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        variants: Array<{
          description?: string | null;
          name: string;
          imageUri?: string | null;
        }>;
      }
    | null;
  treatments?: Array<{
    name?: string | null;
    weight: any;
    displayName?: string | null;
    description?: string | null;
    imageUri?: string | null;
    variant:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
  }> | null;
  rollout?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
    | null;
};

export type AbTestListItemFragment = {
  displayName: string;
  state: string;
  name: string;
  createTime: string;
  updateTime: string;
  stateHistory: Array<{ state?: string | null }>;
  moduleData2: {
    decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | Record<PropertyKey, never>
    | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        comments: Array<{
          name: string;
          resolved?: boolean | null;
          assignee?:
            | { __typename: 'Error' }
            | { __typename: 'IamV1Identity'; name: string }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  moduleData: Array<{ value?: any | null; key: string }>;
};

export type AbTestTreatmentFragment = {
  name?: string | null;
  weight: any;
  displayName?: string | null;
  description?: string | null;
  imageUri?: string | null;
  variant:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
};

export type AbTestsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type AbTestsQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          displayName: string;
          state: string;
          name: string;
          createTime: string;
          updateTime: string;
          stateHistory: Array<{ state?: string | null }>;
          moduleData2: {
            decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            rollout?: {
              variantImageUri?: string | null;
              reach?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
                steps: Array<{
                  durationSincePreviousStep: string;
                  reach: string;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                  updateTime?: string | null;
                }>;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
          };
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | Record<PropertyKey, never>
            | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          comments?:
            | {
                __typename: 'CollaborationV1ListCommentsResponse';
                comments: Array<{
                  name: string;
                  resolved?: boolean | null;
                  assignee?:
                    | { __typename: 'Error' }
                    | { __typename: 'IamV1Identity'; name: string }
                    | null;
                }>;
              }
            | { __typename: 'Error' }
            | null;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          moduleData: Array<{ value?: any | null; key: string }>;
        }>;
      }
    | null;
};

export type AssignmentUsageQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type AssignmentUsageQuery = {
  rule?:
    | { __typename: 'Error' }
    | {
        __typename: 'FlagsAdminV1FlagRule';
        name: string;
        usageMetadata: {
          assignmentUsageMetadata: Array<{
            applyCount?: any | null;
            resolveCount?: any | null;
            assignmentId?: string | null;
            lastApplyTime?: string | null;
          }>;
        };
      }
    | null;
};

export type CreateAbTestMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  input: WorkflowV1WorkflowInstanceInput;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateAbTestMutation = {
  createWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        comments?:
          | {
              __typename: 'CollaborationV1ListCommentsResponse';
              nextPageToken?: string | null;
              comments: Array<{
                __typename: 'CollaborationV1Comment';
                name: string;
                resource: string;
                createTime: string;
                updateTime: string;
                content: string;
                resolved?: boolean | null;
                author:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>;
                assignee?:
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                anchor?: { zone?: { zone: string } | null } | null;
                queryReactionSummary?:
                  | {
                      __typename: 'CollaborationV1QueryReactionSummaryResponse';
                      summary: {
                        name: string;
                        commentCount: number;
                        emojiReactions: Array<{
                          key: string;
                          value?: {
                            emoji?: string | null;
                            reactionCount?: number | null;
                            identities: Array<
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                            >;
                          } | null;
                        }>;
                      };
                    }
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | null;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type GetFlagVariantsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetFlagVariantsQuery = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        variants: Array<{
          description?: string | null;
          name: string;
          imageUri?: string | null;
        }>;
      }
    | null;
};

export type OnAbTestCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAbTestCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      comments?:
        | {
            __typename: 'CollaborationV1ListCommentsResponse';
            nextPageToken?: string | null;
            comments: Array<{
              __typename: 'CollaborationV1Comment';
              name: string;
              resource: string;
              createTime: string;
              updateTime: string;
              content: string;
              resolved?: boolean | null;
              author:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>;
              assignee?:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>
                | null;
              anchor?: { zone?: { zone: string } | null } | null;
              queryReactionSummary?:
                | {
                    __typename: 'CollaborationV1QueryReactionSummaryResponse';
                    summary: {
                      name: string;
                      commentCount: number;
                      emojiReactions: Array<{
                        key: string;
                        value?: {
                          emoji?: string | null;
                          reactionCount?: number | null;
                          identities: Array<
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                          >;
                        } | null;
                      }>;
                    };
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnAbTestUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAbTestUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      comments?:
        | {
            __typename: 'CollaborationV1ListCommentsResponse';
            nextPageToken?: string | null;
            comments: Array<{
              __typename: 'CollaborationV1Comment';
              name: string;
              resource: string;
              createTime: string;
              updateTime: string;
              content: string;
              resolved?: boolean | null;
              author:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>;
              assignee?:
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | Record<PropertyKey, never>
                | null;
              anchor?: { zone?: { zone: string } | null } | null;
              queryReactionSummary?:
                | {
                    __typename: 'CollaborationV1QueryReactionSummaryResponse';
                    summary: {
                      name: string;
                      commentCount: number;
                      emojiReactions: Array<{
                        key: string;
                        value?: {
                          emoji?: string | null;
                          reactionCount?: number | null;
                          identities: Array<
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                          >;
                        } | null;
                      }>;
                    };
                  }
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | null;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateAbTestDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateAbTestDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
        };
      }
    | null;
};

export type DecisionDataFragment = {
  outcome?: DecisionRecordDataOutcome | null;
  conclusion?: string | null;
  treatment?: string | null;
};

export type UpdateDecisionDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateDecisionDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
        };
      }
    | null;
};

export type AddExploratoryAnalysisMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type AddExploratoryAnalysisMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
          };
        };
      }
    | null;
};

export type DeleteExploratoryAnalysisMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type DeleteExploratoryAnalysisMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
          };
        };
      }
    | null;
};

export type DimensionTablePickerOptionsQueryVariables = Exact<{
  dimensionTableFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type DimensionTablePickerOptionsQuery = {
  dimensionTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListDimensionTablesResponse';
        dimensionTables: Array<{
          name: string;
          dimensions: Array<{
            name: string;
            type?: MetricsV1ColumnType | null;
          }>;
          entityColumnMapping: {
            entity:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1Entity'; name: string };
          };
        }>;
      }
    | null;
};

export type EditExploratoryAnalysisMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type EditExploratoryAnalysisMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
          };
        };
      }
    | null;
};

export type ExploratoryAnalysisFragment = {
  createTime: string;
  updateTime: string;
  id: string;
  messages: Array<string>;
  name: string;
  splitByExposureFilters?: boolean | null;
  startTime?: string | null;
  endTime?: string | null;
  useCustomDateRange?: boolean | null;
  state: ExploreDataAnalysisState;
  useScheduledCalculation?: boolean | null;
  analysisResults?: Array<{
    exposureFilterName?: string | null;
    analysisResult:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'StatsV2AnalysisAnalysisResult';
          name: string;
          exposureFilter?: string | null;
          updateTime: string;
          annotations: Array<{
            context: Array<{
              key?: StatsV2AnalysisStatsAnnotationContext | null;
              value?: string | null;
            }>;
          }>;
          results: Array<{
            id?: string | null;
            annotations: Array<{
              info?: string | null;
              warning?: string | null;
              context: Array<{
                key?: StatsV2AnalysisStatsAnnotationContext | null;
                value?: string | null;
              }>;
              error?: {
                category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                details?: string | null;
              } | null;
            }>;
            metricDetails?: {
              direction?: StatsV2AnalysisMetricDirection | null;
              hasRun?: boolean | null;
              metricType?: StatsV2AnalysisMetricType | null;
              plannedEffectSize?: { value?: string | null } | null;
            } | null;
            result: Array<{
              comparisonId?: string | null;
              isSignificant?: boolean | null;
              usedDataType?: StatsV2AnalysisStatsDataType | null;
              segmentId?: string | null;
              dimensions: Array<{ value?: string | null; key: string }>;
              groupStats: Array<{
                sampleSize?: any | null;
                id?: string | null;
              }>;
              groups?: {
                baseline?: string | null;
                compared?: string | null;
              } | null;
              lastDeteriorationResult?: {
                baselineEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                baselineSampleSize?: any | null;
                comparedEstimateAbs?: number | null;
                comparedEstimateRel?: number | null;
                comparedSampleSize?: any | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  isSignificant?: boolean | null;
                  lower?: number | null;
                  powered?: number | null;
                  upper?: number | null;
                } | null;
              } | null;
              lastResult?: {
                baselineEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                baselineSampleSize?: any | null;
                comparedEstimateAbs?: number | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
                differenceEstimateRel?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
              } | null;
              status?: {
                status?: StatsV2AnalysisMetricResultStatus | null;
                message?: string | null;
                metricType?: StatsV2AnalysisMetricType | null;
                decisionPowered?: boolean | null;
                decisionIsSignificant?: boolean | null;
                validationIsSignificant?: boolean | null;
              } | null;
              result: Array<{
                resultTime?: string | null;
                baselineEstimateAbs?: number | null;
                comparedEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                comparedEstimateRel?: number | null;
                varianceReductionRate?: number | null;
                unadjustedEstimateBaseline?: number | null;
                unadjustedEstimateCompared?: number | null;
                baselineSampleSize?: any | null;
                comparedSampleSize?: any | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
                differenceEstimateRel?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
              }>;
              sampleSize?: {
                current?: any | null;
                required?: any | null;
                poweredEffectRel?: number | null;
                poweredEffectAbs?: number | null;
              } | null;
            }>;
            srmResult: Array<{
              isSignificant?: boolean | null;
              segmentId?: string | null;
              status?: {
                status?: StatsV2AnalysisMetricResultStatus | null;
                message?: string | null;
                metricType?: StatsV2AnalysisMetricType | null;
                decisionPowered?: boolean | null;
                decisionIsSignificant?: boolean | null;
                validationIsSignificant?: boolean | null;
              } | null;
              dimensions: Array<{ key: string; value?: string | null }>;
              result: Array<{
                group?: string | null;
                observed?: number | null;
                expected?: number | null;
                isSignificant?: boolean | null;
              }>;
            }>;
            statsSettings?: {
              method?: StatsV2AnalysisMethod | null;
              adjustedAlpha?: number | null;
              adjustedBeta?: number | null;
              hasVarianceReduction?: boolean | null;
            } | null;
          }>;
          treatments: Array<{
            id?: string | null;
            recommendation?: {
              shipping?: StatsV2AnalysisShippingRecommendation | null;
              status?: {
                quality?: StatsV2AnalysisQualityStatus | null;
                tanking?: StatsV2AnalysisTankingStatus | null;
                guardrail?: StatsV2AnalysisGuardrailStatus | null;
                success?: StatsV2AnalysisSuccessStatus | null;
              } | null;
            } | null;
          }>;
        };
  }> | null;
  conclusion?: { updateTime: string; text: string } | null;
  metrics: Array<{
    calculationError?: string | null;
    name:
      | {
          name: string;
          displayName: string;
          description?: string | null;
          factTable?:
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                description?: string | null;
                sql: string;
                state: MetricsV1TableState;
                factDataDeliveredUntilTime?: string | null;
                timestampColumn: { name: string };
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      displayName: string;
                      name: string;
                      everyone?: boolean | null;
                      user?:
                        | { pictureUri?: string | null; name: string }
                        | Record<PropertyKey, never>
                        | null;
                      group?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      apiClient?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | null;
                entities: Array<{
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                  column: { name: string };
                }>;
                measures: Array<{
                  declaredType?: MetricsV1ColumnType | null;
                  column: { name: string };
                  unit?: {
                    baseUnitMultiplier?: number | null;
                    baseUnit?: MetricsV1UnitBaseUnit | null;
                    currencyCode?: string | null;
                    customUnit?: string | null;
                  } | null;
                }>;
                dimensions: Array<{ name: string }>;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                error?: {
                  details: Array<string>;
                  message?: string | null;
                } | null;
                schemaValidationJob:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1SqlJob';
                      name: string;
                      successfulQueryResult?: {
                        schema: Array<{
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        }>;
                      } | null;
                    };
                source?: {
                  type?: MetricsV1MetricMetricSourceType | null;
                  reference?: string | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
          entity?:
            | {
                __typename: 'MetricsV1Entity';
                createTime: string;
                name: string;
                displayName: string;
                primaryKeyType: MetricsV1ColumnType;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                defaultAssignmentTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | null;
              }
            | Record<PropertyKey, never>
            | null;
        }
      | Record<PropertyKey, never>;
    dimensions: Array<
      | {
          column: string;
          dimensionTable?:
            | {
                __typename: 'MetricsV1DimensionTable';
                name: string;
                displayName: string;
                description?: string | null;
                state: MetricsV1TableState;
                dimensionDataDeliveredUntilTime?: string | null;
                sql: string;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                entityColumnMapping: {
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        createTime: string;
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                        labels: Array<{ key: string; value?: string | null }>;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{ relation: string }>;
                            }
                          | null;
                        defaultAssignmentTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | null;
                      };
                  column: { name: string };
                };
                dimensions: Array<{ name: string }>;
                labels: Array<{ key: string; value?: string | null }>;
                error?: {
                  details: Array<string>;
                  message?: string | null;
                } | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
                timeConfig?: {
                  window: string;
                  timestampColumn: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  };
                } | null;
                valueMappings: Array<{
                  column: string;
                  mappings: Array<{
                    inputDimensionValue?: string | null;
                    outputDimensionValue?: string | null;
                  }>;
                }>;
              }
            | Record<PropertyKey, never>
            | null;
        }
      | {
          column: string;
          factTable:
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                description?: string | null;
                sql: string;
                state: MetricsV1TableState;
                factDataDeliveredUntilTime?: string | null;
                timestampColumn: { name: string };
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      displayName: string;
                      name: string;
                      everyone?: boolean | null;
                      user?:
                        | { pictureUri?: string | null; name: string }
                        | Record<PropertyKey, never>
                        | null;
                      group?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      apiClient?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | null;
                entities: Array<{
                  entity:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      };
                  column: { name: string };
                }>;
                measures: Array<{
                  declaredType?: MetricsV1ColumnType | null;
                  column: { name: string };
                  unit?: {
                    baseUnitMultiplier?: number | null;
                    baseUnit?: MetricsV1UnitBaseUnit | null;
                    currencyCode?: string | null;
                    customUnit?: string | null;
                  } | null;
                }>;
                dimensions: Array<{ name: string }>;
                dataDeliveredUntilUpdateStrategyConfig?: {
                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                  disableEmptyPartitions?: boolean | null;
                  automaticUpdateConfig?: {
                    commitDelay: string;
                    changeThreshold?: { value?: string | null } | null;
                  } | null;
                  dailyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                  hourlyUpdateConfig?: {
                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                    maxZeroDuration?: string | null;
                  } | null;
                } | null;
                error?: {
                  details: Array<string>;
                  message?: string | null;
                } | null;
                schemaValidationJob:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1SqlJob';
                      name: string;
                      successfulQueryResult?: {
                        schema: Array<{
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        }>;
                      } | null;
                    };
                source?: {
                  type?: MetricsV1MetricMetricSourceType | null;
                  reference?: string | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | Record<PropertyKey, never>;
        }
    >;
    calculation?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1MetricCalculation';
          name: string;
          state?: MetricsV1MetricCalculationState | null;
        }
      | null;
    scheduledCalculation?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1ScheduledMetricCalculation';
          name: string;
          state?: MetricsV1ScheduledMetricCalculationState | null;
          status: {
            scheduled?: { nextScheduleTime: string } | null;
            cancelled?: { cancelledTime: string } | null;
            calculating?: {
              metricCalculation: { name: string } | Record<PropertyKey, never>;
            } | null;
            waiting?: {
              dataDeliveredUntilTime?: string | null;
              needDataUntilTime: string;
              exposureTable?:
                | { name: string }
                | Record<PropertyKey, never>
                | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>
                | null;
            } | null;
            error?: { errorMessage: string } | null;
          };
        }
      | null;
  }>;
  createdBy?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        name: string;
        fullName: string;
        email: string;
        pictureUri?: string | null;
        lastLoginTime?: string | null;
      }
    | null;
};

export type ExploratoryAnalysisFunctionResponseFragment = {
  __typename: 'WorkflowV1ExecuteFunctionResponse';
  response?: any | null;
  instance: {
    name: string;
    moduleData: Array<{ key: string; value?: any | null }>;
    moduleData2: {
      explore?: {
        exploratoryAnalyses: Array<{
          createTime: string;
          updateTime: string;
          id: string;
          messages: Array<string>;
          name: string;
          splitByExposureFilters?: boolean | null;
          startTime?: string | null;
          endTime?: string | null;
          useCustomDateRange?: boolean | null;
          state: ExploreDataAnalysisState;
          useScheduledCalculation?: boolean | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          conclusion?: { updateTime: string; text: string } | null;
          metrics: Array<{
            calculationError?: string | null;
            name:
              | {
                  name: string;
                  displayName: string;
                  description?: string | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        description?: string | null;
                        sql: string;
                        state: MetricsV1TableState;
                        factDataDeliveredUntilTime?: string | null;
                        timestampColumn: { name: string };
                        owner?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              displayName: string;
                              name: string;
                              everyone?: boolean | null;
                              user?:
                                | { pictureUri?: string | null; name: string }
                                | Record<PropertyKey, never>
                                | null;
                              group?:
                                | { name: string }
                                | Record<PropertyKey, never>
                                | null;
                              apiClient?:
                                | { name: string }
                                | Record<PropertyKey, never>
                                | null;
                            }
                          | null;
                        entities: Array<{
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          column: { name: string };
                        }>;
                        measures: Array<{
                          declaredType?: MetricsV1ColumnType | null;
                          column: { name: string };
                          unit?: {
                            baseUnitMultiplier?: number | null;
                            baseUnit?: MetricsV1UnitBaseUnit | null;
                            currencyCode?: string | null;
                            customUnit?: string | null;
                          } | null;
                        }>;
                        dimensions: Array<{ name: string }>;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                        error?: {
                          details: Array<string>;
                          message?: string | null;
                        } | null;
                        schemaValidationJob:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1SqlJob';
                              name: string;
                              successfulQueryResult?: {
                                schema: Array<{
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                }>;
                              } | null;
                            };
                        source?: {
                          type?: MetricsV1MetricMetricSourceType | null;
                          reference?: string | null;
                        } | null;
                        labels: Array<{ key: string; value?: string | null }>;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{ relation: string }>;
                            }
                          | null;
                      }
                    | Record<PropertyKey, never>
                    | null;
                  entity?:
                    | {
                        __typename: 'MetricsV1Entity';
                        createTime: string;
                        name: string;
                        displayName: string;
                        primaryKeyType: MetricsV1ColumnType;
                        labels: Array<{ key: string; value?: string | null }>;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{ relation: string }>;
                            }
                          | null;
                        defaultAssignmentTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | null;
                      }
                    | Record<PropertyKey, never>
                    | null;
                }
              | Record<PropertyKey, never>;
            dimensions: Array<
              | {
                  column: string;
                  dimensionTable?:
                    | {
                        __typename: 'MetricsV1DimensionTable';
                        name: string;
                        displayName: string;
                        description?: string | null;
                        state: MetricsV1TableState;
                        dimensionDataDeliveredUntilTime?: string | null;
                        sql: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                        owner?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                            }
                          | null;
                        entityColumnMapping: {
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                createTime: string;
                                name: string;
                                displayName: string;
                                primaryKeyType: MetricsV1ColumnType;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                                resourceRelations?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'FgaV1ListResourceRelationsResponse';
                                      resourceRelations: Array<{
                                        relation: string;
                                      }>;
                                    }
                                  | null;
                                defaultAssignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      name: string;
                                      displayName: string;
                                      state: MetricsV1TableState;
                                    }
                                  | null;
                              };
                          column: { name: string };
                        };
                        dimensions: Array<{ name: string }>;
                        labels: Array<{ key: string; value?: string | null }>;
                        error?: {
                          details: Array<string>;
                          message?: string | null;
                        } | null;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{ relation: string }>;
                            }
                          | null;
                        timeConfig?: {
                          window: string;
                          timestampColumn: {
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          };
                        } | null;
                        valueMappings: Array<{
                          column: string;
                          mappings: Array<{
                            inputDimensionValue?: string | null;
                            outputDimensionValue?: string | null;
                          }>;
                        }>;
                      }
                    | Record<PropertyKey, never>
                    | null;
                }
              | {
                  column: string;
                  factTable:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        description?: string | null;
                        sql: string;
                        state: MetricsV1TableState;
                        factDataDeliveredUntilTime?: string | null;
                        timestampColumn: { name: string };
                        owner?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              displayName: string;
                              name: string;
                              everyone?: boolean | null;
                              user?:
                                | { pictureUri?: string | null; name: string }
                                | Record<PropertyKey, never>
                                | null;
                              group?:
                                | { name: string }
                                | Record<PropertyKey, never>
                                | null;
                              apiClient?:
                                | { name: string }
                                | Record<PropertyKey, never>
                                | null;
                            }
                          | null;
                        entities: Array<{
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          column: { name: string };
                        }>;
                        measures: Array<{
                          declaredType?: MetricsV1ColumnType | null;
                          column: { name: string };
                          unit?: {
                            baseUnitMultiplier?: number | null;
                            baseUnit?: MetricsV1UnitBaseUnit | null;
                            currencyCode?: string | null;
                            customUnit?: string | null;
                          } | null;
                        }>;
                        dimensions: Array<{ name: string }>;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                        error?: {
                          details: Array<string>;
                          message?: string | null;
                        } | null;
                        schemaValidationJob:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1SqlJob';
                              name: string;
                              successfulQueryResult?: {
                                schema: Array<{
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                }>;
                              } | null;
                            };
                        source?: {
                          type?: MetricsV1MetricMetricSourceType | null;
                          reference?: string | null;
                        } | null;
                        labels: Array<{ key: string; value?: string | null }>;
                        resourceRelations?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FgaV1ListResourceRelationsResponse';
                              resourceRelations: Array<{ relation: string }>;
                            }
                          | null;
                      }
                    | Record<PropertyKey, never>;
                }
            >;
            calculation?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            scheduledCalculation?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                }
              | null;
          }>;
          createdBy?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
        }>;
      } | null;
    };
  };
};

export type ExploreDataFragment = {
  exploratoryAnalyses: Array<{
    createTime: string;
    updateTime: string;
    id: string;
    messages: Array<string>;
    name: string;
    splitByExposureFilters?: boolean | null;
    startTime?: string | null;
    endTime?: string | null;
    useCustomDateRange?: boolean | null;
    state: ExploreDataAnalysisState;
    useScheduledCalculation?: boolean | null;
    analysisResults?: Array<{
      exposureFilterName?: string | null;
      analysisResult:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'StatsV2AnalysisAnalysisResult';
            name: string;
            exposureFilter?: string | null;
            updateTime: string;
            annotations: Array<{
              context: Array<{
                key?: StatsV2AnalysisStatsAnnotationContext | null;
                value?: string | null;
              }>;
            }>;
            results: Array<{
              id?: string | null;
              annotations: Array<{
                info?: string | null;
                warning?: string | null;
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
                error?: {
                  category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                  details?: string | null;
                } | null;
              }>;
              metricDetails?: {
                direction?: StatsV2AnalysisMetricDirection | null;
                hasRun?: boolean | null;
                metricType?: StatsV2AnalysisMetricType | null;
                plannedEffectSize?: { value?: string | null } | null;
              } | null;
              result: Array<{
                comparisonId?: string | null;
                isSignificant?: boolean | null;
                usedDataType?: StatsV2AnalysisStatsDataType | null;
                segmentId?: string | null;
                dimensions: Array<{ value?: string | null; key: string }>;
                groupStats: Array<{
                  sampleSize?: any | null;
                  id?: string | null;
                }>;
                groups?: {
                  baseline?: string | null;
                  compared?: string | null;
                } | null;
                lastDeteriorationResult?: {
                  baselineEstimateAbs?: number | null;
                  baselineEstimateRel?: number | null;
                  baselineSampleSize?: any | null;
                  comparedEstimateAbs?: number | null;
                  comparedEstimateRel?: number | null;
                  comparedSampleSize?: any | null;
                  differenceEstimateAbs?: {
                    estimate?: number | null;
                    isSignificant?: boolean | null;
                    lower?: number | null;
                    powered?: number | null;
                    upper?: number | null;
                  } | null;
                } | null;
                lastResult?: {
                  baselineEstimateAbs?: number | null;
                  baselineEstimateRel?: number | null;
                  baselineSampleSize?: any | null;
                  comparedEstimateAbs?: number | null;
                  differenceEstimateAbs?: {
                    estimate?: number | null;
                    lower?: number | null;
                    upper?: number | null;
                    isSignificant?: boolean | null;
                  } | null;
                  differenceEstimateRel?: {
                    estimate?: number | null;
                    lower?: number | null;
                    upper?: number | null;
                    isSignificant?: boolean | null;
                  } | null;
                } | null;
                status?: {
                  status?: StatsV2AnalysisMetricResultStatus | null;
                  message?: string | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  decisionPowered?: boolean | null;
                  decisionIsSignificant?: boolean | null;
                  validationIsSignificant?: boolean | null;
                } | null;
                result: Array<{
                  resultTime?: string | null;
                  baselineEstimateAbs?: number | null;
                  comparedEstimateAbs?: number | null;
                  baselineEstimateRel?: number | null;
                  comparedEstimateRel?: number | null;
                  varianceReductionRate?: number | null;
                  unadjustedEstimateBaseline?: number | null;
                  unadjustedEstimateCompared?: number | null;
                  baselineSampleSize?: any | null;
                  comparedSampleSize?: any | null;
                  differenceEstimateAbs?: {
                    estimate?: number | null;
                    lower?: number | null;
                    upper?: number | null;
                    isSignificant?: boolean | null;
                  } | null;
                  differenceEstimateRel?: {
                    estimate?: number | null;
                    lower?: number | null;
                    upper?: number | null;
                    isSignificant?: boolean | null;
                  } | null;
                }>;
                sampleSize?: {
                  current?: any | null;
                  required?: any | null;
                  poweredEffectRel?: number | null;
                  poweredEffectAbs?: number | null;
                } | null;
              }>;
              srmResult: Array<{
                isSignificant?: boolean | null;
                segmentId?: string | null;
                status?: {
                  status?: StatsV2AnalysisMetricResultStatus | null;
                  message?: string | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  decisionPowered?: boolean | null;
                  decisionIsSignificant?: boolean | null;
                  validationIsSignificant?: boolean | null;
                } | null;
                dimensions: Array<{ key: string; value?: string | null }>;
                result: Array<{
                  group?: string | null;
                  observed?: number | null;
                  expected?: number | null;
                  isSignificant?: boolean | null;
                }>;
              }>;
              statsSettings?: {
                method?: StatsV2AnalysisMethod | null;
                adjustedAlpha?: number | null;
                adjustedBeta?: number | null;
                hasVarianceReduction?: boolean | null;
              } | null;
            }>;
            treatments: Array<{
              id?: string | null;
              recommendation?: {
                shipping?: StatsV2AnalysisShippingRecommendation | null;
                status?: {
                  quality?: StatsV2AnalysisQualityStatus | null;
                  tanking?: StatsV2AnalysisTankingStatus | null;
                  guardrail?: StatsV2AnalysisGuardrailStatus | null;
                  success?: StatsV2AnalysisSuccessStatus | null;
                } | null;
              } | null;
            }>;
          };
    }> | null;
    conclusion?: { updateTime: string; text: string } | null;
    metrics: Array<{
      calculationError?: string | null;
      name:
        | {
            name: string;
            displayName: string;
            description?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  sql: string;
                  state: MetricsV1TableState;
                  factDataDeliveredUntilTime?: string | null;
                  timestampColumn: { name: string };
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  entities: Array<{
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    column: { name: string };
                  }>;
                  measures: Array<{
                    declaredType?: MetricsV1ColumnType | null;
                    column: { name: string };
                    unit?: {
                      baseUnitMultiplier?: number | null;
                      baseUnit?: MetricsV1UnitBaseUnit | null;
                      currencyCode?: string | null;
                      customUnit?: string | null;
                    } | null;
                  }>;
                  dimensions: Array<{ name: string }>;
                  dataDeliveredUntilUpdateStrategyConfig?: {
                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                    disableEmptyPartitions?: boolean | null;
                    automaticUpdateConfig?: {
                      commitDelay: string;
                      changeThreshold?: { value?: string | null } | null;
                    } | null;
                    dailyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                    hourlyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                  } | null;
                  error?: {
                    details: Array<string>;
                    message?: string | null;
                  } | null;
                  schemaValidationJob:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1SqlJob';
                        name: string;
                        successfulQueryResult?: {
                          schema: Array<{
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          }>;
                        } | null;
                      };
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | Record<PropertyKey, never>
              | null;
            entity?:
              | {
                  __typename: 'MetricsV1Entity';
                  createTime: string;
                  name: string;
                  displayName: string;
                  primaryKeyType: MetricsV1ColumnType;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                  defaultAssignmentTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                }
              | Record<PropertyKey, never>
              | null;
          }
        | Record<PropertyKey, never>;
      dimensions: Array<
        | {
            column: string;
            dimensionTable?:
              | {
                  __typename: 'MetricsV1DimensionTable';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  state: MetricsV1TableState;
                  dimensionDataDeliveredUntilTime?: string | null;
                  sql: string;
                  dataDeliveredUntilUpdateStrategyConfig?: {
                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                    disableEmptyPartitions?: boolean | null;
                    automaticUpdateConfig?: {
                      commitDelay: string;
                      changeThreshold?: { value?: string | null } | null;
                    } | null;
                    dailyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                    hourlyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                  } | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  entityColumnMapping: {
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        };
                    column: { name: string };
                  };
                  dimensions: Array<{ name: string }>;
                  labels: Array<{ key: string; value?: string | null }>;
                  error?: {
                    details: Array<string>;
                    message?: string | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                  timeConfig?: {
                    window: string;
                    timestampColumn: {
                      name: string;
                      type?: MetricsV1ColumnType | null;
                    };
                  } | null;
                  valueMappings: Array<{
                    column: string;
                    mappings: Array<{
                      inputDimensionValue?: string | null;
                      outputDimensionValue?: string | null;
                    }>;
                  }>;
                }
              | Record<PropertyKey, never>
              | null;
          }
        | {
            column: string;
            factTable:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  sql: string;
                  state: MetricsV1TableState;
                  factDataDeliveredUntilTime?: string | null;
                  timestampColumn: { name: string };
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  entities: Array<{
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    column: { name: string };
                  }>;
                  measures: Array<{
                    declaredType?: MetricsV1ColumnType | null;
                    column: { name: string };
                    unit?: {
                      baseUnitMultiplier?: number | null;
                      baseUnit?: MetricsV1UnitBaseUnit | null;
                      currencyCode?: string | null;
                      customUnit?: string | null;
                    } | null;
                  }>;
                  dimensions: Array<{ name: string }>;
                  dataDeliveredUntilUpdateStrategyConfig?: {
                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                    disableEmptyPartitions?: boolean | null;
                    automaticUpdateConfig?: {
                      commitDelay: string;
                      changeThreshold?: { value?: string | null } | null;
                    } | null;
                    dailyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                    hourlyUpdateConfig?: {
                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                      maxZeroDuration?: string | null;
                    } | null;
                  } | null;
                  error?: {
                    details: Array<string>;
                    message?: string | null;
                  } | null;
                  schemaValidationJob:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1SqlJob';
                        name: string;
                        successfulQueryResult?: {
                          schema: Array<{
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          }>;
                        } | null;
                      };
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | Record<PropertyKey, never>;
          }
      >;
      calculation?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1MetricCalculation';
            name: string;
            state?: MetricsV1MetricCalculationState | null;
          }
        | null;
      scheduledCalculation?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1ScheduledMetricCalculation';
            name: string;
            state?: MetricsV1ScheduledMetricCalculationState | null;
            status: {
              scheduled?: { nextScheduleTime: string } | null;
              cancelled?: { cancelledTime: string } | null;
              calculating?: {
                metricCalculation:
                  | { name: string }
                  | Record<PropertyKey, never>;
              } | null;
              waiting?: {
                dataDeliveredUntilTime?: string | null;
                needDataUntilTime: string;
                exposureTable?:
                  | { name: string }
                  | Record<PropertyKey, never>
                  | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    }
                  | Record<PropertyKey, never>
                  | null;
              } | null;
              error?: { errorMessage: string } | null;
            };
          }
        | null;
    }>;
    createdBy?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1User';
          name: string;
          fullName: string;
          email: string;
          pictureUri?: string | null;
          lastLoginTime?: string | null;
        }
      | null;
  }>;
};

export type MetricDimensionPickerQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type MetricDimensionPickerQuery = {
  metric?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1Metric';
        name: string;
        factTable?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              state: MetricsV1TableState;
            }
          | null;
        entity?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1Entity'; name: string }
          | null;
      }
    | null;
};

export type RefreshExploratoryAnalysisCalculationsMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type RefreshExploratoryAnalysisCalculationsMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
          };
        };
      }
    | null;
};

export type ExecuteUpdateSegmentMutationVariables = Exact<{
  workflowInstance: Scalars['String']['input'];
  requestJson: Scalars['JSON']['input'];
}>;

export type ExecuteUpdateSegmentMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: { __typename: 'WorkflowV1WorkflowInstance'; name: string };
      }
    | null;
};

export type FlagsDataFragment = {
  targetingKeySelector?: string | null;
  stickyAssignments?: boolean | null;
  ignoreTargetingForSticky?: boolean | null;
  intakePaused?: boolean | null;
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
      }
    | null;
  segment?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Segment';
        name: string;
        displayName?: string | null;
        description?: string | null;
        state?: FlagsAdminV1SegmentState | null;
        createTime: string;
        updateTime: string;
        flag?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FlagsAdminV1Flag';
              name: string;
              displayName: string;
            }
          | null;
        workflowInstance?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            }
          | null;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        allocation?: {
          exclusiveTo: Array<string>;
          exclusivityTags: Array<string>;
          proportion?: { value?: string | null } | null;
        } | null;
        targeting?: {
          criteria: Array<{
            key: string;
            value?: {
              attribute?: {
                attributeName?: string | null;
                eqRule?: {
                  value?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                setRule?: {
                  values: Array<{
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  }>;
                } | null;
                rangeRule?: {
                  startInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  startExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endInclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                  endExclusive?: {
                    boolValue?: boolean | null;
                    numberValue?: number | null;
                    stringValue?: string | null;
                    timestampValue?: string | null;
                    versionValue?: { version?: string | null } | null;
                  } | null;
                } | null;
                startsWithRule?: { value?: string | null } | null;
                containsRule?: { value?: string | null } | null;
                endsWithRule?: { value?: string | null } | null;
                anyRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
                allRule?: {
                  rule?: {
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                  } | null;
                } | null;
              } | null;
              segment?: {
                segment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Segment';
                      name: string;
                      displayName?: string | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
              } | null;
              materializedSegment?: {
                materializedSegment?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1MaterializedSegment';
                      name: string;
                      displayName: string;
                    }
                  | null;
              } | null;
            } | null;
          }>;
          expression?: {
            ref?: string | null;
            not?: { ref?: string | null } | null;
            and?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            or?: {
              operands: Array<{
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
          } | null;
        } | null;
        labels: Array<{ key: string; value?: string | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string; resource: string }>;
            }
          | null;
      }
    | null;
  rule?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'FlagsAdminV1FlagRule'; name: string }
    | null;
};

export type PauseIntakeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type PauseIntakeMutation = {
  executeFunction?:
    | {
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
        };
      }
    | Record<PropertyKey, never>
    | null;
};

export type ResumeIntakeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ResumeIntakeMutation = {
  executeFunction?:
    | {
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
        };
      }
    | Record<PropertyKey, never>
    | null;
};

export type UpdateFlagsDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateFlagsDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
        };
      }
    | null;
};

export type HypothesisDataFragment = { text?: string | null };

export type UpdateHypothesisDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateHypothesisDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: { hypothesis?: { text?: string | null } | null };
      }
    | null;
};

export type UpdateWorkflowInstanceInitiativesMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
}>;

export type UpdateWorkflowInstanceInitiativesMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
              updateTime: string;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                  }
                | null;
              reviews?: {
                mandatory?: boolean | null;
                reviewers: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                >;
              } | null;
              stakeholders: Array<{
                role: string;
                identity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    };
              }>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              automatedActions: Array<{
                action?: {
                  executeFunctionAction?: {
                    __typename: 'ActionsV1TypesExecuteFunctionAction';
                    function?: string | null;
                    parameters?: any | null;
                  } | null;
                  transitionAction?: {
                    __typename: 'ActionsV1TypesTransitionWorkflowAction';
                    action?: string | null;
                    parameters?: any | null;
                  } | null;
                  pagerdutyAction?: {
                    pdKey: string;
                    severity: ActionsV1TypesSeverity;
                    title?: string | null;
                    description?: string | null;
                  } | null;
                } | null;
                trigger?: {
                  stateTrigger?: {
                    __typename: 'ActionsV1TypesStateTrigger';
                    resource?: string | null;
                    state?: string | null;
                  } | null;
                  activityTrigger?: {
                    kind?: string | null;
                    resource?: string | null;
                  } | null;
                } | null;
              }>;
            }
        >;
      }
    | null;
};

export type MetricsDataFragment = {
  bucket?: MetricsDataBucket | null;
  assignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1AssignmentTable';
        name: string;
        displayName: string;
        dimensions: Array<{ name: string }>;
        dataWarehouse?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'MetricsV1DataWarehouse'; name: string }
          | null;
      }
    | null;
  exposureTableSchedule?:
    | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
    | Record<PropertyKey, never>
    | null;
  metrics: Array<{
    __typename: 'MetricsDataMetric';
    preferredDirection?: MetricsDataMetricPreferredDirection | null;
    surfaceOnly?: boolean | null;
    metric:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1Metric';
          displayName: string;
          name: string;
          description?: string | null;
          createTime: string;
          updateTime: string;
          deleteTime?: string | null;
          state?: MetricsV1MetricState | null;
          preferredDirection?: MetricsV1MetricPreferredDirection | null;
          measurement?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Measurement';
                name: string;
                displayName: string;
                typeSpec: {
                  averageMetricSpec?: {
                    measurement?: { name: string } | null;
                    aggregation: { type: MetricsV1AggregationType };
                  } | null;
                  ratioMetricSpec?: {
                    numerator?: { name: string } | null;
                    numeratorAggregation: { type: MetricsV1AggregationType };
                    denominator?: { name: string } | null;
                    denominatorAggregation: { type: MetricsV1AggregationType };
                  } | null;
                  quantileMetricSpec?: {
                    quantileLevel: number;
                    aggregation: { type: MetricsV1AggregationType };
                  } | null;
                };
                filter?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attribute: string;
                        eqRule?: {
                          value: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          };
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            nullValue?: { dummyField?: string | null } | null;
                          } | null;
                        } | null;
                        likeRule?: { pattern: string } | null;
                      } | null;
                    } | null;
                  }>;
                  expression: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  };
                } | null;
                entity:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Entity';
                      name: string;
                      displayName: string;
                    };
                factTable:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      state: MetricsV1TableState;
                    };
                nullHandling?: {
                  replaceEntityNullWithZero?: boolean | null;
                } | null;
              }
            | null;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                displayName: string;
                name: string;
                everyone?: boolean | null;
                user?:
                  | { pictureUri?: string | null; name: string }
                  | Record<PropertyKey, never>
                  | null;
                group?: { name: string } | Record<PropertyKey, never> | null;
                apiClient?:
                  | { name: string }
                  | Record<PropertyKey, never>
                  | null;
              }
            | null;
          factTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1FactTable';
                name: string;
                displayName: string;
                state: MetricsV1TableState;
              }
            | null;
          filter?: {
            criteria: Array<{
              key: string;
              value?: {
                attribute?: {
                  attribute: string;
                  eqRule?: {
                    value: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    };
                  } | null;
                  setRule?: {
                    values: Array<{
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    }>;
                  } | null;
                  rangeRule?: {
                    startInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    startExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endInclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                    endExclusive?: {
                      boolValue?: boolean | null;
                      numberValue?: number | null;
                      stringValue?: string | null;
                      timestampValue?: string | null;
                      nullValue?: { dummyField?: string | null } | null;
                    } | null;
                  } | null;
                  likeRule?: { pattern: string } | null;
                } | null;
              } | null;
            }>;
            expression: {
              ref?: string | null;
              not?: { ref?: string | null } | null;
              and?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
              or?: {
                operands: Array<{
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                    }>;
                  } | null;
                }>;
              } | null;
            };
          } | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
          measurementConfig?: {
            closedWindow?: {
              aggregationWindow: string;
              exposureOffset: string;
            } | null;
            semiOpenWindow?: {
              aggregationWindow: string;
              exposureOffset?: string | null;
            } | null;
            openWindow?: { dummy?: string | null } | null;
          } | null;
          varianceReductionConfig?: {
            aggregationWindowOverride?: string | null;
            disabled?: boolean | null;
          } | null;
          nullHandling?: { replaceEntityNullWithZero?: boolean | null } | null;
          typeSpec?: {
            ratioMetricSpec?: {
              numerator?: { name: string } | null;
              numeratorAggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
              numeratorFilter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              denominator?: { name: string } | null;
              denominatorAggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
              denominatorFilter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
            } | null;
            averageMetricSpec?: {
              measurement?: {
                name: string;
                type?: MetricsV1ColumnType | null;
              } | null;
              aggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
            } | null;
            quantileMetricSpec?: {
              quantileLevel: number;
              measurement?: {
                name: string;
                type?: MetricsV1ColumnType | null;
              } | null;
              aggregation: {
                type: MetricsV1AggregationType;
                threshold?: {
                  direction: MetricsV1AggregationThresholdDirection;
                  threshold: { value?: string | null };
                } | null;
                cap?: {
                  min?: { value?: string | null } | null;
                  max?: { value?: string | null } | null;
                } | null;
              };
            } | null;
          } | null;
          labels: Array<{ key: string; value?: string | null }>;
          archiveInfo?: {
            reason?: string | null;
            archiveTime?: string | null;
          } | null;
          defaultEffectSize?: { value?: string | null } | null;
          source?: {
            type?: MetricsV1MetricMetricSourceType | null;
            reference?: string | null;
          } | null;
          verification?: {
            state?: MetricsV1MetricMetricVerificationVerificationState | null;
            verifyTime?: string | null;
            verifier?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
          } | null;
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
        };
    schedule?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1ScheduledMetricCalculation';
          name: string;
          state?: MetricsV1ScheduledMetricCalculationState | null;
          nextScheduledRunTime: string;
          nextExposureStartTime: string;
          nextExposureEndTime: string;
          iteration: number;
          executedCalculationsCount: number;
          status: {
            scheduled?: { nextScheduleTime: string } | null;
            cancelled?: { cancelledTime: string } | null;
            calculating?: {
              metricCalculation: { name: string } | Record<PropertyKey, never>;
            } | null;
            waiting?: {
              dataDeliveredUntilTime?: string | null;
              needDataUntilTime: string;
              exposureTable?:
                | { name: string }
                | Record<PropertyKey, never>
                | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | Record<PropertyKey, never>
                | null;
            } | null;
            error?: { errorMessage: string } | null;
          };
          metricCalculationSpec: {
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  name: string;
                  displayName: string;
                  nullHandling?: {
                    __typename: 'MetricsV1MetricNullHandlingConfig';
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  measurementConfig?: {
                    closedWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: {
                      __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                    } | null;
                  } | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        dataDeliveredUntilUpdateStrategyConfig?: {
                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                          disableEmptyPartitions?: boolean | null;
                          automaticUpdateConfig?: {
                            commitDelay: string;
                            changeThreshold?: { value?: string | null } | null;
                          } | null;
                          dailyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                          hourlyUpdateConfig?: {
                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                            maxZeroDuration?: string | null;
                          } | null;
                        } | null;
                        partitionedUpdateStrategyState?: {
                          currentPartitionLastCheckTime?: string | null;
                          existsCheckDuration?: string | null;
                          state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                          usualLateness?: string | null;
                        } | null;
                      }
                    | null;
                };
            exposureTable:
              | {
                  __typename: 'MetricsV1ExposureTable';
                  scheduledExposureCalculation?:
                    | {
                        __typename: 'MetricsV1ScheduledExposureCalculation';
                        name: string;
                        exposureCalculationSpec: {
                          __typename: 'MetricsV1ExposureCalculationSpec';
                          assignmentTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1AssignmentTable';
                                name: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                              };
                        };
                        status: {
                          calculating?: {
                            exposureCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          cancelled?: { cancelledTime: string } | null;
                          error?: { errorMessage: string } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            assignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1AssignmentTable';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                          scheduled?: { nextScheduleTime: string } | null;
                        };
                      }
                    | Record<PropertyKey, never>
                    | null;
                }
              | Record<PropertyKey, never>;
            measurementTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1MeasurementTable'; name: string }
              | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{
                  relation: string;
                  resource: string;
                }>;
              }
            | null;
          labels: Array<{ key: string; value?: string | null }>;
        }
      | null;
    metricRole:
      | {
          nonInferiorityMargin?: number | null;
          guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
        }
      | {
          minimumDetectableEffect?: number | null;
          successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
        };
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
          deleteTime?: string | null;
        }
      | null;
    calculation?:
      | { __typename: 'MetricsV1MetricCalculation'; name: string }
      | Record<PropertyKey, never>
      | null;
  }>;
  filters?: Array<{
    displayName?: string | null;
    factTable?:
      | {
          __typename: 'MetricsV1FactTable';
          name: string;
          displayName: string;
          labels: Array<{ key: string; value?: string | null }>;
        }
      | Record<PropertyKey, never>
      | null;
    filter?: { criteria: any; expression: any } | null;
  }> | null;
  entity?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
    | null;
};

export type UpdateMetricsDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateMetricsDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
    | null;
};

export type PlanningDataFragment = {
  planned?: {
    startTime?: string | null;
    endTime?: string | null;
    runtime?: string | null;
  } | null;
  actual?: {
    startTime?: string | null;
    endTime?: string | null;
    runtime?: string | null;
  } | null;
};

export type UpdatePlanningDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePlanningDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
        };
      }
    | null;
};

export type CalculateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CalculateMutation = {
  executeFunction?:
    | {
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
        };
      }
    | Record<PropertyKey, never>
    | null;
};

export type CreateReanalysisMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  input: WorkflowV1WorkflowInstanceInput;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateReanalysisMutation = {
  createWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type DescribeAssignmentTableMutationVariables = Exact<{
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;

export type DescribeAssignmentTableMutation = {
  describeAssignmentTable?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1DescribeAssignmentTableResponse';
        assignmentsData: Array<{
          exposureKey: string;
          variants: Array<string>;
        }>;
      }
    | null;
};

export type ExposureCalculationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ExposureCalculationQuery = {
  exposureCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExposureCalculation';
        name: string;
        startTime: string;
        endTime: string;
        sql: string;
        state: MetricsV1ExposureCalculationState;
        sqlJob:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1SqlJob';
              name: string;
              state?: MetricsV1SqlJobState | null;
              labels: Array<{ key: string; value?: string | null }>;
              failedQueryResult?: { error?: string | null } | null;
            };
      }
    | null;
};

export type OnReanalysisCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnReanalysisCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnReanalysisUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnReanalysisUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type ReanalysesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReanalysesQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          displayName: string;
          state: string;
          name: string;
          createTime: string;
          updateTime: string;
          stateHistory: Array<{ state?: string | null }>;
          moduleData2: {
            reanalysis?: {
              exposureState?: ReanalysisDataExposureState | null;
              metrics?: Array<{
                name?: string | null;
                state?: ReanalysisDataMetricDataState | null;
              }> | null;
            } | null;
            exposure?: { exposure: Array<{ totalExposureCount: any }> } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            rollout?: {
              variantImageUri?: string | null;
              reach?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
                steps: Array<{
                  durationSincePreviousStep: string;
                  reach: string;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                  updateTime?: string | null;
                }>;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
            decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
          };
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | Record<PropertyKey, never>
            | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          comments?:
            | {
                __typename: 'CollaborationV1ListCommentsResponse';
                comments: Array<{
                  name: string;
                  resolved?: boolean | null;
                  assignee?:
                    | { __typename: 'Error' }
                    | { __typename: 'IamV1Identity'; name: string }
                    | null;
                }>;
              }
            | { __typename: 'Error' }
            | null;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          moduleData: Array<{ value?: any | null; key: string }>;
        }>;
      }
    | null;
};

export type ReanalysisFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  moduleData2: {
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type ReanalysisQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type ReanalysisQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type ReanalysisListItemFragment = {
  displayName: string;
  state: string;
  name: string;
  createTime: string;
  updateTime: string;
  stateHistory: Array<{ state?: string | null }>;
  moduleData2: {
    reanalysis?: {
      exposureState?: ReanalysisDataExposureState | null;
      metrics?: Array<{
        name?: string | null;
        state?: ReanalysisDataMetricDataState | null;
      }> | null;
    } | null;
    exposure?: { exposure: Array<{ totalExposureCount: any }> } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
    decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | Record<PropertyKey, never>
    | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        comments: Array<{
          name: string;
          resolved?: boolean | null;
          assignee?:
            | { __typename: 'Error' }
            | { __typename: 'IamV1Identity'; name: string }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  moduleData: Array<{ value?: any | null; key: string }>;
};

export type ReportFragment = {
  name?: string | null;
  sections: Array<
    | {
        __typename: 'ReportDataHypothesisSection';
        id: string;
        hypothesisData: { hypothesis?: string | null };
      }
    | {
        __typename: 'ReportDataImagesSection';
        id: string;
        imagesData: {
          images?: Array<{
            imageUri?: string | null;
            label?: string | null;
            text?: string | null;
            id: string;
          }> | null;
        };
      }
    | {
        __typename: 'ReportDataMetricsSection';
        id: string;
        metricsData: {
          metrics?: Array<{
            metricName?: string | null;
            treatments?: Array<{
              hidden?: boolean | null;
              treatment: string;
            }> | null;
          }> | null;
        };
      }
    | {
        __typename: 'ReportDataNextSection';
        id: string;
        nextData: { text?: string | null; title?: string | null };
      }
    | {
        __typename: 'ReportDataOutcomeSection';
        id: string;
        outcomeData: { conclusion?: string | null; outcome?: string | null };
      }
    | {
        __typename: 'ReportDataRecommendationSection';
        id: string;
        recommendationsData: {
          content?: Array<{
            variant?: string | null;
            shippingRecommendation?: string | null;
            text?: string | null;
            id: string;
          }> | null;
        };
      }
    | {
        __typename: 'ReportDataResultsSection';
        id: string;
        resultsData: { text?: string | null; title?: string | null };
      }
    | {
        __typename: 'ReportDataSummarySection';
        id: string;
        summaryData: {
          imageUri?: string | null;
          text?: string | null;
          title?: string | null;
        };
      }
  >;
};

export type DeleteReviewResponseMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type DeleteReviewResponseMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData2: {
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
          };
        };
      }
    | null;
};

export type RequestReviewsMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type RequestReviewsMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData2: {
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
          };
        };
      }
    | null;
};

export type SubmitReviewMutationVariables = Exact<{
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
}>;

export type SubmitReviewMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData2: {
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
          };
        };
      }
    | null;
};

export type WorkflowReviewResponseFragment = {
  __typename: 'ReviewsDataSurfaceReviewDataResponse';
  id?: string | null;
  state: ReviewsDataSurfaceReviewDataResponseState;
  stale?: boolean | null;
  commentId?: string | null;
  groups?: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
        service?: string | null;
        everyone?: boolean | null;
        user?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              scimExternalId?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
        apiClient?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1ApiClient';
              name: string;
              displayName: string;
              description?: string | null;
              clientId: string;
              clientSecret?: string | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            }
          | null;
        group?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Group';
              name: string;
              displayName: string;
              description?: string | null;
              groupType: IamV1GroupGroupType;
              slackChannel?: string | null;
              createTime: string;
              updateTime: string;
              identity: { name: string } | Record<PropertyKey, never>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
        agent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Agent';
              name: string;
              displayName: string;
              pictureUri?: string | null;
              reviewerSkill?: { enabled: boolean } | null;
            }
          | null;
      }
  > | null;
  reviewer:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
        service?: string | null;
        everyone?: boolean | null;
        user?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              scimExternalId?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
        apiClient?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1ApiClient';
              name: string;
              displayName: string;
              description?: string | null;
              clientId: string;
              clientSecret?: string | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            }
          | null;
        group?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Group';
              name: string;
              displayName: string;
              description?: string | null;
              groupType: IamV1GroupGroupType;
              slackChannel?: string | null;
              createTime: string;
              updateTime: string;
              identity: { name: string } | Record<PropertyKey, never>;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
            }
          | null;
        agent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Agent';
              name: string;
              displayName: string;
              pictureUri?: string | null;
              reviewerSkill?: { enabled: boolean } | null;
            }
          | null;
      };
};

export type WorkflowReviewsFragment = {
  __typename: 'ReviewsData';
  approvalRequired?: boolean | null;
  reviewId?: string | null;
  status?: ReviewsDataStatus | null;
  optionalReviews?: Array<{
    __typename: 'ReviewsDataSurfaceReviewData';
    state: ReviewsDataSurfaceReviewDataState;
    responses?: Array<{
      __typename: 'ReviewsDataSurfaceReviewDataResponse';
      id?: string | null;
      state: ReviewsDataSurfaceReviewDataResponseState;
      stale?: boolean | null;
      commentId?: string | null;
      groups?: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
            service?: string | null;
            everyone?: boolean | null;
            user?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  scimExternalId?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
            apiClient?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1ApiClient';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  clientId: string;
                  clientSecret?: string | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | null;
            group?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Group';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  groupType: IamV1GroupGroupType;
                  slackChannel?: string | null;
                  createTime: string;
                  updateTime: string;
                  identity: { name: string } | Record<PropertyKey, never>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            agent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Agent';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                  reviewerSkill?: { enabled: boolean } | null;
                }
              | null;
          }
      > | null;
      reviewer:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
            service?: string | null;
            everyone?: boolean | null;
            user?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  scimExternalId?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
            apiClient?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1ApiClient';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  clientId: string;
                  clientSecret?: string | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | null;
            group?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Group';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  groupType: IamV1GroupGroupType;
                  slackChannel?: string | null;
                  createTime: string;
                  updateTime: string;
                  identity: { name: string } | Record<PropertyKey, never>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            agent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Agent';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                  reviewerSkill?: { enabled: boolean } | null;
                }
              | null;
          };
    }> | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
          deleteTime?: string | null;
        }
      | null;
  }> | null;
  requiredReviews?: Array<{
    __typename: 'ReviewsDataSurfaceReviewData';
    state: ReviewsDataSurfaceReviewDataState;
    responses?: Array<{
      __typename: 'ReviewsDataSurfaceReviewDataResponse';
      id?: string | null;
      state: ReviewsDataSurfaceReviewDataResponseState;
      stale?: boolean | null;
      commentId?: string | null;
      groups?: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
            service?: string | null;
            everyone?: boolean | null;
            user?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  scimExternalId?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
            apiClient?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1ApiClient';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  clientId: string;
                  clientSecret?: string | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | null;
            group?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Group';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  groupType: IamV1GroupGroupType;
                  slackChannel?: string | null;
                  createTime: string;
                  updateTime: string;
                  identity: { name: string } | Record<PropertyKey, never>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            agent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Agent';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                  reviewerSkill?: { enabled: boolean } | null;
                }
              | null;
          }
      > | null;
      reviewer:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
            service?: string | null;
            everyone?: boolean | null;
            user?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  scimExternalId?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
            apiClient?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1ApiClient';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  clientId: string;
                  clientSecret?: string | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                }
              | null;
            group?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Group';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  groupType: IamV1GroupGroupType;
                  slackChannel?: string | null;
                  createTime: string;
                  updateTime: string;
                  identity: { name: string } | Record<PropertyKey, never>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            agent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Agent';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                  reviewerSkill?: { enabled: boolean } | null;
                }
              | null;
          };
    }> | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
          deleteTime?: string | null;
        }
      | null;
  }> | null;
};

export type WorkflowReviewsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type WorkflowReviewsQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
        };
      }
    | null;
};

export type WorkflowReviewsDataFragment = {
  __typename: 'ReviewsDataSurfaceReviewData';
  state: ReviewsDataSurfaceReviewDataState;
  responses?: Array<{
    __typename: 'ReviewsDataSurfaceReviewDataResponse';
    id?: string | null;
    state: ReviewsDataSurfaceReviewDataResponseState;
    stale?: boolean | null;
    commentId?: string | null;
    groups?: Array<
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        }
    > | null;
    reviewer:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'IamV1Identity';
          name: string;
          displayName: string;
          pictureUri?: string | null;
          service?: string | null;
          everyone?: boolean | null;
          user?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1User';
                name: string;
                fullName: string;
                email: string;
                pictureUri?: string | null;
                scimExternalId?: string | null;
                lastLoginTime?: string | null;
              }
            | null;
          apiClient?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1ApiClient';
                name: string;
                displayName: string;
                description?: string | null;
                clientId: string;
                clientSecret?: string | null;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{ relation: string }>;
                    }
                  | null;
              }
            | null;
          group?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Group';
                name: string;
                displayName: string;
                description?: string | null;
                groupType: IamV1GroupGroupType;
                slackChannel?: string | null;
                createTime: string;
                updateTime: string;
                identity: { name: string } | Record<PropertyKey, never>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          agent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Agent';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                reviewerSkill?: { enabled: boolean } | null;
              }
            | null;
        };
  }> | null;
  surface?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        deleteTime?: string | null;
      }
    | null;
};

export type CreateRolloutMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  input: WorkflowV1WorkflowInstanceInput;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateRolloutMutation = {
  createWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type FlagsWithVariantsQueryVariables = Exact<{
  filter: Scalars['String']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type FlagsWithVariantsQuery = {
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        nextPageToken?: string | null;
        flags: Array<{ name: string; variants: Array<{ name: string }> }>;
      }
    | null;
};

export type GetMaxReachMutationVariables = Exact<{
  workflowInstance: Scalars['String']['input'];
}>;

export type GetMaxReachMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1ExecuteFunctionResponse'; response?: any | null }
    | null;
};

export type OnRolloutCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnRolloutCreatedSubscription = {
  workflowInstanceCreated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type OnRolloutUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnRolloutUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      attachments?:
        | {
            __typename: 'CollaborationV1ListAttachmentsResponse';
            nextPageToken?: string | null;
            attachments: Array<{
              __typename: 'CollaborationV1Attachment';
              name: string;
              displayName?: string | null;
              uri: string;
              resource: string;
              createTime: string;
              labels: Array<{ key: string; value?: string | null }>;
            }>;
          }
        | { __typename: 'Error' }
        | null;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type RolloutFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  attachments?:
    | {
        __typename: 'CollaborationV1ListAttachmentsResponse';
        nextPageToken?: string | null;
        attachments: Array<{
          __typename: 'CollaborationV1Attachment';
          name: string;
          displayName?: string | null;
          uri: string;
          resource: string;
          createTime: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  moduleData2: {
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type RolloutQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type RolloutQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        attachments?:
          | {
              __typename: 'CollaborationV1ListAttachmentsResponse';
              nextPageToken?: string | null;
              attachments: Array<{
                __typename: 'CollaborationV1Attachment';
                name: string;
                displayName?: string | null;
                uri: string;
                resource: string;
                createTime: string;
                labels: Array<{ key: string; value?: string | null }>;
              }>;
            }
          | { __typename: 'Error' }
          | null;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type RolloutDataFragment = {
  variantImageUri?: string | null;
  reach?: string | null;
  initialReach?: string | null;
  controlAssignmentId?: string | null;
  description?: string | null;
  monitoringDisabled: boolean;
  treatmentGroupProportion?: number | null;
  variantAssignmentId?: string | null;
  schedule?: {
    state?: RolloutDataScheduleState | null;
    stateReason?: {
      failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
    } | null;
    steps: Array<{
      durationSincePreviousStep: string;
      reach: string;
      status?: RolloutDataScheduleScheduleStepsStatus | null;
      updateTime?: string | null;
    }>;
  } | null;
  variant?:
    | { __typename: 'Error' }
    | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
    | null;
  abtest?:
    | { __typename: 'Error' }
    | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
    | null;
  controlVariant?:
    | { __typename: 'Error' }
    | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
    | null;
  flag?:
    | { __typename: 'Error' }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        clients: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Client';
              name: string;
              displayName: string;
              createTime: string;
              deleteTime?: string | null;
            }
        >;
      }
    | null;
};

export type RolloutDataScheduleFragment = {
  state?: RolloutDataScheduleState | null;
  stateReason?: {
    failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
  } | null;
  steps: Array<{
    durationSincePreviousStep: string;
    reach: string;
    status?: RolloutDataScheduleScheduleStepsStatus | null;
    updateTime?: string | null;
  }>;
};

export type RolloutListItemFragment = {
  displayName: string;
  state: string;
  name: string;
  createTime: string;
  updateTime: string;
  stateHistory: Array<{ state?: string | null }>;
  moduleData2: {
    exposure?: { exposure: Array<{ totalExposureCount: any }> } | null;
    rollout?: {
      reach?: string | null;
      variantImageUri?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        steps: Array<{
          reach: string;
          durationSincePreviousStep: string;
          updateTime?: string | null;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
        }>;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
  };
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | Record<PropertyKey, never>
    | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        comments: Array<{
          name: string;
          resolved?: boolean | null;
          assignee?:
            | { __typename: 'Error' }
            | { __typename: 'IamV1Identity'; name: string }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  moduleData: Array<{ value?: any | null; key: string }>;
};

export type RolloutsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type RolloutsQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          displayName: string;
          state: string;
          name: string;
          createTime: string;
          updateTime: string;
          stateHistory: Array<{ state?: string | null }>;
          moduleData2: {
            exposure?: { exposure: Array<{ totalExposureCount: any }> } | null;
            rollout?: {
              reach?: string | null;
              variantImageUri?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                steps: Array<{
                  reach: string;
                  durationSincePreviousStep: string;
                  updateTime?: string | null;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                }>;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
          };
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | Record<PropertyKey, never>
            | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          comments?:
            | {
                __typename: 'CollaborationV1ListCommentsResponse';
                comments: Array<{
                  name: string;
                  resolved?: boolean | null;
                  assignee?:
                    | { __typename: 'Error' }
                    | { __typename: 'IamV1Identity'; name: string }
                    | null;
                }>;
              }
            | { __typename: 'Error' }
            | null;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          moduleData: Array<{ value?: any | null; key: string }>;
        }>;
      }
    | null;
};

export type UpdateRolloutDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateRolloutDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
      }
    | null;
};

export type CalculateSampleSizeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type CalculateSampleSizeMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData2: {
            samplesize?: {
              error?: string | null;
              useScheduledCalculation?: boolean | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataState | null;
              exposure?:
                | {
                    exposureCalculation?: any | null;
                    scheduledExposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    assignmentTable: {
                      assignmentTable?: string | null;
                      filters?: { assignmentFilter?: any | null } | null;
                    };
                  }
                | {
                    exposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    existingInstance: {
                      workflowInstance:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          };
                    };
                  }
                | null;
              exposureSource?:
                | {
                    assignmentTable?: string | null;
                    customStartTime?: string | null;
                    customEndTime?: string | null;
                    filters?: {
                      assignmentFilter?: any | null;
                      entityFilter?: any | null;
                      exposureFilter?: string | null;
                    } | null;
                  }
                | {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  }
                | null;
              metrics?: Array<{
                error?: string | null;
                metric: string;
                metricCalculation?: any | null;
                scheduledMetricCalculation?: any | null;
                requiredSampleSize?: any | null;
                state?: SampleSizeDataSampleSizeMetricState | null;
                type?: SampleSizeDataSampleSizeMetricType | null;
                metricCalculationName?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                summaryStats?: {
                  mean?: number | null;
                  variance?: number | null;
                  varianceReductionRate?: number | null;
                  count?: any | null;
                } | null;
                observedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  mean?: number | null;
                  variance?: number | null;
                  expectedSampleSize?: any | null;
                }> | null;
                forecastedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  expectedSampleSize?: any | null;
                }> | null;
              }> | null;
            } | null;
          };
        };
      }
    | null;
};

export type CancelSampleSizeCalculationsMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CancelSampleSizeCalculationsMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData2: {
            samplesize?: {
              error?: string | null;
              useScheduledCalculation?: boolean | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataState | null;
              exposure?:
                | {
                    exposureCalculation?: any | null;
                    scheduledExposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    assignmentTable: {
                      assignmentTable?: string | null;
                      filters?: { assignmentFilter?: any | null } | null;
                    };
                  }
                | {
                    exposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    existingInstance: {
                      workflowInstance:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          };
                    };
                  }
                | null;
              exposureSource?:
                | {
                    assignmentTable?: string | null;
                    customStartTime?: string | null;
                    customEndTime?: string | null;
                    filters?: {
                      assignmentFilter?: any | null;
                      entityFilter?: any | null;
                      exposureFilter?: string | null;
                    } | null;
                  }
                | {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  }
                | null;
              metrics?: Array<{
                error?: string | null;
                metric: string;
                metricCalculation?: any | null;
                scheduledMetricCalculation?: any | null;
                requiredSampleSize?: any | null;
                state?: SampleSizeDataSampleSizeMetricState | null;
                type?: SampleSizeDataSampleSizeMetricType | null;
                metricCalculationName?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                summaryStats?: {
                  mean?: number | null;
                  variance?: number | null;
                  varianceReductionRate?: number | null;
                  count?: any | null;
                } | null;
                observedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  mean?: number | null;
                  variance?: number | null;
                  expectedSampleSize?: any | null;
                }> | null;
                forecastedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  expectedSampleSize?: any | null;
                }> | null;
              }> | null;
            } | null;
          };
        };
      }
    | null;
};

export type PreviousExperimentFragment = {
  name: string;
  displayName: string;
  moduleData2: {
    planning?: {
      actual?: {
        endTime?: string | null;
        runtime?: string | null;
        startTime?: string | null;
      } | null;
    } | null;
  };
  owner?:
    | { __typename: 'Error' }
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | null;
};

export type PreviousExperimentsQueryVariables = Exact<{
  parent?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type PreviousExperimentsQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          name: string;
          displayName: string;
          moduleData2: {
            planning?: {
              actual?: {
                endTime?: string | null;
                runtime?: string | null;
                startTime?: string | null;
              } | null;
            } | null;
          };
          owner?:
            | { __typename: 'Error' }
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | null;
        }>;
      }
    | null;
};

export type SampleSizeDataFragment = {
  error?: string | null;
  useScheduledCalculation?: boolean | null;
  requiredSampleSize?: any | null;
  state?: SampleSizeDataState | null;
  exposure?:
    | {
        exposureCalculation?: any | null;
        scheduledExposureCalculation?: any | null;
        startTime?: string | null;
        endTime?: string | null;
        assignmentTable: {
          assignmentTable?: string | null;
          filters?: { assignmentFilter?: any | null } | null;
        };
      }
    | {
        exposureCalculation?: any | null;
        startTime?: string | null;
        endTime?: string | null;
        existingInstance: {
          workflowInstance:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
              };
        };
      }
    | null;
  exposureSource?:
    | {
        assignmentTable?: string | null;
        customStartTime?: string | null;
        customEndTime?: string | null;
        filters?: {
          assignmentFilter?: any | null;
          entityFilter?: any | null;
          exposureFilter?: string | null;
        } | null;
      }
    | {
        workflowInstance:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            };
      }
    | null;
  metrics?: Array<{
    error?: string | null;
    metric: string;
    metricCalculation?: any | null;
    scheduledMetricCalculation?: any | null;
    requiredSampleSize?: any | null;
    state?: SampleSizeDataSampleSizeMetricState | null;
    type?: SampleSizeDataSampleSizeMetricType | null;
    metricCalculationName?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'MetricsV1MetricCalculation';
          name: string;
          state?: MetricsV1MetricCalculationState | null;
        }
      | null;
    summaryStats?: {
      mean?: number | null;
      variance?: number | null;
      varianceReductionRate?: number | null;
      count?: any | null;
    } | null;
    observedData?: Array<{
      dayIndex: any;
      requiredSampleSize?: any | null;
      mean?: number | null;
      variance?: number | null;
      expectedSampleSize?: any | null;
    }> | null;
    forecastedData?: Array<{
      dayIndex: any;
      requiredSampleSize?: any | null;
      expectedSampleSize?: any | null;
    }> | null;
  }> | null;
};

export type SampleSizeMetricCalculationSqlQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type SampleSizeMetricCalculationSqlQuery = {
  metricCalculation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1MetricCalculation';
        name: string;
        sql?: string | null;
      }
    | null;
};

export type UpdateSampleSizeDataMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSampleSizeDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        moduleData2: {
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
        };
      }
    | null;
};

export type AnalysisResultFragment = {
  name: string;
  exposureFilter?: string | null;
  updateTime: string;
  annotations: Array<{
    context: Array<{
      key?: StatsV2AnalysisStatsAnnotationContext | null;
      value?: string | null;
    }>;
  }>;
  results: Array<{
    id?: string | null;
    annotations: Array<{
      info?: string | null;
      warning?: string | null;
      context: Array<{
        key?: StatsV2AnalysisStatsAnnotationContext | null;
        value?: string | null;
      }>;
      error?: {
        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
        details?: string | null;
      } | null;
    }>;
    metricDetails?: {
      direction?: StatsV2AnalysisMetricDirection | null;
      hasRun?: boolean | null;
      metricType?: StatsV2AnalysisMetricType | null;
      plannedEffectSize?: { value?: string | null } | null;
    } | null;
    result: Array<{
      comparisonId?: string | null;
      isSignificant?: boolean | null;
      usedDataType?: StatsV2AnalysisStatsDataType | null;
      segmentId?: string | null;
      dimensions: Array<{ value?: string | null; key: string }>;
      groupStats: Array<{ sampleSize?: any | null; id?: string | null }>;
      groups?: { baseline?: string | null; compared?: string | null } | null;
      lastDeteriorationResult?: {
        baselineEstimateAbs?: number | null;
        baselineEstimateRel?: number | null;
        baselineSampleSize?: any | null;
        comparedEstimateAbs?: number | null;
        comparedEstimateRel?: number | null;
        comparedSampleSize?: any | null;
        differenceEstimateAbs?: {
          estimate?: number | null;
          isSignificant?: boolean | null;
          lower?: number | null;
          powered?: number | null;
          upper?: number | null;
        } | null;
      } | null;
      lastResult?: {
        baselineEstimateAbs?: number | null;
        baselineEstimateRel?: number | null;
        baselineSampleSize?: any | null;
        comparedEstimateAbs?: number | null;
        differenceEstimateAbs?: {
          estimate?: number | null;
          lower?: number | null;
          upper?: number | null;
          isSignificant?: boolean | null;
        } | null;
        differenceEstimateRel?: {
          estimate?: number | null;
          lower?: number | null;
          upper?: number | null;
          isSignificant?: boolean | null;
        } | null;
      } | null;
      status?: {
        status?: StatsV2AnalysisMetricResultStatus | null;
        message?: string | null;
        metricType?: StatsV2AnalysisMetricType | null;
        decisionPowered?: boolean | null;
        decisionIsSignificant?: boolean | null;
        validationIsSignificant?: boolean | null;
      } | null;
      result: Array<{
        resultTime?: string | null;
        baselineEstimateAbs?: number | null;
        comparedEstimateAbs?: number | null;
        baselineEstimateRel?: number | null;
        comparedEstimateRel?: number | null;
        varianceReductionRate?: number | null;
        unadjustedEstimateBaseline?: number | null;
        unadjustedEstimateCompared?: number | null;
        baselineSampleSize?: any | null;
        comparedSampleSize?: any | null;
        differenceEstimateAbs?: {
          estimate?: number | null;
          lower?: number | null;
          upper?: number | null;
          isSignificant?: boolean | null;
        } | null;
        differenceEstimateRel?: {
          estimate?: number | null;
          lower?: number | null;
          upper?: number | null;
          isSignificant?: boolean | null;
        } | null;
      }>;
      sampleSize?: {
        current?: any | null;
        required?: any | null;
        poweredEffectRel?: number | null;
        poweredEffectAbs?: number | null;
      } | null;
    }>;
    srmResult: Array<{
      isSignificant?: boolean | null;
      segmentId?: string | null;
      status?: {
        status?: StatsV2AnalysisMetricResultStatus | null;
        message?: string | null;
        metricType?: StatsV2AnalysisMetricType | null;
        decisionPowered?: boolean | null;
        decisionIsSignificant?: boolean | null;
        validationIsSignificant?: boolean | null;
      } | null;
      dimensions: Array<{ key: string; value?: string | null }>;
      result: Array<{
        group?: string | null;
        observed?: number | null;
        expected?: number | null;
        isSignificant?: boolean | null;
      }>;
    }>;
    statsSettings?: {
      method?: StatsV2AnalysisMethod | null;
      adjustedAlpha?: number | null;
      adjustedBeta?: number | null;
      hasVarianceReduction?: boolean | null;
    } | null;
  }>;
  treatments: Array<{
    id?: string | null;
    recommendation?: {
      shipping?: StatsV2AnalysisShippingRecommendation | null;
      status?: {
        quality?: StatsV2AnalysisQualityStatus | null;
        tanking?: StatsV2AnalysisTankingStatus | null;
        guardrail?: StatsV2AnalysisGuardrailStatus | null;
        success?: StatsV2AnalysisSuccessStatus | null;
      } | null;
    } | null;
  }>;
};

export type OnAnalysisResultUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAnalysisResultUpdatedSubscription = {
  analysisResultUpdated?: {
    analysisResult: {
      name: string;
      exposureFilter?: string | null;
      updateTime: string;
      annotations: Array<{
        context: Array<{
          key?: StatsV2AnalysisStatsAnnotationContext | null;
          value?: string | null;
        }>;
      }>;
      results: Array<{
        id?: string | null;
        annotations: Array<{
          info?: string | null;
          warning?: string | null;
          context: Array<{
            key?: StatsV2AnalysisStatsAnnotationContext | null;
            value?: string | null;
          }>;
          error?: {
            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
            details?: string | null;
          } | null;
        }>;
        metricDetails?: {
          direction?: StatsV2AnalysisMetricDirection | null;
          hasRun?: boolean | null;
          metricType?: StatsV2AnalysisMetricType | null;
          plannedEffectSize?: { value?: string | null } | null;
        } | null;
        result: Array<{
          comparisonId?: string | null;
          isSignificant?: boolean | null;
          usedDataType?: StatsV2AnalysisStatsDataType | null;
          segmentId?: string | null;
          dimensions: Array<{ value?: string | null; key: string }>;
          groupStats: Array<{ sampleSize?: any | null; id?: string | null }>;
          groups?: {
            baseline?: string | null;
            compared?: string | null;
          } | null;
          lastDeteriorationResult?: {
            baselineEstimateAbs?: number | null;
            baselineEstimateRel?: number | null;
            baselineSampleSize?: any | null;
            comparedEstimateAbs?: number | null;
            comparedEstimateRel?: number | null;
            comparedSampleSize?: any | null;
            differenceEstimateAbs?: {
              estimate?: number | null;
              isSignificant?: boolean | null;
              lower?: number | null;
              powered?: number | null;
              upper?: number | null;
            } | null;
          } | null;
          lastResult?: {
            baselineEstimateAbs?: number | null;
            baselineEstimateRel?: number | null;
            baselineSampleSize?: any | null;
            comparedEstimateAbs?: number | null;
            differenceEstimateAbs?: {
              estimate?: number | null;
              lower?: number | null;
              upper?: number | null;
              isSignificant?: boolean | null;
            } | null;
            differenceEstimateRel?: {
              estimate?: number | null;
              lower?: number | null;
              upper?: number | null;
              isSignificant?: boolean | null;
            } | null;
          } | null;
          status?: {
            status?: StatsV2AnalysisMetricResultStatus | null;
            message?: string | null;
            metricType?: StatsV2AnalysisMetricType | null;
            decisionPowered?: boolean | null;
            decisionIsSignificant?: boolean | null;
            validationIsSignificant?: boolean | null;
          } | null;
          result: Array<{
            resultTime?: string | null;
            baselineEstimateAbs?: number | null;
            comparedEstimateAbs?: number | null;
            baselineEstimateRel?: number | null;
            comparedEstimateRel?: number | null;
            varianceReductionRate?: number | null;
            unadjustedEstimateBaseline?: number | null;
            unadjustedEstimateCompared?: number | null;
            baselineSampleSize?: any | null;
            comparedSampleSize?: any | null;
            differenceEstimateAbs?: {
              estimate?: number | null;
              lower?: number | null;
              upper?: number | null;
              isSignificant?: boolean | null;
            } | null;
            differenceEstimateRel?: {
              estimate?: number | null;
              lower?: number | null;
              upper?: number | null;
              isSignificant?: boolean | null;
            } | null;
          }>;
          sampleSize?: {
            current?: any | null;
            required?: any | null;
            poweredEffectRel?: number | null;
            poweredEffectAbs?: number | null;
          } | null;
        }>;
        srmResult: Array<{
          isSignificant?: boolean | null;
          segmentId?: string | null;
          status?: {
            status?: StatsV2AnalysisMetricResultStatus | null;
            message?: string | null;
            metricType?: StatsV2AnalysisMetricType | null;
            decisionPowered?: boolean | null;
            decisionIsSignificant?: boolean | null;
            validationIsSignificant?: boolean | null;
          } | null;
          dimensions: Array<{ key: string; value?: string | null }>;
          result: Array<{
            group?: string | null;
            observed?: number | null;
            expected?: number | null;
            isSignificant?: boolean | null;
          }>;
        }>;
        statsSettings?: {
          method?: StatsV2AnalysisMethod | null;
          adjustedAlpha?: number | null;
          adjustedBeta?: number | null;
          hasVarianceReduction?: boolean | null;
        } | null;
      }>;
      treatments: Array<{
        id?: string | null;
        recommendation?: {
          shipping?: StatsV2AnalysisShippingRecommendation | null;
          status?: {
            quality?: StatsV2AnalysisQualityStatus | null;
            tanking?: StatsV2AnalysisTankingStatus | null;
            guardrail?: StatsV2AnalysisGuardrailStatus | null;
            success?: StatsV2AnalysisSuccessStatus | null;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type StatsDataFragment = {
  testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
  analysisResults?: Array<{
    exposureFilterName?: string | null;
    analysisResult:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'StatsV2AnalysisAnalysisResult';
          name: string;
          exposureFilter?: string | null;
          updateTime: string;
          annotations: Array<{
            context: Array<{
              key?: StatsV2AnalysisStatsAnnotationContext | null;
              value?: string | null;
            }>;
          }>;
          results: Array<{
            id?: string | null;
            annotations: Array<{
              info?: string | null;
              warning?: string | null;
              context: Array<{
                key?: StatsV2AnalysisStatsAnnotationContext | null;
                value?: string | null;
              }>;
              error?: {
                category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                details?: string | null;
              } | null;
            }>;
            metricDetails?: {
              direction?: StatsV2AnalysisMetricDirection | null;
              hasRun?: boolean | null;
              metricType?: StatsV2AnalysisMetricType | null;
              plannedEffectSize?: { value?: string | null } | null;
            } | null;
            result: Array<{
              comparisonId?: string | null;
              isSignificant?: boolean | null;
              usedDataType?: StatsV2AnalysisStatsDataType | null;
              segmentId?: string | null;
              dimensions: Array<{ value?: string | null; key: string }>;
              groupStats: Array<{
                sampleSize?: any | null;
                id?: string | null;
              }>;
              groups?: {
                baseline?: string | null;
                compared?: string | null;
              } | null;
              lastDeteriorationResult?: {
                baselineEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                baselineSampleSize?: any | null;
                comparedEstimateAbs?: number | null;
                comparedEstimateRel?: number | null;
                comparedSampleSize?: any | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  isSignificant?: boolean | null;
                  lower?: number | null;
                  powered?: number | null;
                  upper?: number | null;
                } | null;
              } | null;
              lastResult?: {
                baselineEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                baselineSampleSize?: any | null;
                comparedEstimateAbs?: number | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
                differenceEstimateRel?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
              } | null;
              status?: {
                status?: StatsV2AnalysisMetricResultStatus | null;
                message?: string | null;
                metricType?: StatsV2AnalysisMetricType | null;
                decisionPowered?: boolean | null;
                decisionIsSignificant?: boolean | null;
                validationIsSignificant?: boolean | null;
              } | null;
              result: Array<{
                resultTime?: string | null;
                baselineEstimateAbs?: number | null;
                comparedEstimateAbs?: number | null;
                baselineEstimateRel?: number | null;
                comparedEstimateRel?: number | null;
                varianceReductionRate?: number | null;
                unadjustedEstimateBaseline?: number | null;
                unadjustedEstimateCompared?: number | null;
                baselineSampleSize?: any | null;
                comparedSampleSize?: any | null;
                differenceEstimateAbs?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
                differenceEstimateRel?: {
                  estimate?: number | null;
                  lower?: number | null;
                  upper?: number | null;
                  isSignificant?: boolean | null;
                } | null;
              }>;
              sampleSize?: {
                current?: any | null;
                required?: any | null;
                poweredEffectRel?: number | null;
                poweredEffectAbs?: number | null;
              } | null;
            }>;
            srmResult: Array<{
              isSignificant?: boolean | null;
              segmentId?: string | null;
              status?: {
                status?: StatsV2AnalysisMetricResultStatus | null;
                message?: string | null;
                metricType?: StatsV2AnalysisMetricType | null;
                decisionPowered?: boolean | null;
                decisionIsSignificant?: boolean | null;
                validationIsSignificant?: boolean | null;
              } | null;
              dimensions: Array<{ key: string; value?: string | null }>;
              result: Array<{
                group?: string | null;
                observed?: number | null;
                expected?: number | null;
                isSignificant?: boolean | null;
              }>;
            }>;
            statsSettings?: {
              method?: StatsV2AnalysisMethod | null;
              adjustedAlpha?: number | null;
              adjustedBeta?: number | null;
              hasVarianceReduction?: boolean | null;
            } | null;
          }>;
          treatments: Array<{
            id?: string | null;
            recommendation?: {
              shipping?: StatsV2AnalysisShippingRecommendation | null;
              status?: {
                quality?: StatsV2AnalysisQualityStatus | null;
                tanking?: StatsV2AnalysisTankingStatus | null;
                guardrail?: StatsV2AnalysisGuardrailStatus | null;
                success?: StatsV2AnalysisSuccessStatus | null;
              } | null;
            } | null;
          }>;
        };
  }> | null;
  metricMethods?: Array<{
    metricName: string;
    method: StatsDataMethodMethod;
  }> | null;
};

export type StatsHypothesisResultFragment = {
  id?: string | null;
  annotations: Array<{
    info?: string | null;
    warning?: string | null;
    context: Array<{
      key?: StatsV2AnalysisStatsAnnotationContext | null;
      value?: string | null;
    }>;
    error?: {
      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
      details?: string | null;
    } | null;
  }>;
  metricDetails?: {
    direction?: StatsV2AnalysisMetricDirection | null;
    hasRun?: boolean | null;
    metricType?: StatsV2AnalysisMetricType | null;
    plannedEffectSize?: { value?: string | null } | null;
  } | null;
  result: Array<{
    comparisonId?: string | null;
    isSignificant?: boolean | null;
    usedDataType?: StatsV2AnalysisStatsDataType | null;
    segmentId?: string | null;
    dimensions: Array<{ value?: string | null; key: string }>;
    groupStats: Array<{ sampleSize?: any | null; id?: string | null }>;
    groups?: { baseline?: string | null; compared?: string | null } | null;
    lastDeteriorationResult?: {
      baselineEstimateAbs?: number | null;
      baselineEstimateRel?: number | null;
      baselineSampleSize?: any | null;
      comparedEstimateAbs?: number | null;
      comparedEstimateRel?: number | null;
      comparedSampleSize?: any | null;
      differenceEstimateAbs?: {
        estimate?: number | null;
        isSignificant?: boolean | null;
        lower?: number | null;
        powered?: number | null;
        upper?: number | null;
      } | null;
    } | null;
    lastResult?: {
      baselineEstimateAbs?: number | null;
      baselineEstimateRel?: number | null;
      baselineSampleSize?: any | null;
      comparedEstimateAbs?: number | null;
      differenceEstimateAbs?: {
        estimate?: number | null;
        lower?: number | null;
        upper?: number | null;
        isSignificant?: boolean | null;
      } | null;
      differenceEstimateRel?: {
        estimate?: number | null;
        lower?: number | null;
        upper?: number | null;
        isSignificant?: boolean | null;
      } | null;
    } | null;
    status?: {
      status?: StatsV2AnalysisMetricResultStatus | null;
      message?: string | null;
      metricType?: StatsV2AnalysisMetricType | null;
      decisionPowered?: boolean | null;
      decisionIsSignificant?: boolean | null;
      validationIsSignificant?: boolean | null;
    } | null;
    result: Array<{
      resultTime?: string | null;
      baselineEstimateAbs?: number | null;
      comparedEstimateAbs?: number | null;
      baselineEstimateRel?: number | null;
      comparedEstimateRel?: number | null;
      varianceReductionRate?: number | null;
      unadjustedEstimateBaseline?: number | null;
      unadjustedEstimateCompared?: number | null;
      baselineSampleSize?: any | null;
      comparedSampleSize?: any | null;
      differenceEstimateAbs?: {
        estimate?: number | null;
        lower?: number | null;
        upper?: number | null;
        isSignificant?: boolean | null;
      } | null;
      differenceEstimateRel?: {
        estimate?: number | null;
        lower?: number | null;
        upper?: number | null;
        isSignificant?: boolean | null;
      } | null;
    }>;
    sampleSize?: {
      current?: any | null;
      required?: any | null;
      poweredEffectRel?: number | null;
      poweredEffectAbs?: number | null;
    } | null;
  }>;
  srmResult: Array<{
    isSignificant?: boolean | null;
    segmentId?: string | null;
    status?: {
      status?: StatsV2AnalysisMetricResultStatus | null;
      message?: string | null;
      metricType?: StatsV2AnalysisMetricType | null;
      decisionPowered?: boolean | null;
      decisionIsSignificant?: boolean | null;
      validationIsSignificant?: boolean | null;
    } | null;
    dimensions: Array<{ key: string; value?: string | null }>;
    result: Array<{
      group?: string | null;
      observed?: number | null;
      expected?: number | null;
      isSignificant?: boolean | null;
    }>;
  }>;
  statsSettings?: {
    method?: StatsV2AnalysisMethod | null;
    adjustedAlpha?: number | null;
    adjustedBeta?: number | null;
    hasVarianceReduction?: boolean | null;
  } | null;
};

export type UpdateWorkflowInstanceSurfacesMutationVariables = Exact<{
  input: PartialWorkflowV1WorkflowInstanceInput;
}>;

export type UpdateWorkflowInstanceSurfacesMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
      }
    | null;
};

export type CheckPermissionsMutationVariables = Exact<{
  workflowInstance: Scalars['String']['input'];
}>;

export type CheckPermissionsMutation = {
  checkPermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1CheckPermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
};

export type CloneMutationVariables = Exact<{
  name: Scalars['String']['input'];
  newDisplayName: Scalars['String']['input'];
}>;

export type CloneMutation = {
  executeFunction?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ExecuteFunctionResponse';
        response?: any | null;
        instance: {
          name: string;
          moduleData: Array<{ key: string; value?: any | null }>;
        };
      }
    | null;
};

export type CloneWorkflowInstanceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type CloneWorkflowInstanceMutation = {
  cloneWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type CreateWorkflowInstanceMutationVariables = Exact<{
  workflowInstance: WorkflowV1WorkflowInstanceInput;
  parent: Scalars['String']['input'];
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateWorkflowInstanceMutation = {
  createWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type CreateWorkflowTemplateMutationVariables = Exact<{
  workflowTemplate: WorkflowV1WorkflowTemplateInput;
}>;

export type CreateWorkflowTemplateMutation = {
  createWorkflowTemplate?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowTemplate';
        name: string;
        displayName: string;
        description?: string | null;
        createTime: string;
        updateTime: string;
        creator:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            };
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        sourceInstance:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowInstance';
              name: string;
              displayName: string;
            };
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type CreateWorkflowVersionMutationVariables = Exact<{
  workflowVersion: WorkflowV1WorkflowVersionInput;
  parent: Scalars['String']['input'];
}>;

export type CreateWorkflowVersionMutation = {
  createWorkflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1WorkflowVersion'; name: string }
    | null;
};

export type DeleteWorkflowInstanceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type DeleteWorkflowInstanceMutation = {
  deleteWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty' }
    | null;
};

export type GetDisplayNamesQueryVariables = Exact<{
  metricsFilter?: InputMaybe<Scalars['String']['input']>;
  entitiesFilter?: InputMaybe<Scalars['String']['input']>;
  assignmentTablesFilter?: InputMaybe<Scalars['String']['input']>;
  factTablesFilter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDisplayNamesQuery = {
  metrics?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListMetricsResponse';
        metrics: Array<{ name: string; displayName: string }>;
      }
    | null;
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        entities: Array<{ name: string; displayName: string }>;
      }
    | null;
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{ name: string; displayName: string }>;
      }
    | null;
  factTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListFactTablesResponse';
        factTables: Array<{ name: string; displayName: string }>;
      }
    | null;
  workflows?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowsResponse';
        workflows: Array<{ name: string; displayName: string }>;
      }
    | null;
};

export type GetWorkflowInstanceQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetWorkflowInstanceQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type GetWorkflowInstanceCreateInfoQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetWorkflowInstanceCreateInfoQuery = {
  workflow?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Workflow';
        name: string;
        workflowInfo: { modules: Array<{ key: string }> };
      }
    | null;
  entities?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListEntitiesResponse';
        entities: Array<{ name: string }>;
      }
    | null;
  assignmentTables?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ListAssignmentTablesResponse';
        assignmentTables: Array<{ name: string }>;
      }
    | null;
};

export type GetWorkflowInstanceEventsQueryVariables = Exact<{
  resource: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  eventTypes?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetWorkflowInstanceEventsQuery = {
  events?:
    | {
        __typename: 'ConnectorsV1ListEventsResponse';
        nextPageToken?: string | null;
        events: Array<{
          name: string;
          pubsubMetadata?: {
            consumeTime?: string | null;
            publishTime?: string | null;
          } | null;
          eventType?:
            | {
                name: string;
                description?: string | null;
                persist?: boolean | null;
              }
            | Record<PropertyKey, never>
            | null;
          cloudEvent?: {
            textData?: string | null;
            protoData?: any | null;
            binaryData?: string | null;
            source?: string | null;
            specVersion?: string | null;
          } | null;
        }>;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
};

export type ListEntityContextOverridesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEntityContextOverridesQuery = {
  evaluationContextFieldOverrides?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListEvaluationContextFieldOverridesResponse';
        evaluationContextFieldOverrides: Array<{
          name: string;
          field: string;
          semanticType?: {
            entityReference?: {
              entity: { name: string } | Record<PropertyKey, never>;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type ListWorkflowInstancesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListWorkflowInstancesQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          displayName: string;
          state: string;
          name: string;
          createTime: string;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'IamV1Identity'; name: string; displayName: string }
            | Record<PropertyKey, never>
            | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          comments?:
            | {
                __typename: 'CollaborationV1ListCommentsResponse';
                comments: Array<{
                  name: string;
                  resolved?: boolean | null;
                  assignee?:
                    | { __typename: 'Error' }
                    | { __typename: 'IamV1Identity'; name: string }
                    | null;
                }>;
              }
            | { __typename: 'Error' }
            | null;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          moduleData: Array<{ value?: any | null; key: string }>;
          moduleData2: {
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            rollout?: {
              variantImageUri?: string | null;
              reach?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
                steps: Array<{
                  durationSincePreviousStep: string;
                  reach: string;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                  updateTime?: string | null;
                }>;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
            decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
          };
        }>;
      }
    | null;
};

export type OnWorkflowInstanceUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnWorkflowInstanceUpdatedSubscription = {
  workflowInstanceUpdated?: {
    workflowInstance?: {
      __typename: 'WorkflowV1WorkflowInstance';
      possibleTransitions: Array<string>;
      lockedDataKeys: Array<string>;
      displayName: string;
      state: string;
      name: string;
      deleteTime?: string | null;
      updateTime: string;
      labels: Array<{ key: string; value?: string | null }>;
      owner?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'IamV1Identity';
            name: string;
            displayName: string;
            pictureUri?: string | null;
          }
        | null;
      surfaces: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Surface';
            name: string;
            displayName: string;
            description?: string | null;
            metricConfig?: {
              metrics: Array<{
                enforcementLevel?: WorkflowV1EnforcementLevel | null;
                metric:
                  | { name: string; displayName: string }
                  | Record<PropertyKey, never>;
              }>;
            } | null;
          }
      >;
      surfaceRequirements: Array<{
        enforcementLevel?: WorkflowV1EnforcementLevel | null;
        reason?: string | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
            }
          | null;
      }>;
      initiatives: Array<
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1Initiative';
            name: string;
            displayName: string;
            description?: string | null;
          }
      >;
      workflowVersion?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1WorkflowVersion';
            name: string;
            workflowInfo?: {
              modules: Array<{ key: string }>;
              functions: Array<{ key: string }>;
            } | null;
          }
        | null;
      stateHistory: Array<{ state?: string | null }>;
      pendingTransition?: {
        succeededSteps: Array<string>;
        targetState: string;
        unprocessedSteps: Array<string>;
        transitionAction: string;
        failedSteps: Array<{
          actionStep: string;
          failuresMessages: Array<string>;
        }>;
      } | null;
      checks: Array<{
        name: string;
        displayName?: string | null;
        state: WorkflowV1WorkflowInstanceCheckState;
        message: string;
        updateTime: string;
        data?: any | null;
        labels: Array<{ key: string; value?: string | null }>;
        parent?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
          | null;
      }>;
      moduleData: Array<{ key: string; value?: any | null }>;
      moduleData2: {
        abtest?: {
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                variants: Array<{
                  description?: string | null;
                  name: string;
                  imageUri?: string | null;
                }>;
              }
            | null;
          treatments?: Array<{
            name?: string | null;
            weight: any;
            displayName?: string | null;
            description?: string | null;
            imageUri?: string | null;
            variant:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
          }> | null;
          rollout?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
        } | null;
        flags?: {
          targetingKeySelector?: string | null;
          stickyAssignments?: boolean | null;
          ignoreTargetingForSticky?: boolean | null;
          intakePaused?: boolean | null;
          flag?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
          segment?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FlagsAdminV1Segment';
                name: string;
                displayName?: string | null;
                description?: string | null;
                state?: FlagsAdminV1SegmentState | null;
                createTime: string;
                updateTime: string;
                flag?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FlagsAdminV1Flag';
                      name: string;
                      displayName: string;
                    }
                  | null;
                workflowInstance?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    }
                  | null;
                owner?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
                allocation?: {
                  exclusiveTo: Array<string>;
                  exclusivityTags: Array<string>;
                  proportion?: { value?: string | null } | null;
                } | null;
                targeting?: {
                  criteria: Array<{
                    key: string;
                    value?: {
                      attribute?: {
                        attributeName?: string | null;
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                        anyRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                        allRule?: {
                          rule?: {
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                          } | null;
                        } | null;
                      } | null;
                      segment?: {
                        segment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1Segment';
                              name: string;
                              displayName?: string | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                            }
                          | null;
                      } | null;
                      materializedSegment?: {
                        materializedSegment?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'FlagsAdminV1MaterializedSegment';
                              name: string;
                              displayName: string;
                            }
                          | null;
                      } | null;
                    } | null;
                  }>;
                  expression?: {
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  } | null;
                } | null;
                labels: Array<{ key: string; value?: string | null }>;
                resourceRelations?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'FgaV1ListResourceRelationsResponse';
                      resourceRelations: Array<{
                        relation: string;
                        resource: string;
                      }>;
                    }
                  | null;
              }
            | null;
          rule?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'FlagsAdminV1FlagRule'; name: string }
            | null;
        } | null;
        hypothesis?: { text?: string | null } | null;
        decision?: {
          outcome?: DecisionRecordDataOutcome | null;
          conclusion?: string | null;
          treatment?: string | null;
        } | null;
        reviews?: {
          __typename: 'ReviewsData';
          approvalRequired?: boolean | null;
          reviewId?: string | null;
          status?: ReviewsDataStatus | null;
          optionalReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
          requiredReviews?: Array<{
            __typename: 'ReviewsDataSurfaceReviewData';
            state: ReviewsDataSurfaceReviewDataState;
            responses?: Array<{
              __typename: 'ReviewsDataSurfaceReviewDataResponse';
              id?: string | null;
              state: ReviewsDataSurfaceReviewDataResponseState;
              stale?: boolean | null;
              commentId?: string | null;
              groups?: Array<
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  }
              > | null;
              reviewer:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    name: string;
                    displayName: string;
                    pictureUri?: string | null;
                    service?: string | null;
                    everyone?: boolean | null;
                    user?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1User';
                          name: string;
                          fullName: string;
                          email: string;
                          pictureUri?: string | null;
                          scimExternalId?: string | null;
                          lastLoginTime?: string | null;
                        }
                      | null;
                    apiClient?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1ApiClient';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          clientId: string;
                          clientSecret?: string | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | null;
                    group?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Group';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          groupType: IamV1GroupGroupType;
                          slackChannel?: string | null;
                          createTime: string;
                          updateTime: string;
                          identity:
                            | { name: string }
                            | Record<PropertyKey, never>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{
                                  relation: string;
                                  resource: string;
                                }>;
                              }
                            | null;
                        }
                      | null;
                    agent?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Agent';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                          reviewerSkill?: { enabled: boolean } | null;
                        }
                      | null;
                  };
            }> | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
          }> | null;
        } | null;
        planning?: {
          planned?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
          actual?: {
            startTime?: string | null;
            endTime?: string | null;
            runtime?: string | null;
          } | null;
        } | null;
        samplesize?: {
          error?: string | null;
          useScheduledCalculation?: boolean | null;
          requiredSampleSize?: any | null;
          state?: SampleSizeDataState | null;
          exposure?:
            | {
                exposureCalculation?: any | null;
                scheduledExposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                assignmentTable: {
                  assignmentTable?: string | null;
                  filters?: { assignmentFilter?: any | null } | null;
                };
              }
            | {
                exposureCalculation?: any | null;
                startTime?: string | null;
                endTime?: string | null;
                existingInstance: {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                };
              }
            | null;
          exposureSource?:
            | {
                assignmentTable?: string | null;
                customStartTime?: string | null;
                customEndTime?: string | null;
                filters?: {
                  assignmentFilter?: any | null;
                  entityFilter?: any | null;
                  exposureFilter?: string | null;
                } | null;
              }
            | {
                workflowInstance:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1WorkflowInstance';
                      name: string;
                      displayName: string;
                    };
              }
            | null;
          metrics?: Array<{
            error?: string | null;
            metric: string;
            metricCalculation?: any | null;
            scheduledMetricCalculation?: any | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataSampleSizeMetricState | null;
            type?: SampleSizeDataSampleSizeMetricType | null;
            metricCalculationName?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1MetricCalculation';
                  name: string;
                  state?: MetricsV1MetricCalculationState | null;
                }
              | null;
            summaryStats?: {
              mean?: number | null;
              variance?: number | null;
              varianceReductionRate?: number | null;
              count?: any | null;
            } | null;
            observedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              mean?: number | null;
              variance?: number | null;
              expectedSampleSize?: any | null;
            }> | null;
            forecastedData?: Array<{
              dayIndex: any;
              requiredSampleSize?: any | null;
              expectedSampleSize?: any | null;
            }> | null;
          }> | null;
        } | null;
        metrics?: {
          bucket?: MetricsDataBucket | null;
          assignmentTable?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1AssignmentTable';
                name: string;
                displayName: string;
                dimensions: Array<{ name: string }>;
                dataWarehouse?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1DataWarehouse'; name: string }
                  | null;
              }
            | null;
          exposureTableSchedule?:
            | {
                __typename: 'MetricsV1ScheduledExposureCalculation';
                name: string;
              }
            | Record<PropertyKey, never>
            | null;
          metrics: Array<{
            __typename: 'MetricsDataMetric';
            preferredDirection?: MetricsDataMetricPreferredDirection | null;
            surfaceOnly?: boolean | null;
            metric:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Metric';
                  displayName: string;
                  name: string;
                  description?: string | null;
                  createTime: string;
                  updateTime: string;
                  deleteTime?: string | null;
                  state?: MetricsV1MetricState | null;
                  preferredDirection?: MetricsV1MetricPreferredDirection | null;
                  measurement?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Measurement';
                        name: string;
                        displayName: string;
                        typeSpec: {
                          averageMetricSpec?: {
                            measurement?: { name: string } | null;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                          ratioMetricSpec?: {
                            numerator?: { name: string } | null;
                            numeratorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                            denominator?: { name: string } | null;
                            denominatorAggregation: {
                              type: MetricsV1AggregationType;
                            };
                          } | null;
                          quantileMetricSpec?: {
                            quantileLevel: number;
                            aggregation: { type: MetricsV1AggregationType };
                          } | null;
                        };
                        filter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        factTable:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            };
                        nullHandling?: {
                          replaceEntityNullWithZero?: boolean | null;
                        } | null;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        displayName: string;
                        name: string;
                        everyone?: boolean | null;
                        user?:
                          | { pictureUri?: string | null; name: string }
                          | Record<PropertyKey, never>
                          | null;
                        group?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        apiClient?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | null;
                  factTable?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | null;
                  filter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  entity?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1Entity';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  measurementConfig?: {
                    closedWindow?: {
                      aggregationWindow: string;
                      exposureOffset: string;
                    } | null;
                    semiOpenWindow?: {
                      aggregationWindow: string;
                      exposureOffset?: string | null;
                    } | null;
                    openWindow?: { dummy?: string | null } | null;
                  } | null;
                  varianceReductionConfig?: {
                    aggregationWindowOverride?: string | null;
                    disabled?: boolean | null;
                  } | null;
                  nullHandling?: {
                    replaceEntityNullWithZero?: boolean | null;
                  } | null;
                  typeSpec?: {
                    ratioMetricSpec?: {
                      numerator?: { name: string } | null;
                      numeratorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      numeratorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      denominator?: { name: string } | null;
                      denominatorAggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                      denominatorFilter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                    } | null;
                    averageMetricSpec?: {
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                    quantileMetricSpec?: {
                      quantileLevel: number;
                      measurement?: {
                        name: string;
                        type?: MetricsV1ColumnType | null;
                      } | null;
                      aggregation: {
                        type: MetricsV1AggregationType;
                        threshold?: {
                          direction: MetricsV1AggregationThresholdDirection;
                          threshold: { value?: string | null };
                        } | null;
                        cap?: {
                          min?: { value?: string | null } | null;
                          max?: { value?: string | null } | null;
                        } | null;
                      };
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  archiveInfo?: {
                    reason?: string | null;
                    archiveTime?: string | null;
                  } | null;
                  defaultEffectSize?: { value?: string | null } | null;
                  source?: {
                    type?: MetricsV1MetricMetricSourceType | null;
                    reference?: string | null;
                  } | null;
                  verification?: {
                    state?: MetricsV1MetricMetricVerificationVerificationState | null;
                    verifyTime?: string | null;
                    verifier?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                  } | null;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{ relation: string }>;
                      }
                    | null;
                };
            schedule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1ScheduledMetricCalculation';
                  name: string;
                  state?: MetricsV1ScheduledMetricCalculationState | null;
                  nextScheduledRunTime: string;
                  nextExposureStartTime: string;
                  nextExposureEndTime: string;
                  iteration: number;
                  executedCalculationsCount: number;
                  status: {
                    scheduled?: { nextScheduleTime: string } | null;
                    cancelled?: { cancelledTime: string } | null;
                    calculating?: {
                      metricCalculation:
                        | { name: string }
                        | Record<PropertyKey, never>;
                    } | null;
                    waiting?: {
                      dataDeliveredUntilTime?: string | null;
                      needDataUntilTime: string;
                      exposureTable?:
                        | { name: string }
                        | Record<PropertyKey, never>
                        | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    } | null;
                    error?: { errorMessage: string } | null;
                  };
                  metricCalculationSpec: {
                    metric:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Metric';
                          name: string;
                          displayName: string;
                          nullHandling?: {
                            __typename: 'MetricsV1MetricNullHandlingConfig';
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                          measurementConfig?: {
                            closedWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                              aggregationWindow: string;
                              exposureOffset: string;
                            } | null;
                            semiOpenWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                              aggregationWindow: string;
                              exposureOffset?: string | null;
                            } | null;
                            openWindow?: {
                              __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                            } | null;
                          } | null;
                          factTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                dataDeliveredUntilUpdateStrategyConfig?: {
                                  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                  disableEmptyPartitions?: boolean | null;
                                  automaticUpdateConfig?: {
                                    commitDelay: string;
                                    changeThreshold?: {
                                      value?: string | null;
                                    } | null;
                                  } | null;
                                  dailyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                  hourlyUpdateConfig?: {
                                    __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                    maxZeroDuration?: string | null;
                                  } | null;
                                } | null;
                                partitionedUpdateStrategyState?: {
                                  currentPartitionLastCheckTime?: string | null;
                                  existsCheckDuration?: string | null;
                                  state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                  usualLateness?: string | null;
                                } | null;
                              }
                            | null;
                        };
                    exposureTable:
                      | {
                          __typename: 'MetricsV1ExposureTable';
                          scheduledExposureCalculation?:
                            | {
                                __typename: 'MetricsV1ScheduledExposureCalculation';
                                name: string;
                                exposureCalculationSpec: {
                                  __typename: 'MetricsV1ExposureCalculationSpec';
                                  assignmentTable:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'MetricsV1AssignmentTable';
                                        name: string;
                                        dataDeliveredUntilUpdateStrategyConfig?: {
                                          strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                          disableEmptyPartitions?:
                                            | boolean
                                            | null;
                                          automaticUpdateConfig?: {
                                            commitDelay: string;
                                            changeThreshold?: {
                                              value?: string | null;
                                            } | null;
                                          } | null;
                                          dailyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                          hourlyUpdateConfig?: {
                                            __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                            maxZeroDuration?: string | null;
                                          } | null;
                                        } | null;
                                      };
                                };
                                status: {
                                  calculating?: {
                                    exposureCalculation:
                                      | { name: string }
                                      | Record<PropertyKey, never>;
                                  } | null;
                                  cancelled?: { cancelledTime: string } | null;
                                  error?: { errorMessage: string } | null;
                                  waiting?: {
                                    dataDeliveredUntilTime?: string | null;
                                    needDataUntilTime: string;
                                    assignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          displayName: string;
                                        }
                                      | null;
                                  } | null;
                                  scheduled?: {
                                    nextScheduleTime: string;
                                  } | null;
                                };
                              }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | Record<PropertyKey, never>;
                    measurementTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1MeasurementTable';
                          name: string;
                        }
                      | null;
                  };
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | null;
            metricRole:
              | {
                  nonInferiorityMargin?: number | null;
                  guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                }
              | {
                  minimumDetectableEffect?: number | null;
                  successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                };
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                  deleteTime?: string | null;
                }
              | null;
            calculation?:
              | { __typename: 'MetricsV1MetricCalculation'; name: string }
              | Record<PropertyKey, never>
              | null;
          }>;
          filters?: Array<{
            displayName?: string | null;
            factTable?:
              | {
                  __typename: 'MetricsV1FactTable';
                  name: string;
                  displayName: string;
                  labels: Array<{ key: string; value?: string | null }>;
                }
              | Record<PropertyKey, never>
              | null;
            filter?: { criteria: any; expression: any } | null;
          }> | null;
          entity?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1Entity';
                name: string;
                displayName: string;
              }
            | null;
        } | null;
        stats?: {
          testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
          analysisResults?: Array<{
            exposureFilterName?: string | null;
            analysisResult:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'StatsV2AnalysisAnalysisResult';
                  name: string;
                  exposureFilter?: string | null;
                  updateTime: string;
                  annotations: Array<{
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                  }>;
                  results: Array<{
                    id?: string | null;
                    annotations: Array<{
                      info?: string | null;
                      warning?: string | null;
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                      error?: {
                        category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                        details?: string | null;
                      } | null;
                    }>;
                    metricDetails?: {
                      direction?: StatsV2AnalysisMetricDirection | null;
                      hasRun?: boolean | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      plannedEffectSize?: { value?: string | null } | null;
                    } | null;
                    result: Array<{
                      comparisonId?: string | null;
                      isSignificant?: boolean | null;
                      usedDataType?: StatsV2AnalysisStatsDataType | null;
                      segmentId?: string | null;
                      dimensions: Array<{ value?: string | null; key: string }>;
                      groupStats: Array<{
                        sampleSize?: any | null;
                        id?: string | null;
                      }>;
                      groups?: {
                        baseline?: string | null;
                        compared?: string | null;
                      } | null;
                      lastDeteriorationResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        comparedEstimateRel?: number | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          isSignificant?: boolean | null;
                          lower?: number | null;
                          powered?: number | null;
                          upper?: number | null;
                        } | null;
                      } | null;
                      lastResult?: {
                        baselineEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        baselineSampleSize?: any | null;
                        comparedEstimateAbs?: number | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      } | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      result: Array<{
                        resultTime?: string | null;
                        baselineEstimateAbs?: number | null;
                        comparedEstimateAbs?: number | null;
                        baselineEstimateRel?: number | null;
                        comparedEstimateRel?: number | null;
                        varianceReductionRate?: number | null;
                        unadjustedEstimateBaseline?: number | null;
                        unadjustedEstimateCompared?: number | null;
                        baselineSampleSize?: any | null;
                        comparedSampleSize?: any | null;
                        differenceEstimateAbs?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                        differenceEstimateRel?: {
                          estimate?: number | null;
                          lower?: number | null;
                          upper?: number | null;
                          isSignificant?: boolean | null;
                        } | null;
                      }>;
                      sampleSize?: {
                        current?: any | null;
                        required?: any | null;
                        poweredEffectRel?: number | null;
                        poweredEffectAbs?: number | null;
                      } | null;
                    }>;
                    srmResult: Array<{
                      isSignificant?: boolean | null;
                      segmentId?: string | null;
                      status?: {
                        status?: StatsV2AnalysisMetricResultStatus | null;
                        message?: string | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        decisionPowered?: boolean | null;
                        decisionIsSignificant?: boolean | null;
                        validationIsSignificant?: boolean | null;
                      } | null;
                      dimensions: Array<{ key: string; value?: string | null }>;
                      result: Array<{
                        group?: string | null;
                        observed?: number | null;
                        expected?: number | null;
                        isSignificant?: boolean | null;
                      }>;
                    }>;
                    statsSettings?: {
                      method?: StatsV2AnalysisMethod | null;
                      adjustedAlpha?: number | null;
                      adjustedBeta?: number | null;
                      hasVarianceReduction?: boolean | null;
                    } | null;
                  }>;
                  treatments: Array<{
                    id?: string | null;
                    recommendation?: {
                      shipping?: StatsV2AnalysisShippingRecommendation | null;
                      status?: {
                        quality?: StatsV2AnalysisQualityStatus | null;
                        tanking?: StatsV2AnalysisTankingStatus | null;
                        guardrail?: StatsV2AnalysisGuardrailStatus | null;
                        success?: StatsV2AnalysisSuccessStatus | null;
                      } | null;
                    } | null;
                  }>;
                };
          }> | null;
          metricMethods?: Array<{
            metricName: string;
            method: StatsDataMethodMethod;
          }> | null;
        } | null;
        explore?: {
          exploratoryAnalyses: Array<{
            createTime: string;
            updateTime: string;
            id: string;
            messages: Array<string>;
            name: string;
            splitByExposureFilters?: boolean | null;
            startTime?: string | null;
            endTime?: string | null;
            useCustomDateRange?: boolean | null;
            state: ExploreDataAnalysisState;
            useScheduledCalculation?: boolean | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            conclusion?: { updateTime: string; text: string } | null;
            metrics: Array<{
              calculationError?: string | null;
              name:
                | {
                    name: string;
                    displayName: string;
                    description?: string | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                    entity?:
                      | {
                          __typename: 'MetricsV1Entity';
                          createTime: string;
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          defaultAssignmentTable?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | Record<PropertyKey, never>;
              dimensions: Array<
                | {
                    column: string;
                    dimensionTable?:
                      | {
                          __typename: 'MetricsV1DimensionTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          state: MetricsV1TableState;
                          dimensionDataDeliveredUntilTime?: string | null;
                          sql: string;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                name: string;
                                displayName: string;
                                pictureUri?: string | null;
                              }
                            | null;
                          entityColumnMapping: {
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  createTime: string;
                                  name: string;
                                  displayName: string;
                                  primaryKeyType: MetricsV1ColumnType;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                  resourceRelations?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        __typename: 'FgaV1ListResourceRelationsResponse';
                                        resourceRelations: Array<{
                                          relation: string;
                                        }>;
                                      }
                                    | null;
                                  defaultAssignmentTable?:
                                    | {
                                        __typename: 'Error';
                                        message?: string | null;
                                        code: ErrorCode;
                                      }
                                    | {
                                        name: string;
                                        displayName: string;
                                        state: MetricsV1TableState;
                                      }
                                    | null;
                                };
                            column: { name: string };
                          };
                          dimensions: Array<{ name: string }>;
                          labels: Array<{ key: string; value?: string | null }>;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                          timeConfig?: {
                            window: string;
                            timestampColumn: {
                              name: string;
                              type?: MetricsV1ColumnType | null;
                            };
                          } | null;
                          valueMappings: Array<{
                            column: string;
                            mappings: Array<{
                              inputDimensionValue?: string | null;
                              outputDimensionValue?: string | null;
                            }>;
                          }>;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | {
                    column: string;
                    factTable:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          description?: string | null;
                          sql: string;
                          state: MetricsV1TableState;
                          factDataDeliveredUntilTime?: string | null;
                          timestampColumn: { name: string };
                          owner?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'IamV1Identity';
                                displayName: string;
                                name: string;
                                everyone?: boolean | null;
                                user?:
                                  | { pictureUri?: string | null; name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                group?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                                apiClient?:
                                  | { name: string }
                                  | Record<PropertyKey, never>
                                  | null;
                              }
                            | null;
                          entities: Array<{
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            column: { name: string };
                          }>;
                          measures: Array<{
                            declaredType?: MetricsV1ColumnType | null;
                            column: { name: string };
                            unit?: {
                              baseUnitMultiplier?: number | null;
                              baseUnit?: MetricsV1UnitBaseUnit | null;
                              currencyCode?: string | null;
                              customUnit?: string | null;
                            } | null;
                          }>;
                          dimensions: Array<{ name: string }>;
                          dataDeliveredUntilUpdateStrategyConfig?: {
                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                            disableEmptyPartitions?: boolean | null;
                            automaticUpdateConfig?: {
                              commitDelay: string;
                              changeThreshold?: {
                                value?: string | null;
                              } | null;
                            } | null;
                            dailyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                            hourlyUpdateConfig?: {
                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                              maxZeroDuration?: string | null;
                            } | null;
                          } | null;
                          error?: {
                            details: Array<string>;
                            message?: string | null;
                          } | null;
                          schemaValidationJob:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1SqlJob';
                                name: string;
                                successfulQueryResult?: {
                                  schema: Array<{
                                    name: string;
                                    type?: MetricsV1ColumnType | null;
                                  }>;
                                } | null;
                              };
                          source?: {
                            type?: MetricsV1MetricMetricSourceType | null;
                            reference?: string | null;
                          } | null;
                          labels: Array<{ key: string; value?: string | null }>;
                          resourceRelations?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FgaV1ListResourceRelationsResponse';
                                resourceRelations: Array<{ relation: string }>;
                              }
                            | null;
                        }
                      | Record<PropertyKey, never>;
                  }
              >;
              calculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              scheduledCalculation?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                  }
                | null;
            }>;
            createdBy?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1User';
                  name: string;
                  fullName: string;
                  email: string;
                  pictureUri?: string | null;
                  lastLoginTime?: string | null;
                }
              | null;
          }>;
        } | null;
        rollout?: {
          variantImageUri?: string | null;
          reach?: string | null;
          initialReach?: string | null;
          controlAssignmentId?: string | null;
          description?: string | null;
          monitoringDisabled: boolean;
          treatmentGroupProportion?: number | null;
          variantAssignmentId?: string | null;
          schedule?: {
            state?: RolloutDataScheduleState | null;
            stateReason?: {
              failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
            } | null;
            steps: Array<{
              durationSincePreviousStep: string;
              reach: string;
              status?: RolloutDataScheduleScheduleStepsStatus | null;
              updateTime?: string | null;
            }>;
          } | null;
          variant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          abtest?:
            | { __typename: 'Error' }
            | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
            | null;
          controlVariant?:
            | { __typename: 'Error' }
            | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
            | null;
          flag?:
            | { __typename: 'Error' }
            | {
                __typename: 'FlagsAdminV1Flag';
                name: string;
                clients: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Client';
                      name: string;
                      displayName: string;
                      createTime: string;
                      deleteTime?: string | null;
                    }
                >;
              }
            | null;
        } | null;
      };
      resourceRelations?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FgaV1ListResourceRelationsResponse';
            resourceRelations: Array<{ relation: string }>;
          }
        | null;
      queryWorkflowInstancePermissions?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
            isAllAllowed?: boolean | null;
            actionPermissionCheckResults: Array<{
              action?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
            functionPermissionCheckResults: Array<{
              function?: string | null;
              isAllowed?: boolean | null;
              permissionChecks: Array<{
                isAllowed?: boolean | null;
                relation?: string | null;
                resource?: string | null;
              }>;
            }>;
          }
        | null;
      transitionStatus?: {
        action: string;
        initiator:
          | { name: string; displayName: string }
          | Record<PropertyKey, never>;
        running?: { startTime: string } | null;
        completed?: { startTime: string; endTime: string } | null;
        failed?: { startTime: string; endTime: string; error: string } | null;
      } | null;
    } | null;
  } | null;
};

export type PendingTransitionFragment = {
  succeededSteps: Array<string>;
  targetState: string;
  unprocessedSteps: Array<string>;
  transitionAction: string;
  failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
};

export type SaveWorkflowInstanceModuleDataMutationVariables = Exact<{
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
}>;

export type SaveWorkflowInstanceModuleDataMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        possibleTransitions: Array<string>;
        lockedDataKeys: Array<string>;
        displayName: string;
        state: string;
        name: string;
        deleteTime?: string | null;
        updateTime: string;
        labels: Array<{ key: string; value?: string | null }>;
        owner?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1Identity';
              name: string;
              displayName: string;
              pictureUri?: string | null;
            }
          | null;
        surfaces: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              metricConfig?: {
                metrics: Array<{
                  enforcementLevel?: WorkflowV1EnforcementLevel | null;
                  metric:
                    | { name: string; displayName: string }
                    | Record<PropertyKey, never>;
                }>;
              } | null;
            }
        >;
        surfaceRequirements: Array<{
          enforcementLevel?: WorkflowV1EnforcementLevel | null;
          reason?: string | null;
          surface?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
              }
            | null;
        }>;
        initiatives: Array<
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Initiative';
              name: string;
              displayName: string;
              description?: string | null;
            }
        >;
        workflowVersion?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1WorkflowVersion';
              name: string;
              workflowInfo?: {
                modules: Array<{ key: string }>;
                functions: Array<{ key: string }>;
              } | null;
            }
          | null;
        stateHistory: Array<{ state?: string | null }>;
        pendingTransition?: {
          succeededSteps: Array<string>;
          targetState: string;
          unprocessedSteps: Array<string>;
          transitionAction: string;
          failedSteps: Array<{
            actionStep: string;
            failuresMessages: Array<string>;
          }>;
        } | null;
        checks: Array<{
          name: string;
          displayName?: string | null;
          state: WorkflowV1WorkflowInstanceCheckState;
          message: string;
          updateTime: string;
          data?: any | null;
          labels: Array<{ key: string; value?: string | null }>;
          parent?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
            | null;
        }>;
        moduleData: Array<{ key: string; value?: any | null }>;
        moduleData2: {
          abtest?: {
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  variants: Array<{
                    description?: string | null;
                    name: string;
                    imageUri?: string | null;
                  }>;
                }
              | null;
            treatments?: Array<{
              name?: string | null;
              weight: any;
              displayName?: string | null;
              description?: string | null;
              imageUri?: string | null;
              variant:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
            }> | null;
            rollout?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
          } | null;
          flags?: {
            targetingKeySelector?: string | null;
            stickyAssignments?: boolean | null;
            ignoreTargetingForSticky?: boolean | null;
            intakePaused?: boolean | null;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
            segment?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Segment';
                  name: string;
                  displayName?: string | null;
                  description?: string | null;
                  state?: FlagsAdminV1SegmentState | null;
                  createTime: string;
                  updateTime: string;
                  flag?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FlagsAdminV1Flag';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  workflowInstance?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      }
                    | null;
                  owner?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                      }
                    | null;
                  allocation?: {
                    exclusiveTo: Array<string>;
                    exclusivityTags: Array<string>;
                    proportion?: { value?: string | null } | null;
                  } | null;
                  targeting?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attributeName?: string | null;
                          eqRule?: {
                            value?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              versionValue?: { version?: string | null } | null;
                            } | null;
                          } | null;
                          startsWithRule?: { value?: string | null } | null;
                          containsRule?: { value?: string | null } | null;
                          endsWithRule?: { value?: string | null } | null;
                          anyRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                          allRule?: {
                            rule?: {
                              eqRule?: {
                                value?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  versionValue?: {
                                    version?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              startsWithRule?: { value?: string | null } | null;
                              containsRule?: { value?: string | null } | null;
                              endsWithRule?: { value?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                        segment?: {
                          segment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1Segment';
                                name: string;
                                displayName?: string | null;
                                labels: Array<{
                                  key: string;
                                  value?: string | null;
                                }>;
                              }
                            | null;
                        } | null;
                        materializedSegment?: {
                          materializedSegment?:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'FlagsAdminV1MaterializedSegment';
                                name: string;
                                displayName: string;
                              }
                            | null;
                        } | null;
                      } | null;
                    }>;
                    expression?: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    } | null;
                  } | null;
                  labels: Array<{ key: string; value?: string | null }>;
                  resourceRelations?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'FgaV1ListResourceRelationsResponse';
                        resourceRelations: Array<{
                          relation: string;
                          resource: string;
                        }>;
                      }
                    | null;
                }
              | null;
            rule?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'FlagsAdminV1FlagRule'; name: string }
              | null;
          } | null;
          hypothesis?: { text?: string | null } | null;
          decision?: {
            outcome?: DecisionRecordDataOutcome | null;
            conclusion?: string | null;
            treatment?: string | null;
          } | null;
          reviews?: {
            __typename: 'ReviewsData';
            approvalRequired?: boolean | null;
            reviewId?: string | null;
            status?: ReviewsDataStatus | null;
            optionalReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
            requiredReviews?: Array<{
              __typename: 'ReviewsDataSurfaceReviewData';
              state: ReviewsDataSurfaceReviewDataState;
              responses?: Array<{
                __typename: 'ReviewsDataSurfaceReviewDataResponse';
                id?: string | null;
                state: ReviewsDataSurfaceReviewDataResponseState;
                stale?: boolean | null;
                commentId?: string | null;
                groups?: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    }
                > | null;
                reviewer:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      service?: string | null;
                      everyone?: boolean | null;
                      user?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1User';
                            name: string;
                            fullName: string;
                            email: string;
                            pictureUri?: string | null;
                            scimExternalId?: string | null;
                            lastLoginTime?: string | null;
                          }
                        | null;
                      apiClient?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1ApiClient';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            clientId: string;
                            clientSecret?: string | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      group?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Group';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            groupType: IamV1GroupGroupType;
                            slackChannel?: string | null;
                            createTime: string;
                            updateTime: string;
                            identity:
                              | { name: string }
                              | Record<PropertyKey, never>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                    resource: string;
                                  }>;
                                }
                              | null;
                          }
                        | null;
                      agent?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Agent';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                            reviewerSkill?: { enabled: boolean } | null;
                          }
                        | null;
                    };
              }> | null;
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
            }> | null;
          } | null;
          planning?: {
            planned?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
            actual?: {
              startTime?: string | null;
              endTime?: string | null;
              runtime?: string | null;
            } | null;
          } | null;
          samplesize?: {
            error?: string | null;
            useScheduledCalculation?: boolean | null;
            requiredSampleSize?: any | null;
            state?: SampleSizeDataState | null;
            exposure?:
              | {
                  exposureCalculation?: any | null;
                  scheduledExposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  assignmentTable: {
                    assignmentTable?: string | null;
                    filters?: { assignmentFilter?: any | null } | null;
                  };
                }
              | {
                  exposureCalculation?: any | null;
                  startTime?: string | null;
                  endTime?: string | null;
                  existingInstance: {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  };
                }
              | null;
            exposureSource?:
              | {
                  assignmentTable?: string | null;
                  customStartTime?: string | null;
                  customEndTime?: string | null;
                  filters?: {
                    assignmentFilter?: any | null;
                    entityFilter?: any | null;
                    exposureFilter?: string | null;
                  } | null;
                }
              | {
                  workflowInstance:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'WorkflowV1WorkflowInstance';
                        name: string;
                        displayName: string;
                      };
                }
              | null;
            metrics?: Array<{
              error?: string | null;
              metric: string;
              metricCalculation?: any | null;
              scheduledMetricCalculation?: any | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataSampleSizeMetricState | null;
              type?: SampleSizeDataSampleSizeMetricType | null;
              metricCalculationName?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1MetricCalculation';
                    name: string;
                    state?: MetricsV1MetricCalculationState | null;
                  }
                | null;
              summaryStats?: {
                mean?: number | null;
                variance?: number | null;
                varianceReductionRate?: number | null;
                count?: any | null;
              } | null;
              observedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                mean?: number | null;
                variance?: number | null;
                expectedSampleSize?: any | null;
              }> | null;
              forecastedData?: Array<{
                dayIndex: any;
                requiredSampleSize?: any | null;
                expectedSampleSize?: any | null;
              }> | null;
            }> | null;
          } | null;
          metrics?: {
            bucket?: MetricsDataBucket | null;
            assignmentTable?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1AssignmentTable';
                  name: string;
                  displayName: string;
                  dimensions: Array<{ name: string }>;
                  dataWarehouse?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | { __typename: 'MetricsV1DataWarehouse'; name: string }
                    | null;
                }
              | null;
            exposureTableSchedule?:
              | {
                  __typename: 'MetricsV1ScheduledExposureCalculation';
                  name: string;
                }
              | Record<PropertyKey, never>
              | null;
            metrics: Array<{
              __typename: 'MetricsDataMetric';
              preferredDirection?: MetricsDataMetricPreferredDirection | null;
              surfaceOnly?: boolean | null;
              metric:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Metric';
                    displayName: string;
                    name: string;
                    description?: string | null;
                    createTime: string;
                    updateTime: string;
                    deleteTime?: string | null;
                    state?: MetricsV1MetricState | null;
                    preferredDirection?: MetricsV1MetricPreferredDirection | null;
                    measurement?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Measurement';
                          name: string;
                          displayName: string;
                          typeSpec: {
                            averageMetricSpec?: {
                              measurement?: { name: string } | null;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                            ratioMetricSpec?: {
                              numerator?: { name: string } | null;
                              numeratorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                              denominator?: { name: string } | null;
                              denominatorAggregation: {
                                type: MetricsV1AggregationType;
                              };
                            } | null;
                            quantileMetricSpec?: {
                              quantileLevel: number;
                              aggregation: { type: MetricsV1AggregationType };
                            } | null;
                          };
                          filter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          entity:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1Entity';
                                name: string;
                                displayName: string;
                              };
                          factTable:
                            | {
                                __typename: 'Error';
                                message?: string | null;
                                code: ErrorCode;
                              }
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              };
                          nullHandling?: {
                            replaceEntityNullWithZero?: boolean | null;
                          } | null;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          displayName: string;
                          name: string;
                          everyone?: boolean | null;
                          user?:
                            | { pictureUri?: string | null; name: string }
                            | Record<PropertyKey, never>
                            | null;
                          group?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          apiClient?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                        }
                      | null;
                    factTable?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | null;
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    measurementConfig?: {
                      closedWindow?: {
                        aggregationWindow: string;
                        exposureOffset: string;
                      } | null;
                      semiOpenWindow?: {
                        aggregationWindow: string;
                        exposureOffset?: string | null;
                      } | null;
                      openWindow?: { dummy?: string | null } | null;
                    } | null;
                    varianceReductionConfig?: {
                      aggregationWindowOverride?: string | null;
                      disabled?: boolean | null;
                    } | null;
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                    typeSpec?: {
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        numeratorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                        denominatorFilter?: {
                          criteria: Array<{
                            key: string;
                            value?: {
                              attribute?: {
                                attribute: string;
                                eqRule?: {
                                  value: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  };
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    nullValue?: {
                                      dummyField?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                likeRule?: { pattern: string } | null;
                              } | null;
                            } | null;
                          }>;
                          expression: {
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          };
                        } | null;
                      } | null;
                      averageMetricSpec?: {
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        measurement?: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        } | null;
                        aggregation: {
                          type: MetricsV1AggregationType;
                          threshold?: {
                            direction: MetricsV1AggregationThresholdDirection;
                            threshold: { value?: string | null };
                          } | null;
                          cap?: {
                            min?: { value?: string | null } | null;
                            max?: { value?: string | null } | null;
                          } | null;
                        };
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    archiveInfo?: {
                      reason?: string | null;
                      archiveTime?: string | null;
                    } | null;
                    defaultEffectSize?: { value?: string | null } | null;
                    source?: {
                      type?: MetricsV1MetricMetricSourceType | null;
                      reference?: string | null;
                    } | null;
                    verification?: {
                      state?: MetricsV1MetricMetricVerificationVerificationState | null;
                      verifyTime?: string | null;
                      verifier?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                    } | null;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{ relation: string }>;
                        }
                      | null;
                  };
              schedule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1ScheduledMetricCalculation';
                    name: string;
                    state?: MetricsV1ScheduledMetricCalculationState | null;
                    nextScheduledRunTime: string;
                    nextExposureStartTime: string;
                    nextExposureEndTime: string;
                    iteration: number;
                    executedCalculationsCount: number;
                    status: {
                      scheduled?: { nextScheduleTime: string } | null;
                      cancelled?: { cancelledTime: string } | null;
                      calculating?: {
                        metricCalculation:
                          | { name: string }
                          | Record<PropertyKey, never>;
                      } | null;
                      waiting?: {
                        dataDeliveredUntilTime?: string | null;
                        needDataUntilTime: string;
                        exposureTable?:
                          | { name: string }
                          | Record<PropertyKey, never>
                          | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              state: MetricsV1TableState;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      } | null;
                      error?: { errorMessage: string } | null;
                    };
                    metricCalculationSpec: {
                      metric:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Metric';
                            name: string;
                            displayName: string;
                            nullHandling?: {
                              __typename: 'MetricsV1MetricNullHandlingConfig';
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                            measurementConfig?: {
                              closedWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                aggregationWindow: string;
                                exposureOffset: string;
                              } | null;
                              semiOpenWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                aggregationWindow: string;
                                exposureOffset?: string | null;
                              } | null;
                              openWindow?: {
                                __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                              } | null;
                            } | null;
                            factTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  dataDeliveredUntilUpdateStrategyConfig?: {
                                    strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                    disableEmptyPartitions?: boolean | null;
                                    automaticUpdateConfig?: {
                                      commitDelay: string;
                                      changeThreshold?: {
                                        value?: string | null;
                                      } | null;
                                    } | null;
                                    dailyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                    hourlyUpdateConfig?: {
                                      __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                      maxZeroDuration?: string | null;
                                    } | null;
                                  } | null;
                                  partitionedUpdateStrategyState?: {
                                    currentPartitionLastCheckTime?:
                                      | string
                                      | null;
                                    existsCheckDuration?: string | null;
                                    state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                    usualLateness?: string | null;
                                  } | null;
                                }
                              | null;
                          };
                      exposureTable:
                        | {
                            __typename: 'MetricsV1ExposureTable';
                            scheduledExposureCalculation?:
                              | {
                                  __typename: 'MetricsV1ScheduledExposureCalculation';
                                  name: string;
                                  exposureCalculationSpec: {
                                    __typename: 'MetricsV1ExposureCalculationSpec';
                                    assignmentTable:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'MetricsV1AssignmentTable';
                                          name: string;
                                          dataDeliveredUntilUpdateStrategyConfig?: {
                                            strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                            disableEmptyPartitions?:
                                              | boolean
                                              | null;
                                            automaticUpdateConfig?: {
                                              commitDelay: string;
                                              changeThreshold?: {
                                                value?: string | null;
                                              } | null;
                                            } | null;
                                            dailyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                            hourlyUpdateConfig?: {
                                              __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                              maxZeroDuration?: string | null;
                                            } | null;
                                          } | null;
                                        };
                                  };
                                  status: {
                                    calculating?: {
                                      exposureCalculation:
                                        | { name: string }
                                        | Record<PropertyKey, never>;
                                    } | null;
                                    cancelled?: {
                                      cancelledTime: string;
                                    } | null;
                                    error?: { errorMessage: string } | null;
                                    waiting?: {
                                      dataDeliveredUntilTime?: string | null;
                                      needDataUntilTime: string;
                                      assignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            displayName: string;
                                          }
                                        | null;
                                    } | null;
                                    scheduled?: {
                                      nextScheduleTime: string;
                                    } | null;
                                  };
                                }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | Record<PropertyKey, never>;
                      measurementTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1MeasurementTable';
                            name: string;
                          }
                        | null;
                    };
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | null;
              metricRole:
                | {
                    nonInferiorityMargin?: number | null;
                    guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                  }
                | {
                    minimumDetectableEffect?: number | null;
                    successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                  };
              surface?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1Surface';
                    name: string;
                    displayName: string;
                    description?: string | null;
                    deleteTime?: string | null;
                  }
                | null;
              calculation?:
                | { __typename: 'MetricsV1MetricCalculation'; name: string }
                | Record<PropertyKey, never>
                | null;
            }>;
            filters?: Array<{
              displayName?: string | null;
              factTable?:
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    labels: Array<{ key: string; value?: string | null }>;
                  }
                | Record<PropertyKey, never>
                | null;
              filter?: { criteria: any; expression: any } | null;
            }> | null;
            entity?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'MetricsV1Entity';
                  name: string;
                  displayName: string;
                }
              | null;
          } | null;
          stats?: {
            testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
            analysisResults?: Array<{
              exposureFilterName?: string | null;
              analysisResult:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'StatsV2AnalysisAnalysisResult';
                    name: string;
                    exposureFilter?: string | null;
                    updateTime: string;
                    annotations: Array<{
                      context: Array<{
                        key?: StatsV2AnalysisStatsAnnotationContext | null;
                        value?: string | null;
                      }>;
                    }>;
                    results: Array<{
                      id?: string | null;
                      annotations: Array<{
                        info?: string | null;
                        warning?: string | null;
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                        error?: {
                          category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                          details?: string | null;
                        } | null;
                      }>;
                      metricDetails?: {
                        direction?: StatsV2AnalysisMetricDirection | null;
                        hasRun?: boolean | null;
                        metricType?: StatsV2AnalysisMetricType | null;
                        plannedEffectSize?: { value?: string | null } | null;
                      } | null;
                      result: Array<{
                        comparisonId?: string | null;
                        isSignificant?: boolean | null;
                        usedDataType?: StatsV2AnalysisStatsDataType | null;
                        segmentId?: string | null;
                        dimensions: Array<{
                          value?: string | null;
                          key: string;
                        }>;
                        groupStats: Array<{
                          sampleSize?: any | null;
                          id?: string | null;
                        }>;
                        groups?: {
                          baseline?: string | null;
                          compared?: string | null;
                        } | null;
                        lastDeteriorationResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          comparedEstimateRel?: number | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            isSignificant?: boolean | null;
                            lower?: number | null;
                            powered?: number | null;
                            upper?: number | null;
                          } | null;
                        } | null;
                        lastResult?: {
                          baselineEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          baselineSampleSize?: any | null;
                          comparedEstimateAbs?: number | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        } | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        result: Array<{
                          resultTime?: string | null;
                          baselineEstimateAbs?: number | null;
                          comparedEstimateAbs?: number | null;
                          baselineEstimateRel?: number | null;
                          comparedEstimateRel?: number | null;
                          varianceReductionRate?: number | null;
                          unadjustedEstimateBaseline?: number | null;
                          unadjustedEstimateCompared?: number | null;
                          baselineSampleSize?: any | null;
                          comparedSampleSize?: any | null;
                          differenceEstimateAbs?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                          differenceEstimateRel?: {
                            estimate?: number | null;
                            lower?: number | null;
                            upper?: number | null;
                            isSignificant?: boolean | null;
                          } | null;
                        }>;
                        sampleSize?: {
                          current?: any | null;
                          required?: any | null;
                          poweredEffectRel?: number | null;
                          poweredEffectAbs?: number | null;
                        } | null;
                      }>;
                      srmResult: Array<{
                        isSignificant?: boolean | null;
                        segmentId?: string | null;
                        status?: {
                          status?: StatsV2AnalysisMetricResultStatus | null;
                          message?: string | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          decisionPowered?: boolean | null;
                          decisionIsSignificant?: boolean | null;
                          validationIsSignificant?: boolean | null;
                        } | null;
                        dimensions: Array<{
                          key: string;
                          value?: string | null;
                        }>;
                        result: Array<{
                          group?: string | null;
                          observed?: number | null;
                          expected?: number | null;
                          isSignificant?: boolean | null;
                        }>;
                      }>;
                      statsSettings?: {
                        method?: StatsV2AnalysisMethod | null;
                        adjustedAlpha?: number | null;
                        adjustedBeta?: number | null;
                        hasVarianceReduction?: boolean | null;
                      } | null;
                    }>;
                    treatments: Array<{
                      id?: string | null;
                      recommendation?: {
                        shipping?: StatsV2AnalysisShippingRecommendation | null;
                        status?: {
                          quality?: StatsV2AnalysisQualityStatus | null;
                          tanking?: StatsV2AnalysisTankingStatus | null;
                          guardrail?: StatsV2AnalysisGuardrailStatus | null;
                          success?: StatsV2AnalysisSuccessStatus | null;
                        } | null;
                      } | null;
                    }>;
                  };
            }> | null;
            metricMethods?: Array<{
              metricName: string;
              method: StatsDataMethodMethod;
            }> | null;
          } | null;
          explore?: {
            exploratoryAnalyses: Array<{
              createTime: string;
              updateTime: string;
              id: string;
              messages: Array<string>;
              name: string;
              splitByExposureFilters?: boolean | null;
              startTime?: string | null;
              endTime?: string | null;
              useCustomDateRange?: boolean | null;
              state: ExploreDataAnalysisState;
              useScheduledCalculation?: boolean | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              conclusion?: { updateTime: string; text: string } | null;
              metrics: Array<{
                calculationError?: string | null;
                name:
                  | {
                      name: string;
                      displayName: string;
                      description?: string | null;
                      factTable?:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                      entity?:
                        | {
                            __typename: 'MetricsV1Entity';
                            createTime: string;
                            name: string;
                            displayName: string;
                            primaryKeyType: MetricsV1ColumnType;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            defaultAssignmentTable?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                dimensions: Array<
                  | {
                      column: string;
                      dimensionTable?:
                        | {
                            __typename: 'MetricsV1DimensionTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            state: MetricsV1TableState;
                            dimensionDataDeliveredUntilTime?: string | null;
                            sql: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  name: string;
                                  displayName: string;
                                  pictureUri?: string | null;
                                }
                              | null;
                            entityColumnMapping: {
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    createTime: string;
                                    name: string;
                                    displayName: string;
                                    primaryKeyType: MetricsV1ColumnType;
                                    labels: Array<{
                                      key: string;
                                      value?: string | null;
                                    }>;
                                    resourceRelations?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          __typename: 'FgaV1ListResourceRelationsResponse';
                                          resourceRelations: Array<{
                                            relation: string;
                                          }>;
                                        }
                                      | null;
                                    defaultAssignmentTable?:
                                      | {
                                          __typename: 'Error';
                                          message?: string | null;
                                          code: ErrorCode;
                                        }
                                      | {
                                          name: string;
                                          displayName: string;
                                          state: MetricsV1TableState;
                                        }
                                      | null;
                                  };
                              column: { name: string };
                            };
                            dimensions: Array<{ name: string }>;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                            timeConfig?: {
                              window: string;
                              timestampColumn: {
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              };
                            } | null;
                            valueMappings: Array<{
                              column: string;
                              mappings: Array<{
                                inputDimensionValue?: string | null;
                                outputDimensionValue?: string | null;
                              }>;
                            }>;
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | {
                      column: string;
                      factTable:
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            description?: string | null;
                            sql: string;
                            state: MetricsV1TableState;
                            factDataDeliveredUntilTime?: string | null;
                            timestampColumn: { name: string };
                            owner?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'IamV1Identity';
                                  displayName: string;
                                  name: string;
                                  everyone?: boolean | null;
                                  user?:
                                    | {
                                        pictureUri?: string | null;
                                        name: string;
                                      }
                                    | Record<PropertyKey, never>
                                    | null;
                                  group?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                  apiClient?:
                                    | { name: string }
                                    | Record<PropertyKey, never>
                                    | null;
                                }
                              | null;
                            entities: Array<{
                              entity:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1Entity';
                                    name: string;
                                    displayName: string;
                                  };
                              column: { name: string };
                            }>;
                            measures: Array<{
                              declaredType?: MetricsV1ColumnType | null;
                              column: { name: string };
                              unit?: {
                                baseUnitMultiplier?: number | null;
                                baseUnit?: MetricsV1UnitBaseUnit | null;
                                currencyCode?: string | null;
                                customUnit?: string | null;
                              } | null;
                            }>;
                            dimensions: Array<{ name: string }>;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            error?: {
                              details: Array<string>;
                              message?: string | null;
                            } | null;
                            schemaValidationJob:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1SqlJob';
                                  name: string;
                                  successfulQueryResult?: {
                                    schema: Array<{
                                      name: string;
                                      type?: MetricsV1ColumnType | null;
                                    }>;
                                  } | null;
                                };
                            source?: {
                              type?: MetricsV1MetricMetricSourceType | null;
                              reference?: string | null;
                            } | null;
                            labels: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            resourceRelations?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FgaV1ListResourceRelationsResponse';
                                  resourceRelations: Array<{
                                    relation: string;
                                  }>;
                                }
                              | null;
                          }
                        | Record<PropertyKey, never>;
                    }
                >;
                calculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                scheduledCalculation?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                    }
                  | null;
              }>;
              createdBy?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1User';
                    name: string;
                    fullName: string;
                    email: string;
                    pictureUri?: string | null;
                    lastLoginTime?: string | null;
                  }
                | null;
            }>;
          } | null;
          rollout?: {
            variantImageUri?: string | null;
            reach?: string | null;
            initialReach?: string | null;
            controlAssignmentId?: string | null;
            description?: string | null;
            monitoringDisabled: boolean;
            treatmentGroupProportion?: number | null;
            variantAssignmentId?: string | null;
            schedule?: {
              state?: RolloutDataScheduleState | null;
              stateReason?: {
                failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
              } | null;
              steps: Array<{
                durationSincePreviousStep: string;
                reach: string;
                status?: RolloutDataScheduleScheduleStepsStatus | null;
                updateTime?: string | null;
              }>;
            } | null;
            variant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            abtest?:
              | { __typename: 'Error' }
              | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
              | null;
            controlVariant?:
              | { __typename: 'Error' }
              | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
              | null;
            flag?:
              | { __typename: 'Error' }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  clients: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Client';
                        name: string;
                        displayName: string;
                        createTime: string;
                        deleteTime?: string | null;
                      }
                  >;
                }
              | null;
          } | null;
        };
        resourceRelations?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations: Array<{ relation: string }>;
            }
          | null;
        queryWorkflowInstancePermissions?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
              isAllAllowed?: boolean | null;
              actionPermissionCheckResults: Array<{
                action?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
              functionPermissionCheckResults: Array<{
                function?: string | null;
                isAllowed?: boolean | null;
                permissionChecks: Array<{
                  isAllowed?: boolean | null;
                  relation?: string | null;
                  resource?: string | null;
                }>;
              }>;
            }
          | null;
        transitionStatus?: {
          action: string;
          initiator:
            | { name: string; displayName: string }
            | Record<PropertyKey, never>;
          running?: { startTime: string } | null;
          completed?: { startTime: string; endTime: string } | null;
          failed?: { startTime: string; endTime: string; error: string } | null;
        } | null;
      }
    | null;
};

export type SimilarExperimentsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type SimilarExperimentsQuery = {
  search?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'SearchV1ExternalSearchResponse';
        nextPageToken?: string | null;
        totalSize?: number | null;
        hits: Array<{
          score?: number | null;
          resource?:
            | {
                __typename: 'WorkflowV1WorkflowInstance';
                name: string;
                displayName: string;
                surfaces: Array<
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                >;
                moduleData2: {
                  metrics?: {
                    entity?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                          primaryKeyType: MetricsV1ColumnType;
                        }
                      | null;
                  } | null;
                };
              }
            | Record<PropertyKey, never>
            | null;
        }>;
      }
    | null;
};

export type TransitionStatusFragment = {
  action: string;
  initiator: { name: string; displayName: string } | Record<PropertyKey, never>;
  running?: { startTime: string } | null;
  failed?: { startTime: string; endTime: string; error: string } | null;
  completed?: { startTime: string; endTime: string } | null;
};

export type TransitionWorkflowInstanceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  action: Scalars['String']['input'];
  asyncTransition: Scalars['Boolean']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type TransitionWorkflowInstanceMutation = {
  transitionWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1TransitionWorkflowInstanceResponse';
        workflowInstance?: {
          __typename: 'WorkflowV1WorkflowInstance';
          possibleTransitions: Array<string>;
          lockedDataKeys: Array<string>;
          displayName: string;
          state: string;
          name: string;
          deleteTime?: string | null;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          surfaces: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
                metricConfig?: {
                  metrics: Array<{
                    enforcementLevel?: WorkflowV1EnforcementLevel | null;
                    metric:
                      | { name: string; displayName: string }
                      | Record<PropertyKey, never>;
                  }>;
                } | null;
              }
          >;
          surfaceRequirements: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            reason?: string | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                }
              | null;
          }>;
          initiatives: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Initiative';
                name: string;
                displayName: string;
                description?: string | null;
              }
          >;
          workflowVersion?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowVersion';
                name: string;
                workflowInfo?: {
                  modules: Array<{ key: string }>;
                  functions: Array<{ key: string }>;
                } | null;
              }
            | null;
          stateHistory: Array<{ state?: string | null }>;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            abtest?: {
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    variants: Array<{
                      description?: string | null;
                      name: string;
                      imageUri?: string | null;
                    }>;
                  }
                | null;
              treatments?: Array<{
                name?: string | null;
                weight: any;
                displayName?: string | null;
                description?: string | null;
                imageUri?: string | null;
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              }> | null;
              rollout?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
            } | null;
            flags?: {
              targetingKeySelector?: string | null;
              stickyAssignments?: boolean | null;
              ignoreTargetingForSticky?: boolean | null;
              intakePaused?: boolean | null;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
              rule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagRule'; name: string }
                | null;
            } | null;
            hypothesis?: { text?: string | null } | null;
            decision?: {
              outcome?: DecisionRecordDataOutcome | null;
              conclusion?: string | null;
              treatment?: string | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            samplesize?: {
              error?: string | null;
              useScheduledCalculation?: boolean | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataState | null;
              exposure?:
                | {
                    exposureCalculation?: any | null;
                    scheduledExposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    assignmentTable: {
                      assignmentTable?: string | null;
                      filters?: { assignmentFilter?: any | null } | null;
                    };
                  }
                | {
                    exposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    existingInstance: {
                      workflowInstance:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          };
                    };
                  }
                | null;
              exposureSource?:
                | {
                    assignmentTable?: string | null;
                    customStartTime?: string | null;
                    customEndTime?: string | null;
                    filters?: {
                      assignmentFilter?: any | null;
                      entityFilter?: any | null;
                      exposureFilter?: string | null;
                    } | null;
                  }
                | {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  }
                | null;
              metrics?: Array<{
                error?: string | null;
                metric: string;
                metricCalculation?: any | null;
                scheduledMetricCalculation?: any | null;
                requiredSampleSize?: any | null;
                state?: SampleSizeDataSampleSizeMetricState | null;
                type?: SampleSizeDataSampleSizeMetricType | null;
                metricCalculationName?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                summaryStats?: {
                  mean?: number | null;
                  variance?: number | null;
                  varianceReductionRate?: number | null;
                  count?: any | null;
                } | null;
                observedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  mean?: number | null;
                  variance?: number | null;
                  expectedSampleSize?: any | null;
                }> | null;
                forecastedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  expectedSampleSize?: any | null;
                }> | null;
              }> | null;
            } | null;
            metrics?: {
              bucket?: MetricsDataBucket | null;
              assignmentTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1AssignmentTable';
                    name: string;
                    displayName: string;
                    dimensions: Array<{ name: string }>;
                    dataWarehouse?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | { __typename: 'MetricsV1DataWarehouse'; name: string }
                      | null;
                  }
                | null;
              exposureTableSchedule?:
                | {
                    __typename: 'MetricsV1ScheduledExposureCalculation';
                    name: string;
                  }
                | Record<PropertyKey, never>
                | null;
              metrics: Array<{
                __typename: 'MetricsDataMetric';
                preferredDirection?: MetricsDataMetricPreferredDirection | null;
                surfaceOnly?: boolean | null;
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      displayName: string;
                      name: string;
                      description?: string | null;
                      createTime: string;
                      updateTime: string;
                      deleteTime?: string | null;
                      state?: MetricsV1MetricState | null;
                      preferredDirection?: MetricsV1MetricPreferredDirection | null;
                      measurement?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Measurement';
                            name: string;
                            displayName: string;
                            typeSpec: {
                              averageMetricSpec?: {
                                measurement?: { name: string } | null;
                                aggregation: { type: MetricsV1AggregationType };
                              } | null;
                              ratioMetricSpec?: {
                                numerator?: { name: string } | null;
                                numeratorAggregation: {
                                  type: MetricsV1AggregationType;
                                };
                                denominator?: { name: string } | null;
                                denominatorAggregation: {
                                  type: MetricsV1AggregationType;
                                };
                              } | null;
                              quantileMetricSpec?: {
                                quantileLevel: number;
                                aggregation: { type: MetricsV1AggregationType };
                              } | null;
                            };
                            filter?: {
                              criteria: Array<{
                                key: string;
                                value?: {
                                  attribute?: {
                                    attribute: string;
                                    eqRule?: {
                                      value: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      };
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    likeRule?: { pattern: string } | null;
                                  } | null;
                                } | null;
                              }>;
                              expression: {
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              };
                            } | null;
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            factTable:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                };
                            nullHandling?: {
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                          }
                        | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                      filter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      entity?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          }
                        | null;
                      measurementConfig?: {
                        closedWindow?: {
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: { dummy?: string | null } | null;
                      } | null;
                      varianceReductionConfig?: {
                        aggregationWindowOverride?: string | null;
                        disabled?: boolean | null;
                      } | null;
                      nullHandling?: {
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      typeSpec?: {
                        ratioMetricSpec?: {
                          numerator?: { name: string } | null;
                          numeratorAggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                          numeratorFilter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          denominator?: { name: string } | null;
                          denominatorAggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                          denominatorFilter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                        } | null;
                        averageMetricSpec?: {
                          measurement?: {
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          } | null;
                          aggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                        } | null;
                        quantileMetricSpec?: {
                          quantileLevel: number;
                          measurement?: {
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          } | null;
                          aggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                        } | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      archiveInfo?: {
                        reason?: string | null;
                        archiveTime?: string | null;
                      } | null;
                      defaultEffectSize?: { value?: string | null } | null;
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      verification?: {
                        state?: MetricsV1MetricMetricVerificationVerificationState | null;
                        verifyTime?: string | null;
                        verifier?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                            }
                          | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    };
                schedule?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      nextScheduledRunTime: string;
                      nextExposureStartTime: string;
                      nextExposureEndTime: string;
                      iteration: number;
                      executedCalculationsCount: number;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                      metricCalculationSpec: {
                        metric:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Metric';
                              name: string;
                              displayName: string;
                              nullHandling?: {
                                __typename: 'MetricsV1MetricNullHandlingConfig';
                                replaceEntityNullWithZero?: boolean | null;
                              } | null;
                              measurementConfig?: {
                                closedWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                  aggregationWindow: string;
                                  exposureOffset: string;
                                } | null;
                                semiOpenWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                  aggregationWindow: string;
                                  exposureOffset?: string | null;
                                } | null;
                                openWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                                } | null;
                              } | null;
                              factTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1FactTable';
                                    name: string;
                                    displayName: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                    partitionedUpdateStrategyState?: {
                                      currentPartitionLastCheckTime?:
                                        | string
                                        | null;
                                      existsCheckDuration?: string | null;
                                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                      usualLateness?: string | null;
                                    } | null;
                                  }
                                | null;
                            };
                        exposureTable:
                          | {
                              __typename: 'MetricsV1ExposureTable';
                              scheduledExposureCalculation?:
                                | {
                                    __typename: 'MetricsV1ScheduledExposureCalculation';
                                    name: string;
                                    exposureCalculationSpec: {
                                      __typename: 'MetricsV1ExposureCalculationSpec';
                                      assignmentTable:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            dataDeliveredUntilUpdateStrategyConfig?: {
                                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                              disableEmptyPartitions?:
                                                | boolean
                                                | null;
                                              automaticUpdateConfig?: {
                                                commitDelay: string;
                                                changeThreshold?: {
                                                  value?: string | null;
                                                } | null;
                                              } | null;
                                              dailyUpdateConfig?: {
                                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                                maxZeroDuration?: string | null;
                                              } | null;
                                              hourlyUpdateConfig?: {
                                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                                maxZeroDuration?: string | null;
                                              } | null;
                                            } | null;
                                          };
                                    };
                                    status: {
                                      calculating?: {
                                        exposureCalculation:
                                          | { name: string }
                                          | Record<PropertyKey, never>;
                                      } | null;
                                      cancelled?: {
                                        cancelledTime: string;
                                      } | null;
                                      error?: { errorMessage: string } | null;
                                      waiting?: {
                                        dataDeliveredUntilTime?: string | null;
                                        needDataUntilTime: string;
                                        assignmentTable?:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1AssignmentTable';
                                              name: string;
                                              displayName: string;
                                            }
                                          | null;
                                      } | null;
                                      scheduled?: {
                                        nextScheduleTime: string;
                                      } | null;
                                    };
                                  }
                                | Record<PropertyKey, never>
                                | null;
                            }
                          | Record<PropertyKey, never>;
                        measurementTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1MeasurementTable';
                              name: string;
                            }
                          | null;
                      };
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
                metricRole:
                  | {
                      nonInferiorityMargin?: number | null;
                      guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                    }
                  | {
                      minimumDetectableEffect?: number | null;
                      successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                    };
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
                calculation?:
                  | { __typename: 'MetricsV1MetricCalculation'; name: string }
                  | Record<PropertyKey, never>
                  | null;
              }>;
              filters?: Array<{
                displayName?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
                filter?: { criteria: any; expression: any } | null;
              }> | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
            } | null;
            stats?: {
              testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              metricMethods?: Array<{
                metricName: string;
                method: StatsDataMethodMethod;
              }> | null;
            } | null;
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
            rollout?: {
              variantImageUri?: string | null;
              reach?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
                steps: Array<{
                  durationSincePreviousStep: string;
                  reach: string;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                  updateTime?: string | null;
                }>;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          queryWorkflowInstancePermissions?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
                isAllAllowed?: boolean | null;
                actionPermissionCheckResults: Array<{
                  action?: string | null;
                  isAllowed?: boolean | null;
                  permissionChecks: Array<{
                    isAllowed?: boolean | null;
                    relation?: string | null;
                    resource?: string | null;
                  }>;
                }>;
                functionPermissionCheckResults: Array<{
                  function?: string | null;
                  isAllowed?: boolean | null;
                  permissionChecks: Array<{
                    isAllowed?: boolean | null;
                    relation?: string | null;
                    resource?: string | null;
                  }>;
                }>;
              }
            | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            completed?: { startTime: string; endTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
          } | null;
        } | null;
      }
    | null;
};

export type UpdateWorkflowInstanceLabelsMutationVariables = Exact<{
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
}>;

export type UpdateWorkflowInstanceLabelsMutation = {
  updateWorkflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        labels: Array<{ key: string; value?: string | null }>;
      }
    | null;
};

export type UpdateWorkflowInstanceNameMutationVariables = Exact<{
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
}>;

export type UpdateWorkflowInstanceNameMutation = {
  updateWorkflowInstance?:
    | { name: string; displayName: string }
    | Record<PropertyKey, never>
    | null;
};

export type WorkflowEventFragment = {
  name: string;
  pubsubMetadata?: {
    consumeTime?: string | null;
    publishTime?: string | null;
  } | null;
  eventType?:
    | { name: string; description?: string | null; persist?: boolean | null }
    | Record<PropertyKey, never>
    | null;
  cloudEvent?: {
    textData?: string | null;
    protoData?: any | null;
    binaryData?: string | null;
    source?: string | null;
    specVersion?: string | null;
  } | null;
};

export type WorkflowInstanceFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  possibleTransitions: Array<string>;
  lockedDataKeys: Array<string>;
  displayName: string;
  state: string;
  name: string;
  deleteTime?: string | null;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  surfaces: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Surface';
        name: string;
        displayName: string;
        description?: string | null;
        metricConfig?: {
          metrics: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            metric:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
          }>;
        } | null;
      }
  >;
  surfaceRequirements: Array<{
    enforcementLevel?: WorkflowV1EnforcementLevel | null;
    reason?: string | null;
    surface?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | {
          __typename: 'WorkflowV1Surface';
          name: string;
          displayName: string;
          description?: string | null;
        }
      | null;
  }>;
  initiatives: Array<
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1Initiative';
        name: string;
        displayName: string;
        description?: string | null;
      }
  >;
  workflowVersion?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowVersion';
        name: string;
        workflowInfo?: {
          modules: Array<{ key: string }>;
          functions: Array<{ key: string }>;
        } | null;
      }
    | null;
  stateHistory: Array<{ state?: string | null }>;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  moduleData: Array<{ key: string; value?: any | null }>;
  moduleData2: {
    abtest?: {
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            variants: Array<{
              description?: string | null;
              name: string;
              imageUri?: string | null;
            }>;
          }
        | null;
      treatments?: Array<{
        name?: string | null;
        weight: any;
        displayName?: string | null;
        description?: string | null;
        imageUri?: string | null;
        variant:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
      }> | null;
      rollout?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
    } | null;
    flags?: {
      targetingKeySelector?: string | null;
      stickyAssignments?: boolean | null;
      ignoreTargetingForSticky?: boolean | null;
      intakePaused?: boolean | null;
      flag?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
      segment?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'FlagsAdminV1Segment';
            name: string;
            displayName?: string | null;
            description?: string | null;
            state?: FlagsAdminV1SegmentState | null;
            createTime: string;
            updateTime: string;
            flag?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FlagsAdminV1Flag';
                  name: string;
                  displayName: string;
                }
              | null;
            workflowInstance?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                }
              | null;
            owner?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Identity';
                  name: string;
                  displayName: string;
                  pictureUri?: string | null;
                }
              | null;
            allocation?: {
              exclusiveTo: Array<string>;
              exclusivityTags: Array<string>;
              proportion?: { value?: string | null } | null;
            } | null;
            targeting?: {
              criteria: Array<{
                key: string;
                value?: {
                  attribute?: {
                    attributeName?: string | null;
                    eqRule?: {
                      value?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    setRule?: {
                      values: Array<{
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      }>;
                    } | null;
                    rangeRule?: {
                      startInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      startExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endInclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                      endExclusive?: {
                        boolValue?: boolean | null;
                        numberValue?: number | null;
                        stringValue?: string | null;
                        timestampValue?: string | null;
                        versionValue?: { version?: string | null } | null;
                      } | null;
                    } | null;
                    startsWithRule?: { value?: string | null } | null;
                    containsRule?: { value?: string | null } | null;
                    endsWithRule?: { value?: string | null } | null;
                    anyRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                    allRule?: {
                      rule?: {
                        eqRule?: {
                          value?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        setRule?: {
                          values: Array<{
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          }>;
                        } | null;
                        rangeRule?: {
                          startInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          startExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endInclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                          endExclusive?: {
                            boolValue?: boolean | null;
                            numberValue?: number | null;
                            stringValue?: string | null;
                            timestampValue?: string | null;
                            versionValue?: { version?: string | null } | null;
                          } | null;
                        } | null;
                        startsWithRule?: { value?: string | null } | null;
                        containsRule?: { value?: string | null } | null;
                        endsWithRule?: { value?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  segment?: {
                    segment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Segment';
                          name: string;
                          displayName?: string | null;
                          labels: Array<{ key: string; value?: string | null }>;
                        }
                      | null;
                  } | null;
                  materializedSegment?: {
                    materializedSegment?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1MaterializedSegment';
                          name: string;
                          displayName: string;
                        }
                      | null;
                  } | null;
                } | null;
              }>;
              expression?: {
                ref?: string | null;
                not?: { ref?: string | null } | null;
                and?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
                or?: {
                  operands: Array<{
                    ref?: string | null;
                    not?: { ref?: string | null } | null;
                    and?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                    or?: {
                      operands: Array<{
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                          }>;
                        } | null;
                      }>;
                    } | null;
                  }>;
                } | null;
              } | null;
            } | null;
            labels: Array<{ key: string; value?: string | null }>;
            resourceRelations?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'FgaV1ListResourceRelationsResponse';
                  resourceRelations: Array<{
                    relation: string;
                    resource: string;
                  }>;
                }
              | null;
          }
        | null;
      rule?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'FlagsAdminV1FlagRule'; name: string }
        | null;
    } | null;
    hypothesis?: { text?: string | null } | null;
    decision?: {
      outcome?: DecisionRecordDataOutcome | null;
      conclusion?: string | null;
      treatment?: string | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    samplesize?: {
      error?: string | null;
      useScheduledCalculation?: boolean | null;
      requiredSampleSize?: any | null;
      state?: SampleSizeDataState | null;
      exposure?:
        | {
            exposureCalculation?: any | null;
            scheduledExposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            assignmentTable: {
              assignmentTable?: string | null;
              filters?: { assignmentFilter?: any | null } | null;
            };
          }
        | {
            exposureCalculation?: any | null;
            startTime?: string | null;
            endTime?: string | null;
            existingInstance: {
              workflowInstance:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'WorkflowV1WorkflowInstance';
                    name: string;
                    displayName: string;
                  };
            };
          }
        | null;
      exposureSource?:
        | {
            assignmentTable?: string | null;
            customStartTime?: string | null;
            customEndTime?: string | null;
            filters?: {
              assignmentFilter?: any | null;
              entityFilter?: any | null;
              exposureFilter?: string | null;
            } | null;
          }
        | {
            workflowInstance:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1WorkflowInstance';
                  name: string;
                  displayName: string;
                };
          }
        | null;
      metrics?: Array<{
        error?: string | null;
        metric: string;
        metricCalculation?: any | null;
        scheduledMetricCalculation?: any | null;
        requiredSampleSize?: any | null;
        state?: SampleSizeDataSampleSizeMetricState | null;
        type?: SampleSizeDataSampleSizeMetricType | null;
        metricCalculationName?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1MetricCalculation';
              name: string;
              state?: MetricsV1MetricCalculationState | null;
            }
          | null;
        summaryStats?: {
          mean?: number | null;
          variance?: number | null;
          varianceReductionRate?: number | null;
          count?: any | null;
        } | null;
        observedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          mean?: number | null;
          variance?: number | null;
          expectedSampleSize?: any | null;
        }> | null;
        forecastedData?: Array<{
          dayIndex: any;
          requiredSampleSize?: any | null;
          expectedSampleSize?: any | null;
        }> | null;
      }> | null;
    } | null;
    metrics?: {
      bucket?: MetricsDataBucket | null;
      assignmentTable?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | {
            __typename: 'MetricsV1AssignmentTable';
            name: string;
            displayName: string;
            dimensions: Array<{ name: string }>;
            dataWarehouse?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'MetricsV1DataWarehouse'; name: string }
              | null;
          }
        | null;
      exposureTableSchedule?:
        | { __typename: 'MetricsV1ScheduledExposureCalculation'; name: string }
        | Record<PropertyKey, never>
        | null;
      metrics: Array<{
        __typename: 'MetricsDataMetric';
        preferredDirection?: MetricsDataMetricPreferredDirection | null;
        surfaceOnly?: boolean | null;
        metric:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1Metric';
              displayName: string;
              name: string;
              description?: string | null;
              createTime: string;
              updateTime: string;
              deleteTime?: string | null;
              state?: MetricsV1MetricState | null;
              preferredDirection?: MetricsV1MetricPreferredDirection | null;
              measurement?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Measurement';
                    name: string;
                    displayName: string;
                    typeSpec: {
                      averageMetricSpec?: {
                        measurement?: { name: string } | null;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                      ratioMetricSpec?: {
                        numerator?: { name: string } | null;
                        numeratorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                        denominator?: { name: string } | null;
                        denominatorAggregation: {
                          type: MetricsV1AggregationType;
                        };
                      } | null;
                      quantileMetricSpec?: {
                        quantileLevel: number;
                        aggregation: { type: MetricsV1AggregationType };
                      } | null;
                    };
                    filter?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attribute: string;
                            eqRule?: {
                              value: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              };
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                nullValue?: {
                                  dummyField?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            likeRule?: { pattern: string } | null;
                          } | null;
                        } | null;
                      }>;
                      expression: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      };
                    } | null;
                    entity:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1Entity';
                          name: string;
                          displayName: string;
                        };
                    factTable:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        };
                    nullHandling?: {
                      replaceEntityNullWithZero?: boolean | null;
                    } | null;
                  }
                | null;
              owner?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'IamV1Identity';
                    displayName: string;
                    name: string;
                    everyone?: boolean | null;
                    user?:
                      | { pictureUri?: string | null; name: string }
                      | Record<PropertyKey, never>
                      | null;
                    group?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    apiClient?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                  }
                | null;
              factTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1FactTable';
                    name: string;
                    displayName: string;
                    state: MetricsV1TableState;
                  }
                | null;
              filter?: {
                criteria: Array<{
                  key: string;
                  value?: {
                    attribute?: {
                      attribute: string;
                      eqRule?: {
                        value: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        };
                      } | null;
                      setRule?: {
                        values: Array<{
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        }>;
                      } | null;
                      rangeRule?: {
                        startInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        startExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endInclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                        endExclusive?: {
                          boolValue?: boolean | null;
                          numberValue?: number | null;
                          stringValue?: string | null;
                          timestampValue?: string | null;
                          nullValue?: { dummyField?: string | null } | null;
                        } | null;
                      } | null;
                      likeRule?: { pattern: string } | null;
                    } | null;
                  } | null;
                }>;
                expression: {
                  ref?: string | null;
                  not?: { ref?: string | null } | null;
                  and?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                  or?: {
                    operands: Array<{
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                        }>;
                      } | null;
                    }>;
                  } | null;
                };
              } | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
              measurementConfig?: {
                closedWindow?: {
                  aggregationWindow: string;
                  exposureOffset: string;
                } | null;
                semiOpenWindow?: {
                  aggregationWindow: string;
                  exposureOffset?: string | null;
                } | null;
                openWindow?: { dummy?: string | null } | null;
              } | null;
              varianceReductionConfig?: {
                aggregationWindowOverride?: string | null;
                disabled?: boolean | null;
              } | null;
              nullHandling?: {
                replaceEntityNullWithZero?: boolean | null;
              } | null;
              typeSpec?: {
                ratioMetricSpec?: {
                  numerator?: { name: string } | null;
                  numeratorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  numeratorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                  denominator?: { name: string } | null;
                  denominatorAggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                  denominatorFilter?: {
                    criteria: Array<{
                      key: string;
                      value?: {
                        attribute?: {
                          attribute: string;
                          eqRule?: {
                            value: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            };
                          } | null;
                          setRule?: {
                            values: Array<{
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            }>;
                          } | null;
                          rangeRule?: {
                            startInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            startExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endInclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                            endExclusive?: {
                              boolValue?: boolean | null;
                              numberValue?: number | null;
                              stringValue?: string | null;
                              timestampValue?: string | null;
                              nullValue?: { dummyField?: string | null } | null;
                            } | null;
                          } | null;
                          likeRule?: { pattern: string } | null;
                        } | null;
                      } | null;
                    }>;
                    expression: {
                      ref?: string | null;
                      not?: { ref?: string | null } | null;
                      and?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                      or?: {
                        operands: Array<{
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                            }>;
                          } | null;
                        }>;
                      } | null;
                    };
                  } | null;
                } | null;
                averageMetricSpec?: {
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
                quantileMetricSpec?: {
                  quantileLevel: number;
                  measurement?: {
                    name: string;
                    type?: MetricsV1ColumnType | null;
                  } | null;
                  aggregation: {
                    type: MetricsV1AggregationType;
                    threshold?: {
                      direction: MetricsV1AggregationThresholdDirection;
                      threshold: { value?: string | null };
                    } | null;
                    cap?: {
                      min?: { value?: string | null } | null;
                      max?: { value?: string | null } | null;
                    } | null;
                  };
                } | null;
              } | null;
              labels: Array<{ key: string; value?: string | null }>;
              archiveInfo?: {
                reason?: string | null;
                archiveTime?: string | null;
              } | null;
              defaultEffectSize?: { value?: string | null } | null;
              source?: {
                type?: MetricsV1MetricMetricSourceType | null;
                reference?: string | null;
              } | null;
              verification?: {
                state?: MetricsV1MetricMetricVerificationVerificationState | null;
                verifyTime?: string | null;
                verifier?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Identity';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                    }
                  | null;
              } | null;
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{ relation: string }>;
                  }
                | null;
            };
        schedule?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'MetricsV1ScheduledMetricCalculation';
              name: string;
              state?: MetricsV1ScheduledMetricCalculationState | null;
              nextScheduledRunTime: string;
              nextExposureStartTime: string;
              nextExposureEndTime: string;
              iteration: number;
              executedCalculationsCount: number;
              status: {
                scheduled?: { nextScheduleTime: string } | null;
                cancelled?: { cancelledTime: string } | null;
                calculating?: {
                  metricCalculation:
                    | { name: string }
                    | Record<PropertyKey, never>;
                } | null;
                waiting?: {
                  dataDeliveredUntilTime?: string | null;
                  needDataUntilTime: string;
                  exposureTable?:
                    | { name: string }
                    | Record<PropertyKey, never>
                    | null;
                  factTable?:
                    | {
                        __typename: 'MetricsV1FactTable';
                        name: string;
                        displayName: string;
                        state: MetricsV1TableState;
                      }
                    | Record<PropertyKey, never>
                    | null;
                } | null;
                error?: { errorMessage: string } | null;
              };
              metricCalculationSpec: {
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      name: string;
                      displayName: string;
                      nullHandling?: {
                        __typename: 'MetricsV1MetricNullHandlingConfig';
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      measurementConfig?: {
                        closedWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: {
                          __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                        } | null;
                      } | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            dataDeliveredUntilUpdateStrategyConfig?: {
                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                              disableEmptyPartitions?: boolean | null;
                              automaticUpdateConfig?: {
                                commitDelay: string;
                                changeThreshold?: {
                                  value?: string | null;
                                } | null;
                              } | null;
                              dailyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                              hourlyUpdateConfig?: {
                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                maxZeroDuration?: string | null;
                              } | null;
                            } | null;
                            partitionedUpdateStrategyState?: {
                              currentPartitionLastCheckTime?: string | null;
                              existsCheckDuration?: string | null;
                              state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                              usualLateness?: string | null;
                            } | null;
                          }
                        | null;
                    };
                exposureTable:
                  | {
                      __typename: 'MetricsV1ExposureTable';
                      scheduledExposureCalculation?:
                        | {
                            __typename: 'MetricsV1ScheduledExposureCalculation';
                            name: string;
                            exposureCalculationSpec: {
                              __typename: 'MetricsV1ExposureCalculationSpec';
                              assignmentTable:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1AssignmentTable';
                                    name: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                  };
                            };
                            status: {
                              calculating?: {
                                exposureCalculation:
                                  | { name: string }
                                  | Record<PropertyKey, never>;
                              } | null;
                              cancelled?: { cancelledTime: string } | null;
                              error?: { errorMessage: string } | null;
                              waiting?: {
                                dataDeliveredUntilTime?: string | null;
                                needDataUntilTime: string;
                                assignmentTable?:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1AssignmentTable';
                                      name: string;
                                      displayName: string;
                                    }
                                  | null;
                              } | null;
                              scheduled?: { nextScheduleTime: string } | null;
                            };
                          }
                        | Record<PropertyKey, never>
                        | null;
                    }
                  | Record<PropertyKey, never>;
                measurementTable?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'MetricsV1MeasurementTable'; name: string }
                  | null;
              };
              resourceRelations?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FgaV1ListResourceRelationsResponse';
                    resourceRelations: Array<{
                      relation: string;
                      resource: string;
                    }>;
                  }
                | null;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | null;
        metricRole:
          | {
              nonInferiorityMargin?: number | null;
              guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
            }
          | {
              minimumDetectableEffect?: number | null;
              successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
            };
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
        calculation?:
          | { __typename: 'MetricsV1MetricCalculation'; name: string }
          | Record<PropertyKey, never>
          | null;
      }>;
      filters?: Array<{
        displayName?: string | null;
        factTable?:
          | {
              __typename: 'MetricsV1FactTable';
              name: string;
              displayName: string;
              labels: Array<{ key: string; value?: string | null }>;
            }
          | Record<PropertyKey, never>
          | null;
        filter?: { criteria: any; expression: any } | null;
      }> | null;
      entity?:
        | { __typename: 'Error'; message?: string | null; code: ErrorCode }
        | { __typename: 'MetricsV1Entity'; name: string; displayName: string }
        | null;
    } | null;
    stats?: {
      testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
      analysisResults?: Array<{
        exposureFilterName?: string | null;
        analysisResult:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'StatsV2AnalysisAnalysisResult';
              name: string;
              exposureFilter?: string | null;
              updateTime: string;
              annotations: Array<{
                context: Array<{
                  key?: StatsV2AnalysisStatsAnnotationContext | null;
                  value?: string | null;
                }>;
              }>;
              results: Array<{
                id?: string | null;
                annotations: Array<{
                  info?: string | null;
                  warning?: string | null;
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                  error?: {
                    category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                    details?: string | null;
                  } | null;
                }>;
                metricDetails?: {
                  direction?: StatsV2AnalysisMetricDirection | null;
                  hasRun?: boolean | null;
                  metricType?: StatsV2AnalysisMetricType | null;
                  plannedEffectSize?: { value?: string | null } | null;
                } | null;
                result: Array<{
                  comparisonId?: string | null;
                  isSignificant?: boolean | null;
                  usedDataType?: StatsV2AnalysisStatsDataType | null;
                  segmentId?: string | null;
                  dimensions: Array<{ value?: string | null; key: string }>;
                  groupStats: Array<{
                    sampleSize?: any | null;
                    id?: string | null;
                  }>;
                  groups?: {
                    baseline?: string | null;
                    compared?: string | null;
                  } | null;
                  lastDeteriorationResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    comparedEstimateRel?: number | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      isSignificant?: boolean | null;
                      lower?: number | null;
                      powered?: number | null;
                      upper?: number | null;
                    } | null;
                  } | null;
                  lastResult?: {
                    baselineEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    baselineSampleSize?: any | null;
                    comparedEstimateAbs?: number | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  } | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  result: Array<{
                    resultTime?: string | null;
                    baselineEstimateAbs?: number | null;
                    comparedEstimateAbs?: number | null;
                    baselineEstimateRel?: number | null;
                    comparedEstimateRel?: number | null;
                    varianceReductionRate?: number | null;
                    unadjustedEstimateBaseline?: number | null;
                    unadjustedEstimateCompared?: number | null;
                    baselineSampleSize?: any | null;
                    comparedSampleSize?: any | null;
                    differenceEstimateAbs?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                    differenceEstimateRel?: {
                      estimate?: number | null;
                      lower?: number | null;
                      upper?: number | null;
                      isSignificant?: boolean | null;
                    } | null;
                  }>;
                  sampleSize?: {
                    current?: any | null;
                    required?: any | null;
                    poweredEffectRel?: number | null;
                    poweredEffectAbs?: number | null;
                  } | null;
                }>;
                srmResult: Array<{
                  isSignificant?: boolean | null;
                  segmentId?: string | null;
                  status?: {
                    status?: StatsV2AnalysisMetricResultStatus | null;
                    message?: string | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    decisionPowered?: boolean | null;
                    decisionIsSignificant?: boolean | null;
                    validationIsSignificant?: boolean | null;
                  } | null;
                  dimensions: Array<{ key: string; value?: string | null }>;
                  result: Array<{
                    group?: string | null;
                    observed?: number | null;
                    expected?: number | null;
                    isSignificant?: boolean | null;
                  }>;
                }>;
                statsSettings?: {
                  method?: StatsV2AnalysisMethod | null;
                  adjustedAlpha?: number | null;
                  adjustedBeta?: number | null;
                  hasVarianceReduction?: boolean | null;
                } | null;
              }>;
              treatments: Array<{
                id?: string | null;
                recommendation?: {
                  shipping?: StatsV2AnalysisShippingRecommendation | null;
                  status?: {
                    quality?: StatsV2AnalysisQualityStatus | null;
                    tanking?: StatsV2AnalysisTankingStatus | null;
                    guardrail?: StatsV2AnalysisGuardrailStatus | null;
                    success?: StatsV2AnalysisSuccessStatus | null;
                  } | null;
                } | null;
              }>;
            };
      }> | null;
      metricMethods?: Array<{
        metricName: string;
        method: StatsDataMethodMethod;
      }> | null;
    } | null;
    explore?: {
      exploratoryAnalyses: Array<{
        createTime: string;
        updateTime: string;
        id: string;
        messages: Array<string>;
        name: string;
        splitByExposureFilters?: boolean | null;
        startTime?: string | null;
        endTime?: string | null;
        useCustomDateRange?: boolean | null;
        state: ExploreDataAnalysisState;
        useScheduledCalculation?: boolean | null;
        analysisResults?: Array<{
          exposureFilterName?: string | null;
          analysisResult:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'StatsV2AnalysisAnalysisResult';
                name: string;
                exposureFilter?: string | null;
                updateTime: string;
                annotations: Array<{
                  context: Array<{
                    key?: StatsV2AnalysisStatsAnnotationContext | null;
                    value?: string | null;
                  }>;
                }>;
                results: Array<{
                  id?: string | null;
                  annotations: Array<{
                    info?: string | null;
                    warning?: string | null;
                    context: Array<{
                      key?: StatsV2AnalysisStatsAnnotationContext | null;
                      value?: string | null;
                    }>;
                    error?: {
                      category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                      details?: string | null;
                    } | null;
                  }>;
                  metricDetails?: {
                    direction?: StatsV2AnalysisMetricDirection | null;
                    hasRun?: boolean | null;
                    metricType?: StatsV2AnalysisMetricType | null;
                    plannedEffectSize?: { value?: string | null } | null;
                  } | null;
                  result: Array<{
                    comparisonId?: string | null;
                    isSignificant?: boolean | null;
                    usedDataType?: StatsV2AnalysisStatsDataType | null;
                    segmentId?: string | null;
                    dimensions: Array<{ value?: string | null; key: string }>;
                    groupStats: Array<{
                      sampleSize?: any | null;
                      id?: string | null;
                    }>;
                    groups?: {
                      baseline?: string | null;
                      compared?: string | null;
                    } | null;
                    lastDeteriorationResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      comparedEstimateRel?: number | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        isSignificant?: boolean | null;
                        lower?: number | null;
                        powered?: number | null;
                        upper?: number | null;
                      } | null;
                    } | null;
                    lastResult?: {
                      baselineEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      baselineSampleSize?: any | null;
                      comparedEstimateAbs?: number | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    } | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    result: Array<{
                      resultTime?: string | null;
                      baselineEstimateAbs?: number | null;
                      comparedEstimateAbs?: number | null;
                      baselineEstimateRel?: number | null;
                      comparedEstimateRel?: number | null;
                      varianceReductionRate?: number | null;
                      unadjustedEstimateBaseline?: number | null;
                      unadjustedEstimateCompared?: number | null;
                      baselineSampleSize?: any | null;
                      comparedSampleSize?: any | null;
                      differenceEstimateAbs?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                      differenceEstimateRel?: {
                        estimate?: number | null;
                        lower?: number | null;
                        upper?: number | null;
                        isSignificant?: boolean | null;
                      } | null;
                    }>;
                    sampleSize?: {
                      current?: any | null;
                      required?: any | null;
                      poweredEffectRel?: number | null;
                      poweredEffectAbs?: number | null;
                    } | null;
                  }>;
                  srmResult: Array<{
                    isSignificant?: boolean | null;
                    segmentId?: string | null;
                    status?: {
                      status?: StatsV2AnalysisMetricResultStatus | null;
                      message?: string | null;
                      metricType?: StatsV2AnalysisMetricType | null;
                      decisionPowered?: boolean | null;
                      decisionIsSignificant?: boolean | null;
                      validationIsSignificant?: boolean | null;
                    } | null;
                    dimensions: Array<{ key: string; value?: string | null }>;
                    result: Array<{
                      group?: string | null;
                      observed?: number | null;
                      expected?: number | null;
                      isSignificant?: boolean | null;
                    }>;
                  }>;
                  statsSettings?: {
                    method?: StatsV2AnalysisMethod | null;
                    adjustedAlpha?: number | null;
                    adjustedBeta?: number | null;
                    hasVarianceReduction?: boolean | null;
                  } | null;
                }>;
                treatments: Array<{
                  id?: string | null;
                  recommendation?: {
                    shipping?: StatsV2AnalysisShippingRecommendation | null;
                    status?: {
                      quality?: StatsV2AnalysisQualityStatus | null;
                      tanking?: StatsV2AnalysisTankingStatus | null;
                      guardrail?: StatsV2AnalysisGuardrailStatus | null;
                      success?: StatsV2AnalysisSuccessStatus | null;
                    } | null;
                  } | null;
                }>;
              };
        }> | null;
        conclusion?: { updateTime: string; text: string } | null;
        metrics: Array<{
          calculationError?: string | null;
          name:
            | {
                name: string;
                displayName: string;
                description?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
                entity?:
                  | {
                      __typename: 'MetricsV1Entity';
                      createTime: string;
                      name: string;
                      displayName: string;
                      primaryKeyType: MetricsV1ColumnType;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      defaultAssignmentTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | Record<PropertyKey, never>;
          dimensions: Array<
            | {
                column: string;
                dimensionTable?:
                  | {
                      __typename: 'MetricsV1DimensionTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      state: MetricsV1TableState;
                      dimensionDataDeliveredUntilTime?: string | null;
                      sql: string;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            name: string;
                            displayName: string;
                            pictureUri?: string | null;
                          }
                        | null;
                      entityColumnMapping: {
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            };
                        column: { name: string };
                      };
                      dimensions: Array<{ name: string }>;
                      labels: Array<{ key: string; value?: string | null }>;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                      timeConfig?: {
                        window: string;
                        timestampColumn: {
                          name: string;
                          type?: MetricsV1ColumnType | null;
                        };
                      } | null;
                      valueMappings: Array<{
                        column: string;
                        mappings: Array<{
                          inputDimensionValue?: string | null;
                          outputDimensionValue?: string | null;
                        }>;
                      }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
              }
            | {
                column: string;
                factTable:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      sql: string;
                      state: MetricsV1TableState;
                      factDataDeliveredUntilTime?: string | null;
                      timestampColumn: { name: string };
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      entities: Array<{
                        entity:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Entity';
                              name: string;
                              displayName: string;
                            };
                        column: { name: string };
                      }>;
                      measures: Array<{
                        declaredType?: MetricsV1ColumnType | null;
                        column: { name: string };
                        unit?: {
                          baseUnitMultiplier?: number | null;
                          baseUnit?: MetricsV1UnitBaseUnit | null;
                          currencyCode?: string | null;
                          customUnit?: string | null;
                        } | null;
                      }>;
                      dimensions: Array<{ name: string }>;
                      dataDeliveredUntilUpdateStrategyConfig?: {
                        strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                        disableEmptyPartitions?: boolean | null;
                        automaticUpdateConfig?: {
                          commitDelay: string;
                          changeThreshold?: { value?: string | null } | null;
                        } | null;
                        dailyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                        hourlyUpdateConfig?: {
                          __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                          maxZeroDuration?: string | null;
                        } | null;
                      } | null;
                      error?: {
                        details: Array<string>;
                        message?: string | null;
                      } | null;
                      schemaValidationJob:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1SqlJob';
                            name: string;
                            successfulQueryResult?: {
                              schema: Array<{
                                name: string;
                                type?: MetricsV1ColumnType | null;
                              }>;
                            } | null;
                          };
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | Record<PropertyKey, never>;
              }
          >;
          calculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1MetricCalculation';
                name: string;
                state?: MetricsV1MetricCalculationState | null;
              }
            | null;
          scheduledCalculation?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'MetricsV1ScheduledMetricCalculation';
                name: string;
                state?: MetricsV1ScheduledMetricCalculationState | null;
                status: {
                  scheduled?: { nextScheduleTime: string } | null;
                  cancelled?: { cancelledTime: string } | null;
                  calculating?: {
                    metricCalculation:
                      | { name: string }
                      | Record<PropertyKey, never>;
                  } | null;
                  waiting?: {
                    dataDeliveredUntilTime?: string | null;
                    needDataUntilTime: string;
                    exposureTable?:
                      | { name: string }
                      | Record<PropertyKey, never>
                      | null;
                    factTable?:
                      | {
                          __typename: 'MetricsV1FactTable';
                          name: string;
                          displayName: string;
                          state: MetricsV1TableState;
                        }
                      | Record<PropertyKey, never>
                      | null;
                  } | null;
                  error?: { errorMessage: string } | null;
                };
              }
            | null;
        }>;
        createdBy?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'IamV1User';
              name: string;
              fullName: string;
              email: string;
              pictureUri?: string | null;
              lastLoginTime?: string | null;
            }
          | null;
      }>;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
  };
  resourceRelations?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FgaV1ListResourceRelationsResponse';
        resourceRelations: Array<{ relation: string }>;
      }
    | null;
  queryWorkflowInstancePermissions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
        isAllAllowed?: boolean | null;
        actionPermissionCheckResults: Array<{
          action?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
        functionPermissionCheckResults: Array<{
          function?: string | null;
          isAllowed?: boolean | null;
          permissionChecks: Array<{
            isAllowed?: boolean | null;
            relation?: string | null;
            resource?: string | null;
          }>;
        }>;
      }
    | null;
  transitionStatus?: {
    action: string;
    initiator:
      | { name: string; displayName: string }
      | Record<PropertyKey, never>;
    running?: { startTime: string } | null;
    completed?: { startTime: string; endTime: string } | null;
    failed?: { startTime: string; endTime: string; error: string } | null;
  } | null;
};

export type WorkflowInstanceCheckFragment = {
  name: string;
  displayName?: string | null;
  state: WorkflowV1WorkflowInstanceCheckState;
  message: string;
  updateTime: string;
  data?: any | null;
  labels: Array<{ key: string; value?: string | null }>;
  parent?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
    | null;
};

export type WorkflowInstanceListItemFragment = {
  displayName: string;
  state: string;
  name: string;
  createTime: string;
  updateTime: string;
  labels: Array<{ key: string; value?: string | null }>;
  owner?:
    | { __typename: 'IamV1Identity'; name: string; displayName: string }
    | Record<PropertyKey, never>
    | null;
  checks: Array<{
    name: string;
    displayName?: string | null;
    state: WorkflowV1WorkflowInstanceCheckState;
    message: string;
    updateTime: string;
    data?: any | null;
    labels: Array<{ key: string; value?: string | null }>;
    parent?:
      | { __typename: 'Error'; message?: string | null; code: ErrorCode }
      | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
      | null;
  }>;
  comments?:
    | {
        __typename: 'CollaborationV1ListCommentsResponse';
        comments: Array<{
          name: string;
          resolved?: boolean | null;
          assignee?:
            | { __typename: 'Error' }
            | { __typename: 'IamV1Identity'; name: string }
            | null;
        }>;
      }
    | { __typename: 'Error' }
    | null;
  pendingTransition?: {
    succeededSteps: Array<string>;
    targetState: string;
    unprocessedSteps: Array<string>;
    transitionAction: string;
    failedSteps: Array<{ actionStep: string; failuresMessages: Array<string> }>;
  } | null;
  moduleData: Array<{ value?: any | null; key: string }>;
  moduleData2: {
    planning?: {
      planned?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
      actual?: {
        startTime?: string | null;
        endTime?: string | null;
        runtime?: string | null;
      } | null;
    } | null;
    reviews?: {
      __typename: 'ReviewsData';
      approvalRequired?: boolean | null;
      reviewId?: string | null;
      status?: ReviewsDataStatus | null;
      optionalReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
      requiredReviews?: Array<{
        __typename: 'ReviewsDataSurfaceReviewData';
        state: ReviewsDataSurfaceReviewDataState;
        responses?: Array<{
          __typename: 'ReviewsDataSurfaceReviewDataResponse';
          id?: string | null;
          state: ReviewsDataSurfaceReviewDataResponseState;
          stale?: boolean | null;
          commentId?: string | null;
          groups?: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              }
          > | null;
          reviewer:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
                service?: string | null;
                everyone?: boolean | null;
                user?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      scimExternalId?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
                apiClient?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1ApiClient';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      clientId: string;
                      clientSecret?: string | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    }
                  | null;
                group?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Group';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      groupType: IamV1GroupGroupType;
                      slackChannel?: string | null;
                      createTime: string;
                      updateTime: string;
                      identity: { name: string } | Record<PropertyKey, never>;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                    }
                  | null;
                agent?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1Agent';
                      name: string;
                      displayName: string;
                      pictureUri?: string | null;
                      reviewerSkill?: { enabled: boolean } | null;
                    }
                  | null;
              };
        }> | null;
        surface?:
          | { __typename: 'Error'; message?: string | null; code: ErrorCode }
          | {
              __typename: 'WorkflowV1Surface';
              name: string;
              displayName: string;
              description?: string | null;
              deleteTime?: string | null;
            }
          | null;
      }> | null;
    } | null;
    rollout?: {
      variantImageUri?: string | null;
      reach?: string | null;
      initialReach?: string | null;
      controlAssignmentId?: string | null;
      description?: string | null;
      monitoringDisabled: boolean;
      treatmentGroupProportion?: number | null;
      variantAssignmentId?: string | null;
      schedule?: {
        state?: RolloutDataScheduleState | null;
        stateReason?: {
          failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
        } | null;
        steps: Array<{
          durationSincePreviousStep: string;
          reach: string;
          status?: RolloutDataScheduleScheduleStepsStatus | null;
          updateTime?: string | null;
        }>;
      } | null;
      variant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      abtest?:
        | { __typename: 'Error' }
        | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
        | null;
      controlVariant?:
        | { __typename: 'Error' }
        | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
        | null;
      flag?:
        | { __typename: 'Error' }
        | {
            __typename: 'FlagsAdminV1Flag';
            name: string;
            clients: Array<
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'IamV1Client';
                  name: string;
                  displayName: string;
                  createTime: string;
                  deleteTime?: string | null;
                }
            >;
          }
        | null;
    } | null;
    decision?: { outcome?: DecisionRecordDataOutcome | null } | null;
  };
};

export type WorkflowInstanceRefFragment = {
  __typename: 'WorkflowV1WorkflowInstance';
  name: string;
  displayName: string;
};

export type WorkflowInstanceRefQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type WorkflowInstanceRefQuery = {
  workflowInstance?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        displayName: string;
      }
    | null;
};

export type WorkflowInstancesQueryVariables = Exact<{
  parent?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type WorkflowInstancesQuery = {
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        nextPageToken?: string | null;
        workflowInstances: Array<{
          __typename: 'WorkflowV1WorkflowInstance';
          possibleTransitions: Array<string>;
          lockedDataKeys: Array<string>;
          displayName: string;
          state: string;
          name: string;
          deleteTime?: string | null;
          updateTime: string;
          labels: Array<{ key: string; value?: string | null }>;
          owner?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'IamV1Identity';
                name: string;
                displayName: string;
                pictureUri?: string | null;
              }
            | null;
          surfaces: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Surface';
                name: string;
                displayName: string;
                description?: string | null;
                metricConfig?: {
                  metrics: Array<{
                    enforcementLevel?: WorkflowV1EnforcementLevel | null;
                    metric:
                      | { name: string; displayName: string }
                      | Record<PropertyKey, never>;
                  }>;
                } | null;
              }
          >;
          surfaceRequirements: Array<{
            enforcementLevel?: WorkflowV1EnforcementLevel | null;
            reason?: string | null;
            surface?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | {
                  __typename: 'WorkflowV1Surface';
                  name: string;
                  displayName: string;
                  description?: string | null;
                }
              | null;
          }>;
          initiatives: Array<
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1Initiative';
                name: string;
                displayName: string;
                description?: string | null;
              }
          >;
          workflowVersion?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1WorkflowVersion';
                name: string;
                workflowInfo?: {
                  modules: Array<{ key: string }>;
                  functions: Array<{ key: string }>;
                } | null;
              }
            | null;
          stateHistory: Array<{ state?: string | null }>;
          pendingTransition?: {
            succeededSteps: Array<string>;
            targetState: string;
            unprocessedSteps: Array<string>;
            transitionAction: string;
            failedSteps: Array<{
              actionStep: string;
              failuresMessages: Array<string>;
            }>;
          } | null;
          checks: Array<{
            name: string;
            displayName?: string | null;
            state: WorkflowV1WorkflowInstanceCheckState;
            message: string;
            updateTime: string;
            data?: any | null;
            labels: Array<{ key: string; value?: string | null }>;
            parent?:
              | {
                  __typename: 'Error';
                  message?: string | null;
                  code: ErrorCode;
                }
              | { __typename: 'WorkflowV1WorkflowInstanceCheck'; name: string }
              | null;
          }>;
          moduleData: Array<{ key: string; value?: any | null }>;
          moduleData2: {
            abtest?: {
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    variants: Array<{
                      description?: string | null;
                      name: string;
                      imageUri?: string | null;
                    }>;
                  }
                | null;
              treatments?: Array<{
                name?: string | null;
                weight: any;
                displayName?: string | null;
                description?: string | null;
                imageUri?: string | null;
                variant:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | { __typename: 'FlagsAdminV1FlagVariant'; name: string };
              }> | null;
              rollout?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
            } | null;
            flags?: {
              targetingKeySelector?: string | null;
              stickyAssignments?: boolean | null;
              ignoreTargetingForSticky?: boolean | null;
              intakePaused?: boolean | null;
              flag?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
              segment?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'FlagsAdminV1Segment';
                    name: string;
                    displayName?: string | null;
                    description?: string | null;
                    state?: FlagsAdminV1SegmentState | null;
                    createTime: string;
                    updateTime: string;
                    flag?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FlagsAdminV1Flag';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    workflowInstance?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        }
                      | null;
                    owner?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Identity';
                          name: string;
                          displayName: string;
                          pictureUri?: string | null;
                        }
                      | null;
                    allocation?: {
                      exclusiveTo: Array<string>;
                      exclusivityTags: Array<string>;
                      proportion?: { value?: string | null } | null;
                    } | null;
                    targeting?: {
                      criteria: Array<{
                        key: string;
                        value?: {
                          attribute?: {
                            attributeName?: string | null;
                            eqRule?: {
                              value?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            setRule?: {
                              values: Array<{
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              }>;
                            } | null;
                            rangeRule?: {
                              startInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              startExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endInclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                              endExclusive?: {
                                boolValue?: boolean | null;
                                numberValue?: number | null;
                                stringValue?: string | null;
                                timestampValue?: string | null;
                                versionValue?: {
                                  version?: string | null;
                                } | null;
                              } | null;
                            } | null;
                            startsWithRule?: { value?: string | null } | null;
                            containsRule?: { value?: string | null } | null;
                            endsWithRule?: { value?: string | null } | null;
                            anyRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                            allRule?: {
                              rule?: {
                                eqRule?: {
                                  value?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                setRule?: {
                                  values: Array<{
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  }>;
                                } | null;
                                rangeRule?: {
                                  startInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  startExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endInclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                  endExclusive?: {
                                    boolValue?: boolean | null;
                                    numberValue?: number | null;
                                    stringValue?: string | null;
                                    timestampValue?: string | null;
                                    versionValue?: {
                                      version?: string | null;
                                    } | null;
                                  } | null;
                                } | null;
                                startsWithRule?: {
                                  value?: string | null;
                                } | null;
                                containsRule?: { value?: string | null } | null;
                                endsWithRule?: { value?: string | null } | null;
                              } | null;
                            } | null;
                          } | null;
                          segment?: {
                            segment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1Segment';
                                  name: string;
                                  displayName?: string | null;
                                  labels: Array<{
                                    key: string;
                                    value?: string | null;
                                  }>;
                                }
                              | null;
                          } | null;
                          materializedSegment?: {
                            materializedSegment?:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'FlagsAdminV1MaterializedSegment';
                                  name: string;
                                  displayName: string;
                                }
                              | null;
                          } | null;
                        } | null;
                      }>;
                      expression?: {
                        ref?: string | null;
                        not?: { ref?: string | null } | null;
                        and?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                        or?: {
                          operands: Array<{
                            ref?: string | null;
                            not?: { ref?: string | null } | null;
                            and?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                            or?: {
                              operands: Array<{
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                  }>;
                                } | null;
                              }>;
                            } | null;
                          }>;
                        } | null;
                      } | null;
                    } | null;
                    labels: Array<{ key: string; value?: string | null }>;
                    resourceRelations?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'FgaV1ListResourceRelationsResponse';
                          resourceRelations: Array<{
                            relation: string;
                            resource: string;
                          }>;
                        }
                      | null;
                  }
                | null;
              rule?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | { __typename: 'FlagsAdminV1FlagRule'; name: string }
                | null;
            } | null;
            hypothesis?: { text?: string | null } | null;
            decision?: {
              outcome?: DecisionRecordDataOutcome | null;
              conclusion?: string | null;
              treatment?: string | null;
            } | null;
            reviews?: {
              __typename: 'ReviewsData';
              approvalRequired?: boolean | null;
              reviewId?: string | null;
              status?: ReviewsDataStatus | null;
              optionalReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
              requiredReviews?: Array<{
                __typename: 'ReviewsDataSurfaceReviewData';
                state: ReviewsDataSurfaceReviewDataState;
                responses?: Array<{
                  __typename: 'ReviewsDataSurfaceReviewDataResponse';
                  id?: string | null;
                  state: ReviewsDataSurfaceReviewDataResponseState;
                  stale?: boolean | null;
                  commentId?: string | null;
                  groups?: Array<
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      }
                  > | null;
                  reviewer:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'IamV1Identity';
                        name: string;
                        displayName: string;
                        pictureUri?: string | null;
                        service?: string | null;
                        everyone?: boolean | null;
                        user?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1User';
                              name: string;
                              fullName: string;
                              email: string;
                              pictureUri?: string | null;
                              scimExternalId?: string | null;
                              lastLoginTime?: string | null;
                            }
                          | null;
                        apiClient?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1ApiClient';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              clientId: string;
                              clientSecret?: string | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        group?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Group';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              groupType: IamV1GroupGroupType;
                              slackChannel?: string | null;
                              createTime: string;
                              updateTime: string;
                              identity:
                                | { name: string }
                                | Record<PropertyKey, never>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                      resource: string;
                                    }>;
                                  }
                                | null;
                            }
                          | null;
                        agent?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Agent';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                              reviewerSkill?: { enabled: boolean } | null;
                            }
                          | null;
                      };
                }> | null;
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
              }> | null;
            } | null;
            planning?: {
              planned?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
              actual?: {
                startTime?: string | null;
                endTime?: string | null;
                runtime?: string | null;
              } | null;
            } | null;
            samplesize?: {
              error?: string | null;
              useScheduledCalculation?: boolean | null;
              requiredSampleSize?: any | null;
              state?: SampleSizeDataState | null;
              exposure?:
                | {
                    exposureCalculation?: any | null;
                    scheduledExposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    assignmentTable: {
                      assignmentTable?: string | null;
                      filters?: { assignmentFilter?: any | null } | null;
                    };
                  }
                | {
                    exposureCalculation?: any | null;
                    startTime?: string | null;
                    endTime?: string | null;
                    existingInstance: {
                      workflowInstance:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'WorkflowV1WorkflowInstance';
                            name: string;
                            displayName: string;
                          };
                    };
                  }
                | null;
              exposureSource?:
                | {
                    assignmentTable?: string | null;
                    customStartTime?: string | null;
                    customEndTime?: string | null;
                    filters?: {
                      assignmentFilter?: any | null;
                      entityFilter?: any | null;
                      exposureFilter?: string | null;
                    } | null;
                  }
                | {
                    workflowInstance:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'WorkflowV1WorkflowInstance';
                          name: string;
                          displayName: string;
                        };
                  }
                | null;
              metrics?: Array<{
                error?: string | null;
                metric: string;
                metricCalculation?: any | null;
                scheduledMetricCalculation?: any | null;
                requiredSampleSize?: any | null;
                state?: SampleSizeDataSampleSizeMetricState | null;
                type?: SampleSizeDataSampleSizeMetricType | null;
                metricCalculationName?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1MetricCalculation';
                      name: string;
                      state?: MetricsV1MetricCalculationState | null;
                    }
                  | null;
                summaryStats?: {
                  mean?: number | null;
                  variance?: number | null;
                  varianceReductionRate?: number | null;
                  count?: any | null;
                } | null;
                observedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  mean?: number | null;
                  variance?: number | null;
                  expectedSampleSize?: any | null;
                }> | null;
                forecastedData?: Array<{
                  dayIndex: any;
                  requiredSampleSize?: any | null;
                  expectedSampleSize?: any | null;
                }> | null;
              }> | null;
            } | null;
            metrics?: {
              bucket?: MetricsDataBucket | null;
              assignmentTable?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1AssignmentTable';
                    name: string;
                    displayName: string;
                    dimensions: Array<{ name: string }>;
                    dataWarehouse?:
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | { __typename: 'MetricsV1DataWarehouse'; name: string }
                      | null;
                  }
                | null;
              exposureTableSchedule?:
                | {
                    __typename: 'MetricsV1ScheduledExposureCalculation';
                    name: string;
                  }
                | Record<PropertyKey, never>
                | null;
              metrics: Array<{
                __typename: 'MetricsDataMetric';
                preferredDirection?: MetricsDataMetricPreferredDirection | null;
                surfaceOnly?: boolean | null;
                metric:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1Metric';
                      displayName: string;
                      name: string;
                      description?: string | null;
                      createTime: string;
                      updateTime: string;
                      deleteTime?: string | null;
                      state?: MetricsV1MetricState | null;
                      preferredDirection?: MetricsV1MetricPreferredDirection | null;
                      measurement?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Measurement';
                            name: string;
                            displayName: string;
                            typeSpec: {
                              averageMetricSpec?: {
                                measurement?: { name: string } | null;
                                aggregation: { type: MetricsV1AggregationType };
                              } | null;
                              ratioMetricSpec?: {
                                numerator?: { name: string } | null;
                                numeratorAggregation: {
                                  type: MetricsV1AggregationType;
                                };
                                denominator?: { name: string } | null;
                                denominatorAggregation: {
                                  type: MetricsV1AggregationType;
                                };
                              } | null;
                              quantileMetricSpec?: {
                                quantileLevel: number;
                                aggregation: { type: MetricsV1AggregationType };
                              } | null;
                            };
                            filter?: {
                              criteria: Array<{
                                key: string;
                                value?: {
                                  attribute?: {
                                    attribute: string;
                                    eqRule?: {
                                      value: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      };
                                    } | null;
                                    setRule?: {
                                      values: Array<{
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      }>;
                                    } | null;
                                    rangeRule?: {
                                      startInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      startExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      endInclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                      endExclusive?: {
                                        boolValue?: boolean | null;
                                        numberValue?: number | null;
                                        stringValue?: string | null;
                                        timestampValue?: string | null;
                                        nullValue?: {
                                          dummyField?: string | null;
                                        } | null;
                                      } | null;
                                    } | null;
                                    likeRule?: { pattern: string } | null;
                                  } | null;
                                } | null;
                              }>;
                              expression: {
                                ref?: string | null;
                                not?: { ref?: string | null } | null;
                                and?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                                or?: {
                                  operands: Array<{
                                    ref?: string | null;
                                    not?: { ref?: string | null } | null;
                                    and?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                    or?: {
                                      operands: Array<{
                                        ref?: string | null;
                                        not?: { ref?: string | null } | null;
                                      }>;
                                    } | null;
                                  }>;
                                } | null;
                              };
                            } | null;
                            entity:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1Entity';
                                  name: string;
                                  displayName: string;
                                };
                            factTable:
                              | {
                                  __typename: 'Error';
                                  message?: string | null;
                                  code: ErrorCode;
                                }
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                };
                            nullHandling?: {
                              replaceEntityNullWithZero?: boolean | null;
                            } | null;
                          }
                        | null;
                      owner?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'IamV1Identity';
                            displayName: string;
                            name: string;
                            everyone?: boolean | null;
                            user?:
                              | { pictureUri?: string | null; name: string }
                              | Record<PropertyKey, never>
                              | null;
                            group?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            apiClient?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                          }
                        | null;
                      factTable?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1FactTable';
                            name: string;
                            displayName: string;
                            state: MetricsV1TableState;
                          }
                        | null;
                      filter?: {
                        criteria: Array<{
                          key: string;
                          value?: {
                            attribute?: {
                              attribute: string;
                              eqRule?: {
                                value: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                };
                              } | null;
                              setRule?: {
                                values: Array<{
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                }>;
                              } | null;
                              rangeRule?: {
                                startInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                startExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endInclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                                endExclusive?: {
                                  boolValue?: boolean | null;
                                  numberValue?: number | null;
                                  stringValue?: string | null;
                                  timestampValue?: string | null;
                                  nullValue?: {
                                    dummyField?: string | null;
                                  } | null;
                                } | null;
                              } | null;
                              likeRule?: { pattern: string } | null;
                            } | null;
                          } | null;
                        }>;
                        expression: {
                          ref?: string | null;
                          not?: { ref?: string | null } | null;
                          and?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                          or?: {
                            operands: Array<{
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                }>;
                              } | null;
                            }>;
                          } | null;
                        };
                      } | null;
                      entity?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'MetricsV1Entity';
                            name: string;
                            displayName: string;
                          }
                        | null;
                      measurementConfig?: {
                        closedWindow?: {
                          aggregationWindow: string;
                          exposureOffset: string;
                        } | null;
                        semiOpenWindow?: {
                          aggregationWindow: string;
                          exposureOffset?: string | null;
                        } | null;
                        openWindow?: { dummy?: string | null } | null;
                      } | null;
                      varianceReductionConfig?: {
                        aggregationWindowOverride?: string | null;
                        disabled?: boolean | null;
                      } | null;
                      nullHandling?: {
                        replaceEntityNullWithZero?: boolean | null;
                      } | null;
                      typeSpec?: {
                        ratioMetricSpec?: {
                          numerator?: { name: string } | null;
                          numeratorAggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                          numeratorFilter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                          denominator?: { name: string } | null;
                          denominatorAggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                          denominatorFilter?: {
                            criteria: Array<{
                              key: string;
                              value?: {
                                attribute?: {
                                  attribute: string;
                                  eqRule?: {
                                    value: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    };
                                  } | null;
                                  setRule?: {
                                    values: Array<{
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    }>;
                                  } | null;
                                  rangeRule?: {
                                    startInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    startExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endInclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                    endExclusive?: {
                                      boolValue?: boolean | null;
                                      numberValue?: number | null;
                                      stringValue?: string | null;
                                      timestampValue?: string | null;
                                      nullValue?: {
                                        dummyField?: string | null;
                                      } | null;
                                    } | null;
                                  } | null;
                                  likeRule?: { pattern: string } | null;
                                } | null;
                              } | null;
                            }>;
                            expression: {
                              ref?: string | null;
                              not?: { ref?: string | null } | null;
                              and?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                              or?: {
                                operands: Array<{
                                  ref?: string | null;
                                  not?: { ref?: string | null } | null;
                                  and?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                  or?: {
                                    operands: Array<{
                                      ref?: string | null;
                                      not?: { ref?: string | null } | null;
                                    }>;
                                  } | null;
                                }>;
                              } | null;
                            };
                          } | null;
                        } | null;
                        averageMetricSpec?: {
                          measurement?: {
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          } | null;
                          aggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                        } | null;
                        quantileMetricSpec?: {
                          quantileLevel: number;
                          measurement?: {
                            name: string;
                            type?: MetricsV1ColumnType | null;
                          } | null;
                          aggregation: {
                            type: MetricsV1AggregationType;
                            threshold?: {
                              direction: MetricsV1AggregationThresholdDirection;
                              threshold: { value?: string | null };
                            } | null;
                            cap?: {
                              min?: { value?: string | null } | null;
                              max?: { value?: string | null } | null;
                            } | null;
                          };
                        } | null;
                      } | null;
                      labels: Array<{ key: string; value?: string | null }>;
                      archiveInfo?: {
                        reason?: string | null;
                        archiveTime?: string | null;
                      } | null;
                      defaultEffectSize?: { value?: string | null } | null;
                      source?: {
                        type?: MetricsV1MetricMetricSourceType | null;
                        reference?: string | null;
                      } | null;
                      verification?: {
                        state?: MetricsV1MetricMetricVerificationVerificationState | null;
                        verifyTime?: string | null;
                        verifier?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'IamV1Identity';
                              name: string;
                              displayName: string;
                              pictureUri?: string | null;
                            }
                          | null;
                      } | null;
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{ relation: string }>;
                          }
                        | null;
                    };
                schedule?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'MetricsV1ScheduledMetricCalculation';
                      name: string;
                      state?: MetricsV1ScheduledMetricCalculationState | null;
                      nextScheduledRunTime: string;
                      nextExposureStartTime: string;
                      nextExposureEndTime: string;
                      iteration: number;
                      executedCalculationsCount: number;
                      status: {
                        scheduled?: { nextScheduleTime: string } | null;
                        cancelled?: { cancelledTime: string } | null;
                        calculating?: {
                          metricCalculation:
                            | { name: string }
                            | Record<PropertyKey, never>;
                        } | null;
                        waiting?: {
                          dataDeliveredUntilTime?: string | null;
                          needDataUntilTime: string;
                          exposureTable?:
                            | { name: string }
                            | Record<PropertyKey, never>
                            | null;
                          factTable?:
                            | {
                                __typename: 'MetricsV1FactTable';
                                name: string;
                                displayName: string;
                                state: MetricsV1TableState;
                              }
                            | Record<PropertyKey, never>
                            | null;
                        } | null;
                        error?: { errorMessage: string } | null;
                      };
                      metricCalculationSpec: {
                        metric:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1Metric';
                              name: string;
                              displayName: string;
                              nullHandling?: {
                                __typename: 'MetricsV1MetricNullHandlingConfig';
                                replaceEntityNullWithZero?: boolean | null;
                              } | null;
                              measurementConfig?: {
                                closedWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigClosedWindowConfig';
                                  aggregationWindow: string;
                                  exposureOffset: string;
                                } | null;
                                semiOpenWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigSemiOpenWindowConfig';
                                  aggregationWindow: string;
                                  exposureOffset?: string | null;
                                } | null;
                                openWindow?: {
                                  __typename: 'MetricsV1MetricMeasurementConfigOpenWindowConfig';
                                } | null;
                              } | null;
                              factTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1FactTable';
                                    name: string;
                                    displayName: string;
                                    dataDeliveredUntilUpdateStrategyConfig?: {
                                      strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                      disableEmptyPartitions?: boolean | null;
                                      automaticUpdateConfig?: {
                                        commitDelay: string;
                                        changeThreshold?: {
                                          value?: string | null;
                                        } | null;
                                      } | null;
                                      dailyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                      hourlyUpdateConfig?: {
                                        __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                        maxZeroDuration?: string | null;
                                      } | null;
                                    } | null;
                                    partitionedUpdateStrategyState?: {
                                      currentPartitionLastCheckTime?:
                                        | string
                                        | null;
                                      existsCheckDuration?: string | null;
                                      state?: MetricsV1PartitionedUpdateStrategyStateState | null;
                                      usualLateness?: string | null;
                                    } | null;
                                  }
                                | null;
                            };
                        exposureTable:
                          | {
                              __typename: 'MetricsV1ExposureTable';
                              scheduledExposureCalculation?:
                                | {
                                    __typename: 'MetricsV1ScheduledExposureCalculation';
                                    name: string;
                                    exposureCalculationSpec: {
                                      __typename: 'MetricsV1ExposureCalculationSpec';
                                      assignmentTable:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'MetricsV1AssignmentTable';
                                            name: string;
                                            dataDeliveredUntilUpdateStrategyConfig?: {
                                              strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                              disableEmptyPartitions?:
                                                | boolean
                                                | null;
                                              automaticUpdateConfig?: {
                                                commitDelay: string;
                                                changeThreshold?: {
                                                  value?: string | null;
                                                } | null;
                                              } | null;
                                              dailyUpdateConfig?: {
                                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                                maxZeroDuration?: string | null;
                                              } | null;
                                              hourlyUpdateConfig?: {
                                                __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                                maxZeroDuration?: string | null;
                                              } | null;
                                            } | null;
                                          };
                                    };
                                    status: {
                                      calculating?: {
                                        exposureCalculation:
                                          | { name: string }
                                          | Record<PropertyKey, never>;
                                      } | null;
                                      cancelled?: {
                                        cancelledTime: string;
                                      } | null;
                                      error?: { errorMessage: string } | null;
                                      waiting?: {
                                        dataDeliveredUntilTime?: string | null;
                                        needDataUntilTime: string;
                                        assignmentTable?:
                                          | {
                                              __typename: 'Error';
                                              message?: string | null;
                                              code: ErrorCode;
                                            }
                                          | {
                                              __typename: 'MetricsV1AssignmentTable';
                                              name: string;
                                              displayName: string;
                                            }
                                          | null;
                                      } | null;
                                      scheduled?: {
                                        nextScheduleTime: string;
                                      } | null;
                                    };
                                  }
                                | Record<PropertyKey, never>
                                | null;
                            }
                          | Record<PropertyKey, never>;
                        measurementTable?:
                          | {
                              __typename: 'Error';
                              message?: string | null;
                              code: ErrorCode;
                            }
                          | {
                              __typename: 'MetricsV1MeasurementTable';
                              name: string;
                            }
                          | null;
                      };
                      resourceRelations?:
                        | {
                            __typename: 'Error';
                            message?: string | null;
                            code: ErrorCode;
                          }
                        | {
                            __typename: 'FgaV1ListResourceRelationsResponse';
                            resourceRelations: Array<{
                              relation: string;
                              resource: string;
                            }>;
                          }
                        | null;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | null;
                metricRole:
                  | {
                      nonInferiorityMargin?: number | null;
                      guardrailMetricKind: MetricsDataMetricGuardrailMetricMetricKind;
                    }
                  | {
                      minimumDetectableEffect?: number | null;
                      successMetricKind: MetricsDataMetricSuccessMetricMetricKind;
                    };
                surface?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'WorkflowV1Surface';
                      name: string;
                      displayName: string;
                      description?: string | null;
                      deleteTime?: string | null;
                    }
                  | null;
                calculation?:
                  | { __typename: 'MetricsV1MetricCalculation'; name: string }
                  | Record<PropertyKey, never>
                  | null;
              }>;
              filters?: Array<{
                displayName?: string | null;
                factTable?:
                  | {
                      __typename: 'MetricsV1FactTable';
                      name: string;
                      displayName: string;
                      labels: Array<{ key: string; value?: string | null }>;
                    }
                  | Record<PropertyKey, never>
                  | null;
                filter?: { criteria: any; expression: any } | null;
              }> | null;
              entity?:
                | {
                    __typename: 'Error';
                    message?: string | null;
                    code: ErrorCode;
                  }
                | {
                    __typename: 'MetricsV1Entity';
                    name: string;
                    displayName: string;
                  }
                | null;
            } | null;
            stats?: {
              testHorizonStrategy?: StatsDataTestHorizonStrategy | null;
              analysisResults?: Array<{
                exposureFilterName?: string | null;
                analysisResult:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'StatsV2AnalysisAnalysisResult';
                      name: string;
                      exposureFilter?: string | null;
                      updateTime: string;
                      annotations: Array<{
                        context: Array<{
                          key?: StatsV2AnalysisStatsAnnotationContext | null;
                          value?: string | null;
                        }>;
                      }>;
                      results: Array<{
                        id?: string | null;
                        annotations: Array<{
                          info?: string | null;
                          warning?: string | null;
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                          error?: {
                            category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                            details?: string | null;
                          } | null;
                        }>;
                        metricDetails?: {
                          direction?: StatsV2AnalysisMetricDirection | null;
                          hasRun?: boolean | null;
                          metricType?: StatsV2AnalysisMetricType | null;
                          plannedEffectSize?: { value?: string | null } | null;
                        } | null;
                        result: Array<{
                          comparisonId?: string | null;
                          isSignificant?: boolean | null;
                          usedDataType?: StatsV2AnalysisStatsDataType | null;
                          segmentId?: string | null;
                          dimensions: Array<{
                            value?: string | null;
                            key: string;
                          }>;
                          groupStats: Array<{
                            sampleSize?: any | null;
                            id?: string | null;
                          }>;
                          groups?: {
                            baseline?: string | null;
                            compared?: string | null;
                          } | null;
                          lastDeteriorationResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            comparedEstimateRel?: number | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              isSignificant?: boolean | null;
                              lower?: number | null;
                              powered?: number | null;
                              upper?: number | null;
                            } | null;
                          } | null;
                          lastResult?: {
                            baselineEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            baselineSampleSize?: any | null;
                            comparedEstimateAbs?: number | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          } | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          result: Array<{
                            resultTime?: string | null;
                            baselineEstimateAbs?: number | null;
                            comparedEstimateAbs?: number | null;
                            baselineEstimateRel?: number | null;
                            comparedEstimateRel?: number | null;
                            varianceReductionRate?: number | null;
                            unadjustedEstimateBaseline?: number | null;
                            unadjustedEstimateCompared?: number | null;
                            baselineSampleSize?: any | null;
                            comparedSampleSize?: any | null;
                            differenceEstimateAbs?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                            differenceEstimateRel?: {
                              estimate?: number | null;
                              lower?: number | null;
                              upper?: number | null;
                              isSignificant?: boolean | null;
                            } | null;
                          }>;
                          sampleSize?: {
                            current?: any | null;
                            required?: any | null;
                            poweredEffectRel?: number | null;
                            poweredEffectAbs?: number | null;
                          } | null;
                        }>;
                        srmResult: Array<{
                          isSignificant?: boolean | null;
                          segmentId?: string | null;
                          status?: {
                            status?: StatsV2AnalysisMetricResultStatus | null;
                            message?: string | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            decisionPowered?: boolean | null;
                            decisionIsSignificant?: boolean | null;
                            validationIsSignificant?: boolean | null;
                          } | null;
                          dimensions: Array<{
                            key: string;
                            value?: string | null;
                          }>;
                          result: Array<{
                            group?: string | null;
                            observed?: number | null;
                            expected?: number | null;
                            isSignificant?: boolean | null;
                          }>;
                        }>;
                        statsSettings?: {
                          method?: StatsV2AnalysisMethod | null;
                          adjustedAlpha?: number | null;
                          adjustedBeta?: number | null;
                          hasVarianceReduction?: boolean | null;
                        } | null;
                      }>;
                      treatments: Array<{
                        id?: string | null;
                        recommendation?: {
                          shipping?: StatsV2AnalysisShippingRecommendation | null;
                          status?: {
                            quality?: StatsV2AnalysisQualityStatus | null;
                            tanking?: StatsV2AnalysisTankingStatus | null;
                            guardrail?: StatsV2AnalysisGuardrailStatus | null;
                            success?: StatsV2AnalysisSuccessStatus | null;
                          } | null;
                        } | null;
                      }>;
                    };
              }> | null;
              metricMethods?: Array<{
                metricName: string;
                method: StatsDataMethodMethod;
              }> | null;
            } | null;
            explore?: {
              exploratoryAnalyses: Array<{
                createTime: string;
                updateTime: string;
                id: string;
                messages: Array<string>;
                name: string;
                splitByExposureFilters?: boolean | null;
                startTime?: string | null;
                endTime?: string | null;
                useCustomDateRange?: boolean | null;
                state: ExploreDataAnalysisState;
                useScheduledCalculation?: boolean | null;
                analysisResults?: Array<{
                  exposureFilterName?: string | null;
                  analysisResult:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'StatsV2AnalysisAnalysisResult';
                        name: string;
                        exposureFilter?: string | null;
                        updateTime: string;
                        annotations: Array<{
                          context: Array<{
                            key?: StatsV2AnalysisStatsAnnotationContext | null;
                            value?: string | null;
                          }>;
                        }>;
                        results: Array<{
                          id?: string | null;
                          annotations: Array<{
                            info?: string | null;
                            warning?: string | null;
                            context: Array<{
                              key?: StatsV2AnalysisStatsAnnotationContext | null;
                              value?: string | null;
                            }>;
                            error?: {
                              category?: StatsV2AnalysisStatsAnnotationErrorCategory | null;
                              details?: string | null;
                            } | null;
                          }>;
                          metricDetails?: {
                            direction?: StatsV2AnalysisMetricDirection | null;
                            hasRun?: boolean | null;
                            metricType?: StatsV2AnalysisMetricType | null;
                            plannedEffectSize?: {
                              value?: string | null;
                            } | null;
                          } | null;
                          result: Array<{
                            comparisonId?: string | null;
                            isSignificant?: boolean | null;
                            usedDataType?: StatsV2AnalysisStatsDataType | null;
                            segmentId?: string | null;
                            dimensions: Array<{
                              value?: string | null;
                              key: string;
                            }>;
                            groupStats: Array<{
                              sampleSize?: any | null;
                              id?: string | null;
                            }>;
                            groups?: {
                              baseline?: string | null;
                              compared?: string | null;
                            } | null;
                            lastDeteriorationResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              comparedEstimateRel?: number | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                isSignificant?: boolean | null;
                                lower?: number | null;
                                powered?: number | null;
                                upper?: number | null;
                              } | null;
                            } | null;
                            lastResult?: {
                              baselineEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              baselineSampleSize?: any | null;
                              comparedEstimateAbs?: number | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            } | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            result: Array<{
                              resultTime?: string | null;
                              baselineEstimateAbs?: number | null;
                              comparedEstimateAbs?: number | null;
                              baselineEstimateRel?: number | null;
                              comparedEstimateRel?: number | null;
                              varianceReductionRate?: number | null;
                              unadjustedEstimateBaseline?: number | null;
                              unadjustedEstimateCompared?: number | null;
                              baselineSampleSize?: any | null;
                              comparedSampleSize?: any | null;
                              differenceEstimateAbs?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                              differenceEstimateRel?: {
                                estimate?: number | null;
                                lower?: number | null;
                                upper?: number | null;
                                isSignificant?: boolean | null;
                              } | null;
                            }>;
                            sampleSize?: {
                              current?: any | null;
                              required?: any | null;
                              poweredEffectRel?: number | null;
                              poweredEffectAbs?: number | null;
                            } | null;
                          }>;
                          srmResult: Array<{
                            isSignificant?: boolean | null;
                            segmentId?: string | null;
                            status?: {
                              status?: StatsV2AnalysisMetricResultStatus | null;
                              message?: string | null;
                              metricType?: StatsV2AnalysisMetricType | null;
                              decisionPowered?: boolean | null;
                              decisionIsSignificant?: boolean | null;
                              validationIsSignificant?: boolean | null;
                            } | null;
                            dimensions: Array<{
                              key: string;
                              value?: string | null;
                            }>;
                            result: Array<{
                              group?: string | null;
                              observed?: number | null;
                              expected?: number | null;
                              isSignificant?: boolean | null;
                            }>;
                          }>;
                          statsSettings?: {
                            method?: StatsV2AnalysisMethod | null;
                            adjustedAlpha?: number | null;
                            adjustedBeta?: number | null;
                            hasVarianceReduction?: boolean | null;
                          } | null;
                        }>;
                        treatments: Array<{
                          id?: string | null;
                          recommendation?: {
                            shipping?: StatsV2AnalysisShippingRecommendation | null;
                            status?: {
                              quality?: StatsV2AnalysisQualityStatus | null;
                              tanking?: StatsV2AnalysisTankingStatus | null;
                              guardrail?: StatsV2AnalysisGuardrailStatus | null;
                              success?: StatsV2AnalysisSuccessStatus | null;
                            } | null;
                          } | null;
                        }>;
                      };
                }> | null;
                conclusion?: { updateTime: string; text: string } | null;
                metrics: Array<{
                  calculationError?: string | null;
                  name:
                    | {
                        name: string;
                        displayName: string;
                        description?: string | null;
                        factTable?:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                        entity?:
                          | {
                              __typename: 'MetricsV1Entity';
                              createTime: string;
                              name: string;
                              displayName: string;
                              primaryKeyType: MetricsV1ColumnType;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              defaultAssignmentTable?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    name: string;
                                    displayName: string;
                                    state: MetricsV1TableState;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | Record<PropertyKey, never>;
                  dimensions: Array<
                    | {
                        column: string;
                        dimensionTable?:
                          | {
                              __typename: 'MetricsV1DimensionTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              state: MetricsV1TableState;
                              dimensionDataDeliveredUntilTime?: string | null;
                              sql: string;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    name: string;
                                    displayName: string;
                                    pictureUri?: string | null;
                                  }
                                | null;
                              entityColumnMapping: {
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      createTime: string;
                                      name: string;
                                      displayName: string;
                                      primaryKeyType: MetricsV1ColumnType;
                                      labels: Array<{
                                        key: string;
                                        value?: string | null;
                                      }>;
                                      resourceRelations?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            __typename: 'FgaV1ListResourceRelationsResponse';
                                            resourceRelations: Array<{
                                              relation: string;
                                            }>;
                                          }
                                        | null;
                                      defaultAssignmentTable?:
                                        | {
                                            __typename: 'Error';
                                            message?: string | null;
                                            code: ErrorCode;
                                          }
                                        | {
                                            name: string;
                                            displayName: string;
                                            state: MetricsV1TableState;
                                          }
                                        | null;
                                    };
                                column: { name: string };
                              };
                              dimensions: Array<{ name: string }>;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                              timeConfig?: {
                                window: string;
                                timestampColumn: {
                                  name: string;
                                  type?: MetricsV1ColumnType | null;
                                };
                              } | null;
                              valueMappings: Array<{
                                column: string;
                                mappings: Array<{
                                  inputDimensionValue?: string | null;
                                  outputDimensionValue?: string | null;
                                }>;
                              }>;
                            }
                          | Record<PropertyKey, never>
                          | null;
                      }
                    | {
                        column: string;
                        factTable:
                          | {
                              __typename: 'MetricsV1FactTable';
                              name: string;
                              displayName: string;
                              description?: string | null;
                              sql: string;
                              state: MetricsV1TableState;
                              factDataDeliveredUntilTime?: string | null;
                              timestampColumn: { name: string };
                              owner?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'IamV1Identity';
                                    displayName: string;
                                    name: string;
                                    everyone?: boolean | null;
                                    user?:
                                      | {
                                          pictureUri?: string | null;
                                          name: string;
                                        }
                                      | Record<PropertyKey, never>
                                      | null;
                                    group?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                    apiClient?:
                                      | { name: string }
                                      | Record<PropertyKey, never>
                                      | null;
                                  }
                                | null;
                              entities: Array<{
                                entity:
                                  | {
                                      __typename: 'Error';
                                      message?: string | null;
                                      code: ErrorCode;
                                    }
                                  | {
                                      __typename: 'MetricsV1Entity';
                                      name: string;
                                      displayName: string;
                                    };
                                column: { name: string };
                              }>;
                              measures: Array<{
                                declaredType?: MetricsV1ColumnType | null;
                                column: { name: string };
                                unit?: {
                                  baseUnitMultiplier?: number | null;
                                  baseUnit?: MetricsV1UnitBaseUnit | null;
                                  currencyCode?: string | null;
                                  customUnit?: string | null;
                                } | null;
                              }>;
                              dimensions: Array<{ name: string }>;
                              dataDeliveredUntilUpdateStrategyConfig?: {
                                strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
                                disableEmptyPartitions?: boolean | null;
                                automaticUpdateConfig?: {
                                  commitDelay: string;
                                  changeThreshold?: {
                                    value?: string | null;
                                  } | null;
                                } | null;
                                dailyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                                hourlyUpdateConfig?: {
                                  __typename: 'MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig';
                                  maxZeroDuration?: string | null;
                                } | null;
                              } | null;
                              error?: {
                                details: Array<string>;
                                message?: string | null;
                              } | null;
                              schemaValidationJob:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'MetricsV1SqlJob';
                                    name: string;
                                    successfulQueryResult?: {
                                      schema: Array<{
                                        name: string;
                                        type?: MetricsV1ColumnType | null;
                                      }>;
                                    } | null;
                                  };
                              source?: {
                                type?: MetricsV1MetricMetricSourceType | null;
                                reference?: string | null;
                              } | null;
                              labels: Array<{
                                key: string;
                                value?: string | null;
                              }>;
                              resourceRelations?:
                                | {
                                    __typename: 'Error';
                                    message?: string | null;
                                    code: ErrorCode;
                                  }
                                | {
                                    __typename: 'FgaV1ListResourceRelationsResponse';
                                    resourceRelations: Array<{
                                      relation: string;
                                    }>;
                                  }
                                | null;
                            }
                          | Record<PropertyKey, never>;
                      }
                  >;
                  calculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1MetricCalculation';
                        name: string;
                        state?: MetricsV1MetricCalculationState | null;
                      }
                    | null;
                  scheduledCalculation?:
                    | {
                        __typename: 'Error';
                        message?: string | null;
                        code: ErrorCode;
                      }
                    | {
                        __typename: 'MetricsV1ScheduledMetricCalculation';
                        name: string;
                        state?: MetricsV1ScheduledMetricCalculationState | null;
                        status: {
                          scheduled?: { nextScheduleTime: string } | null;
                          cancelled?: { cancelledTime: string } | null;
                          calculating?: {
                            metricCalculation:
                              | { name: string }
                              | Record<PropertyKey, never>;
                          } | null;
                          waiting?: {
                            dataDeliveredUntilTime?: string | null;
                            needDataUntilTime: string;
                            exposureTable?:
                              | { name: string }
                              | Record<PropertyKey, never>
                              | null;
                            factTable?:
                              | {
                                  __typename: 'MetricsV1FactTable';
                                  name: string;
                                  displayName: string;
                                  state: MetricsV1TableState;
                                }
                              | Record<PropertyKey, never>
                              | null;
                          } | null;
                          error?: { errorMessage: string } | null;
                        };
                      }
                    | null;
                }>;
                createdBy?:
                  | {
                      __typename: 'Error';
                      message?: string | null;
                      code: ErrorCode;
                    }
                  | {
                      __typename: 'IamV1User';
                      name: string;
                      fullName: string;
                      email: string;
                      pictureUri?: string | null;
                      lastLoginTime?: string | null;
                    }
                  | null;
              }>;
            } | null;
            rollout?: {
              variantImageUri?: string | null;
              reach?: string | null;
              initialReach?: string | null;
              controlAssignmentId?: string | null;
              description?: string | null;
              monitoringDisabled: boolean;
              treatmentGroupProportion?: number | null;
              variantAssignmentId?: string | null;
              schedule?: {
                state?: RolloutDataScheduleState | null;
                stateReason?: {
                  failed?: RolloutDataScheduleScheduleStateReasonFailed | null;
                } | null;
                steps: Array<{
                  durationSincePreviousStep: string;
                  reach: string;
                  status?: RolloutDataScheduleScheduleStepsStatus | null;
                  updateTime?: string | null;
                }>;
              } | null;
              variant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              abtest?:
                | { __typename: 'Error' }
                | { __typename: 'WorkflowV1WorkflowInstance'; name: string }
                | null;
              controlVariant?:
                | { __typename: 'Error' }
                | { __typename: 'FlagsAdminV1FlagVariant'; name: string }
                | null;
              flag?:
                | { __typename: 'Error' }
                | {
                    __typename: 'FlagsAdminV1Flag';
                    name: string;
                    clients: Array<
                      | {
                          __typename: 'Error';
                          message?: string | null;
                          code: ErrorCode;
                        }
                      | {
                          __typename: 'IamV1Client';
                          name: string;
                          displayName: string;
                          createTime: string;
                          deleteTime?: string | null;
                        }
                    >;
                  }
                | null;
            } | null;
          };
          resourceRelations?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'FgaV1ListResourceRelationsResponse';
                resourceRelations: Array<{ relation: string }>;
              }
            | null;
          queryWorkflowInstancePermissions?:
            | { __typename: 'Error'; message?: string | null; code: ErrorCode }
            | {
                __typename: 'WorkflowV1QueryWorkflowInstancePermissionsResponse';
                isAllAllowed?: boolean | null;
                actionPermissionCheckResults: Array<{
                  action?: string | null;
                  isAllowed?: boolean | null;
                  permissionChecks: Array<{
                    isAllowed?: boolean | null;
                    relation?: string | null;
                    resource?: string | null;
                  }>;
                }>;
                functionPermissionCheckResults: Array<{
                  function?: string | null;
                  isAllowed?: boolean | null;
                  permissionChecks: Array<{
                    isAllowed?: boolean | null;
                    relation?: string | null;
                    resource?: string | null;
                  }>;
                }>;
              }
            | null;
          transitionStatus?: {
            action: string;
            initiator:
              | { name: string; displayName: string }
              | Record<PropertyKey, never>;
            running?: { startTime: string } | null;
            completed?: { startTime: string; endTime: string } | null;
            failed?: {
              startTime: string;
              endTime: string;
              error: string;
            } | null;
          } | null;
        }>;
      }
    | null;
};

export type WorkflowTemplateFragment = {
  __typename: 'WorkflowV1WorkflowTemplate';
  name: string;
  displayName: string;
  description?: string | null;
  createTime: string;
  updateTime: string;
  creator:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      };
  owner?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1Identity';
        name: string;
        displayName: string;
        pictureUri?: string | null;
      }
    | null;
  sourceInstance:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1WorkflowInstance';
        name: string;
        displayName: string;
      };
  labels: Array<{ key: string; value?: string | null }>;
};

export type WorkflowsQueryVariables = Exact<{ [key: string]: never }>;

export type WorkflowsQuery = {
  workflows?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowsResponse';
        workflows: Array<{
          __typename: 'WorkflowV1Workflow';
          name: string;
          workflowInfo: { modules: Array<{ key: string }> };
        }>;
      }
    | null;
};

export const IdentityRefFragmentDoc = gql`
  fragment IdentityRef on IamV1Identity {
    __typename
    name
    displayName
    pictureUri
  }
`;
export const DefaultErrorFragmentDoc = gql`
  fragment DefaultError on Error {
    __typename
    message
    code
  }
`;
export const InitiativeRefFragmentDoc = gql`
  fragment InitiativeRef on WorkflowV1Initiative {
    __typename
    name
    displayName
    description
  }
`;
export const PendingTransitionFragmentDoc = gql`
  fragment PendingTransition on WorkflowV1WorkflowInstancePendingTransition {
    succeededSteps
    targetState
    unprocessedSteps
    transitionAction
    failedSteps {
      actionStep
      failuresMessages
    }
  }
`;
export const WorkflowInstanceCheckFragmentDoc = gql`
  fragment WorkflowInstanceCheck on WorkflowV1WorkflowInstanceCheck {
    name
    displayName
    state
    message
    updateTime
    labels {
      key
      value
    }
    data
    parent {
      ... on WorkflowV1WorkflowInstanceCheck {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const AbTestTreatmentFragmentDoc = gql`
  fragment AbTestTreatment on AbTestDataTreatment {
    name
    weight
    variant {
      __typename
      ... on FlagsAdminV1FlagVariant {
        name
      }
      ...DefaultError
    }
    displayName
    description
    imageUri
  }
  ${DefaultErrorFragmentDoc}
`;
export const AbTestDataFragmentDoc = gql`
  fragment AbTestData on AbTestData {
    flag {
      __typename
      ... on FlagsAdminV1Flag {
        name
        variants {
          description
          name
          imageUri
        }
      }
      ...DefaultError
    }
    treatments {
      ...AbTestTreatment
    }
    rollout {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${AbTestTreatmentFragmentDoc}
`;
export const FlagClientFragmentDoc = gql`
  fragment FlagClient on IamV1Client {
    __typename
    name
    displayName
    createTime
    deleteTime
  }
`;
export const AllocationFragmentDoc = gql`
  fragment Allocation on FlagsAdminV1SegmentAllocation {
    exclusiveTo
    exclusivityTags
    proportion {
      value
    }
  }
`;
export const ValueFragmentDoc = gql`
  fragment Value on FlagsTypesV1TargetingValue {
    boolValue
    numberValue
    stringValue
    timestampValue
    versionValue {
      version
    }
  }
`;
export const EqRuleFragmentDoc = gql`
  fragment EqRule on FlagsTypesV1TargetingEqRule {
    value {
      ...Value
    }
  }
  ${ValueFragmentDoc}
`;
export const SetRuleFragmentDoc = gql`
  fragment SetRule on FlagsTypesV1TargetingSetRule {
    values {
      ...Value
    }
  }
  ${ValueFragmentDoc}
`;
export const RangeRuleFragmentDoc = gql`
  fragment RangeRule on FlagsTypesV1TargetingRangeRule {
    startInclusive {
      ...Value
    }
    startExclusive {
      ...Value
    }
    endInclusive {
      ...Value
    }
    endExclusive {
      ...Value
    }
  }
  ${ValueFragmentDoc}
`;
export const StartsWithRuleFragmentDoc = gql`
  fragment StartsWithRule on FlagsTypesV1TargetingStartsWithRule {
    value
  }
`;
export const ContainsRuleFragmentDoc = gql`
  fragment ContainsRule on FlagsTypesV1TargetingContainsRule {
    value
  }
`;
export const EndsWithRuleFragmentDoc = gql`
  fragment EndsWithRule on FlagsTypesV1TargetingEndsWithRule {
    value
  }
`;
export const InnerRuleInputFragmentDoc = gql`
  fragment InnerRuleInput on FlagsTypesV1TargetingInnerRule {
    eqRule {
      ...EqRule
    }
    setRule {
      ...SetRule
    }
    rangeRule {
      ...RangeRule
    }
    startsWithRule {
      ...StartsWithRule
    }
    containsRule {
      ...ContainsRule
    }
    endsWithRule {
      ...EndsWithRule
    }
  }
  ${EqRuleFragmentDoc}
  ${SetRuleFragmentDoc}
  ${RangeRuleFragmentDoc}
  ${StartsWithRuleFragmentDoc}
  ${ContainsRuleFragmentDoc}
  ${EndsWithRuleFragmentDoc}
`;
export const TargetingCriterionFragmentDoc = gql`
  fragment TargetingCriterion on FlagsTypesV1TargetingCriterion {
    attribute {
      attributeName
      eqRule {
        ...EqRule
      }
      setRule {
        ...SetRule
      }
      rangeRule {
        ...RangeRule
      }
      startsWithRule {
        ...StartsWithRule
      }
      containsRule {
        ...ContainsRule
      }
      endsWithRule {
        ...EndsWithRule
      }
      anyRule {
        rule {
          ...InnerRuleInput
        }
      }
      allRule {
        rule {
          ...InnerRuleInput
        }
      }
    }
    segment {
      segment {
        ... on FlagsAdminV1Segment {
          __typename
          name
          displayName
          labels {
            key
            value
          }
        }
        ...DefaultError
      }
    }
    materializedSegment {
      materializedSegment {
        ... on FlagsAdminV1MaterializedSegment {
          __typename
          name
          displayName
        }
        ...DefaultError
      }
    }
  }
  ${EqRuleFragmentDoc}
  ${SetRuleFragmentDoc}
  ${RangeRuleFragmentDoc}
  ${StartsWithRuleFragmentDoc}
  ${ContainsRuleFragmentDoc}
  ${EndsWithRuleFragmentDoc}
  ${InnerRuleInputFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const TargetingFragmentDoc = gql`
  fragment Targeting on FlagsTypesV1Targeting {
    criteria {
      key
      value {
        ...TargetingCriterion
      }
    }
    expression {
      ref
      not {
        ref
      }
      and {
        operands {
          ref
          not {
            ref
          }
          and {
            operands {
              ref
              not {
                ref
              }
              and {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
              or {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
            }
          }
          or {
            operands {
              ref
              not {
                ref
              }
              and {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
              or {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
            }
          }
        }
      }
      or {
        operands {
          ref
          not {
            ref
          }
          and {
            operands {
              ref
              not {
                ref
              }
              and {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
              or {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
            }
          }
          or {
            operands {
              ref
              not {
                ref
              }
              and {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
              or {
                operands {
                  ref
                  not {
                    ref
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${TargetingCriterionFragmentDoc}
`;
export const SegmentFragmentDoc = gql`
  fragment Segment on FlagsAdminV1Segment {
    __typename
    name
    displayName
    description
    state
    createTime
    updateTime
    flag {
      ... on FlagsAdminV1Flag {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
    workflowInstance {
      ... on WorkflowV1WorkflowInstance {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    allocation {
      ...Allocation
    }
    targeting {
      ...Targeting
    }
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${AllocationFragmentDoc}
  ${TargetingFragmentDoc}
`;
export const FlagsDataFragmentDoc = gql`
  fragment FlagsData on FlagsData {
    flag {
      __typename
      ... on FlagsAdminV1Flag {
        name
        clients {
          ...FlagClient
          ...DefaultError
        }
      }
      ...DefaultError
    }
    segment {
      __typename
      ...Segment
      ...DefaultError
    }
    targetingKeySelector
    stickyAssignments
    ignoreTargetingForSticky
    rule {
      __typename
      ... on FlagsAdminV1FlagRule {
        name
      }
      ...DefaultError
    }
    intakePaused
  }
  ${FlagClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${SegmentFragmentDoc}
`;
export const HypothesisDataFragmentDoc = gql`
  fragment HypothesisData on HypothesisData {
    text
  }
`;
export const DecisionDataFragmentDoc = gql`
  fragment DecisionData on DecisionRecordData {
    outcome
    conclusion
    treatment
  }
`;
export const ApiClientFragmentDoc = gql`
  fragment ApiClient on IamV1ApiClient {
    __typename
    name
    displayName
    description
    clientId
    clientSecret
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const GroupFragmentDoc = gql`
  fragment Group on IamV1Group {
    __typename
    name
    displayName
    description
    groupType
    slackChannel
    createTime
    updateTime
    identity {
      ... on IamV1Identity {
        name
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const IdentityFragmentDoc = gql`
  fragment Identity on IamV1Identity {
    __typename
    name
    displayName
    pictureUri
    service
    user {
      __typename
      ... on IamV1User {
        name
        fullName
        email
        pictureUri
        scimExternalId
        lastLoginTime
      }
      ...DefaultError
    }
    apiClient {
      ...ApiClient
      ...DefaultError
    }
    group {
      ...Group
      ...DefaultError
    }
    agent {
      __typename
      ... on IamV1Agent {
        name
        displayName
        pictureUri
        reviewerSkill {
          enabled
        }
      }
      ...DefaultError
    }
    everyone
  }
  ${DefaultErrorFragmentDoc}
  ${ApiClientFragmentDoc}
  ${GroupFragmentDoc}
`;
export const WorkflowReviewResponseFragmentDoc = gql`
  fragment WorkflowReviewResponse on ReviewsDataSurfaceReviewDataResponse {
    __typename
    id
    state
    stale
    commentId
    groups {
      ...Identity
      ...DefaultError
    }
    reviewer {
      ...Identity
      ...DefaultError
    }
  }
  ${IdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SurfaceRefFragmentDoc = gql`
  fragment SurfaceRef on WorkflowV1Surface {
    __typename
    name
    displayName
    description
    deleteTime
  }
`;
export const WorkflowReviewsDataFragmentDoc = gql`
  fragment WorkflowReviewsData on ReviewsDataSurfaceReviewData {
    __typename
    state
    responses {
      ...WorkflowReviewResponse
    }
    surface {
      ...SurfaceRef
      ...DefaultError
    }
  }
  ${WorkflowReviewResponseFragmentDoc}
  ${SurfaceRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const WorkflowReviewsFragmentDoc = gql`
  fragment WorkflowReviews on ReviewsData {
    __typename
    approvalRequired
    reviewId
    status
    optionalReviews {
      ...WorkflowReviewsData
    }
    requiredReviews {
      ...WorkflowReviewsData
    }
  }
  ${WorkflowReviewsDataFragmentDoc}
`;
export const PlanningDataFragmentDoc = gql`
  fragment PlanningData on PlanningData {
    planned {
      startTime
      endTime
      runtime
    }
    actual {
      startTime
      endTime
      runtime
    }
  }
`;
export const SampleSizeDataFragmentDoc = gql`
  fragment SampleSizeData on SampleSizeData {
    error
    useScheduledCalculation
    exposure {
      ... on SampleSizeDataExposureCalculation {
        exposureCalculation
        scheduledExposureCalculation
        startTime
        endTime
        assignmentTable {
          assignmentTable
          filters {
            assignmentFilter
          }
        }
      }
      ... on SampleSizeDataScheduledExposureCalculation {
        exposureCalculation
        startTime
        endTime
        existingInstance {
          workflowInstance {
            ... on WorkflowV1WorkflowInstance {
              __typename
              name
              displayName
            }
            ...DefaultError
          }
        }
      }
    }
    exposureSource {
      ... on SampleSizeDataAssignmentTable {
        assignmentTable
        customStartTime
        customEndTime
        filters {
          assignmentFilter
          entityFilter
          exposureFilter
        }
      }
      ... on SampleSizeDataExistingInstance {
        workflowInstance {
          ... on WorkflowV1WorkflowInstance {
            __typename
            name
            displayName
          }
          ...DefaultError
        }
      }
    }
    metrics {
      error
      metric
      metricCalculation
      metricCalculationName {
        ... on MetricsV1MetricCalculation {
          __typename
          name
          state
        }
        ...DefaultError
      }
      scheduledMetricCalculation
      requiredSampleSize
      summaryStats {
        mean
        variance
        varianceReductionRate
        count
      }
      observedData {
        dayIndex
        requiredSampleSize
        mean
        variance
        expectedSampleSize
      }
      forecastedData {
        dayIndex
        requiredSampleSize
        expectedSampleSize
      }
      state
      type
    }
    requiredSampleSize
    state
  }
  ${DefaultErrorFragmentDoc}
`;
export const MetricsFilterValueFragmentDoc = gql`
  fragment MetricsFilterValue on MetricsV1FilterValue {
    boolValue
    numberValue
    stringValue
    timestampValue
    nullValue {
      dummyField
    }
  }
`;
export const MetricFilterEqRuleFragmentDoc = gql`
  fragment MetricFilterEqRule on MetricsV1FilterEqRule {
    value {
      ...MetricsFilterValue
    }
  }
  ${MetricsFilterValueFragmentDoc}
`;
export const MetricFilterSetRuleFragmentDoc = gql`
  fragment MetricFilterSetRule on MetricsV1FilterSetRule {
    values {
      ...MetricsFilterValue
    }
  }
  ${MetricsFilterValueFragmentDoc}
`;
export const MetricsFilterRangeRuleFragmentDoc = gql`
  fragment MetricsFilterRangeRule on MetricsV1FilterRangeRule {
    startInclusive {
      ...MetricsFilterValue
    }
    startExclusive {
      ...MetricsFilterValue
    }
    endInclusive {
      ...MetricsFilterValue
    }
    endExclusive {
      ...MetricsFilterValue
    }
  }
  ${MetricsFilterValueFragmentDoc}
`;
export const MetricFilterLikeRuleFragmentDoc = gql`
  fragment MetricFilterLikeRule on MetricsV1FilterLikeRule {
    pattern
  }
`;
export const MetricFilterValuesFragmentDoc = gql`
  fragment MetricFilterValues on MetricsV1FilterCriterionAttributeCriterion {
    eqRule {
      ...MetricFilterEqRule
    }
    setRule {
      ...MetricFilterSetRule
    }
    rangeRule {
      ...MetricsFilterRangeRule
    }
    likeRule {
      ...MetricFilterLikeRule
    }
  }
  ${MetricFilterEqRuleFragmentDoc}
  ${MetricFilterSetRuleFragmentDoc}
  ${MetricsFilterRangeRuleFragmentDoc}
  ${MetricFilterLikeRuleFragmentDoc}
`;
export const MetricFilterCriterionFragmentDoc = gql`
  fragment MetricFilterCriterion on MetricsV1FilterCriterion {
    attribute {
      attribute
      ...MetricFilterValues
    }
  }
  ${MetricFilterValuesFragmentDoc}
`;
export const MetricFilterExpressionFragmentDoc = gql`
  fragment MetricFilterExpression on MetricsV1Expression {
    ref
    not {
      ref
    }
    and {
      operands {
        ref
        not {
          ref
        }
        and {
          operands {
            ref
            not {
              ref
            }
          }
        }
        or {
          operands {
            ref
            not {
              ref
            }
          }
        }
      }
    }
    or {
      operands {
        ref
        not {
          ref
        }
        and {
          operands {
            ref
            not {
              ref
            }
          }
        }
        or {
          operands {
            ref
            not {
              ref
            }
          }
        }
      }
    }
  }
`;
export const MetricFilterFragmentDoc = gql`
  fragment MetricFilter on MetricsV1Filter {
    criteria {
      key
      value {
        ...MetricFilterCriterion
      }
    }
    expression {
      ...MetricFilterExpression
    }
  }
  ${MetricFilterCriterionFragmentDoc}
  ${MetricFilterExpressionFragmentDoc}
`;
export const FactTableRefFragmentDoc = gql`
  fragment FactTableRef on MetricsV1FactTable {
    __typename
    name
    displayName
    state
  }
`;
export const MetricAggregationFragmentDoc = gql`
  fragment MetricAggregation on MetricsV1Aggregation {
    type
    threshold {
      direction
      threshold {
        value
      }
    }
    cap {
      min {
        value
      }
      max {
        value
      }
    }
  }
`;
export const MetricDetailsFragmentDoc = gql`
  fragment MetricDetails on MetricsV1Metric {
    __typename
    displayName
    name
    description
    measurement {
      ... on MetricsV1Measurement {
        __typename
        name
        displayName
        typeSpec {
          averageMetricSpec {
            measurement {
              name
            }
            aggregation {
              type
            }
          }
          ratioMetricSpec {
            numerator {
              name
            }
            numeratorAggregation {
              type
            }
            denominator {
              name
            }
            denominatorAggregation {
              type
            }
          }
          quantileMetricSpec {
            quantileLevel
            aggregation {
              type
            }
          }
        }
        filter {
          ...MetricFilter
        }
        entity {
          ... on MetricsV1Entity {
            name
            displayName
            __typename
          }
          ...DefaultError
        }
        factTable {
          ...FactTableRef
          ...DefaultError
        }
        nullHandling {
          replaceEntityNullWithZero
        }
      }
      ...DefaultError
    }
    owner {
      ... on IamV1Identity {
        __typename
        displayName
        name
        everyone
        user {
          ... on IamV1User {
            pictureUri
            name
          }
        }
        group {
          ... on IamV1Group {
            name
          }
        }
        apiClient {
          ... on IamV1ApiClient {
            name
          }
        }
      }
      ...DefaultError
    }
    factTable {
      ...FactTableRef
      ...DefaultError
    }
    filter {
      ...MetricFilter
    }
    entity {
      ... on MetricsV1Entity {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
    measurementConfig {
      closedWindow {
        aggregationWindow
        exposureOffset
      }
      semiOpenWindow {
        aggregationWindow
        exposureOffset
      }
      openWindow {
        dummy
      }
    }
    varianceReductionConfig {
      aggregationWindowOverride
      disabled
    }
    nullHandling {
      replaceEntityNullWithZero
    }
    typeSpec {
      ratioMetricSpec {
        numerator {
          name
        }
        numeratorAggregation {
          ...MetricAggregation
        }
        numeratorFilter {
          ...MetricFilter
        }
        denominator {
          name
        }
        denominatorAggregation {
          ...MetricAggregation
        }
        denominatorFilter {
          ...MetricFilter
        }
      }
      averageMetricSpec {
        measurement {
          name
          type
        }
        aggregation {
          ...MetricAggregation
        }
      }
      quantileMetricSpec {
        quantileLevel
        measurement {
          name
          type
        }
        aggregation {
          ...MetricAggregation
        }
      }
    }
    labels {
      key
      value
    }
    createTime
    updateTime
    deleteTime
    state
    archiveInfo {
      reason
      archiveTime
    }
    preferredDirection
    defaultEffectSize {
      value
    }
    source {
      type
      reference
    }
    verification {
      state
      verifier {
        ... on IamV1Identity {
          __typename
          ...IdentityRef
        }
        ...DefaultError
      }
      verifyTime
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${MetricFilterFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
  ${MetricAggregationFragmentDoc}
  ${IdentityRefFragmentDoc}
`;
export const ScheduledMetricCalculationStatusFragmentDoc = gql`
  fragment ScheduledMetricCalculationStatus on MetricsV1ScheduledMetricCalculationStatus {
    scheduled {
      nextScheduleTime
    }
    cancelled {
      cancelledTime
    }
    calculating {
      metricCalculation {
        ... on MetricsV1MetricCalculation {
          name
        }
      }
    }
    waiting {
      dataDeliveredUntilTime
      needDataUntilTime
      exposureTable {
        ... on MetricsV1ExposureTable {
          name
        }
      }
      factTable {
        ...FactTableRef
      }
    }
    error {
      errorMessage
    }
  }
  ${FactTableRefFragmentDoc}
`;
export const DataDeliveredUntilUpdateStrategyConfigFragmentDoc = gql`
  fragment DataDeliveredUntilUpdateStrategyConfig on MetricsV1DataDeliveredUntilUpdateStrategyConfig {
    strategy
    automaticUpdateConfig {
      commitDelay
      changeThreshold {
        value
      }
    }
    dailyUpdateConfig {
      __typename
      maxZeroDuration
    }
    hourlyUpdateConfig {
      __typename
      maxZeroDuration
    }
    disableEmptyPartitions
  }
`;
export const ScheduledExposureCalculationStatusFragmentDoc = gql`
  fragment ScheduledExposureCalculationStatus on MetricsV1ScheduledExposureCalculationStatus {
    calculating {
      exposureCalculation {
        ... on MetricsV1ExposureCalculation {
          name
        }
      }
    }
    cancelled {
      cancelledTime
    }
    error {
      errorMessage
    }
    waiting {
      assignmentTable {
        ... on MetricsV1AssignmentTable {
          __typename
          name
          displayName
        }
        ...DefaultError
      }
      dataDeliveredUntilTime
      needDataUntilTime
    }
    scheduled {
      nextScheduleTime
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const MetricCalculationSpecFragmentDoc = gql`
  fragment MetricCalculationSpec on MetricsV1MetricCalculationSpec {
    metric {
      ... on MetricsV1Metric {
        __typename
        name
        displayName
        nullHandling {
          replaceEntityNullWithZero
          __typename
        }
        measurementConfig {
          closedWindow {
            __typename
            aggregationWindow
            exposureOffset
          }
          semiOpenWindow {
            __typename
            aggregationWindow
            exposureOffset
          }
          openWindow {
            __typename
          }
        }
        factTable {
          ... on MetricsV1FactTable {
            __typename
            name
            displayName
            dataDeliveredUntilUpdateStrategyConfig {
              ...DataDeliveredUntilUpdateStrategyConfig
            }
            partitionedUpdateStrategyState {
              currentPartitionLastCheckTime
              existsCheckDuration
              state
              usualLateness
            }
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
    exposureTable {
      ... on MetricsV1ExposureTable {
        __typename
        scheduledExposureCalculation {
          ... on MetricsV1ScheduledExposureCalculation {
            __typename
            name
            exposureCalculationSpec {
              ... on MetricsV1ExposureCalculationSpec {
                __typename
                assignmentTable {
                  ... on MetricsV1AssignmentTable {
                    __typename
                    name
                    dataDeliveredUntilUpdateStrategyConfig {
                      ...DataDeliveredUntilUpdateStrategyConfig
                    }
                  }
                  ...DefaultError
                }
              }
            }
            status {
              ...ScheduledExposureCalculationStatus
            }
          }
        }
      }
    }
    measurementTable {
      ... on MetricsV1MeasurementTable {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ScheduledExposureCalculationStatusFragmentDoc}
`;
export const MetricScheduleFragmentDoc = gql`
  fragment MetricSchedule on MetricsV1ScheduledMetricCalculation {
    __typename
    name
    state
    status {
      ...ScheduledMetricCalculationStatus
    }
    metricCalculationSpec {
      ...MetricCalculationSpec
    }
    nextScheduledRunTime
    nextExposureStartTime
    nextExposureEndTime
    iteration
    executedCalculationsCount
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
  }
  ${ScheduledMetricCalculationStatusFragmentDoc}
  ${MetricCalculationSpecFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MetricsDataFragmentDoc = gql`
  fragment MetricsData on MetricsData {
    bucket
    assignmentTable {
      __typename
      ... on MetricsV1AssignmentTable {
        name
        displayName
        dimensions {
          name
        }
        dataWarehouse {
          ... on MetricsV1DataWarehouse {
            __typename
            name
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
    exposureTableSchedule {
      ... on MetricsV1ScheduledExposureCalculation {
        __typename
        name
      }
    }
    metrics {
      __typename
      metric {
        ...MetricDetails
        ...DefaultError
      }
      preferredDirection
      schedule {
        ...MetricSchedule
        ...DefaultError
      }
      metricRole {
        ... on MetricsDataMetricSuccessMetric {
          successMetricKind: metricKind
          minimumDetectableEffect
        }
        ... on MetricsDataMetricGuardrailMetric {
          guardrailMetricKind: metricKind
          nonInferiorityMargin
        }
      }
      surface {
        ...SurfaceRef
        ...DefaultError
      }
      surfaceOnly
      calculation {
        ... on MetricsV1MetricCalculation {
          __typename
          name
        }
      }
      schedule {
        ... on MetricsV1ScheduledMetricCalculation {
          __typename
          name
        }
      }
    }
    filters {
      displayName
      factTable {
        ... on MetricsV1FactTable {
          __typename
          name
          displayName
          labels {
            key
            value
          }
        }
      }
      filter {
        criteria
        expression
      }
    }
    entity {
      __typename
      ... on MetricsV1Entity {
        name
        displayName
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${MetricDetailsFragmentDoc}
  ${MetricScheduleFragmentDoc}
  ${SurfaceRefFragmentDoc}
`;
export const StatsHypothesisResultFragmentDoc = gql`
  fragment StatsHypothesisResult on StatsV2AnalysisStatsHypothesisResult {
    annotations {
      context {
        key
        value
      }
      error {
        category
        details
      }
      info
      warning
    }
    id
    metricDetails {
      direction
      hasRun
      metricType
      plannedEffectSize {
        value
      }
    }
    result {
      comparisonId
      dimensions {
        value
        key
      }
      groupStats {
        sampleSize
        id
      }
      groups {
        baseline
        compared
      }
      isSignificant
      lastDeteriorationResult {
        baselineEstimateAbs
        baselineEstimateRel
        baselineSampleSize
        comparedEstimateAbs
        comparedEstimateRel
        comparedSampleSize
        differenceEstimateAbs {
          estimate
          isSignificant
          lower
          powered
          upper
        }
      }
      lastResult {
        baselineEstimateAbs
        baselineEstimateRel
        baselineSampleSize
        comparedEstimateAbs
        differenceEstimateAbs {
          estimate
          lower
          upper
          isSignificant
        }
        differenceEstimateRel {
          estimate
          lower
          upper
          isSignificant
        }
      }
      status {
        status
        message
        metricType
        decisionPowered
        decisionIsSignificant
        validationIsSignificant
      }
      result {
        resultTime
        baselineEstimateAbs
        comparedEstimateAbs
        baselineEstimateRel
        comparedEstimateRel
        differenceEstimateAbs {
          estimate
          lower
          upper
          isSignificant
        }
        differenceEstimateRel {
          estimate
          lower
          upper
          isSignificant
        }
        varianceReductionRate
        unadjustedEstimateBaseline
        unadjustedEstimateCompared
        baselineSampleSize
        comparedSampleSize
      }
      sampleSize {
        current
        required
        poweredEffectRel
        poweredEffectAbs
      }
      usedDataType
      segmentId
    }
    srmResult {
      status {
        status
        message
        metricType
        decisionPowered
        decisionIsSignificant
        validationIsSignificant
      }
      isSignificant
      dimensions {
        key
        value
      }
      segmentId
      result {
        group
        observed
        expected
        isSignificant
      }
    }
    statsSettings {
      method
      adjustedAlpha
      adjustedBeta
      hasVarianceReduction
    }
  }
`;
export const AnalysisResultFragmentDoc = gql`
  fragment AnalysisResult on StatsV2AnalysisAnalysisResult {
    name
    exposureFilter
    annotations {
      context {
        key
        value
      }
    }
    results {
      ...StatsHypothesisResult
    }
    treatments {
      id
      recommendation {
        status {
          quality
          tanking
          guardrail
          success
        }
        shipping
      }
    }
    updateTime
  }
  ${StatsHypothesisResultFragmentDoc}
`;
export const StatsDataFragmentDoc = gql`
  fragment StatsData on StatsData {
    analysisResults {
      analysisResult {
        __typename
        ...AnalysisResult
        ...DefaultError
      }
      exposureFilterName
    }
    testHorizonStrategy
    metricMethods {
      metricName
      method
    }
  }
  ${AnalysisResultFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MetricsTableErrorFragmentDoc = gql`
  fragment MetricsTableError on MetricsV1OperationError {
    details
    message
  }
`;
export const FactTableFragmentDoc = gql`
  fragment FactTable on MetricsV1FactTable {
    __typename
    name
    displayName
    description
    timestampColumn {
      name
    }
    owner {
      ... on IamV1Identity {
        __typename
        displayName
        name
        everyone
        user {
          ... on IamV1User {
            pictureUri
            name
          }
        }
        group {
          ... on IamV1Group {
            name
          }
        }
        apiClient {
          ... on IamV1ApiClient {
            name
          }
        }
      }
      ...DefaultError
    }
    sql
    state
    entities {
      entity {
        ... on MetricsV1Entity {
          __typename
          name
          displayName
        }
        ...DefaultError
      }
      column {
        name
      }
    }
    measures {
      column {
        name
      }
      declaredType
      unit {
        baseUnitMultiplier
        baseUnit
        currencyCode
        customUnit
      }
    }
    dimensions {
      name
    }
    dataDeliveredUntilUpdateStrategyConfig {
      ...DataDeliveredUntilUpdateStrategyConfig
    }
    factDataDeliveredUntilTime
    error {
      ...MetricsTableError
    }
    schemaValidationJob {
      ... on MetricsV1SqlJob {
        __typename
        name
        successfulQueryResult {
          schema {
            name
            type
          }
        }
      }
      ...DefaultError
    }
    source {
      type
      reference
    }
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
`;
export const EntityRefFragmentDoc = gql`
  fragment EntityRef on MetricsV1Entity {
    __typename
    name
    displayName
    primaryKeyType
  }
`;
export const EntityFragmentDoc = gql`
  fragment Entity on MetricsV1Entity {
    ...EntityRef
    createTime
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    defaultAssignmentTable {
      ... on MetricsV1AssignmentTable {
        name
        displayName
        state
      }
      ...DefaultError
    }
  }
  ${EntityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const DimensionTableFragmentDoc = gql`
  fragment DimensionTable on MetricsV1DimensionTable {
    __typename
    name
    displayName
    description
    state
    dimensionDataDeliveredUntilTime
    dataDeliveredUntilUpdateStrategyConfig {
      ...DataDeliveredUntilUpdateStrategyConfig
    }
    sql
    owner {
      ...IdentityRef
      ...DefaultError
    }
    entityColumnMapping {
      entity {
        ...Entity
        ...DefaultError
      }
      column {
        name
      }
    }
    dimensions {
      name
    }
    labels {
      key
      value
    }
    error {
      ...MetricsTableError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    timeConfig {
      timestampColumn {
        name
        type
      }
      window
    }
    valueMappings {
      column
      mappings {
        inputDimensionValue
        outputDimensionValue
      }
    }
  }
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${EntityFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
`;
export const UserFragmentDoc = gql`
  fragment User on IamV1User {
    name
    fullName
    email
    pictureUri
    lastLoginTime
    __typename
  }
`;
export const ExploratoryAnalysisFragmentDoc = gql`
  fragment ExploratoryAnalysis on ExploreDataAnalysis {
    analysisResults {
      analysisResult {
        __typename
        ...AnalysisResult
        ...DefaultError
      }
      exposureFilterName
    }
    conclusion {
      ... on ExploreDataAnalysisConclusion {
        updateTime
        text
      }
    }
    createTime
    updateTime
    id
    messages
    metrics {
      name {
        ... on MetricsV1Metric {
          name
          displayName
          description
          factTable {
            ...FactTable
          }
          entity {
            ...Entity
          }
        }
      }
      dimensions {
        ... on ExploreDataAnalysisMetricMetricCalculationDimensionTableDimension {
          column
          dimensionTable {
            ...DimensionTable
          }
        }
        ... on ExploreDataAnalysisMetricMetricCalculationFactTableDimension {
          column
          factTable {
            ...FactTable
          }
        }
      }
      calculation {
        ... on MetricsV1MetricCalculation {
          __typename
          name
          state
        }
        ...DefaultError
      }
      scheduledCalculation {
        ... on MetricsV1ScheduledMetricCalculation {
          __typename
          name
          state
          status {
            ...ScheduledMetricCalculationStatus
          }
        }
        ...DefaultError
      }
      calculationError
    }
    name
    splitByExposureFilters
    startTime
    endTime
    useCustomDateRange
    state
    useScheduledCalculation
    createdBy {
      ...User
      ...DefaultError
    }
  }
  ${AnalysisResultFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableFragmentDoc}
  ${EntityFragmentDoc}
  ${DimensionTableFragmentDoc}
  ${ScheduledMetricCalculationStatusFragmentDoc}
  ${UserFragmentDoc}
`;
export const ExploreDataFragmentDoc = gql`
  fragment ExploreData on ExploreData {
    exploratoryAnalyses {
      ...ExploratoryAnalysis
    }
  }
  ${ExploratoryAnalysisFragmentDoc}
`;
export const RolloutDataScheduleFragmentDoc = gql`
  fragment RolloutDataSchedule on RolloutDataSchedule {
    state
    stateReason {
      failed
    }
    steps {
      durationSincePreviousStep
      reach
      status
      updateTime
    }
  }
`;
export const RolloutDataFragmentDoc = gql`
  fragment RolloutData on RolloutData {
    schedule {
      ...RolloutDataSchedule
    }
    variantImageUri
    variant {
      __typename
      ... on FlagsAdminV1FlagVariant {
        name
      }
    }
    reach
    initialReach
    abtest {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
      }
    }
    controlAssignmentId
    controlVariant {
      __typename
      ... on FlagsAdminV1FlagVariant {
        name
      }
    }
    description
    flag {
      __typename
      ... on FlagsAdminV1Flag {
        name
        clients {
          ...FlagClient
          ...DefaultError
        }
      }
    }
    monitoringDisabled
    treatmentGroupProportion
    variantAssignmentId
  }
  ${RolloutDataScheduleFragmentDoc}
  ${FlagClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const WorkflowInstanceFragmentDoc = gql`
  fragment WorkflowInstance on WorkflowV1WorkflowInstance {
    __typename
    possibleTransitions
    lockedDataKeys
    displayName
    state
    name
    deleteTime
    updateTime
    labels {
      key
      value
    }
    owner {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    surfaces {
      ... on WorkflowV1Surface {
        __typename
        name
        displayName
        description
        metricConfig {
          metrics {
            metric {
              ... on MetricsV1Metric {
                name
                displayName
              }
            }
            enforcementLevel
          }
        }
      }
      ...DefaultError
    }
    surfaceRequirements {
      surface {
        ... on WorkflowV1Surface {
          __typename
          name
          displayName
          description
        }
        ...DefaultError
      }
      enforcementLevel
      reason
    }
    initiatives {
      ...InitiativeRef
      ...DefaultError
    }
    workflowVersion {
      ... on WorkflowV1WorkflowVersion {
        __typename
        name
        workflowInfo {
          modules {
            key
          }
          functions {
            key
          }
        }
      }
      ...DefaultError
    }
    stateHistory {
      state
    }
    pendingTransition {
      ...PendingTransition
    }
    checks {
      ...WorkflowInstanceCheck
    }
    moduleData {
      key
      value
    }
    moduleData2 {
      abtest {
        ...AbTestData
      }
      flags {
        ...FlagsData
      }
      hypothesis {
        ...HypothesisData
      }
      decision {
        ...DecisionData
      }
      reviews {
        ...WorkflowReviews
      }
      planning {
        ...PlanningData
      }
      samplesize {
        ...SampleSizeData
      }
      metrics {
        ...MetricsData
      }
      stats {
        ...StatsData
      }
      explore {
        ...ExploreData
      }
      rollout {
        ...RolloutData
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    queryWorkflowInstancePermissions {
      ... on WorkflowV1QueryWorkflowInstancePermissionsResponse {
        actionPermissionCheckResults {
          action
          isAllowed
          permissionChecks {
            isAllowed
            relation
            resource
          }
        }
        functionPermissionCheckResults {
          function
          isAllowed
          permissionChecks {
            isAllowed
            relation
            resource
          }
        }
        isAllAllowed
        __typename
      }
      ...DefaultError
    }
    transitionStatus {
      ... on WorkflowV1WorkflowInstanceTransitionStatus {
        action
        initiator {
          ... on IamV1Identity {
            name
            displayName
          }
        }
        running {
          ... on WorkflowV1WorkflowInstanceTransitionStatusRunning {
            startTime
          }
        }
        completed {
          ... on WorkflowV1WorkflowInstanceTransitionStatusCompleted {
            startTime
            endTime
          }
        }
        failed {
          ... on WorkflowV1WorkflowInstanceTransitionStatusFailed {
            startTime
            endTime
            error
          }
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${InitiativeRefFragmentDoc}
  ${PendingTransitionFragmentDoc}
  ${WorkflowInstanceCheckFragmentDoc}
  ${AbTestDataFragmentDoc}
  ${FlagsDataFragmentDoc}
  ${HypothesisDataFragmentDoc}
  ${DecisionDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${SampleSizeDataFragmentDoc}
  ${MetricsDataFragmentDoc}
  ${StatsDataFragmentDoc}
  ${ExploreDataFragmentDoc}
  ${RolloutDataFragmentDoc}
`;
export const SpotifyAnalysisDataFragmentDoc = gql`
  fragment SpotifyAnalysisData on SpotifyAnalysis {
    mhMetrics {
      secondary
      metricName
      success {
        minimumDetectableEffect
      }
      guardrail {
        nonInferiorityMargin
      }
      preferredDirection
      userCreated
    }
    experimentId
    treatments {
      name
      weight
      id
    }
  }
`;
export const ReactionSummaryFragmentDoc = gql`
  fragment ReactionSummary on CollaborationV1ReactionSummary {
    name
    commentCount
    emojiReactions {
      key
      value {
        emoji
        reactionCount
        identities {
          ...IdentityRef
          ...DefaultError
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const CommentFragmentDoc = gql`
  fragment Comment on CollaborationV1Comment {
    name
    resource
    author {
      ...IdentityRef
    }
    assignee {
      ...IdentityRef
    }
    createTime
    updateTime
    content
    resolved
    anchor {
      zone {
        zone
      }
    }
    queryReactionSummary {
      __typename
      ...DefaultError
      ... on CollaborationV1QueryReactionSummaryResponse {
        summary {
          ...ReactionSummary
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ReactionSummaryFragmentDoc}
`;
export const SpotifyAnalysisFragmentDoc = gql`
  fragment SpotifyAnalysis on WorkflowV1WorkflowInstance {
    __typename
    ...WorkflowInstance
    moduleData2 {
      spotifyanalysis {
        ...SpotifyAnalysisData
      }
      explore {
        ...ExploreData
      }
    }
    comments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListCommentsResponse {
        comments {
          __typename
          ...Comment
        }
        nextPageToken
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${SpotifyAnalysisDataFragmentDoc}
  ${ExploreDataFragmentDoc}
  ${CommentFragmentDoc}
`;
export const AttachmentFragmentDoc = gql`
  fragment Attachment on CollaborationV1Attachment {
    __typename
    name
    displayName
    uri
    resource
    createTime
    labels {
      key
      value
    }
  }
`;
export const C4sAbTestDataFragmentDoc = gql`
  fragment C4sAbTestData on C4sAbTest {
    __typename
    primaryUnit
    rampUpDuration
    treatments {
      id
      name
      displayName
      description
      weight
      imageUri
      overrideUserIds
      propertyAssignments {
        name
        scope
        value
      }
    }
  }
`;
export const AudienceFragmentDoc = gql`
  fragment Audience on AudiencesDataAudience {
    __typename
    id
    segment {
      __typename
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const AudiencesDataFragmentDoc = gql`
  fragment AudiencesData on AudiencesData {
    __typename
    audiences {
      ...Audience
    }
  }
  ${AudienceFragmentDoc}
`;
export const C4sAbTestFragmentDoc = gql`
  fragment C4sAbTest on WorkflowV1WorkflowInstance {
    __typename
    ...WorkflowInstance
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
    moduleData2 {
      c4sabtest {
        ...C4sAbTestData
      }
      planning {
        ...PlanningData
      }
      audiences {
        ...AudiencesData
      }
      reviews {
        ...WorkflowReviews
      }
      metrics {
        ...MetricsData
      }
      stats {
        ...StatsData
      }
      explore {
        ...ExploreData
      }
      hypothesis {
        ...HypothesisData
      }
      samplesize {
        ...SampleSizeData
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${AttachmentFragmentDoc}
  ${C4sAbTestDataFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${AudiencesDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${MetricsDataFragmentDoc}
  ${StatsDataFragmentDoc}
  ${ExploreDataFragmentDoc}
  ${HypothesisDataFragmentDoc}
  ${SampleSizeDataFragmentDoc}
`;
export const C4sRolloutDataFragmentDoc = gql`
  fragment C4sRolloutData on C4sRollout {
    __typename
    description
    primaryUnit
    monitoringDisabled
    reach
    schedule {
      state
      stateReason {
        failed
      }
      steps {
        durationSincePreviousStep
        reach
        status
        updateTime
      }
    }
    treatments {
      id
      name
      displayName
      description
      weight
      imageUri
      overrideUserIds
      propertyAssignments {
        name
        scope
        value
      }
    }
  }
`;
export const C4sRolloutFragmentDoc = gql`
  fragment C4sRollout on WorkflowV1WorkflowInstance {
    __typename
    ...WorkflowInstance
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
    moduleData2 {
      c4srollout {
        ...C4sRolloutData
      }
      planning {
        ...PlanningData
      }
      audiences {
        ...AudiencesData
      }
      reviews {
        ...WorkflowReviews
      }
      metrics {
        ...MetricsData
      }
      stats {
        ...StatsData
      }
      explore {
        ...ExploreData
      }
      samplesize {
        ...SampleSizeData
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${AttachmentFragmentDoc}
  ${C4sRolloutDataFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${AudiencesDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${MetricsDataFragmentDoc}
  ${StatsDataFragmentDoc}
  ${ExploreDataFragmentDoc}
  ${SampleSizeDataFragmentDoc}
`;
export const StaticConfigDataFragmentDoc = gql`
  fragment StaticConfigData on StaticConfig {
    propertyAssignments {
      scope
      name
      value
    }
    primaryUnit
    description
  }
`;
export const StaticConfigFragmentDoc = gql`
  fragment StaticConfig on WorkflowV1WorkflowInstance {
    __typename
    ...WorkflowInstance
    moduleData2 {
      staticconfig {
        ...StaticConfigData
      }
      audiences {
        ...AudiencesData
      }
    }
    comments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListCommentsResponse {
        comments {
          __typename
          ...Comment
        }
        nextPageToken
      }
    }
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${StaticConfigDataFragmentDoc}
  ${AudiencesDataFragmentDoc}
  ${CommentFragmentDoc}
  ${AttachmentFragmentDoc}
`;
export const ChangeSetFragmentDoc = gql`
  fragment ChangeSet on ActivityV1ResourceChangeSet {
    __typename
    changes {
      description
      fieldPath
      fieldType
      newValue
      oldValue
      changeType
      reorderDetails {
        moves {
          item
          newPosition
          oldPosition
        }
      }
    }
  }
`;
export const ActivityFragmentDoc = gql`
  fragment Activity on ActivityV1Activity {
    __typename
    name
    title
    body
    data
    primaryResource
    relatedResources
    priority
    activityTime
    createTime
    updateTime
    actor {
      ...IdentityRef
    }
    creator {
      ...IdentityRef
    }
    updater {
      ...IdentityRef
    }
    labels {
      key
      value
    }
    changeSet {
      ...ChangeSet
    }
  }
  ${IdentityRefFragmentDoc}
  ${ChangeSetFragmentDoc}
`;
export const ActivityTypeRefFragmentDoc = gql`
  fragment ActivityTypeRef on ActivityV1ActivityType {
    __typename
    name
    displayName
  }
`;
export const FeedActivityFragmentDoc = gql`
  fragment FeedActivity on ActivityV1Activity {
    __typename
    name
    title
    body
    data
    primaryResource
    relatedResources
    priority
    activityTime
    createTime
    updateTime
    actor {
      ...IdentityRef
    }
    creator {
      ...IdentityRef
    }
    updater {
      ...IdentityRef
    }
    labels {
      key
      value
    }
    queryReactionSummary {
      __typename
      ...DefaultError
      ... on CollaborationV1QueryReactionSummaryResponse {
        summary {
          ...ReactionSummary
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ReactionSummaryFragmentDoc}
`;
export const ChannelDeliveryStatusFragmentDoc = gql`
  fragment ChannelDeliveryStatus on ActivityV1FeedEntryChannelDeliveryStatus {
    channel
    state
    failedAttempts
    lastError
  }
`;
export const FeedEntryFragmentDoc = gql`
  fragment FeedEntry on ActivityV1FeedEntry {
    __typename
    name
    entryTime
    read
    createTime
    updateTime
    creator {
      ...IdentityRef
    }
    activity {
      ...FeedActivity
    }
    channelDeliveryStatuses {
      ...ChannelDeliveryStatus
    }
  }
  ${IdentityRefFragmentDoc}
  ${FeedActivityFragmentDoc}
  ${ChannelDeliveryStatusFragmentDoc}
`;
export const ConversationRefFragmentDoc = gql`
  fragment ConversationRef on ConversationsV1Conversation {
    __typename
    name
    sessionId
    title
    firstUserMessage
    messageCount
    createTime
    updateTime
  }
`;
export const ConversationFragmentDoc = gql`
  fragment Conversation on ConversationsV1Conversation {
    ...ConversationRef
    messages {
      id
      role
      content
      createTime
      events {
        eventType
        content
        metadata
        createTime
      }
    }
  }
  ${ConversationRefFragmentDoc}
`;
export const InsightsDocumentFragmentDoc = gql`
  fragment InsightsDocument on InsightsV1InsightsDocument {
    __typename
    name
    title
    text
    lifecycle
    description
  }
`;
export const InsightsDocumentRefFragmentDoc = gql`
  fragment InsightsDocumentRef on InsightsV1InsightsDocument {
    __typename
    name
    title
    lifecycle
    description
  }
`;
export const InsightsTableContextRefFragmentDoc = gql`
  fragment InsightsTableContextRef on InsightsV1InsightsTableContext {
    __typename
    name
    displayName
    enabled
    source
    createTime
    updateTime
    labels {
      key
      value
    }
    factTable {
      ... on MetricsV1FactTable {
        __typename
        name
        displayName
        description
        state
      }
      ... on Error {
        __typename
        message
      }
    }
  }
`;
export const AccountDomainFragmentDoc = gql`
  fragment AccountDomain on AdminV1AccountDomain {
    __typename
    domainId
    domain
    state
    verificationTxt
    verificationHost
  }
`;
export const AgentReviewPreviewFragmentDoc = gql`
  fragment AgentReviewPreview on CollaborationV1AgentReviewPreview {
    __typename
    name
    resource
    agent {
      ... on IamV1Agent {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    state
    outcome
    comment
    sections {
      zone
      title
      comment
    }
    errorMessage
    createTime
    updateTime
  }
  ${DefaultErrorFragmentDoc}
`;
export const AuthAppFragmentDoc = gql`
  fragment AuthApp on IamV1OAuthApp {
    name
    displayName
  }
`;
export const EnvironmentFragmentDoc = gql`
  fragment Environment on FlagsAdminV1Environment {
    __typename
    name
    color
    description
    deleteTime
  }
`;
export const ClientCredentialFragmentDoc = gql`
  fragment ClientCredential on IamV1ClientCredential {
    __typename
    name
    displayName
    sdkType
    lastSeenTime
    createTime
    creator {
      ... on IamV1Identity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    hasEncryptionKey
    clientSecret {
      secret
    }
    environments {
      ...Environment
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EnvironmentFragmentDoc}
`;
export const SemanticTypeFragmentDoc = gql`
  fragment SemanticType on FlagsAdminV1ContextFieldSemanticType {
    enumType {
      values {
        value
      }
    }
    entityReference {
      entity {
        ... on MetricsV1Entity {
          name
          displayName
          __typename
        }
        ...DefaultError
      }
    }
    country {
      format
    }
    timestamp {
      dummy
    }
    date {
      dummy
    }
    version {
      dummy
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const ContextSchemaEntryFragmentDoc = gql`
  fragment ContextSchemaEntry on FlagsAdminV1EvaluationContextSchemaSchemaEntry {
    key
    value {
      displayName
      hidden
      semanticType {
        ...SemanticType
      }
      types
    }
  }
  ${SemanticTypeFragmentDoc}
`;
export const ContextSchemaFragmentDoc = gql`
  fragment ContextSchema on FlagsAdminV1EvaluationContextSchema {
    schema {
      ...ContextSchemaEntry
    }
  }
  ${ContextSchemaEntryFragmentDoc}
`;
export const BigQueryConfigFragmentDoc = gql`
  fragment BigQueryConfig on MetricsV1BigQueryConfig {
    gcpProjectId
    dataset
    serviceAccount
    processingProjectId
    interactiveProjectId
  }
`;
export const DataBricksConfigFragmentDoc = gql`
  fragment DataBricksConfig on MetricsV1DatabricksConfig {
    host
    warehouseId
    clientId
    exposureSchema
    resultsSchema
  }
`;
export const RedshiftConfigFragmentDoc = gql`
  fragment RedshiftConfig on MetricsV1RedshiftConfig {
    cluster
    database
    exposureSchema
    region
    roleArn
    webIdentitySettings {
      __typename
    }
    credentialsSettings {
      accessKeyId
    }
  }
`;
export const SnowflakeConfigFragmentDoc = gql`
  fragment SnowflakeConfig on MetricsV1SnowflakeConfig {
    account
    user
    authenticationKey {
      ... on IamV1CryptoKey {
        __typename
        name
      }
      ...DefaultError
    }
    role
    warehouse
    exposureDatabase
    exposureSchema
  }
  ${DefaultErrorFragmentDoc}
`;
export const WarehouseLimitsFragmentDoc = gql`
  fragment WarehouseLimits on MetricsV1DataWarehouseDataWarehouseLimits {
    maxConcurrentInteractiveQueries
    maxConcurrentQueries
  }
`;
export const DataWarehouseFragmentDoc = gql`
  fragment DataWarehouse on MetricsV1DataWarehouse {
    __typename
    name
    isPrimary
    deleteTime
    config {
      bigQueryConfig {
        ...BigQueryConfig
      }
      dataBricksConfig {
        ...DataBricksConfig
      }
      redshiftConfig {
        ...RedshiftConfig
      }
      snowflakeConfig {
        ...SnowflakeConfig
      }
    }
    limits {
      ...WarehouseLimits
    }
  }
  ${BigQueryConfigFragmentDoc}
  ${DataBricksConfigFragmentDoc}
  ${RedshiftConfigFragmentDoc}
  ${SnowflakeConfigFragmentDoc}
  ${WarehouseLimitsFragmentDoc}
`;
export const EntityRelationTableEntityFragmentDoc = gql`
  fragment EntityRelationTableEntity on MetricsV1Entity {
    name
    displayName
    primaryKeyType
  }
`;
export const EntityRelationTableRowFragmentDoc = gql`
  fragment EntityRelationTableRow on MetricsV1EntityRelationTable {
    name
    targetEntity {
      ... on MetricsV1Entity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    targetEntityIdColumn {
      name
      type
    }
    parentEntityIdColumn {
      name
      type
    }
    state
    error {
      ...MetricsTableError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
`;
export const EvaluationContextFieldOverrideFragmentDoc = gql`
  fragment EvaluationContextFieldOverride on FlagsAdminV1EvaluationContextFieldOverride {
    name
    displayName
    field
    hidden
    kind
    semanticType {
      ...SemanticType
    }
    nonPii
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        resourceRelations {
          relation
        }
        __typename
      }
      ...DefaultError
    }
    __typename
  }
  ${SemanticTypeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const EventTypeFragmentDoc = gql`
  fragment EventType on ConnectorsV1EventType {
    name
    description
    __typename
  }
`;
export const EventFragmentDoc = gql`
  fragment Event on ConnectorsV1Event {
    __typename
    name
    eventType {
      ...EventType
      ...DefaultError
    }
    resources
    pubsubMetadata {
      messageId
      publishTime
      consumeTime
    }
    cloudEvent {
      id
      type
      source
      protoData
    }
  }
  ${EventTypeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ConnectorBigQueryConfigFragmentDoc = gql`
  fragment ConnectorBigQueryConfig on ConnectorsV1BigQueryConfig {
    dataset
    project
    serviceAccount
  }
`;
export const ConnectorS3BucketConfigFragmentDoc = gql`
  fragment ConnectorS3BucketConfig on ConnectorsV1S3BucketConfig {
    roleArn
    bucket
    region
    webIdentitySettings {
      __typename
    }
    credentialsSettings {
      accessKeyId
    }
  }
`;
export const ConnectorDatabricksConnectionConfigFragmentDoc = gql`
  fragment ConnectorDatabricksConnectionConfig on ConnectorsV1DatabricksConnectionConfig {
    host
    warehouseId
    clientId
  }
`;
export const ConnectorBatchFileConfigFragmentDoc = gql`
  fragment ConnectorBatchFileConfig on ConnectorsV1BatchFileConfig {
    maxEventsPerFile
    maxFileAge
    maxFileSize
  }
`;
export const ConnectorDatabricksConfigFragmentDoc = gql`
  fragment ConnectorDatabricksConfig on ConnectorsV1DatabricksConfig {
    schema
    s3BucketConfig {
      ...ConnectorS3BucketConfig
    }
    connectionConfig {
      ...ConnectorDatabricksConnectionConfig
    }
    batchFileConfig {
      ...ConnectorBatchFileConfig
    }
  }
  ${ConnectorS3BucketConfigFragmentDoc}
  ${ConnectorDatabricksConnectionConfigFragmentDoc}
  ${ConnectorBatchFileConfigFragmentDoc}
`;
export const ConnectorRedshiftConfigFragmentDoc = gql`
  fragment ConnectorRedshiftConfig on ConnectorsV1RedshiftConfig {
    database
    cluster
    region
    roleArn
    schema
    webIdentitySettings {
      __typename
    }
    credentialsSettings {
      accessKeyId
    }
  }
`;
export const ConnectorSnowflakeConfigFragmentDoc = gql`
  fragment ConnectorSnowflakeConfig on ConnectorsV1SnowflakeConfig {
    user
    account
    database
    role
    schema
  }
`;
export const UsageMetadataFragmentDoc = gql`
  fragment UsageMetadata on ConnectorsV1UsageMetadata {
    errorRate {
      rate1m
      rate5m
      rate15m
    }
    successRate {
      rate1m
      rate5m
      rate15m
    }
    successRatio {
      rate1m
      rate5m
      rate15m
    }
    lag {
      p95
    }
  }
`;
export const EventConnectionFragmentDoc = gql`
  fragment EventConnection on ConnectorsV1EventConnection {
    __typename
    name
    state
    createTime
    bigQuery {
      bigQueryConfig {
        ...ConnectorBigQueryConfig
      }
      tablePrefix
    }
    databricks {
      databricksConfig {
        ...ConnectorDatabricksConfig
      }
    }
    redshift {
      tablePrefix
      redshiftConfig {
        ...ConnectorRedshiftConfig
      }
      batchFileConfig {
        ...ConnectorBatchFileConfig
      }
      s3Config {
        ...ConnectorS3BucketConfig
      }
    }
    snowflake {
      tablePrefix
      snowflakeConfig {
        ...ConnectorSnowflakeConfig
      }
    }
    usageMetadata {
      ...UsageMetadata
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${ConnectorBigQueryConfigFragmentDoc}
  ${ConnectorDatabricksConfigFragmentDoc}
  ${ConnectorRedshiftConfigFragmentDoc}
  ${ConnectorBatchFileConfigFragmentDoc}
  ${ConnectorS3BucketConfigFragmentDoc}
  ${ConnectorSnowflakeConfigFragmentDoc}
  ${UsageMetadataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const FeedFragmentDoc = gql`
  fragment Feed on ActivityV1Feed {
    __typename
    name
    channels {
      disabled
      email {
        address
      }
      lastError {
        message
        errorTime
      }
      priority
      slack {
        channel
      }
      activityTypes {
        ... on ActivityV1ActivityType {
          name
          displayName
        }
      }
      webhook {
        uri
        id
      }
    }
    feedSubscriptions(pageSize: 100) {
      ... on ActivityV1ListFeedSubscriptionsResponse {
        __typename
        feedSubscriptions {
          resourceType
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const ConnectorPubsubConfigFragmentDoc = gql`
  fragment ConnectorPubsubConfig on ConnectorsV1PubsubConfig {
    serviceAccount
    project
    topic
    outputFormat
  }
`;
export const ConnectorKinesisConfigFragmentDoc = gql`
  fragment ConnectorKinesisConfig on ConnectorsV1KinesisConfig {
    region
    roleArn
    stream
    outputFormat
  }
`;
export const FlagAppliedConnectionFragmentDoc = gql`
  fragment FlagAppliedConnection on ConnectorsV1FlagAppliedConnection {
    __typename
    name
    state
    createTime
    bigQuery {
      bigQueryConfig {
        ...ConnectorBigQueryConfig
      }
      table
    }
    databricks {
      databricksConfig {
        ...ConnectorDatabricksConfig
      }
      table
    }
    pubsub {
      pubsubConfig {
        ...ConnectorPubsubConfig
      }
    }
    kinesis {
      kinesisConfig {
        ...ConnectorKinesisConfig
      }
    }
    redshift {
      table
      redshiftConfig {
        ...ConnectorRedshiftConfig
      }
      batchFileConfig {
        ...ConnectorBatchFileConfig
      }
      s3Config {
        ...ConnectorS3BucketConfig
      }
    }
    snowflake {
      snowflakeConfig {
        ...ConnectorSnowflakeConfig
      }
      table
    }
    usageMetadata {
      ...UsageMetadata
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${ConnectorBigQueryConfigFragmentDoc}
  ${ConnectorDatabricksConfigFragmentDoc}
  ${ConnectorPubsubConfigFragmentDoc}
  ${ConnectorKinesisConfigFragmentDoc}
  ${ConnectorRedshiftConfigFragmentDoc}
  ${ConnectorBatchFileConfigFragmentDoc}
  ${ConnectorS3BucketConfigFragmentDoc}
  ${ConnectorSnowflakeConfigFragmentDoc}
  ${UsageMetadataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const OAuthAppFragmentDoc = gql`
  fragment OAuthApp on IamV1OAuthApp {
    __typename
    name
    displayName
    description
    clientId
    clientSecret
    allowedCallbackUrls
    allowedWebOrigins
    allowedLogoutUrls
    logoUri
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const PlatformConnectionFragmentDoc = gql`
  fragment PlatformConnection on ConnectorsV1PlatformConnection {
    name
    state
    eventType {
      ... on ConnectorsV1EventType {
        name
        description
      }
    }
    createTime
    pubsub {
      pubsubConfig {
        ...ConnectorPubsubConfig
      }
    }
    kinesis {
      kinesisConfig {
        ...ConnectorKinesisConfig
      }
    }
  }
  ${ConnectorPubsubConfigFragmentDoc}
  ${ConnectorKinesisConfigFragmentDoc}
`;
export const RoleFragmentDoc = gql`
  fragment Role on IamV1Role {
    name
    displayName
    builtin
    permissions {
      category
      description
      type
    }
    __typename
  }
`;
export const PolicyFragmentDoc = gql`
  fragment Policy on IamV1Policy {
    name
    __typename
    createTime
    updateTime
    roles {
      ...Role
      ...DefaultError
    }
    identities {
      ...IdentityRef
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${RoleFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
`;
export const RoleRefFragmentDoc = gql`
  fragment RoleRef on IamV1Role {
    __typename
    name
    displayName
  }
`;
export const RoleIndexPageRoleFragmentDoc = gql`
  fragment RoleIndexPageRole on IamV1Role {
    ...RoleRef
    builtin
    permissions {
      category
      description
      type
    }
  }
  ${RoleRefFragmentDoc}
`;
export const SqlJobFragmentDoc = gql`
  fragment SqlJob on MetricsV1SqlJob {
    __typename
    name
    successfulQueryResult {
      schema {
        name
        type
      }
    }
    failedQueryResult {
      error
    }
    pendingQueryResult {
      __typename
    }
  }
`;
export const UserInvitationFragmentDoc = gql`
  fragment UserInvitation on IamV1UserInvitation {
    __typename
    name
    invitedEmail
    inviter
    expirationTime
    createTime
    ttl
  }
`;
export const ManagedTokenUsageFragmentDoc = gql`
  fragment ManagedTokenUsage on AiworkflowsV1TokenUsage {
    inputTokens
    outputTokens
    cacheCreationInputTokens
    cacheReadInputTokens
    totalInputTokens
    totalTokens
  }
`;
export const ManagedCodingSessionFragmentDoc = gql`
  fragment ManagedCodingSession on AiworkflowsV1ManagedCodingSession {
    chatName
    sessionId
    repository
    branch
    provider
    status
    prompt
    prUrl
    usage {
      ...ManagedTokenUsage
    }
    startedAt
    updatedAt
  }
  ${ManagedTokenUsageFragmentDoc}
`;
export const AttachmentsFragmentDoc = gql`
  fragment Attachments on WorkflowV1WorkflowInstance {
    attachments {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        __typename
        attachments {
          ...Attachment
        }
      }
    }
  }
  ${AttachmentFragmentDoc}
`;
export const ProjectRefFragmentDoc = gql`
  fragment ProjectRef on CollaborationV1Project {
    __typename
    name
    displayName
    updateTime
    deleteTime
  }
`;
export const AssistantOutcomeFragmentDoc = gql`
  fragment AssistantOutcome on ConversationsV2ChatAssistantOutcome {
    outcome {
      __typename
      response
    }
    toolConfirmation {
      __typename
      tool
      input
    }
    askQuestion {
      __typename
      question
      alternatives
    }
    error {
      __typename
      details
    }
  }
`;
export const ChatRefFragmentDoc = gql`
  fragment ChatRef on ConversationsV2Chat {
    __typename
    name
    displayName
    state
    createTime
    updateTime
    source
    creator {
      ...IdentityRef
      ...DefaultError
    }
    project {
      __typename
      ...ProjectRef
      ...DefaultError
    }
    assistantOutcome {
      ...AssistantOutcome
    }
    summary {
      title
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ProjectRefFragmentDoc}
  ${AssistantOutcomeFragmentDoc}
`;
export const ChatFragmentDoc = gql`
  fragment Chat on ConversationsV2Chat {
    ...ChatRef
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${ChatRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ChatEventUserMessageFragmentDoc = gql`
  fragment ChatEventUserMessage on ConversationsV2UserMessage {
    __typename
    content
    parts {
      text
      resource
      imageUri
    }
  }
`;
export const ChatEventAssistantMessageFragmentDoc = gql`
  fragment ChatEventAssistantMessage on ConversationsV2AssistantMessage {
    __typename
    content
    phase
  }
`;
export const ChatEventThinkingFragmentDoc = gql`
  fragment ChatEventThinking on ConversationsV2Thinking {
    __typename
    content
  }
`;
export const ChatEventToolCallFragmentDoc = gql`
  fragment ChatEventToolCall on ConversationsV2ToolCall {
    __typename
    tool
    input
    displayName
  }
`;
export const ChatEventRefFragmentDoc = gql`
  fragment ChatEventRef on ConversationsV2ChatEvent {
    __typename
    name
  }
`;
export const ChatEventToolResultFragmentDoc = gql`
  fragment ChatEventToolResult on ConversationsV2ToolResult {
    __typename
    content
    success
    toolCallEvent {
      __typename
      ... on ConversationsV2ChatEvent {
        ...ChatEventRef
      }
      ...DefaultError
    }
  }
  ${ChatEventRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ChatEventToolConfirmationRequestFragmentDoc = gql`
  fragment ChatEventToolConfirmationRequest on ConversationsV2ToolConfirmationRequest {
    __typename
    tool
    input
    displayName
  }
`;
export const ChatEventToolConfirmationResponseFragmentDoc = gql`
  fragment ChatEventToolConfirmationResponse on ConversationsV2ToolConfirmationResponse {
    __typename
    decision
    toolRequestEvent {
      __typename
      ... on ConversationsV2ChatEvent {
        ...ChatEventRef
        toolConfirmationRequest {
          ...ChatEventToolConfirmationRequest
        }
      }
      ...DefaultError
    }
  }
  ${ChatEventRefFragmentDoc}
  ${ChatEventToolConfirmationRequestFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ChatEventUserInterruptFragmentDoc = gql`
  fragment ChatEventUserInterrupt on ConversationsV2UserInterrupt {
    __typename
  }
`;
export const ChatEventNotificationFragmentDoc = gql`
  fragment ChatEventNotification on ConversationsV2Notification {
    __typename
    childChatStopped {
      __typename
      success
      summary
      childChat {
        __typename
        ... on ConversationsV2Chat {
          ...ChatRef
        }
        ...DefaultError
      }
    }
  }
  ${ChatRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ChatEventErrorFragmentDoc = gql`
  fragment ChatEventError on ConversationsV2Error {
    __typename
    message
    code
  }
`;
export const ChatEventFragmentDoc = gql`
  fragment ChatEvent on ConversationsV2ChatEvent {
    __typename
    name
    createTime
    updateTime
    userMessage {
      ...ChatEventUserMessage
    }
    assistantMessage {
      ...ChatEventAssistantMessage
    }
    thinking {
      ...ChatEventThinking
    }
    toolCall {
      ...ChatEventToolCall
    }
    toolResult {
      ...ChatEventToolResult
    }
    toolConfirmationRequest {
      ...ChatEventToolConfirmationRequest
    }
    toolConfirmationResponse {
      ...ChatEventToolConfirmationResponse
    }
    userInterrupt {
      ...ChatEventUserInterrupt
    }
    notification {
      ...ChatEventNotification
    }
    error {
      ...ChatEventError
    }
  }
  ${ChatEventUserMessageFragmentDoc}
  ${ChatEventAssistantMessageFragmentDoc}
  ${ChatEventThinkingFragmentDoc}
  ${ChatEventToolCallFragmentDoc}
  ${ChatEventToolResultFragmentDoc}
  ${ChatEventToolConfirmationRequestFragmentDoc}
  ${ChatEventToolConfirmationResponseFragmentDoc}
  ${ChatEventUserInterruptFragmentDoc}
  ${ChatEventNotificationFragmentDoc}
  ${ChatEventErrorFragmentDoc}
`;
export const PresenceFragmentDoc = gql`
  fragment Presence on CollaborationV1Presence {
    name
    createTime
    updateTime
    data
    actor {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const CollectionFragmentDoc = gql`
  fragment Collection on CollectionsV1Collection {
    __typename
    name
    displayName
    description
    isPrivate
    updateTime
    createTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
    creator {
      ...IdentityRef
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const WorkflowInstanceRefFragmentDoc = gql`
  fragment WorkflowInstanceRef on WorkflowV1WorkflowInstance {
    __typename
    name
    displayName
  }
`;
export const CollectionEntryFragmentDoc = gql`
  fragment CollectionEntry on CollectionsV1CollectionEntry {
    __typename
    name
    createTime
    resource {
      __typename
      ... on MetricsV1Metric {
        __typename
        name
        displayName
      }
      ... on FlagsAdminV1Flag {
        __typename
        name
        displayName
      }
      ... on WorkflowV1Surface {
        ...SurfaceRef
      }
      ... on WorkflowV1WorkflowInstance {
        ...WorkflowInstanceRef
      }
      ... on CollaborationV1Project {
        ...ProjectRef
      }
    }
  }
  ${SurfaceRefFragmentDoc}
  ${WorkflowInstanceRefFragmentDoc}
  ${ProjectRefFragmentDoc}
`;
export const CollectionRefFragmentDoc = gql`
  fragment CollectionRef on CollectionsV1Collection {
    __typename
    name
    displayName
    description
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const CollectionIndexPageCollectionFragmentDoc = gql`
  fragment CollectionIndexPageCollection on CollectionsV1Collection {
    ...CollectionRef
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${CollectionRefFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const CommentReplyFragmentDoc = gql`
  fragment CommentReply on CollaborationV1CommentReply {
    name
    content
    action
    assignee {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    createTime
    updateTime
    author {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    queryReactionSummary {
      __typename
      ...DefaultError
      ... on CollaborationV1QueryReactionSummaryResponse {
        summary {
          ...ReactionSummary
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ReactionSummaryFragmentDoc}
`;
export const ReactionFragmentDoc = gql`
  fragment Reaction on CollaborationV1Reaction {
    __typename
    name
    emoji
    resource
    createTime
    updateTime
    author {
      __typename
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const LabelFragmentDoc = gql`
  fragment Label on AdminLabelsV1Label {
    __typename
    name
    displayName
    description
    resourceTypes
    allowedValues
    labels {
      key
      value
    }
    createTime
    updateTime
    creator {
      ...IdentityRef
    }
    updater {
      ...IdentityRef
    }
  }
  ${IdentityRefFragmentDoc}
`;
export const LabelRefFragmentDoc = gql`
  fragment LabelRef on AdminLabelsV1Label {
    __typename
    name
    displayName
    description
    resourceTypes
    allowedValues
  }
`;
export const SearchIdentityFragmentDoc = gql`
  fragment SearchIdentity on IamV1Identity {
    __typename
    name
    displayName
    email
    pictureUri
  }
`;
export const CollaborativeDocumentFragmentDoc = gql`
  fragment CollaborativeDocument on CollaborationV1CollaborativeDocument {
    __typename
    name
    resource
    title
    state
    content
    markdown
    pendingOperation {
      type
    }
    etag
    realtimeEditing
    createTime
    updateTime
    publishTime
    creator {
      ...IdentityRef
    }
    updater {
      ...IdentityRef
    }
    publisher {
      ...IdentityRef
    }
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const TiptapTokenFragmentDoc = gql`
  fragment TiptapToken on CollaborationV1GetTiptapTokenResponse {
    __typename
    appId
    tiptapDocumentName
    token
    expiresAt
    readWrite
  }
`;
export const EntityIdentityBindingFragmentDoc = gql`
  fragment EntityIdentityBinding on MetricsV1EntityIdentityBinding {
    __typename
    name
    entity {
      ...EntityRef
      ... on MetricsV1Entity {
        labels {
          key
          value
        }
      }
      ...DefaultError
    }
    identity {
      ...IdentityRef
      ...DefaultError
    }
    value
    createTime
    updateTime
  }
  ${EntityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
`;
export const FieldSemanticTypeFragmentDoc = gql`
  fragment FieldSemanticType on EventsAdminV1FieldSemanticType {
    country {
      format
    }
    entityReference {
      entity {
        ... on MetricsV1Entity {
          name
          displayName
          __typename
        }
        ...DefaultError
      }
    }
    enumType {
      values {
        value
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const EventSchemaIntSchemaFragmentDoc = gql`
  fragment EventSchemaIntSchema on EventsAdminV1EventSchema {
    intSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaDoubleSchemaFragmentDoc = gql`
  fragment EventSchemaDoubleSchema on EventsAdminV1EventSchema {
    doubleSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaStringSchemaFragmentDoc = gql`
  fragment EventSchemaStringSchema on EventsAdminV1EventSchema {
    stringSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaBoolSchemaFragmentDoc = gql`
  fragment EventSchemaBoolSchema on EventsAdminV1EventSchema {
    boolSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaDateSchemaFragmentDoc = gql`
  fragment EventSchemaDateSchema on EventsAdminV1EventSchema {
    dateSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaTimestampSchemaFragmentDoc = gql`
  fragment EventSchemaTimestampSchema on EventsAdminV1EventSchema {
    timestampSchema {
      displayName
      description
      semanticType {
        ...FieldSemanticType
      }
    }
  }
  ${FieldSemanticTypeFragmentDoc}
`;
export const EventSchemaListSchemaFragmentDoc = gql`
  fragment EventSchemaListSchema on EventsAdminV1EventSchema {
    listSchema {
      displayName
      description
      elementSchema {
        ...EventSchemaIntSchema
        ...EventSchemaDoubleSchema
        ...EventSchemaStringSchema
        ...EventSchemaBoolSchema
        ...EventSchemaDateSchema
        ...EventSchemaTimestampSchema
        structSchema {
          displayName
          description
          schema {
            key
            value {
              ...EventSchemaIntSchema
              ...EventSchemaDoubleSchema
              ...EventSchemaStringSchema
              ...EventSchemaBoolSchema
              ...EventSchemaDateSchema
              ...EventSchemaTimestampSchema
              structSchema {
                displayName
                description
                schema {
                  key
                  value {
                    ...EventSchemaIntSchema
                    ...EventSchemaDoubleSchema
                    ...EventSchemaStringSchema
                    ...EventSchemaBoolSchema
                    ...EventSchemaDateSchema
                    ...EventSchemaTimestampSchema
                    structSchema {
                      displayName
                      description
                      schema {
                        key
                      }
                    }
                  }
                }
              }
              listSchema {
                displayName
                description
                elementSchema {
                  ...EventSchemaIntSchema
                  ...EventSchemaDoubleSchema
                  ...EventSchemaStringSchema
                  ...EventSchemaBoolSchema
                  ...EventSchemaDateSchema
                  ...EventSchemaTimestampSchema
                  structSchema {
                    displayName
                    description
                    schema {
                      key
                      value {
                        ...EventSchemaIntSchema
                        ...EventSchemaDoubleSchema
                        ...EventSchemaStringSchema
                        ...EventSchemaBoolSchema
                        ...EventSchemaDateSchema
                        ...EventSchemaTimestampSchema
                        structSchema {
                          displayName
                          description
                          schema {
                            key
                            value {
                              ...EventSchemaIntSchema
                              ...EventSchemaDoubleSchema
                              ...EventSchemaStringSchema
                              ...EventSchemaBoolSchema
                              ...EventSchemaDateSchema
                              ...EventSchemaTimestampSchema
                              structSchema {
                                displayName
                                description
                                schema {
                                  key
                                  value {
                                    ...EventSchemaIntSchema
                                    ...EventSchemaDoubleSchema
                                    ...EventSchemaStringSchema
                                    ...EventSchemaBoolSchema
                                    ...EventSchemaDateSchema
                                    ...EventSchemaTimestampSchema
                                    structSchema {
                                      displayName
                                      description
                                      schema {
                                        key
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${EventSchemaIntSchemaFragmentDoc}
  ${EventSchemaDoubleSchemaFragmentDoc}
  ${EventSchemaStringSchemaFragmentDoc}
  ${EventSchemaBoolSchemaFragmentDoc}
  ${EventSchemaDateSchemaFragmentDoc}
  ${EventSchemaTimestampSchemaFragmentDoc}
`;
export const EventSchemaStructSchemaFragmentDoc = gql`
  fragment EventSchemaStructSchema on EventsAdminV1EventSchema {
    structSchema {
      displayName
      description
      schema {
        key
        value {
          structSchema {
            displayName
            description
            schema {
              key
              value {
                ...EventSchemaListSchema
                ...EventSchemaIntSchema
                ...EventSchemaDoubleSchema
                ...EventSchemaStringSchema
                ...EventSchemaBoolSchema
                ...EventSchemaDateSchema
                ...EventSchemaTimestampSchema
                structSchema {
                  displayName
                  description
                  schema {
                    key
                    value {
                      ...EventSchemaListSchema
                      ...EventSchemaIntSchema
                      ...EventSchemaDoubleSchema
                      ...EventSchemaStringSchema
                      ...EventSchemaBoolSchema
                      ...EventSchemaDateSchema
                      ...EventSchemaTimestampSchema
                      structSchema {
                        displayName
                        description
                        schema {
                          key
                          value {
                            ...EventSchemaListSchema
                            ...EventSchemaIntSchema
                            ...EventSchemaDoubleSchema
                            ...EventSchemaStringSchema
                            ...EventSchemaBoolSchema
                            ...EventSchemaDateSchema
                            ...EventSchemaTimestampSchema
                            structSchema {
                              displayName
                              description
                              schema {
                                key
                                value {
                                  ...EventSchemaListSchema
                                  ...EventSchemaIntSchema
                                  ...EventSchemaDoubleSchema
                                  ...EventSchemaStringSchema
                                  ...EventSchemaBoolSchema
                                  ...EventSchemaDateSchema
                                  ...EventSchemaTimestampSchema
                                  structSchema {
                                    displayName
                                    description
                                    schema {
                                      key
                                      value {
                                        ...EventSchemaListSchema
                                        ...EventSchemaIntSchema
                                        ...EventSchemaDoubleSchema
                                        ...EventSchemaStringSchema
                                        ...EventSchemaBoolSchema
                                        ...EventSchemaDateSchema
                                        ...EventSchemaTimestampSchema
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ...EventSchemaListSchema
          ...EventSchemaIntSchema
          ...EventSchemaDoubleSchema
          ...EventSchemaStringSchema
          ...EventSchemaBoolSchema
          ...EventSchemaDateSchema
          ...EventSchemaTimestampSchema
        }
      }
    }
  }
  ${EventSchemaListSchemaFragmentDoc}
  ${EventSchemaIntSchemaFragmentDoc}
  ${EventSchemaDoubleSchemaFragmentDoc}
  ${EventSchemaStringSchemaFragmentDoc}
  ${EventSchemaBoolSchemaFragmentDoc}
  ${EventSchemaDateSchemaFragmentDoc}
  ${EventSchemaTimestampSchemaFragmentDoc}
`;
export const EventSchemaEntryFragmentDoc = gql`
  fragment EventSchemaEntry on EventsAdminV1EventDefinitionSchemaEntry {
    key
    value {
      ...EventSchemaStructSchema
      ...EventSchemaListSchema
      ...EventSchemaIntSchema
      ...EventSchemaDoubleSchema
      ...EventSchemaStringSchema
      ...EventSchemaBoolSchema
      ...EventSchemaDateSchema
      ...EventSchemaTimestampSchema
    }
  }
  ${EventSchemaStructSchemaFragmentDoc}
  ${EventSchemaListSchemaFragmentDoc}
  ${EventSchemaIntSchemaFragmentDoc}
  ${EventSchemaDoubleSchemaFragmentDoc}
  ${EventSchemaStringSchemaFragmentDoc}
  ${EventSchemaBoolSchemaFragmentDoc}
  ${EventSchemaDateSchemaFragmentDoc}
  ${EventSchemaTimestampSchemaFragmentDoc}
`;
export const EventDefinitionFragmentDoc = gql`
  fragment EventDefinition on EventsAdminV1EventDefinition {
    __typename
    name
    updateTime
    owner {
      ... on IamV1Identity {
        __typename
        displayName
        name
        everyone
        user {
          ... on IamV1User {
            pictureUri
            name
          }
        }
        group {
          ... on IamV1Group {
            name
          }
        }
        apiClient {
          ... on IamV1ApiClient {
            name
          }
        }
      }
      ...DefaultError
    }
    schema {
      ...EventSchemaEntry
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
    usageMetadata {
      publishCount
      validationFailedCount
      lastPublishTime
      lastValidationFailedTime
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EventSchemaEntryFragmentDoc}
`;
export const ClientFragmentDoc = gql`
  fragment Client on IamV1Client {
    __typename
    name
    displayName
    lastSeenTime
    createTime
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const DraftEventFragmentDoc = gql`
  fragment DraftEvent on EventsAdminV1DraftEvent {
    reason
    eventTime
    draftEventDefinition
    payload
    schema {
      __typename
      ...EventSchemaStructSchema
    }
    eventDefinition {
      __typename
      ... on EventsAdminV1EventDefinition {
        ...EventDefinition
      }
    }
    client {
      __typename
      ... on IamV1Client {
        ...Client
      }
    }
  }
  ${EventSchemaStructSchemaFragmentDoc}
  ${EventDefinitionFragmentDoc}
  ${ClientFragmentDoc}
`;
export const ExternalDocumentRefFragmentDoc = gql`
  fragment ExternalDocumentRef on CollaborationV1ExternalDocument {
    __typename
    name
    resource
    title
    markdown
    source {
      type
      sourceId
      uri
    }
    createTime
    updateTime
  }
`;
export const MaterializedSegmentLoadJobFragmentDoc = gql`
  fragment MaterializedSegmentLoadJob on MaterializerV1MaterializedSegmentLoadJob {
    __typename
    name
    sql
    entityIdColumn
    state
    createTime
    updateTime
    progress
    rowCount
    errorMessage
    schedule {
      __typename
      ... on MaterializerV1ScheduledMaterializedSegmentLoadJob {
        name
      }
    }
    exportStartTime
    exportEndTime
    ingestionStatus {
      ingestionStartTime
      ingestionEndTime
      ingestionRate
      progress
      state
    }
    bloomFilterStatus {
      state
      progress
      bloomFilterStartTime
      bloomFilterEndTime
      details {
        keyCount
        sizeBytes
        falsePositiveRate
      }
    }
  }
`;
export const MaterializedSegmentFragmentDoc = gql`
  fragment MaterializedSegment on FlagsAdminV1MaterializedSegment {
    __typename
    name
    displayName
    createTime
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MaterializedSegmentWithSchedulesFragmentDoc = gql`
  fragment MaterializedSegmentWithSchedules on FlagsAdminV1MaterializedSegment {
    ...MaterializedSegment
    scheduledMaterializedSegmentLoadJobs(pageSize: 10) {
      __typename
      ... on MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse {
        scheduledMaterializedSegmentLoadJobs {
          __typename
          name
          state
        }
      }
    }
  }
  ${MaterializedSegmentFragmentDoc}
`;
export const ScheduledMaterializedSegmentLoadJobFragmentDoc = gql`
  fragment ScheduledMaterializedSegmentLoadJob on MaterializerV1ScheduledMaterializedSegmentLoadJob {
    __typename
    name
    sql
    entityIdColumn
    state
    createTime
    updateTime
    scheduleStartTime
    scheduleEndTime
    scheduleIntervals
    nextScheduledRunTime
    executedLoadJobsCount
    attempt
    errorMessage
  }
`;
export const AiWorkflowInstanceFragmentDoc = gql`
  fragment AiWorkflowInstance on AiworkflowsV1AiWorkflowInstance {
    __typename
    name
    mode
    taskType
    actorType
    state
    labels {
      key
      value
    }
    schedule {
      ... on AiworkflowsV1AiWorkflowSchedule {
        __typename
        name
      }
    }
    createTime
    updateTime
  }
`;
export const AiWorkflowScheduleFragmentDoc = gql`
  fragment AiWorkflowSchedule on AiworkflowsV1AiWorkflowSchedule {
    __typename
    name
    actorType
    taskType
    intervalMinutes
    scheduleState
    lastRunTime
    nextRunTime
    executedCount
    createTime
    updateTime
    labels {
      key
      value
    }
  }
`;
export const IntSchemaFragmentDoc = gql`
  fragment IntSchema on FlagsTypesV1FlagSchema {
    intSchema {
      dummy
    }
  }
`;
export const DoubleSchemaFragmentDoc = gql`
  fragment DoubleSchema on FlagsTypesV1FlagSchema {
    doubleSchema {
      dummy
    }
  }
`;
export const StringSchemaFragmentDoc = gql`
  fragment StringSchema on FlagsTypesV1FlagSchema {
    stringSchema {
      dummy
    }
  }
`;
export const BoolSchemaFragmentDoc = gql`
  fragment BoolSchema on FlagsTypesV1FlagSchema {
    boolSchema {
      dummy
    }
  }
`;
export const ListSchemaFragmentDoc = gql`
  fragment ListSchema on FlagsTypesV1FlagSchema {
    listSchema {
      elementSchema {
        ...IntSchema
        ...DoubleSchema
        ...StringSchema
        ...BoolSchema
      }
    }
  }
  ${IntSchemaFragmentDoc}
  ${DoubleSchemaFragmentDoc}
  ${StringSchemaFragmentDoc}
  ${BoolSchemaFragmentDoc}
`;
export const StructSchemaFragmentDoc = gql`
  fragment StructSchema on FlagsTypesV1FlagSchema {
    structSchema {
      schema {
        key
        value {
          ...ListSchema
          ...IntSchema
          ...DoubleSchema
          ...StringSchema
          ...BoolSchema
          structSchema {
            schema {
              key
              value {
                structSchema {
                  schema {
                    key
                    value {
                      ...ListSchema
                      ...IntSchema
                      ...DoubleSchema
                      ...StringSchema
                      ...BoolSchema
                      structSchema {
                        schema {
                          key
                        }
                      }
                    }
                  }
                }
                ...ListSchema
                ...IntSchema
                ...DoubleSchema
                ...StringSchema
                ...BoolSchema
              }
            }
          }
        }
      }
    }
  }
  ${ListSchemaFragmentDoc}
  ${IntSchemaFragmentDoc}
  ${DoubleSchemaFragmentDoc}
  ${StringSchemaFragmentDoc}
  ${BoolSchemaFragmentDoc}
`;
export const EntryFragmentDoc = gql`
  fragment Entry on FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntry {
    key
    value {
      ...StructSchema
      ...ListSchema
      ...IntSchema
      ...DoubleSchema
      ...StringSchema
      ...BoolSchema
    }
  }
  ${StructSchemaFragmentDoc}
  ${ListSchemaFragmentDoc}
  ${IntSchemaFragmentDoc}
  ${DoubleSchemaFragmentDoc}
  ${StringSchemaFragmentDoc}
  ${BoolSchemaFragmentDoc}
`;
export const SchemaFragmentDoc = gql`
  fragment Schema on FlagsTypesV1FlagSchemaStructFlagSchema {
    schema {
      ...Entry
    }
  }
  ${EntryFragmentDoc}
`;
export const VariantFragmentDoc = gql`
  fragment Variant on FlagsAdminV1FlagVariant {
    __typename
    name
    description
    value
    imageUri
    createTime
    updateTime
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const RuleFragmentDoc = gql`
  fragment Rule on FlagsAdminV1FlagRule {
    __typename
    name
    enabled
    updateTime
    targetingKeySelector
    description
    segment {
      ...Segment
      ...DefaultError
    }
    assignmentSpec {
      bucketCount
      assignments {
        assignmentId
        variant {
          variant {
            ... on FlagsAdminV1FlagVariant {
              name
              __typename
            }
            ...DefaultError
          }
        }
        fallthrough {
          dummy
        }
        clientDefault {
          dummy
        }
        bucketRanges {
          lower
          upper
        }
      }
    }
    materializationSpec {
      mode {
        materializationMustMatch
        segmentTargetingCanBeIgnored
      }
      readMaterialization {
        ... on FlagsAdminV1MaterializedSegment {
          name
          __typename
        }
        ...DefaultError
      }
      writeMaterialization {
        ... on FlagsAdminV1MaterializedSegment {
          name
          __typename
        }
        ...DefaultError
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
    environments {
      ...Environment
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${EnvironmentFragmentDoc}
`;
export const FlagFragmentDoc = gql`
  fragment Flag on FlagsAdminV1Flag {
    __typename
    name
    description
    owner {
      ...IdentityRef
      ...DefaultError
    }
    createTime
    updateTime
    archiveTime
    updater {
      ...IdentityRef
      ...DefaultError
    }
    labels {
      key
      value
    }
    schema {
      ...Schema
    }
    state
    variants {
      ...Variant
    }
    rules {
      ...Rule
    }
    clients {
      ...FlagClient
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    usageMetadata {
      lastApplyTime
      lastResolveTime
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${SchemaFragmentDoc}
  ${VariantFragmentDoc}
  ${RuleFragmentDoc}
  ${FlagClientFragmentDoc}
`;
export const FlagListItemFragmentDoc = gql`
  fragment FlagListItem on FlagsAdminV1Flag {
    __typename
    name
    createTime
    archiveTime
    state
    labels {
      key
      value
    }
    owner {
      ... on IamV1Identity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    variants {
      __typename
      name
    }
    rules {
      __typename
      name
    }
    usageMetadata {
      lastApplyTime
      lastResolveTime
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const FlagOptionFragmentDoc = gql`
  fragment FlagOption on FlagsAdminV1Flag {
    name
    variants {
      name
    }
  }
`;
export const ResolvedClientCredentialFragmentDoc = gql`
  fragment ResolvedClientCredential on IamV1ClientCredential {
    name
    displayName
    sdkType
    createTime
    creator {
      ...DefaultError
      ... on IamV1Identity {
        __typename
        name
        displayName
      }
    }
    environments {
      ...DefaultError
      ... on FlagsAdminV1Environment {
        __typename
        name
      }
    }
    clientSecret {
      secret
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const ResolvedClientFragmentDoc = gql`
  fragment ResolvedClient on IamV1Client {
    displayName
    name
    clientCredentials {
      ...DefaultError
      ... on IamV1ListClientCredentialsResponse {
        __typename
        clientCredentials {
          ...ResolvedClientCredential
        }
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${ResolvedClientCredentialFragmentDoc}
`;
export const RuleDetailsFragmentDoc = gql`
  fragment RuleDetails on FlagsResolverAdminV1ResolvedFlagRuleDetails {
    ruleEvaluationReason
    segmentEvaluationReason
    rule {
      ...Rule
      ...DefaultError
    }
  }
  ${RuleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SchemaEntryFragmentDoc = gql`
  fragment SchemaEntry on FlagsAdminV1EvaluationContextSchemaSchemaEntry {
    key
    value {
      types
      displayName
      hidden
      seenValues
      semanticType {
        ...SemanticType
      }
    }
  }
  ${SemanticTypeFragmentDoc}
`;
export const SnippetClientFragmentDoc = gql`
  fragment SnippetClient on IamV1Client {
    displayName
    name
  }
`;
export const SnippetSecretFragmentDoc = gql`
  fragment SnippetSecret on IamV1ClientCredential {
    displayName
    name
    clientSecret {
      secret
    }
  }
`;
export const BillingProductFragmentDoc = gql`
  fragment BillingProduct on BillingV1BillingProduct {
    __typename
    name
    displayName
    description
    prices {
      amountCents
      currencyCode
      recurringInterval
      recurringIntervalCount
      amountType
    }
    plan {
      tier
      pricingModel
      trialAvailable
      entitlements {
        key
        value {
          booleanValue
          integerValue
          unlimited {
            dummy
          }
          custom {
            dummy
          }
        }
      }
    }
    creditPack {
      credits
    }
  }
`;
export const FlagRefFragmentDoc = gql`
  fragment FlagRef on FlagsAdminV1Flag {
    __typename
    name
  }
`;
export const InactiveFlagFragmentDoc = gql`
  fragment InactiveFlag on FlagsAdminV1Flag {
    ...FlagRef
    usageMetadata {
      lastApplyTime
    }
  }
  ${FlagRefFragmentDoc}
`;
export const AppWorkflowInstanceCheckFragmentDoc = gql`
  fragment AppWorkflowInstanceCheck on WorkflowV1WorkflowInstanceCheck {
    name
    state
    displayName
    message
    updateTime
    labels {
      key
      value
    }
  }
`;
export const AppWorkflowInstanceFragmentDoc = gql`
  fragment AppWorkflowInstance on WorkflowV1WorkflowInstance {
    __typename
    displayName
    state
    name
    updateTime
    pendingTransition {
      ...PendingTransition
    }
    transitionStatus {
      action
      initiator {
        ... on IamV1Identity {
          name
          displayName
        }
      }
      running {
        ... on WorkflowV1WorkflowInstanceTransitionStatusRunning {
          startTime
        }
      }
      failed {
        ... on WorkflowV1WorkflowInstanceTransitionStatusFailed {
          startTime
          endTime
          error
        }
      }
      completed {
        ... on WorkflowV1WorkflowInstanceTransitionStatusCompleted {
          startTime
          endTime
        }
      }
    }
    checks {
      ...AppWorkflowInstanceCheck
    }
    moduleData2 {
      planning {
        planned {
          startTime
          endTime
        }
        actual {
          endTime
        }
      }
    }
  }
  ${PendingTransitionFragmentDoc}
  ${AppWorkflowInstanceCheckFragmentDoc}
`;
export const AgentFragmentDoc = gql`
  fragment Agent on IamV1Agent {
    __typename
    name
    displayName
    description
    pictureUri
    owner {
      ...IdentityRef
      ...DefaultError
    }
    identity {
      __typename
      ... on IamV1Identity {
        name
      }
      ...DefaultError
    }
    reviewerSkill {
      enabled
      instructions
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ApiClientRefFragmentDoc = gql`
  fragment ApiClientRef on IamV1ApiClient {
    __typename
    name
    displayName
    description
  }
`;
export const ClientRefFragmentDoc = gql`
  fragment ClientRef on IamV1Client {
    __typename
    name
    displayName
    lastSeenTime
    createTime
  }
`;
export const CurrentUserFragmentDoc = gql`
  fragment CurrentUser on IamV1CurrentUser {
    __typename
    user {
      ...User
      ... on IamV1User {
        slackUserInfo {
          user
          team
        }
      }
    }
    identity {
      ...Identity
    }
    account
    accountMemberships {
      account
      displayName
      externalId
      loginId
      portalInstanceUri
    }
  }
  ${UserFragmentDoc}
  ${IdentityFragmentDoc}
`;
export const UserRefFragmentDoc = gql`
  fragment UserRef on IamV1User {
    name
    fullName
    email
    pictureUri
    lastLoginTime
    __typename
  }
`;
export const AutomatedActionFragmentDoc = gql`
  fragment AutomatedAction on ActionsV1TypesAutomatedAction {
    action {
      executeFunctionAction {
        function
        parameters
        __typename
      }
      transitionAction {
        action
        parameters
        __typename
      }
      pagerdutyAction {
        pdKey
        severity
        title
        description
      }
    }
    trigger {
      stateTrigger {
        resource
        state
        __typename
      }
      activityTrigger {
        kind
        resource
      }
    }
  }
`;
export const InitiativeFragmentDoc = gql`
  fragment Initiative on WorkflowV1Initiative {
    __typename
    name
    displayName
    description
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
    reviews {
      mandatory
      reviewers {
        ...IdentityRef
        ...DefaultError
      }
    }
    stakeholders {
      role
      identity {
        ...IdentityRef
        ...DefaultError
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
    automatedActions {
      ...AutomatedAction
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${AutomatedActionFragmentDoc}
`;
export const InitiativeIndexPageInitiativeFragmentDoc = gql`
  fragment InitiativeIndexPageInitiative on WorkflowV1Initiative {
    ...InitiativeRef
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${InitiativeRefFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const InsightsMetricActiveUsersFragmentDoc = gql`
  fragment InsightsMetricActiveUsers on InsightsV1QueryInsightsMetricResponse {
    __typename
    values {
      __typename
      metricValue
      startTime
      endTime
    }
  }
`;
export const InsightsMetricFlagFragmentDoc = gql`
  fragment InsightsMetricFlag on InsightsV1QueryInsightsMetricResponse {
    __typename
    values {
      __typename
      metricValue
      startTime
    }
  }
`;
export const InsightsMetricLearningsFragmentDoc = gql`
  fragment InsightsMetricLearnings on InsightsV1QueryInsightsMetricResponse {
    __typename
    values {
      __typename
      metricValue
      dimensions {
        __typename
        value
        key
      }
    }
  }
`;
export const InsightsMetricLineChartDataFragmentDoc = gql`
  fragment InsightsMetricLineChartData on InsightsV1QueryInsightsMetricResponse {
    __typename
    values {
      __typename
      metricValue
      startTime
      endTime
      dimensions {
        __typename
        key
        value
      }
    }
  }
`;
export const InsightsMetricOnboardedUsersFragmentDoc = gql`
  fragment InsightsMetricOnboardedUsers on InsightsV1QueryInsightsMetricResponse {
    __typename
    values {
      __typename
      metricValue
      startTime
    }
  }
`;
export const IssueRefFragmentDoc = gql`
  fragment IssueRef on ObservationsV1Issue {
    __typename
    name
    displayName
  }
`;
export const ThemeRefFragmentDoc = gql`
  fragment ThemeRef on ObservationsV1Theme {
    __typename
    name
    displayName
  }
`;
export const CollaborativeDocumentRefFragmentDoc = gql`
  fragment CollaborativeDocumentRef on CollaborationV1CollaborativeDocument {
    __typename
    name
    title
    state
  }
`;
export const IssueFragmentDoc = gql`
  fragment Issue on ObservationsV1Issue {
    ...IssueRef
    state
    kind
    status
    closeReason
    autonomyLevel
    snoozedUntilTime
    confidenceScore
    observationCount
    taskStats {
      completed
      failed
      inProgress
      open
      waitingForInput
    }
    assignee {
      ...IdentityRef
      ...DefaultError
    }
    surfaces {
      ...SurfaceRef
      ...DefaultError
    }
    theme {
      ... on ObservationsV1Theme {
        ...ThemeRef
      }
      ...DefaultError
    }
    driver {
      ...ChatRef
      ...DefaultError
    }
    createTime
    updateTime
    problemStatement {
      ...CollaborativeDocumentRef
      ...DefaultError
    }
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${IssueRefFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${SurfaceRefFragmentDoc}
  ${ThemeRefFragmentDoc}
  ${ChatRefFragmentDoc}
  ${CollaborativeDocumentRefFragmentDoc}
`;
export const IssueSourceFragmentDoc = gql`
  fragment IssueSource on ObservationsV1Source {
    origin
    system
    externalId
    uri
    metadata
  }
`;
export const ObservationRefFragmentDoc = gql`
  fragment ObservationRef on ObservationsV1Observation {
    __typename
    name
    kind
    summary
    excerpt
    source {
      ...IssueSource
    }
    eventTime
    createTime
    issue {
      ... on ObservationsV1Issue {
        name
      }
      ...DefaultError
    }
  }
  ${IssueSourceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const TaskRefFragmentDoc = gql`
  fragment TaskRef on ObservationsV1Task {
    __typename
    name
    displayName
    state
    blocked
    createTime
  }
`;
export const TaskInputRequestFragmentDoc = gql`
  fragment TaskInputRequest on ObservationsV1InputRequest {
    __typename
    approval {
      __typename
      prompt
    }
    codeReview {
      __typename
      prompt
      pullRequestNumber
      repository
      uri
    }
    direction {
      __typename
      prompt
      options
    }
  }
`;
export const TaskInputResponseFragmentDoc = gql`
  fragment TaskInputResponse on ObservationsV1InputResponse {
    __typename
    approval {
      __typename
      approved
      comment
    }
    codeReview {
      __typename
      approved
      comment
    }
    direction {
      __typename
      choice
    }
  }
`;
export const TaskFragmentDoc = gql`
  fragment Task on ObservationsV1Task {
    ...TaskRef
    resource
    updateTime
    plan {
      ... on CollaborationV1CollaborativeDocument {
        __typename
        name
        markdown
      }
      ...DefaultError
    }
    inputRequest {
      ...TaskInputRequest
    }
    inputResponse {
      ...TaskInputResponse
    }
    dependencies {
      ... on ObservationsV1Task {
        ...TaskRef
      }
      ...DefaultError
    }
  }
  ${TaskRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${TaskInputRequestFragmentDoc}
  ${TaskInputResponseFragmentDoc}
`;
export const ThemeFragmentDoc = gql`
  fragment Theme on ObservationsV1Theme {
    ...ThemeRef
    state
    chat {
      ...ChatRef
      ...DefaultError
    }
    createTime
    updateTime
    issueCount
    labels {
      key
      value
    }
    description {
      ...CollaborativeDocumentRef
      ...DefaultError
    }
  }
  ${ThemeRefFragmentDoc}
  ${ChatRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${CollaborativeDocumentRefFragmentDoc}
`;
export const IssueIndexPageIssueFragmentDoc = gql`
  fragment IssueIndexPageIssue on ObservationsV1Issue {
    ...IssueRef
    state
    kind
    status
    closeReason
    snoozedUntilTime
    confidenceScore
    createTime
    updateTime
    assignee {
      ...IdentityRef
      ...DefaultError
    }
    surfaces {
      ...SurfaceRef
      ...DefaultError
    }
    driver {
      ... on ConversationsV2Chat {
        __typename
        name
        state
      }
      ...DefaultError
    }
    tasks {
      ... on ObservationsV1ListTasksResponse {
        __typename
        tasks {
          ...TaskRef
          inputRequest {
            approval {
              __typename
            }
            codeReview {
              __typename
            }
            direction {
              __typename
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${IssueRefFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${SurfaceRefFragmentDoc}
  ${TaskRefFragmentDoc}
`;
export const AssignmentTableRefFragmentDoc = gql`
  fragment AssignmentTableRef on MetricsV1AssignmentTable {
    __typename
    displayName
    name
    state
    deleteTime
    error {
      message
      details
    }
  }
`;
export const AssignmentTableFragmentDoc = gql`
  fragment AssignmentTable on MetricsV1AssignmentTable {
    __typename
    name
    displayName
    description
    deleteTime
    timestampColumn {
      name
    }
    state
    owner {
      ...IdentityRef
      ...DefaultError
    }
    entityColumn {
      name
    }
    exposureKeyColumn {
      name
    }
    variantKeyColumn {
      name
    }
    schemaValidationJob {
      ... on MetricsV1SqlJob {
        __typename
        name
      }
      ...DefaultError
    }
    sql
    dataDeliveredUntilUpdateStrategyConfig {
      ...DataDeliveredUntilUpdateStrategyConfig
    }
    assignmentDataDeliveredUntilTime
    error {
      ...MetricsTableError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
    dimensions {
      name
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
`;
export const DataWarehouseRefFragmentDoc = gql`
  fragment DataWarehouseRef on MetricsV1DataWarehouse {
    __typename
    name
    isPrimary
    deleteTime
    config {
      bigQueryConfig {
        gcpProjectId
      }
      dataBricksConfig {
        host
      }
      snowflakeConfig {
        account
      }
      redshiftConfig {
        cluster
      }
    }
  }
`;
export const AssignmentTableWithWarehouseFragmentDoc = gql`
  fragment AssignmentTableWithWarehouse on MetricsV1AssignmentTable {
    ...AssignmentTable
    dataWarehouse {
      ... on MetricsV1DataWarehouse {
        ...DataWarehouseRef
      }
      ...DefaultError
    }
  }
  ${AssignmentTableFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const DimensionTableWithWarehouseFragmentDoc = gql`
  fragment DimensionTableWithWarehouse on MetricsV1DimensionTable {
    ...DimensionTable
    dataWarehouse {
      ... on MetricsV1DataWarehouse {
        ...DataWarehouseRef
      }
      ...DefaultError
    }
  }
  ${DimensionTableFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const FactTableOptionFragmentDoc = gql`
  fragment FactTableOption on MetricsV1FactTable {
    displayName
    name
    entities {
      entity {
        ... on MetricsV1Entity {
          __typename
          displayName
          name
        }
        ...DefaultError
      }
    }
    measures {
      column {
        name
        type
      }
    }
    state
    error {
      message
      details
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const FactTableWithWarehouseFragmentDoc = gql`
  fragment FactTableWithWarehouse on MetricsV1FactTable {
    ...FactTable
    dataWarehouse {
      ... on MetricsV1DataWarehouse {
        ...DataWarehouseRef
      }
      ...DefaultError
    }
  }
  ${FactTableFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MeasurementRefFragmentDoc = gql`
  fragment MeasurementRef on MetricsV1Measurement {
    __typename
    name
    displayName
  }
`;
export const MetricPickerFragmentDoc = gql`
  fragment MetricPicker on MetricsV1Metric {
    name
    displayName
    description
    state
    owner {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    entity {
      ... on MetricsV1Entity {
        __typename
        displayName
        name
      }
      ...DefaultError
    }
    factTable {
      ...FactTableRef
      ...DefaultError
    }
    measurementConfig {
      closedWindow {
        aggregationWindow
        exposureOffset
      }
      openWindow {
        dummy
      }
      semiOpenWindow {
        aggregationWindow
        exposureOffset
      }
    }
    typeSpec {
      averageMetricSpec {
        __typename
      }
      ratioMetricSpec {
        __typename
      }
      quantileMetricSpec {
        quantileLevel
      }
    }
    labels {
      value
      key
    }
    preferredDirection
    defaultEffectSize {
      value
    }
    varianceReductionConfig {
      disabled
    }
    nullHandling {
      replaceEntityNullWithZero
    }
    source {
      type
    }
    verification {
      state
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
`;
export const PartitionFragmentDoc = gql`
  fragment Partition on MetricsV1Partition {
    __typename
    name
    startTime
    endTime
    createTime
  }
`;
export const PartitionedUpdateStrategyStateFragmentDoc = gql`
  fragment PartitionedUpdateStrategyState on MetricsV1PartitionedUpdateStrategyState {
    currentPartitionLastCheckTime
    existsCheckDuration
    state
    usualLateness
  }
`;
export const DependencyFragmentDoc = gql`
  fragment Dependency on MetricsV1Dependency {
    name
    parent {
      ... on MetricsV1Dependency {
        __typename
        name
      }
    }
    table {
      assignments {
        assignmentTable {
          ... on MetricsV1AssignmentTable {
            __typename
            name
            displayName
            dataDeliveredUntilUpdateStrategyConfig {
              ...DataDeliveredUntilUpdateStrategyConfig
            }
            partitionedUpdateStrategyState {
              ...PartitionedUpdateStrategyState
            }
          }
          ...DefaultError
        }
      }
      dimensions {
        dimensionTable {
          ... on MetricsV1DimensionTable {
            __typename
            name
            displayName
            state
            dataDeliveredUntilUpdateStrategyConfig {
              ...DataDeliveredUntilUpdateStrategyConfig
            }
            partitionedUpdateStrategyState {
              ...PartitionedUpdateStrategyState
            }
          }
        }
      }
      entityRelation {
        entityRelationTable {
          ... on MetricsV1EntityRelationTable {
            __typename
            name
            state
          }
        }
      }
      exposures {
        exposureTable {
          ... on MetricsV1ExposureTable {
            __typename
            name
            state
          }
        }
        scheduledExposureCalculation {
          ... on MetricsV1ScheduledExposureCalculation {
            __typename
            name
            status {
              ...ScheduledExposureCalculationStatus
            }
            state
          }
        }
      }
      facts {
        factTable {
          ... on MetricsV1FactTable {
            __typename
            name
            displayName
            dataDeliveredUntilUpdateStrategyConfig {
              ...DataDeliveredUntilUpdateStrategyConfig
            }
            partitionedUpdateStrategyState {
              ...PartitionedUpdateStrategyState
            }
          }
        }
      }
      measurements {
        measurementTable {
          ... on MetricsV1MeasurementTable {
            __typename
            name
            state
          }
        }
        scheduledMeasurementCalculation {
          ... on MetricsV1ScheduledMeasurementCalculation {
            __typename
            name
            status {
              calculating {
                __typename
              }
              cancelled {
                cancelledTime
              }
              error {
                errorMessage
              }
              waiting {
                __typename
                needDataUntilTime
              }
              scheduled {
                nextScheduleTime
              }
            }
            state
          }
        }
      }
    }
    dataStatus {
      startTime
      endTime
      fulfilled
    }
  }
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${PartitionedUpdateStrategyStateFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ScheduledExposureCalculationStatusFragmentDoc}
`;
export const ExposureCalculationFragmentDoc = gql`
  fragment ExposureCalculation on MetricsV1ExposureCalculation {
    name
    scheduleIteration
    startTime
    endTime
    state
    sql
    sqlJob {
      ... on MetricsV1SqlJob {
        __typename
        createTime
        updateTime
        name
        state
        labels {
          key
          value
        }
        failedQueryResult {
          error
        }
      }
      ...DefaultError
    }
    createTime
    updateTime
  }
  ${DefaultErrorFragmentDoc}
`;
export const MeasurementCalculationFragmentDoc = gql`
  fragment MeasurementCalculation on MetricsV1MeasurementCalculation {
    name
    startTime
    endTime
    state
    sql
    scheduleIteration
    sqlJob {
      ... on MetricsV1SqlJob {
        name
        createTime
        updateTime
        state
        labels {
          key
          value
        }
        failedQueryResult {
          error
        }
        __typename
      }
      ...DefaultError
    }
    supersededBy {
      ... on MetricsV1MeasurementCalculation {
        name
        __typename
      }
      ...DefaultError
    }
    createTime
    updateTime
    times {
      exposureEndTime
      exposureStartTime
      factEndTime
      factStartTime
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const MeasurementDetailsFragmentDoc = gql`
  fragment MeasurementDetails on MetricsV1Measurement {
    __typename
    displayName
    name
    description
    owner {
      ... on IamV1Identity {
        __typename
        displayName
        name
        everyone
        user {
          ... on IamV1User {
            pictureUri
            name
          }
        }
        group {
          ... on IamV1Group {
            name
          }
        }
        apiClient {
          ... on IamV1ApiClient {
            name
          }
        }
      }
      ...DefaultError
    }
    factTable {
      ...FactTableRef
      ...DefaultError
    }
    filter {
      ...MetricFilter
    }
    entity {
      ... on MetricsV1Entity {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
    nullHandling {
      replaceEntityNullWithZero
    }
    typeSpec {
      ratioMetricSpec {
        numerator {
          name
        }
        numeratorAggregation {
          type
          threshold {
            direction
            threshold {
              value
            }
          }
          cap {
            min {
              value
            }
            max {
              value
            }
          }
        }
        numeratorFilter {
          ...MetricFilter
        }
        denominator {
          name
        }
        denominatorAggregation {
          type
          threshold {
            direction
            threshold {
              value
            }
          }
          cap {
            min {
              value
            }
            max {
              value
            }
          }
        }
        denominatorFilter {
          ...MetricFilter
        }
      }
      averageMetricSpec {
        measurement {
          name
          type
        }
        aggregation {
          type
          threshold {
            direction
            threshold {
              value
            }
          }
          cap {
            min {
              value
            }
            max {
              value
            }
          }
        }
      }
      quantileMetricSpec {
        quantileLevel
        measurement {
          name
          type
        }
        aggregation {
          type
          threshold {
            direction
            threshold {
              value
            }
          }
          cap {
            min {
              value
            }
            max {
              value
            }
          }
        }
      }
    }
    source {
      type
      reference
    }
    labels {
      key
      value
    }
    deleteTime
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
  ${MetricFilterFragmentDoc}
`;
export const MeasurementListItemFragmentDoc = gql`
  fragment MeasurementListItem on MetricsV1Measurement {
    name
    displayName
    description
    owner {
      __typename
      ... on IamV1Identity {
        ...IdentityRef
      }
      ...DefaultError
    }
    entity {
      ... on MetricsV1Entity {
        __typename
        displayName
        name
      }
      ...DefaultError
    }
    factTable {
      ...FactTableRef
      ...DefaultError
    }
    labels {
      key
      value
    }
    typeSpec {
      averageMetricSpec {
        aggregation {
          type
        }
      }
      ratioMetricSpec {
        numeratorAggregation {
          type
        }
      }
      quantileMetricSpec {
        quantileLevel
        aggregation {
          type
        }
      }
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
`;
export const MeasurementConfigFieldsFragmentDoc = gql`
  fragment MeasurementConfigFields on MetricsV1MetricMeasurementConfig {
    closedWindow {
      aggregationWindow
      exposureOffset
    }
    semiOpenWindow {
      aggregationWindow
      exposureOffset
    }
    openWindow {
      dummy
    }
  }
`;
export const MeasurementPageMetricFragmentDoc = gql`
  fragment MeasurementPageMetric on MetricsV1Metric {
    __typename
    name
    displayName
    deleteTime
    state
    labels {
      key
      value
    }
    measurementConfig {
      ...MeasurementConfigFields
    }
    owner {
      __typename
      ... on IamV1Identity {
        ...IdentityRef
      }
      ...DefaultError
    }
  }
  ${MeasurementConfigFieldsFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MetricFragmentDoc = gql`
  fragment Metric on MetricsV1Metric {
    name
    displayName
    description
    owner {
      __typename
      ... on IamV1Identity {
        ...IdentityRef
      }
      ...DefaultError
    }
    entity {
      ... on MetricsV1Entity {
        __typename
        displayName
        name
      }
      ...DefaultError
    }
    factTable {
      ...FactTableRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
`;
export const MetricAssignmentTableFragmentDoc = gql`
  fragment MetricAssignmentTable on MetricsV1AssignmentTable {
    displayName
    name
    state
    error {
      message
      details
    }
  }
`;
export const MetricCalculationFragmentDoc = gql`
  fragment MetricCalculation on MetricsV1MetricCalculation {
    name
    startTime
    endTime
    state
    sql
    scheduleIteration
    sqlJob {
      ... on MetricsV1SqlJob {
        name
        createTime
        updateTime
        state
        labels {
          key
          value
        }
        failedQueryResult {
          error
        }
        __typename
      }
      ...DefaultError
    }
    metricResults {
      metricBucketStats {
        summaryStats {
          ratioSummaryStats {
            count
            numeratorMean
            numeratorVariance
            denominatorMean
            denominatorVariance
            countMissing
          }
          averageSummaryStats {
            count
            mean
            variance
            countMissing
          }
        }
        dimensions {
          value
          dimension
        }
        variant
      }
    }
    supersededBy {
      ... on MetricsV1MetricCalculation {
        name
        __typename
      }
      ...DefaultError
    }
    createTime
    updateTime
    times {
      exposureEndTime
      exposureStartTime
      factEndTime
      factStartTime
    }
    outdatedSourceDataInfo {
      actualCount
      expectedCount
      queryEndTime
      queryStartTime
      table
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const MetricDialogEntityRelationTableFragmentFragmentDoc = gql`
  fragment MetricDialogEntityRelationTableFragment on MetricsV1EntityRelationTable {
    name
    targetEntity {
      ... on MetricsV1Entity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const MetricEntityFragmentDoc = gql`
  fragment MetricEntity on MetricsV1Entity {
    primaryKeyType
    displayName
    name
  }
`;
export const MetricPreviewCalculationFragmentDoc = gql`
  fragment MetricPreviewCalculation on MetricsV1MetricCalculation {
    __typename
    name
    createTime
    creator {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    error
    labels {
      key
      value
    }
    metricResults {
      metricBucketStats {
        dimensions {
          value
          dimension
        }
        summaryStats {
          averageSummaryStats {
            mean
            variance
            count
            countMissing
          }
          ratioSummaryStats {
            count
            numeratorMean
            numeratorVariance
            denominatorMean
            denominatorVariance
            countMissing
          }
        }
        variant
      }
    }
    sql
    sqlJob {
      ... on MetricsV1SqlJob {
        __typename
        failedQueryResult {
          error
        }
        pendingQueryResult {
          dummy
        }
        state
        successfulQueryResult {
          schema {
            name
            type
            repeated
          }
          issues {
            message
            name
          }
        }
      }
      ...DefaultError
    }
    state
    endTime
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const MetricRowFragmentDoc = gql`
  fragment MetricRow on MetricsV1MetricRow {
    dimensions {
      key
      value
    }
    aggCount
    value {
      averageSummaryStats {
        mean
        variance
        count
        countMissing
        summaryStatsInfo {
          min
          max
          countZeroes
        }
      }
      ratioSummaryStats {
        numeratorMean
        numeratorVariance
        denominatorMean
        denominatorVariance
        numeratorDenominatorCovariance
        count
        countMissing
        numeratorSummaryStatsInfo {
          min
          max
          countZeroes
        }
        denominatorSummaryStatsInfo {
          min
          max
          countZeroes
        }
      }
    }
  }
`;
export const MetricUsageWorkflowInstanceFragmentDoc = gql`
  fragment MetricUsageWorkflowInstance on WorkflowV1WorkflowInstance {
    state
    displayName
    name
    checks {
      message
      name
      state
      updateTime
      labels {
        key
        value
      }
    }
    moduleData {
      key
      value
    }
    moduleData2 {
      metrics {
        metrics {
          __typename
          preferredDirection
        }
      }
    }
  }
`;
export const MetricsListMeasurementFragmentDoc = gql`
  fragment MetricsListMeasurement on MetricsV1Measurement {
    name
    displayName
    entity {
      ... on MetricsV1Entity {
        __typename
        displayName
        name
      }
      ...DefaultError
    }
    factTable {
      ... on MetricsV1FactTable {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
    typeSpec {
      averageMetricSpec {
        __typename
      }
      ratioMetricSpec {
        __typename
      }
      quantileMetricSpec {
        quantileLevel
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const ProcessRoundLogFragmentDoc = gql`
  fragment ProcessRoundLog on MetricsV1ProcessRoundLog {
    __typename
    name
    createTime
    partition {
      partitionTime
      partitionArrivesLater {
        expectedArrivalTime
      }
      partitionNotCommitted {
        noCommitReason
      }
      partitionCommitted {
        count
        maxWaitTimeReached
      }
      partitionError {
        message
      }
    }
    timestamp {
      currentDataDeliveredUntilTime
      newDataDeliveredUntilTime
      dataCommitted {
        count
      }
      dataPendingCommit {
        previousCount
        currentCount
        noCommitReason
        newDataDeliveredUntil
      }
      dataError {
        message
      }
    }
    verificationState
    error
  }
`;
export const RetriggerFragmentDoc = gql`
  fragment Retrigger on MetricsV1Retrigger {
    __typename
    name
    creator {
      __typename
      ...IdentityRef
      ...DefaultError
    }
    createTime
    completeTime
    currentTime
    targetTime
    updateTime
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ScheduledExposureCalculationFragmentDoc = gql`
  fragment ScheduledExposureCalculation on MetricsV1ScheduledExposureCalculation {
    __typename
    iteration
    name
    status {
      ...ScheduledExposureCalculationStatus
    }
    exposureCalculationSpec {
      ... on MetricsV1ExposureCalculationSpec {
        assignmentTable {
          ... on MetricsV1AssignmentTable {
            __typename
            name
            displayName
            dataDeliveredUntilUpdateStrategyConfig {
              ...DataDeliveredUntilUpdateStrategyConfig
            }
          }
          ...DefaultError
        }
      }
    }
    exposedEntitiesMetricSchedule {
      ... on MetricsV1ScheduledMetricCalculation {
        __typename
        name
      }
      ...DefaultError
    }
    activeRetrigger {
      ...Retrigger
      ...DefaultError
    }
    scheduleIntervals
    scheduleStartTime
    scheduleEndTime
    nextAssignmentStartTime
    nextAssignmentEndTime
    nextScheduledRunTime
    executedCalculationsCount
    labels {
      key
      value
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
  }
  ${ScheduledExposureCalculationStatusFragmentDoc}
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${RetriggerFragmentDoc}
`;
export const MeasurementScheduleStatusFragmentDoc = gql`
  fragment MeasurementScheduleStatus on MetricsV1ScheduledMeasurementCalculationStatus {
    scheduled {
      nextScheduleTime
    }
    cancelled {
      cancelledTime
    }
    calculating {
      measurementCalculation {
        ... on MetricsV1MeasurementCalculation {
          name
        }
      }
    }
    waiting {
      dataDeliveredUntilTime
      needDataUntilTime
      exposureTable {
        ... on MetricsV1ExposureTable {
          name
        }
      }
      factTable {
        ...FactTableRef
      }
    }
    error {
      errorMessage
    }
  }
  ${FactTableRefFragmentDoc}
`;
export const ScheduledMeasurementCalculationFragmentDoc = gql`
  fragment ScheduledMeasurementCalculation on MetricsV1ScheduledMeasurementCalculation {
    __typename
    name
    state
    status {
      ...MeasurementScheduleStatus
    }
    measurementCalculationSpec {
      metric {
        ... on MetricsV1Metric {
          __typename
          name
          displayName
          nullHandling {
            replaceEntityNullWithZero
            __typename
          }
          measurementConfig {
            closedWindow {
              __typename
              aggregationWindow
              exposureOffset
            }
            semiOpenWindow {
              __typename
              aggregationWindow
              exposureOffset
            }
            openWindow {
              __typename
            }
          }
          factTable {
            ... on MetricsV1FactTable {
              __typename
              name
              displayName
              dataDeliveredUntilUpdateStrategyConfig {
                ...DataDeliveredUntilUpdateStrategyConfig
              }
              partitionedUpdateStrategyState {
                currentPartitionLastCheckTime
                existsCheckDuration
                state
                usualLateness
              }
            }
            ...DefaultError
          }
        }
        ...DefaultError
      }
      exposureTable {
        ... on MetricsV1ExposureTable {
          __typename
          scheduledExposureCalculation {
            ... on MetricsV1ScheduledExposureCalculation {
              __typename
              name
              exposureCalculationSpec {
                ... on MetricsV1ExposureCalculationSpec {
                  __typename
                  assignmentTable {
                    ... on MetricsV1AssignmentTable {
                      __typename
                      name
                      dataDeliveredUntilUpdateStrategyConfig {
                        ...DataDeliveredUntilUpdateStrategyConfig
                      }
                    }
                    ...DefaultError
                  }
                }
              }
              status {
                ...ScheduledExposureCalculationStatus
              }
            }
          }
        }
      }
    }
    nextScheduledRunTime
    nextExposureStartTime
    nextExposureEndTime
    scheduleStartTime
    scheduleEndTime
    iteration
    scheduleIntervals
    executedCalculationsCount
    activeRetrigger {
      ...Retrigger
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
  }
  ${MeasurementScheduleStatusFragmentDoc}
  ${DataDeliveredUntilUpdateStrategyConfigFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ScheduledExposureCalculationStatusFragmentDoc}
  ${RetriggerFragmentDoc}
`;
export const ScheduledMetricCalculationFragmentDoc = gql`
  fragment ScheduledMetricCalculation on MetricsV1ScheduledMetricCalculation {
    __typename
    name
    state
    status {
      ...ScheduledMetricCalculationStatus
    }
    metricCalculationSpec {
      ...MetricCalculationSpec
    }
    nextScheduledRunTime
    nextExposureStartTime
    nextExposureEndTime
    scheduleStartTime
    scheduleEndTime
    iteration
    scheduleIntervals
    executedCalculationsCount
    activeRetrigger {
      ...Retrigger
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          relation
          resource
        }
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
  }
  ${ScheduledMetricCalculationStatusFragmentDoc}
  ${MetricCalculationSpecFragmentDoc}
  ${RetriggerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SelectableMetricFragmentDoc = gql`
  fragment SelectableMetric on MetricsV1Metric {
    name
    displayName
    entity {
      ... on MetricsV1Entity {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
    preferredDirection
    defaultEffectSize {
      value
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const WorkflowInstanceExposureDetailsFragmentDoc = gql`
  fragment WorkflowInstanceExposureDetails on WorkflowV1WorkflowInstance {
    name
    state
    moduleData {
      key
      value
    }
    stateHistory {
      enteredTime
      exitedTime
      state
    }
  }
`;
export const TourPreferencesFragmentDoc = gql`
  fragment TourPreferences on OnboardingV1TourPreferences {
    __typename
    featureFlagsStatus
    rolloutsStatus
    abTestsStatus
    dismissed
  }
`;
export const ResourcePermissionFragmentDoc = gql`
  fragment ResourcePermission on FgaV1ResourcePermission {
    name
    resource
    resourcePermission
    identity {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const ProjectFragmentDoc = gql`
  fragment Project on CollaborationV1Project {
    __typename
    name
    displayName
    description
    createTime
    updateTime
    deleteTime
    summary {
      body
      updateTime
    }
    labels {
      key
      value
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    creator {
      ...IdentityRef
      ...DefaultError
    }
    updater {
      ...IdentityRef
      ...DefaultError
    }
    surfaces {
      ...SurfaceRef
      ...DefaultError
    }
    initiatives {
      ...InitiativeRef
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${SurfaceRefFragmentDoc}
  ${InitiativeRefFragmentDoc}
`;
export const PromptHookFragmentDoc = gql`
  fragment PromptHook on ConversationsV2PromptHook {
    __typename
    name
    displayName
    enabled
    promptTemplate
    systemCreated
    createTime
    updateTime
    trigger {
      scheduleTrigger {
        cron
        timeZone
      }
      eventTrigger {
        eventType
        filter
      }
    }
    approvedTools {
      tool
    }
    labels {
      key
      value
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    creator {
      ...IdentityRef
      ...DefaultError
    }
    project {
      ...ProjectRef
      ...DefaultError
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${ProjectRefFragmentDoc}
`;
export const ProjectIndexPageProjectFragmentDoc = gql`
  fragment ProjectIndexPageProject on CollaborationV1Project {
    __typename
    name
    displayName
    description
    createTime
    labels {
      key
      value
    }
    owner {
      ... on IamV1Identity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const PulseRefFragmentDoc = gql`
  fragment PulseRef on PulseV1Pulse {
    __typename
    name
    displayName
  }
`;
export const PulseBlockShellFragmentDoc = gql`
  fragment PulseBlockShell on PulseV1PulseBlock {
    __typename
    name
    displayName
    blockType
    state
    error {
      message
    }
    summary
    summaryUpdateTime
    refreshTime
    source {
      sql {
        query
        question
      }
      staticResult {
        dummy
      }
      agent {
        instructions
        tools
      }
    }
    origin {
      conversation
      message
    }
    createTime
    updateTime
    creator {
      ...IdentityRef
      ...DefaultError
    }
    updater {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const PulseFragmentDoc = gql`
  fragment Pulse on PulseV1Pulse {
    ...PulseRef
    projects {
      ...ProjectRef
      ...DefaultError
    }
    summary
    summaryStale
    summaryUpdateTime
    reportingConfig {
      enabled
      slack {
        channel
      }
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    createTime
    updateTime
    creator {
      ...IdentityRef
      ...DefaultError
    }
    updater {
      ...IdentityRef
      ...DefaultError
    }
    blocks {
      ...PulseBlockShell
    }
    layout {
      placements {
        block {
          ... on PulseV1PulseBlock {
            __typename
            name
          }
          ...DefaultError
        }
        x
        y
        width
        height
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${PulseRefFragmentDoc}
  ${ProjectRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${PulseBlockShellFragmentDoc}
`;
export const PulseBlockFragmentDoc = gql`
  fragment PulseBlock on PulseV1PulseBlock {
    __typename
    name
    displayName
    blockType
    state
    error {
      message
    }
    summary
    summaryUpdateTime
    refreshTime
    source {
      sql {
        query
        question
      }
      staticResult {
        dummy
      }
      agent {
        instructions
        tools
      }
    }
    currentResult {
      queryResult {
        visualizationSpec
        resultRef
        resultData
      }
      agentOutput {
        content
      }
      captureTime
    }
    origin {
      conversation
      message
    }
    createTime
    updateTime
    creator {
      ...IdentityRef
      ...DefaultError
    }
    updater {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const PulseChangeFragmentDoc = gql`
  fragment PulseChange on PulseV1PulseChange {
    name
    action
    actor {
      ...IdentityRef
      ...DefaultError
    }
    actionTime
    target
    description
    systemInitiated
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const PulseIndexPagePulseFragmentDoc = gql`
  fragment PulseIndexPagePulse on PulseV1Pulse {
    ...PulseRef
    projects {
      ...ProjectRef
      ...DefaultError
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    updateTime
  }
  ${PulseRefFragmentDoc}
  ${ProjectRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
`;
export const FindingIssueObservationFragmentDoc = gql`
  fragment FindingIssueObservation on ObservationsV1Observation {
    name
    source {
      externalId
    }
    issue {
      __typename
      ... on ObservationsV1Issue {
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const RecordingRefFragmentDoc = gql`
  fragment RecordingRef on RecordingV1Recording {
    __typename
    name
    client
    createTime
    updateTime
    state
    targetingKey
    duration
    displayName
    labels {
      key
      value
    }
    tags {
      key
      value {
        values
      }
    }
    flagEvaluations {
      flag
      variants {
        variant
      }
    }
    metrics {
      key
      value {
        value
      }
    }
    environmentInfo {
      browser
      browserVersion
      city
      devicePixelRatio
      mobile
      os
      osVersion
      regionCode
      screenHeight
      screenWidth
      userAgent
    }
    routing {
      entryPage
      exitPage
      hostname
      routes {
        pageUri
        title
      }
    }
    sdkInfo {
      sdkVersion
      analyzerVersion
      appVersion
    }
  }
`;
export const RecordingFragmentDoc = gql`
  fragment Recording on RecordingV1Recording {
    ...RecordingRef
    analysis {
      findings {
        id
        kind
        recordingOffset
        summary
      }
      intent
      summary
    }
    downloadRecording {
      ... on RecordingV1DownloadRecordingResponse {
        __typename
        downloadUri
      }
      ...DefaultError
    }
  }
  ${RecordingRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const RecordingRuleFragmentDoc = gql`
  fragment RecordingRule on RecordingV1RecordingRule {
    __typename
    name
    enabled
    order
    sessionSampleRate
    targetingKeySelector
    createTime
    updateTime
    segment {
      ... on FlagsAdminV1Segment {
        __typename
        name
        displayName
        state
        allocation {
          ...Allocation
        }
        targeting {
          ...Targeting
        }
        workflowInstance {
          ... on WorkflowV1WorkflowInstance {
            __typename
            name
            displayName
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
    environments {
      ... on FlagsAdminV1Environment {
        __typename
        name
        color
      }
      ...DefaultError
    }
    labels {
      key
      value
    }
    creator {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${AllocationFragmentDoc}
  ${TargetingFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
`;
export const RecordingPolicyFragmentDoc = gql`
  fragment RecordingPolicy on RecordingV1RecordingPolicy {
    __typename
    name
    displayName
    clients {
      ... on IamV1Client {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
    recordingRules {
      ... on RecordingV1ListRecordingRulesResponse {
        __typename
        recordingRules {
          ...RecordingRule
        }
      }
      ...DefaultError
    }
    createTime
    updateTime
  }
  ${DefaultErrorFragmentDoc}
  ${RecordingRuleFragmentDoc}
`;
export const CollaborationReviewResponseFragmentDoc = gql`
  fragment CollaborationReviewResponse on CollaborationV1ListReviewResponsesResponse {
    __typename
    reviewResponses {
      name
      comment {
        __typename
        ...Comment
        ...DefaultError
      }
    }
  }
  ${CommentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const AppUserFragmentDoc = gql`
  fragment AppUser on IamV1User {
    name
    fullName
    email
    pictureUri
    lastLoginTime
    identity {
      __typename
      ... on IamV1Identity {
        name
        displayName
      }
      ...DefaultError
    }
    __typename
  }
  ${DefaultErrorFragmentDoc}
`;
export const AppGroupFragmentDoc = gql`
  fragment AppGroup on IamV1Group {
    __typename
    name
    displayName
    description
    groupType
    createTime
    updateTime
  }
`;
export const AppIdentityFragmentDoc = gql`
  fragment AppIdentity on IamV1Identity {
    name
    displayName
    user {
      ...AppUser
      ...DefaultError
    }
    group {
      ...AppGroup
      ...DefaultError
    }
    everyone
    __typename
  }
  ${AppUserFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${AppGroupFragmentDoc}
`;
export const ActivityFeedFragmentDoc = gql`
  fragment ActivityFeed on ActivityV1Feed {
    __typename
    channels {
      email {
        address
      }
      slack {
        channel
        user
        team
      }
      priority
      disabled
      activityTypes {
        ... on ActivityV1ActivityType {
          name
          displayName
        }
      }
    }
    name
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const AiWorkflowTriggerFragmentDoc = gql`
  fragment AiWorkflowTrigger on AiworkflowsV1AiWorkflowTrigger {
    __typename
    name
    filterType
    filterName
    createTime
    updateTime
    action {
      executeFunctionAction {
        function
        parameters
      }
      transitionWorkflowAction {
        action
        parameters
      }
    }
    trigger {
      stateTrigger {
        state
      }
      activityTrigger {
        kind
        resource
      }
      dashboardAlertTrigger {
        alertState
        condition {
          comparator
          thresholdValue
        }
        graphType
        labelFilters {
          key
          value
        }
        lastChecked
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export const HoldbackFragmentDoc = gql`
  fragment Holdback on WorkflowV1Holdback {
    __typename
    name
    displayName
    description
    owner {
      ...IdentityRef
    }
    mode
    allocation {
      value
    }
    segment {
      ...Segment
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SegmentRefFragmentDoc = gql`
  fragment SegmentRef on FlagsAdminV1Segment {
    __typename
    name
    displayName
  }
`;
export const SpaceAvailabilitySegmentFragmentDoc = gql`
  fragment SpaceAvailabilitySegment on FlagsAdminV1Segment {
    ...SegmentRef
    state
    allocation {
      ...Allocation
    }
    labels {
      key
      value
    }
    workflowInstance {
      ... on WorkflowV1WorkflowInstance {
        name
        displayName
        moduleData2 {
          planning {
            planned {
              startTime
              endTime
            }
            actual {
              startTime
              endTime
            }
          }
        }
      }
    }
  }
  ${SegmentRefFragmentDoc}
  ${AllocationFragmentDoc}
`;
export const SurfaceIdentityBindingFragmentDoc = gql`
  fragment SurfaceIdentityBinding on WorkflowV1SurfaceIdentityBinding {
    __typename
    name
    identity {
      ...IdentityRef
      ...DefaultError
    }
    enforcementLevel
    createTime
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SurfaceFragmentDoc = gql`
  fragment Surface on WorkflowV1Surface {
    __typename
    name
    displayName
    description
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
    reviews {
      mandatory
      reviewers {
        ...IdentityRef
        ...DefaultError
      }
    }
    stakeholders {
      role
      identity {
        ...IdentityRef
        ...DefaultError
      }
    }
    resourceRelations {
      ... on FgaV1ListResourceRelationsResponse {
        __typename
        resourceRelations {
          ... on FgaV1ResourceRelation {
            relation
            resource
          }
        }
      }
      ...DefaultError
    }
    automatedActions {
      ...AutomatedAction
    }
    labels {
      key
      value
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${AutomatedActionFragmentDoc}
`;
export const SurfaceMetricDetailsFragmentDoc = gql`
  fragment SurfaceMetricDetails on MetricsV1Metric {
    name
    displayName
    preferredDirection
    entity {
      ...EntityRef
      ...DefaultError
    }
  }
  ${EntityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SurfaceMetricsFragmentDoc = gql`
  fragment SurfaceMetrics on WorkflowV1SurfaceMetricConfig {
    metrics {
      metric {
        ...SurfaceMetricDetails
        ...DefaultError
      }
      enforcementLevel
      preferredDirection
      guardrailMetric {
        nonInferiorityMargin {
          value
        }
      }
      successMetric {
        minimumDetectableEffect {
          value
        }
      }
    }
    monitoringMetrics {
      metric {
        ...SurfaceMetricDetails
        ...DefaultError
      }
      preferredDirection
    }
  }
  ${SurfaceMetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const SurfaceWithMetricsFragmentDoc = gql`
  fragment SurfaceWithMetrics on WorkflowV1Surface {
    ...Surface
    metricConfig {
      ...SurfaceMetrics
    }
  }
  ${SurfaceFragmentDoc}
  ${SurfaceMetricsFragmentDoc}
`;
export const ExclusivityGroupFragmentDoc = gql`
  fragment ExclusivityGroup on WorkflowV1ExclusivityGroup {
    __typename
    description
    mode
    name
  }
`;
export const SurfaceIndexPageSurfaceFragmentDoc = gql`
  fragment SurfaceIndexPageSurface on WorkflowV1Surface {
    ...SurfaceRef
    updateTime
    owner {
      ...IdentityRef
      ...DefaultError
    }
  }
  ${SurfaceRefFragmentDoc}
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export const AaTestOnboardingFragmentDoc = gql`
  fragment AaTestOnboarding on WorkflowV1WorkflowInstance {
    displayName
    state
    name
    createTime
    updateTime
    labels {
      key
      value
    }
    owner {
      ... on IamV1Identity {
        __typename
        name
        displayName
        pictureUri
      }
    }
    moduleData2 {
      abtest {
        treatments {
          name
        }
      }
      flags {
        segment {
          __typename
          ... on FlagsAdminV1Segment {
            name
          }
        }
        targetingKeySelector
      }
      metrics {
        metrics {
          __typename
        }
        entity {
          __typename
          ... on MetricsV1Entity {
            name
          }
        }
      }
      hypothesis {
        text
      }
    }
  }
`;
export const AbTestFragmentDoc = gql`
  fragment AbTest on WorkflowV1WorkflowInstance {
    ...WorkflowInstance
    comments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListCommentsResponse {
        comments {
          __typename
          ...Comment
        }
        nextPageToken
      }
    }
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
    moduleData2 {
      abtest {
        ...AbTestData
      }
      flags {
        ...FlagsData
      }
      hypothesis {
        ...HypothesisData
      }
      decision {
        ...DecisionData
      }
      reviews {
        ...WorkflowReviews
      }
      planning {
        ...PlanningData
      }
      samplesize {
        ...SampleSizeData
      }
      metrics {
        ...MetricsData
      }
      stats {
        ...StatsData
      }
      explore {
        ...ExploreData
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${CommentFragmentDoc}
  ${AttachmentFragmentDoc}
  ${AbTestDataFragmentDoc}
  ${FlagsDataFragmentDoc}
  ${HypothesisDataFragmentDoc}
  ${DecisionDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${SampleSizeDataFragmentDoc}
  ${MetricsDataFragmentDoc}
  ${StatsDataFragmentDoc}
  ${ExploreDataFragmentDoc}
`;
export const WorkflowInstanceListItemFragmentDoc = gql`
  fragment WorkflowInstanceListItem on WorkflowV1WorkflowInstance {
    displayName
    state
    name
    createTime
    updateTime
    labels {
      key
      value
    }
    owner {
      ... on IamV1Identity {
        __typename
        name
        displayName
      }
    }
    checks {
      ...WorkflowInstanceCheck
    }
    comments(pageSize: 100, filter: "resolved:false") {
      __typename
      ... on CollaborationV1ListCommentsResponse {
        comments {
          name
          resolved
          assignee {
            __typename
            ... on IamV1Identity {
              name
            }
          }
        }
      }
    }
    pendingTransition {
      ...PendingTransition
    }
    moduleData {
      value
      key
    }
    moduleData2 {
      planning {
        ...PlanningData
      }
      reviews {
        ...WorkflowReviews
      }
      rollout {
        ...RolloutData
      }
      decision {
        outcome
      }
    }
  }
  ${WorkflowInstanceCheckFragmentDoc}
  ${PendingTransitionFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${RolloutDataFragmentDoc}
`;
export const AbTestListItemFragmentDoc = gql`
  fragment AbTestListItem on WorkflowV1WorkflowInstance {
    ...WorkflowInstanceListItem
    stateHistory {
      state
    }
    moduleData2 {
      decision {
        outcome
      }
    }
  }
  ${WorkflowInstanceListItemFragmentDoc}
`;
export const ExploratoryAnalysisFunctionResponseFragmentDoc = gql`
  fragment ExploratoryAnalysisFunctionResponse on WorkflowV1ExecuteFunctionResponse {
    __typename
    response
    instance {
      name
      moduleData {
        key
        value
      }
      moduleData2 {
        explore {
          ...ExploreData
        }
      }
    }
  }
  ${ExploreDataFragmentDoc}
`;
export const ReanalysisFragmentDoc = gql`
  fragment Reanalysis on WorkflowV1WorkflowInstance {
    ...WorkflowInstance
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
    moduleData2 {
      planning {
        ...PlanningData
      }
      reviews {
        ...WorkflowReviews
      }
      stats {
        ...StatsData
      }
      explore {
        ...ExploreData
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${AttachmentFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${StatsDataFragmentDoc}
  ${ExploreDataFragmentDoc}
`;
export const ReanalysisListItemFragmentDoc = gql`
  fragment ReanalysisListItem on WorkflowV1WorkflowInstance {
    ...WorkflowInstanceListItem
    stateHistory {
      state
    }
    moduleData2 {
      reanalysis {
        exposureState
        metrics {
          name
          state
        }
      }
      exposure {
        exposure {
          totalExposureCount
        }
      }
    }
  }
  ${WorkflowInstanceListItemFragmentDoc}
`;
export const ReportFragmentDoc = gql`
  fragment Report on ReportData {
    name
    sections {
      ... on ReportDataMetricsSection {
        __typename
        metricsData {
          metrics {
            metricName
            treatments {
              hidden
              treatment
            }
          }
        }
        id
      }
      ... on ReportDataRecommendationSection {
        __typename
        recommendationsData {
          content {
            variant
            shippingRecommendation
            text
            id
          }
        }
        id
      }
      ... on ReportDataResultsSection {
        __typename
        resultsData {
          text
          title
        }
        id
      }
      ... on ReportDataHypothesisSection {
        __typename
        hypothesisData {
          hypothesis
        }
        id
      }
      ... on ReportDataSummarySection {
        __typename
        id
        summaryData {
          imageUri
          text
          title
        }
      }
      ... on ReportDataOutcomeSection {
        __typename
        outcomeData {
          conclusion
          outcome
        }
        id
      }
      ... on ReportDataImagesSection {
        __typename
        imagesData {
          images {
            imageUri
            label
            text
            id
          }
        }
        id
      }
      ... on ReportDataNextSection {
        __typename
        nextData {
          text
          title
        }
        id
      }
    }
  }
`;
export const RolloutFragmentDoc = gql`
  fragment Rollout on WorkflowV1WorkflowInstance {
    ...WorkflowInstance
    attachments(pageSize: 100) {
      __typename
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          __typename
          ...Attachment
        }
        nextPageToken
      }
    }
    moduleData2 {
      rollout {
        ...RolloutData
      }
      flags {
        ...FlagsData
      }
      decision {
        ...DecisionData
      }
      reviews {
        ...WorkflowReviews
      }
      planning {
        ...PlanningData
      }
      stats {
        ...StatsData
      }
      samplesize {
        ...SampleSizeData
      }
      explore {
        ...ExploreData
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${AttachmentFragmentDoc}
  ${RolloutDataFragmentDoc}
  ${FlagsDataFragmentDoc}
  ${DecisionDataFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
  ${PlanningDataFragmentDoc}
  ${StatsDataFragmentDoc}
  ${SampleSizeDataFragmentDoc}
  ${ExploreDataFragmentDoc}
`;
export const RolloutListItemFragmentDoc = gql`
  fragment RolloutListItem on WorkflowV1WorkflowInstance {
    ...WorkflowInstanceListItem
    stateHistory {
      state
    }
    moduleData2 {
      exposure {
        exposure {
          totalExposureCount
        }
      }
      rollout {
        reach
        schedule {
          state
          steps {
            reach
            durationSincePreviousStep
            updateTime
            status
          }
        }
      }
    }
  }
  ${WorkflowInstanceListItemFragmentDoc}
`;
export const PreviousExperimentFragmentDoc = gql`
  fragment PreviousExperiment on WorkflowV1WorkflowInstance {
    name
    displayName
    moduleData2 {
      planning {
        actual {
          endTime
          runtime
          startTime
        }
      }
    }
    owner {
      __typename
      ... on IamV1Identity {
        name
        displayName
      }
    }
  }
`;
export const TransitionStatusFragmentDoc = gql`
  fragment TransitionStatus on WorkflowV1WorkflowInstanceTransitionStatus {
    action
    initiator {
      ... on IamV1Identity {
        name
        displayName
      }
    }
    running {
      ... on WorkflowV1WorkflowInstanceTransitionStatusRunning {
        startTime
      }
    }
    failed {
      ... on WorkflowV1WorkflowInstanceTransitionStatusFailed {
        startTime
        endTime
        error
      }
    }
    completed {
      ... on WorkflowV1WorkflowInstanceTransitionStatusCompleted {
        startTime
        endTime
      }
    }
  }
`;
export const WorkflowEventFragmentDoc = gql`
  fragment WorkflowEvent on ConnectorsV1Event {
    name
    pubsubMetadata {
      consumeTime
      publishTime
    }
    eventType {
      ... on ConnectorsV1EventType {
        name
        description
        persist
      }
    }
    cloudEvent {
      textData
      protoData
      binaryData
      source
      specVersion
    }
  }
`;
export const WorkflowTemplateFragmentDoc = gql`
  fragment WorkflowTemplate on WorkflowV1WorkflowTemplate {
    __typename
    name
    displayName
    description
    createTime
    updateTime
    creator {
      ...IdentityRef
      ...DefaultError
    }
    owner {
      ...IdentityRef
      ...DefaultError
    }
    sourceInstance {
      ...WorkflowInstanceRef
      ...DefaultError
    }
    labels {
      key
      value
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${WorkflowInstanceRefFragmentDoc}
`;
export const GetAccountStateDocument = gql`
  query GetAccountState {
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
        demoData
      }
      ...DefaultError
    }
    currentAccount {
      ... on AdminV1AccountInfo {
        __typename
        mode
        totalConfidenceAccountInfo {
          state
        }
      }
      ...DefaultError
    }
    flags(pageSize: 1, filter: "_exists_:usageMetadata.lastResolveTime") {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          labels {
            value
            key
          }
        }
      }
      ...DefaultError
    }
    eventDefinitions(
      pageSize: 1
      filter: "_exists_:usageMetadata.lastPublishTime"
    ) {
      ... on EventsAdminV1ListEventDefinitionsResponse {
        __typename
        eventDefinitions {
          name
          usageMetadata {
            lastPublishTime
          }
        }
      }
      ...DefaultError
    }
    currentUser {
      ... on IamV1CurrentUser {
        __typename
        identity {
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetAccountStateQuery__
 *
 * To run a query within a React component, call `useGetAccountStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountStateQuery, GetAccountStateQueryVariables>(
    GetAccountStateDocument,
    options,
  );
}
export function useGetAccountStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >(GetAccountStateDocument, options);
}
// @ts-ignore
export function useGetAccountStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAccountStateQuery,
  GetAccountStateQueryVariables
>;
export function useGetAccountStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccountStateQuery,
        GetAccountStateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAccountStateQuery | undefined,
  GetAccountStateQueryVariables
>;
export function useGetAccountStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccountStateQuery,
        GetAccountStateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >(GetAccountStateDocument, options);
}
export type GetAccountStateQueryHookResult = ReturnType<
  typeof useGetAccountStateQuery
>;
export type GetAccountStateLazyQueryHookResult = ReturnType<
  typeof useGetAccountStateLazyQuery
>;
export type GetAccountStateSuspenseQueryHookResult = ReturnType<
  typeof useGetAccountStateSuspenseQuery
>;
export type GetAccountStateQueryResult = Apollo.QueryResult<
  GetAccountStateQuery,
  GetAccountStateQueryVariables
>;
export const GetEventPublishedDocument = gql`
  query GetEventPublished($name: String!) {
    eventDefinition(name: $name) {
      ... on EventsAdminV1EventDefinition {
        __typename
        name
        usageMetadata {
          lastPublishTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetEventPublishedQuery__
 *
 * To run a query within a React component, call `useGetEventPublishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPublishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPublishedQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventPublishedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  > &
    (
      | { variables: GetEventPublishedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
export function useGetEventPublishedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
// @ts-ignore
export function useGetEventPublishedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEventPublishedQuery,
  GetEventPublishedQueryVariables
>;
export function useGetEventPublishedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventPublishedQuery,
        GetEventPublishedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEventPublishedQuery | undefined,
  GetEventPublishedQueryVariables
>;
export function useGetEventPublishedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventPublishedQuery,
        GetEventPublishedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
export type GetEventPublishedQueryHookResult = ReturnType<
  typeof useGetEventPublishedQuery
>;
export type GetEventPublishedLazyQueryHookResult = ReturnType<
  typeof useGetEventPublishedLazyQuery
>;
export type GetEventPublishedSuspenseQueryHookResult = ReturnType<
  typeof useGetEventPublishedSuspenseQuery
>;
export type GetEventPublishedQueryResult = Apollo.QueryResult<
  GetEventPublishedQuery,
  GetEventPublishedQueryVariables
>;
export const GetFlagResolvedDocument = gql`
  query GetFlagResolved($name: String!) {
    flag(name: $name) {
      ... on FlagsAdminV1Flag {
        __typename
        name
        usageMetadata {
          lastApplyTime
          lastResolveTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetFlagResolvedQuery__
 *
 * To run a query within a React component, call `useGetFlagResolvedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlagResolvedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlagResolvedQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFlagResolvedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  > &
    (
      | { variables: GetFlagResolvedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlagResolvedQuery, GetFlagResolvedQueryVariables>(
    GetFlagResolvedDocument,
    options,
  );
}
export function useGetFlagResolvedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >(GetFlagResolvedDocument, options);
}
// @ts-ignore
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFlagResolvedQuery,
  GetFlagResolvedQueryVariables
>;
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagResolvedQuery,
        GetFlagResolvedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFlagResolvedQuery | undefined,
  GetFlagResolvedQueryVariables
>;
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagResolvedQuery,
        GetFlagResolvedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >(GetFlagResolvedDocument, options);
}
export type GetFlagResolvedQueryHookResult = ReturnType<
  typeof useGetFlagResolvedQuery
>;
export type GetFlagResolvedLazyQueryHookResult = ReturnType<
  typeof useGetFlagResolvedLazyQuery
>;
export type GetFlagResolvedSuspenseQueryHookResult = ReturnType<
  typeof useGetFlagResolvedSuspenseQuery
>;
export type GetFlagResolvedQueryResult = Apollo.QueryResult<
  GetFlagResolvedQuery,
  GetFlagResolvedQueryVariables
>;
export const GetOwnedInstancesDocument = gql`
  query GetOwnedInstances(
    $tutorialFilter: String
    $instancesFilter: String
    $accountFilter: String
  ) {
    tutorialInstances: workflowInstances(pageSize: 1, filter: $tutorialFilter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
    accountWorkflowInstances: workflowInstances(
      pageSize: 1
      filter: $accountFilter
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
    workflowInstances(pageSize: 1, filter: $instancesFilter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetOwnedInstancesQuery__
 *
 * To run a query within a React component, call `useGetOwnedInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnedInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnedInstancesQuery({
 *   variables: {
 *      tutorialFilter: // value for 'tutorialFilter'
 *      instancesFilter: // value for 'instancesFilter'
 *      accountFilter: // value for 'accountFilter'
 *   },
 * });
 */
export function useGetOwnedInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
export function useGetOwnedInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
// @ts-ignore
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetOwnedInstancesQuery,
  GetOwnedInstancesQueryVariables
>;
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOwnedInstancesQuery,
        GetOwnedInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetOwnedInstancesQuery | undefined,
  GetOwnedInstancesQueryVariables
>;
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOwnedInstancesQuery,
        GetOwnedInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
export type GetOwnedInstancesQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesQuery
>;
export type GetOwnedInstancesLazyQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesLazyQuery
>;
export type GetOwnedInstancesSuspenseQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesSuspenseQuery
>;
export type GetOwnedInstancesQueryResult = Apollo.QueryResult<
  GetOwnedInstancesQuery,
  GetOwnedInstancesQueryVariables
>;
export const StoreSlackUserInfoDocument = gql`
  mutation StoreSlackUserInfo($code: String!) {
    storeSlackUserInfo(code: $code) {
      ... on IamV1StoreSlackUserInfoResponse {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type StoreSlackUserInfoMutationFn = Apollo.MutationFunction<
  StoreSlackUserInfoMutation,
  StoreSlackUserInfoMutationVariables
>;

/**
 * __useStoreSlackUserInfoMutation__
 *
 * To run a mutation, you first call `useStoreSlackUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSlackUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSlackUserInfoMutation, { data, loading, error }] = useStoreSlackUserInfoMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStoreSlackUserInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StoreSlackUserInfoMutation,
    StoreSlackUserInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StoreSlackUserInfoMutation,
    StoreSlackUserInfoMutationVariables
  >(StoreSlackUserInfoDocument, options);
}
export type StoreSlackUserInfoMutationHookResult = ReturnType<
  typeof useStoreSlackUserInfoMutation
>;
export type StoreSlackUserInfoMutationResult =
  Apollo.MutationResult<StoreSlackUserInfoMutation>;
export type StoreSlackUserInfoMutationOptions = Apollo.BaseMutationOptions<
  StoreSlackUserInfoMutation,
  StoreSlackUserInfoMutationVariables
>;
export const WriteDemoDataDocument = gql`
  mutation WriteDemoData {
    writeDemoData {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type WriteDemoDataMutationFn = Apollo.MutationFunction<
  WriteDemoDataMutation,
  WriteDemoDataMutationVariables
>;

/**
 * __useWriteDemoDataMutation__
 *
 * To run a mutation, you first call `useWriteDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeDemoDataMutation, { data, loading, error }] = useWriteDemoDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useWriteDemoDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteDemoDataMutation,
    WriteDemoDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteDemoDataMutation,
    WriteDemoDataMutationVariables
  >(WriteDemoDataDocument, options);
}
export type WriteDemoDataMutationHookResult = ReturnType<
  typeof useWriteDemoDataMutation
>;
export type WriteDemoDataMutationResult =
  Apollo.MutationResult<WriteDemoDataMutation>;
export type WriteDemoDataMutationOptions = Apollo.BaseMutationOptions<
  WriteDemoDataMutation,
  WriteDemoDataMutationVariables
>;
export const AnalysisResultDocument = gql`
  query AnalysisResult($name: String!) {
    analysisResult(name: $name) {
      ...AnalysisResult
      ...DefaultError
    }
  }
  ${AnalysisResultFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAnalysisResultQuery__
 *
 * To run a query within a React component, call `useAnalysisResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisResultQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAnalysisResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnalysisResultQuery,
    AnalysisResultQueryVariables
  > &
    (
      | { variables: AnalysisResultQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AnalysisResultQuery, AnalysisResultQueryVariables>(
    AnalysisResultDocument,
    options,
  );
}
export function useAnalysisResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnalysisResultQuery,
    AnalysisResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AnalysisResultQuery, AnalysisResultQueryVariables>(
    AnalysisResultDocument,
    options,
  );
}
// @ts-ignore
export function useAnalysisResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AnalysisResultQuery,
    AnalysisResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AnalysisResultQuery,
  AnalysisResultQueryVariables
>;
export function useAnalysisResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnalysisResultQuery,
        AnalysisResultQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AnalysisResultQuery | undefined,
  AnalysisResultQueryVariables
>;
export function useAnalysisResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnalysisResultQuery,
        AnalysisResultQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AnalysisResultQuery,
    AnalysisResultQueryVariables
  >(AnalysisResultDocument, options);
}
export type AnalysisResultQueryHookResult = ReturnType<
  typeof useAnalysisResultQuery
>;
export type AnalysisResultLazyQueryHookResult = ReturnType<
  typeof useAnalysisResultLazyQuery
>;
export type AnalysisResultSuspenseQueryHookResult = ReturnType<
  typeof useAnalysisResultSuspenseQuery
>;
export type AnalysisResultQueryResult = Apollo.QueryResult<
  AnalysisResultQuery,
  AnalysisResultQueryVariables
>;
export const SpotifyAnalysisDocument = gql`
  query SpotifyAnalysis($name: String!) {
    workflowInstance(name: $name) {
      ...SpotifyAnalysis
      ...DefaultError
    }
  }
  ${SpotifyAnalysisFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSpotifyAnalysisQuery__
 *
 * To run a query within a React component, call `useSpotifyAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotifyAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotifyAnalysisQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSpotifyAnalysisQuery(
  baseOptions: Apollo.QueryHookOptions<
    SpotifyAnalysisQuery,
    SpotifyAnalysisQueryVariables
  > &
    (
      | { variables: SpotifyAnalysisQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SpotifyAnalysisQuery, SpotifyAnalysisQueryVariables>(
    SpotifyAnalysisDocument,
    options,
  );
}
export function useSpotifyAnalysisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpotifyAnalysisQuery,
    SpotifyAnalysisQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SpotifyAnalysisQuery,
    SpotifyAnalysisQueryVariables
  >(SpotifyAnalysisDocument, options);
}
// @ts-ignore
export function useSpotifyAnalysisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SpotifyAnalysisQuery,
    SpotifyAnalysisQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SpotifyAnalysisQuery,
  SpotifyAnalysisQueryVariables
>;
export function useSpotifyAnalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpotifyAnalysisQuery,
        SpotifyAnalysisQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SpotifyAnalysisQuery | undefined,
  SpotifyAnalysisQueryVariables
>;
export function useSpotifyAnalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpotifyAnalysisQuery,
        SpotifyAnalysisQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SpotifyAnalysisQuery,
    SpotifyAnalysisQueryVariables
  >(SpotifyAnalysisDocument, options);
}
export type SpotifyAnalysisQueryHookResult = ReturnType<
  typeof useSpotifyAnalysisQuery
>;
export type SpotifyAnalysisLazyQueryHookResult = ReturnType<
  typeof useSpotifyAnalysisLazyQuery
>;
export type SpotifyAnalysisSuspenseQueryHookResult = ReturnType<
  typeof useSpotifyAnalysisSuspenseQuery
>;
export type SpotifyAnalysisQueryResult = Apollo.QueryResult<
  SpotifyAnalysisQuery,
  SpotifyAnalysisQueryVariables
>;
export const C4sAbTestDocument = gql`
  query C4sAbTest($name: String!) {
    workflowInstance(name: $name) {
      ...C4sAbTest
      ...DefaultError
    }
  }
  ${C4sAbTestFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useC4sAbTestQuery__
 *
 * To run a query within a React component, call `useC4sAbTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useC4sAbTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useC4sAbTestQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useC4sAbTestQuery(
  baseOptions: Apollo.QueryHookOptions<
    C4sAbTestQuery,
    C4sAbTestQueryVariables
  > &
    (
      | { variables: C4sAbTestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<C4sAbTestQuery, C4sAbTestQueryVariables>(
    C4sAbTestDocument,
    options,
  );
}
export function useC4sAbTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    C4sAbTestQuery,
    C4sAbTestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<C4sAbTestQuery, C4sAbTestQueryVariables>(
    C4sAbTestDocument,
    options,
  );
}
// @ts-ignore
export function useC4sAbTestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    C4sAbTestQuery,
    C4sAbTestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<C4sAbTestQuery, C4sAbTestQueryVariables>;
export function useC4sAbTestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<C4sAbTestQuery, C4sAbTestQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  C4sAbTestQuery | undefined,
  C4sAbTestQueryVariables
>;
export function useC4sAbTestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<C4sAbTestQuery, C4sAbTestQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<C4sAbTestQuery, C4sAbTestQueryVariables>(
    C4sAbTestDocument,
    options,
  );
}
export type C4sAbTestQueryHookResult = ReturnType<typeof useC4sAbTestQuery>;
export type C4sAbTestLazyQueryHookResult = ReturnType<
  typeof useC4sAbTestLazyQuery
>;
export type C4sAbTestSuspenseQueryHookResult = ReturnType<
  typeof useC4sAbTestSuspenseQuery
>;
export type C4sAbTestQueryResult = Apollo.QueryResult<
  C4sAbTestQuery,
  C4sAbTestQueryVariables
>;
export const OnC4sAbTestCreatedDocument = gql`
  subscription OnC4sAbTestCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...C4sAbTest
      }
    }
  }
  ${C4sAbTestFragmentDoc}
`;

/**
 * __useOnC4sAbTestCreatedSubscription__
 *
 * To run a query within a React component, call `useOnC4sAbTestCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnC4sAbTestCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnC4sAbTestCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnC4sAbTestCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnC4sAbTestCreatedSubscription,
    OnC4sAbTestCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnC4sAbTestCreatedSubscription,
    OnC4sAbTestCreatedSubscriptionVariables
  >(OnC4sAbTestCreatedDocument, options);
}
export type OnC4sAbTestCreatedSubscriptionHookResult = ReturnType<
  typeof useOnC4sAbTestCreatedSubscription
>;
export type OnC4sAbTestCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnC4sAbTestCreatedSubscription>;
export const OnC4sAbTestUpdatedDocument = gql`
  subscription OnC4sAbTestUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...C4sAbTest
      }
    }
  }
  ${C4sAbTestFragmentDoc}
`;

/**
 * __useOnC4sAbTestUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnC4sAbTestUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnC4sAbTestUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnC4sAbTestUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnC4sAbTestUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnC4sAbTestUpdatedSubscription,
    OnC4sAbTestUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnC4sAbTestUpdatedSubscription,
    OnC4sAbTestUpdatedSubscriptionVariables
  >(OnC4sAbTestUpdatedDocument, options);
}
export type OnC4sAbTestUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnC4sAbTestUpdatedSubscription
>;
export type OnC4sAbTestUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnC4sAbTestUpdatedSubscription>;
export const UpdateC4sAbTestDataDocument = gql`
  mutation UpdateC4sAbTestData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        ...C4sAbTest
        name
        moduleData2 {
          c4sabtest {
            ...C4sAbTestData
          }
        }
      }
      ...DefaultError
    }
  }
  ${C4sAbTestFragmentDoc}
  ${C4sAbTestDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateC4sAbTestDataMutationFn = Apollo.MutationFunction<
  UpdateC4sAbTestDataMutation,
  UpdateC4sAbTestDataMutationVariables
>;

/**
 * __useUpdateC4sAbTestDataMutation__
 *
 * To run a mutation, you first call `useUpdateC4sAbTestDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateC4sAbTestDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateC4sAbTestDataMutation, { data, loading, error }] = useUpdateC4sAbTestDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateC4sAbTestDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateC4sAbTestDataMutation,
    UpdateC4sAbTestDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateC4sAbTestDataMutation,
    UpdateC4sAbTestDataMutationVariables
  >(UpdateC4sAbTestDataDocument, options);
}
export type UpdateC4sAbTestDataMutationHookResult = ReturnType<
  typeof useUpdateC4sAbTestDataMutation
>;
export type UpdateC4sAbTestDataMutationResult =
  Apollo.MutationResult<UpdateC4sAbTestDataMutation>;
export type UpdateC4sAbTestDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateC4sAbTestDataMutation,
  UpdateC4sAbTestDataMutationVariables
>;
export const C4sRolloutDocument = gql`
  query C4sRollout($name: String!) {
    workflowInstance(name: $name) {
      ...C4sRollout
      ...DefaultError
    }
  }
  ${C4sRolloutFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useC4sRolloutQuery__
 *
 * To run a query within a React component, call `useC4sRolloutQuery` and pass it any options that fit your needs.
 * When your component renders, `useC4sRolloutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useC4sRolloutQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useC4sRolloutQuery(
  baseOptions: Apollo.QueryHookOptions<
    C4sRolloutQuery,
    C4sRolloutQueryVariables
  > &
    (
      | { variables: C4sRolloutQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<C4sRolloutQuery, C4sRolloutQueryVariables>(
    C4sRolloutDocument,
    options,
  );
}
export function useC4sRolloutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    C4sRolloutQuery,
    C4sRolloutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<C4sRolloutQuery, C4sRolloutQueryVariables>(
    C4sRolloutDocument,
    options,
  );
}
// @ts-ignore
export function useC4sRolloutSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    C4sRolloutQuery,
    C4sRolloutQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<C4sRolloutQuery, C4sRolloutQueryVariables>;
export function useC4sRolloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        C4sRolloutQuery,
        C4sRolloutQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  C4sRolloutQuery | undefined,
  C4sRolloutQueryVariables
>;
export function useC4sRolloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        C4sRolloutQuery,
        C4sRolloutQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<C4sRolloutQuery, C4sRolloutQueryVariables>(
    C4sRolloutDocument,
    options,
  );
}
export type C4sRolloutQueryHookResult = ReturnType<typeof useC4sRolloutQuery>;
export type C4sRolloutLazyQueryHookResult = ReturnType<
  typeof useC4sRolloutLazyQuery
>;
export type C4sRolloutSuspenseQueryHookResult = ReturnType<
  typeof useC4sRolloutSuspenseQuery
>;
export type C4sRolloutQueryResult = Apollo.QueryResult<
  C4sRolloutQuery,
  C4sRolloutQueryVariables
>;
export const OnC4sRolloutCreatedDocument = gql`
  subscription OnC4sRolloutCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...C4sRollout
      }
    }
  }
  ${C4sRolloutFragmentDoc}
`;

/**
 * __useOnC4sRolloutCreatedSubscription__
 *
 * To run a query within a React component, call `useOnC4sRolloutCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnC4sRolloutCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnC4sRolloutCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnC4sRolloutCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnC4sRolloutCreatedSubscription,
    OnC4sRolloutCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnC4sRolloutCreatedSubscription,
    OnC4sRolloutCreatedSubscriptionVariables
  >(OnC4sRolloutCreatedDocument, options);
}
export type OnC4sRolloutCreatedSubscriptionHookResult = ReturnType<
  typeof useOnC4sRolloutCreatedSubscription
>;
export type OnC4sRolloutCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnC4sRolloutCreatedSubscription>;
export const OnC4sRolloutUpdatedDocument = gql`
  subscription OnC4sRolloutUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...C4sRollout
      }
    }
  }
  ${C4sRolloutFragmentDoc}
`;

/**
 * __useOnC4sRolloutUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnC4sRolloutUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnC4sRolloutUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnC4sRolloutUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnC4sRolloutUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnC4sRolloutUpdatedSubscription,
    OnC4sRolloutUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnC4sRolloutUpdatedSubscription,
    OnC4sRolloutUpdatedSubscriptionVariables
  >(OnC4sRolloutUpdatedDocument, options);
}
export type OnC4sRolloutUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnC4sRolloutUpdatedSubscription
>;
export type OnC4sRolloutUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnC4sRolloutUpdatedSubscription>;
export const UpdateC4sRolloutDataDocument = gql`
  mutation UpdateC4sRolloutData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        ...C4sRollout
        name
        moduleData2 {
          c4srollout {
            ...C4sRolloutData
          }
        }
      }
      ...DefaultError
    }
  }
  ${C4sRolloutFragmentDoc}
  ${C4sRolloutDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateC4sRolloutDataMutationFn = Apollo.MutationFunction<
  UpdateC4sRolloutDataMutation,
  UpdateC4sRolloutDataMutationVariables
>;

/**
 * __useUpdateC4sRolloutDataMutation__
 *
 * To run a mutation, you first call `useUpdateC4sRolloutDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateC4sRolloutDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateC4sRolloutDataMutation, { data, loading, error }] = useUpdateC4sRolloutDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateC4sRolloutDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateC4sRolloutDataMutation,
    UpdateC4sRolloutDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateC4sRolloutDataMutation,
    UpdateC4sRolloutDataMutationVariables
  >(UpdateC4sRolloutDataDocument, options);
}
export type UpdateC4sRolloutDataMutationHookResult = ReturnType<
  typeof useUpdateC4sRolloutDataMutation
>;
export type UpdateC4sRolloutDataMutationResult =
  Apollo.MutationResult<UpdateC4sRolloutDataMutation>;
export type UpdateC4sRolloutDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateC4sRolloutDataMutation,
  UpdateC4sRolloutDataMutationVariables
>;
export const OnStaticConfigCreatedDocument = gql`
  subscription OnStaticConfigCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...StaticConfig
      }
    }
  }
  ${StaticConfigFragmentDoc}
`;

/**
 * __useOnStaticConfigCreatedSubscription__
 *
 * To run a query within a React component, call `useOnStaticConfigCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStaticConfigCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStaticConfigCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnStaticConfigCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnStaticConfigCreatedSubscription,
    OnStaticConfigCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnStaticConfigCreatedSubscription,
    OnStaticConfigCreatedSubscriptionVariables
  >(OnStaticConfigCreatedDocument, options);
}
export type OnStaticConfigCreatedSubscriptionHookResult = ReturnType<
  typeof useOnStaticConfigCreatedSubscription
>;
export type OnStaticConfigCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnStaticConfigCreatedSubscription>;
export const OnStaticConfigUpdatedDocument = gql`
  subscription OnStaticConfigUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...StaticConfig
      }
    }
  }
  ${StaticConfigFragmentDoc}
`;

/**
 * __useOnStaticConfigUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnStaticConfigUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStaticConfigUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStaticConfigUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnStaticConfigUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnStaticConfigUpdatedSubscription,
    OnStaticConfigUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnStaticConfigUpdatedSubscription,
    OnStaticConfigUpdatedSubscriptionVariables
  >(OnStaticConfigUpdatedDocument, options);
}
export type OnStaticConfigUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnStaticConfigUpdatedSubscription
>;
export type OnStaticConfigUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnStaticConfigUpdatedSubscription>;
export const StaticConfigDocument = gql`
  query StaticConfig($name: String!) {
    workflowInstance(name: $name) {
      ...StaticConfig
      ...DefaultError
    }
  }
  ${StaticConfigFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useStaticConfigQuery__
 *
 * To run a query within a React component, call `useStaticConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticConfigQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStaticConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    StaticConfigQuery,
    StaticConfigQueryVariables
  > &
    (
      | { variables: StaticConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StaticConfigQuery, StaticConfigQueryVariables>(
    StaticConfigDocument,
    options,
  );
}
export function useStaticConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StaticConfigQuery,
    StaticConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StaticConfigQuery, StaticConfigQueryVariables>(
    StaticConfigDocument,
    options,
  );
}
// @ts-ignore
export function useStaticConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StaticConfigQuery,
    StaticConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<StaticConfigQuery, StaticConfigQueryVariables>;
export function useStaticConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StaticConfigQuery,
        StaticConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StaticConfigQuery | undefined,
  StaticConfigQueryVariables
>;
export function useStaticConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StaticConfigQuery,
        StaticConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StaticConfigQuery, StaticConfigQueryVariables>(
    StaticConfigDocument,
    options,
  );
}
export type StaticConfigQueryHookResult = ReturnType<
  typeof useStaticConfigQuery
>;
export type StaticConfigLazyQueryHookResult = ReturnType<
  typeof useStaticConfigLazyQuery
>;
export type StaticConfigSuspenseQueryHookResult = ReturnType<
  typeof useStaticConfigSuspenseQuery
>;
export type StaticConfigQueryResult = Apollo.QueryResult<
  StaticConfigQuery,
  StaticConfigQueryVariables
>;
export const UpdateStaticConfigDataDocument = gql`
  mutation UpdateStaticConfigData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        ...StaticConfig
        name
        moduleData2 {
          staticconfig {
            ...StaticConfigData
          }
        }
      }
      ...DefaultError
    }
  }
  ${StaticConfigFragmentDoc}
  ${StaticConfigDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateStaticConfigDataMutationFn = Apollo.MutationFunction<
  UpdateStaticConfigDataMutation,
  UpdateStaticConfigDataMutationVariables
>;

/**
 * __useUpdateStaticConfigDataMutation__
 *
 * To run a mutation, you first call `useUpdateStaticConfigDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaticConfigDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaticConfigDataMutation, { data, loading, error }] = useUpdateStaticConfigDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateStaticConfigDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStaticConfigDataMutation,
    UpdateStaticConfigDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStaticConfigDataMutation,
    UpdateStaticConfigDataMutationVariables
  >(UpdateStaticConfigDataDocument, options);
}
export type UpdateStaticConfigDataMutationHookResult = ReturnType<
  typeof useUpdateStaticConfigDataMutation
>;
export type UpdateStaticConfigDataMutationResult =
  Apollo.MutationResult<UpdateStaticConfigDataMutation>;
export type UpdateStaticConfigDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateStaticConfigDataMutation,
  UpdateStaticConfigDataMutationVariables
>;
export const SampleSizeConfigDocument = gql`
  mutation SampleSizeConfig($workflowInstance: String!) {
    executeFunction(
      workflowInstance: $workflowInstance
      functionName: "getSampleSizeConfig"
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type SampleSizeConfigMutationFn = Apollo.MutationFunction<
  SampleSizeConfigMutation,
  SampleSizeConfigMutationVariables
>;

/**
 * __useSampleSizeConfigMutation__
 *
 * To run a mutation, you first call `useSampleSizeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSampleSizeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sampleSizeConfigMutation, { data, loading, error }] = useSampleSizeConfigMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useSampleSizeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SampleSizeConfigMutation,
    SampleSizeConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SampleSizeConfigMutation,
    SampleSizeConfigMutationVariables
  >(SampleSizeConfigDocument, options);
}
export type SampleSizeConfigMutationHookResult = ReturnType<
  typeof useSampleSizeConfigMutation
>;
export type SampleSizeConfigMutationResult =
  Apollo.MutationResult<SampleSizeConfigMutation>;
export type SampleSizeConfigMutationOptions = Apollo.BaseMutationOptions<
  SampleSizeConfigMutation,
  SampleSizeConfigMutationVariables
>;
export const ActivitiesDocument = gql`
  query Activities(
    $resource: String!
    $pageSize: Int
    $pageToken: String
    $filter: String
  ) {
    activities(
      resource: $resource
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      __typename
      ... on ActivityV1ListActivitiesResponse {
        activities {
          ...Activity
        }
        nextPageToken
        truncatedBeforeTime
      }
      ...DefaultError
    }
  }
  ${ActivityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a React component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivitiesQuery,
    ActivitiesQueryVariables
  > &
    (
      | { variables: ActivitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(
    ActivitiesDocument,
    options,
  );
}
export function useActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivitiesQuery,
    ActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(
    ActivitiesDocument,
    options,
  );
}
// @ts-ignore
export function useActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivitiesQuery,
    ActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export function useActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivitiesQuery,
        ActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivitiesQuery | undefined,
  ActivitiesQueryVariables
>;
export function useActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivitiesQuery,
        ActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActivitiesQuery, ActivitiesQueryVariables>(
    ActivitiesDocument,
    options,
  );
}
export type ActivitiesQueryHookResult = ReturnType<typeof useActivitiesQuery>;
export type ActivitiesLazyQueryHookResult = ReturnType<
  typeof useActivitiesLazyQuery
>;
export type ActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useActivitiesSuspenseQuery
>;
export type ActivitiesQueryResult = Apollo.QueryResult<
  ActivitiesQuery,
  ActivitiesQueryVariables
>;
export const ActivityTypesDocument = gql`
  query ActivityTypes($pageSize: Int, $pageToken: String) {
    activityTypes(pageSize: $pageSize, pageToken: $pageToken) {
      __typename
      ... on ActivityV1ListActivityTypesResponse {
        activityTypes {
          ...ActivityTypeRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ActivityTypeRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useActivityTypesQuery__
 *
 * To run a query within a React component, call `useActivityTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTypesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useActivityTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityTypesQuery,
    ActivityTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityTypesQuery, ActivityTypesQueryVariables>(
    ActivityTypesDocument,
    options,
  );
}
export function useActivityTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityTypesQuery,
    ActivityTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityTypesQuery, ActivityTypesQueryVariables>(
    ActivityTypesDocument,
    options,
  );
}
// @ts-ignore
export function useActivityTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityTypesQuery,
    ActivityTypesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ActivityTypesQuery,
  ActivityTypesQueryVariables
>;
export function useActivityTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityTypesQuery,
        ActivityTypesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivityTypesQuery | undefined,
  ActivityTypesQueryVariables
>;
export function useActivityTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityTypesQuery,
        ActivityTypesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActivityTypesQuery,
    ActivityTypesQueryVariables
  >(ActivityTypesDocument, options);
}
export type ActivityTypesQueryHookResult = ReturnType<
  typeof useActivityTypesQuery
>;
export type ActivityTypesLazyQueryHookResult = ReturnType<
  typeof useActivityTypesLazyQuery
>;
export type ActivityTypesSuspenseQueryHookResult = ReturnType<
  typeof useActivityTypesSuspenseQuery
>;
export type ActivityTypesQueryResult = Apollo.QueryResult<
  ActivityTypesQuery,
  ActivityTypesQueryVariables
>;
export const FeedEntriesDocument = gql`
  query FeedEntries($parent: String!, $pageSize: Int, $pageToken: String) {
    feedEntries(parent: $parent, pageSize: $pageSize, pageToken: $pageToken) {
      ... on ActivityV1ListFeedEntriesResponse {
        __typename
        feedEntries {
          ...FeedEntry
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FeedEntryFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFeedEntriesQuery__
 *
 * To run a query within a React component, call `useFeedEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedEntriesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFeedEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeedEntriesQuery,
    FeedEntriesQueryVariables
  > &
    (
      | { variables: FeedEntriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeedEntriesQuery, FeedEntriesQueryVariables>(
    FeedEntriesDocument,
    options,
  );
}
export function useFeedEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeedEntriesQuery,
    FeedEntriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FeedEntriesQuery, FeedEntriesQueryVariables>(
    FeedEntriesDocument,
    options,
  );
}
// @ts-ignore
export function useFeedEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FeedEntriesQuery,
    FeedEntriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FeedEntriesQuery, FeedEntriesQueryVariables>;
export function useFeedEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedEntriesQuery,
        FeedEntriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FeedEntriesQuery | undefined,
  FeedEntriesQueryVariables
>;
export function useFeedEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedEntriesQuery,
        FeedEntriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FeedEntriesQuery, FeedEntriesQueryVariables>(
    FeedEntriesDocument,
    options,
  );
}
export type FeedEntriesQueryHookResult = ReturnType<typeof useFeedEntriesQuery>;
export type FeedEntriesLazyQueryHookResult = ReturnType<
  typeof useFeedEntriesLazyQuery
>;
export type FeedEntriesSuspenseQueryHookResult = ReturnType<
  typeof useFeedEntriesSuspenseQuery
>;
export type FeedEntriesQueryResult = Apollo.QueryResult<
  FeedEntriesQuery,
  FeedEntriesQueryVariables
>;
export const FollowResourcesDocument = gql`
  mutation FollowResources(
    $feed: String
    $resources: [String!]!
    $activityTypes: [String!]
  ) {
    followResources(
      feed: $feed
      resources: $resources
      activityTypes: $activityTypes
    ) {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type FollowResourcesMutationFn = Apollo.MutationFunction<
  FollowResourcesMutation,
  FollowResourcesMutationVariables
>;

/**
 * __useFollowResourcesMutation__
 *
 * To run a mutation, you first call `useFollowResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followResourcesMutation, { data, loading, error }] = useFollowResourcesMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *      resources: // value for 'resources'
 *      activityTypes: // value for 'activityTypes'
 *   },
 * });
 */
export function useFollowResourcesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FollowResourcesMutation,
    FollowResourcesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FollowResourcesMutation,
    FollowResourcesMutationVariables
  >(FollowResourcesDocument, options);
}
export type FollowResourcesMutationHookResult = ReturnType<
  typeof useFollowResourcesMutation
>;
export type FollowResourcesMutationResult =
  Apollo.MutationResult<FollowResourcesMutation>;
export type FollowResourcesMutationOptions = Apollo.BaseMutationOptions<
  FollowResourcesMutation,
  FollowResourcesMutationVariables
>;
export const OnActivityCreatedDocument = gql`
  subscription OnActivityCreated {
    activityCreated {
      activity {
        ...Activity
      }
    }
  }
  ${ActivityFragmentDoc}
`;

/**
 * __useOnActivityCreatedSubscription__
 *
 * To run a query within a React component, call `useOnActivityCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnActivityCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnActivityCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnActivityCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnActivityCreatedSubscription,
    OnActivityCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnActivityCreatedSubscription,
    OnActivityCreatedSubscriptionVariables
  >(OnActivityCreatedDocument, options);
}
export type OnActivityCreatedSubscriptionHookResult = ReturnType<
  typeof useOnActivityCreatedSubscription
>;
export type OnActivityCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnActivityCreatedSubscription>;
export const QueryIsFollowingResourceDocument = gql`
  query QueryIsFollowingResource($feed: String, $resource: String!) {
    queryIsFollowingResource(feed: $feed, resource: $resource) {
      __typename
      ... on ActivityV1QueryIsFollowingResourceResponse {
        isFollowing
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useQueryIsFollowingResourceQuery__
 *
 * To run a query within a React component, call `useQueryIsFollowingResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryIsFollowingResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryIsFollowingResourceQuery({
 *   variables: {
 *      feed: // value for 'feed'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useQueryIsFollowingResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  > &
    (
      | { variables: QueryIsFollowingResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  >(QueryIsFollowingResourceDocument, options);
}
export function useQueryIsFollowingResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  >(QueryIsFollowingResourceDocument, options);
}
// @ts-ignore
export function useQueryIsFollowingResourceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryIsFollowingResourceQuery,
  QueryIsFollowingResourceQueryVariables
>;
export function useQueryIsFollowingResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryIsFollowingResourceQuery,
        QueryIsFollowingResourceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryIsFollowingResourceQuery | undefined,
  QueryIsFollowingResourceQueryVariables
>;
export function useQueryIsFollowingResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryIsFollowingResourceQuery,
        QueryIsFollowingResourceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryIsFollowingResourceQuery,
    QueryIsFollowingResourceQueryVariables
  >(QueryIsFollowingResourceDocument, options);
}
export type QueryIsFollowingResourceQueryHookResult = ReturnType<
  typeof useQueryIsFollowingResourceQuery
>;
export type QueryIsFollowingResourceLazyQueryHookResult = ReturnType<
  typeof useQueryIsFollowingResourceLazyQuery
>;
export type QueryIsFollowingResourceSuspenseQueryHookResult = ReturnType<
  typeof useQueryIsFollowingResourceSuspenseQuery
>;
export type QueryIsFollowingResourceQueryResult = Apollo.QueryResult<
  QueryIsFollowingResourceQuery,
  QueryIsFollowingResourceQueryVariables
>;
export const UnfollowResourcesDocument = gql`
  mutation UnfollowResources($feed: String, $resources: [String!]!) {
    unfollowResources(feed: $feed, resources: $resources) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UnfollowResourcesMutationFn = Apollo.MutationFunction<
  UnfollowResourcesMutation,
  UnfollowResourcesMutationVariables
>;

/**
 * __useUnfollowResourcesMutation__
 *
 * To run a mutation, you first call `useUnfollowResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowResourcesMutation, { data, loading, error }] = useUnfollowResourcesMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useUnfollowResourcesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnfollowResourcesMutation,
    UnfollowResourcesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnfollowResourcesMutation,
    UnfollowResourcesMutationVariables
  >(UnfollowResourcesDocument, options);
}
export type UnfollowResourcesMutationHookResult = ReturnType<
  typeof useUnfollowResourcesMutation
>;
export type UnfollowResourcesMutationResult =
  Apollo.MutationResult<UnfollowResourcesMutation>;
export type UnfollowResourcesMutationOptions = Apollo.BaseMutationOptions<
  UnfollowResourcesMutation,
  UnfollowResourcesMutationVariables
>;
export const ConversationDocument = gql`
  query Conversation($name: String!, $view: ConversationsV1ConversationView) {
    conversation(name: $name, view: $view) {
      ...Conversation
      ...DefaultError
    }
  }
  ${ConversationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      name: // value for 'name'
 *      view: // value for 'view'
 *   },
 * });
 */
export function useConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConversationQuery,
    ConversationQueryVariables
  > &
    (
      | { variables: ConversationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
export function useConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationQuery,
    ConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
// @ts-ignore
export function useConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConversationQuery,
    ConversationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConversationQuery, ConversationQueryVariables>;
export function useConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConversationQuery,
        ConversationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConversationQuery | undefined,
  ConversationQueryVariables
>;
export function useConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConversationQuery,
        ConversationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
export type ConversationQueryHookResult = ReturnType<
  typeof useConversationQuery
>;
export type ConversationLazyQueryHookResult = ReturnType<
  typeof useConversationLazyQuery
>;
export type ConversationSuspenseQueryHookResult = ReturnType<
  typeof useConversationSuspenseQuery
>;
export type ConversationQueryResult = Apollo.QueryResult<
  ConversationQuery,
  ConversationQueryVariables
>;
export const ConversationsDocument = gql`
  query Conversations($pageSize: Int, $pageToken: String, $agentId: String) {
    conversations(
      pageSize: $pageSize
      pageToken: $pageToken
      agentId: $agentId
    ) {
      ... on ConversationsV1ListConversationsResponse {
        __typename
        conversations {
          ...ConversationRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ConversationRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useConversationsQuery__
 *
 * To run a query within a React component, call `useConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConversationsQuery,
    ConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationsQuery, ConversationsQueryVariables>(
    ConversationsDocument,
    options,
  );
}
export function useConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationsQuery,
    ConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationsQuery, ConversationsQueryVariables>(
    ConversationsDocument,
    options,
  );
}
// @ts-ignore
export function useConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConversationsQuery,
    ConversationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConversationsQuery,
  ConversationsQueryVariables
>;
export function useConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConversationsQuery,
        ConversationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConversationsQuery | undefined,
  ConversationsQueryVariables
>;
export function useConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConversationsQuery,
        ConversationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConversationsQuery,
    ConversationsQueryVariables
  >(ConversationsDocument, options);
}
export type ConversationsQueryHookResult = ReturnType<
  typeof useConversationsQuery
>;
export type ConversationsLazyQueryHookResult = ReturnType<
  typeof useConversationsLazyQuery
>;
export type ConversationsSuspenseQueryHookResult = ReturnType<
  typeof useConversationsSuspenseQuery
>;
export type ConversationsQueryResult = Apollo.QueryResult<
  ConversationsQuery,
  ConversationsQueryVariables
>;
export const GlobalContextExternalDocumentsDocument = gql`
  query GlobalContextExternalDocuments(
    $resource: String!
    $pageSize: Int
    $pageToken: String
  ) {
    externalDocuments(
      resource: $resource
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on CollaborationV1ListExternalDocumentsResponse {
        __typename
        externalDocuments {
          ...ExternalDocumentRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ExternalDocumentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGlobalContextExternalDocumentsQuery__
 *
 * To run a query within a React component, call `useGlobalContextExternalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalContextExternalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalContextExternalDocumentsQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useGlobalContextExternalDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  > &
    (
      | {
          variables: GlobalContextExternalDocumentsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  >(GlobalContextExternalDocumentsDocument, options);
}
export function useGlobalContextExternalDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  >(GlobalContextExternalDocumentsDocument, options);
}
// @ts-ignore
export function useGlobalContextExternalDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GlobalContextExternalDocumentsQuery,
  GlobalContextExternalDocumentsQueryVariables
>;
export function useGlobalContextExternalDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GlobalContextExternalDocumentsQuery,
        GlobalContextExternalDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GlobalContextExternalDocumentsQuery | undefined,
  GlobalContextExternalDocumentsQueryVariables
>;
export function useGlobalContextExternalDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GlobalContextExternalDocumentsQuery,
        GlobalContextExternalDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GlobalContextExternalDocumentsQuery,
    GlobalContextExternalDocumentsQueryVariables
  >(GlobalContextExternalDocumentsDocument, options);
}
export type GlobalContextExternalDocumentsQueryHookResult = ReturnType<
  typeof useGlobalContextExternalDocumentsQuery
>;
export type GlobalContextExternalDocumentsLazyQueryHookResult = ReturnType<
  typeof useGlobalContextExternalDocumentsLazyQuery
>;
export type GlobalContextExternalDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGlobalContextExternalDocumentsSuspenseQuery
>;
export type GlobalContextExternalDocumentsQueryResult = Apollo.QueryResult<
  GlobalContextExternalDocumentsQuery,
  GlobalContextExternalDocumentsQueryVariables
>;
export const CreateInsightsDocumentDocument = gql`
  mutation CreateInsightsDocument(
    $insightsDocument: InsightsV1InsightsDocumentInput!
  ) {
    createInsightsDocument(insightsDocument: $insightsDocument) {
      ...InsightsDocument
      ...DefaultError
    }
  }
  ${InsightsDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateInsightsDocumentMutationFn = Apollo.MutationFunction<
  CreateInsightsDocumentMutation,
  CreateInsightsDocumentMutationVariables
>;

/**
 * __useCreateInsightsDocumentMutation__
 *
 * To run a mutation, you first call `useCreateInsightsDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightsDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightsDocumentMutation, { data, loading, error }] = useCreateInsightsDocumentMutation({
 *   variables: {
 *      insightsDocument: // value for 'insightsDocument'
 *   },
 * });
 */
export function useCreateInsightsDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInsightsDocumentMutation,
    CreateInsightsDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInsightsDocumentMutation,
    CreateInsightsDocumentMutationVariables
  >(CreateInsightsDocumentDocument, options);
}
export type CreateInsightsDocumentMutationHookResult = ReturnType<
  typeof useCreateInsightsDocumentMutation
>;
export type CreateInsightsDocumentMutationResult =
  Apollo.MutationResult<CreateInsightsDocumentMutation>;
export type CreateInsightsDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateInsightsDocumentMutation,
  CreateInsightsDocumentMutationVariables
>;
export const DeleteInsightsDocumentDocument = gql`
  mutation DeleteInsightsDocument($name: String!) {
    deleteInsightsDocument(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteInsightsDocumentMutationFn = Apollo.MutationFunction<
  DeleteInsightsDocumentMutation,
  DeleteInsightsDocumentMutationVariables
>;

/**
 * __useDeleteInsightsDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteInsightsDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightsDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightsDocumentMutation, { data, loading, error }] = useDeleteInsightsDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteInsightsDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInsightsDocumentMutation,
    DeleteInsightsDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteInsightsDocumentMutation,
    DeleteInsightsDocumentMutationVariables
  >(DeleteInsightsDocumentDocument, options);
}
export type DeleteInsightsDocumentMutationHookResult = ReturnType<
  typeof useDeleteInsightsDocumentMutation
>;
export type DeleteInsightsDocumentMutationResult =
  Apollo.MutationResult<DeleteInsightsDocumentMutation>;
export type DeleteInsightsDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteInsightsDocumentMutation,
  DeleteInsightsDocumentMutationVariables
>;
export const InsightsDocumentDocument = gql`
  query InsightsDocument($name: String!) {
    insightsDocument(name: $name) {
      ...InsightsDocument
      ...DefaultError
    }
  }
  ${InsightsDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInsightsDocumentQuery__
 *
 * To run a query within a React component, call `useInsightsDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsDocumentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useInsightsDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    InsightsDocumentQuery,
    InsightsDocumentQueryVariables
  > &
    (
      | { variables: InsightsDocumentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsightsDocumentQuery, InsightsDocumentQueryVariables>(
    InsightsDocumentDocument,
    options,
  );
}
export function useInsightsDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsightsDocumentQuery,
    InsightsDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InsightsDocumentQuery,
    InsightsDocumentQueryVariables
  >(InsightsDocumentDocument, options);
}
// @ts-ignore
export function useInsightsDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InsightsDocumentQuery,
    InsightsDocumentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InsightsDocumentQuery,
  InsightsDocumentQueryVariables
>;
export function useInsightsDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsDocumentQuery,
        InsightsDocumentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InsightsDocumentQuery | undefined,
  InsightsDocumentQueryVariables
>;
export function useInsightsDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsDocumentQuery,
        InsightsDocumentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InsightsDocumentQuery,
    InsightsDocumentQueryVariables
  >(InsightsDocumentDocument, options);
}
export type InsightsDocumentQueryHookResult = ReturnType<
  typeof useInsightsDocumentQuery
>;
export type InsightsDocumentLazyQueryHookResult = ReturnType<
  typeof useInsightsDocumentLazyQuery
>;
export type InsightsDocumentSuspenseQueryHookResult = ReturnType<
  typeof useInsightsDocumentSuspenseQuery
>;
export type InsightsDocumentQueryResult = Apollo.QueryResult<
  InsightsDocumentQuery,
  InsightsDocumentQueryVariables
>;
export const InsightsDocumentsDocument = gql`
  query InsightsDocuments($pageSize: Int, $pageToken: String) {
    insightsDocuments(pageSize: $pageSize, pageToken: $pageToken) {
      ... on InsightsV1ListInsightsDocumentsResponse {
        __typename
        insightsDocuments {
          ...InsightsDocumentRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${InsightsDocumentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInsightsDocumentsQuery__
 *
 * To run a query within a React component, call `useInsightsDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsDocumentsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useInsightsDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >(InsightsDocumentsDocument, options);
}
export function useInsightsDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >(InsightsDocumentsDocument, options);
}
// @ts-ignore
export function useInsightsDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InsightsDocumentsQuery,
  InsightsDocumentsQueryVariables
>;
export function useInsightsDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsDocumentsQuery,
        InsightsDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InsightsDocumentsQuery | undefined,
  InsightsDocumentsQueryVariables
>;
export function useInsightsDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsDocumentsQuery,
        InsightsDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InsightsDocumentsQuery,
    InsightsDocumentsQueryVariables
  >(InsightsDocumentsDocument, options);
}
export type InsightsDocumentsQueryHookResult = ReturnType<
  typeof useInsightsDocumentsQuery
>;
export type InsightsDocumentsLazyQueryHookResult = ReturnType<
  typeof useInsightsDocumentsLazyQuery
>;
export type InsightsDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useInsightsDocumentsSuspenseQuery
>;
export type InsightsDocumentsQueryResult = Apollo.QueryResult<
  InsightsDocumentsQuery,
  InsightsDocumentsQueryVariables
>;
export const InsightsTableContextsDocument = gql`
  query InsightsTableContexts($pageSize: Int, $pageToken: String) {
    insightsTableContexts(pageSize: $pageSize, pageToken: $pageToken) {
      ... on InsightsV1ListInsightsTableContextsResponse {
        __typename
        insightsTableContexts {
          ...InsightsTableContextRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${InsightsTableContextRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInsightsTableContextsQuery__
 *
 * To run a query within a React component, call `useInsightsTableContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsTableContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsTableContextsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useInsightsTableContextsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >(InsightsTableContextsDocument, options);
}
export function useInsightsTableContextsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >(InsightsTableContextsDocument, options);
}
// @ts-ignore
export function useInsightsTableContextsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InsightsTableContextsQuery,
  InsightsTableContextsQueryVariables
>;
export function useInsightsTableContextsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsTableContextsQuery,
        InsightsTableContextsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InsightsTableContextsQuery | undefined,
  InsightsTableContextsQueryVariables
>;
export function useInsightsTableContextsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsTableContextsQuery,
        InsightsTableContextsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InsightsTableContextsQuery,
    InsightsTableContextsQueryVariables
  >(InsightsTableContextsDocument, options);
}
export type InsightsTableContextsQueryHookResult = ReturnType<
  typeof useInsightsTableContextsQuery
>;
export type InsightsTableContextsLazyQueryHookResult = ReturnType<
  typeof useInsightsTableContextsLazyQuery
>;
export type InsightsTableContextsSuspenseQueryHookResult = ReturnType<
  typeof useInsightsTableContextsSuspenseQuery
>;
export type InsightsTableContextsQueryResult = Apollo.QueryResult<
  InsightsTableContextsQuery,
  InsightsTableContextsQueryVariables
>;
export const SyncInsightsTableContextsDocument = gql`
  mutation SyncInsightsTableContexts($includeEnrichment: Boolean) {
    syncInsightsTableContexts(includeEnrichment: $includeEnrichment) {
      ... on InsightsV1SyncInsightsTableContextsResponse {
        __typename
        totalFactTables
        created
        skipped
        failed
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type SyncInsightsTableContextsMutationFn = Apollo.MutationFunction<
  SyncInsightsTableContextsMutation,
  SyncInsightsTableContextsMutationVariables
>;

/**
 * __useSyncInsightsTableContextsMutation__
 *
 * To run a mutation, you first call `useSyncInsightsTableContextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncInsightsTableContextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncInsightsTableContextsMutation, { data, loading, error }] = useSyncInsightsTableContextsMutation({
 *   variables: {
 *      includeEnrichment: // value for 'includeEnrichment'
 *   },
 * });
 */
export function useSyncInsightsTableContextsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncInsightsTableContextsMutation,
    SyncInsightsTableContextsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncInsightsTableContextsMutation,
    SyncInsightsTableContextsMutationVariables
  >(SyncInsightsTableContextsDocument, options);
}
export type SyncInsightsTableContextsMutationHookResult = ReturnType<
  typeof useSyncInsightsTableContextsMutation
>;
export type SyncInsightsTableContextsMutationResult =
  Apollo.MutationResult<SyncInsightsTableContextsMutation>;
export type SyncInsightsTableContextsMutationOptions =
  Apollo.BaseMutationOptions<
    SyncInsightsTableContextsMutation,
    SyncInsightsTableContextsMutationVariables
  >;
export const UpdateInsightsDocumentDocument = gql`
  mutation UpdateInsightsDocument(
    $input: PartialInsightsV1InsightsDocumentInput!
    $updateMask: String
  ) {
    updateInsightsDocument(insightsDocument: $input, updateMask: $updateMask) {
      ...InsightsDocument
      ...DefaultError
    }
  }
  ${InsightsDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateInsightsDocumentMutationFn = Apollo.MutationFunction<
  UpdateInsightsDocumentMutation,
  UpdateInsightsDocumentMutationVariables
>;

/**
 * __useUpdateInsightsDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsDocumentMutation, { data, loading, error }] = useUpdateInsightsDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateInsightsDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInsightsDocumentMutation,
    UpdateInsightsDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateInsightsDocumentMutation,
    UpdateInsightsDocumentMutationVariables
  >(UpdateInsightsDocumentDocument, options);
}
export type UpdateInsightsDocumentMutationHookResult = ReturnType<
  typeof useUpdateInsightsDocumentMutation
>;
export type UpdateInsightsDocumentMutationResult =
  Apollo.MutationResult<UpdateInsightsDocumentMutation>;
export type UpdateInsightsDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateInsightsDocumentMutation,
  UpdateInsightsDocumentMutationVariables
>;
export const UpdateInsightsTableContextDocument = gql`
  mutation UpdateInsightsTableContext(
    $input: PartialInsightsV1InsightsTableContextInput!
    $updateMask: String
  ) {
    updateInsightsTableContext(
      insightsTableContext: $input
      updateMask: $updateMask
    ) {
      ...InsightsTableContextRef
      ...DefaultError
    }
  }
  ${InsightsTableContextRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateInsightsTableContextMutationFn = Apollo.MutationFunction<
  UpdateInsightsTableContextMutation,
  UpdateInsightsTableContextMutationVariables
>;

/**
 * __useUpdateInsightsTableContextMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsTableContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsTableContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsTableContextMutation, { data, loading, error }] = useUpdateInsightsTableContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateInsightsTableContextMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInsightsTableContextMutation,
    UpdateInsightsTableContextMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateInsightsTableContextMutation,
    UpdateInsightsTableContextMutationVariables
  >(UpdateInsightsTableContextDocument, options);
}
export type UpdateInsightsTableContextMutationHookResult = ReturnType<
  typeof useUpdateInsightsTableContextMutation
>;
export type UpdateInsightsTableContextMutationResult =
  Apollo.MutationResult<UpdateInsightsTableContextMutation>;
export type UpdateInsightsTableContextMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateInsightsTableContextMutation,
    UpdateInsightsTableContextMutationVariables
  >;
export const AccountDomainsDocument = gql`
  query AccountDomains($pageSize: Int, $pageToken: String) {
    accountDomains(pageSize: $pageSize, pageToken: $pageToken) {
      ... on AdminV1ListAccountDomainsResponse {
        __typename
        accountDomains {
          ...AccountDomain
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${AccountDomainFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAccountDomainsQuery__
 *
 * To run a query within a React component, call `useAccountDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDomainsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useAccountDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountDomainsQuery,
    AccountDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountDomainsQuery, AccountDomainsQueryVariables>(
    AccountDomainsDocument,
    options,
  );
}
export function useAccountDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountDomainsQuery,
    AccountDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountDomainsQuery, AccountDomainsQueryVariables>(
    AccountDomainsDocument,
    options,
  );
}
// @ts-ignore
export function useAccountDomainsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountDomainsQuery,
    AccountDomainsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountDomainsQuery,
  AccountDomainsQueryVariables
>;
export function useAccountDomainsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountDomainsQuery,
        AccountDomainsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountDomainsQuery | undefined,
  AccountDomainsQueryVariables
>;
export function useAccountDomainsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountDomainsQuery,
        AccountDomainsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AccountDomainsQuery,
    AccountDomainsQueryVariables
  >(AccountDomainsDocument, options);
}
export type AccountDomainsQueryHookResult = ReturnType<
  typeof useAccountDomainsQuery
>;
export type AccountDomainsLazyQueryHookResult = ReturnType<
  typeof useAccountDomainsLazyQuery
>;
export type AccountDomainsSuspenseQueryHookResult = ReturnType<
  typeof useAccountDomainsSuspenseQuery
>;
export type AccountDomainsQueryResult = Apollo.QueryResult<
  AccountDomainsQuery,
  AccountDomainsQueryVariables
>;
export const RegisterAccountDomainDocument = gql`
  mutation RegisterAccountDomain($accountDomain: AdminV1AccountDomainInput!) {
    registerAccountDomain(accountDomain: $accountDomain) {
      ...AccountDomain
      ...DefaultError
    }
  }
  ${AccountDomainFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RegisterAccountDomainMutationFn = Apollo.MutationFunction<
  RegisterAccountDomainMutation,
  RegisterAccountDomainMutationVariables
>;

/**
 * __useRegisterAccountDomainMutation__
 *
 * To run a mutation, you first call `useRegisterAccountDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAccountDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAccountDomainMutation, { data, loading, error }] = useRegisterAccountDomainMutation({
 *   variables: {
 *      accountDomain: // value for 'accountDomain'
 *   },
 * });
 */
export function useRegisterAccountDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterAccountDomainMutation,
    RegisterAccountDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterAccountDomainMutation,
    RegisterAccountDomainMutationVariables
  >(RegisterAccountDomainDocument, options);
}
export type RegisterAccountDomainMutationHookResult = ReturnType<
  typeof useRegisterAccountDomainMutation
>;
export type RegisterAccountDomainMutationResult =
  Apollo.MutationResult<RegisterAccountDomainMutation>;
export type RegisterAccountDomainMutationOptions = Apollo.BaseMutationOptions<
  RegisterAccountDomainMutation,
  RegisterAccountDomainMutationVariables
>;
export const UnregisterAccountDomainDocument = gql`
  mutation UnregisterAccountDomain($domainId: String!) {
    unregisterAccountDomain(domainId: $domainId) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UnregisterAccountDomainMutationFn = Apollo.MutationFunction<
  UnregisterAccountDomainMutation,
  UnregisterAccountDomainMutationVariables
>;

/**
 * __useUnregisterAccountDomainMutation__
 *
 * To run a mutation, you first call `useUnregisterAccountDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterAccountDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterAccountDomainMutation, { data, loading, error }] = useUnregisterAccountDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useUnregisterAccountDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnregisterAccountDomainMutation,
    UnregisterAccountDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnregisterAccountDomainMutation,
    UnregisterAccountDomainMutationVariables
  >(UnregisterAccountDomainDocument, options);
}
export type UnregisterAccountDomainMutationHookResult = ReturnType<
  typeof useUnregisterAccountDomainMutation
>;
export type UnregisterAccountDomainMutationResult =
  Apollo.MutationResult<UnregisterAccountDomainMutation>;
export type UnregisterAccountDomainMutationOptions = Apollo.BaseMutationOptions<
  UnregisterAccountDomainMutation,
  UnregisterAccountDomainMutationVariables
>;
export const VerifyAccountDomainDocument = gql`
  mutation VerifyAccountDomain($domainId: String!) {
    verifyAccountDomain(domainId: $domainId) {
      ...AccountDomain
      ...DefaultError
    }
  }
  ${AccountDomainFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type VerifyAccountDomainMutationFn = Apollo.MutationFunction<
  VerifyAccountDomainMutation,
  VerifyAccountDomainMutationVariables
>;

/**
 * __useVerifyAccountDomainMutation__
 *
 * To run a mutation, you first call `useVerifyAccountDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountDomainMutation, { data, loading, error }] = useVerifyAccountDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useVerifyAccountDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyAccountDomainMutation,
    VerifyAccountDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyAccountDomainMutation,
    VerifyAccountDomainMutationVariables
  >(VerifyAccountDomainDocument, options);
}
export type VerifyAccountDomainMutationHookResult = ReturnType<
  typeof useVerifyAccountDomainMutation
>;
export type VerifyAccountDomainMutationResult =
  Apollo.MutationResult<VerifyAccountDomainMutation>;
export type VerifyAccountDomainMutationOptions = Apollo.BaseMutationOptions<
  VerifyAccountDomainMutation,
  VerifyAccountDomainMutationVariables
>;
export const AddGroupMembersDocument = gql`
  mutation AddGroupMembers($group: String!, $identities: [String!]!) {
    addGroupMembers(group: $group, identities: $identities) {
      ... on IamV1AddGroupMembersResponse {
        __typename
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type AddGroupMembersMutationFn = Apollo.MutationFunction<
  AddGroupMembersMutation,
  AddGroupMembersMutationVariables
>;

/**
 * __useAddGroupMembersMutation__
 *
 * To run a mutation, you first call `useAddGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupMembersMutation, { data, loading, error }] = useAddGroupMembersMutation({
 *   variables: {
 *      group: // value for 'group'
 *      identities: // value for 'identities'
 *   },
 * });
 */
export function useAddGroupMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddGroupMembersMutation,
    AddGroupMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddGroupMembersMutation,
    AddGroupMembersMutationVariables
  >(AddGroupMembersDocument, options);
}
export type AddGroupMembersMutationHookResult = ReturnType<
  typeof useAddGroupMembersMutation
>;
export type AddGroupMembersMutationResult =
  Apollo.MutationResult<AddGroupMembersMutation>;
export type AddGroupMembersMutationOptions = Apollo.BaseMutationOptions<
  AddGroupMembersMutation,
  AddGroupMembersMutationVariables
>;
export const AgentReviewPreviewUpdatedDocument = gql`
  subscription AgentReviewPreviewUpdated {
    agentReviewPreviewUpdated {
      agentReviewPreview {
        ...AgentReviewPreview
      }
    }
  }
  ${AgentReviewPreviewFragmentDoc}
`;

/**
 * __useAgentReviewPreviewUpdatedSubscription__
 *
 * To run a query within a React component, call `useAgentReviewPreviewUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentReviewPreviewUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentReviewPreviewUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAgentReviewPreviewUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AgentReviewPreviewUpdatedSubscription,
    AgentReviewPreviewUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AgentReviewPreviewUpdatedSubscription,
    AgentReviewPreviewUpdatedSubscriptionVariables
  >(AgentReviewPreviewUpdatedDocument, options);
}
export type AgentReviewPreviewUpdatedSubscriptionHookResult = ReturnType<
  typeof useAgentReviewPreviewUpdatedSubscription
>;
export type AgentReviewPreviewUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<AgentReviewPreviewUpdatedSubscription>;
export const ApiClientDetailsDocument = gql`
  query ApiClientDetails($name: String!) {
    apiClient(name: $name) {
      ...ApiClient
      ...DefaultError
    }
  }
  ${ApiClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useApiClientDetailsQuery__
 *
 * To run a query within a React component, call `useApiClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiClientDetailsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useApiClientDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApiClientDetailsQuery,
    ApiClientDetailsQueryVariables
  > &
    (
      | { variables: ApiClientDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApiClientDetailsQuery, ApiClientDetailsQueryVariables>(
    ApiClientDetailsDocument,
    options,
  );
}
export function useApiClientDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApiClientDetailsQuery,
    ApiClientDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApiClientDetailsQuery,
    ApiClientDetailsQueryVariables
  >(ApiClientDetailsDocument, options);
}
// @ts-ignore
export function useApiClientDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApiClientDetailsQuery,
    ApiClientDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ApiClientDetailsQuery,
  ApiClientDetailsQueryVariables
>;
export function useApiClientDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientDetailsQuery,
        ApiClientDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApiClientDetailsQuery | undefined,
  ApiClientDetailsQueryVariables
>;
export function useApiClientDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientDetailsQuery,
        ApiClientDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApiClientDetailsQuery,
    ApiClientDetailsQueryVariables
  >(ApiClientDetailsDocument, options);
}
export type ApiClientDetailsQueryHookResult = ReturnType<
  typeof useApiClientDetailsQuery
>;
export type ApiClientDetailsLazyQueryHookResult = ReturnType<
  typeof useApiClientDetailsLazyQuery
>;
export type ApiClientDetailsSuspenseQueryHookResult = ReturnType<
  typeof useApiClientDetailsSuspenseQuery
>;
export type ApiClientDetailsQueryResult = Apollo.QueryResult<
  ApiClientDetailsQuery,
  ApiClientDetailsQueryVariables
>;
export const ApiClientSecretDocument = gql`
  query ApiClientSecret($name: String!) {
    apiClientSecret(name: $name) {
      ... on IamV1ApiClientSecret {
        __typename
        clientSecret
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useApiClientSecretQuery__
 *
 * To run a query within a React component, call `useApiClientSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiClientSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiClientSecretQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useApiClientSecretQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApiClientSecretQuery,
    ApiClientSecretQueryVariables
  > &
    (
      | { variables: ApiClientSecretQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApiClientSecretQuery, ApiClientSecretQueryVariables>(
    ApiClientSecretDocument,
    options,
  );
}
export function useApiClientSecretLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApiClientSecretQuery,
    ApiClientSecretQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApiClientSecretQuery,
    ApiClientSecretQueryVariables
  >(ApiClientSecretDocument, options);
}
// @ts-ignore
export function useApiClientSecretSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApiClientSecretQuery,
    ApiClientSecretQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ApiClientSecretQuery,
  ApiClientSecretQueryVariables
>;
export function useApiClientSecretSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientSecretQuery,
        ApiClientSecretQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApiClientSecretQuery | undefined,
  ApiClientSecretQueryVariables
>;
export function useApiClientSecretSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientSecretQuery,
        ApiClientSecretQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApiClientSecretQuery,
    ApiClientSecretQueryVariables
  >(ApiClientSecretDocument, options);
}
export type ApiClientSecretQueryHookResult = ReturnType<
  typeof useApiClientSecretQuery
>;
export type ApiClientSecretLazyQueryHookResult = ReturnType<
  typeof useApiClientSecretLazyQuery
>;
export type ApiClientSecretSuspenseQueryHookResult = ReturnType<
  typeof useApiClientSecretSuspenseQuery
>;
export type ApiClientSecretQueryResult = Apollo.QueryResult<
  ApiClientSecretQuery,
  ApiClientSecretQueryVariables
>;
export const ClientCredentialDocument = gql`
  query ClientCredential($name: String!) {
    clientCredential(name: $name) {
      ...ClientCredential
      ...DefaultError
    }
  }
  ${ClientCredentialFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useClientCredentialQuery__
 *
 * To run a query within a React component, call `useClientCredentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCredentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCredentialQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientCredentialQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientCredentialQuery,
    ClientCredentialQueryVariables
  > &
    (
      | { variables: ClientCredentialQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientCredentialQuery, ClientCredentialQueryVariables>(
    ClientCredentialDocument,
    options,
  );
}
export function useClientCredentialLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientCredentialQuery,
    ClientCredentialQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientCredentialQuery,
    ClientCredentialQueryVariables
  >(ClientCredentialDocument, options);
}
// @ts-ignore
export function useClientCredentialSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClientCredentialQuery,
    ClientCredentialQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialQuery,
  ClientCredentialQueryVariables
>;
export function useClientCredentialSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialQuery,
        ClientCredentialQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialQuery | undefined,
  ClientCredentialQueryVariables
>;
export function useClientCredentialSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialQuery,
        ClientCredentialQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClientCredentialQuery,
    ClientCredentialQueryVariables
  >(ClientCredentialDocument, options);
}
export type ClientCredentialQueryHookResult = ReturnType<
  typeof useClientCredentialQuery
>;
export type ClientCredentialLazyQueryHookResult = ReturnType<
  typeof useClientCredentialLazyQuery
>;
export type ClientCredentialSuspenseQueryHookResult = ReturnType<
  typeof useClientCredentialSuspenseQuery
>;
export type ClientCredentialQueryResult = Apollo.QueryResult<
  ClientCredentialQuery,
  ClientCredentialQueryVariables
>;
export const ClientCredentialEncryptionKeyDocument = gql`
  query ClientCredentialEncryptionKey($name: String!) {
    clientCredentialEncryptionKey(name: $name) {
      ... on IamV1ClientCredentialEncryptionKey {
        __typename
        encryptionKey
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useClientCredentialEncryptionKeyQuery__
 *
 * To run a query within a React component, call `useClientCredentialEncryptionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCredentialEncryptionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCredentialEncryptionKeyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientCredentialEncryptionKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  > &
    (
      | {
          variables: ClientCredentialEncryptionKeyQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  >(ClientCredentialEncryptionKeyDocument, options);
}
export function useClientCredentialEncryptionKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  >(ClientCredentialEncryptionKeyDocument, options);
}
// @ts-ignore
export function useClientCredentialEncryptionKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialEncryptionKeyQuery,
  ClientCredentialEncryptionKeyQueryVariables
>;
export function useClientCredentialEncryptionKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialEncryptionKeyQuery,
        ClientCredentialEncryptionKeyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialEncryptionKeyQuery | undefined,
  ClientCredentialEncryptionKeyQueryVariables
>;
export function useClientCredentialEncryptionKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialEncryptionKeyQuery,
        ClientCredentialEncryptionKeyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClientCredentialEncryptionKeyQuery,
    ClientCredentialEncryptionKeyQueryVariables
  >(ClientCredentialEncryptionKeyDocument, options);
}
export type ClientCredentialEncryptionKeyQueryHookResult = ReturnType<
  typeof useClientCredentialEncryptionKeyQuery
>;
export type ClientCredentialEncryptionKeyLazyQueryHookResult = ReturnType<
  typeof useClientCredentialEncryptionKeyLazyQuery
>;
export type ClientCredentialEncryptionKeySuspenseQueryHookResult = ReturnType<
  typeof useClientCredentialEncryptionKeySuspenseQuery
>;
export type ClientCredentialEncryptionKeyQueryResult = Apollo.QueryResult<
  ClientCredentialEncryptionKeyQuery,
  ClientCredentialEncryptionKeyQueryVariables
>;
export const ClientCredentialsDocument = gql`
  query ClientCredentials(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    clientCredentials(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on IamV1ListClientCredentialsResponse {
        __typename
        clientCredentials {
          ...ClientCredential
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ClientCredentialFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useClientCredentialsQuery__
 *
 * To run a query within a React component, call `useClientCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCredentialsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useClientCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  > &
    (
      | { variables: ClientCredentialsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  >(ClientCredentialsDocument, options);
}
export function useClientCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  >(ClientCredentialsDocument, options);
}
// @ts-ignore
export function useClientCredentialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialsQuery,
  ClientCredentialsQueryVariables
>;
export function useClientCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialsQuery,
        ClientCredentialsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ClientCredentialsQuery | undefined,
  ClientCredentialsQueryVariables
>;
export function useClientCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientCredentialsQuery,
        ClientCredentialsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClientCredentialsQuery,
    ClientCredentialsQueryVariables
  >(ClientCredentialsDocument, options);
}
export type ClientCredentialsQueryHookResult = ReturnType<
  typeof useClientCredentialsQuery
>;
export type ClientCredentialsLazyQueryHookResult = ReturnType<
  typeof useClientCredentialsLazyQuery
>;
export type ClientCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useClientCredentialsSuspenseQuery
>;
export type ClientCredentialsQueryResult = Apollo.QueryResult<
  ClientCredentialsQuery,
  ClientCredentialsQueryVariables
>;
export const ConfigureSlackDocument = gql`
  mutation ConfigureSlack($code: String!, $stateToken: String!) {
    configureSlack(code: $code, stateToken: $stateToken) {
      ... on ActivityV1SlackAdminConfig {
        state
        teamId
        __typename
      }
      ... on Error {
        code
      }
    }
  }
`;
export type ConfigureSlackMutationFn = Apollo.MutationFunction<
  ConfigureSlackMutation,
  ConfigureSlackMutationVariables
>;

/**
 * __useConfigureSlackMutation__
 *
 * To run a mutation, you first call `useConfigureSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSlackMutation, { data, loading, error }] = useConfigureSlackMutation({
 *   variables: {
 *      code: // value for 'code'
 *      stateToken: // value for 'stateToken'
 *   },
 * });
 */
export function useConfigureSlackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigureSlackMutation,
    ConfigureSlackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfigureSlackMutation,
    ConfigureSlackMutationVariables
  >(ConfigureSlackDocument, options);
}
export type ConfigureSlackMutationHookResult = ReturnType<
  typeof useConfigureSlackMutation
>;
export type ConfigureSlackMutationResult =
  Apollo.MutationResult<ConfigureSlackMutation>;
export type ConfigureSlackMutationOptions = Apollo.BaseMutationOptions<
  ConfigureSlackMutation,
  ConfigureSlackMutationVariables
>;
export const CreateActivityFeedDocument = gql`
  mutation CreateActivityFeed($feed: ActivityV1FeedInput!, $feedId: String) {
    createFeed(feed: $feed, feedId: $feedId) {
      ... on ActivityV1Feed {
        __typename
        channels {
          email {
            address
          }
          slack {
            channel
          }
          webhook {
            uri
            id
          }
          priority
        }
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateActivityFeedMutationFn = Apollo.MutationFunction<
  CreateActivityFeedMutation,
  CreateActivityFeedMutationVariables
>;

/**
 * __useCreateActivityFeedMutation__
 *
 * To run a mutation, you first call `useCreateActivityFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityFeedMutation, { data, loading, error }] = useCreateActivityFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *      feedId: // value for 'feedId'
 *   },
 * });
 */
export function useCreateActivityFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateActivityFeedMutation,
    CreateActivityFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateActivityFeedMutation,
    CreateActivityFeedMutationVariables
  >(CreateActivityFeedDocument, options);
}
export type CreateActivityFeedMutationHookResult = ReturnType<
  typeof useCreateActivityFeedMutation
>;
export type CreateActivityFeedMutationResult =
  Apollo.MutationResult<CreateActivityFeedMutation>;
export type CreateActivityFeedMutationOptions = Apollo.BaseMutationOptions<
  CreateActivityFeedMutation,
  CreateActivityFeedMutationVariables
>;
export const CreateAgentReviewPreviewDocument = gql`
  mutation CreateAgentReviewPreview(
    $input: CollaborationV1AgentReviewPreviewInput!
  ) {
    createAgentReviewPreview(agentReviewPreview: $input) {
      ... on CollaborationV1AgentReviewPreview {
        ...AgentReviewPreview
      }
      ...DefaultError
    }
  }
  ${AgentReviewPreviewFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAgentReviewPreviewMutationFn = Apollo.MutationFunction<
  CreateAgentReviewPreviewMutation,
  CreateAgentReviewPreviewMutationVariables
>;

/**
 * __useCreateAgentReviewPreviewMutation__
 *
 * To run a mutation, you first call `useCreateAgentReviewPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentReviewPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentReviewPreviewMutation, { data, loading, error }] = useCreateAgentReviewPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentReviewPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAgentReviewPreviewMutation,
    CreateAgentReviewPreviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAgentReviewPreviewMutation,
    CreateAgentReviewPreviewMutationVariables
  >(CreateAgentReviewPreviewDocument, options);
}
export type CreateAgentReviewPreviewMutationHookResult = ReturnType<
  typeof useCreateAgentReviewPreviewMutation
>;
export type CreateAgentReviewPreviewMutationResult =
  Apollo.MutationResult<CreateAgentReviewPreviewMutation>;
export type CreateAgentReviewPreviewMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAgentReviewPreviewMutation,
    CreateAgentReviewPreviewMutationVariables
  >;
export const CreateApiClientDocument = gql`
  mutation CreateApiClient($apiClient: IamV1ApiClientInput!) {
    createApiClient(apiClient: $apiClient) {
      ...ApiClient
      ...DefaultError
    }
  }
  ${ApiClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateApiClientMutationFn = Apollo.MutationFunction<
  CreateApiClientMutation,
  CreateApiClientMutationVariables
>;

/**
 * __useCreateApiClientMutation__
 *
 * To run a mutation, you first call `useCreateApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiClientMutation, { data, loading, error }] = useCreateApiClientMutation({
 *   variables: {
 *      apiClient: // value for 'apiClient'
 *   },
 * });
 */
export function useCreateApiClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApiClientMutation,
    CreateApiClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateApiClientMutation,
    CreateApiClientMutationVariables
  >(CreateApiClientDocument, options);
}
export type CreateApiClientMutationHookResult = ReturnType<
  typeof useCreateApiClientMutation
>;
export type CreateApiClientMutationResult =
  Apollo.MutationResult<CreateApiClientMutation>;
export type CreateApiClientMutationOptions = Apollo.BaseMutationOptions<
  CreateApiClientMutation,
  CreateApiClientMutationVariables
>;
export const CreateClaudeAgentsIntegrationDocument = gql`
  mutation CreateClaudeAgentsIntegration(
    $apiKey: String!
    $agentId: String!
    $environmentId: String!
  ) {
    createExternalIntegration(
      externalIntegration: {
        claudeAgents: {
          apiKey: $apiKey
          agentId: $agentId
          environmentId: $environmentId
        }
      }
    ) {
      ... on AiworkflowsV1ExternalIntegration {
        __typename
        name
        integrationType
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateClaudeAgentsIntegrationMutationFn = Apollo.MutationFunction<
  CreateClaudeAgentsIntegrationMutation,
  CreateClaudeAgentsIntegrationMutationVariables
>;

/**
 * __useCreateClaudeAgentsIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateClaudeAgentsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClaudeAgentsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClaudeAgentsIntegrationMutation, { data, loading, error }] = useCreateClaudeAgentsIntegrationMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      agentId: // value for 'agentId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useCreateClaudeAgentsIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClaudeAgentsIntegrationMutation,
    CreateClaudeAgentsIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClaudeAgentsIntegrationMutation,
    CreateClaudeAgentsIntegrationMutationVariables
  >(CreateClaudeAgentsIntegrationDocument, options);
}
export type CreateClaudeAgentsIntegrationMutationHookResult = ReturnType<
  typeof useCreateClaudeAgentsIntegrationMutation
>;
export type CreateClaudeAgentsIntegrationMutationResult =
  Apollo.MutationResult<CreateClaudeAgentsIntegrationMutation>;
export type CreateClaudeAgentsIntegrationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateClaudeAgentsIntegrationMutation,
    CreateClaudeAgentsIntegrationMutationVariables
  >;
export const CreateClientCredentialDocument = gql`
  mutation CreateClientCredential(
    $parent: String!
    $clientCredential: IamV1ClientCredentialInput!
  ) {
    createClientCredential(
      parent: $parent
      clientCredential: $clientCredential
    ) {
      ...ClientCredential
      ...DefaultError
    }
  }
  ${ClientCredentialFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateClientCredentialMutationFn = Apollo.MutationFunction<
  CreateClientCredentialMutation,
  CreateClientCredentialMutationVariables
>;

/**
 * __useCreateClientCredentialMutation__
 *
 * To run a mutation, you first call `useCreateClientCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientCredentialMutation, { data, loading, error }] = useCreateClientCredentialMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      clientCredential: // value for 'clientCredential'
 *   },
 * });
 */
export function useCreateClientCredentialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClientCredentialMutation,
    CreateClientCredentialMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClientCredentialMutation,
    CreateClientCredentialMutationVariables
  >(CreateClientCredentialDocument, options);
}
export type CreateClientCredentialMutationHookResult = ReturnType<
  typeof useCreateClientCredentialMutation
>;
export type CreateClientCredentialMutationResult =
  Apollo.MutationResult<CreateClientCredentialMutation>;
export type CreateClientCredentialMutationOptions = Apollo.BaseMutationOptions<
  CreateClientCredentialMutation,
  CreateClientCredentialMutationVariables
>;
export const CreateCryptoKeyDocument = gql`
  mutation CreateCryptoKey($id: String!, $kind: IamV1CryptoKeyKind!) {
    createCryptoKey(cryptoKeyId: $id, cryptoKey: { kind: $kind }) {
      ... on IamV1CryptoKey {
        __typename
        name
        state
        kind
        publicKey
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateCryptoKeyMutationFn = Apollo.MutationFunction<
  CreateCryptoKeyMutation,
  CreateCryptoKeyMutationVariables
>;

/**
 * __useCreateCryptoKeyMutation__
 *
 * To run a mutation, you first call `useCreateCryptoKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCryptoKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCryptoKeyMutation, { data, loading, error }] = useCreateCryptoKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateCryptoKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCryptoKeyMutation,
    CreateCryptoKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCryptoKeyMutation,
    CreateCryptoKeyMutationVariables
  >(CreateCryptoKeyDocument, options);
}
export type CreateCryptoKeyMutationHookResult = ReturnType<
  typeof useCreateCryptoKeyMutation
>;
export type CreateCryptoKeyMutationResult =
  Apollo.MutationResult<CreateCryptoKeyMutation>;
export type CreateCryptoKeyMutationOptions = Apollo.BaseMutationOptions<
  CreateCryptoKeyMutation,
  CreateCryptoKeyMutationVariables
>;
export const CreateCursorIntegrationDocument = gql`
  mutation CreateCursorIntegration($apiKey: String!) {
    createExternalIntegration(
      externalIntegration: { cursor: { apiKey: $apiKey } }
    ) {
      ... on AiworkflowsV1ExternalIntegration {
        __typename
        name
        integrationType
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateCursorIntegrationMutationFn = Apollo.MutationFunction<
  CreateCursorIntegrationMutation,
  CreateCursorIntegrationMutationVariables
>;

/**
 * __useCreateCursorIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateCursorIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCursorIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCursorIntegrationMutation, { data, loading, error }] = useCreateCursorIntegrationMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useCreateCursorIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCursorIntegrationMutation,
    CreateCursorIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCursorIntegrationMutation,
    CreateCursorIntegrationMutationVariables
  >(CreateCursorIntegrationDocument, options);
}
export type CreateCursorIntegrationMutationHookResult = ReturnType<
  typeof useCreateCursorIntegrationMutation
>;
export type CreateCursorIntegrationMutationResult =
  Apollo.MutationResult<CreateCursorIntegrationMutation>;
export type CreateCursorIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateCursorIntegrationMutation,
  CreateCursorIntegrationMutationVariables
>;
export const CreateDataWarehouseDocument = gql`
  mutation CreateDataWarehouse($dataWarehouse: MetricsV1DataWarehouseInput!) {
    createDataWarehouse(dataWarehouse: $dataWarehouse) {
      ...DataWarehouse
      ...DefaultError
    }
  }
  ${DataWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateDataWarehouseMutationFn = Apollo.MutationFunction<
  CreateDataWarehouseMutation,
  CreateDataWarehouseMutationVariables
>;

/**
 * __useCreateDataWarehouseMutation__
 *
 * To run a mutation, you first call `useCreateDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataWarehouseMutation, { data, loading, error }] = useCreateDataWarehouseMutation({
 *   variables: {
 *      dataWarehouse: // value for 'dataWarehouse'
 *   },
 * });
 */
export function useCreateDataWarehouseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDataWarehouseMutation,
    CreateDataWarehouseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDataWarehouseMutation,
    CreateDataWarehouseMutationVariables
  >(CreateDataWarehouseDocument, options);
}
export type CreateDataWarehouseMutationHookResult = ReturnType<
  typeof useCreateDataWarehouseMutation
>;
export type CreateDataWarehouseMutationResult =
  Apollo.MutationResult<CreateDataWarehouseMutation>;
export type CreateDataWarehouseMutationOptions = Apollo.BaseMutationOptions<
  CreateDataWarehouseMutation,
  CreateDataWarehouseMutationVariables
>;
export const CreateEntityRelationTableDocument = gql`
  mutation CreateEntityRelationTable(
    $entityRelationTable: MetricsV1EntityRelationTableInput!
    $parent: String!
  ) {
    createEntityRelationTable(
      parent: $parent
      entityRelationTable: $entityRelationTable
    ) {
      ... on MetricsV1EntityRelationTable {
        name
      }
    }
  }
`;
export type CreateEntityRelationTableMutationFn = Apollo.MutationFunction<
  CreateEntityRelationTableMutation,
  CreateEntityRelationTableMutationVariables
>;

/**
 * __useCreateEntityRelationTableMutation__
 *
 * To run a mutation, you first call `useCreateEntityRelationTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityRelationTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityRelationTableMutation, { data, loading, error }] = useCreateEntityRelationTableMutation({
 *   variables: {
 *      entityRelationTable: // value for 'entityRelationTable'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateEntityRelationTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEntityRelationTableMutation,
    CreateEntityRelationTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEntityRelationTableMutation,
    CreateEntityRelationTableMutationVariables
  >(CreateEntityRelationTableDocument, options);
}
export type CreateEntityRelationTableMutationHookResult = ReturnType<
  typeof useCreateEntityRelationTableMutation
>;
export type CreateEntityRelationTableMutationResult =
  Apollo.MutationResult<CreateEntityRelationTableMutation>;
export type CreateEntityRelationTableMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEntityRelationTableMutation,
    CreateEntityRelationTableMutationVariables
  >;
export const CreateEvaluationContextFieldOverrideDocument = gql`
  mutation CreateEvaluationContextFieldOverride(
    $evaluationContextFieldOverride: FlagsAdminV1EvaluationContextFieldOverrideInput!
  ) {
    createEvaluationContextFieldOverride(
      evaluationContextFieldOverride: $evaluationContextFieldOverride
    ) {
      ...DefaultError
      ... on FlagsAdminV1EvaluationContextFieldOverride {
        ...EvaluationContextFieldOverride
        __typename
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EvaluationContextFieldOverrideFragmentDoc}
`;
export type CreateEvaluationContextFieldOverrideMutationFn =
  Apollo.MutationFunction<
    CreateEvaluationContextFieldOverrideMutation,
    CreateEvaluationContextFieldOverrideMutationVariables
  >;

/**
 * __useCreateEvaluationContextFieldOverrideMutation__
 *
 * To run a mutation, you first call `useCreateEvaluationContextFieldOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEvaluationContextFieldOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEvaluationContextFieldOverrideMutation, { data, loading, error }] = useCreateEvaluationContextFieldOverrideMutation({
 *   variables: {
 *      evaluationContextFieldOverride: // value for 'evaluationContextFieldOverride'
 *   },
 * });
 */
export function useCreateEvaluationContextFieldOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEvaluationContextFieldOverrideMutation,
    CreateEvaluationContextFieldOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEvaluationContextFieldOverrideMutation,
    CreateEvaluationContextFieldOverrideMutationVariables
  >(CreateEvaluationContextFieldOverrideDocument, options);
}
export type CreateEvaluationContextFieldOverrideMutationHookResult = ReturnType<
  typeof useCreateEvaluationContextFieldOverrideMutation
>;
export type CreateEvaluationContextFieldOverrideMutationResult =
  Apollo.MutationResult<CreateEvaluationContextFieldOverrideMutation>;
export type CreateEvaluationContextFieldOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEvaluationContextFieldOverrideMutation,
    CreateEvaluationContextFieldOverrideMutationVariables
  >;
export const CreateEventConnectionDocument = gql`
  mutation CreateEventConnection(
    $eventConnection: ConnectorsV1EventConnectionInput!
  ) {
    createEventConnection(eventConnection: $eventConnection) {
      ...EventConnection
      ...DefaultError
    }
  }
  ${EventConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateEventConnectionMutationFn = Apollo.MutationFunction<
  CreateEventConnectionMutation,
  CreateEventConnectionMutationVariables
>;

/**
 * __useCreateEventConnectionMutation__
 *
 * To run a mutation, you first call `useCreateEventConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventConnectionMutation, { data, loading, error }] = useCreateEventConnectionMutation({
 *   variables: {
 *      eventConnection: // value for 'eventConnection'
 *   },
 * });
 */
export function useCreateEventConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventConnectionMutation,
    CreateEventConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEventConnectionMutation,
    CreateEventConnectionMutationVariables
  >(CreateEventConnectionDocument, options);
}
export type CreateEventConnectionMutationHookResult = ReturnType<
  typeof useCreateEventConnectionMutation
>;
export type CreateEventConnectionMutationResult =
  Apollo.MutationResult<CreateEventConnectionMutation>;
export type CreateEventConnectionMutationOptions = Apollo.BaseMutationOptions<
  CreateEventConnectionMutation,
  CreateEventConnectionMutationVariables
>;
export const CreateFlagAppliedConnectionDocument = gql`
  mutation CreateFlagAppliedConnection(
    $flagAppliedConnection: ConnectorsV1FlagAppliedConnectionInput!
  ) {
    createFlagAppliedConnection(flagAppliedConnection: $flagAppliedConnection) {
      ...FlagAppliedConnection
      ...DefaultError
    }
  }
  ${FlagAppliedConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateFlagAppliedConnectionMutationFn = Apollo.MutationFunction<
  CreateFlagAppliedConnectionMutation,
  CreateFlagAppliedConnectionMutationVariables
>;

/**
 * __useCreateFlagAppliedConnectionMutation__
 *
 * To run a mutation, you first call `useCreateFlagAppliedConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlagAppliedConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlagAppliedConnectionMutation, { data, loading, error }] = useCreateFlagAppliedConnectionMutation({
 *   variables: {
 *      flagAppliedConnection: // value for 'flagAppliedConnection'
 *   },
 * });
 */
export function useCreateFlagAppliedConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFlagAppliedConnectionMutation,
    CreateFlagAppliedConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFlagAppliedConnectionMutation,
    CreateFlagAppliedConnectionMutationVariables
  >(CreateFlagAppliedConnectionDocument, options);
}
export type CreateFlagAppliedConnectionMutationHookResult = ReturnType<
  typeof useCreateFlagAppliedConnectionMutation
>;
export type CreateFlagAppliedConnectionMutationResult =
  Apollo.MutationResult<CreateFlagAppliedConnectionMutation>;
export type CreateFlagAppliedConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateFlagAppliedConnectionMutation,
    CreateFlagAppliedConnectionMutationVariables
  >;
export const CreateManagedDataWarehouseDocument = gql`
  mutation CreateManagedDataWarehouse {
    createManagedDataWarehouse {
      ... on OnboardingV1ManagedDataWarehouseProvisioning {
        __typename
        name
        state
        error
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateManagedDataWarehouseMutationFn = Apollo.MutationFunction<
  CreateManagedDataWarehouseMutation,
  CreateManagedDataWarehouseMutationVariables
>;

/**
 * __useCreateManagedDataWarehouseMutation__
 *
 * To run a mutation, you first call `useCreateManagedDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedDataWarehouseMutation, { data, loading, error }] = useCreateManagedDataWarehouseMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateManagedDataWarehouseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateManagedDataWarehouseMutation,
    CreateManagedDataWarehouseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateManagedDataWarehouseMutation,
    CreateManagedDataWarehouseMutationVariables
  >(CreateManagedDataWarehouseDocument, options);
}
export type CreateManagedDataWarehouseMutationHookResult = ReturnType<
  typeof useCreateManagedDataWarehouseMutation
>;
export type CreateManagedDataWarehouseMutationResult =
  Apollo.MutationResult<CreateManagedDataWarehouseMutation>;
export type CreateManagedDataWarehouseMutationOptions =
  Apollo.BaseMutationOptions<
    CreateManagedDataWarehouseMutation,
    CreateManagedDataWarehouseMutationVariables
  >;
export const CreateOAuthAppDocument = gql`
  mutation CreateOAuthApp($oauthApp: IamV1OAuthAppInput!) {
    createOAuthApp(oauthApp: $oauthApp) {
      ...OAuthApp
      ...DefaultError
    }
  }
  ${OAuthAppFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateOAuthAppMutationFn = Apollo.MutationFunction<
  CreateOAuthAppMutation,
  CreateOAuthAppMutationVariables
>;

/**
 * __useCreateOAuthAppMutation__
 *
 * To run a mutation, you first call `useCreateOAuthAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthAppMutation, { data, loading, error }] = useCreateOAuthAppMutation({
 *   variables: {
 *      oauthApp: // value for 'oauthApp'
 *   },
 * });
 */
export function useCreateOAuthAppMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOAuthAppMutation,
    CreateOAuthAppMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOAuthAppMutation,
    CreateOAuthAppMutationVariables
  >(CreateOAuthAppDocument, options);
}
export type CreateOAuthAppMutationHookResult = ReturnType<
  typeof useCreateOAuthAppMutation
>;
export type CreateOAuthAppMutationResult =
  Apollo.MutationResult<CreateOAuthAppMutation>;
export type CreateOAuthAppMutationOptions = Apollo.BaseMutationOptions<
  CreateOAuthAppMutation,
  CreateOAuthAppMutationVariables
>;
export const CreatePolicyDocument = gql`
  mutation CreatePolicy($policy: IamV1PolicyInput!) {
    createPolicy(policy: $policy) {
      ...Policy
      ...DefaultError
    }
  }
  ${PolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreatePolicyMutationFn = Apollo.MutationFunction<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;

/**
 * __useCreatePolicyMutation__
 *
 * To run a mutation, you first call `useCreatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyMutation, { data, loading, error }] = useCreatePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useCreatePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePolicyMutation,
    CreatePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePolicyMutation,
    CreatePolicyMutationVariables
  >(CreatePolicyDocument, options);
}
export type CreatePolicyMutationHookResult = ReturnType<
  typeof useCreatePolicyMutation
>;
export type CreatePolicyMutationResult =
  Apollo.MutationResult<CreatePolicyMutation>;
export type CreatePolicyMutationOptions = Apollo.BaseMutationOptions<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;
export const CreateUserInvitationDocument = gql`
  mutation CreateUserInvitation($userInvitation: IamV1UserInvitationInput!) {
    createUserInvitation(userInvitation: $userInvitation) {
      ...UserInvitation
      ...DefaultError
    }
  }
  ${UserInvitationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateUserInvitationMutationFn = Apollo.MutationFunction<
  CreateUserInvitationMutation,
  CreateUserInvitationMutationVariables
>;

/**
 * __useCreateUserInvitationMutation__
 *
 * To run a mutation, you first call `useCreateUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserInvitationMutation, { data, loading, error }] = useCreateUserInvitationMutation({
 *   variables: {
 *      userInvitation: // value for 'userInvitation'
 *   },
 * });
 */
export function useCreateUserInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserInvitationMutation,
    CreateUserInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserInvitationMutation,
    CreateUserInvitationMutationVariables
  >(CreateUserInvitationDocument, options);
}
export type CreateUserInvitationMutationHookResult = ReturnType<
  typeof useCreateUserInvitationMutation
>;
export type CreateUserInvitationMutationResult =
  Apollo.MutationResult<CreateUserInvitationMutation>;
export type CreateUserInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateUserInvitationMutation,
  CreateUserInvitationMutationVariables
>;
export const CreateWorkflowSecretDocument = gql`
  mutation CreateWorkflowSecret(
    $workflowSecret: WorkflowV1WorkflowSecretInput!
    $workflowSecretId: String!
  ) {
    createWorkflowSecret(
      workflowSecret: $workflowSecret
      workflowSecretId: $workflowSecretId
    ) {
      ... on WorkflowV1WorkflowSecret {
        name
        updateTime
      }
    }
  }
`;
export type CreateWorkflowSecretMutationFn = Apollo.MutationFunction<
  CreateWorkflowSecretMutation,
  CreateWorkflowSecretMutationVariables
>;

/**
 * __useCreateWorkflowSecretMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowSecretMutation, { data, loading, error }] = useCreateWorkflowSecretMutation({
 *   variables: {
 *      workflowSecret: // value for 'workflowSecret'
 *      workflowSecretId: // value for 'workflowSecretId'
 *   },
 * });
 */
export function useCreateWorkflowSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowSecretMutation,
    CreateWorkflowSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowSecretMutation,
    CreateWorkflowSecretMutationVariables
  >(CreateWorkflowSecretDocument, options);
}
export type CreateWorkflowSecretMutationHookResult = ReturnType<
  typeof useCreateWorkflowSecretMutation
>;
export type CreateWorkflowSecretMutationResult =
  Apollo.MutationResult<CreateWorkflowSecretMutation>;
export type CreateWorkflowSecretMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowSecretMutation,
  CreateWorkflowSecretMutationVariables
>;
export const CryptoKeyDocument = gql`
  query CryptoKey($name: String!) {
    cryptoKey(name: $name) {
      ... on IamV1CryptoKey {
        __typename
        name
        state
        kind
        publicKey
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCryptoKeyQuery__
 *
 * To run a query within a React component, call `useCryptoKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoKeyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCryptoKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    CryptoKeyQuery,
    CryptoKeyQueryVariables
  > &
    (
      | { variables: CryptoKeyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CryptoKeyQuery, CryptoKeyQueryVariables>(
    CryptoKeyDocument,
    options,
  );
}
export function useCryptoKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CryptoKeyQuery,
    CryptoKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CryptoKeyQuery, CryptoKeyQueryVariables>(
    CryptoKeyDocument,
    options,
  );
}
// @ts-ignore
export function useCryptoKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CryptoKeyQuery,
    CryptoKeyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CryptoKeyQuery, CryptoKeyQueryVariables>;
export function useCryptoKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CryptoKeyQuery, CryptoKeyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CryptoKeyQuery | undefined,
  CryptoKeyQueryVariables
>;
export function useCryptoKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CryptoKeyQuery, CryptoKeyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CryptoKeyQuery, CryptoKeyQueryVariables>(
    CryptoKeyDocument,
    options,
  );
}
export type CryptoKeyQueryHookResult = ReturnType<typeof useCryptoKeyQuery>;
export type CryptoKeyLazyQueryHookResult = ReturnType<
  typeof useCryptoKeyLazyQuery
>;
export type CryptoKeySuspenseQueryHookResult = ReturnType<
  typeof useCryptoKeySuspenseQuery
>;
export type CryptoKeyQueryResult = Apollo.QueryResult<
  CryptoKeyQuery,
  CryptoKeyQueryVariables
>;
export const CryptoKeysDocument = gql`
  query CryptoKeys($pageSize: Int, $pageToken: String) {
    cryptoKeys(pageSize: $pageSize, pageToken: $pageToken) {
      ... on IamV1ListCryptoKeysResponse {
        __typename
        cryptoKeys {
          name
          state
          kind
          publicKey
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCryptoKeysQuery__
 *
 * To run a query within a React component, call `useCryptoKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoKeysQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useCryptoKeysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CryptoKeysQuery,
    CryptoKeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CryptoKeysQuery, CryptoKeysQueryVariables>(
    CryptoKeysDocument,
    options,
  );
}
export function useCryptoKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CryptoKeysQuery,
    CryptoKeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CryptoKeysQuery, CryptoKeysQueryVariables>(
    CryptoKeysDocument,
    options,
  );
}
// @ts-ignore
export function useCryptoKeysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CryptoKeysQuery,
    CryptoKeysQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CryptoKeysQuery, CryptoKeysQueryVariables>;
export function useCryptoKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CryptoKeysQuery,
        CryptoKeysQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CryptoKeysQuery | undefined,
  CryptoKeysQueryVariables
>;
export function useCryptoKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CryptoKeysQuery,
        CryptoKeysQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CryptoKeysQuery, CryptoKeysQueryVariables>(
    CryptoKeysDocument,
    options,
  );
}
export type CryptoKeysQueryHookResult = ReturnType<typeof useCryptoKeysQuery>;
export type CryptoKeysLazyQueryHookResult = ReturnType<
  typeof useCryptoKeysLazyQuery
>;
export type CryptoKeysSuspenseQueryHookResult = ReturnType<
  typeof useCryptoKeysSuspenseQuery
>;
export type CryptoKeysQueryResult = Apollo.QueryResult<
  CryptoKeysQuery,
  CryptoKeysQueryVariables
>;
export const DeleteAgentIntegrationDocument = gql`
  mutation DeleteAgentIntegration($name: String!) {
    deleteExternalIntegration(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteAgentIntegrationMutationFn = Apollo.MutationFunction<
  DeleteAgentIntegrationMutation,
  DeleteAgentIntegrationMutationVariables
>;

/**
 * __useDeleteAgentIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteAgentIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentIntegrationMutation, { data, loading, error }] = useDeleteAgentIntegrationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAgentIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAgentIntegrationMutation,
    DeleteAgentIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAgentIntegrationMutation,
    DeleteAgentIntegrationMutationVariables
  >(DeleteAgentIntegrationDocument, options);
}
export type DeleteAgentIntegrationMutationHookResult = ReturnType<
  typeof useDeleteAgentIntegrationMutation
>;
export type DeleteAgentIntegrationMutationResult =
  Apollo.MutationResult<DeleteAgentIntegrationMutation>;
export type DeleteAgentIntegrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteAgentIntegrationMutation,
  DeleteAgentIntegrationMutationVariables
>;
export const DeleteApiClientDocument = gql`
  mutation DeleteApiClient($name: String!) {
    deleteApiClient(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteApiClientMutationFn = Apollo.MutationFunction<
  DeleteApiClientMutation,
  DeleteApiClientMutationVariables
>;

/**
 * __useDeleteApiClientMutation__
 *
 * To run a mutation, you first call `useDeleteApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiClientMutation, { data, loading, error }] = useDeleteApiClientMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteApiClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteApiClientMutation,
    DeleteApiClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteApiClientMutation,
    DeleteApiClientMutationVariables
  >(DeleteApiClientDocument, options);
}
export type DeleteApiClientMutationHookResult = ReturnType<
  typeof useDeleteApiClientMutation
>;
export type DeleteApiClientMutationResult =
  Apollo.MutationResult<DeleteApiClientMutation>;
export type DeleteApiClientMutationOptions = Apollo.BaseMutationOptions<
  DeleteApiClientMutation,
  DeleteApiClientMutationVariables
>;
export const DeleteClientCredentialDocument = gql`
  mutation DeleteClientCredential($name: String!) {
    deleteClientCredential(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteClientCredentialMutationFn = Apollo.MutationFunction<
  DeleteClientCredentialMutation,
  DeleteClientCredentialMutationVariables
>;

/**
 * __useDeleteClientCredentialMutation__
 *
 * To run a mutation, you first call `useDeleteClientCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientCredentialMutation, { data, loading, error }] = useDeleteClientCredentialMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteClientCredentialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClientCredentialMutation,
    DeleteClientCredentialMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClientCredentialMutation,
    DeleteClientCredentialMutationVariables
  >(DeleteClientCredentialDocument, options);
}
export type DeleteClientCredentialMutationHookResult = ReturnType<
  typeof useDeleteClientCredentialMutation
>;
export type DeleteClientCredentialMutationResult =
  Apollo.MutationResult<DeleteClientCredentialMutation>;
export type DeleteClientCredentialMutationOptions = Apollo.BaseMutationOptions<
  DeleteClientCredentialMutation,
  DeleteClientCredentialMutationVariables
>;
export const DeleteDataWarehouseDocument = gql`
  mutation DeleteDataWarehouse($name: String!) {
    deleteDataWarehouse(name: $name) {
      ... on MetricsV1DataWarehouse {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteDataWarehouseMutationFn = Apollo.MutationFunction<
  DeleteDataWarehouseMutation,
  DeleteDataWarehouseMutationVariables
>;

/**
 * __useDeleteDataWarehouseMutation__
 *
 * To run a mutation, you first call `useDeleteDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataWarehouseMutation, { data, loading, error }] = useDeleteDataWarehouseMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteDataWarehouseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDataWarehouseMutation,
    DeleteDataWarehouseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDataWarehouseMutation,
    DeleteDataWarehouseMutationVariables
  >(DeleteDataWarehouseDocument, options);
}
export type DeleteDataWarehouseMutationHookResult = ReturnType<
  typeof useDeleteDataWarehouseMutation
>;
export type DeleteDataWarehouseMutationResult =
  Apollo.MutationResult<DeleteDataWarehouseMutation>;
export type DeleteDataWarehouseMutationOptions = Apollo.BaseMutationOptions<
  DeleteDataWarehouseMutation,
  DeleteDataWarehouseMutationVariables
>;
export const DeleteEntityRelationTableDocument = gql`
  mutation DeleteEntityRelationTable($name: String!) {
    deleteEntityRelationTable(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEntityRelationTableMutationFn = Apollo.MutationFunction<
  DeleteEntityRelationTableMutation,
  DeleteEntityRelationTableMutationVariables
>;

/**
 * __useDeleteEntityRelationTableMutation__
 *
 * To run a mutation, you first call `useDeleteEntityRelationTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityRelationTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityRelationTableMutation, { data, loading, error }] = useDeleteEntityRelationTableMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEntityRelationTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEntityRelationTableMutation,
    DeleteEntityRelationTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEntityRelationTableMutation,
    DeleteEntityRelationTableMutationVariables
  >(DeleteEntityRelationTableDocument, options);
}
export type DeleteEntityRelationTableMutationHookResult = ReturnType<
  typeof useDeleteEntityRelationTableMutation
>;
export type DeleteEntityRelationTableMutationResult =
  Apollo.MutationResult<DeleteEntityRelationTableMutation>;
export type DeleteEntityRelationTableMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteEntityRelationTableMutation,
    DeleteEntityRelationTableMutationVariables
  >;
export const DeleteEvaluationContextFieldOverrideDocument = gql`
  mutation DeleteEvaluationContextFieldOverride($name: String!) {
    deleteEvaluationContextFieldOverride(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEvaluationContextFieldOverrideMutationFn =
  Apollo.MutationFunction<
    DeleteEvaluationContextFieldOverrideMutation,
    DeleteEvaluationContextFieldOverrideMutationVariables
  >;

/**
 * __useDeleteEvaluationContextFieldOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteEvaluationContextFieldOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEvaluationContextFieldOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEvaluationContextFieldOverrideMutation, { data, loading, error }] = useDeleteEvaluationContextFieldOverrideMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEvaluationContextFieldOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEvaluationContextFieldOverrideMutation,
    DeleteEvaluationContextFieldOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEvaluationContextFieldOverrideMutation,
    DeleteEvaluationContextFieldOverrideMutationVariables
  >(DeleteEvaluationContextFieldOverrideDocument, options);
}
export type DeleteEvaluationContextFieldOverrideMutationHookResult = ReturnType<
  typeof useDeleteEvaluationContextFieldOverrideMutation
>;
export type DeleteEvaluationContextFieldOverrideMutationResult =
  Apollo.MutationResult<DeleteEvaluationContextFieldOverrideMutation>;
export type DeleteEvaluationContextFieldOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteEvaluationContextFieldOverrideMutation,
    DeleteEvaluationContextFieldOverrideMutationVariables
  >;
export const DeleteEventConnectionDocument = gql`
  mutation DeleteEventConnection($name: String!) {
    deleteEventConnection(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEventConnectionMutationFn = Apollo.MutationFunction<
  DeleteEventConnectionMutation,
  DeleteEventConnectionMutationVariables
>;

/**
 * __useDeleteEventConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteEventConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventConnectionMutation, { data, loading, error }] = useDeleteEventConnectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEventConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEventConnectionMutation,
    DeleteEventConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEventConnectionMutation,
    DeleteEventConnectionMutationVariables
  >(DeleteEventConnectionDocument, options);
}
export type DeleteEventConnectionMutationHookResult = ReturnType<
  typeof useDeleteEventConnectionMutation
>;
export type DeleteEventConnectionMutationResult =
  Apollo.MutationResult<DeleteEventConnectionMutation>;
export type DeleteEventConnectionMutationOptions = Apollo.BaseMutationOptions<
  DeleteEventConnectionMutation,
  DeleteEventConnectionMutationVariables
>;
export const DeleteFeedDocument = gql`
  mutation DeleteFeed($name: String!, $force: Boolean) {
    deleteFeed(name: $name, force: $force) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteFeedMutationFn = Apollo.MutationFunction<
  DeleteFeedMutation,
  DeleteFeedMutationVariables
>;

/**
 * __useDeleteFeedMutation__
 *
 * To run a mutation, you first call `useDeleteFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedMutation, { data, loading, error }] = useDeleteFeedMutation({
 *   variables: {
 *      name: // value for 'name'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useDeleteFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFeedMutation,
    DeleteFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFeedMutation, DeleteFeedMutationVariables>(
    DeleteFeedDocument,
    options,
  );
}
export type DeleteFeedMutationHookResult = ReturnType<
  typeof useDeleteFeedMutation
>;
export type DeleteFeedMutationResult =
  Apollo.MutationResult<DeleteFeedMutation>;
export type DeleteFeedMutationOptions = Apollo.BaseMutationOptions<
  DeleteFeedMutation,
  DeleteFeedMutationVariables
>;
export const DeleteFlagAppliedConnectionDocument = gql`
  mutation DeleteFlagAppliedConnection($name: String!) {
    deleteFlagAppliedConnection(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteFlagAppliedConnectionMutationFn = Apollo.MutationFunction<
  DeleteFlagAppliedConnectionMutation,
  DeleteFlagAppliedConnectionMutationVariables
>;

/**
 * __useDeleteFlagAppliedConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteFlagAppliedConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFlagAppliedConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFlagAppliedConnectionMutation, { data, loading, error }] = useDeleteFlagAppliedConnectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteFlagAppliedConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFlagAppliedConnectionMutation,
    DeleteFlagAppliedConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFlagAppliedConnectionMutation,
    DeleteFlagAppliedConnectionMutationVariables
  >(DeleteFlagAppliedConnectionDocument, options);
}
export type DeleteFlagAppliedConnectionMutationHookResult = ReturnType<
  typeof useDeleteFlagAppliedConnectionMutation
>;
export type DeleteFlagAppliedConnectionMutationResult =
  Apollo.MutationResult<DeleteFlagAppliedConnectionMutation>;
export type DeleteFlagAppliedConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteFlagAppliedConnectionMutation,
    DeleteFlagAppliedConnectionMutationVariables
  >;
export const DeleteGithubIntegrationDocument = gql`
  mutation DeleteGithubIntegration($name: String!) {
    deleteExternalIntegration(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteGithubIntegrationMutationFn = Apollo.MutationFunction<
  DeleteGithubIntegrationMutation,
  DeleteGithubIntegrationMutationVariables
>;

/**
 * __useDeleteGithubIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteGithubIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGithubIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGithubIntegrationMutation, { data, loading, error }] = useDeleteGithubIntegrationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteGithubIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGithubIntegrationMutation,
    DeleteGithubIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteGithubIntegrationMutation,
    DeleteGithubIntegrationMutationVariables
  >(DeleteGithubIntegrationDocument, options);
}
export type DeleteGithubIntegrationMutationHookResult = ReturnType<
  typeof useDeleteGithubIntegrationMutation
>;
export type DeleteGithubIntegrationMutationResult =
  Apollo.MutationResult<DeleteGithubIntegrationMutation>;
export type DeleteGithubIntegrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteGithubIntegrationMutation,
  DeleteGithubIntegrationMutationVariables
>;
export const DeleteOAuthAppDocument = gql`
  mutation DeleteOAuthApp($name: String!) {
    deleteOAuthApp(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteOAuthAppMutationFn = Apollo.MutationFunction<
  DeleteOAuthAppMutation,
  DeleteOAuthAppMutationVariables
>;

/**
 * __useDeleteOAuthAppMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthAppMutation, { data, loading, error }] = useDeleteOAuthAppMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteOAuthAppMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOAuthAppMutation,
    DeleteOAuthAppMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOAuthAppMutation,
    DeleteOAuthAppMutationVariables
  >(DeleteOAuthAppDocument, options);
}
export type DeleteOAuthAppMutationHookResult = ReturnType<
  typeof useDeleteOAuthAppMutation
>;
export type DeleteOAuthAppMutationResult =
  Apollo.MutationResult<DeleteOAuthAppMutation>;
export type DeleteOAuthAppMutationOptions = Apollo.BaseMutationOptions<
  DeleteOAuthAppMutation,
  DeleteOAuthAppMutationVariables
>;
export const DeletePolicyDocument = gql`
  mutation DeletePolicy($name: String!) {
    deletePolicy(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeletePolicyMutationFn = Apollo.MutationFunction<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;

/**
 * __useDeletePolicyMutation__
 *
 * To run a mutation, you first call `useDeletePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyMutation, { data, loading, error }] = useDeletePolicyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeletePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >(DeletePolicyDocument, options);
}
export type DeletePolicyMutationHookResult = ReturnType<
  typeof useDeletePolicyMutation
>;
export type DeletePolicyMutationResult =
  Apollo.MutationResult<DeletePolicyMutation>;
export type DeletePolicyMutationOptions = Apollo.BaseMutationOptions<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($name: String!) {
    deleteUser(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options,
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult =
  Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const DeleteUserInvitationDocument = gql`
  mutation DeleteUserInvitation($name: String!) {
    deleteUserInvitation(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteUserInvitationMutationFn = Apollo.MutationFunction<
  DeleteUserInvitationMutation,
  DeleteUserInvitationMutationVariables
>;

/**
 * __useDeleteUserInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserInvitationMutation, { data, loading, error }] = useDeleteUserInvitationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteUserInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserInvitationMutation,
    DeleteUserInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteUserInvitationMutation,
    DeleteUserInvitationMutationVariables
  >(DeleteUserInvitationDocument, options);
}
export type DeleteUserInvitationMutationHookResult = ReturnType<
  typeof useDeleteUserInvitationMutation
>;
export type DeleteUserInvitationMutationResult =
  Apollo.MutationResult<DeleteUserInvitationMutation>;
export type DeleteUserInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserInvitationMutation,
  DeleteUserInvitationMutationVariables
>;
export const DeleteWorkflowSecretDocument = gql`
  mutation DeleteWorkflowSecret($deleteWorkflowSecretName: String!) {
    deleteWorkflowSecret(name: $deleteWorkflowSecretName) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteWorkflowSecretMutationFn = Apollo.MutationFunction<
  DeleteWorkflowSecretMutation,
  DeleteWorkflowSecretMutationVariables
>;

/**
 * __useDeleteWorkflowSecretMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowSecretMutation, { data, loading, error }] = useDeleteWorkflowSecretMutation({
 *   variables: {
 *      deleteWorkflowSecretName: // value for 'deleteWorkflowSecretName'
 *   },
 * });
 */
export function useDeleteWorkflowSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkflowSecretMutation,
    DeleteWorkflowSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkflowSecretMutation,
    DeleteWorkflowSecretMutationVariables
  >(DeleteWorkflowSecretDocument, options);
}
export type DeleteWorkflowSecretMutationHookResult = ReturnType<
  typeof useDeleteWorkflowSecretMutation
>;
export type DeleteWorkflowSecretMutationResult =
  Apollo.MutationResult<DeleteWorkflowSecretMutation>;
export type DeleteWorkflowSecretMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkflowSecretMutation,
  DeleteWorkflowSecretMutationVariables
>;
export const DimensionTablesPageDocument = gql`
  query DimensionTablesPage(
    $filter: String
    $pageToken: String
    $pageSize: Int
    $orderBy: String
  ) {
    dimensionTables(
      filter: $filter
      pageToken: $pageToken
      pageSize: $pageSize
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListDimensionTablesResponse {
        __typename
        dimensionTables {
          name
          displayName
          entityColumnMapping {
            entity {
              ... on MetricsV1Entity {
                __typename
                displayName
                name
              }
              ...DefaultError
            }
          }
          state
          error {
            message
            details
          }
          dimensions {
            name
          }
          dataWarehouse {
            ... on MetricsV1DataWarehouse {
              ...DataWarehouseRef
            }
            ...DefaultError
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
`;

/**
 * __useDimensionTablesPageQuery__
 *
 * To run a query within a React component, call `useDimensionTablesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionTablesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionTablesPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDimensionTablesPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >(DimensionTablesPageDocument, options);
}
export function useDimensionTablesPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >(DimensionTablesPageDocument, options);
}
// @ts-ignore
export function useDimensionTablesPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablesPageQuery,
  DimensionTablesPageQueryVariables
>;
export function useDimensionTablesPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablesPageQuery,
        DimensionTablesPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablesPageQuery | undefined,
  DimensionTablesPageQueryVariables
>;
export function useDimensionTablesPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablesPageQuery,
        DimensionTablesPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DimensionTablesPageQuery,
    DimensionTablesPageQueryVariables
  >(DimensionTablesPageDocument, options);
}
export type DimensionTablesPageQueryHookResult = ReturnType<
  typeof useDimensionTablesPageQuery
>;
export type DimensionTablesPageLazyQueryHookResult = ReturnType<
  typeof useDimensionTablesPageLazyQuery
>;
export type DimensionTablesPageSuspenseQueryHookResult = ReturnType<
  typeof useDimensionTablesPageSuspenseQuery
>;
export type DimensionTablesPageQueryResult = Apollo.QueryResult<
  DimensionTablesPageQuery,
  DimensionTablesPageQueryVariables
>;
export const DisableSlackDocument = gql`
  mutation DisableSlack {
    disableSlack {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DisableSlackMutationFn = Apollo.MutationFunction<
  DisableSlackMutation,
  DisableSlackMutationVariables
>;

/**
 * __useDisableSlackMutation__
 *
 * To run a mutation, you first call `useDisableSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSlackMutation, { data, loading, error }] = useDisableSlackMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableSlackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableSlackMutation,
    DisableSlackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableSlackMutation,
    DisableSlackMutationVariables
  >(DisableSlackDocument, options);
}
export type DisableSlackMutationHookResult = ReturnType<
  typeof useDisableSlackMutation
>;
export type DisableSlackMutationResult =
  Apollo.MutationResult<DisableSlackMutation>;
export type DisableSlackMutationOptions = Apollo.BaseMutationOptions<
  DisableSlackMutation,
  DisableSlackMutationVariables
>;
export const EvaluationContextFieldOverridesDocument = gql`
  query EvaluationContextFieldOverrides(
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    evaluationContextFieldOverrides(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on FlagsAdminV1ListEvaluationContextFieldOverridesResponse {
        evaluationContextFieldOverrides {
          ...EvaluationContextFieldOverride
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${EvaluationContextFieldOverrideFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEvaluationContextFieldOverridesQuery__
 *
 * To run a query within a React component, call `useEvaluationContextFieldOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationContextFieldOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationContextFieldOverridesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useEvaluationContextFieldOverridesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >(EvaluationContextFieldOverridesDocument, options);
}
export function useEvaluationContextFieldOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >(EvaluationContextFieldOverridesDocument, options);
}
// @ts-ignore
export function useEvaluationContextFieldOverridesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EvaluationContextFieldOverridesQuery,
  EvaluationContextFieldOverridesQueryVariables
>;
export function useEvaluationContextFieldOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EvaluationContextFieldOverridesQuery,
        EvaluationContextFieldOverridesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EvaluationContextFieldOverridesQuery | undefined,
  EvaluationContextFieldOverridesQueryVariables
>;
export function useEvaluationContextFieldOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EvaluationContextFieldOverridesQuery,
        EvaluationContextFieldOverridesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EvaluationContextFieldOverridesQuery,
    EvaluationContextFieldOverridesQueryVariables
  >(EvaluationContextFieldOverridesDocument, options);
}
export type EvaluationContextFieldOverridesQueryHookResult = ReturnType<
  typeof useEvaluationContextFieldOverridesQuery
>;
export type EvaluationContextFieldOverridesLazyQueryHookResult = ReturnType<
  typeof useEvaluationContextFieldOverridesLazyQuery
>;
export type EvaluationContextFieldOverridesSuspenseQueryHookResult = ReturnType<
  typeof useEvaluationContextFieldOverridesSuspenseQuery
>;
export type EvaluationContextFieldOverridesQueryResult = Apollo.QueryResult<
  EvaluationContextFieldOverridesQuery,
  EvaluationContextFieldOverridesQueryVariables
>;
export const EventConnectionDocument = gql`
  query EventConnection($eventConnectionName: String!) {
    eventConnection(name: $eventConnectionName) {
      ...EventConnection
      ...DefaultError
    }
  }
  ${EventConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEventConnectionQuery__
 *
 * To run a query within a React component, call `useEventConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventConnectionQuery({
 *   variables: {
 *      eventConnectionName: // value for 'eventConnectionName'
 *   },
 * });
 */
export function useEventConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    EventConnectionQuery,
    EventConnectionQueryVariables
  > &
    (
      | { variables: EventConnectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventConnectionQuery, EventConnectionQueryVariables>(
    EventConnectionDocument,
    options,
  );
}
export function useEventConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventConnectionQuery,
    EventConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EventConnectionQuery,
    EventConnectionQueryVariables
  >(EventConnectionDocument, options);
}
// @ts-ignore
export function useEventConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventConnectionQuery,
    EventConnectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EventConnectionQuery,
  EventConnectionQueryVariables
>;
export function useEventConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventConnectionQuery,
        EventConnectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventConnectionQuery | undefined,
  EventConnectionQueryVariables
>;
export function useEventConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventConnectionQuery,
        EventConnectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EventConnectionQuery,
    EventConnectionQueryVariables
  >(EventConnectionDocument, options);
}
export type EventConnectionQueryHookResult = ReturnType<
  typeof useEventConnectionQuery
>;
export type EventConnectionLazyQueryHookResult = ReturnType<
  typeof useEventConnectionLazyQuery
>;
export type EventConnectionSuspenseQueryHookResult = ReturnType<
  typeof useEventConnectionSuspenseQuery
>;
export type EventConnectionQueryResult = Apollo.QueryResult<
  EventConnectionQuery,
  EventConnectionQueryVariables
>;
export const EventConnectionsDocument = gql`
  query EventConnections($pageSize: Int, $pageToken: String) {
    eventConnections(pageSize: $pageSize, pageToken: $pageToken) {
      ... on ConnectorsV1ListEventConnectionsResponse {
        __typename
        eventConnections {
          ...EventConnection
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${EventConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEventConnectionsQuery__
 *
 * To run a query within a React component, call `useEventConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventConnectionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useEventConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EventConnectionsQuery,
    EventConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventConnectionsQuery, EventConnectionsQueryVariables>(
    EventConnectionsDocument,
    options,
  );
}
export function useEventConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventConnectionsQuery,
    EventConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EventConnectionsQuery,
    EventConnectionsQueryVariables
  >(EventConnectionsDocument, options);
}
// @ts-ignore
export function useEventConnectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventConnectionsQuery,
    EventConnectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EventConnectionsQuery,
  EventConnectionsQueryVariables
>;
export function useEventConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventConnectionsQuery,
        EventConnectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventConnectionsQuery | undefined,
  EventConnectionsQueryVariables
>;
export function useEventConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventConnectionsQuery,
        EventConnectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EventConnectionsQuery,
    EventConnectionsQueryVariables
  >(EventConnectionsDocument, options);
}
export type EventConnectionsQueryHookResult = ReturnType<
  typeof useEventConnectionsQuery
>;
export type EventConnectionsLazyQueryHookResult = ReturnType<
  typeof useEventConnectionsLazyQuery
>;
export type EventConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useEventConnectionsSuspenseQuery
>;
export type EventConnectionsQueryResult = Apollo.QueryResult<
  EventConnectionsQuery,
  EventConnectionsQueryVariables
>;
export const ExistsDataWarehousesDocument = gql`
  query ExistsDataWarehouses {
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
        demoData
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExistsDataWarehousesQuery__
 *
 * To run a query within a React component, call `useExistsDataWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistsDataWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistsDataWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistsDataWarehousesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >(ExistsDataWarehousesDocument, options);
}
export function useExistsDataWarehousesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >(ExistsDataWarehousesDocument, options);
}
// @ts-ignore
export function useExistsDataWarehousesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExistsDataWarehousesQuery,
  ExistsDataWarehousesQueryVariables
>;
export function useExistsDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExistsDataWarehousesQuery,
        ExistsDataWarehousesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExistsDataWarehousesQuery | undefined,
  ExistsDataWarehousesQueryVariables
>;
export function useExistsDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExistsDataWarehousesQuery,
        ExistsDataWarehousesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExistsDataWarehousesQuery,
    ExistsDataWarehousesQueryVariables
  >(ExistsDataWarehousesDocument, options);
}
export type ExistsDataWarehousesQueryHookResult = ReturnType<
  typeof useExistsDataWarehousesQuery
>;
export type ExistsDataWarehousesLazyQueryHookResult = ReturnType<
  typeof useExistsDataWarehousesLazyQuery
>;
export type ExistsDataWarehousesSuspenseQueryHookResult = ReturnType<
  typeof useExistsDataWarehousesSuspenseQuery
>;
export type ExistsDataWarehousesQueryResult = Apollo.QueryResult<
  ExistsDataWarehousesQuery,
  ExistsDataWarehousesQueryVariables
>;
export const ExistsSlackDocument = gql`
  query ExistsSlack {
    existsSlack {
      ... on ActivityV1SlackAdminConfig {
        __typename
        state
        teamId
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExistsSlackQuery__
 *
 * To run a query within a React component, call `useExistsSlackQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistsSlackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistsSlackQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistsSlackQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExistsSlackQuery,
    ExistsSlackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExistsSlackQuery, ExistsSlackQueryVariables>(
    ExistsSlackDocument,
    options,
  );
}
export function useExistsSlackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExistsSlackQuery,
    ExistsSlackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExistsSlackQuery, ExistsSlackQueryVariables>(
    ExistsSlackDocument,
    options,
  );
}
// @ts-ignore
export function useExistsSlackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExistsSlackQuery,
    ExistsSlackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExistsSlackQuery, ExistsSlackQueryVariables>;
export function useExistsSlackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExistsSlackQuery,
        ExistsSlackQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExistsSlackQuery | undefined,
  ExistsSlackQueryVariables
>;
export function useExistsSlackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExistsSlackQuery,
        ExistsSlackQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExistsSlackQuery, ExistsSlackQueryVariables>(
    ExistsSlackDocument,
    options,
  );
}
export type ExistsSlackQueryHookResult = ReturnType<typeof useExistsSlackQuery>;
export type ExistsSlackLazyQueryHookResult = ReturnType<
  typeof useExistsSlackLazyQuery
>;
export type ExistsSlackSuspenseQueryHookResult = ReturnType<
  typeof useExistsSlackSuspenseQuery
>;
export type ExistsSlackQueryResult = Apollo.QueryResult<
  ExistsSlackQuery,
  ExistsSlackQueryVariables
>;
export const FactTablePageListDocument = gql`
  query FactTablePageList(
    $pageToken: String
    $filter: String
    $orderBy: String
    $pageSize: Int
  ) {
    factTables(
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
      pageSize: $pageSize
    ) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        nextPageToken
        factTables {
          displayName
          name
          measures {
            column {
              name
            }
          }
          entities {
            entity {
              ... on MetricsV1Entity {
                __typename
                name
                displayName
              }
              ...DefaultError
            }
          }
          state
          error {
            ...MetricsTableError
          }
          dataWarehouse {
            ... on MetricsV1DataWarehouse {
              ...DataWarehouseRef
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
`;

/**
 * __useFactTablePageListQuery__
 *
 * To run a query within a React component, call `useFactTablePageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactTablePageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactTablePageListQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useFactTablePageListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >(FactTablePageListDocument, options);
}
export function useFactTablePageListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >(FactTablePageListDocument, options);
}
// @ts-ignore
export function useFactTablePageListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FactTablePageListQuery,
  FactTablePageListQueryVariables
>;
export function useFactTablePageListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTablePageListQuery,
        FactTablePageListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FactTablePageListQuery | undefined,
  FactTablePageListQueryVariables
>;
export function useFactTablePageListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTablePageListQuery,
        FactTablePageListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FactTablePageListQuery,
    FactTablePageListQueryVariables
  >(FactTablePageListDocument, options);
}
export type FactTablePageListQueryHookResult = ReturnType<
  typeof useFactTablePageListQuery
>;
export type FactTablePageListLazyQueryHookResult = ReturnType<
  typeof useFactTablePageListLazyQuery
>;
export type FactTablePageListSuspenseQueryHookResult = ReturnType<
  typeof useFactTablePageListSuspenseQuery
>;
export type FactTablePageListQueryResult = Apollo.QueryResult<
  FactTablePageListQuery,
  FactTablePageListQueryVariables
>;
export const FeedsDocument = gql`
  query Feeds($pageSize: Int, $pageToken: String) {
    feeds(pageSize: $pageSize, pageToken: $pageToken) {
      ...DefaultError
      ... on ActivityV1ListFeedsResponse {
        __typename
        feeds {
          ...Feed
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${FeedFragmentDoc}
`;

/**
 * __useFeedsQuery__
 *
 * To run a query within a React component, call `useFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFeedsQuery(
  baseOptions?: Apollo.QueryHookOptions<FeedsQuery, FeedsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeedsQuery, FeedsQueryVariables>(
    FeedsDocument,
    options,
  );
}
export function useFeedsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FeedsQuery, FeedsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FeedsQuery, FeedsQueryVariables>(
    FeedsDocument,
    options,
  );
}
// @ts-ignore
export function useFeedsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FeedsQuery,
    FeedsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FeedsQuery, FeedsQueryVariables>;
export function useFeedsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FeedsQuery, FeedsQueryVariables>,
): Apollo.UseSuspenseQueryResult<FeedsQuery | undefined, FeedsQueryVariables>;
export function useFeedsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FeedsQuery, FeedsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FeedsQuery, FeedsQueryVariables>(
    FeedsDocument,
    options,
  );
}
export type FeedsQueryHookResult = ReturnType<typeof useFeedsQuery>;
export type FeedsLazyQueryHookResult = ReturnType<typeof useFeedsLazyQuery>;
export type FeedsSuspenseQueryHookResult = ReturnType<
  typeof useFeedsSuspenseQuery
>;
export type FeedsQueryResult = Apollo.QueryResult<
  FeedsQuery,
  FeedsQueryVariables
>;
export const FlagAppliedConnectionDocument = gql`
  query FlagAppliedConnection($flagAppliedConnectionName: String!) {
    flagAppliedConnection(name: $flagAppliedConnectionName) {
      ...FlagAppliedConnection
      ...DefaultError
    }
  }
  ${FlagAppliedConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagAppliedConnectionQuery__
 *
 * To run a query within a React component, call `useFlagAppliedConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagAppliedConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagAppliedConnectionQuery({
 *   variables: {
 *      flagAppliedConnectionName: // value for 'flagAppliedConnectionName'
 *   },
 * });
 */
export function useFlagAppliedConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  > &
    (
      | { variables: FlagAppliedConnectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  >(FlagAppliedConnectionDocument, options);
}
export function useFlagAppliedConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  >(FlagAppliedConnectionDocument, options);
}
// @ts-ignore
export function useFlagAppliedConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FlagAppliedConnectionQuery,
  FlagAppliedConnectionQueryVariables
>;
export function useFlagAppliedConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagAppliedConnectionQuery,
        FlagAppliedConnectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagAppliedConnectionQuery | undefined,
  FlagAppliedConnectionQueryVariables
>;
export function useFlagAppliedConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagAppliedConnectionQuery,
        FlagAppliedConnectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FlagAppliedConnectionQuery,
    FlagAppliedConnectionQueryVariables
  >(FlagAppliedConnectionDocument, options);
}
export type FlagAppliedConnectionQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionQuery
>;
export type FlagAppliedConnectionLazyQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionLazyQuery
>;
export type FlagAppliedConnectionSuspenseQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionSuspenseQuery
>;
export type FlagAppliedConnectionQueryResult = Apollo.QueryResult<
  FlagAppliedConnectionQuery,
  FlagAppliedConnectionQueryVariables
>;
export const FlagAppliedConnectionsDocument = gql`
  query FlagAppliedConnections($pageSize: Int, $pageToken: String) {
    flagAppliedConnections(pageSize: $pageSize, pageToken: $pageToken) {
      ... on ConnectorsV1ListFlagAppliedConnectionsResponse {
        __typename
        flagAppliedConnections {
          ...FlagAppliedConnection
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FlagAppliedConnectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagAppliedConnectionsQuery__
 *
 * To run a query within a React component, call `useFlagAppliedConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagAppliedConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagAppliedConnectionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFlagAppliedConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >(FlagAppliedConnectionsDocument, options);
}
export function useFlagAppliedConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >(FlagAppliedConnectionsDocument, options);
}
// @ts-ignore
export function useFlagAppliedConnectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FlagAppliedConnectionsQuery,
  FlagAppliedConnectionsQueryVariables
>;
export function useFlagAppliedConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagAppliedConnectionsQuery,
        FlagAppliedConnectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagAppliedConnectionsQuery | undefined,
  FlagAppliedConnectionsQueryVariables
>;
export function useFlagAppliedConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagAppliedConnectionsQuery,
        FlagAppliedConnectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FlagAppliedConnectionsQuery,
    FlagAppliedConnectionsQueryVariables
  >(FlagAppliedConnectionsDocument, options);
}
export type FlagAppliedConnectionsQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionsQuery
>;
export type FlagAppliedConnectionsLazyQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionsLazyQuery
>;
export type FlagAppliedConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useFlagAppliedConnectionsSuspenseQuery
>;
export type FlagAppliedConnectionsQueryResult = Apollo.QueryResult<
  FlagAppliedConnectionsQuery,
  FlagAppliedConnectionsQueryVariables
>;
export const GetClientSchemaDocument = gql`
  mutation GetClientSchema($clients: [String!]!) {
    deriveClientEvaluationContextSchema(clients: $clients) {
      ... on FlagsAdminV1DeriveClientEvaluationContextSchemaResponse {
        mergedSchema {
          ...ContextSchema
        }
        capped
        __typename
      }
      ...DefaultError
    }
  }
  ${ContextSchemaFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type GetClientSchemaMutationFn = Apollo.MutationFunction<
  GetClientSchemaMutation,
  GetClientSchemaMutationVariables
>;

/**
 * __useGetClientSchemaMutation__
 *
 * To run a mutation, you first call `useGetClientSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetClientSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getClientSchemaMutation, { data, loading, error }] = useGetClientSchemaMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *   },
 * });
 */
export function useGetClientSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetClientSchemaMutation,
    GetClientSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetClientSchemaMutation,
    GetClientSchemaMutationVariables
  >(GetClientSchemaDocument, options);
}
export type GetClientSchemaMutationHookResult = ReturnType<
  typeof useGetClientSchemaMutation
>;
export type GetClientSchemaMutationResult =
  Apollo.MutationResult<GetClientSchemaMutation>;
export type GetClientSchemaMutationOptions = Apollo.BaseMutationOptions<
  GetClientSchemaMutation,
  GetClientSchemaMutationVariables
>;
export const GetCurrentAccountAutojoinDocument = gql`
  query GetCurrentAccountAutojoin {
    currentAccount {
      ... on AdminV1AccountInfo {
        __typename
        authConnections {
          autoJoin
        }
        allowedLoginEmailDomains
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetCurrentAccountAutojoinQuery__
 *
 * To run a query within a React component, call `useGetCurrentAccountAutojoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAccountAutojoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAccountAutojoinQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAccountAutojoinQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >(GetCurrentAccountAutojoinDocument, options);
}
export function useGetCurrentAccountAutojoinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >(GetCurrentAccountAutojoinDocument, options);
}
// @ts-ignore
export function useGetCurrentAccountAutojoinSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentAccountAutojoinQuery,
  GetCurrentAccountAutojoinQueryVariables
>;
export function useGetCurrentAccountAutojoinSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentAccountAutojoinQuery,
        GetCurrentAccountAutojoinQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentAccountAutojoinQuery | undefined,
  GetCurrentAccountAutojoinQueryVariables
>;
export function useGetCurrentAccountAutojoinSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentAccountAutojoinQuery,
        GetCurrentAccountAutojoinQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentAccountAutojoinQuery,
    GetCurrentAccountAutojoinQueryVariables
  >(GetCurrentAccountAutojoinDocument, options);
}
export type GetCurrentAccountAutojoinQueryHookResult = ReturnType<
  typeof useGetCurrentAccountAutojoinQuery
>;
export type GetCurrentAccountAutojoinLazyQueryHookResult = ReturnType<
  typeof useGetCurrentAccountAutojoinLazyQuery
>;
export type GetCurrentAccountAutojoinSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentAccountAutojoinSuspenseQuery
>;
export type GetCurrentAccountAutojoinQueryResult = Apollo.QueryResult<
  GetCurrentAccountAutojoinQuery,
  GetCurrentAccountAutojoinQueryVariables
>;
export const GetCurrentUserServiceAccountIdDocument = gql`
  query GetCurrentUserServiceAccountId {
    currentUser {
      ... on IamV1CurrentUser {
        __typename
        user {
          name
        }
        serviceAccountOauth2ClientId
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetCurrentUserServiceAccountIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserServiceAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserServiceAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserServiceAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserServiceAccountIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >(GetCurrentUserServiceAccountIdDocument, options);
}
export function useGetCurrentUserServiceAccountIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >(GetCurrentUserServiceAccountIdDocument, options);
}
// @ts-ignore
export function useGetCurrentUserServiceAccountIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentUserServiceAccountIdQuery,
  GetCurrentUserServiceAccountIdQueryVariables
>;
export function useGetCurrentUserServiceAccountIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentUserServiceAccountIdQuery,
        GetCurrentUserServiceAccountIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentUserServiceAccountIdQuery | undefined,
  GetCurrentUserServiceAccountIdQueryVariables
>;
export function useGetCurrentUserServiceAccountIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentUserServiceAccountIdQuery,
        GetCurrentUserServiceAccountIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentUserServiceAccountIdQuery,
    GetCurrentUserServiceAccountIdQueryVariables
  >(GetCurrentUserServiceAccountIdDocument, options);
}
export type GetCurrentUserServiceAccountIdQueryHookResult = ReturnType<
  typeof useGetCurrentUserServiceAccountIdQuery
>;
export type GetCurrentUserServiceAccountIdLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserServiceAccountIdLazyQuery
>;
export type GetCurrentUserServiceAccountIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentUserServiceAccountIdSuspenseQuery
>;
export type GetCurrentUserServiceAccountIdQueryResult = Apollo.QueryResult<
  GetCurrentUserServiceAccountIdQuery,
  GetCurrentUserServiceAccountIdQueryVariables
>;
export const GetEntityRelationTableDocument = gql`
  query GetEntityRelationTable($name: String!, $parentEntityName: String!) {
    entityRelationTable(name: $name) {
      ... on MetricsV1EntityRelationTable {
        __typename
        name
        parentEntityIdColumn {
          name
          type
        }
        targetEntityIdColumn {
          name
          type
        }
        state
        sql
        targetEntity {
          ... on MetricsV1Entity {
            name
            displayName
            __typename
          }
          ...DefaultError
        }
        error {
          ...MetricsTableError
        }
        resourceRelations {
          ... on FgaV1ListResourceRelationsResponse {
            __typename
            resourceRelations {
              relation
              resource
            }
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
    entity(name: $parentEntityName) {
      ... on MetricsV1Entity {
        name
        displayName
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${MetricsTableErrorFragmentDoc}
`;

/**
 * __useGetEntityRelationTableQuery__
 *
 * To run a query within a React component, call `useGetEntityRelationTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityRelationTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityRelationTableQuery({
 *   variables: {
 *      name: // value for 'name'
 *      parentEntityName: // value for 'parentEntityName'
 *   },
 * });
 */
export function useGetEntityRelationTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  > &
    (
      | { variables: GetEntityRelationTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  >(GetEntityRelationTableDocument, options);
}
export function useGetEntityRelationTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  >(GetEntityRelationTableDocument, options);
}
// @ts-ignore
export function useGetEntityRelationTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEntityRelationTableQuery,
  GetEntityRelationTableQueryVariables
>;
export function useGetEntityRelationTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEntityRelationTableQuery,
        GetEntityRelationTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEntityRelationTableQuery | undefined,
  GetEntityRelationTableQueryVariables
>;
export function useGetEntityRelationTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEntityRelationTableQuery,
        GetEntityRelationTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEntityRelationTableQuery,
    GetEntityRelationTableQueryVariables
  >(GetEntityRelationTableDocument, options);
}
export type GetEntityRelationTableQueryHookResult = ReturnType<
  typeof useGetEntityRelationTableQuery
>;
export type GetEntityRelationTableLazyQueryHookResult = ReturnType<
  typeof useGetEntityRelationTableLazyQuery
>;
export type GetEntityRelationTableSuspenseQueryHookResult = ReturnType<
  typeof useGetEntityRelationTableSuspenseQuery
>;
export type GetEntityRelationTableQueryResult = Apollo.QueryResult<
  GetEntityRelationTableQuery,
  GetEntityRelationTableQueryVariables
>;
export const GetFactTableDocument = gql`
  query GetFactTable($name: String!) {
    factTable(name: $name) {
      ...FactTable
      ...DefaultError
    }
  }
  ${FactTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetFactTableQuery__
 *
 * To run a query within a React component, call `useGetFactTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactTableQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFactTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFactTableQuery,
    GetFactTableQueryVariables
  > &
    (
      | { variables: GetFactTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFactTableQuery, GetFactTableQueryVariables>(
    GetFactTableDocument,
    options,
  );
}
export function useGetFactTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFactTableQuery,
    GetFactTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFactTableQuery, GetFactTableQueryVariables>(
    GetFactTableDocument,
    options,
  );
}
// @ts-ignore
export function useGetFactTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFactTableQuery,
    GetFactTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFactTableQuery, GetFactTableQueryVariables>;
export function useGetFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFactTableQuery,
        GetFactTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFactTableQuery | undefined,
  GetFactTableQueryVariables
>;
export function useGetFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFactTableQuery,
        GetFactTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFactTableQuery, GetFactTableQueryVariables>(
    GetFactTableDocument,
    options,
  );
}
export type GetFactTableQueryHookResult = ReturnType<
  typeof useGetFactTableQuery
>;
export type GetFactTableLazyQueryHookResult = ReturnType<
  typeof useGetFactTableLazyQuery
>;
export type GetFactTableSuspenseQueryHookResult = ReturnType<
  typeof useGetFactTableSuspenseQuery
>;
export type GetFactTableQueryResult = Apollo.QueryResult<
  GetFactTableQuery,
  GetFactTableQueryVariables
>;
export const GetManagedWarehouseProvisioningDocument = gql`
  query GetManagedWarehouseProvisioning {
    managedDataWarehouseProvisioning(
      name: "managedDataWarehouseProvisionings/confidence-managed"
    ) {
      ... on OnboardingV1ManagedDataWarehouseProvisioning {
        __typename
        name
        state
        error
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetManagedWarehouseProvisioningQuery__
 *
 * To run a query within a React component, call `useGetManagedWarehouseProvisioningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedWarehouseProvisioningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedWarehouseProvisioningQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagedWarehouseProvisioningQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >(GetManagedWarehouseProvisioningDocument, options);
}
export function useGetManagedWarehouseProvisioningLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >(GetManagedWarehouseProvisioningDocument, options);
}
// @ts-ignore
export function useGetManagedWarehouseProvisioningSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetManagedWarehouseProvisioningQuery,
  GetManagedWarehouseProvisioningQueryVariables
>;
export function useGetManagedWarehouseProvisioningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetManagedWarehouseProvisioningQuery,
        GetManagedWarehouseProvisioningQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetManagedWarehouseProvisioningQuery | undefined,
  GetManagedWarehouseProvisioningQueryVariables
>;
export function useGetManagedWarehouseProvisioningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetManagedWarehouseProvisioningQuery,
        GetManagedWarehouseProvisioningQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetManagedWarehouseProvisioningQuery,
    GetManagedWarehouseProvisioningQueryVariables
  >(GetManagedWarehouseProvisioningDocument, options);
}
export type GetManagedWarehouseProvisioningQueryHookResult = ReturnType<
  typeof useGetManagedWarehouseProvisioningQuery
>;
export type GetManagedWarehouseProvisioningLazyQueryHookResult = ReturnType<
  typeof useGetManagedWarehouseProvisioningLazyQuery
>;
export type GetManagedWarehouseProvisioningSuspenseQueryHookResult = ReturnType<
  typeof useGetManagedWarehouseProvisioningSuspenseQuery
>;
export type GetManagedWarehouseProvisioningQueryResult = Apollo.QueryResult<
  GetManagedWarehouseProvisioningQuery,
  GetManagedWarehouseProvisioningQueryVariables
>;
export const GetPreviewSqlJobDocument = gql`
  query GetPreviewSqlJob($name: String!) {
    sqlJob(name: $name) {
      ...SqlJob
      ...DefaultError
    }
  }
  ${SqlJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetPreviewSqlJobQuery__
 *
 * To run a query within a React component, call `useGetPreviewSqlJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewSqlJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewSqlJobQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPreviewSqlJobQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPreviewSqlJobQuery,
    GetPreviewSqlJobQueryVariables
  > &
    (
      | { variables: GetPreviewSqlJobQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPreviewSqlJobQuery, GetPreviewSqlJobQueryVariables>(
    GetPreviewSqlJobDocument,
    options,
  );
}
export function useGetPreviewSqlJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviewSqlJobQuery,
    GetPreviewSqlJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviewSqlJobQuery,
    GetPreviewSqlJobQueryVariables
  >(GetPreviewSqlJobDocument, options);
}
// @ts-ignore
export function useGetPreviewSqlJobSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPreviewSqlJobQuery,
    GetPreviewSqlJobQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPreviewSqlJobQuery,
  GetPreviewSqlJobQueryVariables
>;
export function useGetPreviewSqlJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPreviewSqlJobQuery,
        GetPreviewSqlJobQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPreviewSqlJobQuery | undefined,
  GetPreviewSqlJobQueryVariables
>;
export function useGetPreviewSqlJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPreviewSqlJobQuery,
        GetPreviewSqlJobQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPreviewSqlJobQuery,
    GetPreviewSqlJobQueryVariables
  >(GetPreviewSqlJobDocument, options);
}
export type GetPreviewSqlJobQueryHookResult = ReturnType<
  typeof useGetPreviewSqlJobQuery
>;
export type GetPreviewSqlJobLazyQueryHookResult = ReturnType<
  typeof useGetPreviewSqlJobLazyQuery
>;
export type GetPreviewSqlJobSuspenseQueryHookResult = ReturnType<
  typeof useGetPreviewSqlJobSuspenseQuery
>;
export type GetPreviewSqlJobQueryResult = Apollo.QueryResult<
  GetPreviewSqlJobQuery,
  GetPreviewSqlJobQueryVariables
>;
export const GetWorkflowDetailsDocument = gql`
  query GetWorkflowDetails($name: String!) {
    workflow(name: $name) {
      ... on WorkflowV1Workflow {
        __typename
        name
        displayName
        currentVersion {
          ... on WorkflowV1WorkflowVersion {
            name
            updater {
              ... on IamV1Identity {
                name
              }
            }
          }
        }
        createTime
        creator {
          ... on IamV1Identity {
            __typename
            name
            displayName
          }
          ...DefaultError
        }
        name
        builtin
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowDetailsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetWorkflowDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  > &
    (
      | { variables: GetWorkflowDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  >(GetWorkflowDetailsDocument, options);
}
export function useGetWorkflowDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  >(GetWorkflowDetailsDocument, options);
}
// @ts-ignore
export function useGetWorkflowDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowDetailsQuery,
  GetWorkflowDetailsQueryVariables
>;
export function useGetWorkflowDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowDetailsQuery,
        GetWorkflowDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowDetailsQuery | undefined,
  GetWorkflowDetailsQueryVariables
>;
export function useGetWorkflowDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowDetailsQuery,
        GetWorkflowDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowDetailsQuery,
    GetWorkflowDetailsQueryVariables
  >(GetWorkflowDetailsDocument, options);
}
export type GetWorkflowDetailsQueryHookResult = ReturnType<
  typeof useGetWorkflowDetailsQuery
>;
export type GetWorkflowDetailsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowDetailsLazyQuery
>;
export type GetWorkflowDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowDetailsSuspenseQuery
>;
export type GetWorkflowDetailsQueryResult = Apollo.QueryResult<
  GetWorkflowDetailsQuery,
  GetWorkflowDetailsQueryVariables
>;
export const GetWorkflowDevVersionsDocument = gql`
  query GetWorkflowDevVersions($parent: String!, $pageToken: String) {
    workflowVersions(
      parent: $parent
      pageSize: 100
      pageToken: $pageToken
      filter: "versionType:LOCAL_DEV"
    ) {
      ... on WorkflowV1ListWorkflowVersionsResponse {
        __typename
        nextPageToken
        workflowVersions {
          name
          updateTime
          workflowConfig {
            localDevConfig {
              displayName
              tunnelInfo {
                url
              }
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowDevVersionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowDevVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowDevVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowDevVersionsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useGetWorkflowDevVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  > &
    (
      | { variables: GetWorkflowDevVersionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  >(GetWorkflowDevVersionsDocument, options);
}
export function useGetWorkflowDevVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  >(GetWorkflowDevVersionsDocument, options);
}
// @ts-ignore
export function useGetWorkflowDevVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowDevVersionsQuery,
  GetWorkflowDevVersionsQueryVariables
>;
export function useGetWorkflowDevVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowDevVersionsQuery,
        GetWorkflowDevVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowDevVersionsQuery | undefined,
  GetWorkflowDevVersionsQueryVariables
>;
export function useGetWorkflowDevVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowDevVersionsQuery,
        GetWorkflowDevVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowDevVersionsQuery,
    GetWorkflowDevVersionsQueryVariables
  >(GetWorkflowDevVersionsDocument, options);
}
export type GetWorkflowDevVersionsQueryHookResult = ReturnType<
  typeof useGetWorkflowDevVersionsQuery
>;
export type GetWorkflowDevVersionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowDevVersionsLazyQuery
>;
export type GetWorkflowDevVersionsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowDevVersionsSuspenseQuery
>;
export type GetWorkflowDevVersionsQueryResult = Apollo.QueryResult<
  GetWorkflowDevVersionsQuery,
  GetWorkflowDevVersionsQueryVariables
>;
export const GetWorkflowInstancesDocument = gql`
  query GetWorkflowInstances(
    $pageToken: String
    $parent: String
    $filter: String
  ) {
    workflowInstances(pageToken: $pageToken, parent: $parent, filter: $filter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        nextPageToken
        workflowInstances {
          name
          displayName
          updateTime
          createTime
          state
          owner {
            __typename
            ... on IamV1Identity {
              ...Identity
            }
            ...DefaultError
          }
          workflowVersion {
            ... on WorkflowV1WorkflowVersion {
              name
              __typename
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowInstancesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstancesQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetWorkflowInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >(GetWorkflowInstancesDocument, options);
}
export function useGetWorkflowInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >(GetWorkflowInstancesDocument, options);
}
// @ts-ignore
export function useGetWorkflowInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstancesQuery,
  GetWorkflowInstancesQueryVariables
>;
export function useGetWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstancesQuery,
        GetWorkflowInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstancesQuery | undefined,
  GetWorkflowInstancesQueryVariables
>;
export function useGetWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstancesQuery,
        GetWorkflowInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInstancesQuery,
    GetWorkflowInstancesQueryVariables
  >(GetWorkflowInstancesDocument, options);
}
export type GetWorkflowInstancesQueryHookResult = ReturnType<
  typeof useGetWorkflowInstancesQuery
>;
export type GetWorkflowInstancesLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInstancesLazyQuery
>;
export type GetWorkflowInstancesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInstancesSuspenseQuery
>;
export type GetWorkflowInstancesQueryResult = Apollo.QueryResult<
  GetWorkflowInstancesQuery,
  GetWorkflowInstancesQueryVariables
>;
export const GetWorkflowVersionsDocument = gql`
  query GetWorkflowVersions(
    $pageToken: String
    $parent: String!
    $filter: String
  ) {
    workflow(name: $parent) {
      ... on WorkflowV1Workflow {
        __typename
        name
        createTime
        builtin
        creator {
          ... on IamV1Identity {
            __typename
            name
            displayName
          }
          ...DefaultError
        }
        currentVersion {
          ... on WorkflowV1WorkflowVersion {
            __typename
            name
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
    workflowVersions(pageToken: $pageToken, parent: $parent, filter: $filter) {
      ... on WorkflowV1ListWorkflowVersionsResponse {
        __typename
        nextPageToken
        workflowVersions {
          name
          createTime
          workflowConfig {
            localDevConfig {
              displayName
              tunnelInfo {
                url
              }
            }
          }
          resourceRelations {
            ... on FgaV1ListResourceRelationsResponse {
              __typename
              resourceRelations {
                ... on FgaV1ResourceRelation {
                  relation
                  resource
                }
              }
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowVersionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowVersionsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetWorkflowVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  > &
    (
      | { variables: GetWorkflowVersionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  >(GetWorkflowVersionsDocument, options);
}
export function useGetWorkflowVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  >(GetWorkflowVersionsDocument, options);
}
// @ts-ignore
export function useGetWorkflowVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowVersionsQuery,
  GetWorkflowVersionsQueryVariables
>;
export function useGetWorkflowVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowVersionsQuery,
        GetWorkflowVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowVersionsQuery | undefined,
  GetWorkflowVersionsQueryVariables
>;
export function useGetWorkflowVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowVersionsQuery,
        GetWorkflowVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowVersionsQuery,
    GetWorkflowVersionsQueryVariables
  >(GetWorkflowVersionsDocument, options);
}
export type GetWorkflowVersionsQueryHookResult = ReturnType<
  typeof useGetWorkflowVersionsQuery
>;
export type GetWorkflowVersionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowVersionsLazyQuery
>;
export type GetWorkflowVersionsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowVersionsSuspenseQuery
>;
export type GetWorkflowVersionsQueryResult = Apollo.QueryResult<
  GetWorkflowVersionsQuery,
  GetWorkflowVersionsQueryVariables
>;
export const GroupMembersDocument = gql`
  query GroupMembers(
    $name: String!
    $pageToken: String
    $pageSize: Int
    $filter: String
  ) {
    groupMembers(
      parent: $name
      pageToken: $pageToken
      pageSize: $pageSize
      filter: $filter
    ) {
      ... on IamV1ListGroupMembersResponse {
        __typename
        groupMembers {
          ...Identity
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${IdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGroupMembersQuery__
 *
 * To run a query within a React component, call `useGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGroupMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupMembersQuery,
    GroupMembersQueryVariables
  > &
    (
      | { variables: GroupMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupMembersQuery, GroupMembersQueryVariables>(
    GroupMembersDocument,
    options,
  );
}
export function useGroupMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupMembersQuery,
    GroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupMembersQuery, GroupMembersQueryVariables>(
    GroupMembersDocument,
    options,
  );
}
// @ts-ignore
export function useGroupMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupMembersQuery,
    GroupMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupMembersQuery,
        GroupMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupMembersQuery | undefined,
  GroupMembersQueryVariables
>;
export function useGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupMembersQuery,
        GroupMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupMembersQuery, GroupMembersQueryVariables>(
    GroupMembersDocument,
    options,
  );
}
export type GroupMembersQueryHookResult = ReturnType<
  typeof useGroupMembersQuery
>;
export type GroupMembersLazyQueryHookResult = ReturnType<
  typeof useGroupMembersLazyQuery
>;
export type GroupMembersSuspenseQueryHookResult = ReturnType<
  typeof useGroupMembersSuspenseQuery
>;
export type GroupMembersQueryResult = Apollo.QueryResult<
  GroupMembersQuery,
  GroupMembersQueryVariables
>;
export const HasAgentIntegrationDocument = gql`
  query HasAgentIntegration(
    $integrationType: AiworkflowsV1ExternalIntegrationType!
    $verify: Boolean
  ) {
    hasExternalIntegration(integrationType: $integrationType, verify: $verify) {
      ... on AiworkflowsV1HasExternalIntegrationResponse {
        __typename
        exists
        integrationName
        working
        claudeAgentsConfig {
          agentId
          environmentId
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useHasAgentIntegrationQuery__
 *
 * To run a query within a React component, call `useHasAgentIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAgentIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAgentIntegrationQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *      verify: // value for 'verify'
 *   },
 * });
 */
export function useHasAgentIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  > &
    (
      | { variables: HasAgentIntegrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  >(HasAgentIntegrationDocument, options);
}
export function useHasAgentIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  >(HasAgentIntegrationDocument, options);
}
// @ts-ignore
export function useHasAgentIntegrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HasAgentIntegrationQuery,
  HasAgentIntegrationQueryVariables
>;
export function useHasAgentIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasAgentIntegrationQuery,
        HasAgentIntegrationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HasAgentIntegrationQuery | undefined,
  HasAgentIntegrationQueryVariables
>;
export function useHasAgentIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasAgentIntegrationQuery,
        HasAgentIntegrationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HasAgentIntegrationQuery,
    HasAgentIntegrationQueryVariables
  >(HasAgentIntegrationDocument, options);
}
export type HasAgentIntegrationQueryHookResult = ReturnType<
  typeof useHasAgentIntegrationQuery
>;
export type HasAgentIntegrationLazyQueryHookResult = ReturnType<
  typeof useHasAgentIntegrationLazyQuery
>;
export type HasAgentIntegrationSuspenseQueryHookResult = ReturnType<
  typeof useHasAgentIntegrationSuspenseQuery
>;
export type HasAgentIntegrationQueryResult = Apollo.QueryResult<
  HasAgentIntegrationQuery,
  HasAgentIntegrationQueryVariables
>;
export const HasGithubIntegrationDocument = gql`
  query hasGithubIntegration {
    hasExternalIntegration(integrationType: GITHUB, verify: true) {
      ... on AiworkflowsV1HasExternalIntegrationResponse {
        __typename
        exists
        integrationName
        working
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useHasGithubIntegrationQuery__
 *
 * To run a query within a React component, call `useHasGithubIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasGithubIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasGithubIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasGithubIntegrationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >(HasGithubIntegrationDocument, options);
}
export function useHasGithubIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >(HasGithubIntegrationDocument, options);
}
// @ts-ignore
export function useHasGithubIntegrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HasGithubIntegrationQuery,
  HasGithubIntegrationQueryVariables
>;
export function useHasGithubIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasGithubIntegrationQuery,
        HasGithubIntegrationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HasGithubIntegrationQuery | undefined,
  HasGithubIntegrationQueryVariables
>;
export function useHasGithubIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasGithubIntegrationQuery,
        HasGithubIntegrationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HasGithubIntegrationQuery,
    HasGithubIntegrationQueryVariables
  >(HasGithubIntegrationDocument, options);
}
export type HasGithubIntegrationQueryHookResult = ReturnType<
  typeof useHasGithubIntegrationQuery
>;
export type HasGithubIntegrationLazyQueryHookResult = ReturnType<
  typeof useHasGithubIntegrationLazyQuery
>;
export type HasGithubIntegrationSuspenseQueryHookResult = ReturnType<
  typeof useHasGithubIntegrationSuspenseQuery
>;
export type HasGithubIntegrationQueryResult = Apollo.QueryResult<
  HasGithubIntegrationQuery,
  HasGithubIntegrationQueryVariables
>;
export const InstantiateGithubInstallationDocument = gql`
  mutation InstantiateGithubInstallation {
    instantiateGithubInstallation {
      ... on AiworkflowsV1InstantiateGithubInstallationResponse {
        __typename
        installationUrl
        state
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type InstantiateGithubInstallationMutationFn = Apollo.MutationFunction<
  InstantiateGithubInstallationMutation,
  InstantiateGithubInstallationMutationVariables
>;

/**
 * __useInstantiateGithubInstallationMutation__
 *
 * To run a mutation, you first call `useInstantiateGithubInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantiateGithubInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantiateGithubInstallationMutation, { data, loading, error }] = useInstantiateGithubInstallationMutation({
 *   variables: {
 *   },
 * });
 */
export function useInstantiateGithubInstallationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InstantiateGithubInstallationMutation,
    InstantiateGithubInstallationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InstantiateGithubInstallationMutation,
    InstantiateGithubInstallationMutationVariables
  >(InstantiateGithubInstallationDocument, options);
}
export type InstantiateGithubInstallationMutationHookResult = ReturnType<
  typeof useInstantiateGithubInstallationMutation
>;
export type InstantiateGithubInstallationMutationResult =
  Apollo.MutationResult<InstantiateGithubInstallationMutation>;
export type InstantiateGithubInstallationMutationOptions =
  Apollo.BaseMutationOptions<
    InstantiateGithubInstallationMutation,
    InstantiateGithubInstallationMutationVariables
  >;
export const InstantiateIntercomInstallationDocument = gql`
  mutation InstantiateIntercomInstallation {
    instantiateIntercomInstallation {
      ... on AiworkflowsV1InstantiateIntercomInstallationResponse {
        __typename
        authorizationUrl
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type InstantiateIntercomInstallationMutationFn = Apollo.MutationFunction<
  InstantiateIntercomInstallationMutation,
  InstantiateIntercomInstallationMutationVariables
>;

/**
 * __useInstantiateIntercomInstallationMutation__
 *
 * To run a mutation, you first call `useInstantiateIntercomInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantiateIntercomInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantiateIntercomInstallationMutation, { data, loading, error }] = useInstantiateIntercomInstallationMutation({
 *   variables: {
 *   },
 * });
 */
export function useInstantiateIntercomInstallationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InstantiateIntercomInstallationMutation,
    InstantiateIntercomInstallationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InstantiateIntercomInstallationMutation,
    InstantiateIntercomInstallationMutationVariables
  >(InstantiateIntercomInstallationDocument, options);
}
export type InstantiateIntercomInstallationMutationHookResult = ReturnType<
  typeof useInstantiateIntercomInstallationMutation
>;
export type InstantiateIntercomInstallationMutationResult =
  Apollo.MutationResult<InstantiateIntercomInstallationMutation>;
export type InstantiateIntercomInstallationMutationOptions =
  Apollo.BaseMutationOptions<
    InstantiateIntercomInstallationMutation,
    InstantiateIntercomInstallationMutationVariables
  >;
export const ListDataWarehousesDocument = gql`
  query ListDataWarehouses {
    dataWarehouses {
      ... on MetricsV1ListDataWarehousesResponse {
        __typename
        dataWarehouses {
          ...DataWarehouse
        }
      }
      ...DefaultError
    }
  }
  ${DataWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListDataWarehousesQuery__
 *
 * To run a query within a React component, call `useListDataWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDataWarehousesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >(ListDataWarehousesDocument, options);
}
export function useListDataWarehousesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >(ListDataWarehousesDocument, options);
}
// @ts-ignore
export function useListDataWarehousesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListDataWarehousesQuery,
  ListDataWarehousesQueryVariables
>;
export function useListDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDataWarehousesQuery,
        ListDataWarehousesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListDataWarehousesQuery | undefined,
  ListDataWarehousesQueryVariables
>;
export function useListDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDataWarehousesQuery,
        ListDataWarehousesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDataWarehousesQuery,
    ListDataWarehousesQueryVariables
  >(ListDataWarehousesDocument, options);
}
export type ListDataWarehousesQueryHookResult = ReturnType<
  typeof useListDataWarehousesQuery
>;
export type ListDataWarehousesLazyQueryHookResult = ReturnType<
  typeof useListDataWarehousesLazyQuery
>;
export type ListDataWarehousesSuspenseQueryHookResult = ReturnType<
  typeof useListDataWarehousesSuspenseQuery
>;
export type ListDataWarehousesQueryResult = Apollo.QueryResult<
  ListDataWarehousesQuery,
  ListDataWarehousesQueryVariables
>;
export const ListEntityRelationTablesDocument = gql`
  query ListEntityRelationTables(
    $parent: String!
    $filter: String
    $pageToken: String
  ) {
    entityRelationTables(
      parent: $parent
      filter: $filter
      pageToken: $pageToken
    ) {
      ... on MetricsV1ListEntityRelationTablesResponse {
        __typename
        nextPageToken
        entityRelationTables {
          ...EntityRelationTableRow
        }
      }
      ...DefaultError
    }
  }
  ${EntityRelationTableRowFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListEntityRelationTablesQuery__
 *
 * To run a query within a React component, call `useListEntityRelationTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEntityRelationTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEntityRelationTablesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useListEntityRelationTablesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  > &
    (
      | { variables: ListEntityRelationTablesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  >(ListEntityRelationTablesDocument, options);
}
export function useListEntityRelationTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  >(ListEntityRelationTablesDocument, options);
}
// @ts-ignore
export function useListEntityRelationTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListEntityRelationTablesQuery,
  ListEntityRelationTablesQueryVariables
>;
export function useListEntityRelationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEntityRelationTablesQuery,
        ListEntityRelationTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEntityRelationTablesQuery | undefined,
  ListEntityRelationTablesQueryVariables
>;
export function useListEntityRelationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEntityRelationTablesQuery,
        ListEntityRelationTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListEntityRelationTablesQuery,
    ListEntityRelationTablesQueryVariables
  >(ListEntityRelationTablesDocument, options);
}
export type ListEntityRelationTablesQueryHookResult = ReturnType<
  typeof useListEntityRelationTablesQuery
>;
export type ListEntityRelationTablesLazyQueryHookResult = ReturnType<
  typeof useListEntityRelationTablesLazyQuery
>;
export type ListEntityRelationTablesSuspenseQueryHookResult = ReturnType<
  typeof useListEntityRelationTablesSuspenseQuery
>;
export type ListEntityRelationTablesQueryResult = Apollo.QueryResult<
  ListEntityRelationTablesQuery,
  ListEntityRelationTablesQueryVariables
>;
export const ListEventsDocument = gql`
  query ListEvents(
    $resource: String
    $eventTypes: [String!]
    $pageToken: String
  ) {
    events(
      resource: $resource
      eventTypes: $eventTypes
      pageToken: $pageToken
    ) {
      ... on ConnectorsV1ListEventsResponse {
        __typename
        events {
          ...Event
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${EventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListEventsQuery__
 *
 * To run a query within a React component, call `useListEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      eventTypes: // value for 'eventTypes'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useListEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListEventsQuery,
    ListEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEventsQuery, ListEventsQueryVariables>(
    ListEventsDocument,
    options,
  );
}
export function useListEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEventsQuery,
    ListEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEventsQuery, ListEventsQueryVariables>(
    ListEventsDocument,
    options,
  );
}
// @ts-ignore
export function useListEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEventsQuery,
    ListEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEventsQuery, ListEventsQueryVariables>;
export function useListEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEventsQuery,
        ListEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEventsQuery | undefined,
  ListEventsQueryVariables
>;
export function useListEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEventsQuery,
        ListEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEventsQuery, ListEventsQueryVariables>(
    ListEventsDocument,
    options,
  );
}
export type ListEventsQueryHookResult = ReturnType<typeof useListEventsQuery>;
export type ListEventsLazyQueryHookResult = ReturnType<
  typeof useListEventsLazyQuery
>;
export type ListEventsSuspenseQueryHookResult = ReturnType<
  typeof useListEventsSuspenseQuery
>;
export type ListEventsQueryResult = Apollo.QueryResult<
  ListEventsQuery,
  ListEventsQueryVariables
>;
export const ListRepositoriesDocument = gql`
  query listRepositories {
    repositories {
      ... on RepositoriesV1ListRepositoriesResponse {
        __typename
        repositories {
          name
          host
          htmlUrl
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListRepositoriesQuery__
 *
 * To run a query within a React component, call `useListRepositoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRepositoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRepositoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRepositoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListRepositoriesQuery,
    ListRepositoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRepositoriesQuery, ListRepositoriesQueryVariables>(
    ListRepositoriesDocument,
    options,
  );
}
export function useListRepositoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListRepositoriesQuery,
    ListRepositoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListRepositoriesQuery,
    ListRepositoriesQueryVariables
  >(ListRepositoriesDocument, options);
}
// @ts-ignore
export function useListRepositoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListRepositoriesQuery,
    ListRepositoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListRepositoriesQuery,
  ListRepositoriesQueryVariables
>;
export function useListRepositoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRepositoriesQuery,
        ListRepositoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListRepositoriesQuery | undefined,
  ListRepositoriesQueryVariables
>;
export function useListRepositoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRepositoriesQuery,
        ListRepositoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListRepositoriesQuery,
    ListRepositoriesQueryVariables
  >(ListRepositoriesDocument, options);
}
export type ListRepositoriesQueryHookResult = ReturnType<
  typeof useListRepositoriesQuery
>;
export type ListRepositoriesLazyQueryHookResult = ReturnType<
  typeof useListRepositoriesLazyQuery
>;
export type ListRepositoriesSuspenseQueryHookResult = ReturnType<
  typeof useListRepositoriesSuspenseQuery
>;
export type ListRepositoriesQueryResult = Apollo.QueryResult<
  ListRepositoriesQuery,
  ListRepositoriesQueryVariables
>;
export const ListUsersDocument = gql`
  query ListUsers($pageToken: String, $pageSize: Int, $filter: String) {
    users(pageToken: $pageToken, pageSize: $pageSize, filter: $filter) {
      ... on IamV1ListUsersResponse {
        __typename
        users {
          ...User
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${UserFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options,
  );
}
export function useListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options,
  );
}
// @ts-ignore
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListUsersQuery, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListUsersQuery | undefined,
  ListUsersQueryVariables
>;
export function useListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options,
  );
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<
  typeof useListUsersLazyQuery
>;
export type ListUsersSuspenseQueryHookResult = ReturnType<
  typeof useListUsersSuspenseQuery
>;
export type ListUsersQueryResult = Apollo.QueryResult<
  ListUsersQuery,
  ListUsersQueryVariables
>;
export const ListWorkflowsDocument = gql`
  query ListWorkflows($pageToken: String) {
    workflows(pageToken: $pageToken) {
      ... on WorkflowV1ListWorkflowsResponse {
        __typename
        nextPageToken
        workflows {
          displayName
          name
          updateTime
          currentVersion {
            ... on WorkflowV1WorkflowVersion {
              __typename
              name
              updateTime
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListWorkflowsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useListWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListWorkflowsQuery,
    ListWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(
    ListWorkflowsDocument,
    options,
  );
}
export function useListWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListWorkflowsQuery,
    ListWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(
    ListWorkflowsDocument,
    options,
  );
}
// @ts-ignore
export function useListWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListWorkflowsQuery,
    ListWorkflowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowsQuery,
  ListWorkflowsQueryVariables
>;
export function useListWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowsQuery,
        ListWorkflowsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowsQuery | undefined,
  ListWorkflowsQueryVariables
>;
export function useListWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowsQuery,
        ListWorkflowsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListWorkflowsQuery,
    ListWorkflowsQueryVariables
  >(ListWorkflowsDocument, options);
}
export type ListWorkflowsQueryHookResult = ReturnType<
  typeof useListWorkflowsQuery
>;
export type ListWorkflowsLazyQueryHookResult = ReturnType<
  typeof useListWorkflowsLazyQuery
>;
export type ListWorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useListWorkflowsSuspenseQuery
>;
export type ListWorkflowsQueryResult = Apollo.QueryResult<
  ListWorkflowsQuery,
  ListWorkflowsQueryVariables
>;
export const MetricsUsingFactTableDocument = gql`
  query MetricsUsingFactTable(
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    metrics(filter: $filter, pageSize: $pageSize, pageToken: $pageToken) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          name
          displayName
          createTime
          entity {
            ... on MetricsV1Entity {
              __typename
              name
              displayName
            }
          }
          owner {
            ... on IamV1Identity {
              __typename
              name
              displayName
            }
          }
          typeSpec {
            averageMetricSpec {
              aggregation {
                type
              }
            }
            ratioMetricSpec {
              numeratorAggregation {
                type
              }
            }
            quantileMetricSpec {
              quantileLevel
              aggregation {
                type
              }
            }
          }
          labels {
            key
            value
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricsUsingFactTableQuery__
 *
 * To run a query within a React component, call `useMetricsUsingFactTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsUsingFactTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsUsingFactTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMetricsUsingFactTableQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >(MetricsUsingFactTableDocument, options);
}
export function useMetricsUsingFactTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >(MetricsUsingFactTableDocument, options);
}
// @ts-ignore
export function useMetricsUsingFactTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricsUsingFactTableQuery,
  MetricsUsingFactTableQueryVariables
>;
export function useMetricsUsingFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricsUsingFactTableQuery,
        MetricsUsingFactTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricsUsingFactTableQuery | undefined,
  MetricsUsingFactTableQueryVariables
>;
export function useMetricsUsingFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricsUsingFactTableQuery,
        MetricsUsingFactTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricsUsingFactTableQuery,
    MetricsUsingFactTableQueryVariables
  >(MetricsUsingFactTableDocument, options);
}
export type MetricsUsingFactTableQueryHookResult = ReturnType<
  typeof useMetricsUsingFactTableQuery
>;
export type MetricsUsingFactTableLazyQueryHookResult = ReturnType<
  typeof useMetricsUsingFactTableLazyQuery
>;
export type MetricsUsingFactTableSuspenseQueryHookResult = ReturnType<
  typeof useMetricsUsingFactTableSuspenseQuery
>;
export type MetricsUsingFactTableQueryResult = Apollo.QueryResult<
  MetricsUsingFactTableQuery,
  MetricsUsingFactTableQueryVariables
>;
export const OAuthAppDocument = gql`
  query OAuthApp($name: String!) {
    oAuthApp(name: $name) {
      ...OAuthApp
      ...DefaultError
    }
  }
  ${OAuthAppFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useOAuthAppQuery__
 *
 * To run a query within a React component, call `useOAuthAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthAppQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOAuthAppQuery(
  baseOptions: Apollo.QueryHookOptions<OAuthAppQuery, OAuthAppQueryVariables> &
    ({ variables: OAuthAppQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OAuthAppQuery, OAuthAppQueryVariables>(
    OAuthAppDocument,
    options,
  );
}
export function useOAuthAppLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuthAppQuery,
    OAuthAppQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OAuthAppQuery, OAuthAppQueryVariables>(
    OAuthAppDocument,
    options,
  );
}
// @ts-ignore
export function useOAuthAppSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OAuthAppQuery,
    OAuthAppQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OAuthAppQuery, OAuthAppQueryVariables>;
export function useOAuthAppSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OAuthAppQuery, OAuthAppQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  OAuthAppQuery | undefined,
  OAuthAppQueryVariables
>;
export function useOAuthAppSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OAuthAppQuery, OAuthAppQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OAuthAppQuery, OAuthAppQueryVariables>(
    OAuthAppDocument,
    options,
  );
}
export type OAuthAppQueryHookResult = ReturnType<typeof useOAuthAppQuery>;
export type OAuthAppLazyQueryHookResult = ReturnType<
  typeof useOAuthAppLazyQuery
>;
export type OAuthAppSuspenseQueryHookResult = ReturnType<
  typeof useOAuthAppSuspenseQuery
>;
export type OAuthAppQueryResult = Apollo.QueryResult<
  OAuthAppQuery,
  OAuthAppQueryVariables
>;
export const OAuthAppsDocument = gql`
  query OAuthApps($pageToken: String) {
    oAuthApps(pageToken: $pageToken) {
      ... on IamV1ListOAuthAppsResponse {
        __typename
        nextPageToken
        oauthApps {
          ...AuthApp
        }
      }
      ...DefaultError
    }
  }
  ${AuthAppFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useOAuthAppsQuery__
 *
 * To run a query within a React component, call `useOAuthAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthAppsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useOAuthAppsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OAuthAppsQuery,
    OAuthAppsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OAuthAppsQuery, OAuthAppsQueryVariables>(
    OAuthAppsDocument,
    options,
  );
}
export function useOAuthAppsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuthAppsQuery,
    OAuthAppsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OAuthAppsQuery, OAuthAppsQueryVariables>(
    OAuthAppsDocument,
    options,
  );
}
// @ts-ignore
export function useOAuthAppsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OAuthAppsQuery,
    OAuthAppsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OAuthAppsQuery, OAuthAppsQueryVariables>;
export function useOAuthAppsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OAuthAppsQuery, OAuthAppsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  OAuthAppsQuery | undefined,
  OAuthAppsQueryVariables
>;
export function useOAuthAppsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OAuthAppsQuery, OAuthAppsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OAuthAppsQuery, OAuthAppsQueryVariables>(
    OAuthAppsDocument,
    options,
  );
}
export type OAuthAppsQueryHookResult = ReturnType<typeof useOAuthAppsQuery>;
export type OAuthAppsLazyQueryHookResult = ReturnType<
  typeof useOAuthAppsLazyQuery
>;
export type OAuthAppsSuspenseQueryHookResult = ReturnType<
  typeof useOAuthAppsSuspenseQuery
>;
export type OAuthAppsQueryResult = Apollo.QueryResult<
  OAuthAppsQuery,
  OAuthAppsQueryVariables
>;
export const PermissionsDocument = gql`
  query Permissions($pageSize: Int, $pageToken: String) {
    permissions(pageSize: $pageSize, pageToken: $pageToken) {
      ... on IamV1ListPermissionsResponse {
        __typename
        permissions {
          category
          description
          type
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PermissionsQuery,
    PermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(
    PermissionsDocument,
    options,
  );
}
export function usePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PermissionsQuery,
    PermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(
    PermissionsDocument,
    options,
  );
}
// @ts-ignore
export function usePermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PermissionsQuery,
    PermissionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PermissionsQuery, PermissionsQueryVariables>;
export function usePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissionsQuery,
        PermissionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PermissionsQuery | undefined,
  PermissionsQueryVariables
>;
export function usePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PermissionsQuery,
        PermissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(
    PermissionsDocument,
    options,
  );
}
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<
  typeof usePermissionsLazyQuery
>;
export type PermissionsSuspenseQueryHookResult = ReturnType<
  typeof usePermissionsSuspenseQuery
>;
export type PermissionsQueryResult = Apollo.QueryResult<
  PermissionsQuery,
  PermissionsQueryVariables
>;
export const PoliciesDocument = gql`
  query Policies($pageSize: Int, $pageToken: String) {
    policies(pageSize: $pageSize, pageToken: $pageToken) {
      ... on IamV1ListPoliciesResponse {
        __typename
        policies {
          ...Policy
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePoliciesQuery__
 *
 * To run a query within a React component, call `usePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<PoliciesQuery, PoliciesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PoliciesQuery, PoliciesQueryVariables>(
    PoliciesDocument,
    options,
  );
}
export function usePoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PoliciesQuery,
    PoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PoliciesQuery, PoliciesQueryVariables>(
    PoliciesDocument,
    options,
  );
}
// @ts-ignore
export function usePoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PoliciesQuery,
    PoliciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PoliciesQuery, PoliciesQueryVariables>;
export function usePoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PoliciesQuery | undefined,
  PoliciesQueryVariables
>;
export function usePoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PoliciesQuery, PoliciesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PoliciesQuery, PoliciesQueryVariables>(
    PoliciesDocument,
    options,
  );
}
export type PoliciesQueryHookResult = ReturnType<typeof usePoliciesQuery>;
export type PoliciesLazyQueryHookResult = ReturnType<
  typeof usePoliciesLazyQuery
>;
export type PoliciesSuspenseQueryHookResult = ReturnType<
  typeof usePoliciesSuspenseQuery
>;
export type PoliciesQueryResult = Apollo.QueryResult<
  PoliciesQuery,
  PoliciesQueryVariables
>;
export const PromotePrimaryDataWarehouseDocument = gql`
  mutation PromotePrimaryDataWarehouse($name: String!) {
    promotePrimaryDataWarehouse(name: $name) {
      ... on MetricsV1DataWarehouse {
        __typename
        name
        isPrimary
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type PromotePrimaryDataWarehouseMutationFn = Apollo.MutationFunction<
  PromotePrimaryDataWarehouseMutation,
  PromotePrimaryDataWarehouseMutationVariables
>;

/**
 * __usePromotePrimaryDataWarehouseMutation__
 *
 * To run a mutation, you first call `usePromotePrimaryDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotePrimaryDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotePrimaryDataWarehouseMutation, { data, loading, error }] = usePromotePrimaryDataWarehouseMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePromotePrimaryDataWarehouseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PromotePrimaryDataWarehouseMutation,
    PromotePrimaryDataWarehouseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PromotePrimaryDataWarehouseMutation,
    PromotePrimaryDataWarehouseMutationVariables
  >(PromotePrimaryDataWarehouseDocument, options);
}
export type PromotePrimaryDataWarehouseMutationHookResult = ReturnType<
  typeof usePromotePrimaryDataWarehouseMutation
>;
export type PromotePrimaryDataWarehouseMutationResult =
  Apollo.MutationResult<PromotePrimaryDataWarehouseMutation>;
export type PromotePrimaryDataWarehouseMutationOptions =
  Apollo.BaseMutationOptions<
    PromotePrimaryDataWarehouseMutation,
    PromotePrimaryDataWarehouseMutationVariables
  >;
export const RemoveDemoDataDocument = gql`
  mutation RemoveDemoData {
    removeDemoData {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type RemoveDemoDataMutationFn = Apollo.MutationFunction<
  RemoveDemoDataMutation,
  RemoveDemoDataMutationVariables
>;

/**
 * __useRemoveDemoDataMutation__
 *
 * To run a mutation, you first call `useRemoveDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDemoDataMutation, { data, loading, error }] = useRemoveDemoDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveDemoDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDemoDataMutation,
    RemoveDemoDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveDemoDataMutation,
    RemoveDemoDataMutationVariables
  >(RemoveDemoDataDocument, options);
}
export type RemoveDemoDataMutationHookResult = ReturnType<
  typeof useRemoveDemoDataMutation
>;
export type RemoveDemoDataMutationResult =
  Apollo.MutationResult<RemoveDemoDataMutation>;
export type RemoveDemoDataMutationOptions = Apollo.BaseMutationOptions<
  RemoveDemoDataMutation,
  RemoveDemoDataMutationVariables
>;
export const RemoveGroupMembersDocument = gql`
  mutation RemoveGroupMembers($group: String!, $identities: [String!]!) {
    removeGroupMembers(group: $group, identities: $identities) {
      ... on IamV1RemoveGroupMembersResponse {
        dummy
      }
    }
  }
`;
export type RemoveGroupMembersMutationFn = Apollo.MutationFunction<
  RemoveGroupMembersMutation,
  RemoveGroupMembersMutationVariables
>;

/**
 * __useRemoveGroupMembersMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMembersMutation, { data, loading, error }] = useRemoveGroupMembersMutation({
 *   variables: {
 *      group: // value for 'group'
 *      identities: // value for 'identities'
 *   },
 * });
 */
export function useRemoveGroupMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveGroupMembersMutation,
    RemoveGroupMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveGroupMembersMutation,
    RemoveGroupMembersMutationVariables
  >(RemoveGroupMembersDocument, options);
}
export type RemoveGroupMembersMutationHookResult = ReturnType<
  typeof useRemoveGroupMembersMutation
>;
export type RemoveGroupMembersMutationResult =
  Apollo.MutationResult<RemoveGroupMembersMutation>;
export type RemoveGroupMembersMutationOptions = Apollo.BaseMutationOptions<
  RemoveGroupMembersMutation,
  RemoveGroupMembersMutationVariables
>;
export const SuggestFactTableColumnsDocument = gql`
  mutation SuggestFactTableColumns($schema: [MetricsV1ColumnInput!]!) {
    suggestFactTableColumns(schema: $schema) {
      ... on MetricsV1SuggestFactTableColumnsResponse {
        __typename
        error
        suggestion {
          dimensions
          entities {
            entity {
              ... on MetricsV1Entity {
                __typename
                name
                displayName
              }
              ...DefaultError
            }
            column
          }
          measures
          timestampColumn
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type SuggestFactTableColumnsMutationFn = Apollo.MutationFunction<
  SuggestFactTableColumnsMutation,
  SuggestFactTableColumnsMutationVariables
>;

/**
 * __useSuggestFactTableColumnsMutation__
 *
 * To run a mutation, you first call `useSuggestFactTableColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestFactTableColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestFactTableColumnsMutation, { data, loading, error }] = useSuggestFactTableColumnsMutation({
 *   variables: {
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useSuggestFactTableColumnsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SuggestFactTableColumnsMutation,
    SuggestFactTableColumnsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SuggestFactTableColumnsMutation,
    SuggestFactTableColumnsMutationVariables
  >(SuggestFactTableColumnsDocument, options);
}
export type SuggestFactTableColumnsMutationHookResult = ReturnType<
  typeof useSuggestFactTableColumnsMutation
>;
export type SuggestFactTableColumnsMutationResult =
  Apollo.MutationResult<SuggestFactTableColumnsMutation>;
export type SuggestFactTableColumnsMutationOptions = Apollo.BaseMutationOptions<
  SuggestFactTableColumnsMutation,
  SuggestFactTableColumnsMutationVariables
>;
export const TestWebhookDocument = gql`
  mutation TestWebhook($account: String!, $uri: String!, $secret: String!) {
    testWebhook(account: $account, uri: $uri, secret: $secret) {
      ... on ActivityV1TestWebhookResponse {
        __typename
        success
        statusCode
        responseDuration
        errorMessage
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type TestWebhookMutationFn = Apollo.MutationFunction<
  TestWebhookMutation,
  TestWebhookMutationVariables
>;

/**
 * __useTestWebhookMutation__
 *
 * To run a mutation, you first call `useTestWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testWebhookMutation, { data, loading, error }] = useTestWebhookMutation({
 *   variables: {
 *      account: // value for 'account'
 *      uri: // value for 'uri'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useTestWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestWebhookMutation,
    TestWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TestWebhookMutation, TestWebhookMutationVariables>(
    TestWebhookDocument,
    options,
  );
}
export type TestWebhookMutationHookResult = ReturnType<
  typeof useTestWebhookMutation
>;
export type TestWebhookMutationResult =
  Apollo.MutationResult<TestWebhookMutation>;
export type TestWebhookMutationOptions = Apollo.BaseMutationOptions<
  TestWebhookMutation,
  TestWebhookMutationVariables
>;
export const UpdateActivityFeedDocument = gql`
  mutation UpdateActivityFeed($feed: PartialActivityV1FeedInput!) {
    updateFeed(feed: $feed) {
      ...Feed
      ...DefaultError
    }
  }
  ${FeedFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateActivityFeedMutationFn = Apollo.MutationFunction<
  UpdateActivityFeedMutation,
  UpdateActivityFeedMutationVariables
>;

/**
 * __useUpdateActivityFeedMutation__
 *
 * To run a mutation, you first call `useUpdateActivityFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityFeedMutation, { data, loading, error }] = useUpdateActivityFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useUpdateActivityFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActivityFeedMutation,
    UpdateActivityFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActivityFeedMutation,
    UpdateActivityFeedMutationVariables
  >(UpdateActivityFeedDocument, options);
}
export type UpdateActivityFeedMutationHookResult = ReturnType<
  typeof useUpdateActivityFeedMutation
>;
export type UpdateActivityFeedMutationResult =
  Apollo.MutationResult<UpdateActivityFeedMutation>;
export type UpdateActivityFeedMutationOptions = Apollo.BaseMutationOptions<
  UpdateActivityFeedMutation,
  UpdateActivityFeedMutationVariables
>;
export const UpdateApiClientDocument = gql`
  mutation UpdateApiClient(
    $apiClient: PartialIamV1ApiClientInput!
    $updateMask: String
  ) {
    updateApiClient(apiClient: $apiClient, updateMask: $updateMask) {
      ...ApiClient
      ...DefaultError
    }
  }
  ${ApiClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateApiClientMutationFn = Apollo.MutationFunction<
  UpdateApiClientMutation,
  UpdateApiClientMutationVariables
>;

/**
 * __useUpdateApiClientMutation__
 *
 * To run a mutation, you first call `useUpdateApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiClientMutation, { data, loading, error }] = useUpdateApiClientMutation({
 *   variables: {
 *      apiClient: // value for 'apiClient'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateApiClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApiClientMutation,
    UpdateApiClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApiClientMutation,
    UpdateApiClientMutationVariables
  >(UpdateApiClientDocument, options);
}
export type UpdateApiClientMutationHookResult = ReturnType<
  typeof useUpdateApiClientMutation
>;
export type UpdateApiClientMutationResult =
  Apollo.MutationResult<UpdateApiClientMutation>;
export type UpdateApiClientMutationOptions = Apollo.BaseMutationOptions<
  UpdateApiClientMutation,
  UpdateApiClientMutationVariables
>;
export const UpdateClientCredentialDocument = gql`
  mutation UpdateClientCredential(
    $input: PartialIamV1ClientCredentialInput!
    $updateMask: String
  ) {
    updateClientCredential(clientCredential: $input, updateMask: $updateMask) {
      ...ClientCredential
      ...DefaultError
    }
  }
  ${ClientCredentialFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateClientCredentialMutationFn = Apollo.MutationFunction<
  UpdateClientCredentialMutation,
  UpdateClientCredentialMutationVariables
>;

/**
 * __useUpdateClientCredentialMutation__
 *
 * To run a mutation, you first call `useUpdateClientCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCredentialMutation, { data, loading, error }] = useUpdateClientCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateClientCredentialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientCredentialMutation,
    UpdateClientCredentialMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientCredentialMutation,
    UpdateClientCredentialMutationVariables
  >(UpdateClientCredentialDocument, options);
}
export type UpdateClientCredentialMutationHookResult = ReturnType<
  typeof useUpdateClientCredentialMutation
>;
export type UpdateClientCredentialMutationResult =
  Apollo.MutationResult<UpdateClientCredentialMutation>;
export type UpdateClientCredentialMutationOptions = Apollo.BaseMutationOptions<
  UpdateClientCredentialMutation,
  UpdateClientCredentialMutationVariables
>;
export const UpdateDataWarehouseDocument = gql`
  mutation UpdateDataWarehouse(
    $dataWarehouse: PartialMetricsV1DataWarehouseInput!
  ) {
    updateDataWarehouse(dataWarehouse: $dataWarehouse) {
      ...DataWarehouse
      ...DefaultError
    }
  }
  ${DataWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateDataWarehouseMutationFn = Apollo.MutationFunction<
  UpdateDataWarehouseMutation,
  UpdateDataWarehouseMutationVariables
>;

/**
 * __useUpdateDataWarehouseMutation__
 *
 * To run a mutation, you first call `useUpdateDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataWarehouseMutation, { data, loading, error }] = useUpdateDataWarehouseMutation({
 *   variables: {
 *      dataWarehouse: // value for 'dataWarehouse'
 *   },
 * });
 */
export function useUpdateDataWarehouseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDataWarehouseMutation,
    UpdateDataWarehouseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDataWarehouseMutation,
    UpdateDataWarehouseMutationVariables
  >(UpdateDataWarehouseDocument, options);
}
export type UpdateDataWarehouseMutationHookResult = ReturnType<
  typeof useUpdateDataWarehouseMutation
>;
export type UpdateDataWarehouseMutationResult =
  Apollo.MutationResult<UpdateDataWarehouseMutation>;
export type UpdateDataWarehouseMutationOptions = Apollo.BaseMutationOptions<
  UpdateDataWarehouseMutation,
  UpdateDataWarehouseMutationVariables
>;
export const UpdateEvaluationContextFieldOverrideDocument = gql`
  mutation UpdateEvaluationContextFieldOverride(
    $evaluationContextFieldOverride: PartialFlagsAdminV1EvaluationContextFieldOverrideInput!
    $updateMask: String
  ) {
    updateEvaluationContextFieldOverride(
      evaluationContextFieldOverride: $evaluationContextFieldOverride
      updateMask: $updateMask
    ) {
      ...DefaultError
      ... on FlagsAdminV1EvaluationContextFieldOverride {
        ...EvaluationContextFieldOverride
        __typename
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EvaluationContextFieldOverrideFragmentDoc}
`;
export type UpdateEvaluationContextFieldOverrideMutationFn =
  Apollo.MutationFunction<
    UpdateEvaluationContextFieldOverrideMutation,
    UpdateEvaluationContextFieldOverrideMutationVariables
  >;

/**
 * __useUpdateEvaluationContextFieldOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateEvaluationContextFieldOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvaluationContextFieldOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvaluationContextFieldOverrideMutation, { data, loading, error }] = useUpdateEvaluationContextFieldOverrideMutation({
 *   variables: {
 *      evaluationContextFieldOverride: // value for 'evaluationContextFieldOverride'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateEvaluationContextFieldOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEvaluationContextFieldOverrideMutation,
    UpdateEvaluationContextFieldOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEvaluationContextFieldOverrideMutation,
    UpdateEvaluationContextFieldOverrideMutationVariables
  >(UpdateEvaluationContextFieldOverrideDocument, options);
}
export type UpdateEvaluationContextFieldOverrideMutationHookResult = ReturnType<
  typeof useUpdateEvaluationContextFieldOverrideMutation
>;
export type UpdateEvaluationContextFieldOverrideMutationResult =
  Apollo.MutationResult<UpdateEvaluationContextFieldOverrideMutation>;
export type UpdateEvaluationContextFieldOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateEvaluationContextFieldOverrideMutation,
    UpdateEvaluationContextFieldOverrideMutationVariables
  >;
export const UpdateOAuthAppDocument = gql`
  mutation UpdateOAuthApp($oauthApp: PartialIamV1OAuthAppInput!) {
    updateOAuthApp(oauthApp: $oauthApp) {
      ...OAuthApp
      ...DefaultError
    }
  }
  ${OAuthAppFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateOAuthAppMutationFn = Apollo.MutationFunction<
  UpdateOAuthAppMutation,
  UpdateOAuthAppMutationVariables
>;

/**
 * __useUpdateOAuthAppMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthAppMutation, { data, loading, error }] = useUpdateOAuthAppMutation({
 *   variables: {
 *      oauthApp: // value for 'oauthApp'
 *   },
 * });
 */
export function useUpdateOAuthAppMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOAuthAppMutation,
    UpdateOAuthAppMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOAuthAppMutation,
    UpdateOAuthAppMutationVariables
  >(UpdateOAuthAppDocument, options);
}
export type UpdateOAuthAppMutationHookResult = ReturnType<
  typeof useUpdateOAuthAppMutation
>;
export type UpdateOAuthAppMutationResult =
  Apollo.MutationResult<UpdateOAuthAppMutation>;
export type UpdateOAuthAppMutationOptions = Apollo.BaseMutationOptions<
  UpdateOAuthAppMutation,
  UpdateOAuthAppMutationVariables
>;
export const UpdatePolicyDocument = gql`
  mutation UpdatePolicy(
    $policy: PartialIamV1PolicyInput!
    $updateMask: String
  ) {
    updatePolicy(policy: $policy, updateMask: $updateMask) {
      ...Policy
      ...DefaultError
    }
  }
  ${PolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdatePolicyMutationFn = Apollo.MutationFunction<
  UpdatePolicyMutation,
  UpdatePolicyMutationVariables
>;

/**
 * __useUpdatePolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyMutation, { data, loading, error }] = useUpdatePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdatePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePolicyMutation,
    UpdatePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePolicyMutation,
    UpdatePolicyMutationVariables
  >(UpdatePolicyDocument, options);
}
export type UpdatePolicyMutationHookResult = ReturnType<
  typeof useUpdatePolicyMutation
>;
export type UpdatePolicyMutationResult =
  Apollo.MutationResult<UpdatePolicyMutation>;
export type UpdatePolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdatePolicyMutation,
  UpdatePolicyMutationVariables
>;
export const UpdateWorkflowSecretDocument = gql`
  mutation UpdateWorkflowSecret(
    $workflowSecret: PartialWorkflowV1WorkflowSecretInput!
  ) {
    updateWorkflowSecret(workflowSecret: $workflowSecret) {
      ... on WorkflowV1WorkflowSecret {
        name
        updateTime
      }
    }
  }
`;
export type UpdateWorkflowSecretMutationFn = Apollo.MutationFunction<
  UpdateWorkflowSecretMutation,
  UpdateWorkflowSecretMutationVariables
>;

/**
 * __useUpdateWorkflowSecretMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowSecretMutation, { data, loading, error }] = useUpdateWorkflowSecretMutation({
 *   variables: {
 *      workflowSecret: // value for 'workflowSecret'
 *   },
 * });
 */
export function useUpdateWorkflowSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowSecretMutation,
    UpdateWorkflowSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowSecretMutation,
    UpdateWorkflowSecretMutationVariables
  >(UpdateWorkflowSecretDocument, options);
}
export type UpdateWorkflowSecretMutationHookResult = ReturnType<
  typeof useUpdateWorkflowSecretMutation
>;
export type UpdateWorkflowSecretMutationResult =
  Apollo.MutationResult<UpdateWorkflowSecretMutation>;
export type UpdateWorkflowSecretMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkflowSecretMutation,
  UpdateWorkflowSecretMutationVariables
>;
export const UpdateWorkflowVersionDocument = gql`
  mutation UpdateWorkflowVersion($version: String!, $name: String!) {
    updateWorkflow(workflow: { currentVersion: $version, name: $name }) {
      ... on WorkflowV1Workflow {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UpdateWorkflowVersionMutationFn = Apollo.MutationFunction<
  UpdateWorkflowVersionMutation,
  UpdateWorkflowVersionMutationVariables
>;

/**
 * __useUpdateWorkflowVersionMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowVersionMutation, { data, loading, error }] = useUpdateWorkflowVersionMutation({
 *   variables: {
 *      version: // value for 'version'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateWorkflowVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowVersionMutation,
    UpdateWorkflowVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowVersionMutation,
    UpdateWorkflowVersionMutationVariables
  >(UpdateWorkflowVersionDocument, options);
}
export type UpdateWorkflowVersionMutationHookResult = ReturnType<
  typeof useUpdateWorkflowVersionMutation
>;
export type UpdateWorkflowVersionMutationResult =
  Apollo.MutationResult<UpdateWorkflowVersionMutation>;
export type UpdateWorkflowVersionMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkflowVersionMutation,
  UpdateWorkflowVersionMutationVariables
>;
export const UserDetailsDocument = gql`
  query UserDetails($name: String!) {
    user(name: $name) {
      ...DefaultError
      ... on IamV1User {
        __typename
        email
        fullName
        name
        pictureUri
        lastLoginTime
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUserDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserDetailsQuery,
    UserDetailsQueryVariables
  > &
    (
      | { variables: UserDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(
    UserDetailsDocument,
    options,
  );
}
export function useUserDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserDetailsQuery,
    UserDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(
    UserDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useUserDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserDetailsQuery,
    UserDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export function useUserDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserDetailsQuery,
        UserDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserDetailsQuery | undefined,
  UserDetailsQueryVariables
>;
export function useUserDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserDetailsQuery,
        UserDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserDetailsQuery, UserDetailsQueryVariables>(
    UserDetailsDocument,
    options,
  );
}
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<
  typeof useUserDetailsLazyQuery
>;
export type UserDetailsSuspenseQueryHookResult = ReturnType<
  typeof useUserDetailsSuspenseQuery
>;
export type UserDetailsQueryResult = Apollo.QueryResult<
  UserDetailsQuery,
  UserDetailsQueryVariables
>;
export const UserInvitationsDocument = gql`
  query UserInvitations($pageSize: Int, $pageToken: String) {
    userInvitations(pageSize: $pageSize, pageToken: $pageToken) {
      ... on IamV1ListUserInvitationsResponse {
        __typename
        nextPageToken
        userInvitations {
          ...UserInvitation
        }
      }
      ...DefaultError
    }
  }
  ${UserInvitationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUserInvitationsQuery__
 *
 * To run a query within a React component, call `useUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitationsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useUserInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserInvitationsQuery,
    UserInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserInvitationsQuery, UserInvitationsQueryVariables>(
    UserInvitationsDocument,
    options,
  );
}
export function useUserInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserInvitationsQuery,
    UserInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserInvitationsQuery,
    UserInvitationsQueryVariables
  >(UserInvitationsDocument, options);
}
// @ts-ignore
export function useUserInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserInvitationsQuery,
    UserInvitationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserInvitationsQuery,
  UserInvitationsQueryVariables
>;
export function useUserInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserInvitationsQuery,
        UserInvitationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserInvitationsQuery | undefined,
  UserInvitationsQueryVariables
>;
export function useUserInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserInvitationsQuery,
        UserInvitationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserInvitationsQuery,
    UserInvitationsQueryVariables
  >(UserInvitationsDocument, options);
}
export type UserInvitationsQueryHookResult = ReturnType<
  typeof useUserInvitationsQuery
>;
export type UserInvitationsLazyQueryHookResult = ReturnType<
  typeof useUserInvitationsLazyQuery
>;
export type UserInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useUserInvitationsSuspenseQuery
>;
export type UserInvitationsQueryResult = Apollo.QueryResult<
  UserInvitationsQuery,
  UserInvitationsQueryVariables
>;
export const ValidateBigQueryDataWarehouseConfigDocument = gql`
  mutation ValidateBigQueryDataWarehouseConfig(
    $bigQueryConfig: MetricsV1BigQueryConfigInput
  ) {
    validateDataWarehouseConfig(bigQueryConfig: $bigQueryConfig) {
      ... on MetricsV1ValidateDataWarehouseConfigResponse {
        __typename
        successful
        validation {
          description
          error
          key
          success
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ValidateBigQueryDataWarehouseConfigMutationFn =
  Apollo.MutationFunction<
    ValidateBigQueryDataWarehouseConfigMutation,
    ValidateBigQueryDataWarehouseConfigMutationVariables
  >;

/**
 * __useValidateBigQueryDataWarehouseConfigMutation__
 *
 * To run a mutation, you first call `useValidateBigQueryDataWarehouseConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBigQueryDataWarehouseConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBigQueryDataWarehouseConfigMutation, { data, loading, error }] = useValidateBigQueryDataWarehouseConfigMutation({
 *   variables: {
 *      bigQueryConfig: // value for 'bigQueryConfig'
 *   },
 * });
 */
export function useValidateBigQueryDataWarehouseConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateBigQueryDataWarehouseConfigMutation,
    ValidateBigQueryDataWarehouseConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateBigQueryDataWarehouseConfigMutation,
    ValidateBigQueryDataWarehouseConfigMutationVariables
  >(ValidateBigQueryDataWarehouseConfigDocument, options);
}
export type ValidateBigQueryDataWarehouseConfigMutationHookResult = ReturnType<
  typeof useValidateBigQueryDataWarehouseConfigMutation
>;
export type ValidateBigQueryDataWarehouseConfigMutationResult =
  Apollo.MutationResult<ValidateBigQueryDataWarehouseConfigMutation>;
export type ValidateBigQueryDataWarehouseConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateBigQueryDataWarehouseConfigMutation,
    ValidateBigQueryDataWarehouseConfigMutationVariables
  >;
export const ValidateBigQueryEventConnectionConfigDocument = gql`
  mutation ValidateBigQueryEventConnectionConfig(
    $bigQuery: ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput
  ) {
    validateEventConnectionConfig(bigQuery: $bigQuery) {
      ... on ConnectorsV1ValidateEventConnectionConfigResponse {
        bigQueryConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateBigQueryEventConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateBigQueryEventConnectionConfigMutation,
    ValidateBigQueryEventConnectionConfigMutationVariables
  >;

/**
 * __useValidateBigQueryEventConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateBigQueryEventConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBigQueryEventConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBigQueryEventConnectionConfigMutation, { data, loading, error }] = useValidateBigQueryEventConnectionConfigMutation({
 *   variables: {
 *      bigQuery: // value for 'bigQuery'
 *   },
 * });
 */
export function useValidateBigQueryEventConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateBigQueryEventConnectionConfigMutation,
    ValidateBigQueryEventConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateBigQueryEventConnectionConfigMutation,
    ValidateBigQueryEventConnectionConfigMutationVariables
  >(ValidateBigQueryEventConnectionConfigDocument, options);
}
export type ValidateBigQueryEventConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateBigQueryEventConnectionConfigMutation>;
export type ValidateBigQueryEventConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateBigQueryEventConnectionConfigMutation>;
export type ValidateBigQueryEventConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateBigQueryEventConnectionConfigMutation,
    ValidateBigQueryEventConnectionConfigMutationVariables
  >;
export const ValidateBigQueryFlagAppliedConnectionConfigDocument = gql`
  mutation ValidateBigQueryFlagAppliedConnectionConfig(
    $bigQuery: ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput
  ) {
    validateFlagAppliedConnectionConfig(bigQuery: $bigQuery) {
      ... on ConnectorsV1ValidateFlagAppliedConnectionConfigResponse {
        bigQueryConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateBigQueryFlagAppliedConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateBigQueryFlagAppliedConnectionConfigMutation,
    ValidateBigQueryFlagAppliedConnectionConfigMutationVariables
  >;

/**
 * __useValidateBigQueryFlagAppliedConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateBigQueryFlagAppliedConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBigQueryFlagAppliedConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBigQueryFlagAppliedConnectionConfigMutation, { data, loading, error }] = useValidateBigQueryFlagAppliedConnectionConfigMutation({
 *   variables: {
 *      bigQuery: // value for 'bigQuery'
 *   },
 * });
 */
export function useValidateBigQueryFlagAppliedConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateBigQueryFlagAppliedConnectionConfigMutation,
    ValidateBigQueryFlagAppliedConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateBigQueryFlagAppliedConnectionConfigMutation,
    ValidateBigQueryFlagAppliedConnectionConfigMutationVariables
  >(ValidateBigQueryFlagAppliedConnectionConfigDocument, options);
}
export type ValidateBigQueryFlagAppliedConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateBigQueryFlagAppliedConnectionConfigMutation>;
export type ValidateBigQueryFlagAppliedConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateBigQueryFlagAppliedConnectionConfigMutation>;
export type ValidateBigQueryFlagAppliedConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateBigQueryFlagAppliedConnectionConfigMutation,
    ValidateBigQueryFlagAppliedConnectionConfigMutationVariables
  >;
export const ValidateDataWarehouseConfigDocument = gql`
  mutation ValidateDataWarehouseConfig(
    $existingWarehouse: String
    $redshiftConfig: MetricsV1RedshiftConfigInput
  ) {
    validateDataWarehouseConfig(
      redshiftConfig: $redshiftConfig
      existingWarehouse: $existingWarehouse
    ) {
      ... on MetricsV1ValidateDataWarehouseConfigResponse {
        __typename
        redshiftConfigValidation {
          availableSchemas
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ValidateDataWarehouseConfigMutationFn = Apollo.MutationFunction<
  ValidateDataWarehouseConfigMutation,
  ValidateDataWarehouseConfigMutationVariables
>;

/**
 * __useValidateDataWarehouseConfigMutation__
 *
 * To run a mutation, you first call `useValidateDataWarehouseConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDataWarehouseConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDataWarehouseConfigMutation, { data, loading, error }] = useValidateDataWarehouseConfigMutation({
 *   variables: {
 *      existingWarehouse: // value for 'existingWarehouse'
 *      redshiftConfig: // value for 'redshiftConfig'
 *   },
 * });
 */
export function useValidateDataWarehouseConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateDataWarehouseConfigMutation,
    ValidateDataWarehouseConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateDataWarehouseConfigMutation,
    ValidateDataWarehouseConfigMutationVariables
  >(ValidateDataWarehouseConfigDocument, options);
}
export type ValidateDataWarehouseConfigMutationHookResult = ReturnType<
  typeof useValidateDataWarehouseConfigMutation
>;
export type ValidateDataWarehouseConfigMutationResult =
  Apollo.MutationResult<ValidateDataWarehouseConfigMutation>;
export type ValidateDataWarehouseConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateDataWarehouseConfigMutation,
    ValidateDataWarehouseConfigMutationVariables
  >;
export const ValidateDatabricksEventConnectionConfigDocument = gql`
  mutation ValidateDatabricksEventConnectionConfig(
    $databricks: ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput
  ) {
    validateEventConnectionConfig(databricks: $databricks) {
      ... on ConnectorsV1ValidateEventConnectionConfigResponse {
        databricksConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateDatabricksEventConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateDatabricksEventConnectionConfigMutation,
    ValidateDatabricksEventConnectionConfigMutationVariables
  >;

/**
 * __useValidateDatabricksEventConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateDatabricksEventConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDatabricksEventConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDatabricksEventConnectionConfigMutation, { data, loading, error }] = useValidateDatabricksEventConnectionConfigMutation({
 *   variables: {
 *      databricks: // value for 'databricks'
 *   },
 * });
 */
export function useValidateDatabricksEventConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateDatabricksEventConnectionConfigMutation,
    ValidateDatabricksEventConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateDatabricksEventConnectionConfigMutation,
    ValidateDatabricksEventConnectionConfigMutationVariables
  >(ValidateDatabricksEventConnectionConfigDocument, options);
}
export type ValidateDatabricksEventConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateDatabricksEventConnectionConfigMutation>;
export type ValidateDatabricksEventConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateDatabricksEventConnectionConfigMutation>;
export type ValidateDatabricksEventConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateDatabricksEventConnectionConfigMutation,
    ValidateDatabricksEventConnectionConfigMutationVariables
  >;
export const ValidateDatabricksFlagAppliedConnectionConfigDocument = gql`
  mutation ValidateDatabricksFlagAppliedConnectionConfig(
    $databricks: ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput
  ) {
    validateFlagAppliedConnectionConfig(databricks: $databricks) {
      ... on ConnectorsV1ValidateFlagAppliedConnectionConfigResponse {
        databricksConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateDatabricksFlagAppliedConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateDatabricksFlagAppliedConnectionConfigMutation,
    ValidateDatabricksFlagAppliedConnectionConfigMutationVariables
  >;

/**
 * __useValidateDatabricksFlagAppliedConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateDatabricksFlagAppliedConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDatabricksFlagAppliedConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDatabricksFlagAppliedConnectionConfigMutation, { data, loading, error }] = useValidateDatabricksFlagAppliedConnectionConfigMutation({
 *   variables: {
 *      databricks: // value for 'databricks'
 *   },
 * });
 */
export function useValidateDatabricksFlagAppliedConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateDatabricksFlagAppliedConnectionConfigMutation,
    ValidateDatabricksFlagAppliedConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateDatabricksFlagAppliedConnectionConfigMutation,
    ValidateDatabricksFlagAppliedConnectionConfigMutationVariables
  >(ValidateDatabricksFlagAppliedConnectionConfigDocument, options);
}
export type ValidateDatabricksFlagAppliedConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateDatabricksFlagAppliedConnectionConfigMutation>;
export type ValidateDatabricksFlagAppliedConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateDatabricksFlagAppliedConnectionConfigMutation>;
export type ValidateDatabricksFlagAppliedConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateDatabricksFlagAppliedConnectionConfigMutation,
    ValidateDatabricksFlagAppliedConnectionConfigMutationVariables
  >;
export const ValidatePubsubFlagAppliedConnectionConfigDocument = gql`
  mutation ValidatePubsubFlagAppliedConnectionConfig(
    $pubsub: ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput
  ) {
    validateFlagAppliedConnectionConfig(pubsub: $pubsub) {
      ... on ConnectorsV1ValidateFlagAppliedConnectionConfigResponse {
        pubsubConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidatePubsubFlagAppliedConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidatePubsubFlagAppliedConnectionConfigMutation,
    ValidatePubsubFlagAppliedConnectionConfigMutationVariables
  >;

/**
 * __useValidatePubsubFlagAppliedConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidatePubsubFlagAppliedConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePubsubFlagAppliedConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePubsubFlagAppliedConnectionConfigMutation, { data, loading, error }] = useValidatePubsubFlagAppliedConnectionConfigMutation({
 *   variables: {
 *      pubsub: // value for 'pubsub'
 *   },
 * });
 */
export function useValidatePubsubFlagAppliedConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidatePubsubFlagAppliedConnectionConfigMutation,
    ValidatePubsubFlagAppliedConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidatePubsubFlagAppliedConnectionConfigMutation,
    ValidatePubsubFlagAppliedConnectionConfigMutationVariables
  >(ValidatePubsubFlagAppliedConnectionConfigDocument, options);
}
export type ValidatePubsubFlagAppliedConnectionConfigMutationHookResult =
  ReturnType<typeof useValidatePubsubFlagAppliedConnectionConfigMutation>;
export type ValidatePubsubFlagAppliedConnectionConfigMutationResult =
  Apollo.MutationResult<ValidatePubsubFlagAppliedConnectionConfigMutation>;
export type ValidatePubsubFlagAppliedConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidatePubsubFlagAppliedConnectionConfigMutation,
    ValidatePubsubFlagAppliedConnectionConfigMutationVariables
  >;
export const ValidateRedshiftEventConnectionConfigDocument = gql`
  mutation ValidateRedshiftEventConnectionConfig(
    $redshift: ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput
  ) {
    validateEventConnectionConfig(redshift: $redshift) {
      ... on ConnectorsV1ValidateEventConnectionConfigResponse {
        redshiftConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateRedshiftEventConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateRedshiftEventConnectionConfigMutation,
    ValidateRedshiftEventConnectionConfigMutationVariables
  >;

/**
 * __useValidateRedshiftEventConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateRedshiftEventConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRedshiftEventConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRedshiftEventConnectionConfigMutation, { data, loading, error }] = useValidateRedshiftEventConnectionConfigMutation({
 *   variables: {
 *      redshift: // value for 'redshift'
 *   },
 * });
 */
export function useValidateRedshiftEventConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateRedshiftEventConnectionConfigMutation,
    ValidateRedshiftEventConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateRedshiftEventConnectionConfigMutation,
    ValidateRedshiftEventConnectionConfigMutationVariables
  >(ValidateRedshiftEventConnectionConfigDocument, options);
}
export type ValidateRedshiftEventConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateRedshiftEventConnectionConfigMutation>;
export type ValidateRedshiftEventConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateRedshiftEventConnectionConfigMutation>;
export type ValidateRedshiftEventConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateRedshiftEventConnectionConfigMutation,
    ValidateRedshiftEventConnectionConfigMutationVariables
  >;
export const ValidateRedshiftFlagAppliedConnectionConfigDocument = gql`
  mutation ValidateRedshiftFlagAppliedConnectionConfig(
    $redshift: ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput
  ) {
    validateFlagAppliedConnectionConfig(redshift: $redshift) {
      ... on ConnectorsV1ValidateFlagAppliedConnectionConfigResponse {
        redshiftConfigValidation {
          dummy
        }
      }
    }
  }
`;
export type ValidateRedshiftFlagAppliedConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateRedshiftFlagAppliedConnectionConfigMutation,
    ValidateRedshiftFlagAppliedConnectionConfigMutationVariables
  >;

/**
 * __useValidateRedshiftFlagAppliedConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateRedshiftFlagAppliedConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRedshiftFlagAppliedConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRedshiftFlagAppliedConnectionConfigMutation, { data, loading, error }] = useValidateRedshiftFlagAppliedConnectionConfigMutation({
 *   variables: {
 *      redshift: // value for 'redshift'
 *   },
 * });
 */
export function useValidateRedshiftFlagAppliedConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateRedshiftFlagAppliedConnectionConfigMutation,
    ValidateRedshiftFlagAppliedConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateRedshiftFlagAppliedConnectionConfigMutation,
    ValidateRedshiftFlagAppliedConnectionConfigMutationVariables
  >(ValidateRedshiftFlagAppliedConnectionConfigDocument, options);
}
export type ValidateRedshiftFlagAppliedConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateRedshiftFlagAppliedConnectionConfigMutation>;
export type ValidateRedshiftFlagAppliedConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateRedshiftFlagAppliedConnectionConfigMutation>;
export type ValidateRedshiftFlagAppliedConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateRedshiftFlagAppliedConnectionConfigMutation,
    ValidateRedshiftFlagAppliedConnectionConfigMutationVariables
  >;
export const ValidateSnowflakeDataWarehouseConfigDocument = gql`
  mutation ValidateSnowflakeDataWarehouseConfig(
    $snowflakeConfig: MetricsV1ValidateSnowflakeConfigInput
  ) {
    validateDataWarehouseConfig(snowflakeConfig: $snowflakeConfig) {
      ... on MetricsV1ValidateDataWarehouseConfigResponse {
        __typename
        snowflakeConfigValidation {
          databases
          roles
          warehouses
          schemas
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ValidateSnowflakeDataWarehouseConfigMutationFn =
  Apollo.MutationFunction<
    ValidateSnowflakeDataWarehouseConfigMutation,
    ValidateSnowflakeDataWarehouseConfigMutationVariables
  >;

/**
 * __useValidateSnowflakeDataWarehouseConfigMutation__
 *
 * To run a mutation, you first call `useValidateSnowflakeDataWarehouseConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSnowflakeDataWarehouseConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSnowflakeDataWarehouseConfigMutation, { data, loading, error }] = useValidateSnowflakeDataWarehouseConfigMutation({
 *   variables: {
 *      snowflakeConfig: // value for 'snowflakeConfig'
 *   },
 * });
 */
export function useValidateSnowflakeDataWarehouseConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateSnowflakeDataWarehouseConfigMutation,
    ValidateSnowflakeDataWarehouseConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateSnowflakeDataWarehouseConfigMutation,
    ValidateSnowflakeDataWarehouseConfigMutationVariables
  >(ValidateSnowflakeDataWarehouseConfigDocument, options);
}
export type ValidateSnowflakeDataWarehouseConfigMutationHookResult = ReturnType<
  typeof useValidateSnowflakeDataWarehouseConfigMutation
>;
export type ValidateSnowflakeDataWarehouseConfigMutationResult =
  Apollo.MutationResult<ValidateSnowflakeDataWarehouseConfigMutation>;
export type ValidateSnowflakeDataWarehouseConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateSnowflakeDataWarehouseConfigMutation,
    ValidateSnowflakeDataWarehouseConfigMutationVariables
  >;
export const ValidateSnowflakeEventConnectionConfigDocument = gql`
  mutation ValidateSnowflakeEventConnectionConfig(
    $snowflake: ConnectorsV1PartialSnowflakeConfigInput
  ) {
    validateEventConnectionConfig(snowflake: $snowflake) {
      ... on ConnectorsV1ValidateEventConnectionConfigResponse {
        __typename
        snowflakeConfigValidation {
          databases
          roles
          schemas
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ValidateSnowflakeEventConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateSnowflakeEventConnectionConfigMutation,
    ValidateSnowflakeEventConnectionConfigMutationVariables
  >;

/**
 * __useValidateSnowflakeEventConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateSnowflakeEventConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSnowflakeEventConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSnowflakeEventConnectionConfigMutation, { data, loading, error }] = useValidateSnowflakeEventConnectionConfigMutation({
 *   variables: {
 *      snowflake: // value for 'snowflake'
 *   },
 * });
 */
export function useValidateSnowflakeEventConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateSnowflakeEventConnectionConfigMutation,
    ValidateSnowflakeEventConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateSnowflakeEventConnectionConfigMutation,
    ValidateSnowflakeEventConnectionConfigMutationVariables
  >(ValidateSnowflakeEventConnectionConfigDocument, options);
}
export type ValidateSnowflakeEventConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateSnowflakeEventConnectionConfigMutation>;
export type ValidateSnowflakeEventConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateSnowflakeEventConnectionConfigMutation>;
export type ValidateSnowflakeEventConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateSnowflakeEventConnectionConfigMutation,
    ValidateSnowflakeEventConnectionConfigMutationVariables
  >;
export const ValidateSnowflakeFlagAppliedConnectionConfigDocument = gql`
  mutation ValidateSnowflakeFlagAppliedConnectionConfig(
    $snowflake: ConnectorsV1PartialSnowflakeConfigInput
  ) {
    validateFlagAppliedConnectionConfig(snowflake: $snowflake) {
      ... on ConnectorsV1ValidateFlagAppliedConnectionConfigResponse {
        __typename
        snowflakeConfigValidation {
          databases
          roles
          schemas
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ValidateSnowflakeFlagAppliedConnectionConfigMutationFn =
  Apollo.MutationFunction<
    ValidateSnowflakeFlagAppliedConnectionConfigMutation,
    ValidateSnowflakeFlagAppliedConnectionConfigMutationVariables
  >;

/**
 * __useValidateSnowflakeFlagAppliedConnectionConfigMutation__
 *
 * To run a mutation, you first call `useValidateSnowflakeFlagAppliedConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSnowflakeFlagAppliedConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSnowflakeFlagAppliedConnectionConfigMutation, { data, loading, error }] = useValidateSnowflakeFlagAppliedConnectionConfigMutation({
 *   variables: {
 *      snowflake: // value for 'snowflake'
 *   },
 * });
 */
export function useValidateSnowflakeFlagAppliedConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateSnowflakeFlagAppliedConnectionConfigMutation,
    ValidateSnowflakeFlagAppliedConnectionConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateSnowflakeFlagAppliedConnectionConfigMutation,
    ValidateSnowflakeFlagAppliedConnectionConfigMutationVariables
  >(ValidateSnowflakeFlagAppliedConnectionConfigDocument, options);
}
export type ValidateSnowflakeFlagAppliedConnectionConfigMutationHookResult =
  ReturnType<typeof useValidateSnowflakeFlagAppliedConnectionConfigMutation>;
export type ValidateSnowflakeFlagAppliedConnectionConfigMutationResult =
  Apollo.MutationResult<ValidateSnowflakeFlagAppliedConnectionConfigMutation>;
export type ValidateSnowflakeFlagAppliedConnectionConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateSnowflakeFlagAppliedConnectionConfigMutation,
    ValidateSnowflakeFlagAppliedConnectionConfigMutationVariables
  >;
export const WarehouseStatsDocument = gql`
  query WarehouseStats($startTime: String!, $endTime: String!) {
    queryDataWarehouseStats(
      interval: DAILY
      startTime: $startTime
      endTime: $endTime
    ) {
      ... on MetricsV1QueryDataWarehouseStatsResponse {
        stats {
          entryTime
          failedQueryCount
          totalQueryCount
          bqStats {
            ... on MetricsV1DataWarehouseStatsEntryBqStats {
              totalSlotMs
              totalBytesBilled
              totalBytesProcessed
            }
          }
        }
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWarehouseStatsQuery__
 *
 * To run a query within a React component, call `useWarehouseStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseStatsQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useWarehouseStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WarehouseStatsQuery,
    WarehouseStatsQueryVariables
  > &
    (
      | { variables: WarehouseStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WarehouseStatsQuery, WarehouseStatsQueryVariables>(
    WarehouseStatsDocument,
    options,
  );
}
export function useWarehouseStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WarehouseStatsQuery,
    WarehouseStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WarehouseStatsQuery, WarehouseStatsQueryVariables>(
    WarehouseStatsDocument,
    options,
  );
}
// @ts-ignore
export function useWarehouseStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WarehouseStatsQuery,
    WarehouseStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WarehouseStatsQuery,
  WarehouseStatsQueryVariables
>;
export function useWarehouseStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WarehouseStatsQuery,
        WarehouseStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WarehouseStatsQuery | undefined,
  WarehouseStatsQueryVariables
>;
export function useWarehouseStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WarehouseStatsQuery,
        WarehouseStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WarehouseStatsQuery,
    WarehouseStatsQueryVariables
  >(WarehouseStatsDocument, options);
}
export type WarehouseStatsQueryHookResult = ReturnType<
  typeof useWarehouseStatsQuery
>;
export type WarehouseStatsLazyQueryHookResult = ReturnType<
  typeof useWarehouseStatsLazyQuery
>;
export type WarehouseStatsSuspenseQueryHookResult = ReturnType<
  typeof useWarehouseStatsSuspenseQuery
>;
export type WarehouseStatsQueryResult = Apollo.QueryResult<
  WarehouseStatsQuery,
  WarehouseStatsQueryVariables
>;
export const WorkflowInstanceDocument = gql`
  query WorkflowInstance($name: String!) {
    workflowInstance(name: $name) {
      ... on WorkflowV1WorkflowInstance {
        __typename
        name
        displayName
        state
        workflowVersion {
          ... on WorkflowV1WorkflowVersion {
            name
            __typename
          }
          ...DefaultError
        }
        createTime
        updateTime
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowInstanceQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkflowInstanceQuery,
    WorkflowInstanceQueryVariables
  > &
    (
      | { variables: WorkflowInstanceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkflowInstanceQuery, WorkflowInstanceQueryVariables>(
    WorkflowInstanceDocument,
    options,
  );
}
export function useWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowInstanceQuery,
    WorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowInstanceQuery,
    WorkflowInstanceQueryVariables
  >(WorkflowInstanceDocument, options);
}
// @ts-ignore
export function useWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowInstanceQuery,
    WorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstanceQuery,
  WorkflowInstanceQueryVariables
>;
export function useWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstanceQuery,
        WorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstanceQuery | undefined,
  WorkflowInstanceQueryVariables
>;
export function useWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstanceQuery,
        WorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowInstanceQuery,
    WorkflowInstanceQueryVariables
  >(WorkflowInstanceDocument, options);
}
export type WorkflowInstanceQueryHookResult = ReturnType<
  typeof useWorkflowInstanceQuery
>;
export type WorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useWorkflowInstanceLazyQuery
>;
export type WorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowInstanceSuspenseQuery
>;
export type WorkflowInstanceQueryResult = Apollo.QueryResult<
  WorkflowInstanceQuery,
  WorkflowInstanceQueryVariables
>;
export const WorkflowLogsDocument = gql`
  query WorkflowLogs($parent: String!, $pageToken: String) {
    workflowLogs(parent: $parent, pageToken: $pageToken) {
      ... on WorkflowV1ListWorkflowLogsResponse {
        __typename
        nextPageToken
        workflowLogs {
          logTime
          level
          message
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowLogsQuery__
 *
 * To run a query within a React component, call `useWorkflowLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowLogsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useWorkflowLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkflowLogsQuery,
    WorkflowLogsQueryVariables
  > &
    (
      | { variables: WorkflowLogsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkflowLogsQuery, WorkflowLogsQueryVariables>(
    WorkflowLogsDocument,
    options,
  );
}
export function useWorkflowLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowLogsQuery,
    WorkflowLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkflowLogsQuery, WorkflowLogsQueryVariables>(
    WorkflowLogsDocument,
    options,
  );
}
// @ts-ignore
export function useWorkflowLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowLogsQuery,
    WorkflowLogsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<WorkflowLogsQuery, WorkflowLogsQueryVariables>;
export function useWorkflowLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowLogsQuery,
        WorkflowLogsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowLogsQuery | undefined,
  WorkflowLogsQueryVariables
>;
export function useWorkflowLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowLogsQuery,
        WorkflowLogsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkflowLogsQuery, WorkflowLogsQueryVariables>(
    WorkflowLogsDocument,
    options,
  );
}
export type WorkflowLogsQueryHookResult = ReturnType<
  typeof useWorkflowLogsQuery
>;
export type WorkflowLogsLazyQueryHookResult = ReturnType<
  typeof useWorkflowLogsLazyQuery
>;
export type WorkflowLogsSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowLogsSuspenseQuery
>;
export type WorkflowLogsQueryResult = Apollo.QueryResult<
  WorkflowLogsQuery,
  WorkflowLogsQueryVariables
>;
export const WorkflowSecretsDocument = gql`
  query WorkflowSecrets($pageToken: String, $pageSize: Int) {
    workflowSecrets(pageToken: $pageToken, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowSecretsResponse {
        __typename
        nextPageToken
        workflowSecrets {
          name
          updateTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowSecretsQuery__
 *
 * To run a query within a React component, call `useWorkflowSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowSecretsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useWorkflowSecretsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkflowSecretsQuery,
    WorkflowSecretsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkflowSecretsQuery, WorkflowSecretsQueryVariables>(
    WorkflowSecretsDocument,
    options,
  );
}
export function useWorkflowSecretsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowSecretsQuery,
    WorkflowSecretsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowSecretsQuery,
    WorkflowSecretsQueryVariables
  >(WorkflowSecretsDocument, options);
}
// @ts-ignore
export function useWorkflowSecretsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowSecretsQuery,
    WorkflowSecretsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowSecretsQuery,
  WorkflowSecretsQueryVariables
>;
export function useWorkflowSecretsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowSecretsQuery,
        WorkflowSecretsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowSecretsQuery | undefined,
  WorkflowSecretsQueryVariables
>;
export function useWorkflowSecretsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowSecretsQuery,
        WorkflowSecretsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowSecretsQuery,
    WorkflowSecretsQueryVariables
  >(WorkflowSecretsDocument, options);
}
export type WorkflowSecretsQueryHookResult = ReturnType<
  typeof useWorkflowSecretsQuery
>;
export type WorkflowSecretsLazyQueryHookResult = ReturnType<
  typeof useWorkflowSecretsLazyQuery
>;
export type WorkflowSecretsSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowSecretsSuspenseQuery
>;
export type WorkflowSecretsQueryResult = Apollo.QueryResult<
  WorkflowSecretsQuery,
  WorkflowSecretsQueryVariables
>;
export const CreateLabelDocument = gql`
  mutation CreateLabel($input: AdminLabelsV1LabelInput!, $labelId: String!) {
    createLabel(label: $input, labelId: $labelId) {
      ...Label
      ...DefaultError
    }
  }
  ${LabelFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateLabelMutationFn = Apollo.MutationFunction<
  CreateLabelMutation,
  CreateLabelMutationVariables
>;

/**
 * __useCreateLabelMutation__
 *
 * To run a mutation, you first call `useCreateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabelMutation, { data, loading, error }] = useCreateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useCreateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLabelMutation,
    CreateLabelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLabelMutation, CreateLabelMutationVariables>(
    CreateLabelDocument,
    options,
  );
}
export type CreateLabelMutationHookResult = ReturnType<
  typeof useCreateLabelMutation
>;
export type CreateLabelMutationResult =
  Apollo.MutationResult<CreateLabelMutation>;
export type CreateLabelMutationOptions = Apollo.BaseMutationOptions<
  CreateLabelMutation,
  CreateLabelMutationVariables
>;
export const DeleteLabelDocument = gql`
  mutation DeleteLabel($name: String!) {
    deleteLabel(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteLabelMutationFn = Apollo.MutationFunction<
  DeleteLabelMutation,
  DeleteLabelMutationVariables
>;

/**
 * __useDeleteLabelMutation__
 *
 * To run a mutation, you first call `useDeleteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabelMutation, { data, loading, error }] = useDeleteLabelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLabelMutation,
    DeleteLabelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteLabelMutation, DeleteLabelMutationVariables>(
    DeleteLabelDocument,
    options,
  );
}
export type DeleteLabelMutationHookResult = ReturnType<
  typeof useDeleteLabelMutation
>;
export type DeleteLabelMutationResult =
  Apollo.MutationResult<DeleteLabelMutation>;
export type DeleteLabelMutationOptions = Apollo.BaseMutationOptions<
  DeleteLabelMutation,
  DeleteLabelMutationVariables
>;
export const UpdateLabelDocument = gql`
  mutation UpdateLabel(
    $label: PartialAdminLabelsV1LabelInput!
    $updateMask: String
  ) {
    updateLabel(label: $label, updateMask: $updateMask) {
      ...Label
      ...DefaultError
    }
  }
  ${LabelFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateLabelMutationFn = Apollo.MutationFunction<
  UpdateLabelMutation,
  UpdateLabelMutationVariables
>;

/**
 * __useUpdateLabelMutation__
 *
 * To run a mutation, you first call `useUpdateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabelMutation, { data, loading, error }] = useUpdateLabelMutation({
 *   variables: {
 *      label: // value for 'label'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLabelMutation,
    UpdateLabelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLabelMutation, UpdateLabelMutationVariables>(
    UpdateLabelDocument,
    options,
  );
}
export type UpdateLabelMutationHookResult = ReturnType<
  typeof useUpdateLabelMutation
>;
export type UpdateLabelMutationResult =
  Apollo.MutationResult<UpdateLabelMutation>;
export type UpdateLabelMutationOptions = Apollo.BaseMutationOptions<
  UpdateLabelMutation,
  UpdateLabelMutationVariables
>;
export const AccountTokenUsageDocument = gql`
  query AccountTokenUsage {
    accountTokenUsage {
      __typename
      ... on AiworkflowsV1AccountTokenUsage {
        usage {
          ...ManagedTokenUsage
        }
        sessionCount
      }
      ...DefaultError
    }
  }
  ${ManagedTokenUsageFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAccountTokenUsageQuery__
 *
 * To run a query within a React component, call `useAccountTokenUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTokenUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTokenUsageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >(AccountTokenUsageDocument, options);
}
export function useAccountTokenUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >(AccountTokenUsageDocument, options);
}
// @ts-ignore
export function useAccountTokenUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountTokenUsageQuery,
  AccountTokenUsageQueryVariables
>;
export function useAccountTokenUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountTokenUsageQuery,
        AccountTokenUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountTokenUsageQuery | undefined,
  AccountTokenUsageQueryVariables
>;
export function useAccountTokenUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountTokenUsageQuery,
        AccountTokenUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AccountTokenUsageQuery,
    AccountTokenUsageQueryVariables
  >(AccountTokenUsageDocument, options);
}
export type AccountTokenUsageQueryHookResult = ReturnType<
  typeof useAccountTokenUsageQuery
>;
export type AccountTokenUsageLazyQueryHookResult = ReturnType<
  typeof useAccountTokenUsageLazyQuery
>;
export type AccountTokenUsageSuspenseQueryHookResult = ReturnType<
  typeof useAccountTokenUsageSuspenseQuery
>;
export type AccountTokenUsageQueryResult = Apollo.QueryResult<
  AccountTokenUsageQuery,
  AccountTokenUsageQueryVariables
>;
export const ArchiveManagedWorkspaceDocument = gql`
  mutation ArchiveManagedWorkspace($account: String!) {
    archiveManagedWorkspace(account: $account) {
      __typename
      ... on AiworkflowsV1ArchiveManagedWorkspaceResponse {
        archivedWorkspaceId
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ArchiveManagedWorkspaceMutationFn = Apollo.MutationFunction<
  ArchiveManagedWorkspaceMutation,
  ArchiveManagedWorkspaceMutationVariables
>;

/**
 * __useArchiveManagedWorkspaceMutation__
 *
 * To run a mutation, you first call `useArchiveManagedWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveManagedWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveManagedWorkspaceMutation, { data, loading, error }] = useArchiveManagedWorkspaceMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useArchiveManagedWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveManagedWorkspaceMutation,
    ArchiveManagedWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveManagedWorkspaceMutation,
    ArchiveManagedWorkspaceMutationVariables
  >(ArchiveManagedWorkspaceDocument, options);
}
export type ArchiveManagedWorkspaceMutationHookResult = ReturnType<
  typeof useArchiveManagedWorkspaceMutation
>;
export type ArchiveManagedWorkspaceMutationResult =
  Apollo.MutationResult<ArchiveManagedWorkspaceMutation>;
export type ArchiveManagedWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  ArchiveManagedWorkspaceMutation,
  ArchiveManagedWorkspaceMutationVariables
>;
export const ManagedAgentSettingsDocument = gql`
  query ManagedAgentSettings {
    managedAgentSettings {
      __typename
      ... on AiworkflowsV1ManagedAgentSettings {
        enabled
        available
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useManagedAgentSettingsQuery__
 *
 * To run a query within a React component, call `useManagedAgentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedAgentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedAgentSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedAgentSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >(ManagedAgentSettingsDocument, options);
}
export function useManagedAgentSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >(ManagedAgentSettingsDocument, options);
}
// @ts-ignore
export function useManagedAgentSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ManagedAgentSettingsQuery,
  ManagedAgentSettingsQueryVariables
>;
export function useManagedAgentSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManagedAgentSettingsQuery,
        ManagedAgentSettingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ManagedAgentSettingsQuery | undefined,
  ManagedAgentSettingsQueryVariables
>;
export function useManagedAgentSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManagedAgentSettingsQuery,
        ManagedAgentSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ManagedAgentSettingsQuery,
    ManagedAgentSettingsQueryVariables
  >(ManagedAgentSettingsDocument, options);
}
export type ManagedAgentSettingsQueryHookResult = ReturnType<
  typeof useManagedAgentSettingsQuery
>;
export type ManagedAgentSettingsLazyQueryHookResult = ReturnType<
  typeof useManagedAgentSettingsLazyQuery
>;
export type ManagedAgentSettingsSuspenseQueryHookResult = ReturnType<
  typeof useManagedAgentSettingsSuspenseQuery
>;
export type ManagedAgentSettingsQueryResult = Apollo.QueryResult<
  ManagedAgentSettingsQuery,
  ManagedAgentSettingsQueryVariables
>;
export const ManagedSessionsDocument = gql`
  query ManagedSessions {
    managedSessions {
      __typename
      ... on AiworkflowsV1ListManagedSessionsResponse {
        sessions {
          ...ManagedCodingSession
        }
      }
      ...DefaultError
    }
  }
  ${ManagedCodingSessionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useManagedSessionsQuery__
 *
 * To run a query within a React component, call `useManagedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedSessionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedSessionsQuery,
    ManagedSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ManagedSessionsQuery, ManagedSessionsQueryVariables>(
    ManagedSessionsDocument,
    options,
  );
}
export function useManagedSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedSessionsQuery,
    ManagedSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedSessionsQuery,
    ManagedSessionsQueryVariables
  >(ManagedSessionsDocument, options);
}
// @ts-ignore
export function useManagedSessionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ManagedSessionsQuery,
    ManagedSessionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ManagedSessionsQuery,
  ManagedSessionsQueryVariables
>;
export function useManagedSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManagedSessionsQuery,
        ManagedSessionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ManagedSessionsQuery | undefined,
  ManagedSessionsQueryVariables
>;
export function useManagedSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManagedSessionsQuery,
        ManagedSessionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ManagedSessionsQuery,
    ManagedSessionsQueryVariables
  >(ManagedSessionsDocument, options);
}
export type ManagedSessionsQueryHookResult = ReturnType<
  typeof useManagedSessionsQuery
>;
export type ManagedSessionsLazyQueryHookResult = ReturnType<
  typeof useManagedSessionsLazyQuery
>;
export type ManagedSessionsSuspenseQueryHookResult = ReturnType<
  typeof useManagedSessionsSuspenseQuery
>;
export type ManagedSessionsQueryResult = Apollo.QueryResult<
  ManagedSessionsQuery,
  ManagedSessionsQueryVariables
>;
export const RegisterManagedWorkspaceDocument = gql`
  mutation RegisterManagedWorkspace($account: String!) {
    registerManagedWorkspace(account: $account) {
      __typename
      ... on AiworkflowsV1ManagedWorkspace {
        workspaceId
        serviceAccountId
        federationRuleId
        agentId
        environmentId
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type RegisterManagedWorkspaceMutationFn = Apollo.MutationFunction<
  RegisterManagedWorkspaceMutation,
  RegisterManagedWorkspaceMutationVariables
>;

/**
 * __useRegisterManagedWorkspaceMutation__
 *
 * To run a mutation, you first call `useRegisterManagedWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterManagedWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerManagedWorkspaceMutation, { data, loading, error }] = useRegisterManagedWorkspaceMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useRegisterManagedWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterManagedWorkspaceMutation,
    RegisterManagedWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterManagedWorkspaceMutation,
    RegisterManagedWorkspaceMutationVariables
  >(RegisterManagedWorkspaceDocument, options);
}
export type RegisterManagedWorkspaceMutationHookResult = ReturnType<
  typeof useRegisterManagedWorkspaceMutation
>;
export type RegisterManagedWorkspaceMutationResult =
  Apollo.MutationResult<RegisterManagedWorkspaceMutation>;
export type RegisterManagedWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterManagedWorkspaceMutation,
    RegisterManagedWorkspaceMutationVariables
  >;
export const AttachmentCreatedDocument = gql`
  subscription AttachmentCreated {
    attachmentCreated {
      attachment {
        ...Attachment
      }
    }
  }
  ${AttachmentFragmentDoc}
`;

/**
 * __useAttachmentCreatedSubscription__
 *
 * To run a query within a React component, call `useAttachmentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAttachmentCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AttachmentCreatedSubscription,
    AttachmentCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AttachmentCreatedSubscription,
    AttachmentCreatedSubscriptionVariables
  >(AttachmentCreatedDocument, options);
}
export type AttachmentCreatedSubscriptionHookResult = ReturnType<
  typeof useAttachmentCreatedSubscription
>;
export type AttachmentCreatedSubscriptionResult =
  Apollo.SubscriptionResult<AttachmentCreatedSubscription>;
export const AttachmentsDocument = gql`
  query Attachments($resource: String!, $pageSize: Int, $pageToken: String) {
    attachments(
      resource: $resource
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      __typename
      ...DefaultError
      ... on CollaborationV1ListAttachmentsResponse {
        attachments {
          ...Attachment
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${AttachmentFragmentDoc}
`;

/**
 * __useAttachmentsQuery__
 *
 * To run a query within a React component, call `useAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentsQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  > &
    (
      | { variables: AttachmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options,
  );
}
export function useAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options,
  );
}
// @ts-ignore
export function useAttachmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttachmentsQuery, AttachmentsQueryVariables>;
export function useAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsQuery,
        AttachmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AttachmentsQuery | undefined,
  AttachmentsQueryVariables
>;
export function useAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsQuery,
        AttachmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options,
  );
}
export type AttachmentsQueryHookResult = ReturnType<typeof useAttachmentsQuery>;
export type AttachmentsLazyQueryHookResult = ReturnType<
  typeof useAttachmentsLazyQuery
>;
export type AttachmentsSuspenseQueryHookResult = ReturnType<
  typeof useAttachmentsSuspenseQuery
>;
export type AttachmentsQueryResult = Apollo.QueryResult<
  AttachmentsQuery,
  AttachmentsQueryVariables
>;
export const CreateAttachmentDocument = gql`
  mutation CreateAttachment($attachment: CollaborationV1AttachmentInput!) {
    createAttachment(attachment: $attachment) {
      __typename
      ...Attachment
      ...DefaultError
    }
  }
  ${AttachmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useCreateAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAttachmentMutation,
    CreateAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAttachmentMutation,
    CreateAttachmentMutationVariables
  >(CreateAttachmentDocument, options);
}
export type CreateAttachmentMutationHookResult = ReturnType<
  typeof useCreateAttachmentMutation
>;
export type CreateAttachmentMutationResult =
  Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>;
export const DeleteAttachmentDocument = gql`
  mutation DeleteAttachment($name: String!) {
    deleteAttachment(name: $name) {
      __typename
      ...Attachment
      ...DefaultError
    }
  }
  ${AttachmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAttachmentMutation,
    DeleteAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAttachmentMutation,
    DeleteAttachmentMutationVariables
  >(DeleteAttachmentDocument, options);
}
export type DeleteAttachmentMutationHookResult = ReturnType<
  typeof useDeleteAttachmentMutation
>;
export type DeleteAttachmentMutationResult =
  Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>;
export const UpdateAttachmentDocument = gql`
  mutation UpdateAttachment(
    $input: PartialCollaborationV1AttachmentInput!
    $updateMask: String
  ) {
    updateAttachment(attachment: $input, updateMask: $updateMask) {
      __typename
      ...Attachment
      ...DefaultError
    }
  }
  ${AttachmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateAttachmentMutationFn = Apollo.MutationFunction<
  UpdateAttachmentMutation,
  UpdateAttachmentMutationVariables
>;

/**
 * __useUpdateAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachmentMutation, { data, loading, error }] = useUpdateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAttachmentMutation,
    UpdateAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAttachmentMutation,
    UpdateAttachmentMutationVariables
  >(UpdateAttachmentDocument, options);
}
export type UpdateAttachmentMutationHookResult = ReturnType<
  typeof useUpdateAttachmentMutation
>;
export type UpdateAttachmentMutationResult =
  Apollo.MutationResult<UpdateAttachmentMutation>;
export type UpdateAttachmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateAttachmentMutation,
  UpdateAttachmentMutationVariables
>;
export const ChatDocument = gql`
  query Chat($name: String!) {
    chat(name: $name) {
      ...Chat
      ...DefaultError
    }
  }
  ${ChatFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useChatQuery__
 *
 * To run a query within a React component, call `useChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useChatQuery(
  baseOptions: Apollo.QueryHookOptions<ChatQuery, ChatQueryVariables> &
    ({ variables: ChatQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
}
export function useChatLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChatQuery, ChatQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatQuery, ChatQueryVariables>(
    ChatDocument,
    options,
  );
}
// @ts-ignore
export function useChatSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ChatQuery, ChatQueryVariables>,
): Apollo.UseSuspenseQueryResult<ChatQuery, ChatQueryVariables>;
export function useChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatQuery, ChatQueryVariables>,
): Apollo.UseSuspenseQueryResult<ChatQuery | undefined, ChatQueryVariables>;
export function useChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatQuery, ChatQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChatQuery, ChatQueryVariables>(
    ChatDocument,
    options,
  );
}
export type ChatQueryHookResult = ReturnType<typeof useChatQuery>;
export type ChatLazyQueryHookResult = ReturnType<typeof useChatLazyQuery>;
export type ChatSuspenseQueryHookResult = ReturnType<
  typeof useChatSuspenseQuery
>;
export type ChatQueryResult = Apollo.QueryResult<ChatQuery, ChatQueryVariables>;
export const ChatEventCreatedDocument = gql`
  subscription ChatEventCreated($filter: String) {
    chatEventCreated(filter: $filter) {
      chatEvent {
        ...ChatEvent
      }
    }
  }
  ${ChatEventFragmentDoc}
`;

/**
 * __useChatEventCreatedSubscription__
 *
 * To run a query within a React component, call `useChatEventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatEventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatEventCreatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChatEventCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ChatEventCreatedSubscription,
    ChatEventCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ChatEventCreatedSubscription,
    ChatEventCreatedSubscriptionVariables
  >(ChatEventCreatedDocument, options);
}
export type ChatEventCreatedSubscriptionHookResult = ReturnType<
  typeof useChatEventCreatedSubscription
>;
export type ChatEventCreatedSubscriptionResult =
  Apollo.SubscriptionResult<ChatEventCreatedSubscription>;
export const ChatEventsDocument = gql`
  query ChatEvents(
    $parent: String!
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    chatEvents(
      parent: $parent
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on ConversationsV2ListChatEventsResponse {
        __typename
        chatEvents {
          ...ChatEvent
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ChatEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useChatEventsQuery__
 *
 * To run a query within a React component, call `useChatEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatEventsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useChatEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChatEventsQuery,
    ChatEventsQueryVariables
  > &
    (
      | { variables: ChatEventsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatEventsQuery, ChatEventsQueryVariables>(
    ChatEventsDocument,
    options,
  );
}
export function useChatEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatEventsQuery,
    ChatEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatEventsQuery, ChatEventsQueryVariables>(
    ChatEventsDocument,
    options,
  );
}
// @ts-ignore
export function useChatEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChatEventsQuery,
    ChatEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ChatEventsQuery, ChatEventsQueryVariables>;
export function useChatEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatEventsQuery,
        ChatEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ChatEventsQuery | undefined,
  ChatEventsQueryVariables
>;
export function useChatEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatEventsQuery,
        ChatEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChatEventsQuery, ChatEventsQueryVariables>(
    ChatEventsDocument,
    options,
  );
}
export type ChatEventsQueryHookResult = ReturnType<typeof useChatEventsQuery>;
export type ChatEventsLazyQueryHookResult = ReturnType<
  typeof useChatEventsLazyQuery
>;
export type ChatEventsSuspenseQueryHookResult = ReturnType<
  typeof useChatEventsSuspenseQuery
>;
export type ChatEventsQueryResult = Apollo.QueryResult<
  ChatEventsQuery,
  ChatEventsQueryVariables
>;
export const ChatUpdatedDocument = gql`
  subscription ChatUpdated($filter: String) {
    chatUpdated(filter: $filter) {
      chat {
        ...Chat
      }
    }
  }
  ${ChatFragmentDoc}
`;

/**
 * __useChatUpdatedSubscription__
 *
 * To run a query within a React component, call `useChatUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChatUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ChatUpdatedSubscription,
    ChatUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ChatUpdatedSubscription,
    ChatUpdatedSubscriptionVariables
  >(ChatUpdatedDocument, options);
}
export type ChatUpdatedSubscriptionHookResult = ReturnType<
  typeof useChatUpdatedSubscription
>;
export type ChatUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<ChatUpdatedSubscription>;
export const ChatsDocument = gql`
  query Chats(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    chats(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on ConversationsV2ListChatsResponse {
        __typename
        chats {
          ...ChatRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ChatRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useChatsQuery__
 *
 * To run a query within a React component, call `useChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useChatsQuery(
  baseOptions?: Apollo.QueryHookOptions<ChatsQuery, ChatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatsQuery, ChatsQueryVariables>(
    ChatsDocument,
    options,
  );
}
export function useChatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChatsQuery, ChatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatsQuery, ChatsQueryVariables>(
    ChatsDocument,
    options,
  );
}
// @ts-ignore
export function useChatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChatsQuery,
    ChatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ChatsQuery, ChatsQueryVariables>;
export function useChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatsQuery, ChatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ChatsQuery | undefined, ChatsQueryVariables>;
export function useChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatsQuery, ChatsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChatsQuery, ChatsQueryVariables>(
    ChatsDocument,
    options,
  );
}
export type ChatsQueryHookResult = ReturnType<typeof useChatsQuery>;
export type ChatsLazyQueryHookResult = ReturnType<typeof useChatsLazyQuery>;
export type ChatsSuspenseQueryHookResult = ReturnType<
  typeof useChatsSuspenseQuery
>;
export type ChatsQueryResult = Apollo.QueryResult<
  ChatsQuery,
  ChatsQueryVariables
>;
export const ConfirmToolDocument = gql`
  mutation ConfirmTool(
    $name: String!
    $decision: ConversationsV2ToolConfirmationResponseDecision!
  ) {
    confirmTool(name: $name, decision: $decision) {
      ... on ConversationsV2ConfirmToolResponse {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ConfirmToolMutationFn = Apollo.MutationFunction<
  ConfirmToolMutation,
  ConfirmToolMutationVariables
>;

/**
 * __useConfirmToolMutation__
 *
 * To run a mutation, you first call `useConfirmToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmToolMutation, { data, loading, error }] = useConfirmToolMutation({
 *   variables: {
 *      name: // value for 'name'
 *      decision: // value for 'decision'
 *   },
 * });
 */
export function useConfirmToolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmToolMutation,
    ConfirmToolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmToolMutation, ConfirmToolMutationVariables>(
    ConfirmToolDocument,
    options,
  );
}
export type ConfirmToolMutationHookResult = ReturnType<
  typeof useConfirmToolMutation
>;
export type ConfirmToolMutationResult =
  Apollo.MutationResult<ConfirmToolMutation>;
export type ConfirmToolMutationOptions = Apollo.BaseMutationOptions<
  ConfirmToolMutation,
  ConfirmToolMutationVariables
>;
export const CreateChatDocument = gql`
  mutation CreateChat($chat: ConversationsV2ChatInput!, $chatId: String) {
    createChat(chat: $chat, chatId: $chatId) {
      ...Chat
      ...DefaultError
    }
  }
  ${ChatFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateChatMutationFn = Apollo.MutationFunction<
  CreateChatMutation,
  CreateChatMutationVariables
>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      chat: // value for 'chat'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useCreateChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatMutation,
    CreateChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(
    CreateChatDocument,
    options,
  );
}
export type CreateChatMutationHookResult = ReturnType<
  typeof useCreateChatMutation
>;
export type CreateChatMutationResult =
  Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<
  CreateChatMutation,
  CreateChatMutationVariables
>;
export const DeleteChatDocument = gql`
  mutation DeleteChat($name: String!) {
    deleteChat(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteChatMutationFn = Apollo.MutationFunction<
  DeleteChatMutation,
  DeleteChatMutationVariables
>;

/**
 * __useDeleteChatMutation__
 *
 * To run a mutation, you first call `useDeleteChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMutation, { data, loading, error }] = useDeleteChatMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChatMutation,
    DeleteChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteChatMutation, DeleteChatMutationVariables>(
    DeleteChatDocument,
    options,
  );
}
export type DeleteChatMutationHookResult = ReturnType<
  typeof useDeleteChatMutation
>;
export type DeleteChatMutationResult =
  Apollo.MutationResult<DeleteChatMutation>;
export type DeleteChatMutationOptions = Apollo.BaseMutationOptions<
  DeleteChatMutation,
  DeleteChatMutationVariables
>;
export const InterruptChatDocument = gql`
  mutation InterruptChat($name: String!) {
    interruptChat(name: $name) {
      ...ChatEvent
      ...DefaultError
    }
  }
  ${ChatEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type InterruptChatMutationFn = Apollo.MutationFunction<
  InterruptChatMutation,
  InterruptChatMutationVariables
>;

/**
 * __useInterruptChatMutation__
 *
 * To run a mutation, you first call `useInterruptChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterruptChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interruptChatMutation, { data, loading, error }] = useInterruptChatMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useInterruptChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InterruptChatMutation,
    InterruptChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InterruptChatMutation,
    InterruptChatMutationVariables
  >(InterruptChatDocument, options);
}
export type InterruptChatMutationHookResult = ReturnType<
  typeof useInterruptChatMutation
>;
export type InterruptChatMutationResult =
  Apollo.MutationResult<InterruptChatMutation>;
export type InterruptChatMutationOptions = Apollo.BaseMutationOptions<
  InterruptChatMutation,
  InterruptChatMutationVariables
>;
export const ResourceDisplayNamesDocument = gql`
  query ResourceDisplayNames(
    $assignmentTablesFilter: String!
    $entitiesFilter: String!
    $factTablesFilter: String!
    $flagsFilter: String!
    $metricsFilter: String!
    $surfacesFilter: String!
    $fetchAssignmentTables: Boolean!
    $fetchEntities: Boolean!
    $fetchFactTables: Boolean!
    $fetchFlags: Boolean!
    $fetchMetrics: Boolean!
    $fetchSurfaces: Boolean!
  ) {
    assignmentTables(filter: $assignmentTablesFilter)
      @include(if: $fetchAssignmentTables) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          name
          displayName
        }
      }
      ...DefaultError
    }
    entities(filter: $entitiesFilter) @include(if: $fetchEntities) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        entities {
          name
          displayName
        }
      }
      ...DefaultError
    }
    factTables(filter: $factTablesFilter) @include(if: $fetchFactTables) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          name
          displayName
        }
      }
      ...DefaultError
    }
    flags(filter: $flagsFilter) @include(if: $fetchFlags) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          displayName
        }
      }
      ...DefaultError
    }
    metrics(filter: $metricsFilter, pageSize: 50) @include(if: $fetchMetrics) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          name
          displayName
        }
      }
      ...DefaultError
    }
    surfaces(filter: $surfacesFilter) @include(if: $fetchSurfaces) {
      ... on WorkflowV1ListSurfacesResponse {
        __typename
        surfaces {
          name
          displayName
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useResourceDisplayNamesQuery__
 *
 * To run a query within a React component, call `useResourceDisplayNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDisplayNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDisplayNamesQuery({
 *   variables: {
 *      assignmentTablesFilter: // value for 'assignmentTablesFilter'
 *      entitiesFilter: // value for 'entitiesFilter'
 *      factTablesFilter: // value for 'factTablesFilter'
 *      flagsFilter: // value for 'flagsFilter'
 *      metricsFilter: // value for 'metricsFilter'
 *      surfacesFilter: // value for 'surfacesFilter'
 *      fetchAssignmentTables: // value for 'fetchAssignmentTables'
 *      fetchEntities: // value for 'fetchEntities'
 *      fetchFactTables: // value for 'fetchFactTables'
 *      fetchFlags: // value for 'fetchFlags'
 *      fetchMetrics: // value for 'fetchMetrics'
 *      fetchSurfaces: // value for 'fetchSurfaces'
 *   },
 * });
 */
export function useResourceDisplayNamesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  > &
    (
      | { variables: ResourceDisplayNamesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  >(ResourceDisplayNamesDocument, options);
}
export function useResourceDisplayNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  >(ResourceDisplayNamesDocument, options);
}
// @ts-ignore
export function useResourceDisplayNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ResourceDisplayNamesQuery,
  ResourceDisplayNamesQueryVariables
>;
export function useResourceDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceDisplayNamesQuery,
        ResourceDisplayNamesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ResourceDisplayNamesQuery | undefined,
  ResourceDisplayNamesQueryVariables
>;
export function useResourceDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceDisplayNamesQuery,
        ResourceDisplayNamesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourceDisplayNamesQuery,
    ResourceDisplayNamesQueryVariables
  >(ResourceDisplayNamesDocument, options);
}
export type ResourceDisplayNamesQueryHookResult = ReturnType<
  typeof useResourceDisplayNamesQuery
>;
export type ResourceDisplayNamesLazyQueryHookResult = ReturnType<
  typeof useResourceDisplayNamesLazyQuery
>;
export type ResourceDisplayNamesSuspenseQueryHookResult = ReturnType<
  typeof useResourceDisplayNamesSuspenseQuery
>;
export type ResourceDisplayNamesQueryResult = Apollo.QueryResult<
  ResourceDisplayNamesQuery,
  ResourceDisplayNamesQueryVariables
>;
export const SendUserMessageDocument = gql`
  mutation SendUserMessage(
    $name: String!
    $userMessage: ConversationsV2UserMessageInput!
  ) {
    sendUserMessage(name: $name, userMessage: $userMessage) {
      ...ChatEvent
      ...DefaultError
    }
  }
  ${ChatEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type SendUserMessageMutationFn = Apollo.MutationFunction<
  SendUserMessageMutation,
  SendUserMessageMutationVariables
>;

/**
 * __useSendUserMessageMutation__
 *
 * To run a mutation, you first call `useSendUserMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUserMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUserMessageMutation, { data, loading, error }] = useSendUserMessageMutation({
 *   variables: {
 *      name: // value for 'name'
 *      userMessage: // value for 'userMessage'
 *   },
 * });
 */
export function useSendUserMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendUserMessageMutation,
    SendUserMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendUserMessageMutation,
    SendUserMessageMutationVariables
  >(SendUserMessageDocument, options);
}
export type SendUserMessageMutationHookResult = ReturnType<
  typeof useSendUserMessageMutation
>;
export type SendUserMessageMutationResult =
  Apollo.MutationResult<SendUserMessageMutation>;
export type SendUserMessageMutationOptions = Apollo.BaseMutationOptions<
  SendUserMessageMutation,
  SendUserMessageMutationVariables
>;
export const UpdateChatDocument = gql`
  mutation UpdateChat(
    $input: PartialConversationsV2ChatInput!
    $updateMask: String
  ) {
    updateChat(chat: $input, updateMask: $updateMask) {
      ...Chat
      ...DefaultError
    }
  }
  ${ChatFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateChatMutationFn = Apollo.MutationFunction<
  UpdateChatMutation,
  UpdateChatMutationVariables
>;

/**
 * __useUpdateChatMutation__
 *
 * To run a mutation, you first call `useUpdateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMutation, { data, loading, error }] = useUpdateChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChatMutation,
    UpdateChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChatMutation, UpdateChatMutationVariables>(
    UpdateChatDocument,
    options,
  );
}
export type UpdateChatMutationHookResult = ReturnType<
  typeof useUpdateChatMutation
>;
export type UpdateChatMutationResult =
  Apollo.MutationResult<UpdateChatMutation>;
export type UpdateChatMutationOptions = Apollo.BaseMutationOptions<
  UpdateChatMutation,
  UpdateChatMutationVariables
>;
export const CreatePresenceDocument = gql`
  mutation CreatePresence(
    $presence: CollaborationV1PresenceInput!
    $presenceId: String
  ) {
    createPresence(presence: $presence, presenceId: $presenceId) {
      __typename
      ...DefaultError
      ...Presence
    }
  }
  ${DefaultErrorFragmentDoc}
  ${PresenceFragmentDoc}
`;
export type CreatePresenceMutationFn = Apollo.MutationFunction<
  CreatePresenceMutation,
  CreatePresenceMutationVariables
>;

/**
 * __useCreatePresenceMutation__
 *
 * To run a mutation, you first call `useCreatePresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresenceMutation, { data, loading, error }] = useCreatePresenceMutation({
 *   variables: {
 *      presence: // value for 'presence'
 *      presenceId: // value for 'presenceId'
 *   },
 * });
 */
export function useCreatePresenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePresenceMutation,
    CreatePresenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePresenceMutation,
    CreatePresenceMutationVariables
  >(CreatePresenceDocument, options);
}
export type CreatePresenceMutationHookResult = ReturnType<
  typeof useCreatePresenceMutation
>;
export type CreatePresenceMutationResult =
  Apollo.MutationResult<CreatePresenceMutation>;
export type CreatePresenceMutationOptions = Apollo.BaseMutationOptions<
  CreatePresenceMutation,
  CreatePresenceMutationVariables
>;
export const DeletePresenceDocument = gql`
  mutation DeletePresence($name: String!) {
    deletePresence(name: $name) {
      __typename
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeletePresenceMutationFn = Apollo.MutationFunction<
  DeletePresenceMutation,
  DeletePresenceMutationVariables
>;

/**
 * __useDeletePresenceMutation__
 *
 * To run a mutation, you first call `useDeletePresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresenceMutation, { data, loading, error }] = useDeletePresenceMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeletePresenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePresenceMutation,
    DeletePresenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePresenceMutation,
    DeletePresenceMutationVariables
  >(DeletePresenceDocument, options);
}
export type DeletePresenceMutationHookResult = ReturnType<
  typeof useDeletePresenceMutation
>;
export type DeletePresenceMutationResult =
  Apollo.MutationResult<DeletePresenceMutation>;
export type DeletePresenceMutationOptions = Apollo.BaseMutationOptions<
  DeletePresenceMutation,
  DeletePresenceMutationVariables
>;
export const PresenceCreatedDocument = gql`
  subscription PresenceCreated($filter: String) {
    presenceCreated(filter: $filter) {
      presence {
        ...Presence
      }
    }
  }
  ${PresenceFragmentDoc}
`;

/**
 * __usePresenceCreatedSubscription__
 *
 * To run a query within a React component, call `usePresenceCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePresenceCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresenceCreatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePresenceCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PresenceCreatedSubscription,
    PresenceCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PresenceCreatedSubscription,
    PresenceCreatedSubscriptionVariables
  >(PresenceCreatedDocument, options);
}
export type PresenceCreatedSubscriptionHookResult = ReturnType<
  typeof usePresenceCreatedSubscription
>;
export type PresenceCreatedSubscriptionResult =
  Apollo.SubscriptionResult<PresenceCreatedSubscription>;
export const PresenceDeletedDocument = gql`
  subscription PresenceDeleted($filter: String) {
    presenceDeleted(filter: $filter) {
      presence
    }
  }
`;

/**
 * __usePresenceDeletedSubscription__
 *
 * To run a query within a React component, call `usePresenceDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePresenceDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresenceDeletedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePresenceDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PresenceDeletedSubscription,
    PresenceDeletedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PresenceDeletedSubscription,
    PresenceDeletedSubscriptionVariables
  >(PresenceDeletedDocument, options);
}
export type PresenceDeletedSubscriptionHookResult = ReturnType<
  typeof usePresenceDeletedSubscription
>;
export type PresenceDeletedSubscriptionResult =
  Apollo.SubscriptionResult<PresenceDeletedSubscription>;
export const PresenceUpdatedDocument = gql`
  subscription PresenceUpdated($filter: String) {
    presenceUpdated(filter: $filter) {
      presence {
        ...Presence
      }
    }
  }
  ${PresenceFragmentDoc}
`;

/**
 * __usePresenceUpdatedSubscription__
 *
 * To run a query within a React component, call `usePresenceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePresenceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresenceUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePresenceUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PresenceUpdatedSubscription,
    PresenceUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PresenceUpdatedSubscription,
    PresenceUpdatedSubscriptionVariables
  >(PresenceUpdatedDocument, options);
}
export type PresenceUpdatedSubscriptionHookResult = ReturnType<
  typeof usePresenceUpdatedSubscription
>;
export type PresenceUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<PresenceUpdatedSubscription>;
export const PresencesDocument = gql`
  query Presences($pageSize: Int, $pageToken: String) {
    presences(pageSize: $pageSize, pageToken: $pageToken) {
      __typename
      ...DefaultError
      ... on CollaborationV1ListPresencesResponse {
        presences {
          ...Presence
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${PresenceFragmentDoc}
`;

/**
 * __usePresencesQuery__
 *
 * To run a query within a React component, call `usePresencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresencesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePresencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PresencesQuery,
    PresencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PresencesQuery, PresencesQueryVariables>(
    PresencesDocument,
    options,
  );
}
export function usePresencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PresencesQuery,
    PresencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PresencesQuery, PresencesQueryVariables>(
    PresencesDocument,
    options,
  );
}
// @ts-ignore
export function usePresencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PresencesQuery,
    PresencesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PresencesQuery, PresencesQueryVariables>;
export function usePresencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PresencesQuery, PresencesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PresencesQuery | undefined,
  PresencesQueryVariables
>;
export function usePresencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PresencesQuery, PresencesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PresencesQuery, PresencesQueryVariables>(
    PresencesDocument,
    options,
  );
}
export type PresencesQueryHookResult = ReturnType<typeof usePresencesQuery>;
export type PresencesLazyQueryHookResult = ReturnType<
  typeof usePresencesLazyQuery
>;
export type PresencesSuspenseQueryHookResult = ReturnType<
  typeof usePresencesSuspenseQuery
>;
export type PresencesQueryResult = Apollo.QueryResult<
  PresencesQuery,
  PresencesQueryVariables
>;
export const UpdatePresenceDocument = gql`
  mutation UpdatePresence(
    $presence: PartialCollaborationV1PresenceInput!
    $updateMask: String
    $allowMissing: Boolean
  ) {
    updatePresence(
      presence: $presence
      updateMask: $updateMask
      allowMissing: $allowMissing
    ) {
      __typename
      ...DefaultError
      ...Presence
    }
  }
  ${DefaultErrorFragmentDoc}
  ${PresenceFragmentDoc}
`;
export type UpdatePresenceMutationFn = Apollo.MutationFunction<
  UpdatePresenceMutation,
  UpdatePresenceMutationVariables
>;

/**
 * __useUpdatePresenceMutation__
 *
 * To run a mutation, you first call `useUpdatePresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresenceMutation, { data, loading, error }] = useUpdatePresenceMutation({
 *   variables: {
 *      presence: // value for 'presence'
 *      updateMask: // value for 'updateMask'
 *      allowMissing: // value for 'allowMissing'
 *   },
 * });
 */
export function useUpdatePresenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePresenceMutation,
    UpdatePresenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePresenceMutation,
    UpdatePresenceMutationVariables
  >(UpdatePresenceDocument, options);
}
export type UpdatePresenceMutationHookResult = ReturnType<
  typeof useUpdatePresenceMutation
>;
export type UpdatePresenceMutationResult =
  Apollo.MutationResult<UpdatePresenceMutation>;
export type UpdatePresenceMutationOptions = Apollo.BaseMutationOptions<
  UpdatePresenceMutation,
  UpdatePresenceMutationVariables
>;
export const CollectionDocument = gql`
  query Collection($name: String!) {
    collection(name: $name) {
      ...Collection
      ...DefaultError
    }
  }
  ${CollectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  > &
    (
      | { variables: CollectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
export function useCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
// @ts-ignore
export function useCollectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionQuery,
    CollectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CollectionQuery, CollectionQueryVariables>;
export function useCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionQuery,
        CollectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionQuery | undefined,
  CollectionQueryVariables
>;
export function useCollectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionQuery,
        CollectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CollectionQuery, CollectionQueryVariables>(
    CollectionDocument,
    options,
  );
}
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<
  typeof useCollectionLazyQuery
>;
export type CollectionSuspenseQueryHookResult = ReturnType<
  typeof useCollectionSuspenseQuery
>;
export type CollectionQueryResult = Apollo.QueryResult<
  CollectionQuery,
  CollectionQueryVariables
>;
export const CollectionEntriesDocument = gql`
  query CollectionEntries(
    $parent: String!
    $pageSize: Int
    $pageToken: String
    $filter: String
  ) {
    collectionEntries(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      ... on CollectionsV1ListCollectionEntriesResponse {
        collectionEntries {
          ...CollectionEntry
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${CollectionEntryFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCollectionEntriesQuery__
 *
 * To run a query within a React component, call `useCollectionEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionEntriesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCollectionEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  > &
    (
      | { variables: CollectionEntriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  >(CollectionEntriesDocument, options);
}
export function useCollectionEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  >(CollectionEntriesDocument, options);
}
// @ts-ignore
export function useCollectionEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectionEntriesQuery,
  CollectionEntriesQueryVariables
>;
export function useCollectionEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionEntriesQuery,
        CollectionEntriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionEntriesQuery | undefined,
  CollectionEntriesQueryVariables
>;
export function useCollectionEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionEntriesQuery,
        CollectionEntriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionEntriesQuery,
    CollectionEntriesQueryVariables
  >(CollectionEntriesDocument, options);
}
export type CollectionEntriesQueryHookResult = ReturnType<
  typeof useCollectionEntriesQuery
>;
export type CollectionEntriesLazyQueryHookResult = ReturnType<
  typeof useCollectionEntriesLazyQuery
>;
export type CollectionEntriesSuspenseQueryHookResult = ReturnType<
  typeof useCollectionEntriesSuspenseQuery
>;
export type CollectionEntriesQueryResult = Apollo.QueryResult<
  CollectionEntriesQuery,
  CollectionEntriesQueryVariables
>;
export const CollectionsDocument = gql`
  query Collections($pageSize: Int, $pageToken: String, $filter: String) {
    collections(pageSize: $pageSize, pageToken: $pageToken, filter: $filter) {
      ... on CollectionsV1ListCollectionsResponse {
        collections {
          ...CollectionRef
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${CollectionRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCollectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CollectionsQuery,
    CollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionsQuery, CollectionsQueryVariables>(
    CollectionsDocument,
    options,
  );
}
export function useCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionsQuery,
    CollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(
    CollectionsDocument,
    options,
  );
}
// @ts-ignore
export function useCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionsQuery,
    CollectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CollectionsQuery, CollectionsQueryVariables>;
export function useCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionsQuery,
        CollectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectionsQuery | undefined,
  CollectionsQueryVariables
>;
export function useCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectionsQuery,
        CollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CollectionsQuery, CollectionsQueryVariables>(
    CollectionsDocument,
    options,
  );
}
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<
  typeof useCollectionsLazyQuery
>;
export type CollectionsSuspenseQueryHookResult = ReturnType<
  typeof useCollectionsSuspenseQuery
>;
export type CollectionsQueryResult = Apollo.QueryResult<
  CollectionsQuery,
  CollectionsQueryVariables
>;
export const CreateCollectionDocument = gql`
  mutation CreateCollection($input: CollectionsV1CollectionInput!) {
    createCollection(collection: $input) {
      ...Collection
      ...DefaultError
    }
  }
  ${CollectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCollectionMutationFn = Apollo.MutationFunction<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollectionMutation,
    CreateCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCollectionMutation,
    CreateCollectionMutationVariables
  >(CreateCollectionDocument, options);
}
export type CreateCollectionMutationHookResult = ReturnType<
  typeof useCreateCollectionMutation
>;
export type CreateCollectionMutationResult =
  Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>;
export const CreateCollectionEntryDocument = gql`
  mutation CreateCollectionEntry(
    $parent: String!
    $collectionEntry: CollectionsV1CollectionEntryInput!
  ) {
    createCollectionEntry(parent: $parent, collectionEntry: $collectionEntry) {
      ...CollectionEntry
      ...DefaultError
    }
  }
  ${CollectionEntryFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCollectionEntryMutationFn = Apollo.MutationFunction<
  CreateCollectionEntryMutation,
  CreateCollectionEntryMutationVariables
>;

/**
 * __useCreateCollectionEntryMutation__
 *
 * To run a mutation, you first call `useCreateCollectionEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionEntryMutation, { data, loading, error }] = useCreateCollectionEntryMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      collectionEntry: // value for 'collectionEntry'
 *   },
 * });
 */
export function useCreateCollectionEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollectionEntryMutation,
    CreateCollectionEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCollectionEntryMutation,
    CreateCollectionEntryMutationVariables
  >(CreateCollectionEntryDocument, options);
}
export type CreateCollectionEntryMutationHookResult = ReturnType<
  typeof useCreateCollectionEntryMutation
>;
export type CreateCollectionEntryMutationResult =
  Apollo.MutationResult<CreateCollectionEntryMutation>;
export type CreateCollectionEntryMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionEntryMutation,
  CreateCollectionEntryMutationVariables
>;
export const CreateCollectionWithIdDocument = gql`
  mutation CreateCollectionWithId(
    $input: CollectionsV1CollectionInput!
    $collectionId: String
  ) {
    createCollection(collection: $input, collectionId: $collectionId) {
      ...Collection
      ...DefaultError
    }
  }
  ${CollectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCollectionWithIdMutationFn = Apollo.MutationFunction<
  CreateCollectionWithIdMutation,
  CreateCollectionWithIdMutationVariables
>;

/**
 * __useCreateCollectionWithIdMutation__
 *
 * To run a mutation, you first call `useCreateCollectionWithIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionWithIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionWithIdMutation, { data, loading, error }] = useCreateCollectionWithIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCreateCollectionWithIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollectionWithIdMutation,
    CreateCollectionWithIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCollectionWithIdMutation,
    CreateCollectionWithIdMutationVariables
  >(CreateCollectionWithIdDocument, options);
}
export type CreateCollectionWithIdMutationHookResult = ReturnType<
  typeof useCreateCollectionWithIdMutation
>;
export type CreateCollectionWithIdMutationResult =
  Apollo.MutationResult<CreateCollectionWithIdMutation>;
export type CreateCollectionWithIdMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionWithIdMutation,
  CreateCollectionWithIdMutationVariables
>;
export const DeleteCollectionDocument = gql`
  mutation DeleteCollection($name: String!) {
    deleteCollection(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteCollectionMutationFn = Apollo.MutationFunction<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCollectionMutation,
    DeleteCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCollectionMutation,
    DeleteCollectionMutationVariables
  >(DeleteCollectionDocument, options);
}
export type DeleteCollectionMutationHookResult = ReturnType<
  typeof useDeleteCollectionMutation
>;
export type DeleteCollectionMutationResult =
  Apollo.MutationResult<DeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>;
export const DeleteCollectionEntryDocument = gql`
  mutation DeleteCollectionEntry($name: String!) {
    deleteCollectionEntry(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteCollectionEntryMutationFn = Apollo.MutationFunction<
  DeleteCollectionEntryMutation,
  DeleteCollectionEntryMutationVariables
>;

/**
 * __useDeleteCollectionEntryMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionEntryMutation, { data, loading, error }] = useDeleteCollectionEntryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteCollectionEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCollectionEntryMutation,
    DeleteCollectionEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCollectionEntryMutation,
    DeleteCollectionEntryMutationVariables
  >(DeleteCollectionEntryDocument, options);
}
export type DeleteCollectionEntryMutationHookResult = ReturnType<
  typeof useDeleteCollectionEntryMutation
>;
export type DeleteCollectionEntryMutationResult =
  Apollo.MutationResult<DeleteCollectionEntryMutation>;
export type DeleteCollectionEntryMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollectionEntryMutation,
  DeleteCollectionEntryMutationVariables
>;
export const UpdateCollectionDocument = gql`
  mutation UpdateCollection(
    $input: PartialCollectionsV1CollectionInput!
    $updateMask: String
  ) {
    updateCollection(collection: $input, updateMask: $updateMask) {
      ...Collection
      ...DefaultError
    }
  }
  ${CollectionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionMutation,
    UpdateCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionMutation,
    UpdateCollectionMutationVariables
  >(UpdateCollectionDocument, options);
}
export type UpdateCollectionMutationHookResult = ReturnType<
  typeof useUpdateCollectionMutation
>;
export type UpdateCollectionMutationResult =
  Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>;
export const CommentDocument = gql`
  query Comment($name: String!) {
    comment(name: $name) {
      __typename
      ...DefaultError
      ...Comment
    }
  }
  ${DefaultErrorFragmentDoc}
  ${CommentFragmentDoc}
`;

/**
 * __useCommentQuery__
 *
 * To run a query within a React component, call `useCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCommentQuery(
  baseOptions: Apollo.QueryHookOptions<CommentQuery, CommentQueryVariables> &
    ({ variables: CommentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommentQuery, CommentQueryVariables>(
    CommentDocument,
    options,
  );
}
export function useCommentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentQuery,
    CommentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommentQuery, CommentQueryVariables>(
    CommentDocument,
    options,
  );
}
// @ts-ignore
export function useCommentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CommentQuery,
    CommentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CommentQuery, CommentQueryVariables>;
export function useCommentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommentQuery, CommentQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CommentQuery | undefined,
  CommentQueryVariables
>;
export function useCommentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommentQuery, CommentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CommentQuery, CommentQueryVariables>(
    CommentDocument,
    options,
  );
}
export type CommentQueryHookResult = ReturnType<typeof useCommentQuery>;
export type CommentLazyQueryHookResult = ReturnType<typeof useCommentLazyQuery>;
export type CommentSuspenseQueryHookResult = ReturnType<
  typeof useCommentSuspenseQuery
>;
export type CommentQueryResult = Apollo.QueryResult<
  CommentQuery,
  CommentQueryVariables
>;
export const CommentCreatedDocument = gql`
  subscription CommentCreated {
    commentCreated {
      comment {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

/**
 * __useCommentCreatedSubscription__
 *
 * To run a query within a React component, call `useCommentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommentCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CommentCreatedSubscription,
    CommentCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CommentCreatedSubscription,
    CommentCreatedSubscriptionVariables
  >(CommentCreatedDocument, options);
}
export type CommentCreatedSubscriptionHookResult = ReturnType<
  typeof useCommentCreatedSubscription
>;
export type CommentCreatedSubscriptionResult =
  Apollo.SubscriptionResult<CommentCreatedSubscription>;
export const CommentRepliesDocument = gql`
  query CommentReplies($parent: String!, $pageSize: Int, $pageToken: String) {
    commentReplies(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      __typename
      ...DefaultError
      ... on CollaborationV1ListCommentRepliesResponse {
        commentReplies {
          ...CommentReply
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${CommentReplyFragmentDoc}
`;

/**
 * __useCommentRepliesQuery__
 *
 * To run a query within a React component, call `useCommentRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentRepliesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useCommentRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommentRepliesQuery,
    CommentRepliesQueryVariables
  > &
    (
      | { variables: CommentRepliesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommentRepliesQuery, CommentRepliesQueryVariables>(
    CommentRepliesDocument,
    options,
  );
}
export function useCommentRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentRepliesQuery,
    CommentRepliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommentRepliesQuery, CommentRepliesQueryVariables>(
    CommentRepliesDocument,
    options,
  );
}
// @ts-ignore
export function useCommentRepliesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CommentRepliesQuery,
    CommentRepliesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CommentRepliesQuery,
  CommentRepliesQueryVariables
>;
export function useCommentRepliesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommentRepliesQuery,
        CommentRepliesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CommentRepliesQuery | undefined,
  CommentRepliesQueryVariables
>;
export function useCommentRepliesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommentRepliesQuery,
        CommentRepliesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CommentRepliesQuery,
    CommentRepliesQueryVariables
  >(CommentRepliesDocument, options);
}
export type CommentRepliesQueryHookResult = ReturnType<
  typeof useCommentRepliesQuery
>;
export type CommentRepliesLazyQueryHookResult = ReturnType<
  typeof useCommentRepliesLazyQuery
>;
export type CommentRepliesSuspenseQueryHookResult = ReturnType<
  typeof useCommentRepliesSuspenseQuery
>;
export type CommentRepliesQueryResult = Apollo.QueryResult<
  CommentRepliesQuery,
  CommentRepliesQueryVariables
>;
export const CommentReplyCreatedDocument = gql`
  subscription CommentReplyCreated {
    commentReplyCreated {
      reply {
        ...CommentReply
      }
    }
  }
  ${CommentReplyFragmentDoc}
`;

/**
 * __useCommentReplyCreatedSubscription__
 *
 * To run a query within a React component, call `useCommentReplyCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentReplyCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentReplyCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommentReplyCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CommentReplyCreatedSubscription,
    CommentReplyCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CommentReplyCreatedSubscription,
    CommentReplyCreatedSubscriptionVariables
  >(CommentReplyCreatedDocument, options);
}
export type CommentReplyCreatedSubscriptionHookResult = ReturnType<
  typeof useCommentReplyCreatedSubscription
>;
export type CommentReplyCreatedSubscriptionResult =
  Apollo.SubscriptionResult<CommentReplyCreatedSubscription>;
export const CommentUpdatedDocument = gql`
  subscription CommentUpdated {
    commentUpdated {
      comment {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

/**
 * __useCommentUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommentUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CommentUpdatedSubscription,
    CommentUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CommentUpdatedSubscription,
    CommentUpdatedSubscriptionVariables
  >(CommentUpdatedDocument, options);
}
export type CommentUpdatedSubscriptionHookResult = ReturnType<
  typeof useCommentUpdatedSubscription
>;
export type CommentUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<CommentUpdatedSubscription>;
export const CommentsDocument = gql`
  query Comments(
    $resource: String
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    comments(
      resource: $resource
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      __typename
      ...DefaultError
      ... on CollaborationV1ListCommentsResponse {
        comments {
          ...Comment
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${CommentFragmentDoc}
`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useCommentsQuery(
  baseOptions?: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(
    CommentsDocument,
    options,
  );
}
export function useCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentsQuery,
    CommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(
    CommentsDocument,
    options,
  );
}
// @ts-ignore
export function useCommentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CommentsQuery,
    CommentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CommentsQuery, CommentsQueryVariables>;
export function useCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CommentsQuery | undefined,
  CommentsQueryVariables
>;
export function useCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(
    CommentsDocument,
    options,
  );
}
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<
  typeof useCommentsLazyQuery
>;
export type CommentsSuspenseQueryHookResult = ReturnType<
  typeof useCommentsSuspenseQuery
>;
export type CommentsQueryResult = Apollo.QueryResult<
  CommentsQuery,
  CommentsQueryVariables
>;
export const CreateCommentDocument = gql`
  mutation CreateComment(
    $comment: CollaborationV1CommentInput!
    $commentId: String
  ) {
    createComment(comment: $comment, commentId: $commentId) {
      __typename
      ...Comment
      ...DefaultError
    }
  }
  ${CommentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCommentMutationFn = Apollo.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >(CreateCommentDocument, options);
}
export type CreateCommentMutationHookResult = ReturnType<
  typeof useCreateCommentMutation
>;
export type CreateCommentMutationResult =
  Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export const CreateCommentReplyDocument = gql`
  mutation CreateCommentReply(
    $reply: CollaborationV1CommentReplyInput!
    $commentName: String!
    $commentReplyId: String!
  ) {
    createCommentReply(
      commentReply: $reply
      parent: $commentName
      commentReplyId: $commentReplyId
    ) {
      __typename
      ...CommentReply
      ...DefaultError
    }
  }
  ${CommentReplyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCommentReplyMutationFn = Apollo.MutationFunction<
  CreateCommentReplyMutation,
  CreateCommentReplyMutationVariables
>;

/**
 * __useCreateCommentReplyMutation__
 *
 * To run a mutation, you first call `useCreateCommentReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentReplyMutation, { data, loading, error }] = useCreateCommentReplyMutation({
 *   variables: {
 *      reply: // value for 'reply'
 *      commentName: // value for 'commentName'
 *      commentReplyId: // value for 'commentReplyId'
 *   },
 * });
 */
export function useCreateCommentReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables
  >(CreateCommentReplyDocument, options);
}
export type CreateCommentReplyMutationHookResult = ReturnType<
  typeof useCreateCommentReplyMutation
>;
export type CreateCommentReplyMutationResult =
  Apollo.MutationResult<CreateCommentReplyMutation>;
export type CreateCommentReplyMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentReplyMutation,
  CreateCommentReplyMutationVariables
>;
export const CreateReactionDocument = gql`
  mutation CreateReaction(
    $input: CollaborationV1ReactionInput!
    $reactionId: String
  ) {
    createReaction(reaction: $input, reactionId: $reactionId) {
      __typename
      ...Reaction
      ...DefaultError
    }
  }
  ${ReactionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateReactionMutationFn = Apollo.MutationFunction<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      reactionId: // value for 'reactionId'
 *   },
 * });
 */
export function useCreateReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >(CreateReactionDocument, options);
}
export type CreateReactionMutationHookResult = ReturnType<
  typeof useCreateReactionMutation
>;
export type CreateReactionMutationResult =
  Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;
export const DeleteCommentDocument = gql`
  mutation DeleteComment($commentName: String!) {
    deleteComment(name: $commentName) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteCommentMutationFn = Apollo.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentName: // value for 'commentName'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >(DeleteCommentDocument, options);
}
export type DeleteCommentMutationHookResult = ReturnType<
  typeof useDeleteCommentMutation
>;
export type DeleteCommentMutationResult =
  Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const UndoReactionDocument = gql`
  mutation UndoReaction($resource: String!, $emoji: String!) {
    undoReaction(resource: $resource, emoji: $emoji) {
      __typename
      ... on CollaborationV1UndoReactionResponse {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UndoReactionMutationFn = Apollo.MutationFunction<
  UndoReactionMutation,
  UndoReactionMutationVariables
>;

/**
 * __useUndoReactionMutation__
 *
 * To run a mutation, you first call `useUndoReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoReactionMutation, { data, loading, error }] = useUndoReactionMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUndoReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UndoReactionMutation,
    UndoReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UndoReactionMutation,
    UndoReactionMutationVariables
  >(UndoReactionDocument, options);
}
export type UndoReactionMutationHookResult = ReturnType<
  typeof useUndoReactionMutation
>;
export type UndoReactionMutationResult =
  Apollo.MutationResult<UndoReactionMutation>;
export type UndoReactionMutationOptions = Apollo.BaseMutationOptions<
  UndoReactionMutation,
  UndoReactionMutationVariables
>;
export const LabelDocument = gql`
  query Label($name: String!) {
    label(name: $name) {
      ...Label
      ...DefaultError
    }
  }
  ${LabelFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useLabelQuery__
 *
 * To run a query within a React component, call `useLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useLabelQuery(
  baseOptions: Apollo.QueryHookOptions<LabelQuery, LabelQueryVariables> &
    ({ variables: LabelQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LabelQuery, LabelQueryVariables>(
    LabelDocument,
    options,
  );
}
export function useLabelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LabelQuery, LabelQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LabelQuery, LabelQueryVariables>(
    LabelDocument,
    options,
  );
}
// @ts-ignore
export function useLabelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LabelQuery,
    LabelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LabelQuery, LabelQueryVariables>;
export function useLabelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>,
): Apollo.UseSuspenseQueryResult<LabelQuery | undefined, LabelQueryVariables>;
export function useLabelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LabelQuery, LabelQueryVariables>(
    LabelDocument,
    options,
  );
}
export type LabelQueryHookResult = ReturnType<typeof useLabelQuery>;
export type LabelLazyQueryHookResult = ReturnType<typeof useLabelLazyQuery>;
export type LabelSuspenseQueryHookResult = ReturnType<
  typeof useLabelSuspenseQuery
>;
export type LabelQueryResult = Apollo.QueryResult<
  LabelQuery,
  LabelQueryVariables
>;
export const LabelsDocument = gql`
  query Labels(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    labels(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on AdminLabelsV1ListLabelsResponse {
        __typename
        labels {
          ...LabelRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${LabelRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useLabelsQuery__
 *
 * To run a query within a React component, call `useLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLabelsQuery(
  baseOptions?: Apollo.QueryHookOptions<LabelsQuery, LabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LabelsQuery, LabelsQueryVariables>(
    LabelsDocument,
    options,
  );
}
export function useLabelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LabelsQuery, LabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LabelsQuery, LabelsQueryVariables>(
    LabelsDocument,
    options,
  );
}
// @ts-ignore
export function useLabelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LabelsQuery,
    LabelsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LabelsQuery, LabelsQueryVariables>;
export function useLabelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LabelsQuery, LabelsQueryVariables>,
): Apollo.UseSuspenseQueryResult<LabelsQuery | undefined, LabelsQueryVariables>;
export function useLabelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LabelsQuery, LabelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LabelsQuery, LabelsQueryVariables>(
    LabelsDocument,
    options,
  );
}
export type LabelsQueryHookResult = ReturnType<typeof useLabelsQuery>;
export type LabelsLazyQueryHookResult = ReturnType<typeof useLabelsLazyQuery>;
export type LabelsSuspenseQueryHookResult = ReturnType<
  typeof useLabelsSuspenseQuery
>;
export type LabelsQueryResult = Apollo.QueryResult<
  LabelsQuery,
  LabelsQueryVariables
>;
export const InitiateImageUploadDocument = gql`
  mutation InitiateImageUpload {
    initiateImageUpload {
      ... on WorkflowV1InitiateImageUploadResponse {
        signedUri
        imageUri
      }
    }
  }
`;
export type InitiateImageUploadMutationFn = Apollo.MutationFunction<
  InitiateImageUploadMutation,
  InitiateImageUploadMutationVariables
>;

/**
 * __useInitiateImageUploadMutation__
 *
 * To run a mutation, you first call `useInitiateImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateImageUploadMutation, { data, loading, error }] = useInitiateImageUploadMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitiateImageUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateImageUploadMutation,
    InitiateImageUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitiateImageUploadMutation,
    InitiateImageUploadMutationVariables
  >(InitiateImageUploadDocument, options);
}
export type InitiateImageUploadMutationHookResult = ReturnType<
  typeof useInitiateImageUploadMutation
>;
export type InitiateImageUploadMutationResult =
  Apollo.MutationResult<InitiateImageUploadMutation>;
export type InitiateImageUploadMutationOptions = Apollo.BaseMutationOptions<
  InitiateImageUploadMutation,
  InitiateImageUploadMutationVariables
>;
export const SearchDocument = gql`
  query Search(
    $query: String!
    $types: [SearchV1ExternalResourceType!]!
    $resourceSpecificFilters: SearchV1ExternalSearchRequestFiltersInput
    $pageSize: Int
    $pageToken: String
  ) {
    search(
      query: $query
      types: $types
      resourceSpecificFilters: $resourceSpecificFilters
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on SearchV1ExternalSearchResponse {
        __typename
        hits {
          resource {
            ... on IamV1Identity {
              ...SearchIdentity
            }
            ... on FlagsAdminV1Flag {
              __typename
              name
              description
            }
            ... on MetricsV1Metric {
              __typename
              name
              displayName
              description
            }
            ... on WorkflowV1WorkflowInstance {
              __typename
              name
              displayName
            }
          }
        }
        nextPageToken
        totalSize
      }
      ...DefaultError
    }
  }
  ${SearchIdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      types: // value for 'types'
 *      resourceSpecificFilters: // value for 'resourceSpecificFilters'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
    ({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options,
  );
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options,
  );
}
// @ts-ignore
export function useSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchQuery,
    SearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchQuery, SearchQueryVariables>;
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchQuery | undefined, SearchQueryVariables>;
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options,
  );
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<
  typeof useSearchSuspenseQuery
>;
export type SearchQueryResult = Apollo.QueryResult<
  SearchQuery,
  SearchQueryVariables
>;
export const DevBarFlagsDocument = gql`
  query DevBarFlags(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    flags(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          variants {
            name
            value
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDevBarFlagsQuery__
 *
 * To run a query within a React component, call `useDevBarFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevBarFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevBarFlagsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDevBarFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DevBarFlagsQuery,
    DevBarFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DevBarFlagsQuery, DevBarFlagsQueryVariables>(
    DevBarFlagsDocument,
    options,
  );
}
export function useDevBarFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DevBarFlagsQuery,
    DevBarFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DevBarFlagsQuery, DevBarFlagsQueryVariables>(
    DevBarFlagsDocument,
    options,
  );
}
// @ts-ignore
export function useDevBarFlagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DevBarFlagsQuery,
    DevBarFlagsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DevBarFlagsQuery, DevBarFlagsQueryVariables>;
export function useDevBarFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DevBarFlagsQuery,
        DevBarFlagsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DevBarFlagsQuery | undefined,
  DevBarFlagsQueryVariables
>;
export function useDevBarFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DevBarFlagsQuery,
        DevBarFlagsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DevBarFlagsQuery, DevBarFlagsQueryVariables>(
    DevBarFlagsDocument,
    options,
  );
}
export type DevBarFlagsQueryHookResult = ReturnType<typeof useDevBarFlagsQuery>;
export type DevBarFlagsLazyQueryHookResult = ReturnType<
  typeof useDevBarFlagsLazyQuery
>;
export type DevBarFlagsSuspenseQueryHookResult = ReturnType<
  typeof useDevBarFlagsSuspenseQuery
>;
export type DevBarFlagsQueryResult = Apollo.QueryResult<
  DevBarFlagsQuery,
  DevBarFlagsQueryVariables
>;
export const CollaborativeDocumentDocument = gql`
  query CollaborativeDocument($name: String!) {
    collaborativeDocument(name: $name) {
      __typename
      ...CollaborativeDocument
      ...DefaultError
    }
  }
  ${CollaborativeDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCollaborativeDocumentQuery__
 *
 * To run a query within a React component, call `useCollaborativeDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborativeDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborativeDocumentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCollaborativeDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  > &
    (
      | { variables: CollaborativeDocumentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  >(CollaborativeDocumentDocument, options);
}
export function useCollaborativeDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  >(CollaborativeDocumentDocument, options);
}
// @ts-ignore
export function useCollaborativeDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollaborativeDocumentQuery,
  CollaborativeDocumentQueryVariables
>;
export function useCollaborativeDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollaborativeDocumentQuery,
        CollaborativeDocumentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollaborativeDocumentQuery | undefined,
  CollaborativeDocumentQueryVariables
>;
export function useCollaborativeDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollaborativeDocumentQuery,
        CollaborativeDocumentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollaborativeDocumentQuery,
    CollaborativeDocumentQueryVariables
  >(CollaborativeDocumentDocument, options);
}
export type CollaborativeDocumentQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentQuery
>;
export type CollaborativeDocumentLazyQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentLazyQuery
>;
export type CollaborativeDocumentSuspenseQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentSuspenseQuery
>;
export type CollaborativeDocumentQueryResult = Apollo.QueryResult<
  CollaborativeDocumentQuery,
  CollaborativeDocumentQueryVariables
>;
export const CollaborativeDocumentRefDocument = gql`
  query CollaborativeDocumentRef($name: String!) {
    collaborativeDocument(name: $name) {
      ...CollaborativeDocumentRef
      ...DefaultError
    }
  }
  ${CollaborativeDocumentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCollaborativeDocumentRefQuery__
 *
 * To run a query within a React component, call `useCollaborativeDocumentRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborativeDocumentRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborativeDocumentRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCollaborativeDocumentRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  > &
    (
      | { variables: CollaborativeDocumentRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  >(CollaborativeDocumentRefDocument, options);
}
export function useCollaborativeDocumentRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  >(CollaborativeDocumentRefDocument, options);
}
// @ts-ignore
export function useCollaborativeDocumentRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollaborativeDocumentRefQuery,
  CollaborativeDocumentRefQueryVariables
>;
export function useCollaborativeDocumentRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollaborativeDocumentRefQuery,
        CollaborativeDocumentRefQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollaborativeDocumentRefQuery | undefined,
  CollaborativeDocumentRefQueryVariables
>;
export function useCollaborativeDocumentRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollaborativeDocumentRefQuery,
        CollaborativeDocumentRefQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollaborativeDocumentRefQuery,
    CollaborativeDocumentRefQueryVariables
  >(CollaborativeDocumentRefDocument, options);
}
export type CollaborativeDocumentRefQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentRefQuery
>;
export type CollaborativeDocumentRefLazyQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentRefLazyQuery
>;
export type CollaborativeDocumentRefSuspenseQueryHookResult = ReturnType<
  typeof useCollaborativeDocumentRefSuspenseQuery
>;
export type CollaborativeDocumentRefQueryResult = Apollo.QueryResult<
  CollaborativeDocumentRefQuery,
  CollaborativeDocumentRefQueryVariables
>;
export const GenerateCollaborativeDocumentDocument = gql`
  mutation GenerateCollaborativeDocument($name: String!) {
    generateCollaborativeDocument(name: $name) {
      __typename
      ...CollaborativeDocument
      ...DefaultError
    }
  }
  ${CollaborativeDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type GenerateCollaborativeDocumentMutationFn = Apollo.MutationFunction<
  GenerateCollaborativeDocumentMutation,
  GenerateCollaborativeDocumentMutationVariables
>;

/**
 * __useGenerateCollaborativeDocumentMutation__
 *
 * To run a mutation, you first call `useGenerateCollaborativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCollaborativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCollaborativeDocumentMutation, { data, loading, error }] = useGenerateCollaborativeDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGenerateCollaborativeDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateCollaborativeDocumentMutation,
    GenerateCollaborativeDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateCollaborativeDocumentMutation,
    GenerateCollaborativeDocumentMutationVariables
  >(GenerateCollaborativeDocumentDocument, options);
}
export type GenerateCollaborativeDocumentMutationHookResult = ReturnType<
  typeof useGenerateCollaborativeDocumentMutation
>;
export type GenerateCollaborativeDocumentMutationResult =
  Apollo.MutationResult<GenerateCollaborativeDocumentMutation>;
export type GenerateCollaborativeDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateCollaborativeDocumentMutation,
    GenerateCollaborativeDocumentMutationVariables
  >;
export const GetTiptapTokenDocument = gql`
  query GetTiptapToken($name: String!) {
    getTiptapToken(name: $name) {
      __typename
      ...TiptapToken
      ...DefaultError
    }
  }
  ${TiptapTokenFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetTiptapTokenQuery__
 *
 * To run a query within a React component, call `useGetTiptapTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTiptapTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTiptapTokenQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTiptapTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTiptapTokenQuery,
    GetTiptapTokenQueryVariables
  > &
    (
      | { variables: GetTiptapTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTiptapTokenQuery, GetTiptapTokenQueryVariables>(
    GetTiptapTokenDocument,
    options,
  );
}
export function useGetTiptapTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTiptapTokenQuery,
    GetTiptapTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTiptapTokenQuery, GetTiptapTokenQueryVariables>(
    GetTiptapTokenDocument,
    options,
  );
}
// @ts-ignore
export function useGetTiptapTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTiptapTokenQuery,
    GetTiptapTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTiptapTokenQuery,
  GetTiptapTokenQueryVariables
>;
export function useGetTiptapTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTiptapTokenQuery,
        GetTiptapTokenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTiptapTokenQuery | undefined,
  GetTiptapTokenQueryVariables
>;
export function useGetTiptapTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTiptapTokenQuery,
        GetTiptapTokenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTiptapTokenQuery,
    GetTiptapTokenQueryVariables
  >(GetTiptapTokenDocument, options);
}
export type GetTiptapTokenQueryHookResult = ReturnType<
  typeof useGetTiptapTokenQuery
>;
export type GetTiptapTokenLazyQueryHookResult = ReturnType<
  typeof useGetTiptapTokenLazyQuery
>;
export type GetTiptapTokenSuspenseQueryHookResult = ReturnType<
  typeof useGetTiptapTokenSuspenseQuery
>;
export type GetTiptapTokenQueryResult = Apollo.QueryResult<
  GetTiptapTokenQuery,
  GetTiptapTokenQueryVariables
>;
export const PublishCollaborativeDocumentDocument = gql`
  mutation PublishCollaborativeDocument(
    $name: String!
    $activityMessage: String
  ) {
    publishCollaborativeDocument(
      name: $name
      activityMessage: $activityMessage
    ) {
      __typename
      ...CollaborativeDocument
      ...DefaultError
    }
  }
  ${CollaborativeDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type PublishCollaborativeDocumentMutationFn = Apollo.MutationFunction<
  PublishCollaborativeDocumentMutation,
  PublishCollaborativeDocumentMutationVariables
>;

/**
 * __usePublishCollaborativeDocumentMutation__
 *
 * To run a mutation, you first call `usePublishCollaborativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCollaborativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCollaborativeDocumentMutation, { data, loading, error }] = usePublishCollaborativeDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      activityMessage: // value for 'activityMessage'
 *   },
 * });
 */
export function usePublishCollaborativeDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishCollaborativeDocumentMutation,
    PublishCollaborativeDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishCollaborativeDocumentMutation,
    PublishCollaborativeDocumentMutationVariables
  >(PublishCollaborativeDocumentDocument, options);
}
export type PublishCollaborativeDocumentMutationHookResult = ReturnType<
  typeof usePublishCollaborativeDocumentMutation
>;
export type PublishCollaborativeDocumentMutationResult =
  Apollo.MutationResult<PublishCollaborativeDocumentMutation>;
export type PublishCollaborativeDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    PublishCollaborativeDocumentMutation,
    PublishCollaborativeDocumentMutationVariables
  >;
export const UnpublishCollaborativeDocumentDocument = gql`
  mutation UnpublishCollaborativeDocument($name: String!) {
    unpublishCollaborativeDocument(name: $name) {
      __typename
      ...CollaborativeDocument
      ...DefaultError
    }
  }
  ${CollaborativeDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UnpublishCollaborativeDocumentMutationFn = Apollo.MutationFunction<
  UnpublishCollaborativeDocumentMutation,
  UnpublishCollaborativeDocumentMutationVariables
>;

/**
 * __useUnpublishCollaborativeDocumentMutation__
 *
 * To run a mutation, you first call `useUnpublishCollaborativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishCollaborativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishCollaborativeDocumentMutation, { data, loading, error }] = useUnpublishCollaborativeDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUnpublishCollaborativeDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnpublishCollaborativeDocumentMutation,
    UnpublishCollaborativeDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnpublishCollaborativeDocumentMutation,
    UnpublishCollaborativeDocumentMutationVariables
  >(UnpublishCollaborativeDocumentDocument, options);
}
export type UnpublishCollaborativeDocumentMutationHookResult = ReturnType<
  typeof useUnpublishCollaborativeDocumentMutation
>;
export type UnpublishCollaborativeDocumentMutationResult =
  Apollo.MutationResult<UnpublishCollaborativeDocumentMutation>;
export type UnpublishCollaborativeDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    UnpublishCollaborativeDocumentMutation,
    UnpublishCollaborativeDocumentMutationVariables
  >;
export const UpdateCollaborativeDocumentDocument = gql`
  mutation UpdateCollaborativeDocument(
    $input: PartialCollaborationV1CollaborativeDocumentInput!
    $updateMask: String
  ) {
    updateCollaborativeDocument(
      collaborativeDocument: $input
      updateMask: $updateMask
    ) {
      __typename
      ...CollaborativeDocument
      ...DefaultError
    }
  }
  ${CollaborativeDocumentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateCollaborativeDocumentMutationFn = Apollo.MutationFunction<
  UpdateCollaborativeDocumentMutation,
  UpdateCollaborativeDocumentMutationVariables
>;

/**
 * __useUpdateCollaborativeDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateCollaborativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollaborativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollaborativeDocumentMutation, { data, loading, error }] = useUpdateCollaborativeDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateCollaborativeDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollaborativeDocumentMutation,
    UpdateCollaborativeDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollaborativeDocumentMutation,
    UpdateCollaborativeDocumentMutationVariables
  >(UpdateCollaborativeDocumentDocument, options);
}
export type UpdateCollaborativeDocumentMutationHookResult = ReturnType<
  typeof useUpdateCollaborativeDocumentMutation
>;
export type UpdateCollaborativeDocumentMutationResult =
  Apollo.MutationResult<UpdateCollaborativeDocumentMutation>;
export type UpdateCollaborativeDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCollaborativeDocumentMutation,
    UpdateCollaborativeDocumentMutationVariables
  >;
export const CreateEntityIdentityBindingDocument = gql`
  mutation CreateEntityIdentityBinding(
    $parent: String!
    $entityIdentityBinding: MetricsV1EntityIdentityBindingInput!
  ) {
    createEntityIdentityBinding(
      parent: $parent
      entityIdentityBinding: $entityIdentityBinding
    ) {
      ...EntityIdentityBinding
      ...DefaultError
    }
  }
  ${EntityIdentityBindingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateEntityIdentityBindingMutationFn = Apollo.MutationFunction<
  CreateEntityIdentityBindingMutation,
  CreateEntityIdentityBindingMutationVariables
>;

/**
 * __useCreateEntityIdentityBindingMutation__
 *
 * To run a mutation, you first call `useCreateEntityIdentityBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityIdentityBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityIdentityBindingMutation, { data, loading, error }] = useCreateEntityIdentityBindingMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      entityIdentityBinding: // value for 'entityIdentityBinding'
 *   },
 * });
 */
export function useCreateEntityIdentityBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEntityIdentityBindingMutation,
    CreateEntityIdentityBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEntityIdentityBindingMutation,
    CreateEntityIdentityBindingMutationVariables
  >(CreateEntityIdentityBindingDocument, options);
}
export type CreateEntityIdentityBindingMutationHookResult = ReturnType<
  typeof useCreateEntityIdentityBindingMutation
>;
export type CreateEntityIdentityBindingMutationResult =
  Apollo.MutationResult<CreateEntityIdentityBindingMutation>;
export type CreateEntityIdentityBindingMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEntityIdentityBindingMutation,
    CreateEntityIdentityBindingMutationVariables
  >;
export const DeleteEntityIdentityBindingDocument = gql`
  mutation DeleteEntityIdentityBinding($name: String!) {
    deleteEntityIdentityBinding(name: $name) {
      __typename
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEntityIdentityBindingMutationFn = Apollo.MutationFunction<
  DeleteEntityIdentityBindingMutation,
  DeleteEntityIdentityBindingMutationVariables
>;

/**
 * __useDeleteEntityIdentityBindingMutation__
 *
 * To run a mutation, you first call `useDeleteEntityIdentityBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityIdentityBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityIdentityBindingMutation, { data, loading, error }] = useDeleteEntityIdentityBindingMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEntityIdentityBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEntityIdentityBindingMutation,
    DeleteEntityIdentityBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEntityIdentityBindingMutation,
    DeleteEntityIdentityBindingMutationVariables
  >(DeleteEntityIdentityBindingDocument, options);
}
export type DeleteEntityIdentityBindingMutationHookResult = ReturnType<
  typeof useDeleteEntityIdentityBindingMutation
>;
export type DeleteEntityIdentityBindingMutationResult =
  Apollo.MutationResult<DeleteEntityIdentityBindingMutation>;
export type DeleteEntityIdentityBindingMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteEntityIdentityBindingMutation,
    DeleteEntityIdentityBindingMutationVariables
  >;
export const EntityIdentityBindingsDocument = gql`
  query EntityIdentityBindings(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $parent: String
  ) {
    entityIdentityBindings(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      parent: $parent
    ) {
      __typename
      ... on MetricsV1ListEntityIdentityBindingsResponse {
        __typename
        entityIdentityBindings {
          ...EntityIdentityBinding
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${EntityIdentityBindingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEntityIdentityBindingsQuery__
 *
 * To run a query within a React component, call `useEntityIdentityBindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityIdentityBindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityIdentityBindingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useEntityIdentityBindingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >(EntityIdentityBindingsDocument, options);
}
export function useEntityIdentityBindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >(EntityIdentityBindingsDocument, options);
}
// @ts-ignore
export function useEntityIdentityBindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EntityIdentityBindingsQuery,
  EntityIdentityBindingsQueryVariables
>;
export function useEntityIdentityBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntityIdentityBindingsQuery,
        EntityIdentityBindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EntityIdentityBindingsQuery | undefined,
  EntityIdentityBindingsQueryVariables
>;
export function useEntityIdentityBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntityIdentityBindingsQuery,
        EntityIdentityBindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EntityIdentityBindingsQuery,
    EntityIdentityBindingsQueryVariables
  >(EntityIdentityBindingsDocument, options);
}
export type EntityIdentityBindingsQueryHookResult = ReturnType<
  typeof useEntityIdentityBindingsQuery
>;
export type EntityIdentityBindingsLazyQueryHookResult = ReturnType<
  typeof useEntityIdentityBindingsLazyQuery
>;
export type EntityIdentityBindingsSuspenseQueryHookResult = ReturnType<
  typeof useEntityIdentityBindingsSuspenseQuery
>;
export type EntityIdentityBindingsQueryResult = Apollo.QueryResult<
  EntityIdentityBindingsQuery,
  EntityIdentityBindingsQueryVariables
>;
export const UpdateEntityIdentityBindingDocument = gql`
  mutation UpdateEntityIdentityBinding(
    $input: PartialMetricsV1EntityIdentityBindingInput!
    $updateMask: String
  ) {
    updateEntityIdentityBinding(
      entityIdentityBinding: $input
      updateMask: $updateMask
    ) {
      ...EntityIdentityBinding
      ...DefaultError
    }
  }
  ${EntityIdentityBindingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateEntityIdentityBindingMutationFn = Apollo.MutationFunction<
  UpdateEntityIdentityBindingMutation,
  UpdateEntityIdentityBindingMutationVariables
>;

/**
 * __useUpdateEntityIdentityBindingMutation__
 *
 * To run a mutation, you first call `useUpdateEntityIdentityBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityIdentityBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityIdentityBindingMutation, { data, loading, error }] = useUpdateEntityIdentityBindingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateEntityIdentityBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEntityIdentityBindingMutation,
    UpdateEntityIdentityBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEntityIdentityBindingMutation,
    UpdateEntityIdentityBindingMutationVariables
  >(UpdateEntityIdentityBindingDocument, options);
}
export type UpdateEntityIdentityBindingMutationHookResult = ReturnType<
  typeof useUpdateEntityIdentityBindingMutation
>;
export type UpdateEntityIdentityBindingMutationResult =
  Apollo.MutationResult<UpdateEntityIdentityBindingMutation>;
export type UpdateEntityIdentityBindingMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateEntityIdentityBindingMutation,
    UpdateEntityIdentityBindingMutationVariables
  >;
export const CreateEnvironmentDocument = gql`
  mutation CreateEnvironment(
    $environment: FlagsAdminV1EnvironmentInput!
    $environmentId: String!
  ) {
    createEnvironment(
      environment: $environment
      environmentId: $environmentId
    ) {
      __typename
      ...Environment
      ...DefaultError
    }
  }
  ${EnvironmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateEnvironmentMutationFn = Apollo.MutationFunction<
  CreateEnvironmentMutation,
  CreateEnvironmentMutationVariables
>;

/**
 * __useCreateEnvironmentMutation__
 *
 * To run a mutation, you first call `useCreateEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnvironmentMutation, { data, loading, error }] = useCreateEnvironmentMutation({
 *   variables: {
 *      environment: // value for 'environment'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useCreateEnvironmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEnvironmentMutation,
    CreateEnvironmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEnvironmentMutation,
    CreateEnvironmentMutationVariables
  >(CreateEnvironmentDocument, options);
}
export type CreateEnvironmentMutationHookResult = ReturnType<
  typeof useCreateEnvironmentMutation
>;
export type CreateEnvironmentMutationResult =
  Apollo.MutationResult<CreateEnvironmentMutation>;
export type CreateEnvironmentMutationOptions = Apollo.BaseMutationOptions<
  CreateEnvironmentMutation,
  CreateEnvironmentMutationVariables
>;
export const DeleteEnvironmentDocument = gql`
  mutation DeleteEnvironment($name: String!) {
    deleteEnvironment(name: $name) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEnvironmentMutationFn = Apollo.MutationFunction<
  DeleteEnvironmentMutation,
  DeleteEnvironmentMutationVariables
>;

/**
 * __useDeleteEnvironmentMutation__
 *
 * To run a mutation, you first call `useDeleteEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnvironmentMutation, { data, loading, error }] = useDeleteEnvironmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEnvironmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEnvironmentMutation,
    DeleteEnvironmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEnvironmentMutation,
    DeleteEnvironmentMutationVariables
  >(DeleteEnvironmentDocument, options);
}
export type DeleteEnvironmentMutationHookResult = ReturnType<
  typeof useDeleteEnvironmentMutation
>;
export type DeleteEnvironmentMutationResult =
  Apollo.MutationResult<DeleteEnvironmentMutation>;
export type DeleteEnvironmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteEnvironmentMutation,
  DeleteEnvironmentMutationVariables
>;
export const EnvironmentsDocument = gql`
  query Environments($pageSize: Int, $pageToken: String) {
    environments(
      pageSize: $pageSize
      pageToken: $pageToken
      showDeleted: true
    ) {
      __typename
      ...DefaultError
      ... on FlagsAdminV1ListEnvironmentsResponse {
        environments {
          ...Environment
        }
        nextPageToken
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EnvironmentFragmentDoc}
`;

/**
 * __useEnvironmentsQuery__
 *
 * To run a query within a React component, call `useEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useEnvironmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnvironmentsQuery,
    EnvironmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(
    EnvironmentsDocument,
    options,
  );
}
export function useEnvironmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnvironmentsQuery,
    EnvironmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(
    EnvironmentsDocument,
    options,
  );
}
// @ts-ignore
export function useEnvironmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EnvironmentsQuery,
    EnvironmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EnvironmentsQuery, EnvironmentsQueryVariables>;
export function useEnvironmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnvironmentsQuery,
        EnvironmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EnvironmentsQuery | undefined,
  EnvironmentsQueryVariables
>;
export function useEnvironmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EnvironmentsQuery,
        EnvironmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(
    EnvironmentsDocument,
    options,
  );
}
export type EnvironmentsQueryHookResult = ReturnType<
  typeof useEnvironmentsQuery
>;
export type EnvironmentsLazyQueryHookResult = ReturnType<
  typeof useEnvironmentsLazyQuery
>;
export type EnvironmentsSuspenseQueryHookResult = ReturnType<
  typeof useEnvironmentsSuspenseQuery
>;
export type EnvironmentsQueryResult = Apollo.QueryResult<
  EnvironmentsQuery,
  EnvironmentsQueryVariables
>;
export const ListEnvironmentsDocument = gql`
  query ListEnvironments {
    environments {
      ... on FlagsAdminV1ListEnvironmentsResponse {
        environments {
          ...Environment
        }
      }
    }
  }
  ${EnvironmentFragmentDoc}
`;

/**
 * __useListEnvironmentsQuery__
 *
 * To run a query within a React component, call `useListEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEnvironmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEnvironmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListEnvironmentsQuery,
    ListEnvironmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEnvironmentsQuery, ListEnvironmentsQueryVariables>(
    ListEnvironmentsDocument,
    options,
  );
}
export function useListEnvironmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEnvironmentsQuery,
    ListEnvironmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListEnvironmentsQuery,
    ListEnvironmentsQueryVariables
  >(ListEnvironmentsDocument, options);
}
// @ts-ignore
export function useListEnvironmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEnvironmentsQuery,
    ListEnvironmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListEnvironmentsQuery,
  ListEnvironmentsQueryVariables
>;
export function useListEnvironmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEnvironmentsQuery,
        ListEnvironmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEnvironmentsQuery | undefined,
  ListEnvironmentsQueryVariables
>;
export function useListEnvironmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEnvironmentsQuery,
        ListEnvironmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListEnvironmentsQuery,
    ListEnvironmentsQueryVariables
  >(ListEnvironmentsDocument, options);
}
export type ListEnvironmentsQueryHookResult = ReturnType<
  typeof useListEnvironmentsQuery
>;
export type ListEnvironmentsLazyQueryHookResult = ReturnType<
  typeof useListEnvironmentsLazyQuery
>;
export type ListEnvironmentsSuspenseQueryHookResult = ReturnType<
  typeof useListEnvironmentsSuspenseQuery
>;
export type ListEnvironmentsQueryResult = Apollo.QueryResult<
  ListEnvironmentsQuery,
  ListEnvironmentsQueryVariables
>;
export const UndeleteEnvironmentDocument = gql`
  mutation UndeleteEnvironment($name: String!) {
    undeleteEnvironment(name: $name) {
      __typename
      ...DefaultError
      ... on FlagsAdminV1Environment {
        ...Environment
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EnvironmentFragmentDoc}
`;
export type UndeleteEnvironmentMutationFn = Apollo.MutationFunction<
  UndeleteEnvironmentMutation,
  UndeleteEnvironmentMutationVariables
>;

/**
 * __useUndeleteEnvironmentMutation__
 *
 * To run a mutation, you first call `useUndeleteEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteEnvironmentMutation, { data, loading, error }] = useUndeleteEnvironmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUndeleteEnvironmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UndeleteEnvironmentMutation,
    UndeleteEnvironmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UndeleteEnvironmentMutation,
    UndeleteEnvironmentMutationVariables
  >(UndeleteEnvironmentDocument, options);
}
export type UndeleteEnvironmentMutationHookResult = ReturnType<
  typeof useUndeleteEnvironmentMutation
>;
export type UndeleteEnvironmentMutationResult =
  Apollo.MutationResult<UndeleteEnvironmentMutation>;
export type UndeleteEnvironmentMutationOptions = Apollo.BaseMutationOptions<
  UndeleteEnvironmentMutation,
  UndeleteEnvironmentMutationVariables
>;
export const UpdateEnvironmentDocument = gql`
  mutation UpdateEnvironment(
    $input: PartialFlagsAdminV1EnvironmentInput!
    $updateMask: String
  ) {
    updateEnvironment(environment: $input, updateMask: $updateMask) {
      __typename
      ...DefaultError
      ... on FlagsAdminV1Environment {
        ...Environment
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EnvironmentFragmentDoc}
`;
export type UpdateEnvironmentMutationFn = Apollo.MutationFunction<
  UpdateEnvironmentMutation,
  UpdateEnvironmentMutationVariables
>;

/**
 * __useUpdateEnvironmentMutation__
 *
 * To run a mutation, you first call `useUpdateEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvironmentMutation, { data, loading, error }] = useUpdateEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateEnvironmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEnvironmentMutation,
    UpdateEnvironmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEnvironmentMutation,
    UpdateEnvironmentMutationVariables
  >(UpdateEnvironmentDocument, options);
}
export type UpdateEnvironmentMutationHookResult = ReturnType<
  typeof useUpdateEnvironmentMutation
>;
export type UpdateEnvironmentMutationResult =
  Apollo.MutationResult<UpdateEnvironmentMutation>;
export type UpdateEnvironmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateEnvironmentMutation,
  UpdateEnvironmentMutationVariables
>;
export const CreateEventDocument = gql`
  mutation CreateEvent(
    $eventId: String!
    $event: EventsAdminV1EventDefinitionInput!
  ) {
    createEventDefinition(
      eventDefinition: $event
      eventDefinitionId: $eventId
    ) {
      ...EventDefinition
      ...DefaultError
    }
  }
  ${EventDefinitionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateEventMutationFn = Apollo.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventMutation,
    CreateEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<
  typeof useCreateEventMutation
>;
export type CreateEventMutationResult =
  Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const DeleteEventDefinitionDocument = gql`
  mutation DeleteEventDefinition($name: String!) {
    deleteEventDefinition(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEventDefinitionMutationFn = Apollo.MutationFunction<
  DeleteEventDefinitionMutation,
  DeleteEventDefinitionMutationVariables
>;

/**
 * __useDeleteEventDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteEventDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventDefinitionMutation, { data, loading, error }] = useDeleteEventDefinitionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEventDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEventDefinitionMutation,
    DeleteEventDefinitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEventDefinitionMutation,
    DeleteEventDefinitionMutationVariables
  >(DeleteEventDefinitionDocument, options);
}
export type DeleteEventDefinitionMutationHookResult = ReturnType<
  typeof useDeleteEventDefinitionMutation
>;
export type DeleteEventDefinitionMutationResult =
  Apollo.MutationResult<DeleteEventDefinitionMutation>;
export type DeleteEventDefinitionMutationOptions = Apollo.BaseMutationOptions<
  DeleteEventDefinitionMutation,
  DeleteEventDefinitionMutationVariables
>;
export const DraftFieldsDocument = gql`
  query DraftFields($pageToken: String) {
    queryDraftEvents(
      filter: "reason:EVENT_DEFINITION_UNKNOWN_FIELDS"
      pageToken: $pageToken
    ) {
      __typename
      ... on EventsAdminV1QueryDraftEventsResponse {
        draftEvents {
          ...DraftEvent
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DraftEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDraftFieldsQuery__
 *
 * To run a query within a React component, call `useDraftFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftFieldsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useDraftFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DraftFieldsQuery,
    DraftFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftFieldsQuery, DraftFieldsQueryVariables>(
    DraftFieldsDocument,
    options,
  );
}
export function useDraftFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftFieldsQuery,
    DraftFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DraftFieldsQuery, DraftFieldsQueryVariables>(
    DraftFieldsDocument,
    options,
  );
}
// @ts-ignore
export function useDraftFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DraftFieldsQuery,
    DraftFieldsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DraftFieldsQuery, DraftFieldsQueryVariables>;
export function useDraftFieldsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftFieldsQuery,
        DraftFieldsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DraftFieldsQuery | undefined,
  DraftFieldsQueryVariables
>;
export function useDraftFieldsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftFieldsQuery,
        DraftFieldsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DraftFieldsQuery, DraftFieldsQueryVariables>(
    DraftFieldsDocument,
    options,
  );
}
export type DraftFieldsQueryHookResult = ReturnType<typeof useDraftFieldsQuery>;
export type DraftFieldsLazyQueryHookResult = ReturnType<
  typeof useDraftFieldsLazyQuery
>;
export type DraftFieldsSuspenseQueryHookResult = ReturnType<
  typeof useDraftFieldsSuspenseQuery
>;
export type DraftFieldsQueryResult = Apollo.QueryResult<
  DraftFieldsQuery,
  DraftFieldsQueryVariables
>;
export const EventDocument = gql`
  query Event($name: String!, $draftFilter: String) {
    eventDefinition(name: $name) {
      __typename
      ...EventDefinition
      ...DefaultError
    }
    queryDraftEvents(filter: $draftFilter) {
      __typename
      ... on EventsAdminV1QueryDraftEventsResponse {
        draftEvents {
          ...DraftEvent
        }
      }
      ...DefaultError
    }
  }
  ${EventDefinitionFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${DraftEventFragmentDoc}
`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      name: // value for 'name'
 *      draftFilter: // value for 'draftFilter'
 *   },
 * });
 */
export function useEventQuery(
  baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables> &
    ({ variables: EventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
export function useEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
// @ts-ignore
export function useEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventQuery,
    EventQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventQuery, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
): Apollo.UseSuspenseQueryResult<EventQuery | undefined, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EventQuery, EventQueryVariables>(
    EventDocument,
    options,
  );
}
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventSuspenseQueryHookResult = ReturnType<
  typeof useEventSuspenseQuery
>;
export type EventQueryResult = Apollo.QueryResult<
  EventQuery,
  EventQueryVariables
>;
export const EventDefinitionsDocument = gql`
  query EventDefinitions(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    eventDefinitions(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on EventsAdminV1ListEventDefinitionsResponse {
        __typename
        eventDefinitions {
          ...EventDefinition
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${EventDefinitionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEventDefinitionsQuery__
 *
 * To run a query within a React component, call `useEventDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDefinitionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useEventDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EventDefinitionsQuery,
    EventDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventDefinitionsQuery, EventDefinitionsQueryVariables>(
    EventDefinitionsDocument,
    options,
  );
}
export function useEventDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventDefinitionsQuery,
    EventDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EventDefinitionsQuery,
    EventDefinitionsQueryVariables
  >(EventDefinitionsDocument, options);
}
// @ts-ignore
export function useEventDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventDefinitionsQuery,
    EventDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EventDefinitionsQuery,
  EventDefinitionsQueryVariables
>;
export function useEventDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventDefinitionsQuery,
        EventDefinitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventDefinitionsQuery | undefined,
  EventDefinitionsQueryVariables
>;
export function useEventDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventDefinitionsQuery,
        EventDefinitionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EventDefinitionsQuery,
    EventDefinitionsQueryVariables
  >(EventDefinitionsDocument, options);
}
export type EventDefinitionsQueryHookResult = ReturnType<
  typeof useEventDefinitionsQuery
>;
export type EventDefinitionsLazyQueryHookResult = ReturnType<
  typeof useEventDefinitionsLazyQuery
>;
export type EventDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useEventDefinitionsSuspenseQuery
>;
export type EventDefinitionsQueryResult = Apollo.QueryResult<
  EventDefinitionsQuery,
  EventDefinitionsQueryVariables
>;
export const EventExistDocument = gql`
  query EventExist($name: String!) {
    eventDefinition(name: $name) {
      ... on EventsAdminV1EventDefinition {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEventExistQuery__
 *
 * To run a query within a React component, call `useEventExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventExistQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEventExistQuery(
  baseOptions: Apollo.QueryHookOptions<
    EventExistQuery,
    EventExistQueryVariables
  > &
    (
      | { variables: EventExistQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventExistQuery, EventExistQueryVariables>(
    EventExistDocument,
    options,
  );
}
export function useEventExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventExistQuery,
    EventExistQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EventExistQuery, EventExistQueryVariables>(
    EventExistDocument,
    options,
  );
}
// @ts-ignore
export function useEventExistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventExistQuery,
    EventExistQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventExistQuery, EventExistQueryVariables>;
export function useEventExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventExistQuery,
        EventExistQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventExistQuery | undefined,
  EventExistQueryVariables
>;
export function useEventExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventExistQuery,
        EventExistQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EventExistQuery, EventExistQueryVariables>(
    EventExistDocument,
    options,
  );
}
export type EventExistQueryHookResult = ReturnType<typeof useEventExistQuery>;
export type EventExistLazyQueryHookResult = ReturnType<
  typeof useEventExistLazyQuery
>;
export type EventExistSuspenseQueryHookResult = ReturnType<
  typeof useEventExistSuspenseQuery
>;
export type EventExistQueryResult = Apollo.QueryResult<
  EventExistQuery,
  EventExistQueryVariables
>;
export const EventUsageDocument = gql`
  query EventUsage($event: String!, $startTime: String!, $endTime: String!) {
    queryEventsUsage(
      eventDefinition: $event
      startTime: $startTime
      endTime: $endTime
    ) {
      ... on EventsAdminV1QueryEventsUsageResponse {
        __typename
        usage {
          hourTime
          publishCount
          validationFailedCount
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEventUsageQuery__
 *
 * To run a query within a React component, call `useEventUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventUsageQuery({
 *   variables: {
 *      event: // value for 'event'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useEventUsageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EventUsageQuery,
    EventUsageQueryVariables
  > &
    (
      | { variables: EventUsageQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventUsageQuery, EventUsageQueryVariables>(
    EventUsageDocument,
    options,
  );
}
export function useEventUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventUsageQuery,
    EventUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EventUsageQuery, EventUsageQueryVariables>(
    EventUsageDocument,
    options,
  );
}
// @ts-ignore
export function useEventUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventUsageQuery,
    EventUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventUsageQuery, EventUsageQueryVariables>;
export function useEventUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventUsageQuery,
        EventUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventUsageQuery | undefined,
  EventUsageQueryVariables
>;
export function useEventUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventUsageQuery,
        EventUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EventUsageQuery, EventUsageQueryVariables>(
    EventUsageDocument,
    options,
  );
}
export type EventUsageQueryHookResult = ReturnType<typeof useEventUsageQuery>;
export type EventUsageLazyQueryHookResult = ReturnType<
  typeof useEventUsageLazyQuery
>;
export type EventUsageSuspenseQueryHookResult = ReturnType<
  typeof useEventUsageSuspenseQuery
>;
export type EventUsageQueryResult = Apollo.QueryResult<
  EventUsageQuery,
  EventUsageQueryVariables
>;
export const OnEventDefinitionCreatedDocument = gql`
  subscription OnEventDefinitionCreated {
    eventDefinitionCreated {
      eventDefinition {
        ...EventDefinition
      }
    }
  }
  ${EventDefinitionFragmentDoc}
`;

/**
 * __useOnEventDefinitionCreatedSubscription__
 *
 * To run a query within a React component, call `useOnEventDefinitionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEventDefinitionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEventDefinitionCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEventDefinitionCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnEventDefinitionCreatedSubscription,
    OnEventDefinitionCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEventDefinitionCreatedSubscription,
    OnEventDefinitionCreatedSubscriptionVariables
  >(OnEventDefinitionCreatedDocument, options);
}
export type OnEventDefinitionCreatedSubscriptionHookResult = ReturnType<
  typeof useOnEventDefinitionCreatedSubscription
>;
export type OnEventDefinitionCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnEventDefinitionCreatedSubscription>;
export const OnEventDefinitionDeletedDocument = gql`
  subscription OnEventDefinitionDeleted {
    eventDefinitionDeleted {
      eventDefinition
    }
  }
`;

/**
 * __useOnEventDefinitionDeletedSubscription__
 *
 * To run a query within a React component, call `useOnEventDefinitionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEventDefinitionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEventDefinitionDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEventDefinitionDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnEventDefinitionDeletedSubscription,
    OnEventDefinitionDeletedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEventDefinitionDeletedSubscription,
    OnEventDefinitionDeletedSubscriptionVariables
  >(OnEventDefinitionDeletedDocument, options);
}
export type OnEventDefinitionDeletedSubscriptionHookResult = ReturnType<
  typeof useOnEventDefinitionDeletedSubscription
>;
export type OnEventDefinitionDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnEventDefinitionDeletedSubscription>;
export const OnEventDefinitionUpdatedDocument = gql`
  subscription OnEventDefinitionUpdated {
    eventDefinitionUpdated {
      eventDefinition {
        ...EventDefinition
      }
    }
  }
  ${EventDefinitionFragmentDoc}
`;

/**
 * __useOnEventDefinitionUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEventDefinitionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEventDefinitionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEventDefinitionUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEventDefinitionUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnEventDefinitionUpdatedSubscription,
    OnEventDefinitionUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEventDefinitionUpdatedSubscription,
    OnEventDefinitionUpdatedSubscriptionVariables
  >(OnEventDefinitionUpdatedDocument, options);
}
export type OnEventDefinitionUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnEventDefinitionUpdatedSubscription
>;
export type OnEventDefinitionUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnEventDefinitionUpdatedSubscription>;
export const QueryDraftEventsDocument = gql`
  query QueryDraftEvents($pageToken: String) {
    queryDraftEvents(
      filter: "reason:EVENT_DEFINITION_MISSING"
      pageToken: $pageToken
    ) {
      __typename
      ... on EventsAdminV1QueryDraftEventsResponse {
        draftEvents {
          ...DraftEvent
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DraftEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useQueryDraftEventsQuery__
 *
 * To run a query within a React component, call `useQueryDraftEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDraftEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDraftEventsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useQueryDraftEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QueryDraftEventsQuery,
    QueryDraftEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryDraftEventsQuery, QueryDraftEventsQueryVariables>(
    QueryDraftEventsDocument,
    options,
  );
}
export function useQueryDraftEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryDraftEventsQuery,
    QueryDraftEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryDraftEventsQuery,
    QueryDraftEventsQueryVariables
  >(QueryDraftEventsDocument, options);
}
// @ts-ignore
export function useQueryDraftEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryDraftEventsQuery,
    QueryDraftEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryDraftEventsQuery,
  QueryDraftEventsQueryVariables
>;
export function useQueryDraftEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryDraftEventsQuery,
        QueryDraftEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryDraftEventsQuery | undefined,
  QueryDraftEventsQueryVariables
>;
export function useQueryDraftEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryDraftEventsQuery,
        QueryDraftEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryDraftEventsQuery,
    QueryDraftEventsQueryVariables
  >(QueryDraftEventsDocument, options);
}
export type QueryDraftEventsQueryHookResult = ReturnType<
  typeof useQueryDraftEventsQuery
>;
export type QueryDraftEventsLazyQueryHookResult = ReturnType<
  typeof useQueryDraftEventsLazyQuery
>;
export type QueryDraftEventsSuspenseQueryHookResult = ReturnType<
  typeof useQueryDraftEventsSuspenseQuery
>;
export type QueryDraftEventsQueryResult = Apollo.QueryResult<
  QueryDraftEventsQuery,
  QueryDraftEventsQueryVariables
>;
export const UpdateEventDefinitionDocument = gql`
  mutation UpdateEventDefinition(
    $event: PartialEventsAdminV1EventDefinitionInput!
    $updateMask: String!
  ) {
    updateEventDefinition(eventDefinition: $event, updateMask: $updateMask) {
      ...EventDefinition
      ...DefaultError
    }
  }
  ${EventDefinitionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateEventDefinitionMutationFn = Apollo.MutationFunction<
  UpdateEventDefinitionMutation,
  UpdateEventDefinitionMutationVariables
>;

/**
 * __useUpdateEventDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateEventDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDefinitionMutation, { data, loading, error }] = useUpdateEventDefinitionMutation({
 *   variables: {
 *      event: // value for 'event'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateEventDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEventDefinitionMutation,
    UpdateEventDefinitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEventDefinitionMutation,
    UpdateEventDefinitionMutationVariables
  >(UpdateEventDefinitionDocument, options);
}
export type UpdateEventDefinitionMutationHookResult = ReturnType<
  typeof useUpdateEventDefinitionMutation
>;
export type UpdateEventDefinitionMutationResult =
  Apollo.MutationResult<UpdateEventDefinitionMutation>;
export type UpdateEventDefinitionMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventDefinitionMutation,
  UpdateEventDefinitionMutationVariables
>;
export const CreateExternalDocumentDocument = gql`
  mutation CreateExternalDocument(
    $externalDocument: CollaborationV1ExternalDocumentInput!
    $externalDocumentId: String
  ) {
    createExternalDocument(
      externalDocument: $externalDocument
      externalDocumentId: $externalDocumentId
    ) {
      ...ExternalDocumentRef
      ...DefaultError
    }
  }
  ${ExternalDocumentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateExternalDocumentMutationFn = Apollo.MutationFunction<
  CreateExternalDocumentMutation,
  CreateExternalDocumentMutationVariables
>;

/**
 * __useCreateExternalDocumentMutation__
 *
 * To run a mutation, you first call `useCreateExternalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalDocumentMutation, { data, loading, error }] = useCreateExternalDocumentMutation({
 *   variables: {
 *      externalDocument: // value for 'externalDocument'
 *      externalDocumentId: // value for 'externalDocumentId'
 *   },
 * });
 */
export function useCreateExternalDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExternalDocumentMutation,
    CreateExternalDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExternalDocumentMutation,
    CreateExternalDocumentMutationVariables
  >(CreateExternalDocumentDocument, options);
}
export type CreateExternalDocumentMutationHookResult = ReturnType<
  typeof useCreateExternalDocumentMutation
>;
export type CreateExternalDocumentMutationResult =
  Apollo.MutationResult<CreateExternalDocumentMutation>;
export type CreateExternalDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateExternalDocumentMutation,
  CreateExternalDocumentMutationVariables
>;
export const DeleteExternalDocumentDocument = gql`
  mutation DeleteExternalDocument($name: String!) {
    deleteExternalDocument(name: $name) {
      ... on CollaborationV1ExternalDocument {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteExternalDocumentMutationFn = Apollo.MutationFunction<
  DeleteExternalDocumentMutation,
  DeleteExternalDocumentMutationVariables
>;

/**
 * __useDeleteExternalDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteExternalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalDocumentMutation, { data, loading, error }] = useDeleteExternalDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteExternalDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExternalDocumentMutation,
    DeleteExternalDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteExternalDocumentMutation,
    DeleteExternalDocumentMutationVariables
  >(DeleteExternalDocumentDocument, options);
}
export type DeleteExternalDocumentMutationHookResult = ReturnType<
  typeof useDeleteExternalDocumentMutation
>;
export type DeleteExternalDocumentMutationResult =
  Apollo.MutationResult<DeleteExternalDocumentMutation>;
export type DeleteExternalDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteExternalDocumentMutation,
  DeleteExternalDocumentMutationVariables
>;
export const ExternalDocumentRefDocument = gql`
  query ExternalDocumentRef($name: String!) {
    externalDocument(name: $name) {
      ...ExternalDocumentRef
      ...DefaultError
    }
  }
  ${ExternalDocumentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExternalDocumentRefQuery__
 *
 * To run a query within a React component, call `useExternalDocumentRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDocumentRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDocumentRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useExternalDocumentRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  > &
    (
      | { variables: ExternalDocumentRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  >(ExternalDocumentRefDocument, options);
}
export function useExternalDocumentRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  >(ExternalDocumentRefDocument, options);
}
// @ts-ignore
export function useExternalDocumentRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExternalDocumentRefQuery,
  ExternalDocumentRefQueryVariables
>;
export function useExternalDocumentRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDocumentRefQuery,
        ExternalDocumentRefQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExternalDocumentRefQuery | undefined,
  ExternalDocumentRefQueryVariables
>;
export function useExternalDocumentRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDocumentRefQuery,
        ExternalDocumentRefQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExternalDocumentRefQuery,
    ExternalDocumentRefQueryVariables
  >(ExternalDocumentRefDocument, options);
}
export type ExternalDocumentRefQueryHookResult = ReturnType<
  typeof useExternalDocumentRefQuery
>;
export type ExternalDocumentRefLazyQueryHookResult = ReturnType<
  typeof useExternalDocumentRefLazyQuery
>;
export type ExternalDocumentRefSuspenseQueryHookResult = ReturnType<
  typeof useExternalDocumentRefSuspenseQuery
>;
export type ExternalDocumentRefQueryResult = Apollo.QueryResult<
  ExternalDocumentRefQuery,
  ExternalDocumentRefQueryVariables
>;
export const SearchProviderDocumentsDocument = gql`
  query SearchProviderDocuments(
    $provider: CollaborationV1SearchProvider!
    $query: String
    $pageSize: Int
    $pageToken: String
  ) {
    searchProviderDocuments(
      provider: $provider
      query: $query
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on CollaborationV1SearchProviderDocumentsResponse {
        nextPageToken
        pages {
          id
          title
          icon
          mimeType
          lastEditedTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSearchProviderDocumentsQuery__
 *
 * To run a query within a React component, call `useSearchProviderDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProviderDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProviderDocumentsQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *      query: // value for 'query'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useSearchProviderDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  > &
    (
      | { variables: SearchProviderDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  >(SearchProviderDocumentsDocument, options);
}
export function useSearchProviderDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  >(SearchProviderDocumentsDocument, options);
}
// @ts-ignore
export function useSearchProviderDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchProviderDocumentsQuery,
  SearchProviderDocumentsQueryVariables
>;
export function useSearchProviderDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchProviderDocumentsQuery,
        SearchProviderDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchProviderDocumentsQuery | undefined,
  SearchProviderDocumentsQueryVariables
>;
export function useSearchProviderDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchProviderDocumentsQuery,
        SearchProviderDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchProviderDocumentsQuery,
    SearchProviderDocumentsQueryVariables
  >(SearchProviderDocumentsDocument, options);
}
export type SearchProviderDocumentsQueryHookResult = ReturnType<
  typeof useSearchProviderDocumentsQuery
>;
export type SearchProviderDocumentsLazyQueryHookResult = ReturnType<
  typeof useSearchProviderDocumentsLazyQuery
>;
export type SearchProviderDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useSearchProviderDocumentsSuspenseQuery
>;
export type SearchProviderDocumentsQueryResult = Apollo.QueryResult<
  SearchProviderDocumentsQuery,
  SearchProviderDocumentsQueryVariables
>;
export const CancelScheduledMaterializedSegmentLoadJobDocument = gql`
  mutation CancelScheduledMaterializedSegmentLoadJob($name: String!) {
    cancelScheduledMaterializedSegmentLoadJob(name: $name) {
      ...ScheduledMaterializedSegmentLoadJob
      ...DefaultError
    }
  }
  ${ScheduledMaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CancelScheduledMaterializedSegmentLoadJobMutationFn =
  Apollo.MutationFunction<
    CancelScheduledMaterializedSegmentLoadJobMutation,
    CancelScheduledMaterializedSegmentLoadJobMutationVariables
  >;

/**
 * __useCancelScheduledMaterializedSegmentLoadJobMutation__
 *
 * To run a mutation, you first call `useCancelScheduledMaterializedSegmentLoadJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledMaterializedSegmentLoadJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledMaterializedSegmentLoadJobMutation, { data, loading, error }] = useCancelScheduledMaterializedSegmentLoadJobMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCancelScheduledMaterializedSegmentLoadJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelScheduledMaterializedSegmentLoadJobMutation,
    CancelScheduledMaterializedSegmentLoadJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelScheduledMaterializedSegmentLoadJobMutation,
    CancelScheduledMaterializedSegmentLoadJobMutationVariables
  >(CancelScheduledMaterializedSegmentLoadJobDocument, options);
}
export type CancelScheduledMaterializedSegmentLoadJobMutationHookResult =
  ReturnType<typeof useCancelScheduledMaterializedSegmentLoadJobMutation>;
export type CancelScheduledMaterializedSegmentLoadJobMutationResult =
  Apollo.MutationResult<CancelScheduledMaterializedSegmentLoadJobMutation>;
export type CancelScheduledMaterializedSegmentLoadJobMutationOptions =
  Apollo.BaseMutationOptions<
    CancelScheduledMaterializedSegmentLoadJobMutation,
    CancelScheduledMaterializedSegmentLoadJobMutationVariables
  >;
export const CreateMaterializedSegmentLoadJobDocument = gql`
  mutation CreateMaterializedSegmentLoadJob(
    $materializedSegmentLoadJob: MaterializerV1MaterializedSegmentLoadJobInput!
    $materializedSegmentLoadJobId: String
    $parent: String!
  ) {
    createMaterializedSegmentLoadJob(
      materializedSegmentLoadJob: $materializedSegmentLoadJob
      materializedSegmentLoadJobId: $materializedSegmentLoadJobId
      parent: $parent
    ) {
      ...MaterializedSegmentLoadJob
      ...DefaultError
    }
  }
  ${MaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateMaterializedSegmentLoadJobMutationFn =
  Apollo.MutationFunction<
    CreateMaterializedSegmentLoadJobMutation,
    CreateMaterializedSegmentLoadJobMutationVariables
  >;

/**
 * __useCreateMaterializedSegmentLoadJobMutation__
 *
 * To run a mutation, you first call `useCreateMaterializedSegmentLoadJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterializedSegmentLoadJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterializedSegmentLoadJobMutation, { data, loading, error }] = useCreateMaterializedSegmentLoadJobMutation({
 *   variables: {
 *      materializedSegmentLoadJob: // value for 'materializedSegmentLoadJob'
 *      materializedSegmentLoadJobId: // value for 'materializedSegmentLoadJobId'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateMaterializedSegmentLoadJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMaterializedSegmentLoadJobMutation,
    CreateMaterializedSegmentLoadJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMaterializedSegmentLoadJobMutation,
    CreateMaterializedSegmentLoadJobMutationVariables
  >(CreateMaterializedSegmentLoadJobDocument, options);
}
export type CreateMaterializedSegmentLoadJobMutationHookResult = ReturnType<
  typeof useCreateMaterializedSegmentLoadJobMutation
>;
export type CreateMaterializedSegmentLoadJobMutationResult =
  Apollo.MutationResult<CreateMaterializedSegmentLoadJobMutation>;
export type CreateMaterializedSegmentLoadJobMutationOptions =
  Apollo.BaseMutationOptions<
    CreateMaterializedSegmentLoadJobMutation,
    CreateMaterializedSegmentLoadJobMutationVariables
  >;
export const CreateScheduledMaterializedSegmentLoadJobDocument = gql`
  mutation CreateScheduledMaterializedSegmentLoadJob(
    $scheduledMaterializedSegmentLoadJob: MaterializerV1ScheduledMaterializedSegmentLoadJobInput!
    $scheduledMaterializedSegmentLoadJobId: String
    $parent: String!
  ) {
    createScheduledMaterializedSegmentLoadJob(
      scheduledMaterializedSegmentLoadJob: $scheduledMaterializedSegmentLoadJob
      scheduledMaterializedSegmentLoadJobId: $scheduledMaterializedSegmentLoadJobId
      parent: $parent
    ) {
      ...ScheduledMaterializedSegmentLoadJob
      ...DefaultError
    }
  }
  ${ScheduledMaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateScheduledMaterializedSegmentLoadJobMutationFn =
  Apollo.MutationFunction<
    CreateScheduledMaterializedSegmentLoadJobMutation,
    CreateScheduledMaterializedSegmentLoadJobMutationVariables
  >;

/**
 * __useCreateScheduledMaterializedSegmentLoadJobMutation__
 *
 * To run a mutation, you first call `useCreateScheduledMaterializedSegmentLoadJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledMaterializedSegmentLoadJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledMaterializedSegmentLoadJobMutation, { data, loading, error }] = useCreateScheduledMaterializedSegmentLoadJobMutation({
 *   variables: {
 *      scheduledMaterializedSegmentLoadJob: // value for 'scheduledMaterializedSegmentLoadJob'
 *      scheduledMaterializedSegmentLoadJobId: // value for 'scheduledMaterializedSegmentLoadJobId'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateScheduledMaterializedSegmentLoadJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScheduledMaterializedSegmentLoadJobMutation,
    CreateScheduledMaterializedSegmentLoadJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScheduledMaterializedSegmentLoadJobMutation,
    CreateScheduledMaterializedSegmentLoadJobMutationVariables
  >(CreateScheduledMaterializedSegmentLoadJobDocument, options);
}
export type CreateScheduledMaterializedSegmentLoadJobMutationHookResult =
  ReturnType<typeof useCreateScheduledMaterializedSegmentLoadJobMutation>;
export type CreateScheduledMaterializedSegmentLoadJobMutationResult =
  Apollo.MutationResult<CreateScheduledMaterializedSegmentLoadJobMutation>;
export type CreateScheduledMaterializedSegmentLoadJobMutationOptions =
  Apollo.BaseMutationOptions<
    CreateScheduledMaterializedSegmentLoadJobMutation,
    CreateScheduledMaterializedSegmentLoadJobMutationVariables
  >;
export const MaterializedSegmentDocument = gql`
  query MaterializedSegment($name: String!) {
    materializedSegment(name: $name) {
      ...MaterializedSegment
      ...DefaultError
    }
  }
  ${MaterializedSegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMaterializedSegmentQuery__
 *
 * To run a query within a React component, call `useMaterializedSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterializedSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterializedSegmentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMaterializedSegmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  > &
    (
      | { variables: MaterializedSegmentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  >(MaterializedSegmentDocument, options);
}
export function useMaterializedSegmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  >(MaterializedSegmentDocument, options);
}
// @ts-ignore
export function useMaterializedSegmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentQuery,
  MaterializedSegmentQueryVariables
>;
export function useMaterializedSegmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentQuery,
        MaterializedSegmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentQuery | undefined,
  MaterializedSegmentQueryVariables
>;
export function useMaterializedSegmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentQuery,
        MaterializedSegmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MaterializedSegmentQuery,
    MaterializedSegmentQueryVariables
  >(MaterializedSegmentDocument, options);
}
export type MaterializedSegmentQueryHookResult = ReturnType<
  typeof useMaterializedSegmentQuery
>;
export type MaterializedSegmentLazyQueryHookResult = ReturnType<
  typeof useMaterializedSegmentLazyQuery
>;
export type MaterializedSegmentSuspenseQueryHookResult = ReturnType<
  typeof useMaterializedSegmentSuspenseQuery
>;
export type MaterializedSegmentQueryResult = Apollo.QueryResult<
  MaterializedSegmentQuery,
  MaterializedSegmentQueryVariables
>;
export const MaterializedSegmentLoadJobsDocument = gql`
  query MaterializedSegmentLoadJobs(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    materializedSegmentLoadJobs(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MaterializerV1ListMaterializedSegmentLoadJobsResponse {
        __typename
        materializedSegmentLoadJobs {
          ...MaterializedSegmentLoadJob
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMaterializedSegmentLoadJobsQuery__
 *
 * To run a query within a React component, call `useMaterializedSegmentLoadJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterializedSegmentLoadJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterializedSegmentLoadJobsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMaterializedSegmentLoadJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  > &
    (
      | { variables: MaterializedSegmentLoadJobsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  >(MaterializedSegmentLoadJobsDocument, options);
}
export function useMaterializedSegmentLoadJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  >(MaterializedSegmentLoadJobsDocument, options);
}
// @ts-ignore
export function useMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentLoadJobsQuery,
  MaterializedSegmentLoadJobsQueryVariables
>;
export function useMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentLoadJobsQuery,
        MaterializedSegmentLoadJobsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentLoadJobsQuery | undefined,
  MaterializedSegmentLoadJobsQueryVariables
>;
export function useMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentLoadJobsQuery,
        MaterializedSegmentLoadJobsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MaterializedSegmentLoadJobsQuery,
    MaterializedSegmentLoadJobsQueryVariables
  >(MaterializedSegmentLoadJobsDocument, options);
}
export type MaterializedSegmentLoadJobsQueryHookResult = ReturnType<
  typeof useMaterializedSegmentLoadJobsQuery
>;
export type MaterializedSegmentLoadJobsLazyQueryHookResult = ReturnType<
  typeof useMaterializedSegmentLoadJobsLazyQuery
>;
export type MaterializedSegmentLoadJobsSuspenseQueryHookResult = ReturnType<
  typeof useMaterializedSegmentLoadJobsSuspenseQuery
>;
export type MaterializedSegmentLoadJobsQueryResult = Apollo.QueryResult<
  MaterializedSegmentLoadJobsQuery,
  MaterializedSegmentLoadJobsQueryVariables
>;
export const MaterializedSegmentsDocument = gql`
  query MaterializedSegments(
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    materializedSegments(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on FlagsAdminV1ListMaterializedSegmentsResponse {
        __typename
        materializedSegments {
          ...MaterializedSegmentWithSchedules
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MaterializedSegmentWithSchedulesFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMaterializedSegmentsQuery__
 *
 * To run a query within a React component, call `useMaterializedSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterializedSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterializedSegmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMaterializedSegmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >(MaterializedSegmentsDocument, options);
}
export function useMaterializedSegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >(MaterializedSegmentsDocument, options);
}
// @ts-ignore
export function useMaterializedSegmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentsQuery,
  MaterializedSegmentsQueryVariables
>;
export function useMaterializedSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentsQuery,
        MaterializedSegmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MaterializedSegmentsQuery | undefined,
  MaterializedSegmentsQueryVariables
>;
export function useMaterializedSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MaterializedSegmentsQuery,
        MaterializedSegmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MaterializedSegmentsQuery,
    MaterializedSegmentsQueryVariables
  >(MaterializedSegmentsDocument, options);
}
export type MaterializedSegmentsQueryHookResult = ReturnType<
  typeof useMaterializedSegmentsQuery
>;
export type MaterializedSegmentsLazyQueryHookResult = ReturnType<
  typeof useMaterializedSegmentsLazyQuery
>;
export type MaterializedSegmentsSuspenseQueryHookResult = ReturnType<
  typeof useMaterializedSegmentsSuspenseQuery
>;
export type MaterializedSegmentsQueryResult = Apollo.QueryResult<
  MaterializedSegmentsQuery,
  MaterializedSegmentsQueryVariables
>;
export const OnMaterializedSegmentLoadJobUpdatedDocument = gql`
  subscription OnMaterializedSegmentLoadJobUpdated {
    materializedSegmentLoadJobUpdated {
      loadJob {
        ...MaterializedSegmentLoadJob
      }
    }
  }
  ${MaterializedSegmentLoadJobFragmentDoc}
`;

/**
 * __useOnMaterializedSegmentLoadJobUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMaterializedSegmentLoadJobUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMaterializedSegmentLoadJobUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMaterializedSegmentLoadJobUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMaterializedSegmentLoadJobUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnMaterializedSegmentLoadJobUpdatedSubscription,
    OnMaterializedSegmentLoadJobUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMaterializedSegmentLoadJobUpdatedSubscription,
    OnMaterializedSegmentLoadJobUpdatedSubscriptionVariables
  >(OnMaterializedSegmentLoadJobUpdatedDocument, options);
}
export type OnMaterializedSegmentLoadJobUpdatedSubscriptionHookResult =
  ReturnType<typeof useOnMaterializedSegmentLoadJobUpdatedSubscription>;
export type OnMaterializedSegmentLoadJobUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMaterializedSegmentLoadJobUpdatedSubscription>;
export const ResumeScheduledMaterializedSegmentLoadJobDocument = gql`
  mutation ResumeScheduledMaterializedSegmentLoadJob($name: String!) {
    resumeScheduledMaterializedSegmentLoadJob(name: $name) {
      ...ScheduledMaterializedSegmentLoadJob
      ...DefaultError
    }
  }
  ${ScheduledMaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ResumeScheduledMaterializedSegmentLoadJobMutationFn =
  Apollo.MutationFunction<
    ResumeScheduledMaterializedSegmentLoadJobMutation,
    ResumeScheduledMaterializedSegmentLoadJobMutationVariables
  >;

/**
 * __useResumeScheduledMaterializedSegmentLoadJobMutation__
 *
 * To run a mutation, you first call `useResumeScheduledMaterializedSegmentLoadJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeScheduledMaterializedSegmentLoadJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeScheduledMaterializedSegmentLoadJobMutation, { data, loading, error }] = useResumeScheduledMaterializedSegmentLoadJobMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useResumeScheduledMaterializedSegmentLoadJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeScheduledMaterializedSegmentLoadJobMutation,
    ResumeScheduledMaterializedSegmentLoadJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResumeScheduledMaterializedSegmentLoadJobMutation,
    ResumeScheduledMaterializedSegmentLoadJobMutationVariables
  >(ResumeScheduledMaterializedSegmentLoadJobDocument, options);
}
export type ResumeScheduledMaterializedSegmentLoadJobMutationHookResult =
  ReturnType<typeof useResumeScheduledMaterializedSegmentLoadJobMutation>;
export type ResumeScheduledMaterializedSegmentLoadJobMutationResult =
  Apollo.MutationResult<ResumeScheduledMaterializedSegmentLoadJobMutation>;
export type ResumeScheduledMaterializedSegmentLoadJobMutationOptions =
  Apollo.BaseMutationOptions<
    ResumeScheduledMaterializedSegmentLoadJobMutation,
    ResumeScheduledMaterializedSegmentLoadJobMutationVariables
  >;
export const ScheduledMaterializedSegmentLoadJobsDocument = gql`
  query ScheduledMaterializedSegmentLoadJobs(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    scheduledMaterializedSegmentLoadJobs(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MaterializerV1ListScheduledMaterializedSegmentLoadJobsResponse {
        __typename
        scheduledMaterializedSegmentLoadJobs {
          ...ScheduledMaterializedSegmentLoadJob
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ScheduledMaterializedSegmentLoadJobFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useScheduledMaterializedSegmentLoadJobsQuery__
 *
 * To run a query within a React component, call `useScheduledMaterializedSegmentLoadJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledMaterializedSegmentLoadJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledMaterializedSegmentLoadJobsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useScheduledMaterializedSegmentLoadJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  > &
    (
      | {
          variables: ScheduledMaterializedSegmentLoadJobsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >(ScheduledMaterializedSegmentLoadJobsDocument, options);
}
export function useScheduledMaterializedSegmentLoadJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >(ScheduledMaterializedSegmentLoadJobsDocument, options);
}
// @ts-ignore
export function useScheduledMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMaterializedSegmentLoadJobsQuery,
  ScheduledMaterializedSegmentLoadJobsQueryVariables
>;
export function useScheduledMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMaterializedSegmentLoadJobsQuery,
        ScheduledMaterializedSegmentLoadJobsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMaterializedSegmentLoadJobsQuery | undefined,
  ScheduledMaterializedSegmentLoadJobsQueryVariables
>;
export function useScheduledMaterializedSegmentLoadJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMaterializedSegmentLoadJobsQuery,
        ScheduledMaterializedSegmentLoadJobsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >(ScheduledMaterializedSegmentLoadJobsDocument, options);
}
export type ScheduledMaterializedSegmentLoadJobsQueryHookResult = ReturnType<
  typeof useScheduledMaterializedSegmentLoadJobsQuery
>;
export type ScheduledMaterializedSegmentLoadJobsLazyQueryHookResult =
  ReturnType<typeof useScheduledMaterializedSegmentLoadJobsLazyQuery>;
export type ScheduledMaterializedSegmentLoadJobsSuspenseQueryHookResult =
  ReturnType<typeof useScheduledMaterializedSegmentLoadJobsSuspenseQuery>;
export type ScheduledMaterializedSegmentLoadJobsQueryResult =
  Apollo.QueryResult<
    ScheduledMaterializedSegmentLoadJobsQuery,
    ScheduledMaterializedSegmentLoadJobsQueryVariables
  >;
export const UpdateMaterializedSegmentDocument = gql`
  mutation UpdateMaterializedSegment(
    $input: PartialFlagsAdminV1MaterializedSegmentInput!
    $updateMask: String
  ) {
    updateMaterializedSegment(
      materializedSegment: $input
      updateMask: $updateMask
    ) {
      ... on FlagsAdminV1MaterializedSegment {
        ...MaterializedSegment
      }
      ...DefaultError
    }
  }
  ${MaterializedSegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateMaterializedSegmentMutationFn = Apollo.MutationFunction<
  UpdateMaterializedSegmentMutation,
  UpdateMaterializedSegmentMutationVariables
>;

/**
 * __useUpdateMaterializedSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateMaterializedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterializedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterializedSegmentMutation, { data, loading, error }] = useUpdateMaterializedSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateMaterializedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMaterializedSegmentMutation,
    UpdateMaterializedSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMaterializedSegmentMutation,
    UpdateMaterializedSegmentMutationVariables
  >(UpdateMaterializedSegmentDocument, options);
}
export type UpdateMaterializedSegmentMutationHookResult = ReturnType<
  typeof useUpdateMaterializedSegmentMutation
>;
export type UpdateMaterializedSegmentMutationResult =
  Apollo.MutationResult<UpdateMaterializedSegmentMutation>;
export type UpdateMaterializedSegmentMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateMaterializedSegmentMutation,
    UpdateMaterializedSegmentMutationVariables
  >;
export const AiWorkflowInstancesDocument = gql`
  query AiWorkflowInstances($filter: String) {
    aiWorkflowInstances(filter: $filter) {
      ... on AiworkflowsV1ListAiWorkflowInstancesResponse {
        __typename
        aiWorkflowInstances {
          ...AiWorkflowInstance
        }
      }
      ...DefaultError
    }
  }
  ${AiWorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAiWorkflowInstancesQuery__
 *
 * To run a query within a React component, call `useAiWorkflowInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiWorkflowInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiWorkflowInstancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiWorkflowInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >(AiWorkflowInstancesDocument, options);
}
export function useAiWorkflowInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >(AiWorkflowInstancesDocument, options);
}
// @ts-ignore
export function useAiWorkflowInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowInstancesQuery,
  AiWorkflowInstancesQueryVariables
>;
export function useAiWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowInstancesQuery,
        AiWorkflowInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowInstancesQuery | undefined,
  AiWorkflowInstancesQueryVariables
>;
export function useAiWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowInstancesQuery,
        AiWorkflowInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiWorkflowInstancesQuery,
    AiWorkflowInstancesQueryVariables
  >(AiWorkflowInstancesDocument, options);
}
export type AiWorkflowInstancesQueryHookResult = ReturnType<
  typeof useAiWorkflowInstancesQuery
>;
export type AiWorkflowInstancesLazyQueryHookResult = ReturnType<
  typeof useAiWorkflowInstancesLazyQuery
>;
export type AiWorkflowInstancesSuspenseQueryHookResult = ReturnType<
  typeof useAiWorkflowInstancesSuspenseQuery
>;
export type AiWorkflowInstancesQueryResult = Apollo.QueryResult<
  AiWorkflowInstancesQuery,
  AiWorkflowInstancesQueryVariables
>;
export const AiWorkflowSchedulesDocument = gql`
  query AiWorkflowSchedules($filter: String) {
    aiWorkflowSchedules(filter: $filter) {
      ... on AiworkflowsV1ListAiWorkflowSchedulesResponse {
        __typename
        aiWorkflowSchedules {
          ...AiWorkflowSchedule
        }
      }
      ...DefaultError
    }
  }
  ${AiWorkflowScheduleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAiWorkflowSchedulesQuery__
 *
 * To run a query within a React component, call `useAiWorkflowSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiWorkflowSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiWorkflowSchedulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiWorkflowSchedulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >(AiWorkflowSchedulesDocument, options);
}
export function useAiWorkflowSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >(AiWorkflowSchedulesDocument, options);
}
// @ts-ignore
export function useAiWorkflowSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowSchedulesQuery,
  AiWorkflowSchedulesQueryVariables
>;
export function useAiWorkflowSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowSchedulesQuery,
        AiWorkflowSchedulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowSchedulesQuery | undefined,
  AiWorkflowSchedulesQueryVariables
>;
export function useAiWorkflowSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowSchedulesQuery,
        AiWorkflowSchedulesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiWorkflowSchedulesQuery,
    AiWorkflowSchedulesQueryVariables
  >(AiWorkflowSchedulesDocument, options);
}
export type AiWorkflowSchedulesQueryHookResult = ReturnType<
  typeof useAiWorkflowSchedulesQuery
>;
export type AiWorkflowSchedulesLazyQueryHookResult = ReturnType<
  typeof useAiWorkflowSchedulesLazyQuery
>;
export type AiWorkflowSchedulesSuspenseQueryHookResult = ReturnType<
  typeof useAiWorkflowSchedulesSuspenseQuery
>;
export type AiWorkflowSchedulesQueryResult = Apollo.QueryResult<
  AiWorkflowSchedulesQuery,
  AiWorkflowSchedulesQueryVariables
>;
export const ArchiveFlagDocument = gql`
  mutation ArchiveFlag($name: String!) {
    archiveFlag(name: $name) {
      __typename
      ...Flag
      ...DefaultError
    }
  }
  ${FlagFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ArchiveFlagMutationFn = Apollo.MutationFunction<
  ArchiveFlagMutation,
  ArchiveFlagMutationVariables
>;

/**
 * __useArchiveFlagMutation__
 *
 * To run a mutation, you first call `useArchiveFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFlagMutation, { data, loading, error }] = useArchiveFlagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useArchiveFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveFlagMutation,
    ArchiveFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveFlagMutation, ArchiveFlagMutationVariables>(
    ArchiveFlagDocument,
    options,
  );
}
export type ArchiveFlagMutationHookResult = ReturnType<
  typeof useArchiveFlagMutation
>;
export type ArchiveFlagMutationResult =
  Apollo.MutationResult<ArchiveFlagMutation>;
export type ArchiveFlagMutationOptions = Apollo.BaseMutationOptions<
  ArchiveFlagMutation,
  ArchiveFlagMutationVariables
>;
export const CancelAiWorkflowScheduleDocument = gql`
  mutation CancelAiWorkflowSchedule($name: String!) {
    cancelAiWorkflowSchedule(name: $name) {
      ... on AiworkflowsV1AiWorkflowSchedule {
        ...AiWorkflowSchedule
      }
      ...DefaultError
    }
  }
  ${AiWorkflowScheduleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CancelAiWorkflowScheduleMutationFn = Apollo.MutationFunction<
  CancelAiWorkflowScheduleMutation,
  CancelAiWorkflowScheduleMutationVariables
>;

/**
 * __useCancelAiWorkflowScheduleMutation__
 *
 * To run a mutation, you first call `useCancelAiWorkflowScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAiWorkflowScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAiWorkflowScheduleMutation, { data, loading, error }] = useCancelAiWorkflowScheduleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCancelAiWorkflowScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAiWorkflowScheduleMutation,
    CancelAiWorkflowScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelAiWorkflowScheduleMutation,
    CancelAiWorkflowScheduleMutationVariables
  >(CancelAiWorkflowScheduleDocument, options);
}
export type CancelAiWorkflowScheduleMutationHookResult = ReturnType<
  typeof useCancelAiWorkflowScheduleMutation
>;
export type CancelAiWorkflowScheduleMutationResult =
  Apollo.MutationResult<CancelAiWorkflowScheduleMutation>;
export type CancelAiWorkflowScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    CancelAiWorkflowScheduleMutation,
    CancelAiWorkflowScheduleMutationVariables
  >;
export const CheckSdkCompatibilityDocument = gql`
  mutation CheckSdkCompatibility($featureIds: [String!]) {
    checkSdkCompatibility(featureIds: $featureIds) {
      ... on InsightsV1CheckSdkCompatibilityResponse {
        __typename
        featureCompatibilities {
          featureId
          displayName
          status
          incompatibleSdks {
            sdkDisplayName
            currentVersion
            requiredVersion
          }
        }
        activeSdks {
          sdkDisplayName
          sdkId
          version
          resolveMode
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CheckSdkCompatibilityMutationFn = Apollo.MutationFunction<
  CheckSdkCompatibilityMutation,
  CheckSdkCompatibilityMutationVariables
>;

/**
 * __useCheckSdkCompatibilityMutation__
 *
 * To run a mutation, you first call `useCheckSdkCompatibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSdkCompatibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSdkCompatibilityMutation, { data, loading, error }] = useCheckSdkCompatibilityMutation({
 *   variables: {
 *      featureIds: // value for 'featureIds'
 *   },
 * });
 */
export function useCheckSdkCompatibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckSdkCompatibilityMutation,
    CheckSdkCompatibilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckSdkCompatibilityMutation,
    CheckSdkCompatibilityMutationVariables
  >(CheckSdkCompatibilityDocument, options);
}
export type CheckSdkCompatibilityMutationHookResult = ReturnType<
  typeof useCheckSdkCompatibilityMutation
>;
export type CheckSdkCompatibilityMutationResult =
  Apollo.MutationResult<CheckSdkCompatibilityMutation>;
export type CheckSdkCompatibilityMutationOptions = Apollo.BaseMutationOptions<
  CheckSdkCompatibilityMutation,
  CheckSdkCompatibilityMutationVariables
>;
export const CreateAiWorkflowInstanceDocument = gql`
  mutation CreateAiWorkflowInstance(
    $input: AiworkflowsV1AiWorkflowInstanceInput!
  ) {
    createAiWorkflowInstance(aiWorkflowInstance: $input) {
      ... on AiworkflowsV1AiWorkflowInstance {
        ...AiWorkflowInstance
      }
      ...DefaultError
    }
  }
  ${AiWorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAiWorkflowInstanceMutationFn = Apollo.MutationFunction<
  CreateAiWorkflowInstanceMutation,
  CreateAiWorkflowInstanceMutationVariables
>;

/**
 * __useCreateAiWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useCreateAiWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiWorkflowInstanceMutation, { data, loading, error }] = useCreateAiWorkflowInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAiWorkflowInstanceMutation,
    CreateAiWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAiWorkflowInstanceMutation,
    CreateAiWorkflowInstanceMutationVariables
  >(CreateAiWorkflowInstanceDocument, options);
}
export type CreateAiWorkflowInstanceMutationHookResult = ReturnType<
  typeof useCreateAiWorkflowInstanceMutation
>;
export type CreateAiWorkflowInstanceMutationResult =
  Apollo.MutationResult<CreateAiWorkflowInstanceMutation>;
export type CreateAiWorkflowInstanceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAiWorkflowInstanceMutation,
    CreateAiWorkflowInstanceMutationVariables
  >;
export const CreateAiWorkflowScheduleDocument = gql`
  mutation CreateAiWorkflowSchedule(
    $input: AiworkflowsV1AiWorkflowScheduleInput!
  ) {
    createAiWorkflowSchedule(aiWorkflowSchedule: $input) {
      ... on AiworkflowsV1AiWorkflowSchedule {
        ...AiWorkflowSchedule
      }
      ...DefaultError
    }
  }
  ${AiWorkflowScheduleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAiWorkflowScheduleMutationFn = Apollo.MutationFunction<
  CreateAiWorkflowScheduleMutation,
  CreateAiWorkflowScheduleMutationVariables
>;

/**
 * __useCreateAiWorkflowScheduleMutation__
 *
 * To run a mutation, you first call `useCreateAiWorkflowScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiWorkflowScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiWorkflowScheduleMutation, { data, loading, error }] = useCreateAiWorkflowScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiWorkflowScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAiWorkflowScheduleMutation,
    CreateAiWorkflowScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAiWorkflowScheduleMutation,
    CreateAiWorkflowScheduleMutationVariables
  >(CreateAiWorkflowScheduleDocument, options);
}
export type CreateAiWorkflowScheduleMutationHookResult = ReturnType<
  typeof useCreateAiWorkflowScheduleMutation
>;
export type CreateAiWorkflowScheduleMutationResult =
  Apollo.MutationResult<CreateAiWorkflowScheduleMutation>;
export type CreateAiWorkflowScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAiWorkflowScheduleMutation,
    CreateAiWorkflowScheduleMutationVariables
  >;
export const CreateCleanupTasksDocument = gql`
  mutation CreateCleanupTasks(
    $name: String!
    $targets: [AiworkflowsV1CleanupTargetInput!]!
  ) {
    createCleanupTasks(name: $name, targets: $targets) {
      ... on AiworkflowsV1AiWorkflowInstance {
        ...AiWorkflowInstance
      }
      ...DefaultError
    }
  }
  ${AiWorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateCleanupTasksMutationFn = Apollo.MutationFunction<
  CreateCleanupTasksMutation,
  CreateCleanupTasksMutationVariables
>;

/**
 * __useCreateCleanupTasksMutation__
 *
 * To run a mutation, you first call `useCreateCleanupTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCleanupTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCleanupTasksMutation, { data, loading, error }] = useCreateCleanupTasksMutation({
 *   variables: {
 *      name: // value for 'name'
 *      targets: // value for 'targets'
 *   },
 * });
 */
export function useCreateCleanupTasksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCleanupTasksMutation,
    CreateCleanupTasksMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCleanupTasksMutation,
    CreateCleanupTasksMutationVariables
  >(CreateCleanupTasksDocument, options);
}
export type CreateCleanupTasksMutationHookResult = ReturnType<
  typeof useCreateCleanupTasksMutation
>;
export type CreateCleanupTasksMutationResult =
  Apollo.MutationResult<CreateCleanupTasksMutation>;
export type CreateCleanupTasksMutationOptions = Apollo.BaseMutationOptions<
  CreateCleanupTasksMutation,
  CreateCleanupTasksMutationVariables
>;
export const CreateFlagDocument = gql`
  mutation CreateFlag($flagId: String!, $flag: FlagsAdminV1FlagInput!) {
    createFlag(flag: $flag, flagId: $flagId) {
      __typename
      ...Flag
      ...DefaultError
    }
  }
  ${FlagFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateFlagMutationFn = Apollo.MutationFunction<
  CreateFlagMutation,
  CreateFlagMutationVariables
>;

/**
 * __useCreateFlagMutation__
 *
 * To run a mutation, you first call `useCreateFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlagMutation, { data, loading, error }] = useCreateFlagMutation({
 *   variables: {
 *      flagId: // value for 'flagId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useCreateFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFlagMutation,
    CreateFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFlagMutation, CreateFlagMutationVariables>(
    CreateFlagDocument,
    options,
  );
}
export type CreateFlagMutationHookResult = ReturnType<
  typeof useCreateFlagMutation
>;
export type CreateFlagMutationResult =
  Apollo.MutationResult<CreateFlagMutation>;
export type CreateFlagMutationOptions = Apollo.BaseMutationOptions<
  CreateFlagMutation,
  CreateFlagMutationVariables
>;
export const CreateMaterializedSegmentDocument = gql`
  mutation CreateMaterializedSegment(
    $materializationId: String
    $materializedSegment: FlagsAdminV1MaterializedSegmentInput!
  ) {
    createMaterializedSegment(
      materializedSegment: $materializedSegment
      materializedSegmentId: $materializationId
    ) {
      __typename
      ...MaterializedSegment
      ...DefaultError
    }
  }
  ${MaterializedSegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateMaterializedSegmentMutationFn = Apollo.MutationFunction<
  CreateMaterializedSegmentMutation,
  CreateMaterializedSegmentMutationVariables
>;

/**
 * __useCreateMaterializedSegmentMutation__
 *
 * To run a mutation, you first call `useCreateMaterializedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterializedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterializedSegmentMutation, { data, loading, error }] = useCreateMaterializedSegmentMutation({
 *   variables: {
 *      materializationId: // value for 'materializationId'
 *      materializedSegment: // value for 'materializedSegment'
 *   },
 * });
 */
export function useCreateMaterializedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMaterializedSegmentMutation,
    CreateMaterializedSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMaterializedSegmentMutation,
    CreateMaterializedSegmentMutationVariables
  >(CreateMaterializedSegmentDocument, options);
}
export type CreateMaterializedSegmentMutationHookResult = ReturnType<
  typeof useCreateMaterializedSegmentMutation
>;
export type CreateMaterializedSegmentMutationResult =
  Apollo.MutationResult<CreateMaterializedSegmentMutation>;
export type CreateMaterializedSegmentMutationOptions =
  Apollo.BaseMutationOptions<
    CreateMaterializedSegmentMutation,
    CreateMaterializedSegmentMutationVariables
  >;
export const CreateRuleDocument = gql`
  mutation CreateRule($parent: String!, $rule: FlagsAdminV1FlagRuleInput!) {
    createRule(parent: $parent, rule: $rule) {
      __typename
      ...Rule
      ...DefaultError
    }
  }
  ${RuleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateRuleMutationFn = Apollo.MutationFunction<
  CreateRuleMutation,
  CreateRuleMutationVariables
>;

/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleMutation, { data, loading, error }] = useCreateRuleMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      rule: // value for 'rule'
 *   },
 * });
 */
export function useCreateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRuleMutation,
    CreateRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRuleMutation, CreateRuleMutationVariables>(
    CreateRuleDocument,
    options,
  );
}
export type CreateRuleMutationHookResult = ReturnType<
  typeof useCreateRuleMutation
>;
export type CreateRuleMutationResult =
  Apollo.MutationResult<CreateRuleMutation>;
export type CreateRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateRuleMutation,
  CreateRuleMutationVariables
>;
export const DeleteRuleDocument = gql`
  mutation DeleteRule($name: String!) {
    deleteRule(name: $name) {
      __typename
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteRuleMutationFn = Apollo.MutationFunction<
  DeleteRuleMutation,
  DeleteRuleMutationVariables
>;

/**
 * __useDeleteRuleMutation__
 *
 * To run a mutation, you first call `useDeleteRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleMutation, { data, loading, error }] = useDeleteRuleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRuleMutation,
    DeleteRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRuleMutation, DeleteRuleMutationVariables>(
    DeleteRuleDocument,
    options,
  );
}
export type DeleteRuleMutationHookResult = ReturnType<
  typeof useDeleteRuleMutation
>;
export type DeleteRuleMutationResult =
  Apollo.MutationResult<DeleteRuleMutation>;
export type DeleteRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRuleMutation,
  DeleteRuleMutationVariables
>;
export const FlagDocument = gql`
  query Flag($name: String!) {
    flag(name: $name) {
      ...Flag
      ...DefaultError
    }
  }
  ${FlagFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagQuery__
 *
 * To run a query within a React component, call `useFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFlagQuery(
  baseOptions: Apollo.QueryHookOptions<FlagQuery, FlagQueryVariables> &
    ({ variables: FlagQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagQuery, FlagQueryVariables>(FlagDocument, options);
}
export function useFlagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FlagQuery, FlagQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagQuery, FlagQueryVariables>(
    FlagDocument,
    options,
  );
}
// @ts-ignore
export function useFlagSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FlagQuery, FlagQueryVariables>,
): Apollo.UseSuspenseQueryResult<FlagQuery, FlagQueryVariables>;
export function useFlagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FlagQuery, FlagQueryVariables>,
): Apollo.UseSuspenseQueryResult<FlagQuery | undefined, FlagQueryVariables>;
export function useFlagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FlagQuery, FlagQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FlagQuery, FlagQueryVariables>(
    FlagDocument,
    options,
  );
}
export type FlagQueryHookResult = ReturnType<typeof useFlagQuery>;
export type FlagLazyQueryHookResult = ReturnType<typeof useFlagLazyQuery>;
export type FlagSuspenseQueryHookResult = ReturnType<
  typeof useFlagSuspenseQuery
>;
export type FlagQueryResult = Apollo.QueryResult<FlagQuery, FlagQueryVariables>;
export const FlagsDocument = gql`
  query Flags(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    flags(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          ...FlagRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FlagRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagsQuery__
 *
 * To run a query within a React component, call `useFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<FlagsQuery, FlagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagsQuery, FlagsQueryVariables>(
    FlagsDocument,
    options,
  );
}
export function useFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FlagsQuery, FlagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagsQuery, FlagsQueryVariables>(
    FlagsDocument,
    options,
  );
}
// @ts-ignore
export function useFlagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagsQuery,
    FlagsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FlagsQuery, FlagsQueryVariables>;
export function useFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FlagsQuery, FlagsQueryVariables>,
): Apollo.UseSuspenseQueryResult<FlagsQuery | undefined, FlagsQueryVariables>;
export function useFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FlagsQuery, FlagsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FlagsQuery, FlagsQueryVariables>(
    FlagsDocument,
    options,
  );
}
export type FlagsQueryHookResult = ReturnType<typeof useFlagsQuery>;
export type FlagsLazyQueryHookResult = ReturnType<typeof useFlagsLazyQuery>;
export type FlagsSuspenseQueryHookResult = ReturnType<
  typeof useFlagsSuspenseQuery
>;
export type FlagsQueryResult = Apollo.QueryResult<
  FlagsQuery,
  FlagsQueryVariables
>;
export const OnFlagCreatedDocument = gql`
  subscription OnFlagCreated {
    flagCreated {
      flag {
        ...Flag
      }
    }
  }
  ${FlagFragmentDoc}
`;

/**
 * __useOnFlagCreatedSubscription__
 *
 * To run a query within a React component, call `useOnFlagCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFlagCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFlagCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnFlagCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnFlagCreatedSubscription,
    OnFlagCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFlagCreatedSubscription,
    OnFlagCreatedSubscriptionVariables
  >(OnFlagCreatedDocument, options);
}
export type OnFlagCreatedSubscriptionHookResult = ReturnType<
  typeof useOnFlagCreatedSubscription
>;
export type OnFlagCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnFlagCreatedSubscription>;
export const OnFlagUpdatedDocument = gql`
  subscription OnFlagUpdated {
    flagUpdated {
      flag {
        ...Flag
      }
    }
  }
  ${FlagFragmentDoc}
`;

/**
 * __useOnFlagUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnFlagUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFlagUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFlagUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnFlagUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnFlagUpdatedSubscription,
    OnFlagUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFlagUpdatedSubscription,
    OnFlagUpdatedSubscriptionVariables
  >(OnFlagUpdatedDocument, options);
}
export type OnFlagUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnFlagUpdatedSubscription
>;
export type OnFlagUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnFlagUpdatedSubscription>;
export const UnarchiveFlagDocument = gql`
  mutation UnarchiveFlag($name: String!) {
    unarchiveFlag(name: $name) {
      __typename
      ...Flag
      ...DefaultError
    }
  }
  ${FlagFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UnarchiveFlagMutationFn = Apollo.MutationFunction<
  UnarchiveFlagMutation,
  UnarchiveFlagMutationVariables
>;

/**
 * __useUnarchiveFlagMutation__
 *
 * To run a mutation, you first call `useUnarchiveFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveFlagMutation, { data, loading, error }] = useUnarchiveFlagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUnarchiveFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveFlagMutation,
    UnarchiveFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveFlagMutation,
    UnarchiveFlagMutationVariables
  >(UnarchiveFlagDocument, options);
}
export type UnarchiveFlagMutationHookResult = ReturnType<
  typeof useUnarchiveFlagMutation
>;
export type UnarchiveFlagMutationResult =
  Apollo.MutationResult<UnarchiveFlagMutation>;
export type UnarchiveFlagMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveFlagMutation,
  UnarchiveFlagMutationVariables
>;
export const UpdateFlagDocument = gql`
  mutation UpdateFlag(
    $input: PartialFlagsAdminV1FlagInput!
    $updateMask: String
  ) {
    updateFlag(flag: $input, updateMask: $updateMask) {
      __typename
      ...Flag
      ...DefaultError
    }
  }
  ${FlagFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateFlagMutationFn = Apollo.MutationFunction<
  UpdateFlagMutation,
  UpdateFlagMutationVariables
>;

/**
 * __useUpdateFlagMutation__
 *
 * To run a mutation, you first call `useUpdateFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlagMutation, { data, loading, error }] = useUpdateFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFlagMutation,
    UpdateFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFlagMutation, UpdateFlagMutationVariables>(
    UpdateFlagDocument,
    options,
  );
}
export type UpdateFlagMutationHookResult = ReturnType<
  typeof useUpdateFlagMutation
>;
export type UpdateFlagMutationResult =
  Apollo.MutationResult<UpdateFlagMutation>;
export type UpdateFlagMutationOptions = Apollo.BaseMutationOptions<
  UpdateFlagMutation,
  UpdateFlagMutationVariables
>;
export const UpdateRuleDocument = gql`
  mutation UpdateRule(
    $input: PartialFlagsAdminV1FlagRuleInput!
    $updateMask: String
  ) {
    updateRule(rule: $input, updateMask: $updateMask) {
      __typename
      ...Rule
      ...DefaultError
    }
  }
  ${RuleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateRuleMutationFn = Apollo.MutationFunction<
  UpdateRuleMutation,
  UpdateRuleMutationVariables
>;

/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleMutation, { data, loading, error }] = useUpdateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRuleMutation,
    UpdateRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRuleMutation, UpdateRuleMutationVariables>(
    UpdateRuleDocument,
    options,
  );
}
export type UpdateRuleMutationHookResult = ReturnType<
  typeof useUpdateRuleMutation
>;
export type UpdateRuleMutationResult =
  Apollo.MutationResult<UpdateRuleMutation>;
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRuleMutation,
  UpdateRuleMutationVariables
>;
export const VariantDocument = gql`
  query Variant($name: String!) {
    variant(name: $name) {
      ...Variant
      ...DefaultError
    }
  }
  ${VariantFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useVariantQuery__
 *
 * To run a query within a React component, call `useVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useVariantQuery(
  baseOptions: Apollo.QueryHookOptions<VariantQuery, VariantQueryVariables> &
    ({ variables: VariantQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VariantQuery, VariantQueryVariables>(
    VariantDocument,
    options,
  );
}
export function useVariantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VariantQuery,
    VariantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VariantQuery, VariantQueryVariables>(
    VariantDocument,
    options,
  );
}
// @ts-ignore
export function useVariantSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VariantQuery,
    VariantQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VariantQuery, VariantQueryVariables>;
export function useVariantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VariantQuery, VariantQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VariantQuery | undefined,
  VariantQueryVariables
>;
export function useVariantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VariantQuery, VariantQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VariantQuery, VariantQueryVariables>(
    VariantDocument,
    options,
  );
}
export type VariantQueryHookResult = ReturnType<typeof useVariantQuery>;
export type VariantLazyQueryHookResult = ReturnType<typeof useVariantLazyQuery>;
export type VariantSuspenseQueryHookResult = ReturnType<
  typeof useVariantSuspenseQuery
>;
export type VariantQueryResult = Apollo.QueryResult<
  VariantQuery,
  VariantQueryVariables
>;
export const FlagIndexPageDocument = gql`
  query FlagIndexPage(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    flags(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          ...FlagListItem
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FlagListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagIndexPageQuery__
 *
 * To run a query within a React component, call `useFlagIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagIndexPageQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFlagIndexPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FlagIndexPageQuery,
    FlagIndexPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagIndexPageQuery, FlagIndexPageQueryVariables>(
    FlagIndexPageDocument,
    options,
  );
}
export function useFlagIndexPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagIndexPageQuery,
    FlagIndexPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagIndexPageQuery, FlagIndexPageQueryVariables>(
    FlagIndexPageDocument,
    options,
  );
}
// @ts-ignore
export function useFlagIndexPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagIndexPageQuery,
    FlagIndexPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FlagIndexPageQuery,
  FlagIndexPageQueryVariables
>;
export function useFlagIndexPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagIndexPageQuery,
        FlagIndexPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagIndexPageQuery | undefined,
  FlagIndexPageQueryVariables
>;
export function useFlagIndexPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagIndexPageQuery,
        FlagIndexPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FlagIndexPageQuery,
    FlagIndexPageQueryVariables
  >(FlagIndexPageDocument, options);
}
export type FlagIndexPageQueryHookResult = ReturnType<
  typeof useFlagIndexPageQuery
>;
export type FlagIndexPageLazyQueryHookResult = ReturnType<
  typeof useFlagIndexPageLazyQuery
>;
export type FlagIndexPageSuspenseQueryHookResult = ReturnType<
  typeof useFlagIndexPageSuspenseQuery
>;
export type FlagIndexPageQueryResult = Apollo.QueryResult<
  FlagIndexPageQuery,
  FlagIndexPageQueryVariables
>;
export const ArchiveUserCreatedSegmentDocument = gql`
  mutation ArchiveUserCreatedSegment($name: String!) {
    archiveSegment(name: $name) {
      ... on FlagsAdminV1Segment {
        name
        state
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ArchiveUserCreatedSegmentMutationFn = Apollo.MutationFunction<
  ArchiveUserCreatedSegmentMutation,
  ArchiveUserCreatedSegmentMutationVariables
>;

/**
 * __useArchiveUserCreatedSegmentMutation__
 *
 * To run a mutation, you first call `useArchiveUserCreatedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserCreatedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserCreatedSegmentMutation, { data, loading, error }] = useArchiveUserCreatedSegmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useArchiveUserCreatedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveUserCreatedSegmentMutation,
    ArchiveUserCreatedSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveUserCreatedSegmentMutation,
    ArchiveUserCreatedSegmentMutationVariables
  >(ArchiveUserCreatedSegmentDocument, options);
}
export type ArchiveUserCreatedSegmentMutationHookResult = ReturnType<
  typeof useArchiveUserCreatedSegmentMutation
>;
export type ArchiveUserCreatedSegmentMutationResult =
  Apollo.MutationResult<ArchiveUserCreatedSegmentMutation>;
export type ArchiveUserCreatedSegmentMutationOptions =
  Apollo.BaseMutationOptions<
    ArchiveUserCreatedSegmentMutation,
    ArchiveUserCreatedSegmentMutationVariables
  >;
export const AvailableClientsDocument = gql`
  query availableClients {
    clients(pageSize: 100) {
      ...DefaultError
      ... on IamV1ListClientsResponse {
        __typename
        nextPageToken
        clients {
          ...ResolvedClient
        }
      }
    }
  }
  ${DefaultErrorFragmentDoc}
  ${ResolvedClientFragmentDoc}
`;

/**
 * __useAvailableClientsQuery__
 *
 * To run a query within a React component, call `useAvailableClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableClientsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableClientsQuery,
    AvailableClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AvailableClientsQuery, AvailableClientsQueryVariables>(
    AvailableClientsDocument,
    options,
  );
}
export function useAvailableClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableClientsQuery,
    AvailableClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableClientsQuery,
    AvailableClientsQueryVariables
  >(AvailableClientsDocument, options);
}
// @ts-ignore
export function useAvailableClientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableClientsQuery,
    AvailableClientsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AvailableClientsQuery,
  AvailableClientsQueryVariables
>;
export function useAvailableClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableClientsQuery,
        AvailableClientsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AvailableClientsQuery | undefined,
  AvailableClientsQueryVariables
>;
export function useAvailableClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableClientsQuery,
        AvailableClientsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AvailableClientsQuery,
    AvailableClientsQueryVariables
  >(AvailableClientsDocument, options);
}
export type AvailableClientsQueryHookResult = ReturnType<
  typeof useAvailableClientsQuery
>;
export type AvailableClientsLazyQueryHookResult = ReturnType<
  typeof useAvailableClientsLazyQuery
>;
export type AvailableClientsSuspenseQueryHookResult = ReturnType<
  typeof useAvailableClientsSuspenseQuery
>;
export type AvailableClientsQueryResult = Apollo.QueryResult<
  AvailableClientsQuery,
  AvailableClientsQueryVariables
>;
export const CreateVariantDocument = gql`
  mutation CreateVariant(
    $variant: FlagsAdminV1FlagVariantInput!
    $parent: String!
  ) {
    createVariant(variant: $variant, parent: $parent) {
      ...Variant
      ...DefaultError
    }
  }
  ${VariantFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateVariantMutationFn = Apollo.MutationFunction<
  CreateVariantMutation,
  CreateVariantMutationVariables
>;

/**
 * __useCreateVariantMutation__
 *
 * To run a mutation, you first call `useCreateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariantMutation, { data, loading, error }] = useCreateVariantMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVariantMutation,
    CreateVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateVariantMutation,
    CreateVariantMutationVariables
  >(CreateVariantDocument, options);
}
export type CreateVariantMutationHookResult = ReturnType<
  typeof useCreateVariantMutation
>;
export type CreateVariantMutationResult =
  Apollo.MutationResult<CreateVariantMutation>;
export type CreateVariantMutationOptions = Apollo.BaseMutationOptions<
  CreateVariantMutation,
  CreateVariantMutationVariables
>;
export const DeleteVariantDocument = gql`
  mutation DeleteVariant($name: String!) {
    deleteVariant(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteVariantMutationFn = Apollo.MutationFunction<
  DeleteVariantMutation,
  DeleteVariantMutationVariables
>;

/**
 * __useDeleteVariantMutation__
 *
 * To run a mutation, you first call `useDeleteVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVariantMutation, { data, loading, error }] = useDeleteVariantMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVariantMutation,
    DeleteVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteVariantMutation,
    DeleteVariantMutationVariables
  >(DeleteVariantDocument, options);
}
export type DeleteVariantMutationHookResult = ReturnType<
  typeof useDeleteVariantMutation
>;
export type DeleteVariantMutationResult =
  Apollo.MutationResult<DeleteVariantMutation>;
export type DeleteVariantMutationOptions = Apollo.BaseMutationOptions<
  DeleteVariantMutation,
  DeleteVariantMutationVariables
>;
export const DeriveClientEvaluationContextSchemaDocument = gql`
  mutation DeriveClientEvaluationContextSchema(
    $schema: [FlagsAdminV1EvaluationContextSchemaSchemaEntryInput!]!
    $clients: [String!]!
  ) {
    deriveClientEvaluationContextSchema(
      mustMatchSchema: { schema: $schema }
      clients: $clients
    ) {
      ... on FlagsAdminV1DeriveClientEvaluationContextSchemaResponse {
        __typename
        capped
        mergedSchema {
          schema {
            ...SchemaEntry
          }
        }
      }
      ...DefaultError
    }
  }
  ${SchemaEntryFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeriveClientEvaluationContextSchemaMutationFn =
  Apollo.MutationFunction<
    DeriveClientEvaluationContextSchemaMutation,
    DeriveClientEvaluationContextSchemaMutationVariables
  >;

/**
 * __useDeriveClientEvaluationContextSchemaMutation__
 *
 * To run a mutation, you first call `useDeriveClientEvaluationContextSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeriveClientEvaluationContextSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deriveClientEvaluationContextSchemaMutation, { data, loading, error }] = useDeriveClientEvaluationContextSchemaMutation({
 *   variables: {
 *      schema: // value for 'schema'
 *      clients: // value for 'clients'
 *   },
 * });
 */
export function useDeriveClientEvaluationContextSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeriveClientEvaluationContextSchemaMutation,
    DeriveClientEvaluationContextSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeriveClientEvaluationContextSchemaMutation,
    DeriveClientEvaluationContextSchemaMutationVariables
  >(DeriveClientEvaluationContextSchemaDocument, options);
}
export type DeriveClientEvaluationContextSchemaMutationHookResult = ReturnType<
  typeof useDeriveClientEvaluationContextSchemaMutation
>;
export type DeriveClientEvaluationContextSchemaMutationResult =
  Apollo.MutationResult<DeriveClientEvaluationContextSchemaMutation>;
export type DeriveClientEvaluationContextSchemaMutationOptions =
  Apollo.BaseMutationOptions<
    DeriveClientEvaluationContextSchemaMutation,
    DeriveClientEvaluationContextSchemaMutationVariables
  >;
export const FlagsFilterDocument = gql`
  query FlagsFilter($filter: String!, $pageToken: String) {
    flags(pageSize: 20, filter: $filter, pageToken: $pageToken) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        nextPageToken
        flags {
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagsFilterQuery__
 *
 * To run a query within a React component, call `useFlagsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagsFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFlagsFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlagsFilterQuery,
    FlagsFilterQueryVariables
  > &
    (
      | { variables: FlagsFilterQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagsFilterQuery, FlagsFilterQueryVariables>(
    FlagsFilterDocument,
    options,
  );
}
export function useFlagsFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagsFilterQuery,
    FlagsFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagsFilterQuery, FlagsFilterQueryVariables>(
    FlagsFilterDocument,
    options,
  );
}
// @ts-ignore
export function useFlagsFilterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagsFilterQuery,
    FlagsFilterQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FlagsFilterQuery, FlagsFilterQueryVariables>;
export function useFlagsFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsFilterQuery,
        FlagsFilterQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagsFilterQuery | undefined,
  FlagsFilterQueryVariables
>;
export function useFlagsFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsFilterQuery,
        FlagsFilterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FlagsFilterQuery, FlagsFilterQueryVariables>(
    FlagsFilterDocument,
    options,
  );
}
export type FlagsFilterQueryHookResult = ReturnType<typeof useFlagsFilterQuery>;
export type FlagsFilterLazyQueryHookResult = ReturnType<
  typeof useFlagsFilterLazyQuery
>;
export type FlagsFilterSuspenseQueryHookResult = ReturnType<
  typeof useFlagsFilterSuspenseQuery
>;
export type FlagsFilterQueryResult = Apollo.QueryResult<
  FlagsFilterQuery,
  FlagsFilterQueryVariables
>;
export const FlagsOptionsDocument = gql`
  query FlagsOptions($filter: String, $pageToken: String, $pageSize: Int) {
    flags(pageSize: $pageSize, filter: $filter, pageToken: $pageToken) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          ...FlagOption
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FlagOptionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagsOptionsQuery__
 *
 * To run a query within a React component, call `useFlagsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagsOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useFlagsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FlagsOptionsQuery,
    FlagsOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagsOptionsQuery, FlagsOptionsQueryVariables>(
    FlagsOptionsDocument,
    options,
  );
}
export function useFlagsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagsOptionsQuery,
    FlagsOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagsOptionsQuery, FlagsOptionsQueryVariables>(
    FlagsOptionsDocument,
    options,
  );
}
// @ts-ignore
export function useFlagsOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagsOptionsQuery,
    FlagsOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FlagsOptionsQuery, FlagsOptionsQueryVariables>;
export function useFlagsOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsOptionsQuery,
        FlagsOptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagsOptionsQuery | undefined,
  FlagsOptionsQueryVariables
>;
export function useFlagsOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsOptionsQuery,
        FlagsOptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FlagsOptionsQuery, FlagsOptionsQueryVariables>(
    FlagsOptionsDocument,
    options,
  );
}
export type FlagsOptionsQueryHookResult = ReturnType<
  typeof useFlagsOptionsQuery
>;
export type FlagsOptionsLazyQueryHookResult = ReturnType<
  typeof useFlagsOptionsLazyQuery
>;
export type FlagsOptionsSuspenseQueryHookResult = ReturnType<
  typeof useFlagsOptionsSuspenseQuery
>;
export type FlagsOptionsQueryResult = Apollo.QueryResult<
  FlagsOptionsQuery,
  FlagsOptionsQueryVariables
>;
export const GetMergedClientSchemaDocument = gql`
  mutation GetMergedClientSchema($clients: [String!]!) {
    deriveClientEvaluationContextSchema(clients: $clients) {
      ... on FlagsAdminV1DeriveClientEvaluationContextSchemaResponse {
        __typename
        capped
        mergedSchema {
          schema {
            ...SchemaEntry
          }
        }
      }
      ...DefaultError
    }
  }
  ${SchemaEntryFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type GetMergedClientSchemaMutationFn = Apollo.MutationFunction<
  GetMergedClientSchemaMutation,
  GetMergedClientSchemaMutationVariables
>;

/**
 * __useGetMergedClientSchemaMutation__
 *
 * To run a mutation, you first call `useGetMergedClientSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMergedClientSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMergedClientSchemaMutation, { data, loading, error }] = useGetMergedClientSchemaMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *   },
 * });
 */
export function useGetMergedClientSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetMergedClientSchemaMutation,
    GetMergedClientSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetMergedClientSchemaMutation,
    GetMergedClientSchemaMutationVariables
  >(GetMergedClientSchemaDocument, options);
}
export type GetMergedClientSchemaMutationHookResult = ReturnType<
  typeof useGetMergedClientSchemaMutation
>;
export type GetMergedClientSchemaMutationResult =
  Apollo.MutationResult<GetMergedClientSchemaMutation>;
export type GetMergedClientSchemaMutationOptions = Apollo.BaseMutationOptions<
  GetMergedClientSchemaMutation,
  GetMergedClientSchemaMutationVariables
>;
export const GetWorkflowInstanceDisplayNamesDocument = gql`
  query GetWorkflowInstanceDisplayNames($filter: String!, $pageToken: String) {
    workflowInstances(filter: $filter, pageToken: $pageToken) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        nextPageToken
        workflowInstances {
          name
          displayName
        }
      }
    }
  }
`;

/**
 * __useGetWorkflowInstanceDisplayNamesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceDisplayNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceDisplayNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceDisplayNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useGetWorkflowInstanceDisplayNamesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  > &
    (
      | {
          variables: GetWorkflowInstanceDisplayNamesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  >(GetWorkflowInstanceDisplayNamesDocument, options);
}
export function useGetWorkflowInstanceDisplayNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  >(GetWorkflowInstanceDisplayNamesDocument, options);
}
// @ts-ignore
export function useGetWorkflowInstanceDisplayNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceDisplayNamesQuery,
  GetWorkflowInstanceDisplayNamesQueryVariables
>;
export function useGetWorkflowInstanceDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceDisplayNamesQuery,
        GetWorkflowInstanceDisplayNamesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceDisplayNamesQuery | undefined,
  GetWorkflowInstanceDisplayNamesQueryVariables
>;
export function useGetWorkflowInstanceDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceDisplayNamesQuery,
        GetWorkflowInstanceDisplayNamesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInstanceDisplayNamesQuery,
    GetWorkflowInstanceDisplayNamesQueryVariables
  >(GetWorkflowInstanceDisplayNamesDocument, options);
}
export type GetWorkflowInstanceDisplayNamesQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceDisplayNamesQuery
>;
export type GetWorkflowInstanceDisplayNamesLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceDisplayNamesLazyQuery
>;
export type GetWorkflowInstanceDisplayNamesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceDisplayNamesSuspenseQuery
>;
export type GetWorkflowInstanceDisplayNamesQueryResult = Apollo.QueryResult<
  GetWorkflowInstanceDisplayNamesQuery,
  GetWorkflowInstanceDisplayNamesQueryVariables
>;
export const ListSnippetSecretsDocument = gql`
  query ListSnippetSecrets(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    clientCredentials(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on IamV1ListClientCredentialsResponse {
        __typename
        clientCredentials {
          ...SnippetSecret
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${SnippetSecretFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListSnippetSecretsQuery__
 *
 * To run a query within a React component, call `useListSnippetSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSnippetSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSnippetSecretsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useListSnippetSecretsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  > &
    (
      | { variables: ListSnippetSecretsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  >(ListSnippetSecretsDocument, options);
}
export function useListSnippetSecretsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  >(ListSnippetSecretsDocument, options);
}
// @ts-ignore
export function useListSnippetSecretsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListSnippetSecretsQuery,
  ListSnippetSecretsQueryVariables
>;
export function useListSnippetSecretsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSnippetSecretsQuery,
        ListSnippetSecretsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListSnippetSecretsQuery | undefined,
  ListSnippetSecretsQueryVariables
>;
export function useListSnippetSecretsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListSnippetSecretsQuery,
        ListSnippetSecretsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListSnippetSecretsQuery,
    ListSnippetSecretsQueryVariables
  >(ListSnippetSecretsDocument, options);
}
export type ListSnippetSecretsQueryHookResult = ReturnType<
  typeof useListSnippetSecretsQuery
>;
export type ListSnippetSecretsLazyQueryHookResult = ReturnType<
  typeof useListSnippetSecretsLazyQuery
>;
export type ListSnippetSecretsSuspenseQueryHookResult = ReturnType<
  typeof useListSnippetSecretsSuspenseQuery
>;
export type ListSnippetSecretsQueryResult = Apollo.QueryResult<
  ListSnippetSecretsQuery,
  ListSnippetSecretsQueryVariables
>;
export const ResolveFlagsVerboseDocument = gql`
  mutation ResolveFlagsVerbose(
    $clientSecret: String!
    $flags: [String!]
    $evaluationContext: JSON
  ) {
    resolveFlagsVerbose(
      clientSecret: $clientSecret
      flags: $flags
      evaluationContext: $evaluationContext
    ) {
      ... on FlagsResolverAdminV1ResolveFlagsVerboseResponse {
        __typename
        resolvedFlags {
          reason
          value
          flag {
            ... on FlagsAdminV1Flag {
              __typename
              name
            }
            ...DefaultError
          }
          ruleDetails {
            ...RuleDetails
          }
          variant {
            ... on FlagsAdminV1FlagVariant {
              name
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${RuleDetailsFragmentDoc}
`;
export type ResolveFlagsVerboseMutationFn = Apollo.MutationFunction<
  ResolveFlagsVerboseMutation,
  ResolveFlagsVerboseMutationVariables
>;

/**
 * __useResolveFlagsVerboseMutation__
 *
 * To run a mutation, you first call `useResolveFlagsVerboseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveFlagsVerboseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveFlagsVerboseMutation, { data, loading, error }] = useResolveFlagsVerboseMutation({
 *   variables: {
 *      clientSecret: // value for 'clientSecret'
 *      flags: // value for 'flags'
 *      evaluationContext: // value for 'evaluationContext'
 *   },
 * });
 */
export function useResolveFlagsVerboseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveFlagsVerboseMutation,
    ResolveFlagsVerboseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResolveFlagsVerboseMutation,
    ResolveFlagsVerboseMutationVariables
  >(ResolveFlagsVerboseDocument, options);
}
export type ResolveFlagsVerboseMutationHookResult = ReturnType<
  typeof useResolveFlagsVerboseMutation
>;
export type ResolveFlagsVerboseMutationResult =
  Apollo.MutationResult<ResolveFlagsVerboseMutation>;
export type ResolveFlagsVerboseMutationOptions = Apollo.BaseMutationOptions<
  ResolveFlagsVerboseMutation,
  ResolveFlagsVerboseMutationVariables
>;
export const RuleResolvedCounterDocument = gql`
  query RuleResolvedCounter($name: String!) {
    rule(name: $name) {
      ... on FlagsAdminV1FlagRule {
        __typename
        usageMetadata {
          __typename
          resolveCount
          lastResolveTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRuleResolvedCounterQuery__
 *
 * To run a query within a React component, call `useRuleResolvedCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleResolvedCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleResolvedCounterQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRuleResolvedCounterQuery(
  baseOptions: Apollo.QueryHookOptions<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  > &
    (
      | { variables: RuleResolvedCounterQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  >(RuleResolvedCounterDocument, options);
}
export function useRuleResolvedCounterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  >(RuleResolvedCounterDocument, options);
}
// @ts-ignore
export function useRuleResolvedCounterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RuleResolvedCounterQuery,
  RuleResolvedCounterQueryVariables
>;
export function useRuleResolvedCounterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RuleResolvedCounterQuery,
        RuleResolvedCounterQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RuleResolvedCounterQuery | undefined,
  RuleResolvedCounterQueryVariables
>;
export function useRuleResolvedCounterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RuleResolvedCounterQuery,
        RuleResolvedCounterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RuleResolvedCounterQuery,
    RuleResolvedCounterQueryVariables
  >(RuleResolvedCounterDocument, options);
}
export type RuleResolvedCounterQueryHookResult = ReturnType<
  typeof useRuleResolvedCounterQuery
>;
export type RuleResolvedCounterLazyQueryHookResult = ReturnType<
  typeof useRuleResolvedCounterLazyQuery
>;
export type RuleResolvedCounterSuspenseQueryHookResult = ReturnType<
  typeof useRuleResolvedCounterSuspenseQuery
>;
export type RuleResolvedCounterQueryResult = Apollo.QueryResult<
  RuleResolvedCounterQuery,
  RuleResolvedCounterQueryVariables
>;
export const SegmentReferencesDocument = gql`
  query SegmentReferences($name: String!) {
    querySegmentReferences(name: $name) {
      ... on FlagsAdminV1QuerySegmentReferencesResponse {
        __typename
        segmentReferences {
          segment {
            ... on FlagsAdminV1Segment {
              __typename
              name
              displayName
              state
            }
            ...DefaultError
          }
          flag {
            ... on FlagsAdminV1Flag {
              __typename
              name
              displayName
              state
              rules {
                name
                segment {
                  ... on FlagsAdminV1Segment {
                    __typename
                    name
                  }
                }
              }
            }
            ...DefaultError
          }
          workflowInstance {
            ... on WorkflowV1WorkflowInstance {
              __typename
              name
              displayName
              state
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSegmentReferencesQuery__
 *
 * To run a query within a React component, call `useSegmentReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentReferencesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSegmentReferencesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  > &
    (
      | { variables: SegmentReferencesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  >(SegmentReferencesDocument, options);
}
export function useSegmentReferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  >(SegmentReferencesDocument, options);
}
// @ts-ignore
export function useSegmentReferencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SegmentReferencesQuery,
  SegmentReferencesQueryVariables
>;
export function useSegmentReferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SegmentReferencesQuery,
        SegmentReferencesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SegmentReferencesQuery | undefined,
  SegmentReferencesQueryVariables
>;
export function useSegmentReferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SegmentReferencesQuery,
        SegmentReferencesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SegmentReferencesQuery,
    SegmentReferencesQueryVariables
  >(SegmentReferencesDocument, options);
}
export type SegmentReferencesQueryHookResult = ReturnType<
  typeof useSegmentReferencesQuery
>;
export type SegmentReferencesLazyQueryHookResult = ReturnType<
  typeof useSegmentReferencesLazyQuery
>;
export type SegmentReferencesSuspenseQueryHookResult = ReturnType<
  typeof useSegmentReferencesSuspenseQuery
>;
export type SegmentReferencesQueryResult = Apollo.QueryResult<
  SegmentReferencesQuery,
  SegmentReferencesQueryVariables
>;
export const UpdateVariantDocument = gql`
  mutation UpdateVariant($variant: PartialFlagsAdminV1FlagVariantInput!) {
    updateVariant(variant: $variant) {
      ...Variant
      ...DefaultError
    }
  }
  ${VariantFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateVariantMutationFn = Apollo.MutationFunction<
  UpdateVariantMutation,
  UpdateVariantMutationVariables
>;

/**
 * __useUpdateVariantMutation__
 *
 * To run a mutation, you first call `useUpdateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVariantMutation, { data, loading, error }] = useUpdateVariantMutation({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useUpdateVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVariantMutation,
    UpdateVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateVariantMutation,
    UpdateVariantMutationVariables
  >(UpdateVariantDocument, options);
}
export type UpdateVariantMutationHookResult = ReturnType<
  typeof useUpdateVariantMutation
>;
export type UpdateVariantMutationResult =
  Apollo.MutationResult<UpdateVariantMutation>;
export type UpdateVariantMutationOptions = Apollo.BaseMutationOptions<
  UpdateVariantMutation,
  UpdateVariantMutationVariables
>;
export const UsageChartDocument = gql`
  query UsageChart($name: String!, $startTime: String!, $endTime: String!) {
    queryFlagUsage(flag: $name, startTime: $startTime, endTime: $endTime) {
      ... on FlagsAdminV1QueryFlagUsageResponse {
        __typename
        usage {
          hourTime
          variants {
            key
            value {
              resolveCount
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUsageChartQuery__
 *
 * To run a query within a React component, call `useUsageChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageChartQuery({
 *   variables: {
 *      name: // value for 'name'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useUsageChartQuery(
  baseOptions: Apollo.QueryHookOptions<
    UsageChartQuery,
    UsageChartQueryVariables
  > &
    (
      | { variables: UsageChartQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsageChartQuery, UsageChartQueryVariables>(
    UsageChartDocument,
    options,
  );
}
export function useUsageChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsageChartQuery,
    UsageChartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsageChartQuery, UsageChartQueryVariables>(
    UsageChartDocument,
    options,
  );
}
// @ts-ignore
export function useUsageChartSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UsageChartQuery,
    UsageChartQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UsageChartQuery, UsageChartQueryVariables>;
export function useUsageChartSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UsageChartQuery,
        UsageChartQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UsageChartQuery | undefined,
  UsageChartQueryVariables
>;
export function useUsageChartSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UsageChartQuery,
        UsageChartQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsageChartQuery, UsageChartQueryVariables>(
    UsageChartDocument,
    options,
  );
}
export type UsageChartQueryHookResult = ReturnType<typeof useUsageChartQuery>;
export type UsageChartLazyQueryHookResult = ReturnType<
  typeof useUsageChartLazyQuery
>;
export type UsageChartSuspenseQueryHookResult = ReturnType<
  typeof useUsageChartSuspenseQuery
>;
export type UsageChartQueryResult = Apollo.QueryResult<
  UsageChartQuery,
  UsageChartQueryVariables
>;
export const AccountBillingDocument = gql`
  query AccountBilling {
    accountBilling {
      ... on BillingV1AccountBilling {
        name
        managementMode
        billingInfo {
          subscription {
            status
            trialEndTime
            cancelAtPeriodEnd
            currentPeriodEndTime
          }
          credits {
            granted
            consumed
          }
        }
        billingHistory {
          trialedBillingProducts {
            __typename
            ... on BillingV1BillingProduct {
              name
            }
          }
        }
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAccountBillingQuery__
 *
 * To run a query within a React component, call `useAccountBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBillingQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountBillingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountBillingQuery,
    AccountBillingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountBillingQuery, AccountBillingQueryVariables>(
    AccountBillingDocument,
    options,
  );
}
export function useAccountBillingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountBillingQuery,
    AccountBillingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountBillingQuery, AccountBillingQueryVariables>(
    AccountBillingDocument,
    options,
  );
}
// @ts-ignore
export function useAccountBillingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountBillingQuery,
    AccountBillingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountBillingQuery,
  AccountBillingQueryVariables
>;
export function useAccountBillingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBillingQuery,
        AccountBillingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountBillingQuery | undefined,
  AccountBillingQueryVariables
>;
export function useAccountBillingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBillingQuery,
        AccountBillingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AccountBillingQuery,
    AccountBillingQueryVariables
  >(AccountBillingDocument, options);
}
export type AccountBillingQueryHookResult = ReturnType<
  typeof useAccountBillingQuery
>;
export type AccountBillingLazyQueryHookResult = ReturnType<
  typeof useAccountBillingLazyQuery
>;
export type AccountBillingSuspenseQueryHookResult = ReturnType<
  typeof useAccountBillingSuspenseQuery
>;
export type AccountBillingQueryResult = Apollo.QueryResult<
  AccountBillingQuery,
  AccountBillingQueryVariables
>;
export const AccountSetupDocument = gql`
  query AccountSetup {
    currentAccount {
      ... on AdminV1AccountInfo {
        __typename
        mode
        billingManagementMode
        createTime
        blocked
        serviceTier {
          tier
          entitlements {
            key
            value {
              booleanValue
              integerValue
              unlimited {
                __typename
              }
            }
            __typename
          }
          __typename
        }
      }
      ...DefaultError
    }
    currentUser {
      ...DefaultError
      ... on IamV1CurrentUser {
        __typename
        identity {
          ...Identity
        }
        user {
          ...User
        }
        account
        accountMemberships {
          account
          displayName
          externalId
          loginId
          __typename
        }
      }
      __typename
    }
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
        demoData
        hasManagedWarehouse
        hasCustomerWarehouse
      }
      ...DefaultError
    }
    dataWarehouses(pageSize: 100) {
      ... on MetricsV1ListDataWarehousesResponse {
        __typename
        dataWarehouses {
          name
          __typename
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
  ${IdentityFragmentDoc}
  ${UserFragmentDoc}
`;

/**
 * __useAccountSetupQuery__
 *
 * To run a query within a React component, call `useAccountSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSetupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountSetupQuery,
    AccountSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountSetupQuery, AccountSetupQueryVariables>(
    AccountSetupDocument,
    options,
  );
}
export function useAccountSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountSetupQuery,
    AccountSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountSetupQuery, AccountSetupQueryVariables>(
    AccountSetupDocument,
    options,
  );
}
// @ts-ignore
export function useAccountSetupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountSetupQuery,
    AccountSetupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AccountSetupQuery, AccountSetupQueryVariables>;
export function useAccountSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountSetupQuery,
        AccountSetupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountSetupQuery | undefined,
  AccountSetupQueryVariables
>;
export function useAccountSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountSetupQuery,
        AccountSetupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccountSetupQuery, AccountSetupQueryVariables>(
    AccountSetupDocument,
    options,
  );
}
export type AccountSetupQueryHookResult = ReturnType<
  typeof useAccountSetupQuery
>;
export type AccountSetupLazyQueryHookResult = ReturnType<
  typeof useAccountSetupLazyQuery
>;
export type AccountSetupSuspenseQueryHookResult = ReturnType<
  typeof useAccountSetupSuspenseQuery
>;
export type AccountSetupQueryResult = Apollo.QueryResult<
  AccountSetupQuery,
  AccountSetupQueryVariables
>;
export const BillingProductsDocument = gql`
  query BillingProducts($pageSize: Int, $pageToken: String) {
    billingProducts(pageSize: $pageSize, pageToken: $pageToken) {
      __typename
      ... on BillingV1ListBillingProductsResponse {
        billingProducts {
          ...BillingProduct
        }
        nextPageToken
      }
      ... on Error {
        code
        message
      }
    }
  }
  ${BillingProductFragmentDoc}
`;

/**
 * __useBillingProductsQuery__
 *
 * To run a query within a React component, call `useBillingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingProductsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useBillingProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BillingProductsQuery,
    BillingProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BillingProductsQuery, BillingProductsQueryVariables>(
    BillingProductsDocument,
    options,
  );
}
export function useBillingProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BillingProductsQuery,
    BillingProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BillingProductsQuery,
    BillingProductsQueryVariables
  >(BillingProductsDocument, options);
}
// @ts-ignore
export function useBillingProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BillingProductsQuery,
    BillingProductsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BillingProductsQuery,
  BillingProductsQueryVariables
>;
export function useBillingProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BillingProductsQuery,
        BillingProductsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BillingProductsQuery | undefined,
  BillingProductsQueryVariables
>;
export function useBillingProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BillingProductsQuery,
        BillingProductsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BillingProductsQuery,
    BillingProductsQueryVariables
  >(BillingProductsDocument, options);
}
export type BillingProductsQueryHookResult = ReturnType<
  typeof useBillingProductsQuery
>;
export type BillingProductsLazyQueryHookResult = ReturnType<
  typeof useBillingProductsLazyQuery
>;
export type BillingProductsSuspenseQueryHookResult = ReturnType<
  typeof useBillingProductsSuspenseQuery
>;
export type BillingProductsQueryResult = Apollo.QueryResult<
  BillingProductsQuery,
  BillingProductsQueryVariables
>;
export const CreditUsageDocument = gql`
  query CreditUsage(
    $pageSize: Int
    $pageToken: String
    $startTime: String
    $endTime: String
    $usageFeature: UsageV1EventsUsageFeature
  ) {
    queryCreditUsage(
      pageSize: $pageSize
      pageToken: $pageToken
      startTime: $startTime
      endTime: $endTime
      usageFeature: $usageFeature
    ) {
      ... on BillingV1CreditUsageReport {
        startTime
        endTime
        lines {
          attributionResource
          usageFeature
          usageDelta
          credits
        }
        totalCredits
        nextPageToken
        totalSize
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCreditUsageQuery__
 *
 * To run a query within a React component, call `useCreditUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditUsageQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      usageFeature: // value for 'usageFeature'
 *   },
 * });
 */
export function useCreditUsageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CreditUsageQuery,
    CreditUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreditUsageQuery, CreditUsageQueryVariables>(
    CreditUsageDocument,
    options,
  );
}
export function useCreditUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditUsageQuery,
    CreditUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreditUsageQuery, CreditUsageQueryVariables>(
    CreditUsageDocument,
    options,
  );
}
// @ts-ignore
export function useCreditUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CreditUsageQuery,
    CreditUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CreditUsageQuery, CreditUsageQueryVariables>;
export function useCreditUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageQuery,
        CreditUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CreditUsageQuery | undefined,
  CreditUsageQueryVariables
>;
export function useCreditUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageQuery,
        CreditUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CreditUsageQuery, CreditUsageQueryVariables>(
    CreditUsageDocument,
    options,
  );
}
export type CreditUsageQueryHookResult = ReturnType<typeof useCreditUsageQuery>;
export type CreditUsageLazyQueryHookResult = ReturnType<
  typeof useCreditUsageLazyQuery
>;
export type CreditUsageSuspenseQueryHookResult = ReturnType<
  typeof useCreditUsageSuspenseQuery
>;
export type CreditUsageQueryResult = Apollo.QueryResult<
  CreditUsageQuery,
  CreditUsageQueryVariables
>;
export const CreditUsageChatsDocument = gql`
  query CreditUsageChats($filter: String!, $pageToken: String, $pageSize: Int) {
    chats(filter: $filter, pageToken: $pageToken, pageSize: $pageSize) {
      ... on ConversationsV2ListChatsResponse {
        nextPageToken
        chats {
          name
          displayName
        }
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCreditUsageChatsQuery__
 *
 * To run a query within a React component, call `useCreditUsageChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditUsageChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditUsageChatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCreditUsageChatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreditUsageChatsQuery,
    CreditUsageChatsQueryVariables
  > &
    (
      | { variables: CreditUsageChatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreditUsageChatsQuery, CreditUsageChatsQueryVariables>(
    CreditUsageChatsDocument,
    options,
  );
}
export function useCreditUsageChatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditUsageChatsQuery,
    CreditUsageChatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreditUsageChatsQuery,
    CreditUsageChatsQueryVariables
  >(CreditUsageChatsDocument, options);
}
// @ts-ignore
export function useCreditUsageChatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CreditUsageChatsQuery,
    CreditUsageChatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CreditUsageChatsQuery,
  CreditUsageChatsQueryVariables
>;
export function useCreditUsageChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageChatsQuery,
        CreditUsageChatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CreditUsageChatsQuery | undefined,
  CreditUsageChatsQueryVariables
>;
export function useCreditUsageChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageChatsQuery,
        CreditUsageChatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreditUsageChatsQuery,
    CreditUsageChatsQueryVariables
  >(CreditUsageChatsDocument, options);
}
export type CreditUsageChatsQueryHookResult = ReturnType<
  typeof useCreditUsageChatsQuery
>;
export type CreditUsageChatsLazyQueryHookResult = ReturnType<
  typeof useCreditUsageChatsLazyQuery
>;
export type CreditUsageChatsSuspenseQueryHookResult = ReturnType<
  typeof useCreditUsageChatsSuspenseQuery
>;
export type CreditUsageChatsQueryResult = Apollo.QueryResult<
  CreditUsageChatsQuery,
  CreditUsageChatsQueryVariables
>;
export const CreditUsageInstancesDocument = gql`
  query CreditUsageInstances(
    $filter: String!
    $pageToken: String
    $pageSize: Int
  ) {
    workflowInstances(
      filter: $filter
      pageToken: $pageToken
      pageSize: $pageSize
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        nextPageToken
        workflowInstances {
          name
          displayName
          state
        }
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCreditUsageInstancesQuery__
 *
 * To run a query within a React component, call `useCreditUsageInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditUsageInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditUsageInstancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCreditUsageInstancesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  > &
    (
      | { variables: CreditUsageInstancesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  >(CreditUsageInstancesDocument, options);
}
export function useCreditUsageInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  >(CreditUsageInstancesDocument, options);
}
// @ts-ignore
export function useCreditUsageInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CreditUsageInstancesQuery,
  CreditUsageInstancesQueryVariables
>;
export function useCreditUsageInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageInstancesQuery,
        CreditUsageInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CreditUsageInstancesQuery | undefined,
  CreditUsageInstancesQueryVariables
>;
export function useCreditUsageInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditUsageInstancesQuery,
        CreditUsageInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreditUsageInstancesQuery,
    CreditUsageInstancesQueryVariables
  >(CreditUsageInstancesDocument, options);
}
export type CreditUsageInstancesQueryHookResult = ReturnType<
  typeof useCreditUsageInstancesQuery
>;
export type CreditUsageInstancesLazyQueryHookResult = ReturnType<
  typeof useCreditUsageInstancesLazyQuery
>;
export type CreditUsageInstancesSuspenseQueryHookResult = ReturnType<
  typeof useCreditUsageInstancesSuspenseQuery
>;
export type CreditUsageInstancesQueryResult = Apollo.QueryResult<
  CreditUsageInstancesQuery,
  CreditUsageInstancesQueryVariables
>;
export const StartCheckoutSessionDocument = gql`
  mutation StartCheckoutSession(
    $products: [String!]
    $returnUri: String
    $successUri: String
  ) {
    startCheckoutSession(
      products: $products
      returnUri: $returnUri
      successUri: $successUri
    ) {
      ... on BillingV1CheckoutSession {
        __typename
        checkoutUri
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type StartCheckoutSessionMutationFn = Apollo.MutationFunction<
  StartCheckoutSessionMutation,
  StartCheckoutSessionMutationVariables
>;

/**
 * __useStartCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useStartCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCheckoutSessionMutation, { data, loading, error }] = useStartCheckoutSessionMutation({
 *   variables: {
 *      products: // value for 'products'
 *      returnUri: // value for 'returnUri'
 *      successUri: // value for 'successUri'
 *   },
 * });
 */
export function useStartCheckoutSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartCheckoutSessionMutation,
    StartCheckoutSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartCheckoutSessionMutation,
    StartCheckoutSessionMutationVariables
  >(StartCheckoutSessionDocument, options);
}
export type StartCheckoutSessionMutationHookResult = ReturnType<
  typeof useStartCheckoutSessionMutation
>;
export type StartCheckoutSessionMutationResult =
  Apollo.MutationResult<StartCheckoutSessionMutation>;
export type StartCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<
  StartCheckoutSessionMutation,
  StartCheckoutSessionMutationVariables
>;
export const StartCustomerPortalSessionDocument = gql`
  mutation StartCustomerPortalSession {
    startCustomerPortalSession {
      ... on BillingV1CustomerPortalSession {
        customerPortalUri
      }
      ...DefaultError
      __typename
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type StartCustomerPortalSessionMutationFn = Apollo.MutationFunction<
  StartCustomerPortalSessionMutation,
  StartCustomerPortalSessionMutationVariables
>;

/**
 * __useStartCustomerPortalSessionMutation__
 *
 * To run a mutation, you first call `useStartCustomerPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCustomerPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCustomerPortalSessionMutation, { data, loading, error }] = useStartCustomerPortalSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartCustomerPortalSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartCustomerPortalSessionMutation,
    StartCustomerPortalSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartCustomerPortalSessionMutation,
    StartCustomerPortalSessionMutationVariables
  >(StartCustomerPortalSessionDocument, options);
}
export type StartCustomerPortalSessionMutationHookResult = ReturnType<
  typeof useStartCustomerPortalSessionMutation
>;
export type StartCustomerPortalSessionMutationResult =
  Apollo.MutationResult<StartCustomerPortalSessionMutation>;
export type StartCustomerPortalSessionMutationOptions =
  Apollo.BaseMutationOptions<
    StartCustomerPortalSessionMutation,
    StartCustomerPortalSessionMutationVariables
  >;
export const TodoDocument = gql`
  query Todo(
    $troubledFilter: String
    $overdueFilter: String
    $endingFilter: String
    $runningFilter: String
    $delayedFilter: String
    $readyFilter: String
    $reviewRequestedFilter: String
    $pageSize: Int
  ) {
    troubled: workflowInstances(filter: $troubledFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    overdue: workflowInstances(filter: $overdueFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    ending: workflowInstances(filter: $endingFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    running: workflowInstances(filter: $runningFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    delayed: workflowInstances(filter: $delayedFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    ready: workflowInstances(filter: $readyFilter, pageSize: $pageSize) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
        }
      }
      ...DefaultError
    }
    reviewRequested: workflowInstances(
      filter: $reviewRequestedFilter
      pageSize: $pageSize
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AppWorkflowInstance
          moduleData2 {
            reviews {
              ...WorkflowReviews
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${AppWorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${WorkflowReviewsFragmentDoc}
`;

/**
 * __useTodoQuery__
 *
 * To run a query within a React component, call `useTodoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodoQuery({
 *   variables: {
 *      troubledFilter: // value for 'troubledFilter'
 *      overdueFilter: // value for 'overdueFilter'
 *      endingFilter: // value for 'endingFilter'
 *      runningFilter: // value for 'runningFilter'
 *      delayedFilter: // value for 'delayedFilter'
 *      readyFilter: // value for 'readyFilter'
 *      reviewRequestedFilter: // value for 'reviewRequestedFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useTodoQuery(
  baseOptions?: Apollo.QueryHookOptions<TodoQuery, TodoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TodoQuery, TodoQueryVariables>(TodoDocument, options);
}
export function useTodoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TodoQuery, TodoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TodoQuery, TodoQueryVariables>(
    TodoDocument,
    options,
  );
}
// @ts-ignore
export function useTodoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TodoQuery, TodoQueryVariables>,
): Apollo.UseSuspenseQueryResult<TodoQuery, TodoQueryVariables>;
export function useTodoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TodoQuery, TodoQueryVariables>,
): Apollo.UseSuspenseQueryResult<TodoQuery | undefined, TodoQueryVariables>;
export function useTodoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TodoQuery, TodoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TodoQuery, TodoQueryVariables>(
    TodoDocument,
    options,
  );
}
export type TodoQueryHookResult = ReturnType<typeof useTodoQuery>;
export type TodoLazyQueryHookResult = ReturnType<typeof useTodoLazyQuery>;
export type TodoSuspenseQueryHookResult = ReturnType<
  typeof useTodoSuspenseQuery
>;
export type TodoQueryResult = Apollo.QueryResult<TodoQuery, TodoQueryVariables>;
export const AgentDocument = gql`
  query Agent($name: String!) {
    agent(name: $name) {
      ...Agent
      ...DefaultError
    }
  }
  ${AgentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAgentQuery__
 *
 * To run a query within a React component, call `useAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAgentQuery(
  baseOptions: Apollo.QueryHookOptions<AgentQuery, AgentQueryVariables> &
    ({ variables: AgentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AgentQuery, AgentQueryVariables>(
    AgentDocument,
    options,
  );
}
export function useAgentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AgentQuery, AgentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AgentQuery, AgentQueryVariables>(
    AgentDocument,
    options,
  );
}
// @ts-ignore
export function useAgentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AgentQuery,
    AgentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AgentQuery, AgentQueryVariables>;
export function useAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentQuery, AgentQueryVariables>,
): Apollo.UseSuspenseQueryResult<AgentQuery | undefined, AgentQueryVariables>;
export function useAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentQuery, AgentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AgentQuery, AgentQueryVariables>(
    AgentDocument,
    options,
  );
}
export type AgentQueryHookResult = ReturnType<typeof useAgentQuery>;
export type AgentLazyQueryHookResult = ReturnType<typeof useAgentLazyQuery>;
export type AgentSuspenseQueryHookResult = ReturnType<
  typeof useAgentSuspenseQuery
>;
export type AgentQueryResult = Apollo.QueryResult<
  AgentQuery,
  AgentQueryVariables
>;
export const AgentsDocument = gql`
  query Agents($pageToken: String, $pageSize: Int, $filter: String) {
    agents(pageToken: $pageToken, pageSize: $pageSize, filter: $filter) {
      ... on IamV1ListAgentsResponse {
        __typename
        agents {
          ...Agent
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${AgentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAgentsQuery__
 *
 * To run a query within a React component, call `useAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAgentsQuery(
  baseOptions?: Apollo.QueryHookOptions<AgentsQuery, AgentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AgentsQuery, AgentsQueryVariables>(
    AgentsDocument,
    options,
  );
}
export function useAgentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AgentsQuery, AgentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AgentsQuery, AgentsQueryVariables>(
    AgentsDocument,
    options,
  );
}
// @ts-ignore
export function useAgentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AgentsQuery,
    AgentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AgentsQuery, AgentsQueryVariables>;
export function useAgentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AgentsQuery | undefined, AgentsQueryVariables>;
export function useAgentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AgentsQuery, AgentsQueryVariables>(
    AgentsDocument,
    options,
  );
}
export type AgentsQueryHookResult = ReturnType<typeof useAgentsQuery>;
export type AgentsLazyQueryHookResult = ReturnType<typeof useAgentsLazyQuery>;
export type AgentsSuspenseQueryHookResult = ReturnType<
  typeof useAgentsSuspenseQuery
>;
export type AgentsQueryResult = Apollo.QueryResult<
  AgentsQuery,
  AgentsQueryVariables
>;
export const ApiClientsDocument = gql`
  query ApiClients(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    apiClients(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on IamV1ListApiClientsResponse {
        __typename
        apiClients {
          ...ApiClientRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ApiClientRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useApiClientsQuery__
 *
 * To run a query within a React component, call `useApiClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiClientsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useApiClientsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ApiClientsQuery,
    ApiClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApiClientsQuery, ApiClientsQueryVariables>(
    ApiClientsDocument,
    options,
  );
}
export function useApiClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApiClientsQuery,
    ApiClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApiClientsQuery, ApiClientsQueryVariables>(
    ApiClientsDocument,
    options,
  );
}
// @ts-ignore
export function useApiClientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApiClientsQuery,
    ApiClientsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ApiClientsQuery, ApiClientsQueryVariables>;
export function useApiClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientsQuery,
        ApiClientsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApiClientsQuery | undefined,
  ApiClientsQueryVariables
>;
export function useApiClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApiClientsQuery,
        ApiClientsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ApiClientsQuery, ApiClientsQueryVariables>(
    ApiClientsDocument,
    options,
  );
}
export type ApiClientsQueryHookResult = ReturnType<typeof useApiClientsQuery>;
export type ApiClientsLazyQueryHookResult = ReturnType<
  typeof useApiClientsLazyQuery
>;
export type ApiClientsSuspenseQueryHookResult = ReturnType<
  typeof useApiClientsSuspenseQuery
>;
export type ApiClientsQueryResult = Apollo.QueryResult<
  ApiClientsQuery,
  ApiClientsQueryVariables
>;
export const ClientDocument = gql`
  query Client($name: String!) {
    client(name: $name) {
      ...Client
      ...DefaultError
    }
  }
  ${ClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientQuery(
  baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables> &
    ({ variables: ClientQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientQuery, ClientQueryVariables>(
    ClientDocument,
    options,
  );
}
export function useClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(
    ClientDocument,
    options,
  );
}
// @ts-ignore
export function useClientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClientQuery,
    ClientQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ClientQuery, ClientQueryVariables>;
export function useClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ClientQuery, ClientQueryVariables>,
): Apollo.UseSuspenseQueryResult<ClientQuery | undefined, ClientQueryVariables>;
export function useClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ClientQuery, ClientQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ClientQuery, ClientQueryVariables>(
    ClientDocument,
    options,
  );
}
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientSuspenseQueryHookResult = ReturnType<
  typeof useClientSuspenseQuery
>;
export type ClientQueryResult = Apollo.QueryResult<
  ClientQuery,
  ClientQueryVariables
>;
export const ClientsDocument = gql`
  query Clients(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    clients(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on IamV1ListClientsResponse {
        __typename
        clients {
          ...ClientRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ClientRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClientsQuery(
  baseOptions?: Apollo.QueryHookOptions<ClientsQuery, ClientsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientsQuery, ClientsQueryVariables>(
    ClientsDocument,
    options,
  );
}
export function useClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientsQuery,
    ClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientsQuery, ClientsQueryVariables>(
    ClientsDocument,
    options,
  );
}
// @ts-ignore
export function useClientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClientsQuery,
    ClientsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ClientsQuery, ClientsQueryVariables>;
export function useClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ClientsQuery, ClientsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ClientsQuery | undefined,
  ClientsQueryVariables
>;
export function useClientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ClientsQuery, ClientsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ClientsQuery, ClientsQueryVariables>(
    ClientsDocument,
    options,
  );
}
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsSuspenseQueryHookResult = ReturnType<
  typeof useClientsSuspenseQuery
>;
export type ClientsQueryResult = Apollo.QueryResult<
  ClientsQuery,
  ClientsQueryVariables
>;
export const CreateAgentDocument = gql`
  mutation CreateAgent($agent: IamV1AgentInput!, $agentId: String) {
    createAgent(agent: $agent, agentId: $agentId) {
      ...Agent
      ...DefaultError
    }
  }
  ${AgentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAgentMutationFn = Apollo.MutationFunction<
  CreateAgentMutation,
  CreateAgentMutationVariables
>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      agent: // value for 'agent'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useCreateAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAgentMutation,
    CreateAgentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(
    CreateAgentDocument,
    options,
  );
}
export type CreateAgentMutationHookResult = ReturnType<
  typeof useCreateAgentMutation
>;
export type CreateAgentMutationResult =
  Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<
  CreateAgentMutation,
  CreateAgentMutationVariables
>;
export const CreateClientDocument = gql`
  mutation CreateClient($client: IamV1ClientInput!) {
    createClient(client: $client) {
      ...Client
      ...DefaultError
    }
  }
  ${ClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateClientMutationFn = Apollo.MutationFunction<
  CreateClientMutation,
  CreateClientMutationVariables
>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      client: // value for 'client'
 *   },
 * });
 */
export function useCreateClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClientMutation,
    CreateClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClientMutation,
    CreateClientMutationVariables
  >(CreateClientDocument, options);
}
export type CreateClientMutationHookResult = ReturnType<
  typeof useCreateClientMutation
>;
export type CreateClientMutationResult =
  Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<
  CreateClientMutation,
  CreateClientMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation CreateGroup($input: IamV1GroupInput!) {
    createGroup(group: $input) {
      ...Group
      ...DefaultError
    }
  }
  ${GroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options,
  );
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>;
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const CreateRoleDocument = gql`
  mutation CreateRole($input: IamV1RoleInput!) {
    createRole(role: $input) {
      ...Role
      ...DefaultError
    }
  }
  ${RoleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateRoleMutationFn = Apollo.MutationFunction<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRoleMutation,
    CreateRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
    CreateRoleDocument,
    options,
  );
}
export type CreateRoleMutationHookResult = ReturnType<
  typeof useCreateRoleMutation
>;
export type CreateRoleMutationResult =
  Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const CurrentUserDocument = gql`
  query CurrentUser {
    currentUser {
      ...DefaultError
      ...CurrentUser
    }
  }
  ${DefaultErrorFragmentDoc}
  ${CurrentUserFragmentDoc}
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentUserQuery,
    CurrentUserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserQuery,
        CurrentUserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CurrentUserQuery | undefined,
  CurrentUserQueryVariables
>;
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserQuery,
        CurrentUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    options,
  );
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<
  typeof useCurrentUserLazyQuery
>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserSuspenseQuery
>;
export type CurrentUserQueryResult = Apollo.QueryResult<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const CurrentUserGroupsDocument = gql`
  query CurrentUserGroups {
    currentUser {
      __typename
      ... on IamV1CurrentUser {
        user {
          name
          userGroups {
            ... on IamV1ListUserGroupsResponse {
              __typename
              userGroups {
                __typename
                group {
                  ...Group
                }
              }
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${GroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useCurrentUserGroupsQuery__
 *
 * To run a query within a React component, call `useCurrentUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >(CurrentUserGroupsDocument, options);
}
export function useCurrentUserGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >(CurrentUserGroupsDocument, options);
}
// @ts-ignore
export function useCurrentUserGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CurrentUserGroupsQuery,
  CurrentUserGroupsQueryVariables
>;
export function useCurrentUserGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserGroupsQuery,
        CurrentUserGroupsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CurrentUserGroupsQuery | undefined,
  CurrentUserGroupsQueryVariables
>;
export function useCurrentUserGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserGroupsQuery,
        CurrentUserGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CurrentUserGroupsQuery,
    CurrentUserGroupsQueryVariables
  >(CurrentUserGroupsDocument, options);
}
export type CurrentUserGroupsQueryHookResult = ReturnType<
  typeof useCurrentUserGroupsQuery
>;
export type CurrentUserGroupsLazyQueryHookResult = ReturnType<
  typeof useCurrentUserGroupsLazyQuery
>;
export type CurrentUserGroupsSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserGroupsSuspenseQuery
>;
export type CurrentUserGroupsQueryResult = Apollo.QueryResult<
  CurrentUserGroupsQuery,
  CurrentUserGroupsQueryVariables
>;
export const DeleteAgentDocument = gql`
  mutation DeleteAgent($name: String!) {
    deleteAgent(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteAgentMutationFn = Apollo.MutationFunction<
  DeleteAgentMutation,
  DeleteAgentMutationVariables
>;

/**
 * __useDeleteAgentMutation__
 *
 * To run a mutation, you first call `useDeleteAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentMutation, { data, loading, error }] = useDeleteAgentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAgentMutation,
    DeleteAgentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAgentMutation, DeleteAgentMutationVariables>(
    DeleteAgentDocument,
    options,
  );
}
export type DeleteAgentMutationHookResult = ReturnType<
  typeof useDeleteAgentMutation
>;
export type DeleteAgentMutationResult =
  Apollo.MutationResult<DeleteAgentMutation>;
export type DeleteAgentMutationOptions = Apollo.BaseMutationOptions<
  DeleteAgentMutation,
  DeleteAgentMutationVariables
>;
export const DeleteClientDocument = gql`
  mutation DeleteClient($name: String!) {
    deleteClient(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteClientMutationFn = Apollo.MutationFunction<
  DeleteClientMutation,
  DeleteClientMutationVariables
>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >(DeleteClientDocument, options);
}
export type DeleteClientMutationHookResult = ReturnType<
  typeof useDeleteClientMutation
>;
export type DeleteClientMutationResult =
  Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<
  DeleteClientMutation,
  DeleteClientMutationVariables
>;
export const DeleteGroupDocument = gql`
  mutation DeleteGroup($name: String!) {
    deleteGroup(name: $name) {
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteGroupMutationFn = Apollo.MutationFunction<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGroupMutation,
    DeleteGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(
    DeleteGroupDocument,
    options,
  );
}
export type DeleteGroupMutationHookResult = ReturnType<
  typeof useDeleteGroupMutation
>;
export type DeleteGroupMutationResult =
  Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation DeleteRole($name: String!) {
    deleteRole(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRoleMutation,
    DeleteRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(
    DeleteRoleDocument,
    options,
  );
}
export type DeleteRoleMutationHookResult = ReturnType<
  typeof useDeleteRoleMutation
>;
export type DeleteRoleMutationResult =
  Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const GroupDocument = gql`
  query Group($name: String!) {
    group(name: $name) {
      __typename
      ...Group
      ...DefaultError
    }
  }
  ${GroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> &
    ({ variables: GroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
export function useGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
// @ts-ignore
export function useGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupQuery,
    GroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupQuery, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupQuery | undefined, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options,
  );
}
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<
  typeof useGroupSuspenseQuery
>;
export type GroupQueryResult = Apollo.QueryResult<
  GroupQuery,
  GroupQueryVariables
>;
export const GroupsDocument = gql`
  query Groups($pageToken: String, $pageSize: Int, $filter: String) {
    groups(pageToken: $pageToken, pageSize: $pageSize, filter: $filter) {
      ... on IamV1ListGroupsResponse {
        __typename
        groups {
          ...Group
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${GroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
export function useGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
// @ts-ignore
export function useGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupsQuery,
    GroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GroupsQuery, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupsQuery | undefined, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(
    GroupsDocument,
    options,
  );
}
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<
  typeof useGroupsSuspenseQuery
>;
export type GroupsQueryResult = Apollo.QueryResult<
  GroupsQuery,
  GroupsQueryVariables
>;
export const IdentitiesDocument = gql`
  query Identities($pageSize: Int, $pageToken: String, $filter: String) {
    identities(pageSize: $pageSize, pageToken: $pageToken, filter: $filter) {
      ... on IamV1ListIdentitiesResponse {
        __typename
        identities {
          ...Identity
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${IdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useIdentitiesQuery__
 *
 * To run a query within a React component, call `useIdentitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentitiesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIdentitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IdentitiesQuery,
    IdentitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IdentitiesQuery, IdentitiesQueryVariables>(
    IdentitiesDocument,
    options,
  );
}
export function useIdentitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IdentitiesQuery,
    IdentitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IdentitiesQuery, IdentitiesQueryVariables>(
    IdentitiesDocument,
    options,
  );
}
// @ts-ignore
export function useIdentitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IdentitiesQuery,
    IdentitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IdentitiesQuery, IdentitiesQueryVariables>;
export function useIdentitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IdentitiesQuery,
        IdentitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IdentitiesQuery | undefined,
  IdentitiesQueryVariables
>;
export function useIdentitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IdentitiesQuery,
        IdentitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IdentitiesQuery, IdentitiesQueryVariables>(
    IdentitiesDocument,
    options,
  );
}
export type IdentitiesQueryHookResult = ReturnType<typeof useIdentitiesQuery>;
export type IdentitiesLazyQueryHookResult = ReturnType<
  typeof useIdentitiesLazyQuery
>;
export type IdentitiesSuspenseQueryHookResult = ReturnType<
  typeof useIdentitiesSuspenseQuery
>;
export type IdentitiesQueryResult = Apollo.QueryResult<
  IdentitiesQuery,
  IdentitiesQueryVariables
>;
export const IdentityDocument = gql`
  query Identity($name: String!) {
    identity(name: $name) {
      __typename
      ...DefaultError
      ...Identity
    }
  }
  ${DefaultErrorFragmentDoc}
  ${IdentityFragmentDoc}
`;

/**
 * __useIdentityQuery__
 *
 * To run a query within a React component, call `useIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useIdentityQuery(
  baseOptions: Apollo.QueryHookOptions<IdentityQuery, IdentityQueryVariables> &
    ({ variables: IdentityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IdentityQuery, IdentityQueryVariables>(
    IdentityDocument,
    options,
  );
}
export function useIdentityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IdentityQuery,
    IdentityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IdentityQuery, IdentityQueryVariables>(
    IdentityDocument,
    options,
  );
}
// @ts-ignore
export function useIdentitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IdentityQuery,
    IdentityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IdentityQuery, IdentityQueryVariables>;
export function useIdentitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  IdentityQuery | undefined,
  IdentityQueryVariables
>;
export function useIdentitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IdentityQuery, IdentityQueryVariables>(
    IdentityDocument,
    options,
  );
}
export type IdentityQueryHookResult = ReturnType<typeof useIdentityQuery>;
export type IdentityLazyQueryHookResult = ReturnType<
  typeof useIdentityLazyQuery
>;
export type IdentitySuspenseQueryHookResult = ReturnType<
  typeof useIdentitySuspenseQuery
>;
export type IdentityQueryResult = Apollo.QueryResult<
  IdentityQuery,
  IdentityQueryVariables
>;
export const IdentityRefDocument = gql`
  query IdentityRef($name: String!) {
    identity(name: $name) {
      __typename
      ...DefaultError
      ...IdentityRef
    }
  }
  ${DefaultErrorFragmentDoc}
  ${IdentityRefFragmentDoc}
`;

/**
 * __useIdentityRefQuery__
 *
 * To run a query within a React component, call `useIdentityRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useIdentityRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    IdentityRefQuery,
    IdentityRefQueryVariables
  > &
    (
      | { variables: IdentityRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IdentityRefQuery, IdentityRefQueryVariables>(
    IdentityRefDocument,
    options,
  );
}
export function useIdentityRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IdentityRefQuery,
    IdentityRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IdentityRefQuery, IdentityRefQueryVariables>(
    IdentityRefDocument,
    options,
  );
}
// @ts-ignore
export function useIdentityRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IdentityRefQuery,
    IdentityRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IdentityRefQuery, IdentityRefQueryVariables>;
export function useIdentityRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IdentityRefQuery,
        IdentityRefQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IdentityRefQuery | undefined,
  IdentityRefQueryVariables
>;
export function useIdentityRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IdentityRefQuery,
        IdentityRefQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IdentityRefQuery, IdentityRefQueryVariables>(
    IdentityRefDocument,
    options,
  );
}
export type IdentityRefQueryHookResult = ReturnType<typeof useIdentityRefQuery>;
export type IdentityRefLazyQueryHookResult = ReturnType<
  typeof useIdentityRefLazyQuery
>;
export type IdentityRefSuspenseQueryHookResult = ReturnType<
  typeof useIdentityRefSuspenseQuery
>;
export type IdentityRefQueryResult = Apollo.QueryResult<
  IdentityRefQuery,
  IdentityRefQueryVariables
>;
export const LatestSdkVersionsDocument = gql`
  query LatestSdkVersions {
    getLatestSdkVersions {
      ... on InsightsV1GetLatestSdkVersionsResponse {
        __typename
        sdkLatestVersions {
          sdkId
          platform
          sdkDisplayName
          latestVersion
        }
        features {
          featureId
          displayName
          minVersions {
            sdkId
            platform
            minVersion
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useLatestSdkVersionsQuery__
 *
 * To run a query within a React component, call `useLatestSdkVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestSdkVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestSdkVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestSdkVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >(LatestSdkVersionsDocument, options);
}
export function useLatestSdkVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >(LatestSdkVersionsDocument, options);
}
// @ts-ignore
export function useLatestSdkVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LatestSdkVersionsQuery,
  LatestSdkVersionsQueryVariables
>;
export function useLatestSdkVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LatestSdkVersionsQuery,
        LatestSdkVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LatestSdkVersionsQuery | undefined,
  LatestSdkVersionsQueryVariables
>;
export function useLatestSdkVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LatestSdkVersionsQuery,
        LatestSdkVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LatestSdkVersionsQuery,
    LatestSdkVersionsQueryVariables
  >(LatestSdkVersionsDocument, options);
}
export type LatestSdkVersionsQueryHookResult = ReturnType<
  typeof useLatestSdkVersionsQuery
>;
export type LatestSdkVersionsLazyQueryHookResult = ReturnType<
  typeof useLatestSdkVersionsLazyQuery
>;
export type LatestSdkVersionsSuspenseQueryHookResult = ReturnType<
  typeof useLatestSdkVersionsSuspenseQuery
>;
export type LatestSdkVersionsQueryResult = Apollo.QueryResult<
  LatestSdkVersionsQuery,
  LatestSdkVersionsQueryVariables
>;
export const OnGroupCreatedDocument = gql`
  subscription OnGroupCreated {
    groupCreated {
      group {
        ...Group
      }
    }
  }
  ${GroupFragmentDoc}
`;

/**
 * __useOnGroupCreatedSubscription__
 *
 * To run a query within a React component, call `useOnGroupCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnGroupCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnGroupCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnGroupCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnGroupCreatedSubscription,
    OnGroupCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnGroupCreatedSubscription,
    OnGroupCreatedSubscriptionVariables
  >(OnGroupCreatedDocument, options);
}
export type OnGroupCreatedSubscriptionHookResult = ReturnType<
  typeof useOnGroupCreatedSubscription
>;
export type OnGroupCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnGroupCreatedSubscription>;
export const OnGroupDeletedDocument = gql`
  subscription OnGroupDeleted {
    groupDeleted {
      group
    }
  }
`;

/**
 * __useOnGroupDeletedSubscription__
 *
 * To run a query within a React component, call `useOnGroupDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnGroupDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnGroupDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnGroupDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnGroupDeletedSubscription,
    OnGroupDeletedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnGroupDeletedSubscription,
    OnGroupDeletedSubscriptionVariables
  >(OnGroupDeletedDocument, options);
}
export type OnGroupDeletedSubscriptionHookResult = ReturnType<
  typeof useOnGroupDeletedSubscription
>;
export type OnGroupDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnGroupDeletedSubscription>;
export const OnGroupUpdatedDocument = gql`
  subscription OnGroupUpdated {
    groupUpdated {
      group {
        ...Group
      }
    }
  }
  ${GroupFragmentDoc}
`;

/**
 * __useOnGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnGroupUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnGroupUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnGroupUpdatedSubscription,
    OnGroupUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnGroupUpdatedSubscription,
    OnGroupUpdatedSubscriptionVariables
  >(OnGroupUpdatedDocument, options);
}
export type OnGroupUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnGroupUpdatedSubscription
>;
export type OnGroupUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnGroupUpdatedSubscription>;
export const RangeQueryDocument = gql`
  mutation RangeQuery(
    $graph: InsightsV1GraphType!
    $startTime: String
    $endTime: String
    $step: String
    $labelFilters: [InsightsV1RangeQueryRequestLabelFiltersEntryInput!]
  ) {
    rangeQuery(
      graph: $graph
      startTime: $startTime
      endTime: $endTime
      step: $step
      labelFilters: $labelFilters
    ) {
      ... on InsightsV1QueryResponse {
        __typename
        status
        data {
          resultType
          result {
            metric {
              key
              value
            }
            sdkResolveMode
            values {
              timestamp
              value
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type RangeQueryMutationFn = Apollo.MutationFunction<
  RangeQueryMutation,
  RangeQueryMutationVariables
>;

/**
 * __useRangeQueryMutation__
 *
 * To run a mutation, you first call `useRangeQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRangeQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rangeQueryMutation, { data, loading, error }] = useRangeQueryMutation({
 *   variables: {
 *      graph: // value for 'graph'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      step: // value for 'step'
 *      labelFilters: // value for 'labelFilters'
 *   },
 * });
 */
export function useRangeQueryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RangeQueryMutation,
    RangeQueryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RangeQueryMutation, RangeQueryMutationVariables>(
    RangeQueryDocument,
    options,
  );
}
export type RangeQueryMutationHookResult = ReturnType<
  typeof useRangeQueryMutation
>;
export type RangeQueryMutationResult =
  Apollo.MutationResult<RangeQueryMutation>;
export type RangeQueryMutationOptions = Apollo.BaseMutationOptions<
  RangeQueryMutation,
  RangeQueryMutationVariables
>;
export const RolesDocument = gql`
  query Roles($pageSize: Int, $pageToken: String) {
    roles(pageSize: $pageSize, pageToken: $pageToken) {
      ... on IamV1ListRolesResponse {
        __typename
        roles {
          ...RoleRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${RoleRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RolesQuery, RolesQueryVariables>(
    RolesDocument,
    options,
  );
}
export function useRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(
    RolesDocument,
    options,
  );
}
// @ts-ignore
export function useRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RolesQuery,
    RolesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RolesQuery, RolesQueryVariables>;
export function useRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>,
): Apollo.UseSuspenseQueryResult<RolesQuery | undefined, RolesQueryVariables>;
export function useRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RolesQuery, RolesQueryVariables>(
    RolesDocument,
    options,
  );
}
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<
  typeof useRolesSuspenseQuery
>;
export type RolesQueryResult = Apollo.QueryResult<
  RolesQuery,
  RolesQueryVariables
>;
export const UpdateAgentDocument = gql`
  mutation UpdateAgent($input: PartialIamV1AgentInput!, $updateMask: String) {
    updateAgent(agent: $input, updateMask: $updateMask) {
      ...Agent
      ...DefaultError
    }
  }
  ${AgentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateAgentMutationFn = Apollo.MutationFunction<
  UpdateAgentMutation,
  UpdateAgentMutationVariables
>;

/**
 * __useUpdateAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMutation, { data, loading, error }] = useUpdateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAgentMutation,
    UpdateAgentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(
    UpdateAgentDocument,
    options,
  );
}
export type UpdateAgentMutationHookResult = ReturnType<
  typeof useUpdateAgentMutation
>;
export type UpdateAgentMutationResult =
  Apollo.MutationResult<UpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.BaseMutationOptions<
  UpdateAgentMutation,
  UpdateAgentMutationVariables
>;
export const UpdateClientDocument = gql`
  mutation UpdateClient($input: PartialIamV1ClientInput!, $updateMask: String) {
    updateClient(client: $input, updateMask: $updateMask) {
      ...Client
      ...DefaultError
    }
  }
  ${ClientFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateClientMutationFn = Apollo.MutationFunction<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >(UpdateClientDocument, options);
}
export type UpdateClientMutationHookResult = ReturnType<
  typeof useUpdateClientMutation
>;
export type UpdateClientMutationResult =
  Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;
export const UpdateGroupDocument = gql`
  mutation UpdateGroup($input: PartialIamV1GroupInput!, $updateMask: String) {
    updateGroup(group: $input, updateMask: $updateMask) {
      __typename
      ...Group
      ...DefaultError
    }
  }
  ${GroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    options,
  );
}
export type UpdateGroupMutationHookResult = ReturnType<
  typeof useUpdateGroupMutation
>;
export type UpdateGroupMutationResult =
  Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const UpdateRoleDocument = gql`
  mutation UpdateRole($input: PartialIamV1RoleInput!, $updateMask: String) {
    updateRole(role: $input, updateMask: $updateMask) {
      ...Role
      ...DefaultError
    }
  }
  ${RoleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoleMutation,
    UpdateRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(
    UpdateRoleDocument,
    options,
  );
}
export type UpdateRoleMutationHookResult = ReturnType<
  typeof useUpdateRoleMutation
>;
export type UpdateRoleMutationResult =
  Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>;
export const UserDocument = gql`
  query User($name: String!) {
    user(name: $name) {
      ...User
      ...DefaultError
    }
  }
  ${UserFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> &
    ({ variables: UserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
// @ts-ignore
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<
  typeof useUserSuspenseQuery
>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
  query Users(
    $pageToken: String
    $pageSize: Int
    $filter: String
    $orderBy: String
  ) {
    users(
      pageToken: $pageToken
      pageSize: $pageSize
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on IamV1ListUsersResponse {
        __typename
        users {
          ...UserRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${UserRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersQuery, UsersQueryVariables>(
    UsersDocument,
    options,
  );
}
export function useUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(
    UsersDocument,
    options,
  );
}
// @ts-ignore
export function useUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UsersQuery,
    UsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(
    UsersDocument,
    options,
  );
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<
  typeof useUsersSuspenseQuery
>;
export type UsersQueryResult = Apollo.QueryResult<
  UsersQuery,
  UsersQueryVariables
>;
export const CreateInitiativeDocument = gql`
  mutation CreateInitiative($input: WorkflowV1InitiativeInput!) {
    createInitiative(initiative: $input) {
      ...Initiative
      ...DefaultError
    }
  }
  ${InitiativeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateInitiativeMutationFn = Apollo.MutationFunction<
  CreateInitiativeMutation,
  CreateInitiativeMutationVariables
>;

/**
 * __useCreateInitiativeMutation__
 *
 * To run a mutation, you first call `useCreateInitiativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitiativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInitiativeMutation, { data, loading, error }] = useCreateInitiativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInitiativeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInitiativeMutation,
    CreateInitiativeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInitiativeMutation,
    CreateInitiativeMutationVariables
  >(CreateInitiativeDocument, options);
}
export type CreateInitiativeMutationHookResult = ReturnType<
  typeof useCreateInitiativeMutation
>;
export type CreateInitiativeMutationResult =
  Apollo.MutationResult<CreateInitiativeMutation>;
export type CreateInitiativeMutationOptions = Apollo.BaseMutationOptions<
  CreateInitiativeMutation,
  CreateInitiativeMutationVariables
>;
export const DeleteInitiativeDocument = gql`
  mutation DeleteInitiative($name: String!) {
    deleteInitiative(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteInitiativeMutationFn = Apollo.MutationFunction<
  DeleteInitiativeMutation,
  DeleteInitiativeMutationVariables
>;

/**
 * __useDeleteInitiativeMutation__
 *
 * To run a mutation, you first call `useDeleteInitiativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInitiativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInitiativeMutation, { data, loading, error }] = useDeleteInitiativeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteInitiativeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInitiativeMutation,
    DeleteInitiativeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteInitiativeMutation,
    DeleteInitiativeMutationVariables
  >(DeleteInitiativeDocument, options);
}
export type DeleteInitiativeMutationHookResult = ReturnType<
  typeof useDeleteInitiativeMutation
>;
export type DeleteInitiativeMutationResult =
  Apollo.MutationResult<DeleteInitiativeMutation>;
export type DeleteInitiativeMutationOptions = Apollo.BaseMutationOptions<
  DeleteInitiativeMutation,
  DeleteInitiativeMutationVariables
>;
export const InitiativeDocument = gql`
  query Initiative($name: String!) {
    initiative(name: $name) {
      ...Initiative
      ...DefaultError
    }
  }
  ${InitiativeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInitiativeQuery__
 *
 * To run a query within a React component, call `useInitiativeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiativeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiativeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useInitiativeQuery(
  baseOptions: Apollo.QueryHookOptions<
    InitiativeQuery,
    InitiativeQueryVariables
  > &
    (
      | { variables: InitiativeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InitiativeQuery, InitiativeQueryVariables>(
    InitiativeDocument,
    options,
  );
}
export function useInitiativeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InitiativeQuery,
    InitiativeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InitiativeQuery, InitiativeQueryVariables>(
    InitiativeDocument,
    options,
  );
}
// @ts-ignore
export function useInitiativeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InitiativeQuery,
    InitiativeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InitiativeQuery, InitiativeQueryVariables>;
export function useInitiativeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativeQuery,
        InitiativeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InitiativeQuery | undefined,
  InitiativeQueryVariables
>;
export function useInitiativeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativeQuery,
        InitiativeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InitiativeQuery, InitiativeQueryVariables>(
    InitiativeDocument,
    options,
  );
}
export type InitiativeQueryHookResult = ReturnType<typeof useInitiativeQuery>;
export type InitiativeLazyQueryHookResult = ReturnType<
  typeof useInitiativeLazyQuery
>;
export type InitiativeSuspenseQueryHookResult = ReturnType<
  typeof useInitiativeSuspenseQuery
>;
export type InitiativeQueryResult = Apollo.QueryResult<
  InitiativeQuery,
  InitiativeQueryVariables
>;
export const InitiativesDocument = gql`
  query Initiatives(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    initiatives(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on WorkflowV1ListInitiativesResponse {
        initiatives {
          ...InitiativeRef
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${InitiativeRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInitiativesQuery__
 *
 * To run a query within a React component, call `useInitiativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiativesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInitiativesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InitiativesQuery,
    InitiativesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InitiativesQuery, InitiativesQueryVariables>(
    InitiativesDocument,
    options,
  );
}
export function useInitiativesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InitiativesQuery,
    InitiativesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InitiativesQuery, InitiativesQueryVariables>(
    InitiativesDocument,
    options,
  );
}
// @ts-ignore
export function useInitiativesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InitiativesQuery,
    InitiativesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InitiativesQuery, InitiativesQueryVariables>;
export function useInitiativesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativesQuery,
        InitiativesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InitiativesQuery | undefined,
  InitiativesQueryVariables
>;
export function useInitiativesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativesQuery,
        InitiativesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InitiativesQuery, InitiativesQueryVariables>(
    InitiativesDocument,
    options,
  );
}
export type InitiativesQueryHookResult = ReturnType<typeof useInitiativesQuery>;
export type InitiativesLazyQueryHookResult = ReturnType<
  typeof useInitiativesLazyQuery
>;
export type InitiativesSuspenseQueryHookResult = ReturnType<
  typeof useInitiativesSuspenseQuery
>;
export type InitiativesQueryResult = Apollo.QueryResult<
  InitiativesQuery,
  InitiativesQueryVariables
>;
export const OnInitiativeCreatedDocument = gql`
  subscription OnInitiativeCreated {
    initiativeCreated {
      initiative {
        ...Initiative
      }
    }
  }
  ${InitiativeFragmentDoc}
`;

/**
 * __useOnInitiativeCreatedSubscription__
 *
 * To run a query within a React component, call `useOnInitiativeCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnInitiativeCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnInitiativeCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnInitiativeCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnInitiativeCreatedSubscription,
    OnInitiativeCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnInitiativeCreatedSubscription,
    OnInitiativeCreatedSubscriptionVariables
  >(OnInitiativeCreatedDocument, options);
}
export type OnInitiativeCreatedSubscriptionHookResult = ReturnType<
  typeof useOnInitiativeCreatedSubscription
>;
export type OnInitiativeCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnInitiativeCreatedSubscription>;
export const OnInitiativeDeletedDocument = gql`
  subscription OnInitiativeDeleted {
    initiativeDeleted {
      initiative
    }
  }
`;

/**
 * __useOnInitiativeDeletedSubscription__
 *
 * To run a query within a React component, call `useOnInitiativeDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnInitiativeDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnInitiativeDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnInitiativeDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnInitiativeDeletedSubscription,
    OnInitiativeDeletedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnInitiativeDeletedSubscription,
    OnInitiativeDeletedSubscriptionVariables
  >(OnInitiativeDeletedDocument, options);
}
export type OnInitiativeDeletedSubscriptionHookResult = ReturnType<
  typeof useOnInitiativeDeletedSubscription
>;
export type OnInitiativeDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnInitiativeDeletedSubscription>;
export const OnInitiativeUpdatedDocument = gql`
  subscription OnInitiativeUpdated {
    initiativeUpdated {
      initiative {
        ...Initiative
      }
    }
  }
  ${InitiativeFragmentDoc}
`;

/**
 * __useOnInitiativeUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnInitiativeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnInitiativeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnInitiativeUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnInitiativeUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnInitiativeUpdatedSubscription,
    OnInitiativeUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnInitiativeUpdatedSubscription,
    OnInitiativeUpdatedSubscriptionVariables
  >(OnInitiativeUpdatedDocument, options);
}
export type OnInitiativeUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnInitiativeUpdatedSubscription
>;
export type OnInitiativeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnInitiativeUpdatedSubscription>;
export const UpdateInitiativeDocument = gql`
  mutation UpdateInitiative(
    $input: PartialWorkflowV1InitiativeInput!
    $updateMask: String
  ) {
    updateInitiative(initiative: $input, updateMask: $updateMask) {
      ...Initiative
      ...DefaultError
    }
  }
  ${InitiativeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateInitiativeMutationFn = Apollo.MutationFunction<
  UpdateInitiativeMutation,
  UpdateInitiativeMutationVariables
>;

/**
 * __useUpdateInitiativeMutation__
 *
 * To run a mutation, you first call `useUpdateInitiativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitiativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitiativeMutation, { data, loading, error }] = useUpdateInitiativeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateInitiativeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInitiativeMutation,
    UpdateInitiativeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateInitiativeMutation,
    UpdateInitiativeMutationVariables
  >(UpdateInitiativeDocument, options);
}
export type UpdateInitiativeMutationHookResult = ReturnType<
  typeof useUpdateInitiativeMutation
>;
export type UpdateInitiativeMutationResult =
  Apollo.MutationResult<UpdateInitiativeMutation>;
export type UpdateInitiativeMutationOptions = Apollo.BaseMutationOptions<
  UpdateInitiativeMutation,
  UpdateInitiativeMutationVariables
>;
export const InitiativePageActivitiesDocument = gql`
  query InitiativePageActivities(
    $name: String!
    $pageSize: Int
    $pageToken: String
  ) {
    activities(resource: $name, pageSize: $pageSize, pageToken: $pageToken) {
      ... on ActivityV1ListActivitiesResponse {
        activities {
          ...FeedActivity
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FeedActivityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useInitiativePageActivitiesQuery__
 *
 * To run a query within a React component, call `useInitiativePageActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiativePageActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiativePageActivitiesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useInitiativePageActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  > &
    (
      | { variables: InitiativePageActivitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  >(InitiativePageActivitiesDocument, options);
}
export function useInitiativePageActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  >(InitiativePageActivitiesDocument, options);
}
// @ts-ignore
export function useInitiativePageActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InitiativePageActivitiesQuery,
  InitiativePageActivitiesQueryVariables
>;
export function useInitiativePageActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativePageActivitiesQuery,
        InitiativePageActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InitiativePageActivitiesQuery | undefined,
  InitiativePageActivitiesQueryVariables
>;
export function useInitiativePageActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InitiativePageActivitiesQuery,
        InitiativePageActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InitiativePageActivitiesQuery,
    InitiativePageActivitiesQueryVariables
  >(InitiativePageActivitiesDocument, options);
}
export type InitiativePageActivitiesQueryHookResult = ReturnType<
  typeof useInitiativePageActivitiesQuery
>;
export type InitiativePageActivitiesLazyQueryHookResult = ReturnType<
  typeof useInitiativePageActivitiesLazyQuery
>;
export type InitiativePageActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useInitiativePageActivitiesSuspenseQuery
>;
export type InitiativePageActivitiesQueryResult = Apollo.QueryResult<
  InitiativePageActivitiesQuery,
  InitiativePageActivitiesQueryVariables
>;
export const InsightsMetricsDocument = gql`
  query InsightsMetrics {
    wau: queryInsightsMetric(name: "insightsMetrics/weekly-active-users") {
      ...InsightsMetricActiveUsers
      ...DefaultError
    }
    mau: queryInsightsMetric(name: "insightsMetrics/monthly-active-users") {
      ...InsightsMetricActiveUsers
      ...DefaultError
    }
    flags: queryInsightsMetric(name: "insightsMetrics/active-flags") {
      ...InsightsMetricFlag
      ...DefaultError
    }
    live: queryInsightsMetric(name: "insightsMetrics/live-workflow-instances") {
      ...InsightsMetricLineChartData
      ...DefaultError
    }
    onboarded: queryInsightsMetric(name: "insightsMetrics/onboarded-users") {
      ...InsightsMetricOnboardedUsers
      ...DefaultError
    }
    surface90days: queryInsightsMetric(
      name: "insightsMetrics/surface-usage-90d"
    ) {
      ...InsightsMetricLineChartData
      ...DefaultError
    }
    learnings: queryInsightsMetric(
      name: "insightsMetrics/experiment-learnings"
    ) {
      ...InsightsMetricLearnings
      ...DefaultError
    }
  }
  ${InsightsMetricActiveUsersFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${InsightsMetricFlagFragmentDoc}
  ${InsightsMetricLineChartDataFragmentDoc}
  ${InsightsMetricOnboardedUsersFragmentDoc}
  ${InsightsMetricLearningsFragmentDoc}
`;

/**
 * __useInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightsMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InsightsMetricsQuery,
    InsightsMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsightsMetricsQuery, InsightsMetricsQueryVariables>(
    InsightsMetricsDocument,
    options,
  );
}
export function useInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsightsMetricsQuery,
    InsightsMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InsightsMetricsQuery,
    InsightsMetricsQueryVariables
  >(InsightsMetricsDocument, options);
}
// @ts-ignore
export function useInsightsMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InsightsMetricsQuery,
    InsightsMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InsightsMetricsQuery,
  InsightsMetricsQueryVariables
>;
export function useInsightsMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsMetricsQuery,
        InsightsMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InsightsMetricsQuery | undefined,
  InsightsMetricsQueryVariables
>;
export function useInsightsMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsMetricsQuery,
        InsightsMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InsightsMetricsQuery,
    InsightsMetricsQueryVariables
  >(InsightsMetricsDocument, options);
}
export type InsightsMetricsQueryHookResult = ReturnType<
  typeof useInsightsMetricsQuery
>;
export type InsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useInsightsMetricsLazyQuery
>;
export type InsightsMetricsSuspenseQueryHookResult = ReturnType<
  typeof useInsightsMetricsSuspenseQuery
>;
export type InsightsMetricsQueryResult = Apollo.QueryResult<
  InsightsMetricsQuery,
  InsightsMetricsQueryVariables
>;
export const CloseIssueDocument = gql`
  mutation CloseIssue(
    $name: String!
    $closeReason: ObservationsV1IssueCloseReason!
  ) {
    closeIssue(name: $name, closeReason: $closeReason) {
      __typename
      ...Issue
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CloseIssueMutationFn = Apollo.MutationFunction<
  CloseIssueMutation,
  CloseIssueMutationVariables
>;

/**
 * __useCloseIssueMutation__
 *
 * To run a mutation, you first call `useCloseIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeIssueMutation, { data, loading, error }] = useCloseIssueMutation({
 *   variables: {
 *      name: // value for 'name'
 *      closeReason: // value for 'closeReason'
 *   },
 * });
 */
export function useCloseIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseIssueMutation,
    CloseIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseIssueMutation, CloseIssueMutationVariables>(
    CloseIssueDocument,
    options,
  );
}
export type CloseIssueMutationHookResult = ReturnType<
  typeof useCloseIssueMutation
>;
export type CloseIssueMutationResult =
  Apollo.MutationResult<CloseIssueMutation>;
export type CloseIssueMutationOptions = Apollo.BaseMutationOptions<
  CloseIssueMutation,
  CloseIssueMutationVariables
>;
export const CreateThemeDocument = gql`
  mutation CreateTheme($theme: ObservationsV1ThemeInput!, $themeId: String) {
    createTheme(theme: $theme, themeId: $themeId) {
      __typename
      ...Theme
      ...DefaultError
    }
  }
  ${ThemeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateThemeMutationFn = Apollo.MutationFunction<
  CreateThemeMutation,
  CreateThemeMutationVariables
>;

/**
 * __useCreateThemeMutation__
 *
 * To run a mutation, you first call `useCreateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThemeMutation, { data, loading, error }] = useCreateThemeMutation({
 *   variables: {
 *      theme: // value for 'theme'
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useCreateThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateThemeMutation,
    CreateThemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateThemeMutation, CreateThemeMutationVariables>(
    CreateThemeDocument,
    options,
  );
}
export type CreateThemeMutationHookResult = ReturnType<
  typeof useCreateThemeMutation
>;
export type CreateThemeMutationResult =
  Apollo.MutationResult<CreateThemeMutation>;
export type CreateThemeMutationOptions = Apollo.BaseMutationOptions<
  CreateThemeMutation,
  CreateThemeMutationVariables
>;
export const IssueDocument = gql`
  query Issue($name: String!) {
    issue(name: $name) {
      ... on ObservationsV1Issue {
        ...Issue
      }
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useIssueQuery__
 *
 * To run a query within a React component, call `useIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useIssueQuery(
  baseOptions: Apollo.QueryHookOptions<IssueQuery, IssueQueryVariables> &
    ({ variables: IssueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IssueQuery, IssueQueryVariables>(
    IssueDocument,
    options,
  );
}
export function useIssueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IssueQuery, IssueQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IssueQuery, IssueQueryVariables>(
    IssueDocument,
    options,
  );
}
// @ts-ignore
export function useIssueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IssueQuery,
    IssueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IssueQuery, IssueQueryVariables>;
export function useIssueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IssueQuery, IssueQueryVariables>,
): Apollo.UseSuspenseQueryResult<IssueQuery | undefined, IssueQueryVariables>;
export function useIssueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IssueQuery, IssueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IssueQuery, IssueQueryVariables>(
    IssueDocument,
    options,
  );
}
export type IssueQueryHookResult = ReturnType<typeof useIssueQuery>;
export type IssueLazyQueryHookResult = ReturnType<typeof useIssueLazyQuery>;
export type IssueSuspenseQueryHookResult = ReturnType<
  typeof useIssueSuspenseQuery
>;
export type IssueQueryResult = Apollo.QueryResult<
  IssueQuery,
  IssueQueryVariables
>;
export const IssuesDocument = gql`
  query Issues(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    issues(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on ObservationsV1ListIssuesResponse {
        __typename
        issues {
          ...IssueRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${IssueRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useIssuesQuery__
 *
 * To run a query within a React component, call `useIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useIssuesQuery(
  baseOptions?: Apollo.QueryHookOptions<IssuesQuery, IssuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IssuesQuery, IssuesQueryVariables>(
    IssuesDocument,
    options,
  );
}
export function useIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IssuesQuery, IssuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IssuesQuery, IssuesQueryVariables>(
    IssuesDocument,
    options,
  );
}
// @ts-ignore
export function useIssuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IssuesQuery,
    IssuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IssuesQuery, IssuesQueryVariables>;
export function useIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IssuesQuery, IssuesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IssuesQuery | undefined, IssuesQueryVariables>;
export function useIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IssuesQuery, IssuesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IssuesQuery, IssuesQueryVariables>(
    IssuesDocument,
    options,
  );
}
export type IssuesQueryHookResult = ReturnType<typeof useIssuesQuery>;
export type IssuesLazyQueryHookResult = ReturnType<typeof useIssuesLazyQuery>;
export type IssuesSuspenseQueryHookResult = ReturnType<
  typeof useIssuesSuspenseQuery
>;
export type IssuesQueryResult = Apollo.QueryResult<
  IssuesQuery,
  IssuesQueryVariables
>;
export const ObservationsDocument = gql`
  query Observations(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    observations(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on ObservationsV1ListObservationsResponse {
        __typename
        observations {
          ...ObservationRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ObservationRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useObservationsQuery__
 *
 * To run a query within a React component, call `useObservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObservationsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useObservationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ObservationsQuery,
    ObservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ObservationsQuery, ObservationsQueryVariables>(
    ObservationsDocument,
    options,
  );
}
export function useObservationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ObservationsQuery,
    ObservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ObservationsQuery, ObservationsQueryVariables>(
    ObservationsDocument,
    options,
  );
}
// @ts-ignore
export function useObservationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ObservationsQuery,
    ObservationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ObservationsQuery, ObservationsQueryVariables>;
export function useObservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ObservationsQuery,
        ObservationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ObservationsQuery | undefined,
  ObservationsQueryVariables
>;
export function useObservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ObservationsQuery,
        ObservationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ObservationsQuery, ObservationsQueryVariables>(
    ObservationsDocument,
    options,
  );
}
export type ObservationsQueryHookResult = ReturnType<
  typeof useObservationsQuery
>;
export type ObservationsLazyQueryHookResult = ReturnType<
  typeof useObservationsLazyQuery
>;
export type ObservationsSuspenseQueryHookResult = ReturnType<
  typeof useObservationsSuspenseQuery
>;
export type ObservationsQueryResult = Apollo.QueryResult<
  ObservationsQuery,
  ObservationsQueryVariables
>;
export const OnIssueCreatedDocument = gql`
  subscription OnIssueCreated($filter: String) {
    issueCreated(filter: $filter) {
      issue {
        ...Issue
      }
    }
  }
  ${IssueFragmentDoc}
`;

/**
 * __useOnIssueCreatedSubscription__
 *
 * To run a query within a React component, call `useOnIssueCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnIssueCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnIssueCreatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnIssueCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnIssueCreatedSubscription,
    OnIssueCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnIssueCreatedSubscription,
    OnIssueCreatedSubscriptionVariables
  >(OnIssueCreatedDocument, options);
}
export type OnIssueCreatedSubscriptionHookResult = ReturnType<
  typeof useOnIssueCreatedSubscription
>;
export type OnIssueCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnIssueCreatedSubscription>;
export const OnIssueUpdatedDocument = gql`
  subscription OnIssueUpdated($filter: String) {
    issueUpdated(filter: $filter) {
      issue {
        ...Issue
      }
    }
  }
  ${IssueFragmentDoc}
`;

/**
 * __useOnIssueUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnIssueUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnIssueUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnIssueUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnIssueUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnIssueUpdatedSubscription,
    OnIssueUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnIssueUpdatedSubscription,
    OnIssueUpdatedSubscriptionVariables
  >(OnIssueUpdatedDocument, options);
}
export type OnIssueUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnIssueUpdatedSubscription
>;
export type OnIssueUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnIssueUpdatedSubscription>;
export const OnTaskCreatedDocument = gql`
  subscription OnTaskCreated($filter: String) {
    taskCreated(filter: $filter) {
      task {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`;

/**
 * __useOnTaskCreatedSubscription__
 *
 * To run a query within a React component, call `useOnTaskCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTaskCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTaskCreatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnTaskCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnTaskCreatedSubscription,
    OnTaskCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnTaskCreatedSubscription,
    OnTaskCreatedSubscriptionVariables
  >(OnTaskCreatedDocument, options);
}
export type OnTaskCreatedSubscriptionHookResult = ReturnType<
  typeof useOnTaskCreatedSubscription
>;
export type OnTaskCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnTaskCreatedSubscription>;
export const OnTaskUpdatedDocument = gql`
  subscription OnTaskUpdated($filter: String) {
    taskUpdated(filter: $filter) {
      task {
        ...Task
      }
    }
  }
  ${TaskFragmentDoc}
`;

/**
 * __useOnTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTaskUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnTaskUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnTaskUpdatedSubscription,
    OnTaskUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnTaskUpdatedSubscription,
    OnTaskUpdatedSubscriptionVariables
  >(OnTaskUpdatedDocument, options);
}
export type OnTaskUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnTaskUpdatedSubscription
>;
export type OnTaskUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnTaskUpdatedSubscription>;
export const OnThemeUpdatedDocument = gql`
  subscription OnThemeUpdated($filter: String) {
    themeUpdated(filter: $filter) {
      theme {
        ...Theme
      }
    }
  }
  ${ThemeFragmentDoc}
`;

/**
 * __useOnThemeUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnThemeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnThemeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnThemeUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnThemeUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnThemeUpdatedSubscription,
    OnThemeUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnThemeUpdatedSubscription,
    OnThemeUpdatedSubscriptionVariables
  >(OnThemeUpdatedDocument, options);
}
export type OnThemeUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnThemeUpdatedSubscription
>;
export type OnThemeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnThemeUpdatedSubscription>;
export const ProvideTaskInputDocument = gql`
  mutation ProvideTaskInput(
    $name: String!
    $inputResponse: ObservationsV1InputResponseInput!
  ) {
    provideTaskInput(name: $name, inputResponse: $inputResponse) {
      __typename
      ...Task
      ...DefaultError
    }
  }
  ${TaskFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ProvideTaskInputMutationFn = Apollo.MutationFunction<
  ProvideTaskInputMutation,
  ProvideTaskInputMutationVariables
>;

/**
 * __useProvideTaskInputMutation__
 *
 * To run a mutation, you first call `useProvideTaskInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvideTaskInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provideTaskInputMutation, { data, loading, error }] = useProvideTaskInputMutation({
 *   variables: {
 *      name: // value for 'name'
 *      inputResponse: // value for 'inputResponse'
 *   },
 * });
 */
export function useProvideTaskInputMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProvideTaskInputMutation,
    ProvideTaskInputMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProvideTaskInputMutation,
    ProvideTaskInputMutationVariables
  >(ProvideTaskInputDocument, options);
}
export type ProvideTaskInputMutationHookResult = ReturnType<
  typeof useProvideTaskInputMutation
>;
export type ProvideTaskInputMutationResult =
  Apollo.MutationResult<ProvideTaskInputMutation>;
export type ProvideTaskInputMutationOptions = Apollo.BaseMutationOptions<
  ProvideTaskInputMutation,
  ProvideTaskInputMutationVariables
>;
export const PullRequestDocument = gql`
  query PullRequest($repository: String!, $number: Int!) {
    pullRequest(repository: $repository, number: $number) {
      ... on RepositoriesV1PullRequest {
        __typename
        additions
        createdAt
        deletions
        draft
        htmlUrl
        head {
          ref
        }
        labels
        merged
        mergeable
        number
        requestedReviewers
        state
        title
        userLogin
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePullRequestQuery__
 *
 * To run a query within a React component, call `usePullRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePullRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePullRequestQuery({
 *   variables: {
 *      repository: // value for 'repository'
 *      number: // value for 'number'
 *   },
 * });
 */
export function usePullRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    PullRequestQuery,
    PullRequestQueryVariables
  > &
    (
      | { variables: PullRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PullRequestQuery, PullRequestQueryVariables>(
    PullRequestDocument,
    options,
  );
}
export function usePullRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PullRequestQuery,
    PullRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PullRequestQuery, PullRequestQueryVariables>(
    PullRequestDocument,
    options,
  );
}
// @ts-ignore
export function usePullRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PullRequestQuery,
    PullRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PullRequestQuery, PullRequestQueryVariables>;
export function usePullRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PullRequestQuery,
        PullRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PullRequestQuery | undefined,
  PullRequestQueryVariables
>;
export function usePullRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PullRequestQuery,
        PullRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PullRequestQuery, PullRequestQueryVariables>(
    PullRequestDocument,
    options,
  );
}
export type PullRequestQueryHookResult = ReturnType<typeof usePullRequestQuery>;
export type PullRequestLazyQueryHookResult = ReturnType<
  typeof usePullRequestLazyQuery
>;
export type PullRequestSuspenseQueryHookResult = ReturnType<
  typeof usePullRequestSuspenseQuery
>;
export type PullRequestQueryResult = Apollo.QueryResult<
  PullRequestQuery,
  PullRequestQueryVariables
>;
export const ReopenIssueDocument = gql`
  mutation ReopenIssue($name: String!) {
    reopenIssue(name: $name) {
      __typename
      ...Issue
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ReopenIssueMutationFn = Apollo.MutationFunction<
  ReopenIssueMutation,
  ReopenIssueMutationVariables
>;

/**
 * __useReopenIssueMutation__
 *
 * To run a mutation, you first call `useReopenIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenIssueMutation, { data, loading, error }] = useReopenIssueMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useReopenIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReopenIssueMutation,
    ReopenIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReopenIssueMutation, ReopenIssueMutationVariables>(
    ReopenIssueDocument,
    options,
  );
}
export type ReopenIssueMutationHookResult = ReturnType<
  typeof useReopenIssueMutation
>;
export type ReopenIssueMutationResult =
  Apollo.MutationResult<ReopenIssueMutation>;
export type ReopenIssueMutationOptions = Apollo.BaseMutationOptions<
  ReopenIssueMutation,
  ReopenIssueMutationVariables
>;
export const ReviewIssueDocument = gql`
  mutation ReviewIssue(
    $name: String!
    $feedback: [ObservationsV1IssueFeedbackInput!]
    $autonomyLevel: ObservationsV1IssueAutonomyLevel
  ) {
    reviewIssue(
      name: $name
      feedback: $feedback
      autonomyLevel: $autonomyLevel
    ) {
      __typename
      ...Issue
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ReviewIssueMutationFn = Apollo.MutationFunction<
  ReviewIssueMutation,
  ReviewIssueMutationVariables
>;

/**
 * __useReviewIssueMutation__
 *
 * To run a mutation, you first call `useReviewIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewIssueMutation, { data, loading, error }] = useReviewIssueMutation({
 *   variables: {
 *      name: // value for 'name'
 *      feedback: // value for 'feedback'
 *      autonomyLevel: // value for 'autonomyLevel'
 *   },
 * });
 */
export function useReviewIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviewIssueMutation,
    ReviewIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReviewIssueMutation, ReviewIssueMutationVariables>(
    ReviewIssueDocument,
    options,
  );
}
export type ReviewIssueMutationHookResult = ReturnType<
  typeof useReviewIssueMutation
>;
export type ReviewIssueMutationResult =
  Apollo.MutationResult<ReviewIssueMutation>;
export type ReviewIssueMutationOptions = Apollo.BaseMutationOptions<
  ReviewIssueMutation,
  ReviewIssueMutationVariables
>;
export const StartInvestigationDocument = gql`
  mutation StartInvestigation($name: String!) {
    startInvestigation(name: $name) {
      __typename
      ...Theme
      ...DefaultError
    }
  }
  ${ThemeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type StartInvestigationMutationFn = Apollo.MutationFunction<
  StartInvestigationMutation,
  StartInvestigationMutationVariables
>;

/**
 * __useStartInvestigationMutation__
 *
 * To run a mutation, you first call `useStartInvestigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartInvestigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startInvestigationMutation, { data, loading, error }] = useStartInvestigationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStartInvestigationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartInvestigationMutation,
    StartInvestigationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartInvestigationMutation,
    StartInvestigationMutationVariables
  >(StartInvestigationDocument, options);
}
export type StartInvestigationMutationHookResult = ReturnType<
  typeof useStartInvestigationMutation
>;
export type StartInvestigationMutationResult =
  Apollo.MutationResult<StartInvestigationMutation>;
export type StartInvestigationMutationOptions = Apollo.BaseMutationOptions<
  StartInvestigationMutation,
  StartInvestigationMutationVariables
>;
export const StartIssueDocument = gql`
  mutation StartIssue($name: String!) {
    startIssue(name: $name) {
      __typename
      ...Issue
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type StartIssueMutationFn = Apollo.MutationFunction<
  StartIssueMutation,
  StartIssueMutationVariables
>;

/**
 * __useStartIssueMutation__
 *
 * To run a mutation, you first call `useStartIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startIssueMutation, { data, loading, error }] = useStartIssueMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStartIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartIssueMutation,
    StartIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartIssueMutation, StartIssueMutationVariables>(
    StartIssueDocument,
    options,
  );
}
export type StartIssueMutationHookResult = ReturnType<
  typeof useStartIssueMutation
>;
export type StartIssueMutationResult =
  Apollo.MutationResult<StartIssueMutation>;
export type StartIssueMutationOptions = Apollo.BaseMutationOptions<
  StartIssueMutation,
  StartIssueMutationVariables
>;
export const TaskDocument = gql`
  query Task($name: String!) {
    task(name: $name) {
      ... on ObservationsV1Task {
        ...Task
      }
      ...DefaultError
    }
  }
  ${TaskFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTaskQuery(
  baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables> &
    ({ variables: TaskQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
}
export function useTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(
    TaskDocument,
    options,
  );
}
// @ts-ignore
export function useTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskQuery, TaskQueryVariables>;
export function useTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskQuery | undefined, TaskQueryVariables>;
export function useTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskQuery, TaskQueryVariables>(
    TaskDocument,
    options,
  );
}
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskSuspenseQueryHookResult = ReturnType<
  typeof useTaskSuspenseQuery
>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const TasksDocument = gql`
  query Tasks(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    tasks(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on ObservationsV1ListTasksResponse {
        __typename
        tasks {
          ...TaskRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${TaskRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TasksQuery, TasksQueryVariables>(
    TasksDocument,
    options,
  );
}
export function useTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(
    TasksDocument,
    options,
  );
}
// @ts-ignore
export function useTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TasksQuery,
    TasksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TasksQuery, TasksQueryVariables>;
export function useTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>,
): Apollo.UseSuspenseQueryResult<TasksQuery | undefined, TasksQueryVariables>;
export function useTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TasksQuery, TasksQueryVariables>(
    TasksDocument,
    options,
  );
}
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksSuspenseQueryHookResult = ReturnType<
  typeof useTasksSuspenseQuery
>;
export type TasksQueryResult = Apollo.QueryResult<
  TasksQuery,
  TasksQueryVariables
>;
export const ThemeDocument = gql`
  query Theme($name: String!) {
    theme(name: $name) {
      __typename
      ...Theme
      ...DefaultError
    }
  }
  ${ThemeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useThemeQuery__
 *
 * To run a query within a React component, call `useThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useThemeQuery(
  baseOptions: Apollo.QueryHookOptions<ThemeQuery, ThemeQueryVariables> &
    ({ variables: ThemeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThemeQuery, ThemeQueryVariables>(
    ThemeDocument,
    options,
  );
}
export function useThemeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThemeQuery, ThemeQueryVariables>(
    ThemeDocument,
    options,
  );
}
// @ts-ignore
export function useThemeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ThemeQuery,
    ThemeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ThemeQuery, ThemeQueryVariables>;
export function useThemeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemeQuery | undefined, ThemeQueryVariables>;
export function useThemeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ThemeQuery, ThemeQueryVariables>(
    ThemeDocument,
    options,
  );
}
export type ThemeQueryHookResult = ReturnType<typeof useThemeQuery>;
export type ThemeLazyQueryHookResult = ReturnType<typeof useThemeLazyQuery>;
export type ThemeSuspenseQueryHookResult = ReturnType<
  typeof useThemeSuspenseQuery
>;
export type ThemeQueryResult = Apollo.QueryResult<
  ThemeQuery,
  ThemeQueryVariables
>;
export const ThemesDocument = gql`
  query Themes(
    $filter: String
    $orderBy: String
    $pageSize: Int
    $pageToken: String
    $showDeleted: Boolean
  ) {
    themes(
      filter: $filter
      orderBy: $orderBy
      pageSize: $pageSize
      pageToken: $pageToken
      showDeleted: $showDeleted
    ) {
      __typename
      ... on ObservationsV1ListThemesResponse {
        themes {
          ...ThemeRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ThemeRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useThemesQuery__
 *
 * To run a query within a React component, call `useThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useThemesQuery(
  baseOptions?: Apollo.QueryHookOptions<ThemesQuery, ThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThemesQuery, ThemesQueryVariables>(
    ThemesDocument,
    options,
  );
}
export function useThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThemesQuery, ThemesQueryVariables>(
    ThemesDocument,
    options,
  );
}
// @ts-ignore
export function useThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ThemesQuery,
    ThemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ThemesQuery, ThemesQueryVariables>;
export function useThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemesQuery | undefined, ThemesQueryVariables>;
export function useThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ThemesQuery, ThemesQueryVariables>(
    ThemesDocument,
    options,
  );
}
export type ThemesQueryHookResult = ReturnType<typeof useThemesQuery>;
export type ThemesLazyQueryHookResult = ReturnType<typeof useThemesLazyQuery>;
export type ThemesSuspenseQueryHookResult = ReturnType<
  typeof useThemesSuspenseQuery
>;
export type ThemesQueryResult = Apollo.QueryResult<
  ThemesQuery,
  ThemesQueryVariables
>;
export const UpdateIssueDocument = gql`
  mutation UpdateIssue(
    $input: PartialObservationsV1IssueInput!
    $updateMask: String
  ) {
    updateIssue(issue: $input, updateMask: $updateMask) {
      __typename
      ...Issue
      ...DefaultError
    }
  }
  ${IssueFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateIssueMutationFn = Apollo.MutationFunction<
  UpdateIssueMutation,
  UpdateIssueMutationVariables
>;

/**
 * __useUpdateIssueMutation__
 *
 * To run a mutation, you first call `useUpdateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssueMutation, { data, loading, error }] = useUpdateIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIssueMutation,
    UpdateIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateIssueMutation, UpdateIssueMutationVariables>(
    UpdateIssueDocument,
    options,
  );
}
export type UpdateIssueMutationHookResult = ReturnType<
  typeof useUpdateIssueMutation
>;
export type UpdateIssueMutationResult =
  Apollo.MutationResult<UpdateIssueMutation>;
export type UpdateIssueMutationOptions = Apollo.BaseMutationOptions<
  UpdateIssueMutation,
  UpdateIssueMutationVariables
>;
export const UpdateThemeDocument = gql`
  mutation UpdateTheme(
    $input: PartialObservationsV1ThemeInput!
    $updateMask: String
  ) {
    updateTheme(theme: $input, updateMask: $updateMask) {
      __typename
      ...Theme
      ...DefaultError
    }
  }
  ${ThemeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateThemeMutationFn = Apollo.MutationFunction<
  UpdateThemeMutation,
  UpdateThemeMutationVariables
>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateThemeMutation,
    UpdateThemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(
    UpdateThemeDocument,
    options,
  );
}
export type UpdateThemeMutationHookResult = ReturnType<
  typeof useUpdateThemeMutation
>;
export type UpdateThemeMutationResult =
  Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<
  UpdateThemeMutation,
  UpdateThemeMutationVariables
>;
export const DeleteMaterializedSegmentDocument = gql`
  mutation DeleteMaterializedSegment($name: String!) {
    deleteMaterializedSegment(name: $name) {
      __typename
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteMaterializedSegmentMutationFn = Apollo.MutationFunction<
  DeleteMaterializedSegmentMutation,
  DeleteMaterializedSegmentMutationVariables
>;

/**
 * __useDeleteMaterializedSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteMaterializedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterializedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterializedSegmentMutation, { data, loading, error }] = useDeleteMaterializedSegmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteMaterializedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMaterializedSegmentMutation,
    DeleteMaterializedSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMaterializedSegmentMutation,
    DeleteMaterializedSegmentMutationVariables
  >(DeleteMaterializedSegmentDocument, options);
}
export type DeleteMaterializedSegmentMutationHookResult = ReturnType<
  typeof useDeleteMaterializedSegmentMutation
>;
export type DeleteMaterializedSegmentMutationResult =
  Apollo.MutationResult<DeleteMaterializedSegmentMutation>;
export type DeleteMaterializedSegmentMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteMaterializedSegmentMutation,
    DeleteMaterializedSegmentMutationVariables
  >;
export const AssignmentTableDocument = gql`
  query AssignmentTable($name: String!) {
    assignmentTable(name: $name) {
      ...AssignmentTableWithWarehouse
      ...DefaultError
    }
  }
  ${AssignmentTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAssignmentTableQuery__
 *
 * To run a query within a React component, call `useAssignmentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentTableQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAssignmentTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentTableQuery,
    AssignmentTableQueryVariables
  > &
    (
      | { variables: AssignmentTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentTableQuery, AssignmentTableQueryVariables>(
    AssignmentTableDocument,
    options,
  );
}
export function useAssignmentTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentTableQuery,
    AssignmentTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentTableQuery,
    AssignmentTableQueryVariables
  >(AssignmentTableDocument, options);
}
// @ts-ignore
export function useAssignmentTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssignmentTableQuery,
    AssignmentTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssignmentTableQuery,
  AssignmentTableQueryVariables
>;
export function useAssignmentTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentTableQuery,
        AssignmentTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssignmentTableQuery | undefined,
  AssignmentTableQueryVariables
>;
export function useAssignmentTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentTableQuery,
        AssignmentTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentTableQuery,
    AssignmentTableQueryVariables
  >(AssignmentTableDocument, options);
}
export type AssignmentTableQueryHookResult = ReturnType<
  typeof useAssignmentTableQuery
>;
export type AssignmentTableLazyQueryHookResult = ReturnType<
  typeof useAssignmentTableLazyQuery
>;
export type AssignmentTableSuspenseQueryHookResult = ReturnType<
  typeof useAssignmentTableSuspenseQuery
>;
export type AssignmentTableQueryResult = Apollo.QueryResult<
  AssignmentTableQuery,
  AssignmentTableQueryVariables
>;
export const AssignmentTablesDocument = gql`
  query AssignmentTables(
    $filter: String
    $pageToken: String
    $pageSize: Int
    $orderBy: String
  ) {
    assignmentTables(
      filter: $filter
      pageToken: $pageToken
      pageSize: $pageSize
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        nextPageToken
        assignmentTables {
          ...AssignmentTableWithWarehouse
        }
      }
      ...DefaultError
    }
  }
  ${AssignmentTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAssignmentTablesQuery__
 *
 * To run a query within a React component, call `useAssignmentTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAssignmentTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssignmentTablesQuery,
    AssignmentTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentTablesQuery, AssignmentTablesQueryVariables>(
    AssignmentTablesDocument,
    options,
  );
}
export function useAssignmentTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentTablesQuery,
    AssignmentTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentTablesQuery,
    AssignmentTablesQueryVariables
  >(AssignmentTablesDocument, options);
}
// @ts-ignore
export function useAssignmentTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssignmentTablesQuery,
    AssignmentTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssignmentTablesQuery,
  AssignmentTablesQueryVariables
>;
export function useAssignmentTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentTablesQuery,
        AssignmentTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssignmentTablesQuery | undefined,
  AssignmentTablesQueryVariables
>;
export function useAssignmentTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentTablesQuery,
        AssignmentTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentTablesQuery,
    AssignmentTablesQueryVariables
  >(AssignmentTablesDocument, options);
}
export type AssignmentTablesQueryHookResult = ReturnType<
  typeof useAssignmentTablesQuery
>;
export type AssignmentTablesLazyQueryHookResult = ReturnType<
  typeof useAssignmentTablesLazyQuery
>;
export type AssignmentTablesSuspenseQueryHookResult = ReturnType<
  typeof useAssignmentTablesSuspenseQuery
>;
export type AssignmentTablesQueryResult = Apollo.QueryResult<
  AssignmentTablesQuery,
  AssignmentTablesQueryVariables
>;
export const CreateAssignmentTableDocument = gql`
  mutation CreateAssignmentTable(
    $assignmentTable: MetricsV1AssignmentTableInput!
  ) {
    createAssignmentTable(assignmentTable: $assignmentTable) {
      ...AssignmentTable
      ...DefaultError
    }
  }
  ${AssignmentTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAssignmentTableMutationFn = Apollo.MutationFunction<
  CreateAssignmentTableMutation,
  CreateAssignmentTableMutationVariables
>;

/**
 * __useCreateAssignmentTableMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentTableMutation, { data, loading, error }] = useCreateAssignmentTableMutation({
 *   variables: {
 *      assignmentTable: // value for 'assignmentTable'
 *   },
 * });
 */
export function useCreateAssignmentTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssignmentTableMutation,
    CreateAssignmentTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAssignmentTableMutation,
    CreateAssignmentTableMutationVariables
  >(CreateAssignmentTableDocument, options);
}
export type CreateAssignmentTableMutationHookResult = ReturnType<
  typeof useCreateAssignmentTableMutation
>;
export type CreateAssignmentTableMutationResult =
  Apollo.MutationResult<CreateAssignmentTableMutation>;
export type CreateAssignmentTableMutationOptions = Apollo.BaseMutationOptions<
  CreateAssignmentTableMutation,
  CreateAssignmentTableMutationVariables
>;
export const CreateDimensionTableDocument = gql`
  mutation CreateDimensionTable($input: MetricsV1DimensionTableInput!) {
    createDimensionTable(dimensionTable: $input) {
      ...DimensionTable
      ...DefaultError
    }
  }
  ${DimensionTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateDimensionTableMutationFn = Apollo.MutationFunction<
  CreateDimensionTableMutation,
  CreateDimensionTableMutationVariables
>;

/**
 * __useCreateDimensionTableMutation__
 *
 * To run a mutation, you first call `useCreateDimensionTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDimensionTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDimensionTableMutation, { data, loading, error }] = useCreateDimensionTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDimensionTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDimensionTableMutation,
    CreateDimensionTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDimensionTableMutation,
    CreateDimensionTableMutationVariables
  >(CreateDimensionTableDocument, options);
}
export type CreateDimensionTableMutationHookResult = ReturnType<
  typeof useCreateDimensionTableMutation
>;
export type CreateDimensionTableMutationResult =
  Apollo.MutationResult<CreateDimensionTableMutation>;
export type CreateDimensionTableMutationOptions = Apollo.BaseMutationOptions<
  CreateDimensionTableMutation,
  CreateDimensionTableMutationVariables
>;
export const CreateEntityDocument = gql`
  mutation CreateEntity($input: MetricsV1EntityInput!, $entityId: String) {
    createEntity(entity: $input, entityId: $entityId) {
      __typename
      ...Entity
      ...DefaultError
    }
  }
  ${EntityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateEntityMutationFn = Apollo.MutationFunction<
  CreateEntityMutation,
  CreateEntityMutationVariables
>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCreateEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEntityMutation,
    CreateEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEntityMutation,
    CreateEntityMutationVariables
  >(CreateEntityDocument, options);
}
export type CreateEntityMutationHookResult = ReturnType<
  typeof useCreateEntityMutation
>;
export type CreateEntityMutationResult =
  Apollo.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = Apollo.BaseMutationOptions<
  CreateEntityMutation,
  CreateEntityMutationVariables
>;
export const CreateFactTableDocument = gql`
  mutation CreateFactTable($factTable: MetricsV1FactTableInput!) {
    createFactTable(factTable: $factTable) {
      ...FactTable
      ...DefaultError
    }
  }
  ${FactTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateFactTableMutationFn = Apollo.MutationFunction<
  CreateFactTableMutation,
  CreateFactTableMutationVariables
>;

/**
 * __useCreateFactTableMutation__
 *
 * To run a mutation, you first call `useCreateFactTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFactTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFactTableMutation, { data, loading, error }] = useCreateFactTableMutation({
 *   variables: {
 *      factTable: // value for 'factTable'
 *   },
 * });
 */
export function useCreateFactTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFactTableMutation,
    CreateFactTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFactTableMutation,
    CreateFactTableMutationVariables
  >(CreateFactTableDocument, options);
}
export type CreateFactTableMutationHookResult = ReturnType<
  typeof useCreateFactTableMutation
>;
export type CreateFactTableMutationResult =
  Apollo.MutationResult<CreateFactTableMutation>;
export type CreateFactTableMutationOptions = Apollo.BaseMutationOptions<
  CreateFactTableMutation,
  CreateFactTableMutationVariables
>;
export const CreateMeasurementDocument = gql`
  mutation CreateMeasurement(
    $measurement: MetricsV1MeasurementInput!
    $measurementId: String
  ) {
    createMeasurement(
      measurement: $measurement
      measurementId: $measurementId
    ) {
      ...MeasurementRef
      ...DefaultError
    }
  }
  ${MeasurementRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateMeasurementMutationFn = Apollo.MutationFunction<
  CreateMeasurementMutation,
  CreateMeasurementMutationVariables
>;

/**
 * __useCreateMeasurementMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementMutation, { data, loading, error }] = useCreateMeasurementMutation({
 *   variables: {
 *      measurement: // value for 'measurement'
 *      measurementId: // value for 'measurementId'
 *   },
 * });
 */
export function useCreateMeasurementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMeasurementMutation,
    CreateMeasurementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMeasurementMutation,
    CreateMeasurementMutationVariables
  >(CreateMeasurementDocument, options);
}
export type CreateMeasurementMutationHookResult = ReturnType<
  typeof useCreateMeasurementMutation
>;
export type CreateMeasurementMutationResult =
  Apollo.MutationResult<CreateMeasurementMutation>;
export type CreateMeasurementMutationOptions = Apollo.BaseMutationOptions<
  CreateMeasurementMutation,
  CreateMeasurementMutationVariables
>;
export const CreateQueryPreviewDocument = gql`
  mutation CreateQueryPreview($query: String!, $dataWarehouse: String) {
    previewSqlQuery(query: $query, dataWarehouse: $dataWarehouse) {
      ... on MetricsV1PreviewSqlQueryResponse {
        __typename
        job
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateQueryPreviewMutationFn = Apollo.MutationFunction<
  CreateQueryPreviewMutation,
  CreateQueryPreviewMutationVariables
>;

/**
 * __useCreateQueryPreviewMutation__
 *
 * To run a mutation, you first call `useCreateQueryPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryPreviewMutation, { data, loading, error }] = useCreateQueryPreviewMutation({
 *   variables: {
 *      query: // value for 'query'
 *      dataWarehouse: // value for 'dataWarehouse'
 *   },
 * });
 */
export function useCreateQueryPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateQueryPreviewMutation,
    CreateQueryPreviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateQueryPreviewMutation,
    CreateQueryPreviewMutationVariables
  >(CreateQueryPreviewDocument, options);
}
export type CreateQueryPreviewMutationHookResult = ReturnType<
  typeof useCreateQueryPreviewMutation
>;
export type CreateQueryPreviewMutationResult =
  Apollo.MutationResult<CreateQueryPreviewMutation>;
export type CreateQueryPreviewMutationOptions = Apollo.BaseMutationOptions<
  CreateQueryPreviewMutation,
  CreateQueryPreviewMutationVariables
>;
export const DataWarehouseExistsDocument = gql`
  query DataWarehouseExists {
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
      }
      ...DefaultError
    }
    currentAccount {
      ... on AdminV1AccountInfo {
        __typename
        mode
        totalConfidenceAccountInfo {
          state
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDataWarehouseExistsQuery__
 *
 * To run a query within a React component, call `useDataWarehouseExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataWarehouseExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataWarehouseExistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataWarehouseExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >(DataWarehouseExistsDocument, options);
}
export function useDataWarehouseExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >(DataWarehouseExistsDocument, options);
}
// @ts-ignore
export function useDataWarehouseExistsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataWarehouseExistsQuery,
  DataWarehouseExistsQueryVariables
>;
export function useDataWarehouseExistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataWarehouseExistsQuery,
        DataWarehouseExistsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataWarehouseExistsQuery | undefined,
  DataWarehouseExistsQueryVariables
>;
export function useDataWarehouseExistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataWarehouseExistsQuery,
        DataWarehouseExistsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataWarehouseExistsQuery,
    DataWarehouseExistsQueryVariables
  >(DataWarehouseExistsDocument, options);
}
export type DataWarehouseExistsQueryHookResult = ReturnType<
  typeof useDataWarehouseExistsQuery
>;
export type DataWarehouseExistsLazyQueryHookResult = ReturnType<
  typeof useDataWarehouseExistsLazyQuery
>;
export type DataWarehouseExistsSuspenseQueryHookResult = ReturnType<
  typeof useDataWarehouseExistsSuspenseQuery
>;
export type DataWarehouseExistsQueryResult = Apollo.QueryResult<
  DataWarehouseExistsQuery,
  DataWarehouseExistsQueryVariables
>;
export const DataWarehousesDocument = gql`
  query DataWarehouses {
    dataWarehouses {
      ... on MetricsV1ListDataWarehousesResponse {
        __typename
        dataWarehouses {
          ...DataWarehouseRef
        }
      }
      ...DefaultError
    }
  }
  ${DataWarehouseRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDataWarehousesQuery__
 *
 * To run a query within a React component, call `useDataWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataWarehousesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DataWarehousesQuery,
    DataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DataWarehousesQuery, DataWarehousesQueryVariables>(
    DataWarehousesDocument,
    options,
  );
}
export function useDataWarehousesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataWarehousesQuery,
    DataWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DataWarehousesQuery, DataWarehousesQueryVariables>(
    DataWarehousesDocument,
    options,
  );
}
// @ts-ignore
export function useDataWarehousesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataWarehousesQuery,
    DataWarehousesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataWarehousesQuery,
  DataWarehousesQueryVariables
>;
export function useDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataWarehousesQuery,
        DataWarehousesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataWarehousesQuery | undefined,
  DataWarehousesQueryVariables
>;
export function useDataWarehousesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataWarehousesQuery,
        DataWarehousesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataWarehousesQuery,
    DataWarehousesQueryVariables
  >(DataWarehousesDocument, options);
}
export type DataWarehousesQueryHookResult = ReturnType<
  typeof useDataWarehousesQuery
>;
export type DataWarehousesLazyQueryHookResult = ReturnType<
  typeof useDataWarehousesLazyQuery
>;
export type DataWarehousesSuspenseQueryHookResult = ReturnType<
  typeof useDataWarehousesSuspenseQuery
>;
export type DataWarehousesQueryResult = Apollo.QueryResult<
  DataWarehousesQuery,
  DataWarehousesQueryVariables
>;
export const DeleteAssignmentTableDocument = gql`
  mutation DeleteAssignmentTable($name: String!) {
    deleteAssignmentTable(name: $name) {
      ...AssignmentTable
      ...DefaultError
    }
  }
  ${AssignmentTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteAssignmentTableMutationFn = Apollo.MutationFunction<
  DeleteAssignmentTableMutation,
  DeleteAssignmentTableMutationVariables
>;

/**
 * __useDeleteAssignmentTableMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentTableMutation, { data, loading, error }] = useDeleteAssignmentTableMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAssignmentTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAssignmentTableMutation,
    DeleteAssignmentTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAssignmentTableMutation,
    DeleteAssignmentTableMutationVariables
  >(DeleteAssignmentTableDocument, options);
}
export type DeleteAssignmentTableMutationHookResult = ReturnType<
  typeof useDeleteAssignmentTableMutation
>;
export type DeleteAssignmentTableMutationResult =
  Apollo.MutationResult<DeleteAssignmentTableMutation>;
export type DeleteAssignmentTableMutationOptions = Apollo.BaseMutationOptions<
  DeleteAssignmentTableMutation,
  DeleteAssignmentTableMutationVariables
>;
export const DeleteDimensionTableDocument = gql`
  mutation DeleteDimensionTable($name: String!) {
    deleteDimensionTable(name: $name) {
      ...DimensionTable
      ...DefaultError
    }
  }
  ${DimensionTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteDimensionTableMutationFn = Apollo.MutationFunction<
  DeleteDimensionTableMutation,
  DeleteDimensionTableMutationVariables
>;

/**
 * __useDeleteDimensionTableMutation__
 *
 * To run a mutation, you first call `useDeleteDimensionTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDimensionTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDimensionTableMutation, { data, loading, error }] = useDeleteDimensionTableMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteDimensionTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDimensionTableMutation,
    DeleteDimensionTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDimensionTableMutation,
    DeleteDimensionTableMutationVariables
  >(DeleteDimensionTableDocument, options);
}
export type DeleteDimensionTableMutationHookResult = ReturnType<
  typeof useDeleteDimensionTableMutation
>;
export type DeleteDimensionTableMutationResult =
  Apollo.MutationResult<DeleteDimensionTableMutation>;
export type DeleteDimensionTableMutationOptions = Apollo.BaseMutationOptions<
  DeleteDimensionTableMutation,
  DeleteDimensionTableMutationVariables
>;
export const DeleteEntityDocument = gql`
  mutation DeleteEntity($name: String!) {
    deleteEntity(name: $name) {
      __typename
      ... on GoogleProtobufEmpty {
        dummy
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteEntityMutationFn = Apollo.MutationFunction<
  DeleteEntityMutation,
  DeleteEntityMutationVariables
>;

/**
 * __useDeleteEntityMutation__
 *
 * To run a mutation, you first call `useDeleteEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityMutation, { data, loading, error }] = useDeleteEntityMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEntityMutation,
    DeleteEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEntityMutation,
    DeleteEntityMutationVariables
  >(DeleteEntityDocument, options);
}
export type DeleteEntityMutationHookResult = ReturnType<
  typeof useDeleteEntityMutation
>;
export type DeleteEntityMutationResult =
  Apollo.MutationResult<DeleteEntityMutation>;
export type DeleteEntityMutationOptions = Apollo.BaseMutationOptions<
  DeleteEntityMutation,
  DeleteEntityMutationVariables
>;
export const DeleteFactTableDocument = gql`
  mutation DeleteFactTable($name: String!) {
    deleteFactTable(name: $name) {
      ...FactTable
      ...DefaultError
    }
  }
  ${FactTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteFactTableMutationFn = Apollo.MutationFunction<
  DeleteFactTableMutation,
  DeleteFactTableMutationVariables
>;

/**
 * __useDeleteFactTableMutation__
 *
 * To run a mutation, you first call `useDeleteFactTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFactTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFactTableMutation, { data, loading, error }] = useDeleteFactTableMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteFactTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFactTableMutation,
    DeleteFactTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFactTableMutation,
    DeleteFactTableMutationVariables
  >(DeleteFactTableDocument, options);
}
export type DeleteFactTableMutationHookResult = ReturnType<
  typeof useDeleteFactTableMutation
>;
export type DeleteFactTableMutationResult =
  Apollo.MutationResult<DeleteFactTableMutation>;
export type DeleteFactTableMutationOptions = Apollo.BaseMutationOptions<
  DeleteFactTableMutation,
  DeleteFactTableMutationVariables
>;
export const DimensionTableDocument = gql`
  query DimensionTable($name: String!) {
    dimensionTable(name: $name) {
      ...DimensionTableWithWarehouse
      ...DefaultError
    }
  }
  ${DimensionTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDimensionTableQuery__
 *
 * To run a query within a React component, call `useDimensionTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionTableQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDimensionTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    DimensionTableQuery,
    DimensionTableQueryVariables
  > &
    (
      | { variables: DimensionTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DimensionTableQuery, DimensionTableQueryVariables>(
    DimensionTableDocument,
    options,
  );
}
export function useDimensionTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimensionTableQuery,
    DimensionTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DimensionTableQuery, DimensionTableQueryVariables>(
    DimensionTableDocument,
    options,
  );
}
// @ts-ignore
export function useDimensionTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimensionTableQuery,
    DimensionTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DimensionTableQuery,
  DimensionTableQueryVariables
>;
export function useDimensionTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTableQuery,
        DimensionTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DimensionTableQuery | undefined,
  DimensionTableQueryVariables
>;
export function useDimensionTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTableQuery,
        DimensionTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DimensionTableQuery,
    DimensionTableQueryVariables
  >(DimensionTableDocument, options);
}
export type DimensionTableQueryHookResult = ReturnType<
  typeof useDimensionTableQuery
>;
export type DimensionTableLazyQueryHookResult = ReturnType<
  typeof useDimensionTableLazyQuery
>;
export type DimensionTableSuspenseQueryHookResult = ReturnType<
  typeof useDimensionTableSuspenseQuery
>;
export type DimensionTableQueryResult = Apollo.QueryResult<
  DimensionTableQuery,
  DimensionTableQueryVariables
>;
export const DimensionTablesDocument = gql`
  query DimensionTables($filter: String, $pageSize: Int, $pageToken: String) {
    dimensionTables(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MetricsV1ListDimensionTablesResponse {
        __typename
        dimensionTables {
          ...DimensionTableWithWarehouse
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DimensionTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDimensionTablesQuery__
 *
 * To run a query within a React component, call `useDimensionTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useDimensionTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DimensionTablesQuery,
    DimensionTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DimensionTablesQuery, DimensionTablesQueryVariables>(
    DimensionTablesDocument,
    options,
  );
}
export function useDimensionTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimensionTablesQuery,
    DimensionTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DimensionTablesQuery,
    DimensionTablesQueryVariables
  >(DimensionTablesDocument, options);
}
// @ts-ignore
export function useDimensionTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimensionTablesQuery,
    DimensionTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablesQuery,
  DimensionTablesQueryVariables
>;
export function useDimensionTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablesQuery,
        DimensionTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablesQuery | undefined,
  DimensionTablesQueryVariables
>;
export function useDimensionTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablesQuery,
        DimensionTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DimensionTablesQuery,
    DimensionTablesQueryVariables
  >(DimensionTablesDocument, options);
}
export type DimensionTablesQueryHookResult = ReturnType<
  typeof useDimensionTablesQuery
>;
export type DimensionTablesLazyQueryHookResult = ReturnType<
  typeof useDimensionTablesLazyQuery
>;
export type DimensionTablesSuspenseQueryHookResult = ReturnType<
  typeof useDimensionTablesSuspenseQuery
>;
export type DimensionTablesQueryResult = Apollo.QueryResult<
  DimensionTablesQuery,
  DimensionTablesQueryVariables
>;
export const EntitiesDocument = gql`
  query Entities(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    entities(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        nextPageToken
        entities {
          ...Entity
        }
      }
      ...DefaultError
    }
  }
  ${EntityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEntitiesQuery__
 *
 * To run a query within a React component, call `useEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useEntitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<EntitiesQuery, EntitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntitiesQuery, EntitiesQueryVariables>(
    EntitiesDocument,
    options,
  );
}
export function useEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntitiesQuery,
    EntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntitiesQuery, EntitiesQueryVariables>(
    EntitiesDocument,
    options,
  );
}
// @ts-ignore
export function useEntitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntitiesQuery,
    EntitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EntitiesQuery, EntitiesQueryVariables>;
export function useEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EntitiesQuery | undefined,
  EntitiesQueryVariables
>;
export function useEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntitiesQuery, EntitiesQueryVariables>(
    EntitiesDocument,
    options,
  );
}
export type EntitiesQueryHookResult = ReturnType<typeof useEntitiesQuery>;
export type EntitiesLazyQueryHookResult = ReturnType<
  typeof useEntitiesLazyQuery
>;
export type EntitiesSuspenseQueryHookResult = ReturnType<
  typeof useEntitiesSuspenseQuery
>;
export type EntitiesQueryResult = Apollo.QueryResult<
  EntitiesQuery,
  EntitiesQueryVariables
>;
export const EntityDocument = gql`
  query Entity($name: String!) {
    entity(name: $name) {
      __typename
      ...Entity
      ...DefaultError
    }
  }
  ${EntityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEntityQuery__
 *
 * To run a query within a React component, call `useEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityQuery(
  baseOptions: Apollo.QueryHookOptions<EntityQuery, EntityQueryVariables> &
    ({ variables: EntityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntityQuery, EntityQueryVariables>(
    EntityDocument,
    options,
  );
}
export function useEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EntityQuery, EntityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntityQuery, EntityQueryVariables>(
    EntityDocument,
    options,
  );
}
// @ts-ignore
export function useEntitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntityQuery,
    EntityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EntityQuery, EntityQueryVariables>;
export function useEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<EntityQuery | undefined, EntityQueryVariables>;
export function useEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntityQuery, EntityQueryVariables>(
    EntityDocument,
    options,
  );
}
export type EntityQueryHookResult = ReturnType<typeof useEntityQuery>;
export type EntityLazyQueryHookResult = ReturnType<typeof useEntityLazyQuery>;
export type EntitySuspenseQueryHookResult = ReturnType<
  typeof useEntitySuspenseQuery
>;
export type EntityQueryResult = Apollo.QueryResult<
  EntityQuery,
  EntityQueryVariables
>;
export const EntityRefDocument = gql`
  query EntityRef($name: String!) {
    entity(name: $name) {
      __typename
      ...DefaultError
      ...EntityRef
    }
  }
  ${DefaultErrorFragmentDoc}
  ${EntityRefFragmentDoc}
`;

/**
 * __useEntityRefQuery__
 *
 * To run a query within a React component, call `useEntityRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    EntityRefQuery,
    EntityRefQueryVariables
  > &
    (
      | { variables: EntityRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntityRefQuery, EntityRefQueryVariables>(
    EntityRefDocument,
    options,
  );
}
export function useEntityRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntityRefQuery,
    EntityRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntityRefQuery, EntityRefQueryVariables>(
    EntityRefDocument,
    options,
  );
}
// @ts-ignore
export function useEntityRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntityRefQuery,
    EntityRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EntityRefQuery, EntityRefQueryVariables>;
export function useEntityRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityRefQuery, EntityRefQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EntityRefQuery | undefined,
  EntityRefQueryVariables
>;
export function useEntityRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityRefQuery, EntityRefQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntityRefQuery, EntityRefQueryVariables>(
    EntityRefDocument,
    options,
  );
}
export type EntityRefQueryHookResult = ReturnType<typeof useEntityRefQuery>;
export type EntityRefLazyQueryHookResult = ReturnType<
  typeof useEntityRefLazyQuery
>;
export type EntityRefSuspenseQueryHookResult = ReturnType<
  typeof useEntityRefSuspenseQuery
>;
export type EntityRefQueryResult = Apollo.QueryResult<
  EntityRefQuery,
  EntityRefQueryVariables
>;
export const FactTableDocument = gql`
  query FactTable($name: String!) {
    factTable(name: $name) {
      ...FactTableWithWarehouse
      ...DefaultError
    }
  }
  ${FactTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFactTableQuery__
 *
 * To run a query within a React component, call `useFactTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactTableQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFactTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    FactTableQuery,
    FactTableQueryVariables
  > &
    (
      | { variables: FactTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FactTableQuery, FactTableQueryVariables>(
    FactTableDocument,
    options,
  );
}
export function useFactTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FactTableQuery,
    FactTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FactTableQuery, FactTableQueryVariables>(
    FactTableDocument,
    options,
  );
}
// @ts-ignore
export function useFactTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FactTableQuery,
    FactTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FactTableQuery, FactTableQueryVariables>;
export function useFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FactTableQuery, FactTableQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  FactTableQuery | undefined,
  FactTableQueryVariables
>;
export function useFactTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FactTableQuery, FactTableQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FactTableQuery, FactTableQueryVariables>(
    FactTableDocument,
    options,
  );
}
export type FactTableQueryHookResult = ReturnType<typeof useFactTableQuery>;
export type FactTableLazyQueryHookResult = ReturnType<
  typeof useFactTableLazyQuery
>;
export type FactTableSuspenseQueryHookResult = ReturnType<
  typeof useFactTableSuspenseQuery
>;
export type FactTableQueryResult = Apollo.QueryResult<
  FactTableQuery,
  FactTableQueryVariables
>;
export const FactTablesDocument = gql`
  query FactTables($filter: String, $pageSize: Int, $pageToken: String) {
    factTables(filter: $filter, pageSize: $pageSize, pageToken: $pageToken) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          ...FactTableWithWarehouse
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FactTableWithWarehouseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFactTablesQuery__
 *
 * To run a query within a React component, call `useFactTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFactTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FactTablesQuery,
    FactTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FactTablesQuery, FactTablesQueryVariables>(
    FactTablesDocument,
    options,
  );
}
export function useFactTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FactTablesQuery,
    FactTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FactTablesQuery, FactTablesQueryVariables>(
    FactTablesDocument,
    options,
  );
}
// @ts-ignore
export function useFactTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FactTablesQuery,
    FactTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FactTablesQuery, FactTablesQueryVariables>;
export function useFactTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTablesQuery,
        FactTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FactTablesQuery | undefined,
  FactTablesQueryVariables
>;
export function useFactTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTablesQuery,
        FactTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FactTablesQuery, FactTablesQueryVariables>(
    FactTablesDocument,
    options,
  );
}
export type FactTablesQueryHookResult = ReturnType<typeof useFactTablesQuery>;
export type FactTablesLazyQueryHookResult = ReturnType<
  typeof useFactTablesLazyQuery
>;
export type FactTablesSuspenseQueryHookResult = ReturnType<
  typeof useFactTablesSuspenseQuery
>;
export type FactTablesQueryResult = Apollo.QueryResult<
  FactTablesQuery,
  FactTablesQueryVariables
>;
export const GetFactTableColumnsDocument = gql`
  query GetFactTableColumns($name: String!) {
    factTable(name: $name) {
      ... on MetricsV1FactTable {
        __typename
        name
        measures {
          column {
            name
            type
          }
          displayName
        }
        dimensions {
          name
          type
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetFactTableColumnsQuery__
 *
 * To run a query within a React component, call `useGetFactTableColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactTableColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactTableColumnsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFactTableColumnsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  > &
    (
      | { variables: GetFactTableColumnsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  >(GetFactTableColumnsDocument, options);
}
export function useGetFactTableColumnsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  >(GetFactTableColumnsDocument, options);
}
// @ts-ignore
export function useGetFactTableColumnsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFactTableColumnsQuery,
  GetFactTableColumnsQueryVariables
>;
export function useGetFactTableColumnsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFactTableColumnsQuery,
        GetFactTableColumnsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFactTableColumnsQuery | undefined,
  GetFactTableColumnsQueryVariables
>;
export function useGetFactTableColumnsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFactTableColumnsQuery,
        GetFactTableColumnsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFactTableColumnsQuery,
    GetFactTableColumnsQueryVariables
  >(GetFactTableColumnsDocument, options);
}
export type GetFactTableColumnsQueryHookResult = ReturnType<
  typeof useGetFactTableColumnsQuery
>;
export type GetFactTableColumnsLazyQueryHookResult = ReturnType<
  typeof useGetFactTableColumnsLazyQuery
>;
export type GetFactTableColumnsSuspenseQueryHookResult = ReturnType<
  typeof useGetFactTableColumnsSuspenseQuery
>;
export type GetFactTableColumnsQueryResult = Apollo.QueryResult<
  GetFactTableColumnsQuery,
  GetFactTableColumnsQueryVariables
>;
export const GetQueryPreviewDocument = gql`
  query GetQueryPreview($jobId: String!) {
    sampleRows(name: $jobId) {
      ... on MetricsV1SampleRows {
        __typename
        successfulQueryResult {
          schema {
            name
            type
          }
          tableIssues {
            message
            severity
          }
        }
        failedQueryResult {
          error
        }
        sampleRows {
          values {
            key
            value
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetQueryPreviewQuery__
 *
 * To run a query within a React component, call `useGetQueryPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryPreviewQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetQueryPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryPreviewQuery,
    GetQueryPreviewQueryVariables
  > &
    (
      | { variables: GetQueryPreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueryPreviewQuery, GetQueryPreviewQueryVariables>(
    GetQueryPreviewDocument,
    options,
  );
}
export function useGetQueryPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryPreviewQuery,
    GetQueryPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueryPreviewQuery,
    GetQueryPreviewQueryVariables
  >(GetQueryPreviewDocument, options);
}
// @ts-ignore
export function useGetQueryPreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryPreviewQuery,
    GetQueryPreviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueryPreviewQuery,
  GetQueryPreviewQueryVariables
>;
export function useGetQueryPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPreviewQuery,
        GetQueryPreviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryPreviewQuery | undefined,
  GetQueryPreviewQueryVariables
>;
export function useGetQueryPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryPreviewQuery,
        GetQueryPreviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueryPreviewQuery,
    GetQueryPreviewQueryVariables
  >(GetQueryPreviewDocument, options);
}
export type GetQueryPreviewQueryHookResult = ReturnType<
  typeof useGetQueryPreviewQuery
>;
export type GetQueryPreviewLazyQueryHookResult = ReturnType<
  typeof useGetQueryPreviewLazyQuery
>;
export type GetQueryPreviewSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryPreviewSuspenseQuery
>;
export type GetQueryPreviewQueryResult = Apollo.QueryResult<
  GetQueryPreviewQuery,
  GetQueryPreviewQueryVariables
>;
export const GetSqlJobDocument = gql`
  query GetSQLJob($name: String!) {
    sqlJob(name: $name) {
      ... on MetricsV1SqlJob {
        __typename
        state
        failedQueryResult {
          error
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetSqlJobQuery__
 *
 * To run a query within a React component, call `useGetSqlJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSqlJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSqlJobQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSqlJobQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSqlJobQuery,
    GetSqlJobQueryVariables
  > &
    (
      | { variables: GetSqlJobQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSqlJobQuery, GetSqlJobQueryVariables>(
    GetSqlJobDocument,
    options,
  );
}
export function useGetSqlJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSqlJobQuery,
    GetSqlJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSqlJobQuery, GetSqlJobQueryVariables>(
    GetSqlJobDocument,
    options,
  );
}
// @ts-ignore
export function useGetSqlJobSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSqlJobQuery,
    GetSqlJobQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSqlJobQuery, GetSqlJobQueryVariables>;
export function useGetSqlJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSqlJobQuery, GetSqlJobQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetSqlJobQuery | undefined,
  GetSqlJobQueryVariables
>;
export function useGetSqlJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSqlJobQuery, GetSqlJobQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSqlJobQuery, GetSqlJobQueryVariables>(
    GetSqlJobDocument,
    options,
  );
}
export type GetSqlJobQueryHookResult = ReturnType<typeof useGetSqlJobQuery>;
export type GetSqlJobLazyQueryHookResult = ReturnType<
  typeof useGetSqlJobLazyQuery
>;
export type GetSqlJobSuspenseQueryHookResult = ReturnType<
  typeof useGetSqlJobSuspenseQuery
>;
export type GetSqlJobQueryResult = Apollo.QueryResult<
  GetSqlJobQuery,
  GetSqlJobQueryVariables
>;
export const ListFactTablesDocument = gql`
  query ListFactTables($filter: String, $pageToken: String) {
    factTables(pageSize: 100, filter: $filter, pageToken: $pageToken) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          ...FactTableOption
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FactTableOptionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListFactTablesQuery__
 *
 * To run a query within a React component, call `useListFactTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFactTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFactTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useListFactTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListFactTablesQuery,
    ListFactTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListFactTablesQuery, ListFactTablesQueryVariables>(
    ListFactTablesDocument,
    options,
  );
}
export function useListFactTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListFactTablesQuery,
    ListFactTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListFactTablesQuery, ListFactTablesQueryVariables>(
    ListFactTablesDocument,
    options,
  );
}
// @ts-ignore
export function useListFactTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListFactTablesQuery,
    ListFactTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListFactTablesQuery,
  ListFactTablesQueryVariables
>;
export function useListFactTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFactTablesQuery,
        ListFactTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListFactTablesQuery | undefined,
  ListFactTablesQueryVariables
>;
export function useListFactTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFactTablesQuery,
        ListFactTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListFactTablesQuery,
    ListFactTablesQueryVariables
  >(ListFactTablesDocument, options);
}
export type ListFactTablesQueryHookResult = ReturnType<
  typeof useListFactTablesQuery
>;
export type ListFactTablesLazyQueryHookResult = ReturnType<
  typeof useListFactTablesLazyQuery
>;
export type ListFactTablesSuspenseQueryHookResult = ReturnType<
  typeof useListFactTablesSuspenseQuery
>;
export type ListFactTablesQueryResult = Apollo.QueryResult<
  ListFactTablesQuery,
  ListFactTablesQueryVariables
>;
export const MeasurementRefsDocument = gql`
  query MeasurementRefs($filter: String, $pageSize: Int, $pageToken: String) {
    measurements(filter: $filter, pageSize: $pageSize, pageToken: $pageToken) {
      ... on MetricsV1ListMeasurementsResponse {
        __typename
        measurements {
          ...MeasurementRef
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MeasurementRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMeasurementRefsQuery__
 *
 * To run a query within a React component, call `useMeasurementRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurementRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurementRefsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMeasurementRefsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MeasurementRefsQuery,
    MeasurementRefsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeasurementRefsQuery, MeasurementRefsQueryVariables>(
    MeasurementRefsDocument,
    options,
  );
}
export function useMeasurementRefsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeasurementRefsQuery,
    MeasurementRefsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MeasurementRefsQuery,
    MeasurementRefsQueryVariables
  >(MeasurementRefsDocument, options);
}
// @ts-ignore
export function useMeasurementRefsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MeasurementRefsQuery,
    MeasurementRefsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MeasurementRefsQuery,
  MeasurementRefsQueryVariables
>;
export function useMeasurementRefsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementRefsQuery,
        MeasurementRefsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MeasurementRefsQuery | undefined,
  MeasurementRefsQueryVariables
>;
export function useMeasurementRefsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementRefsQuery,
        MeasurementRefsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MeasurementRefsQuery,
    MeasurementRefsQueryVariables
  >(MeasurementRefsDocument, options);
}
export type MeasurementRefsQueryHookResult = ReturnType<
  typeof useMeasurementRefsQuery
>;
export type MeasurementRefsLazyQueryHookResult = ReturnType<
  typeof useMeasurementRefsLazyQuery
>;
export type MeasurementRefsSuspenseQueryHookResult = ReturnType<
  typeof useMeasurementRefsSuspenseQuery
>;
export type MeasurementRefsQueryResult = Apollo.QueryResult<
  MeasurementRefsQuery,
  MeasurementRefsQueryVariables
>;
export const MultipleMetricsPickerDocument = gql`
  query MultipleMetricsPicker(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    metrics(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      __typename
      ... on MetricsV1ListMetricsResponse {
        nextPageToken
        metrics {
          ...MetricPicker
        }
      }
      ...DefaultError
    }
  }
  ${MetricPickerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMultipleMetricsPickerQuery__
 *
 * To run a query within a React component, call `useMultipleMetricsPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultipleMetricsPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultipleMetricsPickerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMultipleMetricsPickerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >(MultipleMetricsPickerDocument, options);
}
export function useMultipleMetricsPickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >(MultipleMetricsPickerDocument, options);
}
// @ts-ignore
export function useMultipleMetricsPickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MultipleMetricsPickerQuery,
  MultipleMetricsPickerQueryVariables
>;
export function useMultipleMetricsPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MultipleMetricsPickerQuery,
        MultipleMetricsPickerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MultipleMetricsPickerQuery | undefined,
  MultipleMetricsPickerQueryVariables
>;
export function useMultipleMetricsPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MultipleMetricsPickerQuery,
        MultipleMetricsPickerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MultipleMetricsPickerQuery,
    MultipleMetricsPickerQueryVariables
  >(MultipleMetricsPickerDocument, options);
}
export type MultipleMetricsPickerQueryHookResult = ReturnType<
  typeof useMultipleMetricsPickerQuery
>;
export type MultipleMetricsPickerLazyQueryHookResult = ReturnType<
  typeof useMultipleMetricsPickerLazyQuery
>;
export type MultipleMetricsPickerSuspenseQueryHookResult = ReturnType<
  typeof useMultipleMetricsPickerSuspenseQuery
>;
export type MultipleMetricsPickerQueryResult = Apollo.QueryResult<
  MultipleMetricsPickerQuery,
  MultipleMetricsPickerQueryVariables
>;
export const OnAssignmentTableCreatedDocument = gql`
  subscription OnAssignmentTableCreated {
    assignmentTableCreated {
      assignmentTable {
        ...AssignmentTable
      }
    }
  }
  ${AssignmentTableFragmentDoc}
`;

/**
 * __useOnAssignmentTableCreatedSubscription__
 *
 * To run a query within a React component, call `useOnAssignmentTableCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAssignmentTableCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAssignmentTableCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAssignmentTableCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnAssignmentTableCreatedSubscription,
    OnAssignmentTableCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnAssignmentTableCreatedSubscription,
    OnAssignmentTableCreatedSubscriptionVariables
  >(OnAssignmentTableCreatedDocument, options);
}
export type OnAssignmentTableCreatedSubscriptionHookResult = ReturnType<
  typeof useOnAssignmentTableCreatedSubscription
>;
export type OnAssignmentTableCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnAssignmentTableCreatedSubscription>;
export const OnAssignmentTableUpdatedDocument = gql`
  subscription OnAssignmentTableUpdated {
    assignmentTableUpdated {
      assignmentTable {
        ...AssignmentTable
      }
    }
  }
  ${AssignmentTableFragmentDoc}
`;

/**
 * __useOnAssignmentTableUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAssignmentTableUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAssignmentTableUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAssignmentTableUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAssignmentTableUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnAssignmentTableUpdatedSubscription,
    OnAssignmentTableUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnAssignmentTableUpdatedSubscription,
    OnAssignmentTableUpdatedSubscriptionVariables
  >(OnAssignmentTableUpdatedDocument, options);
}
export type OnAssignmentTableUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnAssignmentTableUpdatedSubscription
>;
export type OnAssignmentTableUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnAssignmentTableUpdatedSubscription>;
export const OnDimensionTableCreatedDocument = gql`
  subscription OnDimensionTableCreated {
    dimensionTableCreated {
      dimensionTable {
        ...DimensionTable
      }
    }
  }
  ${DimensionTableFragmentDoc}
`;

/**
 * __useOnDimensionTableCreatedSubscription__
 *
 * To run a query within a React component, call `useOnDimensionTableCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDimensionTableCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDimensionTableCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDimensionTableCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnDimensionTableCreatedSubscription,
    OnDimensionTableCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnDimensionTableCreatedSubscription,
    OnDimensionTableCreatedSubscriptionVariables
  >(OnDimensionTableCreatedDocument, options);
}
export type OnDimensionTableCreatedSubscriptionHookResult = ReturnType<
  typeof useOnDimensionTableCreatedSubscription
>;
export type OnDimensionTableCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnDimensionTableCreatedSubscription>;
export const OnDimensionTableUpdatedDocument = gql`
  subscription OnDimensionTableUpdated {
    dimensionTableUpdated {
      dimensionTable {
        ...DimensionTable
      }
    }
  }
  ${DimensionTableFragmentDoc}
`;

/**
 * __useOnDimensionTableUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnDimensionTableUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDimensionTableUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDimensionTableUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDimensionTableUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnDimensionTableUpdatedSubscription,
    OnDimensionTableUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnDimensionTableUpdatedSubscription,
    OnDimensionTableUpdatedSubscriptionVariables
  >(OnDimensionTableUpdatedDocument, options);
}
export type OnDimensionTableUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnDimensionTableUpdatedSubscription
>;
export type OnDimensionTableUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnDimensionTableUpdatedSubscription>;
export const OnEntityCreatedDocument = gql`
  subscription OnEntityCreated {
    entityCreated {
      entity {
        ...Entity
      }
    }
  }
  ${EntityFragmentDoc}
`;

/**
 * __useOnEntityCreatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEntityCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnEntityCreatedSubscription,
    OnEntityCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEntityCreatedSubscription,
    OnEntityCreatedSubscriptionVariables
  >(OnEntityCreatedDocument, options);
}
export type OnEntityCreatedSubscriptionHookResult = ReturnType<
  typeof useOnEntityCreatedSubscription
>;
export type OnEntityCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnEntityCreatedSubscription>;
export const OnEntityUpdatedDocument = gql`
  subscription OnEntityUpdated {
    entityUpdated {
      entity {
        ...Entity
      }
    }
  }
  ${EntityFragmentDoc}
`;

/**
 * __useOnEntityUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEntityUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnEntityUpdatedSubscription,
    OnEntityUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnEntityUpdatedSubscription,
    OnEntityUpdatedSubscriptionVariables
  >(OnEntityUpdatedDocument, options);
}
export type OnEntityUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnEntityUpdatedSubscription
>;
export type OnEntityUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnEntityUpdatedSubscription>;
export const OnFactTableCreatedDocument = gql`
  subscription OnFactTableCreated {
    factTableCreated {
      factTable {
        ...FactTable
      }
    }
  }
  ${FactTableFragmentDoc}
`;

/**
 * __useOnFactTableCreatedSubscription__
 *
 * To run a query within a React component, call `useOnFactTableCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFactTableCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFactTableCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnFactTableCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnFactTableCreatedSubscription,
    OnFactTableCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFactTableCreatedSubscription,
    OnFactTableCreatedSubscriptionVariables
  >(OnFactTableCreatedDocument, options);
}
export type OnFactTableCreatedSubscriptionHookResult = ReturnType<
  typeof useOnFactTableCreatedSubscription
>;
export type OnFactTableCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnFactTableCreatedSubscription>;
export const OnFactTableUpdatedDocument = gql`
  subscription OnFactTableUpdated {
    factTableUpdated {
      factTable {
        ...FactTable
      }
    }
  }
  ${FactTableFragmentDoc}
`;

/**
 * __useOnFactTableUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnFactTableUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFactTableUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFactTableUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnFactTableUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnFactTableUpdatedSubscription,
    OnFactTableUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFactTableUpdatedSubscription,
    OnFactTableUpdatedSubscriptionVariables
  >(OnFactTableUpdatedDocument, options);
}
export type OnFactTableUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnFactTableUpdatedSubscription
>;
export type OnFactTableUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnFactTableUpdatedSubscription>;
export const PartitionsDocument = gql`
  query Partitions($parent: String!, $pageSize: Int, $pageToken: String) {
    partitions(parent: $parent, pageSize: $pageSize, pageToken: $pageToken) {
      __typename
      ... on MetricsV1ListPartitionsResponse {
        partitions {
          ...Partition
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PartitionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePartitionsQuery__
 *
 * To run a query within a React component, call `usePartitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartitionsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePartitionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartitionsQuery,
    PartitionsQueryVariables
  > &
    (
      | { variables: PartitionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PartitionsQuery, PartitionsQueryVariables>(
    PartitionsDocument,
    options,
  );
}
export function usePartitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartitionsQuery,
    PartitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PartitionsQuery, PartitionsQueryVariables>(
    PartitionsDocument,
    options,
  );
}
// @ts-ignore
export function usePartitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PartitionsQuery,
    PartitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PartitionsQuery, PartitionsQueryVariables>;
export function usePartitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PartitionsQuery,
        PartitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PartitionsQuery | undefined,
  PartitionsQueryVariables
>;
export function usePartitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PartitionsQuery,
        PartitionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PartitionsQuery, PartitionsQueryVariables>(
    PartitionsDocument,
    options,
  );
}
export type PartitionsQueryHookResult = ReturnType<typeof usePartitionsQuery>;
export type PartitionsLazyQueryHookResult = ReturnType<
  typeof usePartitionsLazyQuery
>;
export type PartitionsSuspenseQueryHookResult = ReturnType<
  typeof usePartitionsSuspenseQuery
>;
export type PartitionsQueryResult = Apollo.QueryResult<
  PartitionsQuery,
  PartitionsQueryVariables
>;
export const UpdateAssignmentTableDocument = gql`
  mutation UpdateAssignmentTable(
    $input: PartialMetricsV1AssignmentTableInput!
    $updateMask: String
  ) {
    updateAssignmentTable(assignmentTable: $input, updateMask: $updateMask) {
      ...AssignmentTable
      ...DefaultError
    }
  }
  ${AssignmentTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateAssignmentTableMutationFn = Apollo.MutationFunction<
  UpdateAssignmentTableMutation,
  UpdateAssignmentTableMutationVariables
>;

/**
 * __useUpdateAssignmentTableMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentTableMutation, { data, loading, error }] = useUpdateAssignmentTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateAssignmentTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssignmentTableMutation,
    UpdateAssignmentTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAssignmentTableMutation,
    UpdateAssignmentTableMutationVariables
  >(UpdateAssignmentTableDocument, options);
}
export type UpdateAssignmentTableMutationHookResult = ReturnType<
  typeof useUpdateAssignmentTableMutation
>;
export type UpdateAssignmentTableMutationResult =
  Apollo.MutationResult<UpdateAssignmentTableMutation>;
export type UpdateAssignmentTableMutationOptions = Apollo.BaseMutationOptions<
  UpdateAssignmentTableMutation,
  UpdateAssignmentTableMutationVariables
>;
export const UpdateDimensionTableDocument = gql`
  mutation UpdateDimensionTable(
    $input: PartialMetricsV1DimensionTableInput!
    $updateMask: String
  ) {
    updateDimensionTable(dimensionTable: $input, updateMask: $updateMask) {
      ...DimensionTable
      ...DefaultError
    }
  }
  ${DimensionTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateDimensionTableMutationFn = Apollo.MutationFunction<
  UpdateDimensionTableMutation,
  UpdateDimensionTableMutationVariables
>;

/**
 * __useUpdateDimensionTableMutation__
 *
 * To run a mutation, you first call `useUpdateDimensionTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDimensionTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDimensionTableMutation, { data, loading, error }] = useUpdateDimensionTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateDimensionTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDimensionTableMutation,
    UpdateDimensionTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDimensionTableMutation,
    UpdateDimensionTableMutationVariables
  >(UpdateDimensionTableDocument, options);
}
export type UpdateDimensionTableMutationHookResult = ReturnType<
  typeof useUpdateDimensionTableMutation
>;
export type UpdateDimensionTableMutationResult =
  Apollo.MutationResult<UpdateDimensionTableMutation>;
export type UpdateDimensionTableMutationOptions = Apollo.BaseMutationOptions<
  UpdateDimensionTableMutation,
  UpdateDimensionTableMutationVariables
>;
export const UpdateEntityDocument = gql`
  mutation UpdateEntity(
    $input: PartialMetricsV1EntityInput!
    $updateMask: String
  ) {
    updateEntity(entity: $input, updateMask: $updateMask) {
      ...Entity
      ...DefaultError
    }
  }
  ${EntityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateEntityMutationFn = Apollo.MutationFunction<
  UpdateEntityMutation,
  UpdateEntityMutationVariables
>;

/**
 * __useUpdateEntityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMutation, { data, loading, error }] = useUpdateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEntityMutation,
    UpdateEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEntityMutation,
    UpdateEntityMutationVariables
  >(UpdateEntityDocument, options);
}
export type UpdateEntityMutationHookResult = ReturnType<
  typeof useUpdateEntityMutation
>;
export type UpdateEntityMutationResult =
  Apollo.MutationResult<UpdateEntityMutation>;
export type UpdateEntityMutationOptions = Apollo.BaseMutationOptions<
  UpdateEntityMutation,
  UpdateEntityMutationVariables
>;
export const UpdateFactTableDocument = gql`
  mutation UpdateFactTable(
    $input: PartialMetricsV1FactTableInput!
    $updateMask: String
  ) {
    updateFactTable(factTable: $input, updateMask: $updateMask) {
      ...FactTable
      ...DefaultError
    }
  }
  ${FactTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateFactTableMutationFn = Apollo.MutationFunction<
  UpdateFactTableMutation,
  UpdateFactTableMutationVariables
>;

/**
 * __useUpdateFactTableMutation__
 *
 * To run a mutation, you first call `useUpdateFactTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFactTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFactTableMutation, { data, loading, error }] = useUpdateFactTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateFactTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFactTableMutation,
    UpdateFactTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFactTableMutation,
    UpdateFactTableMutationVariables
  >(UpdateFactTableDocument, options);
}
export type UpdateFactTableMutationHookResult = ReturnType<
  typeof useUpdateFactTableMutation
>;
export type UpdateFactTableMutationResult =
  Apollo.MutationResult<UpdateFactTableMutation>;
export type UpdateFactTableMutationOptions = Apollo.BaseMutationOptions<
  UpdateFactTableMutation,
  UpdateFactTableMutationVariables
>;
export const ArchiveMetricDocument = gql`
  mutation ArchiveMetric(
    $name: String!
    $archiveInfo: MetricsV1MetricArchiveInfoInput
    $etag: String
  ) {
    archiveMetric(name: $name, archiveInfo: $archiveInfo, etag: $etag) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ArchiveMetricMutationFn = Apollo.MutationFunction<
  ArchiveMetricMutation,
  ArchiveMetricMutationVariables
>;

/**
 * __useArchiveMetricMutation__
 *
 * To run a mutation, you first call `useArchiveMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMetricMutation, { data, loading, error }] = useArchiveMetricMutation({
 *   variables: {
 *      name: // value for 'name'
 *      archiveInfo: // value for 'archiveInfo'
 *      etag: // value for 'etag'
 *   },
 * });
 */
export function useArchiveMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveMetricMutation,
    ArchiveMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveMetricMutation,
    ArchiveMetricMutationVariables
  >(ArchiveMetricDocument, options);
}
export type ArchiveMetricMutationHookResult = ReturnType<
  typeof useArchiveMetricMutation
>;
export type ArchiveMetricMutationResult =
  Apollo.MutationResult<ArchiveMetricMutation>;
export type ArchiveMetricMutationOptions = Apollo.BaseMutationOptions<
  ArchiveMetricMutation,
  ArchiveMetricMutationVariables
>;
export const CancelMetricCalculationDocument = gql`
  mutation CancelMetricCalculation($name: String!) {
    cancelMetricCalculation(name: $name) {
      ... on MetricsV1MetricCalculation {
        name
        state
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CancelMetricCalculationMutationFn = Apollo.MutationFunction<
  CancelMetricCalculationMutation,
  CancelMetricCalculationMutationVariables
>;

/**
 * __useCancelMetricCalculationMutation__
 *
 * To run a mutation, you first call `useCancelMetricCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMetricCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMetricCalculationMutation, { data, loading, error }] = useCancelMetricCalculationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCancelMetricCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelMetricCalculationMutation,
    CancelMetricCalculationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelMetricCalculationMutation,
    CancelMetricCalculationMutationVariables
  >(CancelMetricCalculationDocument, options);
}
export type CancelMetricCalculationMutationHookResult = ReturnType<
  typeof useCancelMetricCalculationMutation
>;
export type CancelMetricCalculationMutationResult =
  Apollo.MutationResult<CancelMetricCalculationMutation>;
export type CancelMetricCalculationMutationOptions = Apollo.BaseMutationOptions<
  CancelMetricCalculationMutation,
  CancelMetricCalculationMutationVariables
>;
export const CreateMetricDocument = gql`
  mutation CreateMetric(
    $metric: MetricsV1MetricInput!
    $metricId: String
    $draft: Boolean
  ) {
    createMetric(metric: $metric, metricId: $metricId, draft: $draft) {
      ... on MetricsV1Metric {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateMetricMutationFn = Apollo.MutationFunction<
  CreateMetricMutation,
  CreateMetricMutationVariables
>;

/**
 * __useCreateMetricMutation__
 *
 * To run a mutation, you first call `useCreateMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricMutation, { data, loading, error }] = useCreateMetricMutation({
 *   variables: {
 *      metric: // value for 'metric'
 *      metricId: // value for 'metricId'
 *      draft: // value for 'draft'
 *   },
 * });
 */
export function useCreateMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetricMutation,
    CreateMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMetricMutation,
    CreateMetricMutationVariables
  >(CreateMetricDocument, options);
}
export type CreateMetricMutationHookResult = ReturnType<
  typeof useCreateMetricMutation
>;
export type CreateMetricMutationResult =
  Apollo.MutationResult<CreateMetricMutation>;
export type CreateMetricMutationOptions = Apollo.BaseMutationOptions<
  CreateMetricMutation,
  CreateMetricMutationVariables
>;
export const CreateMetricCalculationDocument = gql`
  mutation CreateMetricCalculation(
    $metricCalculation: MetricsV1MetricCalculationInput!
    $metricCalculationId: String
  ) {
    createMetricCalculation(
      metricCalculation: $metricCalculation
      metricCalculationId: $metricCalculationId
    ) {
      __typename
      ... on MetricsV1MetricCalculation {
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateMetricCalculationMutationFn = Apollo.MutationFunction<
  CreateMetricCalculationMutation,
  CreateMetricCalculationMutationVariables
>;

/**
 * __useCreateMetricCalculationMutation__
 *
 * To run a mutation, you first call `useCreateMetricCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricCalculationMutation, { data, loading, error }] = useCreateMetricCalculationMutation({
 *   variables: {
 *      metricCalculation: // value for 'metricCalculation'
 *      metricCalculationId: // value for 'metricCalculationId'
 *   },
 * });
 */
export function useCreateMetricCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetricCalculationMutation,
    CreateMetricCalculationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMetricCalculationMutation,
    CreateMetricCalculationMutationVariables
  >(CreateMetricCalculationDocument, options);
}
export type CreateMetricCalculationMutationHookResult = ReturnType<
  typeof useCreateMetricCalculationMutation
>;
export type CreateMetricCalculationMutationResult =
  Apollo.MutationResult<CreateMetricCalculationMutation>;
export type CreateMetricCalculationMutationOptions = Apollo.BaseMutationOptions<
  CreateMetricCalculationMutation,
  CreateMetricCalculationMutationVariables
>;
export const DeleteMeasurementDocument = gql`
  mutation DeleteMeasurement($name: String!) {
    deleteMeasurement(name: $name) {
      ... on MetricsV1Measurement {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteMeasurementMutationFn = Apollo.MutationFunction<
  DeleteMeasurementMutation,
  DeleteMeasurementMutationVariables
>;

/**
 * __useDeleteMeasurementMutation__
 *
 * To run a mutation, you first call `useDeleteMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeasurementMutation, { data, loading, error }] = useDeleteMeasurementMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteMeasurementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMeasurementMutation,
    DeleteMeasurementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMeasurementMutation,
    DeleteMeasurementMutationVariables
  >(DeleteMeasurementDocument, options);
}
export type DeleteMeasurementMutationHookResult = ReturnType<
  typeof useDeleteMeasurementMutation
>;
export type DeleteMeasurementMutationResult =
  Apollo.MutationResult<DeleteMeasurementMutation>;
export type DeleteMeasurementMutationOptions = Apollo.BaseMutationOptions<
  DeleteMeasurementMutation,
  DeleteMeasurementMutationVariables
>;
export const DeleteMetricDocument = gql`
  mutation DeleteMetric($name: String!) {
    deleteMetric(name: $name) {
      ... on MetricsV1Metric {
        __typename
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteMetricMutationFn = Apollo.MutationFunction<
  DeleteMetricMutation,
  DeleteMetricMutationVariables
>;

/**
 * __useDeleteMetricMutation__
 *
 * To run a mutation, you first call `useDeleteMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricMutation, { data, loading, error }] = useDeleteMetricMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMetricMutation,
    DeleteMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMetricMutation,
    DeleteMetricMutationVariables
  >(DeleteMetricDocument, options);
}
export type DeleteMetricMutationHookResult = ReturnType<
  typeof useDeleteMetricMutation
>;
export type DeleteMetricMutationResult =
  Apollo.MutationResult<DeleteMetricMutation>;
export type DeleteMetricMutationOptions = Apollo.BaseMutationOptions<
  DeleteMetricMutation,
  DeleteMetricMutationVariables
>;
export const DependenciesDocument = gql`
  query Dependencies($parent: String!) {
    dependencies(parent: $parent) {
      ... on MetricsV1ListDependenciesResponse {
        dependencies {
          ...Dependency
        }
        __typename
      }
      ...DefaultError
    }
  }
  ${DependencyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDependenciesQuery__
 *
 * To run a query within a React component, call `useDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependenciesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useDependenciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    DependenciesQuery,
    DependenciesQueryVariables
  > &
    (
      | { variables: DependenciesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DependenciesQuery, DependenciesQueryVariables>(
    DependenciesDocument,
    options,
  );
}
export function useDependenciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DependenciesQuery,
    DependenciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DependenciesQuery, DependenciesQueryVariables>(
    DependenciesDocument,
    options,
  );
}
// @ts-ignore
export function useDependenciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DependenciesQuery,
    DependenciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DependenciesQuery, DependenciesQueryVariables>;
export function useDependenciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DependenciesQuery,
        DependenciesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DependenciesQuery | undefined,
  DependenciesQueryVariables
>;
export function useDependenciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DependenciesQuery,
        DependenciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DependenciesQuery, DependenciesQueryVariables>(
    DependenciesDocument,
    options,
  );
}
export type DependenciesQueryHookResult = ReturnType<
  typeof useDependenciesQuery
>;
export type DependenciesLazyQueryHookResult = ReturnType<
  typeof useDependenciesLazyQuery
>;
export type DependenciesSuspenseQueryHookResult = ReturnType<
  typeof useDependenciesSuspenseQuery
>;
export type DependenciesQueryResult = Apollo.QueryResult<
  DependenciesQuery,
  DependenciesQueryVariables
>;
export const EntityRelationTablesDocument = gql`
  query entityRelationTables($entity: String!) {
    entityRelationTables(parent: $entity) {
      ... on MetricsV1ListEntityRelationTablesResponse {
        __typename
        entityRelationTables {
          ...MetricDialogEntityRelationTableFragment
        }
      }
      ...DefaultError
    }
    entity(name: $entity) {
      ... on MetricsV1Entity {
        __typename
        name
        displayName
      }
      ...DefaultError
    }
  }
  ${MetricDialogEntityRelationTableFragmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useEntityRelationTablesQuery__
 *
 * To run a query within a React component, call `useEntityRelationTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRelationTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRelationTablesQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useEntityRelationTablesQuery(
  baseOptions: Apollo.QueryHookOptions<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  > &
    (
      | { variables: EntityRelationTablesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  >(EntityRelationTablesDocument, options);
}
export function useEntityRelationTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  >(EntityRelationTablesDocument, options);
}
// @ts-ignore
export function useEntityRelationTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EntityRelationTablesQuery,
  EntityRelationTablesQueryVariables
>;
export function useEntityRelationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntityRelationTablesQuery,
        EntityRelationTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EntityRelationTablesQuery | undefined,
  EntityRelationTablesQueryVariables
>;
export function useEntityRelationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntityRelationTablesQuery,
        EntityRelationTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EntityRelationTablesQuery,
    EntityRelationTablesQueryVariables
  >(EntityRelationTablesDocument, options);
}
export type EntityRelationTablesQueryHookResult = ReturnType<
  typeof useEntityRelationTablesQuery
>;
export type EntityRelationTablesLazyQueryHookResult = ReturnType<
  typeof useEntityRelationTablesLazyQuery
>;
export type EntityRelationTablesSuspenseQueryHookResult = ReturnType<
  typeof useEntityRelationTablesSuspenseQuery
>;
export type EntityRelationTablesQueryResult = Apollo.QueryResult<
  EntityRelationTablesQuery,
  EntityRelationTablesQueryVariables
>;
export const ExposureCalculationsDocument = gql`
  query ExposureCalculations(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    exposureCalculations(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MetricsV1ListExposureCalculationsResponse {
        nextPageToken
        exposureCalculations {
          ...ExposureCalculation
        }
        __typename
      }
      ...DefaultError
    }
  }
  ${ExposureCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExposureCalculationsQuery__
 *
 * To run a query within a React component, call `useExposureCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureCalculationsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useExposureCalculationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  > &
    (
      | { variables: ExposureCalculationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  >(ExposureCalculationsDocument, options);
}
export function useExposureCalculationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  >(ExposureCalculationsDocument, options);
}
// @ts-ignore
export function useExposureCalculationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExposureCalculationsQuery,
  ExposureCalculationsQueryVariables
>;
export function useExposureCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureCalculationsQuery,
        ExposureCalculationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExposureCalculationsQuery | undefined,
  ExposureCalculationsQueryVariables
>;
export function useExposureCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureCalculationsQuery,
        ExposureCalculationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExposureCalculationsQuery,
    ExposureCalculationsQueryVariables
  >(ExposureCalculationsDocument, options);
}
export type ExposureCalculationsQueryHookResult = ReturnType<
  typeof useExposureCalculationsQuery
>;
export type ExposureCalculationsLazyQueryHookResult = ReturnType<
  typeof useExposureCalculationsLazyQuery
>;
export type ExposureCalculationsSuspenseQueryHookResult = ReturnType<
  typeof useExposureCalculationsSuspenseQuery
>;
export type ExposureCalculationsQueryResult = Apollo.QueryResult<
  ExposureCalculationsQuery,
  ExposureCalculationsQueryVariables
>;
export const ExposureTablesDocument = gql`
  query ExposureTables($filter: String, $pageSize: Int, $pageToken: String) {
    exposureTables(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MetricsV1ListExposureTablesResponse {
        __typename
        exposureTables {
          name
          displayName
          state
          createTime
          entity {
            ... on MetricsV1Entity {
              __typename
              name
              displayName
            }
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExposureTablesQuery__
 *
 * To run a query within a React component, call `useExposureTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useExposureTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExposureTablesQuery,
    ExposureTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExposureTablesQuery, ExposureTablesQueryVariables>(
    ExposureTablesDocument,
    options,
  );
}
export function useExposureTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureTablesQuery,
    ExposureTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExposureTablesQuery, ExposureTablesQueryVariables>(
    ExposureTablesDocument,
    options,
  );
}
// @ts-ignore
export function useExposureTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExposureTablesQuery,
    ExposureTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExposureTablesQuery,
  ExposureTablesQueryVariables
>;
export function useExposureTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureTablesQuery,
        ExposureTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExposureTablesQuery | undefined,
  ExposureTablesQueryVariables
>;
export function useExposureTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureTablesQuery,
        ExposureTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExposureTablesQuery,
    ExposureTablesQueryVariables
  >(ExposureTablesDocument, options);
}
export type ExposureTablesQueryHookResult = ReturnType<
  typeof useExposureTablesQuery
>;
export type ExposureTablesLazyQueryHookResult = ReturnType<
  typeof useExposureTablesLazyQuery
>;
export type ExposureTablesSuspenseQueryHookResult = ReturnType<
  typeof useExposureTablesSuspenseQuery
>;
export type ExposureTablesQueryResult = Apollo.QueryResult<
  ExposureTablesQuery,
  ExposureTablesQueryVariables
>;
export const ExposureTrendDataDocument = gql`
  query ExposureTrendData(
    $name: String!
    $groupByDimensions: [String!]!
    $accumulateDimension: String
    $timeZone: String
    $endTime: String
  ) {
    queryScheduledMetricCalculation(
      name: $name
      groupByDimensions: $groupByDimensions
      accumulateDimension: $accumulateDimension
      timeZone: $timeZone
      endTime: $endTime
    ) {
      ... on MetricsV1QueryScheduledMetricCalculationResponse {
        __typename
        dimensions
        minStartTime
        maxStartTime
        rows {
          dimensions {
            key
            value
          }
          aggCount
          value {
            averageSummaryStats {
              count
              mean
              variance
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExposureTrendDataQuery__
 *
 * To run a query within a React component, call `useExposureTrendDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureTrendDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureTrendDataQuery({
 *   variables: {
 *      name: // value for 'name'
 *      groupByDimensions: // value for 'groupByDimensions'
 *      accumulateDimension: // value for 'accumulateDimension'
 *      timeZone: // value for 'timeZone'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useExposureTrendDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  > &
    (
      | { variables: ExposureTrendDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  >(ExposureTrendDataDocument, options);
}
export function useExposureTrendDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  >(ExposureTrendDataDocument, options);
}
// @ts-ignore
export function useExposureTrendDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExposureTrendDataQuery,
  ExposureTrendDataQueryVariables
>;
export function useExposureTrendDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureTrendDataQuery,
        ExposureTrendDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExposureTrendDataQuery | undefined,
  ExposureTrendDataQueryVariables
>;
export function useExposureTrendDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureTrendDataQuery,
        ExposureTrendDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExposureTrendDataQuery,
    ExposureTrendDataQueryVariables
  >(ExposureTrendDataDocument, options);
}
export type ExposureTrendDataQueryHookResult = ReturnType<
  typeof useExposureTrendDataQuery
>;
export type ExposureTrendDataLazyQueryHookResult = ReturnType<
  typeof useExposureTrendDataLazyQuery
>;
export type ExposureTrendDataSuspenseQueryHookResult = ReturnType<
  typeof useExposureTrendDataSuspenseQuery
>;
export type ExposureTrendDataQueryResult = Apollo.QueryResult<
  ExposureTrendDataQuery,
  ExposureTrendDataQueryVariables
>;
export const FactTableMeasuresDocument = gql`
  query FactTableMeasures($name: String!) {
    factTable(name: $name) {
      ... on MetricsV1FactTable {
        __typename
        name
        measures {
          column {
            name
            type
          }
          declaredType
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFactTableMeasuresQuery__
 *
 * To run a query within a React component, call `useFactTableMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactTableMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactTableMeasuresQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFactTableMeasuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  > &
    (
      | { variables: FactTableMeasuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  >(FactTableMeasuresDocument, options);
}
export function useFactTableMeasuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  >(FactTableMeasuresDocument, options);
}
// @ts-ignore
export function useFactTableMeasuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FactTableMeasuresQuery,
  FactTableMeasuresQueryVariables
>;
export function useFactTableMeasuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTableMeasuresQuery,
        FactTableMeasuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FactTableMeasuresQuery | undefined,
  FactTableMeasuresQueryVariables
>;
export function useFactTableMeasuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FactTableMeasuresQuery,
        FactTableMeasuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FactTableMeasuresQuery,
    FactTableMeasuresQueryVariables
  >(FactTableMeasuresDocument, options);
}
export type FactTableMeasuresQueryHookResult = ReturnType<
  typeof useFactTableMeasuresQuery
>;
export type FactTableMeasuresLazyQueryHookResult = ReturnType<
  typeof useFactTableMeasuresLazyQuery
>;
export type FactTableMeasuresSuspenseQueryHookResult = ReturnType<
  typeof useFactTableMeasuresSuspenseQuery
>;
export type FactTableMeasuresQueryResult = Apollo.QueryResult<
  FactTableMeasuresQuery,
  FactTableMeasuresQueryVariables
>;
export const GetMandatoryMetricsDocument = gql`
  mutation GetMandatoryMetrics($instance: String!) {
    executeFunction(
      workflowInstance: $instance
      functionName: "getMandatoryMetrics"
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
      }
    }
  }
`;
export type GetMandatoryMetricsMutationFn = Apollo.MutationFunction<
  GetMandatoryMetricsMutation,
  GetMandatoryMetricsMutationVariables
>;

/**
 * __useGetMandatoryMetricsMutation__
 *
 * To run a mutation, you first call `useGetMandatoryMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMandatoryMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMandatoryMetricsMutation, { data, loading, error }] = useGetMandatoryMetricsMutation({
 *   variables: {
 *      instance: // value for 'instance'
 *   },
 * });
 */
export function useGetMandatoryMetricsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetMandatoryMetricsMutation,
    GetMandatoryMetricsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetMandatoryMetricsMutation,
    GetMandatoryMetricsMutationVariables
  >(GetMandatoryMetricsDocument, options);
}
export type GetMandatoryMetricsMutationHookResult = ReturnType<
  typeof useGetMandatoryMetricsMutation
>;
export type GetMandatoryMetricsMutationResult =
  Apollo.MutationResult<GetMandatoryMetricsMutation>;
export type GetMandatoryMetricsMutationOptions = Apollo.BaseMutationOptions<
  GetMandatoryMetricsMutation,
  GetMandatoryMetricsMutationVariables
>;
export const GetMetricDetailsDocument = gql`
  query GetMetricDetails($name: String!) {
    metric(name: $name) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetMetricDetailsQuery__
 *
 * To run a query within a React component, call `useGetMetricDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricDetailsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetMetricDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMetricDetailsQuery,
    GetMetricDetailsQueryVariables
  > &
    (
      | { variables: GetMetricDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricDetailsQuery, GetMetricDetailsQueryVariables>(
    GetMetricDetailsDocument,
    options,
  );
}
export function useGetMetricDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricDetailsQuery,
    GetMetricDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetricDetailsQuery,
    GetMetricDetailsQueryVariables
  >(GetMetricDetailsDocument, options);
}
// @ts-ignore
export function useGetMetricDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMetricDetailsQuery,
    GetMetricDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMetricDetailsQuery,
  GetMetricDetailsQueryVariables
>;
export function useGetMetricDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricDetailsQuery,
        GetMetricDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMetricDetailsQuery | undefined,
  GetMetricDetailsQueryVariables
>;
export function useGetMetricDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricDetailsQuery,
        GetMetricDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMetricDetailsQuery,
    GetMetricDetailsQueryVariables
  >(GetMetricDetailsDocument, options);
}
export type GetMetricDetailsQueryHookResult = ReturnType<
  typeof useGetMetricDetailsQuery
>;
export type GetMetricDetailsLazyQueryHookResult = ReturnType<
  typeof useGetMetricDetailsLazyQuery
>;
export type GetMetricDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetMetricDetailsSuspenseQuery
>;
export type GetMetricDetailsQueryResult = Apollo.QueryResult<
  GetMetricDetailsQuery,
  GetMetricDetailsQueryVariables
>;
export const GetMetricSchedulesDocument = gql`
  query GetMetricSchedules($filter: String) {
    scheduledMetricCalculations(filter: $filter) {
      ... on MetricsV1ListScheduledMetricCalculationsResponse {
        __typename
        scheduledMetricCalculations {
          ...MetricSchedule
        }
      }
      ...DefaultError
    }
  }
  ${MetricScheduleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetMetricSchedulesQuery__
 *
 * To run a query within a React component, call `useGetMetricSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricSchedulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMetricSchedulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >(GetMetricSchedulesDocument, options);
}
export function useGetMetricSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >(GetMetricSchedulesDocument, options);
}
// @ts-ignore
export function useGetMetricSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMetricSchedulesQuery,
  GetMetricSchedulesQueryVariables
>;
export function useGetMetricSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricSchedulesQuery,
        GetMetricSchedulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMetricSchedulesQuery | undefined,
  GetMetricSchedulesQueryVariables
>;
export function useGetMetricSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMetricSchedulesQuery,
        GetMetricSchedulesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMetricSchedulesQuery,
    GetMetricSchedulesQueryVariables
  >(GetMetricSchedulesDocument, options);
}
export type GetMetricSchedulesQueryHookResult = ReturnType<
  typeof useGetMetricSchedulesQuery
>;
export type GetMetricSchedulesLazyQueryHookResult = ReturnType<
  typeof useGetMetricSchedulesLazyQuery
>;
export type GetMetricSchedulesSuspenseQueryHookResult = ReturnType<
  typeof useGetMetricSchedulesSuspenseQuery
>;
export type GetMetricSchedulesQueryResult = Apollo.QueryResult<
  GetMetricSchedulesQuery,
  GetMetricSchedulesQueryVariables
>;
export const ListMetricsDocument = gql`
  query ListMetrics(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    metrics(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        nextPageToken
        metrics {
          name
          displayName
          description
          state
          owner {
            __typename
            ... on IamV1Identity {
              ...IdentityRef
            }
            ...DefaultError
          }
          entity {
            ... on MetricsV1Entity {
              __typename
              displayName
              name
            }
            ...DefaultError
          }
          factTable {
            ...FactTableRef
            ...DefaultError
          }
          labels {
            key
            value
          }
          varianceReductionConfig {
            disabled
          }
          nullHandling {
            replaceEntityNullWithZero
          }
          preferredDirection
          defaultEffectSize {
            value
          }
          typeSpec {
            averageMetricSpec {
              __typename
            }
            ratioMetricSpec {
              __typename
            }
            quantileMetricSpec {
              quantileLevel
            }
          }
          source {
            type
          }
          verification {
            state
          }
          measurementConfig {
            ...MeasurementConfigFields
          }
          measurement {
            ... on MetricsV1Measurement {
              __typename
              ...MetricsListMeasurement
            }
            ...DefaultError
          }
          dataWarehouse {
            ... on MetricsV1DataWarehouse {
              ...DataWarehouseRef
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${FactTableRefFragmentDoc}
  ${MeasurementConfigFieldsFragmentDoc}
  ${MetricsListMeasurementFragmentDoc}
  ${DataWarehouseRefFragmentDoc}
`;

/**
 * __useListMetricsQuery__
 *
 * To run a query within a React component, call `useListMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListMetricsQuery,
    ListMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMetricsQuery, ListMetricsQueryVariables>(
    ListMetricsDocument,
    options,
  );
}
export function useListMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMetricsQuery,
    ListMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMetricsQuery, ListMetricsQueryVariables>(
    ListMetricsDocument,
    options,
  );
}
// @ts-ignore
export function useListMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMetricsQuery,
    ListMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListMetricsQuery, ListMetricsQueryVariables>;
export function useListMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMetricsQuery,
        ListMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListMetricsQuery | undefined,
  ListMetricsQueryVariables
>;
export function useListMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMetricsQuery,
        ListMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMetricsQuery, ListMetricsQueryVariables>(
    ListMetricsDocument,
    options,
  );
}
export type ListMetricsQueryHookResult = ReturnType<typeof useListMetricsQuery>;
export type ListMetricsLazyQueryHookResult = ReturnType<
  typeof useListMetricsLazyQuery
>;
export type ListMetricsSuspenseQueryHookResult = ReturnType<
  typeof useListMetricsSuspenseQuery
>;
export type ListMetricsQueryResult = Apollo.QueryResult<
  ListMetricsQuery,
  ListMetricsQueryVariables
>;
export const MeasurementDocument = gql`
  query Measurement($name: String!) {
    measurement(name: $name) {
      ...MeasurementDetails
      ...DefaultError
    }
  }
  ${MeasurementDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMeasurementQuery__
 *
 * To run a query within a React component, call `useMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurementQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMeasurementQuery(
  baseOptions: Apollo.QueryHookOptions<
    MeasurementQuery,
    MeasurementQueryVariables
  > &
    (
      | { variables: MeasurementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeasurementQuery, MeasurementQueryVariables>(
    MeasurementDocument,
    options,
  );
}
export function useMeasurementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeasurementQuery,
    MeasurementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeasurementQuery, MeasurementQueryVariables>(
    MeasurementDocument,
    options,
  );
}
// @ts-ignore
export function useMeasurementSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MeasurementQuery,
    MeasurementQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MeasurementQuery, MeasurementQueryVariables>;
export function useMeasurementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementQuery,
        MeasurementQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MeasurementQuery | undefined,
  MeasurementQueryVariables
>;
export function useMeasurementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementQuery,
        MeasurementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeasurementQuery, MeasurementQueryVariables>(
    MeasurementDocument,
    options,
  );
}
export type MeasurementQueryHookResult = ReturnType<typeof useMeasurementQuery>;
export type MeasurementLazyQueryHookResult = ReturnType<
  typeof useMeasurementLazyQuery
>;
export type MeasurementSuspenseQueryHookResult = ReturnType<
  typeof useMeasurementSuspenseQuery
>;
export type MeasurementQueryResult = Apollo.QueryResult<
  MeasurementQuery,
  MeasurementQueryVariables
>;
export const MeasurementCalculationsDocument = gql`
  query MeasurementCalculations(
    $parent: String!
    $pageSize: Int
    $pageToken: String
    $filter: String
  ) {
    measurementCalculations(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      __typename
      ... on MetricsV1ListMeasurementCalculationsResponse {
        measurementCalculations {
          ...MeasurementCalculation
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MeasurementCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMeasurementCalculationsQuery__
 *
 * To run a query within a React component, call `useMeasurementCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurementCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurementCalculationsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMeasurementCalculationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  > &
    (
      | { variables: MeasurementCalculationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  >(MeasurementCalculationsDocument, options);
}
export function useMeasurementCalculationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  >(MeasurementCalculationsDocument, options);
}
// @ts-ignore
export function useMeasurementCalculationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MeasurementCalculationsQuery,
  MeasurementCalculationsQueryVariables
>;
export function useMeasurementCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementCalculationsQuery,
        MeasurementCalculationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MeasurementCalculationsQuery | undefined,
  MeasurementCalculationsQueryVariables
>;
export function useMeasurementCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementCalculationsQuery,
        MeasurementCalculationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MeasurementCalculationsQuery,
    MeasurementCalculationsQueryVariables
  >(MeasurementCalculationsDocument, options);
}
export type MeasurementCalculationsQueryHookResult = ReturnType<
  typeof useMeasurementCalculationsQuery
>;
export type MeasurementCalculationsLazyQueryHookResult = ReturnType<
  typeof useMeasurementCalculationsLazyQuery
>;
export type MeasurementCalculationsSuspenseQueryHookResult = ReturnType<
  typeof useMeasurementCalculationsSuspenseQuery
>;
export type MeasurementCalculationsQueryResult = Apollo.QueryResult<
  MeasurementCalculationsQuery,
  MeasurementCalculationsQueryVariables
>;
export const MeasurementMetricsDocument = gql`
  query MeasurementMetrics(
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    metrics(filter: $filter, pageSize: $pageSize, pageToken: $pageToken) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        nextPageToken
        metrics {
          ...MeasurementPageMetric
        }
      }
      ...DefaultError
    }
  }
  ${MeasurementPageMetricFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMeasurementMetricsQuery__
 *
 * To run a query within a React component, call `useMeasurementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurementMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMeasurementMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >(MeasurementMetricsDocument, options);
}
export function useMeasurementMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >(MeasurementMetricsDocument, options);
}
// @ts-ignore
export function useMeasurementMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MeasurementMetricsQuery,
  MeasurementMetricsQueryVariables
>;
export function useMeasurementMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementMetricsQuery,
        MeasurementMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MeasurementMetricsQuery | undefined,
  MeasurementMetricsQueryVariables
>;
export function useMeasurementMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementMetricsQuery,
        MeasurementMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MeasurementMetricsQuery,
    MeasurementMetricsQueryVariables
  >(MeasurementMetricsDocument, options);
}
export type MeasurementMetricsQueryHookResult = ReturnType<
  typeof useMeasurementMetricsQuery
>;
export type MeasurementMetricsLazyQueryHookResult = ReturnType<
  typeof useMeasurementMetricsLazyQuery
>;
export type MeasurementMetricsSuspenseQueryHookResult = ReturnType<
  typeof useMeasurementMetricsSuspenseQuery
>;
export type MeasurementMetricsQueryResult = Apollo.QueryResult<
  MeasurementMetricsQuery,
  MeasurementMetricsQueryVariables
>;
export const MeasurementsDocument = gql`
  query Measurements(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    measurements(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListMeasurementsResponse {
        __typename
        nextPageToken
        measurements {
          ...MeasurementListItem
        }
      }
      ...DefaultError
    }
  }
  ${MeasurementListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMeasurementsQuery__
 *
 * To run a query within a React component, call `useMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMeasurementsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MeasurementsQuery,
    MeasurementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeasurementsQuery, MeasurementsQueryVariables>(
    MeasurementsDocument,
    options,
  );
}
export function useMeasurementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeasurementsQuery,
    MeasurementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeasurementsQuery, MeasurementsQueryVariables>(
    MeasurementsDocument,
    options,
  );
}
// @ts-ignore
export function useMeasurementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MeasurementsQuery,
    MeasurementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MeasurementsQuery, MeasurementsQueryVariables>;
export function useMeasurementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementsQuery,
        MeasurementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MeasurementsQuery | undefined,
  MeasurementsQueryVariables
>;
export function useMeasurementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeasurementsQuery,
        MeasurementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeasurementsQuery, MeasurementsQueryVariables>(
    MeasurementsDocument,
    options,
  );
}
export type MeasurementsQueryHookResult = ReturnType<
  typeof useMeasurementsQuery
>;
export type MeasurementsLazyQueryHookResult = ReturnType<
  typeof useMeasurementsLazyQuery
>;
export type MeasurementsSuspenseQueryHookResult = ReturnType<
  typeof useMeasurementsSuspenseQuery
>;
export type MeasurementsQueryResult = Apollo.QueryResult<
  MeasurementsQuery,
  MeasurementsQueryVariables
>;
export const MetricDocument = gql`
  query Metric($name: String!) {
    metric(name: $name) {
      __typename
      ...MetricPicker
    }
  }
  ${MetricPickerFragmentDoc}
`;

/**
 * __useMetricQuery__
 *
 * To run a query within a React component, call `useMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMetricQuery(
  baseOptions: Apollo.QueryHookOptions<MetricQuery, MetricQueryVariables> &
    ({ variables: MetricQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MetricQuery, MetricQueryVariables>(
    MetricDocument,
    options,
  );
}
export function useMetricLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MetricQuery, MetricQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MetricQuery, MetricQueryVariables>(
    MetricDocument,
    options,
  );
}
// @ts-ignore
export function useMetricSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricQuery,
    MetricQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MetricQuery, MetricQueryVariables>;
export function useMetricSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MetricQuery, MetricQueryVariables>,
): Apollo.UseSuspenseQueryResult<MetricQuery | undefined, MetricQueryVariables>;
export function useMetricSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MetricQuery, MetricQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MetricQuery, MetricQueryVariables>(
    MetricDocument,
    options,
  );
}
export type MetricQueryHookResult = ReturnType<typeof useMetricQuery>;
export type MetricLazyQueryHookResult = ReturnType<typeof useMetricLazyQuery>;
export type MetricSuspenseQueryHookResult = ReturnType<
  typeof useMetricSuspenseQuery
>;
export type MetricQueryResult = Apollo.QueryResult<
  MetricQuery,
  MetricQueryVariables
>;
export const MetricCalculationDocument = gql`
  query MetricCalculation($name: String!) {
    metricCalculation(name: $name) {
      ...MetricPreviewCalculation
      ...DefaultError
    }
  }
  ${MetricPreviewCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricCalculationQuery__
 *
 * To run a query within a React component, call `useMetricCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMetricCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  > &
    (
      | { variables: MetricCalculationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  >(MetricCalculationDocument, options);
}
export function useMetricCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  >(MetricCalculationDocument, options);
}
// @ts-ignore
export function useMetricCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricCalculationQuery,
  MetricCalculationQueryVariables
>;
export function useMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricCalculationQuery,
        MetricCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricCalculationQuery | undefined,
  MetricCalculationQueryVariables
>;
export function useMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricCalculationQuery,
        MetricCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricCalculationQuery,
    MetricCalculationQueryVariables
  >(MetricCalculationDocument, options);
}
export type MetricCalculationQueryHookResult = ReturnType<
  typeof useMetricCalculationQuery
>;
export type MetricCalculationLazyQueryHookResult = ReturnType<
  typeof useMetricCalculationLazyQuery
>;
export type MetricCalculationSuspenseQueryHookResult = ReturnType<
  typeof useMetricCalculationSuspenseQuery
>;
export type MetricCalculationQueryResult = Apollo.QueryResult<
  MetricCalculationQuery,
  MetricCalculationQueryVariables
>;
export const MetricCalculationsDocument = gql`
  query MetricCalculations(
    $parent: String!
    $pageSize: Int
    $pageToken: String
    $filter: String
  ) {
    metricCalculations(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      __typename
      ... on MetricsV1ListMetricCalculationsResponse {
        metricCalculations {
          ...MetricCalculation
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MetricCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricCalculationsQuery__
 *
 * To run a query within a React component, call `useMetricCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricCalculationsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMetricCalculationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  > &
    (
      | { variables: MetricCalculationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  >(MetricCalculationsDocument, options);
}
export function useMetricCalculationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  >(MetricCalculationsDocument, options);
}
// @ts-ignore
export function useMetricCalculationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricCalculationsQuery,
  MetricCalculationsQueryVariables
>;
export function useMetricCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricCalculationsQuery,
        MetricCalculationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricCalculationsQuery | undefined,
  MetricCalculationsQueryVariables
>;
export function useMetricCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricCalculationsQuery,
        MetricCalculationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricCalculationsQuery,
    MetricCalculationsQueryVariables
  >(MetricCalculationsDocument, options);
}
export type MetricCalculationsQueryHookResult = ReturnType<
  typeof useMetricCalculationsQuery
>;
export type MetricCalculationsLazyQueryHookResult = ReturnType<
  typeof useMetricCalculationsLazyQuery
>;
export type MetricCalculationsSuspenseQueryHookResult = ReturnType<
  typeof useMetricCalculationsSuspenseQuery
>;
export type MetricCalculationsQueryResult = Apollo.QueryResult<
  MetricCalculationsQuery,
  MetricCalculationsQueryVariables
>;
export const MetricConfigAssignmentTablesDocument = gql`
  query MetricConfigAssignmentTables(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    assignmentTables(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          ...MetricAssignmentTable
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MetricAssignmentTableFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricConfigAssignmentTablesQuery__
 *
 * To run a query within a React component, call `useMetricConfigAssignmentTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricConfigAssignmentTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricConfigAssignmentTablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMetricConfigAssignmentTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >(MetricConfigAssignmentTablesDocument, options);
}
export function useMetricConfigAssignmentTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >(MetricConfigAssignmentTablesDocument, options);
}
// @ts-ignore
export function useMetricConfigAssignmentTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricConfigAssignmentTablesQuery,
  MetricConfigAssignmentTablesQueryVariables
>;
export function useMetricConfigAssignmentTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricConfigAssignmentTablesQuery,
        MetricConfigAssignmentTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricConfigAssignmentTablesQuery | undefined,
  MetricConfigAssignmentTablesQueryVariables
>;
export function useMetricConfigAssignmentTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricConfigAssignmentTablesQuery,
        MetricConfigAssignmentTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricConfigAssignmentTablesQuery,
    MetricConfigAssignmentTablesQueryVariables
  >(MetricConfigAssignmentTablesDocument, options);
}
export type MetricConfigAssignmentTablesQueryHookResult = ReturnType<
  typeof useMetricConfigAssignmentTablesQuery
>;
export type MetricConfigAssignmentTablesLazyQueryHookResult = ReturnType<
  typeof useMetricConfigAssignmentTablesLazyQuery
>;
export type MetricConfigAssignmentTablesSuspenseQueryHookResult = ReturnType<
  typeof useMetricConfigAssignmentTablesSuspenseQuery
>;
export type MetricConfigAssignmentTablesQueryResult = Apollo.QueryResult<
  MetricConfigAssignmentTablesQuery,
  MetricConfigAssignmentTablesQueryVariables
>;
export const MetricConfigEntitiesDocument = gql`
  query MetricConfigEntities(
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    entities(filter: $filter, pageSize: $pageSize, pageToken: $pageToken) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        entities {
          ...MetricEntity
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MetricEntityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricConfigEntitiesQuery__
 *
 * To run a query within a React component, call `useMetricConfigEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricConfigEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricConfigEntitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMetricConfigEntitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >(MetricConfigEntitiesDocument, options);
}
export function useMetricConfigEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >(MetricConfigEntitiesDocument, options);
}
// @ts-ignore
export function useMetricConfigEntitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricConfigEntitiesQuery,
  MetricConfigEntitiesQueryVariables
>;
export function useMetricConfigEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricConfigEntitiesQuery,
        MetricConfigEntitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricConfigEntitiesQuery | undefined,
  MetricConfigEntitiesQueryVariables
>;
export function useMetricConfigEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricConfigEntitiesQuery,
        MetricConfigEntitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricConfigEntitiesQuery,
    MetricConfigEntitiesQueryVariables
  >(MetricConfigEntitiesDocument, options);
}
export type MetricConfigEntitiesQueryHookResult = ReturnType<
  typeof useMetricConfigEntitiesQuery
>;
export type MetricConfigEntitiesLazyQueryHookResult = ReturnType<
  typeof useMetricConfigEntitiesLazyQuery
>;
export type MetricConfigEntitiesSuspenseQueryHookResult = ReturnType<
  typeof useMetricConfigEntitiesSuspenseQuery
>;
export type MetricConfigEntitiesQueryResult = Apollo.QueryResult<
  MetricConfigEntitiesQuery,
  MetricConfigEntitiesQueryVariables
>;
export const MetricPreviewCalculationsDocument = gql`
  query MetricPreviewCalculations($filter: String, $pageSize: Int) {
    metricCalculations(
      parent: "scheduledMetricCalculations/ad-hoc"
      orderBy: "createTime:desc"
      pageSize: $pageSize
      filter: $filter
    ) {
      __typename
      ... on MetricsV1ListMetricCalculationsResponse {
        metricCalculations {
          ...MetricPreviewCalculation
        }
      }
      ...DefaultError
    }
  }
  ${MetricPreviewCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricPreviewCalculationsQuery__
 *
 * To run a query within a React component, call `useMetricPreviewCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricPreviewCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricPreviewCalculationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useMetricPreviewCalculationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >(MetricPreviewCalculationsDocument, options);
}
export function useMetricPreviewCalculationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >(MetricPreviewCalculationsDocument, options);
}
// @ts-ignore
export function useMetricPreviewCalculationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricPreviewCalculationsQuery,
  MetricPreviewCalculationsQueryVariables
>;
export function useMetricPreviewCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricPreviewCalculationsQuery,
        MetricPreviewCalculationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricPreviewCalculationsQuery | undefined,
  MetricPreviewCalculationsQueryVariables
>;
export function useMetricPreviewCalculationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricPreviewCalculationsQuery,
        MetricPreviewCalculationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricPreviewCalculationsQuery,
    MetricPreviewCalculationsQueryVariables
  >(MetricPreviewCalculationsDocument, options);
}
export type MetricPreviewCalculationsQueryHookResult = ReturnType<
  typeof useMetricPreviewCalculationsQuery
>;
export type MetricPreviewCalculationsLazyQueryHookResult = ReturnType<
  typeof useMetricPreviewCalculationsLazyQuery
>;
export type MetricPreviewCalculationsSuspenseQueryHookResult = ReturnType<
  typeof useMetricPreviewCalculationsSuspenseQuery
>;
export type MetricPreviewCalculationsQueryResult = Apollo.QueryResult<
  MetricPreviewCalculationsQuery,
  MetricPreviewCalculationsQueryVariables
>;
export const MetricUsageDocument = gql`
  query MetricUsage($filter: String, $pageSize: Int, $pageToken: String) {
    workflowInstances(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...MetricUsageWorkflowInstance
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${MetricUsageWorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricUsageQuery__
 *
 * To run a query within a React component, call `useMetricUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricUsageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMetricUsageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricUsageQuery,
    MetricUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MetricUsageQuery, MetricUsageQueryVariables>(
    MetricUsageDocument,
    options,
  );
}
export function useMetricUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricUsageQuery,
    MetricUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MetricUsageQuery, MetricUsageQueryVariables>(
    MetricUsageDocument,
    options,
  );
}
// @ts-ignore
export function useMetricUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricUsageQuery,
    MetricUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MetricUsageQuery, MetricUsageQueryVariables>;
export function useMetricUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricUsageQuery,
        MetricUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricUsageQuery | undefined,
  MetricUsageQueryVariables
>;
export function useMetricUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricUsageQuery,
        MetricUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MetricUsageQuery, MetricUsageQueryVariables>(
    MetricUsageDocument,
    options,
  );
}
export type MetricUsageQueryHookResult = ReturnType<typeof useMetricUsageQuery>;
export type MetricUsageLazyQueryHookResult = ReturnType<
  typeof useMetricUsageLazyQuery
>;
export type MetricUsageSuspenseQueryHookResult = ReturnType<
  typeof useMetricUsageSuspenseQuery
>;
export type MetricUsageQueryResult = Apollo.QueryResult<
  MetricUsageQuery,
  MetricUsageQueryVariables
>;
export const MetricsDocument = gql`
  query Metrics(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    metrics(
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        nextPageToken
        metrics {
          ...Metric
        }
      }
      ...DefaultError
    }
  }
  ${MetricFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricsQuery__
 *
 * To run a query within a React component, call `useMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<MetricsQuery, MetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MetricsQuery, MetricsQueryVariables>(
    MetricsDocument,
    options,
  );
}
export function useMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricsQuery,
    MetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MetricsQuery, MetricsQueryVariables>(
    MetricsDocument,
    options,
  );
}
// @ts-ignore
export function useMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricsQuery,
    MetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MetricsQuery, MetricsQueryVariables>;
export function useMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MetricsQuery, MetricsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MetricsQuery | undefined,
  MetricsQueryVariables
>;
export function useMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MetricsQuery, MetricsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MetricsQuery, MetricsQueryVariables>(
    MetricsDocument,
    options,
  );
}
export type MetricsQueryHookResult = ReturnType<typeof useMetricsQuery>;
export type MetricsLazyQueryHookResult = ReturnType<typeof useMetricsLazyQuery>;
export type MetricsSuspenseQueryHookResult = ReturnType<
  typeof useMetricsSuspenseQuery
>;
export type MetricsQueryResult = Apollo.QueryResult<
  MetricsQuery,
  MetricsQueryVariables
>;
export const MetricsPickerDocument = gql`
  query MetricsPicker(
    $filter: String
    $orderBy: String
    $pageSize: Int
    $pageToken: String
  ) {
    metrics(
      filter: $filter
      orderBy: $orderBy
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        nextPageToken
        metrics {
          name
          displayName
          description
          state
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricsPickerQuery__
 *
 * To run a query within a React component, call `useMetricsPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsPickerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMetricsPickerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetricsPickerQuery,
    MetricsPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MetricsPickerQuery, MetricsPickerQueryVariables>(
    MetricsPickerDocument,
    options,
  );
}
export function useMetricsPickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricsPickerQuery,
    MetricsPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MetricsPickerQuery, MetricsPickerQueryVariables>(
    MetricsPickerDocument,
    options,
  );
}
// @ts-ignore
export function useMetricsPickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricsPickerQuery,
    MetricsPickerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricsPickerQuery,
  MetricsPickerQueryVariables
>;
export function useMetricsPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricsPickerQuery,
        MetricsPickerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricsPickerQuery | undefined,
  MetricsPickerQueryVariables
>;
export function useMetricsPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricsPickerQuery,
        MetricsPickerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricsPickerQuery,
    MetricsPickerQueryVariables
  >(MetricsPickerDocument, options);
}
export type MetricsPickerQueryHookResult = ReturnType<
  typeof useMetricsPickerQuery
>;
export type MetricsPickerLazyQueryHookResult = ReturnType<
  typeof useMetricsPickerLazyQuery
>;
export type MetricsPickerSuspenseQueryHookResult = ReturnType<
  typeof useMetricsPickerSuspenseQuery
>;
export type MetricsPickerQueryResult = Apollo.QueryResult<
  MetricsPickerQuery,
  MetricsPickerQueryVariables
>;
export const OnMeasurementUpdatedDocument = gql`
  subscription OnMeasurementUpdated {
    measurementUpdated {
      measurement {
        ...MeasurementDetails
      }
    }
  }
  ${MeasurementDetailsFragmentDoc}
`;

/**
 * __useOnMeasurementUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMeasurementUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMeasurementUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMeasurementUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMeasurementUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnMeasurementUpdatedSubscription,
    OnMeasurementUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMeasurementUpdatedSubscription,
    OnMeasurementUpdatedSubscriptionVariables
  >(OnMeasurementUpdatedDocument, options);
}
export type OnMeasurementUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnMeasurementUpdatedSubscription
>;
export type OnMeasurementUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMeasurementUpdatedSubscription>;
export const OnMetricCalculationUpdatedDocument = gql`
  subscription OnMetricCalculationUpdated($filter: String) {
    metricCalculationUpdated(filter: $filter) {
      metricCalculation {
        ...MetricPreviewCalculation
      }
    }
  }
  ${MetricPreviewCalculationFragmentDoc}
`;

/**
 * __useOnMetricCalculationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMetricCalculationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMetricCalculationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMetricCalculationUpdatedSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnMetricCalculationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnMetricCalculationUpdatedSubscription,
    OnMetricCalculationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMetricCalculationUpdatedSubscription,
    OnMetricCalculationUpdatedSubscriptionVariables
  >(OnMetricCalculationUpdatedDocument, options);
}
export type OnMetricCalculationUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnMetricCalculationUpdatedSubscription
>;
export type OnMetricCalculationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMetricCalculationUpdatedSubscription>;
export const OnMetricUpdatedDocument = gql`
  subscription OnMetricUpdated {
    metricUpdated {
      metric {
        ...MetricDetails
      }
    }
  }
  ${MetricDetailsFragmentDoc}
`;

/**
 * __useOnMetricUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMetricUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMetricUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMetricUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMetricUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnMetricUpdatedSubscription,
    OnMetricUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnMetricUpdatedSubscription,
    OnMetricUpdatedSubscriptionVariables
  >(OnMetricUpdatedDocument, options);
}
export type OnMetricUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnMetricUpdatedSubscription
>;
export type OnMetricUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnMetricUpdatedSubscription>;
export const OnRetriggerCreatedDocument = gql`
  subscription OnRetriggerCreated {
    retriggerCreated {
      retrigger {
        ...Retrigger
      }
    }
  }
  ${RetriggerFragmentDoc}
`;

/**
 * __useOnRetriggerCreatedSubscription__
 *
 * To run a query within a React component, call `useOnRetriggerCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRetriggerCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRetriggerCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnRetriggerCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnRetriggerCreatedSubscription,
    OnRetriggerCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnRetriggerCreatedSubscription,
    OnRetriggerCreatedSubscriptionVariables
  >(OnRetriggerCreatedDocument, options);
}
export type OnRetriggerCreatedSubscriptionHookResult = ReturnType<
  typeof useOnRetriggerCreatedSubscription
>;
export type OnRetriggerCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnRetriggerCreatedSubscription>;
export const OnRetriggerUpdatedDocument = gql`
  subscription OnRetriggerUpdated {
    retriggerUpdated {
      retrigger {
        ...Retrigger
      }
    }
  }
  ${RetriggerFragmentDoc}
`;

/**
 * __useOnRetriggerUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnRetriggerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRetriggerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRetriggerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnRetriggerUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnRetriggerUpdatedSubscription,
    OnRetriggerUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnRetriggerUpdatedSubscription,
    OnRetriggerUpdatedSubscriptionVariables
  >(OnRetriggerUpdatedDocument, options);
}
export type OnRetriggerUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnRetriggerUpdatedSubscription
>;
export type OnRetriggerUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnRetriggerUpdatedSubscription>;
export const OnScheduledExposureCalculationUpdatedDocument = gql`
  subscription OnScheduledExposureCalculationUpdated {
    scheduledExposureCalculationUpdated {
      scheduledExposureCalculation {
        ...ScheduledExposureCalculation
      }
    }
  }
  ${ScheduledExposureCalculationFragmentDoc}
`;

/**
 * __useOnScheduledExposureCalculationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnScheduledExposureCalculationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnScheduledExposureCalculationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnScheduledExposureCalculationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnScheduledExposureCalculationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnScheduledExposureCalculationUpdatedSubscription,
    OnScheduledExposureCalculationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnScheduledExposureCalculationUpdatedSubscription,
    OnScheduledExposureCalculationUpdatedSubscriptionVariables
  >(OnScheduledExposureCalculationUpdatedDocument, options);
}
export type OnScheduledExposureCalculationUpdatedSubscriptionHookResult =
  ReturnType<typeof useOnScheduledExposureCalculationUpdatedSubscription>;
export type OnScheduledExposureCalculationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnScheduledExposureCalculationUpdatedSubscription>;
export const OnScheduledMeasurementCalculationUpdatedDocument = gql`
  subscription OnScheduledMeasurementCalculationUpdated {
    scheduledMeasurementCalculationUpdated {
      scheduledMeasurementCalculation {
        ...ScheduledMeasurementCalculation
      }
    }
  }
  ${ScheduledMeasurementCalculationFragmentDoc}
`;

/**
 * __useOnScheduledMeasurementCalculationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnScheduledMeasurementCalculationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnScheduledMeasurementCalculationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnScheduledMeasurementCalculationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnScheduledMeasurementCalculationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnScheduledMeasurementCalculationUpdatedSubscription,
    OnScheduledMeasurementCalculationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnScheduledMeasurementCalculationUpdatedSubscription,
    OnScheduledMeasurementCalculationUpdatedSubscriptionVariables
  >(OnScheduledMeasurementCalculationUpdatedDocument, options);
}
export type OnScheduledMeasurementCalculationUpdatedSubscriptionHookResult =
  ReturnType<typeof useOnScheduledMeasurementCalculationUpdatedSubscription>;
export type OnScheduledMeasurementCalculationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnScheduledMeasurementCalculationUpdatedSubscription>;
export const OnScheduledMetricCalculationUpdatedDocument = gql`
  subscription OnScheduledMetricCalculationUpdated {
    scheduledMetricCalculationUpdated {
      scheduledMetricCalculation {
        ...ScheduledMetricCalculation
      }
    }
  }
  ${ScheduledMetricCalculationFragmentDoc}
`;

/**
 * __useOnScheduledMetricCalculationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnScheduledMetricCalculationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnScheduledMetricCalculationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnScheduledMetricCalculationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnScheduledMetricCalculationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnScheduledMetricCalculationUpdatedSubscription,
    OnScheduledMetricCalculationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnScheduledMetricCalculationUpdatedSubscription,
    OnScheduledMetricCalculationUpdatedSubscriptionVariables
  >(OnScheduledMetricCalculationUpdatedDocument, options);
}
export type OnScheduledMetricCalculationUpdatedSubscriptionHookResult =
  ReturnType<typeof useOnScheduledMetricCalculationUpdatedSubscription>;
export type OnScheduledMetricCalculationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnScheduledMetricCalculationUpdatedSubscription>;
export const ProcessRoundLogsDocument = gql`
  query ProcessRoundLogs($parent: String!, $pageSize: Int, $pageToken: String) {
    processRoundLogs(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      __typename
      ... on MetricsV1ListProcessRoundLogsResponse {
        processRoundLogs {
          ...ProcessRoundLog
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ProcessRoundLogFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useProcessRoundLogsQuery__
 *
 * To run a query within a React component, call `useProcessRoundLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessRoundLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessRoundLogsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useProcessRoundLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProcessRoundLogsQuery,
    ProcessRoundLogsQueryVariables
  > &
    (
      | { variables: ProcessRoundLogsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProcessRoundLogsQuery, ProcessRoundLogsQueryVariables>(
    ProcessRoundLogsDocument,
    options,
  );
}
export function useProcessRoundLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProcessRoundLogsQuery,
    ProcessRoundLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProcessRoundLogsQuery,
    ProcessRoundLogsQueryVariables
  >(ProcessRoundLogsDocument, options);
}
// @ts-ignore
export function useProcessRoundLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProcessRoundLogsQuery,
    ProcessRoundLogsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ProcessRoundLogsQuery,
  ProcessRoundLogsQueryVariables
>;
export function useProcessRoundLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProcessRoundLogsQuery,
        ProcessRoundLogsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ProcessRoundLogsQuery | undefined,
  ProcessRoundLogsQueryVariables
>;
export function useProcessRoundLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProcessRoundLogsQuery,
        ProcessRoundLogsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ProcessRoundLogsQuery,
    ProcessRoundLogsQueryVariables
  >(ProcessRoundLogsDocument, options);
}
export type ProcessRoundLogsQueryHookResult = ReturnType<
  typeof useProcessRoundLogsQuery
>;
export type ProcessRoundLogsLazyQueryHookResult = ReturnType<
  typeof useProcessRoundLogsLazyQuery
>;
export type ProcessRoundLogsSuspenseQueryHookResult = ReturnType<
  typeof useProcessRoundLogsSuspenseQuery
>;
export type ProcessRoundLogsQueryResult = Apollo.QueryResult<
  ProcessRoundLogsQuery,
  ProcessRoundLogsQueryVariables
>;
export const PublishMetricDocument = gql`
  mutation PublishMetric($name: String!, $etag: String) {
    publishMetric(name: $name, etag: $etag) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type PublishMetricMutationFn = Apollo.MutationFunction<
  PublishMetricMutation,
  PublishMetricMutationVariables
>;

/**
 * __usePublishMetricMutation__
 *
 * To run a mutation, you first call `usePublishMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMetricMutation, { data, loading, error }] = usePublishMetricMutation({
 *   variables: {
 *      name: // value for 'name'
 *      etag: // value for 'etag'
 *   },
 * });
 */
export function usePublishMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishMetricMutation,
    PublishMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishMetricMutation,
    PublishMetricMutationVariables
  >(PublishMetricDocument, options);
}
export type PublishMetricMutationHookResult = ReturnType<
  typeof usePublishMetricMutation
>;
export type PublishMetricMutationResult =
  Apollo.MutationResult<PublishMetricMutation>;
export type PublishMetricMutationOptions = Apollo.BaseMutationOptions<
  PublishMetricMutation,
  PublishMetricMutationVariables
>;
export const QueryAvailableTimeRangeDocument = gql`
  query QueryAvailableTimeRange(
    $metricCalculationSpec: MetricsV1MetricCalculationSpecInput
  ) {
    queryAvailableTimeRange(metricCalculationSpec: $metricCalculationSpec) {
      ... on MetricsV1QueryAvailableTimeRangeResponse {
        __typename
        startTime
        endTime
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useQueryAvailableTimeRangeQuery__
 *
 * To run a query within a React component, call `useQueryAvailableTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAvailableTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAvailableTimeRangeQuery({
 *   variables: {
 *      metricCalculationSpec: // value for 'metricCalculationSpec'
 *   },
 * });
 */
export function useQueryAvailableTimeRangeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >(QueryAvailableTimeRangeDocument, options);
}
export function useQueryAvailableTimeRangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >(QueryAvailableTimeRangeDocument, options);
}
// @ts-ignore
export function useQueryAvailableTimeRangeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryAvailableTimeRangeQuery,
  QueryAvailableTimeRangeQueryVariables
>;
export function useQueryAvailableTimeRangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryAvailableTimeRangeQuery,
        QueryAvailableTimeRangeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryAvailableTimeRangeQuery | undefined,
  QueryAvailableTimeRangeQueryVariables
>;
export function useQueryAvailableTimeRangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryAvailableTimeRangeQuery,
        QueryAvailableTimeRangeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryAvailableTimeRangeQuery,
    QueryAvailableTimeRangeQueryVariables
  >(QueryAvailableTimeRangeDocument, options);
}
export type QueryAvailableTimeRangeQueryHookResult = ReturnType<
  typeof useQueryAvailableTimeRangeQuery
>;
export type QueryAvailableTimeRangeLazyQueryHookResult = ReturnType<
  typeof useQueryAvailableTimeRangeLazyQuery
>;
export type QueryAvailableTimeRangeSuspenseQueryHookResult = ReturnType<
  typeof useQueryAvailableTimeRangeSuspenseQuery
>;
export type QueryAvailableTimeRangeQueryResult = Apollo.QueryResult<
  QueryAvailableTimeRangeQuery,
  QueryAvailableTimeRangeQueryVariables
>;
export const QueryMetricCalculationDocument = gql`
  query QueryMetricCalculation(
    $name: String!
    $groupByDimensions: [String!]!
    $accumulateDimension: String
    $timeZone: String
  ) {
    queryMetricCalculation(
      name: $name
      groupByDimensions: $groupByDimensions
      accumulateDimension: $accumulateDimension
      timeZone: $timeZone
    ) {
      ... on MetricsV1QueryMetricCalculationResponse {
        __typename
        dimensions
        rows {
          ...MetricRow
        }
      }
      ...DefaultError
    }
  }
  ${MetricRowFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useQueryMetricCalculationQuery__
 *
 * To run a query within a React component, call `useQueryMetricCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMetricCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMetricCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *      groupByDimensions: // value for 'groupByDimensions'
 *      accumulateDimension: // value for 'accumulateDimension'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useQueryMetricCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  > &
    (
      | { variables: QueryMetricCalculationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  >(QueryMetricCalculationDocument, options);
}
export function useQueryMetricCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  >(QueryMetricCalculationDocument, options);
}
// @ts-ignore
export function useQueryMetricCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryMetricCalculationQuery,
  QueryMetricCalculationQueryVariables
>;
export function useQueryMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryMetricCalculationQuery,
        QueryMetricCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryMetricCalculationQuery | undefined,
  QueryMetricCalculationQueryVariables
>;
export function useQueryMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryMetricCalculationQuery,
        QueryMetricCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryMetricCalculationQuery,
    QueryMetricCalculationQueryVariables
  >(QueryMetricCalculationDocument, options);
}
export type QueryMetricCalculationQueryHookResult = ReturnType<
  typeof useQueryMetricCalculationQuery
>;
export type QueryMetricCalculationLazyQueryHookResult = ReturnType<
  typeof useQueryMetricCalculationLazyQuery
>;
export type QueryMetricCalculationSuspenseQueryHookResult = ReturnType<
  typeof useQueryMetricCalculationSuspenseQuery
>;
export type QueryMetricCalculationQueryResult = Apollo.QueryResult<
  QueryMetricCalculationQuery,
  QueryMetricCalculationQueryVariables
>;
export const QueryScheduledMetricCalculationDocument = gql`
  query QueryScheduledMetricCalculation(
    $name: String!
    $groupByDimensions: [String!]!
    $accumulateDimension: String
    $timeZone: String
    $endTime: String
  ) {
    queryScheduledMetricCalculation(
      name: $name
      groupByDimensions: $groupByDimensions
      accumulateDimension: $accumulateDimension
      timeZone: $timeZone
      endTime: $endTime
    ) {
      ... on MetricsV1QueryScheduledMetricCalculationResponse {
        __typename
        dimensions
        minStartTime
        maxStartTime
        rows {
          dimensions {
            key
            value
          }
          aggCount
          value {
            averageSummaryStats {
              mean
              variance
              count
              countMissing
            }
            ratioSummaryStats {
              numeratorMean
              numeratorVariance
              denominatorMean
              denominatorVariance
              count
              countMissing
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useQueryScheduledMetricCalculationQuery__
 *
 * To run a query within a React component, call `useQueryScheduledMetricCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryScheduledMetricCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryScheduledMetricCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *      groupByDimensions: // value for 'groupByDimensions'
 *      accumulateDimension: // value for 'accumulateDimension'
 *      timeZone: // value for 'timeZone'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useQueryScheduledMetricCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  > &
    (
      | {
          variables: QueryScheduledMetricCalculationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  >(QueryScheduledMetricCalculationDocument, options);
}
export function useQueryScheduledMetricCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  >(QueryScheduledMetricCalculationDocument, options);
}
// @ts-ignore
export function useQueryScheduledMetricCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryScheduledMetricCalculationQuery,
  QueryScheduledMetricCalculationQueryVariables
>;
export function useQueryScheduledMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryScheduledMetricCalculationQuery,
        QueryScheduledMetricCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryScheduledMetricCalculationQuery | undefined,
  QueryScheduledMetricCalculationQueryVariables
>;
export function useQueryScheduledMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryScheduledMetricCalculationQuery,
        QueryScheduledMetricCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryScheduledMetricCalculationQuery,
    QueryScheduledMetricCalculationQueryVariables
  >(QueryScheduledMetricCalculationDocument, options);
}
export type QueryScheduledMetricCalculationQueryHookResult = ReturnType<
  typeof useQueryScheduledMetricCalculationQuery
>;
export type QueryScheduledMetricCalculationLazyQueryHookResult = ReturnType<
  typeof useQueryScheduledMetricCalculationLazyQuery
>;
export type QueryScheduledMetricCalculationSuspenseQueryHookResult = ReturnType<
  typeof useQueryScheduledMetricCalculationSuspenseQuery
>;
export type QueryScheduledMetricCalculationQueryResult = Apollo.QueryResult<
  QueryScheduledMetricCalculationQuery,
  QueryScheduledMetricCalculationQueryVariables
>;
export const RetriggerScheduledExposureCalculationDocument = gql`
  mutation RetriggerScheduledExposureCalculation(
    $name: String!
    $retriggerDependentMetricSchedules: Boolean!
  ) {
    retriggerScheduledExposureCalculation(
      name: $name
      retriggerDependentMetricSchedules: $retriggerDependentMetricSchedules
    ) {
      ...ScheduledExposureCalculation
      ...DefaultError
    }
  }
  ${ScheduledExposureCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RetriggerScheduledExposureCalculationMutationFn =
  Apollo.MutationFunction<
    RetriggerScheduledExposureCalculationMutation,
    RetriggerScheduledExposureCalculationMutationVariables
  >;

/**
 * __useRetriggerScheduledExposureCalculationMutation__
 *
 * To run a mutation, you first call `useRetriggerScheduledExposureCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerScheduledExposureCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerScheduledExposureCalculationMutation, { data, loading, error }] = useRetriggerScheduledExposureCalculationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      retriggerDependentMetricSchedules: // value for 'retriggerDependentMetricSchedules'
 *   },
 * });
 */
export function useRetriggerScheduledExposureCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetriggerScheduledExposureCalculationMutation,
    RetriggerScheduledExposureCalculationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetriggerScheduledExposureCalculationMutation,
    RetriggerScheduledExposureCalculationMutationVariables
  >(RetriggerScheduledExposureCalculationDocument, options);
}
export type RetriggerScheduledExposureCalculationMutationHookResult =
  ReturnType<typeof useRetriggerScheduledExposureCalculationMutation>;
export type RetriggerScheduledExposureCalculationMutationResult =
  Apollo.MutationResult<RetriggerScheduledExposureCalculationMutation>;
export type RetriggerScheduledExposureCalculationMutationOptions =
  Apollo.BaseMutationOptions<
    RetriggerScheduledExposureCalculationMutation,
    RetriggerScheduledExposureCalculationMutationVariables
  >;
export const RetriggerScheduledMetricCalculationDocument = gql`
  mutation RetriggerScheduledMetricCalculation($name: String!) {
    retriggerScheduledMetricCalculation(name: $name) {
      ...ScheduledMetricCalculation
    }
  }
  ${ScheduledMetricCalculationFragmentDoc}
`;
export type RetriggerScheduledMetricCalculationMutationFn =
  Apollo.MutationFunction<
    RetriggerScheduledMetricCalculationMutation,
    RetriggerScheduledMetricCalculationMutationVariables
  >;

/**
 * __useRetriggerScheduledMetricCalculationMutation__
 *
 * To run a mutation, you first call `useRetriggerScheduledMetricCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerScheduledMetricCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerScheduledMetricCalculationMutation, { data, loading, error }] = useRetriggerScheduledMetricCalculationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRetriggerScheduledMetricCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetriggerScheduledMetricCalculationMutation,
    RetriggerScheduledMetricCalculationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetriggerScheduledMetricCalculationMutation,
    RetriggerScheduledMetricCalculationMutationVariables
  >(RetriggerScheduledMetricCalculationDocument, options);
}
export type RetriggerScheduledMetricCalculationMutationHookResult = ReturnType<
  typeof useRetriggerScheduledMetricCalculationMutation
>;
export type RetriggerScheduledMetricCalculationMutationResult =
  Apollo.MutationResult<RetriggerScheduledMetricCalculationMutation>;
export type RetriggerScheduledMetricCalculationMutationOptions =
  Apollo.BaseMutationOptions<
    RetriggerScheduledMetricCalculationMutation,
    RetriggerScheduledMetricCalculationMutationVariables
  >;
export const RetriggersDocument = gql`
  query Retriggers($parent: String!, $pageSize: Int) {
    retriggers(parent: $parent, pageSize: $pageSize) {
      __typename
      ... on MetricsV1ListRetriggersResponse {
        retriggers {
          ...Retrigger
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${RetriggerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRetriggersQuery__
 *
 * To run a query within a React component, call `useRetriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetriggersQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useRetriggersQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetriggersQuery,
    RetriggersQueryVariables
  > &
    (
      | { variables: RetriggersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RetriggersQuery, RetriggersQueryVariables>(
    RetriggersDocument,
    options,
  );
}
export function useRetriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetriggersQuery,
    RetriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RetriggersQuery, RetriggersQueryVariables>(
    RetriggersDocument,
    options,
  );
}
// @ts-ignore
export function useRetriggersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RetriggersQuery,
    RetriggersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RetriggersQuery, RetriggersQueryVariables>;
export function useRetriggersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RetriggersQuery,
        RetriggersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RetriggersQuery | undefined,
  RetriggersQueryVariables
>;
export function useRetriggersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RetriggersQuery,
        RetriggersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RetriggersQuery, RetriggersQueryVariables>(
    RetriggersDocument,
    options,
  );
}
export type RetriggersQueryHookResult = ReturnType<typeof useRetriggersQuery>;
export type RetriggersLazyQueryHookResult = ReturnType<
  typeof useRetriggersLazyQuery
>;
export type RetriggersSuspenseQueryHookResult = ReturnType<
  typeof useRetriggersSuspenseQuery
>;
export type RetriggersQueryResult = Apollo.QueryResult<
  RetriggersQuery,
  RetriggersQueryVariables
>;
export const ScheduledExposureCalculationDocument = gql`
  query ScheduledExposureCalculation($name: String!) {
    scheduledExposureCalculation(name: $name) {
      ...ScheduledExposureCalculation
      ...DefaultError
    }
  }
  ${ScheduledExposureCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useScheduledExposureCalculationQuery__
 *
 * To run a query within a React component, call `useScheduledExposureCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledExposureCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledExposureCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useScheduledExposureCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  > &
    (
      | {
          variables: ScheduledExposureCalculationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  >(ScheduledExposureCalculationDocument, options);
}
export function useScheduledExposureCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  >(ScheduledExposureCalculationDocument, options);
}
// @ts-ignore
export function useScheduledExposureCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ScheduledExposureCalculationQuery,
  ScheduledExposureCalculationQueryVariables
>;
export function useScheduledExposureCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledExposureCalculationQuery,
        ScheduledExposureCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ScheduledExposureCalculationQuery | undefined,
  ScheduledExposureCalculationQueryVariables
>;
export function useScheduledExposureCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledExposureCalculationQuery,
        ScheduledExposureCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledExposureCalculationQuery,
    ScheduledExposureCalculationQueryVariables
  >(ScheduledExposureCalculationDocument, options);
}
export type ScheduledExposureCalculationQueryHookResult = ReturnType<
  typeof useScheduledExposureCalculationQuery
>;
export type ScheduledExposureCalculationLazyQueryHookResult = ReturnType<
  typeof useScheduledExposureCalculationLazyQuery
>;
export type ScheduledExposureCalculationSuspenseQueryHookResult = ReturnType<
  typeof useScheduledExposureCalculationSuspenseQuery
>;
export type ScheduledExposureCalculationQueryResult = Apollo.QueryResult<
  ScheduledExposureCalculationQuery,
  ScheduledExposureCalculationQueryVariables
>;
export const ScheduledMeasurementCalculationDocument = gql`
  query ScheduledMeasurementCalculation($name: String!) {
    scheduledMeasurementCalculation(name: $name) {
      ...ScheduledMeasurementCalculation
      ...DefaultError
    }
  }
  ${ScheduledMeasurementCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useScheduledMeasurementCalculationQuery__
 *
 * To run a query within a React component, call `useScheduledMeasurementCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledMeasurementCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledMeasurementCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useScheduledMeasurementCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  > &
    (
      | {
          variables: ScheduledMeasurementCalculationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  >(ScheduledMeasurementCalculationDocument, options);
}
export function useScheduledMeasurementCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  >(ScheduledMeasurementCalculationDocument, options);
}
// @ts-ignore
export function useScheduledMeasurementCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMeasurementCalculationQuery,
  ScheduledMeasurementCalculationQueryVariables
>;
export function useScheduledMeasurementCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMeasurementCalculationQuery,
        ScheduledMeasurementCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMeasurementCalculationQuery | undefined,
  ScheduledMeasurementCalculationQueryVariables
>;
export function useScheduledMeasurementCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMeasurementCalculationQuery,
        ScheduledMeasurementCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledMeasurementCalculationQuery,
    ScheduledMeasurementCalculationQueryVariables
  >(ScheduledMeasurementCalculationDocument, options);
}
export type ScheduledMeasurementCalculationQueryHookResult = ReturnType<
  typeof useScheduledMeasurementCalculationQuery
>;
export type ScheduledMeasurementCalculationLazyQueryHookResult = ReturnType<
  typeof useScheduledMeasurementCalculationLazyQuery
>;
export type ScheduledMeasurementCalculationSuspenseQueryHookResult = ReturnType<
  typeof useScheduledMeasurementCalculationSuspenseQuery
>;
export type ScheduledMeasurementCalculationQueryResult = Apollo.QueryResult<
  ScheduledMeasurementCalculationQuery,
  ScheduledMeasurementCalculationQueryVariables
>;
export const ScheduledMetricCalculationDocument = gql`
  query ScheduledMetricCalculation($name: String!) {
    scheduledMetricCalculation(name: $name) {
      ...ScheduledMetricCalculation
      ...DefaultError
    }
  }
  ${ScheduledMetricCalculationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useScheduledMetricCalculationQuery__
 *
 * To run a query within a React component, call `useScheduledMetricCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledMetricCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledMetricCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useScheduledMetricCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  > &
    (
      | { variables: ScheduledMetricCalculationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  >(ScheduledMetricCalculationDocument, options);
}
export function useScheduledMetricCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  >(ScheduledMetricCalculationDocument, options);
}
// @ts-ignore
export function useScheduledMetricCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMetricCalculationQuery,
  ScheduledMetricCalculationQueryVariables
>;
export function useScheduledMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMetricCalculationQuery,
        ScheduledMetricCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ScheduledMetricCalculationQuery | undefined,
  ScheduledMetricCalculationQueryVariables
>;
export function useScheduledMetricCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledMetricCalculationQuery,
        ScheduledMetricCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledMetricCalculationQuery,
    ScheduledMetricCalculationQueryVariables
  >(ScheduledMetricCalculationDocument, options);
}
export type ScheduledMetricCalculationQueryHookResult = ReturnType<
  typeof useScheduledMetricCalculationQuery
>;
export type ScheduledMetricCalculationLazyQueryHookResult = ReturnType<
  typeof useScheduledMetricCalculationLazyQuery
>;
export type ScheduledMetricCalculationSuspenseQueryHookResult = ReturnType<
  typeof useScheduledMetricCalculationSuspenseQuery
>;
export type ScheduledMetricCalculationQueryResult = Apollo.QueryResult<
  ScheduledMetricCalculationQuery,
  ScheduledMetricCalculationQueryVariables
>;
export const SuggestMetricDocument = gql`
  mutation SuggestMetric($displayName: String, $description: String) {
    suggestMetric(displayName: $displayName, description: $description) {
      ... on MetricsV1SuggestMetricResponse {
        __typename
        error
        metric {
          ...MetricDetails
        }
      }
      ... on Error {
        __typename
        code
        message
      }
    }
  }
  ${MetricDetailsFragmentDoc}
`;
export type SuggestMetricMutationFn = Apollo.MutationFunction<
  SuggestMetricMutation,
  SuggestMetricMutationVariables
>;

/**
 * __useSuggestMetricMutation__
 *
 * To run a mutation, you first call `useSuggestMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestMetricMutation, { data, loading, error }] = useSuggestMetricMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSuggestMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SuggestMetricMutation,
    SuggestMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SuggestMetricMutation,
    SuggestMetricMutationVariables
  >(SuggestMetricDocument, options);
}
export type SuggestMetricMutationHookResult = ReturnType<
  typeof useSuggestMetricMutation
>;
export type SuggestMetricMutationResult =
  Apollo.MutationResult<SuggestMetricMutation>;
export type SuggestMetricMutationOptions = Apollo.BaseMutationOptions<
  SuggestMetricMutation,
  SuggestMetricMutationVariables
>;
export const UnarchiveMetricDocument = gql`
  mutation UnarchiveMetric($name: String!, $etag: String) {
    unarchiveMetric(name: $name, etag: $etag) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UnarchiveMetricMutationFn = Apollo.MutationFunction<
  UnarchiveMetricMutation,
  UnarchiveMetricMutationVariables
>;

/**
 * __useUnarchiveMetricMutation__
 *
 * To run a mutation, you first call `useUnarchiveMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveMetricMutation, { data, loading, error }] = useUnarchiveMetricMutation({
 *   variables: {
 *      name: // value for 'name'
 *      etag: // value for 'etag'
 *   },
 * });
 */
export function useUnarchiveMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveMetricMutation,
    UnarchiveMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveMetricMutation,
    UnarchiveMetricMutationVariables
  >(UnarchiveMetricDocument, options);
}
export type UnarchiveMetricMutationHookResult = ReturnType<
  typeof useUnarchiveMetricMutation
>;
export type UnarchiveMetricMutationResult =
  Apollo.MutationResult<UnarchiveMetricMutation>;
export type UnarchiveMetricMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveMetricMutation,
  UnarchiveMetricMutationVariables
>;
export const UpdateMeasurementDocument = gql`
  mutation UpdateMeasurement(
    $input: PartialMetricsV1MeasurementInput!
    $updateMask: String
    $allowMissing: Boolean
  ) {
    updateMeasurement(
      measurement: $input
      updateMask: $updateMask
      allowMissing: $allowMissing
    ) {
      ...MeasurementDetails
      ...DefaultError
    }
  }
  ${MeasurementDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateMeasurementMutationFn = Apollo.MutationFunction<
  UpdateMeasurementMutation,
  UpdateMeasurementMutationVariables
>;

/**
 * __useUpdateMeasurementMutation__
 *
 * To run a mutation, you first call `useUpdateMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasurementMutation, { data, loading, error }] = useUpdateMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *      allowMissing: // value for 'allowMissing'
 *   },
 * });
 */
export function useUpdateMeasurementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMeasurementMutation,
    UpdateMeasurementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMeasurementMutation,
    UpdateMeasurementMutationVariables
  >(UpdateMeasurementDocument, options);
}
export type UpdateMeasurementMutationHookResult = ReturnType<
  typeof useUpdateMeasurementMutation
>;
export type UpdateMeasurementMutationResult =
  Apollo.MutationResult<UpdateMeasurementMutation>;
export type UpdateMeasurementMutationOptions = Apollo.BaseMutationOptions<
  UpdateMeasurementMutation,
  UpdateMeasurementMutationVariables
>;
export const UpdateMetricDocument = gql`
  mutation UpdateMetric(
    $input: PartialMetricsV1MetricInput!
    $updateMask: String
    $allowMissing: Boolean
  ) {
    updateMetric(
      metric: $input
      updateMask: $updateMask
      allowMissing: $allowMissing
    ) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateMetricMutationFn = Apollo.MutationFunction<
  UpdateMetricMutation,
  UpdateMetricMutationVariables
>;

/**
 * __useUpdateMetricMutation__
 *
 * To run a mutation, you first call `useUpdateMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricMutation, { data, loading, error }] = useUpdateMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *      allowMissing: // value for 'allowMissing'
 *   },
 * });
 */
export function useUpdateMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMetricMutation,
    UpdateMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMetricMutation,
    UpdateMetricMutationVariables
  >(UpdateMetricDocument, options);
}
export type UpdateMetricMutationHookResult = ReturnType<
  typeof useUpdateMetricMutation
>;
export type UpdateMetricMutationResult =
  Apollo.MutationResult<UpdateMetricMutation>;
export type UpdateMetricMutationOptions = Apollo.BaseMutationOptions<
  UpdateMetricMutation,
  UpdateMetricMutationVariables
>;
export const VerifyMetricDocument = gql`
  mutation VerifyMetric(
    $name: String!
    $verification: MetricsV1MetricMetricVerificationVerificationState!
  ) {
    verifyMetric(name: $name, verification: $verification) {
      ...MetricDetails
      ...DefaultError
    }
  }
  ${MetricDetailsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type VerifyMetricMutationFn = Apollo.MutationFunction<
  VerifyMetricMutation,
  VerifyMetricMutationVariables
>;

/**
 * __useVerifyMetricMutation__
 *
 * To run a mutation, you first call `useVerifyMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMetricMutation, { data, loading, error }] = useVerifyMetricMutation({
 *   variables: {
 *      name: // value for 'name'
 *      verification: // value for 'verification'
 *   },
 * });
 */
export function useVerifyMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyMetricMutation,
    VerifyMetricMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyMetricMutation,
    VerifyMetricMutationVariables
  >(VerifyMetricDocument, options);
}
export type VerifyMetricMutationHookResult = ReturnType<
  typeof useVerifyMetricMutation
>;
export type VerifyMetricMutationResult =
  Apollo.MutationResult<VerifyMetricMutation>;
export type VerifyMetricMutationOptions = Apollo.BaseMutationOptions<
  VerifyMetricMutation,
  VerifyMetricMutationVariables
>;
export const WorkflowDisplayNamesDocument = gql`
  query WorkflowDisplayNames($pageToken: String) {
    workflows(pageToken: $pageToken) {
      ... on WorkflowV1ListWorkflowsResponse {
        __typename
        workflows {
          displayName
          name
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowDisplayNamesQuery__
 *
 * To run a query within a React component, call `useWorkflowDisplayNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowDisplayNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowDisplayNamesQuery({
 *   variables: {
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useWorkflowDisplayNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >(WorkflowDisplayNamesDocument, options);
}
export function useWorkflowDisplayNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >(WorkflowDisplayNamesDocument, options);
}
// @ts-ignore
export function useWorkflowDisplayNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowDisplayNamesQuery,
  WorkflowDisplayNamesQueryVariables
>;
export function useWorkflowDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowDisplayNamesQuery,
        WorkflowDisplayNamesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowDisplayNamesQuery | undefined,
  WorkflowDisplayNamesQueryVariables
>;
export function useWorkflowDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowDisplayNamesQuery,
        WorkflowDisplayNamesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowDisplayNamesQuery,
    WorkflowDisplayNamesQueryVariables
  >(WorkflowDisplayNamesDocument, options);
}
export type WorkflowDisplayNamesQueryHookResult = ReturnType<
  typeof useWorkflowDisplayNamesQuery
>;
export type WorkflowDisplayNamesLazyQueryHookResult = ReturnType<
  typeof useWorkflowDisplayNamesLazyQuery
>;
export type WorkflowDisplayNamesSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowDisplayNamesSuspenseQuery
>;
export type WorkflowDisplayNamesQueryResult = Apollo.QueryResult<
  WorkflowDisplayNamesQuery,
  WorkflowDisplayNamesQueryVariables
>;
export const OnboardingDetailsDocument = gql`
  query OnboardingDetails {
    clients(pageSize: 1) {
      ... on IamV1ListClientsResponse {
        __typename
        clients {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
    flags(pageSize: 100) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
          owner {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
          variants {
            name
            creator {
              ... on IamV1Identity {
                __typename
                name
                displayName
                pictureUri
              }
              ...DefaultError
            }
          }
          rules {
            __typename
            name
            enabled
            labels {
              key
              value
            }
          }
          usageMetadata {
            lastResolveTime
          }
        }
      }
      ...DefaultError
    }
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
      }
      ...DefaultError
    }
    dataWarehouses(pageSize: 1) {
      ... on MetricsV1ListDataWarehousesResponse {
        __typename
        dataWarehouses {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
    flagAppliedConnections(pageSize: 1) {
      ... on ConnectorsV1ListFlagAppliedConnectionsResponse {
        __typename
        flagAppliedConnections {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
    assignmentTables(pageSize: 1) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
    factTables(pageSize: 1) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
    metrics(pageSize: 1) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          name
          creator {
            ... on IamV1Identity {
              __typename
              name
              displayName
              pictureUri
            }
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useOnboardingDetailsQuery__
 *
 * To run a query within a React component, call `useOnboardingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >(OnboardingDetailsDocument, options);
}
export function useOnboardingDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >(OnboardingDetailsDocument, options);
}
// @ts-ignore
export function useOnboardingDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OnboardingDetailsQuery,
  OnboardingDetailsQueryVariables
>;
export function useOnboardingDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingDetailsQuery,
        OnboardingDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OnboardingDetailsQuery | undefined,
  OnboardingDetailsQueryVariables
>;
export function useOnboardingDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingDetailsQuery,
        OnboardingDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OnboardingDetailsQuery,
    OnboardingDetailsQueryVariables
  >(OnboardingDetailsDocument, options);
}
export type OnboardingDetailsQueryHookResult = ReturnType<
  typeof useOnboardingDetailsQuery
>;
export type OnboardingDetailsLazyQueryHookResult = ReturnType<
  typeof useOnboardingDetailsLazyQuery
>;
export type OnboardingDetailsSuspenseQueryHookResult = ReturnType<
  typeof useOnboardingDetailsSuspenseQuery
>;
export type OnboardingDetailsQueryResult = Apollo.QueryResult<
  OnboardingDetailsQuery,
  OnboardingDetailsQueryVariables
>;
export const OnboardingSetupDocument = gql`
  query OnboardingSetup {
    onboardingSetup(name: "onboardingSetup") {
      ... on OnboardingV1OnboardingSetup {
        __typename
        path
        dismissed
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useOnboardingSetupQuery__
 *
 * To run a query within a React component, call `useOnboardingSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingSetupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingSetupQuery,
    OnboardingSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingSetupQuery, OnboardingSetupQueryVariables>(
    OnboardingSetupDocument,
    options,
  );
}
export function useOnboardingSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingSetupQuery,
    OnboardingSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OnboardingSetupQuery,
    OnboardingSetupQueryVariables
  >(OnboardingSetupDocument, options);
}
// @ts-ignore
export function useOnboardingSetupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OnboardingSetupQuery,
    OnboardingSetupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OnboardingSetupQuery,
  OnboardingSetupQueryVariables
>;
export function useOnboardingSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingSetupQuery,
        OnboardingSetupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OnboardingSetupQuery | undefined,
  OnboardingSetupQueryVariables
>;
export function useOnboardingSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingSetupQuery,
        OnboardingSetupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OnboardingSetupQuery,
    OnboardingSetupQueryVariables
  >(OnboardingSetupDocument, options);
}
export type OnboardingSetupQueryHookResult = ReturnType<
  typeof useOnboardingSetupQuery
>;
export type OnboardingSetupLazyQueryHookResult = ReturnType<
  typeof useOnboardingSetupLazyQuery
>;
export type OnboardingSetupSuspenseQueryHookResult = ReturnType<
  typeof useOnboardingSetupSuspenseQuery
>;
export type OnboardingSetupQueryResult = Apollo.QueryResult<
  OnboardingSetupQuery,
  OnboardingSetupQueryVariables
>;
export const TourPreferencesDocument = gql`
  query TourPreferences {
    tourPreferences {
      ...TourPreferences
      ...DefaultError
    }
  }
  ${TourPreferencesFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useTourPreferencesQuery__
 *
 * To run a query within a React component, call `useTourPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTourPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TourPreferencesQuery,
    TourPreferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TourPreferencesQuery, TourPreferencesQueryVariables>(
    TourPreferencesDocument,
    options,
  );
}
export function useTourPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TourPreferencesQuery,
    TourPreferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TourPreferencesQuery,
    TourPreferencesQueryVariables
  >(TourPreferencesDocument, options);
}
// @ts-ignore
export function useTourPreferencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TourPreferencesQuery,
    TourPreferencesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TourPreferencesQuery,
  TourPreferencesQueryVariables
>;
export function useTourPreferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TourPreferencesQuery,
        TourPreferencesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TourPreferencesQuery | undefined,
  TourPreferencesQueryVariables
>;
export function useTourPreferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TourPreferencesQuery,
        TourPreferencesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TourPreferencesQuery,
    TourPreferencesQueryVariables
  >(TourPreferencesDocument, options);
}
export type TourPreferencesQueryHookResult = ReturnType<
  typeof useTourPreferencesQuery
>;
export type TourPreferencesLazyQueryHookResult = ReturnType<
  typeof useTourPreferencesLazyQuery
>;
export type TourPreferencesSuspenseQueryHookResult = ReturnType<
  typeof useTourPreferencesSuspenseQuery
>;
export type TourPreferencesQueryResult = Apollo.QueryResult<
  TourPreferencesQuery,
  TourPreferencesQueryVariables
>;
export const UpdateOnboardingSetupDocument = gql`
  mutation UpdateOnboardingSetup(
    $input: PartialOnboardingV1OnboardingSetupInput!
    $updateMask: String
  ) {
    updateOnboardingSetup(onboardingSetup: $input, updateMask: $updateMask) {
      ... on OnboardingV1OnboardingSetup {
        __typename
        path
        dismissed
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UpdateOnboardingSetupMutationFn = Apollo.MutationFunction<
  UpdateOnboardingSetupMutation,
  UpdateOnboardingSetupMutationVariables
>;

/**
 * __useUpdateOnboardingSetupMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingSetupMutation, { data, loading, error }] = useUpdateOnboardingSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateOnboardingSetupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOnboardingSetupMutation,
    UpdateOnboardingSetupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOnboardingSetupMutation,
    UpdateOnboardingSetupMutationVariables
  >(UpdateOnboardingSetupDocument, options);
}
export type UpdateOnboardingSetupMutationHookResult = ReturnType<
  typeof useUpdateOnboardingSetupMutation
>;
export type UpdateOnboardingSetupMutationResult =
  Apollo.MutationResult<UpdateOnboardingSetupMutation>;
export type UpdateOnboardingSetupMutationOptions = Apollo.BaseMutationOptions<
  UpdateOnboardingSetupMutation,
  UpdateOnboardingSetupMutationVariables
>;
export const UpdateTourPreferencesDocument = gql`
  mutation UpdateTourPreferences(
    $input: PartialOnboardingV1TourPreferencesInput!
    $updateMask: String
  ) {
    updateTourPreferences(tourPreferences: $input, updateMask: $updateMask) {
      ...TourPreferences
      ...DefaultError
    }
  }
  ${TourPreferencesFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateTourPreferencesMutationFn = Apollo.MutationFunction<
  UpdateTourPreferencesMutation,
  UpdateTourPreferencesMutationVariables
>;

/**
 * __useUpdateTourPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateTourPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourPreferencesMutation, { data, loading, error }] = useUpdateTourPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateTourPreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTourPreferencesMutation,
    UpdateTourPreferencesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTourPreferencesMutation,
    UpdateTourPreferencesMutationVariables
  >(UpdateTourPreferencesDocument, options);
}
export type UpdateTourPreferencesMutationHookResult = ReturnType<
  typeof useUpdateTourPreferencesMutation
>;
export type UpdateTourPreferencesMutationResult =
  Apollo.MutationResult<UpdateTourPreferencesMutation>;
export type UpdateTourPreferencesMutationOptions = Apollo.BaseMutationOptions<
  UpdateTourPreferencesMutation,
  UpdateTourPreferencesMutationVariables
>;
export const ExecuteCheckDocument = gql`
  mutation ExecuteCheck($resourceRelations: [FgaV1ResourceRelationInput!]!) {
    executeCheck(resourceRelations: $resourceRelations) {
      ... on FgaV1ExecuteCheckResponse {
        __typename
        allAllowed
        results {
          relation {
            resource
            relation
          }
          allowed
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ExecuteCheckMutationFn = Apollo.MutationFunction<
  ExecuteCheckMutation,
  ExecuteCheckMutationVariables
>;

/**
 * __useExecuteCheckMutation__
 *
 * To run a mutation, you first call `useExecuteCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCheckMutation, { data, loading, error }] = useExecuteCheckMutation({
 *   variables: {
 *      resourceRelations: // value for 'resourceRelations'
 *   },
 * });
 */
export function useExecuteCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteCheckMutation,
    ExecuteCheckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExecuteCheckMutation,
    ExecuteCheckMutationVariables
  >(ExecuteCheckDocument, options);
}
export type ExecuteCheckMutationHookResult = ReturnType<
  typeof useExecuteCheckMutation
>;
export type ExecuteCheckMutationResult =
  Apollo.MutationResult<ExecuteCheckMutation>;
export type ExecuteCheckMutationOptions = Apollo.BaseMutationOptions<
  ExecuteCheckMutation,
  ExecuteCheckMutationVariables
>;
export const ResourcePermissionsDocument = gql`
  query ResourcePermissions($name: String!) {
    resourcePermissions(resource: $name, pageSize: 100) {
      ... on FgaV1ListResourcePermissionsResponse {
        __typename
        resourcePermissions {
          name
          resource
          resourcePermission
          identity {
            ...IdentityRef
            ...DefaultError
          }
        }
      }
      ...DefaultError
    }
  }
  ${IdentityRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useResourcePermissionsQuery__
 *
 * To run a query within a React component, call `useResourcePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePermissionsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useResourcePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  > &
    (
      | { variables: ResourcePermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  >(ResourcePermissionsDocument, options);
}
export function useResourcePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  >(ResourcePermissionsDocument, options);
}
// @ts-ignore
export function useResourcePermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ResourcePermissionsQuery,
  ResourcePermissionsQueryVariables
>;
export function useResourcePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcePermissionsQuery,
        ResourcePermissionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ResourcePermissionsQuery | undefined,
  ResourcePermissionsQueryVariables
>;
export function useResourcePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcePermissionsQuery,
        ResourcePermissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResourcePermissionsQuery,
    ResourcePermissionsQueryVariables
  >(ResourcePermissionsDocument, options);
}
export type ResourcePermissionsQueryHookResult = ReturnType<
  typeof useResourcePermissionsQuery
>;
export type ResourcePermissionsLazyQueryHookResult = ReturnType<
  typeof useResourcePermissionsLazyQuery
>;
export type ResourcePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useResourcePermissionsSuspenseQuery
>;
export type ResourcePermissionsQueryResult = Apollo.QueryResult<
  ResourcePermissionsQuery,
  ResourcePermissionsQueryVariables
>;
export const WriteResourcePermissionsDocument = gql`
  mutation WriteResourcePermissions(
    $removePermissions: [String!]
    $addPermissions: [FgaV1ResourcePermissionInput!]
  ) {
    writeResourcePermissions(
      removePermissions: $removePermissions
      addPermissions: $addPermissions
    ) {
      ... on FgaV1WriteResourcePermissionsResponse {
        __typename
        addedPermissions {
          ...ResourcePermission
        }
        removedPermissions {
          name
        }
      }
      ...DefaultError
    }
  }
  ${ResourcePermissionFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type WriteResourcePermissionsMutationFn = Apollo.MutationFunction<
  WriteResourcePermissionsMutation,
  WriteResourcePermissionsMutationVariables
>;

/**
 * __useWriteResourcePermissionsMutation__
 *
 * To run a mutation, you first call `useWriteResourcePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteResourcePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeResourcePermissionsMutation, { data, loading, error }] = useWriteResourcePermissionsMutation({
 *   variables: {
 *      removePermissions: // value for 'removePermissions'
 *      addPermissions: // value for 'addPermissions'
 *   },
 * });
 */
export function useWriteResourcePermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteResourcePermissionsMutation,
    WriteResourcePermissionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteResourcePermissionsMutation,
    WriteResourcePermissionsMutationVariables
  >(WriteResourcePermissionsDocument, options);
}
export type WriteResourcePermissionsMutationHookResult = ReturnType<
  typeof useWriteResourcePermissionsMutation
>;
export type WriteResourcePermissionsMutationResult =
  Apollo.MutationResult<WriteResourcePermissionsMutation>;
export type WriteResourcePermissionsMutationOptions =
  Apollo.BaseMutationOptions<
    WriteResourcePermissionsMutation,
    WriteResourcePermissionsMutationVariables
  >;
export const TransferWorkflowOwnershipDocument = gql`
  mutation TransferWorkflowOwnership(
    $workflowInstance: PartialWorkflowV1WorkflowInstanceInput!
  ) {
    updateWorkflowInstance(
      workflowInstance: $workflowInstance
      updateMask: "owner"
    ) {
      ... on WorkflowV1WorkflowInstance {
        __typename
        name
        owner {
          __typename
          ... on IamV1Identity {
            __typename
            name
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type TransferWorkflowOwnershipMutationFn = Apollo.MutationFunction<
  TransferWorkflowOwnershipMutation,
  TransferWorkflowOwnershipMutationVariables
>;

/**
 * __useTransferWorkflowOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferWorkflowOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferWorkflowOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferWorkflowOwnershipMutation, { data, loading, error }] = useTransferWorkflowOwnershipMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useTransferWorkflowOwnershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferWorkflowOwnershipMutation,
    TransferWorkflowOwnershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TransferWorkflowOwnershipMutation,
    TransferWorkflowOwnershipMutationVariables
  >(TransferWorkflowOwnershipDocument, options);
}
export type TransferWorkflowOwnershipMutationHookResult = ReturnType<
  typeof useTransferWorkflowOwnershipMutation
>;
export type TransferWorkflowOwnershipMutationResult =
  Apollo.MutationResult<TransferWorkflowOwnershipMutation>;
export type TransferWorkflowOwnershipMutationOptions =
  Apollo.BaseMutationOptions<
    TransferWorkflowOwnershipMutation,
    TransferWorkflowOwnershipMutationVariables
  >;
export const CreateProjectDocument = gql`
  mutation CreateProject(
    $project: CollaborationV1ProjectInput!
    $projectId: String
  ) {
    createProject(project: $project, projectId: $projectId) {
      __typename
      ...Project
      ...DefaultError
    }
  }
  ${ProjectFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >(CreateProjectDocument, options);
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>;
export type CreateProjectMutationResult =
  Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;
export const CreatePromptHookDocument = gql`
  mutation CreatePromptHook(
    $promptHook: ConversationsV2PromptHookInput!
    $promptHookId: String
  ) {
    createPromptHook(promptHook: $promptHook, promptHookId: $promptHookId) {
      __typename
      ...PromptHook
      ...DefaultError
    }
  }
  ${PromptHookFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreatePromptHookMutationFn = Apollo.MutationFunction<
  CreatePromptHookMutation,
  CreatePromptHookMutationVariables
>;

/**
 * __useCreatePromptHookMutation__
 *
 * To run a mutation, you first call `useCreatePromptHookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromptHookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromptHookMutation, { data, loading, error }] = useCreatePromptHookMutation({
 *   variables: {
 *      promptHook: // value for 'promptHook'
 *      promptHookId: // value for 'promptHookId'
 *   },
 * });
 */
export function useCreatePromptHookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePromptHookMutation,
    CreatePromptHookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePromptHookMutation,
    CreatePromptHookMutationVariables
  >(CreatePromptHookDocument, options);
}
export type CreatePromptHookMutationHookResult = ReturnType<
  typeof useCreatePromptHookMutation
>;
export type CreatePromptHookMutationResult =
  Apollo.MutationResult<CreatePromptHookMutation>;
export type CreatePromptHookMutationOptions = Apollo.BaseMutationOptions<
  CreatePromptHookMutation,
  CreatePromptHookMutationVariables
>;
export const DeleteProjectDocument = gql`
  mutation DeleteProject($name: String!) {
    deleteProject(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >(DeleteProjectDocument, options);
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>;
export type DeleteProjectMutationResult =
  Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;
export const DeletePromptHookDocument = gql`
  mutation DeletePromptHook($name: String!) {
    deletePromptHook(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeletePromptHookMutationFn = Apollo.MutationFunction<
  DeletePromptHookMutation,
  DeletePromptHookMutationVariables
>;

/**
 * __useDeletePromptHookMutation__
 *
 * To run a mutation, you first call `useDeletePromptHookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromptHookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromptHookMutation, { data, loading, error }] = useDeletePromptHookMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeletePromptHookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePromptHookMutation,
    DeletePromptHookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePromptHookMutation,
    DeletePromptHookMutationVariables
  >(DeletePromptHookDocument, options);
}
export type DeletePromptHookMutationHookResult = ReturnType<
  typeof useDeletePromptHookMutation
>;
export type DeletePromptHookMutationResult =
  Apollo.MutationResult<DeletePromptHookMutation>;
export type DeletePromptHookMutationOptions = Apollo.BaseMutationOptions<
  DeletePromptHookMutation,
  DeletePromptHookMutationVariables
>;
export const OnProjectCreatedDocument = gql`
  subscription OnProjectCreated {
    projectCreated {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useOnProjectCreatedSubscription__
 *
 * To run a query within a React component, call `useOnProjectCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProjectCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProjectCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnProjectCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnProjectCreatedSubscription,
    OnProjectCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnProjectCreatedSubscription,
    OnProjectCreatedSubscriptionVariables
  >(OnProjectCreatedDocument, options);
}
export type OnProjectCreatedSubscriptionHookResult = ReturnType<
  typeof useOnProjectCreatedSubscription
>;
export type OnProjectCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnProjectCreatedSubscription>;
export const OnProjectUpdatedDocument = gql`
  subscription OnProjectUpdated {
    projectUpdated {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useOnProjectUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnProjectUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProjectUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProjectUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnProjectUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnProjectUpdatedSubscription,
    OnProjectUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnProjectUpdatedSubscription,
    OnProjectUpdatedSubscriptionVariables
  >(OnProjectUpdatedDocument, options);
}
export type OnProjectUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnProjectUpdatedSubscription
>;
export type OnProjectUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnProjectUpdatedSubscription>;
export const ProjectDocument = gql`
  query Project($name: String!) {
    project(name: $name) {
      ...Project
      ...DefaultError
    }
  }
  ${ProjectFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> &
    ({ variables: ProjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options,
  );
}
export function useProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectQuery,
    ProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options,
  );
}
// @ts-ignore
export function useProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectQuery,
    ProjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ProjectQuery, ProjectQueryVariables>;
export function useProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ProjectQuery | undefined,
  ProjectQueryVariables
>;
export function useProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options,
  );
}
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<
  typeof useProjectSuspenseQuery
>;
export type ProjectQueryResult = Apollo.QueryResult<
  ProjectQuery,
  ProjectQueryVariables
>;
export const ProjectRefDocument = gql`
  query ProjectRef($name: String!) {
    project(name: $name) {
      ...ProjectRef
      ...DefaultError
    }
  }
  ${ProjectRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useProjectRefQuery__
 *
 * To run a query within a React component, call `useProjectRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectRefQuery,
    ProjectRefQueryVariables
  > &
    (
      | { variables: ProjectRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectRefQuery, ProjectRefQueryVariables>(
    ProjectRefDocument,
    options,
  );
}
export function useProjectRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectRefQuery,
    ProjectRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectRefQuery, ProjectRefQueryVariables>(
    ProjectRefDocument,
    options,
  );
}
// @ts-ignore
export function useProjectRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectRefQuery,
    ProjectRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ProjectRefQuery, ProjectRefQueryVariables>;
export function useProjectRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectRefQuery,
        ProjectRefQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ProjectRefQuery | undefined,
  ProjectRefQueryVariables
>;
export function useProjectRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectRefQuery,
        ProjectRefQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectRefQuery, ProjectRefQueryVariables>(
    ProjectRefDocument,
    options,
  );
}
export type ProjectRefQueryHookResult = ReturnType<typeof useProjectRefQuery>;
export type ProjectRefLazyQueryHookResult = ReturnType<
  typeof useProjectRefLazyQuery
>;
export type ProjectRefSuspenseQueryHookResult = ReturnType<
  typeof useProjectRefSuspenseQuery
>;
export type ProjectRefQueryResult = Apollo.QueryResult<
  ProjectRefQuery,
  ProjectRefQueryVariables
>;
export const ProjectsDocument = gql`
  query Projects(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    projects(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on CollaborationV1ListProjectsResponse {
        __typename
        projects {
          ...ProjectRef
          resourceRelations {
            ... on FgaV1ListResourceRelationsResponse {
              __typename
              resourceRelations {
                ... on FgaV1ResourceRelation {
                  relation
                }
              }
            }
            ...DefaultError
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ProjectRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options,
  );
}
export function useProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectsQuery,
    ProjectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options,
  );
}
// @ts-ignore
export function useProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectsQuery,
    ProjectsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ProjectsQuery | undefined,
  ProjectsQueryVariables
>;
export function useProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options,
  );
}
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<
  typeof useProjectsLazyQuery
>;
export type ProjectsSuspenseQueryHookResult = ReturnType<
  typeof useProjectsSuspenseQuery
>;
export type ProjectsQueryResult = Apollo.QueryResult<
  ProjectsQuery,
  ProjectsQueryVariables
>;
export const PromptHookDocument = gql`
  query PromptHook($name: String!) {
    promptHook(name: $name) {
      ...PromptHook
      ...DefaultError
      ... on ConversationsV2PromptHook {
        collaborativeDocuments {
          ... on CollaborationV1ListCollaborativeDocumentsResponse {
            __typename
            collaborativeDocuments {
              ...CollaborativeDocumentRef
            }
          }
          ...DefaultError
        }
      }
    }
  }
  ${PromptHookFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${CollaborativeDocumentRefFragmentDoc}
`;

/**
 * __usePromptHookQuery__
 *
 * To run a query within a React component, call `usePromptHookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHookQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePromptHookQuery(
  baseOptions: Apollo.QueryHookOptions<
    PromptHookQuery,
    PromptHookQueryVariables
  > &
    (
      | { variables: PromptHookQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PromptHookQuery, PromptHookQueryVariables>(
    PromptHookDocument,
    options,
  );
}
export function usePromptHookLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PromptHookQuery,
    PromptHookQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PromptHookQuery, PromptHookQueryVariables>(
    PromptHookDocument,
    options,
  );
}
// @ts-ignore
export function usePromptHookSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PromptHookQuery,
    PromptHookQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PromptHookQuery, PromptHookQueryVariables>;
export function usePromptHookSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromptHookQuery,
        PromptHookQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PromptHookQuery | undefined,
  PromptHookQueryVariables
>;
export function usePromptHookSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromptHookQuery,
        PromptHookQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PromptHookQuery, PromptHookQueryVariables>(
    PromptHookDocument,
    options,
  );
}
export type PromptHookQueryHookResult = ReturnType<typeof usePromptHookQuery>;
export type PromptHookLazyQueryHookResult = ReturnType<
  typeof usePromptHookLazyQuery
>;
export type PromptHookSuspenseQueryHookResult = ReturnType<
  typeof usePromptHookSuspenseQuery
>;
export type PromptHookQueryResult = Apollo.QueryResult<
  PromptHookQuery,
  PromptHookQueryVariables
>;
export const PromptHooksDocument = gql`
  query PromptHooks(
    $filter: String
    $orderBy: String
    $pageSize: Int
    $pageToken: String
  ) {
    promptHooks(
      filter: $filter
      orderBy: $orderBy
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      __typename
      ... on ConversationsV2ListPromptHooksResponse {
        promptHooks {
          ...PromptHook
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PromptHookFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePromptHooksQuery__
 *
 * To run a query within a React component, call `usePromptHooksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHooksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePromptHooksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PromptHooksQuery,
    PromptHooksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PromptHooksQuery, PromptHooksQueryVariables>(
    PromptHooksDocument,
    options,
  );
}
export function usePromptHooksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PromptHooksQuery,
    PromptHooksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PromptHooksQuery, PromptHooksQueryVariables>(
    PromptHooksDocument,
    options,
  );
}
// @ts-ignore
export function usePromptHooksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PromptHooksQuery,
    PromptHooksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PromptHooksQuery, PromptHooksQueryVariables>;
export function usePromptHooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromptHooksQuery,
        PromptHooksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PromptHooksQuery | undefined,
  PromptHooksQueryVariables
>;
export function usePromptHooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromptHooksQuery,
        PromptHooksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PromptHooksQuery, PromptHooksQueryVariables>(
    PromptHooksDocument,
    options,
  );
}
export type PromptHooksQueryHookResult = ReturnType<typeof usePromptHooksQuery>;
export type PromptHooksLazyQueryHookResult = ReturnType<
  typeof usePromptHooksLazyQuery
>;
export type PromptHooksSuspenseQueryHookResult = ReturnType<
  typeof usePromptHooksSuspenseQuery
>;
export type PromptHooksQueryResult = Apollo.QueryResult<
  PromptHooksQuery,
  PromptHooksQueryVariables
>;
export const UpdateProjectDocument = gql`
  mutation UpdateProject(
    $input: PartialCollaborationV1ProjectInput!
    $updateMask: String
  ) {
    updateProject(project: $input, updateMask: $updateMask) {
      __typename
      ...Project
      ...DefaultError
    }
  }
  ${ProjectFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >(UpdateProjectDocument, options);
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>;
export type UpdateProjectMutationResult =
  Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;
export const UpdatePromptHookDocument = gql`
  mutation UpdatePromptHook(
    $input: PartialConversationsV2PromptHookInput!
    $updateMask: String
  ) {
    updatePromptHook(promptHook: $input, updateMask: $updateMask) {
      ...PromptHook
      ...DefaultError
    }
  }
  ${PromptHookFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdatePromptHookMutationFn = Apollo.MutationFunction<
  UpdatePromptHookMutation,
  UpdatePromptHookMutationVariables
>;

/**
 * __useUpdatePromptHookMutation__
 *
 * To run a mutation, you first call `useUpdatePromptHookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromptHookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromptHookMutation, { data, loading, error }] = useUpdatePromptHookMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdatePromptHookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePromptHookMutation,
    UpdatePromptHookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePromptHookMutation,
    UpdatePromptHookMutationVariables
  >(UpdatePromptHookDocument, options);
}
export type UpdatePromptHookMutationHookResult = ReturnType<
  typeof useUpdatePromptHookMutation
>;
export type UpdatePromptHookMutationResult =
  Apollo.MutationResult<UpdatePromptHookMutation>;
export type UpdatePromptHookMutationOptions = Apollo.BaseMutationOptions<
  UpdatePromptHookMutation,
  UpdatePromptHookMutationVariables
>;
export const ProjectIndexPageDocument = gql`
  query ProjectIndexPage(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    projects(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on CollaborationV1ListProjectsResponse {
        __typename
        projects {
          ...ProjectIndexPageProject
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ProjectIndexPageProjectFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useProjectIndexPageQuery__
 *
 * To run a query within a React component, call `useProjectIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectIndexPageQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useProjectIndexPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProjectIndexPageQuery,
    ProjectIndexPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectIndexPageQuery, ProjectIndexPageQueryVariables>(
    ProjectIndexPageDocument,
    options,
  );
}
export function useProjectIndexPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectIndexPageQuery,
    ProjectIndexPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProjectIndexPageQuery,
    ProjectIndexPageQueryVariables
  >(ProjectIndexPageDocument, options);
}
// @ts-ignore
export function useProjectIndexPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectIndexPageQuery,
    ProjectIndexPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ProjectIndexPageQuery,
  ProjectIndexPageQueryVariables
>;
export function useProjectIndexPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectIndexPageQuery,
        ProjectIndexPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ProjectIndexPageQuery | undefined,
  ProjectIndexPageQueryVariables
>;
export function useProjectIndexPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectIndexPageQuery,
        ProjectIndexPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ProjectIndexPageQuery,
    ProjectIndexPageQueryVariables
  >(ProjectIndexPageDocument, options);
}
export type ProjectIndexPageQueryHookResult = ReturnType<
  typeof useProjectIndexPageQuery
>;
export type ProjectIndexPageLazyQueryHookResult = ReturnType<
  typeof useProjectIndexPageLazyQuery
>;
export type ProjectIndexPageSuspenseQueryHookResult = ReturnType<
  typeof useProjectIndexPageSuspenseQuery
>;
export type ProjectIndexPageQueryResult = Apollo.QueryResult<
  ProjectIndexPageQuery,
  ProjectIndexPageQueryVariables
>;
export const CapturePulseBlockDocument = gql`
  mutation CapturePulseBlock(
    $sourceChat: String!
    $sourceEvent: String
    $displayName: String
    $pulse: String
    $blockType: PulseV1PulseBlockType
    $visualizationSpec: JSON
    $selectedContent: String
  ) {
    capturePulseBlock(
      sourceChat: $sourceChat
      sourceEvent: $sourceEvent
      displayName: $displayName
      pulse: $pulse
      blockType: $blockType
      visualizationSpec: $visualizationSpec
      selectedContent: $selectedContent
    ) {
      ... on PulseV1CapturePulseBlockResponse {
        __typename
        pulse {
          ...PulseRef
        }
        block {
          ...PulseBlock
        }
      }
      ...DefaultError
    }
  }
  ${PulseRefFragmentDoc}
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CapturePulseBlockMutationFn = Apollo.MutationFunction<
  CapturePulseBlockMutation,
  CapturePulseBlockMutationVariables
>;

/**
 * __useCapturePulseBlockMutation__
 *
 * To run a mutation, you first call `useCapturePulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePulseBlockMutation, { data, loading, error }] = useCapturePulseBlockMutation({
 *   variables: {
 *      sourceChat: // value for 'sourceChat'
 *      sourceEvent: // value for 'sourceEvent'
 *      displayName: // value for 'displayName'
 *      pulse: // value for 'pulse'
 *      blockType: // value for 'blockType'
 *      visualizationSpec: // value for 'visualizationSpec'
 *      selectedContent: // value for 'selectedContent'
 *   },
 * });
 */
export function useCapturePulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CapturePulseBlockMutation,
    CapturePulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CapturePulseBlockMutation,
    CapturePulseBlockMutationVariables
  >(CapturePulseBlockDocument, options);
}
export type CapturePulseBlockMutationHookResult = ReturnType<
  typeof useCapturePulseBlockMutation
>;
export type CapturePulseBlockMutationResult =
  Apollo.MutationResult<CapturePulseBlockMutation>;
export type CapturePulseBlockMutationOptions = Apollo.BaseMutationOptions<
  CapturePulseBlockMutation,
  CapturePulseBlockMutationVariables
>;
export const ConfigurePulseRefreshScheduleDocument = gql`
  mutation ConfigurePulseRefreshSchedule(
    $pulse: String!
    $schedule: PulseV1PulseRefreshSchedule!
    $timeZone: String
    $interval: Int
    $hour: Int
    $minute: Int
    $dayOfWeek: Int
  ) {
    configurePulseRefreshSchedule(
      pulse: $pulse
      schedule: $schedule
      timeZone: $timeZone
      interval: $interval
      hour: $hour
      minute: $minute
      dayOfWeek: $dayOfWeek
    ) {
      ... on PulseV1ConfigurePulseRefreshScheduleResponse {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ConfigurePulseRefreshScheduleMutationFn = Apollo.MutationFunction<
  ConfigurePulseRefreshScheduleMutation,
  ConfigurePulseRefreshScheduleMutationVariables
>;

/**
 * __useConfigurePulseRefreshScheduleMutation__
 *
 * To run a mutation, you first call `useConfigurePulseRefreshScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigurePulseRefreshScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configurePulseRefreshScheduleMutation, { data, loading, error }] = useConfigurePulseRefreshScheduleMutation({
 *   variables: {
 *      pulse: // value for 'pulse'
 *      schedule: // value for 'schedule'
 *      timeZone: // value for 'timeZone'
 *      interval: // value for 'interval'
 *      hour: // value for 'hour'
 *      minute: // value for 'minute'
 *      dayOfWeek: // value for 'dayOfWeek'
 *   },
 * });
 */
export function useConfigurePulseRefreshScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigurePulseRefreshScheduleMutation,
    ConfigurePulseRefreshScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfigurePulseRefreshScheduleMutation,
    ConfigurePulseRefreshScheduleMutationVariables
  >(ConfigurePulseRefreshScheduleDocument, options);
}
export type ConfigurePulseRefreshScheduleMutationHookResult = ReturnType<
  typeof useConfigurePulseRefreshScheduleMutation
>;
export type ConfigurePulseRefreshScheduleMutationResult =
  Apollo.MutationResult<ConfigurePulseRefreshScheduleMutation>;
export type ConfigurePulseRefreshScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    ConfigurePulseRefreshScheduleMutation,
    ConfigurePulseRefreshScheduleMutationVariables
  >;
export const CreatePulseDocument = gql`
  mutation CreatePulse($pulse: PulseV1PulseInput!, $pulseId: String) {
    createPulse(pulse: $pulse, pulseId: $pulseId) {
      ...PulseRef
      ...DefaultError
    }
  }
  ${PulseRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreatePulseMutationFn = Apollo.MutationFunction<
  CreatePulseMutation,
  CreatePulseMutationVariables
>;

/**
 * __useCreatePulseMutation__
 *
 * To run a mutation, you first call `useCreatePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPulseMutation, { data, loading, error }] = useCreatePulseMutation({
 *   variables: {
 *      pulse: // value for 'pulse'
 *      pulseId: // value for 'pulseId'
 *   },
 * });
 */
export function useCreatePulseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePulseMutation,
    CreatePulseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePulseMutation, CreatePulseMutationVariables>(
    CreatePulseDocument,
    options,
  );
}
export type CreatePulseMutationHookResult = ReturnType<
  typeof useCreatePulseMutation
>;
export type CreatePulseMutationResult =
  Apollo.MutationResult<CreatePulseMutation>;
export type CreatePulseMutationOptions = Apollo.BaseMutationOptions<
  CreatePulseMutation,
  CreatePulseMutationVariables
>;
export const CreatePulseBlockDocument = gql`
  mutation CreatePulseBlock(
    $parent: String!
    $pulseBlock: PulseV1PulseBlockInput!
  ) {
    createPulseBlock(parent: $parent, pulseBlock: $pulseBlock) {
      ...PulseBlock
      ...DefaultError
    }
  }
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreatePulseBlockMutationFn = Apollo.MutationFunction<
  CreatePulseBlockMutation,
  CreatePulseBlockMutationVariables
>;

/**
 * __useCreatePulseBlockMutation__
 *
 * To run a mutation, you first call `useCreatePulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPulseBlockMutation, { data, loading, error }] = useCreatePulseBlockMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      pulseBlock: // value for 'pulseBlock'
 *   },
 * });
 */
export function useCreatePulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePulseBlockMutation,
    CreatePulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePulseBlockMutation,
    CreatePulseBlockMutationVariables
  >(CreatePulseBlockDocument, options);
}
export type CreatePulseBlockMutationHookResult = ReturnType<
  typeof useCreatePulseBlockMutation
>;
export type CreatePulseBlockMutationResult =
  Apollo.MutationResult<CreatePulseBlockMutation>;
export type CreatePulseBlockMutationOptions = Apollo.BaseMutationOptions<
  CreatePulseBlockMutation,
  CreatePulseBlockMutationVariables
>;
export const DeletePulseDocument = gql`
  mutation DeletePulse($name: String!) {
    deletePulse(name: $name, force: true) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeletePulseMutationFn = Apollo.MutationFunction<
  DeletePulseMutation,
  DeletePulseMutationVariables
>;

/**
 * __useDeletePulseMutation__
 *
 * To run a mutation, you first call `useDeletePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePulseMutation, { data, loading, error }] = useDeletePulseMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeletePulseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePulseMutation,
    DeletePulseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePulseMutation, DeletePulseMutationVariables>(
    DeletePulseDocument,
    options,
  );
}
export type DeletePulseMutationHookResult = ReturnType<
  typeof useDeletePulseMutation
>;
export type DeletePulseMutationResult =
  Apollo.MutationResult<DeletePulseMutation>;
export type DeletePulseMutationOptions = Apollo.BaseMutationOptions<
  DeletePulseMutation,
  DeletePulseMutationVariables
>;
export const DeletePulseBlockDocument = gql`
  mutation DeletePulseBlock($name: String!) {
    deletePulseBlock(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeletePulseBlockMutationFn = Apollo.MutationFunction<
  DeletePulseBlockMutation,
  DeletePulseBlockMutationVariables
>;

/**
 * __useDeletePulseBlockMutation__
 *
 * To run a mutation, you first call `useDeletePulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePulseBlockMutation, { data, loading, error }] = useDeletePulseBlockMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeletePulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePulseBlockMutation,
    DeletePulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePulseBlockMutation,
    DeletePulseBlockMutationVariables
  >(DeletePulseBlockDocument, options);
}
export type DeletePulseBlockMutationHookResult = ReturnType<
  typeof useDeletePulseBlockMutation
>;
export type DeletePulseBlockMutationResult =
  Apollo.MutationResult<DeletePulseBlockMutation>;
export type DeletePulseBlockMutationOptions = Apollo.BaseMutationOptions<
  DeletePulseBlockMutation,
  DeletePulseBlockMutationVariables
>;
export const PreviewPulseBlockDocument = gql`
  mutation PreviewPulseBlock($input: PulseV1PulseBlockInput!) {
    previewPulseBlock(pulseBlock: $input) {
      ...PulseBlock
      ...DefaultError
    }
  }
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type PreviewPulseBlockMutationFn = Apollo.MutationFunction<
  PreviewPulseBlockMutation,
  PreviewPulseBlockMutationVariables
>;

/**
 * __usePreviewPulseBlockMutation__
 *
 * To run a mutation, you first call `usePreviewPulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewPulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewPulseBlockMutation, { data, loading, error }] = usePreviewPulseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewPulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PreviewPulseBlockMutation,
    PreviewPulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PreviewPulseBlockMutation,
    PreviewPulseBlockMutationVariables
  >(PreviewPulseBlockDocument, options);
}
export type PreviewPulseBlockMutationHookResult = ReturnType<
  typeof usePreviewPulseBlockMutation
>;
export type PreviewPulseBlockMutationResult =
  Apollo.MutationResult<PreviewPulseBlockMutation>;
export type PreviewPulseBlockMutationOptions = Apollo.BaseMutationOptions<
  PreviewPulseBlockMutation,
  PreviewPulseBlockMutationVariables
>;
export const PulseDocument = gql`
  query Pulse($name: String!, $view: PulseV1PulseView) {
    pulse(name: $name, view: $view) {
      ...Pulse
      ...DefaultError
    }
  }
  ${PulseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePulseQuery__
 *
 * To run a query within a React component, call `usePulseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseQuery({
 *   variables: {
 *      name: // value for 'name'
 *      view: // value for 'view'
 *   },
 * });
 */
export function usePulseQuery(
  baseOptions: Apollo.QueryHookOptions<PulseQuery, PulseQueryVariables> &
    ({ variables: PulseQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PulseQuery, PulseQueryVariables>(
    PulseDocument,
    options,
  );
}
export function usePulseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PulseQuery, PulseQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PulseQuery, PulseQueryVariables>(
    PulseDocument,
    options,
  );
}
// @ts-ignore
export function usePulseSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PulseQuery,
    PulseQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PulseQuery, PulseQueryVariables>;
export function usePulseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PulseQuery, PulseQueryVariables>,
): Apollo.UseSuspenseQueryResult<PulseQuery | undefined, PulseQueryVariables>;
export function usePulseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PulseQuery, PulseQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PulseQuery, PulseQueryVariables>(
    PulseDocument,
    options,
  );
}
export type PulseQueryHookResult = ReturnType<typeof usePulseQuery>;
export type PulseLazyQueryHookResult = ReturnType<typeof usePulseLazyQuery>;
export type PulseSuspenseQueryHookResult = ReturnType<
  typeof usePulseSuspenseQuery
>;
export type PulseQueryResult = Apollo.QueryResult<
  PulseQuery,
  PulseQueryVariables
>;
export const PulseBlockDocument = gql`
  query PulseBlock($name: String!) {
    pulseBlock(name: $name) {
      ...PulseBlock
      ...DefaultError
    }
  }
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePulseBlockQuery__
 *
 * To run a query within a React component, call `usePulseBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseBlockQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePulseBlockQuery(
  baseOptions: Apollo.QueryHookOptions<
    PulseBlockQuery,
    PulseBlockQueryVariables
  > &
    (
      | { variables: PulseBlockQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PulseBlockQuery, PulseBlockQueryVariables>(
    PulseBlockDocument,
    options,
  );
}
export function usePulseBlockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PulseBlockQuery,
    PulseBlockQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PulseBlockQuery, PulseBlockQueryVariables>(
    PulseBlockDocument,
    options,
  );
}
// @ts-ignore
export function usePulseBlockSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PulseBlockQuery,
    PulseBlockQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PulseBlockQuery, PulseBlockQueryVariables>;
export function usePulseBlockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PulseBlockQuery,
        PulseBlockQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PulseBlockQuery | undefined,
  PulseBlockQueryVariables
>;
export function usePulseBlockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PulseBlockQuery,
        PulseBlockQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PulseBlockQuery, PulseBlockQueryVariables>(
    PulseBlockDocument,
    options,
  );
}
export type PulseBlockQueryHookResult = ReturnType<typeof usePulseBlockQuery>;
export type PulseBlockLazyQueryHookResult = ReturnType<
  typeof usePulseBlockLazyQuery
>;
export type PulseBlockSuspenseQueryHookResult = ReturnType<
  typeof usePulseBlockSuspenseQuery
>;
export type PulseBlockQueryResult = Apollo.QueryResult<
  PulseBlockQuery,
  PulseBlockQueryVariables
>;
export const PulseChangesDocument = gql`
  query PulseChanges($parent: String!, $pageSize: Int, $pageToken: String) {
    pulseChanges(parent: $parent, pageSize: $pageSize, pageToken: $pageToken) {
      __typename
      ... on PulseV1ListPulseChangesResponse {
        pulseChanges {
          ...PulseChange
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PulseChangeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePulseChangesQuery__
 *
 * To run a query within a React component, call `usePulseChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseChangesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function usePulseChangesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PulseChangesQuery,
    PulseChangesQueryVariables
  > &
    (
      | { variables: PulseChangesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PulseChangesQuery, PulseChangesQueryVariables>(
    PulseChangesDocument,
    options,
  );
}
export function usePulseChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PulseChangesQuery,
    PulseChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PulseChangesQuery, PulseChangesQueryVariables>(
    PulseChangesDocument,
    options,
  );
}
// @ts-ignore
export function usePulseChangesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PulseChangesQuery,
    PulseChangesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PulseChangesQuery, PulseChangesQueryVariables>;
export function usePulseChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PulseChangesQuery,
        PulseChangesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PulseChangesQuery | undefined,
  PulseChangesQueryVariables
>;
export function usePulseChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PulseChangesQuery,
        PulseChangesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PulseChangesQuery, PulseChangesQueryVariables>(
    PulseChangesDocument,
    options,
  );
}
export type PulseChangesQueryHookResult = ReturnType<
  typeof usePulseChangesQuery
>;
export type PulseChangesLazyQueryHookResult = ReturnType<
  typeof usePulseChangesLazyQuery
>;
export type PulseChangesSuspenseQueryHookResult = ReturnType<
  typeof usePulseChangesSuspenseQuery
>;
export type PulseChangesQueryResult = Apollo.QueryResult<
  PulseChangesQuery,
  PulseChangesQueryVariables
>;
export const PulsesDocument = gql`
  query Pulses($pageSize: Int, $pageToken: String, $filter: String) {
    pulses(pageSize: $pageSize, pageToken: $pageToken, filter: $filter) {
      ... on PulseV1ListPulsesResponse {
        __typename
        pulses {
          ...PulseIndexPagePulse
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PulseIndexPagePulseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePulsesQuery__
 *
 * To run a query within a React component, call `usePulsesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulsesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePulsesQuery(
  baseOptions?: Apollo.QueryHookOptions<PulsesQuery, PulsesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PulsesQuery, PulsesQueryVariables>(
    PulsesDocument,
    options,
  );
}
export function usePulsesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PulsesQuery, PulsesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PulsesQuery, PulsesQueryVariables>(
    PulsesDocument,
    options,
  );
}
// @ts-ignore
export function usePulsesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PulsesQuery,
    PulsesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PulsesQuery, PulsesQueryVariables>;
export function usePulsesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PulsesQuery, PulsesQueryVariables>,
): Apollo.UseSuspenseQueryResult<PulsesQuery | undefined, PulsesQueryVariables>;
export function usePulsesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PulsesQuery, PulsesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PulsesQuery, PulsesQueryVariables>(
    PulsesDocument,
    options,
  );
}
export type PulsesQueryHookResult = ReturnType<typeof usePulsesQuery>;
export type PulsesLazyQueryHookResult = ReturnType<typeof usePulsesLazyQuery>;
export type PulsesSuspenseQueryHookResult = ReturnType<
  typeof usePulsesSuspenseQuery
>;
export type PulsesQueryResult = Apollo.QueryResult<
  PulsesQuery,
  PulsesQueryVariables
>;
export const RefreshPulseDocument = gql`
  mutation RefreshPulse($pulse: String!) {
    refreshPulse(pulse: $pulse) {
      ... on PulseV1RefreshPulseResponse {
        __typename
        pulse {
          ...PulseRef
        }
        refreshedBlocks {
          ...PulseBlock
        }
      }
      ...DefaultError
    }
  }
  ${PulseRefFragmentDoc}
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RefreshPulseMutationFn = Apollo.MutationFunction<
  RefreshPulseMutation,
  RefreshPulseMutationVariables
>;

/**
 * __useRefreshPulseMutation__
 *
 * To run a mutation, you first call `useRefreshPulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPulseMutation, { data, loading, error }] = useRefreshPulseMutation({
 *   variables: {
 *      pulse: // value for 'pulse'
 *   },
 * });
 */
export function useRefreshPulseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshPulseMutation,
    RefreshPulseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshPulseMutation,
    RefreshPulseMutationVariables
  >(RefreshPulseDocument, options);
}
export type RefreshPulseMutationHookResult = ReturnType<
  typeof useRefreshPulseMutation
>;
export type RefreshPulseMutationResult =
  Apollo.MutationResult<RefreshPulseMutation>;
export type RefreshPulseMutationOptions = Apollo.BaseMutationOptions<
  RefreshPulseMutation,
  RefreshPulseMutationVariables
>;
export const RefreshPulseBlockDocument = gql`
  mutation RefreshPulseBlock($pulseBlock: String!) {
    refreshPulseBlock(pulseBlock: $pulseBlock) {
      ... on PulseV1RefreshPulseBlockResponse {
        __typename
        pulseBlock {
          ...PulseBlock
        }
      }
      ...DefaultError
    }
  }
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RefreshPulseBlockMutationFn = Apollo.MutationFunction<
  RefreshPulseBlockMutation,
  RefreshPulseBlockMutationVariables
>;

/**
 * __useRefreshPulseBlockMutation__
 *
 * To run a mutation, you first call `useRefreshPulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPulseBlockMutation, { data, loading, error }] = useRefreshPulseBlockMutation({
 *   variables: {
 *      pulseBlock: // value for 'pulseBlock'
 *   },
 * });
 */
export function useRefreshPulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshPulseBlockMutation,
    RefreshPulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshPulseBlockMutation,
    RefreshPulseBlockMutationVariables
  >(RefreshPulseBlockDocument, options);
}
export type RefreshPulseBlockMutationHookResult = ReturnType<
  typeof useRefreshPulseBlockMutation
>;
export type RefreshPulseBlockMutationResult =
  Apollo.MutationResult<RefreshPulseBlockMutation>;
export type RefreshPulseBlockMutationOptions = Apollo.BaseMutationOptions<
  RefreshPulseBlockMutation,
  RefreshPulseBlockMutationVariables
>;
export const ResolvePulseRefreshScheduleDocument = gql`
  query ResolvePulseRefreshSchedule($pulse: String!) {
    resolvePulseRefreshSchedule(pulse: $pulse) {
      ... on PulseV1ResolvePulseRefreshScheduleResponse {
        __typename
        schedule
        timeZone
        interval
        hour
        minute
        dayOfWeek
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useResolvePulseRefreshScheduleQuery__
 *
 * To run a query within a React component, call `useResolvePulseRefreshScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolvePulseRefreshScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolvePulseRefreshScheduleQuery({
 *   variables: {
 *      pulse: // value for 'pulse'
 *   },
 * });
 */
export function useResolvePulseRefreshScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  > &
    (
      | { variables: ResolvePulseRefreshScheduleQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  >(ResolvePulseRefreshScheduleDocument, options);
}
export function useResolvePulseRefreshScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  >(ResolvePulseRefreshScheduleDocument, options);
}
// @ts-ignore
export function useResolvePulseRefreshScheduleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ResolvePulseRefreshScheduleQuery,
  ResolvePulseRefreshScheduleQueryVariables
>;
export function useResolvePulseRefreshScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResolvePulseRefreshScheduleQuery,
        ResolvePulseRefreshScheduleQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ResolvePulseRefreshScheduleQuery | undefined,
  ResolvePulseRefreshScheduleQueryVariables
>;
export function useResolvePulseRefreshScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResolvePulseRefreshScheduleQuery,
        ResolvePulseRefreshScheduleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResolvePulseRefreshScheduleQuery,
    ResolvePulseRefreshScheduleQueryVariables
  >(ResolvePulseRefreshScheduleDocument, options);
}
export type ResolvePulseRefreshScheduleQueryHookResult = ReturnType<
  typeof useResolvePulseRefreshScheduleQuery
>;
export type ResolvePulseRefreshScheduleLazyQueryHookResult = ReturnType<
  typeof useResolvePulseRefreshScheduleLazyQuery
>;
export type ResolvePulseRefreshScheduleSuspenseQueryHookResult = ReturnType<
  typeof useResolvePulseRefreshScheduleSuspenseQuery
>;
export type ResolvePulseRefreshScheduleQueryResult = Apollo.QueryResult<
  ResolvePulseRefreshScheduleQuery,
  ResolvePulseRefreshScheduleQueryVariables
>;
export const UpdatePulseDocument = gql`
  mutation UpdatePulse($input: PartialPulseV1PulseInput!, $updateMask: String) {
    updatePulse(pulse: $input, updateMask: $updateMask) {
      ...Pulse
    }
  }
  ${PulseFragmentDoc}
`;
export type UpdatePulseMutationFn = Apollo.MutationFunction<
  UpdatePulseMutation,
  UpdatePulseMutationVariables
>;

/**
 * __useUpdatePulseMutation__
 *
 * To run a mutation, you first call `useUpdatePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePulseMutation, { data, loading, error }] = useUpdatePulseMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdatePulseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePulseMutation,
    UpdatePulseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePulseMutation, UpdatePulseMutationVariables>(
    UpdatePulseDocument,
    options,
  );
}
export type UpdatePulseMutationHookResult = ReturnType<
  typeof useUpdatePulseMutation
>;
export type UpdatePulseMutationResult =
  Apollo.MutationResult<UpdatePulseMutation>;
export type UpdatePulseMutationOptions = Apollo.BaseMutationOptions<
  UpdatePulseMutation,
  UpdatePulseMutationVariables
>;
export const UpdatePulseBlockDocument = gql`
  mutation UpdatePulseBlock(
    $input: PartialPulseV1PulseBlockInput!
    $updateMask: String
  ) {
    updatePulseBlock(pulseBlock: $input, updateMask: $updateMask) {
      ...PulseBlock
      ...DefaultError
    }
  }
  ${PulseBlockFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdatePulseBlockMutationFn = Apollo.MutationFunction<
  UpdatePulseBlockMutation,
  UpdatePulseBlockMutationVariables
>;

/**
 * __useUpdatePulseBlockMutation__
 *
 * To run a mutation, you first call `useUpdatePulseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePulseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePulseBlockMutation, { data, loading, error }] = useUpdatePulseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdatePulseBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePulseBlockMutation,
    UpdatePulseBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePulseBlockMutation,
    UpdatePulseBlockMutationVariables
  >(UpdatePulseBlockDocument, options);
}
export type UpdatePulseBlockMutationHookResult = ReturnType<
  typeof useUpdatePulseBlockMutation
>;
export type UpdatePulseBlockMutationResult =
  Apollo.MutationResult<UpdatePulseBlockMutation>;
export type UpdatePulseBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdatePulseBlockMutation,
  UpdatePulseBlockMutationVariables
>;
export const AggregateRecordingFilterValuesDocument = gql`
  query AggregateRecordingFilterValues($filter: String) {
    aggregateRecordingFilterValues(filter: $filter) {
      ... on RecordingV1AggregateRecordingFilterValuesResponse {
        labels {
          key
          values
        }
        tags {
          key
          values
        }
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAggregateRecordingFilterValuesQuery__
 *
 * To run a query within a React component, call `useAggregateRecordingFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateRecordingFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateRecordingFilterValuesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAggregateRecordingFilterValuesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >(AggregateRecordingFilterValuesDocument, options);
}
export function useAggregateRecordingFilterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >(AggregateRecordingFilterValuesDocument, options);
}
// @ts-ignore
export function useAggregateRecordingFilterValuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AggregateRecordingFilterValuesQuery,
  AggregateRecordingFilterValuesQueryVariables
>;
export function useAggregateRecordingFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AggregateRecordingFilterValuesQuery,
        AggregateRecordingFilterValuesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AggregateRecordingFilterValuesQuery | undefined,
  AggregateRecordingFilterValuesQueryVariables
>;
export function useAggregateRecordingFilterValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AggregateRecordingFilterValuesQuery,
        AggregateRecordingFilterValuesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AggregateRecordingFilterValuesQuery,
    AggregateRecordingFilterValuesQueryVariables
  >(AggregateRecordingFilterValuesDocument, options);
}
export type AggregateRecordingFilterValuesQueryHookResult = ReturnType<
  typeof useAggregateRecordingFilterValuesQuery
>;
export type AggregateRecordingFilterValuesLazyQueryHookResult = ReturnType<
  typeof useAggregateRecordingFilterValuesLazyQuery
>;
export type AggregateRecordingFilterValuesSuspenseQueryHookResult = ReturnType<
  typeof useAggregateRecordingFilterValuesSuspenseQuery
>;
export type AggregateRecordingFilterValuesQueryResult = Apollo.QueryResult<
  AggregateRecordingFilterValuesQuery,
  AggregateRecordingFilterValuesQueryVariables
>;
export const CreateRecordingPolicyDocument = gql`
  mutation CreateRecordingPolicy(
    $recordingPolicy: RecordingV1RecordingPolicyInput!
    $recordingPolicyId: String
  ) {
    createRecordingPolicy(
      recordingPolicy: $recordingPolicy
      recordingPolicyId: $recordingPolicyId
    ) {
      ...RecordingPolicy
      ...DefaultError
    }
  }
  ${RecordingPolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateRecordingPolicyMutationFn = Apollo.MutationFunction<
  CreateRecordingPolicyMutation,
  CreateRecordingPolicyMutationVariables
>;

/**
 * __useCreateRecordingPolicyMutation__
 *
 * To run a mutation, you first call `useCreateRecordingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingPolicyMutation, { data, loading, error }] = useCreateRecordingPolicyMutation({
 *   variables: {
 *      recordingPolicy: // value for 'recordingPolicy'
 *      recordingPolicyId: // value for 'recordingPolicyId'
 *   },
 * });
 */
export function useCreateRecordingPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRecordingPolicyMutation,
    CreateRecordingPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRecordingPolicyMutation,
    CreateRecordingPolicyMutationVariables
  >(CreateRecordingPolicyDocument, options);
}
export type CreateRecordingPolicyMutationHookResult = ReturnType<
  typeof useCreateRecordingPolicyMutation
>;
export type CreateRecordingPolicyMutationResult =
  Apollo.MutationResult<CreateRecordingPolicyMutation>;
export type CreateRecordingPolicyMutationOptions = Apollo.BaseMutationOptions<
  CreateRecordingPolicyMutation,
  CreateRecordingPolicyMutationVariables
>;
export const CreateRecordingRuleDocument = gql`
  mutation CreateRecordingRule(
    $parent: String!
    $recordingRule: RecordingV1RecordingRuleInput!
    $recordingRuleId: String
  ) {
    createRecordingRule(
      parent: $parent
      recordingRule: $recordingRule
      recordingRuleId: $recordingRuleId
    ) {
      ...RecordingRule
      ...DefaultError
    }
  }
  ${RecordingRuleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateRecordingRuleMutationFn = Apollo.MutationFunction<
  CreateRecordingRuleMutation,
  CreateRecordingRuleMutationVariables
>;

/**
 * __useCreateRecordingRuleMutation__
 *
 * To run a mutation, you first call `useCreateRecordingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingRuleMutation, { data, loading, error }] = useCreateRecordingRuleMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      recordingRule: // value for 'recordingRule'
 *      recordingRuleId: // value for 'recordingRuleId'
 *   },
 * });
 */
export function useCreateRecordingRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRecordingRuleMutation,
    CreateRecordingRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRecordingRuleMutation,
    CreateRecordingRuleMutationVariables
  >(CreateRecordingRuleDocument, options);
}
export type CreateRecordingRuleMutationHookResult = ReturnType<
  typeof useCreateRecordingRuleMutation
>;
export type CreateRecordingRuleMutationResult =
  Apollo.MutationResult<CreateRecordingRuleMutation>;
export type CreateRecordingRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateRecordingRuleMutation,
  CreateRecordingRuleMutationVariables
>;
export const DeleteRecordingPolicyDocument = gql`
  mutation DeleteRecordingPolicy($name: String!) {
    deleteRecordingPolicy(name: $name) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteRecordingPolicyMutationFn = Apollo.MutationFunction<
  DeleteRecordingPolicyMutation,
  DeleteRecordingPolicyMutationVariables
>;

/**
 * __useDeleteRecordingPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteRecordingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecordingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecordingPolicyMutation, { data, loading, error }] = useDeleteRecordingPolicyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteRecordingPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRecordingPolicyMutation,
    DeleteRecordingPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRecordingPolicyMutation,
    DeleteRecordingPolicyMutationVariables
  >(DeleteRecordingPolicyDocument, options);
}
export type DeleteRecordingPolicyMutationHookResult = ReturnType<
  typeof useDeleteRecordingPolicyMutation
>;
export type DeleteRecordingPolicyMutationResult =
  Apollo.MutationResult<DeleteRecordingPolicyMutation>;
export type DeleteRecordingPolicyMutationOptions = Apollo.BaseMutationOptions<
  DeleteRecordingPolicyMutation,
  DeleteRecordingPolicyMutationVariables
>;
export const DeleteRecordingRuleDocument = gql`
  mutation DeleteRecordingRule($name: String!) {
    deleteRecordingRule(name: $name) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteRecordingRuleMutationFn = Apollo.MutationFunction<
  DeleteRecordingRuleMutation,
  DeleteRecordingRuleMutationVariables
>;

/**
 * __useDeleteRecordingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteRecordingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecordingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecordingRuleMutation, { data, loading, error }] = useDeleteRecordingRuleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteRecordingRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRecordingRuleMutation,
    DeleteRecordingRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRecordingRuleMutation,
    DeleteRecordingRuleMutationVariables
  >(DeleteRecordingRuleDocument, options);
}
export type DeleteRecordingRuleMutationHookResult = ReturnType<
  typeof useDeleteRecordingRuleMutation
>;
export type DeleteRecordingRuleMutationResult =
  Apollo.MutationResult<DeleteRecordingRuleMutation>;
export type DeleteRecordingRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRecordingRuleMutation,
  DeleteRecordingRuleMutationVariables
>;
export const FlagVariantsDocument = gql`
  query FlagVariants($name: String!) {
    flag(name: $name) {
      ... on FlagsAdminV1Flag {
        __typename
        name
        variants {
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagVariantsQuery__
 *
 * To run a query within a React component, call `useFlagVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagVariantsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFlagVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlagVariantsQuery,
    FlagVariantsQueryVariables
  > &
    (
      | { variables: FlagVariantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlagVariantsQuery, FlagVariantsQueryVariables>(
    FlagVariantsDocument,
    options,
  );
}
export function useFlagVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagVariantsQuery,
    FlagVariantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlagVariantsQuery, FlagVariantsQueryVariables>(
    FlagVariantsDocument,
    options,
  );
}
// @ts-ignore
export function useFlagVariantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagVariantsQuery,
    FlagVariantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FlagVariantsQuery, FlagVariantsQueryVariables>;
export function useFlagVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagVariantsQuery,
        FlagVariantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagVariantsQuery | undefined,
  FlagVariantsQueryVariables
>;
export function useFlagVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagVariantsQuery,
        FlagVariantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FlagVariantsQuery, FlagVariantsQueryVariables>(
    FlagVariantsDocument,
    options,
  );
}
export type FlagVariantsQueryHookResult = ReturnType<
  typeof useFlagVariantsQuery
>;
export type FlagVariantsLazyQueryHookResult = ReturnType<
  typeof useFlagVariantsLazyQuery
>;
export type FlagVariantsSuspenseQueryHookResult = ReturnType<
  typeof useFlagVariantsSuspenseQuery
>;
export type FlagVariantsQueryResult = Apollo.QueryResult<
  FlagVariantsQuery,
  FlagVariantsQueryVariables
>;
export const RecordingDocument = gql`
  query Recording($name: String!) {
    recording(name: $name) {
      ...Recording
      ...DefaultError
    }
  }
  ${RecordingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingQuery__
 *
 * To run a query within a React component, call `useRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRecordingQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingQuery,
    RecordingQueryVariables
  > &
    (
      | { variables: RecordingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecordingQuery, RecordingQueryVariables>(
    RecordingDocument,
    options,
  );
}
export function useRecordingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingQuery,
    RecordingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecordingQuery, RecordingQueryVariables>(
    RecordingDocument,
    options,
  );
}
// @ts-ignore
export function useRecordingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingQuery,
    RecordingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RecordingQuery, RecordingQueryVariables>;
export function useRecordingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecordingQuery, RecordingQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RecordingQuery | undefined,
  RecordingQueryVariables
>;
export function useRecordingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecordingQuery, RecordingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecordingQuery, RecordingQueryVariables>(
    RecordingDocument,
    options,
  );
}
export type RecordingQueryHookResult = ReturnType<typeof useRecordingQuery>;
export type RecordingLazyQueryHookResult = ReturnType<
  typeof useRecordingLazyQuery
>;
export type RecordingSuspenseQueryHookResult = ReturnType<
  typeof useRecordingSuspenseQuery
>;
export type RecordingQueryResult = Apollo.QueryResult<
  RecordingQuery,
  RecordingQueryVariables
>;
export const RecordingObservationIssuesPageDocument = gql`
  query RecordingObservationIssuesPage($name: String!, $pageToken: String) {
    recording(name: $name) {
      ... on RecordingV1Recording {
        __typename
        name
        observations(pageSize: 100, pageToken: $pageToken) {
          ... on ObservationsV1ListObservationsResponse {
            __typename
            observations {
              ...FindingIssueObservation
            }
            nextPageToken
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
  }
  ${FindingIssueObservationFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingObservationIssuesPageQuery__
 *
 * To run a query within a React component, call `useRecordingObservationIssuesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingObservationIssuesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingObservationIssuesPageQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useRecordingObservationIssuesPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  > &
    (
      | {
          variables: RecordingObservationIssuesPageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  >(RecordingObservationIssuesPageDocument, options);
}
export function useRecordingObservationIssuesPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  >(RecordingObservationIssuesPageDocument, options);
}
// @ts-ignore
export function useRecordingObservationIssuesPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingObservationIssuesPageQuery,
  RecordingObservationIssuesPageQueryVariables
>;
export function useRecordingObservationIssuesPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingObservationIssuesPageQuery,
        RecordingObservationIssuesPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingObservationIssuesPageQuery | undefined,
  RecordingObservationIssuesPageQueryVariables
>;
export function useRecordingObservationIssuesPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingObservationIssuesPageQuery,
        RecordingObservationIssuesPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingObservationIssuesPageQuery,
    RecordingObservationIssuesPageQueryVariables
  >(RecordingObservationIssuesPageDocument, options);
}
export type RecordingObservationIssuesPageQueryHookResult = ReturnType<
  typeof useRecordingObservationIssuesPageQuery
>;
export type RecordingObservationIssuesPageLazyQueryHookResult = ReturnType<
  typeof useRecordingObservationIssuesPageLazyQuery
>;
export type RecordingObservationIssuesPageSuspenseQueryHookResult = ReturnType<
  typeof useRecordingObservationIssuesPageSuspenseQuery
>;
export type RecordingObservationIssuesPageQueryResult = Apollo.QueryResult<
  RecordingObservationIssuesPageQuery,
  RecordingObservationIssuesPageQueryVariables
>;
export const RecordingPoliciesDocument = gql`
  query RecordingPolicies($pageSize: Int, $pageToken: String) {
    recordingPolicies(pageSize: $pageSize, pageToken: $pageToken) {
      ... on RecordingV1ListRecordingPoliciesResponse {
        __typename
        recordingPolicies {
          ...RecordingPolicy
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${RecordingPolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingPoliciesQuery__
 *
 * To run a query within a React component, call `useRecordingPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingPoliciesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useRecordingPoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >(RecordingPoliciesDocument, options);
}
export function useRecordingPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >(RecordingPoliciesDocument, options);
}
// @ts-ignore
export function useRecordingPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingPoliciesQuery,
  RecordingPoliciesQueryVariables
>;
export function useRecordingPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingPoliciesQuery,
        RecordingPoliciesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingPoliciesQuery | undefined,
  RecordingPoliciesQueryVariables
>;
export function useRecordingPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingPoliciesQuery,
        RecordingPoliciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingPoliciesQuery,
    RecordingPoliciesQueryVariables
  >(RecordingPoliciesDocument, options);
}
export type RecordingPoliciesQueryHookResult = ReturnType<
  typeof useRecordingPoliciesQuery
>;
export type RecordingPoliciesLazyQueryHookResult = ReturnType<
  typeof useRecordingPoliciesLazyQuery
>;
export type RecordingPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useRecordingPoliciesSuspenseQuery
>;
export type RecordingPoliciesQueryResult = Apollo.QueryResult<
  RecordingPoliciesQuery,
  RecordingPoliciesQueryVariables
>;
export const RecordingPolicyDocument = gql`
  query RecordingPolicy($name: String!) {
    recordingPolicy(name: $name) {
      ...RecordingPolicy
      ...DefaultError
    }
  }
  ${RecordingPolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingPolicyQuery__
 *
 * To run a query within a React component, call `useRecordingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingPolicyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRecordingPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingPolicyQuery,
    RecordingPolicyQueryVariables
  > &
    (
      | { variables: RecordingPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecordingPolicyQuery, RecordingPolicyQueryVariables>(
    RecordingPolicyDocument,
    options,
  );
}
export function useRecordingPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingPolicyQuery,
    RecordingPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingPolicyQuery,
    RecordingPolicyQueryVariables
  >(RecordingPolicyDocument, options);
}
// @ts-ignore
export function useRecordingPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingPolicyQuery,
    RecordingPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingPolicyQuery,
  RecordingPolicyQueryVariables
>;
export function useRecordingPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingPolicyQuery,
        RecordingPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingPolicyQuery | undefined,
  RecordingPolicyQueryVariables
>;
export function useRecordingPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingPolicyQuery,
        RecordingPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingPolicyQuery,
    RecordingPolicyQueryVariables
  >(RecordingPolicyDocument, options);
}
export type RecordingPolicyQueryHookResult = ReturnType<
  typeof useRecordingPolicyQuery
>;
export type RecordingPolicyLazyQueryHookResult = ReturnType<
  typeof useRecordingPolicyLazyQuery
>;
export type RecordingPolicySuspenseQueryHookResult = ReturnType<
  typeof useRecordingPolicySuspenseQuery
>;
export type RecordingPolicyQueryResult = Apollo.QueryResult<
  RecordingPolicyQuery,
  RecordingPolicyQueryVariables
>;
export const RecordingRulesForPolicyDocument = gql`
  query RecordingRulesForPolicy($name: String!) {
    recordingPolicy(name: $name) {
      ... on RecordingV1RecordingPolicy {
        __typename
        name
        recordingRules {
          ... on RecordingV1ListRecordingRulesResponse {
            __typename
            recordingRules {
              name
              enabled
              sessionSampleRate
              targetingKeySelector
              segment {
                ... on FlagsAdminV1Segment {
                  __typename
                  name
                  allocation {
                    proportion {
                      value
                    }
                  }
                  workflowInstance {
                    ... on WorkflowV1WorkflowInstance {
                      __typename
                      name
                    }
                    ...DefaultError
                  }
                }
                ...DefaultError
              }
            }
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingRulesForPolicyQuery__
 *
 * To run a query within a React component, call `useRecordingRulesForPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingRulesForPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingRulesForPolicyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRecordingRulesForPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  > &
    (
      | { variables: RecordingRulesForPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  >(RecordingRulesForPolicyDocument, options);
}
export function useRecordingRulesForPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  >(RecordingRulesForPolicyDocument, options);
}
// @ts-ignore
export function useRecordingRulesForPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingRulesForPolicyQuery,
  RecordingRulesForPolicyQueryVariables
>;
export function useRecordingRulesForPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingRulesForPolicyQuery,
        RecordingRulesForPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingRulesForPolicyQuery | undefined,
  RecordingRulesForPolicyQueryVariables
>;
export function useRecordingRulesForPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingRulesForPolicyQuery,
        RecordingRulesForPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingRulesForPolicyQuery,
    RecordingRulesForPolicyQueryVariables
  >(RecordingRulesForPolicyDocument, options);
}
export type RecordingRulesForPolicyQueryHookResult = ReturnType<
  typeof useRecordingRulesForPolicyQuery
>;
export type RecordingRulesForPolicyLazyQueryHookResult = ReturnType<
  typeof useRecordingRulesForPolicyLazyQuery
>;
export type RecordingRulesForPolicySuspenseQueryHookResult = ReturnType<
  typeof useRecordingRulesForPolicySuspenseQuery
>;
export type RecordingRulesForPolicyQueryResult = Apollo.QueryResult<
  RecordingRulesForPolicyQuery,
  RecordingRulesForPolicyQueryVariables
>;
export const RecordingsDocument = gql`
  query Recordings(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    recordings(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on RecordingV1ListRecordingsResponse {
        recordings {
          ...RecordingRef
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${RecordingRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingsQuery__
 *
 * To run a query within a React component, call `useRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRecordingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecordingsQuery,
    RecordingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecordingsQuery, RecordingsQueryVariables>(
    RecordingsDocument,
    options,
  );
}
export function useRecordingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingsQuery,
    RecordingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecordingsQuery, RecordingsQueryVariables>(
    RecordingsDocument,
    options,
  );
}
// @ts-ignore
export function useRecordingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingsQuery,
    RecordingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RecordingsQuery, RecordingsQueryVariables>;
export function useRecordingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingsQuery,
        RecordingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingsQuery | undefined,
  RecordingsQueryVariables
>;
export function useRecordingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingsQuery,
        RecordingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecordingsQuery, RecordingsQueryVariables>(
    RecordingsDocument,
    options,
  );
}
export type RecordingsQueryHookResult = ReturnType<typeof useRecordingsQuery>;
export type RecordingsLazyQueryHookResult = ReturnType<
  typeof useRecordingsLazyQuery
>;
export type RecordingsSuspenseQueryHookResult = ReturnType<
  typeof useRecordingsSuspenseQuery
>;
export type RecordingsQueryResult = Apollo.QueryResult<
  RecordingsQuery,
  RecordingsQueryVariables
>;
export const ReorderRecordingRulesDocument = gql`
  mutation ReorderRecordingRules($parent: String!, $rules: [String!]!) {
    reorderRecordingRules(parent: $parent, rules: $rules) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ReorderRecordingRulesMutationFn = Apollo.MutationFunction<
  ReorderRecordingRulesMutation,
  ReorderRecordingRulesMutationVariables
>;

/**
 * __useReorderRecordingRulesMutation__
 *
 * To run a mutation, you first call `useReorderRecordingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderRecordingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderRecordingRulesMutation, { data, loading, error }] = useReorderRecordingRulesMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useReorderRecordingRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderRecordingRulesMutation,
    ReorderRecordingRulesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReorderRecordingRulesMutation,
    ReorderRecordingRulesMutationVariables
  >(ReorderRecordingRulesDocument, options);
}
export type ReorderRecordingRulesMutationHookResult = ReturnType<
  typeof useReorderRecordingRulesMutation
>;
export type ReorderRecordingRulesMutationResult =
  Apollo.MutationResult<ReorderRecordingRulesMutation>;
export type ReorderRecordingRulesMutationOptions = Apollo.BaseMutationOptions<
  ReorderRecordingRulesMutation,
  ReorderRecordingRulesMutationVariables
>;
export const SubmitRecordingFeedbackDocument = gql`
  mutation SubmitRecordingFeedback(
    $name: String!
    $rating: RecordingV1RecordingFeedbackRating!
  ) {
    submitRecordingFeedback(name: $name, rating: $rating) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type SubmitRecordingFeedbackMutationFn = Apollo.MutationFunction<
  SubmitRecordingFeedbackMutation,
  SubmitRecordingFeedbackMutationVariables
>;

/**
 * __useSubmitRecordingFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitRecordingFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRecordingFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRecordingFeedbackMutation, { data, loading, error }] = useSubmitRecordingFeedbackMutation({
 *   variables: {
 *      name: // value for 'name'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useSubmitRecordingFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitRecordingFeedbackMutation,
    SubmitRecordingFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitRecordingFeedbackMutation,
    SubmitRecordingFeedbackMutationVariables
  >(SubmitRecordingFeedbackDocument, options);
}
export type SubmitRecordingFeedbackMutationHookResult = ReturnType<
  typeof useSubmitRecordingFeedbackMutation
>;
export type SubmitRecordingFeedbackMutationResult =
  Apollo.MutationResult<SubmitRecordingFeedbackMutation>;
export type SubmitRecordingFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SubmitRecordingFeedbackMutation,
  SubmitRecordingFeedbackMutationVariables
>;
export const UpdateRecordingPolicyDocument = gql`
  mutation UpdateRecordingPolicy(
    $input: PartialRecordingV1RecordingPolicyInput!
    $updateMask: String
  ) {
    updateRecordingPolicy(recordingPolicy: $input, updateMask: $updateMask) {
      ...RecordingPolicy
      ...DefaultError
    }
  }
  ${RecordingPolicyFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateRecordingPolicyMutationFn = Apollo.MutationFunction<
  UpdateRecordingPolicyMutation,
  UpdateRecordingPolicyMutationVariables
>;

/**
 * __useUpdateRecordingPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateRecordingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecordingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecordingPolicyMutation, { data, loading, error }] = useUpdateRecordingPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateRecordingPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRecordingPolicyMutation,
    UpdateRecordingPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRecordingPolicyMutation,
    UpdateRecordingPolicyMutationVariables
  >(UpdateRecordingPolicyDocument, options);
}
export type UpdateRecordingPolicyMutationHookResult = ReturnType<
  typeof useUpdateRecordingPolicyMutation
>;
export type UpdateRecordingPolicyMutationResult =
  Apollo.MutationResult<UpdateRecordingPolicyMutation>;
export type UpdateRecordingPolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdateRecordingPolicyMutation,
  UpdateRecordingPolicyMutationVariables
>;
export const UpdateRecordingRuleDocument = gql`
  mutation UpdateRecordingRule(
    $input: PartialRecordingV1RecordingRuleInput!
    $updateMask: String
  ) {
    updateRecordingRule(recordingRule: $input, updateMask: $updateMask) {
      ...RecordingRule
      ...DefaultError
    }
  }
  ${RecordingRuleFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateRecordingRuleMutationFn = Apollo.MutationFunction<
  UpdateRecordingRuleMutation,
  UpdateRecordingRuleMutationVariables
>;

/**
 * __useUpdateRecordingRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRecordingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecordingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecordingRuleMutation, { data, loading, error }] = useUpdateRecordingRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateRecordingRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRecordingRuleMutation,
    UpdateRecordingRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRecordingRuleMutation,
    UpdateRecordingRuleMutationVariables
  >(UpdateRecordingRuleDocument, options);
}
export type UpdateRecordingRuleMutationHookResult = ReturnType<
  typeof useUpdateRecordingRuleMutation
>;
export type UpdateRecordingRuleMutationResult =
  Apollo.MutationResult<UpdateRecordingRuleMutation>;
export type UpdateRecordingRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRecordingRuleMutation,
  UpdateRecordingRuleMutationVariables
>;
export const RecordingInsightsOverviewDocument = gql`
  query RecordingInsightsOverview(
    $client: String
    $endTime: String!
    $granularity: String!
    $maxDuration: String
    $metrics: [String!]!
    $minDuration: String
    $startTime: String!
  ) {
    recordingInsightsOverview: queryRecordingInsightsOverview(
      client: $client
      endTime: $endTime
      granularity: $granularity
      maxDuration: $maxDuration
      metrics: $metrics
      minDuration: $minDuration
      startTime: $startTime
    ) {
      __typename
      ... on RecordingV1QueryRecordingInsightsOverviewResponse {
        signals {
          metric
          buckets {
            startTime
            totalRecordings
            affectedRecordings
            affectedPercentage
            signalCount
            totalRoutes
            affectedRoutes
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingInsightsOverviewQuery__
 *
 * To run a query within a React component, call `useRecordingInsightsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingInsightsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingInsightsOverviewQuery({
 *   variables: {
 *      client: // value for 'client'
 *      endTime: // value for 'endTime'
 *      granularity: // value for 'granularity'
 *      maxDuration: // value for 'maxDuration'
 *      metrics: // value for 'metrics'
 *      minDuration: // value for 'minDuration'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useRecordingInsightsOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  > &
    (
      | { variables: RecordingInsightsOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  >(RecordingInsightsOverviewDocument, options);
}
export function useRecordingInsightsOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  >(RecordingInsightsOverviewDocument, options);
}
// @ts-ignore
export function useRecordingInsightsOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingInsightsOverviewQuery,
  RecordingInsightsOverviewQueryVariables
>;
export function useRecordingInsightsOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingInsightsOverviewQuery,
        RecordingInsightsOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingInsightsOverviewQuery | undefined,
  RecordingInsightsOverviewQueryVariables
>;
export function useRecordingInsightsOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingInsightsOverviewQuery,
        RecordingInsightsOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingInsightsOverviewQuery,
    RecordingInsightsOverviewQueryVariables
  >(RecordingInsightsOverviewDocument, options);
}
export type RecordingInsightsOverviewQueryHookResult = ReturnType<
  typeof useRecordingInsightsOverviewQuery
>;
export type RecordingInsightsOverviewLazyQueryHookResult = ReturnType<
  typeof useRecordingInsightsOverviewLazyQuery
>;
export type RecordingInsightsOverviewSuspenseQueryHookResult = ReturnType<
  typeof useRecordingInsightsOverviewSuspenseQuery
>;
export type RecordingInsightsOverviewQueryResult = Apollo.QueryResult<
  RecordingInsightsOverviewQuery,
  RecordingInsightsOverviewQueryVariables
>;
export const RecordingRouteInsightsDocument = gql`
  query RecordingRouteInsights(
    $client: String
    $endTime: String!
    $granularity: String!
    $maxDuration: String
    $metric: String!
    $minDuration: String
    $routeOrder: RecordingV1RecordingRouteInsightsOrder
    $routeLimit: Int
    $startTime: String!
  ) {
    recordingRouteInsights: queryRecordingRouteInsights(
      client: $client
      endTime: $endTime
      granularity: $granularity
      maxDuration: $maxDuration
      metric: $metric
      minDuration: $minDuration
      routeOrder: $routeOrder
      routeLimit: $routeLimit
      startTime: $startTime
    ) {
      __typename
      ... on RecordingV1QueryRecordingRouteInsightsResponse {
        summaryBuckets {
          startTime
          totalRecordings
          affectedRecordings
          affectedPercentage
          signalCount
          totalRoutes
          affectedRoutes
        }
        routes {
          route
          buckets {
            totalRecordings
            affectedRecordings
            affectedPercentage
            signalCount
            signalsPerAffectedRecording
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRecordingRouteInsightsQuery__
 *
 * To run a query within a React component, call `useRecordingRouteInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingRouteInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingRouteInsightsQuery({
 *   variables: {
 *      client: // value for 'client'
 *      endTime: // value for 'endTime'
 *      granularity: // value for 'granularity'
 *      maxDuration: // value for 'maxDuration'
 *      metric: // value for 'metric'
 *      minDuration: // value for 'minDuration'
 *      routeOrder: // value for 'routeOrder'
 *      routeLimit: // value for 'routeLimit'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useRecordingRouteInsightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  > &
    (
      | { variables: RecordingRouteInsightsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  >(RecordingRouteInsightsDocument, options);
}
export function useRecordingRouteInsightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  >(RecordingRouteInsightsDocument, options);
}
// @ts-ignore
export function useRecordingRouteInsightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecordingRouteInsightsQuery,
  RecordingRouteInsightsQueryVariables
>;
export function useRecordingRouteInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingRouteInsightsQuery,
        RecordingRouteInsightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecordingRouteInsightsQuery | undefined,
  RecordingRouteInsightsQueryVariables
>;
export function useRecordingRouteInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecordingRouteInsightsQuery,
        RecordingRouteInsightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecordingRouteInsightsQuery,
    RecordingRouteInsightsQueryVariables
  >(RecordingRouteInsightsDocument, options);
}
export type RecordingRouteInsightsQueryHookResult = ReturnType<
  typeof useRecordingRouteInsightsQuery
>;
export type RecordingRouteInsightsLazyQueryHookResult = ReturnType<
  typeof useRecordingRouteInsightsLazyQuery
>;
export type RecordingRouteInsightsSuspenseQueryHookResult = ReturnType<
  typeof useRecordingRouteInsightsSuspenseQuery
>;
export type RecordingRouteInsightsQueryResult = Apollo.QueryResult<
  RecordingRouteInsightsQuery,
  RecordingRouteInsightsQueryVariables
>;
export const ReviewDocument = gql`
  query Review($name: String!) {
    review(name: $name) {
      ... on CollaborationV1Review {
        __typename
        name
        resource
        state
        reviewResponses {
          ...CollaborationReviewResponse
        }
      }
    }
  }
  ${CollaborationReviewResponseFragmentDoc}
`;

/**
 * __useReviewQuery__
 *
 * To run a query within a React component, call `useReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useReviewQuery(
  baseOptions: Apollo.QueryHookOptions<ReviewQuery, ReviewQueryVariables> &
    ({ variables: ReviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReviewQuery, ReviewQueryVariables>(
    ReviewDocument,
    options,
  );
}
export function useReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewQuery, ReviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReviewQuery, ReviewQueryVariables>(
    ReviewDocument,
    options,
  );
}
// @ts-ignore
export function useReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReviewQuery,
    ReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReviewQuery, ReviewQueryVariables>;
export function useReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewQuery, ReviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewQuery | undefined, ReviewQueryVariables>;
export function useReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewQuery, ReviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReviewQuery, ReviewQueryVariables>(
    ReviewDocument,
    options,
  );
}
export type ReviewQueryHookResult = ReturnType<typeof useReviewQuery>;
export type ReviewLazyQueryHookResult = ReturnType<typeof useReviewLazyQuery>;
export type ReviewSuspenseQueryHookResult = ReturnType<
  typeof useReviewSuspenseQuery
>;
export type ReviewQueryResult = Apollo.QueryResult<
  ReviewQuery,
  ReviewQueryVariables
>;
export const ConfidenceResourceSearchDocument = gql`
  query ConfidenceResourceSearch(
    $filter: String
    $nameFilter: String
    $pageSize: Int
    $includeWorkflows: Boolean!
    $workflowFilter: String
    $includeMetrics: Boolean!
    $includeFactTables: Boolean!
    $includeAssignmentTables: Boolean!
    $includeFlags: Boolean!
    $includeEvents: Boolean!
    $includeEntities: Boolean!
    $includeInitiatives: Boolean!
    $includeProjects: Boolean!
    $includeSurfaces: Boolean!
  ) {
    metrics(filter: $filter, pageSize: $pageSize)
      @include(if: $includeMetrics) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          displayName
          name
        }
      }
      ...DefaultError
    }
    factTables(filter: $filter, pageSize: $pageSize)
      @include(if: $includeFactTables) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          displayName
          name
        }
      }
      ...DefaultError
    }
    workflowInstances(pageSize: $pageSize, filter: $workflowFilter)
      @include(if: $includeWorkflows) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          displayName
          name
        }
      }
      ...DefaultError
    }
    assignmentTables(pageSize: $pageSize, filter: $filter)
      @include(if: $includeAssignmentTables) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          displayName
          name
        }
      }
      ...DefaultError
    }
    flags(pageSize: $pageSize, filter: $nameFilter)
      @include(if: $includeFlags) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
        }
      }
      ...DefaultError
    }
    eventDefinitions(pageSize: $pageSize, filter: $nameFilter)
      @include(if: $includeEvents) {
      ... on EventsAdminV1ListEventDefinitionsResponse {
        __typename
        eventDefinitions {
          name
        }
      }
      ...DefaultError
    }
    entities(filter: $filter, pageSize: $pageSize)
      @include(if: $includeEntities) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        entities {
          displayName
          name
        }
      }
      ...DefaultError
    }
    initiatives(filter: $filter, pageSize: $pageSize)
      @include(if: $includeInitiatives) {
      ... on WorkflowV1ListInitiativesResponse {
        __typename
        initiatives {
          displayName
          name
        }
      }
      ...DefaultError
    }
    projects(filter: $filter, pageSize: $pageSize)
      @include(if: $includeProjects) {
      ... on CollaborationV1ListProjectsResponse {
        __typename
        projects {
          displayName
          name
        }
      }
      ...DefaultError
    }
    surfaces(filter: $filter, pageSize: $pageSize)
      @include(if: $includeSurfaces) {
      ... on WorkflowV1ListSurfacesResponse {
        __typename
        surfaces {
          displayName
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useConfidenceResourceSearchQuery__
 *
 * To run a query within a React component, call `useConfidenceResourceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfidenceResourceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfidenceResourceSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      nameFilter: // value for 'nameFilter'
 *      pageSize: // value for 'pageSize'
 *      includeWorkflows: // value for 'includeWorkflows'
 *      workflowFilter: // value for 'workflowFilter'
 *      includeMetrics: // value for 'includeMetrics'
 *      includeFactTables: // value for 'includeFactTables'
 *      includeAssignmentTables: // value for 'includeAssignmentTables'
 *      includeFlags: // value for 'includeFlags'
 *      includeEvents: // value for 'includeEvents'
 *      includeEntities: // value for 'includeEntities'
 *      includeInitiatives: // value for 'includeInitiatives'
 *      includeProjects: // value for 'includeProjects'
 *      includeSurfaces: // value for 'includeSurfaces'
 *   },
 * });
 */
export function useConfidenceResourceSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  > &
    (
      | { variables: ConfidenceResourceSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  >(ConfidenceResourceSearchDocument, options);
}
export function useConfidenceResourceSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  >(ConfidenceResourceSearchDocument, options);
}
// @ts-ignore
export function useConfidenceResourceSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConfidenceResourceSearchQuery,
  ConfidenceResourceSearchQueryVariables
>;
export function useConfidenceResourceSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConfidenceResourceSearchQuery,
        ConfidenceResourceSearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConfidenceResourceSearchQuery | undefined,
  ConfidenceResourceSearchQueryVariables
>;
export function useConfidenceResourceSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConfidenceResourceSearchQuery,
        ConfidenceResourceSearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConfidenceResourceSearchQuery,
    ConfidenceResourceSearchQueryVariables
  >(ConfidenceResourceSearchDocument, options);
}
export type ConfidenceResourceSearchQueryHookResult = ReturnType<
  typeof useConfidenceResourceSearchQuery
>;
export type ConfidenceResourceSearchLazyQueryHookResult = ReturnType<
  typeof useConfidenceResourceSearchLazyQuery
>;
export type ConfidenceResourceSearchSuspenseQueryHookResult = ReturnType<
  typeof useConfidenceResourceSearchSuspenseQuery
>;
export type ConfidenceResourceSearchQueryResult = Apollo.QueryResult<
  ConfidenceResourceSearchQuery,
  ConfidenceResourceSearchQueryVariables
>;
export const ConfidenceSearchDocument = gql`
  query ConfidenceSearch(
    $filter: String
    $pageSize: Int
    $flagsFilter: String
    $eventsFilter: String
  ) {
    metrics(filter: $filter, pageSize: $pageSize) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          displayName
          name
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
    factTables(filter: $filter, pageSize: $pageSize) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          displayName
          name
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
    workflowInstances(pageSize: $pageSize, filter: $filter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          displayName
          name
          state
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
    assignmentTables(pageSize: $pageSize, filter: $filter) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          displayName
          name
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
    flags(pageSize: $pageSize, filter: $flagsFilter) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
    eventDefinitions(pageSize: $pageSize, filter: $eventsFilter) {
      ... on EventsAdminV1ListEventDefinitionsResponse {
        __typename
        eventDefinitions {
          name
          owner {
            ...AppIdentity
          }
        }
      }
      ...DefaultError
    }
  }
  ${AppIdentityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useConfidenceSearchQuery__
 *
 * To run a query within a React component, call `useConfidenceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfidenceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfidenceSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      flagsFilter: // value for 'flagsFilter'
 *      eventsFilter: // value for 'eventsFilter'
 *   },
 * });
 */
export function useConfidenceSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConfidenceSearchQuery,
    ConfidenceSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfidenceSearchQuery, ConfidenceSearchQueryVariables>(
    ConfidenceSearchDocument,
    options,
  );
}
export function useConfidenceSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfidenceSearchQuery,
    ConfidenceSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConfidenceSearchQuery,
    ConfidenceSearchQueryVariables
  >(ConfidenceSearchDocument, options);
}
// @ts-ignore
export function useConfidenceSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConfidenceSearchQuery,
    ConfidenceSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConfidenceSearchQuery,
  ConfidenceSearchQueryVariables
>;
export function useConfidenceSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConfidenceSearchQuery,
        ConfidenceSearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConfidenceSearchQuery | undefined,
  ConfidenceSearchQueryVariables
>;
export function useConfidenceSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConfidenceSearchQuery,
        ConfidenceSearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConfidenceSearchQuery,
    ConfidenceSearchQueryVariables
  >(ConfidenceSearchDocument, options);
}
export type ConfidenceSearchQueryHookResult = ReturnType<
  typeof useConfidenceSearchQuery
>;
export type ConfidenceSearchLazyQueryHookResult = ReturnType<
  typeof useConfidenceSearchLazyQuery
>;
export type ConfidenceSearchSuspenseQueryHookResult = ReturnType<
  typeof useConfidenceSearchSuspenseQuery
>;
export type ConfidenceSearchQueryResult = Apollo.QueryResult<
  ConfidenceSearchQuery,
  ConfidenceSearchQueryVariables
>;
export const ActivityFeedDocument = gql`
  query ActivityFeed($name: String!) {
    feed(name: $name) {
      ...ActivityFeed
      ...DefaultError
    }
  }
  ${ActivityFeedFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useActivityFeedQuery__
 *
 * To run a query within a React component, call `useActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFeedQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useActivityFeedQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivityFeedQuery,
    ActivityFeedQueryVariables
  > &
    (
      | { variables: ActivityFeedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(
    ActivityFeedDocument,
    options,
  );
}
export function useActivityFeedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityFeedQuery,
    ActivityFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(
    ActivityFeedDocument,
    options,
  );
}
// @ts-ignore
export function useActivityFeedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityFeedQuery,
    ActivityFeedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActivityFeedQuery, ActivityFeedQueryVariables>;
export function useActivityFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityFeedQuery,
        ActivityFeedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivityFeedQuery | undefined,
  ActivityFeedQueryVariables
>;
export function useActivityFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityFeedQuery,
        ActivityFeedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActivityFeedQuery, ActivityFeedQueryVariables>(
    ActivityFeedDocument,
    options,
  );
}
export type ActivityFeedQueryHookResult = ReturnType<
  typeof useActivityFeedQuery
>;
export type ActivityFeedLazyQueryHookResult = ReturnType<
  typeof useActivityFeedLazyQuery
>;
export type ActivityFeedSuspenseQueryHookResult = ReturnType<
  typeof useActivityFeedSuspenseQuery
>;
export type ActivityFeedQueryResult = Apollo.QueryResult<
  ActivityFeedQuery,
  ActivityFeedQueryVariables
>;
export const AddSurfaceIdentityBindingDocument = gql`
  mutation AddSurfaceIdentityBinding(
    $parent: String!
    $surfaceIdentityBinding: WorkflowV1SurfaceIdentityBindingInput!
  ) {
    addSurfaceIdentityBinding(
      parent: $parent
      surfaceIdentityBinding: $surfaceIdentityBinding
    ) {
      ...SurfaceIdentityBinding
      ...DefaultError
    }
  }
  ${SurfaceIdentityBindingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type AddSurfaceIdentityBindingMutationFn = Apollo.MutationFunction<
  AddSurfaceIdentityBindingMutation,
  AddSurfaceIdentityBindingMutationVariables
>;

/**
 * __useAddSurfaceIdentityBindingMutation__
 *
 * To run a mutation, you first call `useAddSurfaceIdentityBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurfaceIdentityBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurfaceIdentityBindingMutation, { data, loading, error }] = useAddSurfaceIdentityBindingMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      surfaceIdentityBinding: // value for 'surfaceIdentityBinding'
 *   },
 * });
 */
export function useAddSurfaceIdentityBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSurfaceIdentityBindingMutation,
    AddSurfaceIdentityBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSurfaceIdentityBindingMutation,
    AddSurfaceIdentityBindingMutationVariables
  >(AddSurfaceIdentityBindingDocument, options);
}
export type AddSurfaceIdentityBindingMutationHookResult = ReturnType<
  typeof useAddSurfaceIdentityBindingMutation
>;
export type AddSurfaceIdentityBindingMutationResult =
  Apollo.MutationResult<AddSurfaceIdentityBindingMutation>;
export type AddSurfaceIdentityBindingMutationOptions =
  Apollo.BaseMutationOptions<
    AddSurfaceIdentityBindingMutation,
    AddSurfaceIdentityBindingMutationVariables
  >;
export const AiWorkflowTriggersDocument = gql`
  query AiWorkflowTriggers(
    $pageSize: Int
    $pageToken: String
    $filter: String
  ) {
    aiWorkflowTriggers(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
    ) {
      __typename
      ... on AiworkflowsV1ListAiWorkflowTriggersResponse {
        aiWorkflowTriggers {
          ...AiWorkflowTrigger
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${AiWorkflowTriggerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAiWorkflowTriggersQuery__
 *
 * To run a query within a React component, call `useAiWorkflowTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiWorkflowTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiWorkflowTriggersQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiWorkflowTriggersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >(AiWorkflowTriggersDocument, options);
}
export function useAiWorkflowTriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >(AiWorkflowTriggersDocument, options);
}
// @ts-ignore
export function useAiWorkflowTriggersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowTriggersQuery,
  AiWorkflowTriggersQueryVariables
>;
export function useAiWorkflowTriggersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowTriggersQuery,
        AiWorkflowTriggersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AiWorkflowTriggersQuery | undefined,
  AiWorkflowTriggersQueryVariables
>;
export function useAiWorkflowTriggersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiWorkflowTriggersQuery,
        AiWorkflowTriggersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiWorkflowTriggersQuery,
    AiWorkflowTriggersQueryVariables
  >(AiWorkflowTriggersDocument, options);
}
export type AiWorkflowTriggersQueryHookResult = ReturnType<
  typeof useAiWorkflowTriggersQuery
>;
export type AiWorkflowTriggersLazyQueryHookResult = ReturnType<
  typeof useAiWorkflowTriggersLazyQuery
>;
export type AiWorkflowTriggersSuspenseQueryHookResult = ReturnType<
  typeof useAiWorkflowTriggersSuspenseQuery
>;
export type AiWorkflowTriggersQueryResult = Apollo.QueryResult<
  AiWorkflowTriggersQuery,
  AiWorkflowTriggersQueryVariables
>;
export const ComputeSegmentSpaceCalendarDocument = gql`
  mutation ComputeSegmentSpaceCalendar(
    $startDate: GoogleTypeDateInput!
    $endDate: GoogleTypeDateInput!
    $segments: [FlagsAdminV1SegmentScheduleInput!]
  ) {
    computeSegmentSpaceCalendar(
      startDate: $startDate
      endDate: $endDate
      segments: $segments
    ) {
      ... on FlagsAdminV1ComputeSegmentSpaceCalendarResponse {
        __typename
        dailyAvailability {
          date {
            year
            month
            day
          }
          availableSpace {
            value
          }
          reclaimableSpace {
            key
            value {
              value
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ComputeSegmentSpaceCalendarMutationFn = Apollo.MutationFunction<
  ComputeSegmentSpaceCalendarMutation,
  ComputeSegmentSpaceCalendarMutationVariables
>;

/**
 * __useComputeSegmentSpaceCalendarMutation__
 *
 * To run a mutation, you first call `useComputeSegmentSpaceCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeSegmentSpaceCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeSegmentSpaceCalendarMutation, { data, loading, error }] = useComputeSegmentSpaceCalendarMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      segments: // value for 'segments'
 *   },
 * });
 */
export function useComputeSegmentSpaceCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ComputeSegmentSpaceCalendarMutation,
    ComputeSegmentSpaceCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ComputeSegmentSpaceCalendarMutation,
    ComputeSegmentSpaceCalendarMutationVariables
  >(ComputeSegmentSpaceCalendarDocument, options);
}
export type ComputeSegmentSpaceCalendarMutationHookResult = ReturnType<
  typeof useComputeSegmentSpaceCalendarMutation
>;
export type ComputeSegmentSpaceCalendarMutationResult =
  Apollo.MutationResult<ComputeSegmentSpaceCalendarMutation>;
export type ComputeSegmentSpaceCalendarMutationOptions =
  Apollo.BaseMutationOptions<
    ComputeSegmentSpaceCalendarMutation,
    ComputeSegmentSpaceCalendarMutationVariables
  >;
export const CreateAiWorkflowTriggerDocument = gql`
  mutation CreateAiWorkflowTrigger(
    $aiWorkflowTrigger: AiworkflowsV1AiWorkflowTriggerInput!
  ) {
    createAiWorkflowTrigger(aiWorkflowTrigger: $aiWorkflowTrigger) {
      ...AiWorkflowTrigger
      ...DefaultError
    }
  }
  ${AiWorkflowTriggerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAiWorkflowTriggerMutationFn = Apollo.MutationFunction<
  CreateAiWorkflowTriggerMutation,
  CreateAiWorkflowTriggerMutationVariables
>;

/**
 * __useCreateAiWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useCreateAiWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiWorkflowTriggerMutation, { data, loading, error }] = useCreateAiWorkflowTriggerMutation({
 *   variables: {
 *      aiWorkflowTrigger: // value for 'aiWorkflowTrigger'
 *   },
 * });
 */
export function useCreateAiWorkflowTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAiWorkflowTriggerMutation,
    CreateAiWorkflowTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAiWorkflowTriggerMutation,
    CreateAiWorkflowTriggerMutationVariables
  >(CreateAiWorkflowTriggerDocument, options);
}
export type CreateAiWorkflowTriggerMutationHookResult = ReturnType<
  typeof useCreateAiWorkflowTriggerMutation
>;
export type CreateAiWorkflowTriggerMutationResult =
  Apollo.MutationResult<CreateAiWorkflowTriggerMutation>;
export type CreateAiWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<
  CreateAiWorkflowTriggerMutation,
  CreateAiWorkflowTriggerMutationVariables
>;
export const CreateFeedDocument = gql`
  mutation CreateFeed($feed: ActivityV1FeedInput!, $feedId: String) {
    createFeed(feed: $feed, feedId: $feedId) {
      ... on ActivityV1Feed {
        __typename
        channels {
          email {
            address
          }
          slack {
            channel
          }
          priority
          activityTypes {
            ... on ActivityV1ActivityType {
              name
            }
          }
        }
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateFeedMutationFn = Apollo.MutationFunction<
  CreateFeedMutation,
  CreateFeedMutationVariables
>;

/**
 * __useCreateFeedMutation__
 *
 * To run a mutation, you first call `useCreateFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedMutation, { data, loading, error }] = useCreateFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *      feedId: // value for 'feedId'
 *   },
 * });
 */
export function useCreateFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFeedMutation,
    CreateFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFeedMutation, CreateFeedMutationVariables>(
    CreateFeedDocument,
    options,
  );
}
export type CreateFeedMutationHookResult = ReturnType<
  typeof useCreateFeedMutation
>;
export type CreateFeedMutationResult =
  Apollo.MutationResult<CreateFeedMutation>;
export type CreateFeedMutationOptions = Apollo.BaseMutationOptions<
  CreateFeedMutation,
  CreateFeedMutationVariables
>;
export const CreateHoldbackDocument = gql`
  mutation CreateHoldback(
    $holdback: WorkflowV1HoldbackInput!
    $holdbackId: String!
    $parent: String!
  ) {
    createHoldback(
      holdback: $holdback
      holdbackId: $holdbackId
      parent: $parent
    ) {
      ...Holdback
      ...DefaultError
    }
  }
  ${HoldbackFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateHoldbackMutationFn = Apollo.MutationFunction<
  CreateHoldbackMutation,
  CreateHoldbackMutationVariables
>;

/**
 * __useCreateHoldbackMutation__
 *
 * To run a mutation, you first call `useCreateHoldbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHoldbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHoldbackMutation, { data, loading, error }] = useCreateHoldbackMutation({
 *   variables: {
 *      holdback: // value for 'holdback'
 *      holdbackId: // value for 'holdbackId'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateHoldbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateHoldbackMutation,
    CreateHoldbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateHoldbackMutation,
    CreateHoldbackMutationVariables
  >(CreateHoldbackDocument, options);
}
export type CreateHoldbackMutationHookResult = ReturnType<
  typeof useCreateHoldbackMutation
>;
export type CreateHoldbackMutationResult =
  Apollo.MutationResult<CreateHoldbackMutation>;
export type CreateHoldbackMutationOptions = Apollo.BaseMutationOptions<
  CreateHoldbackMutation,
  CreateHoldbackMutationVariables
>;
export const CreateSurfaceDocument = gql`
  mutation CreateSurface($input: WorkflowV1SurfaceInput!) {
    createSurface(surface: $input) {
      ...Surface
      ...DefaultError
    }
  }
  ${SurfaceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateSurfaceMutationFn = Apollo.MutationFunction<
  CreateSurfaceMutation,
  CreateSurfaceMutationVariables
>;

/**
 * __useCreateSurfaceMutation__
 *
 * To run a mutation, you first call `useCreateSurfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurfaceMutation, { data, loading, error }] = useCreateSurfaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurfaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSurfaceMutation,
    CreateSurfaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSurfaceMutation,
    CreateSurfaceMutationVariables
  >(CreateSurfaceDocument, options);
}
export type CreateSurfaceMutationHookResult = ReturnType<
  typeof useCreateSurfaceMutation
>;
export type CreateSurfaceMutationResult =
  Apollo.MutationResult<CreateSurfaceMutation>;
export type CreateSurfaceMutationOptions = Apollo.BaseMutationOptions<
  CreateSurfaceMutation,
  CreateSurfaceMutationVariables
>;
export const DeleteAiWorkflowTriggerDocument = gql`
  mutation DeleteAiWorkflowTrigger($name: String!) {
    deleteAiWorkflowTrigger(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteAiWorkflowTriggerMutationFn = Apollo.MutationFunction<
  DeleteAiWorkflowTriggerMutation,
  DeleteAiWorkflowTriggerMutationVariables
>;

/**
 * __useDeleteAiWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteAiWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiWorkflowTriggerMutation, { data, loading, error }] = useDeleteAiWorkflowTriggerMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAiWorkflowTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAiWorkflowTriggerMutation,
    DeleteAiWorkflowTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAiWorkflowTriggerMutation,
    DeleteAiWorkflowTriggerMutationVariables
  >(DeleteAiWorkflowTriggerDocument, options);
}
export type DeleteAiWorkflowTriggerMutationHookResult = ReturnType<
  typeof useDeleteAiWorkflowTriggerMutation
>;
export type DeleteAiWorkflowTriggerMutationResult =
  Apollo.MutationResult<DeleteAiWorkflowTriggerMutation>;
export type DeleteAiWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<
  DeleteAiWorkflowTriggerMutation,
  DeleteAiWorkflowTriggerMutationVariables
>;
export const DeleteHoldbackDocument = gql`
  mutation DeleteHoldback($name: String!) {
    deleteHoldback(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteHoldbackMutationFn = Apollo.MutationFunction<
  DeleteHoldbackMutation,
  DeleteHoldbackMutationVariables
>;

/**
 * __useDeleteHoldbackMutation__
 *
 * To run a mutation, you first call `useDeleteHoldbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHoldbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHoldbackMutation, { data, loading, error }] = useDeleteHoldbackMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteHoldbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteHoldbackMutation,
    DeleteHoldbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteHoldbackMutation,
    DeleteHoldbackMutationVariables
  >(DeleteHoldbackDocument, options);
}
export type DeleteHoldbackMutationHookResult = ReturnType<
  typeof useDeleteHoldbackMutation
>;
export type DeleteHoldbackMutationResult =
  Apollo.MutationResult<DeleteHoldbackMutation>;
export type DeleteHoldbackMutationOptions = Apollo.BaseMutationOptions<
  DeleteHoldbackMutation,
  DeleteHoldbackMutationVariables
>;
export const DeleteSurfaceDocument = gql`
  mutation DeleteSurface($name: String!) {
    deleteSurface(name: $name) {
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteSurfaceMutationFn = Apollo.MutationFunction<
  DeleteSurfaceMutation,
  DeleteSurfaceMutationVariables
>;

/**
 * __useDeleteSurfaceMutation__
 *
 * To run a mutation, you first call `useDeleteSurfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurfaceMutation, { data, loading, error }] = useDeleteSurfaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteSurfaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSurfaceMutation,
    DeleteSurfaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSurfaceMutation,
    DeleteSurfaceMutationVariables
  >(DeleteSurfaceDocument, options);
}
export type DeleteSurfaceMutationHookResult = ReturnType<
  typeof useDeleteSurfaceMutation
>;
export type DeleteSurfaceMutationResult =
  Apollo.MutationResult<DeleteSurfaceMutation>;
export type DeleteSurfaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteSurfaceMutation,
  DeleteSurfaceMutationVariables
>;
export const HoldbackDocument = gql`
  query Holdback($name: String!) {
    holdback(name: $name) {
      ...Holdback
      ...DefaultError
    }
  }
  ${HoldbackFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useHoldbackQuery__
 *
 * To run a query within a React component, call `useHoldbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoldbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoldbackQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHoldbackQuery(
  baseOptions: Apollo.QueryHookOptions<HoldbackQuery, HoldbackQueryVariables> &
    ({ variables: HoldbackQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HoldbackQuery, HoldbackQueryVariables>(
    HoldbackDocument,
    options,
  );
}
export function useHoldbackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HoldbackQuery,
    HoldbackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HoldbackQuery, HoldbackQueryVariables>(
    HoldbackDocument,
    options,
  );
}
// @ts-ignore
export function useHoldbackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HoldbackQuery,
    HoldbackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HoldbackQuery, HoldbackQueryVariables>;
export function useHoldbackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HoldbackQuery, HoldbackQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  HoldbackQuery | undefined,
  HoldbackQueryVariables
>;
export function useHoldbackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HoldbackQuery, HoldbackQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HoldbackQuery, HoldbackQueryVariables>(
    HoldbackDocument,
    options,
  );
}
export type HoldbackQueryHookResult = ReturnType<typeof useHoldbackQuery>;
export type HoldbackLazyQueryHookResult = ReturnType<
  typeof useHoldbackLazyQuery
>;
export type HoldbackSuspenseQueryHookResult = ReturnType<
  typeof useHoldbackSuspenseQuery
>;
export type HoldbackQueryResult = Apollo.QueryResult<
  HoldbackQuery,
  HoldbackQueryVariables
>;
export const HoldbacksDocument = gql`
  query Holdbacks(
    $parent: String!
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    holdbacks(
      parent: $parent
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on WorkflowV1ListHoldbacksResponse {
        __typename
        holdbacks {
          ...Holdback
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${HoldbackFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useHoldbacksQuery__
 *
 * To run a query within a React component, call `useHoldbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoldbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoldbacksQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useHoldbacksQuery(
  baseOptions: Apollo.QueryHookOptions<
    HoldbacksQuery,
    HoldbacksQueryVariables
  > &
    (
      | { variables: HoldbacksQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HoldbacksQuery, HoldbacksQueryVariables>(
    HoldbacksDocument,
    options,
  );
}
export function useHoldbacksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HoldbacksQuery,
    HoldbacksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HoldbacksQuery, HoldbacksQueryVariables>(
    HoldbacksDocument,
    options,
  );
}
// @ts-ignore
export function useHoldbacksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HoldbacksQuery,
    HoldbacksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HoldbacksQuery, HoldbacksQueryVariables>;
export function useHoldbacksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HoldbacksQuery, HoldbacksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  HoldbacksQuery | undefined,
  HoldbacksQueryVariables
>;
export function useHoldbacksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HoldbacksQuery, HoldbacksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HoldbacksQuery, HoldbacksQueryVariables>(
    HoldbacksDocument,
    options,
  );
}
export type HoldbacksQueryHookResult = ReturnType<typeof useHoldbacksQuery>;
export type HoldbacksLazyQueryHookResult = ReturnType<
  typeof useHoldbacksLazyQuery
>;
export type HoldbacksSuspenseQueryHookResult = ReturnType<
  typeof useHoldbacksSuspenseQuery
>;
export type HoldbacksQueryResult = Apollo.QueryResult<
  HoldbacksQuery,
  HoldbacksQueryVariables
>;
export const OnSurfaceCreatedDocument = gql`
  subscription OnSurfaceCreated {
    surfaceCreated {
      surface {
        ...Surface
      }
    }
  }
  ${SurfaceFragmentDoc}
`;

/**
 * __useOnSurfaceCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSurfaceCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSurfaceCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSurfaceCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSurfaceCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnSurfaceCreatedSubscription,
    OnSurfaceCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSurfaceCreatedSubscription,
    OnSurfaceCreatedSubscriptionVariables
  >(OnSurfaceCreatedDocument, options);
}
export type OnSurfaceCreatedSubscriptionHookResult = ReturnType<
  typeof useOnSurfaceCreatedSubscription
>;
export type OnSurfaceCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnSurfaceCreatedSubscription>;
export const OnSurfaceDeletedDocument = gql`
  subscription OnSurfaceDeleted {
    surfaceDeleted {
      surface
    }
  }
`;

/**
 * __useOnSurfaceDeletedSubscription__
 *
 * To run a query within a React component, call `useOnSurfaceDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSurfaceDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSurfaceDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSurfaceDeletedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnSurfaceDeletedSubscription,
    OnSurfaceDeletedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSurfaceDeletedSubscription,
    OnSurfaceDeletedSubscriptionVariables
  >(OnSurfaceDeletedDocument, options);
}
export type OnSurfaceDeletedSubscriptionHookResult = ReturnType<
  typeof useOnSurfaceDeletedSubscription
>;
export type OnSurfaceDeletedSubscriptionResult =
  Apollo.SubscriptionResult<OnSurfaceDeletedSubscription>;
export const OnSurfaceUpdatedDocument = gql`
  subscription OnSurfaceUpdated {
    surfaceUpdated {
      surface {
        ...Surface
      }
    }
  }
  ${SurfaceFragmentDoc}
`;

/**
 * __useOnSurfaceUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnSurfaceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSurfaceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSurfaceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSurfaceUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnSurfaceUpdatedSubscription,
    OnSurfaceUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSurfaceUpdatedSubscription,
    OnSurfaceUpdatedSubscriptionVariables
  >(OnSurfaceUpdatedDocument, options);
}
export type OnSurfaceUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnSurfaceUpdatedSubscription
>;
export type OnSurfaceUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnSurfaceUpdatedSubscription>;
export const RemoveSurfaceIdentityBindingDocument = gql`
  mutation RemoveSurfaceIdentityBinding($name: String!) {
    removeSurfaceIdentityBinding(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type RemoveSurfaceIdentityBindingMutationFn = Apollo.MutationFunction<
  RemoveSurfaceIdentityBindingMutation,
  RemoveSurfaceIdentityBindingMutationVariables
>;

/**
 * __useRemoveSurfaceIdentityBindingMutation__
 *
 * To run a mutation, you first call `useRemoveSurfaceIdentityBindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSurfaceIdentityBindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSurfaceIdentityBindingMutation, { data, loading, error }] = useRemoveSurfaceIdentityBindingMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRemoveSurfaceIdentityBindingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSurfaceIdentityBindingMutation,
    RemoveSurfaceIdentityBindingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSurfaceIdentityBindingMutation,
    RemoveSurfaceIdentityBindingMutationVariables
  >(RemoveSurfaceIdentityBindingDocument, options);
}
export type RemoveSurfaceIdentityBindingMutationHookResult = ReturnType<
  typeof useRemoveSurfaceIdentityBindingMutation
>;
export type RemoveSurfaceIdentityBindingMutationResult =
  Apollo.MutationResult<RemoveSurfaceIdentityBindingMutation>;
export type RemoveSurfaceIdentityBindingMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveSurfaceIdentityBindingMutation,
    RemoveSurfaceIdentityBindingMutationVariables
  >;
export const SpaceAvailabilitySegmentsDocument = gql`
  query SpaceAvailabilitySegments(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    segments(
      filter: $filter
      pageSize: $pageSize
      view: BASIC
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on FlagsAdminV1ListSegmentsResponse {
        __typename
        segments {
          ...SpaceAvailabilitySegment
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${SpaceAvailabilitySegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSpaceAvailabilitySegmentsQuery__
 *
 * To run a query within a React component, call `useSpaceAvailabilitySegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceAvailabilitySegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceAvailabilitySegmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSpaceAvailabilitySegmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >(SpaceAvailabilitySegmentsDocument, options);
}
export function useSpaceAvailabilitySegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >(SpaceAvailabilitySegmentsDocument, options);
}
// @ts-ignore
export function useSpaceAvailabilitySegmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SpaceAvailabilitySegmentsQuery,
  SpaceAvailabilitySegmentsQueryVariables
>;
export function useSpaceAvailabilitySegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceAvailabilitySegmentsQuery,
        SpaceAvailabilitySegmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SpaceAvailabilitySegmentsQuery | undefined,
  SpaceAvailabilitySegmentsQueryVariables
>;
export function useSpaceAvailabilitySegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceAvailabilitySegmentsQuery,
        SpaceAvailabilitySegmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SpaceAvailabilitySegmentsQuery,
    SpaceAvailabilitySegmentsQueryVariables
  >(SpaceAvailabilitySegmentsDocument, options);
}
export type SpaceAvailabilitySegmentsQueryHookResult = ReturnType<
  typeof useSpaceAvailabilitySegmentsQuery
>;
export type SpaceAvailabilitySegmentsLazyQueryHookResult = ReturnType<
  typeof useSpaceAvailabilitySegmentsLazyQuery
>;
export type SpaceAvailabilitySegmentsSuspenseQueryHookResult = ReturnType<
  typeof useSpaceAvailabilitySegmentsSuspenseQuery
>;
export type SpaceAvailabilitySegmentsQueryResult = Apollo.QueryResult<
  SpaceAvailabilitySegmentsQuery,
  SpaceAvailabilitySegmentsQueryVariables
>;
export const SurfaceDocument = gql`
  query Surface($name: String!) {
    surface(name: $name) {
      ...SurfaceWithMetrics
      ...DefaultError
    }
  }
  ${SurfaceWithMetricsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSurfaceQuery__
 *
 * To run a query within a React component, call `useSurfaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurfaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurfaceQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSurfaceQuery(
  baseOptions: Apollo.QueryHookOptions<SurfaceQuery, SurfaceQueryVariables> &
    ({ variables: SurfaceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SurfaceQuery, SurfaceQueryVariables>(
    SurfaceDocument,
    options,
  );
}
export function useSurfaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SurfaceQuery,
    SurfaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SurfaceQuery, SurfaceQueryVariables>(
    SurfaceDocument,
    options,
  );
}
// @ts-ignore
export function useSurfaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SurfaceQuery,
    SurfaceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SurfaceQuery, SurfaceQueryVariables>;
export function useSurfaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurfaceQuery, SurfaceQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SurfaceQuery | undefined,
  SurfaceQueryVariables
>;
export function useSurfaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurfaceQuery, SurfaceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SurfaceQuery, SurfaceQueryVariables>(
    SurfaceDocument,
    options,
  );
}
export type SurfaceQueryHookResult = ReturnType<typeof useSurfaceQuery>;
export type SurfaceLazyQueryHookResult = ReturnType<typeof useSurfaceLazyQuery>;
export type SurfaceSuspenseQueryHookResult = ReturnType<
  typeof useSurfaceSuspenseQuery
>;
export type SurfaceQueryResult = Apollo.QueryResult<
  SurfaceQuery,
  SurfaceQueryVariables
>;
export const SurfaceCoordinationDocument = gql`
  query SurfaceCoordination(
    $filter: String
    $showDeletedHoldbacks: Boolean
    $showDeletedExclusivityGroups: Boolean
  ) {
    surfaces(filter: $filter) {
      ...DefaultError
      ... on WorkflowV1ListSurfacesResponse {
        __typename
        surfaces {
          name
          description
          displayName
          holdbacks(showDeleted: $showDeletedHoldbacks) {
            ... on WorkflowV1ListHoldbacksResponse {
              __typename
              holdbacks {
                name
                description
                mode
                displayName
              }
            }
            ...DefaultError
          }
          exclusivityGroups(showDeleted: $showDeletedExclusivityGroups) {
            ... on WorkflowV1ListExclusivityGroupsResponse {
              __typename
              exclusivityGroups {
                name
                mode
                description
              }
            }
            ...DefaultError
          }
        }
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSurfaceCoordinationQuery__
 *
 * To run a query within a React component, call `useSurfaceCoordinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurfaceCoordinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurfaceCoordinationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      showDeletedHoldbacks: // value for 'showDeletedHoldbacks'
 *      showDeletedExclusivityGroups: // value for 'showDeletedExclusivityGroups'
 *   },
 * });
 */
export function useSurfaceCoordinationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >(SurfaceCoordinationDocument, options);
}
export function useSurfaceCoordinationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >(SurfaceCoordinationDocument, options);
}
// @ts-ignore
export function useSurfaceCoordinationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SurfaceCoordinationQuery,
  SurfaceCoordinationQueryVariables
>;
export function useSurfaceCoordinationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfaceCoordinationQuery,
        SurfaceCoordinationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SurfaceCoordinationQuery | undefined,
  SurfaceCoordinationQueryVariables
>;
export function useSurfaceCoordinationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfaceCoordinationQuery,
        SurfaceCoordinationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SurfaceCoordinationQuery,
    SurfaceCoordinationQueryVariables
  >(SurfaceCoordinationDocument, options);
}
export type SurfaceCoordinationQueryHookResult = ReturnType<
  typeof useSurfaceCoordinationQuery
>;
export type SurfaceCoordinationLazyQueryHookResult = ReturnType<
  typeof useSurfaceCoordinationLazyQuery
>;
export type SurfaceCoordinationSuspenseQueryHookResult = ReturnType<
  typeof useSurfaceCoordinationSuspenseQuery
>;
export type SurfaceCoordinationQueryResult = Apollo.QueryResult<
  SurfaceCoordinationQuery,
  SurfaceCoordinationQueryVariables
>;
export const SurfaceIdentityBindingsDocument = gql`
  query SurfaceIdentityBindings(
    $parent: String!
    $pageSize: Int
    $pageToken: String
  ) {
    surfaceIdentityBindings(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      __typename
      ... on WorkflowV1ListSurfaceIdentityBindingsResponse {
        __typename
        surfaceIdentityBindings {
          ...SurfaceIdentityBinding
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${SurfaceIdentityBindingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSurfaceIdentityBindingsQuery__
 *
 * To run a query within a React component, call `useSurfaceIdentityBindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurfaceIdentityBindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurfaceIdentityBindingsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useSurfaceIdentityBindingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  > &
    (
      | { variables: SurfaceIdentityBindingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  >(SurfaceIdentityBindingsDocument, options);
}
export function useSurfaceIdentityBindingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  >(SurfaceIdentityBindingsDocument, options);
}
// @ts-ignore
export function useSurfaceIdentityBindingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SurfaceIdentityBindingsQuery,
  SurfaceIdentityBindingsQueryVariables
>;
export function useSurfaceIdentityBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfaceIdentityBindingsQuery,
        SurfaceIdentityBindingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SurfaceIdentityBindingsQuery | undefined,
  SurfaceIdentityBindingsQueryVariables
>;
export function useSurfaceIdentityBindingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfaceIdentityBindingsQuery,
        SurfaceIdentityBindingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SurfaceIdentityBindingsQuery,
    SurfaceIdentityBindingsQueryVariables
  >(SurfaceIdentityBindingsDocument, options);
}
export type SurfaceIdentityBindingsQueryHookResult = ReturnType<
  typeof useSurfaceIdentityBindingsQuery
>;
export type SurfaceIdentityBindingsLazyQueryHookResult = ReturnType<
  typeof useSurfaceIdentityBindingsLazyQuery
>;
export type SurfaceIdentityBindingsSuspenseQueryHookResult = ReturnType<
  typeof useSurfaceIdentityBindingsSuspenseQuery
>;
export type SurfaceIdentityBindingsQueryResult = Apollo.QueryResult<
  SurfaceIdentityBindingsQuery,
  SurfaceIdentityBindingsQueryVariables
>;
export const SurfacesDocument = gql`
  query Surfaces(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    surfaces(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on WorkflowV1ListSurfacesResponse {
        surfaces {
          ...SurfaceRef
        }
        nextPageToken
        __typename
      }
      ...DefaultError
    }
  }
  ${SurfaceRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSurfacesQuery__
 *
 * To run a query within a React component, call `useSurfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurfacesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSurfacesQuery(
  baseOptions?: Apollo.QueryHookOptions<SurfacesQuery, SurfacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SurfacesQuery, SurfacesQueryVariables>(
    SurfacesDocument,
    options,
  );
}
export function useSurfacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SurfacesQuery,
    SurfacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SurfacesQuery, SurfacesQueryVariables>(
    SurfacesDocument,
    options,
  );
}
// @ts-ignore
export function useSurfacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SurfacesQuery,
    SurfacesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SurfacesQuery, SurfacesQueryVariables>;
export function useSurfacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurfacesQuery, SurfacesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SurfacesQuery | undefined,
  SurfacesQueryVariables
>;
export function useSurfacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurfacesQuery, SurfacesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SurfacesQuery, SurfacesQueryVariables>(
    SurfacesDocument,
    options,
  );
}
export type SurfacesQueryHookResult = ReturnType<typeof useSurfacesQuery>;
export type SurfacesLazyQueryHookResult = ReturnType<
  typeof useSurfacesLazyQuery
>;
export type SurfacesSuspenseQueryHookResult = ReturnType<
  typeof useSurfacesSuspenseQuery
>;
export type SurfacesQueryResult = Apollo.QueryResult<
  SurfacesQuery,
  SurfacesQueryVariables
>;
export const UpdateAiWorkflowTriggerDocument = gql`
  mutation UpdateAiWorkflowTrigger(
    $aiWorkflowTrigger: PartialAiworkflowsV1AiWorkflowTriggerInput!
    $updateMask: String
  ) {
    updateAiWorkflowTrigger(
      aiWorkflowTrigger: $aiWorkflowTrigger
      updateMask: $updateMask
    ) {
      ...AiWorkflowTrigger
      ...DefaultError
    }
  }
  ${AiWorkflowTriggerFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateAiWorkflowTriggerMutationFn = Apollo.MutationFunction<
  UpdateAiWorkflowTriggerMutation,
  UpdateAiWorkflowTriggerMutationVariables
>;

/**
 * __useUpdateAiWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateAiWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiWorkflowTriggerMutation, { data, loading, error }] = useUpdateAiWorkflowTriggerMutation({
 *   variables: {
 *      aiWorkflowTrigger: // value for 'aiWorkflowTrigger'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateAiWorkflowTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAiWorkflowTriggerMutation,
    UpdateAiWorkflowTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAiWorkflowTriggerMutation,
    UpdateAiWorkflowTriggerMutationVariables
  >(UpdateAiWorkflowTriggerDocument, options);
}
export type UpdateAiWorkflowTriggerMutationHookResult = ReturnType<
  typeof useUpdateAiWorkflowTriggerMutation
>;
export type UpdateAiWorkflowTriggerMutationResult =
  Apollo.MutationResult<UpdateAiWorkflowTriggerMutation>;
export type UpdateAiWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<
  UpdateAiWorkflowTriggerMutation,
  UpdateAiWorkflowTriggerMutationVariables
>;
export const UpdateFeedDocument = gql`
  mutation UpdateFeed($feed: PartialActivityV1FeedInput!) {
    updateFeed(feed: $feed) {
      ... on ActivityV1Feed {
        __typename
        channels {
          email {
            address
          }
          slack {
            channel
          }
          priority
          disabled
          activityTypes {
            ... on ActivityV1ActivityType {
              name
            }
          }
        }
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UpdateFeedMutationFn = Apollo.MutationFunction<
  UpdateFeedMutation,
  UpdateFeedMutationVariables
>;

/**
 * __useUpdateFeedMutation__
 *
 * To run a mutation, you first call `useUpdateFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedMutation, { data, loading, error }] = useUpdateFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useUpdateFeedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFeedMutation,
    UpdateFeedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFeedMutation, UpdateFeedMutationVariables>(
    UpdateFeedDocument,
    options,
  );
}
export type UpdateFeedMutationHookResult = ReturnType<
  typeof useUpdateFeedMutation
>;
export type UpdateFeedMutationResult =
  Apollo.MutationResult<UpdateFeedMutation>;
export type UpdateFeedMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeedMutation,
  UpdateFeedMutationVariables
>;
export const UpdateHoldbackDocument = gql`
  mutation UpdateHoldback(
    $input: PartialWorkflowV1HoldbackInput!
    $updateMask: String
  ) {
    updateHoldback(holdback: $input, updateMask: $updateMask) {
      ...Holdback
      ...DefaultError
    }
  }
  ${HoldbackFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateHoldbackMutationFn = Apollo.MutationFunction<
  UpdateHoldbackMutation,
  UpdateHoldbackMutationVariables
>;

/**
 * __useUpdateHoldbackMutation__
 *
 * To run a mutation, you first call `useUpdateHoldbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHoldbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHoldbackMutation, { data, loading, error }] = useUpdateHoldbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateHoldbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHoldbackMutation,
    UpdateHoldbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHoldbackMutation,
    UpdateHoldbackMutationVariables
  >(UpdateHoldbackDocument, options);
}
export type UpdateHoldbackMutationHookResult = ReturnType<
  typeof useUpdateHoldbackMutation
>;
export type UpdateHoldbackMutationResult =
  Apollo.MutationResult<UpdateHoldbackMutation>;
export type UpdateHoldbackMutationOptions = Apollo.BaseMutationOptions<
  UpdateHoldbackMutation,
  UpdateHoldbackMutationVariables
>;
export const UpdateSurfaceDocument = gql`
  mutation UpdateSurface(
    $input: PartialWorkflowV1SurfaceInput!
    $updateMask: String
  ) {
    updateSurface(surface: $input, updateMask: $updateMask) {
      ...Surface
      ...SurfaceWithMetrics
      ...DefaultError
    }
  }
  ${SurfaceFragmentDoc}
  ${SurfaceWithMetricsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateSurfaceMutationFn = Apollo.MutationFunction<
  UpdateSurfaceMutation,
  UpdateSurfaceMutationVariables
>;

/**
 * __useUpdateSurfaceMutation__
 *
 * To run a mutation, you first call `useUpdateSurfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurfaceMutation, { data, loading, error }] = useUpdateSurfaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateSurfaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSurfaceMutation,
    UpdateSurfaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSurfaceMutation,
    UpdateSurfaceMutationVariables
  >(UpdateSurfaceDocument, options);
}
export type UpdateSurfaceMutationHookResult = ReturnType<
  typeof useUpdateSurfaceMutation
>;
export type UpdateSurfaceMutationResult =
  Apollo.MutationResult<UpdateSurfaceMutation>;
export type UpdateSurfaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateSurfaceMutation,
  UpdateSurfaceMutationVariables
>;
export const CreateExclusivityGroupDocument = gql`
  mutation CreateExclusivityGroup(
    $exclusivityGroup: WorkflowV1ExclusivityGroupInput!
    $exclusivityGroupId: String!
    $parent: String!
  ) {
    createExclusivityGroup(
      exclusivityGroup: $exclusivityGroup
      exclusivityGroupId: $exclusivityGroupId
      parent: $parent
    ) {
      ...ExclusivityGroup
      ...DefaultError
    }
  }
  ${ExclusivityGroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateExclusivityGroupMutationFn = Apollo.MutationFunction<
  CreateExclusivityGroupMutation,
  CreateExclusivityGroupMutationVariables
>;

/**
 * __useCreateExclusivityGroupMutation__
 *
 * To run a mutation, you first call `useCreateExclusivityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExclusivityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExclusivityGroupMutation, { data, loading, error }] = useCreateExclusivityGroupMutation({
 *   variables: {
 *      exclusivityGroup: // value for 'exclusivityGroup'
 *      exclusivityGroupId: // value for 'exclusivityGroupId'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateExclusivityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExclusivityGroupMutation,
    CreateExclusivityGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExclusivityGroupMutation,
    CreateExclusivityGroupMutationVariables
  >(CreateExclusivityGroupDocument, options);
}
export type CreateExclusivityGroupMutationHookResult = ReturnType<
  typeof useCreateExclusivityGroupMutation
>;
export type CreateExclusivityGroupMutationResult =
  Apollo.MutationResult<CreateExclusivityGroupMutation>;
export type CreateExclusivityGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateExclusivityGroupMutation,
  CreateExclusivityGroupMutationVariables
>;
export const DeleteExclusivityGroupDocument = gql`
  mutation DeleteExclusivityGroup($name: String!) {
    deleteExclusivityGroup(name: $name) {
      ... on GoogleProtobufEmpty {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteExclusivityGroupMutationFn = Apollo.MutationFunction<
  DeleteExclusivityGroupMutation,
  DeleteExclusivityGroupMutationVariables
>;

/**
 * __useDeleteExclusivityGroupMutation__
 *
 * To run a mutation, you first call `useDeleteExclusivityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExclusivityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExclusivityGroupMutation, { data, loading, error }] = useDeleteExclusivityGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteExclusivityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExclusivityGroupMutation,
    DeleteExclusivityGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteExclusivityGroupMutation,
    DeleteExclusivityGroupMutationVariables
  >(DeleteExclusivityGroupDocument, options);
}
export type DeleteExclusivityGroupMutationHookResult = ReturnType<
  typeof useDeleteExclusivityGroupMutation
>;
export type DeleteExclusivityGroupMutationResult =
  Apollo.MutationResult<DeleteExclusivityGroupMutation>;
export type DeleteExclusivityGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteExclusivityGroupMutation,
  DeleteExclusivityGroupMutationVariables
>;
export const ExclusivityGroupDocument = gql`
  query ExclusivityGroup($name: String!) {
    exclusivityGroup(name: $name) {
      ...ExclusivityGroup
      ...DefaultError
    }
  }
  ${ExclusivityGroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExclusivityGroupQuery__
 *
 * To run a query within a React component, call `useExclusivityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useExclusivityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExclusivityGroupQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useExclusivityGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExclusivityGroupQuery,
    ExclusivityGroupQueryVariables
  > &
    (
      | { variables: ExclusivityGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExclusivityGroupQuery, ExclusivityGroupQueryVariables>(
    ExclusivityGroupDocument,
    options,
  );
}
export function useExclusivityGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExclusivityGroupQuery,
    ExclusivityGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExclusivityGroupQuery,
    ExclusivityGroupQueryVariables
  >(ExclusivityGroupDocument, options);
}
// @ts-ignore
export function useExclusivityGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExclusivityGroupQuery,
    ExclusivityGroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExclusivityGroupQuery,
  ExclusivityGroupQueryVariables
>;
export function useExclusivityGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExclusivityGroupQuery,
        ExclusivityGroupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExclusivityGroupQuery | undefined,
  ExclusivityGroupQueryVariables
>;
export function useExclusivityGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExclusivityGroupQuery,
        ExclusivityGroupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExclusivityGroupQuery,
    ExclusivityGroupQueryVariables
  >(ExclusivityGroupDocument, options);
}
export type ExclusivityGroupQueryHookResult = ReturnType<
  typeof useExclusivityGroupQuery
>;
export type ExclusivityGroupLazyQueryHookResult = ReturnType<
  typeof useExclusivityGroupLazyQuery
>;
export type ExclusivityGroupSuspenseQueryHookResult = ReturnType<
  typeof useExclusivityGroupSuspenseQuery
>;
export type ExclusivityGroupQueryResult = Apollo.QueryResult<
  ExclusivityGroupQuery,
  ExclusivityGroupQueryVariables
>;
export const ExclusivityGroupsDocument = gql`
  query ExclusivityGroups(
    $parent: String!
    $filter: String
    $pageSize: Int
    $pageToken: String
  ) {
    exclusivityGroups(
      parent: $parent
      filter: $filter
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on WorkflowV1ListExclusivityGroupsResponse {
        __typename
        exclusivityGroups {
          ...ExclusivityGroup
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ExclusivityGroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExclusivityGroupsQuery__
 *
 * To run a query within a React component, call `useExclusivityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExclusivityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExclusivityGroupsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useExclusivityGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  > &
    (
      | { variables: ExclusivityGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  >(ExclusivityGroupsDocument, options);
}
export function useExclusivityGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  >(ExclusivityGroupsDocument, options);
}
// @ts-ignore
export function useExclusivityGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExclusivityGroupsQuery,
  ExclusivityGroupsQueryVariables
>;
export function useExclusivityGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExclusivityGroupsQuery,
        ExclusivityGroupsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExclusivityGroupsQuery | undefined,
  ExclusivityGroupsQueryVariables
>;
export function useExclusivityGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExclusivityGroupsQuery,
        ExclusivityGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExclusivityGroupsQuery,
    ExclusivityGroupsQueryVariables
  >(ExclusivityGroupsDocument, options);
}
export type ExclusivityGroupsQueryHookResult = ReturnType<
  typeof useExclusivityGroupsQuery
>;
export type ExclusivityGroupsLazyQueryHookResult = ReturnType<
  typeof useExclusivityGroupsLazyQuery
>;
export type ExclusivityGroupsSuspenseQueryHookResult = ReturnType<
  typeof useExclusivityGroupsSuspenseQuery
>;
export type ExclusivityGroupsQueryResult = Apollo.QueryResult<
  ExclusivityGroupsQuery,
  ExclusivityGroupsQueryVariables
>;
export const SurfacePageActivitiesDocument = gql`
  query SurfacePageActivities(
    $name: String!
    $pageSize: Int
    $pageToken: String
  ) {
    activities(resource: $name, pageSize: $pageSize, pageToken: $pageToken) {
      ... on ActivityV1ListActivitiesResponse {
        activities {
          ...FeedActivity
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${FeedActivityFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSurfacePageActivitiesQuery__
 *
 * To run a query within a React component, call `useSurfacePageActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurfacePageActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurfacePageActivitiesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useSurfacePageActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  > &
    (
      | { variables: SurfacePageActivitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  >(SurfacePageActivitiesDocument, options);
}
export function useSurfacePageActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  >(SurfacePageActivitiesDocument, options);
}
// @ts-ignore
export function useSurfacePageActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SurfacePageActivitiesQuery,
  SurfacePageActivitiesQueryVariables
>;
export function useSurfacePageActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfacePageActivitiesQuery,
        SurfacePageActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SurfacePageActivitiesQuery | undefined,
  SurfacePageActivitiesQueryVariables
>;
export function useSurfacePageActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SurfacePageActivitiesQuery,
        SurfacePageActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SurfacePageActivitiesQuery,
    SurfacePageActivitiesQueryVariables
  >(SurfacePageActivitiesDocument, options);
}
export type SurfacePageActivitiesQueryHookResult = ReturnType<
  typeof useSurfacePageActivitiesQuery
>;
export type SurfacePageActivitiesLazyQueryHookResult = ReturnType<
  typeof useSurfacePageActivitiesLazyQuery
>;
export type SurfacePageActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useSurfacePageActivitiesSuspenseQuery
>;
export type SurfacePageActivitiesQueryResult = Apollo.QueryResult<
  SurfacePageActivitiesQuery,
  SurfacePageActivitiesQueryVariables
>;
export const UpdateExclusivityGroupDocument = gql`
  mutation UpdateExclusivityGroup(
    $exclusivityGroup: PartialWorkflowV1ExclusivityGroupInput!
    $updateMask: String
  ) {
    updateExclusivityGroup(
      exclusivityGroup: $exclusivityGroup
      updateMask: $updateMask
    ) {
      ...ExclusivityGroup
      ...DefaultError
    }
  }
  ${ExclusivityGroupFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateExclusivityGroupMutationFn = Apollo.MutationFunction<
  UpdateExclusivityGroupMutation,
  UpdateExclusivityGroupMutationVariables
>;

/**
 * __useUpdateExclusivityGroupMutation__
 *
 * To run a mutation, you first call `useUpdateExclusivityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExclusivityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExclusivityGroupMutation, { data, loading, error }] = useUpdateExclusivityGroupMutation({
 *   variables: {
 *      exclusivityGroup: // value for 'exclusivityGroup'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateExclusivityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExclusivityGroupMutation,
    UpdateExclusivityGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExclusivityGroupMutation,
    UpdateExclusivityGroupMutationVariables
  >(UpdateExclusivityGroupDocument, options);
}
export type UpdateExclusivityGroupMutationHookResult = ReturnType<
  typeof useUpdateExclusivityGroupMutation
>;
export type UpdateExclusivityGroupMutationResult =
  Apollo.MutationResult<UpdateExclusivityGroupMutation>;
export type UpdateExclusivityGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateExclusivityGroupMutation,
  UpdateExclusivityGroupMutationVariables
>;
export const AllocateSegmentDocument = gql`
  mutation AllocateSegment($name: String!) {
    allocateSegment(name: $name) {
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type AllocateSegmentMutationFn = Apollo.MutationFunction<
  AllocateSegmentMutation,
  AllocateSegmentMutationVariables
>;

/**
 * __useAllocateSegmentMutation__
 *
 * To run a mutation, you first call `useAllocateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocateSegmentMutation, { data, loading, error }] = useAllocateSegmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAllocateSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AllocateSegmentMutation,
    AllocateSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AllocateSegmentMutation,
    AllocateSegmentMutationVariables
  >(AllocateSegmentDocument, options);
}
export type AllocateSegmentMutationHookResult = ReturnType<
  typeof useAllocateSegmentMutation
>;
export type AllocateSegmentMutationResult =
  Apollo.MutationResult<AllocateSegmentMutation>;
export type AllocateSegmentMutationOptions = Apollo.BaseMutationOptions<
  AllocateSegmentMutation,
  AllocateSegmentMutationVariables
>;
export const ArchiveSegmentDocument = gql`
  mutation ArchiveSegment($name: String!) {
    archiveSegment(name: $name) {
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type ArchiveSegmentMutationFn = Apollo.MutationFunction<
  ArchiveSegmentMutation,
  ArchiveSegmentMutationVariables
>;

/**
 * __useArchiveSegmentMutation__
 *
 * To run a mutation, you first call `useArchiveSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSegmentMutation, { data, loading, error }] = useArchiveSegmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useArchiveSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveSegmentMutation,
    ArchiveSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveSegmentMutation,
    ArchiveSegmentMutationVariables
  >(ArchiveSegmentDocument, options);
}
export type ArchiveSegmentMutationHookResult = ReturnType<
  typeof useArchiveSegmentMutation
>;
export type ArchiveSegmentMutationResult =
  Apollo.MutationResult<ArchiveSegmentMutation>;
export type ArchiveSegmentMutationOptions = Apollo.BaseMutationOptions<
  ArchiveSegmentMutation,
  ArchiveSegmentMutationVariables
>;
export const CreateSegmentDocument = gql`
  mutation CreateSegment($segment: FlagsAdminV1SegmentInput!) {
    createSegment(segment: $segment) {
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateSegmentMutationFn = Apollo.MutationFunction<
  CreateSegmentMutation,
  CreateSegmentMutationVariables
>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useCreateSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSegmentMutation,
    CreateSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSegmentMutation,
    CreateSegmentMutationVariables
  >(CreateSegmentDocument, options);
}
export type CreateSegmentMutationHookResult = ReturnType<
  typeof useCreateSegmentMutation
>;
export type CreateSegmentMutationResult =
  Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<
  CreateSegmentMutation,
  CreateSegmentMutationVariables
>;
export const OnSegmentCreatedDocument = gql`
  subscription OnSegmentCreated {
    segmentCreated {
      segment {
        ...Segment
      }
    }
  }
  ${SegmentFragmentDoc}
`;

/**
 * __useOnSegmentCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSegmentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSegmentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSegmentCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSegmentCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnSegmentCreatedSubscription,
    OnSegmentCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSegmentCreatedSubscription,
    OnSegmentCreatedSubscriptionVariables
  >(OnSegmentCreatedDocument, options);
}
export type OnSegmentCreatedSubscriptionHookResult = ReturnType<
  typeof useOnSegmentCreatedSubscription
>;
export type OnSegmentCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnSegmentCreatedSubscription>;
export const OnSegmentUpdatedDocument = gql`
  subscription OnSegmentUpdated {
    segmentUpdated {
      segment {
        ...Segment
      }
    }
  }
  ${SegmentFragmentDoc}
`;

/**
 * __useOnSegmentUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnSegmentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSegmentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSegmentUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSegmentUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnSegmentUpdatedSubscription,
    OnSegmentUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnSegmentUpdatedSubscription,
    OnSegmentUpdatedSubscriptionVariables
  >(OnSegmentUpdatedDocument, options);
}
export type OnSegmentUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnSegmentUpdatedSubscription
>;
export type OnSegmentUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnSegmentUpdatedSubscription>;
export const SegmentDocument = gql`
  query Segment($name: String!) {
    segment(name: $name) {
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSegmentQuery__
 *
 * To run a query within a React component, call `useSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSegmentQuery(
  baseOptions: Apollo.QueryHookOptions<SegmentQuery, SegmentQueryVariables> &
    ({ variables: SegmentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SegmentQuery, SegmentQueryVariables>(
    SegmentDocument,
    options,
  );
}
export function useSegmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SegmentQuery,
    SegmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SegmentQuery, SegmentQueryVariables>(
    SegmentDocument,
    options,
  );
}
// @ts-ignore
export function useSegmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SegmentQuery,
    SegmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SegmentQuery, SegmentQueryVariables>;
export function useSegmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SegmentQuery, SegmentQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SegmentQuery | undefined,
  SegmentQueryVariables
>;
export function useSegmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SegmentQuery, SegmentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SegmentQuery, SegmentQueryVariables>(
    SegmentDocument,
    options,
  );
}
export type SegmentQueryHookResult = ReturnType<typeof useSegmentQuery>;
export type SegmentLazyQueryHookResult = ReturnType<typeof useSegmentLazyQuery>;
export type SegmentSuspenseQueryHookResult = ReturnType<
  typeof useSegmentSuspenseQuery
>;
export type SegmentQueryResult = Apollo.QueryResult<
  SegmentQuery,
  SegmentQueryVariables
>;
export const SegmentAvailableSpaceDocument = gql`
  mutation SegmentAvailableSpace(
    $segment: String
    $queryParams: FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput
  ) {
    segmentAvailableSpace(segment: $segment, queryParams: $queryParams) {
      ... on FlagsAdminV1SegmentAvailableSpaceResponse {
        __typename
        availableSpace {
          value
        }
        relatedSegments {
          ... on FlagsAdminV1Segment {
            ...SegmentRef
            workflowInstance {
              ... on WorkflowV1WorkflowInstance {
                name
                displayName
                moduleData2 {
                  planning {
                    planned {
                      startTime
                      endTime
                    }
                    actual {
                      startTime
                      endTime
                    }
                  }
                }
              }
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${SegmentRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type SegmentAvailableSpaceMutationFn = Apollo.MutationFunction<
  SegmentAvailableSpaceMutation,
  SegmentAvailableSpaceMutationVariables
>;

/**
 * __useSegmentAvailableSpaceMutation__
 *
 * To run a mutation, you first call `useSegmentAvailableSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentAvailableSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentAvailableSpaceMutation, { data, loading, error }] = useSegmentAvailableSpaceMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *      queryParams: // value for 'queryParams'
 *   },
 * });
 */
export function useSegmentAvailableSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SegmentAvailableSpaceMutation,
    SegmentAvailableSpaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SegmentAvailableSpaceMutation,
    SegmentAvailableSpaceMutationVariables
  >(SegmentAvailableSpaceDocument, options);
}
export type SegmentAvailableSpaceMutationHookResult = ReturnType<
  typeof useSegmentAvailableSpaceMutation
>;
export type SegmentAvailableSpaceMutationResult =
  Apollo.MutationResult<SegmentAvailableSpaceMutation>;
export type SegmentAvailableSpaceMutationOptions = Apollo.BaseMutationOptions<
  SegmentAvailableSpaceMutation,
  SegmentAvailableSpaceMutationVariables
>;
export const SegmentsDocument = gql`
  query Segments(
    $filter: String
    $pageSize: Int
    $pageToken: String
    $orderBy: String
  ) {
    segments(
      filter: $filter
      pageSize: $pageSize
      view: BASIC
      pageToken: $pageToken
      orderBy: $orderBy
    ) {
      ... on FlagsAdminV1ListSegmentsResponse {
        __typename
        segments {
          ...Segment
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSegmentsQuery__
 *
 * To run a query within a React component, call `useSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSegmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<SegmentsQuery, SegmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SegmentsQuery, SegmentsQueryVariables>(
    SegmentsDocument,
    options,
  );
}
export function useSegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SegmentsQuery,
    SegmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SegmentsQuery, SegmentsQueryVariables>(
    SegmentsDocument,
    options,
  );
}
// @ts-ignore
export function useSegmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SegmentsQuery,
    SegmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SegmentsQuery, SegmentsQueryVariables>;
export function useSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SegmentsQuery | undefined,
  SegmentsQueryVariables
>;
export function useSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SegmentsQuery, SegmentsQueryVariables>(
    SegmentsDocument,
    options,
  );
}
export type SegmentsQueryHookResult = ReturnType<typeof useSegmentsQuery>;
export type SegmentsLazyQueryHookResult = ReturnType<
  typeof useSegmentsLazyQuery
>;
export type SegmentsSuspenseQueryHookResult = ReturnType<
  typeof useSegmentsSuspenseQuery
>;
export type SegmentsQueryResult = Apollo.QueryResult<
  SegmentsQuery,
  SegmentsQueryVariables
>;
export const UpdateSegmentDocument = gql`
  mutation UpdateSegment(
    $input: PartialFlagsAdminV1SegmentInput!
    $updateMask: String
  ) {
    updateSegment(segment: $input, updateMask: $updateMask) {
      ...Segment
      ...DefaultError
    }
  }
  ${SegmentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<
  UpdateSegmentMutation,
  UpdateSegmentMutationVariables
>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSegmentMutation,
    UpdateSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSegmentMutation,
    UpdateSegmentMutationVariables
  >(UpdateSegmentDocument, options);
}
export type UpdateSegmentMutationHookResult = ReturnType<
  typeof useUpdateSegmentMutation
>;
export type UpdateSegmentMutationResult =
  Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateSegmentMutation,
  UpdateSegmentMutationVariables
>;
export const AaTestOnboardingDocument = gql`
  query AaTestOnboarding(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
      parent: "workflows/abtest"
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AaTestOnboarding
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${AaTestOnboardingFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAaTestOnboardingQuery__
 *
 * To run a query within a React component, call `useAaTestOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAaTestOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAaTestOnboardingQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAaTestOnboardingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AaTestOnboardingQuery,
    AaTestOnboardingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AaTestOnboardingQuery, AaTestOnboardingQueryVariables>(
    AaTestOnboardingDocument,
    options,
  );
}
export function useAaTestOnboardingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AaTestOnboardingQuery,
    AaTestOnboardingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AaTestOnboardingQuery,
    AaTestOnboardingQueryVariables
  >(AaTestOnboardingDocument, options);
}
// @ts-ignore
export function useAaTestOnboardingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AaTestOnboardingQuery,
    AaTestOnboardingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AaTestOnboardingQuery,
  AaTestOnboardingQueryVariables
>;
export function useAaTestOnboardingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AaTestOnboardingQuery,
        AaTestOnboardingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AaTestOnboardingQuery | undefined,
  AaTestOnboardingQueryVariables
>;
export function useAaTestOnboardingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AaTestOnboardingQuery,
        AaTestOnboardingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AaTestOnboardingQuery,
    AaTestOnboardingQueryVariables
  >(AaTestOnboardingDocument, options);
}
export type AaTestOnboardingQueryHookResult = ReturnType<
  typeof useAaTestOnboardingQuery
>;
export type AaTestOnboardingLazyQueryHookResult = ReturnType<
  typeof useAaTestOnboardingLazyQuery
>;
export type AaTestOnboardingSuspenseQueryHookResult = ReturnType<
  typeof useAaTestOnboardingSuspenseQuery
>;
export type AaTestOnboardingQueryResult = Apollo.QueryResult<
  AaTestOnboardingQuery,
  AaTestOnboardingQueryVariables
>;
export const AbTestDocument = gql`
  query AbTest($name: String!) {
    workflowInstance(name: $name) {
      ...AbTest
      ...DefaultError
    }
  }
  ${AbTestFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAbTestQuery__
 *
 * To run a query within a React component, call `useAbTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbTestQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAbTestQuery(
  baseOptions: Apollo.QueryHookOptions<AbTestQuery, AbTestQueryVariables> &
    ({ variables: AbTestQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AbTestQuery, AbTestQueryVariables>(
    AbTestDocument,
    options,
  );
}
export function useAbTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AbTestQuery, AbTestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AbTestQuery, AbTestQueryVariables>(
    AbTestDocument,
    options,
  );
}
// @ts-ignore
export function useAbTestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AbTestQuery,
    AbTestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AbTestQuery, AbTestQueryVariables>;
export function useAbTestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AbTestQuery, AbTestQueryVariables>,
): Apollo.UseSuspenseQueryResult<AbTestQuery | undefined, AbTestQueryVariables>;
export function useAbTestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AbTestQuery, AbTestQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AbTestQuery, AbTestQueryVariables>(
    AbTestDocument,
    options,
  );
}
export type AbTestQueryHookResult = ReturnType<typeof useAbTestQuery>;
export type AbTestLazyQueryHookResult = ReturnType<typeof useAbTestLazyQuery>;
export type AbTestSuspenseQueryHookResult = ReturnType<
  typeof useAbTestSuspenseQuery
>;
export type AbTestQueryResult = Apollo.QueryResult<
  AbTestQuery,
  AbTestQueryVariables
>;
export const AbTestsDocument = gql`
  query AbTests(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
      parent: "workflows/abtest"
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...AbTestListItem
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${AbTestListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useAbTestsQuery__
 *
 * To run a query within a React component, call `useAbTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbTestsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAbTestsQuery(
  baseOptions?: Apollo.QueryHookOptions<AbTestsQuery, AbTestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AbTestsQuery, AbTestsQueryVariables>(
    AbTestsDocument,
    options,
  );
}
export function useAbTestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AbTestsQuery,
    AbTestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AbTestsQuery, AbTestsQueryVariables>(
    AbTestsDocument,
    options,
  );
}
// @ts-ignore
export function useAbTestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AbTestsQuery,
    AbTestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AbTestsQuery, AbTestsQueryVariables>;
export function useAbTestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AbTestsQuery, AbTestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AbTestsQuery | undefined,
  AbTestsQueryVariables
>;
export function useAbTestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AbTestsQuery, AbTestsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AbTestsQuery, AbTestsQueryVariables>(
    AbTestsDocument,
    options,
  );
}
export type AbTestsQueryHookResult = ReturnType<typeof useAbTestsQuery>;
export type AbTestsLazyQueryHookResult = ReturnType<typeof useAbTestsLazyQuery>;
export type AbTestsSuspenseQueryHookResult = ReturnType<
  typeof useAbTestsSuspenseQuery
>;
export type AbTestsQueryResult = Apollo.QueryResult<
  AbTestsQuery,
  AbTestsQueryVariables
>;
export const AssignmentUsageDocument = gql`
  query AssignmentUsage($name: String!) {
    rule(name: $name) {
      __typename
      ... on FlagsAdminV1FlagRule {
        name
        usageMetadata {
          assignmentUsageMetadata {
            applyCount
            resolveCount
            assignmentId
            lastApplyTime
          }
        }
      }
    }
  }
`;

/**
 * __useAssignmentUsageQuery__
 *
 * To run a query within a React component, call `useAssignmentUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentUsageQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAssignmentUsageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentUsageQuery,
    AssignmentUsageQueryVariables
  > &
    (
      | { variables: AssignmentUsageQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentUsageQuery, AssignmentUsageQueryVariables>(
    AssignmentUsageDocument,
    options,
  );
}
export function useAssignmentUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentUsageQuery,
    AssignmentUsageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentUsageQuery,
    AssignmentUsageQueryVariables
  >(AssignmentUsageDocument, options);
}
// @ts-ignore
export function useAssignmentUsageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssignmentUsageQuery,
    AssignmentUsageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssignmentUsageQuery,
  AssignmentUsageQueryVariables
>;
export function useAssignmentUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentUsageQuery,
        AssignmentUsageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssignmentUsageQuery | undefined,
  AssignmentUsageQueryVariables
>;
export function useAssignmentUsageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentUsageQuery,
        AssignmentUsageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentUsageQuery,
    AssignmentUsageQueryVariables
  >(AssignmentUsageDocument, options);
}
export type AssignmentUsageQueryHookResult = ReturnType<
  typeof useAssignmentUsageQuery
>;
export type AssignmentUsageLazyQueryHookResult = ReturnType<
  typeof useAssignmentUsageLazyQuery
>;
export type AssignmentUsageSuspenseQueryHookResult = ReturnType<
  typeof useAssignmentUsageSuspenseQuery
>;
export type AssignmentUsageQueryResult = Apollo.QueryResult<
  AssignmentUsageQuery,
  AssignmentUsageQueryVariables
>;
export const CreateAbTestDocument = gql`
  mutation CreateAbTest(
    $parent: String!
    $input: WorkflowV1WorkflowInstanceInput!
    $workflowInstanceId: String
  ) {
    createWorkflowInstance(
      parent: $parent
      workflowInstance: $input
      workflowInstanceId: $workflowInstanceId
    ) {
      __typename
      ...AbTest
      ...DefaultError
    }
  }
  ${AbTestFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateAbTestMutationFn = Apollo.MutationFunction<
  CreateAbTestMutation,
  CreateAbTestMutationVariables
>;

/**
 * __useCreateAbTestMutation__
 *
 * To run a mutation, you first call `useCreateAbTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbTestMutation, { data, loading, error }] = useCreateAbTestMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      input: // value for 'input'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useCreateAbTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAbTestMutation,
    CreateAbTestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAbTestMutation,
    CreateAbTestMutationVariables
  >(CreateAbTestDocument, options);
}
export type CreateAbTestMutationHookResult = ReturnType<
  typeof useCreateAbTestMutation
>;
export type CreateAbTestMutationResult =
  Apollo.MutationResult<CreateAbTestMutation>;
export type CreateAbTestMutationOptions = Apollo.BaseMutationOptions<
  CreateAbTestMutation,
  CreateAbTestMutationVariables
>;
export const GetFlagVariantsDocument = gql`
  query GetFlagVariants($name: String!) {
    flag(name: $name) {
      ... on FlagsAdminV1Flag {
        __typename
        name
        variants {
          description
          name
          imageUri
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetFlagVariantsQuery__
 *
 * To run a query within a React component, call `useGetFlagVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlagVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlagVariantsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFlagVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFlagVariantsQuery,
    GetFlagVariantsQueryVariables
  > &
    (
      | { variables: GetFlagVariantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlagVariantsQuery, GetFlagVariantsQueryVariables>(
    GetFlagVariantsDocument,
    options,
  );
}
export function useGetFlagVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFlagVariantsQuery,
    GetFlagVariantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFlagVariantsQuery,
    GetFlagVariantsQueryVariables
  >(GetFlagVariantsDocument, options);
}
// @ts-ignore
export function useGetFlagVariantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFlagVariantsQuery,
    GetFlagVariantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFlagVariantsQuery,
  GetFlagVariantsQueryVariables
>;
export function useGetFlagVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagVariantsQuery,
        GetFlagVariantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFlagVariantsQuery | undefined,
  GetFlagVariantsQueryVariables
>;
export function useGetFlagVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagVariantsQuery,
        GetFlagVariantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFlagVariantsQuery,
    GetFlagVariantsQueryVariables
  >(GetFlagVariantsDocument, options);
}
export type GetFlagVariantsQueryHookResult = ReturnType<
  typeof useGetFlagVariantsQuery
>;
export type GetFlagVariantsLazyQueryHookResult = ReturnType<
  typeof useGetFlagVariantsLazyQuery
>;
export type GetFlagVariantsSuspenseQueryHookResult = ReturnType<
  typeof useGetFlagVariantsSuspenseQuery
>;
export type GetFlagVariantsQueryResult = Apollo.QueryResult<
  GetFlagVariantsQuery,
  GetFlagVariantsQueryVariables
>;
export const OnAbTestCreatedDocument = gql`
  subscription OnAbTestCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...AbTest
      }
    }
  }
  ${AbTestFragmentDoc}
`;

/**
 * __useOnAbTestCreatedSubscription__
 *
 * To run a query within a React component, call `useOnAbTestCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAbTestCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAbTestCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAbTestCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnAbTestCreatedSubscription,
    OnAbTestCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnAbTestCreatedSubscription,
    OnAbTestCreatedSubscriptionVariables
  >(OnAbTestCreatedDocument, options);
}
export type OnAbTestCreatedSubscriptionHookResult = ReturnType<
  typeof useOnAbTestCreatedSubscription
>;
export type OnAbTestCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnAbTestCreatedSubscription>;
export const OnAbTestUpdatedDocument = gql`
  subscription OnAbTestUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...AbTest
      }
    }
  }
  ${AbTestFragmentDoc}
`;

/**
 * __useOnAbTestUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAbTestUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAbTestUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAbTestUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAbTestUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnAbTestUpdatedSubscription,
    OnAbTestUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnAbTestUpdatedSubscription,
    OnAbTestUpdatedSubscriptionVariables
  >(OnAbTestUpdatedDocument, options);
}
export type OnAbTestUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnAbTestUpdatedSubscription
>;
export type OnAbTestUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnAbTestUpdatedSubscription>;
export const UpdateAbTestDataDocument = gql`
  mutation UpdateAbTestData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          abtest {
            ...AbTestData
          }
        }
      }
      ...DefaultError
    }
  }
  ${AbTestDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateAbTestDataMutationFn = Apollo.MutationFunction<
  UpdateAbTestDataMutation,
  UpdateAbTestDataMutationVariables
>;

/**
 * __useUpdateAbTestDataMutation__
 *
 * To run a mutation, you first call `useUpdateAbTestDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAbTestDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAbTestDataMutation, { data, loading, error }] = useUpdateAbTestDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateAbTestDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAbTestDataMutation,
    UpdateAbTestDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAbTestDataMutation,
    UpdateAbTestDataMutationVariables
  >(UpdateAbTestDataDocument, options);
}
export type UpdateAbTestDataMutationHookResult = ReturnType<
  typeof useUpdateAbTestDataMutation
>;
export type UpdateAbTestDataMutationResult =
  Apollo.MutationResult<UpdateAbTestDataMutation>;
export type UpdateAbTestDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateAbTestDataMutation,
  UpdateAbTestDataMutationVariables
>;
export const UpdateDecisionDataDocument = gql`
  mutation UpdateDecisionData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          decision {
            ...DecisionData
          }
        }
      }
      ...DefaultError
    }
  }
  ${DecisionDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateDecisionDataMutationFn = Apollo.MutationFunction<
  UpdateDecisionDataMutation,
  UpdateDecisionDataMutationVariables
>;

/**
 * __useUpdateDecisionDataMutation__
 *
 * To run a mutation, you first call `useUpdateDecisionDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDecisionDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDecisionDataMutation, { data, loading, error }] = useUpdateDecisionDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateDecisionDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDecisionDataMutation,
    UpdateDecisionDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDecisionDataMutation,
    UpdateDecisionDataMutationVariables
  >(UpdateDecisionDataDocument, options);
}
export type UpdateDecisionDataMutationHookResult = ReturnType<
  typeof useUpdateDecisionDataMutation
>;
export type UpdateDecisionDataMutationResult =
  Apollo.MutationResult<UpdateDecisionDataMutation>;
export type UpdateDecisionDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateDecisionDataMutation,
  UpdateDecisionDataMutationVariables
>;
export const AddExploratoryAnalysisDocument = gql`
  mutation addExploratoryAnalysis(
    $parameters: JSON
    $workflowInstance: String!
  ) {
    executeFunction(
      functionName: "addExploratoryAnalysis"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ...ExploratoryAnalysisFunctionResponse
      ...DefaultError
    }
  }
  ${ExploratoryAnalysisFunctionResponseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type AddExploratoryAnalysisMutationFn = Apollo.MutationFunction<
  AddExploratoryAnalysisMutation,
  AddExploratoryAnalysisMutationVariables
>;

/**
 * __useAddExploratoryAnalysisMutation__
 *
 * To run a mutation, you first call `useAddExploratoryAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExploratoryAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExploratoryAnalysisMutation, { data, loading, error }] = useAddExploratoryAnalysisMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useAddExploratoryAnalysisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddExploratoryAnalysisMutation,
    AddExploratoryAnalysisMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddExploratoryAnalysisMutation,
    AddExploratoryAnalysisMutationVariables
  >(AddExploratoryAnalysisDocument, options);
}
export type AddExploratoryAnalysisMutationHookResult = ReturnType<
  typeof useAddExploratoryAnalysisMutation
>;
export type AddExploratoryAnalysisMutationResult =
  Apollo.MutationResult<AddExploratoryAnalysisMutation>;
export type AddExploratoryAnalysisMutationOptions = Apollo.BaseMutationOptions<
  AddExploratoryAnalysisMutation,
  AddExploratoryAnalysisMutationVariables
>;
export const DeleteExploratoryAnalysisDocument = gql`
  mutation deleteExploratoryAnalysis(
    $parameters: JSON
    $workflowInstance: String!
  ) {
    executeFunction(
      functionName: "deleteExploratoryAnalysis"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ...ExploratoryAnalysisFunctionResponse
      ...DefaultError
    }
  }
  ${ExploratoryAnalysisFunctionResponseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteExploratoryAnalysisMutationFn = Apollo.MutationFunction<
  DeleteExploratoryAnalysisMutation,
  DeleteExploratoryAnalysisMutationVariables
>;

/**
 * __useDeleteExploratoryAnalysisMutation__
 *
 * To run a mutation, you first call `useDeleteExploratoryAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExploratoryAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExploratoryAnalysisMutation, { data, loading, error }] = useDeleteExploratoryAnalysisMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useDeleteExploratoryAnalysisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExploratoryAnalysisMutation,
    DeleteExploratoryAnalysisMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteExploratoryAnalysisMutation,
    DeleteExploratoryAnalysisMutationVariables
  >(DeleteExploratoryAnalysisDocument, options);
}
export type DeleteExploratoryAnalysisMutationHookResult = ReturnType<
  typeof useDeleteExploratoryAnalysisMutation
>;
export type DeleteExploratoryAnalysisMutationResult =
  Apollo.MutationResult<DeleteExploratoryAnalysisMutation>;
export type DeleteExploratoryAnalysisMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteExploratoryAnalysisMutation,
    DeleteExploratoryAnalysisMutationVariables
  >;
export const DimensionTablePickerOptionsDocument = gql`
  query DimensionTablePickerOptions($dimensionTableFilter: String) {
    dimensionTables(filter: $dimensionTableFilter) {
      ... on MetricsV1ListDimensionTablesResponse {
        __typename
        dimensionTables {
          name
          dimensions {
            name
            type
          }
          entityColumnMapping {
            entity {
              ... on MetricsV1Entity {
                name
                __typename
              }
              ...DefaultError
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useDimensionTablePickerOptionsQuery__
 *
 * To run a query within a React component, call `useDimensionTablePickerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionTablePickerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionTablePickerOptionsQuery({
 *   variables: {
 *      dimensionTableFilter: // value for 'dimensionTableFilter'
 *   },
 * });
 */
export function useDimensionTablePickerOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >(DimensionTablePickerOptionsDocument, options);
}
export function useDimensionTablePickerOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >(DimensionTablePickerOptionsDocument, options);
}
// @ts-ignore
export function useDimensionTablePickerOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablePickerOptionsQuery,
  DimensionTablePickerOptionsQueryVariables
>;
export function useDimensionTablePickerOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablePickerOptionsQuery,
        DimensionTablePickerOptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DimensionTablePickerOptionsQuery | undefined,
  DimensionTablePickerOptionsQueryVariables
>;
export function useDimensionTablePickerOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimensionTablePickerOptionsQuery,
        DimensionTablePickerOptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DimensionTablePickerOptionsQuery,
    DimensionTablePickerOptionsQueryVariables
  >(DimensionTablePickerOptionsDocument, options);
}
export type DimensionTablePickerOptionsQueryHookResult = ReturnType<
  typeof useDimensionTablePickerOptionsQuery
>;
export type DimensionTablePickerOptionsLazyQueryHookResult = ReturnType<
  typeof useDimensionTablePickerOptionsLazyQuery
>;
export type DimensionTablePickerOptionsSuspenseQueryHookResult = ReturnType<
  typeof useDimensionTablePickerOptionsSuspenseQuery
>;
export type DimensionTablePickerOptionsQueryResult = Apollo.QueryResult<
  DimensionTablePickerOptionsQuery,
  DimensionTablePickerOptionsQueryVariables
>;
export const EditExploratoryAnalysisDocument = gql`
  mutation editExploratoryAnalysis(
    $parameters: JSON
    $workflowInstance: String!
  ) {
    executeFunction(
      functionName: "editExploratoryAnalysis"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ...ExploratoryAnalysisFunctionResponse
      ...DefaultError
    }
  }
  ${ExploratoryAnalysisFunctionResponseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type EditExploratoryAnalysisMutationFn = Apollo.MutationFunction<
  EditExploratoryAnalysisMutation,
  EditExploratoryAnalysisMutationVariables
>;

/**
 * __useEditExploratoryAnalysisMutation__
 *
 * To run a mutation, you first call `useEditExploratoryAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExploratoryAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExploratoryAnalysisMutation, { data, loading, error }] = useEditExploratoryAnalysisMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useEditExploratoryAnalysisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditExploratoryAnalysisMutation,
    EditExploratoryAnalysisMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditExploratoryAnalysisMutation,
    EditExploratoryAnalysisMutationVariables
  >(EditExploratoryAnalysisDocument, options);
}
export type EditExploratoryAnalysisMutationHookResult = ReturnType<
  typeof useEditExploratoryAnalysisMutation
>;
export type EditExploratoryAnalysisMutationResult =
  Apollo.MutationResult<EditExploratoryAnalysisMutation>;
export type EditExploratoryAnalysisMutationOptions = Apollo.BaseMutationOptions<
  EditExploratoryAnalysisMutation,
  EditExploratoryAnalysisMutationVariables
>;
export const MetricDimensionPickerDocument = gql`
  query MetricDimensionPicker($name: String!) {
    metric(name: $name) {
      ... on MetricsV1Metric {
        __typename
        name
        factTable {
          ...FactTableRef
          ...DefaultError
        }
        entity {
          ... on MetricsV1Entity {
            name
            __typename
          }
          ...DefaultError
        }
      }
      ...DefaultError
    }
  }
  ${FactTableRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useMetricDimensionPickerQuery__
 *
 * To run a query within a React component, call `useMetricDimensionPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricDimensionPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricDimensionPickerQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMetricDimensionPickerQuery(
  baseOptions: Apollo.QueryHookOptions<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  > &
    (
      | { variables: MetricDimensionPickerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  >(MetricDimensionPickerDocument, options);
}
export function useMetricDimensionPickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  >(MetricDimensionPickerDocument, options);
}
// @ts-ignore
export function useMetricDimensionPickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MetricDimensionPickerQuery,
  MetricDimensionPickerQueryVariables
>;
export function useMetricDimensionPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricDimensionPickerQuery,
        MetricDimensionPickerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MetricDimensionPickerQuery | undefined,
  MetricDimensionPickerQueryVariables
>;
export function useMetricDimensionPickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MetricDimensionPickerQuery,
        MetricDimensionPickerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MetricDimensionPickerQuery,
    MetricDimensionPickerQueryVariables
  >(MetricDimensionPickerDocument, options);
}
export type MetricDimensionPickerQueryHookResult = ReturnType<
  typeof useMetricDimensionPickerQuery
>;
export type MetricDimensionPickerLazyQueryHookResult = ReturnType<
  typeof useMetricDimensionPickerLazyQuery
>;
export type MetricDimensionPickerSuspenseQueryHookResult = ReturnType<
  typeof useMetricDimensionPickerSuspenseQuery
>;
export type MetricDimensionPickerQueryResult = Apollo.QueryResult<
  MetricDimensionPickerQuery,
  MetricDimensionPickerQueryVariables
>;
export const RefreshExploratoryAnalysisCalculationsDocument = gql`
  mutation refreshExploratoryAnalysisCalculations(
    $parameters: JSON
    $workflowInstance: String!
  ) {
    executeFunction(
      functionName: "refreshExploratoryAnalysisCalculations"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ...ExploratoryAnalysisFunctionResponse
      ...DefaultError
    }
  }
  ${ExploratoryAnalysisFunctionResponseFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RefreshExploratoryAnalysisCalculationsMutationFn =
  Apollo.MutationFunction<
    RefreshExploratoryAnalysisCalculationsMutation,
    RefreshExploratoryAnalysisCalculationsMutationVariables
  >;

/**
 * __useRefreshExploratoryAnalysisCalculationsMutation__
 *
 * To run a mutation, you first call `useRefreshExploratoryAnalysisCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshExploratoryAnalysisCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshExploratoryAnalysisCalculationsMutation, { data, loading, error }] = useRefreshExploratoryAnalysisCalculationsMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useRefreshExploratoryAnalysisCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshExploratoryAnalysisCalculationsMutation,
    RefreshExploratoryAnalysisCalculationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshExploratoryAnalysisCalculationsMutation,
    RefreshExploratoryAnalysisCalculationsMutationVariables
  >(RefreshExploratoryAnalysisCalculationsDocument, options);
}
export type RefreshExploratoryAnalysisCalculationsMutationHookResult =
  ReturnType<typeof useRefreshExploratoryAnalysisCalculationsMutation>;
export type RefreshExploratoryAnalysisCalculationsMutationResult =
  Apollo.MutationResult<RefreshExploratoryAnalysisCalculationsMutation>;
export type RefreshExploratoryAnalysisCalculationsMutationOptions =
  Apollo.BaseMutationOptions<
    RefreshExploratoryAnalysisCalculationsMutation,
    RefreshExploratoryAnalysisCalculationsMutationVariables
  >;
export const ExecuteUpdateSegmentDocument = gql`
  mutation ExecuteUpdateSegment(
    $workflowInstance: String!
    $requestJson: JSON!
  ) {
    executeFunction(
      workflowInstance: $workflowInstance
      functionName: "updateSegment"
      parameters: $requestJson
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
        instance {
          __typename
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type ExecuteUpdateSegmentMutationFn = Apollo.MutationFunction<
  ExecuteUpdateSegmentMutation,
  ExecuteUpdateSegmentMutationVariables
>;

/**
 * __useExecuteUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useExecuteUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeUpdateSegmentMutation, { data, loading, error }] = useExecuteUpdateSegmentMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *      requestJson: // value for 'requestJson'
 *   },
 * });
 */
export function useExecuteUpdateSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteUpdateSegmentMutation,
    ExecuteUpdateSegmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExecuteUpdateSegmentMutation,
    ExecuteUpdateSegmentMutationVariables
  >(ExecuteUpdateSegmentDocument, options);
}
export type ExecuteUpdateSegmentMutationHookResult = ReturnType<
  typeof useExecuteUpdateSegmentMutation
>;
export type ExecuteUpdateSegmentMutationResult =
  Apollo.MutationResult<ExecuteUpdateSegmentMutation>;
export type ExecuteUpdateSegmentMutationOptions = Apollo.BaseMutationOptions<
  ExecuteUpdateSegmentMutation,
  ExecuteUpdateSegmentMutationVariables
>;
export const PauseIntakeDocument = gql`
  mutation PauseIntake($name: String!) {
    executeFunction(workflowInstance: $name, functionName: "pauseIntake") {
      ... on WorkflowV1ExecuteFunctionResponse {
        response
        instance {
          name
          moduleData {
            key
            value
          }
        }
      }
    }
  }
`;
export type PauseIntakeMutationFn = Apollo.MutationFunction<
  PauseIntakeMutation,
  PauseIntakeMutationVariables
>;

/**
 * __usePauseIntakeMutation__
 *
 * To run a mutation, you first call `usePauseIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseIntakeMutation, { data, loading, error }] = usePauseIntakeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePauseIntakeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PauseIntakeMutation,
    PauseIntakeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PauseIntakeMutation, PauseIntakeMutationVariables>(
    PauseIntakeDocument,
    options,
  );
}
export type PauseIntakeMutationHookResult = ReturnType<
  typeof usePauseIntakeMutation
>;
export type PauseIntakeMutationResult =
  Apollo.MutationResult<PauseIntakeMutation>;
export type PauseIntakeMutationOptions = Apollo.BaseMutationOptions<
  PauseIntakeMutation,
  PauseIntakeMutationVariables
>;
export const ResumeIntakeDocument = gql`
  mutation ResumeIntake($name: String!) {
    executeFunction(workflowInstance: $name, functionName: "resumeIntake") {
      ... on WorkflowV1ExecuteFunctionResponse {
        response
        instance {
          name
          moduleData {
            key
            value
          }
        }
      }
    }
  }
`;
export type ResumeIntakeMutationFn = Apollo.MutationFunction<
  ResumeIntakeMutation,
  ResumeIntakeMutationVariables
>;

/**
 * __useResumeIntakeMutation__
 *
 * To run a mutation, you first call `useResumeIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeIntakeMutation, { data, loading, error }] = useResumeIntakeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useResumeIntakeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeIntakeMutation,
    ResumeIntakeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResumeIntakeMutation,
    ResumeIntakeMutationVariables
  >(ResumeIntakeDocument, options);
}
export type ResumeIntakeMutationHookResult = ReturnType<
  typeof useResumeIntakeMutation
>;
export type ResumeIntakeMutationResult =
  Apollo.MutationResult<ResumeIntakeMutation>;
export type ResumeIntakeMutationOptions = Apollo.BaseMutationOptions<
  ResumeIntakeMutation,
  ResumeIntakeMutationVariables
>;
export const UpdateFlagsDataDocument = gql`
  mutation UpdateFlagsData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          flags {
            ...FlagsData
          }
        }
      }
      ...DefaultError
    }
  }
  ${FlagsDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateFlagsDataMutationFn = Apollo.MutationFunction<
  UpdateFlagsDataMutation,
  UpdateFlagsDataMutationVariables
>;

/**
 * __useUpdateFlagsDataMutation__
 *
 * To run a mutation, you first call `useUpdateFlagsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlagsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlagsDataMutation, { data, loading, error }] = useUpdateFlagsDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateFlagsDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFlagsDataMutation,
    UpdateFlagsDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFlagsDataMutation,
    UpdateFlagsDataMutationVariables
  >(UpdateFlagsDataDocument, options);
}
export type UpdateFlagsDataMutationHookResult = ReturnType<
  typeof useUpdateFlagsDataMutation
>;
export type UpdateFlagsDataMutationResult =
  Apollo.MutationResult<UpdateFlagsDataMutation>;
export type UpdateFlagsDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateFlagsDataMutation,
  UpdateFlagsDataMutationVariables
>;
export const UpdateHypothesisDataDocument = gql`
  mutation UpdateHypothesisData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          hypothesis {
            ...HypothesisData
          }
        }
      }
      ...DefaultError
    }
  }
  ${HypothesisDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateHypothesisDataMutationFn = Apollo.MutationFunction<
  UpdateHypothesisDataMutation,
  UpdateHypothesisDataMutationVariables
>;

/**
 * __useUpdateHypothesisDataMutation__
 *
 * To run a mutation, you first call `useUpdateHypothesisDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHypothesisDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHypothesisDataMutation, { data, loading, error }] = useUpdateHypothesisDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateHypothesisDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHypothesisDataMutation,
    UpdateHypothesisDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHypothesisDataMutation,
    UpdateHypothesisDataMutationVariables
  >(UpdateHypothesisDataDocument, options);
}
export type UpdateHypothesisDataMutationHookResult = ReturnType<
  typeof useUpdateHypothesisDataMutation
>;
export type UpdateHypothesisDataMutationResult =
  Apollo.MutationResult<UpdateHypothesisDataMutation>;
export type UpdateHypothesisDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateHypothesisDataMutation,
  UpdateHypothesisDataMutationVariables
>;
export const UpdateWorkflowInstanceInitiativesDocument = gql`
  mutation UpdateWorkflowInstanceInitiatives(
    $input: PartialWorkflowV1WorkflowInstanceInput!
  ) {
    updateWorkflowInstance(
      workflowInstance: $input
      updateMask: "initiatives"
    ) {
      ... on WorkflowV1WorkflowInstance {
        name
        __typename
        initiatives {
          __typename
          ...Initiative
          ...DefaultError
        }
      }
      ...DefaultError
    }
  }
  ${InitiativeFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateWorkflowInstanceInitiativesMutationFn =
  Apollo.MutationFunction<
    UpdateWorkflowInstanceInitiativesMutation,
    UpdateWorkflowInstanceInitiativesMutationVariables
  >;

/**
 * __useUpdateWorkflowInstanceInitiativesMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowInstanceInitiativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowInstanceInitiativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowInstanceInitiativesMutation, { data, loading, error }] = useUpdateWorkflowInstanceInitiativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowInstanceInitiativesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowInstanceInitiativesMutation,
    UpdateWorkflowInstanceInitiativesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowInstanceInitiativesMutation,
    UpdateWorkflowInstanceInitiativesMutationVariables
  >(UpdateWorkflowInstanceInitiativesDocument, options);
}
export type UpdateWorkflowInstanceInitiativesMutationHookResult = ReturnType<
  typeof useUpdateWorkflowInstanceInitiativesMutation
>;
export type UpdateWorkflowInstanceInitiativesMutationResult =
  Apollo.MutationResult<UpdateWorkflowInstanceInitiativesMutation>;
export type UpdateWorkflowInstanceInitiativesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkflowInstanceInitiativesMutation,
    UpdateWorkflowInstanceInitiativesMutationVariables
  >;
export const UpdateMetricsDataDocument = gql`
  mutation UpdateMetricsData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UpdateMetricsDataMutationFn = Apollo.MutationFunction<
  UpdateMetricsDataMutation,
  UpdateMetricsDataMutationVariables
>;

/**
 * __useUpdateMetricsDataMutation__
 *
 * To run a mutation, you first call `useUpdateMetricsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricsDataMutation, { data, loading, error }] = useUpdateMetricsDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateMetricsDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMetricsDataMutation,
    UpdateMetricsDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMetricsDataMutation,
    UpdateMetricsDataMutationVariables
  >(UpdateMetricsDataDocument, options);
}
export type UpdateMetricsDataMutationHookResult = ReturnType<
  typeof useUpdateMetricsDataMutation
>;
export type UpdateMetricsDataMutationResult =
  Apollo.MutationResult<UpdateMetricsDataMutation>;
export type UpdateMetricsDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateMetricsDataMutation,
  UpdateMetricsDataMutationVariables
>;
export const UpdatePlanningDataDocument = gql`
  mutation UpdatePlanningData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          planning {
            ...PlanningData
          }
        }
      }
      ...DefaultError
    }
  }
  ${PlanningDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdatePlanningDataMutationFn = Apollo.MutationFunction<
  UpdatePlanningDataMutation,
  UpdatePlanningDataMutationVariables
>;

/**
 * __useUpdatePlanningDataMutation__
 *
 * To run a mutation, you first call `useUpdatePlanningDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanningDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanningDataMutation, { data, loading, error }] = useUpdatePlanningDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdatePlanningDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlanningDataMutation,
    UpdatePlanningDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlanningDataMutation,
    UpdatePlanningDataMutationVariables
  >(UpdatePlanningDataDocument, options);
}
export type UpdatePlanningDataMutationHookResult = ReturnType<
  typeof useUpdatePlanningDataMutation
>;
export type UpdatePlanningDataMutationResult =
  Apollo.MutationResult<UpdatePlanningDataMutation>;
export type UpdatePlanningDataMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlanningDataMutation,
  UpdatePlanningDataMutationVariables
>;
export const CalculateDocument = gql`
  mutation Calculate($name: String!) {
    executeFunction(workflowInstance: $name, functionName: "calculate") {
      ... on WorkflowV1ExecuteFunctionResponse {
        response
        instance {
          name
          moduleData {
            key
            value
          }
        }
      }
    }
  }
`;
export type CalculateMutationFn = Apollo.MutationFunction<
  CalculateMutation,
  CalculateMutationVariables
>;

/**
 * __useCalculateMutation__
 *
 * To run a mutation, you first call `useCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateMutation, { data, loading, error }] = useCalculateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCalculateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CalculateMutation,
    CalculateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CalculateMutation, CalculateMutationVariables>(
    CalculateDocument,
    options,
  );
}
export type CalculateMutationHookResult = ReturnType<
  typeof useCalculateMutation
>;
export type CalculateMutationResult = Apollo.MutationResult<CalculateMutation>;
export type CalculateMutationOptions = Apollo.BaseMutationOptions<
  CalculateMutation,
  CalculateMutationVariables
>;
export const CreateReanalysisDocument = gql`
  mutation CreateReanalysis(
    $parent: String!
    $input: WorkflowV1WorkflowInstanceInput!
    $workflowInstanceId: String
  ) {
    createWorkflowInstance(
      parent: $parent
      workflowInstance: $input
      workflowInstanceId: $workflowInstanceId
    ) {
      __typename
      ...Reanalysis
      ...DefaultError
    }
  }
  ${ReanalysisFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateReanalysisMutationFn = Apollo.MutationFunction<
  CreateReanalysisMutation,
  CreateReanalysisMutationVariables
>;

/**
 * __useCreateReanalysisMutation__
 *
 * To run a mutation, you first call `useCreateReanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReanalysisMutation, { data, loading, error }] = useCreateReanalysisMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      input: // value for 'input'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useCreateReanalysisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReanalysisMutation,
    CreateReanalysisMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReanalysisMutation,
    CreateReanalysisMutationVariables
  >(CreateReanalysisDocument, options);
}
export type CreateReanalysisMutationHookResult = ReturnType<
  typeof useCreateReanalysisMutation
>;
export type CreateReanalysisMutationResult =
  Apollo.MutationResult<CreateReanalysisMutation>;
export type CreateReanalysisMutationOptions = Apollo.BaseMutationOptions<
  CreateReanalysisMutation,
  CreateReanalysisMutationVariables
>;
export const DescribeAssignmentTableDocument = gql`
  mutation DescribeAssignmentTable(
    $name: String!
    $startTime: String!
    $endTime: String!
  ) {
    describeAssignmentTable(
      name: $name
      startTime: $startTime
      endTime: $endTime
    ) {
      ... on MetricsV1DescribeAssignmentTableResponse {
        __typename
        assignmentsData {
          exposureKey
          variants
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DescribeAssignmentTableMutationFn = Apollo.MutationFunction<
  DescribeAssignmentTableMutation,
  DescribeAssignmentTableMutationVariables
>;

/**
 * __useDescribeAssignmentTableMutation__
 *
 * To run a mutation, you first call `useDescribeAssignmentTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDescribeAssignmentTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [describeAssignmentTableMutation, { data, loading, error }] = useDescribeAssignmentTableMutation({
 *   variables: {
 *      name: // value for 'name'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useDescribeAssignmentTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DescribeAssignmentTableMutation,
    DescribeAssignmentTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DescribeAssignmentTableMutation,
    DescribeAssignmentTableMutationVariables
  >(DescribeAssignmentTableDocument, options);
}
export type DescribeAssignmentTableMutationHookResult = ReturnType<
  typeof useDescribeAssignmentTableMutation
>;
export type DescribeAssignmentTableMutationResult =
  Apollo.MutationResult<DescribeAssignmentTableMutation>;
export type DescribeAssignmentTableMutationOptions = Apollo.BaseMutationOptions<
  DescribeAssignmentTableMutation,
  DescribeAssignmentTableMutationVariables
>;
export const ExposureCalculationDocument = gql`
  query ExposureCalculation($name: String!) {
    exposureCalculation(name: $name) {
      ...DefaultError
      ... on MetricsV1ExposureCalculation {
        __typename
        name
        startTime
        endTime
        sql
        state
        sqlJob {
          ... on MetricsV1SqlJob {
            name
            state
            labels {
              key
              value
            }
            failedQueryResult {
              error
            }
            __typename
          }
          ...DefaultError
        }
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useExposureCalculationQuery__
 *
 * To run a query within a React component, call `useExposureCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureCalculationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useExposureCalculationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  > &
    (
      | { variables: ExposureCalculationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  >(ExposureCalculationDocument, options);
}
export function useExposureCalculationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  >(ExposureCalculationDocument, options);
}
// @ts-ignore
export function useExposureCalculationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExposureCalculationQuery,
  ExposureCalculationQueryVariables
>;
export function useExposureCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureCalculationQuery,
        ExposureCalculationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExposureCalculationQuery | undefined,
  ExposureCalculationQueryVariables
>;
export function useExposureCalculationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExposureCalculationQuery,
        ExposureCalculationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExposureCalculationQuery,
    ExposureCalculationQueryVariables
  >(ExposureCalculationDocument, options);
}
export type ExposureCalculationQueryHookResult = ReturnType<
  typeof useExposureCalculationQuery
>;
export type ExposureCalculationLazyQueryHookResult = ReturnType<
  typeof useExposureCalculationLazyQuery
>;
export type ExposureCalculationSuspenseQueryHookResult = ReturnType<
  typeof useExposureCalculationSuspenseQuery
>;
export type ExposureCalculationQueryResult = Apollo.QueryResult<
  ExposureCalculationQuery,
  ExposureCalculationQueryVariables
>;
export const OnReanalysisCreatedDocument = gql`
  subscription OnReanalysisCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...Reanalysis
      }
    }
  }
  ${ReanalysisFragmentDoc}
`;

/**
 * __useOnReanalysisCreatedSubscription__
 *
 * To run a query within a React component, call `useOnReanalysisCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnReanalysisCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnReanalysisCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnReanalysisCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnReanalysisCreatedSubscription,
    OnReanalysisCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnReanalysisCreatedSubscription,
    OnReanalysisCreatedSubscriptionVariables
  >(OnReanalysisCreatedDocument, options);
}
export type OnReanalysisCreatedSubscriptionHookResult = ReturnType<
  typeof useOnReanalysisCreatedSubscription
>;
export type OnReanalysisCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnReanalysisCreatedSubscription>;
export const OnReanalysisUpdatedDocument = gql`
  subscription OnReanalysisUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...Reanalysis
      }
    }
  }
  ${ReanalysisFragmentDoc}
`;

/**
 * __useOnReanalysisUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnReanalysisUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnReanalysisUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnReanalysisUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnReanalysisUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnReanalysisUpdatedSubscription,
    OnReanalysisUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnReanalysisUpdatedSubscription,
    OnReanalysisUpdatedSubscriptionVariables
  >(OnReanalysisUpdatedDocument, options);
}
export type OnReanalysisUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnReanalysisUpdatedSubscription
>;
export type OnReanalysisUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnReanalysisUpdatedSubscription>;
export const ReanalysesDocument = gql`
  query Reanalyses(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
      parent: "workflows/reanalysis"
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...ReanalysisListItem
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${ReanalysisListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useReanalysesQuery__
 *
 * To run a query within a React component, call `useReanalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReanalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReanalysesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReanalysesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReanalysesQuery,
    ReanalysesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReanalysesQuery, ReanalysesQueryVariables>(
    ReanalysesDocument,
    options,
  );
}
export function useReanalysesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReanalysesQuery,
    ReanalysesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReanalysesQuery, ReanalysesQueryVariables>(
    ReanalysesDocument,
    options,
  );
}
// @ts-ignore
export function useReanalysesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReanalysesQuery,
    ReanalysesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReanalysesQuery, ReanalysesQueryVariables>;
export function useReanalysesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReanalysesQuery,
        ReanalysesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReanalysesQuery | undefined,
  ReanalysesQueryVariables
>;
export function useReanalysesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReanalysesQuery,
        ReanalysesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReanalysesQuery, ReanalysesQueryVariables>(
    ReanalysesDocument,
    options,
  );
}
export type ReanalysesQueryHookResult = ReturnType<typeof useReanalysesQuery>;
export type ReanalysesLazyQueryHookResult = ReturnType<
  typeof useReanalysesLazyQuery
>;
export type ReanalysesSuspenseQueryHookResult = ReturnType<
  typeof useReanalysesSuspenseQuery
>;
export type ReanalysesQueryResult = Apollo.QueryResult<
  ReanalysesQuery,
  ReanalysesQueryVariables
>;
export const ReanalysisDocument = gql`
  query Reanalysis($name: String!) {
    workflowInstance(name: $name) {
      ...Reanalysis
      ...DefaultError
    }
  }
  ${ReanalysisFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useReanalysisQuery__
 *
 * To run a query within a React component, call `useReanalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useReanalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReanalysisQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useReanalysisQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReanalysisQuery,
    ReanalysisQueryVariables
  > &
    (
      | { variables: ReanalysisQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReanalysisQuery, ReanalysisQueryVariables>(
    ReanalysisDocument,
    options,
  );
}
export function useReanalysisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReanalysisQuery,
    ReanalysisQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReanalysisQuery, ReanalysisQueryVariables>(
    ReanalysisDocument,
    options,
  );
}
// @ts-ignore
export function useReanalysisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReanalysisQuery,
    ReanalysisQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReanalysisQuery, ReanalysisQueryVariables>;
export function useReanalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReanalysisQuery,
        ReanalysisQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReanalysisQuery | undefined,
  ReanalysisQueryVariables
>;
export function useReanalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReanalysisQuery,
        ReanalysisQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReanalysisQuery, ReanalysisQueryVariables>(
    ReanalysisDocument,
    options,
  );
}
export type ReanalysisQueryHookResult = ReturnType<typeof useReanalysisQuery>;
export type ReanalysisLazyQueryHookResult = ReturnType<
  typeof useReanalysisLazyQuery
>;
export type ReanalysisSuspenseQueryHookResult = ReturnType<
  typeof useReanalysisSuspenseQuery
>;
export type ReanalysisQueryResult = Apollo.QueryResult<
  ReanalysisQuery,
  ReanalysisQueryVariables
>;
export const DeleteReviewResponseDocument = gql`
  mutation deleteReviewResponse($parameters: JSON, $workflowInstance: String!) {
    executeFunction(
      functionName: "deleteReviewResponse"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
        instance {
          name
          moduleData2 {
            reviews {
              ...WorkflowReviews
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${WorkflowReviewsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type DeleteReviewResponseMutationFn = Apollo.MutationFunction<
  DeleteReviewResponseMutation,
  DeleteReviewResponseMutationVariables
>;

/**
 * __useDeleteReviewResponseMutation__
 *
 * To run a mutation, you first call `useDeleteReviewResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewResponseMutation, { data, loading, error }] = useDeleteReviewResponseMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useDeleteReviewResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReviewResponseMutation,
    DeleteReviewResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReviewResponseMutation,
    DeleteReviewResponseMutationVariables
  >(DeleteReviewResponseDocument, options);
}
export type DeleteReviewResponseMutationHookResult = ReturnType<
  typeof useDeleteReviewResponseMutation
>;
export type DeleteReviewResponseMutationResult =
  Apollo.MutationResult<DeleteReviewResponseMutation>;
export type DeleteReviewResponseMutationOptions = Apollo.BaseMutationOptions<
  DeleteReviewResponseMutation,
  DeleteReviewResponseMutationVariables
>;
export const RequestReviewsDocument = gql`
  mutation requestReviews($parameters: JSON, $workflowInstance: String!) {
    executeFunction(
      functionName: "requestReviews"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
        instance {
          name
          moduleData2 {
            reviews {
              ...WorkflowReviews
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${WorkflowReviewsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type RequestReviewsMutationFn = Apollo.MutationFunction<
  RequestReviewsMutation,
  RequestReviewsMutationVariables
>;

/**
 * __useRequestReviewsMutation__
 *
 * To run a mutation, you first call `useRequestReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReviewsMutation, { data, loading, error }] = useRequestReviewsMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useRequestReviewsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestReviewsMutation,
    RequestReviewsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestReviewsMutation,
    RequestReviewsMutationVariables
  >(RequestReviewsDocument, options);
}
export type RequestReviewsMutationHookResult = ReturnType<
  typeof useRequestReviewsMutation
>;
export type RequestReviewsMutationResult =
  Apollo.MutationResult<RequestReviewsMutation>;
export type RequestReviewsMutationOptions = Apollo.BaseMutationOptions<
  RequestReviewsMutation,
  RequestReviewsMutationVariables
>;
export const SubmitReviewDocument = gql`
  mutation submitReview($parameters: JSON, $workflowInstance: String!) {
    executeFunction(
      functionName: "submitReviewResponse"
      parameters: $parameters
      workflowInstance: $workflowInstance
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
        instance {
          name
          moduleData2 {
            reviews {
              ...WorkflowReviews
            }
          }
        }
      }
      ...DefaultError
    }
  }
  ${WorkflowReviewsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type SubmitReviewMutationFn = Apollo.MutationFunction<
  SubmitReviewMutation,
  SubmitReviewMutationVariables
>;

/**
 * __useSubmitReviewMutation__
 *
 * To run a mutation, you first call `useSubmitReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReviewMutation, { data, loading, error }] = useSubmitReviewMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useSubmitReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitReviewMutation,
    SubmitReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitReviewMutation,
    SubmitReviewMutationVariables
  >(SubmitReviewDocument, options);
}
export type SubmitReviewMutationHookResult = ReturnType<
  typeof useSubmitReviewMutation
>;
export type SubmitReviewMutationResult =
  Apollo.MutationResult<SubmitReviewMutation>;
export type SubmitReviewMutationOptions = Apollo.BaseMutationOptions<
  SubmitReviewMutation,
  SubmitReviewMutationVariables
>;
export const WorkflowReviewsDocument = gql`
  query WorkflowReviews($name: String!) {
    workflowInstance(name: $name) {
      ... on WorkflowV1WorkflowInstance {
        __typename
        moduleData2 {
          reviews {
            ...WorkflowReviews
          }
        }
        name
      }
      ...DefaultError
    }
  }
  ${WorkflowReviewsFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowReviewsQuery__
 *
 * To run a query within a React component, call `useWorkflowReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowReviewsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useWorkflowReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkflowReviewsQuery,
    WorkflowReviewsQueryVariables
  > &
    (
      | { variables: WorkflowReviewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkflowReviewsQuery, WorkflowReviewsQueryVariables>(
    WorkflowReviewsDocument,
    options,
  );
}
export function useWorkflowReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowReviewsQuery,
    WorkflowReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowReviewsQuery,
    WorkflowReviewsQueryVariables
  >(WorkflowReviewsDocument, options);
}
// @ts-ignore
export function useWorkflowReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowReviewsQuery,
    WorkflowReviewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowReviewsQuery,
  WorkflowReviewsQueryVariables
>;
export function useWorkflowReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowReviewsQuery,
        WorkflowReviewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowReviewsQuery | undefined,
  WorkflowReviewsQueryVariables
>;
export function useWorkflowReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowReviewsQuery,
        WorkflowReviewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowReviewsQuery,
    WorkflowReviewsQueryVariables
  >(WorkflowReviewsDocument, options);
}
export type WorkflowReviewsQueryHookResult = ReturnType<
  typeof useWorkflowReviewsQuery
>;
export type WorkflowReviewsLazyQueryHookResult = ReturnType<
  typeof useWorkflowReviewsLazyQuery
>;
export type WorkflowReviewsSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowReviewsSuspenseQuery
>;
export type WorkflowReviewsQueryResult = Apollo.QueryResult<
  WorkflowReviewsQuery,
  WorkflowReviewsQueryVariables
>;
export const CreateRolloutDocument = gql`
  mutation CreateRollout(
    $parent: String!
    $input: WorkflowV1WorkflowInstanceInput!
    $workflowInstanceId: String
  ) {
    createWorkflowInstance(
      parent: $parent
      workflowInstance: $input
      workflowInstanceId: $workflowInstanceId
    ) {
      __typename
      ...Rollout
      ...DefaultError
    }
  }
  ${RolloutFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateRolloutMutationFn = Apollo.MutationFunction<
  CreateRolloutMutation,
  CreateRolloutMutationVariables
>;

/**
 * __useCreateRolloutMutation__
 *
 * To run a mutation, you first call `useCreateRolloutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRolloutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRolloutMutation, { data, loading, error }] = useCreateRolloutMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      input: // value for 'input'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useCreateRolloutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRolloutMutation,
    CreateRolloutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRolloutMutation,
    CreateRolloutMutationVariables
  >(CreateRolloutDocument, options);
}
export type CreateRolloutMutationHookResult = ReturnType<
  typeof useCreateRolloutMutation
>;
export type CreateRolloutMutationResult =
  Apollo.MutationResult<CreateRolloutMutation>;
export type CreateRolloutMutationOptions = Apollo.BaseMutationOptions<
  CreateRolloutMutation,
  CreateRolloutMutationVariables
>;
export const FlagsWithVariantsDocument = gql`
  query FlagsWithVariants($filter: String!, $pageToken: String) {
    flags(pageSize: 20, filter: $filter, pageToken: $pageToken) {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          variants {
            name
          }
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useFlagsWithVariantsQuery__
 *
 * To run a query within a React component, call `useFlagsWithVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlagsWithVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlagsWithVariantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useFlagsWithVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  > &
    (
      | { variables: FlagsWithVariantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  >(FlagsWithVariantsDocument, options);
}
export function useFlagsWithVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  >(FlagsWithVariantsDocument, options);
}
// @ts-ignore
export function useFlagsWithVariantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FlagsWithVariantsQuery,
  FlagsWithVariantsQueryVariables
>;
export function useFlagsWithVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsWithVariantsQuery,
        FlagsWithVariantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FlagsWithVariantsQuery | undefined,
  FlagsWithVariantsQueryVariables
>;
export function useFlagsWithVariantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FlagsWithVariantsQuery,
        FlagsWithVariantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FlagsWithVariantsQuery,
    FlagsWithVariantsQueryVariables
  >(FlagsWithVariantsDocument, options);
}
export type FlagsWithVariantsQueryHookResult = ReturnType<
  typeof useFlagsWithVariantsQuery
>;
export type FlagsWithVariantsLazyQueryHookResult = ReturnType<
  typeof useFlagsWithVariantsLazyQuery
>;
export type FlagsWithVariantsSuspenseQueryHookResult = ReturnType<
  typeof useFlagsWithVariantsSuspenseQuery
>;
export type FlagsWithVariantsQueryResult = Apollo.QueryResult<
  FlagsWithVariantsQuery,
  FlagsWithVariantsQueryVariables
>;
export const GetMaxReachDocument = gql`
  mutation getMaxReach($workflowInstance: String!) {
    executeFunction(
      workflowInstance: $workflowInstance
      functionName: "getRolloutInfo"
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type GetMaxReachMutationFn = Apollo.MutationFunction<
  GetMaxReachMutation,
  GetMaxReachMutationVariables
>;

/**
 * __useGetMaxReachMutation__
 *
 * To run a mutation, you first call `useGetMaxReachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMaxReachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMaxReachMutation, { data, loading, error }] = useGetMaxReachMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useGetMaxReachMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetMaxReachMutation,
    GetMaxReachMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetMaxReachMutation, GetMaxReachMutationVariables>(
    GetMaxReachDocument,
    options,
  );
}
export type GetMaxReachMutationHookResult = ReturnType<
  typeof useGetMaxReachMutation
>;
export type GetMaxReachMutationResult =
  Apollo.MutationResult<GetMaxReachMutation>;
export type GetMaxReachMutationOptions = Apollo.BaseMutationOptions<
  GetMaxReachMutation,
  GetMaxReachMutationVariables
>;
export const OnRolloutCreatedDocument = gql`
  subscription OnRolloutCreated {
    workflowInstanceCreated {
      workflowInstance {
        ...Rollout
      }
    }
  }
  ${RolloutFragmentDoc}
`;

/**
 * __useOnRolloutCreatedSubscription__
 *
 * To run a query within a React component, call `useOnRolloutCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRolloutCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRolloutCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnRolloutCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnRolloutCreatedSubscription,
    OnRolloutCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnRolloutCreatedSubscription,
    OnRolloutCreatedSubscriptionVariables
  >(OnRolloutCreatedDocument, options);
}
export type OnRolloutCreatedSubscriptionHookResult = ReturnType<
  typeof useOnRolloutCreatedSubscription
>;
export type OnRolloutCreatedSubscriptionResult =
  Apollo.SubscriptionResult<OnRolloutCreatedSubscription>;
export const OnRolloutUpdatedDocument = gql`
  subscription OnRolloutUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...Rollout
      }
    }
  }
  ${RolloutFragmentDoc}
`;

/**
 * __useOnRolloutUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnRolloutUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnRolloutUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnRolloutUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnRolloutUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnRolloutUpdatedSubscription,
    OnRolloutUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnRolloutUpdatedSubscription,
    OnRolloutUpdatedSubscriptionVariables
  >(OnRolloutUpdatedDocument, options);
}
export type OnRolloutUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnRolloutUpdatedSubscription
>;
export type OnRolloutUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnRolloutUpdatedSubscription>;
export const RolloutDocument = gql`
  query Rollout($name: String!) {
    workflowInstance(name: $name) {
      ...Rollout
      ...DefaultError
    }
  }
  ${RolloutFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRolloutQuery__
 *
 * To run a query within a React component, call `useRolloutQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolloutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolloutQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRolloutQuery(
  baseOptions: Apollo.QueryHookOptions<RolloutQuery, RolloutQueryVariables> &
    ({ variables: RolloutQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RolloutQuery, RolloutQueryVariables>(
    RolloutDocument,
    options,
  );
}
export function useRolloutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RolloutQuery,
    RolloutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RolloutQuery, RolloutQueryVariables>(
    RolloutDocument,
    options,
  );
}
// @ts-ignore
export function useRolloutSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RolloutQuery,
    RolloutQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RolloutQuery, RolloutQueryVariables>;
export function useRolloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolloutQuery, RolloutQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RolloutQuery | undefined,
  RolloutQueryVariables
>;
export function useRolloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolloutQuery, RolloutQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RolloutQuery, RolloutQueryVariables>(
    RolloutDocument,
    options,
  );
}
export type RolloutQueryHookResult = ReturnType<typeof useRolloutQuery>;
export type RolloutLazyQueryHookResult = ReturnType<typeof useRolloutLazyQuery>;
export type RolloutSuspenseQueryHookResult = ReturnType<
  typeof useRolloutSuspenseQuery
>;
export type RolloutQueryResult = Apollo.QueryResult<
  RolloutQuery,
  RolloutQueryVariables
>;
export const RolloutsDocument = gql`
  query Rollouts(
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
      parent: "workflows/rollout"
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...RolloutListItem
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${RolloutListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useRolloutsQuery__
 *
 * To run a query within a React component, call `useRolloutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolloutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolloutsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRolloutsQuery(
  baseOptions?: Apollo.QueryHookOptions<RolloutsQuery, RolloutsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RolloutsQuery, RolloutsQueryVariables>(
    RolloutsDocument,
    options,
  );
}
export function useRolloutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RolloutsQuery,
    RolloutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RolloutsQuery, RolloutsQueryVariables>(
    RolloutsDocument,
    options,
  );
}
// @ts-ignore
export function useRolloutsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RolloutsQuery,
    RolloutsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RolloutsQuery, RolloutsQueryVariables>;
export function useRolloutsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolloutsQuery, RolloutsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RolloutsQuery | undefined,
  RolloutsQueryVariables
>;
export function useRolloutsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RolloutsQuery, RolloutsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RolloutsQuery, RolloutsQueryVariables>(
    RolloutsDocument,
    options,
  );
}
export type RolloutsQueryHookResult = ReturnType<typeof useRolloutsQuery>;
export type RolloutsLazyQueryHookResult = ReturnType<
  typeof useRolloutsLazyQuery
>;
export type RolloutsSuspenseQueryHookResult = ReturnType<
  typeof useRolloutsSuspenseQuery
>;
export type RolloutsQueryResult = Apollo.QueryResult<
  RolloutsQuery,
  RolloutsQueryVariables
>;
export const UpdateRolloutDataDocument = gql`
  mutation UpdateRolloutData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          rollout {
            ...RolloutData
          }
        }
      }
      ...DefaultError
    }
  }
  ${RolloutDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateRolloutDataMutationFn = Apollo.MutationFunction<
  UpdateRolloutDataMutation,
  UpdateRolloutDataMutationVariables
>;

/**
 * __useUpdateRolloutDataMutation__
 *
 * To run a mutation, you first call `useUpdateRolloutDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolloutDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRolloutDataMutation, { data, loading, error }] = useUpdateRolloutDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateRolloutDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRolloutDataMutation,
    UpdateRolloutDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRolloutDataMutation,
    UpdateRolloutDataMutationVariables
  >(UpdateRolloutDataDocument, options);
}
export type UpdateRolloutDataMutationHookResult = ReturnType<
  typeof useUpdateRolloutDataMutation
>;
export type UpdateRolloutDataMutationResult =
  Apollo.MutationResult<UpdateRolloutDataMutation>;
export type UpdateRolloutDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateRolloutDataMutation,
  UpdateRolloutDataMutationVariables
>;
export const CalculateSampleSizeDocument = gql`
  mutation CalculateSampleSize($name: String!, $parameters: JSON) {
    executeFunction(
      workflowInstance: $name
      functionName: "calculateSampleSize"
      parameters: $parameters
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        instance {
          name
          moduleData2 {
            samplesize {
              ...SampleSizeData
            }
          }
        }
        response
      }
      ...DefaultError
    }
  }
  ${SampleSizeDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CalculateSampleSizeMutationFn = Apollo.MutationFunction<
  CalculateSampleSizeMutation,
  CalculateSampleSizeMutationVariables
>;

/**
 * __useCalculateSampleSizeMutation__
 *
 * To run a mutation, you first call `useCalculateSampleSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateSampleSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateSampleSizeMutation, { data, loading, error }] = useCalculateSampleSizeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCalculateSampleSizeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CalculateSampleSizeMutation,
    CalculateSampleSizeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CalculateSampleSizeMutation,
    CalculateSampleSizeMutationVariables
  >(CalculateSampleSizeDocument, options);
}
export type CalculateSampleSizeMutationHookResult = ReturnType<
  typeof useCalculateSampleSizeMutation
>;
export type CalculateSampleSizeMutationResult =
  Apollo.MutationResult<CalculateSampleSizeMutation>;
export type CalculateSampleSizeMutationOptions = Apollo.BaseMutationOptions<
  CalculateSampleSizeMutation,
  CalculateSampleSizeMutationVariables
>;
export const CancelSampleSizeCalculationsDocument = gql`
  mutation CancelSampleSizeCalculations($name: String!) {
    executeFunction(
      workflowInstance: $name
      functionName: "cancelSampleSizeCalculations"
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        instance {
          name
          moduleData2 {
            samplesize {
              ...SampleSizeData
            }
          }
        }
        response
      }
      ...DefaultError
    }
  }
  ${SampleSizeDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CancelSampleSizeCalculationsMutationFn = Apollo.MutationFunction<
  CancelSampleSizeCalculationsMutation,
  CancelSampleSizeCalculationsMutationVariables
>;

/**
 * __useCancelSampleSizeCalculationsMutation__
 *
 * To run a mutation, you first call `useCancelSampleSizeCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSampleSizeCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSampleSizeCalculationsMutation, { data, loading, error }] = useCancelSampleSizeCalculationsMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCancelSampleSizeCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelSampleSizeCalculationsMutation,
    CancelSampleSizeCalculationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelSampleSizeCalculationsMutation,
    CancelSampleSizeCalculationsMutationVariables
  >(CancelSampleSizeCalculationsDocument, options);
}
export type CancelSampleSizeCalculationsMutationHookResult = ReturnType<
  typeof useCancelSampleSizeCalculationsMutation
>;
export type CancelSampleSizeCalculationsMutationResult =
  Apollo.MutationResult<CancelSampleSizeCalculationsMutation>;
export type CancelSampleSizeCalculationsMutationOptions =
  Apollo.BaseMutationOptions<
    CancelSampleSizeCalculationsMutation,
    CancelSampleSizeCalculationsMutationVariables
  >;
export const PreviousExperimentsDocument = gql`
  query PreviousExperiments(
    $parent: String
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...PreviousExperiment
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${PreviousExperimentFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __usePreviousExperimentsQuery__
 *
 * To run a query within a React component, call `usePreviousExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousExperimentsQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePreviousExperimentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >(PreviousExperimentsDocument, options);
}
export function usePreviousExperimentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >(PreviousExperimentsDocument, options);
}
// @ts-ignore
export function usePreviousExperimentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PreviousExperimentsQuery,
  PreviousExperimentsQueryVariables
>;
export function usePreviousExperimentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreviousExperimentsQuery,
        PreviousExperimentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PreviousExperimentsQuery | undefined,
  PreviousExperimentsQueryVariables
>;
export function usePreviousExperimentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreviousExperimentsQuery,
        PreviousExperimentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PreviousExperimentsQuery,
    PreviousExperimentsQueryVariables
  >(PreviousExperimentsDocument, options);
}
export type PreviousExperimentsQueryHookResult = ReturnType<
  typeof usePreviousExperimentsQuery
>;
export type PreviousExperimentsLazyQueryHookResult = ReturnType<
  typeof usePreviousExperimentsLazyQuery
>;
export type PreviousExperimentsSuspenseQueryHookResult = ReturnType<
  typeof usePreviousExperimentsSuspenseQuery
>;
export type PreviousExperimentsQueryResult = Apollo.QueryResult<
  PreviousExperimentsQuery,
  PreviousExperimentsQueryVariables
>;
export const SampleSizeMetricCalculationSqlDocument = gql`
  query SampleSizeMetricCalculationSql($name: String!) {
    metricCalculation(name: $name) {
      ... on MetricsV1MetricCalculation {
        __typename
        name
        sql
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useSampleSizeMetricCalculationSqlQuery__
 *
 * To run a query within a React component, call `useSampleSizeMetricCalculationSqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleSizeMetricCalculationSqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleSizeMetricCalculationSqlQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSampleSizeMetricCalculationSqlQuery(
  baseOptions: Apollo.QueryHookOptions<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  > &
    (
      | {
          variables: SampleSizeMetricCalculationSqlQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  >(SampleSizeMetricCalculationSqlDocument, options);
}
export function useSampleSizeMetricCalculationSqlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  >(SampleSizeMetricCalculationSqlDocument, options);
}
// @ts-ignore
export function useSampleSizeMetricCalculationSqlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SampleSizeMetricCalculationSqlQuery,
  SampleSizeMetricCalculationSqlQueryVariables
>;
export function useSampleSizeMetricCalculationSqlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SampleSizeMetricCalculationSqlQuery,
        SampleSizeMetricCalculationSqlQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SampleSizeMetricCalculationSqlQuery | undefined,
  SampleSizeMetricCalculationSqlQueryVariables
>;
export function useSampleSizeMetricCalculationSqlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SampleSizeMetricCalculationSqlQuery,
        SampleSizeMetricCalculationSqlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SampleSizeMetricCalculationSqlQuery,
    SampleSizeMetricCalculationSqlQueryVariables
  >(SampleSizeMetricCalculationSqlDocument, options);
}
export type SampleSizeMetricCalculationSqlQueryHookResult = ReturnType<
  typeof useSampleSizeMetricCalculationSqlQuery
>;
export type SampleSizeMetricCalculationSqlLazyQueryHookResult = ReturnType<
  typeof useSampleSizeMetricCalculationSqlLazyQuery
>;
export type SampleSizeMetricCalculationSqlSuspenseQueryHookResult = ReturnType<
  typeof useSampleSizeMetricCalculationSqlSuspenseQuery
>;
export type SampleSizeMetricCalculationSqlQueryResult = Apollo.QueryResult<
  SampleSizeMetricCalculationSqlQuery,
  SampleSizeMetricCalculationSqlQueryVariables
>;
export const UpdateSampleSizeDataDocument = gql`
  mutation UpdateSampleSizeData(
    $input: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: $updateMask) {
      __typename
      ... on WorkflowV1WorkflowInstance {
        name
        moduleData2 {
          samplesize {
            ...SampleSizeData
          }
        }
      }
      ...DefaultError
    }
  }
  ${SampleSizeDataFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateSampleSizeDataMutationFn = Apollo.MutationFunction<
  UpdateSampleSizeDataMutation,
  UpdateSampleSizeDataMutationVariables
>;

/**
 * __useUpdateSampleSizeDataMutation__
 *
 * To run a mutation, you first call `useUpdateSampleSizeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleSizeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleSizeDataMutation, { data, loading, error }] = useUpdateSampleSizeDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useUpdateSampleSizeDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSampleSizeDataMutation,
    UpdateSampleSizeDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSampleSizeDataMutation,
    UpdateSampleSizeDataMutationVariables
  >(UpdateSampleSizeDataDocument, options);
}
export type UpdateSampleSizeDataMutationHookResult = ReturnType<
  typeof useUpdateSampleSizeDataMutation
>;
export type UpdateSampleSizeDataMutationResult =
  Apollo.MutationResult<UpdateSampleSizeDataMutation>;
export type UpdateSampleSizeDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateSampleSizeDataMutation,
  UpdateSampleSizeDataMutationVariables
>;
export const OnAnalysisResultUpdatedDocument = gql`
  subscription OnAnalysisResultUpdated {
    analysisResultUpdated {
      analysisResult {
        ...AnalysisResult
      }
    }
  }
  ${AnalysisResultFragmentDoc}
`;

/**
 * __useOnAnalysisResultUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAnalysisResultUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnalysisResultUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnalysisResultUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnalysisResultUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnAnalysisResultUpdatedSubscription,
    OnAnalysisResultUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnAnalysisResultUpdatedSubscription,
    OnAnalysisResultUpdatedSubscriptionVariables
  >(OnAnalysisResultUpdatedDocument, options);
}
export type OnAnalysisResultUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnAnalysisResultUpdatedSubscription
>;
export type OnAnalysisResultUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnAnalysisResultUpdatedSubscription>;
export const UpdateWorkflowInstanceSurfacesDocument = gql`
  mutation UpdateWorkflowInstanceSurfaces(
    $input: PartialWorkflowV1WorkflowInstanceInput!
  ) {
    updateWorkflowInstance(workflowInstance: $input, updateMask: "surfaces") {
      ... on WorkflowV1WorkflowInstance {
        name
        __typename
        surfaces {
          __typename
          ...SurfaceRef
          ...DefaultError
        }
        surfaceRequirements {
          surface {
            ... on WorkflowV1Surface {
              __typename
              name
              displayName
              description
            }
            ...DefaultError
          }
          enforcementLevel
          reason
        }
      }
      ...DefaultError
    }
  }
  ${SurfaceRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type UpdateWorkflowInstanceSurfacesMutationFn = Apollo.MutationFunction<
  UpdateWorkflowInstanceSurfacesMutation,
  UpdateWorkflowInstanceSurfacesMutationVariables
>;

/**
 * __useUpdateWorkflowInstanceSurfacesMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowInstanceSurfacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowInstanceSurfacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowInstanceSurfacesMutation, { data, loading, error }] = useUpdateWorkflowInstanceSurfacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowInstanceSurfacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowInstanceSurfacesMutation,
    UpdateWorkflowInstanceSurfacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowInstanceSurfacesMutation,
    UpdateWorkflowInstanceSurfacesMutationVariables
  >(UpdateWorkflowInstanceSurfacesDocument, options);
}
export type UpdateWorkflowInstanceSurfacesMutationHookResult = ReturnType<
  typeof useUpdateWorkflowInstanceSurfacesMutation
>;
export type UpdateWorkflowInstanceSurfacesMutationResult =
  Apollo.MutationResult<UpdateWorkflowInstanceSurfacesMutation>;
export type UpdateWorkflowInstanceSurfacesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkflowInstanceSurfacesMutation,
    UpdateWorkflowInstanceSurfacesMutationVariables
  >;
export const CheckPermissionsDocument = gql`
  mutation CheckPermissions($workflowInstance: String!) {
    checkPermissions(workflowInstance: $workflowInstance) {
      ... on WorkflowV1CheckPermissionsResponse {
        actionPermissionCheckResults {
          action
          isAllowed
          permissionChecks {
            isAllowed
            relation
            resource
          }
        }
        functionPermissionCheckResults {
          function
          isAllowed
          permissionChecks {
            isAllowed
            relation
            resource
          }
        }
        isAllAllowed
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CheckPermissionsMutationFn = Apollo.MutationFunction<
  CheckPermissionsMutation,
  CheckPermissionsMutationVariables
>;

/**
 * __useCheckPermissionsMutation__
 *
 * To run a mutation, you first call `useCheckPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPermissionsMutation, { data, loading, error }] = useCheckPermissionsMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useCheckPermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckPermissionsMutation,
    CheckPermissionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckPermissionsMutation,
    CheckPermissionsMutationVariables
  >(CheckPermissionsDocument, options);
}
export type CheckPermissionsMutationHookResult = ReturnType<
  typeof useCheckPermissionsMutation
>;
export type CheckPermissionsMutationResult =
  Apollo.MutationResult<CheckPermissionsMutation>;
export type CheckPermissionsMutationOptions = Apollo.BaseMutationOptions<
  CheckPermissionsMutation,
  CheckPermissionsMutationVariables
>;
export const CloneDocument = gql`
  mutation Clone($name: String!, $newDisplayName: String!) {
    executeFunction(
      workflowInstance: $name
      functionName: "clone"
      parameters: { displayName: $newDisplayName }
    ) {
      ... on WorkflowV1ExecuteFunctionResponse {
        __typename
        response
        instance {
          name
          moduleData {
            key
            value
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CloneMutationFn = Apollo.MutationFunction<
  CloneMutation,
  CloneMutationVariables
>;

/**
 * __useCloneMutation__
 *
 * To run a mutation, you first call `useCloneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneMutation, { data, loading, error }] = useCloneMutation({
 *   variables: {
 *      name: // value for 'name'
 *      newDisplayName: // value for 'newDisplayName'
 *   },
 * });
 */
export function useCloneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneMutation,
    CloneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneMutation, CloneMutationVariables>(
    CloneDocument,
    options,
  );
}
export type CloneMutationHookResult = ReturnType<typeof useCloneMutation>;
export type CloneMutationResult = Apollo.MutationResult<CloneMutation>;
export type CloneMutationOptions = Apollo.BaseMutationOptions<
  CloneMutation,
  CloneMutationVariables
>;
export const CloneWorkflowInstanceDocument = gql`
  mutation CloneWorkflowInstance(
    $name: String!
    $displayName: String!
    $owner: String
  ) {
    cloneWorkflowInstance(
      name: $name
      displayName: $displayName
      owner: $owner
    ) {
      ...WorkflowInstance
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CloneWorkflowInstanceMutationFn = Apollo.MutationFunction<
  CloneWorkflowInstanceMutation,
  CloneWorkflowInstanceMutationVariables
>;

/**
 * __useCloneWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useCloneWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneWorkflowInstanceMutation, { data, loading, error }] = useCloneWorkflowInstanceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useCloneWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneWorkflowInstanceMutation,
    CloneWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CloneWorkflowInstanceMutation,
    CloneWorkflowInstanceMutationVariables
  >(CloneWorkflowInstanceDocument, options);
}
export type CloneWorkflowInstanceMutationHookResult = ReturnType<
  typeof useCloneWorkflowInstanceMutation
>;
export type CloneWorkflowInstanceMutationResult =
  Apollo.MutationResult<CloneWorkflowInstanceMutation>;
export type CloneWorkflowInstanceMutationOptions = Apollo.BaseMutationOptions<
  CloneWorkflowInstanceMutation,
  CloneWorkflowInstanceMutationVariables
>;
export const CreateWorkflowInstanceDocument = gql`
  mutation CreateWorkflowInstance(
    $workflowInstance: WorkflowV1WorkflowInstanceInput!
    $parent: String!
    $workflowInstanceId: String
  ) {
    createWorkflowInstance(
      parent: $parent
      workflowInstance: $workflowInstance
      workflowInstanceId: $workflowInstanceId
    ) {
      ...WorkflowInstance
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateWorkflowInstanceMutationFn = Apollo.MutationFunction<
  CreateWorkflowInstanceMutation,
  CreateWorkflowInstanceMutationVariables
>;

/**
 * __useCreateWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowInstanceMutation, { data, loading, error }] = useCreateWorkflowInstanceMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *      parent: // value for 'parent'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useCreateWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowInstanceMutation,
    CreateWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowInstanceMutation,
    CreateWorkflowInstanceMutationVariables
  >(CreateWorkflowInstanceDocument, options);
}
export type CreateWorkflowInstanceMutationHookResult = ReturnType<
  typeof useCreateWorkflowInstanceMutation
>;
export type CreateWorkflowInstanceMutationResult =
  Apollo.MutationResult<CreateWorkflowInstanceMutation>;
export type CreateWorkflowInstanceMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowInstanceMutation,
  CreateWorkflowInstanceMutationVariables
>;
export const CreateWorkflowTemplateDocument = gql`
  mutation CreateWorkflowTemplate(
    $workflowTemplate: WorkflowV1WorkflowTemplateInput!
  ) {
    createWorkflowTemplate(workflowTemplate: $workflowTemplate) {
      ...WorkflowTemplate
      ...DefaultError
    }
  }
  ${WorkflowTemplateFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type CreateWorkflowTemplateMutationFn = Apollo.MutationFunction<
  CreateWorkflowTemplateMutation,
  CreateWorkflowTemplateMutationVariables
>;

/**
 * __useCreateWorkflowTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowTemplateMutation, { data, loading, error }] = useCreateWorkflowTemplateMutation({
 *   variables: {
 *      workflowTemplate: // value for 'workflowTemplate'
 *   },
 * });
 */
export function useCreateWorkflowTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowTemplateMutation,
    CreateWorkflowTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowTemplateMutation,
    CreateWorkflowTemplateMutationVariables
  >(CreateWorkflowTemplateDocument, options);
}
export type CreateWorkflowTemplateMutationHookResult = ReturnType<
  typeof useCreateWorkflowTemplateMutation
>;
export type CreateWorkflowTemplateMutationResult =
  Apollo.MutationResult<CreateWorkflowTemplateMutation>;
export type CreateWorkflowTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowTemplateMutation,
  CreateWorkflowTemplateMutationVariables
>;
export const CreateWorkflowVersionDocument = gql`
  mutation CreateWorkflowVersion(
    $workflowVersion: WorkflowV1WorkflowVersionInput!
    $parent: String!
  ) {
    createWorkflowVersion(parent: $parent, workflowVersion: $workflowVersion) {
      ... on WorkflowV1WorkflowVersion {
        name
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateWorkflowVersionMutationFn = Apollo.MutationFunction<
  CreateWorkflowVersionMutation,
  CreateWorkflowVersionMutationVariables
>;

/**
 * __useCreateWorkflowVersionMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowVersionMutation, { data, loading, error }] = useCreateWorkflowVersionMutation({
 *   variables: {
 *      workflowVersion: // value for 'workflowVersion'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateWorkflowVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowVersionMutation,
    CreateWorkflowVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowVersionMutation,
    CreateWorkflowVersionMutationVariables
  >(CreateWorkflowVersionDocument, options);
}
export type CreateWorkflowVersionMutationHookResult = ReturnType<
  typeof useCreateWorkflowVersionMutation
>;
export type CreateWorkflowVersionMutationResult =
  Apollo.MutationResult<CreateWorkflowVersionMutation>;
export type CreateWorkflowVersionMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowVersionMutation,
  CreateWorkflowVersionMutationVariables
>;
export const DeleteWorkflowInstanceDocument = gql`
  mutation DeleteWorkflowInstance($name: String!) {
    deleteWorkflowInstance(name: $name) {
      __typename
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type DeleteWorkflowInstanceMutationFn = Apollo.MutationFunction<
  DeleteWorkflowInstanceMutation,
  DeleteWorkflowInstanceMutationVariables
>;

/**
 * __useDeleteWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowInstanceMutation, { data, loading, error }] = useDeleteWorkflowInstanceMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkflowInstanceMutation,
    DeleteWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkflowInstanceMutation,
    DeleteWorkflowInstanceMutationVariables
  >(DeleteWorkflowInstanceDocument, options);
}
export type DeleteWorkflowInstanceMutationHookResult = ReturnType<
  typeof useDeleteWorkflowInstanceMutation
>;
export type DeleteWorkflowInstanceMutationResult =
  Apollo.MutationResult<DeleteWorkflowInstanceMutation>;
export type DeleteWorkflowInstanceMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkflowInstanceMutation,
  DeleteWorkflowInstanceMutationVariables
>;
export const GetDisplayNamesDocument = gql`
  query GetDisplayNames(
    $metricsFilter: String
    $entitiesFilter: String
    $assignmentTablesFilter: String
    $factTablesFilter: String
    $pageSize: Int
  ) {
    metrics(filter: $metricsFilter, showDeleted: true, pageSize: $pageSize) {
      ... on MetricsV1ListMetricsResponse {
        __typename
        metrics {
          name
          displayName
        }
      }
      ...DefaultError
    }
    entities(filter: $entitiesFilter) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        entities {
          name
          displayName
        }
      }
      ...DefaultError
    }
    assignmentTables(filter: $assignmentTablesFilter) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          name
          displayName
        }
      }
      ...DefaultError
    }
    factTables(filter: $factTablesFilter) {
      ... on MetricsV1ListFactTablesResponse {
        __typename
        factTables {
          name
          displayName
        }
      }
      ...DefaultError
    }
    workflows {
      ... on WorkflowV1ListWorkflowsResponse {
        __typename
        workflows {
          name
          displayName
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetDisplayNamesQuery__
 *
 * To run a query within a React component, call `useGetDisplayNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayNamesQuery({
 *   variables: {
 *      metricsFilter: // value for 'metricsFilter'
 *      entitiesFilter: // value for 'entitiesFilter'
 *      assignmentTablesFilter: // value for 'assignmentTablesFilter'
 *      factTablesFilter: // value for 'factTablesFilter'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetDisplayNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDisplayNamesQuery,
    GetDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDisplayNamesQuery, GetDisplayNamesQueryVariables>(
    GetDisplayNamesDocument,
    options,
  );
}
export function useGetDisplayNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDisplayNamesQuery,
    GetDisplayNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDisplayNamesQuery,
    GetDisplayNamesQueryVariables
  >(GetDisplayNamesDocument, options);
}
// @ts-ignore
export function useGetDisplayNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDisplayNamesQuery,
    GetDisplayNamesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDisplayNamesQuery,
  GetDisplayNamesQueryVariables
>;
export function useGetDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDisplayNamesQuery,
        GetDisplayNamesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDisplayNamesQuery | undefined,
  GetDisplayNamesQueryVariables
>;
export function useGetDisplayNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDisplayNamesQuery,
        GetDisplayNamesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDisplayNamesQuery,
    GetDisplayNamesQueryVariables
  >(GetDisplayNamesDocument, options);
}
export type GetDisplayNamesQueryHookResult = ReturnType<
  typeof useGetDisplayNamesQuery
>;
export type GetDisplayNamesLazyQueryHookResult = ReturnType<
  typeof useGetDisplayNamesLazyQuery
>;
export type GetDisplayNamesSuspenseQueryHookResult = ReturnType<
  typeof useGetDisplayNamesSuspenseQuery
>;
export type GetDisplayNamesQueryResult = Apollo.QueryResult<
  GetDisplayNamesQuery,
  GetDisplayNamesQueryVariables
>;
export const GetWorkflowInstanceDocument = gql`
  query GetWorkflowInstance($name: String!) {
    workflowInstance(name: $name) {
      ...WorkflowInstance
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  > &
    (
      | { variables: GetWorkflowInstanceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  >(GetWorkflowInstanceDocument, options);
}
export function useGetWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  >(GetWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useGetWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceQuery,
  GetWorkflowInstanceQueryVariables
>;
export function useGetWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceQuery,
        GetWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceQuery | undefined,
  GetWorkflowInstanceQueryVariables
>;
export function useGetWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceQuery,
        GetWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInstanceQuery,
    GetWorkflowInstanceQueryVariables
  >(GetWorkflowInstanceDocument, options);
}
export type GetWorkflowInstanceQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceQuery
>;
export type GetWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceLazyQuery
>;
export type GetWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceSuspenseQuery
>;
export type GetWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetWorkflowInstanceQuery,
  GetWorkflowInstanceQueryVariables
>;
export const GetWorkflowInstanceCreateInfoDocument = gql`
  query GetWorkflowInstanceCreateInfo($name: String!) {
    workflow(name: $name) {
      ... on WorkflowV1Workflow {
        __typename
        name
        workflowInfo {
          modules {
            key
          }
        }
      }
      ...DefaultError
    }
    entities(pageSize: 1) {
      ... on MetricsV1ListEntitiesResponse {
        __typename
        entities {
          name
        }
      }
      ...DefaultError
    }
    assignmentTables(pageSize: 2) {
      ... on MetricsV1ListAssignmentTablesResponse {
        __typename
        assignmentTables {
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowInstanceCreateInfoQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceCreateInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceCreateInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceCreateInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetWorkflowInstanceCreateInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  > &
    (
      | {
          variables: GetWorkflowInstanceCreateInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  >(GetWorkflowInstanceCreateInfoDocument, options);
}
export function useGetWorkflowInstanceCreateInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  >(GetWorkflowInstanceCreateInfoDocument, options);
}
// @ts-ignore
export function useGetWorkflowInstanceCreateInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceCreateInfoQuery,
  GetWorkflowInstanceCreateInfoQueryVariables
>;
export function useGetWorkflowInstanceCreateInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceCreateInfoQuery,
        GetWorkflowInstanceCreateInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceCreateInfoQuery | undefined,
  GetWorkflowInstanceCreateInfoQueryVariables
>;
export function useGetWorkflowInstanceCreateInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceCreateInfoQuery,
        GetWorkflowInstanceCreateInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInstanceCreateInfoQuery,
    GetWorkflowInstanceCreateInfoQueryVariables
  >(GetWorkflowInstanceCreateInfoDocument, options);
}
export type GetWorkflowInstanceCreateInfoQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceCreateInfoQuery
>;
export type GetWorkflowInstanceCreateInfoLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceCreateInfoLazyQuery
>;
export type GetWorkflowInstanceCreateInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceCreateInfoSuspenseQuery
>;
export type GetWorkflowInstanceCreateInfoQueryResult = Apollo.QueryResult<
  GetWorkflowInstanceCreateInfoQuery,
  GetWorkflowInstanceCreateInfoQueryVariables
>;
export const GetWorkflowInstanceEventsDocument = gql`
  query GetWorkflowInstanceEvents(
    $resource: String!
    $pageSize: Int
    $eventTypes: [String!]
    $pageToken: String
  ) {
    events(
      resource: $resource
      pageSize: $pageSize
      eventTypes: $eventTypes
      pageToken: $pageToken
    ) {
      ... on ConnectorsV1ListEventsResponse {
        __typename
        nextPageToken
        events {
          ...WorkflowEvent
        }
      }
      ...DefaultError
    }
  }
  ${WorkflowEventFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetWorkflowInstanceEventsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceEventsQuery({
 *   variables: {
 *      resource: // value for 'resource'
 *      pageSize: // value for 'pageSize'
 *      eventTypes: // value for 'eventTypes'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useGetWorkflowInstanceEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  > &
    (
      | { variables: GetWorkflowInstanceEventsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  >(GetWorkflowInstanceEventsDocument, options);
}
export function useGetWorkflowInstanceEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  >(GetWorkflowInstanceEventsDocument, options);
}
// @ts-ignore
export function useGetWorkflowInstanceEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceEventsQuery,
  GetWorkflowInstanceEventsQueryVariables
>;
export function useGetWorkflowInstanceEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceEventsQuery,
        GetWorkflowInstanceEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowInstanceEventsQuery | undefined,
  GetWorkflowInstanceEventsQueryVariables
>;
export function useGetWorkflowInstanceEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowInstanceEventsQuery,
        GetWorkflowInstanceEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowInstanceEventsQuery,
    GetWorkflowInstanceEventsQueryVariables
  >(GetWorkflowInstanceEventsDocument, options);
}
export type GetWorkflowInstanceEventsQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceEventsQuery
>;
export type GetWorkflowInstanceEventsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceEventsLazyQuery
>;
export type GetWorkflowInstanceEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowInstanceEventsSuspenseQuery
>;
export type GetWorkflowInstanceEventsQueryResult = Apollo.QueryResult<
  GetWorkflowInstanceEventsQuery,
  GetWorkflowInstanceEventsQueryVariables
>;
export const ListEntityContextOverridesDocument = gql`
  query ListEntityContextOverrides($filter: String) {
    evaluationContextFieldOverrides(filter: $filter) {
      ... on FlagsAdminV1ListEvaluationContextFieldOverridesResponse {
        evaluationContextFieldOverrides {
          name
          field
          semanticType {
            entityReference {
              entity {
                ... on MetricsV1Entity {
                  name
                }
              }
            }
          }
        }
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListEntityContextOverridesQuery__
 *
 * To run a query within a React component, call `useListEntityContextOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEntityContextOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEntityContextOverridesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListEntityContextOverridesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >(ListEntityContextOverridesDocument, options);
}
export function useListEntityContextOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >(ListEntityContextOverridesDocument, options);
}
// @ts-ignore
export function useListEntityContextOverridesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListEntityContextOverridesQuery,
  ListEntityContextOverridesQueryVariables
>;
export function useListEntityContextOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEntityContextOverridesQuery,
        ListEntityContextOverridesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEntityContextOverridesQuery | undefined,
  ListEntityContextOverridesQueryVariables
>;
export function useListEntityContextOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEntityContextOverridesQuery,
        ListEntityContextOverridesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListEntityContextOverridesQuery,
    ListEntityContextOverridesQueryVariables
  >(ListEntityContextOverridesDocument, options);
}
export type ListEntityContextOverridesQueryHookResult = ReturnType<
  typeof useListEntityContextOverridesQuery
>;
export type ListEntityContextOverridesLazyQueryHookResult = ReturnType<
  typeof useListEntityContextOverridesLazyQuery
>;
export type ListEntityContextOverridesSuspenseQueryHookResult = ReturnType<
  typeof useListEntityContextOverridesSuspenseQuery
>;
export type ListEntityContextOverridesQueryResult = Apollo.QueryResult<
  ListEntityContextOverridesQuery,
  ListEntityContextOverridesQueryVariables
>;
export const ListWorkflowInstancesDocument = gql`
  query ListWorkflowInstances(
    $pageSize: Int
    $pageToken: String
    $workflow: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      pageSize: $pageSize
      pageToken: $pageToken
      parent: $workflow
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...WorkflowInstanceListItem
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${WorkflowInstanceListItemFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useListWorkflowInstancesQuery__
 *
 * To run a query within a React component, call `useListWorkflowInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowInstancesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      workflow: // value for 'workflow'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListWorkflowInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >(ListWorkflowInstancesDocument, options);
}
export function useListWorkflowInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >(ListWorkflowInstancesDocument, options);
}
// @ts-ignore
export function useListWorkflowInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowInstancesQuery,
  ListWorkflowInstancesQueryVariables
>;
export function useListWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowInstancesQuery,
        ListWorkflowInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowInstancesQuery | undefined,
  ListWorkflowInstancesQueryVariables
>;
export function useListWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowInstancesQuery,
        ListWorkflowInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListWorkflowInstancesQuery,
    ListWorkflowInstancesQueryVariables
  >(ListWorkflowInstancesDocument, options);
}
export type ListWorkflowInstancesQueryHookResult = ReturnType<
  typeof useListWorkflowInstancesQuery
>;
export type ListWorkflowInstancesLazyQueryHookResult = ReturnType<
  typeof useListWorkflowInstancesLazyQuery
>;
export type ListWorkflowInstancesSuspenseQueryHookResult = ReturnType<
  typeof useListWorkflowInstancesSuspenseQuery
>;
export type ListWorkflowInstancesQueryResult = Apollo.QueryResult<
  ListWorkflowInstancesQuery,
  ListWorkflowInstancesQueryVariables
>;
export const OnWorkflowInstanceUpdatedDocument = gql`
  subscription OnWorkflowInstanceUpdated {
    workflowInstanceUpdated {
      workflowInstance {
        ...WorkflowInstance
      }
    }
  }
  ${WorkflowInstanceFragmentDoc}
`;

/**
 * __useOnWorkflowInstanceUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnWorkflowInstanceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWorkflowInstanceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWorkflowInstanceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnWorkflowInstanceUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnWorkflowInstanceUpdatedSubscription,
    OnWorkflowInstanceUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnWorkflowInstanceUpdatedSubscription,
    OnWorkflowInstanceUpdatedSubscriptionVariables
  >(OnWorkflowInstanceUpdatedDocument, options);
}
export type OnWorkflowInstanceUpdatedSubscriptionHookResult = ReturnType<
  typeof useOnWorkflowInstanceUpdatedSubscription
>;
export type OnWorkflowInstanceUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OnWorkflowInstanceUpdatedSubscription>;
export const SaveWorkflowInstanceModuleDataDocument = gql`
  mutation SaveWorkflowInstanceModuleData(
    $workflowInstance: PartialWorkflowV1WorkflowInstanceInput!
    $updateMask: String
  ) {
    updateWorkflowInstance(
      workflowInstance: $workflowInstance
      updateMask: $updateMask
    ) {
      __typename
      ...WorkflowInstance
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type SaveWorkflowInstanceModuleDataMutationFn = Apollo.MutationFunction<
  SaveWorkflowInstanceModuleDataMutation,
  SaveWorkflowInstanceModuleDataMutationVariables
>;

/**
 * __useSaveWorkflowInstanceModuleDataMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowInstanceModuleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowInstanceModuleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowInstanceModuleDataMutation, { data, loading, error }] = useSaveWorkflowInstanceModuleDataMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *      updateMask: // value for 'updateMask'
 *   },
 * });
 */
export function useSaveWorkflowInstanceModuleDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveWorkflowInstanceModuleDataMutation,
    SaveWorkflowInstanceModuleDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveWorkflowInstanceModuleDataMutation,
    SaveWorkflowInstanceModuleDataMutationVariables
  >(SaveWorkflowInstanceModuleDataDocument, options);
}
export type SaveWorkflowInstanceModuleDataMutationHookResult = ReturnType<
  typeof useSaveWorkflowInstanceModuleDataMutation
>;
export type SaveWorkflowInstanceModuleDataMutationResult =
  Apollo.MutationResult<SaveWorkflowInstanceModuleDataMutation>;
export type SaveWorkflowInstanceModuleDataMutationOptions =
  Apollo.BaseMutationOptions<
    SaveWorkflowInstanceModuleDataMutation,
    SaveWorkflowInstanceModuleDataMutationVariables
  >;
export const SimilarExperimentsDocument = gql`
  query SimilarExperiments(
    $query: String!
    $pageSize: Int
    $pageToken: String
  ) {
    search(
      query: $query
      types: [WORKFLOW_INSTANCE]
      pageSize: $pageSize
      pageToken: $pageToken
    ) {
      ... on SearchV1ExternalSearchResponse {
        __typename
        hits {
          score
          resource {
            ... on WorkflowV1WorkflowInstance {
              __typename
              name
              displayName
              surfaces {
                ...SurfaceRef
                ...DefaultError
              }
              moduleData2 {
                metrics {
                  entity {
                    ...EntityRef
                    ...DefaultError
                  }
                }
              }
            }
          }
        }
        nextPageToken
        totalSize
      }
      ...DefaultError
    }
  }
  ${SurfaceRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
  ${EntityRefFragmentDoc}
`;

/**
 * __useSimilarExperimentsQuery__
 *
 * To run a query within a React component, call `useSimilarExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarExperimentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useSimilarExperimentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  > &
    (
      | { variables: SimilarExperimentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  >(SimilarExperimentsDocument, options);
}
export function useSimilarExperimentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  >(SimilarExperimentsDocument, options);
}
// @ts-ignore
export function useSimilarExperimentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SimilarExperimentsQuery,
  SimilarExperimentsQueryVariables
>;
export function useSimilarExperimentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimilarExperimentsQuery,
        SimilarExperimentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SimilarExperimentsQuery | undefined,
  SimilarExperimentsQueryVariables
>;
export function useSimilarExperimentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimilarExperimentsQuery,
        SimilarExperimentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SimilarExperimentsQuery,
    SimilarExperimentsQueryVariables
  >(SimilarExperimentsDocument, options);
}
export type SimilarExperimentsQueryHookResult = ReturnType<
  typeof useSimilarExperimentsQuery
>;
export type SimilarExperimentsLazyQueryHookResult = ReturnType<
  typeof useSimilarExperimentsLazyQuery
>;
export type SimilarExperimentsSuspenseQueryHookResult = ReturnType<
  typeof useSimilarExperimentsSuspenseQuery
>;
export type SimilarExperimentsQueryResult = Apollo.QueryResult<
  SimilarExperimentsQuery,
  SimilarExperimentsQueryVariables
>;
export const TransitionWorkflowInstanceDocument = gql`
  mutation TransitionWorkflowInstance(
    $name: String!
    $action: String!
    $asyncTransition: Boolean!
    $parameters: JSON
  ) {
    transitionWorkflowInstance(
      name: $name
      action: $action
      asyncTransition: $asyncTransition
      parameters: $parameters
    ) {
      ... on WorkflowV1TransitionWorkflowInstanceResponse {
        __typename
        workflowInstance {
          ...WorkflowInstance
        }
      }
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;
export type TransitionWorkflowInstanceMutationFn = Apollo.MutationFunction<
  TransitionWorkflowInstanceMutation,
  TransitionWorkflowInstanceMutationVariables
>;

/**
 * __useTransitionWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useTransitionWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionWorkflowInstanceMutation, { data, loading, error }] = useTransitionWorkflowInstanceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      action: // value for 'action'
 *      asyncTransition: // value for 'asyncTransition'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useTransitionWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransitionWorkflowInstanceMutation,
    TransitionWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TransitionWorkflowInstanceMutation,
    TransitionWorkflowInstanceMutationVariables
  >(TransitionWorkflowInstanceDocument, options);
}
export type TransitionWorkflowInstanceMutationHookResult = ReturnType<
  typeof useTransitionWorkflowInstanceMutation
>;
export type TransitionWorkflowInstanceMutationResult =
  Apollo.MutationResult<TransitionWorkflowInstanceMutation>;
export type TransitionWorkflowInstanceMutationOptions =
  Apollo.BaseMutationOptions<
    TransitionWorkflowInstanceMutation,
    TransitionWorkflowInstanceMutationVariables
  >;
export const UpdateWorkflowInstanceLabelsDocument = gql`
  mutation UpdateWorkflowInstanceLabels(
    $workflowInstance: PartialWorkflowV1WorkflowInstanceInput!
  ) {
    updateWorkflowInstance(
      workflowInstance: $workflowInstance
      updateMask: "labels"
    ) {
      ... on WorkflowV1WorkflowInstance {
        __typename
        name
        labels {
          key
          value
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type UpdateWorkflowInstanceLabelsMutationFn = Apollo.MutationFunction<
  UpdateWorkflowInstanceLabelsMutation,
  UpdateWorkflowInstanceLabelsMutationVariables
>;

/**
 * __useUpdateWorkflowInstanceLabelsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowInstanceLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowInstanceLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowInstanceLabelsMutation, { data, loading, error }] = useUpdateWorkflowInstanceLabelsMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useUpdateWorkflowInstanceLabelsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowInstanceLabelsMutation,
    UpdateWorkflowInstanceLabelsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowInstanceLabelsMutation,
    UpdateWorkflowInstanceLabelsMutationVariables
  >(UpdateWorkflowInstanceLabelsDocument, options);
}
export type UpdateWorkflowInstanceLabelsMutationHookResult = ReturnType<
  typeof useUpdateWorkflowInstanceLabelsMutation
>;
export type UpdateWorkflowInstanceLabelsMutationResult =
  Apollo.MutationResult<UpdateWorkflowInstanceLabelsMutation>;
export type UpdateWorkflowInstanceLabelsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkflowInstanceLabelsMutation,
    UpdateWorkflowInstanceLabelsMutationVariables
  >;
export const UpdateWorkflowInstanceNameDocument = gql`
  mutation UpdateWorkflowInstanceName(
    $workflowInstance: PartialWorkflowV1WorkflowInstanceInput!
  ) {
    updateWorkflowInstance(
      workflowInstance: $workflowInstance
      updateMask: "displayName"
    ) {
      ... on WorkflowV1WorkflowInstance {
        name
        displayName
      }
    }
  }
`;
export type UpdateWorkflowInstanceNameMutationFn = Apollo.MutationFunction<
  UpdateWorkflowInstanceNameMutation,
  UpdateWorkflowInstanceNameMutationVariables
>;

/**
 * __useUpdateWorkflowInstanceNameMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowInstanceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowInstanceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowInstanceNameMutation, { data, loading, error }] = useUpdateWorkflowInstanceNameMutation({
 *   variables: {
 *      workflowInstance: // value for 'workflowInstance'
 *   },
 * });
 */
export function useUpdateWorkflowInstanceNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowInstanceNameMutation,
    UpdateWorkflowInstanceNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkflowInstanceNameMutation,
    UpdateWorkflowInstanceNameMutationVariables
  >(UpdateWorkflowInstanceNameDocument, options);
}
export type UpdateWorkflowInstanceNameMutationHookResult = ReturnType<
  typeof useUpdateWorkflowInstanceNameMutation
>;
export type UpdateWorkflowInstanceNameMutationResult =
  Apollo.MutationResult<UpdateWorkflowInstanceNameMutation>;
export type UpdateWorkflowInstanceNameMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkflowInstanceNameMutation,
    UpdateWorkflowInstanceNameMutationVariables
  >;
export const WorkflowInstanceRefDocument = gql`
  query WorkflowInstanceRef($name: String!) {
    workflowInstance(name: $name) {
      __typename
      ...WorkflowInstanceRef
      ...DefaultError
    }
  }
  ${WorkflowInstanceRefFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowInstanceRefQuery__
 *
 * To run a query within a React component, call `useWorkflowInstanceRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowInstanceRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowInstanceRefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useWorkflowInstanceRefQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  > &
    (
      | { variables: WorkflowInstanceRefQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  >(WorkflowInstanceRefDocument, options);
}
export function useWorkflowInstanceRefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  >(WorkflowInstanceRefDocument, options);
}
// @ts-ignore
export function useWorkflowInstanceRefSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstanceRefQuery,
  WorkflowInstanceRefQueryVariables
>;
export function useWorkflowInstanceRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstanceRefQuery,
        WorkflowInstanceRefQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstanceRefQuery | undefined,
  WorkflowInstanceRefQueryVariables
>;
export function useWorkflowInstanceRefSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstanceRefQuery,
        WorkflowInstanceRefQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowInstanceRefQuery,
    WorkflowInstanceRefQueryVariables
  >(WorkflowInstanceRefDocument, options);
}
export type WorkflowInstanceRefQueryHookResult = ReturnType<
  typeof useWorkflowInstanceRefQuery
>;
export type WorkflowInstanceRefLazyQueryHookResult = ReturnType<
  typeof useWorkflowInstanceRefLazyQuery
>;
export type WorkflowInstanceRefSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowInstanceRefSuspenseQuery
>;
export type WorkflowInstanceRefQueryResult = Apollo.QueryResult<
  WorkflowInstanceRefQuery,
  WorkflowInstanceRefQueryVariables
>;
export const WorkflowInstancesDocument = gql`
  query WorkflowInstances(
    $parent: String
    $pageSize: Int
    $pageToken: String
    $filter: String
    $orderBy: String
  ) {
    workflowInstances(
      parent: $parent
      pageSize: $pageSize
      pageToken: $pageToken
      filter: $filter
      orderBy: $orderBy
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          ...WorkflowInstance
        }
        nextPageToken
      }
      ...DefaultError
    }
  }
  ${WorkflowInstanceFragmentDoc}
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowInstancesQuery__
 *
 * To run a query within a React component, call `useWorkflowInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowInstancesQuery({
 *   variables: {
 *      parent: // value for 'parent'
 *      pageSize: // value for 'pageSize'
 *      pageToken: // value for 'pageToken'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useWorkflowInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >(WorkflowInstancesDocument, options);
}
export function useWorkflowInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >(WorkflowInstancesDocument, options);
}
// @ts-ignore
export function useWorkflowInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstancesQuery,
  WorkflowInstancesQueryVariables
>;
export function useWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstancesQuery,
        WorkflowInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkflowInstancesQuery | undefined,
  WorkflowInstancesQueryVariables
>;
export function useWorkflowInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkflowInstancesQuery,
        WorkflowInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkflowInstancesQuery,
    WorkflowInstancesQueryVariables
  >(WorkflowInstancesDocument, options);
}
export type WorkflowInstancesQueryHookResult = ReturnType<
  typeof useWorkflowInstancesQuery
>;
export type WorkflowInstancesLazyQueryHookResult = ReturnType<
  typeof useWorkflowInstancesLazyQuery
>;
export type WorkflowInstancesSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowInstancesSuspenseQuery
>;
export type WorkflowInstancesQueryResult = Apollo.QueryResult<
  WorkflowInstancesQuery,
  WorkflowInstancesQueryVariables
>;
export const WorkflowsDocument = gql`
  query Workflows {
    workflows {
      ...DefaultError
      __typename
      ... on WorkflowV1ListWorkflowsResponse {
        workflows {
          __typename
          name
          workflowInfo {
            modules {
              key
            }
          }
        }
      }
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useWorkflowsQuery__
 *
 * To run a query within a React component, call `useWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorkflowsQuery,
    WorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkflowsQuery, WorkflowsQueryVariables>(
    WorkflowsDocument,
    options,
  );
}
export function useWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkflowsQuery,
    WorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkflowsQuery, WorkflowsQueryVariables>(
    WorkflowsDocument,
    options,
  );
}
// @ts-ignore
export function useWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkflowsQuery,
    WorkflowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<WorkflowsQuery, WorkflowsQueryVariables>;
export function useWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  WorkflowsQuery | undefined,
  WorkflowsQueryVariables
>;
export function useWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkflowsQuery, WorkflowsQueryVariables>(
    WorkflowsDocument,
    options,
  );
}
export type WorkflowsQueryHookResult = ReturnType<typeof useWorkflowsQuery>;
export type WorkflowsLazyQueryHookResult = ReturnType<
  typeof useWorkflowsLazyQuery
>;
export type WorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useWorkflowsSuspenseQuery
>;
export type WorkflowsQueryResult = Apollo.QueryResult<
  WorkflowsQuery,
  WorkflowsQueryVariables
>;
